import './index.css';var p4 = Object.defineProperty;
var f4 = (s, r, c) => r in s ? p4(s, r, { enumerable: !0, configurable: !0, writable: !0, value: c }) : s[r] = c;
var x = (s, r, c) => f4(s, typeof r != "symbol" ? r + "" : r, c);
var ec;
// @__NO_SIDE_EFFECTS__
function SU(s) {
  return {
    lang: (s == null ? void 0 : s.lang) ?? (ec == null ? void 0 : ec.lang),
    message: s == null ? void 0 : s.message,
    abortEarly: (s == null ? void 0 : s.abortEarly) ?? (ec == null ? void 0 : ec.abortEarly),
    abortPipeEarly: (s == null ? void 0 : s.abortPipeEarly) ?? (ec == null ? void 0 : ec.abortPipeEarly)
  };
}
var RR;
// @__NO_SIDE_EFFECTS__
function g4(s) {
  return RR == null ? void 0 : RR.get(s);
}
var ER;
// @__NO_SIDE_EFFECTS__
function v4(s) {
  return ER == null ? void 0 : ER.get(s);
}
var UR;
// @__NO_SIDE_EFFECTS__
function S4(s, r) {
  var c;
  return (c = UR == null ? void 0 : UR.get(s)) == null ? void 0 : c.get(r);
}
// @__NO_SIDE_EFFECTS__
function u6(s) {
  var c, h;
  const r = typeof s;
  return r === "string" ? `"${s}"` : r === "number" || r === "bigint" || r === "boolean" ? `${s}` : r === "object" || r === "function" ? (s && ((h = (c = Object.getPrototypeOf(s)) == null ? void 0 : c.constructor) == null ? void 0 : h.name)) ?? "null" : r;
}
function Eo(s, r, c, h, f) {
  const v = f && "input" in f ? f.input : c.value, R = (f == null ? void 0 : f.expected) ?? s.expects ?? null, T = (f == null ? void 0 : f.received) ?? /* @__PURE__ */ u6(v), E = {
    kind: s.kind,
    type: s.type,
    input: v,
    expected: R,
    received: T,
    message: `Invalid ${r}: ${R ? `Expected ${R} but r` : "R"}eceived ${T}`,
    requirement: s.requirement,
    path: f == null ? void 0 : f.path,
    issues: f == null ? void 0 : f.issues,
    lang: h.lang,
    abortEarly: h.abortEarly,
    abortPipeEarly: h.abortPipeEarly
  }, C = s.kind === "schema", N = (f == null ? void 0 : f.message) ?? s.message ?? /* @__PURE__ */ S4(s.reference, E.lang) ?? (C ? /* @__PURE__ */ v4(E.lang) : null) ?? h.message ?? /* @__PURE__ */ g4(E.lang);
  N !== void 0 && (E.message = typeof N == "function" ? (
    // @ts-expect-error
    N(E)
  ) : N), C && (c.typed = !1), c.issues ? c.issues.push(E) : c.issues = [E];
}
// @__NO_SIDE_EFFECTS__
function or(s) {
  return {
    version: 1,
    vendor: "valibot",
    validate(r) {
      return s["~run"]({ value: r }, /* @__PURE__ */ SU());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function R4(s, r) {
  return Object.hasOwn(s, r) && r !== "__proto__" && r !== "prototype" && r !== "constructor";
}
// @__NO_SIDE_EFFECTS__
function RU(s, r) {
  const c = [...new Set(s)];
  return c.length > 1 ? `(${c.join(` ${r} `)})` : c[0] ?? "never";
}
// @__NO_SIDE_EFFECTS__
function E4(s, r, c) {
  return typeof s.fallback == "function" ? (
    // @ts-expect-error
    s.fallback(r, c)
  ) : (
    // @ts-expect-error
    s.fallback
  );
}
// @__NO_SIDE_EFFECTS__
function EU(s, r, c) {
  return typeof s.default == "function" ? (
    // @ts-expect-error
    s.default(r, c)
  ) : (
    // @ts-expect-error
    s.default
  );
}
// @__NO_SIDE_EFFECTS__
function UU() {
  return {
    kind: "schema",
    type: "any",
    reference: UU,
    expects: "any",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(s) {
      return s.typed = !0, s;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function kv(s, r) {
  return {
    kind: "schema",
    type: "array",
    reference: kv,
    expects: "Array",
    async: !1,
    item: s,
    message: r,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(c, h) {
      var v;
      const f = c.value;
      if (Array.isArray(f)) {
        c.typed = !0, c.value = [];
        for (let R = 0; R < f.length; R++) {
          const T = f[R], E = this.item["~run"]({ value: T }, h);
          if (E.issues) {
            const C = {
              type: "array",
              origin: "value",
              input: f,
              key: R,
              value: T
            };
            for (const N of E.issues)
              N.path ? N.path.unshift(C) : N.path = [C], (v = c.issues) == null || v.push(N);
            if (c.issues || (c.issues = E.issues), h.abortEarly) {
              c.typed = !1;
              break;
            }
          }
          E.typed || (c.typed = !1), c.value.push(E.value);
        }
      } else
        Eo(this, "type", c, h);
      return c;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ea(s) {
  return {
    kind: "schema",
    type: "boolean",
    reference: Ea,
    expects: "boolean",
    async: !1,
    message: s,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(r, c) {
      return typeof r.value == "boolean" ? r.typed = !0 : Eo(this, "type", r, c), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Tv(s, r) {
  return {
    kind: "schema",
    type: "literal",
    reference: Tv,
    expects: /* @__PURE__ */ u6(s),
    async: !1,
    literal: s,
    message: r,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(c, h) {
      return c.value === this.literal ? c.typed = !0 : Eo(this, "type", c, h), c;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function IR(s, r, c) {
  return {
    kind: "schema",
    type: "map",
    reference: IR,
    expects: "Map",
    async: !1,
    key: s,
    value: r,
    message: c,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(h, f) {
      var R, T;
      const v = h.value;
      if (v instanceof Map) {
        h.typed = !0, h.value = /* @__PURE__ */ new Map();
        for (const [E, C] of v) {
          const N = this.key["~run"]({ value: E }, f);
          if (N.issues) {
            const V = {
              type: "map",
              origin: "key",
              input: v,
              key: E,
              value: C
            };
            for (const B of N.issues)
              B.path ? B.path.unshift(V) : B.path = [V], (R = h.issues) == null || R.push(B);
            if (h.issues || (h.issues = N.issues), f.abortEarly) {
              h.typed = !1;
              break;
            }
          }
          const _ = this.value["~run"](
            { value: C },
            f
          );
          if (_.issues) {
            const V = {
              type: "map",
              origin: "value",
              input: v,
              key: E,
              value: C
            };
            for (const B of _.issues)
              B.path ? B.path.unshift(V) : B.path = [V], (T = h.issues) == null || T.push(B);
            if (h.issues || (h.issues = _.issues), f.abortEarly) {
              h.typed = !1;
              break;
            }
          }
          (!N.typed || !_.typed) && (h.typed = !1), h.value.set(N.value, _.value);
        }
      } else
        Eo(this, "type", h, f);
      return h;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Bi(s) {
  return {
    kind: "schema",
    type: "number",
    reference: Bi,
    expects: "number",
    async: !1,
    message: s,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(r, c) {
      return typeof r.value == "number" && !isNaN(r.value) ? r.typed = !0 : Eo(this, "type", r, c), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ri(s, r) {
  return {
    kind: "schema",
    type: "object",
    reference: ri,
    expects: "Object",
    async: !1,
    entries: s,
    message: r,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(c, h) {
      var v;
      const f = c.value;
      if (f && typeof f == "object") {
        c.typed = !0, c.value = {};
        for (const R in this.entries) {
          const T = this.entries[R];
          if (R in f || (T.type === "exact_optional" || T.type === "optional" || T.type === "nullish") && // @ts-expect-error
          T.default !== void 0) {
            const E = R in f ? (
              // @ts-expect-error
              f[R]
            ) : /* @__PURE__ */ EU(T), C = T["~run"]({ value: E }, h);
            if (C.issues) {
              const N = {
                type: "object",
                origin: "value",
                input: f,
                key: R,
                value: E
              };
              for (const _ of C.issues)
                _.path ? _.path.unshift(N) : _.path = [N], (v = c.issues) == null || v.push(_);
              if (c.issues || (c.issues = C.issues), h.abortEarly) {
                c.typed = !1;
                break;
              }
            }
            C.typed || (c.typed = !1), c.value[R] = C.value;
          } else if (T.fallback !== void 0)
            c.value[R] = /* @__PURE__ */ E4(T);
          else if (T.type !== "exact_optional" && T.type !== "optional" && T.type !== "nullish" && (Eo(this, "key", c, h, {
            input: void 0,
            expected: `"${R}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: f,
                key: R,
                // @ts-expect-error
                value: f[R]
              }
            ]
          }), h.abortEarly))
            break;
        }
      } else
        Eo(this, "type", c, h);
      return c;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ke(s, r) {
  return {
    kind: "schema",
    type: "optional",
    reference: Ke,
    expects: `(${s.expects} | undefined)`,
    async: !1,
    wrapped: s,
    default: r,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(c, h) {
      return c.value === void 0 && (this.default !== void 0 && (c.value = /* @__PURE__ */ EU(this, c, h)), c.value === void 0) ? (c.typed = !0, c) : this.wrapped["~run"](c, h);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function TU(s, r) {
  return {
    kind: "schema",
    type: "picklist",
    reference: TU,
    expects: /* @__PURE__ */ RU(s.map(u6), "|"),
    async: !1,
    options: s,
    message: r,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(c, h) {
      return this.options.includes(c.value) ? c.typed = !0 : Eo(this, "type", c, h), c;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function yU(s, r, c) {
  return {
    kind: "schema",
    type: "record",
    reference: yU,
    expects: "Object",
    async: !1,
    key: s,
    value: r,
    message: c,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(h, f) {
      var R, T;
      const v = h.value;
      if (v && typeof v == "object") {
        h.typed = !0, h.value = {};
        for (const E in v)
          if (/* @__PURE__ */ R4(v, E)) {
            const C = v[E], N = this.key["~run"]({ value: E }, f);
            if (N.issues) {
              const V = {
                type: "object",
                origin: "key",
                input: v,
                key: E,
                value: C
              };
              for (const B of N.issues)
                B.path = [V], (R = h.issues) == null || R.push(B);
              if (h.issues || (h.issues = N.issues), f.abortEarly) {
                h.typed = !1;
                break;
              }
            }
            const _ = this.value["~run"](
              { value: C },
              f
            );
            if (_.issues) {
              const V = {
                type: "object",
                origin: "value",
                input: v,
                key: E,
                value: C
              };
              for (const B of _.issues)
                B.path ? B.path.unshift(V) : B.path = [V], (T = h.issues) == null || T.push(B);
              if (h.issues || (h.issues = _.issues), f.abortEarly) {
                h.typed = !1;
                break;
              }
            }
            (!N.typed || !_.typed) && (h.typed = !1), N.typed && (h.value[N.value] = _.value);
          }
      } else
        Eo(this, "type", h, f);
      return h;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function $t(s) {
  return {
    kind: "schema",
    type: "string",
    reference: $t,
    expects: "string",
    async: !1,
    message: s,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(r, c) {
      return typeof r.value == "string" ? r.typed = !0 : Eo(this, "type", r, c), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function P5(s) {
  let r;
  if (s)
    for (const c of s)
      r ? r.push(...c.issues) : r = c.issues;
  return r;
}
// @__NO_SIDE_EFFECTS__
function NU(s, r) {
  return {
    kind: "schema",
    type: "union",
    reference: NU,
    expects: /* @__PURE__ */ RU(
      s.map((c) => c.expects),
      "|"
    ),
    async: !1,
    options: s,
    message: r,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(c, h) {
      let f, v, R;
      for (const T of this.options) {
        const E = T["~run"]({ value: c.value }, h);
        if (E.typed)
          if (E.issues)
            v ? v.push(E) : v = [E];
          else {
            f = E;
            break;
          }
        else
          R ? R.push(E) : R = [E];
      }
      if (f)
        return f;
      if (v) {
        if (v.length === 1)
          return v[0];
        Eo(this, "type", c, h, {
          issues: /* @__PURE__ */ P5(v)
        }), c.typed = !0;
      } else {
        if ((R == null ? void 0 : R.length) === 1)
          return R[0];
        Eo(this, "type", c, h, {
          issues: /* @__PURE__ */ P5(R)
        });
      }
      return c;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function bU() {
  return {
    kind: "schema",
    type: "unknown",
    reference: bU,
    expects: "unknown",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    },
    "~run"(s) {
      return s.typed = !0, s;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function U4(s, r) {
  const c = {};
  for (const h of r)
    c[h] = s.entries[h];
  return {
    ...s,
    entries: c,
    get "~standard"() {
      return /* @__PURE__ */ or(this);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function f2(s, r, c) {
  const h = s["~run"]({ value: r }, /* @__PURE__ */ SU(c));
  return {
    typed: h.typed,
    success: !h.issues,
    output: h.value,
    issues: h.issues
  };
}
class T4 {
  constructor() {
    x(this, "actionListenersMap");
    x(this, "emittingEvents", !1);
    this.actionListenersMap = /* @__PURE__ */ new Map();
  }
  startEmitting() {
    this.emittingEvents = !0;
  }
  stopEmitting() {
    this.emittingEvents = !1;
  }
  publish(r, c = !1) {
    const h = r.type.startsWith("internal.");
    if (!this.emittingEvents && !c && !h)
      return;
    const f = this.actionListenersMap.get(r.type);
    if (f)
      for (const v of f)
        typeof v == "function" && ("payload" in r ? v(r.payload) : v());
  }
  // Subscribe to actions
  subscribe(r, c, h) {
    var v, R;
    if ((v = h == null ? void 0 : h.signal) != null && v.aborted)
      return () => {
      };
    this.actionListenersMap.get(r) || this.actionListenersMap.set(r, []), (R = this.actionListenersMap.get(r)) == null || R.push(c);
    const f = () => {
      const T = this.actionListenersMap.get(r);
      T && this.actionListenersMap.set(
        r,
        T.filter((E) => E !== c)
      );
    };
    return h != null && h.signal && h.signal.addEventListener("abort", f, { once: !0 }), f;
  }
}
const Je = new T4(), G5 = (s) => {
  let r;
  const c = /* @__PURE__ */ new Set(), h = (C, N) => {
    const _ = typeof C == "function" ? C(r) : C;
    if (!Object.is(_, r)) {
      const V = r;
      r = N ?? (typeof _ != "object" || _ === null) ? _ : Object.assign({}, r, _), c.forEach((B) => B(r, V));
    }
  }, f = () => r, T = { setState: h, getState: f, getInitialState: () => E, subscribe: (C) => (c.add(C), () => c.delete(C)) }, E = r = s(h, f, T);
  return T;
}, y4 = (s) => s ? G5(s) : G5;
function N4(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var dv = { exports: {} }, Dt = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y5;
function b4() {
  if (Y5) return Dt;
  Y5 = 1;
  var s = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), c = Symbol.for("react.fragment"), h = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), v = Symbol.for("react.consumer"), R = Symbol.for("react.context"), T = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), C = Symbol.for("react.memo"), N = Symbol.for("react.lazy"), _ = Symbol.iterator;
  function V(M) {
    return M === null || typeof M != "object" ? null : (M = _ && M[_] || M["@@iterator"], typeof M == "function" ? M : null);
  }
  var B = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, ce = Object.assign, oe = {};
  function be(M, W, q) {
    this.props = M, this.context = W, this.refs = oe, this.updater = q || B;
  }
  be.prototype.isReactComponent = {}, be.prototype.setState = function(M, W) {
    if (typeof M != "object" && typeof M != "function" && M != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, M, W, "setState");
  }, be.prototype.forceUpdate = function(M) {
    this.updater.enqueueForceUpdate(this, M, "forceUpdate");
  };
  function ge() {
  }
  ge.prototype = be.prototype;
  function te(M, W, q) {
    this.props = M, this.context = W, this.refs = oe, this.updater = q || B;
  }
  var _e = te.prototype = new ge();
  _e.constructor = te, ce(_e, be.prototype), _e.isPureReactComponent = !0;
  var Ue = Array.isArray, j = { H: null, A: null, T: null, S: null, V: null }, Te = Object.prototype.hasOwnProperty;
  function Ne(M, W, q, Re, $, Be) {
    return q = Be.ref, {
      $$typeof: s,
      type: M,
      key: W,
      ref: q !== void 0 ? q : null,
      props: Be
    };
  }
  function xe(M, W) {
    return Ne(
      M.type,
      W,
      void 0,
      void 0,
      void 0,
      M.props
    );
  }
  function Fe(M) {
    return typeof M == "object" && M !== null && M.$$typeof === s;
  }
  function ye(M) {
    var W = { "=": "=0", ":": "=2" };
    return "$" + M.replace(/[=:]/g, function(q) {
      return W[q];
    });
  }
  var Ve = /\/+/g;
  function we(M, W) {
    return typeof M == "object" && M !== null && M.key != null ? ye("" + M.key) : W.toString(36);
  }
  function Oe() {
  }
  function Ie(M) {
    switch (M.status) {
      case "fulfilled":
        return M.value;
      case "rejected":
        throw M.reason;
      default:
        switch (typeof M.status == "string" ? M.then(Oe, Oe) : (M.status = "pending", M.then(
          function(W) {
            M.status === "pending" && (M.status = "fulfilled", M.value = W);
          },
          function(W) {
            M.status === "pending" && (M.status = "rejected", M.reason = W);
          }
        )), M.status) {
          case "fulfilled":
            return M.value;
          case "rejected":
            throw M.reason;
        }
    }
    throw M;
  }
  function he(M, W, q, Re, $) {
    var Be = typeof M;
    (Be === "undefined" || Be === "boolean") && (M = null);
    var Ce = !1;
    if (M === null) Ce = !0;
    else
      switch (Be) {
        case "bigint":
        case "string":
        case "number":
          Ce = !0;
          break;
        case "object":
          switch (M.$$typeof) {
            case s:
            case r:
              Ce = !0;
              break;
            case N:
              return Ce = M._init, he(
                Ce(M._payload),
                W,
                q,
                Re,
                $
              );
          }
      }
    if (Ce)
      return $ = $(M), Ce = Re === "" ? "." + we(M, 0) : Re, Ue($) ? (q = "", Ce != null && (q = Ce.replace(Ve, "$&/") + "/"), he($, W, q, "", function(dt) {
        return dt;
      })) : $ != null && (Fe($) && ($ = xe(
        $,
        q + ($.key == null || M && M.key === $.key ? "" : ("" + $.key).replace(
          Ve,
          "$&/"
        ) + "/") + Ce
      )), W.push($)), 1;
    Ce = 0;
    var It = Re === "" ? "." : Re + ":";
    if (Ue(M))
      for (var Pe = 0; Pe < M.length; Pe++)
        Re = M[Pe], Be = It + we(Re, Pe), Ce += he(
          Re,
          W,
          q,
          Be,
          $
        );
    else if (Pe = V(M), typeof Pe == "function")
      for (M = Pe.call(M), Pe = 0; !(Re = M.next()).done; )
        Re = Re.value, Be = It + we(Re, Pe++), Ce += he(
          Re,
          W,
          q,
          Be,
          $
        );
    else if (Be === "object") {
      if (typeof M.then == "function")
        return he(
          Ie(M),
          W,
          q,
          Re,
          $
        );
      throw W = String(M), Error(
        "Objects are not valid as a React child (found: " + (W === "[object Object]" ? "object with keys {" + Object.keys(M).join(", ") + "}" : W) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return Ce;
  }
  function O(M, W, q) {
    if (M == null) return M;
    var Re = [], $ = 0;
    return he(M, Re, "", "", function(Be) {
      return W.call(q, Be, $++);
    }), Re;
  }
  function G(M) {
    if (M._status === -1) {
      var W = M._result;
      W = W(), W.then(
        function(q) {
          (M._status === 0 || M._status === -1) && (M._status = 1, M._result = q);
        },
        function(q) {
          (M._status === 0 || M._status === -1) && (M._status = 2, M._result = q);
        }
      ), M._status === -1 && (M._status = 0, M._result = W);
    }
    if (M._status === 1) return M._result.default;
    throw M._result;
  }
  var se = typeof reportError == "function" ? reportError : function(M) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var W = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof M == "object" && M !== null && typeof M.message == "string" ? String(M.message) : String(M),
        error: M
      });
      if (!window.dispatchEvent(W)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", M);
      return;
    }
    console.error(M);
  };
  function De() {
  }
  return Dt.Children = {
    map: O,
    forEach: function(M, W, q) {
      O(
        M,
        function() {
          W.apply(this, arguments);
        },
        q
      );
    },
    count: function(M) {
      var W = 0;
      return O(M, function() {
        W++;
      }), W;
    },
    toArray: function(M) {
      return O(M, function(W) {
        return W;
      }) || [];
    },
    only: function(M) {
      if (!Fe(M))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return M;
    }
  }, Dt.Component = be, Dt.Fragment = c, Dt.Profiler = f, Dt.PureComponent = te, Dt.StrictMode = h, Dt.Suspense = E, Dt.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = j, Dt.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(M) {
      return j.H.useMemoCache(M);
    }
  }, Dt.cache = function(M) {
    return function() {
      return M.apply(null, arguments);
    };
  }, Dt.cloneElement = function(M, W, q) {
    if (M == null)
      throw Error(
        "The argument must be a React element, but you passed " + M + "."
      );
    var Re = ce({}, M.props), $ = M.key, Be = void 0;
    if (W != null)
      for (Ce in W.ref !== void 0 && (Be = void 0), W.key !== void 0 && ($ = "" + W.key), W)
        !Te.call(W, Ce) || Ce === "key" || Ce === "__self" || Ce === "__source" || Ce === "ref" && W.ref === void 0 || (Re[Ce] = W[Ce]);
    var Ce = arguments.length - 2;
    if (Ce === 1) Re.children = q;
    else if (1 < Ce) {
      for (var It = Array(Ce), Pe = 0; Pe < Ce; Pe++)
        It[Pe] = arguments[Pe + 2];
      Re.children = It;
    }
    return Ne(M.type, $, void 0, void 0, Be, Re);
  }, Dt.createContext = function(M) {
    return M = {
      $$typeof: R,
      _currentValue: M,
      _currentValue2: M,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, M.Provider = M, M.Consumer = {
      $$typeof: v,
      _context: M
    }, M;
  }, Dt.createElement = function(M, W, q) {
    var Re, $ = {}, Be = null;
    if (W != null)
      for (Re in W.key !== void 0 && (Be = "" + W.key), W)
        Te.call(W, Re) && Re !== "key" && Re !== "__self" && Re !== "__source" && ($[Re] = W[Re]);
    var Ce = arguments.length - 2;
    if (Ce === 1) $.children = q;
    else if (1 < Ce) {
      for (var It = Array(Ce), Pe = 0; Pe < Ce; Pe++)
        It[Pe] = arguments[Pe + 2];
      $.children = It;
    }
    if (M && M.defaultProps)
      for (Re in Ce = M.defaultProps, Ce)
        $[Re] === void 0 && ($[Re] = Ce[Re]);
    return Ne(M, Be, void 0, void 0, null, $);
  }, Dt.createRef = function() {
    return { current: null };
  }, Dt.forwardRef = function(M) {
    return { $$typeof: T, render: M };
  }, Dt.isValidElement = Fe, Dt.lazy = function(M) {
    return {
      $$typeof: N,
      _payload: { _status: -1, _result: M },
      _init: G
    };
  }, Dt.memo = function(M, W) {
    return {
      $$typeof: C,
      type: M,
      compare: W === void 0 ? null : W
    };
  }, Dt.startTransition = function(M) {
    var W = j.T, q = {};
    j.T = q;
    try {
      var Re = M(), $ = j.S;
      $ !== null && $(q, Re), typeof Re == "object" && Re !== null && typeof Re.then == "function" && Re.then(De, se);
    } catch (Be) {
      se(Be);
    } finally {
      j.T = W;
    }
  }, Dt.unstable_useCacheRefresh = function() {
    return j.H.useCacheRefresh();
  }, Dt.use = function(M) {
    return j.H.use(M);
  }, Dt.useActionState = function(M, W, q) {
    return j.H.useActionState(M, W, q);
  }, Dt.useCallback = function(M, W) {
    return j.H.useCallback(M, W);
  }, Dt.useContext = function(M) {
    return j.H.useContext(M);
  }, Dt.useDebugValue = function() {
  }, Dt.useDeferredValue = function(M, W) {
    return j.H.useDeferredValue(M, W);
  }, Dt.useEffect = function(M, W, q) {
    var Re = j.H;
    if (typeof q == "function")
      throw Error(
        "useEffect CRUD overload is not enabled in this build of React."
      );
    return Re.useEffect(M, W);
  }, Dt.useId = function() {
    return j.H.useId();
  }, Dt.useImperativeHandle = function(M, W, q) {
    return j.H.useImperativeHandle(M, W, q);
  }, Dt.useInsertionEffect = function(M, W) {
    return j.H.useInsertionEffect(M, W);
  }, Dt.useLayoutEffect = function(M, W) {
    return j.H.useLayoutEffect(M, W);
  }, Dt.useMemo = function(M, W) {
    return j.H.useMemo(M, W);
  }, Dt.useOptimistic = function(M, W) {
    return j.H.useOptimistic(M, W);
  }, Dt.useReducer = function(M, W, q) {
    return j.H.useReducer(M, W, q);
  }, Dt.useRef = function(M) {
    return j.H.useRef(M);
  }, Dt.useState = function(M) {
    return j.H.useState(M);
  }, Dt.useSyncExternalStore = function(M, W, q) {
    return j.H.useSyncExternalStore(
      M,
      W,
      q
    );
  }, Dt.useTransition = function() {
    return j.H.useTransition();
  }, Dt.version = "19.1.0", Dt;
}
var a2 = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
a2.exports;
var X5;
function C4() {
  return X5 || (X5 = 1, function(s, r) {
    process.env.NODE_ENV !== "production" && function() {
      function c(F, z) {
        Object.defineProperty(v.prototype, F, {
          get: function() {
            z[0], z[1];
          }
        });
      }
      function h(F) {
        return F === null || typeof F != "object" ? null : (F = xn && F[xn] || F["@@iterator"], typeof F == "function" ? F : null);
      }
      function f(F, z) {
        F = (F = F.constructor) && (F.displayName || F.name) || "ReactClass";
        var Ze = F + "." + z;
        Yt[Ze] || (console.error(
          "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",
          z,
          F
        ), Yt[Ze] = !0);
      }
      function v(F, z, Ze) {
        this.props = F, this.context = z, this.refs = sr, this.updater = Ze || hn;
      }
      function R() {
      }
      function T(F, z, Ze) {
        this.props = F, this.context = z, this.refs = sr, this.updater = Ze || hn;
      }
      function E(F) {
        return "" + F;
      }
      function C(F) {
        try {
          E(F);
          var z = !1;
        } catch {
          z = !0;
        }
        if (z) {
          z = console;
          var Ze = z.error, Ae = typeof Symbol == "function" && Symbol.toStringTag && F[Symbol.toStringTag] || F.constructor.name || "Object";
          return Ze.call(
            z,
            "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
            Ae
          ), E(F);
        }
      }
      function N(F) {
        if (F == null) return null;
        if (typeof F == "function")
          return F.$$typeof === Vr ? null : F.displayName || F.name || null;
        if (typeof F == "string") return F;
        switch (F) {
          case M:
            return "Fragment";
          case q:
            return "Profiler";
          case W:
            return "StrictMode";
          case Ce:
            return "Suspense";
          case It:
            return "SuspenseList";
          case dn:
            return "Activity";
        }
        if (typeof F == "object")
          switch (typeof F.tag == "number" && console.error(
            "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
          ), F.$$typeof) {
            case De:
              return "Portal";
            case $:
              return (F.displayName || "Context") + ".Provider";
            case Re:
              return (F._context.displayName || "Context") + ".Consumer";
            case Be:
              var z = F.render;
              return F = F.displayName, F || (F = z.displayName || z.name || "", F = F !== "" ? "ForwardRef(" + F + ")" : "ForwardRef"), F;
            case Pe:
              return z = F.displayName || null, z !== null ? z : N(F.type) || "Memo";
            case dt:
              z = F._payload, F = F._init;
              try {
                return N(F(z));
              } catch {
              }
          }
        return null;
      }
      function _(F) {
        if (F === M) return "<>";
        if (typeof F == "object" && F !== null && F.$$typeof === dt)
          return "<...>";
        try {
          var z = N(F);
          return z ? "<" + z + ">" : "<...>";
        } catch {
          return "<...>";
        }
      }
      function V() {
        var F = vt.A;
        return F === null ? null : F.getOwner();
      }
      function B() {
        return Error("react-stack-top-frame");
      }
      function ce(F) {
        if (ea.call(F, "key")) {
          var z = Object.getOwnPropertyDescriptor(F, "key").get;
          if (z && z.isReactWarning) return !1;
        }
        return F.key !== void 0;
      }
      function oe(F, z) {
        function Ze() {
          Ta || (Ta = !0, console.error(
            "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
            z
          ));
        }
        Ze.isReactWarning = !0, Object.defineProperty(F, "key", {
          get: Ze,
          configurable: !0
        });
      }
      function be() {
        var F = N(this.type);
        return Uo[F] || (Uo[F] = !0, console.error(
          "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
        )), F = this.props.ref, F !== void 0 ? F : null;
      }
      function ge(F, z, Ze, Ae, Ye, ut, gt, Vt) {
        return Ze = ut.ref, F = {
          $$typeof: se,
          type: F,
          key: z,
          props: ut,
          _owner: Ye
        }, (Ze !== void 0 ? Ze : null) !== null ? Object.defineProperty(F, "ref", {
          enumerable: !1,
          get: be
        }) : Object.defineProperty(F, "ref", { enumerable: !1, value: null }), F._store = {}, Object.defineProperty(F._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: 0
        }), Object.defineProperty(F, "_debugInfo", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: null
        }), Object.defineProperty(F, "_debugStack", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: gt
        }), Object.defineProperty(F, "_debugTask", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: Vt
        }), Object.freeze && (Object.freeze(F.props), Object.freeze(F)), F;
      }
      function te(F, z) {
        return z = ge(
          F.type,
          z,
          void 0,
          void 0,
          F._owner,
          F.props,
          F._debugStack,
          F._debugTask
        ), F._store && (z._store.validated = F._store.validated), z;
      }
      function _e(F) {
        return typeof F == "object" && F !== null && F.$$typeof === se;
      }
      function Ue(F) {
        var z = { "=": "=0", ":": "=2" };
        return "$" + F.replace(/[=:]/g, function(Ze) {
          return z[Ze];
        });
      }
      function j(F, z) {
        return typeof F == "object" && F !== null && F.key != null ? (C(F.key), Ue("" + F.key)) : z.toString(36);
      }
      function Te() {
      }
      function Ne(F) {
        switch (F.status) {
          case "fulfilled":
            return F.value;
          case "rejected":
            throw F.reason;
          default:
            switch (typeof F.status == "string" ? F.then(Te, Te) : (F.status = "pending", F.then(
              function(z) {
                F.status === "pending" && (F.status = "fulfilled", F.value = z);
              },
              function(z) {
                F.status === "pending" && (F.status = "rejected", F.reason = z);
              }
            )), F.status) {
              case "fulfilled":
                return F.value;
              case "rejected":
                throw F.reason;
            }
        }
        throw F;
      }
      function xe(F, z, Ze, Ae, Ye) {
        var ut = typeof F;
        (ut === "undefined" || ut === "boolean") && (F = null);
        var gt = !1;
        if (F === null) gt = !0;
        else
          switch (ut) {
            case "bigint":
            case "string":
            case "number":
              gt = !0;
              break;
            case "object":
              switch (F.$$typeof) {
                case se:
                case De:
                  gt = !0;
                  break;
                case dt:
                  return gt = F._init, xe(
                    gt(F._payload),
                    z,
                    Ze,
                    Ae,
                    Ye
                  );
              }
          }
        if (gt) {
          gt = F, Ye = Ye(gt);
          var Vt = Ae === "" ? "." + j(gt, 0) : Ae;
          return Bt(Ye) ? (Ze = "", Vt != null && (Ze = Vt.replace(Pn, "$&/") + "/"), xe(Ye, z, Ze, "", function(Nn) {
            return Nn;
          })) : Ye != null && (_e(Ye) && (Ye.key != null && (gt && gt.key === Ye.key || C(Ye.key)), Ze = te(
            Ye,
            Ze + (Ye.key == null || gt && gt.key === Ye.key ? "" : ("" + Ye.key).replace(
              Pn,
              "$&/"
            ) + "/") + Vt
          ), Ae !== "" && gt != null && _e(gt) && gt.key == null && gt._store && !gt._store.validated && (Ze._store.validated = 2), Ye = Ze), z.push(Ye)), 1;
        }
        if (gt = 0, Vt = Ae === "" ? "." : Ae + ":", Bt(F))
          for (var ht = 0; ht < F.length; ht++)
            Ae = F[ht], ut = Vt + j(Ae, ht), gt += xe(
              Ae,
              z,
              Ze,
              ut,
              Ye
            );
        else if (ht = h(F), typeof ht == "function")
          for (ht === F.entries && (_i = !0), F = ht.call(F), ht = 0; !(Ae = F.next()).done; )
            Ae = Ae.value, ut = Vt + j(Ae, ht++), gt += xe(
              Ae,
              z,
              Ze,
              ut,
              Ye
            );
        else if (ut === "object") {
          if (typeof F.then == "function")
            return xe(
              Ne(F),
              z,
              Ze,
              Ae,
              Ye
            );
          throw z = String(F), Error(
            "Objects are not valid as a React child (found: " + (z === "[object Object]" ? "object with keys {" + Object.keys(F).join(", ") + "}" : z) + "). If you meant to render a collection of children, use an array instead."
          );
        }
        return gt;
      }
      function Fe(F, z, Ze) {
        if (F == null) return F;
        var Ae = [], Ye = 0;
        return xe(F, Ae, "", "", function(ut) {
          return z.call(Ze, ut, Ye++);
        }), Ae;
      }
      function ye(F) {
        if (F._status === -1) {
          var z = F._result;
          z = z(), z.then(
            function(Ze) {
              (F._status === 0 || F._status === -1) && (F._status = 1, F._result = Ze);
            },
            function(Ze) {
              (F._status === 0 || F._status === -1) && (F._status = 2, F._result = Ze);
            }
          ), F._status === -1 && (F._status = 0, F._result = z);
        }
        if (F._status === 1)
          return z = F._result, z === void 0 && console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`,
            z
          ), "default" in z || console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`,
            z
          ), z.default;
        throw F._result;
      }
      function Ve() {
        var F = vt.H;
        return F === null && console.error(
          `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
        ), F;
      }
      function we() {
      }
      function Oe(F) {
        if (Fr === null)
          try {
            var z = ("require" + Math.random()).slice(0, 7);
            Fr = (s && s[z]).call(
              s,
              "timers"
            ).setImmediate;
          } catch {
            Fr = function(Ae) {
              To === !1 && (To = !0, typeof MessageChannel > "u" && console.error(
                "This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."
              ));
              var Ye = new MessageChannel();
              Ye.port1.onmessage = Ae, Ye.port2.postMessage(void 0);
            };
          }
        return Fr(F);
      }
      function Ie(F) {
        return 1 < F.length && typeof AggregateError == "function" ? new AggregateError(F) : F[0];
      }
      function he(F, z) {
        z !== Ii - 1 && console.error(
          "You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "
        ), Ii = z;
      }
      function O(F, z, Ze) {
        var Ae = vt.actQueue;
        if (Ae !== null)
          if (Ae.length !== 0)
            try {
              G(Ae), Oe(function() {
                return O(F, z, Ze);
              });
              return;
            } catch (Ye) {
              vt.thrownErrors.push(Ye);
            }
          else vt.actQueue = null;
        0 < vt.thrownErrors.length ? (Ae = Ie(vt.thrownErrors), vt.thrownErrors.length = 0, Ze(Ae)) : z(F);
      }
      function G(F) {
        if (!Mn) {
          Mn = !0;
          var z = 0;
          try {
            for (; z < F.length; z++) {
              var Ze = F[z];
              do {
                vt.didUsePromise = !1;
                var Ae = Ze(!1);
                if (Ae !== null) {
                  if (vt.didUsePromise) {
                    F[z] = Ze, F.splice(0, z);
                    return;
                  }
                  Ze = Ae;
                } else break;
              } while (!0);
            }
            F.length = 0;
          } catch (Ye) {
            F.splice(0, z + 1), vt.thrownErrors.push(Ye);
          } finally {
            Mn = !1;
          }
        }
      }
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      var se = Symbol.for("react.transitional.element"), De = Symbol.for("react.portal"), M = Symbol.for("react.fragment"), W = Symbol.for("react.strict_mode"), q = Symbol.for("react.profiler"), Re = Symbol.for("react.consumer"), $ = Symbol.for("react.context"), Be = Symbol.for("react.forward_ref"), Ce = Symbol.for("react.suspense"), It = Symbol.for("react.suspense_list"), Pe = Symbol.for("react.memo"), dt = Symbol.for("react.lazy"), dn = Symbol.for("react.activity"), xn = Symbol.iterator, Yt = {}, hn = {
        isMounted: function() {
          return !1;
        },
        enqueueForceUpdate: function(F) {
          f(F, "forceUpdate");
        },
        enqueueReplaceState: function(F) {
          f(F, "replaceState");
        },
        enqueueSetState: function(F) {
          f(F, "setState");
        }
      }, Aa = Object.assign, sr = {};
      Object.freeze(sr), v.prototype.isReactComponent = {}, v.prototype.setState = function(F, z) {
        if (typeof F != "object" && typeof F != "function" && F != null)
          throw Error(
            "takes an object of state variables to update or a function which returns an object of state variables."
          );
        this.updater.enqueueSetState(this, F, z, "setState");
      }, v.prototype.forceUpdate = function(F) {
        this.updater.enqueueForceUpdate(this, F, "forceUpdate");
      };
      var Tn = {
        isMounted: [
          "isMounted",
          "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
          "replaceState",
          "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
      }, yn;
      for (yn in Tn)
        Tn.hasOwnProperty(yn) && c(yn, Tn[yn]);
      R.prototype = v.prototype, Tn = T.prototype = new R(), Tn.constructor = T, Aa(Tn, v.prototype), Tn.isPureReactComponent = !0;
      var Bt = Array.isArray, Vr = Symbol.for("react.client.reference"), vt = {
        H: null,
        A: null,
        T: null,
        S: null,
        V: null,
        actQueue: null,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
      }, ea = Object.prototype.hasOwnProperty, Ci = console.createTask ? console.createTask : function() {
        return null;
      };
      Tn = {
        "react-stack-bottom-frame": function(F) {
          return F();
        }
      };
      var Ta, Vi, Uo = {}, ta = Tn["react-stack-bottom-frame"].bind(Tn, B)(), jn = Ci(_(B)), _i = !1, Pn = /\/+/g, _r = typeof reportError == "function" ? reportError : function(F) {
        if (typeof window == "object" && typeof window.ErrorEvent == "function") {
          var z = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: typeof F == "object" && F !== null && typeof F.message == "string" ? String(F.message) : String(F),
            error: F
          });
          if (!window.dispatchEvent(z)) return;
        } else if (typeof process == "object" && typeof process.emit == "function") {
          process.emit("uncaughtException", F);
          return;
        }
        console.error(F);
      }, To = !1, Fr = null, Ii = 0, oi = !1, Mn = !1, Li = typeof queueMicrotask == "function" ? function(F) {
        queueMicrotask(function() {
          return queueMicrotask(F);
        });
      } : Oe;
      Tn = Object.freeze({
        __proto__: null,
        c: function(F) {
          return Ve().useMemoCache(F);
        }
      }), r.Children = {
        map: Fe,
        forEach: function(F, z, Ze) {
          Fe(
            F,
            function() {
              z.apply(this, arguments);
            },
            Ze
          );
        },
        count: function(F) {
          var z = 0;
          return Fe(F, function() {
            z++;
          }), z;
        },
        toArray: function(F) {
          return Fe(F, function(z) {
            return z;
          }) || [];
        },
        only: function(F) {
          if (!_e(F))
            throw Error(
              "React.Children.only expected to receive a single React element child."
            );
          return F;
        }
      }, r.Component = v, r.Fragment = M, r.Profiler = q, r.PureComponent = T, r.StrictMode = W, r.Suspense = Ce, r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = vt, r.__COMPILER_RUNTIME = Tn, r.act = function(F) {
        var z = vt.actQueue, Ze = Ii;
        Ii++;
        var Ae = vt.actQueue = z !== null ? z : [], Ye = !1;
        try {
          var ut = F();
        } catch (ht) {
          vt.thrownErrors.push(ht);
        }
        if (0 < vt.thrownErrors.length)
          throw he(z, Ze), F = Ie(vt.thrownErrors), vt.thrownErrors.length = 0, F;
        if (ut !== null && typeof ut == "object" && typeof ut.then == "function") {
          var gt = ut;
          return Li(function() {
            Ye || oi || (oi = !0, console.error(
              "You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"
            ));
          }), {
            then: function(ht, Nn) {
              Ye = !0, gt.then(
                function(Ji) {
                  if (he(z, Ze), Ze === 0) {
                    try {
                      G(Ae), Oe(function() {
                        return O(
                          Ji,
                          ht,
                          Nn
                        );
                      });
                    } catch (yo) {
                      vt.thrownErrors.push(yo);
                    }
                    if (0 < vt.thrownErrors.length) {
                      var is = Ie(
                        vt.thrownErrors
                      );
                      vt.thrownErrors.length = 0, Nn(is);
                    }
                  } else ht(Ji);
                },
                function(Ji) {
                  he(z, Ze), 0 < vt.thrownErrors.length && (Ji = Ie(
                    vt.thrownErrors
                  ), vt.thrownErrors.length = 0), Nn(Ji);
                }
              );
            }
          };
        }
        var Vt = ut;
        if (he(z, Ze), Ze === 0 && (G(Ae), Ae.length !== 0 && Li(function() {
          Ye || oi || (oi = !0, console.error(
            "A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"
          ));
        }), vt.actQueue = null), 0 < vt.thrownErrors.length)
          throw F = Ie(vt.thrownErrors), vt.thrownErrors.length = 0, F;
        return {
          then: function(ht, Nn) {
            Ye = !0, Ze === 0 ? (vt.actQueue = Ae, Oe(function() {
              return O(
                Vt,
                ht,
                Nn
              );
            })) : ht(Vt);
          }
        };
      }, r.cache = function(F) {
        return function() {
          return F.apply(null, arguments);
        };
      }, r.captureOwnerStack = function() {
        var F = vt.getCurrentStack;
        return F === null ? null : F();
      }, r.cloneElement = function(F, z, Ze) {
        if (F == null)
          throw Error(
            "The argument must be a React element, but you passed " + F + "."
          );
        var Ae = Aa({}, F.props), Ye = F.key, ut = F._owner;
        if (z != null) {
          var gt;
          e: {
            if (ea.call(z, "ref") && (gt = Object.getOwnPropertyDescriptor(
              z,
              "ref"
            ).get) && gt.isReactWarning) {
              gt = !1;
              break e;
            }
            gt = z.ref !== void 0;
          }
          gt && (ut = V()), ce(z) && (C(z.key), Ye = "" + z.key);
          for (Vt in z)
            !ea.call(z, Vt) || Vt === "key" || Vt === "__self" || Vt === "__source" || Vt === "ref" && z.ref === void 0 || (Ae[Vt] = z[Vt]);
        }
        var Vt = arguments.length - 2;
        if (Vt === 1) Ae.children = Ze;
        else if (1 < Vt) {
          gt = Array(Vt);
          for (var ht = 0; ht < Vt; ht++)
            gt[ht] = arguments[ht + 2];
          Ae.children = gt;
        }
        for (Ae = ge(
          F.type,
          Ye,
          void 0,
          void 0,
          ut,
          Ae,
          F._debugStack,
          F._debugTask
        ), Ye = 2; Ye < arguments.length; Ye++)
          ut = arguments[Ye], _e(ut) && ut._store && (ut._store.validated = 1);
        return Ae;
      }, r.createContext = function(F) {
        return F = {
          $$typeof: $,
          _currentValue: F,
          _currentValue2: F,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        }, F.Provider = F, F.Consumer = {
          $$typeof: Re,
          _context: F
        }, F._currentRenderer = null, F._currentRenderer2 = null, F;
      }, r.createElement = function(F, z, Ze) {
        for (var Ae = 2; Ae < arguments.length; Ae++) {
          var Ye = arguments[Ae];
          _e(Ye) && Ye._store && (Ye._store.validated = 1);
        }
        if (Ae = {}, Ye = null, z != null)
          for (ht in Vi || !("__self" in z) || "key" in z || (Vi = !0), ce(z) && (C(z.key), Ye = "" + z.key), z)
            ea.call(z, ht) && ht !== "key" && ht !== "__self" && ht !== "__source" && (Ae[ht] = z[ht]);
        var ut = arguments.length - 2;
        if (ut === 1) Ae.children = Ze;
        else if (1 < ut) {
          for (var gt = Array(ut), Vt = 0; Vt < ut; Vt++)
            gt[Vt] = arguments[Vt + 2];
          Object.freeze && Object.freeze(gt), Ae.children = gt;
        }
        if (F && F.defaultProps)
          for (ht in ut = F.defaultProps, ut)
            Ae[ht] === void 0 && (Ae[ht] = ut[ht]);
        Ye && oe(
          Ae,
          typeof F == "function" ? F.displayName || F.name || "Unknown" : F
        );
        var ht = 1e4 > vt.recentlyCreatedOwnerStacks++;
        return ge(
          F,
          Ye,
          void 0,
          void 0,
          V(),
          Ae,
          ht ? Error("react-stack-top-frame") : ta,
          ht ? Ci(_(F)) : jn
        );
      }, r.createRef = function() {
        var F = { current: null };
        return Object.seal(F), F;
      }, r.forwardRef = function(F) {
        F != null && F.$$typeof === Pe ? console.error(
          "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))."
        ) : typeof F != "function" ? console.error(
          "forwardRef requires a render function but was given %s.",
          F === null ? "null" : typeof F
        ) : F.length !== 0 && F.length !== 2 && console.error(
          "forwardRef render functions accept exactly two parameters: props and ref. %s",
          F.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."
        ), F != null && F.defaultProps != null && console.error(
          "forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?"
        );
        var z = { $$typeof: Be, render: F }, Ze;
        return Object.defineProperty(z, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return Ze;
          },
          set: function(Ae) {
            Ze = Ae, F.name || F.displayName || (Object.defineProperty(F, "name", { value: Ae }), F.displayName = Ae);
          }
        }), z;
      }, r.isValidElement = _e, r.lazy = function(F) {
        return {
          $$typeof: dt,
          _payload: { _status: -1, _result: F },
          _init: ye
        };
      }, r.memo = function(F, z) {
        F == null && console.error(
          "memo: The first argument must be a component. Instead received: %s",
          F === null ? "null" : typeof F
        ), z = {
          $$typeof: Pe,
          type: F,
          compare: z === void 0 ? null : z
        };
        var Ze;
        return Object.defineProperty(z, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return Ze;
          },
          set: function(Ae) {
            Ze = Ae, F.name || F.displayName || (Object.defineProperty(F, "name", { value: Ae }), F.displayName = Ae);
          }
        }), z;
      }, r.startTransition = function(F) {
        var z = vt.T, Ze = {};
        vt.T = Ze, Ze._updatedFibers = /* @__PURE__ */ new Set();
        try {
          var Ae = F(), Ye = vt.S;
          Ye !== null && Ye(Ze, Ae), typeof Ae == "object" && Ae !== null && typeof Ae.then == "function" && Ae.then(we, _r);
        } catch (ut) {
          _r(ut);
        } finally {
          z === null && Ze._updatedFibers && (F = Ze._updatedFibers.size, Ze._updatedFibers.clear(), 10 < F), vt.T = z;
        }
      }, r.unstable_useCacheRefresh = function() {
        return Ve().useCacheRefresh();
      }, r.use = function(F) {
        return Ve().use(F);
      }, r.useActionState = function(F, z, Ze) {
        return Ve().useActionState(
          F,
          z,
          Ze
        );
      }, r.useCallback = function(F, z) {
        return Ve().useCallback(F, z);
      }, r.useContext = function(F) {
        var z = Ve();
        return F.$$typeof === Re && console.error(
          "Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"
        ), z.useContext(F);
      }, r.useDebugValue = function(F, z) {
        return Ve().useDebugValue(F, z);
      }, r.useDeferredValue = function(F, z) {
        return Ve().useDeferredValue(F, z);
      }, r.useEffect = function(F, z, Ze) {
        F == null;
        var Ae = Ve();
        if (typeof Ze == "function")
          throw Error(
            "useEffect CRUD overload is not enabled in this build of React."
          );
        return Ae.useEffect(F, z);
      }, r.useId = function() {
        return Ve().useId();
      }, r.useImperativeHandle = function(F, z, Ze) {
        return Ve().useImperativeHandle(F, z, Ze);
      }, r.useInsertionEffect = function(F, z) {
        return F == null, Ve().useInsertionEffect(F, z);
      }, r.useLayoutEffect = function(F, z) {
        return F == null, Ve().useLayoutEffect(F, z);
      }, r.useMemo = function(F, z) {
        return Ve().useMemo(F, z);
      }, r.useOptimistic = function(F, z) {
        return Ve().useOptimistic(F, z);
      }, r.useReducer = function(F, z, Ze) {
        return Ve().useReducer(F, z, Ze);
      }, r.useRef = function(F) {
        return Ve().useRef(F);
      }, r.useState = function(F) {
        return Ve().useState(F);
      }, r.useSyncExternalStore = function(F, z, Ze) {
        return Ve().useSyncExternalStore(
          F,
          z,
          Ze
        );
      }, r.useTransition = function() {
        return Ve().useTransition();
      }, r.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    }();
  }(a2, a2.exports)), a2.exports;
}
var K5;
function om() {
  return K5 || (K5 = 1, process.env.NODE_ENV === "production" ? dv.exports = b4() : dv.exports = C4()), dv.exports;
}
var ne = om();
const rc = /* @__PURE__ */ N4(ne), V4 = (s) => s;
function _4(s, r = V4) {
  const c = rc.useSyncExternalStore(
    s.subscribe,
    () => r(s.getState()),
    () => r(s.getInitialState())
  );
  return rc.useDebugValue(c), c;
}
const q5 = (s) => {
  const r = y4(s), c = (h) => _4(r, h);
  return Object.assign(c, r), c;
}, lc = (s) => s ? q5(s) : q5, F4 = (s) => (r, c, h) => {
  const f = h.subscribe;
  return h.subscribe = (R, T, E) => {
    let C = R;
    if (T) {
      const N = (E == null ? void 0 : E.equalityFn) || Object.is;
      let _ = R(h.getState());
      C = (V) => {
        const B = R(V);
        if (!N(_, B)) {
          const ce = _;
          T(_ = B, ce);
        }
      }, E != null && E.fireImmediately && T(_, _);
    }
    return f(C);
  }, s(r, c, h);
}, Fd = F4;
function bu(s, r) {
  return (...c) => Object.assign({}, s, r(...c));
}
function M4(s, r) {
  let c;
  try {
    c = s();
  } catch {
    return;
  }
  return {
    getItem: (f) => {
      var v;
      const R = (E) => E === null ? null : JSON.parse(E, void 0), T = (v = c.getItem(f)) != null ? v : null;
      return T instanceof Promise ? T.then(R) : R(T);
    },
    setItem: (f, v) => c.setItem(f, JSON.stringify(v, void 0)),
    removeItem: (f) => c.removeItem(f)
  };
}
const LR = (s) => (r) => {
  try {
    const c = s(r);
    return c instanceof Promise ? c : {
      then(h) {
        return LR(h)(c);
      },
      catch(h) {
        return this;
      }
    };
  } catch (c) {
    return {
      then(h) {
        return this;
      },
      catch(h) {
        return LR(h)(c);
      }
    };
  }
}, k4 = (s, r) => (c, h, f) => {
  let v = {
    storage: M4(() => localStorage),
    partialize: (oe) => oe,
    version: 0,
    merge: (oe, be) => ({
      ...be,
      ...oe
    }),
    ...r
  }, R = !1;
  const T = /* @__PURE__ */ new Set(), E = /* @__PURE__ */ new Set();
  let C = v.storage;
  if (!C)
    return s(
      (...oe) => {
        `${v.name}`, c(...oe);
      },
      h,
      f
    );
  const N = () => {
    const oe = v.partialize({ ...h() });
    return C.setItem(v.name, {
      state: oe,
      version: v.version
    });
  }, _ = f.setState;
  f.setState = (oe, be) => {
    _(oe, be), N();
  };
  const V = s(
    (...oe) => {
      c(...oe), N();
    },
    h,
    f
  );
  f.getInitialState = () => V;
  let B;
  const ce = () => {
    var oe, be;
    if (!C) return;
    R = !1, T.forEach((te) => {
      var _e;
      return te((_e = h()) != null ? _e : V);
    });
    const ge = ((be = v.onRehydrateStorage) == null ? void 0 : be.call(v, (oe = h()) != null ? oe : V)) || void 0;
    return LR(C.getItem.bind(C))(v.name).then((te) => {
      if (te)
        if (typeof te.version == "number" && te.version !== v.version) {
          if (v.migrate) {
            const _e = v.migrate(
              te.state,
              te.version
            );
            return _e instanceof Promise ? _e.then((Ue) => [!0, Ue]) : [!0, _e];
          }
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return [!1, te.state];
      return [!1, void 0];
    }).then((te) => {
      var _e;
      const [Ue, j] = te;
      if (B = v.merge(
        j,
        (_e = h()) != null ? _e : V
      ), c(B, !0), Ue)
        return N();
    }).then(() => {
      ge == null || ge(B, void 0), B = h(), R = !0, E.forEach((te) => te(B));
    }).catch((te) => {
      ge == null || ge(void 0, te);
    });
  };
  return f.persist = {
    setOptions: (oe) => {
      v = {
        ...v,
        ...oe
      }, oe.storage && (C = oe.storage);
    },
    clearStorage: () => {
      C == null || C.removeItem(v.name);
    },
    getOptions: () => v,
    rehydrate: () => ce(),
    hasHydrated: () => R,
    onHydrate: (oe) => (T.add(oe), () => {
      T.delete(oe);
    }),
    onFinishHydration: (oe) => (E.add(oe), () => {
      E.delete(oe);
    })
  }, v.skipHydration || ce(), B || V;
}, D4 = k4, uv = 3 / 4, qf = 16 / 9, ac = 8, TR = 240, yv = {
  MODERATOR: "moderator",
  NONE: "none"
}, We = {
  AUDIO: "audio",
  VIDEO: "video",
  SCREENSHARE: "screenshare"
}, Ai = {
  TILE: "TILE",
  SIDEBAR: "SIDEBAR",
  SPOTLIGHT: "SPOTLIGHT"
}, im = {
  VOICE: "VOICE",
  VIDEO: "VIDEO"
}, Dv = {
  FRONT: "FRONT",
  REAR: "REAR"
}, Vd = {
  USER: "user",
  ENVIRONMENT: "environment"
}, h6 = {
  USER: 1
}, m6 = {
  userInfo: "user-info",
  initialConfig: "initial_config"
}, yd = {
  FULL_HD: 1080,
  HIGH: 720,
  STANDARD: 360,
  LOW: 180,
  NONE: 0
}, Q4 = {
  WEB: "web"
}, st = {
  SessionStatusListener: {
    onConnected: "onConnected",
    onSessionJoined: "onSessionJoined",
    onSessionLeft: "onSessionLeft",
    onConnectionLost: "onConnectionLost",
    onConnectionRestored: "onConnectionRestored",
    onRemoteConnectionLost: "onRemoteConnectionLost",
    onRemoteConnectionRestored: "onRemoteConnectionRestored",
    onConnectionClosed: "onConnectionClosed",
    onConnectionFailed: "onConnectionFailed"
  },
  MediaEventsListener: {
    onAudioMuted: "onAudioMuted",
    onAudioUnMuted: "onAudioUnMuted",
    onVideoPaused: "onVideoPaused",
    onVideoResumed: "onVideoResumed",
    onRecordingStarted: "onRecordingStarted",
    onRecordingStopped: "onRecordingStopped",
    onStreamingStarted: "onStreamingStarted",
    onStreamingStopped: "onStreamingStopped",
    onScreenShareStarted: "onScreenShareStarted",
    onScreenShareStopped: "onScreenShareStopped"
  },
  ParticipantEventsListner: {
    onParticipantConnected: "onParticipantConnected",
    onParticipantJoined: "onParticipantJoined",
    onParticipantLeft: "onParticipantLeft",
    onParticipantAudioMuted: "onParticipantAudioMuted",
    onParticipantAudioUnmuted: "onParticipantAudioUnmuted",
    onParticipantVideoPaused: "onParticipantVideoPaused",
    onParticipantVideoResumed: "onParticipantVideoResumed",
    onParticipantHandRaised: "onParticipantHandRaised",
    onParticipantHandLowered: "onParticipantHandLowered",
    onParticipantStartedScreenShare: "onParticipantStartedScreenShare",
    onParticipantStoppedScreenShare: "onParticipantStoppedScreenShare",
    onParticipantStartedRecording: "onParticipantStartedRecording",
    onParticipantStoppedRecording: "onParticipantStoppedRecording",
    onParticipantStartedStreaming: "onParticipantStartedStreaming",
    onParticipantStoppedStreaming: "onParticipantStoppedStreaming",
    onDominantSpeakerChanged: "onDominantSpeakerChanged",
    onParticipantListChanged: "onParticipantListChanged"
  },
  ButtonClickListener: {
    onLeaveSessionButtonClicked: "onLeaveSessionButtonClicked",
    onRaiseHandButtonClicked: "onRaiseHandButtonClicked",
    onShareInviteButtonClicked: "onShareInviteButtonClicked",
    onChangeLayoutButtonClicked: "onChangeLayoutButtonClicked",
    onParticipantListButtonClicked: "onParticipantListButtonClicked",
    onToggleAudioButtonClicked: "onToggleAudioButtonClicked",
    onToggleVideoButtonClicked: "onToggleVideoButtonClicked",
    onRecordingToggleButtonClicked: "onRecordingToggleButtonClicked",
    onScreenShareButtonClicked: "onScreenShareButtonClicked",
    onChatButtonClicked: "onChatButtonClicked"
  },
  CallLayoutListener: {
    onCallLayoutChanged: "onCallLayoutChanged",
    onParticipantListVisible: "onParticipantListVisible",
    onParticipantListHidden: "onParticipantListHidden"
  }
}, Cu = {
  MediaEventsListener: {
    ...st.MediaEventsListener,
    onAudioInputDeviceChanged: "onAudioInputDeviceChanged",
    onVideoInputDeviceChanged: "onVideoInputDeviceChanged",
    onAudioOutputDeviceChanged: "onAudioOutputDeviceChanged",
    onAudioInputDevicesChanged: "onAudioInputDevicesChanged",
    onVideoInputDevicesChanged: "onVideoInputDevicesChanged",
    onAudioOutputDevicesChanged: "onAudioOutputDevicesChanged",
    onVirtualBackgroundFailed: "onVirtualBackgroundFailed"
  }
}, hu = {
  MediaEventsListener: {
    ...st.MediaEventsListener,
    onAudioModeChanged: "onAudioModeChanged",
    onAudioModesChanged: "onAudioModesChanged",
    onCameraFacingChanged: "onCameraFacingChanged"
  },
  ButtonClickListener: {
    ...st.ButtonClickListener
  },
  CallLayoutListener: {
    ...st.CallLayoutListener,
    onPictureInPictureLayoutEnabled: "onPictureInPictureLayoutEnabled",
    onPictureInPictureLayoutDisabled: "onPictureInPictureLayoutDisabled"
  }
}, Un = {
  connectionWillClose: "internal.sessionWillClose",
  onConnectionEstablished: "internal.onConnectionEstablished",
  onSessionJoined: "internal.onSessionJoined",
  notification: "internal.notification",
  queryPermission: "internal.queryPermission",
  lifecycle: {
    componentDidMount: "internal.componentDidMount",
    componentWillUnmount: "internal.componentWillUnmount",
    SDKInitialized: "internal.SDKInitialized"
  }
}, Qv = [
  { code: "en-US", label: "English (United States)" },
  { code: "de-DE", label: "German (Germany)" },
  { code: "en-GB", label: "English (United Kingdom)" },
  { code: "es-ES", label: "Spanish (Spain)" },
  { code: "fr-FR", label: "French (France)" },
  { code: "hi-IN", label: "Hindi (India)" },
  { code: "hu-HU", label: "Hungarian (Hungary)" },
  { code: "it-IT", label: "Italian (Italy)" },
  { code: "ja-JP", label: "Japanese (Japan)" },
  { code: "ko-KR", label: "Korean (South Korea)" },
  { code: "lt-LT", label: "Lithuanian (Lithuania)" },
  { code: "ms-MY", label: "Malay (Malaysia)" },
  { code: "nl-NL", label: "Dutch (Netherlands)" },
  { code: "pt-PT", label: "Portuguese (Portugal)" },
  { code: "ru-RU", label: "Russian (Russia)" },
  { code: "sv-SE", label: "Swedish (Sweden)" },
  { code: "tr-TR", label: "Turkish (Turkey)" },
  { code: "zh", label: "Chinese Mandarin (Simplified, China)" },
  { code: "zh-TW", label: "Chinese Mandarin (Traditional, Taiwan)" }
];
function x4(s, r, c) {
  if (s <= 0 || r <= 0 || c <= 0)
    throw new Error(
      "Container dimensions and number of tiles must be positive"
    );
  const f = s * r / c, v = TR * TR * uv;
  if (f < v) {
    const _e = Math.max(
      2,
      Math.floor(s / TR)
    ), Ue = Math.ceil(c / _e), j = _e * ac, Te = (s - j) / _e, Ne = Te * uv;
    return {
      rows: Ue,
      columns: _e,
      tileWidth: Te,
      tileHeight: Ne,
      paddingVertical: 0,
      allocatedWidth: s,
      allocatedHeight: r
    };
  }
  const R = Math.sqrt(c);
  let T = Math.floor(R), E = Math.ceil(c / T), C = yR(
    s,
    r,
    E,
    T
  );
  if (C < uv)
    for (; C < uv && E > 1; )
      E--, T = Math.ceil(c / E), C = yR(
        s,
        r,
        E,
        T
      );
  else
    for (; C > qf && E < c; )
      E++, T = Math.ceil(c / E), C = yR(
        s,
        r,
        E,
        T
      );
  Math.ceil(c / (E - 1)) === T && E--;
  const _ = E * ac, V = T * ac;
  let B = (s - _) / E, ce = (r - V) / T, oe = 0;
  const be = B / ce;
  be < 9 / 16 ? (oe = (ce - B * qf) * T / 2, ce = B * qf) : be > qf && (B = ce * qf);
  const ge = B * E + _, te = ce * T + V;
  return {
    rows: T,
    columns: E,
    tileWidth: B,
    tileHeight: ce,
    paddingVertical: oe,
    allocatedWidth: ge,
    allocatedHeight: te
  };
}
function yR(s, r, c, h) {
  const f = c * ac, v = h * ac, R = (s - f) / c, T = (r - v) / h;
  return R / T;
}
const $5 = (s) => Symbol.iterator in s, eE = (s) => (
  // HACK: avoid checking entries type
  "entries" in s
), tE = (s, r) => {
  const c = s instanceof Map ? s : new Map(s.entries()), h = r instanceof Map ? r : new Map(r.entries());
  if (c.size !== h.size)
    return !1;
  for (const [f, v] of c)
    if (!Object.is(v, h.get(f)))
      return !1;
  return !0;
}, Z4 = (s, r) => {
  const c = s[Symbol.iterator](), h = r[Symbol.iterator]();
  let f = c.next(), v = h.next();
  for (; !f.done && !v.done; ) {
    if (!Object.is(f.value, v.value))
      return !1;
    f = c.next(), v = h.next();
  }
  return !!f.done && !!v.done;
};
function O4(s, r) {
  return Object.is(s, r) ? !0 : typeof s != "object" || s === null || typeof r != "object" || r === null || Object.getPrototypeOf(s) !== Object.getPrototypeOf(r) ? !1 : $5(s) && $5(r) ? eE(s) && eE(r) ? tE(s, r) : Z4(s, r) : tE(
    { entries: () => Object.entries(s) },
    { entries: () => Object.entries(r) }
  );
}
const w4 = (s) => s.split(" ").map((r) => r[0]).join("").toUpperCase().slice(0, 2), CU = (s) => {
  const r = Math.floor(s / 1e3), c = Math.floor(r / 3600), h = Math.floor(r % 3600 / 60), f = r % 60, v = h.toString().padStart(2, "0"), R = f.toString().padStart(2, "0");
  return c > 0 ? `${c.toString().padStart(2, "0")}:${v}:${R}` : `${v}:${R}`;
};
function VU(s) {
  try {
    return JSON.parse(s);
  } catch (r) {
    return console.error("Failed to parse JSON:", r), null;
  }
}
const qh = (s) => s.getType() === "audio" ? We.AUDIO : s.getVideoType() === "desktop" ? We.SCREENSHARE : We.VIDEO;
function JR(s, r, c) {
  const h = new Set(r.map(c));
  return s.filter((f) => !h.has(c(f)));
}
function p6(s, r) {
  if (s.length !== r.length)
    return !1;
  for (let c = 0; c < s.length; c++)
    if (!O4(s[c], r[c]))
      return !1;
  return !0;
}
function _U(s, r) {
  return (s == null ? void 0 : s.deviceId) === (r == null ? void 0 : r.deviceId) && (s == null ? void 0 : s.label) === (r == null ? void 0 : r.label);
}
function Ph(s) {
  return s.find((r) => r.deviceId === "default") || s[0];
}
function B4(s, r, c = 5e3) {
  return new Promise((h, f) => {
    if (r(s.getState())) {
      h();
      return;
    }
    const v = setTimeout(() => {
      R(), f(new Error("waitForStoreState timed out"));
    }, c), R = s.subscribe((T) => {
      r(T) && (clearTimeout(v), R(), h());
    });
  });
}
const A4 = [
  "connection.droppedError",
  "connection.otherError",
  "connection.serverError"
];
function FU(s) {
  return A4.includes(s.name);
}
async function rr(s, r) {
  try {
    return { data: r != null ? await Promise.race([
      s,
      new Promise(
        (h, f) => setTimeout(() => f(new Error("timeout")), r)
      )
    ]) : await s, error: null };
  } catch (c) {
    return { data: null, error: c };
  }
}
function MU(s) {
  try {
    return { data: s(), error: null };
  } catch (r) {
    return { data: null, error: r };
  }
}
function kU(s, r) {
  let c = null;
  return (...h) => {
    c && clearTimeout(c), c = setTimeout(() => {
      MU(() => s(...h));
    }, r);
  };
}
const I4 = 3e3, $h = /* @__PURE__ */ new WeakMap(), f6 = /* @__PURE__ */ new WeakSet();
function L4(s) {
  return f6.has(s);
}
function Jv(s, r) {
  if (f6.has(s))
    return r === void 0 ? Promise.resolve() : Promise.reject(new Error("Track is being disposed"));
  const c = s.setEffect(r), h = $h.get(s) ?? /* @__PURE__ */ new Set(), f = () => {
    h.delete(v), h.size === 0 && $h.delete(s);
  }, v = c.then(f, f);
  return h.add(v), $h.set(s, h), c;
}
async function J4(s) {
  let r;
  const c = new Promise((h) => {
    r = setTimeout(() => h(!0), I4);
  });
  try {
    let h = $h.get(s);
    for (; h; ) {
      const f = Promise.all(h).then(() => !1);
      if (await Promise.race([f, c]))
        return;
      h = $h.get(s);
    }
  } finally {
    clearTimeout(r);
  }
}
function W4(s) {
  var r;
  for (const c of [s._originalStream, s.stream])
    (r = c == null ? void 0 : c.getTracks) == null || r.call(c).forEach((h) => h.stop());
}
async function H4(s) {
  f6.add(s);
  try {
    $h.has(s) && await J4(s), await s.dispose();
  } catch (r) {
    throw W4(s), r;
  }
}
const z4 = /* @__PURE__ */ ri({
  low: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
  standard: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
  high: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
  fullHd: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
  ultraHd: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
  ssHigh: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi())
}), hv = /* @__PURE__ */ ri({
  maxBitratesVideo: /* @__PURE__ */ Ke(z4),
  scalabilityModeEnabled: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea()),
  useSimulcast: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea()),
  useKSVC: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea())
}), j4 = /* @__PURE__ */ ri({
  codecPreferenceOrder: /* @__PURE__ */ Ke(/* @__PURE__ */ kv(/* @__PURE__ */ $t())),
  screenshareCodec: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
  mobileScreenshareCodec: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
  enableAdaptiveMode: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea()),
  av1: /* @__PURE__ */ Ke(hv),
  h264: /* @__PURE__ */ Ke(hv),
  vp8: /* @__PURE__ */ Ke(hv),
  vp9: /* @__PURE__ */ Ke(hv),
  minHeightForQualityLvl: /* @__PURE__ */ Ke(/* @__PURE__ */ yU(/* @__PURE__ */ $t(), /* @__PURE__ */ $t())),
  mobileCodecPreferenceOrder: /* @__PURE__ */ Ke(/* @__PURE__ */ kv(/* @__PURE__ */ $t()))
}), P4 = /* @__PURE__ */ ri({
  uid: /* @__PURE__ */ $t(),
  name: /* @__PURE__ */ $t(),
  avatar: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
  status: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
  role: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
  lastActiveAt: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi())
}), G4 = /* @__PURE__ */ ri({
  WEBRTC_HOST: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
  ANALYTICS_HOST: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
  ANALYTICS_VERSION: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
  PRESENTER_MODE_ENABLED: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea()),
  connectionConfig: /* @__PURE__ */ ri({
    audioQuality: /* @__PURE__ */ Ke(
      /* @__PURE__ */ ri({
        stereo: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea())
      })
    ),
    bridgeChannel: /* @__PURE__ */ Ke(
      /* @__PURE__ */ ri({
        preferSctp: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea())
      })
    ),
    constraints: /* @__PURE__ */ Ke(
      /* @__PURE__ */ ri({
        video: /* @__PURE__ */ Ke(
          /* @__PURE__ */ ri({
            height: /* @__PURE__ */ Ke(
              /* @__PURE__ */ ri({
                ideal: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
                max: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
                min: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi())
              })
            ),
            width: /* @__PURE__ */ Ke(
              /* @__PURE__ */ ri({
                ideal: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
                max: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
                min: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi())
              })
            )
          })
        )
      })
    ),
    e2ee: /* @__PURE__ */ Ke(/* @__PURE__ */ kv(/* @__PURE__ */ bU())),
    e2eping: /* @__PURE__ */ Ke(
      /* @__PURE__ */ ri({
        enabled: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea())
      })
    ),
    flags: /* @__PURE__ */ Ke(
      /* @__PURE__ */ ri({
        receiveMultipleVideoStreams: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea()),
        sendMultipleVideoStreams: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea()),
        sourceNameSignaling: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea()),
        ssrcRewritingEnabled: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea())
      })
    ),
    hosts: /* @__PURE__ */ ri({
      domain: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
      muc: /* @__PURE__ */ Ke(/* @__PURE__ */ $t())
    }),
    hiddenDomain: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
    bosh: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
    websocket: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
    serviceUrl: /* @__PURE__ */ $t(),
    p2p: /* @__PURE__ */ ri({
      enabled: /* @__PURE__ */ Ea()
    }),
    resolution: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
    // Only its max is read by lib-jitsi-meet: 5 or less sends a bridge screen
    // share as its full-resolution layer alone. Defaults to keeping all layers.
    desktopSharingFrameRate: /* @__PURE__ */ Ke(
      /* @__PURE__ */ ri({
        min: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
        max: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi())
      })
    ),
    videoQuality: /* @__PURE__ */ Ke(j4),
    pcStatsInterval: /* @__PURE__ */ Ke(/* @__PURE__ */ Bi()),
    // Set by the client (never by the backend): a prepared session is created
    // silent so lib-jitsi-meet keeps the bridge audio receive inactive until
    // the media join.
    startSilent: /* @__PURE__ */ Ke(/* @__PURE__ */ Ea())
  })
}), DU = /* @__PURE__ */ ri({
  callToken: /* @__PURE__ */ $t(),
  settings: G4,
  sessionId: /* @__PURE__ */ $t(),
  user: P4
}), g6 = /* @__PURE__ */ ri({
  pid: /* @__PURE__ */ $t(),
  name: /* @__PURE__ */ $t(),
  uid: /* @__PURE__ */ $t(),
  // audioMuted: v.boolean(),
  // videoPaused: v.boolean(),
  avatar: /* @__PURE__ */ Ke(/* @__PURE__ */ $t())
});
function v6() {
  const s = Hn();
  return s === "preparing" || s === "prepared";
}
function Cr(s, r, c = {}) {
  const h = je.getState().getParticipantById(r);
  if (h) {
    const f = /* @__PURE__ */ f2(g6, h);
    f.success && Je.publish(
      {
        type: s,
        payload: f.output
      },
      c.forceEmit
    );
  }
}
function QU() {
  return je.getState().participants.flatMap((r) => {
    const c = /* @__PURE__ */ f2(g6, r);
    return c.success ? [c.output] : [];
  });
}
function Y4(s = {}) {
  Je.publish(
    {
      type: st.ParticipantEventsListner.onParticipantListChanged,
      payload: QU()
    },
    s.forceEmit
  );
}
class S6 {
  /**
   * Mutes or unmutes the local user's audio during the call.
   *
   * The boolean parameter exists for backward compatibility with the v4 SDK,
   * where `muteAudio(false)` was the way to unmute. New code should prefer
   * {@link SessionMethodsCore.unmuteAudio} for clarity.
   *
   * @param muteAudio - `true` (default) mutes the local audio track, `false` unmutes it.
   */
  static muteAudio(r = !0) {
    r ? Hv() : PR();
  }
  /**
   * Unmutes the local user's audio during the call.
   */
  static unmuteAudio() {
    PR();
  }
  /**
   * Toggles the local user's audio mute state.
   * If audio is muted, it will be unmuted, and vice versa.
   */
  static toggleAudio() {
    $U();
  }
  /**
   * Pauses or resumes the local user's video stream.
   *
   * The boolean parameter exists for backward compatibility with the v4 SDK,
   * where `pauseVideo(false)` was the way to resume. New code should prefer
   * {@link SessionMethodsCore.resumeVideo} for clarity.
   *
   * @param pauseVideo - `true` (default) pauses the local video track, `false` resumes it.
   */
  static pauseVideo(r = !0) {
    r ? v2() : Zv();
  }
  /**
   * Resumes the local user's video stream.
   */
  static resumeVideo() {
    Zv();
  }
  /**
   * Toggles the local user's video stream.
   * If video is paused, it will be resumed, and vice versa.
   */
  static toggleVideo() {
    eT();
  }
  /**
   * Local user leaves the current session. While a session is merely
   * prepared (see `prepareSession`), this cancels the prepare instead:
   * `onSessionLeft` is not fired, `onConnectionClosed` is. Also cancels a
   * `connect()` / join that is still generating or verifying its token, or
   * still connecting — the remaining steps are skipped and
   * `onConnectionClosed` fires once (design-docs/CANCEL_CONNECT_DESIGN.md).
   */
  static leaveSession() {
    $i();
  }
  /**
   * Returns the current session state:
   * - `idle` — no session;
   * - `preparing` — `prepareSession()` is connecting / joining;
   * - `prepared` — connected and joined in prepared state (invisible to
   *   others, no media); `joinSession()` will be near-instant;
   * - `joining` — a direct `joinSession()` (no prior prepare) is connecting;
   * - `joined` — the local user is in the session.
   */
  static getSessionState() {
    const r = Hn();
    return r === "left" ? "idle" : r;
  }
  /**
   * Ends the current session for all participants.
   * This will terminate the conference and disconnect everyone. Also honoured
   * while the session is merely prepared (see `connect()`): the prepared user
   * is in the room at the signalling level, so the end request is sent as is.
   * The server only acts on it when the local user is a moderator. Before
   * the conference is joined (token generation / verification, connecting,
   * join in flight) there is nothing to end for anyone else: this cancels the
   * connect exactly like `leaveSession()` (CANCEL_CONNECT_DESIGN D4).
   */
  static endSessionForAll() {
    $i({ shouldEndSession: !0 });
  }
  /**
   * Retrieves the current list of remote participants in the call session —
   * the same roster the `onParticipantListChanged` listener receives (both go
   * through one helper, so they can never disagree). The local user is not in
   * it, and neither is anyone whose identity is not known yet: participants
   * without a `uid` — recorder / transcriber bots, and remotes whose
   * `user-info` has not landed — are left out
   * (design-docs/GET_PARTICIPANTS_DESIGN.md D1, D8).
   *
   * The array is a snapshot: it is safe to sort / mutate, and it does not
   * update as the call changes — re-call this, or subscribe to
   * `onParticipantListChanged`.
   *
   * @returns The remote participants of the call session; `[]` when the local
   * user is alone in it.
   */
  static getParticipants() {
    return QU();
  }
  /**
   * Raises the user's virtual hand in the call.
   */
  static raiseHand() {
    WU();
  }
  /**
   * Lowers the user's virtual hand in the call.
   */
  static lowerHand() {
    xv();
  }
  /**
   * Toggles the user's virtual hand state.
   * If the hand is raised, it will be lowered, and vice versa.
   */
  static toggleHand() {
    y6();
  }
  /**
   * Switches between the front and rear camera.
   */
  static switchCamera() {
    uT();
  }
  /**
   * Sets the layout type for the call.
   * @param layout - The type of layout to set (tile, sidebar or spotlight).
   */
  static setLayout(r) {
    yu(r);
  }
  /**
   * Starts streaming the call to the given RTMP destination.
   * @param streamUrl - The RTMP ingest URL (e.g., "rtmp://a.rtmp.youtube.com/live2").
   * @param streamKey - The stream key for the destination (e.g., "xxxx-xxxx-xxxx-xxxx-xxxx").
   */
  static startStreaming(r, c) {
    jR(r, c);
  }
  /**
   * Stops the ongoing call streaming.
   */
  static stopStreaming() {
    YU();
  }
  /**
   * Starts recording the call.
   */
  static startRecording() {
    g2();
  }
  /**
   * Stops the ongoing call recording.
   */
  static stopRecording() {
    PU();
  }
  /**
   * Toggles the call recording state.
   * If recording is active, it will be stopped, and vice versa.
   */
  static toggleRecording() {
    GU();
  }
  /**
   * Starts transcription of the call.
   */
  static startTranscription() {
    C6();
  }
  /**
   * Stops the ongoing call transcription.
   */
  static stopTranscription() {
    oT();
  }
  /**
   * Pins a participant's video to focus on them.
   * @param participantId - The ID of the participant to pin.
   * @param type - The type of the participant.
   */
  static pinParticipant(r, c) {
    IU(r, c);
  }
  /**
   * Unpins a participant's video.
   */
  static unpinParticipant() {
    LU();
  }
  /**
   * Mutes the audio of a specific participant.
   * @param participantId - The ID of the participant to mute.
   */
  static muteParticipant(r) {
    UT(r);
  }
  /**
   * Pauses the video stream of a specific participant.
   * @param participantId - The ID of the participant whose video to pause.
   */
  static pauseParticipantVideo(r) {
    DN(r);
  }
  /**
   * Sets the unread message count displayed on the chat button.
   * @param count - The number of unread messages.
   */
  static setChatButtonUnreadCount(r) {
    x8(r);
  }
  /**
   * Toggles the visibility of the participant list panel.
   */
  static toggleParticipantList() {
    M8();
  }
  /**
   * Shows the participant list panel.
   */
  static showParticipantList() {
    F8();
  }
  /**
   * Hides the participant list panel.
   */
  static hideParticipantList() {
    nT();
  }
  // Legacy Methods
  /**
   * @deprecated switchToVideoCall is deprecated and not supported.
   */
  static switchToVideoCall() {
    console.error("switchToVideoCall method deprecated and not supported.");
  }
  /**
   * @deprecated use leaveSession() instead
   */
  static endSession() {
    this.leaveSession();
  }
  /**
   * Retrieves call details for a given session ID and auth token.
   * @param sessionID - The session ID of the call.
   * @param authToken - The authentication token required to make the API call.
   * @returns A Promise that resolves to a CallLog object containing the call details.
   * @throws {CometChatCallsException} If there is an error retrieving the call details.
   * @deprecated This method is deprecated and not supported.
   */
  static getCallDetails(r, c) {
    throw new Error("This method is deprecated and not supported.");
  }
}
const xU = [
  "leaveSession",
  "endSession",
  "endSessionForAll",
  "getSessionState",
  "getCallDetails",
  "getParticipants"
];
function ZU(s, r, { exclude: c = [], guard: h }) {
  const f = /* @__PURE__ */ new Set([
    "length",
    "name",
    "prototype",
    "caller",
    "arguments",
    ...c
  ]), v = [];
  for (let R = r; R && R !== Function.prototype; R = Object.getPrototypeOf(R))
    for (const T of Object.getOwnPropertyNames(R)) {
      if (f.has(T) || T in s)
        continue;
      const E = Object.getOwnPropertyDescriptor(R, T);
      if (typeof (E == null ? void 0 : E.value) != "function")
        continue;
      const C = E.value;
      Object.defineProperty(s, T, {
        configurable: !0,
        writable: !0,
        enumerable: !1,
        value: function(..._) {
          if (h(this, T))
            return C.apply(r, _);
        }
      }), v.push(T);
    }
  return v;
}
function X4() {
  const s = Hn();
  return s !== "idle" && s !== "left";
}
class OU {
  /**
   * @internal The platform layer creates its one instance; apps reach it
   * through `connect()` / `initiateCall()` / `getActiveSession()`.
   */
  constructor() {
    x(this, "_sessionId", null);
    x(this, "_callToken", "");
    x(this, "_settings", {});
    /** Which prepare the state below belongs to; a later one supersedes it. */
    x(this, "prepareId", 0);
    /** `true` from {@link beginPrepare} until the prepare has settled. */
    x(this, "preparing", !1);
    x(this, "outcome", null);
    x(this, "_settled", Promise.resolve(null));
    x(this, "resolveSettled", null);
  }
  /**
   * The session this object describes — the ID `connect()` was called with.
   * `null` when nothing named it to the SDK: before the first `connect()`,
   * or for a session joined directly with a call token only.
   */
  get sessionId() {
    return this._sessionId;
  }
  /**
   * The call token of the session this object describes: minted by
   * `connect()` (`''` until it exists — the object describes the session from
   * before the token does, so a cancel during the token generation lands on
   * it too) or handed to a direct join. This is what the actual join needs.
   */
  get callToken() {
    return this._callToken;
  }
  /** The session settings, frozen at prepare (D6) or applied by the direct join. */
  get settings() {
    return this._settings;
  }
  /**
   * Resolves once the current prepare has settled, with the same outcome as
   * {@link prepareStatus} / {@link error}; resolves `null` when there is no
   * prepare (before the first `connect()`, or after a direct join). A prepare
   * superseded by a later `connect()` settles `cancelled`.
   */
  get settled() {
    return this._settled;
  }
  /** Outcome of the current prepare; see {@link PrepareStatus}. */
  get prepareStatus() {
    return this.outcome ? this.outcome.status : this.preparing ? "pending" : "none";
  }
  /** Why the prepare failed; `null` unless `prepareStatus` is `failed`. */
  get error() {
    var r;
    return ((r = this.outcome) == null ? void 0 : r.status) === "failed" ? this.outcome.error : null;
  }
  /**
   * Starts describing the session `connect()` / `initiateCall()` is about
   * to prepare — before its token is minted, so a failure or a cancel on the
   * way to the prepare lands here too. A prepare still in flight is
   * superseded: its waiters hear `cancelled`. Returns the id of this prepare
   * — hand it to {@link settle} / {@link cancelPendingPrepare} /
   * {@link isPreparing} so a reply of a superseded prepare is ignored — and
   * the promise of *this* prepare's outcome (unlike {@link settled}, which
   * follows the object to whatever prepare is current).
   * @internal
   */
  beginPrepare(r, c, h = null) {
    this.cancelPendingPrepare(), this.prepareId += 1, this._sessionId = h, this._callToken = r, this._settings = c, this.outcome = null, this.preparing = !0;
    const f = new Promise((v) => {
      this.resolveSettled = v;
    });
    return this._settled = f, { prepareId: this.prepareId, settled: f };
  }
  /**
   * Starts describing a session that is joined directly (the static
   * `joinSession()`, the React Native `Component` mount of a session that
   * was not prepared). A prepare still in flight is superseded. The prepare
   * outcome is kept when the join is of the very session that was prepared
   * — it says why the prepare did not survive — and cleared to `none` for
   * any other session.
   * @internal
   */
  beginDirectJoin(r, c, h = null) {
    this.cancelPendingPrepare();
    const f = this.isSameSession(r, h);
    this.prepareId += 1, this._sessionId = h, this._callToken = r, this._settings = c, this.preparing = !1, this.resolveSettled = null, f || (this.outcome = null, this._settled = Promise.resolve(null));
  }
  /**
   * Whether the prepare `prepareId` is the current one and still in flight
   * — neither settled, nor cancelled, nor superseded by a later prepare or
   * a direct join. The platform continuations ask after every await.
   * @internal
   */
  isPreparing(r) {
    return this.preparing && this.prepareId === r;
  }
  /**
   * Records the token minted for the current prepare (`connect()` /
   * `initiateCall()` begin the prepare before generating it).
   * @internal
   */
  setCallToken(r) {
    this._callToken = r;
  }
  /**
   * Records the outcome of the prepare `prepareId` (the current one by
   * default). First outcome wins; a superseded prepare is ignored.
   * @internal
   */
  settle(r, c = this.prepareId) {
    var h;
    this.isPreparing(c) && (this.outcome = r, this.preparing = !1, (h = this.resolveSettled) == null || h.call(this, r), this.resolveSettled = null);
  }
  /**
   * Cancels the prepare `prepareId` (the current one by default) if it has
   * not settled yet, e.g. while its token is still being minted or verified,
   * before the core is involved. No-op otherwise.
   * @internal
   */
  cancelPendingPrepare(r = this.prepareId) {
    this.settle({ status: "cancelled", error: null }, r);
  }
  /**
   * Whether the SDK owns a live session: one being prepared (from the
   * moment `connect()` is called, before any token exists), prepared, being
   * joined or joined — through a prepare or directly. `false` once the
   * session ended, was cancelled or its prepare failed. Same name and
   * meaning as the Android / iOS `CallSession`, and what backs
   * `CometChatCalls.getActiveSession()`.
   */
  isSessionActive() {
    return this.preparing || X4();
  }
  /**
   * The current state of the session: the core session state, `idle` when
   * no session is live.
   */
  getSessionState() {
    if (!this.isSessionActive())
      return "idle";
    const r = Hn();
    return r === "left" ? "idle" : r;
  }
  /**
   * Whether the local user is actually in the call: `true` only once the
   * session is joined. `false` while it is idle, preparing, prepared (in the
   * lobby), being joined or left — that is what {@link isSessionActive}
   * covers. Same name and meaning as the Android / iOS `CallSession`.
   */
  isSessionJoined() {
    return this.getSessionState() === "joined";
  }
  /**
   * The remote participants of the active call session — the same roster the
   * `onParticipantListChanged` listener receives. Same as the static
   * `CometChatCalls.getParticipants()`.
   *
   * Returns an empty array when no session is active, and does so silently:
   * this is a getter, not a command, and the obvious cleanup pattern (handle
   * `onSessionLeft` → read the roster one last time) must not warn
   * (design-docs/GET_PARTICIPANTS_DESIGN.md D4). The guard is load-bearing
   * all the same — the stores are reset just after the session is left, so
   * there is a window in which the phase is already `left` while the roster
   * is still populated, and a stale roster must not leak through it.
   *
   * The array is a snapshot and does not update as the call changes.
   */
  getParticipants() {
    return this.isSessionActive() ? S6.getParticipants() : [];
  }
  /**
   * Leaves the live session: cancels the prepare while merely preparing /
   * prepared (`onConnectionClosed` fires, `onSessionLeft` does not), leaves
   * the call once joined. A no-op when no session is live. Same as the
   * static `leaveSession()`.
   */
  async leave() {
    this.isSessionActive() && (await $i(), this.cancelPendingPrepare());
  }
  /**
   * Ends the live session for all participants (see the static
   * `endSessionForAll()`). Before the conference is joined this cancels the
   * connect exactly like {@link leave}; once joined the end request is sent
   * and the teardown arrives with the server's confirmation. A no-op when
   * no session is live.
   */
  async endSessionForAll() {
    this.guardActive("endSessionForAll") && (await $i({ shouldEndSession: !0 }), this.cancelPendingPrepare());
  }
  /**
   * @deprecated This method is deprecated and not supported.
   */
  getCallDetails(r, c) {
    throw new Error("This method is deprecated and not supported.");
  }
  /**
   * Subscribes to an SDK event. Like a listener registered on the Android /
   * iOS `CallSession`, it stays registered across sessions until the
   * returned unsubscribe function is called. Same as the static
   * `CometChatCalls.addEventListener()`.
   */
  addEventListener(r, c) {
    return Je.subscribe(
      r,
      c
    );
  }
  /**
   * Forgets the session this object describes. Test-only: the SDK never
   * resets the object, it re-points it at the next session.
   * @internal
   */
  reset() {
    this.cancelPendingPrepare(), this._sessionId = null, this._callToken = "", this._settings = {}, this.outcome = null, this.preparing = !1, this.resolveSettled = null, this._settled = Promise.resolve(null);
  }
  /**
   * The ownership guard shared by every mirrored session method.
   * @internal
   */
  guardActive(r) {
    return this.isSessionActive() ? !0 : (`${this.constructor.name}${r}`, !1);
  }
  /**
   * Whether `callToken` / `sessionId` name the session this object
   * describes: by session ID when both sides know it (every
   * `generateToken()` mints a different token for the same session), by
   * token otherwise. Nothing matches an object that describes no session.
   */
  isSameSession(r, c) {
    return c !== null && this._sessionId !== null ? c === this._sessionId : r !== "" && r === this._callToken;
  }
}
ZU(OU.prototype, S6, {
  exclude: xU,
  guard: (s, r) => s.guardActive(r)
});
const K4 = '/*! For license information please see lib-jitsi-meet.min.js.LICENSE.txt */\n!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.JitsiMeetJS=t():e.JitsiMeetJS=t()}(self,(()=>(()=>{var __webpack_modules__={449:(e,t,n)=>{const i=n(526).Z;e.exports=function(e){return"object"==typeof window.JitsiMeetJS?Object.assign({},window.JitsiMeetJS,e):e}(i)},444:e=>{e.exports=class{constructor(e,t,n){this._userId=e,this.setDisplayName(t),this._isLocalStats=n||!1,this.setDominantSpeaker(!1),this.totalDominantSpeakerTime=0,this._dominantSpeakerStart=0,this._isDominantSpeaker=!1,this._isSilent=!1,this._hasLeft=!1,this._faceLandmarks=[]}getUserId(){return this._userId}getDisplayName(){return this.displayName}setDisplayName(e){this.displayName=e}isLocalStats(){return this._isLocalStats}isDominantSpeaker(){return this._isDominantSpeaker}setDominantSpeaker(e,t){if(this.isDominantSpeaker()||!e||t){if(this.isDominantSpeaker())if(e){if(this._isSilent&&!t)this._dominantSpeakerStart=Date.now();else if(!this._isSilent&&t){const e=Date.now()-this._dominantSpeakerStart;this.totalDominantSpeakerTime+=e,this._dominantSpeakerStart=0}}else if(!this._isSilent){const e=Date.now()-this._dominantSpeakerStart;this.totalDominantSpeakerTime+=e,this._dominantSpeakerStart=0}}else this._dominantSpeakerStart=Date.now();this._isDominantSpeaker=e,this._isSilent=t}getTotalDominantSpeakerTime(){let e=this.totalDominantSpeakerTime;return this.isDominantSpeaker()&&!this._isSilent&&(e+=Date.now()-this._dominantSpeakerStart),e}hasLeft(){return this._hasLeft}markAsHasLeft(){this._hasLeft=!0,this.setDominantSpeaker(!1)}getFaceLandmarks(){return this._faceLandmarks}setFaceLandmarks(e){this._faceLandmarks=e}addFaceLandmarks(e){this._faceLandmarks.push(e)}}},832:e=>{function t(e,t){if(!e||!t||"function"!=typeof e.addListener||"function"!=typeof t.emit)throw new Error("Invalid arguments passed to EventEmitterForwarder");this.src=e,this.dest=t,this.listeners=new Map}t.prototype.forward=function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];const i=t[0];t[0]=this.dest;const r=Function.prototype.bind.apply(this.dest.emit,t);this.src.addListener(i,r),this.listeners.set(i,r)},t.prototype.removeListeners=function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];t.forEach((e=>{const t=this.listeners.get(e);t&&(this.src.removeListener(e,t),this.listeners.delete(e))}))},e.exports=t},399:e=>{function t(e,t){return Math.floor(Math.random()*(t-e+1))+e}function n(e){return e[t(0,e.length-1)]}const i={randomHexDigit:()=>n("0123456789abcdef"),randomHexString(e){let t="";for(;e--;)t+=this.randomHexDigit();return t},randomElement:n,randomAlphanumStr:function(e){let t="";for(let i=0;i<e;i+=1)t+=n("0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");return t},randomInt:t};e.exports=i},549:(e,t,n)=>{const i=n(799),r={loadScript(e,t,n,r,o,s){const a=document,d="script",c=a.createElement(d),l=a.getElementsByTagName(d)[0];if(c.async=t,r){const t=i();if(t){const n=t.src,i=n.substring(0,n.lastIndexOf("/")+1);n&&i&&(e=i+e)}}o&&(c.onload=o),s&&(c.onerror=s),c.src=e,n?l.parentNode.insertBefore(c,l):l.parentNode.appendChild(c)}};e.exports=r},667:(e,t,n)=>{const i=n(399),r=["Aaliyah","Aaron","Abagail","Abbey","Abbie","Abbigail","Abby","Abdiel","Abdul","Abdullah","Abe","Abel","Abelardo","Abigail","Abigale","Abigayle","Abner","Abraham","Ada","Adah","Adalberto","Adaline","Adam","Adan","Addie","Addison","Adela","Adelbert","Adele","Adelia","Adeline","Adell","Adella","Adelle","Aditya","Adolf","Adolfo","Adolph","Adolphus","Adonis","Adrain","Adrian","Adriana","Adrianna","Adriel","Adrien","Adrienne","Afton","Aglae","Agnes","Agustin","Agustina","Ahmad","Ahmed","Aida","Aidan","Aiden","Aileen","Aisha","Aiyana","Akeem","Al","Alaina","Alan","Alana","Alanis","Alanna","Alayna","Alba","Albert","Alberta","Albertha","Alberto","Albin","Albina","Alda","Alden","Alec","Aleen","Alejandra","Alejandrin","Alek","Alena","Alene","Alessandra","Alessandro","Alessia","Aletha","Alex","Alexa","Alexander","Alexandra","Alexandre","Alexandrea","Alexandria","Alexandrine","Alexandro","Alexane","Alexanne","Alexie","Alexis","Alexys","Alexzander","Alf","Alfonso","Alfonzo","Alford","Alfred","Alfreda","Alfredo","Ali","Alia","Alice","Alicia","Alisa","Alisha","Alison","Alivia","Aliya","Aliyah","Aliza","Alize","Allan","Allen","Allene","Allie","Allison","Ally","Alphonso","Alta","Althea","Alva","Alvah","Alvena","Alvera","Alverta","Alvina","Alvis","Alyce","Alycia","Alysa","Alysha","Alyson","Alysson","Amalia","Amanda","Amani","Amara","Amari","Amaya","Amber","Ambrose","Amelia","Amelie","Amely","America","Americo","Amie","Amina","Amir","Amira","Amiya","Amos","Amparo","Amy","Amya","Ana","Anabel","Anabelle","Anahi","Anais","Anastacio","Anastasia","Anderson","Andre","Andreane","Andreanne","Andres","Andrew","Andy","Angel","Angela","Angelica","Angelina","Angeline","Angelita","Angelo","Angie","Angus","Anibal","Anika","Anissa","Anita","Aniya","Aniyah","Anjali","Anna","Annabel","Annabell","Annabelle","Annalise","Annamae","Annamarie","Anne","Annetta","Annette","Annie","Ansel","Ansley","Anthony","Antoinette","Antone","Antonetta","Antonette","Antonia","Antonietta","Antonina","Antonio","Antwan","Antwon","Anya","April","Ara","Araceli","Aracely","Arch","Archibald","Ardella","Arden","Ardith","Arely","Ari","Ariane","Arianna","Aric","Ariel","Arielle","Arjun","Arlene","Arlie","Arlo","Armand","Armando","Armani","Arnaldo","Arne","Arno","Arnold","Arnoldo","Arnulfo","Aron","Art","Arthur","Arturo","Arvel","Arvid","Arvilla","Aryanna","Asa","Asha","Ashlee","Ashleigh","Ashley","Ashly","Ashlynn","Ashton","Ashtyn","Asia","Assunta","Astrid","Athena","Aubree","Aubrey","Audie","Audra","Audreanne","Audrey","August","Augusta","Augustine","Augustus","Aurelia","Aurelie","Aurelio","Aurore","Austen","Austin","Austyn","Autumn","Ava","Avery","Avis","Axel","Ayana","Ayden","Ayla","Aylin","Baby","Bailee","Bailey","Barbara","Barney","Baron","Barrett","Barry","Bart","Bartholome","Barton","Baylee","Beatrice","Beau","Beaulah","Bell","Bella","Belle","Ben","Benedict","Benjamin","Bennett","Bennie","Benny","Benton","Berenice","Bernadette","Bernadine","Bernard","Bernardo","Berneice","Bernhard","Bernice","Bernie","Berniece","Bernita","Berry","Bert","Berta","Bertha","Bertram","Bertrand","Beryl","Bessie","Beth","Bethany","Bethel","Betsy","Bette","Bettie","Betty","Bettye","Beulah","Beverly","Bianka","Bill","Billie","Billy","Birdie","Blair","Blaise","Blake","Blanca","Blanche","Blaze","Bo","Bobbie","Bobby","Bonita","Bonnie","Boris","Boyd","Brad","Braden","Bradford","Bradley","Bradly","Brady","Braeden","Brain","Brandi","Brando","Brandon","Brandt","Brandy","Brandyn","Brannon","Branson","Brant","Braulio","Braxton","Brayan","Breana","Breanna","Breanne","Brenda","Brendan","Brenden","Brendon","Brenna","Brennan","Brennon","Brent","Bret","Brett","Bria","Brian","Briana","Brianne","Brice","Bridget","Bridgette","Bridie","Brielle","Brigitte","Brionna","Brisa","Britney","Brittany","Brock","Broderick","Brody","Brook","Brooke","Brooklyn","Brooks","Brown","Bruce","Bryana","Bryce","Brycen","Bryon","Buck","Bud","Buddy","Buford","Bulah","Burdette","Burley","Burnice","Buster","Cade","Caden","Caesar","Caitlyn","Cale","Caleb","Caleigh","Cali","Calista","Callie","Camden","Cameron","Camila","Camilla","Camille","Camren","Camron","Camryn","Camylle","Candace","Candelario","Candice","Candida","Candido","Cara","Carey","Carissa","Carlee","Carleton","Carley","Carli","Carlie","Carlo","Carlos","Carlotta","Carmel","Carmela","Carmella","Carmelo","Carmen","Carmine","Carol","Carolanne","Carole","Carolina","Caroline","Carolyn","Carolyne","Carrie","Carroll","Carson","Carter","Cary","Casandra","Casey","Casimer","Casimir","Casper","Cassandra","Cassandre","Cassidy","Cassie","Catalina","Caterina","Catharine","Catherine","Cathrine","Cathryn","Cathy","Cayla","Ceasar","Cecelia","Cecil","Cecile","Cecilia","Cedrick","Celestine","Celestino","Celia","Celine","Cesar","Chad","Chadd","Chadrick","Chaim","Chance","Chandler","Chanel","Chanelle","Charity","Charlene","Charles","Charley","Charlie","Charlotte","Chase","Chasity","Chauncey","Chaya","Chaz","Chelsea","Chelsey","Chelsie","Chesley","Chester","Chet","Cheyanne","Cheyenne","Chloe","Chris","Christ","Christa","Christelle","Christian","Christiana","Christina","Christine","Christop","Christophe","Christopher","Christy","Chyna","Ciara","Cicero","Cielo","Cierra","Cindy","Citlalli","Clair","Claire","Clara","Clarabelle","Clare","Clarissa","Clark","Claud","Claude","Claudia","Claudie","Claudine","Clay","Clemens","Clement","Clementina","Clementine","Clemmie","Cleo","Cleora","Cleta","Cletus","Cleve","Cleveland","Clifford","Clifton","Clint","Clinton","Clotilde","Clovis","Cloyd","Clyde","Coby","Cody","Colby","Cole","Coleman","Colin","Colleen","Collin","Colt","Colten","Colton","Columbus","Concepcion","Conner","Connie","Connor","Conor","Conrad","Constance","Constantin","Consuelo","Cooper","Cora","Coralie","Corbin","Cordelia","Cordell","Cordia","Cordie","Corene","Corine","Cornelius","Cornell","Corrine","Cortez","Cortney","Cory","Coty","Courtney","Coy","Craig","Crawford","Creola","Cristal","Cristian","Cristina","Cristobal","Cristopher","Cruz","Crystal","Crystel","Cullen","Curt","Curtis","Cydney","Cynthia","Cyril","Cyrus","Dagmar","Dahlia","Daija","Daisha","Daisy","Dakota","Dale","Dallas","Dallin","Dalton","Damaris","Dameon","Damian","Damien","Damion","Damon","Dan","Dana","Dandre","Dane","D\'angelo","Dangelo","Danial","Daniela","Daniella","Danielle","Danika","Dannie","Danny","Dante","Danyka","Daphne","Daphnee","Daphney","Darby","Daren","Darian","Dariana","Darien","Dario","Darion","Darius","Darlene","Daron","Darrel","Darrell","Darren","Darrick","Darrin","Darrion","Darron","Darryl","Darwin","Daryl","Dashawn","Dasia","Dave","David","Davin","Davion","Davon","Davonte","Dawn","Dawson","Dax","Dayana","Dayna","Dayne","Dayton","Dean","Deangelo","Deanna","Deborah","Declan","Dedric","Dedrick","Dee","Deion","Deja","Dejah","Dejon","Dejuan","Delaney","Delbert","Delfina","Delia","Delilah","Dell","Della","Delmer","Delores","Delpha","Delphia","Delphine","Delta","Demarco","Demarcus","Demario","Demetris","Demetrius","Demond","Dena","Denis","Dennis","Deon","Deondre","Deontae","Deonte","Dereck","Derek","Derick","Deron","Derrick","Deshaun","Deshawn","Desiree","Desmond","Dessie","Destany","Destin","Destinee","Destiney","Destini","Destiny","Devan","Devante","Deven","Devin","Devon","Devonte","Devyn","Dewayne","Dewitt","Dexter","Diamond","Diana","Dianna","Diego","Dillan","Dillon","Dimitri","Dina","Dino","Dion","Dixie","Dock","Dolly","Dolores","Domenic","Domenica","Domenick","Domenico","Domingo","Dominic","Dominique","Don","Donald","Donato","Donavon","Donna","Donnell","Donnie","Donny","Dora","Dorcas","Dorian","Doris","Dorothea","Dorothy","Dorris","Dortha","Dorthy","Doug","Douglas","Dovie","Doyle","Drake","Drew","Duane","Dudley","Dulce","Duncan","Durward","Dustin","Dusty","Dwight","Dylan","Earl","Earlene","Earline","Earnest","Earnestine","Easter","Easton","Ebba","Ebony","Ed","Eda","Edd","Eddie","Eden","Edgar","Edgardo","Edison","Edmond","Edmund","Edna","Eduardo","Edward","Edwardo","Edwin","Edwina","Edyth","Edythe","Effie","Efrain","Efren","Eileen","Einar","Eino","Eladio","Elaina","Elbert","Elda","Eldon","Eldora","Eldred","Eldridge","Eleanora","Eleanore","Eleazar","Electa","Elena","Elenor","Elenora","Eleonore","Elfrieda","Eli","Elian","Eliane","Elias","Eliezer","Elijah","Elinor","Elinore","Elisa","Elisabeth","Elise","Eliseo","Elisha","Elissa","Eliza","Elizabeth","Ella","Ellen","Ellie","Elliot","Elliott","Ellis","Ellsworth","Elmer","Elmira","Elmo","Elmore","Elna","Elnora","Elody","Eloisa","Eloise","Elouise","Eloy","Elroy","Elsa","Else","Elsie","Elta","Elton","Elva","Elvera","Elvie","Elvis","Elwin","Elwyn","Elyse","Elyssa","Elza","Emanuel","Emelia","Emelie","Emely","Emerald","Emerson","Emery","Emie","Emil","Emile","Emilia","Emiliano","Emilie","Emilio","Emily","Emma","Emmalee","Emmanuel","Emmanuelle","Emmet","Emmett","Emmie","Emmitt","Emmy","Emory","Ena","Enid","Enoch","Enola","Enos","Enrico","Enrique","Ephraim","Era","Eriberto","Eric","Erica","Erich","Erick","Ericka","Erik","Erika","Erin","Erling","Erna","Ernest","Ernestina","Ernestine","Ernesto","Ernie","Ervin","Erwin","Eryn","Esmeralda","Esperanza","Esta","Esteban","Estefania","Estel","Estell","Estella","Estelle","Estevan","Esther","Estrella","Etha","Ethan","Ethel","Ethelyn","Ethyl","Ettie","Eudora","Eugene","Eugenia","Eula","Eulah","Eulalia","Euna","Eunice","Eusebio","Eva","Evalyn","Evan","Evangeline","Evans","Eve","Eveline","Evelyn","Everardo","Everett","Everette","Evert","Evie","Ewald","Ewell","Ezekiel","Ezequiel","Ezra","Fabian","Fabiola","Fae","Fannie","Fanny","Fatima","Faustino","Fausto","Favian","Fay","Faye","Federico","Felicia","Felicita","Felicity","Felipa","Felipe","Felix","Felton","Fermin","Fern","Fernando","Ferne","Fidel","Filiberto","Filomena","Finn","Fiona","Flavie","Flavio","Fleta","Fletcher","Flo","Florence","Florencio","Florian","Florida","Florine","Flossie","Floy","Floyd","Ford","Forest","Forrest","Foster","Frances","Francesca","Francesco","Francis","Francisca","Francisco","Franco","Frank","Frankie","Franz","Fred","Freda","Freddie","Freddy","Frederic","Frederick","Frederik","Frederique","Fredrick","Fredy","Freeda","Freeman","Freida","Frida","Frieda","Friedrich","Fritz","Furman","Gabe","Gabriel","Gabriella","Gabrielle","Gaetano","Gage","Gail","Gardner","Garett","Garfield","Garland","Garnet","Garnett","Garret","Garrett","Garrick","Garrison","Garry","Garth","Gaston","Gavin","Gay","Gayle","Gaylord","Gene","General","Genesis","Genevieve","Gennaro","Genoveva","Geo","Geoffrey","George","Georgette","Georgiana","Georgianna","Geovanni","Geovanny","Geovany","Gerald","Geraldine","Gerard","Gerardo","Gerda","Gerhard","Germaine","German","Gerry","Gerson","Gertrude","Gia","Gianni","Gideon","Gilbert","Gilberto","Gilda","Giles","Gillian","Gina","Gino","Giovani","Giovanna","Giovanni","Giovanny","Gisselle","Giuseppe","Gladyce","Gladys","Glen","Glenda","Glenna","Glennie","Gloria","Godfrey","Golda","Golden","Gonzalo","Gordon","Grace","Gracie","Graciela","Grady","Graham","Grant","Granville","Grayce","Grayson","Green","Greg","Gregg","Gregoria","Gregorio","Gregory","Greta","Gretchen","Greyson","Griffin","Grover","Guadalupe","Gudrun","Guido","Guillermo","Guiseppe","Gunnar","Gunner","Gus","Gussie","Gust","Gustave","Guy","Gwen","Gwendolyn","Hadley","Hailee","Hailey","Hailie","Hal","Haleigh","Haley","Halie","Halle","Hallie","Hank","Hanna","Hannah","Hans","Hardy","Harley","Harmon","Harmony","Harold","Harrison","Harry","Harvey","Haskell","Hassan","Hassie","Hattie","Haven","Hayden","Haylee","Hayley","Haylie","Hazel","Hazle","Heath","Heather","Heaven","Heber","Hector","Heidi","Helen","Helena","Helene","Helga","Hellen","Helmer","Heloise","Henderson","Henri","Henriette","Henry","Herbert","Herman","Hermann","Hermina","Herminia","Herminio","Hershel","Herta","Hertha","Hester","Hettie","Hilario","Hilbert","Hilda","Hildegard","Hillard","Hillary","Hilma","Hilton","Hipolito","Hiram","Hobart","Holden","Hollie","Hollis","Holly","Hope","Horace","Horacio","Hortense","Hosea","Houston","Howard","Howell","Hoyt","Hubert","Hudson","Hugh","Hulda","Humberto","Hunter","Hyman","Ian","Ibrahim","Icie","Ida","Idell","Idella","Ignacio","Ignatius","Ike","Ila","Ilene","Iliana","Ima","Imani","Imelda","Immanuel","Imogene","Ines","Irma","Irving","Irwin","Isaac","Isabel","Isabell","Isabella","Isabelle","Isac","Isadore","Isai","Isaiah","Isaias","Isidro","Ismael","Isobel","Isom","Israel","Issac","Itzel","Iva","Ivah","Ivory","Ivy","Izabella","Izaiah","Jabari","Jace","Jacey","Jacinthe","Jacinto","Jack","Jackeline","Jackie","Jacklyn","Jackson","Jacky","Jaclyn","Jacquelyn","Jacques","Jacynthe","Jada","Jade","Jaden","Jadon","Jadyn","Jaeden","Jaida","Jaiden","Jailyn","Jaime","Jairo","Jakayla","Jake","Jakob","Jaleel","Jalen","Jalon","Jalyn","Jamaal","Jamal","Jamar","Jamarcus","Jamel","Jameson","Jamey","Jamie","Jamil","Jamir","Jamison","Jammie","Jan","Jana","Janae","Jane","Janelle","Janessa","Janet","Janice","Janick","Janie","Janis","Janiya","Jannie","Jany","Jaquan","Jaquelin","Jaqueline","Jared","Jaren","Jarod","Jaron","Jarred","Jarrell","Jarret","Jarrett","Jarrod","Jarvis","Jasen","Jasmin","Jason","Jasper","Jaunita","Javier","Javon","Javonte","Jay","Jayce","Jaycee","Jayda","Jayde","Jayden","Jaydon","Jaylan","Jaylen","Jaylin","Jaylon","Jayme","Jayne","Jayson","Jazlyn","Jazmin","Jazmyn","Jazmyne","Jean","Jeanette","Jeanie","Jeanne","Jed","Jedediah","Jedidiah","Jeff","Jefferey","Jeffery","Jeffrey","Jeffry","Jena","Jenifer","Jennie","Jennifer","Jennings","Jennyfer","Jensen","Jerad","Jerald","Jeramie","Jeramy","Jerel","Jeremie","Jeremy","Jermain","Jermaine","Jermey","Jerod","Jerome","Jeromy","Jerrell","Jerrod","Jerrold","Jerry","Jess","Jesse","Jessica","Jessie","Jessika","Jessy","Jessyca","Jesus","Jett","Jettie","Jevon","Jewel","Jewell","Jillian","Jimmie","Jimmy","Jo","Joan","Joana","Joanie","Joanne","Joannie","Joanny","Joany","Joaquin","Jocelyn","Jodie","Jody","Joe","Joel","Joelle","Joesph","Joey","Johan","Johann","Johanna","Johathan","John","Johnathan","Johnathon","Johnnie","Johnny","Johnpaul","Johnson","Jolie","Jon","Jonas","Jonatan","Jonathan","Jonathon","Jordan","Jordane","Jordi","Jordon","Jordy","Jordyn","Jorge","Jose","Josefa","Josefina","Joseph","Josephine","Josh","Joshua","Joshuah","Josiah","Josiane","Josianne","Josie","Josue","Jovan","Jovani","Jovanny","Jovany","Joy","Joyce","Juana","Juanita","Judah","Judd","Jude","Judge","Judson","Judy","Jules","Julia","Julian","Juliana","Julianne","Julie","Julien","Juliet","Julio","Julius","June","Junior","Junius","Justen","Justice","Justina","Justine","Juston","Justus","Justyn","Juvenal","Juwan","Kacey","Kaci","Kacie","Kade","Kaden","Kadin","Kaela","Kaelyn","Kaia","Kailee","Kailey","Kailyn","Kaitlin","Kaitlyn","Kale","Kaleb","Kaleigh","Kaley","Kali","Kallie","Kameron","Kamille","Kamren","Kamron","Kamryn","Kane","Kara","Kareem","Karelle","Karen","Kari","Kariane","Karianne","Karina","Karine","Karl","Karlee","Karley","Karli","Karlie","Karolann","Karson","Kasandra","Kasey","Kassandra","Katarina","Katelin","Katelyn","Katelynn","Katharina","Katherine","Katheryn","Kathleen","Kathlyn","Kathryn","Kathryne","Katlyn","Katlynn","Katrina","Katrine","Kattie","Kavon","Kay","Kaya","Kaycee","Kayden","Kayla","Kaylah","Kaylee","Kayleigh","Kayley","Kayli","Kaylie","Kaylin","Keagan","Keanu","Keara","Keaton","Keegan","Keeley","Keely","Keenan","Keira","Keith","Kellen","Kelley","Kelli","Kellie","Kelly","Kelsi","Kelsie","Kelton","Kelvin","Ken","Kendall","Kendra","Kendrick","Kenna","Kennedi","Kennedy","Kenneth","Kennith","Kenny","Kenton","Kenya","Kenyatta","Kenyon","Keon","Keshaun","Keshawn","Keven","Kevin","Kevon","Keyon","Keyshawn","Khalid","Khalil","Kian","Kiana","Kianna","Kiara","Kiarra","Kiel","Kiera","Kieran","Kiley","Kim","Kimberly","King","Kip","Kira","Kirk","Kirsten","Kirstin","Kitty","Kobe","Koby","Kody","Kolby","Kole","Korbin","Korey","Kory","Kraig","Kris","Krista","Kristian","Kristin","Kristina","Kristofer","Kristoffer","Kristopher","Kristy","Krystal","Krystel","Krystina","Kurt","Kurtis","Kyla","Kyle","Kylee","Kyleigh","Kyler","Kylie","Kyra","Lacey","Lacy","Ladarius","Lafayette","Laila","Laisha","Lamar","Lambert","Lamont","Lance","Landen","Lane","Laney","Larissa","Laron","Larry","Larue","Laura","Laurel","Lauren","Laurence","Lauretta","Lauriane","Laurianne","Laurie","Laurine","Laury","Lauryn","Lavada","Lavern","Laverna","Laverne","Lavina","Lavinia","Lavon","Lavonne","Lawrence","Lawson","Layla","Layne","Lazaro","Lea","Leann","Leanna","Leanne","Leatha","Leda","Lee","Leif","Leila","Leilani","Lela","Lelah","Leland","Lelia","Lempi","Lemuel","Lenna","Lennie","Lenny","Lenora","Lenore","Leo","Leola","Leon","Leonard","Leonardo","Leone","Leonel","Leonie","Leonor","Leonora","Leopold","Leopoldo","Leora","Lera","Lesley","Leslie","Lesly","Lessie","Lester","Leta","Letha","Letitia","Levi","Lew","Lewis","Lexi","Lexie","Lexus","Lia","Liam","Liana","Libbie","Libby","Lila","Lilian","Liliana","Liliane","Lilla","Lillian","Lilliana","Lillie","Lilly","Lily","Lilyan","Lina","Lincoln","Linda","Lindsay","Lindsey","Linnea","Linnie","Linwood","Lionel","Lisa","Lisandro","Lisette","Litzy","Liza","Lizeth","Lizzie","Llewellyn","Lloyd","Logan","Lois","Lola","Lolita","Loma","Lon","London","Lonie","Lonnie","Lonny","Lonzo","Lora","Loraine","Loren","Lorena","Lorenz","Lorenza","Lorenzo","Lori","Lorine","Lorna","Lottie","Lou","Louie","Louisa","Lourdes","Louvenia","Lowell","Loy","Loyal","Loyce","Lucas","Luciano","Lucie","Lucienne","Lucile","Lucinda","Lucio","Lucious","Lucius","Lucy","Ludie","Ludwig","Lue","Luella","Luigi","Luis","Luisa","Lukas","Lula","Lulu","Luna","Lupe","Lura","Lurline","Luther","Luz","Lyda","Lydia","Lyla","Lynn","Lyric","Lysanne","Mabel","Mabelle","Mable","Mac","Macey","Maci","Macie","Mack","Mackenzie","Macy","Madaline","Madalyn","Maddison","Madeline","Madelyn","Madelynn","Madge","Madie","Madilyn","Madisen","Madison","Madisyn","Madonna","Madyson","Mae","Maegan","Maeve","Mafalda","Magali","Magdalen","Magdalena","Maggie","Magnolia","Magnus","Maia","Maida","Maiya","Major","Makayla","Makenna","Makenzie","Malachi","Malcolm","Malika","Malinda","Mallie","Mallory","Malvina","Mandy","Manley","Manuel","Manuela","Mara","Marc","Marcel","Marcelina","Marcelino","Marcella","Marcelle","Marcellus","Marcelo","Marcia","Marco","Marcos","Marcus","Margaret","Margarete","Margarett","Margaretta","Margarette","Margarita","Marge","Margie","Margot","Margret","Marguerite","Maria","Mariah","Mariam","Marian","Mariana","Mariane","Marianna","Marianne","Mariano","Maribel","Marie","Mariela","Marielle","Marietta","Marilie","Marilou","Marilyne","Marina","Mario","Marion","Marisa","Marisol","Maritza","Marjolaine","Marjorie","Marjory","Mark","Markus","Marlee","Marlen","Marlene","Marley","Marlin","Marlon","Marques","Marquis","Marquise","Marshall","Marta","Martin","Martina","Martine","Marty","Marvin","Mary","Maryam","Maryjane","Maryse","Mason","Mateo","Mathew","Mathias","Mathilde","Matilda","Matilde","Matt","Matteo","Mattie","Maud","Maude","Maudie","Maureen","Maurice","Mauricio","Maurine","Maverick","Mavis","Max","Maxie","Maxime","Maximilian","Maximillia","Maximillian","Maximo","Maximus","Maxine","Maxwell","May","Maya","Maybell","Maybelle","Maye","Maymie","Maynard","Mayra","Mazie","Mckayla","Mckenna","Mckenzie","Meagan","Meaghan","Meda","Megane","Meggie","Meghan","Mekhi","Melany","Melba","Melisa","Melissa","Mellie","Melody","Melvin","Melvina","Melyna","Melyssa","Mercedes","Meredith","Merl","Merle","Merlin","Merritt","Mertie","Mervin","Meta","Mia","Micaela","Micah","Michael","Michaela","Michale","Micheal","Michel","Michele","Michelle","Miguel","Mikayla","Mike","Mikel","Milan","Miles","Milford","Miller","Millie","Milo","Milton","Mina","Minerva","Minnie","Miracle","Mireille","Mireya","Misael","Missouri","Misty","Mitchel","Mitchell","Mittie","Modesta","Modesto","Mohamed","Mohammad","Mohammed","Moises","Mollie","Molly","Mona","Monica","Monique","Monroe","Monserrat","Monserrate","Montana","Monte","Monty","Morgan","Moriah","Morris","Mortimer","Morton","Mose","Moses","Moshe","Mossie","Mozell","Mozelle","Muhammad","Muriel","Murl","Murphy","Murray","Mustafa","Mya","Myah","Mylene","Myles","Myra","Myriam","Myrl","Myrna","Myron","Myrtice","Myrtie","Myrtis","Myrtle","Nadia","Nakia","Name","Nannie","Naomi","Naomie","Napoleon","Narciso","Nash","Nasir","Nat","Natalia","Natalie","Natasha","Nathan","Nathanael","Nathanial","Nathaniel","Nathen","Nayeli","Neal","Ned","Nedra","Neha","Neil","Nelda","Nella","Nelle","Nellie","Nels","Nelson","Neoma","Nestor","Nettie","Neva","Newell","Newton","Nia","Nicholas","Nicholaus","Nichole","Nick","Nicklaus","Nickolas","Nico","Nicola","Nicolas","Nicole","Nicolette","Nigel","Nikita","Nikki","Nikko","Niko","Nikolas","Nils","Nina","Noah","Noble","Noe","Noel","Noelia","Noemi","Noemie","Noemy","Nola","Nolan","Nona","Nora","Norbert","Norberto","Norene","Norma","Norris","Norval","Norwood","Nova","Novella","Nya","Nyah","Nyasia","Obie","Oceane","Ocie","Octavia","Oda","Odell","Odessa","Odie","Ofelia","Okey","Ola","Olaf","Ole","Olen","Oleta","Olga","Olin","Oliver","Ollie","Oma","Omari","Omer","Ona","Onie","Opal","Ophelia","Ora","Oral","Oran","Oren","Orie","Orin","Orion","Orland","Orlando","Orlo","Orpha","Orrin","Orval","Orville","Osbaldo","Osborne","Oscar","Osvaldo","Oswald","Oswaldo","Otha","Otho","Otilia","Otis","Ottilie","Ottis","Otto","Ova","Owen","Ozella","Pablo","Paige","Palma","Pamela","Pansy","Paolo","Paris","Parker","Pascale","Pasquale","Pat","Patience","Patricia","Patrick","Patsy","Pattie","Paul","Paula","Pauline","Paxton","Payton","Pearl","Pearlie","Pearline","Pedro","Peggie","Penelope","Percival","Percy","Perry","Pete","Peter","Petra","Peyton","Philip","Phoebe","Phyllis","Pierce","Pierre","Pietro","Pink","Pinkie","Piper","Polly","Porter","Precious","Presley","Preston","Price","Prince","Princess","Priscilla","Providenci","Prudence","Queen","Queenie","Quentin","Quincy","Quinn","Quinten","Quinton","Rachael","Rachel","Rachelle","Rae","Raegan","Rafael","Rafaela","Raheem","Rahsaan","Rahul","Raina","Raleigh","Ralph","Ramiro","Ramon","Ramona","Randal","Randall","Randi","Randy","Ransom","Raoul","Raphael","Raphaelle","Raquel","Rashad","Rashawn","Rasheed","Raul","Raven","Ray","Raymond","Raymundo","Reagan","Reanna","Reba","Rebeca","Rebecca","Rebeka","Rebekah","Reece","Reed","Reese","Regan","Reggie","Reginald","Reid","Reilly","Reina","Reinhold","Remington","Rene","Renee","Ressie","Reta","Retha","Retta","Reuben","Reva","Rex","Rey","Reyes","Reymundo","Reyna","Reynold","Rhea","Rhett","Rhianna","Rhiannon","Rhoda","Ricardo","Richard","Richie","Richmond","Rick","Rickey","Rickie","Ricky","Rico","Rigoberto","Riley","Rita","River","Robb","Robbie","Robert","Roberta","Roberto","Robin","Robyn","Rocio","Rocky","Rod","Roderick","Rodger","Rodolfo","Rodrick","Rodrigo","Roel","Rogelio","Roger","Rogers","Rolando","Rollin","Roma","Romaine","Roman","Ron","Ronaldo","Ronny","Roosevelt","Rory","Rosa","Rosalee","Rosalia","Rosalind","Rosalinda","Rosalyn","Rosamond","Rosanna","Rosario","Roscoe","Rose","Rosella","Roselyn","Rosemarie","Rosemary","Rosendo","Rosetta","Rosie","Rosina","Roslyn","Ross","Rossie","Rowan","Rowena","Rowland","Roxane","Roxanne","Roy","Royal","Royce","Rozella","Ruben","Rubie","Ruby","Rubye","Rudolph","Rudy","Rupert","Russ","Russel","Russell","Rusty","Ruth","Ruthe","Ruthie","Ryan","Ryann","Ryder","Rylan","Rylee","Ryleigh","Ryley","Sabina","Sabrina","Sabryna","Sadie","Sadye","Sage","Saige","Sallie","Sally","Salma","Salvador","Salvatore","Sam","Samanta","Samantha","Samara","Samir","Sammie","Sammy","Samson","Sandra","Sandrine","Sandy","Sanford","Santa","Santiago","Santina","Santino","Santos","Sarah","Sarai","Sarina","Sasha","Saul","Savanah","Savanna","Savannah","Savion","Scarlett","Schuyler","Scot","Scottie","Scotty","Seamus","Sean","Sebastian","Sedrick","Selena","Selina","Selmer","Serena","Serenity","Seth","Shad","Shaina","Shakira","Shana","Shane","Shanel","Shanelle","Shania","Shanie","Shaniya","Shanna","Shannon","Shanny","Shanon","Shany","Sharon","Shaun","Shawn","Shawna","Shaylee","Shayna","Shayne","Shea","Sheila","Sheldon","Shemar","Sheridan","Sherman","Sherwood","Shirley","Shyann","Shyanne","Sibyl","Sid","Sidney","Sienna","Sierra","Sigmund","Sigrid","Sigurd","Silas","Sim","Simeon","Simone","Sincere","Sister","Skye","Skyla","Skylar","Sofia","Soledad","Solon","Sonia","Sonny","Sonya","Sophia","Sophie","Spencer","Stacey","Stacy","Stan","Stanford","Stanley","Stanton","Stefan","Stefanie","Stella","Stephan","Stephania","Stephanie","Stephany","Stephen","Stephon","Sterling","Steve","Stevie","Stewart","Stone","Stuart","Summer","Sunny","Susan","Susana","Susanna","Susie","Suzanne","Sven","Syble","Sydnee","Sydney","Sydni","Sydnie","Sylvan","Sylvester","Sylvia","Tabitha","Tad","Talia","Talon","Tamara","Tamia","Tania","Tanner","Tanya","Tara","Taryn","Tate","Tatum","Tatyana","Taurean","Tavares","Taya","Taylor","Teagan","Ted","Telly","Terence","Teresa","Terrance","Terrell","Terrence","Terrill","Terry","Tess","Tessie","Tevin","Thad","Thaddeus","Thalia","Thea","Thelma","Theo","Theodora","Theodore","Theresa","Therese","Theresia","Theron","Thomas","Thora","Thurman","Tia","Tiana","Tianna","Tiara","Tierra","Tiffany","Tillman","Timmothy","Timmy","Timothy","Tina","Tito","Titus","Tobin","Toby","Tod","Tom","Tomas","Tomasa","Tommie","Toney","Toni","Tony","Torey","Torrance","Torrey","Toy","Trace","Tracey","Tracy","Travis","Travon","Tre","Tremaine","Tremayne","Trent","Trenton","Tressa","Tressie","Treva","Trever","Trevion","Trevor","Trey","Trinity","Trisha","Tristian","Tristin","Triston","Troy","Trudie","Trycia","Trystan","Turner","Twila","Tyler","Tyra","Tyree","Tyreek","Tyrel","Tyrell","Tyrese","Tyrique","Tyshawn","Tyson","Ubaldo","Ulices","Ulises","Una","Unique","Urban","Uriah","Uriel","Ursula","Vada","Valentin","Valentina","Valentine","Valerie","Vallie","Van","Vance","Vanessa","Vaughn","Veda","Velda","Vella","Velma","Velva","Vena","Verda","Verdie","Vergie","Verla","Verlie","Vern","Verna","Verner","Vernice","Vernie","Vernon","Verona","Veronica","Vesta","Vicenta","Vicente","Vickie","Vicky","Victor","Victoria","Vida","Vidal","Vilma","Vince","Vincent","Vincenza","Vincenzo","Vinnie","Viola","Violet","Violette","Virgie","Virgil","Virginia","Virginie","Vita","Vito","Viva","Vivian","Viviane","Vivianne","Vivien","Vivienne","Vladimir","Wade","Waino","Waldo","Walker","Wallace","Walter","Walton","Wanda","Ward","Warren","Watson","Wava","Waylon","Wayne","Webster","Weldon","Wellington","Wendell","Wendy","Werner","Westley","Weston","Whitney","Wilber","Wilbert","Wilburn","Wiley","Wilford","Wilfred","Wilfredo","Wilfrid","Wilhelm","Wilhelmine","Will","Willa","Willard","William","Willie","Willis","Willow","Willy","Wilma","Wilmer","Wilson","Wilton","Winfield","Winifred","Winnifred","Winona","Winston","Woodrow","Wyatt","Wyman","Xander","Xavier","Xzavier","Yadira","Yasmeen","Yasmin","Yasmine","Yazmin","Yesenia","Yessenia","Yolanda","Yoshiko","Yvette","Yvonne","Zachariah","Zachary","Zachery","Zack","Zackary","Zackery","Zakary","Zander","Zane","Zaria","Zechariah","Zelda","Zella","Zelma","Zena","Zetta","Zion","Zita","Zoe","Zoey","Zoie","Zoila","Zola","Zora","Zula"];e.exports={generateUsername:function(){return`${i.randomElement(r)}-${i.randomAlphanumStr(3)}`}}},32:(e,t)=>{"use strict";const n=/"(?:_|\\\\u005[Ff])(?:_|\\\\u005[Ff])(?:p|\\\\u0070)(?:r|\\\\u0072)(?:o|\\\\u006[Ff])(?:t|\\\\u0074)(?:o|\\\\u006[Ff])(?:_|\\\\u005[Ff])(?:_|\\\\u005[Ff])"\\s*\\:/;t.parse=function(e){const i="object"==typeof(arguments.length<=1?void 0:arguments[1])&&(arguments.length<=1?void 0:arguments[1]),r=(arguments.length<=1?0:arguments.length-1)>1||!i?arguments.length<=1?void 0:arguments[1]:void 0,o=(arguments.length<=1?0:arguments.length-1)>1&&(arguments.length<=2?void 0:arguments[2])||i||{},s=JSON.parse(e,r);return"ignore"===o.protoAction?s:s&&"object"==typeof s&&e.match(n)?(t.scan(s,o),s):s},t.scan=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=[e];for(;n.length;){const e=n;n=[];for(const i of e){if(Object.prototype.hasOwnProperty.call(i,"__proto__")){if("remove"!==t.protoAction)throw new SyntaxError("Object contains forbidden prototype property");delete i.__proto__}for(const e in i){const t=i[e];t&&"object"==typeof t&&n.push(i[e])}}}},t.safeParse=function(e,n){try{return t.parse(e,n)}catch(e){return null}}},122:function(e,t,n){var i;!function(r,o){"use strict";var s="function",a="undefined",d="object",c="string",l="major",h="model",u="name",p="type",m="vendor",g="version",f="architecture",v="console",_="mobile",y="tablet",E="smarttv",S="wearable",b="embedded",T="Amazon",C="Apple",x="ASUS",R="BlackBerry",A="Browser",w="Chrome",I="Firefox",P="Google",D="Huawei",O="LG",k="Microsoft",N="Motorola",M="Opera",L="Samsung",F="Sharp",j="Sony",V="Xiaomi",U="Zebra",H="Facebook",$="Chromium OS",J="Mac OS",B=function(e){for(var t={},n=0;n<e.length;n++)t[e[n].toUpperCase()]=e[n];return t},q=function(e,t){return typeof e===c&&-1!==G(t).indexOf(G(e))},G=function(e){return e.toLowerCase()},z=function(e,t){if(typeof e===c)return e=e.replace(/^\\s\\s*/,""),typeof t===a?e:e.substring(0,350)},K=function(e,t){for(var n,i,r,a,c,l,h=0;h<t.length&&!c;){var u=t[h],p=t[h+1];for(n=i=0;n<u.length&&!c&&u[n];)if(c=u[n++].exec(e))for(r=0;r<p.length;r++)l=c[++i],typeof(a=p[r])===d&&a.length>0?2===a.length?typeof a[1]==s?this[a[0]]=a[1].call(this,l):this[a[0]]=a[1]:3===a.length?typeof a[1]!==s||a[1].exec&&a[1].test?this[a[0]]=l?l.replace(a[1],a[2]):o:this[a[0]]=l?a[1].call(this,l,a[2]):o:4===a.length&&(this[a[0]]=l?a[3].call(this,l.replace(a[1],a[2])):o):this[a]=l||o;h+=2}},W=function(e,t){for(var n in t)if(typeof t[n]===d&&t[n].length>0){for(var i=0;i<t[n].length;i++)if(q(t[n][i],e))return"?"===n?o:n}else if(q(t[n],e))return"?"===n?o:n;return e},X={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"},Y={browser:[[/\\b(?:crmo|crios)\\/([\\w\\.]+)/i],[g,[u,"Chrome"]],[/edg(?:e|ios|a)?\\/([\\w\\.]+)/i],[g,[u,"Edge"]],[/(opera mini)\\/([-\\w\\.]+)/i,/(opera [mobiletab]{3,6})\\b.+version\\/([-\\w\\.]+)/i,/(opera)(?:.+version\\/|[\\/ ]+)([\\w\\.]+)/i],[u,g],[/opios[\\/ ]+([\\w\\.]+)/i],[g,[u,M+" Mini"]],[/\\bopr\\/([\\w\\.]+)/i],[g,[u,M]],[/(kindle)\\/([\\w\\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\\/ ]?([\\w\\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\\/ ]?([\\w\\.]*)/i,/(ba?idubrowser)[\\/ ]?([\\w\\.]+)/i,/(?:ms|\\()(ie) ([\\w\\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\\/([-\\w\\.]+)/i,/(heytap|ovi)browser\\/([\\d\\.]+)/i,/(weibo)__([\\d\\.]+)/i],[u,g],[/(?:\\buc? ?browser|(?:juc.+)ucweb)[\\/ ]?([\\w\\.]+)/i],[g,[u,"UC"+A]],[/microm.+\\bqbcore\\/([\\w\\.]+)/i,/\\bqbcore\\/([\\w\\.]+).+microm/i],[g,[u,"WeChat(Win) Desktop"]],[/micromessenger\\/([\\w\\.]+)/i],[g,[u,"WeChat"]],[/konqueror\\/([\\w\\.]+)/i],[g,[u,"Konqueror"]],[/trident.+rv[: ]([\\w\\.]{1,9})\\b.+like gecko/i],[g,[u,"IE"]],[/ya(?:search)?browser\\/([\\w\\.]+)/i],[g,[u,"Yandex"]],[/(avast|avg)\\/([\\w\\.]+)/i],[[u,/(.+)/,"$1 Secure "+A],g],[/\\bfocus\\/([\\w\\.]+)/i],[g,[u,I+" Focus"]],[/\\bopt\\/([\\w\\.]+)/i],[g,[u,M+" Touch"]],[/coc_coc\\w+\\/([\\w\\.]+)/i],[g,[u,"Coc Coc"]],[/dolfin\\/([\\w\\.]+)/i],[g,[u,"Dolphin"]],[/coast\\/([\\w\\.]+)/i],[g,[u,M+" Coast"]],[/miuibrowser\\/([\\w\\.]+)/i],[g,[u,"MIUI "+A]],[/fxios\\/([-\\w\\.]+)/i],[g,[u,I]],[/\\bqihu|(qi?ho?o?|360)browser/i],[[u,"360 "+A]],[/(oculus|samsung|sailfish|huawei)browser\\/([\\w\\.]+)/i],[[u,/(.+)/,"$1 "+A],g],[/(comodo_dragon)\\/([\\w\\.]+)/i],[[u,/_/g," "],g],[/(electron)\\/([\\w\\.]+) safari/i,/(tesla)(?: qtcarbrowser|\\/(20\\d\\d\\.[-\\w\\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\\/ ]?([\\w\\.]+)/i],[u,g],[/(metasr)[\\/ ]?([\\w\\.]+)/i,/(lbbrowser)/i,/\\[(linkedin)app\\]/i],[u],[/((?:fban\\/fbios|fb_iab\\/fb4a)(?!.+fbav)|;fbav\\/([\\w\\.]+);)/i],[[u,H],g],[/(kakao(?:talk|story))[\\/ ]([\\w\\.]+)/i,/(naver)\\(.*?(\\d+\\.[\\w\\.]+).*\\)/i,/safari (line)\\/([\\w\\.]+)/i,/\\b(line)\\/([\\w\\.]+)\\/iab/i,/(chromium|instagram)[\\/ ]([-\\w\\.]+)/i],[u,g],[/\\bgsa\\/([\\w\\.]+) .*safari\\//i],[g,[u,"GSA"]],[/musical_ly(?:.+app_?version\\/|_)([\\w\\.]+)/i],[g,[u,"TikTok"]],[/headlesschrome(?:\\/([\\w\\.]+)| )/i],[g,[u,w+" Headless"]],[/ wv\\).+(chrome)\\/([\\w\\.]+)/i],[[u,w+" WebView"],g],[/droid.+ version\\/([\\w\\.]+)\\b.+(?:mobile safari|safari)/i],[g,[u,"Android "+A]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\\/v?([\\w\\.]+)/i],[u,g],[/version\\/([\\w\\.\\,]+) .*mobile\\/\\w+ (safari)/i],[g,[u,"Mobile Safari"]],[/version\\/([\\w(\\.|\\,)]+) .*(mobile ?safari|safari)/i],[g,u],[/webkit.+?(mobile ?safari|safari)(\\/[\\w\\.]+)/i],[u,[g,W,{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}]],[/(webkit|khtml)\\/([\\w\\.]+)/i],[u,g],[/(navigator|netscape\\d?)\\/([-\\w\\.]+)/i],[[u,"Netscape"],g],[/mobile vr; rv:([\\w\\.]+)\\).+firefox/i],[g,[u,I+" Reality"]],[/ekiohf.+(flow)\\/([\\w\\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\\/ ]?([\\w\\.\\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\\/([-\\w\\.]+)$/i,/(firefox)\\/([\\w\\.]+)/i,/(mozilla)\\/([\\w\\.]+) .+rv\\:.+gecko\\/\\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\\. ]?browser)[-\\/ ]?v?([\\w\\.]+)/i,/(links) \\(([\\w\\.]+)/i,/panasonic;(viera)/i],[u,g],[/(cobalt)\\/([\\w\\.]+)/i],[u,[g,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\\)]/i],[[f,"amd64"]],[/(ia32(?=;))/i],[[f,G]],[/((?:i[346]|x)86)[;\\)]/i],[[f,"ia32"]],[/\\b(aarch64|arm(v?8e?l?|_?64))\\b/i],[[f,"arm64"]],[/\\b(arm(?:v[67])?ht?n?[fl]p?)\\b/i],[[f,"armhf"]],[/windows (ce|mobile); ppc;/i],[[f,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\\))/i],[[f,/ower/,"",G]],[/(sun4\\w)[;\\)]/i],[[f,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\\))|\\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\\b|pa-risc)/i],[[f,G]]],device:[[/\\b(sch-i[89]0\\d|shw-m380s|sm-[ptx]\\w{2,4}|gt-[pn]\\d{2,4}|sgh-t8[56]9|nexus 10)/i],[h,[m,L],[p,y]],[/\\b((?:s[cgp]h|gt|sm)-\\w+|sc[g-]?[\\d]+a?|galaxy nexus)/i,/samsung[- ]([-\\w]+)/i,/sec-(sgh\\w+)/i],[h,[m,L],[p,_]],[/(?:\\/|\\()(ip(?:hone|od)[\\w, ]*)(?:\\/|;)/i],[h,[m,C],[p,_]],[/\\((ipad);[-\\w\\),; ]+apple/i,/applecoremedia\\/[\\w\\.]+ \\((ipad)/i,/\\b(ipad)\\d\\d?,\\d\\d?[;\\]].+ios/i],[h,[m,C],[p,y]],[/(macintosh);/i],[h,[m,C]],[/\\b(sh-?[altvz]?\\d\\d[a-ekm]?)/i],[h,[m,F],[p,_]],[/\\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\\d{2})\\b(?!.+d\\/s)/i],[h,[m,D],[p,y]],[/(?:huawei|honor)([-\\w ]+)[;\\)]/i,/\\b(nexus 6p|\\w{2,4}e?-[atu]?[ln][\\dx][012359c][adn]?)\\b(?!.+d\\/s)/i],[h,[m,D],[p,_]],[/\\b(poco[\\w ]+)(?: bui|\\))/i,/\\b; (\\w+) build\\/hm\\1/i,/\\b(hm[-_ ]?note?[_ ]?(?:\\d\\w)?) bui/i,/\\b(redmi[\\-_ ]?(?:note|k)?[\\w_ ]+)(?: bui|\\))/i,/\\b(mi[-_ ]?(?:a\\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\\d?\\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\\))/i],[[h,/_/g," "],[m,V],[p,_]],[/\\b(mi[-_ ]?(?:pad)(?:[\\w_ ]+))(?: bui|\\))/i],[[h,/_/g," "],[m,V],[p,y]],[/; (\\w+) bui.+ oppo/i,/\\b(cph[12]\\d{3}|p(?:af|c[al]|d\\w|e[ar])[mt]\\d0|x9007|a101op)\\b/i],[h,[m,"OPPO"],[p,_]],[/vivo (\\w+)(?: bui|\\))/i,/\\b(v[12]\\d{3}\\w?[at])(?: bui|;)/i],[h,[m,"Vivo"],[p,_]],[/\\b(rmx[12]\\d{3})(?: bui|;|\\))/i],[h,[m,"Realme"],[p,_]],[/\\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\\b[\\w ]+build\\//i,/\\bmot(?:orola)?[- ](\\w*)/i,/((?:moto[\\w\\(\\) ]+|xt\\d{3,4}|nexus 6)(?= bui|\\)))/i],[h,[m,N],[p,_]],[/\\b(mz60\\d|xoom[2 ]{0,2}) build\\//i],[h,[m,N],[p,y]],[/((?=lg)?[vl]k\\-?\\d{3}) bui| 3\\.[-\\w; ]{10}lg?-([06cv9]{3,4})/i],[h,[m,O],[p,y]],[/(lm(?:-?f100[nv]?|-[\\w\\.]+)(?= bui|\\))|nexus [45])/i,/\\blg[-e;\\/ ]+((?!browser|netcast|android tv)\\w+)/i,/\\blg-?([\\d\\w]+) bui/i],[h,[m,O],[p,_]],[/(ideatab[-\\w ]+)/i,/lenovo ?(s[56]000[-\\w]+|tab(?:[\\w ]+)|yt[-\\d\\w]{6}|tb[-\\d\\w]{6})/i],[h,[m,"Lenovo"],[p,y]],[/(?:maemo|nokia).*(n900|lumia \\d+)/i,/nokia[-_ ]?([-\\w\\.]*)/i],[[h,/_/g," "],[m,"Nokia"],[p,_]],[/(pixel c)\\b/i],[h,[m,P],[p,y]],[/droid.+; (pixel[\\daxl ]{0,6})(?: bui|\\))/i],[h,[m,P],[p,_]],[/droid.+ (a?\\d[0-2]{2}so|[c-g]\\d{4}|so[-gl]\\w+|xq-a\\w[4-7][12])(?= bui|\\).+chrome\\/(?![1-6]{0,1}\\d\\.))/i],[h,[m,j],[p,_]],[/sony tablet [ps]/i,/\\b(?:sony)?sgp\\w+(?: bui|\\))/i],[[h,"Xperia Tablet"],[m,j],[p,y]],[/ (kb2005|in20[12]5|be20[12][59])\\b/i,/(?:one)?(?:plus)? (a\\d0\\d\\d)(?: b|\\))/i],[h,[m,"OnePlus"],[p,_]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\\))/i,/(kf[a-z]+)( bui|\\)).+silk\\//i],[h,[m,T],[p,y]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\\)).+silk\\//i],[[h,/(.+)/g,"Fire Phone $1"],[m,T],[p,_]],[/(playbook);[-\\w\\),; ]+(rim)/i],[h,m,[p,y]],[/\\b((?:bb[a-f]|st[hv])100-\\d)/i,/\\(bb10; (\\w+)/i],[h,[m,R],[p,_]],[/(?:\\b|asus_)(transfo[prime ]{4,10} \\w+|eeepc|slider \\w+|nexus 7|padfone|p00[cj])/i],[h,[m,x],[p,y]],[/ (z[bes]6[027][012][km][ls]|zenfone \\d\\w?)\\b/i],[h,[m,x],[p,_]],[/(nexus 9)/i],[h,[m,"HTC"],[p,y]],[/(htc)[-;_ ]{1,2}([\\w ]+(?=\\)| bui)|\\w+)/i,/(zte)[- ]([\\w ]+?)(?: bui|\\/|\\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\\.))|sony(?!-bra))[-_ ]?([-\\w]*)/i],[m,[h,/_/g," "],[p,_]],[/droid.+; ([ab][1-7]-?[0178a]\\d\\d?)/i],[h,[m,"Acer"],[p,y]],[/droid.+; (m[1-5] note) bui/i,/\\bmz-([-\\w]{2,})/i],[h,[m,"Meizu"],[p,_]],[/(blackberry|benq|palm(?=\\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\\w]*)/i,/(hp) ([\\w ]+\\w)/i,/(asus)-?(\\w+)/i,/(microsoft); (lumia[\\w ]+)/i,/(lenovo)[-_ ]?([-\\w]+)/i,/(jolla)/i,/(oppo) ?([\\w ]+) bui/i],[m,h,[p,_]],[/(kobo)\\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\\/([\\w\\.]+)/i,/(nook)[\\w ]+build\\/(\\w+)/i,/(dell) (strea[kpr\\d ]*[\\dko])/i,/(le[- ]+pan)[- ]+(\\w{1,9}) bui/i,/(trinity)[- ]*(t\\d{3}) bui/i,/(gigaset)[- ]+(q\\w{1,9}) bui/i,/(vodafone) ([\\w ]+)(?:\\)| bui)/i],[m,h,[p,y]],[/(surface duo)/i],[h,[m,k],[p,y]],[/droid [\\d\\.]+; (fp\\du?)(?: b|\\))/i],[h,[m,"Fairphone"],[p,_]],[/(u304aa)/i],[h,[m,"AT&T"],[p,_]],[/\\bsie-(\\w*)/i],[h,[m,"Siemens"],[p,_]],[/\\b(rct\\w+) b/i],[h,[m,"RCA"],[p,y]],[/\\b(venue[\\d ]{2,7}) b/i],[h,[m,"Dell"],[p,y]],[/\\b(q(?:mv|ta)\\w+) b/i],[h,[m,"Verizon"],[p,y]],[/\\b(?:barnes[& ]+noble |bn[rt])([\\w\\+ ]*) b/i],[h,[m,"Barnes & Noble"],[p,y]],[/\\b(tm\\d{3}\\w+) b/i],[h,[m,"NuVision"],[p,y]],[/\\b(k88) b/i],[h,[m,"ZTE"],[p,y]],[/\\b(nx\\d{3}j) b/i],[h,[m,"ZTE"],[p,_]],[/\\b(gen\\d{3}) b.+49h/i],[h,[m,"Swiss"],[p,_]],[/\\b(zur\\d{3}) b/i],[h,[m,"Swiss"],[p,y]],[/\\b((zeki)?tb.*\\b) b/i],[h,[m,"Zeki"],[p,y]],[/\\b([yr]\\d{2}) b/i,/\\b(dragon[- ]+touch |dt)(\\w{5}) b/i],[[m,"Dragon Touch"],h,[p,y]],[/\\b(ns-?\\w{0,9}) b/i],[h,[m,"Insignia"],[p,y]],[/\\b((nxa|next)-?\\w{0,9}) b/i],[h,[m,"NextBook"],[p,y]],[/\\b(xtreme\\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[m,"Voice"],h,[p,_]],[/\\b(lvtel\\-)?(v1[12]) b/i],[[m,"LvTel"],h,[p,_]],[/\\b(ph-1) /i],[h,[m,"Essential"],[p,_]],[/\\b(v(100md|700na|7011|917g).*\\b) b/i],[h,[m,"Envizen"],[p,y]],[/\\b(trio[-\\w\\. ]+) b/i],[h,[m,"MachSpeed"],[p,y]],[/\\btu_(1491) b/i],[h,[m,"Rotor"],[p,y]],[/(shield[\\w ]+) b/i],[h,[m,"Nvidia"],[p,y]],[/(sprint) (\\w+)/i],[m,h,[p,_]],[/(kin\\.[onetw]{3})/i],[[h,/\\./g," "],[m,k],[p,_]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\\)/i],[h,[m,U],[p,y]],[/droid.+; (ec30|ps20|tc[2-8]\\d[kx])\\)/i],[h,[m,U],[p,_]],[/smart-tv.+(samsung)/i],[m,[p,E]],[/hbbtv.+maple;(\\d+)/i],[[h,/^/,"SmartTV"],[m,L],[p,E]],[/(nux; netcast.+smarttv|lg (netcast\\.tv-201\\d|android tv))/i],[[m,O],[p,E]],[/(apple) ?tv/i],[m,[h,C+" TV"],[p,E]],[/crkey/i],[[h,w+"cast"],[m,P],[p,E]],[/droid.+aft(\\w)( bui|\\))/i],[h,[m,T],[p,E]],[/\\(dtv[\\);].+(aquos)/i,/(aquos-tv[\\w ]+)\\)/i],[h,[m,F],[p,E]],[/(bravia[\\w ]+)( bui|\\))/i],[h,[m,j],[p,E]],[/(mitv-\\w{5}) bui/i],[h,[m,V],[p,E]],[/Hbbtv.*(technisat) (.*);/i],[m,h,[p,E]],[/\\b(roku)[\\dx]*[\\)\\/]((?:dvp-)?[\\d\\.]*)/i,/hbbtv\\/\\d+\\.\\d+\\.\\d+ +\\([\\w\\+ ]*; *([\\w\\d][^;]*);([^;]*)/i],[[m,z],[h,z],[p,E]],[/\\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\\b/i],[[p,E]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[m,h,[p,v]],[/droid.+; (shield) bui/i],[h,[m,"Nvidia"],[p,v]],[/(playstation [345portablevi]+)/i],[h,[m,j],[p,v]],[/\\b(xbox(?: one)?(?!; xbox))[\\); ]/i],[h,[m,k],[p,v]],[/((pebble))app/i],[m,h,[p,S]],[/(watch)(?: ?os[,\\/]|\\d,\\d\\/)[\\d\\.]+/i],[h,[m,C],[p,S]],[/droid.+; (glass) \\d/i],[h,[m,P],[p,S]],[/droid.+; (wt63?0{2,3})\\)/i],[h,[m,U],[p,S]],[/(quest( 2| pro)?)/i],[h,[m,H],[p,S]],[/(tesla)(?: qtcarbrowser|\\/[-\\w\\.]+)/i],[m,[p,b]],[/(aeobc)\\b/i],[h,[m,T],[p,b]],[/droid .+?; ([^;]+?)(?: bui|\\) applew).+? mobile safari/i],[h,[p,_]],[/droid .+?; ([^;]+?)(?: bui|\\) applew).+?(?! mobile) safari/i],[h,[p,y]],[/\\b((tablet|tab)[;\\/]|focus\\/\\d(?!.+mobile))/i],[[p,y]],[/(phone|mobile(?:[;\\/]| [ \\w\\/\\.]*safari)|pda(?=.+windows ce))/i],[[p,_]],[/(android[-\\w\\. ]{0,9});.+buil/i],[h,[m,"Generic"]]],engine:[[/windows.+ edge\\/([\\w\\.]+)/i],[g,[u,"EdgeHTML"]],[/webkit\\/537\\.36.+chrome\\/(?!27)([\\w\\.]+)/i],[g,[u,"Blink"]],[/(presto)\\/([\\w\\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\\/([\\w\\.]+)/i,/ekioh(flow)\\/([\\w\\.]+)/i,/(khtml|tasman|links)[\\/ ]\\(?([\\w\\.]+)/i,/(icab)[\\/ ]([23]\\.[\\d\\.]+)/i,/\\b(libweb)/i],[u,g],[/rv\\:([\\w\\.]{1,9})\\b.+(gecko)/i],[g,u]],os:[[/microsoft (windows) (vista|xp)/i],[u,g],[/(windows) nt 6\\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\\/ ]?([\\d\\.\\w ]*)/i,/(windows)[\\/ ]?([ntce\\d\\. ]+\\w)(?!.+xbox)/i],[u,[g,W,X]],[/(win(?=3|9|n)|win 9x )([nt\\d\\.]+)/i],[[u,"Windows"],[g,W,X]],[/ip[honead]{2,4}\\b(?:.*os ([\\w]+) like mac|; opera)/i,/ios;fbsv\\/([\\d\\.]+)/i,/cfnetwork\\/.+darwin/i],[[g,/_/g,"."],[u,"iOS"]],[/(mac os x) ?([\\w\\. ]*)/i,/(macintosh|mac_powerpc\\b)(?!.+haiku)/i],[[u,J],[g,/_/g,"."]],[/droid ([\\w\\.]+)\\b.+(android[- ]x86|harmonyos)/i],[g,u],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\\/ ]?([\\w\\.]*)/i,/(blackberry)\\w*\\/([\\w\\.]*)/i,/(tizen|kaios)[\\/ ]([\\w\\.]+)/i,/\\((series40);/i],[u,g],[/\\(bb(10);/i],[g,[u,R]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\\/ ]?([\\w\\.]*)/i],[g,[u,"Symbian"]],[/mozilla\\/[\\d\\.]+ \\((?:mobile|tablet|tv|mobile; [\\w ]+); rv:.+ gecko\\/([\\w\\.]+)/i],[g,[u,I+" OS"]],[/web0s;.+rt(tv)/i,/\\b(?:hp)?wos(?:browser)?\\/([\\w\\.]+)/i],[g,[u,"webOS"]],[/watch(?: ?os[,\\/]|\\d,\\d\\/)([\\d\\.]+)/i],[g,[u,"watchOS"]],[/crkey\\/([\\d\\.]+)/i],[g,[u,w+"cast"]],[/(cros) [\\w]+(?:\\)| ([\\w\\.]+)\\b)/i],[[u,$],g],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\\/(\\d+\\.[\\w\\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\\);]+)/i,/\\b(joli|palm)\\b ?(?:os)?\\/?([\\w\\.]*)/i,/(mint)[\\/\\(\\) ]?(\\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\\/ ]?(?!chrom|package)([-\\w\\.]*)/i,/(hurd|linux) ?([\\w\\.]*)/i,/(gnu) ?([\\w\\.]*)/i,/\\b([-frentopcghs]{0,5}bsd|dragonfly)[\\/ ]?(?!amd|[ix346]{1,2}86)([\\w\\.]*)/i,/(haiku) (\\w+)/i],[u,g],[/(sunos) ?([\\w\\.\\d]*)/i],[[u,"Solaris"],g],[/((?:open)?solaris)[-\\/ ]?([\\w\\.]*)/i,/(aix) ((\\d)(?=\\.|\\)| )[\\w\\.])*/i,/\\b(beos|os\\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\\w\\.]*)/i],[u,g]]},Q=function(e,t){if(typeof e===d&&(t=e,e=o),!(this instanceof Q))return new Q(e,t).getResult();var n=typeof r!==a&&r.navigator?r.navigator:o,i=e||(n&&n.userAgent?n.userAgent:""),v=n&&n.userAgentData?n.userAgentData:o,E=t?function(e,t){var n={};for(var i in e)t[i]&&t[i].length%2==0?n[i]=t[i].concat(e[i]):n[i]=e[i];return n}(Y,t):Y,S=n&&n.userAgent==i;return this.getBrowser=function(){var e,t={};return t[u]=o,t[g]=o,K.call(t,i,E.browser),t[l]=typeof(e=t[g])===c?e.replace(/[^\\d\\.]/g,"").split(".")[0]:o,S&&n&&n.brave&&typeof n.brave.isBrave==s&&(t[u]="Brave"),t},this.getCPU=function(){var e={};return e[f]=o,K.call(e,i,E.cpu),e},this.getDevice=function(){var e={};return e[m]=o,e[h]=o,e[p]=o,K.call(e,i,E.device),S&&!e[p]&&v&&v.mobile&&(e[p]=_),S&&"Macintosh"==e[h]&&n&&typeof n.standalone!==a&&n.maxTouchPoints&&n.maxTouchPoints>2&&(e[h]="iPad",e[p]=y),e},this.getEngine=function(){var e={};return e[u]=o,e[g]=o,K.call(e,i,E.engine),e},this.getOS=function(){var e={};return e[u]=o,e[g]=o,K.call(e,i,E.os),S&&!e[u]&&v&&"Unknown"!=v.platform&&(e[u]=v.platform.replace(/chrome os/i,$).replace(/macos/i,J)),e},this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}},this.getUA=function(){return i},this.setUA=function(e){return i=typeof e===c&&e.length>350?z(e,350):e,this},this.setUA(i),this};Q.VERSION="1.0.35",Q.BROWSER=B([u,g,l]),Q.CPU=B([f]),Q.DEVICE=B([h,m,p,v,_,E,y,S,b]),Q.ENGINE=Q.OS=B([u,g]),typeof t!==a?(e.exports&&(t=e.exports=Q),t.UAParser=Q):n.amdO?(i=function(){return Q}.call(t,n,t,e))===o||(e.exports=i):typeof r!==a&&(r.UAParser=Q);var Z=typeof r!==a&&(r.jQuery||r.Zepto);if(Z&&!Z.ua){var ee=new Q;Z.ua=ee.getResult(),Z.ua.get=function(){return ee.getUA()},Z.ua.set=function(e){ee.setUA(e);var t=ee.getResult();for(var n in t)Z.ua[n]=t[n]}}}("object"==typeof window?window:this)},505:(e,t,n)=>{var i=n(350);function r(e,t){this.logStorage=e,this.stringifyObjects=!(!t||!t.stringifyObjects)&&t.stringifyObjects,this.storeInterval=t&&t.storeInterval?t.storeInterval:3e4,this.maxEntryLength=t&&t.maxEntryLength?t.maxEntryLength:1e4,Object.values(i.levels).forEach(function(e){this[e]=function(){this._log.apply(this,arguments)}.bind(this,e)}.bind(this)),this.storeLogsIntervalID=null,this.queue=[],this.totalLen=0,this.outputCache=[]}r.prototype.stringify=function(e){try{return JSON.stringify(e)}catch(e){return"[object with circular refs?]"}},r.prototype.formatLogMessage=function(e){for(var t="",n=1,i=arguments.length;n<i;n++){var r=arguments[n];r instanceof Error?t+=r.toString()+": "+r.stack:this.stringifyObjects&&"object"==typeof r?t+=this.stringify(r):t+=r,n!==i-1&&(t+=" ")}return t.length?t:null},r.prototype._log=function(){var e=arguments[1],t=this.formatLogMessage.apply(this,arguments);if(t){var n=this.queue[this.queue.length-1];(n&&n.text)===t?n.count+=1:(this.queue.push({text:t,timestamp:e,count:1}),this.totalLen+=t.length)}this.totalLen>=this.maxEntryLength&&this._flush(!0,!0)},r.prototype.start=function(){this._reschedulePublishInterval()},r.prototype._reschedulePublishInterval=function(){this.storeLogsIntervalID&&(window.clearTimeout(this.storeLogsIntervalID),this.storeLogsIntervalID=null),this.storeLogsIntervalID=window.setTimeout(this._flush.bind(this,!1,!0),this.storeInterval)},r.prototype.flush=function(){this._flush(!1,!0)},r.prototype._storeLogs=function(e){try{this.logStorage.storeLogs(e)}catch(e){console.error("LogCollector error when calling logStorage.storeLogs(): ",e)}},r.prototype._flush=function(e,t){var n=!1;try{n=this.logStorage.isReady()}catch(e){console.error("LogCollector error when calling logStorage.isReady(): ",e)}this.totalLen>0&&(n||e)&&(n?(this.outputCache.length&&(this.outputCache.forEach(function(e){this._storeLogs(e)}.bind(this)),this.outputCache=[]),this._storeLogs(this.queue)):this.outputCache.push(this.queue),this.queue=[],this.totalLen=0),t&&this._reschedulePublishInterval()},r.prototype.stop=function(){this._flush(!1,!1)},e.exports=r},350:e=>{var t={trace:0,debug:1,info:2,log:3,warn:4,error:5};o.consoleTransport=console;var n=[o.consoleTransport];o.addGlobalTransport=function(e){-1===n.indexOf(e)&&n.push(e)},o.removeGlobalTransport=function(e){var t=n.indexOf(e);-1!==t&&n.splice(t,1)};var i={};function r(){var e=arguments[0],r=arguments[1],o=Array.prototype.slice.call(arguments,2);if(!(t[r]<e.level))for(var s=!(e.options.disableCallerInfo||i.disableCallerInfo)&&function(){var e={methodName:"",fileLocation:"",line:null,column:null},t=new Error,n=t.stack?t.stack.split("\\n"):[];if(!n||n.length<3)return e;var i=null;return n[3]&&(i=n[3].match(/\\s*at\\s*(.+?)\\s*\\((\\S*)\\s*:(\\d*)\\s*:(\\d*)\\)/)),!i||i.length<=4?(0===n[2].indexOf("log@")?e.methodName=n[3].substr(0,n[3].indexOf("@")):e.methodName=n[2].substr(0,n[2].indexOf("@")),e):(e.methodName=i[1],e.fileLocation=i[2],e.line=i[3],e.column=i[4],e)}(),a=n.concat(e.transports),d=0;d<a.length;d++){var c=a[d],l=c[r];if(l&&"function"==typeof l){var h=[];h.push((new Date).toISOString()),e.id&&h.push("["+e.id+"]"),s&&s.methodName.length>1&&h.push("<"+s.methodName+">: ");var u=h.concat(o);try{l.bind(c).apply(c,u)}catch(e){console.error("An error occured when trying to log with one of the available transports",e)}}}}function o(e,n,i,o){this.id=n,this.options=o||{},this.transports=i,this.transports||(this.transports=[]),this.level=t[e];for(var s=Object.keys(t),a=0;a<s.length;a++)this[s[a]]=r.bind(null,this,s[a])}o.setGlobalOptions=function(e){i=e||{}},o.prototype.setLevel=function(e){this.level=t[e]},e.exports=o,o.levels={TRACE:"trace",DEBUG:"debug",INFO:"info",LOG:"log",WARN:"warn",ERROR:"error"}},810:(e,t,n)=>{var i=n(350),r=n(505),o={},s=[],a=i.levels.TRACE;e.exports={addGlobalTransport:function(e){i.addGlobalTransport(e)},removeGlobalTransport:function(e){i.removeGlobalTransport(e)},setGlobalOptions:function(e){i.setGlobalOptions(e)},getLogger:function(e,t,n){var r=new i(a,e,t,n);return e?(o[e]=o[e]||[],o[e].push(r)):s.push(r),r},getUntrackedLogger:function(e,t,n){return new i(a,e,t,n)},setLogLevelById:function(e,t){for(var n=t?o[t]||[]:s,i=0;i<n.length;i++)n[i].setLevel(e)},setLogLevel:function(e){a=e;for(var t=0;t<s.length;t++)s[t].setLevel(e);for(var n in o){var i=o[n]||[];for(t=0;t<i.length;t++)i[t].setLevel(e)}},levels:i.levels,LogCollector:r}},22:e=>{var t=e.exports={v:[{name:"version",reg:/^(\\d*)$/}],o:[{name:"origin",reg:/^(\\S*) (\\d*) (\\d*) (\\S*) IP(\\d) (\\S*)/,names:["username","sessionId","sessionVersion","netType","ipVer","address"],format:"%s %s %d %s IP%d %s"}],s:[{name:"name"}],i:[{name:"description"}],u:[{name:"uri"}],e:[{name:"email"}],p:[{name:"phone"}],z:[{name:"timezones"}],r:[{name:"repeats"}],t:[{name:"timing",reg:/^(\\d*) (\\d*)/,names:["start","stop"],format:"%d %d"}],c:[{name:"connection",reg:/^IN IP(\\d) (\\S*)/,names:["version","ip"],format:"IN IP%d %s"}],b:[{push:"bandwidth",reg:/^(TIAS|AS|CT|RR|RS):(\\d*)/,names:["type","limit"],format:"%s:%s"}],m:[{reg:/^(\\w*) (\\d*) ([\\w/]*)(?: (.*))?/,names:["type","port","protocol","payloads"],format:"%s %d %s %s"}],a:[{push:"rtp",reg:/^rtpmap:(\\d*) ([\\w\\-.]*)(?:\\s*\\/(\\d*)(?:\\s*\\/(\\S*))?)?/,names:["payload","codec","rate","encoding"],format:function(e){return e.encoding?"rtpmap:%d %s/%s/%s":e.rate?"rtpmap:%d %s/%s":"rtpmap:%d %s"}},{push:"fmtp",reg:/^fmtp:(\\d*) ([\\S| ]*)/,names:["payload","config"],format:"fmtp:%d %s"},{name:"control",reg:/^control:(.*)/,format:"control:%s"},{name:"rtcp",reg:/^rtcp:(\\d*)(?: (\\S*) IP(\\d) (\\S*))?/,names:["port","netType","ipVer","address"],format:function(e){return null!=e.address?"rtcp:%d %s IP%d %s":"rtcp:%d"}},{push:"rtcpFbTrrInt",reg:/^rtcp-fb:(\\*|\\d*) trr-int (\\d*)/,names:["payload","value"],format:"rtcp-fb:%s trr-int %d"},{push:"rtcpFb",reg:/^rtcp-fb:(\\*|\\d*) ([\\w-_]*)(?: ([\\w-_]*))?/,names:["payload","type","subtype"],format:function(e){return null!=e.subtype?"rtcp-fb:%s %s %s":"rtcp-fb:%s %s"}},{push:"ext",reg:/^extmap:(\\d+)(?:\\/(\\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\\S*)(?: (\\S*))?/,names:["value","direction","encrypt-uri","uri","config"],format:function(e){return"extmap:%d"+(e.direction?"/%s":"%v")+(e["encrypt-uri"]?" %s":"%v")+" %s"+(e.config?" %s":"")}},{name:"extmapAllowMixed",reg:/^(extmap-allow-mixed)/},{push:"crypto",reg:/^crypto:(\\d*) ([\\w_]*) (\\S*)(?: (\\S*))?/,names:["id","suite","config","sessionConfig"],format:function(e){return null!=e.sessionConfig?"crypto:%d %s %s %s":"crypto:%d %s %s"}},{name:"setup",reg:/^setup:(\\w*)/,format:"setup:%s"},{name:"connectionType",reg:/^connection:(new|existing)/,format:"connection:%s"},{name:"mid",reg:/^mid:([^\\s]*)/,format:"mid:%s"},{name:"msid",reg:/^msid:(.*)/,format:"msid:%s"},{name:"ptime",reg:/^ptime:(\\d*(?:\\.\\d*)*)/,format:"ptime:%d"},{name:"maxptime",reg:/^maxptime:(\\d*(?:\\.\\d*)*)/,format:"maxptime:%d"},{name:"direction",reg:/^(sendrecv|recvonly|sendonly|inactive)/},{name:"icelite",reg:/^(ice-lite)/},{name:"iceUfrag",reg:/^ice-ufrag:(\\S*)/,format:"ice-ufrag:%s"},{name:"icePwd",reg:/^ice-pwd:(\\S*)/,format:"ice-pwd:%s"},{name:"fingerprint",reg:/^fingerprint:(\\S*) (\\S*)/,names:["type","hash"],format:"fingerprint:%s %s"},{push:"candidates",reg:/^candidate:(\\S*) (\\d*) (\\S*) (\\d*) (\\S*) (\\d*) typ (\\S*)(?: raddr (\\S*) rport (\\d*))?(?: tcptype (\\S*))?(?: generation (\\d*))?(?: network-id (\\d*))?(?: network-cost (\\d*))?/,names:["foundation","component","transport","priority","ip","port","type","raddr","rport","tcptype","generation","network-id","network-cost"],format:function(e){var t="candidate:%s %d %s %d %s %d typ %s";return t+=null!=e.raddr?" raddr %s rport %d":"%v%v",t+=null!=e.tcptype?" tcptype %s":"%v",null!=e.generation&&(t+=" generation %d"),(t+=null!=e["network-id"]?" network-id %d":"%v")+(null!=e["network-cost"]?" network-cost %d":"%v")}},{name:"endOfCandidates",reg:/^(end-of-candidates)/},{name:"remoteCandidates",reg:/^remote-candidates:(.*)/,format:"remote-candidates:%s"},{name:"iceOptions",reg:/^ice-options:(\\S*)/,format:"ice-options:%s"},{push:"ssrcs",reg:/^ssrc:(\\d*) ([\\w_-]*)(?::(.*))?/,names:["id","attribute","value"],format:function(e){var t="ssrc:%d";return null!=e.attribute&&(t+=" %s",null!=e.value&&(t+=":%s")),t}},{push:"ssrcGroups",reg:/^ssrc-group:([\\x21\\x23\\x24\\x25\\x26\\x27\\x2A\\x2B\\x2D\\x2E\\w]*) (.*)/,names:["semantics","ssrcs"],format:"ssrc-group:%s %s"},{name:"msidSemantic",reg:/^msid-semantic:\\s?(\\w*) (\\S*)/,names:["semantic","token"],format:"msid-semantic: %s %s"},{push:"groups",reg:/^group:(\\w*) (.*)/,names:["type","mids"],format:"group:%s %s"},{name:"rtcpMux",reg:/^(rtcp-mux)/},{name:"rtcpRsize",reg:/^(rtcp-rsize)/},{name:"sctpmap",reg:/^sctpmap:([\\w_/]*) (\\S*)(?: (\\S*))?/,names:["sctpmapNumber","app","maxMessageSize"],format:function(e){return null!=e.maxMessageSize?"sctpmap:%s %s %s":"sctpmap:%s %s"}},{name:"xGoogleFlag",reg:/^x-google-flag:([^\\s]*)/,format:"x-google-flag:%s"},{push:"rids",reg:/^rid:([\\d\\w]+) (\\w+)(?: ([\\S| ]*))?/,names:["id","direction","params"],format:function(e){return e.params?"rid:%s %s %s":"rid:%s %s"}},{push:"imageattrs",reg:new RegExp("^imageattr:(\\\\d+|\\\\*)[\\\\s\\\\t]+(send|recv)[\\\\s\\\\t]+(\\\\*|\\\\[\\\\S+\\\\](?:[\\\\s\\\\t]+\\\\[\\\\S+\\\\])*)(?:[\\\\s\\\\t]+(recv|send)[\\\\s\\\\t]+(\\\\*|\\\\[\\\\S+\\\\](?:[\\\\s\\\\t]+\\\\[\\\\S+\\\\])*))?"),names:["pt","dir1","attrs1","dir2","attrs2"],format:function(e){return"imageattr:%s %s %s"+(e.dir2?" %s %s":"")}},{name:"simulcast",reg:new RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\\\-_~;,]+)(?:\\\\s?(send|recv) ([a-zA-Z0-9\\\\-_~;,]+))?$"),names:["dir1","list1","dir2","list2"],format:function(e){return"simulcast:%s %s"+(e.dir2?" %s %s":"")}},{name:"simulcast_03",reg:/^simulcast:[\\s\\t]+([\\S+\\s\\t]+)$/,names:["value"],format:"simulcast: %s"},{name:"framerate",reg:/^framerate:(\\d+(?:$|\\.\\d+))/,format:"framerate:%s"},{name:"sourceFilter",reg:/^source-filter: *(excl|incl) (\\S*) (IP4|IP6|\\*) (\\S*) (.*)/,names:["filterMode","netType","addressTypes","destAddress","srcList"],format:"source-filter: %s %s %s %s %s"},{name:"bundleOnly",reg:/^(bundle-only)/},{name:"label",reg:/^label:(.+)/,format:"label:%s"},{name:"sctpPort",reg:/^sctp-port:(\\d+)$/,format:"sctp-port:%s"},{name:"maxMessageSize",reg:/^max-message-size:(\\d+)$/,format:"max-message-size:%s"},{push:"tsRefClocks",reg:/^ts-refclk:([^\\s=]*)(?:=(\\S*))?/,names:["clksrc","clksrcExt"],format:function(e){return"ts-refclk:%s"+(null!=e.clksrcExt?"=%s":"")}},{name:"mediaClk",reg:/^mediaclk:(?:id=(\\S*))? *([^\\s=]*)(?:=(\\S*))?(?: *rate=(\\d+)\\/(\\d+))?/,names:["id","mediaClockName","mediaClockValue","rateNumerator","rateDenominator"],format:function(e){var t="mediaclk:";return t+=null!=e.id?"id=%s %s":"%v%s",t+=null!=e.mediaClockValue?"=%s":"",(t+=null!=e.rateNumerator?" rate=%s":"")+(null!=e.rateDenominator?"/%s":"")}},{name:"keywords",reg:/^keywds:(.+)$/,format:"keywds:%s"},{name:"content",reg:/^content:(.+)/,format:"content:%s"},{name:"bfcpFloorCtrl",reg:/^floorctrl:(c-only|s-only|c-s)/,format:"floorctrl:%s"},{name:"bfcpConfId",reg:/^confid:(\\d+)/,format:"confid:%s"},{name:"bfcpUserId",reg:/^userid:(\\d+)/,format:"userid:%s"},{name:"bfcpFloorId",reg:/^floorid:(.+) (?:m-stream|mstrm):(.+)/,names:["id","mStream"],format:"floorid:%s mstrm:%s"},{push:"invalid",names:["value"]}]};Object.keys(t).forEach((function(e){t[e].forEach((function(e){e.reg||(e.reg=/(.*)/),e.format||(e.format="%s")}))}))},561:(e,t,n)=>{var i=n(92),r=n(508);t.write=r,t.parse=i.parse,t.parseParams=i.parseParams,t.parseFmtpConfig=i.parseFmtpConfig,t.parsePayloads=i.parsePayloads,t.parseRemoteCandidates=i.parseRemoteCandidates,t.parseImageAttributes=i.parseImageAttributes,t.parseSimulcastStreamList=i.parseSimulcastStreamList},92:(e,t,n)=>{var i=function(e){return String(Number(e))===e?Number(e):e},r=function(e,t,n){var r=e.name&&e.names;e.push&&!t[e.push]?t[e.push]=[]:r&&!t[e.name]&&(t[e.name]={});var o=e.push?{}:r?t[e.name]:t;!function(e,t,n,r){if(r&&!n)t[r]=i(e[1]);else for(var o=0;o<n.length;o+=1)null!=e[o+1]&&(t[n[o]]=i(e[o+1]))}(n.match(e.reg),o,e.names,e.name),e.push&&t[e.push].push(o)},o=n(22),s=RegExp.prototype.test.bind(/^([a-z])=(.*)/);t.parse=function(e){var t={},n=[],i=t;return e.split(/(\\r\\n|\\r|\\n)/).filter(s).forEach((function(e){var t=e[0],s=e.slice(2);"m"===t&&(n.push({rtp:[],fmtp:[]}),i=n[n.length-1]);for(var a=0;a<(o[t]||[]).length;a+=1){var d=o[t][a];if(d.reg.test(s))return r(d,i,s)}})),t.media=n,t};var a=function(e,t){var n=t.split(/=(.+)/,2);return 2===n.length?e[n[0]]=i(n[1]):1===n.length&&t.length>1&&(e[n[0]]=void 0),e};t.parseParams=function(e){return e.split(/;\\s?/).reduce(a,{})},t.parseFmtpConfig=t.parseParams,t.parsePayloads=function(e){return e.toString().split(" ").map(Number)},t.parseRemoteCandidates=function(e){for(var t=[],n=e.split(" ").map(i),r=0;r<n.length;r+=3)t.push({component:n[r],ip:n[r+1],port:n[r+2]});return t},t.parseImageAttributes=function(e){return e.split(" ").map((function(e){return e.substring(1,e.length-1).split(",").reduce(a,{})}))},t.parseSimulcastStreamList=function(e){return e.split(";").map((function(e){return e.split(",").map((function(e){var t,n=!1;return"~"!==e[0]?t=i(e):(t=i(e.substring(1,e.length)),n=!0),{scid:t,paused:n}}))}))}},508:(e,t,n)=>{var i=n(22),r=/%[sdv%]/g,o=function(e){var t=1,n=arguments,i=n.length;return e.replace(r,(function(e){if(t>=i)return e;var r=n[t];switch(t+=1,e){case"%%":return"%";case"%s":return String(r);case"%d":return Number(r);case"%v":return""}}))},s=function(e,t,n){var i=[e+"="+(t.format instanceof Function?t.format(t.push?n:n[t.name]):t.format)];if(t.names)for(var r=0;r<t.names.length;r+=1){var s=t.names[r];t.name?i.push(n[t.name][s]):i.push(n[t.names[r]])}else i.push(n[t.name]);return o.apply(null,i)},a=["v","o","s","i","u","e","p","c","b","t","r","z","a"],d=["i","c","b","a"];e.exports=function(e,t){t=t||{},null==e.version&&(e.version=0),null==e.name&&(e.name=" "),e.media.forEach((function(e){null==e.payloads&&(e.payloads="")}));var n=t.outerOrder||a,r=t.innerOrder||d,o=[];return n.forEach((function(t){i[t].forEach((function(n){n.name in e&&null!=e[n.name]?o.push(s(t,n,e)):n.push in e&&null!=e[n.push]&&e[n.push].forEach((function(e){o.push(s(t,n,e))}))}))})),e.media.forEach((function(e){o.push(s("m",i.m[0],e)),r.forEach((function(t){i[t].forEach((function(n){n.name in e&&null!=e[n.name]?o.push(s(t,n,e)):n.push in e&&null!=e[n.push]&&e[n.push].forEach((function(e){o.push(s(t,n,e))}))}))}))})),o.join("\\r\\n")+"\\r\\n"}},803:function(e){e.exports=(()=>{var e={607:(e,t,n)=>{"use strict";t.ap=t.Tk=t.Vk=t.b1=t.zP=t.$j=t.dL=t.aM=t.vP=t.xt=t.Zt=t.UN=t.IO=t.zl=t.v6=t.S1=void 0,n(699);var i=n(231);t.S1=function(e,t){(0,i.initSDK)(e||{},[""],t)},t.v6=function(e){(0,i.setConfig)(e)},t.zl=function(e){},t.IO=function(e,t){(0,i.setUserRating)(e,t)},t.UN=function(e){(0,i.addKeys)(e)},t.Zt=function(){(0,i.disableDataCollection)()},t.xt=function(){(0,i.enableDataCollection)()},t.vP=function(e){(0,i.addEvent)(e)},t.aM=function(e,t){(0,i.mapStream)(e,t)},t.dL=function(e,t){(0,i.mapTrack)(e,t)},t.$j=function(){(0,i.connect)()},t.zP=function(){(0,i.disconnect)()},t.b1=function(e){(0,i.registerOnStatsListener)(e)},t.Vk=function(e){(0,i.persistentEnd)(e)},t.Tk=function(e,t){(0,i.persistentStart)(e,t)},t.ap=function(e){(0,i.registerStateListener)(e)},t.default={init:t.S1,addTags:t.zl,setUserRating:t.IO,addKeys:t.UN,setConfig:t.v6,disableDataCollection:t.Zt,enableDataCollection:t.xt,addEvent:t.vP,mapStream:t.aM,mapTrack:t.dL,connect:t.$j,disconnect:t.zP,addStatsListener:t.b1,persistentEnd:t.Vk,persistentStart:t.Tk,addStateListener:t.ap,qualityrtc:{run:i.qrtcRun,stop:i.qrtcStop}}},231:function(e,t,n){"use strict";var i=this&&this.__assign||function(){return i=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},i.apply(this,arguments)},r=this&&this.__awaiter||function(e,t,n,i){return new(n||(n=Promise))((function(r,o){function s(e){try{d(i.next(e))}catch(e){o(e)}}function a(e){try{d(i.throw(e))}catch(e){o(e)}}function d(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}d((i=i.apply(e,t||[])).next())}))},o=this&&this.__generator||function(e,t){var n,i,r,o,s={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(a){return function(d){return function(a){if(n)throw new TypeError("Generator is already executing.");for(;o&&(o=0,a[0]&&(s=0)),s;)try{if(n=1,i&&(r=2&a[0]?i.return:a[0]?i.throw||((r=i.return)&&r.call(i),0):i.next)&&!(r=r.call(i,a[1])).done)return r;switch(i=0,r&&(a=[2&a[0],r.value]),a[0]){case 0:case 1:r=a;break;case 4:return s.label++,{value:a[1],done:!1};case 5:s.label++,i=a[1],a=[0];continue;case 7:a=s.ops.pop(),s.trys.pop();continue;default:if(!((r=(r=s.trys).length>0&&r[r.length-1])||6!==a[0]&&2!==a[0])){s=0;continue}if(3===a[0]&&(!r||a[1]>r[0]&&a[1]<r[3])){s.label=a[1];break}if(6===a[0]&&s.label<r[1]){s.label=r[1],r=a;break}if(r&&s.label<r[2]){s.label=r[2],s.ops.push(a);break}r[2]&&s.ops.pop(),s.trys.pop();continue}a=t.call(e,s)}catch(e){a=[6,e],i=0}finally{n=r=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,d])}}},s=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var i,r=0,o=t.length;r<o;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.qrtcStop=t.qrtcRun=t.persistentStart=t.persistentEnd=t.registerStateListener=t.registerOnStatsListener=t.disconnect=t.connect=t.mapTrack=t.mapStream=t.addEvent=t.enableDataCollection=t.disableDataCollection=t.addKeys=t.setUserRating=t.setConfig=t.initSDK=t.sdkLogWithoutTrace=t.sdkLog=void 0;var a,d,c,l,h,u=n(85),p=n(911),m=n(593),g=n(412),f="undefined"!=typeof window,v=f?window:n.g,_=!!f&&!!v.mozRTCPeerConnection,y=(!!f&&!_&&v.RTCPeerConnection&&v.navigator.webkitGetUserMedia,{}),E=0,S={},b={rtcRoomId:void 0,rtcPeerId:void 0,projectId:void 0},T=null,C=null,x=null,R=0,A=!1,w=!1,I=0,P=!1,D=!1,O=null,k=null,N=!0;t.sdkLog=(0,m.getSdkLogger)((function(){return null==T?void 0:T.logLevel})),t.sdkLogWithoutTrace=(0,m.getSdkLogWithoutTrace)((function(){return null==T?void 0:T.logLevel}));var M=function(e){return e?"".concat(e.kind,":").concat(e.id," state:").concat(e.readyState," muted:").concat(e.muted," label:").concat(e.label):"no track"},L={},F=function(e){var n,r=e.forceRecreate,o=void 0!==r&&r,s=e.reconnecting,d=void 0!==s&&s,l=e.pcId,u=void 0===l?"PC_unknown":l,p=e.nailUp,f=void 0!==p&&p;if(null==x?void 0:x.isDisabledDataCollection())(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. disabledDataCollection, ignore [".concat(u,"]"));else{if((0,t.sdkLog)("debug","maybeOpenWebsocketConnection called: [".concat(u,"]"),{forceRecreate:o,reconnecting:d,isManualDisconnect:D,isManualConnect:P,tryingToConnectSocket:A,watchrtcConfig:JSON.stringify(T),disabled:null==x?void 0:x.isDisabledDataCollection(),openChannels:JSON.stringify(y)}),D=!1,(null===(n=null==x?void 0:x.connection)||void 0===n?void 0:n.readyState)===v.WebSocket.OPEN){if(!(0,m.isRoomIdOrPeerIdChanged)(b,T)||!o)return void(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. WS connection already opened [".concat(u,"]"));(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. Closing WS connection. [".concat(u,"]")),null==x||x.close()}var _=(0,m.countOfValidConnections)(y);if(!P&&_<1&&!A)(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. WS connection not opened - previous connect call not finished or missing peer connection [".concat(u,"]"),{openChannels:JSON.stringify(y),connectionCount:_,tryingToConnectSocket:A,isManualConnect:P});else{var E=(0,m.validateConfig)(T),C=Object.keys(y)[_-1];if(!E)return A=!1,void(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. WS connection not opened - invalid config [".concat(u,"]"),{watchrtcConfig:T});T.keys&&Object.keys(T.keys||{}).forEach((function(e){"string"==typeof T.keys[e]&&(T.keys[e]=[T.keys[e]])}));var O=!!T.rtcToken,M=(0,m.getConnectionData)("ws",O?T.rtcToken:T.rtcApiKey,T.proxyUrl);x||(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. WS socket wasn\'t initialized [".concat(u,"]")),A=!0,R=Date.now(),(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. Opening websocket connection [".concat(u,"]")),j(f);var L=Date.now();null==x||x.connect({url:"".concat(M.url,"?").concat(O?"token":"apiKey","=").concat(M.key,"&timestamp=").concat(Date.now()),options:{cleanOldTraces:N},onData:function(e){for(var n,r=0,o=Object.entries(e);r<o.length;r++){var s=o[r],l=s[0],h=s[1];S[l]=h}if(b.projectId=e.projectId,A=!1,T.allowBrowserLogCollection=Boolean(e.collectConsoleLogEnabled),T.allowBrowserLogCollection?!(null===(n=null==T?void 0:T.console)||void 0===n?void 0:n.override)&&e.collectConsoleLogLevel&&(0,m.setConsoleLevel)(e.collectConsoleLogLevel,a):((0,m.restoreOriginalConsoleMethods)(),(null==x?void 0:x.buffer)&&(x.buffer=x.buffer.filter((function(e){return"log"!==e[0]})))),(0,t.sdkLog)("info","Connection established. watchRTCConnectionId: ".concat(e.connectionId," sdkVersion:").concat(g.default," [").concat(u,"]")),e.interval!==T.collectionInterval){var p=T.collectionInterval;T.collectionInterval=e.interval,$(),j(),(0,t.sdkLog)("error","Collection interval mismatch - connection state reset"),a({data:["collectionIntervalChange",null,{oldInterval:p}]})}a({data:["watchrtc",C,i(i(i({},T),e),{sdkVersion:g.default})]}),d&&((0,t.sdkLog)("debug","websocket onData reconnecting"),a({data:["reconnect",null,null]})),c&&a({data:["hardware",null,c]}),a({data:["sessionId",null,v.watchRTCSessionId]})},onError:function(e,n){(0,t.sdkLog)("debug","websocket onError ".concat(n)),"auth"===n&&(w=!0),A=!1,R=0},onOpen:function(){if(N=!1,k&&k({connectionStatus:"connected"}),d){var e=Date.now()-I;a({data:["reconnectDuration",null,e]})}w=!1,h&&(clearInterval(h),h=void 0);var n=Date.now()-L;(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. Connection opened. Opening time - ".concat(n," ms [").concat(u,"]"))},onClose:function(e){k&&k({connectionStatus:"disconnected"});var n=e.code,i=e.reason,r=e.wasClean;(0,t.sdkLog)("debug","close event. authFailed: ".concat(w," code: ").concat(n," reason: ").concat(i," wasClean: ").concat(r," reconnectTimerId: ").concat(h),{authFailed:w,code:n,reason:i,wasClean:r,reconnectTimerId:h}),w?((0,t.sdkLog)("debug","websocket authFailed"),h&&clearInterval(h)):h||D||((0,t.sdkLog)("debug","websocket onClose reconnecting"),I=Date.now(),F({reconnecting:!0,pcId:u}),h=setInterval((function(){F({reconnecting:!0,pcId:u})}),3e4))}})}}},j=function(e){if(void 0===e&&(e=!1),v.clearInterval(d),e){(0,t.sdkLog)("debug","startStatsCollection - nail up");for(var n=function(e){"closed"!==e.pc.signalingState&&e.pc.getStats(null).then((function(t){var n={};_?t.forEach((function(e){n["".concat(e.type,"_").concat(e.id)]=e})):n=(0,m.map2obj)(t),e.nailUpRef=JSON.parse(JSON.stringify(n))}))},s=0,a=Object.values(y);s<a.length;s++)n(a[s])}d=v.setInterval((function(){return r(this,void 0,void 0,(function(){var e,n,r,s,a,c,l;return o(this,(function(o){switch(o.label){case 0:return P||0!==(0,m.countOfValidConnections)(y)?[3,1]:((null==T?void 0:T.logGetStats)&&(0,t.sdkLog)("debug","getStatsInterval. No valid connections at this time"),R&&R+2e4<Date.now()&&(N=!0,v.clearInterval(d),null==x||x.close(),(0,t.sdkLog)("info","Last connection closed. watchRTCConnectionId: ".concat(null==S?void 0:S.connectionId," sdkVersion: ").concat(g.default))),[3,6]);case 1:R=Date.now(),e={connections:{},streams:{}},n=0,r=Object.values(y),o.label=2;case 2:return n<r.length?(s=r[n],(null==T?void 0:T.logGetStats)&&(0,t.sdkLogWithoutTrace)("debug","getStatsInterval. ".concat(s.id," signalingState: ").concat(s.pc.signalingState)),"closed"===s.pc.signalingState?[3,4]:[4,V(s)]):[3,5];case 3:a=o.sent(),c=a.peer,l=a.streams,e.connections=i(i({},e.connections),c),e.streams=i(i({},e.streams),l),o.label=4;case 4:return n++,[3,2];case 5:O&&O(e),o.label=6;case 6:return[2]}}))}))}),T.collectionInterval)},V=function(e){return new Promise((function(n,i){if(e){var r=e.id,o=e.pc,s=e.prev,d=e.nailUpRef;o.getStats(null).then((function(i){(null==T?void 0:T.logGetStats)&&(0,t.sdkLogWithoutTrace)("debug","getStats res",{res:i});var o={};_?i.forEach((function(e){o["".concat(e.type,"_").concat(e.id)]=e})):o=(0,m.map2obj)(i);var c=JSON.parse(JSON.stringify(o));o=(0,m.applyPatchForRTT)(s,o),d&&(o=(0,m.subtractNailUpReferenceStats)(d,o));var l=(0,m.deltaCompression)(s,o);(null==T?void 0:T.logGetStats)&&(0,t.sdkLogWithoutTrace)("debug","getStats(null) [".concat(r,"]"),{data:l}),null!==(null==l?void 0:l.timestamp)&&(null==l?void 0:l.timestamp)!==-1/0&&a({data:["getstats",r,l]}),e.prev=c,n((0,m.exposeApplicationStatsForPC)(r,s,o,L))}))}}))};t.initSDK=function(e,n,r){var o,s;if(v.watchRTCInitialized)(0,t.sdkLogWithoutTrace)("info","init. watchRTC SDK already has been initialized");else if(v.RTCPeerConnection){if(!(-1!==v.RTCPeerConnection.toString().indexOf("[native code]"))&&f&&(0,t.sdkLog)("info","init. RTCPeerConnection object has been already overridden"),v.watchRTCInitialized=!0,v.watchRTCSessionId=(0,m.generateID)(),setTimeout((function(){var e=Date.now();(0,m.getHardwareInfo)().then((function(n){var i=Date.now()-e;i<=5e4?(c=n,(0,t.sdkLog)("debug","getHardware",{hardwareInfo:c})):(0,t.sdkLog)("debug","getHardware failure: getHardwareTime: ".concat(i),{hardwareInfo:c})})).catch((function(e){(0,t.sdkLog)("error","Error. Get hardware info: ".concat(e.message))}))}),0),f){var d=new URLSearchParams(location.search);d.has("watchrtc")&&"debug"===d.get("watchrtc")&&(e.logLevel="debug")}if(x=(null==r?void 0:r.socketService)||new u.default,C=(null==r?void 0:r.httpService)||new p.default,e.collectionInterval=null!==(o=e.collectionInterval)&&void 0!==o?o:8e3,e.logLevel=e.logLevel||"debug",T=e,b.rtcRoomId=T.rtcRoomId,b.rtcPeerId=T.rtcPeerId,a=x.trace,T.wsUrl&&(0,t.sdkLog)("info",\'"wsUrl" config property is deprecated. Use "proxyUrl" instead of it\'),T.proxyUrl&&(0,t.sdkLog)("info",\'"proxyUrl" is used\'),(null==T?void 0:T.debug)&&(0,t.sdkLog)("info",\'"debug" config property is deprecated. Use "logLevel" instead of it\'),n.forEach((function(e){if(v[e+"RTCPeerConnection"]){var n=v[e+"RTCPeerConnection"],r=function(e,r){(null==e?void 0:e.watchrtc)&&(T=i(i({},T),e.watchrtc),b.rtcRoomId=T.rtcRoomId,b.rtcPeerId=T.rtcPeerId);var o=new n(e,r),s="PC_"+E++;return o.__rtcStatsId=s,y[s]={id:s,pc:o,validConnection:!1},e||(e={nullConfig:!0}),((e=JSON.parse(JSON.stringify(e)))&&e.iceServers||[]).forEach((function(e){delete e.credential})),(null==e?void 0:e.watchrtc)&&delete e.watchrtc,e.browserType=_?"moz":"webkit",(0,t.sdkLog)("debug","new RTCPeerConnection called.",{config:JSON.stringify(e),constraints:r}),a({data:["create",s,e]}),r&&a({data:["constraints",s,r]}),o.addEventListener("icecandidate",(function(e){(0,t.sdkLog)("debug","onicecandidate id:[".concat(s,"], candidate:[").concat(e.candidate,"]")),a({data:["onicecandidate",s,e.candidate]})})),o.addEventListener("icecandidateerror",(function(e){(0,t.sdkLog)("debug","onicecandidateerror id:[".concat(s,"], error:[").concat(e.errorCode,":").concat(e.errorText,"]")),a({data:["onicecandidateerror",s,"".concat(e.errorCode,":").concat(e.errorText)]})})),o.addEventListener("addstream",(function(e){a({data:["onaddstream",s,e.stream.id+" "+e.stream.getTracks().map((function(e){return e.kind+":"+e.id}))]})})),o.addEventListener("track",(function(e){a({data:["ontrack",s,M(e.track)+" "+e.streams.map((function(e){return"stream:"+e.id}))]}),e.track.addEventListener("ended",(function(){a({data:["ontrack",s,M(e.track)+" "+e.streams.map((function(e){return"stream:"+e.id}))]})}))})),o.addEventListener("removestream",(function(e){a({data:["onremovestream",s,e.stream.id+" "+e.stream.getTracks().map((function(e){return e.kind+":"+e.id}))]})})),o.addEventListener("signalingstatechange",(function(){y[s]&&!y[s].validConnection?(y[s].validConnection=!0,setTimeout((function(){(0,t.sdkLog)("debug","signalingstatechage. forceRecreate websocket connection[".concat(s,"]"),{openChannels:JSON.stringify(y)}),F({forceRecreate:!0,pcId:s})}),5e3)):(0,t.sdkLog)("debug","signalingstatechage. WS connection opening not triggered - peer connection not in channels or was already opened [".concat(s,"]"),{openChannels:JSON.stringify(y)}),a({data:["onsignalingstatechange",s,o.signalingState]})})),o.addEventListener("iceconnectionstatechange",(function(){(0,t.sdkLog)("debug","oniceconnectionstatechange id:[".concat(s,"], state:[").concat(o.iceConnectionState,"]")),a({data:["oniceconnectionstatechange",s,o.iceConnectionState]})})),o.addEventListener("icegatheringstatechange",(function(){(0,t.sdkLog)("debug","onicegatheringstatechange id:[".concat(s,"], state:[").concat(o.iceGatheringState,"]")),a({data:["onicegatheringstatechange",s,o.iceGatheringState]})})),o.addEventListener("connectionstatechange",(function(){(0,t.sdkLog)("debug","onconnectionstatechange id:[".concat(s,"], state:[").concat(o.connectionState,"]")),a({data:["onconnectionstatechange",s,o.connectionState]})})),o.addEventListener("negotiationneeded",(function(){(0,t.sdkLog)("debug","onnegotiationneeded id:[".concat(s,"]")),a({data:["onnegotiationneeded",s,void 0]})})),o.addEventListener("datachannel",(function(e){(0,t.sdkLog)("debug","ondatachannel id:[".concat(s,"], data:[").concat(e.channel.id," ").concat(e.channel.label,"]")),a({data:["ondatachannel",s,[e.channel.id,e.channel.label]]})})),(0,t.sdkLog)("debug","RTCPeerConnection override complete [".concat(s,"].")),o};if("HTMLMediaElement"in v&&"setSinkId"in HTMLMediaElement.prototype){var o=HTMLMediaElement.prototype.setSinkId;HTMLMediaElement.prototype.setSinkId=function(){var e=arguments[0];return navigator.mediaDevices.enumerateDevices().then((function(t){var n=t.find((function(t){return t.deviceId===e}));n&&n.deviceId!==l&&a({data:["audioOutputChange",null,n.label]}),l=e})).catch((function(e){(0,t.sdkLog)("debug",e.message,{error:e})})),o.apply(this,arguments)}}if("RTCRtpTransceiver"in v&&"setCodecPreferences"in v.RTCRtpTransceiver.prototype){var s=v.RTCRtpTransceiver,d=s.prototype.setCodecPreferences;s.prototype.setCodecPreferences=function(){return a({data:["setCodecPreferences",this.__pcId,arguments]}),d.apply(this,arguments)}}if("RTCRtpSender"in v&&"setParameters"in v.RTCRtpSender.prototype){var c=(h=v.RTCRtpSender).prototype.setParameters;h.prototype.setParameters=function(){return a({data:["setParameters",this.__pcId,arguments]}),c.apply(this,arguments)}}if("RTCRtpSender"in v&&"replaceTrack"in v.RTCRtpSender.prototype){var h,u=(h=v.RTCRtpSender).prototype.replaceTrack;h.prototype.replaceTrack=function(){var e=arguments[0];if(e){a({data:["replaceTrack",this.__pcId,M(e)]});var t=this.track;t&&t.label!==e.label&&a({data:["".concat(e.kind,"InputChange"),this.__pcId,e.label]})}else a({data:["replaceTrack",this.__pcId,null]});return u.apply(this,arguments)}}["addTransceiver"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n=this,r="";arguments[1]&&arguments[1].streams&&(r=arguments[1].streams.map((function(e){return"stream:"+e.id})).join(";"));var o="string"==typeof arguments[0]?arguments[0]:arguments[0].kind+":"+arguments[0].id+" "+arguments[0].label,s=arguments[1]?i(i({},arguments[1]),{streams:r}):null;a({data:[e,this.__rtcStatsId,[o,s]]});var d=t.apply(this,arguments);d.sender.__pcId=this.__rtcStatsId;var c=arguments[0];return"object"==typeof c&&(a({data:["onlocaltrack",this.__rtcStatsId,M(c)]}),c.addEventListener("ended",(function(){a({data:["onlocaltrack",n.__rtcStatsId,M(c)]})}))),d})})),["createDataChannel","restartIce"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){return a({data:[e,this.__rtcStatsId,arguments]}),t.apply(this,arguments)})})),["close"].forEach((function(e){var i=n.prototype[e];i&&(n.prototype[e]=function(){return a({data:[e,this.__rtcStatsId,arguments]}),delete y[this.__rtcStatsId],D=!0,(0,t.sdkLog)("debug","on RTCPeerConnection(".concat(this.__rtcStatsId,") close")),i.apply(this,arguments)})})),["addStream","removeStream"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n=this,i=arguments[0],r=i.getTracks().map((function(e){return e.kind+":"+e.id})).join(",");return a({data:[e,this.__rtcStatsId,i.id+" "+r]}),"addStream"===e&&i.getTracks().map((function(e){a({data:["onlocaltrack",n.__rtcStatsId,M(e)+" "+i.id]}),e.addEventListener("ended",(function(){a({data:["onlocaltrack",n.__rtcStatsId,M(e)+" "+i.id]})}))})),t.apply(this,arguments)})})),["addTrack"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n=this,i=arguments[0],r=[].slice.call(arguments,1);a({data:[e,this.__rtcStatsId,M(i)+" "+(r.map((function(e){return"stream:"+e.id})).join(";")||"-")]}),a({data:["onlocaltrack",this.__rtcStatsId,M(i)+" "+r.map((function(e){return"stream:"+e.id}))]}),i.addEventListener("ended",(function(){a({data:["onlocaltrack",n.__rtcStatsId,M(i)+" "+r.map((function(e){return"stream:"+e.id}))]})}));var o=t.apply(this,arguments);o.__pcId=this.__rtcStatsId;var s=this.getTransceivers();return s&&s.forEach((function(e){e.__pcId=n.__rtcStatsId})),o})})),["removeTrack"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n=arguments[0].track;return a({data:[e,this.__rtcStatsId,n?M(n):"null"]}),t.apply(this,arguments)})})),["createOffer","createAnswer"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n,i=this.__rtcStatsId,r=arguments;return 1===arguments.length&&"object"==typeof arguments[0]?n=arguments[0]:3===arguments.length&&"object"==typeof arguments[2]&&(n=arguments[2]),a({data:[e,this.__rtcStatsId,n]}),t.apply(this,n?[n]:void 0).then((function(t){if(a({data:[e+"OnSuccess",i,t]}),!(r.length>0&&"function"==typeof r[0]))return t;r[0].apply(null,[t])}),(function(t){if(a({data:[e+"OnFailure",i,t.toString()]}),!(r.length>1&&"function"==typeof r[1]))throw t;r[1].apply(null,[t])}))})})),["setLocalDescription","setRemoteDescription","addIceCandidate"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n=this.__rtcStatsId,i=arguments,r=this,o="setLocalDescription"===e&&(!i[0]||i[0]&&!i[0].sdp);return a({data:[e,this.__rtcStatsId,o?{parameterless:!0}:i[0]]}),t.apply(this,[i[0]]).then((function(){a({data:[e+"OnSuccess",n,o?null==r?void 0:r.localDescription:void 0]}),i.length>=2&&"function"==typeof i[1]&&i[1].apply(null,[])}),(function(t){if(a({data:[e+"OnFailure",n,t.toString()]}),!(i.length>=3&&"function"==typeof i[2]))throw t;i[2].apply(null,[t])}))})})),n.generateCertificate&&Object.defineProperty(r,"generateCertificate",{get:function(){return arguments.length?n.generateCertificate.apply(null,arguments):n.generateCertificate}}),v[e+"RTCPeerConnection"]=r,v[e+"RTCPeerConnection"].prototype=n.prototype,(0,t.sdkLog)("debug","RTCPeerConnection prefixes override complete")}else(0,t.sdkLog)("debug","RTCPeerConnection prefixes override failed")})),f){if(n.forEach((function(e){var t=e+(e.length?"GetUserMedia":"getUserMedia");if(navigator[t]){var n=navigator[t].bind(navigator);navigator[t]=function(){a({data:["getUserMedia",null,arguments[0]]});var e=arguments[1],t=arguments[2];n(arguments[0],(function(t){a({data:["getUserMediaOnSuccess",null,(0,m.dumpStream)(t)]}),e&&e(t)}),(function(e){var n=["getUserMediaOnFailure",null,e.name];a({data:n}),H(n),t&&t(e)}))}.bind(navigator)}})),navigator.mediaDevices&&navigator.mediaDevices.getUserMedia){var h=navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);navigator.mediaDevices.getUserMedia=function(){return a({data:["navigator.mediaDevices.getUserMedia",null,arguments[0]]}),h.apply(navigator.mediaDevices,arguments).then((function(e){return a({data:["navigator.mediaDevices.getUserMediaOnSuccess",null,(0,m.dumpStream)(e)]}),e}),(function(e){var t=["navigator.mediaDevices.getUserMediaOnFailure",null,e.name];return a({data:t}),H(t),Promise.reject(e)}))}.bind(navigator.mediaDevices)}if(navigator.mediaDevices&&navigator.mediaDevices.getDisplayMedia){var g=navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices);navigator.mediaDevices.getDisplayMedia=function(){return a({data:["navigator.mediaDevices.getDisplayMedia",null,arguments[0]]}),g.apply(navigator.mediaDevices,arguments).then((function(e){return a({data:["navigator.mediaDevices.getDisplayMediaOnSuccess",null,(0,m.dumpStream)(e)]}),e}),(function(e){var t=["navigator.mediaDevices.getDisplayMediaOnFailure",null,e.name];return a({data:t}),H(t),Promise.reject(e)}))}.bind(navigator.mediaDevices)}}(null===(s=e.console)||void 0===s?void 0:s.level)&&(0,m.setConsoleLevel)(e.console.level,a)}else(0,t.sdkLogWithoutTrace)("info","init. RTCPeerConnection does not exist in global globalContext")},t.setConfig=function(e){var n;v.watchRTCInitialized?(!(!1===(null==T?void 0:T.allowBrowserLogCollection))&&!0===(null===(n=null==e?void 0:e.console)||void 0===n?void 0:n.override)&&e.console.level&&(0,m.setConsoleLevel)(e.console.level,a),"collectionInterval"in e&&delete e.collectionInterval,T=i(i({},T),e),b.rtcRoomId=T.rtcRoomId,b.rtcPeerId=T.rtcPeerId,(0,t.sdkLog)("debug","setConfig",{newWatchrtcConfig:JSON.stringify(e),watchrtcConfig:JSON.stringify(T)}),F({})):(0,t.sdkLog)("error","SDK is not initialized. Use \'init\' function first.")},t.setUserRating=function(e,n){var i;if(!v.watchRTCInitialized)return(0,t.sdkLog)("error","SDK is not initialized. Use \'init\' function first."),Promise.resolve({error:"SDK is not initialized. Use \'init\' function first."});if(!(0,m.validateRating)(e))return Promise.resolve({error:"Rating is invalid"});var r=(null===(i=null==x?void 0:x.connection)||void 0===i?void 0:i.readyState)===v.WebSocket.OPEN,o=["userRating",null,{rating:e,ratingComment:n}];return new Promise((function(e,t){r?a({data:o,options:{promiseFuncs:{resolve:e,reject:t}}}):U.apply(void 0,o).then((function(){return e({})})).catch((function(t){return e({error:t})}))}))},t.addKeys=function(e){var n;if(v.watchRTCInitialized){Object.keys(e||{}).forEach((function(t){"string"==typeof e[t]&&(e[t]=[e[t]])}));var i=["keys",null,e],r=(null===(n=null==x?void 0:x.connection)||void 0===n?void 0:n.readyState)===v.WebSocket.OPEN,o=null==x?void 0:x.wasConnected;return new Promise((function(e,t){var n={promiseFuncs:{resolve:e,reject:t}};r?a({data:i,options:n}):o?U.apply(void 0,i).then((function(){return e({})})).catch((function(t){return e({error:t})})):a({data:i,options:n})}))}(0,t.sdkLog)("error","SDK is not initialized. Use \'init\' function first.")},t.disableDataCollection=function(){v.watchRTCInitialized?(a({data:["disableDataCollection",null,null]}),null==x||x.disableDataCollection()):(0,t.sdkLog)("error","SDK is not initialized. Use \'init\' function first.")},t.enableDataCollection=function(){v.watchRTCInitialized?(a({data:["enableDataCollection",null,null]}),null==x||x.enableDataCollection()):(0,t.sdkLog)("error","SDK is not initialized. Use \'init\' function first.")},t.addEvent=function(e){if(v.watchRTCInitialized){if((0,m.validateEvent)(e,y)){var n=i({},e),r=null;n.pc&&(r=n.pc.__rtcStatsId||null,delete n.pc);var o=["event",r,n];return new Promise((function(e,t){a({data:o,options:{promiseFuncs:{resolve:e,reject:t}}})}))}}else(0,t.sdkLog)("error","addEvent error. SDK is not initialized. Use \'init\' function first.")},t.mapStream=function(e,n){if(v.watchRTCInitialized){if(e&&n){var i=["mapStream",null,{id:e,name:n}];(0,t.sdkLog)("info","mapStream method is deprecated. Please use mapTrack instead."),a({data:i})}}else(0,t.sdkLog)("error","mapStream error. SDK is not initialized. Use \'init\' function first.")},t.mapTrack=function(e,n){v.watchRTCInitialized?!e||!n||(L[e]=n,a({data:["mapTrack",null,{id:e,name:n}]})):(0,t.sdkLog)("error","mapTrack error. SDK is not initialized. Use \'init\' function first.")},t.connect=function(){v.watchRTCInitialized?(N=!0,P=!0,(0,t.sdkLog)("debug","manual connect"),F({})):(0,t.sdkLog)("error","connect error. SDK is not initialized. Use \'init\' function first.")},t.disconnect=function(){v.watchRTCInitialized?(P=!1,D=!0,null==x||x.close(),(0,t.sdkLog)("debug","manual disconnect")):(0,t.sdkLog)("error","disconnect error. SDK is not initialized. Use \'init\' function first.")},t.registerOnStatsListener=function(e){O=e},t.registerStateListener=function(e){k=e};var U=function(){for(var e,n=[],i=0;i<arguments.length;i++)n[i]=arguments[i];if(!b.rtcRoomId||!b.rtcPeerId){var r="Missing configuration parameters rtcPeerId and rtcRoomId to connect";return!b.rtcRoomId&&b.rtcPeerId?r="Missing configuration parameter rtcRoomId to connect":!b.rtcPeerId&&b.rtcRoomId&&(r="Missing configuration parameter rtcPeerId to connect"),(0,t.sdkLog)("error",r),Promise.reject(r)}if(!b.projectId&&!T.rtcApiKey)return r="Missing apiKey to enable trace before connection establishment",(0,t.sdkLog)("info",r),Promise.reject(r);var o=(0,m.getConnectionData)("http",T.rtcApiKey,T.proxyUrl);return C?C.trace.apply(C,s(["".concat(o.url,"/trace"),null!==(e=b.projectId)&&void 0!==e?e:o.key,b.rtcRoomId,b.rtcPeerId],n,!1)):Promise.reject("Invalid configuration of http service")},H=function(e){var n=null==T?void 0:T.rtcApiKey,i=null==T?void 0:T.rtcRoomId,r=null==T?void 0:T.rtcPeerId;if(n&&i&&r){var o=(0,m.getConnectionData)("http",null==T?void 0:T.rtcApiKey,T.proxyUrl);e=e||(null==x?void 0:x.buffer)||[],null==C||C.trace("".concat(o.url,"/error"),o.key,i,r,e)}else(0,t.sdkLog)("error","Cannot report an error. Please provide rtcApiKey, rtcRoomId and rtcPeerId ")};t.persistentEnd=function(e){v.watchRTCInitialized?(clearInterval(d),P=!1,D=!0,null==x||x.close(e),(0,t.sdkLog)("debug","persistentEnd. sessionId: ".concat(v.watchRTCSessionId))):(0,t.sdkLog)("error","persistentEnd error. SDK is not initialized. Use \'init\' function first.")};var $=function(){var e;(0,t.sdkLog)("debug","resetConnectionState sessionId: ".concat(v.watchRTCSessionId));for(var n=0,i=Object.values(y);n<i.length;n++)i[n].prev=null;(null===(e=null==x?void 0:x.buffer)||void 0===e?void 0:e.length)&&(x.buffer=x.buffer.filter((function(e){return"getstats"!==e[0]})))};t.persistentStart=function(e,n){v.watchRTCInitialized?(T=i(i({},T),{rtcRoomId:e,rtcPeerId:n}),b.rtcRoomId=e,b.rtcPeerId=n,$(),F({nailUp:!0}),(0,t.sdkLog)("debug","persistentStart. sessionId: ".concat(v.watchRTCSessionId),{watchrtcConfig:T})):(0,t.sdkLog)("error","persistentStart error. SDK is not initialized. Use \'init\' function first.")};var J=function(e){return new Promise((function(t,n){var i=document.createElement("script");i.src=e,i.onload=t,i.onerror=n,document.head.appendChild(i)}))},B=!1;t.qrtcRun=function(e){var n=e.options,s=e.progressCallback;return r(void 0,void 0,void 0,(function(){var e,a,d,c,l,h,u,p,_,y,E,S,b,C;return o(this,(function(x){switch(x.label){case 0:if(!f)return(0,t.sdkLogWithoutTrace)("info","Cannot run qualityRTC test in non-browser environment"),[2];B=!1,(0,t.disableDataCollection)(),x.label=1;case 1:return x.trys.push([1,,4,5]),a=(null==n?void 0:n.codeUrl)||"https://qualityrtc-sdk.s3.amazonaws.com/".concat(g.default,"/main.bundle.js"),d={},n&&Object.keys(n||{}).forEach((function(e){"string"==typeof n[e]&&(d[e]=n[e])})),c=(0,m.getConnectionData)("http",null==T?void 0:T.rtcApiKey,T.proxyUrl),l=!!(null==n?void 0:n.configUrl),h=l?"".concat(n.configUrl,"/.netlify/functions/get-config"):c.url+"/get-qualityrtc-config?apiKey=".concat(c.key,"&").concat(new URLSearchParams(d)),console.log("runNetworkTest: request to run, loading lib and config",{codeUrl:a,configUrl:h}),[4,Promise.all([(R=h,r(void 0,void 0,void 0,(function(){return o(this,(function(e){switch(e.label){case 0:return[4,fetch(R)];case 1:return[4,e.sent().json()];case 2:return[2,e.sent()]}}))}))),J(a)])];case 2:if(u=x.sent(),p=u[0],_=u[1],console.log("runNetworkTest:JS code & config loaded",{codeLoad:_,configAnswer:p}),!(y=v.__qualityRTC))throw new Error("runNetworkTest:Failed to load qualityRTC, __qualityRTC is undefined");return E=function(e){return!B&&(s&&s(e),!0)},S=l?p.config:p.jsonConfig.config,b=l?null==n?void 0:n.configUrl:new URL(p.url).origin,C=i(i({},S),{isProbe:!0,options:i(i(i({},S.options),n),{wakeLock:!0,netlifyBaseUrl:b})}),console.log("runNetworkTest: code & config loaded, running test",{config:C,configData:S,qualityRTC:y,netlifyBaseUrl:b}),[4,y.run({config:C,progressCallback:E})];case 3:return e=x.sent(),console.log("runNetworkTest:JS Test completed",{answer:e}),[3,5];case 4:return(0,t.enableDataCollection)(),[7];case 5:return[2,e]}var R}))}))},t.qrtcStop=function(){f?B=!0:(0,t.sdkLogWithoutTrace)("info","Cannot run qualityRTC test in non-browser environment")}},527:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.getStreamsFromStats=t.getTransportFromStats=void 0,t.getTransportFromStats=function(e,t){if(!t)return null;var n=Object.keys(t),i=n.filter((function(e){return"candidate-pair"===t[e].type&&t[e].nominated}));if(i.length>0){var r=t[i[0]],o=r.localCandidateId,s=r.remoteCandidateId,a=n.find((function(e){return"local-candidate"===t[e].type&&t[e].id===o})),d=n.find((function(e){return"remote-candidate"===t[e].type&&t[e].id===s}));if(a&&d){var c=t[a],l=t[d],h={};return h[e]={connection:"relay"===c.candidateType?"relay":"direct",transport:"relay"===c.candidateType?c.relayProtocol:"udp",address:"".concat(l.address,":").concat(l.port)},h}}return null},t.getStreamsFromStats=function(e,t,n,i){var r={},o=Object.keys(n);return o.filter((function(e){return"inbound-rtp"===n[e].type||"outbound-rtp"===n[e].type})).forEach((function(s){var a=n[s],d=t&&s in t?t[s]:null,c="inbound-rtp"===a.type?"inbound":"outbound",l=a.kind,h=a.remoteId in n?n[a.remoteId]:null,u=d&&d.remoteId in t?t[d.remoteId]:null,p=d?(a.timestamp-d.timestamp)/1e3:null,m={direction:c,kind:l,peerId:e};if("video"===l&&(m.frameWidth=a.frameWidth,m.frameHeight=a.frameHeight,m.framerate=a.framesPerSecond),"inbound-rtp"===a.type)m.jitter=a.jitter,m.mappedName=a.trackIdentifier in i?i[a.trackIdentifier]:null,m.bytesReceived=d?a.bytesReceived-d.bytesReceived:null,m.packetsReceived=d?a.packetsReceived-d.packetsReceived:null,m.packetsLost=d?a.packetsLost-d.packetsLost:null,m.packetsLoss=m.packetsLost+m.packetsReceived>0?100*m.packetsLost/(m.packetsLost+m.packetsReceived):null,m.bitrate=p?8*m.bytesReceived/p:null,m.roundTripTime=h&&"roundTripTime"in h?h.roundTripTime:null;else{m.bytesSent=d?a.bytesSent-d.bytesSent:null,m.packetsSent=d?a.packetsSent-d.packetsSent:null,m.bitrate=p?8*m.bytesSent/p:null,m.roundTripTime=h&&"roundTripTime"in h?h.roundTripTime:null,m.jitter=h&&"jitter"in h?h.jitter:null,m.packetsLost=h&&u?h.packetsLost-u.packetsLost:null,m.packetsLoss=h&&"fractionLost"in h?h.fractionLost:null;var g=o.find((function(e){return n[e].id===a.mediaSourceId}));if(g){var f=n[g].trackIdentifier;m.mappedName=f in i?i[f]:null}}var v=o.find((function(e){return n[e].id===a.codecId}));if(v){var _=n[v].mimeType||"";m.codec=_.includes("/")?_.split("/")[1]:_}r[n[s].id]=m})),r}},699:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0})},593:function(e,t,n){"use strict";var i,r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},r.apply(this,arguments)},o=this&&this.__awaiter||function(e,t,n,i){return new(n||(n=Promise))((function(r,o){function s(e){try{d(i.next(e))}catch(e){o(e)}}function a(e){try{d(i.throw(e))}catch(e){o(e)}}function d(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}d((i=i.apply(e,t||[])).next())}))},s=this&&this.__generator||function(e,t){var n,i,r,o,s={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(a){return function(d){return function(a){if(n)throw new TypeError("Generator is already executing.");for(;o&&(o=0,a[0]&&(s=0)),s;)try{if(n=1,i&&(r=2&a[0]?i.return:a[0]?i.throw||((r=i.return)&&r.call(i),0):i.next)&&!(r=r.call(i,a[1])).done)return r;switch(i=0,r&&(a=[2&a[0],r.value]),a[0]){case 0:case 1:r=a;break;case 4:return s.label++,{value:a[1],done:!1};case 5:s.label++,i=a[1],a=[0];continue;case 7:a=s.ops.pop(),s.trys.pop();continue;default:if(!((r=(r=s.trys).length>0&&r[r.length-1])||6!==a[0]&&2!==a[0])){s=0;continue}if(3===a[0]&&(!r||a[1]>r[0]&&a[1]<r[3])){s.label=a[1];break}if(6===a[0]&&s.label<r[1]){s.label=r[1],r=a;break}if(r&&s.label<r[2]){s.label=r[2],s.ops.push(a);break}r[2]&&s.ops.pop(),s.trys.pop();continue}a=t.call(e,s)}catch(e){a=[6,e],i=0}finally{n=r=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,d])}}},a=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var i,r=0,o=t.length;r<o;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.generateID=t.subtractNailUpReferenceStats=t.applyPatchForRTT=t.exposeApplicationStatsForPC=t.restoreOriginalConsoleMethods=t.setConsoleLevel=t.getHardwareInfo=t.validateEvent=t.validateRating=t.isRoomIdOrPeerIdChanged=t.countOfValidConnections=t.validateConfig=t.getConnectionData=t.dumpStream=t.map2obj=t.mangleChromeStats=t.deltaCompression=t.getSdkLogWithoutTrace=t.getSdkLogger=t.logPrefix=void 0;var d=n(240),c=n(527),l=n(231),h=function(){var e=new Date;return("00"+(e.getMonth()+1)).slice(-2)+"/"+("00"+e.getDate()).slice(-2)+"/"+e.getFullYear()+" "+("00"+e.getHours()).slice(-2)+":"+("00"+e.getMinutes()).slice(-2)+":"+("00"+e.getSeconds()).slice(-2)+":"+("000"+e.getMilliseconds()).slice(-3)};t.logPrefix=function(e){return void 0===e&&(e="info"),"error"===e?["".concat(h()," %cwatchRTC %cERROR"),"background: ".concat("gold","; color: black; padding: 2px 0.5em; border-radius: 0.5em;"),"background: ".concat("red","; color: white; padding: 2px 0.5em; border-radius: 0.5em;")]:["".concat(h()," %cwatchRTC"),"background: ".concat("gold","; color: black; padding: 2px 0.5em; border-radius: 0.5em;")]};var u=["debug","info","error"],p=function(e,n){return void 0===e&&(e=console.log),function(i,r,o){var s=n(),d=u.indexOf(s),c=u.indexOf(i);if(!("silent"===s||c<d)){var l=a(a([],(0,t.logPrefix)(i),!0),[r],!1);o&&l.push(o),e.apply(void 0,l)}}};t.getSdkLogger=p.bind(null,console.log),t.getSdkLogWithoutTrace=p.bind(null,null!==(i=console._original_log)&&void 0!==i?i:console.log),t.deltaCompression=function(e,t){e=e||{},t=t||{},t=JSON.parse(JSON.stringify(t)),Object.keys(t).forEach((function(n){var i=t[n];delete i.id,e[n]&&Object.keys(i).forEach((function(r){i.timestamp&&"string"==typeof i.timestamp&&(i.timestamp=new Date(i.timestamp).getTime()),(i[r]===e[n][r]||Array.isArray(i[r])&&JSON.stringify(i[r])===JSON.stringify(e[n][r]))&&delete t[n][r],(0===Object.keys(i).length||1===Object.keys(i).length&&i.timestamp)&&delete t[n]}))}));var n=-1/0;return Object.keys(t).forEach((function(e){var i=t[e];i.timestamp>n&&(n=i.timestamp)})),Object.keys(t).forEach((function(e){var i=t[e];i.timestamp===n&&(i.timestamp=0)})),t.timestamp=n,t},t.mangleChromeStats=function(e,t){var n={};return t.result().forEach((function(e){var t={id:e.id,timestamp:e.timestamp.getTime(),type:e.type};e.names().forEach((function(n){t[n]=e.stat(n)})),n[t.id]=t})),n},t.map2obj=function(e){if(!e.entries)return e;var t={};return e.forEach((function(e,n){t[n]=e})),t},t.dumpStream=function(e){return{id:e.id,tracks:e.getTracks().map((function(e){return{id:e.id,kind:e.kind,label:e.label,enabled:e.enabled,muted:e.muted,readyState:e.readyState}}))}},t.getConnectionData=function(e,t,n){var i="".concat("ws"==e?"ws":"http","://localhost:9101"),r="".concat("ws"==e?"wss":"https","://watchrtc-staging1.testrtc.com"),o="".concat("ws"==e?"wss":"https","://watchrtc-staging2.testrtc.com"),s="".concat("ws"==e?"wss":"https","://watchrtc.testrtc.com"),a="".concat("ws"==e?"wss":"https","://watchrtc-app1.testrtc.com");n&&"http"===e&&(n=n.includes("wss://")?n.replace("wss://","https://"):n.replace("ws://","http://"));var d=t.split(":");return-1!==t.indexOf("local")?{url:n||i,key:d[1]}:-1!==t.indexOf("staging1")?{url:n||r,key:d[1]}:-1!==t.indexOf("staging")?{url:n||o,key:d[1]}:-1!==t.indexOf("production1")?{url:n||a,key:d[1]}:-1!==t.indexOf("production")?{url:n||s,key:d[1]}:{url:n||s,key:d[0]}},t.validateConfig=function(e){return(null==e?void 0:e.rtcApiKey)?!(!(null==e?void 0:e.rtcRoomId)||!(null==e?void 0:e.rtcPeerId))||((0,l.sdkLog)("debug","config.rtcRoomId or config.rtcPeerId is empty."),!1):((0,l.sdkLog)("debug","config.rtcApiKey or config.rtcToken need to be provided."),!1)},t.countOfValidConnections=function(e){return Object.keys(e).filter((function(t){return e[t].validConnection})).length},t.isRoomIdOrPeerIdChanged=function(e,t){var n=!1;return t.rtcRoomId&&e.rtcRoomId&&e.rtcRoomId!==t.rtcRoomId&&(n=!0),t.rtcPeerId&&e.rtcPeerId&&e.rtcPeerId!==t.rtcPeerId&&(n=!0),n&&(0,l.sdkLog)("debug","maybeOpenWebsocketConnection. rtcRoomId or rtcPeerId has been changed",{old:{rtcRoomId:e.rtcRoomId,rtcPeerId:e.rtcPeerId},new:{rtcRoomId:t.rtcRoomId,rtcPeerId:t.rtcPeerId}}),n},t.validateRating=function(e){return e?!("number"!=typeof e||e<1||e>5)||((0,l.sdkLog)("error","rating parameter should be number from 1 to 5"),!1):((0,l.sdkLog)("error","rating parameter is required"),!1)},t.validateEvent=function(e,t){return e?["global","local","log"].includes(e.type)?e.parameters&&"object"!=typeof e.parameters?((0,l.sdkLog)("error",\'event.parameters should be JSON object"\'),!1):!e.pc||e.pc.__rtcStatsId in t||((0,l.sdkLog)("error",\'event.pc should be a RTCPeerConnection used in the call"\'),!1):((0,l.sdkLog)("error",\'event.type should be either "global" or "local" or "log"\'),!1):((0,l.sdkLog)("error","event parameter is required"),!1)},t.getHardwareInfo=function(){return o(void 0,void 0,void 0,(function(){function e(e){return(Math.round(100*e)/100).toFixed(2)}var t,i,a,c;return s(this,(function(h){switch(h.label){case 0:return"undefined"==typeof window?[2]:(t=function(e){return o(void 0,void 0,void 0,(function(){return s(this,(function(t){switch(t.label){case 0:return[4,new Promise((function(t){try{var i=n(804)("./".concat(e));return i.shift(),t(i)}catch(n){(0,l.sdkLog)("error","Error. getHardwareInfo. loadBenchmarks",{err:n.stack,fileName:e}),t([])}}))];case 1:return[2,t.sent()]}}))}))},[4,d.getGPUTier({override:{loadBenchmarks:t}})]);case 1:return i=h.sent(),a=r(r({},i),{cores_count:window.navigator.hardwareConcurrency}),(c=window.performance.memory)&&(a.jsHeapSizeLimit=e(c.jsHeapSizeLimit/1048576),a.totalJSHeapSize=e(c.totalJSHeapSize/1048576),a.usedJSHeapSize=e(c.usedJSHeapSize/1048576)),[2,a]}}))}))};var m={originalMethodPrefix:"_original_",methodsToPatch:["log","debug","info","warn","error"],level:""},g=function(e,t){var n=console[e];n&&(console[m.originalMethodPrefix+e]=n,console[e]=function(){for(var i=[],r=0;r<arguments.length;r++)i[r]=arguments[r];if(m.level&&i.length&&t){var o=m.methodsToPatch.indexOf(e),s=m.methodsToPatch.indexOf(m.level);if(o>=0&&o>=s){var a=f(i);t({data:["log",null,{type:e,text:a}]})}}n.apply(console,i)})};t.setConsoleLevel=function(e,t){if(e&&m.methodsToPatch.includes(e)&&e!==m.level){var n=m.methodsToPatch.indexOf(e),i=m.methodsToPatch.indexOf(m.level);if(i<0)for(var r=0,o=m.methodsToPatch.slice(n);r<o.length;r++){var s=o[r];g(s,t)}else if(n<i)for(var a=0,d=m.methodsToPatch.slice(n,i);a<d.length;a++)s=d[a],g(s,t);m.level=e}},t.restoreOriginalConsoleMethods=function(){if("console"in window)for(var e=0,t=m.methodsToPatch;e<t.length;e++){var n=t[e],i=console[m.originalMethodPrefix+n];i&&(console[n]=i.bind(console),delete console[m.originalMethodPrefix+n])}},t.exposeApplicationStatsForPC=function(e,t,n,i){return{peer:(0,c.getTransportFromStats)(e,n),streams:(0,c.getStreamsFromStats)(e,t,n,i)}};var f=function(e){try{return e.map((function(e){return"string"==typeof e?e:JSON.stringify(e,v())})).join(" ")}catch(e){return""}},v=function(){var e=new WeakSet;return function(t,n){if("object"==typeof n&&null!==n){if(e.has(n))return;e.add(n)}return n}};t.applyPatchForRTT=function(e,t){e=e||{},t=t||{};var n=!0;return 0===Object.keys(e).length&&(n=!1),Object.keys(t).filter((function(e){return"remote-outbound-rtp"===t[e].type||"remote-inbound-rtp"===t[e].type})).forEach((function(i){if("roundTripTime"in t[i]){var r="roundTripTimeMeasurements"in t[i]&&Boolean(e[i])&&"roundTripTimeMeasurements"in e[i];n&&r&&t[i].roundTripTimeMeasurements===e[i].roundTripTimeMeasurements&&(t[i].roundTripTime=NaN)}else t[i].roundTripTime=NaN})),t},t.subtractNailUpReferenceStats=function(e,t){for(var n=function(t,n){if(t in e){var i=e[t];switch(n.type){case"inbound-rtp":["bytesReceived","packetsReceived","packetsLost","framesDecoded","keyFramesDecoded","framesRendered","framesDropped","qpSum","totalDecodeTime","totalInterFrameDelay","totalSquaredInterFrameDelay","pauseCount","totalPausesDuration","freezeCount","totalFreezesDuration","headerBytesReceived","packetsDiscarded","fecBytesReceived","fecPacketsReceived","fecPacketsDiscarded","firCount","pliCount","totalProcessingDelay","nackCount","jitterBufferEmittedCount","totalSamplesReceived","concealedSamples","silentConcealedSamples","concealmentEvents","totalAudioEnergy","totalSamplesDuration","framesReceived","framesAssembledFromMultiplePackets","totalAssemblyTime","retransmittedPacketsReceived","retransmittedBytesReceived"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"outbound-rtp":["packetsSent","bytesSent","headerBytesSent","retransmittedPacketsSent","retransmittedBytesSent","totalEncodedBytesTarget","framesSent","hugeFramesSent","framesEncoded","keyFramesEncoded","qpSum","totalEncodeTime","totalPacketsSendDelay","qualityLimitationResolutionChanges","qualityLimitationDurations","nackCount","firCount","pliCount"].forEach((function(e){e in n&&("qualityLimitationDurations"===e?(n[e].bandwidth=Math.max(n[e].bandwidth-i[e].bandwidth,0),n[e].cpu=Math.max(n[e].cpu-i[e].cpu,0),n[e].other=Math.max(n[e].other-i[e].other,0),n[e].none=Math.max(n[e].none-i[e].none,0)):n[e]=Math.max(n[e]-i[e],0))}));break;case"remote-inbound-rtp":["packetsReceived","packetsLost","totalRoundTripTime","roundTripTimeMeasurements"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"remote-outbound-rtp":["packetsSent","bytesSent","totalRoundTripTime","roundTripTimeMeasurements"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"media-source":["totalAudioEnergy","totalSamplesDuration","droppedSamplesDuration","droppedSamplesEvents","totalCaptureDelay","totalSamplesCaptured","frames"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"media-playout":["synthesizedSamplesDuration","synthesizedSamplesEvents","totalSamplesDuration","totalPlayoutDelay","totalSamplesCount"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"peer-connection":["dataChannelsOpened","dataChannelsClosed"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"data-channel":["messagesSent","bytesSent","messagesReceived","bytesReceived"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"transport":["packetsSent","packetsReceived","bytesSent","bytesReceived","selectedCandidatePairChanges"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"candidate-pair":["packetsSent","packetsReceived","bytesSent","bytesReceived","totalRoundTripTime","requestsReceived","requestsSent","responsesReceived","responsesSent","consentRequestsSent","packetsDiscardedOnSend","bytesDiscardedOnSend"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}))}}},i=0,r=Object.entries(t);i<r.length;i++){var o=r[i];n(o[0],o[1])}return t},t.generateID=function(){return Math.random().toString(36).substring(2,15)+Math.random().toString(36).substring(2,15)}},412:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default="1.38.2"},911:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(231),r=function(){function e(){e._instance?(0,i.sdkLog)("info","WatchRTCSocket instance already created"):e._instance=this}return e.prototype.trace=function(e,t,n,r){for(var o=[],s=4;s<arguments.length;s++)o[s-4]=arguments[s];var a=Array.prototype.slice.call(o);return a.push(Date.now()),a[1]instanceof RTCPeerConnection&&(a[1]=a[1].__rtcStatsId),fetch(e,{method:"POST",mode:"cors",cache:"no-cache",credentials:"same-origin",headers:{"Content-Type":"application/json"},body:JSON.stringify({data:o,projectId:t,rtcRoomId:n,rtcPeerId:r})}).then((function(){return{}})).catch((function(e){return(0,i.sdkLog)("error",e.message,{err:e.stack}),{error:e}}))},e}();t.default=r},85:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(231),r=n(354),o="undefined"!=typeof window?window:n.g,s=function(){function e(){var t=this;this.connection=null,this.wasConnected=!1,this.buffer=[],this.sendInterval=1,this.onClose=function(){},this.dataCollection=!0,this.sendPromises=[],this.prevMessageTs=Date.now(),this.trace=function(n){var s=n.data,a=n.options,d=Array.prototype.slice.call(s),c=t.prevMessageTs,l=Date.now(),h=l-c;if(Math.abs(h)>=432e5&&t.trace({data:["timeChange",null,{now:l,prevMessageTs:c,timeSinceLastMessage:h}]}),d.push(l),d[1]instanceof RTCPeerConnection&&(d[1]=d[1].__rtcStatsId),e._instance.dataCollection)if(e._instance.connection&&e._instance.connection.readyState===o.WebSocket.OPEN||!(e._instance.buffer.length>1e3)){if(e._instance.buffer.push(d),(null==a?void 0:a.promiseFuncs)&&e._instance.sendPromises.push(a.promiseFuncs),e._instance.connection&&e._instance.connection.readyState===o.WebSocket.OPEN&&e._instance.buffer.length>=e._instance.sendInterval){var u=JSON.stringify(e._instance.buffer),p=r.compressToEncodedURIComponent(u);(0,i.sdkLogWithoutTrace)("debug","lines: ".concat(u.length)),(0,i.sdkLogWithoutTrace)("debug","compressedMessage: ".concat(p.length)),e._instance.buffer=[],e._instance.connection.send(p),e._instance.sendPromises.forEach((function(e){return(0,e.resolve)({})})),e._instance.sendPromises=[]}}else(null==a?void 0:a.promiseFuncs)&&a.promiseFuncs.resolve({error:"Message buffer size exceeded"});else(null==a?void 0:a.promiseFuncs)&&a.promiseFuncs.resolve({error:"Data collection disabled"})},e._instance?(0,i.sdkLog)("info","WatchRTCSocket instance already created"):e._instance=this}return e.prototype.connect=function(t){var n=t.url,r=t.onData,s=t.onError,a=t.onOpen,d=t.onClose,c=t.options,l=(void 0===c?{}:c).cleanOldTraces;e._instance.connection&&(e._instance.connection.close(),e._instance.connection=null);var h=e._instance;if(l){var u=Date.now()-6e5,p=h.buffer.filter((function(e){return e[3]>u})),m=h.buffer.length-p.length;h.buffer=p;var g=["oldTracesCleanup",null,{filteredCount:m},Date.now()];(0,i.sdkLog)("info","watchRTC SDK flushed ".concat(m," messages")),h.buffer.push(g)}e._instance.connection=new o.WebSocket(n,"2.0"),e._instance.connection.onopen=a||null,e._instance.connection.onclose=d||null,e._instance.connection.onmessage=function(t){var n;try{var o=JSON.parse(t.data);o.error?(null===(n=null==h?void 0:h.connection)||void 0===n||n.close(),h.connection=null,(0,i.sdkLog)("error","\\n"+o.error),s(o.error,"auth")):(o.sendInterval&&(e._instance.sendInterval=o.sendInterval),r(o),e._instance.wasConnected=!0)}catch(e){(0,i.sdkLog)("error","\\n",{err:e.stack}),s(e.message)}},e._instance.connection.onerror=function(e){(0,i.sdkLog)("error","\\n",e),s(e,"connection")}},e.prototype.close=function(t){var n,i;if(t&&(null===(i=null===(n=e._instance)||void 0===n?void 0:n.connection)||void 0===i?void 0:i.readyState)===o.WebSocket.OPEN){var s=JSON.stringify(["nailUpCallEnd",null,null,Date.now()]),a=r.compressToEncodedURIComponent(s);e._instance.connection.send(a)}e._instance.buffer=[],e._instance.sendPromises.forEach((function(e){return(0,e.resolve)({error:"Connection was close"})})),e._instance.sendPromises=[],e._instance.connection&&(e._instance.connection.close(),e._instance.onClose(),e._instance.connection=null)},e.prototype.disableDataCollection=function(){(0,i.sdkLog)("debug","Data collection disabled."),e._instance.dataCollection=!1},e.prototype.enableDataCollection=function(){(0,i.sdkLog)("debug","Data collection enabled."),e._instance.dataCollection=!0},e.prototype.isDisabledDataCollection=function(){return!e._instance.dataCollection},e}();t.default=s},240:function(e,t){!function(e){"use strict";var t=function(e,n){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])})(e,n)};function n(e,t,n,i){return new(n||(n=Promise))((function(r,o){function s(e){try{d(i.next(e))}catch(e){o(e)}}function a(e){try{d(i.throw(e))}catch(e){o(e)}}function d(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}d((i=i.apply(e,t||[])).next())}))}function i(e,t){var n,i,r,o,s={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,i&&(r=2&o[0]?i.return:o[0]?i.throw||((r=i.return)&&r.call(i),0):i.next)&&!(r=r.call(i,o[1])).done)return r;switch(i=0,r&&(o=[2&o[0],r.value]),o[0]){case 0:case 1:r=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,i=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!((r=(r=s.trys).length>0&&r[r.length-1])||6!==o[0]&&2!==o[0])){s=0;continue}if(3===o[0]&&(!r||o[1]>r[0]&&o[1]<r[3])){s.label=o[1];break}if(6===o[0]&&s.label<r[1]){s.label=r[1],r=o;break}if(r&&s.label<r[2]){s.label=r[2],s.ops.push(o);break}r[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],i=0}finally{n=r=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}}var r=["geforce 320m","geforce 8600","geforce 8600m gt","geforce 8800 gs","geforce 8800 gt","geforce 9400","geforce 9400m g","geforce 9400m","geforce 9600m gt","geforce 9600m","geforce fx go5200","geforce gt 120","geforce gt 130","geforce gt 330m","geforce gtx 285","google swiftshader","intel g41","intel g45","intel gma 4500mhd","intel gma x3100","intel hd 3000","intel q45","legacy","mali-2","mali-3","mali-4","quadro fx 1500","quadro fx 4","quadro fx 5","radeon hd 2400","radeon hd 2600","radeon hd 4670","radeon hd 4850","radeon hd 4870","radeon hd 5670","radeon hd 5750","radeon hd 6290","radeon hd 6300","radeon hd 6310","radeon hd 6320","radeon hd 6490m","radeon hd 6630m","radeon hd 6750m","radeon hd 6770m","radeon hd 6970m","sgx 543","sgx543"];function o(e){return e.toLowerCase().replace(/^angle ?\\((.+)\\)*$/,"$1").replace(/\\s(\\d{1,2}gb|direct3d.+$)|\\(r\\)| \\([^)]+\\)$/g,"")}var s="undefined"==typeof window,a=function(){if(!s){var e=window.navigator,t=e.userAgent,n=e.platform,i=e.maxTouchPoints,r=/(iphone|ipod|ipad)/i.test(t),o="iPad"===n||"MacIntel"===n&&i>0&&!window.MSStream;return{isIpad:o,isMobile:/android/i.test(t)||r||o,isSafari12:/Version\\/12.+Safari/.test(t)}}}();var d=[],c=[];function l(e,t){if(e===t)return 0;var n=e;e.length>t.length&&(e=t,t=n);for(var i=e.length,r=t.length;i>0&&e.charCodeAt(~-i)===t.charCodeAt(~-r);)i--,r--;for(var o,s=0;s<i&&e.charCodeAt(s)===t.charCodeAt(s);)s++;if(r-=s,0==(i-=s))return r;for(var a,l,h=0,u=0,p=0;u<i;)c[u]=e.charCodeAt(s+u),d[u]=++u;for(;p<r;)for(o=t.charCodeAt(s+p),a=p++,h=p,u=0;u<i;u++)l=o===c[u]?a:a+1,a=d[u],h=d[u]=a>h?l>h?h+1:l:l>a?a+1:l;return h}function h(e){return null!=e}var u=function(e){function n(t){var n=this.constructor,i=e.call(this,t)||this;return Object.setPrototypeOf(i,n.prototype),i}return function(e,n){if("function"!=typeof n&&null!==n)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");function i(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}(n,e),n}(Error);e.getGPUTier=function(e){var t=void 0===e?{}:e,d=t.mobileTiers,c=void 0===d?[0,15,30,60]:d,p=t.desktopTiers,m=void 0===p?[0,15,30,60]:p,g=t.override,f=void 0===g?{}:g,v=t.glContext,_=t.failIfMajorPerformanceCaveat,y=void 0!==_&&_,E=t.benchmarksURL,S=void 0===E?"https://unpkg.com/detect-gpu@".concat("4.0.8","/dist/benchmarks"):E;return n(void 0,void 0,void 0,(function(){var e,t,d,p,g,_,E,b,T,C,x,R,A,w,I,P,D,O,k,N,M,L,F,j,V,U;return i(this,(function(H){switch(H.label){case 0:if(e={},s)return[2,{tier:0,type:"SSR"}];if(t=f.isIpad,d=void 0===t?!!(null==a?void 0:a.isIpad):t,p=f.isMobile,g=void 0===p?!!(null==a?void 0:a.isMobile):p,_=f.screenSize,E=void 0===_?window.screen:_,b=f.loadBenchmarks,T=void 0===b?function(e){return n(void 0,void 0,void 0,(function(){var t;return i(this,(function(n){switch(n.label){case 0:return[4,fetch("".concat(S,"/").concat(e)).then((function(e){return e.json()}))];case 1:if(t=n.sent(),parseInt(t.shift().split(".")[0],10)<4)throw new u("Detect GPU benchmark data is out of date. Please update to version 4x");return[2,t]}}))}))}:b,C=f.renderer,x=function(e){for(var t=0,n=g?["adreno","apple","mali-t","mali","nvidia","powervr"]:["intel","apple","amd","radeon","nvidia","geforce"];t<n.length;t++){var i=n[t];if(e.includes(i))return i}},R=function(t){return n(void 0,void 0,void 0,(function(){var n,r,o,s,a,c,h,p,m,f,v,_,y,S,b,C,R,A,w,I,P,D,O,k,N,M;return i(this,(function(i){switch(i.label){case 0:if(!(n=x(t)))return[2];r="".concat(g?"m":"d","-").concat(n).concat(d?"-ipad":"",".json"),o=e[r]=null!==(M=e[r])&&void 0!==M?M:T(r),i.label=1;case 1:return i.trys.push([1,3,,4]),[4,o];case 2:return s=i.sent(),[3,4];case 3:if((a=i.sent())instanceof u)throw a;return[2];case 4:if(c=function(e){var t,n=(e=e.replace(/\\([^)]+\\)/,"")).match(/\\d+/)||e.match(/(\\W|^)([A-Za-z]{1,3})(\\W|$)/g);return null!==(t=null==n?void 0:n.join("").replace(/\\W|amd/g,""))&&void 0!==t?t:""}(t),(h=s.filter((function(e){return e[1]===c}))).length||(h=s.filter((function(e){return e[0].includes(t)}))),0===(p=h.length))return[2];for(m=p>1?h.map((function(e){return[e,l(t,e[0])]})).sort((function(e,t){return e[1]-t[1]}))[0][0]:h[0],f=m[0],v=m[3],_=Number.MAX_VALUE,S=window.devicePixelRatio,b=E.width*S*E.height*S,C=0,R=v;C<R.length;C++)A=R[C],w=A[0],I=A[1],P=w*I,(D=Math.abs(b-P))<_&&(_=D,y=A);return y?(k=(O=y)[2],N=O[3],[2,[_,k,f,N]]):[2]}}))}))},A=function(e,t,n,i,r){return{device:r,fps:i,gpu:n,isMobile:g,tier:e,type:t}},I="",C)C=o(C),w=[C];else{if(!(P=v||function(e,t){void 0===t&&(t=!1);var n={alpha:!1,antialias:!1,depth:!1,failIfMajorPerformanceCaveat:t,powerPreference:"high-performance",stencil:!1};e&&delete n.powerPreference;var i=window.document.createElement("canvas"),r=i.getContext("webgl",n)||i.getContext("experimental-webgl",n);return null!=r?r:void 0}(null==a?void 0:a.isSafari12,y)))return[2,A(0,"WEBGL_UNSUPPORTED")];if((D=P.getExtension("WEBGL_debug_renderer_info"))&&(C=P.getParameter(D.UNMASKED_RENDERER_WEBGL)),!C)return[2,A(1,"FALLBACK")];I=C,C=o(C),w=function(e,t,n){return"apple gpu"===t?function(e,t,n){if(!n)return[t];var i,r=function(e){var t=e.createShader(35633),n=e.createShader(35632),i=e.createProgram();if(n&&t&&i){e.shaderSource(t,"\\n    precision highp float;\\n    attribute vec3 aPosition;\\n    varying float vvv;\\n    void main() {\\n      vvv = 0.31622776601683794;\\n      gl_Position = vec4(aPosition, 1.0);\\n    }\\n  "),e.shaderSource(n,"\\n    precision highp float;\\n    varying float vvv;\\n    void main() {\\n      vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;\\n      enc = fract(enc);\\n      enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);\\n      gl_FragColor = enc;\\n    }\\n  "),e.compileShader(t),e.compileShader(n),e.attachShader(i,t),e.attachShader(i,n),e.linkProgram(i),e.detachShader(i,t),e.detachShader(i,n),e.deleteShader(t),e.deleteShader(n),e.useProgram(i);var r=e.createBuffer();e.bindBuffer(34962,r),e.bufferData(34962,new Float32Array([-1,-1,0,3,-1,0,-1,3,0]),35044);var o=e.getAttribLocation(i,"aPosition");e.vertexAttribPointer(o,3,5126,!1,0,0),e.enableVertexAttribArray(o),e.clearColor(1,1,1,1),e.clear(16384),e.viewport(0,0,1,1),e.drawArrays(4,0,3);var s=new Uint8Array(4);return e.readPixels(0,0,1,1,6408,5121,s),e.deleteProgram(i),e.deleteBuffer(r),s.join("")}}(e),o="801621810",s="8016218135",d="80162181161",c=(null==a?void 0:a.isIpad)?[["a7",d,12],["a8",s,15],["a8x",s,15],["a9",s,15],["a9x",s,15],["a10",s,15],["a10x",s,15],["a12",o,15],["a12x",o,15],["a12z",o,15],["a14",o,15],["m1",o,15]]:[["a7",d,12],["a8",s,12],["a9",s,15],["a10",s,15],["a11",o,15],["a12",o,15],["a13",o,15],["a14",o,15]];return"80162181255"===r?i=c.filter((function(e){return e[2]>=14})):(i=c.filter((function(e){return e[1]===r}))).length||(i=c),i.map((function(e){var t=e[0];return"apple ".concat(t," gpu")}))}(e,t,n):[t]}(P,C,g)}return[4,Promise.all(w.map(R))];case 1:if(!(O=H.sent().filter(h).sort((function(e,t){var n=e[0],i=void 0===n?Number.MAX_VALUE:n,r=e[1],o=t[0],s=void 0===o?Number.MAX_VALUE:o,a=t[1];return i===s?r-a:i-s}))).length)return[2,(k=r.find((function(e){return C.includes(e)})))?A(0,"BLOCKLISTED",k):A(1,"FALLBACK","".concat(C," (").concat(I,")"))];if(N=O[0],M=N[1],L=N[2],F=N[3],-1===M)return[2,A(0,"BLOCKLISTED",L,M,F)];for(j=g?c:m,V=0,U=0;U<j.length;U++)M>=j[U]&&(V=U);return[2,A(V,"BENCHMARK",L,M,F)]}}))}))},Object.defineProperty(e,"__esModule",{value:!0})}(t)},622:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["qualcomm adreno 540","540",0,[[1919,1279,19]]],["qualcomm adreno 540 gpu","540",0,[[1919,1279,24]]],["qualcomm adreno 618 gpu","618",0,[[1920,1080,20]]],["qualcomm adreno 630 gpu","630",0,[[1920,1080,21]]],["qualcomm adreno 680 gpu","680",0,[[2880,1920,25]]],["qualcomm adreno 685 gpu","685",0,[[1920,1080,28]]],["qualcomm adreno 690 gpu","690",0,[[1920,1280,28]]],["qualcomm adreno 8cx gen 3","8",0,[[1920,1080,22]]]]\')},183:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["amd ???","",0,[[1920,1080,144]]],["amd [amd/ati] fiji [radeon r9 fury / nano series]","9",0,[[1920,1200,162]]],["amd 15dd","15",0,[[3840,2160,14]]],["amd 66af:f1","66",0,[[3840,2160,181]]],["amd 67df:c4","67",0,[[2560,1600,59]]],["amd 67e8:00","67",0,[[1920,1080,59]]],["amd 67ef:c5","67",0,[[1920,1080,52]]],["amd 67ef:cf","67",0,[[1920,1080,74]]],["amd 67ef:e7","67",0,[[1920,1080,60]]],["amd 67ff:08","67",0,[[1920,1200,31]]],["amd 694c:c0","694",0,[[1919,1080,28],[3840,2160,12]]],["amd 694e:c0","694",0,[[3840,2160,27]]],["amd 6980:00","6980",0,[[1920,1200,59]]],["amd 699f:c1","699",0,[[1920,1080,48]]],["amd 7310:00","7310",0,[[3840,2160,55]]],["amd 731f:c1","731",0,[[1920,1080,60]]],["amd 7340:c5","7340",0,[[2560,1600,44]]],["amd advanced micro devices [amd] nee ati device","nee",0,[[1920,1200,157]]],["amd asus amd radeon r9-990x","9",0,[[1920,1080,60]]],["amd asus eah5450","5450",0,[[1600,900,12],[1680,1050,11],[1920,1200,12]]],["amd asus eah5670","5670",0,[[1920,1080,28]]],["amd asus eah6450","6450",0,[[1920,1080,12]]],["amd asus hd7750","7750",0,[[1920,1080,105]]],["amd asus hd7770","7770",0,[[1680,1050,60]]],["amd asus hd7850","7850",0,[[1920,1080,60]]],["amd asus hd7970","7970",0,[[3840,2160,50]]],["amd asus hd8760","8760",0,[[1680,1050,59]]],["amd asus r5 230","5",0,[[1920,1080,12]]],["amd asus r7 240","7",0,[[1600,900,28],[1920,1080,31]]],["amd asus r7 250","7",0,[[1920,1080,59]]],["amd asus r7 250x","7",0,[[1920,1080,60]]],["amd asus r7 265","7",0,[[1920,1080,60]]],["amd asus r7 360","7",0,[[1920,1080,78]]],["amd asus r7 370","7",0,[[1600,900,60],[1920,1080,143]]],["amd asus r9 270","9",0,[[1600,900,60]]],["amd asus r9 280x","9",0,[[1920,1080,146]]],["amd asus r9 295x2","9",0,[[2560,1440,93]]],["amd asus r9 380","9",0,[[1920,1080,60]]],["amd asus r9 390","9",0,[[1920,1080,235]]],["amd asus radeon r7 250","7",0,[[800,638,60]]],["amd asus radeon r7 260x","7",0,[[2560,1080,65]]],["amd asus radeon r9 270x","9",0,[[1024,768,85],[1920,1080,60]]],["amd asus radeon r9 280","9",0,[[1920,1080,60]]],["amd asus radeon rx 460","460",0,[[1360,768,104]]],["amd asus radeon rx 470","470",0,[[1920,1080,60]]],["amd asus radeon rx 480","480",0,[[1920,1080,124]]],["amd asus radeon rx 550","550",0,[[1440,900,60],[1920,1080,49]]],["amd asus radeon rx 5500 xt","5500",0,[[1920,1080,325]]],["amd asus radeon rx 560","560",0,[[1360,768,60],[1920,1080,85]]],["amd asus radeon rx 570","570",0,[[1600,900,202],[1920,1080,60]]],["amd asus radeon rx 5700","5700",0,[[1920,1080,327]]],["amd asus radeon rx 5700 xt","5700",0,[[1920,1080,224],[2560,1440,60]]],["amd asus radeon rx 580","580",0,[[1920,1080,177],[2560,1080,60]]],["amd asus radeon rx vega","rx",0,[[2560,1440,117]]],["amd asus rx 6600xt macos","6600",0,[[3840,2160,60]]],["amd ati mobility radeon hd 5870","5870",0,[[1920,1200,19]]],["amd baffin amd radeon rx 560","560",0,[[1920,1080,60]]],["amd barco mxrt 5600","5600",0,[[2800,2100,30]]],["amd carrizo 9874","9874",0,[[1920,1200,11]]],["amd cezanne","",0,[[1920,1080,162]]],["amd device","",0,[[1920,1080,188]]],["amd ellesmere radeon rx 570","570",0,[[1920,1080,60]]],["amd embedded radeon e9171","9171",0,[[3840,2160,26]]],["amd embedded radeon e9173","9173",0,[[3840,2160,16]]],["amd firepro 2270","2270",0,[[1245,768,19],[1920,1200,9]]],["amd firepro 3800 graphics adapter","3800",0,[[1920,1080,18]]],["amd firepro d300","300",0,[[1920,1080,60],[2560,1440,60],[3440,1440,60],[3840,2160,30]]],["amd firepro d500","500",0,[[1600,900,60],[2560,1440,59],[2560,1600,87],[3840,2160,57]]],["amd firepro d700","700",0,[[2048,1152,59],[2560,1440,59]]],["amd firepro m2000","2000",0,[[1600,900,28],[1920,1080,24]]],["amd firepro m4000","4000",0,[[1920,1080,57]]],["amd firepro m4000 mobility pro","4000",0,[[1920,1080,57]]],["amd firepro m4100","4100",0,[[1920,1080,58]]],["amd firepro m4100 firegl v","4100",0,[[1920,1080,24]]],["amd firepro m4150","4150",0,[[1600,900,51]]],["amd firepro m4170","4170",0,[[1920,1080,43]]],["amd firepro m5100","5100",0,[[1920,1080,60]]],["amd firepro m5100 firegl v","5100",0,[[1920,1080,29]]],["amd firepro m5950","5950",0,[[1920,1080,42]]],["amd firepro m6000 mobility pro","6000",0,[[1600,900,33],[1920,1080,60]]],["amd firepro m6100","6100",0,[[1920,1080,60]]],["amd firepro m6100 firegl v","6100",0,[[1920,1080,60]]],["amd firepro m7820","7820",0,[[1680,1050,44]]],["amd firepro r5000","5000",0,[[1920,1080,60]]],["amd firepro s10000","10000",0,[[2560,1440,58]]],["amd firepro s7150","7150",0,[[1440,900,70]]],["amd firepro s9000","9000",0,[[1920,1080,60]]],["amd firepro s9050","9050",0,[[1920,1080,101]]],["amd firepro v graphics adapter","v",0,[[1680,1050,53],[1920,1080,54]]],["amd firepro v3800","3800",0,[[1280,992,28],[1680,1050,25]]],["amd firepro v3900","3900",0,[[1920,1080,28],[2560,1440,26]]],["amd firepro v4800","4800",0,[[1440,900,37],[1920,1080,50]]],["amd firepro v4800 graphics adapter","4800",0,[[1920,1080,46]]],["amd firepro v4900","4900",0,[[1600,900,76],[1920,1080,53]]],["amd firepro v4900 graphics adapter","4900",0,[[1920,1200,40]]],["amd firepro v5800","5800",0,[[1366,768,60],[1920,1200,62]]],["amd firepro v5800 graphics adapter","5800",0,[[1360,768,83],[1280,1024,58]]],["amd firepro v5900","5900",0,[[1920,1080,53],[1920,1200,58],[3440,1440,34]]],["amd firepro v5900 graphics adapter","5900",0,[[1600,1200,54],[1920,1080,65]]],["amd firepro v7800 graphics adapter","7800",0,[[1680,1050,60],[1920,1080,60]]],["amd firepro v7900","7900",0,[[1920,1080,135],[1920,1200,60],[2560,1080,124]]],["amd firepro v7900 graphics adapter","7900",0,[[1920,1080,58]]],["amd firepro v8800","8800",0,[[2560,1440,58]]],["amd firepro w2100","2100",0,[[1920,1080,33]]],["amd firepro w4100","4100",0,[[1920,1080,55]]],["amd firepro w4100 graphics adapter","4100",0,[[1600,1200,70],[1920,1080,56]]],["amd firepro w4150m firegl v","4150",0,[[1920,1080,45]]],["amd firepro w4170m","4170",0,[[1366,768,11]]],["amd firepro w4190m","4190",0,[[1920,1080,42]]],["amd firepro w4300","4300",0,[[1280,1024,116]]],["amd firepro w5000","5000",0,[[1920,1080,60],[2560,1600,75]]],["amd firepro w5000 graphics adapter","5000",0,[[1280,1024,60],[1920,1080,117]]],["amd firepro w5100","5100",0,[[1920,1080,60],[1920,1200,59]]],["amd firepro w5100 graphics adapter","5100",0,[[1920,1080,89],[3840,2160,29]]],["amd firepro w5130m","5130",0,[[1920,1080,60]]],["amd firepro w5170m","5170",0,[[1920,1080,84],[2560,1440,51]]],["amd firepro w600","600",0,[[3840,2160,25]]],["amd firepro w6150m","6150",0,[[1920,1080,45]]],["amd firepro w7000","7000",0,[[1920,1080,60],[1920,1200,136]]],["amd firepro w7000 graphics adapter","7000",0,[[1920,1080,60]]],["amd firepro w7100","7100",0,[[1920,1080,60],[1920,1200,141]]],["amd firepro w7100 graphics adapter","7100",0,[[1200,900,60]]],["amd firepro w7170m","7170",0,[[1920,1080,60]]],["amd firepro w8000","8000",0,[[1920,1200,110],[2560,1440,60]]],["amd firepro w8100","8100",0,[[1920,1080,60],[1920,1200,60]]],["amd firepro w8100 graphic adapter","8100",0,[[1280,1024,113]]],["amd firepro w9100","9100",0,[[1920,1080,60],[1920,1200,188],[2560,1600,59]]],["amd gigabyte radeon rx 580","580",0,[[1920,1080,60]]],["amd gigabyte vega 64 macos","64",0,[[1920,1080,60]]],["amd hd7950 martin rev.","7950",0,[[2560,1440,101]]],["amd hd7950 martin ver.","7950",0,[[2560,1440,104]]],["amd kamen rider black rx","rx",0,[[1920,1080,60]]],["amd kaveri","",0,[[1920,1080,9]]],["amd madison [mobility radeon hd 5650 / 6530m/6550m]","5650",0,[[1366,768,43]]],["amd matrox c680 pcie x16","680",0,[[2560,1440,49]]],["amd matrox c900 pcie x16","900",0,[[5760,3240,9]]],["amd metal","",0,[[1920,1080,120]]],["amd mobility radeon hd 4250","4250",0,[[963,722,26]]],["amd mobility radeon hd 5000","5000",0,[[1366,768,47]]],["amd mobility radeon hd 5400","5400",0,[[1366,768,24]]],["amd mobility radeon hd 5430","5430",0,[[1600,900,15],[1920,1080,60]]],["amd mobility radeon hd 5470","5470",0,[[1366,768,24]]],["amd mobility radeon hd 5570","5570",0,[[1920,1080,27]]],["amd mobility radeon hd 5730 / 6570m","5730",0,[[1366,768,58]]],["amd mobility radeon hd 5850","5850",0,[[1600,900,55]]],["amd mobility radeon hd 5870","5870",0,[[1600,900,64],[1920,1200,53]]],["amd msi / amd rx 560","560",0,[[1920,1080,60]]],["amd msi / amd rx 560 4g","560",0,[[1920,1080,60]]],["amd msi baffin rx650","650",0,[[1920,1080,399]]],["amd msi rx560","560",0,[[1920,1080,343]]],["amd msi rx650","650",0,[[1920,1080,60]]],["amd mxgpu","",0,[[1920,1012,67],[1920,1080,106]]],["amd navi 10 5700 xt","10",0,[[3840,2160,60]]],["amd opal xt/gl","xt",0,[[1366,768,60]]],["amd park [mobility radeon hd 5430","5430",0,[[1280,720,11]]],["amd picasso","",0,[[1920,1080,48]]],["amd pitcairn pro radeon hd 7850","7850",0,[[1920,1080,60]]],["amd powercolor radeon r9 280","9",0,[[1920,1080,60]]],["amd r9 270x devil","9",0,[[1920,1080,60]]],["amd r9 280x dual-x","9",0,[[1920,1080,60]]],["amd r9 380","9",0,[[2560,1440,119]]],["amd r9 xxx","9",0,[[1920,1080,60]]],["amd radeon","",0,[[1920,1080,299],[3440,1440,60]]],["amd radeon 500","500",0,[[1920,1080,73]]],["amd radeon 520","520",0,[[1920,1080,35],[2560,1440,29]]],["amd radeon 530","530",0,[[1366,768,60],[1920,1080,30]]],["amd radeon 535","535",0,[[1920,1080,35]]],["amd radeon 535dx","535",0,[[1366,768,31],[1920,1080,37]]],["amd radeon 540","540",0,[[1920,1080,38]]],["amd radeon 540 / rx 540x/550/550x","540",0,[[2560,1440,88]]],["amd radeon 540x","540",0,[[1920,1080,59]]],["amd radeon 550","550",0,[[1920,1080,115]]],["amd radeon 550x","550",0,[[1920,1080,28]]],["amd radeon 610","610",0,[[1920,1080,29]]],["amd radeon 620","620",0,[[1920,1080,18]]],["amd radeon 625","625",0,[[1366,768,55],[1920,1080,47]]],["amd radeon 630","630",0,[[1920,1080,29]]],["amd radeon 6600m and 6700m","6600",0,[[1366,768,36],[1440,900,60]]],["amd radeon 6800","6800",0,[[3440,1440,100]]],["amd radeon 7500m/7600m","7500",0,[[1366,768,37]]],["amd radeon 7950 x2","7950",0,[[2560,1440,174]]],["amd radeon d700","700",0,[[2560,1440,120]]],["amd radeon e6460","6460",0,[[1600,1200,13]]],["amd radeon e6760","6760",0,[[1200,900,54],[1920,1080,42]]],["amd radeon e8860","8860",0,[[1920,1200,27],[2560,1374,88]]],["amd radeon e8870","8870",0,[[1920,1080,81]]],["amd radeon e8870mxm","8870",0,[[1920,1080,60]]],["amd radeon e9260","9260",0,[[1680,1050,60],[3840,2160,38]]],["amd radeon e9550","9550",0,[[1680,1050,60],[3840,2160,58]]],["amd radeon embedded e9560","9560",0,[[1920,1200,60]]],["amd radeon fury","",0,[[1920,1080,60]]],["amd radeon fury x","x",0,[[1920,1080,60],[2560,1440,144]]],["amd radeon hd - firepro d300","300",0,[[1920,1080,60]]],["amd radeon hd - firepro d300 opengl engine","300",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd - firepro d500 opengl engine","500",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd - firepro d700 opengl engine","700",0,[[3840,2160,52]]],["amd radeon hd 2600 xt","2600",1,[[2560,1600,-1]]],["amd radeon hd 5000","5000",0,[[1920,1080,8]]],["amd radeon hd 5400","5400",0,[[1920,1080,12]]],["amd radeon hd 5450","5450",0,[[1920,1080,13]]],["amd radeon hd 5470","5470",0,[[1280,1024,16]]],["amd radeon hd 5500","5500",0,[[1920,1080,27]]],["amd radeon hd 5570","5570",0,[[1920,1080,60],[2048,1152,31]]],["amd radeon hd 5600","5600",0,[[1920,1080,56]]],["amd radeon hd 5650","5650",0,[[1366,768,53]]],["amd radeon hd 5670","5670",1,[[1920,1080,-1],[2560,1440,-1]]],["amd radeon hd 5670 opengl engine","5670",1,[[2560,1440,-1]]],["amd radeon hd 5700","5700",0,[[1920,1080,59]]],["amd radeon hd 5730","5730",0,[[1366,768,46],[1680,1050,40]]],["amd radeon hd 5750","5750",1,[[1920,1080,-1],[1920,1200,-1],[2560,1440,-1]]],["amd radeon hd 5750 opengl engine","5750",1,[[2560,1440,-1]]],["amd radeon hd 5770","5770",0,[[1776,1000,43],[1920,1080,59]]],["amd radeon hd 5800","5800",0,[[1366,768,60],[1920,1200,102]]],["amd radeon hd 5850","5850",0,[[1920,1080,60]]],["amd radeon hd 5870","5870",0,[[1280,960,75],[1920,1080,60],[2048,1280,60]]],["amd radeon hd 5870m","5870",0,[[2560,1080,31]]],["amd radeon hd 5970","5970",0,[[1360,768,60],[1920,1080,60]]],["amd radeon hd 6230","6230",0,[[1366,768,13]]],["amd radeon hd 6250","6250",0,[[1280,800,8],[1366,768,8]]],["amd radeon hd 6290","6290",1,[[1366,768,-1]]],["amd radeon hd 6300m","6300",1,[[1366,768,-1]]],["amd radeon hd 6310","6310",1,[[1366,768,-1]]],["amd radeon hd 6320","6320",1,[[1366,768,-1]]],["amd radeon hd 6350","6350",0,[[1280,1024,18],[1920,1080,14]]],["amd radeon hd 6370d","6370",0,[[1920,1080,14]]],["amd radeon hd 6370m","6370",0,[[1366,768,25]]],["amd radeon hd 6380g","6380",0,[[1366,768,19]]],["amd radeon hd 6400","6400",0,[[1920,1080,13]]],["amd radeon hd 6400m","6400",0,[[1366,768,28]]],["amd radeon hd 6400m/7400m","6400",0,[[1366,768,28]]],["amd radeon hd 6410d","6410",0,[[1920,1080,11]]],["amd radeon hd 6450","6450",0,[[1920,1080,14]]],["amd radeon hd 6450 / r5 230","6450",0,[[1440,900,12]]],["amd radeon hd 6450 230","6450",0,[[1920,1080,15]]],["amd radeon hd 6470m","6470",0,[[1366,768,27],[1600,900,21]]],["amd radeon hd 6470m/7400m","6470",0,[[1366,768,44]]],["amd radeon hd 6480g","6480",0,[[1280,768,19],[1366,768,27],[1600,900,18]]],["amd radeon hd 6490m","6490",1,[[1366,768,-1],[1440,900,-1],[1680,1050,-1]]],["amd radeon hd 6500","6500",0,[[1920,1080,25]]],["amd radeon hd 6500m/5600","6500",0,[[1920,1080,27]]],["amd radeon hd 6510","6510",0,[[1600,900,32]]],["amd radeon hd 6520g","6520",0,[[1366,768,21],[1600,900,20]]],["amd radeon hd 6530d","6530",0,[[1366,768,31],[1440,900,36],[1920,1080,24]]],["amd radeon hd 6540","6540",0,[[1600,1200,13]]],["amd radeon hd 6550d","6550",0,[[1920,1080,28]]],["amd radeon hd 6570","6570",0,[[1920,1080,52],[2560,1440,17]]],["amd radeon hd 6620g","6620",0,[[1360,768,43],[1366,768,28]]],["amd radeon hd 6630m","6630",1,[[1366,768,-1],[1600,900,-1],[1920,1080,-1]]],["amd radeon hd 6630m/6650m/6750m/7670m/7690m","6630",1,[[1366,768,-1],[1920,1080,-1]]],["amd radeon hd 6650m","6650",0,[[1366,768,51],[1600,900,31]]],["amd radeon hd 6670","6670",0,[[1920,1080,55]]],["amd radeon hd 6700","6700",0,[[1920,1080,56]]],["amd radeon hd 6700 green","6700",0,[[1360,768,89]]],["amd radeon hd 6700m/7700m/7900m","6700",0,[[1366,768,59]]],["amd radeon hd 6730m/6770m","6730",0,[[1366,768,58],[1920,1080,46]]],["amd radeon hd 6730m/6770m/7690m xt","6730",0,[[1920,1080,48]]],["amd radeon hd 6750","6750",0,[[1440,900,72],[1920,1080,60]]],["amd radeon hd 6750m","6750",1,[[1440,900,-1],[1920,1080,-1],[1920,1200,-1]]],["amd radeon hd 6770","6770",0,[[1920,1080,60]]],["amd radeon hd 6770m","6770",1,[[1440,900,-1],[2560,1440,-1]]],["amd radeon hd 6770m opengl engine","6770",1,[[2560,1440,-1]]],["amd radeon hd 6790","6790",0,[[1920,1080,59]]],["amd radeon hd 6800","6800",0,[[1280,1024,89],[1920,1080,60]]],["amd radeon hd 6800m","6800",0,[[1600,900,18],[1920,1080,40]]],["amd radeon hd 6850","6850",0,[[1920,1080,59],[2560,1600,54]]],["amd radeon hd 6870","6870",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd 6900","6900",0,[[1920,1080,60]]],["amd radeon hd 6900m","6900",0,[[1920,1080,60]]],["amd radeon hd 6950","6950",0,[[1680,1050,60],[1920,1080,41]]],["amd radeon hd 6970","6970",0,[[1920,1080,60]]],["amd radeon hd 6970m","6970",1,[[2560,1440,-1]]],["amd radeon hd 6970m opengl engine","6970",1,[[2560,1440,-1]]],["amd radeon hd 6990","6990",0,[[1920,1080,60]]],["amd radeon hd 7000","7000",0,[[1920,1080,24]]],["amd radeon hd 7290","7290",0,[[1366,768,9]]],["amd radeon hd 7310","7310",0,[[1366,768,14]]],["amd radeon hd 7340","7340",0,[[1366,768,17],[1920,1080,10]]],["amd radeon hd 7340g","7340",0,[[1366,768,15]]],["amd radeon hd 7340m","7340",0,[[1366,768,15]]],["amd radeon hd 7350","7350",0,[[1920,1080,13]]],["amd radeon hd 7400","7400",0,[[1920,1080,18]]],["amd radeon hd 7400g","7400",0,[[963,768,31]]],["amd radeon hd 7400m","7400",0,[[1366,768,44]]],["amd radeon hd 7420g","7420",0,[[1366,768,28],[1600,900,26]]],["amd radeon hd 7450","7450",0,[[1920,1080,15]]],["amd radeon hd 7450a","7450",0,[[1920,1080,15]]],["amd radeon hd 7450m","7450",0,[[1366,768,30]]],["amd radeon hd 7470","7470",0,[[1680,1050,22],[1920,1080,144]]],["amd radeon hd 7470m","7470",0,[[1366,768,31],[1600,900,23]]],["amd radeon hd 7480d","7480",0,[[1280,1024,25],[1920,1080,24],[1920,1200,18]]],["amd radeon hd 7500","7500",0,[[1366,696,49],[1366,768,49]]],["amd radeon hd 7500g","7500",0,[[1366,768,26]]],["amd radeon hd 7500m/7600m","7500",0,[[1366,768,46]]],["amd radeon hd 7520g","7520",0,[[1366,768,33]]],["amd radeon hd 7520g + hd 7400m dual","7520",0,[[1366,768,34]]],["amd radeon hd 7520g + hd 7600m dual","7520",0,[[1366,768,31],[1600,900,41]]],["amd radeon hd 7540d","7540",0,[[1024,768,55],[1280,1024,44],[1920,1080,22]]],["amd radeon hd 7540d + hd 6670 dual","7540",0,[[1280,1024,36]]],["amd radeon hd 7550m/7650m","7550",0,[[1366,768,57]]],["amd radeon hd 7560d","7560",0,[[1920,1080,34]]],["amd radeon hd 7560d + hd 6570 dual","7560",0,[[1680,1050,44]]],["amd radeon hd 7560d + hd 6670 dual","7560",0,[[800,638,60]]],["amd radeon hd 7570","7570",0,[[1024,768,72],[1920,1080,52]]],["amd radeon hd 7570m","7570",0,[[1366,768,35]]],["amd radeon hd 7570m/hd 7670m","7570",0,[[1366,768,50],[1600,900,29]]],["amd radeon hd 7600","7600",0,[[1920,1080,60]]],["amd radeon hd 7600a","7600",0,[[1920,1080,28]]],["amd radeon hd 7600g","7600",0,[[1366,768,29]]],["amd radeon hd 7600g + 7500m/7600m dual","7600",0,[[1366,768,19]]],["amd radeon hd 7600g + hd 8670m dual","7600",0,[[1366,768,29]]],["amd radeon hd 7600g + hd dual","7600",0,[[1366,768,20]]],["amd radeon hd 7600m","7600",0,[[1366,768,56]]],["amd radeon hd 7600m/7700m","7600",0,[[1366,768,31]]],["amd radeon hd 7610m","7610",0,[[1366,768,43]]],["amd radeon hd 7620g","7620",0,[[1366,768,22],[1920,1080,19]]],["amd radeon hd 7640g","7640",0,[[1366,768,38]]],["amd radeon hd 7640g + 7470m dual","7640",0,[[1366,768,32]]],["amd radeon hd 7640g + 7600m dual","7640",0,[[1366,768,23]]],["amd radeon hd 7640g + 7670m dual","7640",0,[[1600,900,15]]],["amd radeon hd 7640g + 8500m dual","7640",0,[[1366,768,35]]],["amd radeon hd 7640g + hd 7400m dual","7640",0,[[1366,768,37]]],["amd radeon hd 7640g + hd 7500 dual","7640",0,[[1366,768,35]]],["amd radeon hd 7640g + hd 7670m dual","7640",0,[[1366,768,34]]],["amd radeon hd 7640g + hd 8500m dual","7640",0,[[1366,768,40]]],["amd radeon hd 7640g + hd 8570m dual","7640",0,[[1366,768,31]]],["amd radeon hd 7650a","7650",0,[[1680,1050,43],[1920,1080,15]]],["amd radeon hd 7650m","7650",0,[[1366,768,41],[1600,900,45]]],["amd radeon hd 7660d","7660",0,[[1680,1050,40],[1920,1008,60],[1920,1080,38]]],["amd radeon hd 7660d + hd 6570 dual","7660",0,[[1200,900,32]]],["amd radeon hd 7660d + hd 6670 dual","7660",0,[[1360,768,57],[1920,1080,53]]],["amd radeon hd 7660g","7660",0,[[1366,768,44],[1600,900,41],[1920,1080,34],[1920,1200,27]]],["amd radeon hd 7660g + 7600m dual","7660",0,[[1366,768,53],[1600,900,45]]],["amd radeon hd 7660g + 7670m dual","7660",0,[[1366,768,52]]],["amd radeon hd 7660g + 8670m dual","7660",0,[[1600,900,46]]],["amd radeon hd 7660g + hd 7600m dual","7660",0,[[1366,768,50]]],["amd radeon hd 7660g + hd 7670m dual","7660",0,[[1366,768,35]]],["amd radeon hd 7660g + hd 8600m dual","7660",0,[[1600,900,29]]],["amd radeon hd 7670","7670",0,[[1920,1080,39]]],["amd radeon hd 7670m","7670",0,[[1366,768,49],[1920,1080,36]]],["amd radeon hd 7700","7700",0,[[1400,1050,45],[1920,1080,60]]],["amd radeon hd 7700m","7700",0,[[1920,1080,54]]],["amd radeon hd 7730m","7730",0,[[1920,1080,57]]],["amd radeon hd 7750","7750",0,[[1280,1024,60],[1600,900,60],[1400,1050,98],[1920,1080,60],[3840,2160,23]]],["amd radeon hd 7750 / r7 250e","7750",0,[[2560,1080,69]]],["amd radeon hd 7750m","7750",0,[[1680,1050,57]]],["amd radeon hd 7770","7770",0,[[1920,1080,60]]],["amd radeon hd 7770 / r7 250x","7770",0,[[1680,1050,78]]],["amd radeon hd 7770 ghz","7770",0,[[1920,1080,78]]],["amd radeon hd 7790","7790",0,[[1920,1080,16]]],["amd radeon hd 7790 / r7 360 / r9 260/360","7790",0,[[1280,1024,131]]],["amd radeon hd 7800","7800",0,[[1920,1080,60]]],["amd radeon hd 7800m","7800",0,[[1920,1080,57]]],["amd radeon hd 7850","7850",0,[[1920,1080,60]]],["amd radeon hd 7850 / r7 265 / r9 270 1024sp","7850",0,[[1280,1024,87]]],["amd radeon hd 7870","7870",0,[[1920,1080,120],[2560,1440,60],[2560,1600,114],[3840,2160,30]]],["amd radeon hd 7870 ghz","7870",0,[[1920,1080,75]]],["amd radeon hd 7870 xt","7870",0,[[1920,1080,57],[3840,2160,53]]],["amd radeon hd 7870m","7870",0,[[1920,1080,22],[2732,1536,40]]],["amd radeon hd 7900","7900",0,[[2560,1600,59]]],["amd radeon hd 7950","7950",0,[[1920,1080,50]]],["amd radeon hd 7950 / r9 280","7950",0,[[1920,1080,59]]],["amd radeon hd 7950 oem / r9 280","7950",0,[[1920,1080,60]]],["amd radeon hd 7970","7970",0,[[1920,1080,60]]],["amd radeon hd 7970 / r9 280x","7970",0,[[1920,1080,193]]],["amd radeon hd 7970m","7970",0,[[1366,768,60],[1920,1080,60]]],["amd radeon hd 7970x/8970 280x","7970",0,[[1920,1080,60]]],["amd radeon hd 7990","7990",0,[[1920,1080,60],[5120,2880,63]]],["amd radeon hd 7xxx","7",0,[[1920,1080,60]]],["amd radeon hd 8180","8180",0,[[1366,768,10]]],["amd radeon hd 8200 / r3","8200",0,[[1366,768,21],[1600,900,13],[1680,1050,13]]],["amd radeon hd 8210","8210",0,[[1366,768,18]]],["amd radeon hd 8240","8240",0,[[1600,900,17]]],["amd radeon hd 8240 / r3","8240",0,[[1366,768,14]]],["amd radeon hd 8250","8250",0,[[1366,768,14],[1920,1200,10]]],["amd radeon hd 8280","8280",0,[[1600,900,60]]],["amd radeon hd 8280 / r3","8280",0,[[1366,768,22]]],["amd radeon hd 8280e","8280",0,[[2880,1620,6]]],["amd radeon hd 8330","8330",0,[[1366,768,24]]],["amd radeon hd 8350","8350",0,[[1920,1080,57]]],["amd radeon hd 8350g","8350",0,[[1366,768,18]]],["amd radeon hd 8370d","8370",0,[[1366,768,60],[1280,1024,26],[1920,1080,22]]],["amd radeon hd 8400","8400",0,[[1366,768,30],[1920,1080,16]]],["amd radeon hd 8400 / r3","8400",0,[[1360,768,19],[1366,768,22],[1920,1080,12]]],["amd radeon hd 8400e","8400",0,[[1680,1050,17],[1920,1080,16],[1920,1200,14]]],["amd radeon hd 8410g","8410",0,[[1366,768,32]]],["amd radeon hd 8450g","8450",0,[[1366,768,23]]],["amd radeon hd 8450g + hd 8750m dual","8450",0,[[1366,768,21]]],["amd radeon hd 8470","8470",0,[[1920,1080,17]]],["amd radeon hd 8470 + 7660d dual","8470",0,[[1920,1080,60]]],["amd radeon hd 8470d","8470",0,[[1280,1024,44],[1920,1080,21]]],["amd radeon hd 8470d + hd 6450 dual","8470",0,[[1600,900,37]]],["amd radeon hd 8490","8490",0,[[1920,1080,18],[1920,1200,20]]],["amd radeon hd 8500m","8500",0,[[1366,768,41],[1920,1080,19]]],["amd radeon hd 8500m/8700m","8500",0,[[1920,1080,30]]],["amd radeon hd 8510g","8510",0,[[1366,768,29],[1920,1080,17]]],["amd radeon hd 8550","8550",0,[[1920,1080,25]]],["amd radeon hd 8550g","8550",0,[[1366,768,34],[1600,900,41],[1920,1080,34]]],["amd radeon hd 8550g + 8500m dual","8550",0,[[1366,768,42]]],["amd radeon hd 8550g + 8600 dual","8550",0,[[1920,1080,27]]],["amd radeon hd 8550g + hd 8570m dual","8550",0,[[1366,768,32]]],["amd radeon hd 8550g + hd 8600 dual","8550",0,[[1366,768,60]]],["amd radeon hd 8550g + hd 8750m dual","8550",0,[[1366,768,37]]],["amd radeon hd 8550g + r5 m230 dual","8550",0,[[1366,768,29]]],["amd radeon hd 8570","8570",0,[[1280,1024,60],[1680,1050,54],[1920,1080,50]]],["amd radeon hd 8570 / r5 430 / r7 240 / radeon 520","8570",0,[[1920,1080,25]]],["amd radeon hd 8570d","8570",0,[[1920,1080,16]]],["amd radeon hd 8570d + r7 240 dual","8570",0,[[1920,1080,45]]],["amd radeon hd 8570m","8570",0,[[1366,768,40]]],["amd radeon hd 8600","8600",0,[[1366,768,41]]],["amd radeon hd 8600m","8600",0,[[1366,768,42],[1920,1080,14]]],["amd radeon hd 8610g","8610",0,[[1366,768,31],[1920,1080,16]]],["amd radeon hd 8610g + 8600m dual","8610",0,[[1366,768,22]]],["amd radeon hd 8610g + hd 8600m dual","8610",0,[[1366,768,41]]],["amd radeon hd 8610g + hd 8670m dual","8610",0,[[1366,768,33]]],["amd radeon hd 8650g","8650",0,[[1360,768,44],[1366,768,44]]],["amd radeon hd 8650g + 8500m dual","8650",0,[[1366,768,35]]],["amd radeon hd 8650g + 8600 dual","8650",0,[[1920,1080,38]]],["amd radeon hd 8650g + 8600m dual","8650",0,[[1366,768,21]]],["amd radeon hd 8650g + 8670m dual","8650",0,[[1366,768,66]]],["amd radeon hd 8650g + 8750m dual","8650",0,[[1920,1080,28]]],["amd radeon hd 8650g + hd 7600m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + hd 8500m dual","8650",0,[[1366,768,23]]],["amd radeon hd 8650g + hd 8570m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + hd 8600m dual","8650",0,[[1366,768,46],[1600,900,29]]],["amd radeon hd 8650g + hd 8750m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + r5 m200 dual","8650",0,[[1366,768,35]]],["amd radeon hd 8670 / r7 250","8670",0,[[1024,768,1]]],["amd radeon hd 8670a/8670m/8690m","8670",0,[[1366,768,47]]],["amd radeon hd 8670a/8670m/8750m","8670",0,[[1366,768,60]]],["amd radeon hd 8670d","8670",0,[[1024,768,45],[1280,1024,69],[1920,1080,38]]],["amd radeon hd 8670d + 7700 dual","8670",0,[[1680,1050,58]]],["amd radeon hd 8670d + hd 6670 dual","8670",0,[[1680,1050,33]]],["amd radeon hd 8670d + r5 200 dual","8670",0,[[2560,1080,14]]],["amd radeon hd 8670d + r7 200 dual","8670",0,[[1920,1080,37]]],["amd radeon hd 8670m","8670",0,[[1366,768,41]]],["amd radeon hd 8690a","8690",0,[[1920,1080,31]]],["amd radeon hd 8690m","8690",0,[[1600,900,35]]],["amd radeon hd 8700m","8700",0,[[1366,768,60]]],["amd radeon hd 8730m","8730",0,[[1366,768,59]]],["amd radeon hd 8750m","8750",0,[[1366,768,60]]],["amd radeon hd 8770","8770",0,[[1920,1080,111]]],["amd radeon hd 8790m","8790",0,[[1600,900,78],[1920,1080,60]]],["amd radeon hd 8800m","8800",0,[[1920,1080,60],[2880,1800,45]]],["amd radeon hd 8830m","8830",0,[[1920,1080,82]]],["amd radeon hd 8850m","8850",0,[[1366,768,45]]],["amd radeon hd 8870m","8870",0,[[1280,1024,60],[1600,900,60]]],["amd radeon hd 8950","8950",0,[[1920,1080,60],[1920,1200,59]]],["amd radeon hd 8970","8970",0,[[2560,1600,60]]],["amd radeon hd 8970m","8970",0,[[1920,1080,146],[1920,1200,60]]],["amd radeon hd 8xxx","8",0,[[1920,1080,120],[2560,1440,58]]],["amd radeon hd5450","5450",0,[[1280,720,24]]],["amd radeon hd6870","6870",0,[[1920,1080,60]]],["amd radeon hd7970m","7970",0,[[2560,1440,116]]],["amd radeon hd8530m","8530",0,[[1366,768,40]]],["amd radeon hd8730","8730",0,[[1680,1050,42]]],["amd radeon hd8970m","8970",0,[[1920,1080,74]]],["amd radeon hybrid","",0,[[1366,768,27]]],["amd radeon infoshock rx 460","460",0,[[1360,768,102]]],["amd radeon instinct mi25","25",0,[[1920,1200,26]]],["amd radeon instinct mi25 mxgpu","25",0,[[1920,1080,20],[1920,1200,32]]],["amd radeon m535dx","535",0,[[1366,768,58]]],["amd radeon navi14","14",0,[[3840,2160,60]]],["amd radeon polaris","",0,[[3840,2160,60],[5120,2880,44]]],["amd radeon polaris 10","10",0,[[1920,1200,60]]],["amd radeon pro","pro",0,[[1920,1080,114]]],["amd radeon pro 270x","270",0,[[2560,1440,74]]],["amd radeon pro 450","450",0,[[1920,1080,30],[2880,1800,43],[3360,2100,36],[5120,2880,30]]],["amd radeon pro 450 opengl engine","450",0,[[1920,1200,60]]],["amd radeon pro 455","455",0,[[2879,1800,54],[2880,1800,48],[3360,2100,37]]],["amd radeon pro 455 opengl engine","455",0,[[3360,2100,36]]],["amd radeon pro 460","460",0,[[2880,1800,50],[3360,2100,42]]],["amd radeon pro 460 opengl engine","460",0,[[5760,3240,15]]],["amd radeon pro 470","470",0,[[6016,3384,49]]],["amd radeon pro 480","480",0,[[1920,1080,60]]],["amd radeon pro 5300","5300",0,[[5120,2880,60]]],["amd radeon pro 5300m","5300",0,[[1920,1080,214],[3584,2240,130]]],["amd radeon pro 5500 xt","5500",0,[[5120,2880,51]]],["amd radeon pro 5500m","5500",0,[[3072,1920,60],[3584,2240,139]]],["amd radeon pro 555","555",0,[[2879,1800,54],[2880,1800,36],[3360,2100,40]]],["amd radeon pro 555x","555",0,[[2880,1800,42],[3360,2100,39]]],["amd radeon pro 560","560",0,[[2879,1800,56],[2880,1800,56],[3360,2100,42]]],["amd radeon pro 5600m","5600",0,[[3072,1920,60],[3584,2240,60]]],["amd radeon pro 560x","560",0,[[2879,1800,59],[2880,1800,71],[3360,2100,43]]],["amd radeon pro 570","570",0,[[5120,2880,48]]],["amd radeon pro 570 opengl engine","570",0,[[5120,2880,46]]],["amd radeon pro 5700","5700",0,[[5120,2880,60]]],["amd radeon pro 5700 xt","5700",0,[[5120,2880,60]]],["amd radeon pro 570x","570",0,[[5120,2880,50]]],["amd radeon pro 575","575",0,[[4096,2304,60],[5120,2880,50]]],["amd radeon pro 575 opengl engine","575",0,[[5120,2880,48]]],["amd radeon pro 575x","575",0,[[5120,2880,56]]],["amd radeon pro 580","580",0,[[5120,2880,54]]],["amd radeon pro 580 opengl engine","580",0,[[5120,2880,50]]],["amd radeon pro 580x","580",0,[[5120,2880,52]]],["amd radeon pro duo","pro",0,[[1920,1080,234],[1800,1350,59],[3840,2160,82],[4096,2160,60]]],["amd radeon pro rx 560","560",0,[[2560,1080,60]]],["amd radeon pro ssg","pro",0,[[3440,1440,125]]],["amd radeon pro v340","340",0,[[1920,1080,112]]],["amd radeon pro v520 mxgpu","520",0,[[1920,1080,271]]],["amd radeon pro v7350x2","7350",0,[[1920,1080,60]]],["amd radeon pro vega 16","16",0,[[2879,1800,60],[3360,2100,60]]],["amd radeon pro vega 20","20",0,[[2880,1800,120],[3360,2100,121],[3840,2160,30]]],["amd radeon pro vega 48","48",0,[[5120,2880,86]]],["amd radeon pro vega 56","56",0,[[1920,1080,60],[5120,2880,60]]],["amd radeon pro vega 56 opengl engine","56",0,[[5120,2880,60]]],["amd radeon pro vega 64","64",0,[[5120,2880,60]]],["amd radeon pro vega 64 opengl engine","64",0,[[5120,2880,60]]],["amd radeon pro vega 64x","64",0,[[2560,1440,206],[4096,2304,60],[5120,2880,60]]],["amd radeon pro vega ii","proii",0,[[3840,1600,60],[5120,2880,60]]],["amd radeon pro vega ii duo","proii",0,[[2560,1440,239],[5120,2880,60]]],["amd radeon pro w5500","5500",0,[[1920,1080,195],[3840,2160,59],[7680,3240,56]]],["amd radeon pro w5500m","5500",0,[[1920,1080,60]]],["amd radeon pro w5500x","5500",0,[[1920,1200,60]]],["amd radeon pro w5700","5700",0,[[1680,1050,253],[5120,1440,120],[3840,2160,60]]],["amd radeon pro w5700x","5700",0,[[3840,2160,60]]],["amd radeon pro w6600","6600",0,[[1920,1200,60],[3840,2160,166]]],["amd radeon pro w6600m","6600",0,[[1920,1080,60]]],["amd radeon pro w6800","6800",0,[[1920,1080,60],[3840,2160,237]]],["amd radeon pro w6800x","6800",0,[[6016,3384,60]]],["amd radeon pro w6800x duo","6800",0,[[3840,1600,60],[5120,2880,45]]],["amd radeon pro w6900x","6900",0,[[3840,2160,60]]],["amd radeon pro wx","pro",0,[[2560,1080,69]]],["amd radeon pro wx 2100","2100",0,[[1280,1024,145],[1920,1080,60]]],["amd radeon pro wx 3100","3100",0,[[1919,1080,58],[1920,1080,123],[2560,1440,82]]],["amd radeon pro wx 3200","3200",0,[[2560,1440,92]]],["amd radeon pro wx 4100","4100",0,[[1920,1080,60],[1920,1200,60],[3840,2160,30],[5120,2880,18]]],["amd radeon pro wx 4130","4130",0,[[1920,1080,60],[3840,2160,30]]],["amd radeon pro wx 4150","4150",0,[[1920,1080,56],[3840,2160,37],[4096,2160,34]]],["amd radeon pro wx 5100","5100",0,[[1920,1080,60],[2560,1440,91],[3840,2160,55]]],["amd radeon pro wx 5100 opengl engine","5100",0,[[2560,1440,60]]],["amd radeon pro wx 7100","7100",0,[[1920,1080,122],[2560,1080,58],[3840,2160,60],[5120,2880,60]]],["amd radeon pro wx 7100 mobile","7100",0,[[2560,1440,60]]],["amd radeon pro wx 7100 opengl engine","7100",0,[[3840,2160,60]]],["amd radeon pro wx 8200","8200",0,[[3440,1440,124]]],["amd radeon pro wx 9100","9100",0,[[1920,1080,60],[4096,2160,101]]],["amd radeon pro wx 9100 opengl engine","9100",0,[[1920,1080,60]]],["amd radeon pro wx vega m gl","prom",0,[[3840,2160,14]]],["amd radeon pro wx3200","3200",0,[[1920,1080,55]]],["amd radeon pro wx9100","9100",0,[[2560,1440,60]]],["amd radeon r2","2",0,[[1366,768,13],[1600,900,14]]],["amd radeon r2e","2",0,[[1366,768,16],[1920,1080,45],[3840,2160,4]]],["amd radeon r3","3",0,[[1366,768,17],[1920,1080,15]]],["amd radeon r4","4",0,[[1366,768,19],[1920,1080,13]]],["amd radeon r4e","4",0,[[3840,2160,6]]],["amd radeon r5","5",0,[[1024,768,38],[1360,768,25],[1366,768,21],[1280,1024,33],[1920,1080,14],[3200,1800,7]]],["amd radeon r5 220","5",0,[[1366,768,19],[1920,1080,12]]],["amd radeon r5 230","5",0,[[1920,1080,21]]],["amd radeon r5 235","5",0,[[1920,1080,17]]],["amd radeon r5 240","5",0,[[1280,1024,34],[1920,1080,24]]],["amd radeon r5 340","5",0,[[1920,1080,27]]],["amd radeon r5 340x","5",0,[[1920,1080,31]]],["amd radeon r5 430","5",0,[[1280,1024,31],[1680,1050,54],[1920,1080,54]]],["amd radeon r5 435","5",0,[[1920,1080,30]]],["amd radeon r5 m200","5",0,[[1600,900,45],[1920,1080,20]]],["amd radeon r5 m200 / hd 8500m","5",0,[[1366,768,31],[1920,1080,24]]],["amd radeon r5 m230","5",0,[[1366,768,37]]],["amd radeon r5 m240","5",0,[[1366,768,42],[1920,1080,23]]],["amd radeon r5 m255","5",0,[[1366,768,59],[1600,900,33]]],["amd radeon r5 m315","5",0,[[1366,768,45]]],["amd radeon r5 m320","5",0,[[1920,1080,19]]],["amd radeon r5 m330","5",0,[[1366,768,27],[1920,1080,26]]],["amd radeon r5 m335","5",0,[[1366,768,55],[1920,1080,19]]],["amd radeon r5 m420","5",0,[[1366,768,49]]],["amd radeon r5 m430","5",0,[[1366,768,36],[1920,1080,20]]],["amd radeon r5 m435","5",0,[[1920,1080,41],[2560,1440,67]]],["amd radeon r5 m445","5",0,[[1920,1080,32]]],["amd radeon r5e","5",0,[[1600,768,14],[1920,1080,16]]],["amd radeon r6","6",0,[[1366,768,30],[1280,1024,23],[1920,1080,12]]],["amd radeon r6 m255dx","6",0,[[1366,768,25]]],["amd radeon r6 m340dx","6",0,[[1366,768,31],[1920,1080,15]]],["amd radeon r6e","6",0,[[3840,2160,5]]],["amd radeon r7","7",0,[[1366,768,35],[1280,1024,31],[1680,1050,39],[1920,1080,12],[1920,1200,16],[2560,1080,15],[2560,1440,21],[3840,2160,8]]],["amd radeon r7 200","7",0,[[1280,1024,45],[1920,1080,120]]],["amd radeon r7 200 series","7",0,[[1920,1080,43]]],["amd radeon r7 240","7",0,[[1920,1080,29]]],["amd radeon r7 240 + hd 8570d dual","7",0,[[1920,1080,43]]],["amd radeon r7 250","7",0,[[1920,1080,49]]],["amd radeon r7 250e","7",0,[[1920,1080,60]]],["amd radeon r7 250x","7",0,[[1920,1080,60]]],["amd radeon r7 260x","7",0,[[1920,1080,56]]],["amd radeon r7 260x/360","7",0,[[1920,1200,102]]],["amd radeon r7 350","7",0,[[1024,768,60],[1280,1024,79],[1920,1080,59]]],["amd radeon r7 350x","7",0,[[1920,1080,50]]],["amd radeon r7 360","7",0,[[1920,1048,60],[1920,1080,102]]],["amd radeon r7 360 / r9 360","7",0,[[1920,1080,60]]],["amd radeon r7 370","7",0,[[1600,900,60],[1920,1080,75]]],["amd radeon r7 370 / r9 270","7",0,[[1920,1080,74]]],["amd radeon r7 370 / r9 270x/370","7",0,[[1600,900,115],[1920,1080,60]]],["amd radeon r7 370 / r9 270x/370x","7",0,[[1920,1080,115]]],["amd radeon r7 370 series","7",0,[[1920,1080,212],[3840,2160,60]]],["amd radeon r7 430","7",0,[[1920,1080,55],[3840,2160,10]]],["amd radeon r7 450","7",0,[[1920,1080,60]]],["amd radeon r7 a360","7",0,[[1920,1080,28]]],["amd radeon r7 graphics + hd 7700 dual","7",0,[[1600,1200,72]]],["amd radeon r7 graphics + r5 340 dual","7",0,[[1920,1080,47]]],["amd radeon r7 graphics + r7 200 dual","7",0,[[1920,1080,45],[1920,1200,47]]],["amd radeon r7 graphics + r7 350 dual","7",0,[[1919,1080,60]]],["amd radeon r7 m260","7",0,[[1600,900,44],[1920,1080,13]]],["amd radeon r7 m260dx","7",0,[[1366,768,46],[1920,1080,18]]],["amd radeon r7 m260x","7",0,[[1920,1080,29]]],["amd radeon r7 m265","7",0,[[1366,768,48],[1920,1080,27]]],["amd radeon r7 m270","7",0,[[1920,1080,31],[3840,2160,10]]],["amd radeon r7 m340","7",0,[[1366,768,60],[1920,1080,32]]],["amd radeon r7 m350","7",0,[[3840,2160,12]]],["amd radeon r7 m360","7",0,[[1366,768,40],[1920,1080,22]]],["amd radeon r7 m370","7",0,[[1920,1080,24]]],["amd radeon r7 m440","7",0,[[1920,1080,39]]],["amd radeon r7 m445","7",0,[[1920,1080,36]]],["amd radeon r7 m460","7",0,[[1919,1080,24],[1920,1080,29]]],["amd radeon r7 m520","7",0,[[1919,1080,17]]],["amd radeon r7 series / hd 9000","7",0,[[1920,1080,71],[2560,1080,59]]],["amd radeon r7e","7",0,[[1024,768,41]]],["amd radeon r8 m350dx","8",0,[[1366,768,30]]],["amd radeon r8 m365dx","8",0,[[1920,1080,28]]],["amd radeon r8 m435dx","8",0,[[1920,1080,22]]],["amd radeon r8 m445dx","8",0,[[1366,768,38],[1920,1080,27]]],["amd radeon r8 m535dx","8",0,[[1366,768,55]]],["amd radeon r9","9",0,[[1920,1080,60]]],["amd radeon r9 200","9",0,[[1920,1080,60]]],["amd radeon r9 200 / hd 7900","9",0,[[1920,1080,250]]],["amd radeon r9 255","9",0,[[1600,900,52],[1920,1080,51]]],["amd radeon r9 260","9",0,[[1920,1080,16]]],["amd radeon r9 270","9",0,[[1280,1024,60],[1920,1080,60]]],["amd radeon r9 270 1024sp","9",0,[[1920,1080,135]]],["amd radeon r9 270x","9",0,[[1920,1080,30]]],["amd radeon r9 280","9",0,[[1920,1080,75],[1920,1200,428],[2560,1440,60]]],["amd radeon r9 280,","9",0,[[5120,2880,39]]],["amd radeon r9 280x","9",0,[[1920,1080,137]]],["amd radeon r9 285","9",0,[[1920,1080,60],[1920,1200,129]]],["amd radeon r9 290","9",0,[[1920,1080,60]]],["amd radeon r9 290x","9",0,[[1920,1080,60],[2560,1440,60],[3840,2160,118]]],["amd radeon r9 300","9",0,[[1920,1080,59]]],["amd radeon r9 350","9",0,[[1920,1200,63]]],["amd radeon r9 360","9",0,[[1600,900,83],[1920,1080,60],[2560,1440,59]]],["amd radeon r9 370","9",0,[[1680,1050,205],[1920,1080,60],[3840,2160,49]]],["amd radeon r9 370x","9",0,[[1920,1080,60]]],["amd radeon r9 380","9",0,[[1920,1080,41],[2560,1440,75]]],["amd radeon r9 380x","9",0,[[2560,1600,60]]],["amd radeon r9 390","9",0,[[1920,1080,60],[2560,1440,60]]],["amd radeon r9 390x","9",0,[[2560,1440,60],[3840,2160,60]]],["amd radeon r9 a375","9",0,[[1920,1080,28]]],["amd radeon r9 fury","9",0,[[1920,1080,75],[3840,2160,133]]],["amd radeon r9 fury / nano","9",0,[[1920,1200,155]]],["amd radeon r9 m200x","9",0,[[1366,768,104],[1920,1080,60]]],["amd radeon r9 m265x","9",0,[[1920,1080,33]]],["amd radeon r9 m270x","9",0,[[1600,900,60],[1920,1080,68]]],["amd radeon r9 m275","9",0,[[1920,1080,29]]],["amd radeon r9 m275x","9",0,[[1920,1080,20]]],["amd radeon r9 m280x","9",0,[[1920,1080,60],[2560,1440,25]]],["amd radeon r9 m290","9",0,[[5120,2880,33]]],["amd radeon r9 m290x","9",0,[[1920,1080,60],[3840,2160,61],[5120,2880,33]]],["amd radeon r9 m295x","9",0,[[3840,2160,33],[5120,2880,36]]],["amd radeon r9 m295x mac","9",0,[[5120,2880,42]]],["amd radeon r9 m295x mac edition / r9 380x","9",0,[[1920,1080,128]]],["amd radeon r9 m360","9",0,[[1920,1080,60],[3840,2160,26]]],["amd radeon r9 m370x","9",0,[[2560,1440,30],[2880,1800,27]]],["amd radeon r9 m370x opengl engine","9",0,[[5120,2880,14]]],["amd radeon r9 m375","9",0,[[1920,1080,29]]],["amd radeon r9 m375x","9",0,[[1920,1080,60],[3840,2160,22]]],["amd radeon r9 m380","9",0,[[1920,1080,50],[3840,2160,8],[5120,2880,9]]],["amd radeon r9 m380 opengl engine","9",0,[[5120,2880,15]]],["amd radeon r9 m385","9",0,[[1920,1080,58]]],["amd radeon r9 m385x","9",0,[[1920,1080,60]]],["amd radeon r9 m390","9",0,[[5119,2879,29],[5120,2880,21],[5760,3240,32]]],["amd radeon r9 m390 opengl engine","9",0,[[5120,2880,27]]],["amd radeon r9 m390x","9",0,[[1920,1080,140]]],["amd radeon r9 m395","9",0,[[2560,1440,59],[5120,2880,19]]],["amd radeon r9 m395 opengl engine","9",0,[[5120,2880,38]]],["amd radeon r9 m395x","9",0,[[3840,2160,58],[5120,2880,36]]],["amd radeon r9 m395x opengl engine","9",0,[[5120,2880,35]]],["amd radeon r9 m470","9",0,[[3840,2160,29]]],["amd radeon r9 m470x","9",0,[[1920,1080,60]]],["amd radeon r9-290x","9",0,[[1920,1080,60]]],["amd radeon renoir graphics d1","1",0,[[1366,768,60]]],["amd radeon rro 580x","580",0,[[5120,2880,59]]],["amd radeon rx 460","460",0,[[1920,1080,55],[2560,1080,60],[3840,2160,31]]],["amd radeon rx 460 / pro 450/455/460/555/555x/560/560x","460",0,[[3440,1440,93]]],["amd radeon rx 460 / pro 450/455/460/560","460",0,[[1920,1080,72]]],["amd radeon rx 470","470",0,[[1280,1024,73],[1920,1080,58],[1920,1200,147],[3840,2160,51]]],["amd radeon rx 470 opengl engine","470",0,[[2560,1440,60]]],["amd radeon rx 475m","475",0,[[1920,1080,60]]],["amd radeon rx 480","480",0,[[1400,1050,267],[1920,1080,60],[2560,1080,71]]],["amd radeon rx 480 opengl engine","480",0,[[1920,1080,60]]],["amd radeon rx 5300m","5300",0,[[1920,1080,60],[3840,2160,60]]],["amd radeon rx 540","540",0,[[1919,1080,52],[1920,1080,36]]],["amd radeon rx 550","550",0,[[1280,1024,135],[1920,1080,60],[1920,1200,60],[6016,3384,15]]],["amd radeon rx 550 640sp / rx 560","550",0,[[1920,1080,60]]],["amd radeon rx 5500","5500",0,[[1920,1080,139]]],["amd radeon rx 5500 / pro 5500m","5500",0,[[1920,1080,60],[2560,1440,227]]],["amd radeon rx 5500 xt","5500",0,[[1920,1080,239]]],["amd radeon rx 5500m","5500",0,[[1920,1048,144],[1920,1080,144],[3840,2160,60]]],["amd radeon rx 550x","550",0,[[1920,1080,52]]],["amd radeon rx 560","560",0,[[1920,1080,60],[1920,1200,42],[2560,1440,60]]],["amd radeon rx 560 [baffin]","560",0,[[1920,1080,60]]],["amd radeon rx 5600 oem/5600 xt / 5700 xt","5600",0,[[1920,1080,360],[2560,1440,164]]],["amd radeon rx 5600 xt","5600",0,[[1920,1080,75]]],["amd radeon rx 5600m","5600",0,[[1920,1080,144]]],["amd radeon rx 560d","560",0,[[2560,1080,60]]],["amd radeon rx 560x","560",0,[[1920,1080,115],[3840,2160,35]]],["amd radeon rx 570","570",0,[[1920,1080,60],[3072,1728,60]]],["amd radeon rx 570 opengl engine","570",0,[[1920,1080,226]]],["amd radeon rx 5700","5700",0,[[1920,1080,144]]],["amd radeon rx 5700 / 5700 xt","5700",0,[[3840,2160,201]]],["amd radeon rx 5700 xt","5700",0,[[1920,1080,464],[3840,2160,60],[6016,3384,34]]],["amd radeon rx 5700 xt 50th anniversary","5700",0,[[2560,1440,144],[3840,1600,60],[3840,2160,222],[5120,2880,60]]],["amd radeon rx 5700xt","5700",0,[[1920,1080,369]]],["amd radeon rx 580","580",0,[[1920,1080,60],[1920,1200,97],[2560,1440,60],[3840,2160,60]]],["amd radeon rx 580 2048sp","580",0,[[1920,1080,60]]],["amd radeon rx 580 opengl engine","580",0,[[1920,1080,145]]],["amd radeon rx 580 special","580",0,[[2560,1440,60]]],["amd radeon rx 580x","580",0,[[1920,1200,60],[3840,2160,79]]],["amd radeon rx 590","590",0,[[1920,1080,75],[2560,1440,164],[3584,2240,60]]],["amd radeon rx 640","640",0,[[1920,1080,39]]],["amd radeon rx 6500 xt","6500",0,[[1920,1080,60]]],["amd radeon rx 6600","6600",0,[[1920,1080,433],[3840,2160,57]]],["amd radeon rx 6600 xt","6600",0,[[1920,1080,60]]],["amd radeon rx 6600 xt/6600m","6600",0,[[2560,1440,60]]],["amd radeon rx 6600m","6600",0,[[1920,1080,139]]],["amd radeon rx 6700 xt","6700",0,[[1920,1080,451]]],["amd radeon rx 6700 xt / 6800m","6700",0,[[2560,1440,144]]],["amd radeon rx 6700m","6700",0,[[1920,1080,240]]],["amd radeon rx 6800","6800",0,[[2560,1440,564],[3840,2160,60]]],["amd radeon rx 6800 xt","6800",0,[[2560,1440,446],[3440,1440,144],[3840,2160,60]]],["amd radeon rx 6800 xt / 6900 xt","6800",0,[[2560,1440,239]]],["amd radeon rx 6800 xt 16gb","6800",0,[[6400,2666,60]]],["amd radeon rx 6800m","6800",0,[[1920,1080,300]]],["amd radeon rx 6900 xt","6900",0,[[3840,2160,60]]],["amd radeon rx rx 560","560",0,[[1920,1080,60]]],["amd radeon rx vega","rx",0,[[1920,1080,39]]],["amd radeon rx vega 10","10",0,[[1920,1080,38]]],["amd radeon rx vega 11","11",0,[[1920,1080,35]]],["amd radeon rx vega 56","56",0,[[1920,1080,144],[3440,1440,60],[3840,2160,60]]],["amd radeon rx vega 56 8gb","56",0,[[2560,1600,60]]],["amd radeon rx vega 56 opengl engine","56",0,[[2560,1440,60]]],["amd radeon rx vega 64","64",0,[[2560,1440,518]]],["amd radeon rx vega 64 8gb","64",0,[[2560,1440,60]]],["amd radeon rx vega 64 opengl engine","64",0,[[3840,2160,119]]],["amd radeon rx vega 64.1","64",0,[[6016,3384,60]]],["amd radeon rx vega 8","8",0,[[1920,1080,53]]],["amd radeon rx vega m gh","rxm",0,[[1920,1080,60],[2560,1440,60],[3840,2160,51]]],["amd radeon rx vega m gl","rxm",0,[[2560,1440,567],[3840,2160,59]]],["amd radeon rx vega11","11",0,[[2496,1664,30]]],["amd radeon rx460","460",0,[[1920,1080,60]]],["amd radeon rx480","480",0,[[1920,1080,102],[2560,1080,71]]],["amd radeon rx540","540",0,[[2400,1800,37]]],["amd radeon rx550","550",0,[[1920,1080,60]]],["amd radeon rx560","560",0,[[1920,1080,93]]],["amd radeon rx5600","5600",0,[[3840,2160,129]]],["amd radeon rx570","570",0,[[5120,2880,59]]],["amd radeon rx5700","5700",0,[[1920,1080,60]]],["amd radeon rx580","580",0,[[1920,1080,60]]],["amd radeon rx590 gme","590",0,[[1920,1080,112]]],["amd radeon rx6600xt","6600",0,[[3840,2160,60]]],["amd radeon sky 500","500",0,[[4096,2160,34]]],["amd radeon vega","",0,[[5120,2880,32]]],["amd radeon vega 10","10",0,[[1920,1080,44]]],["amd radeon vega 10 mobile","10",0,[[1920,1080,30]]],["amd radeon vega 11","11",0,[[1280,1024,60],[1920,1080,60],[3840,2160,17]]],["amd radeon vega 2","2",0,[[1366,768,30]]],["amd radeon vega 3","3",0,[[1440,900,44],[1920,1080,29],[3840,2160,8]]],["amd radeon vega 3 mobile","3",0,[[1920,1080,30]]],["amd radeon vega 56","56",0,[[2560,1440,144]]],["amd radeon vega 6","6",0,[[1366,768,61],[1920,1080,23]]],["amd radeon vega 64","64",0,[[6016,3384,35]]],["amd radeon vega 64 lc","64",0,[[2560,1080,60]]],["amd radeon vega 8","8",0,[[1920,1080,35],[2560,1440,24],[4096,2160,15]]],["amd radeon vega 8 mobile","8",0,[[1920,1080,36]]],["amd radeon vega 9","9",0,[[2496,1663,32],[2496,1664,39]]],["amd radeon vega fe","fe",0,[[1920,1080,120],[2560,1440,60]]],["amd radeon vega frontier","",0,[[1920,1080,120],[3840,2160,60]]],["amd radeon vega frontier edition opengl engine","",0,[[3440,1440,60]]],["amd radeon vega series / radeon vega mobile","",0,[[1920,1080,67]]],["amd radeon vii","vii",0,[[1920,1080,468],[2560,1440,60],[3840,2160,60]]],["amd radeont 540x","540",0,[[1920,1080,74],[3840,2160,22]]],["amd radeont rx 5300","5300",0,[[1920,1080,60]]],["amd radeont rx 5500m","5500",0,[[1920,1080,303]]],["amd radeont rx 560x","560",0,[[1920,1080,60]]],["amd renoir","",0,[[1920,1080,60]]],["amd rx 480","480",0,[[1680,1050,119]]],["amd rx 560","560",0,[[5120,2880,37]]],["amd rx 5700xt","5700",0,[[3840,2160,60]]],["amd rx 580","580",0,[[1920,1200,60],[5120,2880,60]]],["amd rx 590","590",0,[[5120,2880,60]]],["amd rx vega 64","64",0,[[1920,1080,60]]],["amd rx xxx","xxx",0,[[1920,1080,60],[2560,1440,144]]],["amd saphire radeon rx 580","580",0,[[1920,1080,57]]],["amd sapphire hd 5770","5770",0,[[1440,900,60]]],["amd sapphire nitro+ rx 6800","6800",0,[[1920,1080,75]]],["amd sapphire radeon hd6870","6870",0,[[1680,1050,60]]],["amd sapphire radeon rx 560","560",0,[[1280,1024,60]]],["amd sapphire radeon rx vega 64 8gb","64",0,[[2560,1440,144]]],["amd tonga pro gl [firepro w7100]","7100",0,[[1920,1200,127]]],["amd video controller","",0,[[1919,1079,60],[1920,1080,291]]],["intel radeong 0.4 on amd bonaire","0",0,[[1920,1200,92]]],["intel radeong 0.4 on amd cape verde","0",0,[[1920,1200,73]]],["intel radeong 0.4 on amd polaris10","0",0,[[3840,2160,108]]],["intel radeong 0.4 on amd tonga","0",0,[[1920,1080,124]]],["radeong 0.4 on amd polaris10","0",0,[[3840,2160,109]]],["radeong 0.4 on amd tahiti","0",0,[[1920,1080,223]]]]\')},732:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["apple a14","14",0,[[2704,1756,120]]],["apple m1","1",0,[[2880,1800,60]]],["apple m1 max","1",0,[[3456,2234,120]]],["apple m1 pro","1",0,[[3024,1964,120]]],["apple paravirtual device","",0,[[1024,768,30]]]]\')},405:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["intel geforce gtx 960","960",0,[[1920,1080,26]]],["nvidia asus geforce gt 430","430",0,[[1366,768,35]]],["nvidia asus geforce gt 440","440",0,[[1920,1080,28]]],["nvidia asus geforce gt 520","520",0,[[1680,1050,12]]],["nvidia asus geforce gt 610","610",0,[[1920,1200,15]]],["nvidia asus geforce gt 630","630",0,[[1680,1050,41]]],["nvidia asus geforce gt 640","640",0,[[2560,1440,34]]],["nvidia asus geforce gt 710","710",0,[[1920,1080,31]]],["nvidia asus geforce gt 730","730",0,[[2560,1080,28],[3840,2160,12]]],["nvidia asus geforce gts 450","450",0,[[1920,1080,54]]],["nvidia asus geforce gtx 1060","1060",0,[[3840,2160,38]]],["nvidia asus geforce gtx 1080","1080",0,[[2560,1440,120]]],["nvidia asus geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia asus geforce gtx 480","480",0,[[1920,1080,59]]],["nvidia asus geforce gtx 550 ti","550",0,[[1920,1080,57]]],["nvidia asus geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia asus geforce gtx 560 se","560",0,[[1920,1080,59]]],["nvidia asus geforce gtx 560 ti","560",0,[[1680,1050,58]]],["nvidia asus geforce gtx 570","570",0,[[1280,1024,74]]],["nvidia asus geforce gtx 570 hd","570",0,[[1920,1080,60]]],["nvidia asus geforce gtx 580","580",0,[[1920,1200,59]]],["nvidia asus geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia asus geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia asus geforce gtx 750 ti","750",0,[[1360,768,59],[1920,1080,118]]],["nvidia asus geforce gtx 760","760",0,[[1920,1080,60],[1920,1200,60]]],["nvidia asus geforce gtx 770","770",0,[[1920,1080,60]]],["nvidia asus geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia asus geforce gtx 950","950",0,[[1920,1080,60]]],["nvidia asus geforce gtx 960","960",0,[[1920,1080,60],[2560,1600,117]]],["nvidia asus geforce gtx 970","970",0,[[2560,1600,60]]],["nvidia asus geforce gtx 980 ti","980",0,[[2560,1440,131]]],["nvidia colorful geforce gtx 960","960",0,[[2560,1440,60]]],["nvidia elitegroup geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia evga geforce gt 545","545",0,[[1920,1080,37]]],["nvidia evga geforce gt 640","640",0,[[1366,768,60]]],["nvidia evga geforce gt 710","710",0,[[1680,1050,36],[1920,1080,29]]],["nvidia evga geforce gt 730","730",0,[[1600,900,59]]],["nvidia evga geforce gt 740","740",0,[[1280,1024,45]]],["nvidia evga geforce gtx 1050 ti","1050",0,[[2560,1440,60],[4096,2304,58]]],["nvidia evga geforce gtx 1070","1070",0,[[5120,2880,60]]],["nvidia evga geforce gtx 1080 ti","1080",0,[[1920,1200,60]]],["nvidia evga geforce gtx 560 ti","560",0,[[1680,1050,59]]],["nvidia evga geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia evga geforce gtx 580","580",0,[[2560,1440,60]]],["nvidia evga geforce gtx 650","650",0,[[1920,1200,87],[2560,1600,43]]],["nvidia evga geforce gtx 650 ti","650",0,[[1680,1050,116],[2560,1440,55]]],["nvidia evga geforce gtx 650 ti boost","650",0,[[1920,1080,56]]],["nvidia evga geforce gtx 660 ti","660",0,[[1920,1200,60]]],["nvidia evga geforce gtx 680","680",0,[[1600,1200,60]]],["nvidia evga geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia evga geforce gtx 760","760",0,[[1920,1080,119],[1920,1200,60]]],["nvidia evga geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia evga geforce gtx 960","960",0,[[1920,1080,60],[2560,1440,115]]],["nvidia evga geforce gtx 970","970",0,[[1920,1080,120]]],["nvidia evga geforce gtx 980","980",0,[[3440,1440,60]]],["nvidia evga geforce gtx 980 ti","980",0,[[1920,1080,60]]],["nvidia gainward geforce gt 630","630",0,[[1920,1080,28]]],["nvidia gainward geforce gts 450","450",0,[[1920,1080,55]]],["nvidia gainward geforce gtx 460","460",0,[[1920,1080,58]]],["nvidia gainward geforce gtx 550 ti","550",0,[[1280,1024,67]]],["nvidia gainward geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia gainward geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia gainward geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia geforce 210","210",0,[[1920,1080,8]]],["nvidia geforce 410m","410",0,[[1366,768,25],[1600,900,19]]],["nvidia geforce 510","510",0,[[1280,960,20]]],["nvidia geforce 605","605",0,[[1768,992,17],[1920,1080,15]]],["nvidia geforce 610m","610",0,[[1366,768,26]]],["nvidia geforce 610m/710m/810m/820m / gt 620m/625m/630m/720m","610",0,[[1366,768,51]]],["nvidia geforce 615","615",0,[[1920,1080,21]]],["nvidia geforce 705m","705",0,[[1920,1080,18]]],["nvidia geforce 710a","710",0,[[1920,1080,32]]],["nvidia geforce 710m","710",0,[[1366,768,55]]],["nvidia geforce 730a","730",0,[[1920,1080,37]]],["nvidia geforce 800m","800",0,[[1920,1080,18]]],["nvidia geforce 810m","810",0,[[1366,768,44],[1920,1080,31]]],["nvidia geforce 820a","820",0,[[1920,1080,28]]],["nvidia geforce 820m","820",0,[[1366,768,57],[1920,1080,23]]],["nvidia geforce 830a","830",0,[[1920,1080,53]]],["nvidia geforce 830m","830",0,[[1366,768,60]]],["nvidia geforce 8400 gs","8400",0,[[1680,1050,4]]],["nvidia geforce 8400 gs rev. 3","8400",0,[[1920,1080,4]]],["nvidia geforce 840a","840",0,[[1920,1080,56]]],["nvidia geforce 840m","840",0,[[1920,1080,56]]],["nvidia geforce 845m","845",0,[[1920,1080,59]]],["nvidia geforce 8600 gt","8600",1,[[1920,1200,-1]]],["nvidia geforce 8600 gts","8600",1,[[1920,1080,-1]]],["nvidia geforce 910m","910",0,[[1366,768,58],[1600,900,45]]],["nvidia geforce 920m","920",0,[[1366,768,60]]],["nvidia geforce 920mx","920",0,[[1366,768,60],[1920,1080,60]]],["nvidia geforce 9300 / nforce 730i","9300",0,[[1920,1080,6]]],["nvidia geforce 930a","930",0,[[1920,1080,55]]],["nvidia geforce 930m","930",0,[[1366,768,60]]],["nvidia geforce 930mx","930",0,[[1366,768,89],[1920,1080,59]]],["nvidia geforce 9400 gt","9400",1,[[1366,768,-1]]],["nvidia geforce 940a","940",0,[[1920,1080,58]]],["nvidia geforce 940m","940",0,[[1920,1080,54]]],["nvidia geforce 940mx","940",0,[[1920,1080,60]]],["nvidia geforce 945m","945",0,[[1920,1080,59]]],["nvidia geforce 9600 gt","9600",0,[[1920,1200,2]]],["nvidia geforce 9600m gt","9600",1,[[1440,900,-1]]],["nvidia geforce 9800 gt","9800",0,[[1920,1200,52]]],["nvidia geforce 9800 gtx / 9800 gtx+","9800",0,[[1280,1024,59]]],["nvidia geforce gpu","gpu",0,[[3000,2000,36]]],["nvidia geforce gt 1010","1010",0,[[1920,1080,135]]],["nvidia geforce gt 1030","1030",0,[[1920,1080,60]]],["nvidia geforce gt 1030 opengl engine","1030",0,[[6720,3780,15]]],["nvidia geforce gt 120","120",1,[[1920,1080,-1]]],["nvidia geforce gt 240","240",0,[[1366,768,32]]],["nvidia geforce gt 320m","320",0,[[1366,768,26]]],["nvidia geforce gt 415m","415",0,[[1366,768,19]]],["nvidia geforce gt 420","420",0,[[1024,768,33],[1920,1080,20]]],["nvidia geforce gt 420m","420",0,[[1366,768,28]]],["nvidia geforce gt 425m","425",0,[[1366,768,55],[1600,900,28]]],["nvidia geforce gt 430","430",0,[[1600,1200,16],[1920,1080,28]]],["nvidia geforce gt 435m","435",0,[[1366,768,53],[1920,1080,22]]],["nvidia geforce gt 440","440",0,[[1280,1024,51],[1680,1050,38],[1920,1080,45]]],["nvidia geforce gt 445m","445",0,[[1600,900,53]]],["nvidia geforce gt 520","520",0,[[1440,900,19],[1920,1080,17]]],["nvidia geforce gt 520m","520",0,[[1366,768,29]]],["nvidia geforce gt 520mx","520",0,[[1366,768,35]]],["nvidia geforce gt 525m","525",0,[[1366,768,28],[1600,900,22]]],["nvidia geforce gt 530","530",0,[[1920,1080,26]]],["nvidia geforce gt 540m","540",0,[[1366,768,38]]],["nvidia geforce gt 545","545",0,[[1920,1080,54]]],["nvidia geforce gt 550m","550",0,[[1600,900,44],[1920,1080,29]]],["nvidia geforce gt 555m","555",0,[[1920,1080,42]]],["nvidia geforce gt 555m/635m","555",0,[[1920,1080,36]]],["nvidia geforce gt 610","610",0,[[1280,1024,22],[1920,1080,15]]],["nvidia geforce gt 620","620",0,[[1920,1080,19]]],["nvidia geforce gt 620 oem","620",0,[[1920,1080,20],[1920,1200,20]]],["nvidia geforce gt 620m","620",0,[[1366,768,55],[1920,1080,30]]],["nvidia geforce gt 620m/630m/635m/640m le","620",0,[[1368,768,38]]],["nvidia geforce gt 625","625",0,[[1920,1080,18]]],["nvidia geforce gt 625m","625",0,[[1366,768,38]]],["nvidia geforce gt 630","630",0,[[1680,1050,36],[1920,1080,36],[1920,1200,30]]],["nvidia geforce gt 630 oem","630",0,[[1600,900,33]]],["nvidia geforce gt 630 opengl engine","630",0,[[1920,1080,33]]],["nvidia geforce gt 630 rev. 2","630",0,[[1920,1080,26]]],["nvidia geforce gt 630m","630",0,[[1366,768,57]]],["nvidia geforce gt 635","635",0,[[1920,1080,27]]],["nvidia geforce gt 635m","635",0,[[1366,768,47]]],["nvidia geforce gt 640","640",0,[[1920,1080,47]]],["nvidia geforce gt 640 oem","640",0,[[1920,1080,46],[2560,1440,35]]],["nvidia geforce gt 640 opengl engine","640",0,[[1280,1024,43]]],["nvidia geforce gt 640 rev. 2","640",0,[[1280,1024,60],[1920,1080,55]]],["nvidia geforce gt 640m","640",0,[[1366,768,82],[1600,900,59],[1920,1080,34]]],["nvidia geforce gt 640m le","640",0,[[1920,1080,49]]],["nvidia geforce gt 640m mac","640",0,[[1366,768,56],[1920,1080,20]]],["nvidia geforce gt 640m opengl engine","640",0,[[1920,1080,45]]],["nvidia geforce gt 645m","645",0,[[1366,768,60]]],["nvidia geforce gt 650m","650",0,[[1360,768,59],[1920,1080,58],[2560,1440,59]]],["nvidia geforce gt 650m mac","650",0,[[1440,900,56],[1920,1080,15],[2560,1440,19],[2880,1800,31]]],["nvidia geforce gt 650m opengl engine","650",0,[[1920,1080,56],[3840,2160,27]]],["nvidia geforce gt 705","705",0,[[1920,1080,11]]],["nvidia geforce gt 710","710",0,[[1920,1080,28]]],["nvidia geforce gt 710b","710",0,[[1920,1080,26]]],["nvidia geforce gt 710m","710",0,[[1366,768,46]]],["nvidia geforce gt 720","720",0,[[1920,1080,19],[2560,1440,16],[5120,2880,5]]],["nvidia geforce gt 720 opengl engine","720",0,[[2560,1600,20]]],["nvidia geforce gt 720m","720",0,[[1366,768,42]]],["nvidia geforce gt 730","730",0,[[1920,1080,54]]],["nvidia geforce gt 730a","730",0,[[1920,1080,23]]],["nvidia geforce gt 730m","730",0,[[1920,1080,43]]],["nvidia geforce gt 735m","735",0,[[1920,1080,39]]],["nvidia geforce gt 740","740",0,[[1920,1080,55],[3440,1440,23]]],["nvidia geforce gt 740 opengl engine","740",0,[[1920,1200,51]]],["nvidia geforce gt 740m","740",0,[[1366,768,60]]],["nvidia geforce gt 745m","745",0,[[1920,1080,55]]],["nvidia geforce gt 750m","750",0,[[1920,1080,57]]],["nvidia geforce gt 750m mac","750",0,[[1920,1080,58],[2880,1800,28]]],["nvidia geforce gt 755m","755",0,[[1920,1080,57]]],["nvidia geforce gt 755m mac","755",0,[[2560,1440,41]]],["nvidia geforce gt 755m opengl engine","755",0,[[2560,1440,51]]],["nvidia geforce gt 820m","820",0,[[1600,900,47]]],["nvidia geforce gts 250","250",0,[[1680,1050,53]]],["nvidia geforce gts 450","450",0,[[1360,768,60],[1680,1050,57],[1920,1080,55]]],["nvidia geforce gts 450 rev. 2","450",0,[[1920,1080,56]]],["nvidia geforce gtx 1050","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 3gb","1050",0,[[1280,1024,60]]],["nvidia geforce gtx 1050 mobile","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 opengl engine","1050",0,[[1920,1080,116]]],["nvidia geforce gtx 1050 ti","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 ti mobile","1050",0,[[1920,1080,298]]],["nvidia geforce gtx 1050 ti opengl engine","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 ti with max-q design","1050",0,[[1920,1080,268],[2560,1440,102],[3840,2160,60]]],["nvidia geforce gtx 1050 with max-q design","1050",0,[[1920,1080,60],[3840,2160,24]]],["nvidia geforce gtx 1060","1060",0,[[1920,1080,60],[3840,2160,59]]],["nvidia geforce gtx 1060 3gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 3gb opengl engine","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 5gb","1060",0,[[1920,1080,55]]],["nvidia geforce gtx 1060 6gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 6gb opengl engine","1060",0,[[1920,1080,75]]],["nvidia geforce gtx 1060 mobile","1060",0,[[1920,1080,422]]],["nvidia geforce gtx 1060 mobile 6gb","1060",0,[[1920,1080,120]]],["nvidia geforce gtx 1060 with max-q design","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060se 3gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1070","1070",0,[[1920,1080,134]]],["nvidia geforce gtx 1070 a17","1070",0,[[1920,1080,60]]],["nvidia geforce gtx 1070 mobile","1070",0,[[1920,1080,467]]],["nvidia geforce gtx 1070 opengl engine","1070",0,[[1920,1080,143]]],["nvidia geforce gtx 1070 ti","1070",0,[[1920,1080,60],[6016,3384,59]]],["nvidia geforce gtx 1070 ti opengl engine","1070",0,[[1920,1080,75]]],["nvidia geforce gtx 1070 with max-q design","1070",0,[[1920,1080,448]]],["nvidia geforce gtx 1070 with maxq design","1070",0,[[1920,1080,60],[3840,2160,59]]],["nvidia geforce gtx 1080","1080",0,[[1920,1080,119],[2560,1440,326],[3840,2160,286]]],["nvidia geforce gtx 1080 mobile","1080",0,[[1920,1080,120]]],["nvidia geforce gtx 1080 opengl engine","1080",0,[[1920,1080,79]]],["nvidia geforce gtx 1080 ti","1080",0,[[1920,1080,120]]],["nvidia geforce gtx 1080 ti opengl engine","1080",0,[[1920,1080,127]]],["nvidia geforce gtx 1080 with max-q design","1080",0,[[1920,1080,144]]],["nvidia geforce gtx 1180","1180",0,[[3440,1440,60]]],["nvidia geforce gtx 1650","1650",0,[[1920,1080,380]]],["nvidia geforce gtx 1650 mobile / max-q","1650",0,[[1920,1080,292]]],["nvidia geforce gtx 1650 super","1650",0,[[1920,1080,433]]],["nvidia geforce gtx 1650 ti","1650",0,[[1920,1080,144],[3840,2400,59]]],["nvidia geforce gtx 1650 ti mobile","1650",0,[[1920,1080,144]]],["nvidia geforce gtx 1650 ti with max-q design","1650",0,[[1920,1080,60],[3839,2160,60]]],["nvidia geforce gtx 1650 with max-q design","1650",0,[[1920,1080,142],[3000,2000,60]]],["nvidia geforce gtx 1660","1660",0,[[1920,1080,144]]],["nvidia geforce gtx 1660 super","1660",0,[[1920,1080,60]]],["nvidia geforce gtx 1660 ti","1660",0,[[1920,1080,546],[3840,2160,60]]],["nvidia geforce gtx 1660 ti mobile","1660",0,[[1920,1080,451]]],["nvidia geforce gtx 1660 ti with max-q design","1660",0,[[1920,1080,144]]],["nvidia geforce gtx 280","280",0,[[1680,1050,56]]],["nvidia geforce gtx 295","295",0,[[1920,1080,56]]],["nvidia geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia geforce gtx 460 oem","460",0,[[1360,768,60],[1920,1080,60]]],["nvidia geforce gtx 460 opengl engine","460",0,[[1920,1080,59]]],["nvidia geforce gtx 460 se","460",0,[[1920,1080,56],[1920,1200,57]]],["nvidia geforce gtx 460 v2","460",0,[[1920,1080,60],[1920,1200,60],[2560,1600,55]]],["nvidia geforce gtx 460m","460",0,[[1920,1080,46]]],["nvidia geforce gtx 465","465",0,[[1920,1080,134],[1920,1200,59]]],["nvidia geforce gtx 470","470",0,[[1680,1050,60],[1920,1080,59]]],["nvidia geforce gtx 470m","470",0,[[1920,1200,55]]],["nvidia geforce gtx 480","480",0,[[1440,900,191],[1920,1080,115],[1920,1200,60]]],["nvidia geforce gtx 480 opengl engine","480",0,[[1600,1200,60]]],["nvidia geforce gtx 550 ti","550",0,[[1280,1024,58],[1920,1080,58]]],["nvidia geforce gtx 550 ti opengl engine","550",0,[[1920,1080,55]]],["nvidia geforce gtx 555","555",0,[[1920,1080,54]]],["nvidia geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia geforce gtx 560 se","560",0,[[1680,1050,52],[1920,1080,111]]],["nvidia geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia geforce gtx 560 ti 448 cores","560",0,[[1920,1080,60],[2560,1440,60]]],["nvidia geforce gtx 560 ti oem","560",0,[[1920,1080,176]]],["nvidia geforce gtx 560 ti opengl engine","560",0,[[1920,1080,48]]],["nvidia geforce gtx 560m","560",0,[[1920,1080,55]]],["nvidia geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia geforce gtx 570 opengl engine","570",0,[[1920,1080,60]]],["nvidia geforce gtx 570 rev. 2","570",0,[[1920,1080,60],[1920,1200,60]]],["nvidia geforce gtx 570m","570",0,[[1920,1080,125],[2560,1440,8]]],["nvidia geforce gtx 580","580",0,[[1920,1080,60]]],["nvidia geforce gtx 580 opengl engine","580",0,[[1680,1050,59]]],["nvidia geforce gtx 580m","580",0,[[1920,1080,60]]],["nvidia geforce gtx 590","590",0,[[1920,1080,59]]],["nvidia geforce gtx 645","645",0,[[1920,1080,57],[1920,1200,58]]],["nvidia geforce gtx 645 opengl engine","645",0,[[1920,1200,58]]],["nvidia geforce gtx 650","650",0,[[1920,1080,72]]],["nvidia geforce gtx 650 oem","650",0,[[1366,768,59]]],["nvidia geforce gtx 650 opengl engine","650",0,[[1920,1080,59]]],["nvidia geforce gtx 650 ti","650",0,[[1920,1080,60]]],["nvidia geforce gtx 650 ti boost","650",0,[[1280,1024,60],[1600,1200,187],[1920,1080,60]]],["nvidia geforce gtx 650 ti opengl engine","650",0,[[1920,1080,60]]],["nvidia geforce gtx 660","660",0,[[1920,1080,111]]],["nvidia geforce gtx 660 oem","660",0,[[1920,1080,59]]],["nvidia geforce gtx 660 ti","660",0,[[1920,1080,60]]],["nvidia geforce gtx 660 ti opengl engine","660",0,[[1280,1024,60]]],["nvidia geforce gtx 660m","660",0,[[1680,1050,36],[1920,1080,59]]],["nvidia geforce gtx 660m mac","660",0,[[2560,1440,2]]],["nvidia geforce gtx 660m opengl engine","660",0,[[2560,1440,36]]],["nvidia geforce gtx 670","670",0,[[1920,1080,100]]],["nvidia geforce gtx 670 opengl engine","670",0,[[1920,1080,60]]],["nvidia geforce gtx 670m","670",0,[[1920,1080,66]]],["nvidia geforce gtx 670mx","670",0,[[1920,1080,60]]],["nvidia geforce gtx 675m","675",0,[[1920,1080,60]]],["nvidia geforce gtx 675mx","675",0,[[1680,1050,60],[1920,1080,60],[2560,1440,55]]],["nvidia geforce gtx 675mx mac","675",0,[[2560,1440,36]]],["nvidia geforce gtx 675mx opengl engine","675",0,[[2560,1440,60]]],["nvidia geforce gtx 680","680",0,[[1920,1080,60]]],["nvidia geforce gtx 680 opengl engine","680",0,[[1920,1080,60]]],["nvidia geforce gtx 680m","680",0,[[1920,1080,39],[1920,1200,60]]],["nvidia geforce gtx 680m opengl engine","680",0,[[1920,1080,36]]],["nvidia geforce gtx 680mx","680",0,[[2560,1440,59]]],["nvidia geforce gtx 680mx opengl engine","680",0,[[2560,1440,59]]],["nvidia geforce gtx 690","690",0,[[1920,1080,60],[3840,2160,30]]],["nvidia geforce gtx 745","745",0,[[1920,1080,60],[2560,1600,29]]],["nvidia geforce gtx 750","750",0,[[1920,1080,60]]],["nvidia geforce gtx 750 opengl engine","750",0,[[1920,1200,58]]],["nvidia geforce gtx 750 ti","750",0,[[1920,1080,97]]],["nvidia geforce gtx 760","760",0,[[1920,1080,60],[1920,1200,116]]],["nvidia geforce gtx 760 oem","760",0,[[1920,1080,60]]],["nvidia geforce gtx 760 opengl engine","760",0,[[1920,1080,52]]],["nvidia geforce gtx 760 ti","760",0,[[1920,1080,60],[1920,1200,60]]],["nvidia geforce gtx 760 ti oem","760",0,[[1920,1200,60]]],["nvidia geforce gtx 760 ti opengl engine","760",0,[[1920,1080,60]]],["nvidia geforce gtx 760a","760",0,[[2560,1080,15]]],["nvidia geforce gtx 760m","760",0,[[1920,1080,60]]],["nvidia geforce gtx 765m","765",0,[[1920,1080,53],[2560,1440,57]]],["nvidia geforce gtx 765m by nick[d]vb","765",0,[[2560,1440,58]]],["nvidia geforce gtx 765m opengl engine","765",0,[[2560,1440,57]]],["nvidia geforce gtx 770","770",0,[[1920,1080,143],[2560,1440,203]]],["nvidia geforce gtx 770 opengl engine","770",0,[[1920,1080,60]]],["nvidia geforce gtx 770m","770",0,[[1920,1080,60],[2560,1440,59]]],["nvidia geforce gtx 770m by nick[d]vb","770",0,[[2560,1440,34]]],["nvidia geforce gtx 770m opengl engine","770",0,[[2560,1440,59]]],["nvidia geforce gtx 775m by idopt mac","775",0,[[2560,1440,56]]],["nvidia geforce gtx 775m mac","775",0,[[2560,1440,59]]],["nvidia geforce gtx 775m opengl engine","775",0,[[2560,1440,60]]],["nvidia geforce gtx 780","780",0,[[1920,1080,159]]],["nvidia geforce gtx 780 by st3phl3","780",0,[[3840,2160,30]]],["nvidia geforce gtx 780 mac","780",0,[[1680,1050,60],[1920,1080,60]]],["nvidia geforce gtx 780 rev. 2","780",0,[[1920,1080,144],[2560,1440,119],[3840,2160,58],[5120,2880,58]]],["nvidia geforce gtx 780 ti","780",0,[[1280,1024,120],[1920,1080,119]]],["nvidia geforce gtx 780 ti opengl engine","780",0,[[2560,1440,60]]],["nvidia geforce gtx 780m","780",0,[[1920,1080,60],[2560,1440,59]]],["nvidia geforce gtx 780m by nick[d]vb","780",0,[[1920,1080,59],[2560,1440,60]]],["nvidia geforce gtx 780m mac","780",0,[[2560,1440,60]]],["nvidia geforce gtx 780m opengl engine","780",0,[[2560,1440,60]]],["nvidia geforce gtx 850a","850",0,[[2560,1440,48]]],["nvidia geforce gtx 850m","850",0,[[1920,1080,60]]],["nvidia geforce gtx 860m","860",0,[[1920,1080,59]]],["nvidia geforce gtx 860m opengl engine","860",0,[[2560,1440,58]]],["nvidia geforce gtx 870m","870",0,[[1920,1080,60],[2560,1440,102]]],["nvidia geforce gtx 880m","880",0,[[1920,1080,60],[2560,1440,74]]],["nvidia geforce gtx 880m opengl engine","880",0,[[2560,1440,60]]],["nvidia geforce gtx 950","950",0,[[1920,1080,98]]],["nvidia geforce gtx 950 opengl engine","950",0,[[1920,1200,60]]],["nvidia geforce gtx 950a","950",0,[[1920,1080,60],[3840,2160,38]]],["nvidia geforce gtx 950m","950",0,[[1920,1080,114]]],["nvidia geforce gtx 960","960",0,[[1920,1080,60]]],["nvidia geforce gtx 960a","960",0,[[1920,1440,128]]],["nvidia geforce gtx 960m","960",0,[[1920,1080,119],[3840,2160,37]]],["nvidia geforce gtx 965m","965",0,[[1920,1080,195],[3000,2000,59],[3840,2160,41]]],["nvidia geforce gtx 965m opengl engine","965",0,[[2880,1620,55]]],["nvidia geforce gtx 970","970",0,[[1920,1080,143]]],["nvidia geforce gtx 970 opengl engine","970",0,[[2560,1600,60]]],["nvidia geforce gtx 970m","970",0,[[1920,1080,60]]],["nvidia geforce gtx 980","980",0,[[1920,1080,60],[3440,1440,294]]],["nvidia geforce gtx 980 ti","980",0,[[1920,1080,119],[2560,1440,456]]],["nvidia geforce gtx 980 ti opengl engine","980",0,[[1920,1080,60]]],["nvidia geforce gtx 980m","980",0,[[1920,1080,60],[3840,2160,104]]],["nvidia geforce gtx titan","gtx",0,[[1920,1080,119],[1920,1200,119],[2560,1440,60]]],["nvidia geforce gtx titan black","gtx",0,[[1680,1050,60],[1920,1080,60],[1920,1200,60],[2560,1440,60]]],["nvidia geforce gtx titan black opengl engine","gtx",0,[[3840,2160,60]]],["nvidia geforce gtx titan opengl engine","gtx",0,[[2560,1440,60]]],["nvidia geforce gtx titan x","gtxx",0,[[1920,1080,144],[2560,1440,120],[2560,1600,60]]],["nvidia geforce gtx titan xp","gtxxp",0,[[2560,1440,60],[3440,1440,60]]],["nvidia geforce gtx titan z","gtxz",0,[[1440,900,59],[1920,1080,39],[3840,2160,60]]],["nvidia geforce gtx780m by nikey22","780",0,[[2560,1440,60]]],["nvidia geforce gtx870m by nikey22","870",0,[[2560,1440,60]]],["nvidia geforce gtx880m","880",0,[[1920,1080,60]]],["nvidia geforce gtx880m by nikey22","880",0,[[2560,1440,59]]],["nvidia geforce gtx880m opengl engine","880",0,[[2560,1440,59]]],["nvidia geforce mx110","110",0,[[1366,768,61],[1920,1080,57]]],["nvidia geforce mx130","130",0,[[1920,1080,60]]],["nvidia geforce mx150","150",0,[[1920,1080,113]]],["nvidia geforce mx230","230",0,[[1920,1080,60]]],["nvidia geforce mx250","250",0,[[1920,1080,60]]],["nvidia geforce mx330","330",0,[[1920,1080,60],[3840,2160,51]]],["nvidia geforce mx350","350",0,[[1920,1080,60]]],["nvidia geforce mx450","450",0,[[1920,1080,60]]],["nvidia geforce pre-release graphics device","pre",0,[[2560,1440,60]]],["nvidia geforce pre-release tesla c2075 opengl engine","2075",0,[[1600,900,59]]],["nvidia geforce pre-release titan x opengl engine","prex",0,[[1920,1080,60]]],["nvidia geforce pre-release titan xp collectors edition opengl e","prexpe",0,[[1920,1080,59]]],["nvidia geforce pre-release titan xp opengl engine","prexp",0,[[2560,1440,60]]],["nvidia geforce rtx 2060","2060",0,[[1920,1080,512]]],["nvidia geforce rtx 2060 max-q","2060",0,[[2560,1440,301]]],["nvidia geforce rtx 2060 mobile","2060",0,[[1920,1080,518]]],["nvidia geforce rtx 2060 rev. a","2060",0,[[3840,2160,257]]],["nvidia geforce rtx 2060 super","2060",0,[[1920,1080,645],[2560,1440,143]]],["nvidia geforce rtx 2060 with max-q design","2060",0,[[1920,1080,292],[1920,1200,60]]],["nvidia geforce rtx 2070","2070",0,[[1920,1080,60],[3840,2160,60]]],["nvidia geforce rtx 2070 mobile","2070",0,[[1920,1080,477]]],["nvidia geforce rtx 2070 mobile / max-q","2070",0,[[1920,1080,526]]],["nvidia geforce rtx 2070 mobile / max-q refresh","2070",0,[[1920,1080,143]]],["nvidia geforce rtx 2070 rev. a","2070",0,[[2560,1440,144]]],["nvidia geforce rtx 2070 super","2070",0,[[1920,1080,510]]],["nvidia geforce rtx 2070 super with max-q design","2070",0,[[1920,1080,300]]],["nvidia geforce rtx 2070 with max-q design","2070",0,[[1920,1080,240]]],["nvidia geforce rtx 2080","2080",0,[[1920,1080,632],[2560,1440,165]]],["nvidia geforce rtx 2080 mobile","2080",0,[[1920,1080,144]]],["nvidia geforce rtx 2080 rev. a","2080",0,[[2560,1440,143]]],["nvidia geforce rtx 2080 super","2080",0,[[1920,1080,601]]],["nvidia geforce rtx 2080 super mobile / max-q","2080",0,[[3840,2160,59]]],["nvidia geforce rtx 2080 super with max-q design","2080",0,[[1920,1080,300]]],["nvidia geforce rtx 2080 ti","2080",0,[[1920,1080,83]]],["nvidia geforce rtx 2080 ti rev. a","2080",0,[[1920,1080,403]]],["nvidia geforce rtx 2080 with max-q design","2080",0,[[1920,1080,476]]],["nvidia geforce rtx 3050","3050",0,[[1920,1080,60]]],["nvidia geforce rtx 3050 laptop gpu","3050",0,[[1920,1080,144]]],["nvidia geforce rtx 3050 ti laptop gpu","3050",0,[[1920,1080,144]]],["nvidia geforce rtx 3060","3060",0,[[1920,1080,674]]],["nvidia geforce rtx 3060 laptop gpu","3060",0,[[1920,1080,300]]],["nvidia geforce rtx 3060 lite hash rate","3060",0,[[1920,1080,60]]],["nvidia geforce rtx 3060 mobile / max-q","3060",0,[[1920,1080,435]]],["nvidia geforce rtx 3060 ti","3060",0,[[1920,1080,779]]],["nvidia geforce rtx 3070","3070",0,[[1920,1080,723],[2560,1440,294]]],["nvidia geforce rtx 3070 laptop gpu","3070",0,[[1920,1080,357]]],["nvidia geforce rtx 3070 mobile / max-q","3070",0,[[2560,1440,386]]],["nvidia geforce rtx 3070 ti","3070",0,[[1920,1080,60]]],["nvidia geforce rtx 3080","3080",0,[[1920,1080,726],[2560,1440,60],[3840,2160,60]]],["nvidia geforce rtx 3080 laptop gpu","3080",0,[[1920,1080,294],[2560,1440,244]]],["nvidia geforce rtx 3080 mobile / max-q 8gb/16gb","3080",0,[[1920,1080,293]]],["nvidia geforce rtx 3080 ti","3080",0,[[1920,1080,239],[2560,1440,60]]],["nvidia geforce rtx 3090","3090",0,[[2560,1440,60],[3840,2160,474]]],["nvidia geforce rtx t10-16","10",0,[[2560,1600,3]]],["nvidia geforce rtx t10-8","10",0,[[2560,1600,3]]],["nvidia gigabyte geforce gt 440","440",0,[[1280,1024,34]]],["nvidia gigabyte geforce gt 610","610",0,[[1920,1080,17]]],["nvidia gigabyte geforce gt 630","630",0,[[1920,1080,34]]],["nvidia gigabyte geforce gt 730","730",0,[[1280,1024,38]]],["nvidia gigabyte geforce gts 450","450",0,[[1280,1024,37]]],["nvidia gigabyte geforce gtx 1050 ti","1050",0,[[1920,1080,30]]],["nvidia gigabyte geforce gtx 460","460",0,[[1680,1050,60]]],["nvidia gigabyte geforce gtx 550 ti","550",0,[[1920,1080,57]]],["nvidia gigabyte geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 570 hd","570",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 580","580",0,[[1920,1200,60]]],["nvidia gigabyte geforce gtx 650","650",0,[[1680,1050,55]]],["nvidia gigabyte geforce gtx 650 ti","650",0,[[2560,1440,40]]],["nvidia gigabyte geforce gtx 660","660",0,[[1920,1080,31]]],["nvidia gigabyte geforce gtx 660 ti","660",0,[[5120,2880,29]]],["nvidia gigabyte geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 750","750",0,[[1920,1080,59]]],["nvidia gigabyte geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 760","760",0,[[3440,1440,17]]],["nvidia gigabyte geforce gtx 770","770",0,[[2560,1440,59]]],["nvidia gigabyte geforce gtx 780 ti","780",0,[[1920,1080,240]]],["nvidia gigabyte geforce gtx 960","960",0,[[1920,1080,142],[1920,1200,120]]],["nvidia gigabyte geforce gtx 970","970",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 980","980",0,[[2560,1440,60]]],["nvidia gigabyte geforce gtx 980 ti","980",0,[[1920,1080,60]]],["nvidia hp geforce gt 730","730",0,[[1920,1080,55]]],["nvidia inno3d geforce gtx660","3",0,[[2560,1440,107]]],["nvidia msi geforce gt 610","610",0,[[1920,1080,16]]],["nvidia msi geforce gt 630","630",0,[[1440,900,12]]],["nvidia msi geforce gt 635","635",0,[[1920,1080,30]]],["nvidia msi geforce gt 710","710",0,[[1920,1080,27]]],["nvidia msi geforce gt 730","730",0,[[1920,1080,53]]],["nvidia msi geforce gtx 1050 ti","1050",0,[[1920,1080,59]]],["nvidia msi geforce gtx 1060","1060",0,[[1920,1080,120]]],["nvidia msi geforce gtx 1070","1070",0,[[1920,1200,45]]],["nvidia msi geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia msi geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia msi geforce gtx 570 hd","570",0,[[1920,1200,60]]],["nvidia msi geforce gtx 580","580",0,[[2560,1440,60]]],["nvidia msi geforce gtx 650","650",0,[[2560,1080,52]]],["nvidia msi geforce gtx 650 ti","650",0,[[1920,1080,60]]],["nvidia msi geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia msi geforce gtx 660 ti","660",0,[[1680,1050,49]]],["nvidia msi geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia msi geforce gtx 745","745",0,[[1920,1080,55]]],["nvidia msi geforce gtx 760","760",0,[[1280,1024,30],[1920,1080,58]]],["nvidia msi geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia msi geforce gtx 950","950",0,[[1920,1080,59]]],["nvidia msi geforce gtx 960","960",0,[[1680,1050,120],[2560,1440,59]]],["nvidia msi geforce gtx 970","970",0,[[1680,1050,60]]],["nvidia msi geforce gtx 980","980",0,[[1920,1080,120],[3840,2160,60]]],["nvidia msi geforce gtx 980 ti","980",0,[[5120,2880,56]]],["nvidia null geforce 920a","920",0,[[1920,1080,25]]],["nvidia palit geforce gtx 650","650",0,[[1920,1080,49]]],["nvidia palit geforce gtx 650 ti","650",0,[[1920,1080,59]]],["nvidia palit geforce gtx 660","660",0,[[1920,1080,26]]],["nvidia pegatron geforce gt 420","420",0,[[1400,1050,25]]],["nvidia pny geforce gt 610","610",0,[[1280,1024,19]]],["nvidia pny geforce gtx 1060","1060",0,[[1920,1080,60]]],["nvidia pny geforce gtx 460","460",0,[[1360,768,59]]],["nvidia pny geforce gtx 550 ti","550",0,[[1920,1080,55]]],["nvidia pny geforce gtx 570 hd","570",0,[[1280,1024,72]]],["nvidia pny geforce gtx 580","580",0,[[1920,1200,59]]],["nvidia pny geforce gtx 680","680",0,[[2560,1080,120]]],["nvidia pny geforce gtx 750","750",0,[[1280,1024,60]]],["nvidia pny geforce gtx 970","970",0,[[2560,1440,60]]],["nvidia pny geforce gtx 980","980",0,[[1920,1080,120]]],["nvidia point of view geforce gtx 470","470",0,[[1920,1080,59]]],["nvidia point of view geforce gtx 660 ti","660",0,[[1680,1050,59]]],["nvidia sony geforce 410m","410",0,[[1366,768,24]]],["nvidia toshiba geforce gt 525m","525",0,[[1366,768,33]]],["nvidia zotac geforce gt 430","430",0,[[1600,900,32]]],["nvidia zotac geforce gt 610","610",0,[[1920,1080,15]]],["nvidia zotac geforce gt 630","630",0,[[1360,768,46]]],["nvidia zotac geforce gt 740","740",0,[[1280,1024,118]]],["nvidia zotac geforce gtx 460","460",0,[[1920,1080,59]]],["nvidia zotac geforce gtx 550 ti","550",0,[[1920,1080,42]]],["nvidia zotac geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 580","580",0,[[1920,1080,48]]],["nvidia zotac geforce gtx 650","650",0,[[1920,1080,44]]],["nvidia zotac geforce gtx 650 ti","650",0,[[1920,1080,58]]],["nvidia zotac geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 680","680",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 750","750",0,[[1680,1050,114],[1920,1080,60]]],["nvidia zotac geforce gtx 760","760",0,[[1920,1080,101]]],["nvidia zotac geforce gtx 770","770",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 960","960",0,[[2048,1152,60]]]]\')},178:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["intel","",0,[[4096,2304,12]]],["intel 0x496e74656c2048442047726170686963000732034343","0",0,[[1920,1080,22]]],["intel broxton-p hd","p",0,[[1920,1080,73]]],["intel cherryview hd","hd",0,[[1920,1080,16]]],["intel coffee lake uhd","uhd",0,[[1920,1080,49]]],["intel cometlake uhd graphics 630","630",0,[[2560,1440,40]]],["intel corporation 2nd gen core processor family integrated graphics controller","2",0,[[1366,768,25]]],["intel corporation 2nd generation core processor family integrated graphics controller","2",0,[[1600,900,28]]],["intel corporation 3rd gen core processor graphics controller","3",0,[[1366,768,20]]],["intel corporation 8th gen core processor gaussian mixture model","8",0,[[1366,768,17]]],["intel corporation atom processor z36xxx/z37xxx series graphics & display","36",0,[[1280,799,18],[1366,768,18]]],["intel corporation atom/celeron/pentium processor n4200 series integrated graphics controller","4200",0,[[1280,1024,28]]],["intel corporation atom/celeron/pentium processor x5-e8000 integrated graphics controller","5",0,[[1366,768,34]]],["intel corporation atom/celeron/pentium processor x5-e8000 series pci configuration registers","5",0,[[1920,1080,14]]],["intel corporation broadwell-u integrated","u",0,[[1920,1080,38]]],["intel corporation celeron n3350 n4200/atom e3900 series integrated graphics controller","3350",0,[[1680,1050,33]]],["intel corporation coffeelake-h gt2 [uhd graphics 630]","2",0,[[1920,1080,76]]],["intel corporation cometlake-h gt2 [uhd graphics]","2",0,[[3072,1728,29]]],["intel corporation cometlake-s gt2 [uhd graphics 630]","2",0,[[1920,1080,52]]],["intel corporation cometlake-u gt2 [uhd graphics]","2",0,[[1920,1080,39]]],["intel corporation device","",0,[[1920,1080,31]]],["intel corporation geminilake [uhd graphics 600]","600",0,[[1920,1080,15]]],["intel corporation haswell-ult integrated graphics controller","ult",0,[[1366,768,35]]],["intel corporation hd","hd",0,[[1920,1080,24]]],["intel corporation hd graphics 500","500",0,[[1366,768,19]]],["intel corporation hd graphics 510","510",0,[[1368,768,48]]],["intel corporation hd graphics 515","515",0,[[1920,1080,29]]],["intel corporation hd graphics 520","520",0,[[1366,768,59]]],["intel corporation hd graphics 530","530",0,[[1920,1080,58]]],["intel corporation hd graphics 5300","5300",0,[[1920,1080,35]]],["intel corporation hd graphics 5500","5500",0,[[1920,1080,36]]],["intel corporation hd graphics 610","610",0,[[1920,1080,28]]],["intel corporation hd graphics 620","620",0,[[1920,1080,56],[3200,1800,17]]],["intel corporation hd graphics 630","630",0,[[1920,1080,58]]],["intel corporation iris graphics 540","540",0,[[1920,1080,54]]],["intel corporation iris graphics 6100","6100",0,[[2560,1600,20]]],["intel corporation iris plus graphics 650","650",0,[[1440,900,60]]],["intel corporation iris plus graphics 655","655",0,[[1920,1080,119]]],["intel corporation iris plus graphics g1","1",0,[[1920,1080,57]]],["intel corporation iris plus graphics g7","7",0,[[1920,1080,112]]],["intel corporation iris pro graphics 580","580",0,[[1920,1080,60]]],["intel corporation iris pro graphics 6200","6200",0,[[2560,1080,41]]],["intel corporation iris xe","xe",0,[[1920,1200,60]]],["intel corporation sky lake integrated","sky",0,[[2560,1440,52]]],["intel corporation skylake gt2 [hd graphics 520]","2",0,[[1920,1080,52],[2560,1440,31]]],["intel corporation skylake integrated","",0,[[1920,1080,51]]],["intel corporation tigerlake gt2 [iris xe graphics]","2",0,[[1920,1080,60]]],["intel corporation tigerlake-lp gt2 [iris xe graphics]","2",0,[[1920,1080,60]]],["intel corporation uhd","uhd",0,[[1920,1080,65]]],["intel corporation uhd graphics 605","605",0,[[1920,1080,21]]],["intel corporation uhd graphics 615","615",0,[[1920,1080,30]]],["intel corporation uhd graphics 620","620",0,[[1920,1080,55]]],["intel corporation uhd graphics 630","630",0,[[1920,1080,57]]],["intel corporation whiskeylake-u gt2 [uhd graphics 620]","2",0,[[1920,1080,57]]],["intel corporation xeon e3-1200 v2 gen core processor graphics controller","3",0,[[1920,1080,15]]],["intel corporation xeon e3-1200 v3 gen core processor integrated graphics controller","3",0,[[1360,768,42],[1440,900,34],[1280,1024,23],[1920,1080,22]]],["intel corporation, series chipset iris plus graphics 655","655",0,[[1920,1080,42]]],["intel geforce gtx 960","960",0,[[1920,1080,26]]],["intel gen12 desktop graphics controller","12",0,[[3840,2160,20]]],["intel graphics gfx-driver-user-feature_dg1_poweron-27723 dch releaseinternal","1",0,[[3840,2160,11]]],["intel hd","hd",0,[[1280,800,18],[1366,768,26],[1600,900,12],[1920,1080,13],[1920,1200,16],[1920,1280,18],[3000,2002,6],[4096,2160,4]]],["intel hd 4000","4000",0,[[1366,768,37]]],["intel hd 530","530",0,[[1920,1200,54]]],["intel hd graphics 3000","3000",0,[[1920,1080,21]]],["intel hd graphics 4000","4000",0,[[1280,800,41],[1366,768,33],[1440,900,31],[1680,1050,50],[1920,1080,27],[2560,1600,13],[2880,1800,12]]],["intel hd graphics 4000,,,,,,,","4000",0,[[1920,1080,19]]],["intel hd graphics 4400","4400",0,[[1366,768,28],[1280,1024,48],[1920,1080,18],[2160,1440,20]]],["intel hd graphics 4600","4600",0,[[1366,768,14],[1280,960,65],[1280,1024,60],[1600,900,33],[1680,1050,31],[1600,1200,47],[1920,1080,19],[1920,1200,22],[2880,1620,14]]],["intel hd graphics 500","500",0,[[1920,1080,15]]],["intel hd graphics 5000","5000",0,[[1366,768,45],[1440,900,42],[1920,1032,25],[1920,1080,27],[2160,1439,19],[2160,1440,23],[2560,1440,15]]],["intel hd graphics 505","505",0,[[1366,768,28],[1920,1080,16]]],["intel hd graphics 510","510",0,[[1366,768,29],[1440,900,46],[1680,1050,12],[1920,1080,27]]],["intel hd graphics 515","515",0,[[1920,1080,45],[2720,768,22],[1920,1280,41],[2160,1440,28],[2560,1600,16],[2736,1824,19],[3200,1800,12],[3840,2160,10]]],["intel hd graphics 520","520",0,[[1366,768,90],[1920,1080,30],[2736,1824,26],[3000,2000,21]]],["intel hd graphics 530","530",0,[[1366,768,21],[1280,1024,65],[1920,1080,47],[1920,1200,39],[3840,2160,6]]],["intel hd graphics 5300","5300",0,[[1920,1080,21],[2304,1440,19],[2560,1600,13]]],["intel hd graphics 5500","5500",0,[[1366,768,37],[1920,1080,21]]],["intel hd graphics 5600","5600",0,[[1920,1080,26],[1920,1200,40],[2880,1620,21]]],["intel hd graphics 6000","6000",0,[[1366,768,43],[1440,900,40],[1920,1080,21]]],["intel hd graphics 610","610",0,[[1366,768,33],[1600,900,42],[1920,1080,27],[3840,2160,8]]],["intel hd graphics 615","615",0,[[1600,900,13],[1920,1080,18],[1800,1200,29],[1920,1200,34],[2560,1440,25],[2560,1600,21],[2736,1824,21]]],["intel hd graphics 620","620",0,[[1920,1080,37],[2736,1824,27],[3200,1800,25],[3840,2160,13]]],["intel hd graphics 630","630",0,[[1366,768,69],[1920,1080,40],[2560,1440,27],[2560,1600,23],[3360,2100,56],[3840,2160,12]]],["intel hd graphics 630 gt2","630",0,[[1920,1080,39],[1720,1440,120]]],["intel hd graphics cfl crb","hdcfl",0,[[2560,1440,38]]],["intel hd graphics family","hd",0,[[1366,768,44]]],["intel hd graphics icl rvp","hdicl",0,[[1920,1080,58]]],["intel hd graphics icl rvp bigsur","hdicl",0,[[1920,1080,57]]],["intel hd graphics kbl crb","hdkbl",0,[[1920,1080,57],[3840,2160,13]]],["intel hd graphics p4600","4600",0,[[1280,1024,57],[1920,1080,18],[2560,1600,60]]],["intel hd graphics p530","530",0,[[2560,1440,36],[3840,2160,12]]],["intel hd graphics p630","630",0,[[1440,900,35],[1920,1200,50]]],["intel hd graphics, gen10","10",0,[[3840,2160,4]]],["intel hd5500 broadwell pg7","5500",0,[[1366,768,31]]],["intel hd5500 graphics pg7","5500",0,[[1366,768,56]]],["intel iris","",0,[[1366,768,57],[1600,900,34],[1920,1080,34],[2560,1600,17],[2880,1800,14]]],["intel iris graphics 5100","5100",0,[[1920,1080,35],[2560,1600,18]]],["intel iris graphics 540","540",0,[[1920,1080,20],[2736,1824,28],[2880,1800,23],[3200,1800,17],[3840,2160,17]]],["intel iris graphics 550","550",0,[[1920,1080,81],[2160,1440,45],[2560,1600,28],[2880,1800,26],[3840,2160,24]]],["intel iris graphics 6100","6100",0,[[1920,1080,26],[2560,1600,19],[3840,2160,10]]],["intel iris graphics 6200","6200",0,[[4096,2304,13]]],["intel iris graphics 640","640",0,[[2256,1504,24],[3840,2160,9]]],["intel iris graphics 650","650",0,[[2560,1440,24]]],["intel iris graphics p580","580",0,[[3840,2160,12]]],["intel iris plus","",0,[[1920,1080,60],[2256,1504,95],[2496,1664,93],[2736,1824,60],[2880,1800,60],[3000,2000,56]]],["intel iris plus graphics 640","640",0,[[1920,1080,87],[2256,1504,46],[2560,1600,44],[2735,1823,28],[2736,1824,28],[2880,1800,26],[3072,1728,25],[3200,1800,37],[3840,2160,16]]],["intel iris plus graphics 645","645",0,[[2560,1599,32],[2560,1600,56],[2880,1800,47]]],["intel iris plus graphics 650","650",0,[[1920,1080,60],[2560,1600,49],[2880,1800,27],[3840,2160,16]]],["intel iris plus graphics 655","655",0,[[1920,1080,58],[2560,1440,85],[2880,1800,32],[3840,2160,24]]],["intel iris pro","pro",0,[[1920,1080,56]]],["intel iris pro graphics 5200","5200",0,[[1920,1080,53],[2879,1800,24],[2880,1800,21]]],["intel iris pro graphics 580","580",0,[[1920,1080,58],[2560,1080,91],[2560,1440,58],[3840,1600,27]]],["intel iris pro graphics 6200","6200",0,[[1366,696,38],[1920,1080,58],[1920,1200,60],[3840,2160,19],[4096,2304,14]]],["intel iris pro graphics p580","580",0,[[1024,768,42],[1920,1080,103],[3840,2160,27]]],["intel iris pro graphics p6300","6300",0,[[1366,768,102],[1440,900,128],[1920,1080,30]]],["intel iris xe","xe",0,[[1920,1080,88]]],["intel iris xe graphics releaseinternal","xe",0,[[3840,2160,38]]],["intel iris xe max","xe",0,[[1920,1080,60],[3840,2160,56]]],["intel kabylake hd graphics ult gt2","2",0,[[3840,2160,11]]],["intel kabylake hd graphics ulx gt2","2",0,[[1920,1080,28],[3840,2160,6]]],["intel kbl unknown","kbl",0,[[1920,1080,54]]],["intel mesa dri intel bay trail","dribay",0,[[1366,768,14]]],["intel mesa dri intel haswell mobile","dri",0,[[1920,1080,27]]],["intel mesa dri intel hd","drihd",0,[[1920,1080,10]]],["intel mesa dri intel hd graphics 400","400",0,[[1366,768,30]]],["intel mesa dri intel hd graphics 505","505",0,[[1920,1080,27]]],["intel mesa dri intel hd graphics 520","520",0,[[1920,1080,45],[2560,1440,24]]],["intel mesa dri intel hd graphics 530","530",0,[[3840,2160,12]]],["intel mesa dri intel hd graphics 5500","5500",0,[[1366,768,40]]],["intel mesa dri intel hd graphics 620","620",0,[[1920,1080,53]]],["intel mesa dri intel hd graphics 630","630",0,[[1477,831,58]]],["intel mesa dri intel hd graphics p4000","4000",0,[[1920,1080,36]]],["intel mesa dri intel iris graphics 540","540",0,[[1280,720,40]]],["intel mesa dri intel ivybridge desktop","dri",0,[[2560,1080,16]]],["intel mesa dri intel ivybridge mobile","dri",0,[[1920,1080,25]]],["intel mesa dri intel kabylake gt2","2",0,[[1920,1080,36]]],["intel mesa dri intel sandybridge desktop","dri",0,[[1280,1024,12]]],["intel mesa dri intel sandybridge mobile","dri",0,[[1366,768,33]]],["intel mesa dri intel uhd graphics 620","620",0,[[2736,1824,22]]],["intel mesa dri intel uhd graphics 630","630",0,[[1920,1080,42]]],["intel mesa intel hd graphics 520","520",0,[[1920,1080,47]]],["intel mesa intel hd graphics 530","530",0,[[1920,1080,55]]],["intel phdgd ivy 4","4",0,[[1366,768,45]]],["intel radeon pro vega 16","16",0,[[3360,1890,20]]],["intel radeong 0.4 on amd bonaire","0",0,[[1920,1200,92]]],["intel radeong 0.4 on amd cape verde","0",0,[[1920,1200,73]]],["intel radeong 0.4 on amd polaris10","0",0,[[3840,2160,108]]],["intel radeong 0.4 on amd tonga","0",0,[[1920,1080,124]]],["intel skl unknown","skl",0,[[1920,1080,43]]],["intel skylake gt2 [hd graphics 520]","2",0,[[1920,1080,39]]],["intel uhd","uhd",0,[[1920,1080,58],[2560,1600,22],[3440,1440,14],[2736,1824,32],[3840,2160,31]]],["intel uhd 630","630",0,[[2560,1440,38]]],["intel uhd graphics 600","600",0,[[1366,768,27],[1920,1080,13],[1920,1200,13],[2560,1440,11],[3840,2160,5]]],["intel uhd graphics 600 universal","600",0,[[1919,1031,15]]],["intel uhd graphics 605","605",0,[[1366,768,29],[1920,1080,37]]],["intel uhd graphics 610","610",0,[[1366,768,58],[1920,1080,32],[1920,1200,37],[2560,1440,17],[3840,2160,11]]],["intel uhd graphics 615","615",0,[[1920,1080,34],[1920,1280,29],[3840,2160,9]]],["intel uhd graphics 617","617",0,[[1920,1080,43],[2560,1599,24],[2560,1600,26],[2880,1800,24]]],["intel uhd graphics 620","620",0,[[1920,1080,50],[2736,1824,33],[3200,1800,16]]],["intel uhd graphics 630","630",0,[[1440,900,112],[1920,1080,44],[1920,1200,65],[2560,1080,68],[2560,1440,26],[3440,1440,25],[3584,2240,137],[3840,2160,12],[6016,3384,8]]],["intel uhd graphics 730","730",0,[[1920,1080,53]]],["intel uhd graphics 750","750",0,[[1920,1080,56],[3840,2160,36]]],["intel uhd graphics 770","770",0,[[3440,1440,78],[5120,1440,31]]],["intel uhd graphics gfx-driver-user-comp_core-23599","23599",0,[[3840,2160,18]]],["intel uhd graphics p630","630",0,[[1920,1080,54],[3840,2160,21]]],["intel uhd graphics releaseinternal","uhd",0,[[3199,1800,22],[3000,2000,47]]],["intel uhd graphics, gen11 lp","11",0,[[3840,2160,10]]],["intel uhd graphics, gen12 lp releaseinternal","12",0,[[3839,2159,4]]],["intel uhd graphics, lkf","uhdlkf",0,[[1927,1439,14]]],["intel unknown","",0,[[1920,1080,37]]],["intel xe","xe",0,[[1920,1080,268],[2560,1440,137]]],["intel xeon e3-1200 v3 gen core processor integrated graphics controller","3",0,[[1600,900,49]]]]\')},217:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["nvidia %nvidia_dev.13d7.0580.1028%","13",0,[[1920,1018,60]]],["nvidia a100-pcie-40gb","100",0,[[1920,1080,449]]],["nvidia a40","40",0,[[1920,1080,504]]],["nvidia a40-8q","40",0,[[2560,1440,58]]],["nvidia ashley","",0,[[1920,1080,60]]],["nvidia asus geforce gt 430","430",0,[[1366,768,35]]],["nvidia asus geforce gt 440","440",0,[[1920,1080,28]]],["nvidia asus geforce gt 520","520",0,[[1680,1050,12]]],["nvidia asus geforce gt 610","610",0,[[1920,1200,15]]],["nvidia asus geforce gt 630","630",0,[[1680,1050,41]]],["nvidia asus geforce gt 640","640",0,[[2560,1440,34]]],["nvidia asus geforce gt 710","710",0,[[1920,1080,31]]],["nvidia asus geforce gt 730","730",0,[[2560,1080,28],[3840,2160,12]]],["nvidia asus geforce gts 450","450",0,[[1920,1080,54]]],["nvidia asus geforce gtx 1060","1060",0,[[3840,2160,38]]],["nvidia asus geforce gtx 1080","1080",0,[[2560,1440,120]]],["nvidia asus geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia asus geforce gtx 480","480",0,[[1920,1080,59]]],["nvidia asus geforce gtx 550 ti","550",0,[[1920,1080,57]]],["nvidia asus geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia asus geforce gtx 560 se","560",0,[[1920,1080,59]]],["nvidia asus geforce gtx 560 ti","560",0,[[1680,1050,58]]],["nvidia asus geforce gtx 570","570",0,[[1280,1024,74]]],["nvidia asus geforce gtx 570 hd","570",0,[[1920,1080,60]]],["nvidia asus geforce gtx 580","580",0,[[1920,1200,59]]],["nvidia asus geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia asus geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia asus geforce gtx 750 ti","750",0,[[1360,768,59],[1920,1080,118]]],["nvidia asus geforce gtx 760","760",0,[[1920,1080,60],[1920,1200,60]]],["nvidia asus geforce gtx 770","770",0,[[1920,1080,60]]],["nvidia asus geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia asus geforce gtx 950","950",0,[[1920,1080,60]]],["nvidia asus geforce gtx 960","960",0,[[1920,1080,60],[2560,1600,117]]],["nvidia asus geforce gtx 970","970",0,[[2560,1600,60]]],["nvidia asus geforce gtx 980 ti","980",0,[[2560,1440,131]]],["nvidia chip model","",0,[[1920,1080,60]]],["nvidia colorful geforce gtx 960","960",0,[[2560,1440,60]]],["nvidia dell nvs 5200m","5200",0,[[1920,1080,27]]],["nvidia dell quadro 2000m","2000",0,[[1920,1080,29]]],["nvidia device","",0,[[1920,1080,746]]],["nvidia elitegroup geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia evga geforce gt 545","545",0,[[1920,1080,37]]],["nvidia evga geforce gt 640","640",0,[[1366,768,60]]],["nvidia evga geforce gt 710","710",0,[[1680,1050,36],[1920,1080,29]]],["nvidia evga geforce gt 730","730",0,[[1600,900,59]]],["nvidia evga geforce gt 740","740",0,[[1280,1024,45]]],["nvidia evga geforce gtx 1050 ti","1050",0,[[2560,1440,60],[4096,2304,58]]],["nvidia evga geforce gtx 1070","1070",0,[[5120,2880,60]]],["nvidia evga geforce gtx 1080 ti","1080",0,[[1920,1200,60]]],["nvidia evga geforce gtx 560 ti","560",0,[[1680,1050,59]]],["nvidia evga geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia evga geforce gtx 580","580",0,[[2560,1440,60]]],["nvidia evga geforce gtx 650","650",0,[[1920,1200,87],[2560,1600,43]]],["nvidia evga geforce gtx 650 ti","650",0,[[1680,1050,116],[2560,1440,55]]],["nvidia evga geforce gtx 650 ti boost","650",0,[[1920,1080,56]]],["nvidia evga geforce gtx 660 ti","660",0,[[1920,1200,60]]],["nvidia evga geforce gtx 680","680",0,[[1600,1200,60]]],["nvidia evga geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia evga geforce gtx 760","760",0,[[1920,1080,119],[1920,1200,60]]],["nvidia evga geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia evga geforce gtx 960","960",0,[[1920,1080,60],[2560,1440,115]]],["nvidia evga geforce gtx 970","970",0,[[1920,1080,120]]],["nvidia evga geforce gtx 980","980",0,[[3440,1440,60]]],["nvidia evga geforce gtx 980 ti","980",0,[[1920,1080,60]]],["nvidia ga104gl [rtx a4000]","104",0,[[3840,2160,60]]],["nvidia gainward geforce gt 630","630",0,[[1920,1080,28]]],["nvidia gainward geforce gts 450","450",0,[[1920,1080,55]]],["nvidia gainward geforce gtx 460","460",0,[[1920,1080,58]]],["nvidia gainward geforce gtx 550 ti","550",0,[[1280,1024,67]]],["nvidia gainward geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia gainward geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia gainward geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia geforce 210","210",0,[[1920,1080,8]]],["nvidia geforce 410m","410",0,[[1366,768,25],[1600,900,19]]],["nvidia geforce 510","510",0,[[1280,960,20]]],["nvidia geforce 605","605",0,[[1768,992,17],[1920,1080,15]]],["nvidia geforce 610m","610",0,[[1366,768,26]]],["nvidia geforce 610m/710m/810m/820m / gt 620m/625m/630m/720m","610",0,[[1366,768,51]]],["nvidia geforce 615","615",0,[[1920,1080,21]]],["nvidia geforce 705m","705",0,[[1920,1080,18]]],["nvidia geforce 710a","710",0,[[1920,1080,32]]],["nvidia geforce 710m","710",0,[[1366,768,55]]],["nvidia geforce 730a","730",0,[[1920,1080,37]]],["nvidia geforce 800m","800",0,[[1920,1080,18]]],["nvidia geforce 810m","810",0,[[1366,768,44],[1920,1080,31]]],["nvidia geforce 820a","820",0,[[1920,1080,28]]],["nvidia geforce 820m","820",0,[[1366,768,57],[1920,1080,23]]],["nvidia geforce 830a","830",0,[[1920,1080,53]]],["nvidia geforce 830m","830",0,[[1366,768,60]]],["nvidia geforce 8400 gs","8400",0,[[1680,1050,4]]],["nvidia geforce 8400 gs rev. 3","8400",0,[[1920,1080,4]]],["nvidia geforce 840a","840",0,[[1920,1080,56]]],["nvidia geforce 840m","840",0,[[1920,1080,56]]],["nvidia geforce 845m","845",0,[[1920,1080,59]]],["nvidia geforce 8600 gt","8600",1,[[1920,1200,-1]]],["nvidia geforce 8600 gts","8600",1,[[1920,1080,-1]]],["nvidia geforce 910m","910",0,[[1366,768,58],[1600,900,45]]],["nvidia geforce 920m","920",0,[[1366,768,60]]],["nvidia geforce 920mx","920",0,[[1366,768,60],[1920,1080,60]]],["nvidia geforce 9300 / nforce 730i","9300",0,[[1920,1080,6]]],["nvidia geforce 930a","930",0,[[1920,1080,55]]],["nvidia geforce 930m","930",0,[[1366,768,60]]],["nvidia geforce 930mx","930",0,[[1366,768,89],[1920,1080,59]]],["nvidia geforce 9400 gt","9400",1,[[1366,768,-1]]],["nvidia geforce 940a","940",0,[[1920,1080,58]]],["nvidia geforce 940m","940",0,[[1920,1080,54]]],["nvidia geforce 940mx","940",0,[[1920,1080,60]]],["nvidia geforce 945m","945",0,[[1920,1080,59]]],["nvidia geforce 9600 gt","9600",0,[[1920,1200,2]]],["nvidia geforce 9600m gt","9600",1,[[1440,900,-1]]],["nvidia geforce 9800 gt","9800",0,[[1920,1200,52]]],["nvidia geforce 9800 gtx / 9800 gtx+","9800",0,[[1280,1024,59]]],["nvidia geforce gpu","gpu",0,[[3000,2000,36]]],["nvidia geforce gt 1010","1010",0,[[1920,1080,135]]],["nvidia geforce gt 1030","1030",0,[[1920,1080,60]]],["nvidia geforce gt 1030 opengl engine","1030",0,[[6720,3780,15]]],["nvidia geforce gt 120","120",1,[[1920,1080,-1]]],["nvidia geforce gt 240","240",0,[[1366,768,32]]],["nvidia geforce gt 320m","320",0,[[1366,768,26]]],["nvidia geforce gt 415m","415",0,[[1366,768,19]]],["nvidia geforce gt 420","420",0,[[1024,768,33],[1920,1080,20]]],["nvidia geforce gt 420m","420",0,[[1366,768,28]]],["nvidia geforce gt 425m","425",0,[[1366,768,55],[1600,900,28]]],["nvidia geforce gt 430","430",0,[[1600,1200,16],[1920,1080,28]]],["nvidia geforce gt 435m","435",0,[[1366,768,53],[1920,1080,22]]],["nvidia geforce gt 440","440",0,[[1280,1024,51],[1680,1050,38],[1920,1080,45]]],["nvidia geforce gt 445m","445",0,[[1600,900,53]]],["nvidia geforce gt 520","520",0,[[1440,900,19],[1920,1080,17]]],["nvidia geforce gt 520m","520",0,[[1366,768,29]]],["nvidia geforce gt 520mx","520",0,[[1366,768,35]]],["nvidia geforce gt 525m","525",0,[[1366,768,28],[1600,900,22]]],["nvidia geforce gt 530","530",0,[[1920,1080,26]]],["nvidia geforce gt 540m","540",0,[[1366,768,38]]],["nvidia geforce gt 545","545",0,[[1920,1080,54]]],["nvidia geforce gt 550m","550",0,[[1600,900,44],[1920,1080,29]]],["nvidia geforce gt 555m","555",0,[[1920,1080,42]]],["nvidia geforce gt 555m/635m","555",0,[[1920,1080,36]]],["nvidia geforce gt 610","610",0,[[1280,1024,22],[1920,1080,15]]],["nvidia geforce gt 620","620",0,[[1920,1080,19]]],["nvidia geforce gt 620 oem","620",0,[[1920,1080,20],[1920,1200,20]]],["nvidia geforce gt 620m","620",0,[[1366,768,55],[1920,1080,30]]],["nvidia geforce gt 620m/630m/635m/640m le","620",0,[[1368,768,38]]],["nvidia geforce gt 625","625",0,[[1920,1080,18]]],["nvidia geforce gt 625m","625",0,[[1366,768,38]]],["nvidia geforce gt 630","630",0,[[1680,1050,36],[1920,1080,36],[1920,1200,30]]],["nvidia geforce gt 630 oem","630",0,[[1600,900,33]]],["nvidia geforce gt 630 opengl engine","630",0,[[1920,1080,33]]],["nvidia geforce gt 630 rev. 2","630",0,[[1920,1080,26]]],["nvidia geforce gt 630m","630",0,[[1366,768,57]]],["nvidia geforce gt 635","635",0,[[1920,1080,27]]],["nvidia geforce gt 635m","635",0,[[1366,768,47]]],["nvidia geforce gt 640","640",0,[[1920,1080,47]]],["nvidia geforce gt 640 oem","640",0,[[1920,1080,46],[2560,1440,35]]],["nvidia geforce gt 640 opengl engine","640",0,[[1280,1024,43]]],["nvidia geforce gt 640 rev. 2","640",0,[[1280,1024,60],[1920,1080,55]]],["nvidia geforce gt 640m","640",0,[[1366,768,82],[1600,900,59],[1920,1080,34]]],["nvidia geforce gt 640m le","640",0,[[1920,1080,49]]],["nvidia geforce gt 640m mac","640",0,[[1366,768,56],[1920,1080,20]]],["nvidia geforce gt 640m opengl engine","640",0,[[1920,1080,45]]],["nvidia geforce gt 645m","645",0,[[1366,768,60]]],["nvidia geforce gt 650m","650",0,[[1360,768,59],[1920,1080,58],[2560,1440,59]]],["nvidia geforce gt 650m mac","650",0,[[1440,900,56],[1920,1080,15],[2560,1440,19],[2880,1800,31]]],["nvidia geforce gt 650m opengl engine","650",0,[[1920,1080,56],[3840,2160,27]]],["nvidia geforce gt 705","705",0,[[1920,1080,11]]],["nvidia geforce gt 710","710",0,[[1920,1080,28]]],["nvidia geforce gt 710b","710",0,[[1920,1080,26]]],["nvidia geforce gt 710m","710",0,[[1366,768,46]]],["nvidia geforce gt 720","720",0,[[1920,1080,19],[2560,1440,16],[5120,2880,5]]],["nvidia geforce gt 720 opengl engine","720",0,[[2560,1600,20]]],["nvidia geforce gt 720m","720",0,[[1366,768,42]]],["nvidia geforce gt 730","730",0,[[1920,1080,54]]],["nvidia geforce gt 730a","730",0,[[1920,1080,23]]],["nvidia geforce gt 730m","730",0,[[1920,1080,43]]],["nvidia geforce gt 735m","735",0,[[1920,1080,39]]],["nvidia geforce gt 740","740",0,[[1920,1080,55],[3440,1440,23]]],["nvidia geforce gt 740 opengl engine","740",0,[[1920,1200,51]]],["nvidia geforce gt 740m","740",0,[[1366,768,60]]],["nvidia geforce gt 745m","745",0,[[1920,1080,55]]],["nvidia geforce gt 750m","750",0,[[1920,1080,57]]],["nvidia geforce gt 750m mac","750",0,[[1920,1080,58],[2880,1800,28]]],["nvidia geforce gt 755m","755",0,[[1920,1080,57]]],["nvidia geforce gt 755m mac","755",0,[[2560,1440,41]]],["nvidia geforce gt 755m opengl engine","755",0,[[2560,1440,51]]],["nvidia geforce gt 820m","820",0,[[1600,900,47]]],["nvidia geforce gts 250","250",0,[[1680,1050,53]]],["nvidia geforce gts 450","450",0,[[1360,768,60],[1680,1050,57],[1920,1080,55]]],["nvidia geforce gts 450 rev. 2","450",0,[[1920,1080,56]]],["nvidia geforce gtx 1050","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 3gb","1050",0,[[1280,1024,60]]],["nvidia geforce gtx 1050 mobile","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 opengl engine","1050",0,[[1920,1080,116]]],["nvidia geforce gtx 1050 ti","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 ti mobile","1050",0,[[1920,1080,298]]],["nvidia geforce gtx 1050 ti opengl engine","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 ti with max-q design","1050",0,[[1920,1080,268],[2560,1440,102],[3840,2160,60]]],["nvidia geforce gtx 1050 with max-q design","1050",0,[[1920,1080,60],[3840,2160,24]]],["nvidia geforce gtx 1060","1060",0,[[1920,1080,60],[3840,2160,59]]],["nvidia geforce gtx 1060 3gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 3gb opengl engine","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 5gb","1060",0,[[1920,1080,55]]],["nvidia geforce gtx 1060 6gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 6gb opengl engine","1060",0,[[1920,1080,75]]],["nvidia geforce gtx 1060 mobile","1060",0,[[1920,1080,422]]],["nvidia geforce gtx 1060 mobile 6gb","1060",0,[[1920,1080,120]]],["nvidia geforce gtx 1060 with max-q design","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060se 3gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1070","1070",0,[[1920,1080,134]]],["nvidia geforce gtx 1070 a17","1070",0,[[1920,1080,60]]],["nvidia geforce gtx 1070 mobile","1070",0,[[1920,1080,467]]],["nvidia geforce gtx 1070 opengl engine","1070",0,[[1920,1080,143]]],["nvidia geforce gtx 1070 ti","1070",0,[[1920,1080,60],[6016,3384,59]]],["nvidia geforce gtx 1070 ti opengl engine","1070",0,[[1920,1080,75]]],["nvidia geforce gtx 1070 with max-q design","1070",0,[[1920,1080,448]]],["nvidia geforce gtx 1070 with maxq design","1070",0,[[1920,1080,60],[3840,2160,59]]],["nvidia geforce gtx 1080","1080",0,[[1920,1080,119],[2560,1440,326],[3840,2160,286]]],["nvidia geforce gtx 1080 mobile","1080",0,[[1920,1080,120]]],["nvidia geforce gtx 1080 opengl engine","1080",0,[[1920,1080,79]]],["nvidia geforce gtx 1080 ti","1080",0,[[1920,1080,120]]],["nvidia geforce gtx 1080 ti opengl engine","1080",0,[[1920,1080,127]]],["nvidia geforce gtx 1080 with max-q design","1080",0,[[1920,1080,144]]],["nvidia geforce gtx 1180","1180",0,[[3440,1440,60]]],["nvidia geforce gtx 1650","1650",0,[[1920,1080,380]]],["nvidia geforce gtx 1650 mobile / max-q","1650",0,[[1920,1080,292]]],["nvidia geforce gtx 1650 super","1650",0,[[1920,1080,433]]],["nvidia geforce gtx 1650 ti","1650",0,[[1920,1080,144],[3840,2400,59]]],["nvidia geforce gtx 1650 ti mobile","1650",0,[[1920,1080,144]]],["nvidia geforce gtx 1650 ti with max-q design","1650",0,[[1920,1080,60],[3839,2160,60]]],["nvidia geforce gtx 1650 with max-q design","1650",0,[[1920,1080,142],[3000,2000,60]]],["nvidia geforce gtx 1660","1660",0,[[1920,1080,144]]],["nvidia geforce gtx 1660 super","1660",0,[[1920,1080,60]]],["nvidia geforce gtx 1660 ti","1660",0,[[1920,1080,546],[3840,2160,60]]],["nvidia geforce gtx 1660 ti mobile","1660",0,[[1920,1080,451]]],["nvidia geforce gtx 1660 ti with max-q design","1660",0,[[1920,1080,144]]],["nvidia geforce gtx 280","280",0,[[1680,1050,56]]],["nvidia geforce gtx 295","295",0,[[1920,1080,56]]],["nvidia geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia geforce gtx 460 oem","460",0,[[1360,768,60],[1920,1080,60]]],["nvidia geforce gtx 460 opengl engine","460",0,[[1920,1080,59]]],["nvidia geforce gtx 460 se","460",0,[[1920,1080,56],[1920,1200,57]]],["nvidia geforce gtx 460 v2","460",0,[[1920,1080,60],[1920,1200,60],[2560,1600,55]]],["nvidia geforce gtx 460m","460",0,[[1920,1080,46]]],["nvidia geforce gtx 465","465",0,[[1920,1080,134],[1920,1200,59]]],["nvidia geforce gtx 470","470",0,[[1680,1050,60],[1920,1080,59]]],["nvidia geforce gtx 470m","470",0,[[1920,1200,55]]],["nvidia geforce gtx 480","480",0,[[1440,900,191],[1920,1080,115],[1920,1200,60]]],["nvidia geforce gtx 480 opengl engine","480",0,[[1600,1200,60]]],["nvidia geforce gtx 550 ti","550",0,[[1280,1024,58],[1920,1080,58]]],["nvidia geforce gtx 550 ti opengl engine","550",0,[[1920,1080,55]]],["nvidia geforce gtx 555","555",0,[[1920,1080,54]]],["nvidia geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia geforce gtx 560 se","560",0,[[1680,1050,52],[1920,1080,111]]],["nvidia geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia geforce gtx 560 ti 448 cores","560",0,[[1920,1080,60],[2560,1440,60]]],["nvidia geforce gtx 560 ti oem","560",0,[[1920,1080,176]]],["nvidia geforce gtx 560 ti opengl engine","560",0,[[1920,1080,48]]],["nvidia geforce gtx 560m","560",0,[[1920,1080,55]]],["nvidia geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia geforce gtx 570 opengl engine","570",0,[[1920,1080,60]]],["nvidia geforce gtx 570 rev. 2","570",0,[[1920,1080,60],[1920,1200,60]]],["nvidia geforce gtx 570m","570",0,[[1920,1080,125],[2560,1440,8]]],["nvidia geforce gtx 580","580",0,[[1920,1080,60]]],["nvidia geforce gtx 580 opengl engine","580",0,[[1680,1050,59]]],["nvidia geforce gtx 580m","580",0,[[1920,1080,60]]],["nvidia geforce gtx 590","590",0,[[1920,1080,59]]],["nvidia geforce gtx 645","645",0,[[1920,1080,57],[1920,1200,58]]],["nvidia geforce gtx 645 opengl engine","645",0,[[1920,1200,58]]],["nvidia geforce gtx 650","650",0,[[1920,1080,72]]],["nvidia geforce gtx 650 oem","650",0,[[1366,768,59]]],["nvidia geforce gtx 650 opengl engine","650",0,[[1920,1080,59]]],["nvidia geforce gtx 650 ti","650",0,[[1920,1080,60]]],["nvidia geforce gtx 650 ti boost","650",0,[[1280,1024,60],[1600,1200,187],[1920,1080,60]]],["nvidia geforce gtx 650 ti opengl engine","650",0,[[1920,1080,60]]],["nvidia geforce gtx 660","660",0,[[1920,1080,111]]],["nvidia geforce gtx 660 oem","660",0,[[1920,1080,59]]],["nvidia geforce gtx 660 ti","660",0,[[1920,1080,60]]],["nvidia geforce gtx 660 ti opengl engine","660",0,[[1280,1024,60]]],["nvidia geforce gtx 660m","660",0,[[1680,1050,36],[1920,1080,59]]],["nvidia geforce gtx 660m mac","660",0,[[2560,1440,2]]],["nvidia geforce gtx 660m opengl engine","660",0,[[2560,1440,36]]],["nvidia geforce gtx 670","670",0,[[1920,1080,100]]],["nvidia geforce gtx 670 opengl engine","670",0,[[1920,1080,60]]],["nvidia geforce gtx 670m","670",0,[[1920,1080,66]]],["nvidia geforce gtx 670mx","670",0,[[1920,1080,60]]],["nvidia geforce gtx 675m","675",0,[[1920,1080,60]]],["nvidia geforce gtx 675mx","675",0,[[1680,1050,60],[1920,1080,60],[2560,1440,55]]],["nvidia geforce gtx 675mx mac","675",0,[[2560,1440,36]]],["nvidia geforce gtx 675mx opengl engine","675",0,[[2560,1440,60]]],["nvidia geforce gtx 680","680",0,[[1920,1080,60]]],["nvidia geforce gtx 680 opengl engine","680",0,[[1920,1080,60]]],["nvidia geforce gtx 680m","680",0,[[1920,1080,39],[1920,1200,60]]],["nvidia geforce gtx 680m opengl engine","680",0,[[1920,1080,36]]],["nvidia geforce gtx 680mx","680",0,[[2560,1440,59]]],["nvidia geforce gtx 680mx opengl engine","680",0,[[2560,1440,59]]],["nvidia geforce gtx 690","690",0,[[1920,1080,60],[3840,2160,30]]],["nvidia geforce gtx 745","745",0,[[1920,1080,60],[2560,1600,29]]],["nvidia geforce gtx 750","750",0,[[1920,1080,60]]],["nvidia geforce gtx 750 opengl engine","750",0,[[1920,1200,58]]],["nvidia geforce gtx 750 ti","750",0,[[1920,1080,97]]],["nvidia geforce gtx 760","760",0,[[1920,1080,60],[1920,1200,116]]],["nvidia geforce gtx 760 oem","760",0,[[1920,1080,60]]],["nvidia geforce gtx 760 opengl engine","760",0,[[1920,1080,52]]],["nvidia geforce gtx 760 ti","760",0,[[1920,1080,60],[1920,1200,60]]],["nvidia geforce gtx 760 ti oem","760",0,[[1920,1200,60]]],["nvidia geforce gtx 760 ti opengl engine","760",0,[[1920,1080,60]]],["nvidia geforce gtx 760a","760",0,[[2560,1080,15]]],["nvidia geforce gtx 760m","760",0,[[1920,1080,60]]],["nvidia geforce gtx 765m","765",0,[[1920,1080,53],[2560,1440,57]]],["nvidia geforce gtx 765m by nick[d]vb","765",0,[[2560,1440,58]]],["nvidia geforce gtx 765m opengl engine","765",0,[[2560,1440,57]]],["nvidia geforce gtx 770","770",0,[[1920,1080,143],[2560,1440,203]]],["nvidia geforce gtx 770 opengl engine","770",0,[[1920,1080,60]]],["nvidia geforce gtx 770m","770",0,[[1920,1080,60],[2560,1440,59]]],["nvidia geforce gtx 770m by nick[d]vb","770",0,[[2560,1440,34]]],["nvidia geforce gtx 770m opengl engine","770",0,[[2560,1440,59]]],["nvidia geforce gtx 775m by idopt mac","775",0,[[2560,1440,56]]],["nvidia geforce gtx 775m mac","775",0,[[2560,1440,59]]],["nvidia geforce gtx 775m opengl engine","775",0,[[2560,1440,60]]],["nvidia geforce gtx 780","780",0,[[1920,1080,159]]],["nvidia geforce gtx 780 by st3phl3","780",0,[[3840,2160,30]]],["nvidia geforce gtx 780 mac","780",0,[[1680,1050,60],[1920,1080,60]]],["nvidia geforce gtx 780 rev. 2","780",0,[[1920,1080,144],[2560,1440,119],[3840,2160,58],[5120,2880,58]]],["nvidia geforce gtx 780 ti","780",0,[[1280,1024,120],[1920,1080,119]]],["nvidia geforce gtx 780 ti opengl engine","780",0,[[2560,1440,60]]],["nvidia geforce gtx 780m","780",0,[[1920,1080,60],[2560,1440,59]]],["nvidia geforce gtx 780m by nick[d]vb","780",0,[[1920,1080,59],[2560,1440,60]]],["nvidia geforce gtx 780m mac","780",0,[[2560,1440,60]]],["nvidia geforce gtx 780m opengl engine","780",0,[[2560,1440,60]]],["nvidia geforce gtx 850a","850",0,[[2560,1440,48]]],["nvidia geforce gtx 850m","850",0,[[1920,1080,60]]],["nvidia geforce gtx 860m","860",0,[[1920,1080,59]]],["nvidia geforce gtx 860m opengl engine","860",0,[[2560,1440,58]]],["nvidia geforce gtx 870m","870",0,[[1920,1080,60],[2560,1440,102]]],["nvidia geforce gtx 880m","880",0,[[1920,1080,60],[2560,1440,74]]],["nvidia geforce gtx 880m opengl engine","880",0,[[2560,1440,60]]],["nvidia geforce gtx 950","950",0,[[1920,1080,98]]],["nvidia geforce gtx 950 opengl engine","950",0,[[1920,1200,60]]],["nvidia geforce gtx 950a","950",0,[[1920,1080,60],[3840,2160,38]]],["nvidia geforce gtx 950m","950",0,[[1920,1080,114]]],["nvidia geforce gtx 960","960",0,[[1920,1080,60]]],["nvidia geforce gtx 960a","960",0,[[1920,1440,128]]],["nvidia geforce gtx 960m","960",0,[[1920,1080,119],[3840,2160,37]]],["nvidia geforce gtx 965m","965",0,[[1920,1080,195],[3000,2000,59],[3840,2160,41]]],["nvidia geforce gtx 965m opengl engine","965",0,[[2880,1620,55]]],["nvidia geforce gtx 970","970",0,[[1920,1080,143]]],["nvidia geforce gtx 970 opengl engine","970",0,[[2560,1600,60]]],["nvidia geforce gtx 970m","970",0,[[1920,1080,60]]],["nvidia geforce gtx 980","980",0,[[1920,1080,60],[3440,1440,294]]],["nvidia geforce gtx 980 ti","980",0,[[1920,1080,119],[2560,1440,456]]],["nvidia geforce gtx 980 ti opengl engine","980",0,[[1920,1080,60]]],["nvidia geforce gtx 980m","980",0,[[1920,1080,60],[3840,2160,104]]],["nvidia geforce gtx titan","gtx",0,[[1920,1080,119],[1920,1200,119],[2560,1440,60]]],["nvidia geforce gtx titan black","gtx",0,[[1680,1050,60],[1920,1080,60],[1920,1200,60],[2560,1440,60]]],["nvidia geforce gtx titan black opengl engine","gtx",0,[[3840,2160,60]]],["nvidia geforce gtx titan opengl engine","gtx",0,[[2560,1440,60]]],["nvidia geforce gtx titan x","gtxx",0,[[1920,1080,144],[2560,1440,120],[2560,1600,60]]],["nvidia geforce gtx titan xp","gtxxp",0,[[2560,1440,60],[3440,1440,60]]],["nvidia geforce gtx titan z","gtxz",0,[[1440,900,59],[1920,1080,39],[3840,2160,60]]],["nvidia geforce gtx780m by nikey22","780",0,[[2560,1440,60]]],["nvidia geforce gtx870m by nikey22","870",0,[[2560,1440,60]]],["nvidia geforce gtx880m","880",0,[[1920,1080,60]]],["nvidia geforce gtx880m by nikey22","880",0,[[2560,1440,59]]],["nvidia geforce gtx880m opengl engine","880",0,[[2560,1440,59]]],["nvidia geforce mx110","110",0,[[1366,768,61],[1920,1080,57]]],["nvidia geforce mx130","130",0,[[1920,1080,60]]],["nvidia geforce mx150","150",0,[[1920,1080,113]]],["nvidia geforce mx230","230",0,[[1920,1080,60]]],["nvidia geforce mx250","250",0,[[1920,1080,60]]],["nvidia geforce mx330","330",0,[[1920,1080,60],[3840,2160,51]]],["nvidia geforce mx350","350",0,[[1920,1080,60]]],["nvidia geforce mx450","450",0,[[1920,1080,60]]],["nvidia geforce pre-release graphics device","pre",0,[[2560,1440,60]]],["nvidia geforce pre-release tesla c2075 opengl engine","2075",0,[[1600,900,59]]],["nvidia geforce pre-release titan x opengl engine","prex",0,[[1920,1080,60]]],["nvidia geforce pre-release titan xp collectors edition opengl e","prexpe",0,[[1920,1080,59]]],["nvidia geforce pre-release titan xp opengl engine","prexp",0,[[2560,1440,60]]],["nvidia geforce rtx 2060","2060",0,[[1920,1080,512]]],["nvidia geforce rtx 2060 max-q","2060",0,[[2560,1440,301]]],["nvidia geforce rtx 2060 mobile","2060",0,[[1920,1080,518]]],["nvidia geforce rtx 2060 rev. a","2060",0,[[3840,2160,257]]],["nvidia geforce rtx 2060 super","2060",0,[[1920,1080,645],[2560,1440,143]]],["nvidia geforce rtx 2060 with max-q design","2060",0,[[1920,1080,292],[1920,1200,60]]],["nvidia geforce rtx 2070","2070",0,[[1920,1080,60],[3840,2160,60]]],["nvidia geforce rtx 2070 mobile","2070",0,[[1920,1080,477]]],["nvidia geforce rtx 2070 mobile / max-q","2070",0,[[1920,1080,526]]],["nvidia geforce rtx 2070 mobile / max-q refresh","2070",0,[[1920,1080,143]]],["nvidia geforce rtx 2070 rev. a","2070",0,[[2560,1440,144]]],["nvidia geforce rtx 2070 super","2070",0,[[1920,1080,510]]],["nvidia geforce rtx 2070 super with max-q design","2070",0,[[1920,1080,300]]],["nvidia geforce rtx 2070 with max-q design","2070",0,[[1920,1080,240]]],["nvidia geforce rtx 2080","2080",0,[[1920,1080,632],[2560,1440,165]]],["nvidia geforce rtx 2080 mobile","2080",0,[[1920,1080,144]]],["nvidia geforce rtx 2080 rev. a","2080",0,[[2560,1440,143]]],["nvidia geforce rtx 2080 super","2080",0,[[1920,1080,601]]],["nvidia geforce rtx 2080 super mobile / max-q","2080",0,[[3840,2160,59]]],["nvidia geforce rtx 2080 super with max-q design","2080",0,[[1920,1080,300]]],["nvidia geforce rtx 2080 ti","2080",0,[[1920,1080,83]]],["nvidia geforce rtx 2080 ti rev. a","2080",0,[[1920,1080,403]]],["nvidia geforce rtx 2080 with max-q design","2080",0,[[1920,1080,476]]],["nvidia geforce rtx 3050","3050",0,[[1920,1080,60]]],["nvidia geforce rtx 3050 laptop gpu","3050",0,[[1920,1080,144]]],["nvidia geforce rtx 3050 ti laptop gpu","3050",0,[[1920,1080,144]]],["nvidia geforce rtx 3060","3060",0,[[1920,1080,674]]],["nvidia geforce rtx 3060 laptop gpu","3060",0,[[1920,1080,300]]],["nvidia geforce rtx 3060 lite hash rate","3060",0,[[1920,1080,60]]],["nvidia geforce rtx 3060 mobile / max-q","3060",0,[[1920,1080,435]]],["nvidia geforce rtx 3060 ti","3060",0,[[1920,1080,779]]],["nvidia geforce rtx 3070","3070",0,[[1920,1080,723],[2560,1440,294]]],["nvidia geforce rtx 3070 laptop gpu","3070",0,[[1920,1080,357]]],["nvidia geforce rtx 3070 mobile / max-q","3070",0,[[2560,1440,386]]],["nvidia geforce rtx 3070 ti","3070",0,[[1920,1080,60]]],["nvidia geforce rtx 3080","3080",0,[[1920,1080,726],[2560,1440,60],[3840,2160,60]]],["nvidia geforce rtx 3080 laptop gpu","3080",0,[[1920,1080,294],[2560,1440,244]]],["nvidia geforce rtx 3080 mobile / max-q 8gb/16gb","3080",0,[[1920,1080,293]]],["nvidia geforce rtx 3080 ti","3080",0,[[1920,1080,239],[2560,1440,60]]],["nvidia geforce rtx 3090","3090",0,[[2560,1440,60],[3840,2160,474]]],["nvidia geforce rtx t10-16","10",0,[[2560,1600,3]]],["nvidia geforce rtx t10-8","10",0,[[2560,1600,3]]],["nvidia gf100 board - 10220000","100",0,[[1920,1200,60]]],["nvidia gf117","117",0,[[1920,1080,32]]],["nvidia gigabyte geforce gt 440","440",0,[[1280,1024,34]]],["nvidia gigabyte geforce gt 610","610",0,[[1920,1080,17]]],["nvidia gigabyte geforce gt 630","630",0,[[1920,1080,34]]],["nvidia gigabyte geforce gt 730","730",0,[[1280,1024,38]]],["nvidia gigabyte geforce gts 450","450",0,[[1280,1024,37]]],["nvidia gigabyte geforce gtx 1050 ti","1050",0,[[1920,1080,30]]],["nvidia gigabyte geforce gtx 460","460",0,[[1680,1050,60]]],["nvidia gigabyte geforce gtx 550 ti","550",0,[[1920,1080,57]]],["nvidia gigabyte geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 570 hd","570",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 580","580",0,[[1920,1200,60]]],["nvidia gigabyte geforce gtx 650","650",0,[[1680,1050,55]]],["nvidia gigabyte geforce gtx 650 ti","650",0,[[2560,1440,40]]],["nvidia gigabyte geforce gtx 660","660",0,[[1920,1080,31]]],["nvidia gigabyte geforce gtx 660 ti","660",0,[[5120,2880,29]]],["nvidia gigabyte geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 750","750",0,[[1920,1080,59]]],["nvidia gigabyte geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 760","760",0,[[3440,1440,17]]],["nvidia gigabyte geforce gtx 770","770",0,[[2560,1440,59]]],["nvidia gigabyte geforce gtx 780 ti","780",0,[[1920,1080,240]]],["nvidia gigabyte geforce gtx 960","960",0,[[1920,1080,142],[1920,1200,120]]],["nvidia gigabyte geforce gtx 970","970",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 980","980",0,[[2560,1440,60]]],["nvidia gigabyte geforce gtx 980 ti","980",0,[[1920,1080,60]]],["nvidia gk104 board - 2051b502","104",0,[[2560,1440,60]]],["nvidia gk104 board - 20530501","104",0,[[2560,1440,60]]],["nvidia gk104gl [grid k2]","104",0,[[2560,1343,21]]],["nvidia gk104gl [grid k520]","104",0,[[1024,768,120]]],["nvidia gp102 [titan x]","102",0,[[3440,1440,462]]],["nvidia gp102 [titan xp]","102",0,[[1920,1080,126]]],["nvidia gp104","104",0,[[1920,1080,60]]],["nvidia gp104gl","104",0,[[2560,1343,36]]],["nvidia gp108","108",0,[[1920,1080,60]]],["nvidia graphics device","",0,[[1920,1080,60],[1920,1200,60],[3840,2160,60]]],["nvidia grid gtx p40-6","40",0,[[1440,900,153]]],["nvidia grid k1","1",0,[[1245,768,6],[1920,1080,35]]],["nvidia grid k140q vgpu","140",0,[[1920,1080,30]]],["nvidia grid k160q","160",0,[[1920,1080,34]]],["nvidia grid k180q","180",0,[[1920,1080,28]]],["nvidia grid k2","2",0,[[1245,768,6],[1920,1080,59]]],["nvidia grid k220q","220",0,[[1920,1200,34]]],["nvidia grid k240q","240",0,[[1920,1080,64]]],["nvidia grid k260q","260",0,[[2560,1440,31]]],["nvidia grid k280q","280",0,[[1920,1080,64]]],["nvidia grid k520","520",0,[[1280,720,60]]],["nvidia grid m10-1b","10",0,[[1024,768,49]]],["nvidia grid m10-2q","10",0,[[2560,1440,15]]],["nvidia grid m6-0b","6",0,[[1680,1050,33]]],["nvidia grid m60-1b","60",0,[[1680,1050,46],[1920,1080,46]]],["nvidia grid m60-1q","60",0,[[1536,864,60]]],["nvidia grid m60-2q","60",0,[[1920,1080,57]]],["nvidia grid m60-4q","60",0,[[1920,1080,59]]],["nvidia grid m60-8q","60",0,[[1920,1080,60]]],["nvidia grid p100-4q","100",0,[[2560,1440,16]]],["nvidia grid p4-4q","4",0,[[1892,932,247]]],["nvidia grid p40-4q","40",0,[[2741,1495,60]]],["nvidia grid p40-8q","40",0,[[1920,1080,60]]],["nvidia grid rtx6000-2q","6000",0,[[1024,768,60]]],["nvidia grid rtx6000p-6","6000",0,[[1280,1024,161]]],["nvidia grid t4-16q","4",0,[[1920,1080,61]]],["nvidia grid t4-1b","4",0,[[1920,1080,46]]],["nvidia grid t4-1q","4",0,[[1280,1024,48]]],["nvidia grid t4-2b4","4",0,[[1536,864,47]]],["nvidia grid t4-2q","4",0,[[1920,1080,65]]],["nvidia grid t4-8q","4",0,[[2560,1080,60]]],["nvidia grid v100-1q","100",0,[[1646,1154,59]]],["nvidia grid v100-2b","100",0,[[1440,900,45]]],["nvidia grid v100dx-16q","100",0,[[1280,1024,60]]],["nvidia grid v100dx-1q","100",0,[[1280,1024,60]]],["nvidia gtx 1060 hl","1060",0,[[3840,2160,60]]],["nvidia gtx 865m by imacgfx","865",0,[[2560,1440,60]]],["nvidia gtx 980m sli","980",0,[[1366,768,29]]],["nvidia gv-n660oc-2gd","660",0,[[1920,1200,60]]],["nvidia gv100","100",0,[[3840,2160,60]]],["nvidia gv100 [titan v]","100",0,[[2560,1440,60]]],["nvidia gv102","102",0,[[2560,1600,525]]],["nvidia hp geforce gt 730","730",0,[[1920,1080,55]]],["nvidia hp quadro 2000","2000",0,[[2560,1080,38]]],["nvidia hp quadro 4000","4000",0,[[2560,1080,52]]],["nvidia hp quadro 600","600",0,[[1360,768,41]]],["nvidia hp quadro k4000","4000",0,[[1920,1200,26]]],["nvidia hp quadro k620","620",0,[[1600,1200,94]]],["nvidia inno3d geforce gtx660","3",0,[[2560,1440,107]]],["nvidia microsoft virtual render driver","",0,[[1920,1080,59]]],["nvidia msi geforce gt 610","610",0,[[1920,1080,16]]],["nvidia msi geforce gt 630","630",0,[[1440,900,12]]],["nvidia msi geforce gt 635","635",0,[[1920,1080,30]]],["nvidia msi geforce gt 710","710",0,[[1920,1080,27]]],["nvidia msi geforce gt 730","730",0,[[1920,1080,53]]],["nvidia msi geforce gtx 1050 ti","1050",0,[[1920,1080,59]]],["nvidia msi geforce gtx 1060","1060",0,[[1920,1080,120]]],["nvidia msi geforce gtx 1070","1070",0,[[1920,1200,45]]],["nvidia msi geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia msi geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia msi geforce gtx 570 hd","570",0,[[1920,1200,60]]],["nvidia msi geforce gtx 580","580",0,[[2560,1440,60]]],["nvidia msi geforce gtx 650","650",0,[[2560,1080,52]]],["nvidia msi geforce gtx 650 ti","650",0,[[1920,1080,60]]],["nvidia msi geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia msi geforce gtx 660 ti","660",0,[[1680,1050,49]]],["nvidia msi geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia msi geforce gtx 745","745",0,[[1920,1080,55]]],["nvidia msi geforce gtx 760","760",0,[[1280,1024,30],[1920,1080,58]]],["nvidia msi geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia msi geforce gtx 950","950",0,[[1920,1080,59]]],["nvidia msi geforce gtx 960","960",0,[[1680,1050,120],[2560,1440,59]]],["nvidia msi geforce gtx 970","970",0,[[1680,1050,60]]],["nvidia msi geforce gtx 980","980",0,[[1920,1080,120],[3840,2160,60]]],["nvidia msi geforce gtx 980 ti","980",0,[[5120,2880,56]]],["nvidia n15e-gt","15",0,[[3840,2160,30]]],["nvidia null geforce 920a","920",0,[[1920,1080,25]]],["nvidia null graphics device","",0,[[1920,1080,24]]],["nvidia nvs 310","310",0,[[1280,1024,24],[1920,1080,15]]],["nvidia nvs 3100m","3100",0,[[1920,1080,10]]],["nvidia nvs 315","315",0,[[1280,1024,25],[1920,1080,15]]],["nvidia nvs 4200m","4200",0,[[1920,1080,11]]],["nvidia nvs 510","510",0,[[1920,1200,27],[2560,1080,24],[3440,1440,16]]],["nvidia nvs 5200m","5200",0,[[1366,768,55],[1600,900,33],[1920,1080,57]]],["nvidia nvs 5400m","5400",0,[[1600,900,46],[1920,1200,27]]],["nvidia p102-100","102",0,[[1600,1200,35]]],["nvidia p106-090","106",0,[[1920,1371,16]]],["nvidia p106-100","106",0,[[1920,1080,60],[3840,2160,30]]],["nvidia p106-100 custom","106",0,[[1680,1050,60]]],["nvidia palit geforce gtx 650","650",0,[[1920,1080,49]]],["nvidia palit geforce gtx 650 ti","650",0,[[1920,1080,59]]],["nvidia palit geforce gtx 660","660",0,[[1920,1080,26]]],["nvidia palit gtx 680 jetstream","680",0,[[1920,1080,60]]],["nvidia pegatron geforce gt 420","420",0,[[1400,1050,25]]],["nvidia pny geforce gt 610","610",0,[[1280,1024,19]]],["nvidia pny geforce gtx 1060","1060",0,[[1920,1080,60]]],["nvidia pny geforce gtx 460","460",0,[[1360,768,59]]],["nvidia pny geforce gtx 550 ti","550",0,[[1920,1080,55]]],["nvidia pny geforce gtx 570 hd","570",0,[[1280,1024,72]]],["nvidia pny geforce gtx 580","580",0,[[1920,1200,59]]],["nvidia pny geforce gtx 680","680",0,[[2560,1080,120]]],["nvidia pny geforce gtx 750","750",0,[[1280,1024,60]]],["nvidia pny geforce gtx 970","970",0,[[2560,1440,60]]],["nvidia pny geforce gtx 980","980",0,[[1920,1080,120]]],["nvidia point of view geforce gtx 470","470",0,[[1920,1080,59]]],["nvidia point of view geforce gtx 660 ti","660",0,[[1680,1050,59]]],["nvidia quadro 1000m","1000",0,[[1920,1080,28]]],["nvidia quadro 1000m,","1000",0,[[1920,1080,27]]],["nvidia quadro 2000","2000",0,[[1920,1080,51],[2560,1440,28]]],["nvidia quadro 2000d","2000",0,[[1280,1024,56]]],["nvidia quadro 2000m","2000",0,[[1920,1080,31]]],["nvidia quadro 3000m","3000",0,[[1920,1080,53],[2560,1440,6]]],["nvidia quadro 3000m opengl engine","3000",0,[[1920,1080,49]]],["nvidia quadro 4000","4000",0,[[1920,1080,56],[1920,1200,58]]],["nvidia quadro 4000m","4000",0,[[1920,1080,51]]],["nvidia quadro 410","410",0,[[1920,1080,23]]],["nvidia quadro 5000","5000",0,[[1920,1080,60],[2560,1080,55],[2560,1440,51]]],["nvidia quadro 5000 opengl engine","5000",0,[[1920,1200,59]]],["nvidia quadro 5000m","5000",0,[[1600,900,110]]],["nvidia quadro 600","600",0,[[1680,1050,28],[1920,1080,28],[1920,1200,26]]],["nvidia quadro 6000","6000",0,[[1920,1080,60],[1920,1200,60]]],["nvidia quadro 7000","7000",0,[[1920,1200,60]]],["nvidia quadro fx 1800m","1800",0,[[1600,900,15]]],["nvidia quadro fx 2800m","2800",0,[[1920,1200,36]]],["nvidia quadro fx grid k1","1",0,[[1920,1080,31]]],["nvidia quadro gp100","100",0,[[1920,1200,366]]],["nvidia quadro gv100","100",0,[[3840,2160,60],[4096,2160,60]]],["nvidia quadro k1000m","1000",0,[[1920,1080,28]]],["nvidia quadro k1000m by nick[d]vb","1000",0,[[1920,1080,36]]],["nvidia quadro k1100m","1100",0,[[1920,1080,56]]],["nvidia quadro k1100m by nick[d]vb","1100",0,[[1920,1080,66]]],["nvidia quadro k1100m opengl engine","1100",0,[[1920,1080,54]]],["nvidia quadro k1200","1200",0,[[1920,1080,60],[2560,1440,57],[3840,2160,28]]],["nvidia quadro k1200 opengl engine","1200",0,[[3840,2160,34]]],["nvidia quadro k2000","2000",0,[[1920,1080,55]]],["nvidia quadro k2000 opengl engine","2000",0,[[2560,1440,44]]],["nvidia quadro k2000d","2000",0,[[1280,1024,57],[1680,1050,57],[1920,1080,59]]],["nvidia quadro k2000m","2000",0,[[1920,1080,36]]],["nvidia quadro k2000m by nick[d]vb","2000",0,[[2560,1440,38]]],["nvidia quadro k2000m opengl engine","2000",0,[[1920,1080,43]]],["nvidia quadro k2100m","2100",0,[[1920,1080,58]]],["nvidia quadro k2100m by nick[d]vb","2100",0,[[2560,1440,54]]],["nvidia quadro k2100m opengl engine","2100",0,[[1920,1080,59]]],["nvidia quadro k2200","2200",0,[[1920,1080,60],[1920,1200,126],[5120,2880,25]]],["nvidia quadro k2200m","2200",0,[[1920,1080,60]]],["nvidia quadro k3000m","3000",0,[[1920,1080,59]]],["nvidia quadro k3000m by st3phl3","3000",0,[[2560,1440,50]]],["nvidia quadro k3100m","3100",0,[[1920,1080,60]]],["nvidia quadro k3100m by nikey22","3100",0,[[2560,1440,59]]],["nvidia quadro k3100m opengl engine","3100",0,[[2560,1440,58]]],["nvidia quadro k4000","4000",0,[[1920,1080,60],[1920,1200,59]]],["nvidia quadro k4000 opengl engine","4000",0,[[1920,1080,59]]],["nvidia quadro k4000m","4000",0,[[1920,1080,80]]],["nvidia quadro k4100m","4100",0,[[1920,1080,32]]],["nvidia quadro k4100m by nikey22","4100",0,[[2560,1440,60]]],["nvidia quadro k420","420",0,[[1366,768,57],[2560,1440,19],[3840,2160,10]]],["nvidia quadro k4200","4200",0,[[1920,1080,60],[2560,1440,59],[3840,2160,57]]],["nvidia quadro k5000","5000",0,[[1920,1080,60],[2560,1440,60]]],["nvidia quadro k5000 opengl engine","5000",0,[[2560,1600,59]]],["nvidia quadro k5000m","5000",0,[[1920,1080,60],[2560,1440,60]]],["nvidia quadro k5000m opengl engine","5000",0,[[2560,1440,60]]],["nvidia quadro k5100m","5100",0,[[1920,1080,60],[2560,1080,171]]],["nvidia quadro k5100m by nikey22","5100",0,[[2560,1440,60]]],["nvidia quadro k510m","510",0,[[1920,1080,33]]],["nvidia quadro k5200","5200",0,[[1920,1080,60],[1920,1200,60]]],["nvidia quadro k5200 opengl engine","5200",0,[[1920,1200,41]]],["nvidia quadro k600","600",0,[[1920,1080,28]]],["nvidia quadro k600 opengl engine","600",0,[[1920,1200,31]]],["nvidia quadro k6000","6000",0,[[1920,1080,60],[1920,1200,60],[2560,1440,60]]],["nvidia quadro k6000 opengl engine","6000",0,[[1920,1080,59]]],["nvidia quadro k610m","610",0,[[1920,1080,36]]],["nvidia quadro k610m by nick[d]vb","610",0,[[1920,1080,34]]],["nvidia quadro k620","620",0,[[1920,1080,87],[1920,1200,69],[2560,1440,44]]],["nvidia quadro k620 opengl engine","620",0,[[1920,1080,59]]],["nvidia quadro k620m","620",0,[[1920,1080,49],[2880,1620,15]]],["nvidia quadro m1000m","1000",0,[[1920,1080,60]]],["nvidia quadro m1200","1200",0,[[1920,1080,60],[3840,2160,43]]],["nvidia quadro m2000","2000",0,[[1920,1080,73],[2560,1440,59]]],["nvidia quadro m2000m","2000",0,[[1920,1080,60]]],["nvidia quadro m2000m special","2000",0,[[1920,1080,60]]],["nvidia quadro m2200","2200",0,[[1920,1080,60]]],["nvidia quadro m2200 mobile","2200",0,[[3840,2160,13]]],["nvidia quadro m3000m","3000",0,[[1920,1080,60]]],["nvidia quadro m4000","4000",0,[[1920,1080,120],[1920,1200,60],[2560,1440,60]]],["nvidia quadro m4000 opengl engine","4000",0,[[1920,1080,60]]],["nvidia quadro m4000m","4000",0,[[1920,1080,60],[3840,2160,69]]],["nvidia quadro m5000","5000",0,[[1920,1080,60],[1920,1200,60],[2560,1440,59]]],["nvidia quadro m5000m","5000",0,[[1920,1080,212],[3840,2160,60]]],["nvidia quadro m500m","500",0,[[1920,1080,58],[2880,1620,29]]],["nvidia quadro m520","520",0,[[1920,1080,59],[3840,2160,27]]],["nvidia quadro m5500","5500",0,[[3440,1440,60]]],["nvidia quadro m6000","6000",0,[[1920,1080,408],[2560,1440,60]]],["nvidia quadro m6000 24gb","6000",0,[[1680,1050,60],[1920,1200,60]]],["nvidia quadro m600m","600",0,[[1920,1080,59]]],["nvidia quadro m620","620",0,[[1920,1080,60]]],["nvidia quadro nvs 4200m","4200",0,[[1600,900,26],[1920,1080,19]]],["nvidia quadro p1000","1000",0,[[1920,1080,60],[1920,1200,60]]],["nvidia quadro p1000 mobile","1000",0,[[1920,1080,60]]],["nvidia quadro p2000","2000",0,[[1680,1050,60],[1920,1080,242],[2560,1440,60]]],["nvidia quadro p2000 mobile","2000",0,[[1920,1080,60]]],["nvidia quadro p2000 opengl engine","2000",0,[[1920,1080,59]]],["nvidia quadro p2000 with max-q design","2000",0,[[1920,1080,60],[3840,2160,67]]],["nvidia quadro p2200","2200",0,[[1920,1080,60],[3840,2160,340]]],["nvidia quadro p3000","3000",0,[[1920,1080,60]]],["nvidia quadro p3200","3200",0,[[1920,1080,60],[3840,2160,60]]],["nvidia quadro p3200 mobile","3200",0,[[3840,2160,60]]],["nvidia quadro p3200 with max-q design","3200",0,[[2560,1440,60]]],["nvidia quadro p400","400",0,[[1680,1050,46],[1920,1080,57],[1920,1200,54]]],["nvidia quadro p4000","4000",0,[[1920,1080,60],[3840,2160,167]]],["nvidia quadro p4200","4200",0,[[1920,1080,60],[3840,2160,60]]],["nvidia quadro p4200 with max-q design","4200",0,[[3839,2159,53]]],["nvidia quadro p500","500",0,[[1920,1080,60]]],["nvidia quadro p5000","5000",0,[[1920,1080,60]]],["nvidia quadro p5000 opengl engine","5000",0,[[3840,2160,58]]],["nvidia quadro p520","520",0,[[1920,1080,60]]],["nvidia quadro p5200","5200",0,[[3840,2160,100]]],["nvidia quadro p600","600",0,[[1920,1080,60]]],["nvidia quadro p6000","6000",0,[[1920,1080,60],[2560,1440,60],[2560,1600,411]]],["nvidia quadro p620","620",0,[[1920,1080,65]]],["nvidia quadro rtx 3000","3000",0,[[1920,1080,60]]],["nvidia quadro rtx 3000 mobile / max-q","3000",0,[[3840,2160,60]]],["nvidia quadro rtx 3000 with max-q design","3000",0,[[3240,2160,60]]],["nvidia quadro rtx 4000","4000",0,[[1920,1080,60]]],["nvidia quadro rtx 4000 mobile / max-q","4000",0,[[1920,1080,60]]],["nvidia quadro rtx 4000 with max-q design","4000",0,[[1920,1080,60],[3840,2160,60]]],["nvidia quadro rtx 5000","5000",0,[[1920,1080,443],[2560,1440,60]]],["nvidia quadro rtx 5000 mobile / max-q","5000",0,[[3840,2160,60]]],["nvidia quadro rtx 5000 with max-q design","5000",0,[[1920,1080,60],[3840,2160,60]]],["nvidia quadro rtx 6000","6000",0,[[1920,1080,438],[2560,1440,60]]],["nvidia quadro rtx 8000","8000",0,[[1920,1080,60],[1920,1200,60]]],["nvidia quadro t1000","1000",0,[[1920,1080,60],[2560,1440,41]]],["nvidia quadro t1000 mobile","1000",0,[[1920,1080,277]]],["nvidia quadro t1000 with max-q design","1000",0,[[1920,1080,60]]],["nvidia quadro t2000","2000",0,[[1920,1080,60]]],["nvidia quadro t2000 mobile / max-q","2000",0,[[1920,1080,302]]],["nvidia quadro t2000 with max-q design","2000",0,[[1920,1080,60],[1920,1200,60],[2560,1440,60]]],["nvidia rtx a1000 laptop gpu","1000",0,[[1920,1080,60]]],["nvidia rtx a2000","2000",0,[[3840,2160,60]]],["nvidia rtx a2000 laptop gpu","2000",0,[[2400,1600,120],[3840,2160,60]]],["nvidia rtx a3000 laptop gpu","3000",0,[[1920,1080,60],[3840,2160,60]]],["nvidia rtx a4000","4000",0,[[1920,1080,60],[3840,2160,60]]],["nvidia rtx a4000 laptop gpu","4000",0,[[1920,1080,60]]],["nvidia rtx a5000","5000",0,[[3840,2160,60]]],["nvidia rtx a5000 laptop gpu","5000",0,[[3840,2160,60]]],["nvidia rtx a6000","6000",0,[[1920,1200,60]]],["nvidia sony geforce 410m","410",0,[[1366,768,24]]],["nvidia t1000","1000",0,[[1920,1080,43],[3840,2160,60]]],["nvidia t1200 laptop gpu","1200",0,[[1920,1080,60]]],["nvidia t400","400",0,[[3840,2160,35]]],["nvidia t500","500",0,[[1920,1080,60],[3839,2159,52]]],["nvidia t600","600",0,[[1920,1080,60]]],["nvidia tesla c2050 / c2070","2050",0,[[1920,1080,105]]],["nvidia tesla c2070","2070",0,[[1920,1200,60]]],["nvidia tesla c2075","2075",0,[[1920,1080,60]]],["nvidia tesla k10","10",0,[[1920,1080,60]]],["nvidia tesla k10.g1.8gb","10",0,[[1440,900,59]]],["nvidia tesla k20m","20",0,[[1240,821,118]]],["nvidia tesla k20xm","20",0,[[3840,2400,17]]],["nvidia tesla k80","80",0,[[1664,896,66],[3840,2160,30]]],["nvidia tesla m10","10",0,[[1440,900,60],[1280,1024,60]]],["nvidia tesla m40","40",0,[[1600,1024,190]]],["nvidia tesla m6","6",0,[[1920,1080,59]]],["nvidia tesla m60","60",0,[[1366,768,60],[1920,962,61],[3840,2160,27]]],["nvidia tesla p100 pcie 16gb","100",0,[[1920,1080,60]]],["nvidia tesla p100-pcie-16gb","100",0,[[1920,1080,103]]],["nvidia tesla p4","4",0,[[1680,1050,60]]],["nvidia tesla p40","40",0,[[1546,877,62],[1920,1200,60]]],["nvidia tesla t4","4",0,[[1440,900,33],[1920,1080,60]]],["nvidia tesla v100-pcie-16gb","100",0,[[1920,997,57]]],["nvidia tesla v100-pcie-32gb","100",0,[[1920,1080,57]]],["nvidia tesla v100-sxm2-16gb","100",0,[[1920,1080,60]]],["nvidia tesla v100-sxm2-32gb","100",0,[[1920,1080,1],[2560,1440,60]]],["nvidia titan rtx","rtx",0,[[2560,1440,60],[3840,2160,680]]],["nvidia titan v","v",0,[[2560,1440,622],[3840,2160,60]]],["nvidia titan x","x",0,[[2560,1080,60],[3840,1600,75],[3840,2160,339]]],["nvidia titan xp","xp",0,[[1920,1200,60],[2560,1440,60],[3440,1440,105]]],["nvidia titan xp collectors","xp",0,[[1920,1080,60],[2560,1440,893],[5120,2880,60]]],["nvidia toshiba geforce gt 525m","525",0,[[1366,768,33]]],["nvidia tu102 [titan rtx]","102",0,[[3840,2160,60]]],["nvidia tu107","107",0,[[1920,1080,312]]],["nvidia tu117m","117",0,[[1920,1080,337]]],["nvidia unknown","",0,[[1920,1080,60]]],["nvidia zotac geforce gt 430","430",0,[[1600,900,32]]],["nvidia zotac geforce gt 610","610",0,[[1920,1080,15]]],["nvidia zotac geforce gt 630","630",0,[[1360,768,46]]],["nvidia zotac geforce gt 740","740",0,[[1280,1024,118]]],["nvidia zotac geforce gtx 460","460",0,[[1920,1080,59]]],["nvidia zotac geforce gtx 550 ti","550",0,[[1920,1080,42]]],["nvidia zotac geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 580","580",0,[[1920,1080,48]]],["nvidia zotac geforce gtx 650","650",0,[[1920,1080,44]]],["nvidia zotac geforce gtx 650 ti","650",0,[[1920,1080,58]]],["nvidia zotac geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 680","680",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 750","750",0,[[1680,1050,114],[1920,1080,60]]],["nvidia zotac geforce gtx 760","760",0,[[1920,1080,101]]],["nvidia zotac geforce gtx 770","770",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 960","960",0,[[2048,1152,60]]]]\')},145:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["amd [amd/ati] fiji [radeon r9 fury / nano series]","9",0,[[1920,1200,162]]],["amd asus amd radeon r9-990x","9",0,[[1920,1080,60]]],["amd asus radeon r7 250","7",0,[[800,638,60]]],["amd asus radeon r7 260x","7",0,[[2560,1080,65]]],["amd asus radeon r9 270x","9",0,[[1024,768,85],[1920,1080,60]]],["amd asus radeon r9 280","9",0,[[1920,1080,60]]],["amd asus radeon rx 460","460",0,[[1360,768,104]]],["amd asus radeon rx 470","470",0,[[1920,1080,60]]],["amd asus radeon rx 480","480",0,[[1920,1080,124]]],["amd asus radeon rx 550","550",0,[[1440,900,60],[1920,1080,49]]],["amd asus radeon rx 5500 xt","5500",0,[[1920,1080,325]]],["amd asus radeon rx 560","560",0,[[1360,768,60],[1920,1080,85]]],["amd asus radeon rx 570","570",0,[[1600,900,202],[1920,1080,60]]],["amd asus radeon rx 5700","5700",0,[[1920,1080,327]]],["amd asus radeon rx 5700 xt","5700",0,[[1920,1080,224],[2560,1440,60]]],["amd asus radeon rx 580","580",0,[[1920,1080,177],[2560,1080,60]]],["amd asus radeon rx vega","rx",0,[[2560,1440,117]]],["amd ati mobility radeon hd 5870","5870",0,[[1920,1200,19]]],["amd baffin amd radeon rx 560","560",0,[[1920,1080,60]]],["amd ellesmere radeon rx 570","570",0,[[1920,1080,60]]],["amd embedded radeon e9171","9171",0,[[3840,2160,26]]],["amd embedded radeon e9173","9173",0,[[3840,2160,16]]],["amd gigabyte radeon rx 580","580",0,[[1920,1080,60]]],["amd madison [mobility radeon hd 5650 / 6530m/6550m]","5650",0,[[1366,768,43]]],["amd mobility radeon hd 4250","4250",0,[[963,722,26]]],["amd mobility radeon hd 5000","5000",0,[[1366,768,47]]],["amd mobility radeon hd 5400","5400",0,[[1366,768,24]]],["amd mobility radeon hd 5430","5430",0,[[1600,900,15],[1920,1080,60]]],["amd mobility radeon hd 5470","5470",0,[[1366,768,24]]],["amd mobility radeon hd 5570","5570",0,[[1920,1080,27]]],["amd mobility radeon hd 5730 / 6570m","5730",0,[[1366,768,58]]],["amd mobility radeon hd 5850","5850",0,[[1600,900,55]]],["amd mobility radeon hd 5870","5870",0,[[1600,900,64],[1920,1200,53]]],["amd park [mobility radeon hd 5430","5430",0,[[1280,720,11]]],["amd pitcairn pro radeon hd 7850","7850",0,[[1920,1080,60]]],["amd powercolor radeon r9 280","9",0,[[1920,1080,60]]],["amd radeon","",0,[[1920,1080,299],[3440,1440,60]]],["amd radeon 500","500",0,[[1920,1080,73]]],["amd radeon 520","520",0,[[1920,1080,35],[2560,1440,29]]],["amd radeon 530","530",0,[[1366,768,60],[1920,1080,30]]],["amd radeon 535","535",0,[[1920,1080,35]]],["amd radeon 535dx","535",0,[[1366,768,31],[1920,1080,37]]],["amd radeon 540","540",0,[[1920,1080,38]]],["amd radeon 540 / rx 540x/550/550x","540",0,[[2560,1440,88]]],["amd radeon 540x","540",0,[[1920,1080,59]]],["amd radeon 550","550",0,[[1920,1080,115]]],["amd radeon 550x","550",0,[[1920,1080,28]]],["amd radeon 610","610",0,[[1920,1080,29]]],["amd radeon 620","620",0,[[1920,1080,18]]],["amd radeon 625","625",0,[[1366,768,55],[1920,1080,47]]],["amd radeon 630","630",0,[[1920,1080,29]]],["amd radeon 6600m and 6700m","6600",0,[[1366,768,36],[1440,900,60]]],["amd radeon 6800","6800",0,[[3440,1440,100]]],["amd radeon 7500m/7600m","7500",0,[[1366,768,37]]],["amd radeon 7950 x2","7950",0,[[2560,1440,174]]],["amd radeon d700","700",0,[[2560,1440,120]]],["amd radeon e6460","6460",0,[[1600,1200,13]]],["amd radeon e6760","6760",0,[[1200,900,54],[1920,1080,42]]],["amd radeon e8860","8860",0,[[1920,1200,27],[2560,1374,88]]],["amd radeon e8870","8870",0,[[1920,1080,81]]],["amd radeon e8870mxm","8870",0,[[1920,1080,60]]],["amd radeon e9260","9260",0,[[1680,1050,60],[3840,2160,38]]],["amd radeon e9550","9550",0,[[1680,1050,60],[3840,2160,58]]],["amd radeon embedded e9560","9560",0,[[1920,1200,60]]],["amd radeon fury","",0,[[1920,1080,60]]],["amd radeon fury x","x",0,[[1920,1080,60],[2560,1440,144]]],["amd radeon hd - firepro d300","300",0,[[1920,1080,60]]],["amd radeon hd - firepro d300 opengl engine","300",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd - firepro d500 opengl engine","500",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd - firepro d700 opengl engine","700",0,[[3840,2160,52]]],["amd radeon hd 2600 xt","2600",1,[[2560,1600,-1]]],["amd radeon hd 5000","5000",0,[[1920,1080,8]]],["amd radeon hd 5400","5400",0,[[1920,1080,12]]],["amd radeon hd 5450","5450",0,[[1920,1080,13]]],["amd radeon hd 5470","5470",0,[[1280,1024,16]]],["amd radeon hd 5500","5500",0,[[1920,1080,27]]],["amd radeon hd 5570","5570",0,[[1920,1080,60],[2048,1152,31]]],["amd radeon hd 5600","5600",0,[[1920,1080,56]]],["amd radeon hd 5650","5650",0,[[1366,768,53]]],["amd radeon hd 5670","5670",1,[[1920,1080,-1],[2560,1440,-1]]],["amd radeon hd 5670 opengl engine","5670",1,[[2560,1440,-1]]],["amd radeon hd 5700","5700",0,[[1920,1080,59]]],["amd radeon hd 5730","5730",0,[[1366,768,46],[1680,1050,40]]],["amd radeon hd 5750","5750",1,[[1920,1080,-1],[1920,1200,-1],[2560,1440,-1]]],["amd radeon hd 5750 opengl engine","5750",1,[[2560,1440,-1]]],["amd radeon hd 5770","5770",0,[[1776,1000,43],[1920,1080,59]]],["amd radeon hd 5800","5800",0,[[1366,768,60],[1920,1200,102]]],["amd radeon hd 5850","5850",0,[[1920,1080,60]]],["amd radeon hd 5870","5870",0,[[1280,960,75],[1920,1080,60],[2048,1280,60]]],["amd radeon hd 5870m","5870",0,[[2560,1080,31]]],["amd radeon hd 5970","5970",0,[[1360,768,60],[1920,1080,60]]],["amd radeon hd 6230","6230",0,[[1366,768,13]]],["amd radeon hd 6250","6250",0,[[1280,800,8],[1366,768,8]]],["amd radeon hd 6290","6290",1,[[1366,768,-1]]],["amd radeon hd 6300m","6300",1,[[1366,768,-1]]],["amd radeon hd 6310","6310",1,[[1366,768,-1]]],["amd radeon hd 6320","6320",1,[[1366,768,-1]]],["amd radeon hd 6350","6350",0,[[1280,1024,18],[1920,1080,14]]],["amd radeon hd 6370d","6370",0,[[1920,1080,14]]],["amd radeon hd 6370m","6370",0,[[1366,768,25]]],["amd radeon hd 6380g","6380",0,[[1366,768,19]]],["amd radeon hd 6400","6400",0,[[1920,1080,13]]],["amd radeon hd 6400m","6400",0,[[1366,768,28]]],["amd radeon hd 6400m/7400m","6400",0,[[1366,768,28]]],["amd radeon hd 6410d","6410",0,[[1920,1080,11]]],["amd radeon hd 6450","6450",0,[[1920,1080,14]]],["amd radeon hd 6450 / r5 230","6450",0,[[1440,900,12]]],["amd radeon hd 6450 230","6450",0,[[1920,1080,15]]],["amd radeon hd 6470m","6470",0,[[1366,768,27],[1600,900,21]]],["amd radeon hd 6470m/7400m","6470",0,[[1366,768,44]]],["amd radeon hd 6480g","6480",0,[[1280,768,19],[1366,768,27],[1600,900,18]]],["amd radeon hd 6490m","6490",1,[[1366,768,-1],[1440,900,-1],[1680,1050,-1]]],["amd radeon hd 6500","6500",0,[[1920,1080,25]]],["amd radeon hd 6500m/5600","6500",0,[[1920,1080,27]]],["amd radeon hd 6510","6510",0,[[1600,900,32]]],["amd radeon hd 6520g","6520",0,[[1366,768,21],[1600,900,20]]],["amd radeon hd 6530d","6530",0,[[1366,768,31],[1440,900,36],[1920,1080,24]]],["amd radeon hd 6540","6540",0,[[1600,1200,13]]],["amd radeon hd 6550d","6550",0,[[1920,1080,28]]],["amd radeon hd 6570","6570",0,[[1920,1080,52],[2560,1440,17]]],["amd radeon hd 6620g","6620",0,[[1360,768,43],[1366,768,28]]],["amd radeon hd 6630m","6630",1,[[1366,768,-1],[1600,900,-1],[1920,1080,-1]]],["amd radeon hd 6630m/6650m/6750m/7670m/7690m","6630",1,[[1366,768,-1],[1920,1080,-1]]],["amd radeon hd 6650m","6650",0,[[1366,768,51],[1600,900,31]]],["amd radeon hd 6670","6670",0,[[1920,1080,55]]],["amd radeon hd 6700","6700",0,[[1920,1080,56]]],["amd radeon hd 6700 green","6700",0,[[1360,768,89]]],["amd radeon hd 6700m/7700m/7900m","6700",0,[[1366,768,59]]],["amd radeon hd 6730m/6770m","6730",0,[[1366,768,58],[1920,1080,46]]],["amd radeon hd 6730m/6770m/7690m xt","6730",0,[[1920,1080,48]]],["amd radeon hd 6750","6750",0,[[1440,900,72],[1920,1080,60]]],["amd radeon hd 6750m","6750",1,[[1440,900,-1],[1920,1080,-1],[1920,1200,-1]]],["amd radeon hd 6770","6770",0,[[1920,1080,60]]],["amd radeon hd 6770m","6770",1,[[1440,900,-1],[2560,1440,-1]]],["amd radeon hd 6770m opengl engine","6770",1,[[2560,1440,-1]]],["amd radeon hd 6790","6790",0,[[1920,1080,59]]],["amd radeon hd 6800","6800",0,[[1280,1024,89],[1920,1080,60]]],["amd radeon hd 6800m","6800",0,[[1600,900,18],[1920,1080,40]]],["amd radeon hd 6850","6850",0,[[1920,1080,59],[2560,1600,54]]],["amd radeon hd 6870","6870",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd 6900","6900",0,[[1920,1080,60]]],["amd radeon hd 6900m","6900",0,[[1920,1080,60]]],["amd radeon hd 6950","6950",0,[[1680,1050,60],[1920,1080,41]]],["amd radeon hd 6970","6970",0,[[1920,1080,60]]],["amd radeon hd 6970m","6970",1,[[2560,1440,-1]]],["amd radeon hd 6970m opengl engine","6970",1,[[2560,1440,-1]]],["amd radeon hd 6990","6990",0,[[1920,1080,60]]],["amd radeon hd 7000","7000",0,[[1920,1080,24]]],["amd radeon hd 7290","7290",0,[[1366,768,9]]],["amd radeon hd 7310","7310",0,[[1366,768,14]]],["amd radeon hd 7340","7340",0,[[1366,768,17],[1920,1080,10]]],["amd radeon hd 7340g","7340",0,[[1366,768,15]]],["amd radeon hd 7340m","7340",0,[[1366,768,15]]],["amd radeon hd 7350","7350",0,[[1920,1080,13]]],["amd radeon hd 7400","7400",0,[[1920,1080,18]]],["amd radeon hd 7400g","7400",0,[[963,768,31]]],["amd radeon hd 7400m","7400",0,[[1366,768,44]]],["amd radeon hd 7420g","7420",0,[[1366,768,28],[1600,900,26]]],["amd radeon hd 7450","7450",0,[[1920,1080,15]]],["amd radeon hd 7450a","7450",0,[[1920,1080,15]]],["amd radeon hd 7450m","7450",0,[[1366,768,30]]],["amd radeon hd 7470","7470",0,[[1680,1050,22],[1920,1080,144]]],["amd radeon hd 7470m","7470",0,[[1366,768,31],[1600,900,23]]],["amd radeon hd 7480d","7480",0,[[1280,1024,25],[1920,1080,24],[1920,1200,18]]],["amd radeon hd 7500","7500",0,[[1366,696,49],[1366,768,49]]],["amd radeon hd 7500g","7500",0,[[1366,768,26]]],["amd radeon hd 7500m/7600m","7500",0,[[1366,768,46]]],["amd radeon hd 7520g","7520",0,[[1366,768,33]]],["amd radeon hd 7520g + hd 7400m dual","7520",0,[[1366,768,34]]],["amd radeon hd 7520g + hd 7600m dual","7520",0,[[1366,768,31],[1600,900,41]]],["amd radeon hd 7540d","7540",0,[[1024,768,55],[1280,1024,44],[1920,1080,22]]],["amd radeon hd 7540d + hd 6670 dual","7540",0,[[1280,1024,36]]],["amd radeon hd 7550m/7650m","7550",0,[[1366,768,57]]],["amd radeon hd 7560d","7560",0,[[1920,1080,34]]],["amd radeon hd 7560d + hd 6570 dual","7560",0,[[1680,1050,44]]],["amd radeon hd 7560d + hd 6670 dual","7560",0,[[800,638,60]]],["amd radeon hd 7570","7570",0,[[1024,768,72],[1920,1080,52]]],["amd radeon hd 7570m","7570",0,[[1366,768,35]]],["amd radeon hd 7570m/hd 7670m","7570",0,[[1366,768,50],[1600,900,29]]],["amd radeon hd 7600","7600",0,[[1920,1080,60]]],["amd radeon hd 7600a","7600",0,[[1920,1080,28]]],["amd radeon hd 7600g","7600",0,[[1366,768,29]]],["amd radeon hd 7600g + 7500m/7600m dual","7600",0,[[1366,768,19]]],["amd radeon hd 7600g + hd 8670m dual","7600",0,[[1366,768,29]]],["amd radeon hd 7600g + hd dual","7600",0,[[1366,768,20]]],["amd radeon hd 7600m","7600",0,[[1366,768,56]]],["amd radeon hd 7600m/7700m","7600",0,[[1366,768,31]]],["amd radeon hd 7610m","7610",0,[[1366,768,43]]],["amd radeon hd 7620g","7620",0,[[1366,768,22],[1920,1080,19]]],["amd radeon hd 7640g","7640",0,[[1366,768,38]]],["amd radeon hd 7640g + 7470m dual","7640",0,[[1366,768,32]]],["amd radeon hd 7640g + 7600m dual","7640",0,[[1366,768,23]]],["amd radeon hd 7640g + 7670m dual","7640",0,[[1600,900,15]]],["amd radeon hd 7640g + 8500m dual","7640",0,[[1366,768,35]]],["amd radeon hd 7640g + hd 7400m dual","7640",0,[[1366,768,37]]],["amd radeon hd 7640g + hd 7500 dual","7640",0,[[1366,768,35]]],["amd radeon hd 7640g + hd 7670m dual","7640",0,[[1366,768,34]]],["amd radeon hd 7640g + hd 8500m dual","7640",0,[[1366,768,40]]],["amd radeon hd 7640g + hd 8570m dual","7640",0,[[1366,768,31]]],["amd radeon hd 7650a","7650",0,[[1680,1050,43],[1920,1080,15]]],["amd radeon hd 7650m","7650",0,[[1366,768,41],[1600,900,45]]],["amd radeon hd 7660d","7660",0,[[1680,1050,40],[1920,1008,60],[1920,1080,38]]],["amd radeon hd 7660d + hd 6570 dual","7660",0,[[1200,900,32]]],["amd radeon hd 7660d + hd 6670 dual","7660",0,[[1360,768,57],[1920,1080,53]]],["amd radeon hd 7660g","7660",0,[[1366,768,44],[1600,900,41],[1920,1080,34],[1920,1200,27]]],["amd radeon hd 7660g + 7600m dual","7660",0,[[1366,768,53],[1600,900,45]]],["amd radeon hd 7660g + 7670m dual","7660",0,[[1366,768,52]]],["amd radeon hd 7660g + 8670m dual","7660",0,[[1600,900,46]]],["amd radeon hd 7660g + hd 7600m dual","7660",0,[[1366,768,50]]],["amd radeon hd 7660g + hd 7670m dual","7660",0,[[1366,768,35]]],["amd radeon hd 7660g + hd 8600m dual","7660",0,[[1600,900,29]]],["amd radeon hd 7670","7670",0,[[1920,1080,39]]],["amd radeon hd 7670m","7670",0,[[1366,768,49],[1920,1080,36]]],["amd radeon hd 7700","7700",0,[[1400,1050,45],[1920,1080,60]]],["amd radeon hd 7700m","7700",0,[[1920,1080,54]]],["amd radeon hd 7730m","7730",0,[[1920,1080,57]]],["amd radeon hd 7750","7750",0,[[1280,1024,60],[1600,900,60],[1400,1050,98],[1920,1080,60],[3840,2160,23]]],["amd radeon hd 7750 / r7 250e","7750",0,[[2560,1080,69]]],["amd radeon hd 7750m","7750",0,[[1680,1050,57]]],["amd radeon hd 7770","7770",0,[[1920,1080,60]]],["amd radeon hd 7770 / r7 250x","7770",0,[[1680,1050,78]]],["amd radeon hd 7770 ghz","7770",0,[[1920,1080,78]]],["amd radeon hd 7790","7790",0,[[1920,1080,16]]],["amd radeon hd 7790 / r7 360 / r9 260/360","7790",0,[[1280,1024,131]]],["amd radeon hd 7800","7800",0,[[1920,1080,60]]],["amd radeon hd 7800m","7800",0,[[1920,1080,57]]],["amd radeon hd 7850","7850",0,[[1920,1080,60]]],["amd radeon hd 7850 / r7 265 / r9 270 1024sp","7850",0,[[1280,1024,87]]],["amd radeon hd 7870","7870",0,[[1920,1080,120],[2560,1440,60],[2560,1600,114],[3840,2160,30]]],["amd radeon hd 7870 ghz","7870",0,[[1920,1080,75]]],["amd radeon hd 7870 xt","7870",0,[[1920,1080,57],[3840,2160,53]]],["amd radeon hd 7870m","7870",0,[[1920,1080,22],[2732,1536,40]]],["amd radeon hd 7900","7900",0,[[2560,1600,59]]],["amd radeon hd 7950","7950",0,[[1920,1080,50]]],["amd radeon hd 7950 / r9 280","7950",0,[[1920,1080,59]]],["amd radeon hd 7950 oem / r9 280","7950",0,[[1920,1080,60]]],["amd radeon hd 7970","7970",0,[[1920,1080,60]]],["amd radeon hd 7970 / r9 280x","7970",0,[[1920,1080,193]]],["amd radeon hd 7970m","7970",0,[[1366,768,60],[1920,1080,60]]],["amd radeon hd 7970x/8970 280x","7970",0,[[1920,1080,60]]],["amd radeon hd 7990","7990",0,[[1920,1080,60],[5120,2880,63]]],["amd radeon hd 7xxx","7",0,[[1920,1080,60]]],["amd radeon hd 8180","8180",0,[[1366,768,10]]],["amd radeon hd 8200 / r3","8200",0,[[1366,768,21],[1600,900,13],[1680,1050,13]]],["amd radeon hd 8210","8210",0,[[1366,768,18]]],["amd radeon hd 8240","8240",0,[[1600,900,17]]],["amd radeon hd 8240 / r3","8240",0,[[1366,768,14]]],["amd radeon hd 8250","8250",0,[[1366,768,14],[1920,1200,10]]],["amd radeon hd 8280","8280",0,[[1600,900,60]]],["amd radeon hd 8280 / r3","8280",0,[[1366,768,22]]],["amd radeon hd 8280e","8280",0,[[2880,1620,6]]],["amd radeon hd 8330","8330",0,[[1366,768,24]]],["amd radeon hd 8350","8350",0,[[1920,1080,57]]],["amd radeon hd 8350g","8350",0,[[1366,768,18]]],["amd radeon hd 8370d","8370",0,[[1366,768,60],[1280,1024,26],[1920,1080,22]]],["amd radeon hd 8400","8400",0,[[1366,768,30],[1920,1080,16]]],["amd radeon hd 8400 / r3","8400",0,[[1360,768,19],[1366,768,22],[1920,1080,12]]],["amd radeon hd 8400e","8400",0,[[1680,1050,17],[1920,1080,16],[1920,1200,14]]],["amd radeon hd 8410g","8410",0,[[1366,768,32]]],["amd radeon hd 8450g","8450",0,[[1366,768,23]]],["amd radeon hd 8450g + hd 8750m dual","8450",0,[[1366,768,21]]],["amd radeon hd 8470","8470",0,[[1920,1080,17]]],["amd radeon hd 8470 + 7660d dual","8470",0,[[1920,1080,60]]],["amd radeon hd 8470d","8470",0,[[1280,1024,44],[1920,1080,21]]],["amd radeon hd 8470d + hd 6450 dual","8470",0,[[1600,900,37]]],["amd radeon hd 8490","8490",0,[[1920,1080,18],[1920,1200,20]]],["amd radeon hd 8500m","8500",0,[[1366,768,41],[1920,1080,19]]],["amd radeon hd 8500m/8700m","8500",0,[[1920,1080,30]]],["amd radeon hd 8510g","8510",0,[[1366,768,29],[1920,1080,17]]],["amd radeon hd 8550","8550",0,[[1920,1080,25]]],["amd radeon hd 8550g","8550",0,[[1366,768,34],[1600,900,41],[1920,1080,34]]],["amd radeon hd 8550g + 8500m dual","8550",0,[[1366,768,42]]],["amd radeon hd 8550g + 8600 dual","8550",0,[[1920,1080,27]]],["amd radeon hd 8550g + hd 8570m dual","8550",0,[[1366,768,32]]],["amd radeon hd 8550g + hd 8600 dual","8550",0,[[1366,768,60]]],["amd radeon hd 8550g + hd 8750m dual","8550",0,[[1366,768,37]]],["amd radeon hd 8550g + r5 m230 dual","8550",0,[[1366,768,29]]],["amd radeon hd 8570","8570",0,[[1280,1024,60],[1680,1050,54],[1920,1080,50]]],["amd radeon hd 8570 / r5 430 / r7 240 / radeon 520","8570",0,[[1920,1080,25]]],["amd radeon hd 8570d","8570",0,[[1920,1080,16]]],["amd radeon hd 8570d + r7 240 dual","8570",0,[[1920,1080,45]]],["amd radeon hd 8570m","8570",0,[[1366,768,40]]],["amd radeon hd 8600","8600",0,[[1366,768,41]]],["amd radeon hd 8600m","8600",0,[[1366,768,42],[1920,1080,14]]],["amd radeon hd 8610g","8610",0,[[1366,768,31],[1920,1080,16]]],["amd radeon hd 8610g + 8600m dual","8610",0,[[1366,768,22]]],["amd radeon hd 8610g + hd 8600m dual","8610",0,[[1366,768,41]]],["amd radeon hd 8610g + hd 8670m dual","8610",0,[[1366,768,33]]],["amd radeon hd 8650g","8650",0,[[1360,768,44],[1366,768,44]]],["amd radeon hd 8650g + 8500m dual","8650",0,[[1366,768,35]]],["amd radeon hd 8650g + 8600 dual","8650",0,[[1920,1080,38]]],["amd radeon hd 8650g + 8600m dual","8650",0,[[1366,768,21]]],["amd radeon hd 8650g + 8670m dual","8650",0,[[1366,768,66]]],["amd radeon hd 8650g + 8750m dual","8650",0,[[1920,1080,28]]],["amd radeon hd 8650g + hd 7600m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + hd 8500m dual","8650",0,[[1366,768,23]]],["amd radeon hd 8650g + hd 8570m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + hd 8600m dual","8650",0,[[1366,768,46],[1600,900,29]]],["amd radeon hd 8650g + hd 8750m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + r5 m200 dual","8650",0,[[1366,768,35]]],["amd radeon hd 8670 / r7 250","8670",0,[[1024,768,1]]],["amd radeon hd 8670a/8670m/8690m","8670",0,[[1366,768,47]]],["amd radeon hd 8670a/8670m/8750m","8670",0,[[1366,768,60]]],["amd radeon hd 8670d","8670",0,[[1024,768,45],[1280,1024,69],[1920,1080,38]]],["amd radeon hd 8670d + 7700 dual","8670",0,[[1680,1050,58]]],["amd radeon hd 8670d + hd 6670 dual","8670",0,[[1680,1050,33]]],["amd radeon hd 8670d + r5 200 dual","8670",0,[[2560,1080,14]]],["amd radeon hd 8670d + r7 200 dual","8670",0,[[1920,1080,37]]],["amd radeon hd 8670m","8670",0,[[1366,768,41]]],["amd radeon hd 8690a","8690",0,[[1920,1080,31]]],["amd radeon hd 8690m","8690",0,[[1600,900,35]]],["amd radeon hd 8700m","8700",0,[[1366,768,60]]],["amd radeon hd 8730m","8730",0,[[1366,768,59]]],["amd radeon hd 8750m","8750",0,[[1366,768,60]]],["amd radeon hd 8770","8770",0,[[1920,1080,111]]],["amd radeon hd 8790m","8790",0,[[1600,900,78],[1920,1080,60]]],["amd radeon hd 8800m","8800",0,[[1920,1080,60],[2880,1800,45]]],["amd radeon hd 8830m","8830",0,[[1920,1080,82]]],["amd radeon hd 8850m","8850",0,[[1366,768,45]]],["amd radeon hd 8870m","8870",0,[[1280,1024,60],[1600,900,60]]],["amd radeon hd 8950","8950",0,[[1920,1080,60],[1920,1200,59]]],["amd radeon hd 8970","8970",0,[[2560,1600,60]]],["amd radeon hd 8970m","8970",0,[[1920,1080,146],[1920,1200,60]]],["amd radeon hd 8xxx","8",0,[[1920,1080,120],[2560,1440,58]]],["amd radeon hd5450","5450",0,[[1280,720,24]]],["amd radeon hd6870","6870",0,[[1920,1080,60]]],["amd radeon hd7970m","7970",0,[[2560,1440,116]]],["amd radeon hd8530m","8530",0,[[1366,768,40]]],["amd radeon hd8730","8730",0,[[1680,1050,42]]],["amd radeon hd8970m","8970",0,[[1920,1080,74]]],["amd radeon hybrid","",0,[[1366,768,27]]],["amd radeon infoshock rx 460","460",0,[[1360,768,102]]],["amd radeon instinct mi25","25",0,[[1920,1200,26]]],["amd radeon instinct mi25 mxgpu","25",0,[[1920,1080,20],[1920,1200,32]]],["amd radeon m535dx","535",0,[[1366,768,58]]],["amd radeon navi14","14",0,[[3840,2160,60]]],["amd radeon polaris","",0,[[3840,2160,60],[5120,2880,44]]],["amd radeon polaris 10","10",0,[[1920,1200,60]]],["amd radeon pro","pro",0,[[1920,1080,114]]],["amd radeon pro 270x","270",0,[[2560,1440,74]]],["amd radeon pro 450","450",0,[[1920,1080,30],[2880,1800,43],[3360,2100,36],[5120,2880,30]]],["amd radeon pro 450 opengl engine","450",0,[[1920,1200,60]]],["amd radeon pro 455","455",0,[[2879,1800,54],[2880,1800,48],[3360,2100,37]]],["amd radeon pro 455 opengl engine","455",0,[[3360,2100,36]]],["amd radeon pro 460","460",0,[[2880,1800,50],[3360,2100,42]]],["amd radeon pro 460 opengl engine","460",0,[[5760,3240,15]]],["amd radeon pro 470","470",0,[[6016,3384,49]]],["amd radeon pro 480","480",0,[[1920,1080,60]]],["amd radeon pro 5300","5300",0,[[5120,2880,60]]],["amd radeon pro 5300m","5300",0,[[1920,1080,214],[3584,2240,130]]],["amd radeon pro 5500 xt","5500",0,[[5120,2880,51]]],["amd radeon pro 5500m","5500",0,[[3072,1920,60],[3584,2240,139]]],["amd radeon pro 555","555",0,[[2879,1800,54],[2880,1800,36],[3360,2100,40]]],["amd radeon pro 555x","555",0,[[2880,1800,42],[3360,2100,39]]],["amd radeon pro 560","560",0,[[2879,1800,56],[2880,1800,56],[3360,2100,42]]],["amd radeon pro 5600m","5600",0,[[3072,1920,60],[3584,2240,60]]],["amd radeon pro 560x","560",0,[[2879,1800,59],[2880,1800,71],[3360,2100,43]]],["amd radeon pro 570","570",0,[[5120,2880,48]]],["amd radeon pro 570 opengl engine","570",0,[[5120,2880,46]]],["amd radeon pro 5700","5700",0,[[5120,2880,60]]],["amd radeon pro 5700 xt","5700",0,[[5120,2880,60]]],["amd radeon pro 570x","570",0,[[5120,2880,50]]],["amd radeon pro 575","575",0,[[4096,2304,60],[5120,2880,50]]],["amd radeon pro 575 opengl engine","575",0,[[5120,2880,48]]],["amd radeon pro 575x","575",0,[[5120,2880,56]]],["amd radeon pro 580","580",0,[[5120,2880,54]]],["amd radeon pro 580 opengl engine","580",0,[[5120,2880,50]]],["amd radeon pro 580x","580",0,[[5120,2880,52]]],["amd radeon pro duo","pro",0,[[1920,1080,234],[1800,1350,59],[3840,2160,82],[4096,2160,60]]],["amd radeon pro rx 560","560",0,[[2560,1080,60]]],["amd radeon pro ssg","pro",0,[[3440,1440,125]]],["amd radeon pro v340","340",0,[[1920,1080,112]]],["amd radeon pro v520 mxgpu","520",0,[[1920,1080,271]]],["amd radeon pro v7350x2","7350",0,[[1920,1080,60]]],["amd radeon pro vega 16","16",0,[[2879,1800,60],[3360,2100,60]]],["amd radeon pro vega 20","20",0,[[2880,1800,120],[3360,2100,121],[3840,2160,30]]],["amd radeon pro vega 48","48",0,[[5120,2880,86]]],["amd radeon pro vega 56","56",0,[[1920,1080,60],[5120,2880,60]]],["amd radeon pro vega 56 opengl engine","56",0,[[5120,2880,60]]],["amd radeon pro vega 64","64",0,[[5120,2880,60]]],["amd radeon pro vega 64 opengl engine","64",0,[[5120,2880,60]]],["amd radeon pro vega 64x","64",0,[[2560,1440,206],[4096,2304,60],[5120,2880,60]]],["amd radeon pro vega ii","proii",0,[[3840,1600,60],[5120,2880,60]]],["amd radeon pro vega ii duo","proii",0,[[2560,1440,239],[5120,2880,60]]],["amd radeon pro w5500","5500",0,[[1920,1080,195],[3840,2160,59],[7680,3240,56]]],["amd radeon pro w5500m","5500",0,[[1920,1080,60]]],["amd radeon pro w5500x","5500",0,[[1920,1200,60]]],["amd radeon pro w5700","5700",0,[[1680,1050,253],[5120,1440,120],[3840,2160,60]]],["amd radeon pro w5700x","5700",0,[[3840,2160,60]]],["amd radeon pro w6600","6600",0,[[1920,1200,60],[3840,2160,166]]],["amd radeon pro w6600m","6600",0,[[1920,1080,60]]],["amd radeon pro w6800","6800",0,[[1920,1080,60],[3840,2160,237]]],["amd radeon pro w6800x","6800",0,[[6016,3384,60]]],["amd radeon pro w6800x duo","6800",0,[[3840,1600,60],[5120,2880,45]]],["amd radeon pro w6900x","6900",0,[[3840,2160,60]]],["amd radeon pro wx","pro",0,[[2560,1080,69]]],["amd radeon pro wx 2100","2100",0,[[1280,1024,145],[1920,1080,60]]],["amd radeon pro wx 3100","3100",0,[[1919,1080,58],[1920,1080,123],[2560,1440,82]]],["amd radeon pro wx 3200","3200",0,[[2560,1440,92]]],["amd radeon pro wx 4100","4100",0,[[1920,1080,60],[1920,1200,60],[3840,2160,30],[5120,2880,18]]],["amd radeon pro wx 4130","4130",0,[[1920,1080,60],[3840,2160,30]]],["amd radeon pro wx 4150","4150",0,[[1920,1080,56],[3840,2160,37],[4096,2160,34]]],["amd radeon pro wx 5100","5100",0,[[1920,1080,60],[2560,1440,91],[3840,2160,55]]],["amd radeon pro wx 5100 opengl engine","5100",0,[[2560,1440,60]]],["amd radeon pro wx 7100","7100",0,[[1920,1080,122],[2560,1080,58],[3840,2160,60],[5120,2880,60]]],["amd radeon pro wx 7100 mobile","7100",0,[[2560,1440,60]]],["amd radeon pro wx 7100 opengl engine","7100",0,[[3840,2160,60]]],["amd radeon pro wx 8200","8200",0,[[3440,1440,124]]],["amd radeon pro wx 9100","9100",0,[[1920,1080,60],[4096,2160,101]]],["amd radeon pro wx 9100 opengl engine","9100",0,[[1920,1080,60]]],["amd radeon pro wx vega m gl","prom",0,[[3840,2160,14]]],["amd radeon pro wx3200","3200",0,[[1920,1080,55]]],["amd radeon pro wx9100","9100",0,[[2560,1440,60]]],["amd radeon r2","2",0,[[1366,768,13],[1600,900,14]]],["amd radeon r2e","2",0,[[1366,768,16],[1920,1080,45],[3840,2160,4]]],["amd radeon r3","3",0,[[1366,768,17],[1920,1080,15]]],["amd radeon r4","4",0,[[1366,768,19],[1920,1080,13]]],["amd radeon r4e","4",0,[[3840,2160,6]]],["amd radeon r5","5",0,[[1024,768,38],[1360,768,25],[1366,768,21],[1280,1024,33],[1920,1080,14],[3200,1800,7]]],["amd radeon r5 220","5",0,[[1366,768,19],[1920,1080,12]]],["amd radeon r5 230","5",0,[[1920,1080,21]]],["amd radeon r5 235","5",0,[[1920,1080,17]]],["amd radeon r5 240","5",0,[[1280,1024,34],[1920,1080,24]]],["amd radeon r5 340","5",0,[[1920,1080,27]]],["amd radeon r5 340x","5",0,[[1920,1080,31]]],["amd radeon r5 430","5",0,[[1280,1024,31],[1680,1050,54],[1920,1080,54]]],["amd radeon r5 435","5",0,[[1920,1080,30]]],["amd radeon r5 m200","5",0,[[1600,900,45],[1920,1080,20]]],["amd radeon r5 m200 / hd 8500m","5",0,[[1366,768,31],[1920,1080,24]]],["amd radeon r5 m230","5",0,[[1366,768,37]]],["amd radeon r5 m240","5",0,[[1366,768,42],[1920,1080,23]]],["amd radeon r5 m255","5",0,[[1366,768,59],[1600,900,33]]],["amd radeon r5 m315","5",0,[[1366,768,45]]],["amd radeon r5 m320","5",0,[[1920,1080,19]]],["amd radeon r5 m330","5",0,[[1366,768,27],[1920,1080,26]]],["amd radeon r5 m335","5",0,[[1366,768,55],[1920,1080,19]]],["amd radeon r5 m420","5",0,[[1366,768,49]]],["amd radeon r5 m430","5",0,[[1366,768,36],[1920,1080,20]]],["amd radeon r5 m435","5",0,[[1920,1080,41],[2560,1440,67]]],["amd radeon r5 m445","5",0,[[1920,1080,32]]],["amd radeon r5e","5",0,[[1600,768,14],[1920,1080,16]]],["amd radeon r6","6",0,[[1366,768,30],[1280,1024,23],[1920,1080,12]]],["amd radeon r6 m255dx","6",0,[[1366,768,25]]],["amd radeon r6 m340dx","6",0,[[1366,768,31],[1920,1080,15]]],["amd radeon r6e","6",0,[[3840,2160,5]]],["amd radeon r7","7",0,[[1366,768,35],[1280,1024,31],[1680,1050,39],[1920,1080,12],[1920,1200,16],[2560,1080,15],[2560,1440,21],[3840,2160,8]]],["amd radeon r7 200","7",0,[[1280,1024,45],[1920,1080,120]]],["amd radeon r7 200 series","7",0,[[1920,1080,43]]],["amd radeon r7 240","7",0,[[1920,1080,29]]],["amd radeon r7 240 + hd 8570d dual","7",0,[[1920,1080,43]]],["amd radeon r7 250","7",0,[[1920,1080,49]]],["amd radeon r7 250e","7",0,[[1920,1080,60]]],["amd radeon r7 250x","7",0,[[1920,1080,60]]],["amd radeon r7 260x","7",0,[[1920,1080,56]]],["amd radeon r7 260x/360","7",0,[[1920,1200,102]]],["amd radeon r7 350","7",0,[[1024,768,60],[1280,1024,79],[1920,1080,59]]],["amd radeon r7 350x","7",0,[[1920,1080,50]]],["amd radeon r7 360","7",0,[[1920,1048,60],[1920,1080,102]]],["amd radeon r7 360 / r9 360","7",0,[[1920,1080,60]]],["amd radeon r7 370","7",0,[[1600,900,60],[1920,1080,75]]],["amd radeon r7 370 / r9 270","7",0,[[1920,1080,74]]],["amd radeon r7 370 / r9 270x/370","7",0,[[1600,900,115],[1920,1080,60]]],["amd radeon r7 370 / r9 270x/370x","7",0,[[1920,1080,115]]],["amd radeon r7 370 series","7",0,[[1920,1080,212],[3840,2160,60]]],["amd radeon r7 430","7",0,[[1920,1080,55],[3840,2160,10]]],["amd radeon r7 450","7",0,[[1920,1080,60]]],["amd radeon r7 a360","7",0,[[1920,1080,28]]],["amd radeon r7 graphics + hd 7700 dual","7",0,[[1600,1200,72]]],["amd radeon r7 graphics + r5 340 dual","7",0,[[1920,1080,47]]],["amd radeon r7 graphics + r7 200 dual","7",0,[[1920,1080,45],[1920,1200,47]]],["amd radeon r7 graphics + r7 350 dual","7",0,[[1919,1080,60]]],["amd radeon r7 m260","7",0,[[1600,900,44],[1920,1080,13]]],["amd radeon r7 m260dx","7",0,[[1366,768,46],[1920,1080,18]]],["amd radeon r7 m260x","7",0,[[1920,1080,29]]],["amd radeon r7 m265","7",0,[[1366,768,48],[1920,1080,27]]],["amd radeon r7 m270","7",0,[[1920,1080,31],[3840,2160,10]]],["amd radeon r7 m340","7",0,[[1366,768,60],[1920,1080,32]]],["amd radeon r7 m350","7",0,[[3840,2160,12]]],["amd radeon r7 m360","7",0,[[1366,768,40],[1920,1080,22]]],["amd radeon r7 m370","7",0,[[1920,1080,24]]],["amd radeon r7 m440","7",0,[[1920,1080,39]]],["amd radeon r7 m445","7",0,[[1920,1080,36]]],["amd radeon r7 m460","7",0,[[1919,1080,24],[1920,1080,29]]],["amd radeon r7 m520","7",0,[[1919,1080,17]]],["amd radeon r7 series / hd 9000","7",0,[[1920,1080,71],[2560,1080,59]]],["amd radeon r7e","7",0,[[1024,768,41]]],["amd radeon r8 m350dx","8",0,[[1366,768,30]]],["amd radeon r8 m365dx","8",0,[[1920,1080,28]]],["amd radeon r8 m435dx","8",0,[[1920,1080,22]]],["amd radeon r8 m445dx","8",0,[[1366,768,38],[1920,1080,27]]],["amd radeon r8 m535dx","8",0,[[1366,768,55]]],["amd radeon r9","9",0,[[1920,1080,60]]],["amd radeon r9 200","9",0,[[1920,1080,60]]],["amd radeon r9 200 / hd 7900","9",0,[[1920,1080,250]]],["amd radeon r9 255","9",0,[[1600,900,52],[1920,1080,51]]],["amd radeon r9 260","9",0,[[1920,1080,16]]],["amd radeon r9 270","9",0,[[1280,1024,60],[1920,1080,60]]],["amd radeon r9 270 1024sp","9",0,[[1920,1080,135]]],["amd radeon r9 270x","9",0,[[1920,1080,30]]],["amd radeon r9 280","9",0,[[1920,1080,75],[1920,1200,428],[2560,1440,60]]],["amd radeon r9 280,","9",0,[[5120,2880,39]]],["amd radeon r9 280x","9",0,[[1920,1080,137]]],["amd radeon r9 285","9",0,[[1920,1080,60],[1920,1200,129]]],["amd radeon r9 290","9",0,[[1920,1080,60]]],["amd radeon r9 290x","9",0,[[1920,1080,60],[2560,1440,60],[3840,2160,118]]],["amd radeon r9 300","9",0,[[1920,1080,59]]],["amd radeon r9 350","9",0,[[1920,1200,63]]],["amd radeon r9 360","9",0,[[1600,900,83],[1920,1080,60],[2560,1440,59]]],["amd radeon r9 370","9",0,[[1680,1050,205],[1920,1080,60],[3840,2160,49]]],["amd radeon r9 370x","9",0,[[1920,1080,60]]],["amd radeon r9 380","9",0,[[1920,1080,41],[2560,1440,75]]],["amd radeon r9 380x","9",0,[[2560,1600,60]]],["amd radeon r9 390","9",0,[[1920,1080,60],[2560,1440,60]]],["amd radeon r9 390x","9",0,[[2560,1440,60],[3840,2160,60]]],["amd radeon r9 a375","9",0,[[1920,1080,28]]],["amd radeon r9 fury","9",0,[[1920,1080,75],[3840,2160,133]]],["amd radeon r9 fury / nano","9",0,[[1920,1200,155]]],["amd radeon r9 m200x","9",0,[[1366,768,104],[1920,1080,60]]],["amd radeon r9 m265x","9",0,[[1920,1080,33]]],["amd radeon r9 m270x","9",0,[[1600,900,60],[1920,1080,68]]],["amd radeon r9 m275","9",0,[[1920,1080,29]]],["amd radeon r9 m275x","9",0,[[1920,1080,20]]],["amd radeon r9 m280x","9",0,[[1920,1080,60],[2560,1440,25]]],["amd radeon r9 m290","9",0,[[5120,2880,33]]],["amd radeon r9 m290x","9",0,[[1920,1080,60],[3840,2160,61],[5120,2880,33]]],["amd radeon r9 m295x","9",0,[[3840,2160,33],[5120,2880,36]]],["amd radeon r9 m295x mac","9",0,[[5120,2880,42]]],["amd radeon r9 m295x mac edition / r9 380x","9",0,[[1920,1080,128]]],["amd radeon r9 m360","9",0,[[1920,1080,60],[3840,2160,26]]],["amd radeon r9 m370x","9",0,[[2560,1440,30],[2880,1800,27]]],["amd radeon r9 m370x opengl engine","9",0,[[5120,2880,14]]],["amd radeon r9 m375","9",0,[[1920,1080,29]]],["amd radeon r9 m375x","9",0,[[1920,1080,60],[3840,2160,22]]],["amd radeon r9 m380","9",0,[[1920,1080,50],[3840,2160,8],[5120,2880,9]]],["amd radeon r9 m380 opengl engine","9",0,[[5120,2880,15]]],["amd radeon r9 m385","9",0,[[1920,1080,58]]],["amd radeon r9 m385x","9",0,[[1920,1080,60]]],["amd radeon r9 m390","9",0,[[5119,2879,29],[5120,2880,21],[5760,3240,32]]],["amd radeon r9 m390 opengl engine","9",0,[[5120,2880,27]]],["amd radeon r9 m390x","9",0,[[1920,1080,140]]],["amd radeon r9 m395","9",0,[[2560,1440,59],[5120,2880,19]]],["amd radeon r9 m395 opengl engine","9",0,[[5120,2880,38]]],["amd radeon r9 m395x","9",0,[[3840,2160,58],[5120,2880,36]]],["amd radeon r9 m395x opengl engine","9",0,[[5120,2880,35]]],["amd radeon r9 m470","9",0,[[3840,2160,29]]],["amd radeon r9 m470x","9",0,[[1920,1080,60]]],["amd radeon r9-290x","9",0,[[1920,1080,60]]],["amd radeon renoir graphics d1","1",0,[[1366,768,60]]],["amd radeon rro 580x","580",0,[[5120,2880,59]]],["amd radeon rx 460","460",0,[[1920,1080,55],[2560,1080,60],[3840,2160,31]]],["amd radeon rx 460 / pro 450/455/460/555/555x/560/560x","460",0,[[3440,1440,93]]],["amd radeon rx 460 / pro 450/455/460/560","460",0,[[1920,1080,72]]],["amd radeon rx 470","470",0,[[1280,1024,73],[1920,1080,58],[1920,1200,147],[3840,2160,51]]],["amd radeon rx 470 opengl engine","470",0,[[2560,1440,60]]],["amd radeon rx 475m","475",0,[[1920,1080,60]]],["amd radeon rx 480","480",0,[[1400,1050,267],[1920,1080,60],[2560,1080,71]]],["amd radeon rx 480 opengl engine","480",0,[[1920,1080,60]]],["amd radeon rx 5300m","5300",0,[[1920,1080,60],[3840,2160,60]]],["amd radeon rx 540","540",0,[[1919,1080,52],[1920,1080,36]]],["amd radeon rx 550","550",0,[[1280,1024,135],[1920,1080,60],[1920,1200,60],[6016,3384,15]]],["amd radeon rx 550 640sp / rx 560","550",0,[[1920,1080,60]]],["amd radeon rx 5500","5500",0,[[1920,1080,139]]],["amd radeon rx 5500 / pro 5500m","5500",0,[[1920,1080,60],[2560,1440,227]]],["amd radeon rx 5500 xt","5500",0,[[1920,1080,239]]],["amd radeon rx 5500m","5500",0,[[1920,1048,144],[1920,1080,144],[3840,2160,60]]],["amd radeon rx 550x","550",0,[[1920,1080,52]]],["amd radeon rx 560","560",0,[[1920,1080,60],[1920,1200,42],[2560,1440,60]]],["amd radeon rx 560 [baffin]","560",0,[[1920,1080,60]]],["amd radeon rx 5600 oem/5600 xt / 5700 xt","5600",0,[[1920,1080,360],[2560,1440,164]]],["amd radeon rx 5600 xt","5600",0,[[1920,1080,75]]],["amd radeon rx 5600m","5600",0,[[1920,1080,144]]],["amd radeon rx 560d","560",0,[[2560,1080,60]]],["amd radeon rx 560x","560",0,[[1920,1080,115],[3840,2160,35]]],["amd radeon rx 570","570",0,[[1920,1080,60],[3072,1728,60]]],["amd radeon rx 570 opengl engine","570",0,[[1920,1080,226]]],["amd radeon rx 5700","5700",0,[[1920,1080,144]]],["amd radeon rx 5700 / 5700 xt","5700",0,[[3840,2160,201]]],["amd radeon rx 5700 xt","5700",0,[[1920,1080,464],[3840,2160,60],[6016,3384,34]]],["amd radeon rx 5700 xt 50th anniversary","5700",0,[[2560,1440,144],[3840,1600,60],[3840,2160,222],[5120,2880,60]]],["amd radeon rx 5700xt","5700",0,[[1920,1080,369]]],["amd radeon rx 580","580",0,[[1920,1080,60],[1920,1200,97],[2560,1440,60],[3840,2160,60]]],["amd radeon rx 580 2048sp","580",0,[[1920,1080,60]]],["amd radeon rx 580 opengl engine","580",0,[[1920,1080,145]]],["amd radeon rx 580 special","580",0,[[2560,1440,60]]],["amd radeon rx 580x","580",0,[[1920,1200,60],[3840,2160,79]]],["amd radeon rx 590","590",0,[[1920,1080,75],[2560,1440,164],[3584,2240,60]]],["amd radeon rx 640","640",0,[[1920,1080,39]]],["amd radeon rx 6500 xt","6500",0,[[1920,1080,60]]],["amd radeon rx 6600","6600",0,[[1920,1080,433],[3840,2160,57]]],["amd radeon rx 6600 xt","6600",0,[[1920,1080,60]]],["amd radeon rx 6600 xt/6600m","6600",0,[[2560,1440,60]]],["amd radeon rx 6600m","6600",0,[[1920,1080,139]]],["amd radeon rx 6700 xt","6700",0,[[1920,1080,451]]],["amd radeon rx 6700 xt / 6800m","6700",0,[[2560,1440,144]]],["amd radeon rx 6700m","6700",0,[[1920,1080,240]]],["amd radeon rx 6800","6800",0,[[2560,1440,564],[3840,2160,60]]],["amd radeon rx 6800 xt","6800",0,[[2560,1440,446],[3440,1440,144],[3840,2160,60]]],["amd radeon rx 6800 xt / 6900 xt","6800",0,[[2560,1440,239]]],["amd radeon rx 6800 xt 16gb","6800",0,[[6400,2666,60]]],["amd radeon rx 6800m","6800",0,[[1920,1080,300]]],["amd radeon rx 6900 xt","6900",0,[[3840,2160,60]]],["amd radeon rx rx 560","560",0,[[1920,1080,60]]],["amd radeon rx vega","rx",0,[[1920,1080,39]]],["amd radeon rx vega 10","10",0,[[1920,1080,38]]],["amd radeon rx vega 11","11",0,[[1920,1080,35]]],["amd radeon rx vega 56","56",0,[[1920,1080,144],[3440,1440,60],[3840,2160,60]]],["amd radeon rx vega 56 8gb","56",0,[[2560,1600,60]]],["amd radeon rx vega 56 opengl engine","56",0,[[2560,1440,60]]],["amd radeon rx vega 64","64",0,[[2560,1440,518]]],["amd radeon rx vega 64 8gb","64",0,[[2560,1440,60]]],["amd radeon rx vega 64 opengl engine","64",0,[[3840,2160,119]]],["amd radeon rx vega 64.1","64",0,[[6016,3384,60]]],["amd radeon rx vega 8","8",0,[[1920,1080,53]]],["amd radeon rx vega m gh","rxm",0,[[1920,1080,60],[2560,1440,60],[3840,2160,51]]],["amd radeon rx vega m gl","rxm",0,[[2560,1440,567],[3840,2160,59]]],["amd radeon rx vega11","11",0,[[2496,1664,30]]],["amd radeon rx460","460",0,[[1920,1080,60]]],["amd radeon rx480","480",0,[[1920,1080,102],[2560,1080,71]]],["amd radeon rx540","540",0,[[2400,1800,37]]],["amd radeon rx550","550",0,[[1920,1080,60]]],["amd radeon rx560","560",0,[[1920,1080,93]]],["amd radeon rx5600","5600",0,[[3840,2160,129]]],["amd radeon rx570","570",0,[[5120,2880,59]]],["amd radeon rx5700","5700",0,[[1920,1080,60]]],["amd radeon rx580","580",0,[[1920,1080,60]]],["amd radeon rx590 gme","590",0,[[1920,1080,112]]],["amd radeon rx6600xt","6600",0,[[3840,2160,60]]],["amd radeon sky 500","500",0,[[4096,2160,34]]],["amd radeon vega","",0,[[5120,2880,32]]],["amd radeon vega 10","10",0,[[1920,1080,44]]],["amd radeon vega 10 mobile","10",0,[[1920,1080,30]]],["amd radeon vega 11","11",0,[[1280,1024,60],[1920,1080,60],[3840,2160,17]]],["amd radeon vega 2","2",0,[[1366,768,30]]],["amd radeon vega 3","3",0,[[1440,900,44],[1920,1080,29],[3840,2160,8]]],["amd radeon vega 3 mobile","3",0,[[1920,1080,30]]],["amd radeon vega 56","56",0,[[2560,1440,144]]],["amd radeon vega 6","6",0,[[1366,768,61],[1920,1080,23]]],["amd radeon vega 64","64",0,[[6016,3384,35]]],["amd radeon vega 64 lc","64",0,[[2560,1080,60]]],["amd radeon vega 8","8",0,[[1920,1080,35],[2560,1440,24],[4096,2160,15]]],["amd radeon vega 8 mobile","8",0,[[1920,1080,36]]],["amd radeon vega 9","9",0,[[2496,1663,32],[2496,1664,39]]],["amd radeon vega fe","fe",0,[[1920,1080,120],[2560,1440,60]]],["amd radeon vega frontier","",0,[[1920,1080,120],[3840,2160,60]]],["amd radeon vega frontier edition opengl engine","",0,[[3440,1440,60]]],["amd radeon vega series / radeon vega mobile","",0,[[1920,1080,67]]],["amd radeon vii","vii",0,[[1920,1080,468],[2560,1440,60],[3840,2160,60]]],["amd radeont 540x","540",0,[[1920,1080,74],[3840,2160,22]]],["amd radeont rx 5300","5300",0,[[1920,1080,60]]],["amd radeont rx 5500m","5500",0,[[1920,1080,303]]],["amd radeont rx 560x","560",0,[[1920,1080,60]]],["amd saphire radeon rx 580","580",0,[[1920,1080,57]]],["amd sapphire radeon hd6870","6870",0,[[1680,1050,60]]],["amd sapphire radeon rx 560","560",0,[[1280,1024,60]]],["amd sapphire radeon rx vega 64 8gb","64",0,[[2560,1440,144]]],["intel radeon pro vega 16","16",0,[[3360,1890,20]]],["intel radeong 0.4 on amd bonaire","0",0,[[1920,1200,92]]],["intel radeong 0.4 on amd cape verde","0",0,[[1920,1200,73]]],["intel radeong 0.4 on amd polaris10","0",0,[[3840,2160,108]]],["intel radeong 0.4 on amd tonga","0",0,[[1920,1080,124]]],["radeon 500","500",0,[[1920,1080,58]]],["radeon 550","550",0,[[1920,1080,60]]],["radeon 550x","550",0,[[1920,1080,68]]],["radeon hd 7700","7700",0,[[1920,1080,60],[1920,1200,90]]],["radeon hd 7800","7800",0,[[1920,1080,60]]],["radeon hd 7900","7900",0,[[1920,1080,60],[1920,1200,60],[2560,1440,60]]],["radeon hd 8500","8500",0,[[1920,1080,42]]],["radeon hd 8790m","8790",0,[[1600,900,60]]],["radeon hd8800","8800",0,[[1920,1080,60]]],["radeon pro wx 5100 graphics (polaris10 / drm 3.27.0 / 4.19.4-1.el7.elrepo.x86_64, llvm 6.0","5100",0,[[1920,1080,60]]],["radeon pro wx3100","3100",0,[[2560,1440,1],[3840,2160,43]]],["radeon r5 340","5",0,[[1536,864,41]]],["radeon r5 m330","5",0,[[1366,768,38]]],["radeon r7 200","7",0,[[1280,1024,60],[2560,1440,52]]],["radeon r7 300","7",0,[[1920,1080,60]]],["radeon r7 m340","7",0,[[1920,1080,32]]],["radeon r7 m360","7",0,[[1920,1080,32]]],["radeon r9 200","9",0,[[1920,1080,60],[1920,1200,60],[2560,1440,1]]],["radeon r9 380","9",0,[[2560,1440,1]]],["radeon r9 390","9",0,[[1920,1080,60],[2560,1440,60]]],["radeon r9 fury","9",0,[[1920,1080,51],[1920,1920,60]]],["radeon rx","rx",0,[[1920,1200,60]]],["radeon rx 460","460",0,[[1920,1080,60],[1920,1200,60]]],["radeon rx 470","470",0,[[1280,768,60],[1680,1050,422],[1920,1080,60],[2560,1440,60]]],["radeon rx 480","480",0,[[1920,1080,60],[1920,1200,185],[2560,1440,1]]],["radeon rx 550","550",0,[[1600,900,60],[1680,1050,60],[1920,1080,1],[1920,1200,60],[2560,1080,60],[3840,2160,30]]],["radeon rx 5500 xt","5500",0,[[1920,1080,60],[1920,1200,60],[2560,1440,60],[3840,2160,19]]],["radeon rx 560","560",0,[[1600,900,60],[1920,1080,29],[1920,1200,47],[2688,1512,60],[3440,1440,60],[3840,2160,58]]],["radeon rx 5600 xt","5600",0,[[1920,1080,60]]],["radeon rx 570","570",0,[[1440,900,60],[1280,1024,60],[1920,1080,51],[1920,1200,60],[2560,1080,60],[2560,1440,37],[3440,1440,60]]],["radeon rx 5700 xt","5700",0,[[1707,960,60],[1920,1080,60],[2560,1440,55],[3840,2160,60]]],["radeon rx 580","580",0,[[1477,831,72],[1440,900,60],[1680,1050,60],[1920,1080,4],[1920,1200,60],[2560,1080,52],[2560,1440,60],[2560,1600,60],[3840,2160,1]]],["radeon rx 580 2048sp","580",0,[[1440,900,75]]],["radeon rx 590","590",0,[[1920,1080,60],[2560,1440,60],[3840,2160,30]]],["radeon rx vega","rx",0,[[1920,1080,60],[1920,1200,60],[2194,1234,60],[2560,1080,60],[2560,1440,60],[3440,1440,75],[3840,2160,60]]],["radeon rx vega 8","8",0,[[3840,2160,23]]],["radeon rx550","550",0,[[1680,1050,60],[1920,1080,60],[3440,1440,58]]],["radeon vega 8","8",0,[[1680,1050,60]]],["radeon vega frontier","",0,[[2560,1440,144]]],["radeon vii","vii",0,[[2560,1440,60],[3440,1440,60],[3840,2160,1]]],["radeong 0.4 on amd polaris10","0",0,[[3840,2160,109]]],["radeong 0.4 on amd tahiti","0",0,[[1920,1080,223]]],["ryzen embedded r1305g with radeon vega gfx","1305",0,[[3840,2160,14]]],["ryzen embedded v1605b with radeon vega gfx","1605",0,[[3840,2160,28]]]]\')},921:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["adreno 506","506",0,[[1512,720,18,"motorola moto g(7) play"]]],["adreno 530","530",0,[[2560,1140,27,"samsung galaxy s7 (sm-930x)"],[2392,1440,28,"google pixel xl"]]],["adreno 615","615",0,[[2088,1080,20,"google pixel 3a"]]],["adreno 618","618",0,[[2210,1080,34,"xiaomi mi 9t"]]],["adreno 620","620",0,[[2340,1080,42,"google pixel 5"]]],["adreno 630","630",0,[[2280,1080,58,"oneplus a6003"]]],["adreno 640","640",0,[[2280,1080,60,"google pixel 4"]]],["qualcomm adreno 205","205",0,[[1280,720,11,"coolpad 8675-w00 (adreno 205)"]]],["qualcomm adreno 304","304",0,[[480,320,16,"zte z353vl cymbal t"],[480,480,6,"lg watch sport"],[758,480,8,"kyocera kyf33 torque x01 s-max"],[782,480,8,"vodafone vfd 510"],[791,480,8,"acer t012"],[792,480,6,"lg k4 2017 (m151, m160, m150 phoenix 3, m153 fortune, m154 risio 2, l58vl rebel 2)"],[800,480,7,"chainway c4050-q4"],[854,480,6,"zte q302c"],[897,540,6,"kyocera c6742 hydro view"],[960,540,6,"cat s40"],[1024,552,6,"tcl 9007 pixi 3 (7)"],[1184,720,4,"micromax q4251 canvas juice a1"],[1187,720,4,"lg phoenix 2 (k37x)"],[1193,720,4,"lg x power (k210, k450)"],[1196,720,4,"obi sj2.5"],[1217,720,4,"fibo la0920"],[1224,720,4,"umax visionbook p70 lte"],[1280,720,4,"k-touch beeline fast +"],[1280,736,4,"alcatel 9022x one touch pixi 3 8.0"],[1280,752,4,"lenovo tab 10 (x103f)"]]],["qualcomm adreno 305","305",0,[[432,320,18,"sonim xp6700"],[480,320,16,"lg t480s wine smart 3g"],[400,400,0,"huawei watch"],[734,480,7,"lg l fino (d290, d295)"],[737,480,7,"acer liquid z220"],[790,480,8,"htc desire 510 (adreno 305)"],[791,480,7,"sony xperia m (c19xx, c20xx)"],[800,480,5,"cherry mobile q510"],[854,480,6,"alcatel a564c one touch pop icon"],[886,540,7,"lg g2 mini (d610, d618, d620)"],[896,540,7,"htc desire 610"],[897,540,5,"motorola xt830c moto e"],[960,540,4,"huawei c8817l"],[1024,528,5,"aurora au701"],[1024,552,4,"asus zenfone go 6.9 (l001 zb690kg)"],[982,600,4,"huawei mediapad 7 youth 2"],[1024,600,7,"samsung galaxy tab 3 7.0 (sm-t215, sm-t217)"],[1024,720,4,"ereneben eben a2"],[1024,722,5,"prestigio pmt5287 multipad ranger 8.0 4g"],[1280,648,5,"tomtom bridge"],[1184,720,5,"htc desire 650 (d650)"],[1188,720,4,"lg aka (h778, h788, f520x)"],[1196,720,3,"zte z787"],[1200,720,4,"lg g vista (d631, vs880, gx2 f430)"],[1216,720,4,"vodafone smart 4 max"],[1217,720,4,"kyocera e6790 duraforce xd"],[1220,720,4,"huawei ascend mate 2 mt2-l03"],[1196,768,4,"infocus m2"],[1280,720,3,"zuum p47"],[1280,732,4,"lg g pad 7.0 (uk410, v410, vk410)"],[1280,736,4,"zte amazing p6"],[1280,737,4,"asus memo pad hd 7 (k00s me175kg)"],[1280,739,4,"lg g pad 8.0 (v480, v49x, p490, t01)"],[1280,740,4,"qualcomm msm8926 (adreno 305, development board)"],[1280,752,4,"asus padfone e (t008 a68m)"],[1216,800,3,"huawei mediapad t1 8.0 (adreno 305)"],[1280,800,3,"samsung tn10gedlte"],[1920,1080,2,"zte s2002 star 1"],[1920,1128,2,"lenovo b8080"]]],["qualcomm adreno 306","306",0,[[734,480,9,"lg f60 (d390, d392)"],[790,480,8,"htc desire 510 (adreno 306)"],[791,480,5,"lg l21g destiny"],[800,480,8,"covia fleaz cp-l42a pop"],[854,480,8,"freetel ft151a priori2 lte"],[897,540,7,"kyocera c6740 hydro wave"],[960,540,5,"blu studio mini lte 2"],[1024,552,6,"tcl 9006w"],[1024,600,5,"samsung sm-t116ir (adreno 306)"],[1024,720,5,"ereneben eben k8s"],[1024,768,5,"samsung sm-p350 galaxy tab a plus"],[1184,720,4,"lg x screen (k500, f650)"],[1188,720,4,"lg band play (f570s)"],[1196,720,4,"fly a5042"],[1199,720,4,"lg stylus 2 (f720, k520, k540, ls775 g stylo 2, l82vl)"],[1200,720,4,"lg g4 stylus (h63x, ms631, f560, ls770 g stylo)"],[1208,720,4,"vizio xr6m10 tablet remote"],[1217,720,4,"lenovo pb1-750x phab"],[1224,720,4,"c spire ft7"],[1280,720,3,"bgh joy smart axs ii"],[1280,736,4,"vodafone smart tab 4g"],[1280,752,4,"huawei mediapad t1 10 (t1-a21)"],[1216,800,4,"huawei mediapad t1 8.0 pro, lte (adreno 306)"],[1280,800,4,"samsung galaxy tab e 8.0 (adreno 306, sm-t377p)"],[1794,1080,2,"bluebird sf550"],[1815,1080,2,"vizio xr6"],[1920,1080,2,"longcheer cc01"]]],["qualcomm adreno 308","308",0,[[800,480,13,"samsung galaxy folder 2 (sm-g160x)"],[854,480,12,"coolpad 3632"],[960,540,10,"samsung sm-j250g"],[1184,720,5,"infocus 00ww"],[1187,720,6,"lg m200"],[1193,720,6,"lg k20 plus (mp260, k20 v vs501)"],[1195,720,6,"lg x charge (x power 2, m322, l63bl fiesta)"],[1199,720,6,"lg stylo 3 (l83bl)"],[1280,720,6,"hisense f23"],[1280,736,6,"lenovo tb-8504"],[1280,752,6,"lenovo tb-x304"],[1344,720,6,"wiko view"],[1223,800,6,"huawei mediapad t3 8.0 (kob-xxx)"],[1368,720,6,"casper via g1"],[1280,800,6,"samsung galaxy tab a2 s (sm-t380, sm-t385)"]]],["qualcomm adreno 320","320",0,[[1196,720,11,"pantech im-a850 vega r3"],[1196,768,10,"google nexus 4 (lg e960)"],[1280,720,8,"blackberry z30"],[1280,752,8,"asus memo pad 10 (k01e me103k)"],[1280,768,10,"lg optimus g (e97x, ls970, e987, f180, kddi lgl21)"],[1920,1008,5,"technicolor px36"],[1794,1080,5,"sony xperia z (c66xx, so-02e, l36x)"],[1848,1080,5,"pantech im-a860 vega n6"],[1920,1080,5,"zte nubia z5 (nx501, nx50x)"],[1920,1104,5,"google nexus 7 (2nd gen, razor)"],[1920,1114,4,"lg g pad 8.3 (vk810 4g)"],[1920,1128,5,"sony xperia tablet z (sgp3xx, so-03e)"]]],["qualcomm adreno 330","330",0,[[800,480,18,"samsung sm-w2014"],[1184,720,27,"sony so-04g xperia a4"],[1196,720,21,"sony xperia j1 compact (d5788)"],[1202,720,21,"lg g flex (d95x, ls995, lgl23, f340)"],[1280,720,20,"amazon fire phone (sd4930ur)"],[1280,768,21,"samsung sm-w2015 galaxy golden 2"],[1280,960,14,"lg f300 optimus vu 3"],[1600,1152,15,"hp pro slate 12"],[1440,1308,10,"blackberry passport"],[1776,1080,11,"google nexus 5"],[1788,1080,11,"lg g3 a f410"],[1794,1080,10,"fujitsu f-01f arrows nx luge (docomo)"],[1803,1080,11,"lg g pro 2 (d838, f350)"],[1836,1080,11,"sony xperia z ultra (c68xx, xl39h, sol24, sgp412)"],[1920,1080,9,"qualcomm quanta is7"],[1920,1104,12,"ntt docomo sh-06f sharp aquos pad"],[1920,1128,12,"sony xperia z2 tablet (sgp5xx, so-05f, sot21)"],[1920,1129,10,"lg g pad ii (v935, v940 prada 3.0, v930 g pad x 10.1, uk932)"],[1920,1200,9,"amazon kindle fire hdx 7 (3rd gen, kfthwa, kfthwi)"],[2048,1440,8,"hp red"],[2392,1440,8,"fujitsu f-02g arrows nx (docomo)"],[2400,1440,6,"iuni u3"],[2560,1440,7,"vivo x520l xplay 3s"],[2560,1504,7,"ntt docomo f-03g (fujitsu arrows tab)"],[2560,1600,5,"samsung sm-t525 galaxy tab pro 10.1"]]],["qualcomm adreno 405","405",0,[[1184,720,13,"lyf ls-5015 water 8"],[1196,720,10,"alcatel 6044 one touch pop up"],[1200,720,12,"oppo a53"],[1280,720,8,"hisense c1"],[1280,736,10,"asus zenpad 8 (adreno 405, p024 z380kl)"],[1776,1080,7,"lyf ls-5505"],[1794,1080,6,"medion life x5020"],[1798,1080,7,"lg h740 g vista 2"],[1800,1080,6,"oppo r7s plus"],[1803,1080,6,"oppo r7 plus (adreno 405)"],[1812,1080,6,"ramos mos1"],[1824,1080,6,"vargo ivargo v210101"],[1836,1080,6,"lenovo pb1-770m everypad3"],[1920,1080,2,"smartisan yq607 jianguo"],[1920,1104,5,"lg vk815 g pad x8.3, p815l g pad ii 8.3"],[1920,1111,6,"lg g pad x 8.0 (v52x)"],[1794,1200,5,"qisda f80"],[1920,1128,5,"huawei mediapad t2 10.0 pro (fdr-xxx)"],[1830,1200,6,"huawei mediapad x3 (ple-xxx)"],[1836,1200,6,"huawei mediapad t2 8.0 pro (jdn-xxx)"]]],["qualcomm adreno 418","418",0,[[1280,768,28,"samsung sm-g9198"],[1776,1080,17,"sharp sh-m03 aquos mini"],[1794,1080,15,"softbank 502sh (sharp aquos xx2)"],[1920,1080,11,"smartisan t2 (sm801)"],[2368,1440,10,"fujitsu f-02h arrows nx (docomo)"],[2392,1440,10,"lg k600"],[2413,1440,10,"motorola moto x style, pure (xt1570, xt1572, xt1575)"],[2560,1440,9,"qiku q terra (8692-a00)"],[2560,1504,9,"ntt docomo f-04h arrows tab"]]],["qualcomm adreno 420","420",0,[[1280,720,32,"odg r7-w"],[1920,1080,20,"samsung galaxy s5 (adreno 420, sm-g901)"],[2392,1440,13,"lg g3 (adreno 420, f460)"],[2560,1352,7,"qualcomm apq8084 (adreno 420, development board)"],[2413,1440,12,"motorola moto x pro"],[2560,1440,8,"qualcomm liquid (adreno 420, windows, development board)"],[2560,1532,12,"samsung galaxy note edge (adreno 420, sm-n915x, scl24, sc-01g)"],[2560,1600,11,"amazon kindle fire hdx 8.9 (4th gen, kfsawa, kfsawi)"]]],["qualcomm adreno 430","430",0,[[1184,720,53,"sony xperia z5 compact (e58xx, so-02h)"],[1280,720,18,"zebra technologies mtp8994"],[1776,1080,29,"sony xperia z5 (e66xx, so-01h, sov32, 501so)"],[1794,1080,19,"vertu signature touch (2015)"],[1920,1080,9,"nokia rm-1106"],[1920,1104,21,"ntt docomo sh-05g sharp aquos pad"],[2392,1440,11,"sony e6508 vzw xperia z4v"],[2413,1440,17,"sirin labs solarin"],[2560,1440,7,"microsoft rm-1105"],[2560,1504,16,"sony xperia z4 tablet (sgp7xx, so-05g, sot31)"]]],["qualcomm adreno 505","505",0,[[728,480,29,"zebra technologies tc25"],[1184,720,15,"ivvi i3-01"],[1196,720,15,"huawei honor 6c (dig-xxx)"],[1199,720,14,"lg stylus 2 plus (ms550, k550)"],[1280,720,14,"xiaomi land"],[1344,720,14,"wiko view prime"],[1368,720,13,"micromax hs3"],[1776,1080,7,"hisense a2"],[1787,1080,7,"lg qua phone px (lgv33)"],[1794,1080,7,"pantech im-100 vega"],[1798,1080,8,"lg stylo 3 plus (tp450, mp450, m470)"],[1802,1080,7,"lg k11 (k530, k535)"],[1812,1080,7,"sugar f11"],[1920,1080,6,"lg x venture (h700, m710)"],[1920,1111,6,"lg g pad x ii 8.0 plus (v530)"],[2004,1080,7,"lg q6 (m700, x600)"],[1920,1128,7,"vodafone vfd 1400"],[1920,1132,7,"huawei mediapad t3 lite 10 (bah-xxx)"],[1839,1200,7,"huawei mediapad m3 lite 8.0 (cpn-xxx)"]]],["qualcomm adreno 506","506",0,[[1184,720,20,"fujitsu f-04j docomo"],[1280,720,20,"samsung galaxy j7 2017 (adreno 506, sm-j727x)"],[1320,720,18,"xiaomi redmi 5"],[1356,720,18,"vivo v7 plus (1716)"],[1620,1080,11,"blackberry bbb100-x (keyone, mercury)"],[1776,1080,10,"condor plume h1"],[1788,1080,10,"huawei nova (caz-xxx)"],[1794,1080,10,"nuans neo reloaded"],[1920,1080,9,"blackberry bbd100"],[1920,1104,9,"nec lavietab pc-ts508fam"],[1980,1080,10,"xiaomi redmi 5 plus"],[1920,1128,9,"zte k92 primetime"],[1920,1132,9,"vestel v tab 1090 lte"],[1920,1200,9,"i.safe is910.1"]]],["qualcomm adreno 508","508",0,[[1776,1080,15,"sonim xp8812"],[1798,1080,15,"sharp fs8010"],[1920,1080,14,"htc u11 life"],[2009,1080,14,"vestel venus z20"]]],["qualcomm adreno 509","509",0,[[2159,1080,15,"asus zenfone 5"]]],["qualcomm adreno 510","510",0,[[1184,720,31,"zebra technologies tc51"],[1208,800,27,"askey turbonet tn800a1 turbotab e1"],[1366,720,29,"sony xperia touch (g1109)"],[1776,1080,13,"agm x2"],[1794,1080,14,"qualcomm msm8952 (adreno 510, development board)"],[1920,1080,14,"coolpad r116 cool1"],[2048,1440,11,"asus zenpad 3 8.0 (p008 z581kl)"],[2160,1440,10,"jide remix pro"],[2048,1536,11,"asus zenpad z10 (p00i zt500kl)"],[2368,1440,10,"vodafone vfd 900"],[2392,1440,10,"sharp aquos z3 (fs8009)"],[2413,1440,9,"infocus m820"],[2560,1440,9,"vivo pd1522a"],[2560,1504,9,"lenovo yoga tab3 plus (yt-x703)"]]],["qualcomm adreno 512","512",0,[[782,480,59,"honeywell cn80"],[1798,1080,23,"sharp fs8016"],[1920,1080,22,"vivo td1608"],[2016,1080,22,"oppo r11s"],[2034,1080,22,"vivo x20a"],[2151,1080,20,"xiaomi redmi note 7"]]],["qualcomm adreno 530","530",0,[[1600,900,56,"keecker keecker"],[1776,1080,43,"softbank 506sh (sharp aquos phone xx3)"],[1794,1080,49,"google pixel"],[1920,1024,47,"contextmedia p-wal-107-elc-03"],[1920,1080,26,"nokia 6071w"],[2048,1536,35,"samsung galaxy tab s3 (sm-t82x)"],[2368,1440,27,"motorola xt1650 (1.8 ghz)"],[2392,1440,21,"lg q8 (h970, x800l)"],[2416,1440,31,"alcatel 6076s"],[2560,1439,17,"hp elite x3"],[2560,1440,4,"hp falcon"],[2672,1440,30,"lg g6 (g600, us997, ls993, vs988, h87x)"],[2880,1440,26,"baofeng ke-01"],[3840,2076,15,"via vt6093"]]],["qualcomm adreno 540","540",0,[[1184,720,61,"sony xperia xz1 compact (g8441)"],[1776,1080,57,"sony xperia xz1 (g834x, sov36, so-01k, 701so)"],[1794,1080,57,"google pixel 2 (walleye)"],[1920,1080,56,"zte nx595j nubia"],[1980,1080,56,"xiaomi mi mix 2"],[2034,1080,55,"oneplus 5t (a5010)"],[2276,1312,43,"essential ph-1"],[2368,1440,39,"sharp aquos r (sh-03j, shv39, 605sh)"],[2392,1440,41,"qualcomm adreno 540 (development board)"],[2416,1440,40,"razer phone"],[2560,1440,36,"htc u11 (u-3x, 2pzc100, 2pzc5, htv33, 601ht)"],[2678,1440,35,"samsung galaxy s8 active (sm-g892)"],[2768,1440,33,"samsung galaxy s8+ (adreno 540, sm-g955x, sc-03j, scv35)"],[2960,1440,33,"samsung galaxy note 8 (adreno 540, sm-n950, sc-01k, scv37)"]]],["qualcomm adreno 615","615",0,[[2560,1492,18,"samsung galaxy tab s5e sm-t720"]]],["qualcomm adreno 616","616",0,[[2047,1080,30,"meizu x8"]]],["qualcomm adreno 618","618",0,[[2183,1080,38,"samsung galaxy a71 (sm-a715f)"],[2274,1080,37,"samsung galaxy a80 sm-a805f"]]],["qualcomm adreno 630","630",0,[[2792,1440,49,"samsung galaxy s9+ (adreno 630, sm-g965)"]]],["qualcomm adreno 640","640",0,[[2020,1080,60,"samsung galaxy s10e (adreno 640, sm-g970x)"],[2064,1080,60,"samsung galaxy note 10 (adreno 640, sm-n970x)"],[2181,1080,60,"samsung galaxy s10 lite"],[2198,1080,60,"samsung galaxy a90 5g"],[2210,1080,79,"xiaomi redmi k20 pro premium edition"],[2048,1410,59,"samsung galaxy fold 5g (adreno 640, sm-f900x)"],[2723,1440,55,"samsung galaxy s10 (adreno 640, sm-g973x)"],[2730,1440,56,"samsung galaxy s10+ (adreno 640, sm-g975x)"],[2759,1440,56,"samsung galaxy note 10+ (adreno 640, sm-n975x)"],[2901,1440,55,"samsung galaxy s10 5g (adreno 640, sm-g977x)"]]],["qualcomm adreno 650","650",0,[[2274,1080,90,"asus zenfone 7"],[3101,1387,50,"samsung galaxy s20 ultra 5g (sm-g988u1)"]]]]\')},535:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["apple a10 gpu","10",0,[[2048,1536,41,"apple ipad (6th gen)"],[2160,1620,36,"apple ipad (10.2-inch) (7th generation)"]]],["apple a10x gpu","10",0,[[2048,1536,59,"apple ipad pro (10.5-inch)"],[2224,1668,69,"apple ipad pro (10.5-inch)"],[2732,2048,46,"apple ipad pro (12.9-inch, 2nd gen)"]]],["apple a12 gpu","12",0,[[2048,1536,60,"apple ipad mini (2019)"]]],["apple a12x gpu","12",0,[[2224,1668,116,"apple ipad pro (11-inch)"],[2388,1668,115,"apple ipad pro (11-inch)"],[2732,2048,60,"apple ipad pro (12.9-inch) (3rd generation)"]]],["apple a12z gpu","12",0,[[2388,1668,115,"apple ipad pro (11-inch) (2nd generation)"],[2732,2048,60,"apple ipad pro (12.9 inch) (4th generation)"]]],["apple a13 gpu","13",0,[[2160,1620,59,"apple ipad 9th gen"]]],["apple a14 gpu","14",0,[[2388,1668,52,"apple ipad air 4th gen (wi-fi only)"]]],["apple a15 gpu","15",0,[[2388,1668,60,"apple ipad mini (6th gen)"]]],["apple a7 gpu","7",0,[[2048,1536,10,"apple ipad mini 3"]]],["apple a8 gpu","8",0,[[2048,1536,16,"apple ipad mini 4"]]],["apple a8x gpu","8",0,[[2048,1536,30,"apple ipad air 2"]]],["apple a9 gpu","9",0,[[2048,1536,29,"apple ipad 9.7 (5th gen)"]]],["apple a9x gpu","9",0,[[2048,1536,40,"apple ipad pro 9.7"],[2732,2048,35,"apple ipad pro"]]],["apple m1 gpu","1",0,[[2732,2048,60,"apple ipad pro (12.9-inch) (5th generation)"]]]]\')},438:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["apple a10 gpu","10",0,[[1334,750,104,"apple iphone 7"],[1920,1080,60,"apple iphone 7 plus"],[2001,1125,59,"apple iphone x"]]],["apple a11 gpu","11",0,[[1334,750,64,"apple iphone 8"],[1920,1080,78,"apple iphone 8 plus"]]],["apple a12 gpu","12",0,[[1792,828,60,"apple iphone xr"],[2436,1125,57,"apple iphone xs"],[2208,1242,60,"apple iphone xs max"]]],["apple a13 gpu","13",0,[[1334,750,60,"apple iphone se (2nd gen)"],[1792,828,61,"apple iphone 11"],[2436,1125,60,"apple iphone 11 pro"],[2688,1242,61,"apple iphone 11 pro max"]]],["apple a14 gpu","14",0,[[2338,1080,60,"apple iphone 12 mini"],[2436,1125,60,"apple iphone 12"],[2778,1284,60,"apple iphone 12 pro max"]]],["apple a15 gpu","15",0,[[2338,1080,60,"apple iphone 13 mini"],[2436,1125,60,"apple iphone 13 pro"],[2688,1242,60,"apple iphone 13 pro max"]]],["apple a7 gpu","7",0,[[1136,640,32,"apple iphone 5s"]]],["apple a8 gpu","8",0,[[1136,640,40,"apple ipod touch 6"],[1334,750,36,"apple iphone 6"],[1920,1080,21,"apple iphone 6 plus"]]],["apple a9 gpu","9",0,[[1136,640,90,"apple iphone se"],[1334,750,72,"apple iphone 6s"],[1920,1080,42,"apple iphone 6s plus"]]]]\')},283:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["intel intel hd graphics for atom x5","5",0,[[1024,600,35,"amazon aeokn"],[1024,720,13,"arbor venus 8"],[1217,720,23,"gole gole1"],[1280,736,27,"medion p850x"],[1360,704,15,"chuwi hibox hero mini pc"],[1280,752,21,"tetratab casebook 3"],[1280,759,28,"lenovo yoga a12 (yb-q501f)"],[1366,720,19,"nextbook nx16a11264 ares 11 (x5-z8300)"],[1920,996,20,"teclast x16 pro"],[1920,1008,12,"teclast tbook 16 pro"],[1920,1016,13,"teclast x16 plus"],[1920,1104,13,"medion p851x"],[1920,1116,13,"teclast x80 pro (x5-z8350)"],[1920,1128,8,"cube technology i12-y"],[1920,1133,9,"cube technology i1-tfp (x5-z8350)"],[1920,1134,11,"microtech e-tab pro lte"],[1920,1136,14,"cube technology iwork 10 ultimate (i15-t)"],[1920,1214,10,"chuwi cw-hi10 plus (x5-z8350)"],[2048,1440,8,"teclast x98 plus"],[2160,1368,10,"chuwi hi12 (x5-z8350)"],[2048,1452,10,"teclast x98 plus ii"],[2048,1536,14,"xiaomi mi pad 2"],[2560,1356,7,"baofeng a1"],[2560,1504,6,"chuwi hibook pro (z8350)"],[2560,1518,11,"lenovo yt3-x90 yoga tablet 3 pro (x5-z8550)"]]],["intel intel hd graphics for baytrail","hdfor",0,[[1024,552,13,"multilaser intel 7qc"],[1024,696,17,"thundersoft dual os tablet"],[1024,720,15,"airis onepad 785i"],[1184,720,18,"trimble tdc500"],[1280,736,12,"acer a1-840"],[1280,752,9,"imuz mupad win 10.1 ii"],[1366,720,13,"nextbook nxa116qc164"],[1366,724,10,"cube technology i10 remix"],[1440,1008,12,"teclast x89 kindow"],[1920,1008,8,"minix neo z64"],[1920,1014,9,"cube technology i7 cx remix"],[1920,1032,11,"hp slate 17"],[1920,1104,5,"jltd d630"],[1920,1128,6,"intel(r) e1008"],[1920,1133,9,"pipo w3f"],[2048,1440,6,"kruger & matz eagle 975 (km0975)"],[2048,1448,6,"jide e-tab 3g"],[2048,1464,6,"reeder a10ix air"],[2560,1344,7,"lenovo yoga tablet 2 pro-1380"],[2560,1504,5,"teclast x10hd 3g"]]],["intel mesa dri intel bay trail","dribay",0,[[1366,768,15,"google chromebook pixel (2015, n2830)"]]],["intel mesa dri intel hd","drihd",0,[[688,412,39,"hp chromebook x360 11 g1 ee"],[960,568,36,"google chromebook pixel (2015, n3450)"],[1024,561,28,"aaeon up-cht01 up board"],[1024,736,33,"google chromebook reef (n3350)"]]],["intel mesa dri intel hd graphics 400","400",0,[[688,412,41,"asus c202sa chromebook"],[768,431,45,"hp chromebook 11 g5"],[960,568,25,"acer chromebook r11 (n3050)"],[1366,768,19,"samsung chromebook 3"],[1536,832,25,"google chromebook r11 (n3160)"],[1920,1080,17,"acer chromebook 14"]]],["intel mesa dri intel hd graphics 510","510",0,[[690,378,53,"hp chromebook chell"],[688,412,60,"acer chromebook 14 for work"]]],["intel mesa dri intel hd graphics 515","515",0,[[1033,617,56,"samsung chromebook pro (m7-6y75, caroline)"],[1536,1088,32,"google chromebook pixel (2015, m3-6y30)"],[1920,980,32,"asus c302 chromebook flip"],[2400,1504,22,"samsung chromebook pro (caroline)"],[3200,1640,12,"google chromebook pixel (2015, 4405y)"]]],["intel mesa dri intel hd graphics 520","520",0,[[700,412,60,"acer chromebook 14 for work (i3-6100u)"]]],["intel mesa dri intel hd graphics 5500","5500",0,[[1080,575,59,"google chromebook pixel (2015, i3-5005u)"],[1920,1000,30,"google chromebook pixel (2015, i5-5300u)"],[2560,1700,14,"google chromebook pixel (2015, i5-5200u)"]]],["intel mesa dri intel hd graphics 615","615",0,[[1034,618,55,"google soraka (4415y)"],[1200,720,34,"google poppy (4410y, kabylake)"],[2400,1504,21,"google chromebook eve (i5-7y54)"]]],["intel mesa dri intel kabylake gt2","2",0,[[960,568,38,"google chromebook pixel (2015, m3-7y30)"]]]]\')},327:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["arm mali-t604 mp4","604",0,[[2560,1504,4,"google nexus 10"]]],["arm mali-t622","622",0,[[1024,564,12,"telechips tcc896x (quad core, development board)"],[1280,720,7,"leadcore l1860 (mali-t622, development board)"]]],["arm mali-t624","624",0,[[1794,1080,7,"huawei grace"],[1812,1080,6,"huawei abc-ul00"],[1830,1080,10,"huawei p8 max (dav-70x)"],[1920,1080,4,"sony amai vp9"],[1920,1104,9,"huawei dtab compact d-02h (docomo)"],[1920,1128,8,"huawei dtab d-01h (docomo)"],[1824,1200,9,"huawei mediapad m2 (m2-80xx)"],[1830,1200,9,"huawei mediapad x2 (gem-701l, gem-702l, gem-703l)"]]],["arm mali-t624 mp2","624",0,[[1280,720,5,"samsung sm-g910f (mali-t624)"]]],["arm mali-t624 mp4","624",0,[[1794,1080,9,"huawei z100"]]],["arm mali-t628","628",0,[[1024,600,30,"thinkware inavi davinci"],[2560,1536,8,"meizu mx4 pro"]]],["arm mali-t628 mp2","628",0,[[1280,720,8,"leadcore l1860 (development board)"]]],["arm mali-t628 mp6","628",0,[[800,480,35,"gen2wave rp1600"],[1280,672,14,"hardkernel odroid-xu3 (development board)"],[1280,720,26,"samsung galaxy alpha (mali-t628, sm-g850)"],[1920,1080,11,"samsung galaxy note iii (mali-t628, sm-n900, sm-n9000q)"],[2560,1600,3,"samsung sm-t520 galaxy tab 10.1"]]],["arm mali-t720","720",0,[[432,240,16,"unihertz jelly pro"],[782,480,8,"mobiistar lai zoro"],[784,480,8,"lg k3 (k100)"],[791,480,6,"i-mobile i-style 812 4g"],[800,480,4,"lava iris 550"],[854,480,3,"verykool sl5009 jet"],[897,540,5,"bluboo xfire"],[960,540,3,"siswoo a5 chocolate"],[1024,552,4,"bb-mobile tq763i techno 7.0 lte"],[1024,714,9,"bluedot bnt-791 (2g)"],[1024,720,3,"zte e8qp"],[1280,624,10,"panasonic p55 novo 4g"],[1280,648,4,"tcl 9025"],[1280,656,7,"acer a1-734 iconia talk s"],[1184,720,4,"lenovo xt1700, xt1706, k10a40"],[1187,720,7,"lg k8 (k350)"],[1189,720,5,"ark impulse p2"],[1193,720,7,"lg x power (k220, f750)"],[1196,720,2,"dtac phone m2"],[1198,720,5,"dtac phone t3"],[1205,720,7,"firefly aurii passion"],[1206,720,4,"archos 50 power"],[1208,720,3,"advan i7 plus"],[1217,720,7,"energy sistem energy phone max 2+"],[1238,720,9,"vnpt technology vivas lotus s3 lte"],[1280,720,2,"archos bush spira c2 5"],[1280,736,2,"digma cs1062ml citi 1903 4g"],[1280,737,3,"waywalkers t805g"],[1280,740,3,"casper via l8"],[1280,746,3,"philips tle821l e line 4g"],[1280,752,3,"4good light at200"],[1280,755,7,"leotec letab1020 supernova qi32"],[1356,720,8,"xiaolajiao la-v11"],[1360,720,7,"tecno in5"],[1368,720,7,"tinno p100"],[1280,800,4,"samsung galaxy tab e 8.0 (sm-t375x, sm-t377x)"],[1920,936,4,"panasonic eluga note"],[1920,996,4,"cube technology u83 iplay10"],[1776,1080,4,"fly fs522 cirrus 14"],[1787,1080,5,"lg x cam (k580, f690)"],[1920,1008,6,"alcatel one touch xess (p17aa)"],[1794,1080,3,"ramos mos 1 max"],[1800,1080,4,"archos sense 55 s"],[1815,1080,4,"archos diamond plus"],[1920,1032,5,"virgin media tellytablet"],[1920,1080,2,"infocus m640"],[1920,1104,4,"vestel v tab 7030"],[1920,1116,4,"jty q101"],[1920,1128,2,"archos 80 oxygen"],[2009,1080,4,"tcl 5099"],[1920,1136,4,"asus zenpad 10 (p028 z301m)"]]],["arm mali-t760","760",0,[[854,480,14,"aux t6200l"],[897,540,13,"sony xperia e4g (e20xx)"],[960,540,12,"gionee v381"],[960,568,24,"asus c100pa chromebook flip"],[1024,552,12,"archos 70 helium"],[1024,720,10,"wiz t-8168"],[1188,720,9,"lg h520 magna, h522 prime plus"],[1196,720,9,"acer s57 liquid jade z"],[1280,720,8,"dunetek vitamin a"],[1280,736,8,"archos 80b helium"],[1280,752,8,"frael m10g 4g"],[1280,768,8,"meizu m1"],[1794,1080,6,"sugar 2 ss136 l8560"],[1920,1032,9,"qbic bxp-300 box pc"],[1920,1080,4,"byxpress mphone xone"],[1920,1104,6,"cube technology t7"],[1920,1128,5,"nec lavietab pc-te510bal"],[2048,1440,3,"teclast p98 4g"],[2560,1440,10,"samsung galaxy note 4 (mali-t760, sm-n910x, sm-n916)"]]],["arm mali-t760 mp6","760",0,[[1920,1080,17,"samsung galaxy a8 (mali-t760, sm-a800x, scv32)"],[2048,1536,12,"samsung galaxy tab s 2 8.0 (sm-t710, sm-t715)"],[2560,1532,10,"samsung galaxy note edge (mali-t760, sm-n915x)"],[2560,1600,10,"samsung galaxy tab s 10.5 (mali-t760, sm-t805s)"]]],["arm mali-t760 mp8","760",0,[[1280,768,42,"samsung sm-w2016"],[1920,1080,25,"meizu niux"],[2160,1200,17,"idealens k2"],[2560,1440,12,"le xiang deepoon m2 vr"],[2560,1504,15,"bungbungame kalos 2"]]],["arm mali-t764","764",0,[[1024,600,19,"gpd q9"],[1280,720,15,"gpd xd"],[1280,752,13,"kruger & matz 1064.1g eagle"],[1280,800,13,"pipo p7"],[1920,1008,6,"rockchip mk809 4k tv stick"],[1920,1010,8,"pipo p7 hd"],[1920,1020,5,"rockchip mk903v mini tv"],[1920,1032,7,"acooo oneboard pro+"],[1872,1080,7,"contextmedia wallboard 32 tablet (p-wal-106-yit-01)"],[1920,1080,7,"rockchip cs4k tv box"],[1920,1128,7,"archos 101 oxygen"],[2048,1437,5,"haier pad 971"],[2048,1440,5,"hisense f5281 vidaa pad"],[2560,1504,4,"teclast p90hd"]]],["arm mali-t820","820",0,[[1344,720,5,"lenovo k320t"],[1776,1080,6,"leagoo t5c"],[1920,1008,7,"probox2 ava tv box"],[1920,1080,4,"skyworth coocaa 5s32 n2"]]],["arm mali-t830","830",0,[[1280,720,9,"samsung galaxy on7 (mali-t830, sm-g600x)"],[1280,800,9,"samsung sm-t536 (mali-t830)"],[1776,1080,9,"huawei p10 lite (was-xxx)"],[1794,1080,9,"huawei honor 6x (bln-xxx)"],[1920,1080,5,"samsung galaxy on7 prime 2018 (sm-g611)"],[2033,1080,8,"huawei p smart (fig-xxx)"],[2040,1080,9,"huawei maimang 6 (rne-xxx)"],[1920,1200,5,"samsung galaxy tab a 10.1 (sm-t580, sm-t585)"]]],["arm mali-t860","860",0,[[1184,720,8,"tcl a626"],[1196,720,8,"green orange go t2"],[1280,720,14,"htc one a9s"],[1920,1024,17,"hardkernel odroid-n1 (development board)"],[1920,1032,16,"contextmedia p-wal-108-elc-02"],[1920,1080,7,"htc u play (u-2u)"],[1920,1116,15,"imuz revolution a8"],[1920,1128,15,"rockchip rk3399 (development board)"],[2400,1440,10,"samsung chromebook plus (kevin)"]]],["arm mali-t860 mp2","860",0,[[598,480,25,"cipherlab 9700a"],[1184,720,11,"vernee m5"],[1193,720,11,"lg x power 2 (u+, x500, m-x320, m320)"],[1196,720,11,"lava z25"],[1199,720,11,"lg stylus 3 (m400)"],[1212,720,11,"meeg 306"],[1280,720,10,"oppo r66"],[1336,720,13,"asus pegasus 4s (x018d zb570tl)"],[1344,720,13,"allview x4 soul infinity n"],[1776,1080,7,"benq f55"],[1794,1080,6,"alcatel 7070"],[1798,1080,7,"energy sistem energy phone pro 3"],[1806,1080,8,"tecno phantom 6"],[1807,1080,7,"covia fleaz cp-j55a g07"],[1810,1080,8,"archos 55 diamond 2 plus"],[1920,1080,4,"advan vandroid i55c"],[2004,1080,7,"asus zenfone max plus m1 (x018d zb570tl)"],[1920,1128,7,"verizon qtaxia1"]]],["arm mali-t880","880",0,[[1184,720,22,"doogee mix"],[1280,720,20,"lenovo k8"],[1344,720,18,"casper via f2"],[1776,1080,11,"alcatel 6060 (mali-t880)"],[1794,1080,20,"huawei mate 8 (nxt-xxx)"],[1824,1080,11,"meiigoo m1"],[1920,1080,10,"letv leeco lex650"],[2016,1080,9,"vernee mix 2"],[2064,1080,10,"umi s2 pro"],[2392,1440,12,"huawei honor v8 (knt-al20)"],[2434,1440,11,"huawei honor note 8 premium edition (edi-al10)"],[2560,1440,24,"meizu pro 6 plus"],[2560,1480,10,"huawei dtab compact d-01j (docomo)"],[2560,1600,10,"huawei mediapad m3 (btv-xxx)"]]],["arm mali-t880 mp12","880",0,[[1920,1080,44,"samsung galaxy s7 (sm-g930f)"],[2560,1440,27,"samsung galaxy note 7 (mali-t880, sm-n930)"]]],["arm mali-t880 mp2","880",0,[[1184,720,19,"sony pikachu"],[1376,720,17,"umi s2"],[1776,1080,10,"coolpad a9s-9"],[1800,1080,11,"infinix x603"],[1920,1080,9,"innjoo pro2"]]],["arm mali-t880 mp4","880",0,[[1280,672,18,"mediatek x20 (development board)"],[1794,1080,13,"infocus tsp"],[1800,1080,16,"infinix x602 zero 4 plus"],[1806,1080,16,"tecno phantom a9"],[1810,1080,8,"mobiistar prime x pro"],[1815,1080,16,"tecno phantom 6 plus"],[1920,1080,7,"elephone r9"],[2048,1440,12,"brown tab 1"],[2392,1440,12,"vernee apollo"],[2416,1440,11,"freetel ftj162b kiwami2"],[2560,1440,10,"ivvi i5"]]],["mali-t830","830",0,[[1480,720,10,"samsung gm-j600fn"]]]]\')},538:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["arm mali-g31","31",0,[[1920,1080,7,"mecool km9 pro"]]],["arm mali-g51","51",0,[[1920,636,10,"telechips tcc803x_lcn"],[1920,1080,5,"skyworth 8n10 g1a"]]],["arm mali-g52 mc1","52",0,[[1280,736,25,"amazon fire hd 8 (kfonwi, 2020)"]]],["arm mali-g52 mc2","52",0,[[2110,1080,23,"xiaomi redmi 10x 4g"],[2264,1080,20,"xiaomi redmi 9 m2004j19c"],[2400,1080,20,"huawei y9a frl-l22"]]],["arm mali-g57 mc3","57",0,[[2158,1080,48,"realme rmx2173"]]],["arm mali-g71","71",0,[[1280,720,14,"samsung sm-j337"],[1812,1080,53,"huawei mate 9 (mha-xxx)"],[1920,1080,12,"sony amai vp9 (mali-g71)"],[2009,1080,11,"tcl 6062"],[2016,1080,11,"gionee s11"],[2038,1080,10,"ulefone power 3"],[2076,1080,15,"samsung galaxy a8 2018 (sm-a530x)"],[2094,1080,15,"samsung sm-a730x"],[2160,1080,9,"oukitel k6"],[2368,1440,35,"huawei honor v9 (duk-xxx)"],[2560,1440,32,"huawei mate 9 pro (lon-xxx)"],[2678,1440,41,"samsung galaxy s8 (mali-g71, sm-g950x)"],[2960,1440,39,"samsung galaxy s8+ (mali-g71, sm-g955x)"]]],["arm mali-g72","72",0,[[2041,1080,55,"huawei mate 10 pro (bla-xxx)"],[2160,1080,56,"huawei honor view 10 (v10, bkl-xxx)"],[2560,1440,43,"huawei mate 10 (alp-xxx)"],[2768,1440,47,"samsung galaxy s9 (mali-g72, sm-g960)"],[2792,1440,47,"samsung galaxy s9+ (mali-g72, sm-g965)"]]],["arm mali-g76","76",0,[[2020,1080,60,"samsung galaxy s10e (mali-g76, sm-g970x)"],[2029,1080,31,"samsung galaxy s10 plus sm-g975n"],[2064,1080,60,"samsung galaxy note 10 5g (mali-g76, sm-n971x)"],[2159,1080,47,"samsung galaxy a51 5g"],[2232,1080,59,"huawei honor 20 pro yal-l41"],[2328,1128,60,"huawei mate 30 pro (lio-lx9, lio-xl00"],[2723,1440,57,"samsung galaxy s10 (mali-g76, sm-g973x)"],[2730,1440,56,"samsung galaxy s10+ (mali-g76, sm-g975x)"],[2733,1440,56,"samsung galaxy s10 5g (mali-g76, sm-g977x)"],[2759,1440,57,"samsung galaxy note 10+ (mali-g76, sm-n975x)"]]],["arm mali-g77","77",0,[[2178,1080,60,"samsung galaxy s20 5g (sm-g981b)"],[2200,1080,67,"samsung galaxy s20 ultra 5g (sm-g988b)"],[2304,1080,55,"oppo pdcm00"]]],["arm mali-g77 mc9","77",0,[[2293,1080,59,"oppo pdsm00"]]],["arm mali-g78","78",0,[[2646,1288,90,"huawei mate 40 pro 5g"]]],["arm mali-t604 mp4","604",0,[[2560,1504,4,"google nexus 10"]]],["arm mali-t622","622",0,[[1024,564,12,"telechips tcc896x (quad core, development board)"],[1280,720,7,"leadcore l1860 (mali-t622, development board)"]]],["arm mali-t624","624",0,[[1794,1080,7,"huawei grace"],[1812,1080,6,"huawei abc-ul00"],[1830,1080,10,"huawei p8 max (dav-70x)"],[1920,1080,4,"sony amai vp9"],[1920,1104,9,"huawei dtab compact d-02h (docomo)"],[1920,1128,8,"huawei dtab d-01h (docomo)"],[1824,1200,9,"huawei mediapad m2 (m2-80xx)"],[1830,1200,9,"huawei mediapad x2 (gem-701l, gem-702l, gem-703l)"]]],["arm mali-t624 mp2","624",0,[[1280,720,5,"samsung sm-g910f (mali-t624)"]]],["arm mali-t624 mp4","624",0,[[1794,1080,9,"huawei z100"]]],["arm mali-t628","628",0,[[1024,600,30,"thinkware inavi davinci"],[2560,1536,8,"meizu mx4 pro"]]],["arm mali-t628 mp2","628",0,[[1280,720,8,"leadcore l1860 (development board)"]]],["arm mali-t628 mp6","628",0,[[800,480,35,"gen2wave rp1600"],[1280,672,14,"hardkernel odroid-xu3 (development board)"],[1280,720,26,"samsung galaxy alpha (mali-t628, sm-g850)"],[1920,1080,11,"samsung galaxy note iii (mali-t628, sm-n900, sm-n9000q)"],[2560,1600,3,"samsung sm-t520 galaxy tab 10.1"]]],["arm mali-t720","720",0,[[432,240,16,"unihertz jelly pro"],[782,480,8,"mobiistar lai zoro"],[784,480,8,"lg k3 (k100)"],[791,480,6,"i-mobile i-style 812 4g"],[800,480,4,"lava iris 550"],[854,480,3,"verykool sl5009 jet"],[897,540,5,"bluboo xfire"],[960,540,3,"siswoo a5 chocolate"],[1024,552,4,"bb-mobile tq763i techno 7.0 lte"],[1024,714,9,"bluedot bnt-791 (2g)"],[1024,720,3,"zte e8qp"],[1280,624,10,"panasonic p55 novo 4g"],[1280,648,4,"tcl 9025"],[1280,656,7,"acer a1-734 iconia talk s"],[1184,720,4,"lenovo xt1700, xt1706, k10a40"],[1187,720,7,"lg k8 (k350)"],[1189,720,5,"ark impulse p2"],[1193,720,7,"lg x power (k220, f750)"],[1196,720,2,"dtac phone m2"],[1198,720,5,"dtac phone t3"],[1205,720,7,"firefly aurii passion"],[1206,720,4,"archos 50 power"],[1208,720,3,"advan i7 plus"],[1217,720,7,"energy sistem energy phone max 2+"],[1238,720,9,"vnpt technology vivas lotus s3 lte"],[1280,720,2,"archos bush spira c2 5"],[1280,736,2,"digma cs1062ml citi 1903 4g"],[1280,737,3,"waywalkers t805g"],[1280,740,3,"casper via l8"],[1280,746,3,"philips tle821l e line 4g"],[1280,752,3,"4good light at200"],[1280,755,7,"leotec letab1020 supernova qi32"],[1356,720,8,"xiaolajiao la-v11"],[1360,720,7,"tecno in5"],[1368,720,7,"tinno p100"],[1280,800,4,"samsung galaxy tab e 8.0 (sm-t375x, sm-t377x)"],[1920,936,4,"panasonic eluga note"],[1920,996,4,"cube technology u83 iplay10"],[1776,1080,4,"fly fs522 cirrus 14"],[1787,1080,5,"lg x cam (k580, f690)"],[1920,1008,6,"alcatel one touch xess (p17aa)"],[1794,1080,3,"ramos mos 1 max"],[1800,1080,4,"archos sense 55 s"],[1815,1080,4,"archos diamond plus"],[1920,1032,5,"virgin media tellytablet"],[1920,1080,2,"infocus m640"],[1920,1104,4,"vestel v tab 7030"],[1920,1116,4,"jty q101"],[1920,1128,2,"archos 80 oxygen"],[2009,1080,4,"tcl 5099"],[1920,1136,4,"asus zenpad 10 (p028 z301m)"]]],["arm mali-t760","760",0,[[854,480,14,"aux t6200l"],[897,540,13,"sony xperia e4g (e20xx)"],[960,540,12,"gionee v381"],[960,568,24,"asus c100pa chromebook flip"],[1024,552,12,"archos 70 helium"],[1024,720,10,"wiz t-8168"],[1188,720,9,"lg h520 magna, h522 prime plus"],[1196,720,9,"acer s57 liquid jade z"],[1280,720,8,"dunetek vitamin a"],[1280,736,8,"archos 80b helium"],[1280,752,8,"frael m10g 4g"],[1280,768,8,"meizu m1"],[1794,1080,6,"sugar 2 ss136 l8560"],[1920,1032,9,"qbic bxp-300 box pc"],[1920,1080,4,"byxpress mphone xone"],[1920,1104,6,"cube technology t7"],[1920,1128,5,"nec lavietab pc-te510bal"],[2048,1440,3,"teclast p98 4g"],[2560,1440,10,"samsung galaxy note 4 (mali-t760, sm-n910x, sm-n916)"]]],["arm mali-t760 mp6","760",0,[[1920,1080,17,"samsung galaxy a8 (mali-t760, sm-a800x, scv32)"],[2048,1536,12,"samsung galaxy tab s 2 8.0 (sm-t710, sm-t715)"],[2560,1532,10,"samsung galaxy note edge (mali-t760, sm-n915x)"],[2560,1600,10,"samsung galaxy tab s 10.5 (mali-t760, sm-t805s)"]]],["arm mali-t760 mp8","760",0,[[1280,768,42,"samsung sm-w2016"],[1920,1080,25,"meizu niux"],[2160,1200,17,"idealens k2"],[2560,1440,12,"le xiang deepoon m2 vr"],[2560,1504,15,"bungbungame kalos 2"]]],["arm mali-t764","764",0,[[1024,600,19,"gpd q9"],[1280,720,15,"gpd xd"],[1280,752,13,"kruger & matz 1064.1g eagle"],[1280,800,13,"pipo p7"],[1920,1008,6,"rockchip mk809 4k tv stick"],[1920,1010,8,"pipo p7 hd"],[1920,1020,5,"rockchip mk903v mini tv"],[1920,1032,7,"acooo oneboard pro+"],[1872,1080,7,"contextmedia wallboard 32 tablet (p-wal-106-yit-01)"],[1920,1080,7,"rockchip cs4k tv box"],[1920,1128,7,"archos 101 oxygen"],[2048,1437,5,"haier pad 971"],[2048,1440,5,"hisense f5281 vidaa pad"],[2560,1504,4,"teclast p90hd"]]],["arm mali-t820","820",0,[[1344,720,5,"lenovo k320t"],[1776,1080,6,"leagoo t5c"],[1920,1008,7,"probox2 ava tv box"],[1920,1080,4,"skyworth coocaa 5s32 n2"]]],["arm mali-t830","830",0,[[1280,720,9,"samsung galaxy on7 (mali-t830, sm-g600x)"],[1280,800,9,"samsung sm-t536 (mali-t830)"],[1776,1080,9,"huawei p10 lite (was-xxx)"],[1794,1080,9,"huawei honor 6x (bln-xxx)"],[1920,1080,5,"samsung galaxy on7 prime 2018 (sm-g611)"],[2033,1080,8,"huawei p smart (fig-xxx)"],[2040,1080,9,"huawei maimang 6 (rne-xxx)"],[1920,1200,5,"samsung galaxy tab a 10.1 (sm-t580, sm-t585)"]]],["arm mali-t860","860",0,[[1184,720,8,"tcl a626"],[1196,720,8,"green orange go t2"],[1280,720,14,"htc one a9s"],[1920,1024,17,"hardkernel odroid-n1 (development board)"],[1920,1032,16,"contextmedia p-wal-108-elc-02"],[1920,1080,7,"htc u play (u-2u)"],[1920,1116,15,"imuz revolution a8"],[1920,1128,15,"rockchip rk3399 (development board)"],[2400,1440,10,"samsung chromebook plus (kevin)"]]],["arm mali-t860 mp2","860",0,[[598,480,25,"cipherlab 9700a"],[1184,720,11,"vernee m5"],[1193,720,11,"lg x power 2 (u+, x500, m-x320, m320)"],[1196,720,11,"lava z25"],[1199,720,11,"lg stylus 3 (m400)"],[1212,720,11,"meeg 306"],[1280,720,10,"oppo r66"],[1336,720,13,"asus pegasus 4s (x018d zb570tl)"],[1344,720,13,"allview x4 soul infinity n"],[1776,1080,7,"benq f55"],[1794,1080,6,"alcatel 7070"],[1798,1080,7,"energy sistem energy phone pro 3"],[1806,1080,8,"tecno phantom 6"],[1807,1080,7,"covia fleaz cp-j55a g07"],[1810,1080,8,"archos 55 diamond 2 plus"],[1920,1080,4,"advan vandroid i55c"],[2004,1080,7,"asus zenfone max plus m1 (x018d zb570tl)"],[1920,1128,7,"verizon qtaxia1"]]],["arm mali-t880","880",0,[[1184,720,22,"doogee mix"],[1280,720,20,"lenovo k8"],[1344,720,18,"casper via f2"],[1776,1080,11,"alcatel 6060 (mali-t880)"],[1794,1080,20,"huawei mate 8 (nxt-xxx)"],[1824,1080,11,"meiigoo m1"],[1920,1080,10,"letv leeco lex650"],[2016,1080,9,"vernee mix 2"],[2064,1080,10,"umi s2 pro"],[2392,1440,12,"huawei honor v8 (knt-al20)"],[2434,1440,11,"huawei honor note 8 premium edition (edi-al10)"],[2560,1440,24,"meizu pro 6 plus"],[2560,1480,10,"huawei dtab compact d-01j (docomo)"],[2560,1600,10,"huawei mediapad m3 (btv-xxx)"]]],["arm mali-t880 mp12","880",0,[[1920,1080,44,"samsung galaxy s7 (sm-g930f)"],[2560,1440,27,"samsung galaxy note 7 (mali-t880, sm-n930)"]]],["arm mali-t880 mp2","880",0,[[1184,720,19,"sony pikachu"],[1376,720,17,"umi s2"],[1776,1080,10,"coolpad a9s-9"],[1800,1080,11,"infinix x603"],[1920,1080,9,"innjoo pro2"]]],["arm mali-t880 mp4","880",0,[[1280,672,18,"mediatek x20 (development board)"],[1794,1080,13,"infocus tsp"],[1800,1080,16,"infinix x602 zero 4 plus"],[1806,1080,16,"tecno phantom a9"],[1810,1080,8,"mobiistar prime x pro"],[1815,1080,16,"tecno phantom 6 plus"],[1920,1080,7,"elephone r9"],[2048,1440,12,"brown tab 1"],[2392,1440,12,"vernee apollo"],[2416,1440,11,"freetel ftj162b kiwami2"],[2560,1440,10,"ivvi i5"]]],["mali-g71","71",0,[[2220,1080,54,"samsung s8+ sm-g955f"]]],["mali-g72","72",0,[[2220,1080,56,"samsung s9+ sm-g965f"]]],["mali-t830","830",0,[[1480,720,10,"samsung gm-j600fn"]]]]\')},884:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["nvidia tegra","",0,[[2048,1440,23,"google nexus 9"]]],["nvidia tegra k1","1",0,[[1920,1008,32,"nvidia jetson tk1 (pm375, development board)"],[1920,1032,12,"lenovo k1 hd (2014)"],[1920,1080,28,"nvidia tegra gk20a (ardbeg, development board)"],[1920,1104,29,"google project tango"],[2048,1536,21,"xiaomi mi pad"],[3840,2088,8,"lenovo thinkvision 28"]]],["nvidia tegra x1","1",0,[[1920,1080,60,"nvidia shield android tv"],[2560,1688,33,"google pixel c"]]]]\')},214:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["powervr rogue g6110","6110",0,[[1024,600,11,"dasaita mtcd px5 head unit"],[1280,752,8,"visual land prestige prime 10se"],[1366,720,7,"ditecma m1092r"],[1920,1008,6,"vensmile t051 tv box"],[1920,1016,5,"geekbuying geekbox tv box"],[1920,1032,4,"hannspree hsg1351"],[1920,1080,5,"10moons tv box (rogue g6110)"],[1920,1128,5,"teclast p10"]]],["powervr rogue g6200","6200",0,[[1280,720,15,"infocus m530"],[1280,736,12,"amazon kindle fire hd 8 (5th gen, kfmewi)"],[1280,752,12,"amazon kindle fire hd 10 (5th gen, kftbwi)"],[1280,800,9,"amazon kindle fire hd 7 (4th gen, kfaswi)"],[1794,1080,5,"ubik uno"],[1920,1080,6,"cherry mobile x220 cosmos one plus"],[1920,1152,8,"meizu mx4 (m460, m460a, m461)"],[2392,1440,6,"hasee hl9916004"],[2560,1440,6,"condor allure a100 pgn-607"]]],["powervr rogue g6230","6230",0,[[1920,1008,8,"rikomagic mk80 tv box (tronsmart draco aw80, fantasy a80)"],[1920,1016,7,"cubietech cubieboard 4 (cc-a80, hansen-a80, development board)"],[2048,1440,5,"teclast p98air"],[2048,1464,7,"actions gs900a (development board)"]]],["powervr rogue g6400","6400",0,[[1794,1080,8,"lg f490 liger (g6400)"],[1920,1032,8,"renesas lager"]]],["powervr rogue g6430","6430",0,[[1024,552,26,"asus fonepad 7 (k01f fe171mg)"],[1280,720,27,"asus zenfone 2 (z008 ze550ml)"],[1280,736,20,"asus fonepad 7 (k019 fe375cg)"],[1280,752,27,"asus zenpad 10 (p01t z300cl)"],[1788,1080,8,"lg f490 liger (g6430)"],[1920,1080,15,"asus zenfone zoom (intel z3560, z00xsb zx551ml)"],[1920,1104,11,"asus memo pad 8 ast21 (intel z3580, k015 me581cl)"],[2048,1440,11,"asus zenpad s 8.0 (p01m z580c)"],[2560,1504,9,"dell venue 10 7040"]]],["powervr rogue ge8100","8100",0,[[906,480,8,"tinno k600"],[1184,720,5,"mediatek mt6739 (development board, rogue ge8100)"],[1339,720,5,"vodafone vfd 720"],[1344,720,6,"gionee f205"]]],["powervr rogue ge8300","8300",0,[[1280,752,9,"acer b3-a40 iconia one 10"],[1208,800,8,"verizon qtaki1"],[1920,1128,5,"acer b3-a40 fhd iconia one 10"]]],["powervr rogue gx6250","6250",0,[[688,412,16,"lenovo n23 yoga / flex 11 chromebook"],[1280,672,25,"renesas salvator-x-r8a7796"],[1280,736,25,"mediatek mt8173 (development board)"],[1920,980,10,"google chromebook pixel (2015, rogue gx6250)"],[1920,1016,14,"peloton ruby"],[1920,1020,8,"acer chromebook r13"],[1920,1032,13,"renesas salvator-x-m3"],[1920,1080,12,"xiaomi mibox 3 pro tv box"],[1920,1128,10,"amazon kindle fire hd 10 (2017, kfsuwi)"],[2048,1536,7,"alps jdtab j01"],[2560,1504,7,"onda f109"]]],["powervr rogue gx6650","6650",0,[[1280,672,52,"renesas salvator-x"],[1920,1032,24,"renesas salvator-x (octa core)"]]],["powervr rogue han","han",0,[[1794,1080,6,"ireadygo w3d"],[1920,1080,6,"changhong x6"],[2392,1440,5,"alcatel one touch d820"],[2560,1440,4,"alcatel 6071y phantom"]]],["powervr rogue hood","",0,[[1280,736,16,"dell venue 7 3740"],[1920,1080,12,"lenovo p90"],[1920,1104,9,"dell venue 8 3840"]]],["powervr rogue lando","",0,[[1920,1080,13,"spreadtrum sp9861e (development board, rogue lando)"]]],["powervr rogue marlowe","",0,[[1920,1080,39,"meitu v6 mp1605"],[2560,1440,25,"meizu pro 7 plus"]]]]\')},804:(e,t,n)=>{var i={"./d-adreno.json":622,"./d-amd.json":183,"./d-apple.json":732,"./d-geforce.json":405,"./d-intel.json":178,"./d-nvidia.json":217,"./d-radeon.json":145,"./m-adreno.json":921,"./m-apple-ipad.json":535,"./m-apple.json":438,"./m-intel.json":283,"./m-mali-t.json":327,"./m-mali.json":538,"./m-nvidia.json":884,"./m-powervr.json":214};function r(e){var t=o(e);return n(t)}function o(e){if(!n.o(i,e)){var t=new Error("Cannot find module \'"+e+"\'");throw t.code="MODULE_NOT_FOUND",t}return i[e]}r.keys=function(){return Object.keys(i)},r.resolve=o,e.exports=r,r.id=804},354:(e,t,n)=>{var i,r=function(){function e(e,t){if(!r[e]){r[e]={};for(var n=0;n<e.length;n++)r[e][e.charAt(n)]=n}return r[e][t]}var t=String.fromCharCode,n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$",r={},o={compressToBase64:function(e){if(null==e)return"";var t=o._compress(e,6,(function(e){return n.charAt(e)}));switch(t.length%4){default:case 0:return t;case 1:return t+"===";case 2:return t+"==";case 3:return t+"="}},decompressFromBase64:function(t){return null==t?"":""==t?null:o._decompress(t.length,32,(function(i){return e(n,t.charAt(i))}))},compressToUTF16:function(e){return null==e?"":o._compress(e,15,(function(e){return t(e+32)}))+" "},decompressFromUTF16:function(e){return null==e?"":""==e?null:o._decompress(e.length,16384,(function(t){return e.charCodeAt(t)-32}))},compressToUint8Array:function(e){for(var t=o.compress(e),n=new Uint8Array(2*t.length),i=0,r=t.length;r>i;i++){var s=t.charCodeAt(i);n[2*i]=s>>>8,n[2*i+1]=s%256}return n},decompressFromUint8Array:function(e){if(null==e)return o.decompress(e);for(var n=new Array(e.length/2),i=0,r=n.length;r>i;i++)n[i]=256*e[2*i]+e[2*i+1];var s=[];return n.forEach((function(e){s.push(t(e))})),o.decompress(s.join(""))},compressToEncodedURIComponent:function(e){return null==e?"":o._compress(e,6,(function(e){return i.charAt(e)}))},decompressFromEncodedURIComponent:function(t){return null==t?"":""==t?null:(t=t.replace(/ /g,"+"),o._decompress(t.length,32,(function(n){return e(i,t.charAt(n))})))},compress:function(e){return o._compress(e,16,(function(e){return t(e)}))},_compress:function(e,t,n){if(null==e)return"";var i,r,o,s={},a={},d="",c="",l="",h=2,u=3,p=2,m=[],g=0,f=0;for(o=0;o<e.length;o+=1)if(d=e.charAt(o),Object.prototype.hasOwnProperty.call(s,d)||(s[d]=u++,a[d]=!0),c=l+d,Object.prototype.hasOwnProperty.call(s,c))l=c;else{if(Object.prototype.hasOwnProperty.call(a,l)){if(l.charCodeAt(0)<256){for(i=0;p>i;i++)g<<=1,f==t-1?(f=0,m.push(n(g)),g=0):f++;for(r=l.charCodeAt(0),i=0;8>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1}else{for(r=1,i=0;p>i;i++)g=g<<1|r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r=0;for(r=l.charCodeAt(0),i=0;16>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1}0==--h&&(h=Math.pow(2,p),p++),delete a[l]}else for(r=s[l],i=0;p>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1;0==--h&&(h=Math.pow(2,p),p++),s[c]=u++,l=String(d)}if(""!==l){if(Object.prototype.hasOwnProperty.call(a,l)){if(l.charCodeAt(0)<256){for(i=0;p>i;i++)g<<=1,f==t-1?(f=0,m.push(n(g)),g=0):f++;for(r=l.charCodeAt(0),i=0;8>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1}else{for(r=1,i=0;p>i;i++)g=g<<1|r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r=0;for(r=l.charCodeAt(0),i=0;16>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1}0==--h&&(h=Math.pow(2,p),p++),delete a[l]}else for(r=s[l],i=0;p>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1;0==--h&&(h=Math.pow(2,p),p++)}for(r=2,i=0;p>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1;for(;;){if(g<<=1,f==t-1){m.push(n(g));break}f++}return m.join("")},decompress:function(e){return null==e?"":""==e?null:o._decompress(e.length,32768,(function(t){return e.charCodeAt(t)}))},_decompress:function(e,n,i){var r,o,s,a,d,c,l,h=[],u=4,p=4,m=3,g="",f=[],v={val:i(0),position:n,index:1};for(r=0;3>r;r+=1)h[r]=r;for(s=0,d=Math.pow(2,2),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;switch(s){case 0:for(s=0,d=Math.pow(2,8),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;l=t(s);break;case 1:for(s=0,d=Math.pow(2,16),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;l=t(s);break;case 2:return""}for(h[3]=l,o=l,f.push(l);;){if(v.index>e)return"";for(s=0,d=Math.pow(2,m),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;switch(l=s){case 0:for(s=0,d=Math.pow(2,8),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;h[p++]=t(s),l=p-1,u--;break;case 1:for(s=0,d=Math.pow(2,16),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;h[p++]=t(s),l=p-1,u--;break;case 2:return f.join("")}if(0==u&&(u=Math.pow(2,m),m++),h[l])g=h[l];else{if(l!==p)return null;g=o+o.charAt(0)}f.push(g),h[p++]=o+g.charAt(0),o=g,0==--u&&(u=Math.pow(2,m),m++)}}};return o}();void 0===(i=function(){return r}.call(t,n,t,e))||(e.exports=i)}},t={};function n(i){if(t[i])return t[i].exports;var r=t[i]={exports:{}};return e[i].call(r.exports,r,r.exports,n),r.exports}return n.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),n.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),n(607)})().default},577:(e,t)=>{"use strict";t.byteLength=function(e){var t=d(e),n=t[0],i=t[1];return 3*(n+i)/4-i},t.toByteArray=function(e){var t,n,o=d(e),s=o[0],a=o[1],c=new r(function(e,t,n){return 3*(t+n)/4-n}(0,s,a)),l=0,h=a>0?s-4:s;for(n=0;n<h;n+=4)t=i[e.charCodeAt(n)]<<18|i[e.charCodeAt(n+1)]<<12|i[e.charCodeAt(n+2)]<<6|i[e.charCodeAt(n+3)],c[l++]=t>>16&255,c[l++]=t>>8&255,c[l++]=255&t;return 2===a&&(t=i[e.charCodeAt(n)]<<2|i[e.charCodeAt(n+1)]>>4,c[l++]=255&t),1===a&&(t=i[e.charCodeAt(n)]<<10|i[e.charCodeAt(n+1)]<<4|i[e.charCodeAt(n+2)]>>2,c[l++]=t>>8&255,c[l++]=255&t),c},t.fromByteArray=function(e){for(var t,i=e.length,r=i%3,o=[],s=16383,a=0,d=i-r;a<d;a+=s)o.push(c(e,a,a+s>d?d:a+s));return 1===r?(t=e[i-1],o.push(n[t>>2]+n[t<<4&63]+"==")):2===r&&(t=(e[i-2]<<8)+e[i-1],o.push(n[t>>10]+n[t>>4&63]+n[t<<2&63]+"=")),o.join("")};for(var n=[],i=[],r="undefined"!=typeof Uint8Array?Uint8Array:Array,o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=0,a=o.length;s<a;++s)n[s]=o[s],i[o.charCodeAt(s)]=s;function d(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=e.indexOf("=");return-1===n&&(n=t),[n,n===t?0:4-n%4]}function c(e,t,i){for(var r,o,s=[],a=t;a<i;a+=3)r=(e[a]<<16&16711680)+(e[a+1]<<8&65280)+(255&e[a+2]),s.push(n[(o=r)>>18&63]+n[o>>12&63]+n[o>>6&63]+n[63&o]);return s.join("")}i["-".charCodeAt(0)]=62,i["_".charCodeAt(0)]=63},799:function(e,t){var n,i;this||window,void 0===(i="function"==typeof(n=function(){var e=/^(interactive|loaded|complete)$/,t=window.location?window.location.href:null,n=t&&t.replace(/#.*$/,"").replace(/\\?.*$/,"")||null,i=document.getElementsByTagName("script"),r="readyState"in(i[0]||document.createElement("script")),o=!window.opera||"[object Opera]"!==window.opera.toString(),s="currentScript"in document;"stackTraceLimit"in Error&&Error.stackTraceLimit!==1/0&&(Error.stackTraceLimit,Error.stackTraceLimit=1/0);var a=!1,d=!1;function c(e,t){var n,i=null,r="number"==typeof t;return t=r?Math.round(t):0,"string"==typeof e&&e&&(r?n=e.match(/(data:text\\/javascript(?:;[^,]+)?,.+?|(?:|blob:)(?:http[s]?|file):\\/\\/[\\/]?.+?\\/[^:\\)]*?)(?::\\d+)(?::\\d+)?/):(n=e.match(/^(?:|[^:@]*@|.+\\)@(?=data:text\\/javascript|blob|http[s]?|file)|.+?\\s+(?: at |@)(?:[^:\\(]+ )*[\\(]?)(data:text\\/javascript(?:;[^,]+)?,.+?|(?:|blob:)(?:http[s]?|file):\\/\\/[\\/]?.+?\\/[^:\\)]*?)(?::\\d+)(?::\\d+)?/))&&n[1]||(n=e.match(/\\)@(data:text\\/javascript(?:;[^,]+)?,.+?|(?:|blob:)(?:http[s]?|file):\\/\\/[\\/]?.+?\\/[^:\\)]*?)(?::\\d+)(?::\\d+)?/)),n&&n[1]&&(i=t>0?c(e.slice(e.indexOf(n[0])+n[0].length),t-1):n[1])),i}function l(){if(0===i.length)return null;var t,h,u,p,m,g=[],f=l.skipStackDepth||1;for(t=0;t<i.length;t++)o&&r?e.test(i[t].readyState)&&g.push(i[t]):g.push(i[t]);if(h=new Error,a&&(u=h.stack),!u&&d)try{throw h}catch(e){u=e.stack}if(u&&!(m=function(e,t){var n,r=null;if(t=t||i,"string"==typeof e&&e)for(n=t.length;n--;)if(t[n].src===e){r=t[n];break}return r}(p=c(u,f),g))&&n&&p===n&&(m=function(e){var t,n,r=null;for(t=0,n=(e=e||i).length;t<n;t++)if(!e[t].hasAttribute("src")){if(r){r=null;break}r=e[t]}return r}(g)),m||1===g.length&&(m=g[0]),m||s&&(m=document.currentScript),!m&&o&&r)for(t=g.length;t--;)if("interactive"===g[t].readyState){m=g[t];break}return m||(m=g[g.length-1]||null),m}(function(){try{var e=new Error;throw a="string"==typeof e.stack&&!!e.stack,e}catch(e){d="string"==typeof e.stack&&!!e.stack}})(),l.skipStackDepth=1;var h=l;return h.near=l,h.far=function(){return null},h.origin=function(){return null},h})?n.apply(t,[]):n)||(e.exports=i)},857:e=>{"use strict";var t,n="object"==typeof Reflect?Reflect:null,i=n&&"function"==typeof n.apply?n.apply:function(e,t,n){return Function.prototype.apply.call(e,t,n)};t=n&&"function"==typeof n.ownKeys?n.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:function(e){return Object.getOwnPropertyNames(e)};var r=Number.isNaN||function(e){return e!=e};function o(){o.init.call(this)}e.exports=o,e.exports.once=function(e,t){return new Promise((function(n,i){function r(n){e.removeListener(t,o),i(n)}function o(){"function"==typeof e.removeListener&&e.removeListener("error",r),n([].slice.call(arguments))}g(e,t,o,{once:!0}),"error"!==t&&function(e,t,n){"function"==typeof e.on&&g(e,"error",t,{once:!0})}(e,r)}))},o.EventEmitter=o,o.prototype._events=void 0,o.prototype._eventsCount=0,o.prototype._maxListeners=void 0;var s=10;function a(e){if("function"!=typeof e)throw new TypeError(\'The "listener" argument must be of type Function. Received type \'+typeof e)}function d(e){return void 0===e._maxListeners?o.defaultMaxListeners:e._maxListeners}function c(e,t,n,i){var r,o,s,c;if(a(n),void 0===(o=e._events)?(o=e._events=Object.create(null),e._eventsCount=0):(void 0!==o.newListener&&(e.emit("newListener",t,n.listener?n.listener:n),o=e._events),s=o[t]),void 0===s)s=o[t]=n,++e._eventsCount;else if("function"==typeof s?s=o[t]=i?[n,s]:[s,n]:i?s.unshift(n):s.push(n),(r=d(e))>0&&s.length>r&&!s.warned){s.warned=!0;var l=new Error("Possible EventEmitter memory leak detected. "+s.length+" "+String(t)+" listeners added. Use emitter.setMaxListeners() to increase limit");l.name="MaxListenersExceededWarning",l.emitter=e,l.type=t,l.count=s.length,c=l,console&&console.warn&&console.warn(c)}return e}function l(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=!0,0===arguments.length?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function h(e,t,n){var i={fired:!1,wrapFn:void 0,target:e,type:t,listener:n},r=l.bind(i);return r.listener=n,i.wrapFn=r,r}function u(e,t,n){var i=e._events;if(void 0===i)return[];var r=i[t];return void 0===r?[]:"function"==typeof r?n?[r.listener||r]:[r]:n?function(e){for(var t=new Array(e.length),n=0;n<t.length;++n)t[n]=e[n].listener||e[n];return t}(r):m(r,r.length)}function p(e){var t=this._events;if(void 0!==t){var n=t[e];if("function"==typeof n)return 1;if(void 0!==n)return n.length}return 0}function m(e,t){for(var n=new Array(t),i=0;i<t;++i)n[i]=e[i];return n}function g(e,t,n,i){if("function"==typeof e.on)i.once?e.once(t,n):e.on(t,n);else{if("function"!=typeof e.addEventListener)throw new TypeError(\'The "emitter" argument must be of type EventEmitter. Received type \'+typeof e);e.addEventListener(t,(function r(o){i.once&&e.removeEventListener(t,r),n(o)}))}}Object.defineProperty(o,"defaultMaxListeners",{enumerable:!0,get:function(){return s},set:function(e){if("number"!=typeof e||e<0||r(e))throw new RangeError(\'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received \'+e+".");s=e}}),o.init=function(){void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},o.prototype.setMaxListeners=function(e){if("number"!=typeof e||e<0||r(e))throw new RangeError(\'The value of "n" is out of range. It must be a non-negative number. Received \'+e+".");return this._maxListeners=e,this},o.prototype.getMaxListeners=function(){return d(this)},o.prototype.emit=function(e){for(var t=[],n=1;n<arguments.length;n++)t.push(arguments[n]);var r="error"===e,o=this._events;if(void 0!==o)r=r&&void 0===o.error;else if(!r)return!1;if(r){var s;if(t.length>0&&(s=t[0]),s instanceof Error)throw s;var a=new Error("Unhandled error."+(s?" ("+s.message+")":""));throw a.context=s,a}var d=o[e];if(void 0===d)return!1;if("function"==typeof d)i(d,this,t);else{var c=d.length,l=m(d,c);for(n=0;n<c;++n)i(l[n],this,t)}return!0},o.prototype.addListener=function(e,t){return c(this,e,t,!1)},o.prototype.on=o.prototype.addListener,o.prototype.prependListener=function(e,t){return c(this,e,t,!0)},o.prototype.once=function(e,t){return a(t),this.on(e,h(this,e,t)),this},o.prototype.prependOnceListener=function(e,t){return a(t),this.prependListener(e,h(this,e,t)),this},o.prototype.removeListener=function(e,t){var n,i,r,o,s;if(a(t),void 0===(i=this._events))return this;if(void 0===(n=i[e]))return this;if(n===t||n.listener===t)0==--this._eventsCount?this._events=Object.create(null):(delete i[e],i.removeListener&&this.emit("removeListener",e,n.listener||t));else if("function"!=typeof n){for(r=-1,o=n.length-1;o>=0;o--)if(n[o]===t||n[o].listener===t){s=n[o].listener,r=o;break}if(r<0)return this;0===r?n.shift():function(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}(n,r),1===n.length&&(i[e]=n[0]),void 0!==i.removeListener&&this.emit("removeListener",e,s||t)}return this},o.prototype.off=o.prototype.removeListener,o.prototype.removeAllListeners=function(e){var t,n,i;if(void 0===(n=this._events))return this;if(void 0===n.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==n[e]&&(0==--this._eventsCount?this._events=Object.create(null):delete n[e]),this;if(0===arguments.length){var r,o=Object.keys(n);for(i=0;i<o.length;++i)"removeListener"!==(r=o[i])&&this.removeAllListeners(r);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if("function"==typeof(t=n[e]))this.removeListener(e,t);else if(void 0!==t)for(i=t.length-1;i>=0;i--)this.removeListener(e,t[i]);return this},o.prototype.listeners=function(e){return u(this,e,!0)},o.prototype.rawListeners=function(e){return u(this,e,!1)},o.listenerCount=function(e,t){return"function"==typeof e.listenerCount?e.listenerCount(t):p.call(e,t)},o.prototype.listenerCount=p,o.prototype.eventNames=function(){return this._eventsCount>0?t(this._events):[]}},387:function(e,t){var n;!function(t,n){"use strict";"object"==typeof e.exports?e.exports=t.document?n(t,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return n(e)}:n(t)}("undefined"!=typeof window?window:this,(function(i,r){"use strict";var o=[],s=Object.getPrototypeOf,a=o.slice,d=o.flat?function(e){return o.flat.call(e)}:function(e){return o.concat.apply([],e)},c=o.push,l=o.indexOf,h={},u=h.toString,p=h.hasOwnProperty,m=p.toString,g=m.call(Object),f={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},_=function(e){return null!=e&&e===e.window},y=i.document,E={type:!0,src:!0,nonce:!0,noModule:!0};function S(e,t,n){var i,r,o=(n=n||y).createElement("script");if(o.text=e,t)for(i in E)(r=t[i]||t.getAttribute&&t.getAttribute(i))&&o.setAttribute(i,r);n.head.appendChild(o).parentNode.removeChild(o)}function b(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?h[u.call(e)]||"object":typeof e}var T="3.6.1 -ajax,-ajax/jsonp,-ajax/load,-ajax/script,-ajax/var/location,-ajax/var/nonce,-ajax/var/rquery,-ajax/xhr,-manipulation/_evalUrl,-deprecated/ajax-event-alias,-effects,-effects/Tween,-effects/animatedSelector",C=function(e,t){return new C.fn.init(e,t)};function x(e){var t=!!e&&"length"in e&&e.length,n=b(e);return!v(e)&&!_(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}C.fn=C.prototype={jquery:T,constructor:C,length:0,toArray:function(){return a.call(this)},get:function(e){return null==e?a.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=C.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return C.each(this,e)},map:function(e){return this.pushStack(C.map(this,(function(t,n){return e.call(t,n,t)})))},slice:function(){return this.pushStack(a.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(C.grep(this,(function(e,t){return(t+1)%2})))},odd:function(){return this.pushStack(C.grep(this,(function(e,t){return t%2})))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:c,sort:o.sort,splice:o.splice},C.extend=C.fn.extend=function(){var e,t,n,i,r,o,s=arguments[0]||{},a=1,d=arguments.length,c=!1;for("boolean"==typeof s&&(c=s,s=arguments[a]||{},a++),"object"==typeof s||v(s)||(s={}),a===d&&(s=this,a--);a<d;a++)if(null!=(e=arguments[a]))for(t in e)i=e[t],"__proto__"!==t&&s!==i&&(c&&i&&(C.isPlainObject(i)||(r=Array.isArray(i)))?(n=s[t],o=r&&!Array.isArray(n)?[]:r||C.isPlainObject(n)?n:{},r=!1,s[t]=C.extend(c,o,i)):void 0!==i&&(s[t]=i));return s},C.extend({expando:"jQuery"+(T+Math.random()).replace(/\\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==u.call(e)||(t=s(e))&&("function"!=typeof(n=p.call(t,"constructor")&&t.constructor)||m.call(n)!==g))},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){S(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,i=0;if(x(e))for(n=e.length;i<n&&!1!==t.call(e[i],i,e[i]);i++);else for(i in e)if(!1===t.call(e[i],i,e[i]))break;return e},makeArray:function(e,t){var n=t||[];return null!=e&&(x(Object(e))?C.merge(n,"string"==typeof e?[e]:e):c.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:l.call(t,e,n)},merge:function(e,t){for(var n=+t.length,i=0,r=e.length;i<n;i++)e[r++]=t[i];return e.length=r,e},grep:function(e,t,n){for(var i=[],r=0,o=e.length,s=!n;r<o;r++)!t(e[r],r)!==s&&i.push(e[r]);return i},map:function(e,t,n){var i,r,o=0,s=[];if(x(e))for(i=e.length;o<i;o++)null!=(r=t(e[o],o,n))&&s.push(r);else for(o in e)null!=(r=t(e[o],o,n))&&s.push(r);return d(s)},guid:1,support:f}),"function"==typeof Symbol&&(C.fn[Symbol.iterator]=o[Symbol.iterator]),C.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),(function(e,t){h["[object "+t+"]"]=t.toLowerCase()}));var R=function(e){var t,n,i,r,o,s,a,d,c,l,h,u,p,m,g,f,v,_,y,E="sizzle"+1*new Date,S=e.document,b=0,T=0,C=de(),x=de(),R=de(),A=de(),w=function(e,t){return e===t&&(h=!0),0},I={}.hasOwnProperty,P=[],D=P.pop,O=P.push,k=P.push,N=P.slice,M=function(e,t){for(var n=0,i=e.length;n<i;n++)if(e[n]===t)return n;return-1},L="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",F="[\\\\x20\\\\t\\\\r\\\\n\\\\f]",j="(?:\\\\\\\\[\\\\da-fA-F]{1,6}"+F+"?|\\\\\\\\[^\\\\r\\\\n\\\\f]|[\\\\w-]|[^\\0-\\\\x7f])+",V="\\\\["+F+"*("+j+")(?:"+F+"*([*^$|!~]?=)"+F+"*(?:\'((?:\\\\\\\\.|[^\\\\\\\\\'])*)\'|\\"((?:\\\\\\\\.|[^\\\\\\\\\\"])*)\\"|("+j+"))|)"+F+"*\\\\]",U=":("+j+")(?:\\\\(((\'((?:\\\\\\\\.|[^\\\\\\\\\'])*)\'|\\"((?:\\\\\\\\.|[^\\\\\\\\\\"])*)\\")|((?:\\\\\\\\.|[^\\\\\\\\()[\\\\]]|"+V+")*)|.*)\\\\)|)",H=new RegExp(F+"+","g"),$=new RegExp("^"+F+"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)"+F+"+$","g"),J=new RegExp("^"+F+"*,"+F+"*"),B=new RegExp("^"+F+"*([>+~]|"+F+")"+F+"*"),q=new RegExp(F+"|>"),G=new RegExp(U),z=new RegExp("^"+j+"$"),K={ID:new RegExp("^#("+j+")"),CLASS:new RegExp("^\\\\.("+j+")"),TAG:new RegExp("^("+j+"|[*])"),ATTR:new RegExp("^"+V),PSEUDO:new RegExp("^"+U),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\\\("+F+"*(even|odd|(([+-]|)(\\\\d*)n|)"+F+"*(?:([+-]|)"+F+"*(\\\\d+)|))"+F+"*\\\\)|)","i"),bool:new RegExp("^(?:"+L+")$","i"),needsContext:new RegExp("^"+F+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\\\("+F+"*((?:-\\\\d)?\\\\d*)"+F+"*\\\\)|)(?=[^-]|$)","i")},W=/HTML$/i,X=/^(?:input|select|textarea|button)$/i,Y=/^h\\d$/i,Q=/^[^{]+\\{\\s*\\[native \\w/,Z=/^(?:#([\\w-]+)|(\\w+)|\\.([\\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\\\\\[\\\\da-fA-F]{1,6}"+F+"?|\\\\\\\\([^\\\\r\\\\n\\\\f])","g"),ne=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},ie=/([\\0-\\x1f\\x7f]|^-?\\d)|^-$|[^\\0-\\x1f\\x7f-\\uFFFF\\w-]/g,re=function(e,t){return t?"\\0"===e?"�":e.slice(0,-1)+"\\\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\\\"+e},oe=function(){u()},se=Ee((function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()}),{dir:"parentNode",next:"legend"});try{k.apply(P=N.call(S.childNodes),S.childNodes),P[S.childNodes.length].nodeType}catch(t){k={apply:P.length?function(e,t){O.apply(e,N.call(t))}:function(e,t){for(var n=e.length,i=0;e[n++]=t[i++];);e.length=n-1}}}function ae(e,t,i,r){var o,a,c,l,h,m,v,_=t&&t.ownerDocument,S=t?t.nodeType:9;if(i=i||[],"string"!=typeof e||!e||1!==S&&9!==S&&11!==S)return i;if(!r&&(u(t),t=t||p,g)){if(11!==S&&(h=Z.exec(e)))if(o=h[1]){if(9===S){if(!(c=t.getElementById(o)))return i;if(c.id===o)return i.push(c),i}else if(_&&(c=_.getElementById(o))&&y(t,c)&&c.id===o)return i.push(c),i}else{if(h[2])return k.apply(i,t.getElementsByTagName(e)),i;if((o=h[3])&&n.getElementsByClassName&&t.getElementsByClassName)return k.apply(i,t.getElementsByClassName(o)),i}if(n.qsa&&!A[e+" "]&&(!f||!f.test(e))&&(1!==S||"object"!==t.nodeName.toLowerCase())){if(v=e,_=t,1===S&&(q.test(e)||B.test(e))){for((_=ee.test(e)&&ve(t.parentNode)||t)===t&&n.scope||((l=t.getAttribute("id"))?l=l.replace(ie,re):t.setAttribute("id",l=E)),a=(m=s(e)).length;a--;)m[a]=(l?"#"+l:":scope")+" "+ye(m[a]);v=m.join(",")}try{return k.apply(i,_.querySelectorAll(v)),i}catch(t){A(e,!0)}finally{l===E&&t.removeAttribute("id")}}}return d(e.replace($,"$1"),t,i,r)}function de(){var e=[];return function t(n,r){return e.push(n+" ")>i.cacheLength&&delete t[e.shift()],t[n+" "]=r}}function ce(e){return e[E]=!0,e}function le(e){var t=p.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function he(e,t){for(var n=e.split("|"),r=n.length;r--;)i.attrHandle[n[r]]=t}function ue(e,t){var n=t&&e,i=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(i)return i;if(n)for(;n=n.nextSibling;)if(n===t)return-1;return e?1:-1}function pe(e){return function(t){return"input"===t.nodeName.toLowerCase()&&t.type===e}}function me(e){return function(t){var n=t.nodeName.toLowerCase();return("input"===n||"button"===n)&&t.type===e}}function ge(e){return function(t){return"form"in t?t.parentNode&&!1===t.disabled?"label"in t?"label"in t.parentNode?t.parentNode.disabled===e:t.disabled===e:t.isDisabled===e||t.isDisabled!==!e&&se(t)===e:t.disabled===e:"label"in t&&t.disabled===e}}function fe(e){return ce((function(t){return t=+t,ce((function(n,i){for(var r,o=e([],n.length,t),s=o.length;s--;)n[r=o[s]]&&(n[r]=!(i[r]=n[r]))}))}))}function ve(e){return e&&void 0!==e.getElementsByTagName&&e}for(t in n=ae.support={},o=ae.isXML=function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!W.test(t||n&&n.nodeName||"HTML")},u=ae.setDocument=function(e){var t,r,s=e?e.ownerDocument||e:S;return s!=p&&9===s.nodeType&&s.documentElement&&(m=(p=s).documentElement,g=!o(p),S!=p&&(r=p.defaultView)&&r.top!==r&&(r.addEventListener?r.addEventListener("unload",oe,!1):r.attachEvent&&r.attachEvent("onunload",oe)),n.scope=le((function(e){return m.appendChild(e).appendChild(p.createElement("div")),void 0!==e.querySelectorAll&&!e.querySelectorAll(":scope fieldset div").length})),n.attributes=le((function(e){return e.className="i",!e.getAttribute("className")})),n.getElementsByTagName=le((function(e){return e.appendChild(p.createComment("")),!e.getElementsByTagName("*").length})),n.getElementsByClassName=Q.test(p.getElementsByClassName),n.getById=le((function(e){return m.appendChild(e).id=E,!p.getElementsByName||!p.getElementsByName(E).length})),n.getById?(i.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},i.find.ID=function(e,t){if(void 0!==t.getElementById&&g){var n=t.getElementById(e);return n?[n]:[]}}):(i.filter.ID=function(e){var t=e.replace(te,ne);return function(e){var n=void 0!==e.getAttributeNode&&e.getAttributeNode("id");return n&&n.value===t}},i.find.ID=function(e,t){if(void 0!==t.getElementById&&g){var n,i,r,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];for(r=t.getElementsByName(e),i=0;o=r[i++];)if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),i.find.TAG=n.getElementsByTagName?function(e,t){return void 0!==t.getElementsByTagName?t.getElementsByTagName(e):n.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,i=[],r=0,o=t.getElementsByTagName(e);if("*"===e){for(;n=o[r++];)1===n.nodeType&&i.push(n);return i}return o},i.find.CLASS=n.getElementsByClassName&&function(e,t){if(void 0!==t.getElementsByClassName&&g)return t.getElementsByClassName(e)},v=[],f=[],(n.qsa=Q.test(p.querySelectorAll))&&(le((function(e){var t;m.appendChild(e).innerHTML="<a id=\'"+E+"\'></a><select id=\'"+E+"-\\r\\\\\' msallowcapture=\'\'><option selected=\'\'></option></select>",e.querySelectorAll("[msallowcapture^=\'\']").length&&f.push("[*^$]="+F+"*(?:\'\'|\\"\\")"),e.querySelectorAll("[selected]").length||f.push("\\\\["+F+"*(?:value|"+L+")"),e.querySelectorAll("[id~="+E+"-]").length||f.push("~="),(t=p.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name=\'\']").length||f.push("\\\\["+F+"*name"+F+"*="+F+"*(?:\'\'|\\"\\")"),e.querySelectorAll(":checked").length||f.push(":checked"),e.querySelectorAll("a#"+E+"+*").length||f.push(".#.+[+~]"),e.querySelectorAll("\\\\\\f"),f.push("[\\\\r\\\\n\\\\f]")})),le((function(e){e.innerHTML="<a href=\'\' disabled=\'disabled\'></a><select disabled=\'disabled\'><option/></select>";var t=p.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&f.push("name"+F+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&f.push(":enabled",":disabled"),m.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&f.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),f.push(",.*:")}))),(n.matchesSelector=Q.test(_=m.matches||m.webkitMatchesSelector||m.mozMatchesSelector||m.oMatchesSelector||m.msMatchesSelector))&&le((function(e){n.disconnectedMatch=_.call(e,"*"),_.call(e,"[s!=\'\']:x"),v.push("!=",U)})),f=f.length&&new RegExp(f.join("|")),v=v.length&&new RegExp(v.join("|")),t=Q.test(m.compareDocumentPosition),y=t||Q.test(m.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,i=t&&t.parentNode;return e===i||!(!i||1!==i.nodeType||!(n.contains?n.contains(i):e.compareDocumentPosition&&16&e.compareDocumentPosition(i)))}:function(e,t){if(t)for(;t=t.parentNode;)if(t===e)return!0;return!1},w=t?function(e,t){if(e===t)return h=!0,0;var i=!e.compareDocumentPosition-!t.compareDocumentPosition;return i||(1&(i=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!n.sortDetached&&t.compareDocumentPosition(e)===i?e==p||e.ownerDocument==S&&y(S,e)?-1:t==p||t.ownerDocument==S&&y(S,t)?1:l?M(l,e)-M(l,t):0:4&i?-1:1)}:function(e,t){if(e===t)return h=!0,0;var n,i=0,r=e.parentNode,o=t.parentNode,s=[e],a=[t];if(!r||!o)return e==p?-1:t==p?1:r?-1:o?1:l?M(l,e)-M(l,t):0;if(r===o)return ue(e,t);for(n=e;n=n.parentNode;)s.unshift(n);for(n=t;n=n.parentNode;)a.unshift(n);for(;s[i]===a[i];)i++;return i?ue(s[i],a[i]):s[i]==S?-1:a[i]==S?1:0}),p},ae.matches=function(e,t){return ae(e,null,null,t)},ae.matchesSelector=function(e,t){if(u(e),n.matchesSelector&&g&&!A[t+" "]&&(!v||!v.test(t))&&(!f||!f.test(t)))try{var i=_.call(e,t);if(i||n.disconnectedMatch||e.document&&11!==e.document.nodeType)return i}catch(e){A(t,!0)}return 0<ae(t,p,null,[e]).length},ae.contains=function(e,t){return(e.ownerDocument||e)!=p&&u(e),y(e,t)},ae.attr=function(e,t){(e.ownerDocument||e)!=p&&u(e);var r=i.attrHandle[t.toLowerCase()],o=r&&I.call(i.attrHandle,t.toLowerCase())?r(e,t,!g):void 0;return void 0!==o?o:n.attributes||!g?e.getAttribute(t):(o=e.getAttributeNode(t))&&o.specified?o.value:null},ae.escape=function(e){return(e+"").replace(ie,re)},ae.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ae.uniqueSort=function(e){var t,i=[],r=0,o=0;if(h=!n.detectDuplicates,l=!n.sortStable&&e.slice(0),e.sort(w),h){for(;t=e[o++];)t===e[o]&&(r=i.push(o));for(;r--;)e.splice(i[r],1)}return l=null,e},r=ae.getText=function(e){var t,n="",i=0,o=e.nodeType;if(o){if(1===o||9===o||11===o){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=r(e)}else if(3===o||4===o)return e.nodeValue}else for(;t=e[i++];)n+=r(t);return n},(i=ae.selectors={cacheLength:50,createPseudo:ce,match:K,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||ae.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&ae.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return K.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&G.test(n)&&(t=s(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=C[e+" "];return t||(t=new RegExp("(^|"+F+")"+e+"("+F+"|$)"))&&C(e,(function(e){return t.test("string"==typeof e.className&&e.className||void 0!==e.getAttribute&&e.getAttribute("class")||"")}))},ATTR:function(e,t,n){return function(i){var r=ae.attr(i,e);return null==r?"!="===t:!t||(r+="","="===t?r===n:"!="===t?r!==n:"^="===t?n&&0===r.indexOf(n):"*="===t?n&&-1<r.indexOf(n):"$="===t?n&&r.slice(-n.length)===n:"~="===t?-1<(" "+r.replace(H," ")+" ").indexOf(n):"|="===t&&(r===n||r.slice(0,n.length+1)===n+"-"))}},CHILD:function(e,t,n,i,r){var o="nth"!==e.slice(0,3),s="last"!==e.slice(-4),a="of-type"===t;return 1===i&&0===r?function(e){return!!e.parentNode}:function(t,n,d){var c,l,h,u,p,m,g=o!==s?"nextSibling":"previousSibling",f=t.parentNode,v=a&&t.nodeName.toLowerCase(),_=!d&&!a,y=!1;if(f){if(o){for(;g;){for(u=t;u=u[g];)if(a?u.nodeName.toLowerCase()===v:1===u.nodeType)return!1;m=g="only"===e&&!m&&"nextSibling"}return!0}if(m=[s?f.firstChild:f.lastChild],s&&_){for(y=(p=(c=(l=(h=(u=f)[E]||(u[E]={}))[u.uniqueID]||(h[u.uniqueID]={}))[e]||[])[0]===b&&c[1])&&c[2],u=p&&f.childNodes[p];u=++p&&u&&u[g]||(y=p=0)||m.pop();)if(1===u.nodeType&&++y&&u===t){l[e]=[b,p,y];break}}else if(_&&(y=p=(c=(l=(h=(u=t)[E]||(u[E]={}))[u.uniqueID]||(h[u.uniqueID]={}))[e]||[])[0]===b&&c[1]),!1===y)for(;(u=++p&&u&&u[g]||(y=p=0)||m.pop())&&((a?u.nodeName.toLowerCase()!==v:1!==u.nodeType)||!++y||(_&&((l=(h=u[E]||(u[E]={}))[u.uniqueID]||(h[u.uniqueID]={}))[e]=[b,y]),u!==t)););return(y-=r)===i||y%i==0&&0<=y/i}}},PSEUDO:function(e,t){var n,r=i.pseudos[e]||i.setFilters[e.toLowerCase()]||ae.error("unsupported pseudo: "+e);return r[E]?r(t):1<r.length?(n=[e,e,"",t],i.setFilters.hasOwnProperty(e.toLowerCase())?ce((function(e,n){for(var i,o=r(e,t),s=o.length;s--;)e[i=M(e,o[s])]=!(n[i]=o[s])})):function(e){return r(e,0,n)}):r}},pseudos:{not:ce((function(e){var t=[],n=[],i=a(e.replace($,"$1"));return i[E]?ce((function(e,t,n,r){for(var o,s=i(e,null,r,[]),a=e.length;a--;)(o=s[a])&&(e[a]=!(t[a]=o))})):function(e,r,o){return t[0]=e,i(t,null,o,n),t[0]=null,!n.pop()}})),has:ce((function(e){return function(t){return 0<ae(e,t).length}})),contains:ce((function(e){return e=e.replace(te,ne),function(t){return-1<(t.textContent||r(t)).indexOf(e)}})),lang:ce((function(e){return z.test(e||"")||ae.error("unsupported lang: "+e),e=e.replace(te,ne).toLowerCase(),function(t){var n;do{if(n=g?t.lang:t.getAttribute("xml:lang")||t.getAttribute("lang"))return(n=n.toLowerCase())===e||0===n.indexOf(e+"-")}while((t=t.parentNode)&&1===t.nodeType);return!1}})),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===m},focus:function(e){return e===p.activeElement&&(!p.hasFocus||p.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!i.pseudos.empty(e)},header:function(e){return Y.test(e.nodeName)},input:function(e){return X.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:fe((function(){return[0]})),last:fe((function(e,t){return[t-1]})),eq:fe((function(e,t,n){return[n<0?n+t:n]})),even:fe((function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e})),odd:fe((function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e})),lt:fe((function(e,t,n){for(var i=n<0?n+t:t<n?t:n;0<=--i;)e.push(i);return e})),gt:fe((function(e,t,n){for(var i=n<0?n+t:n;++i<t;)e.push(i);return e}))}}).pseudos.nth=i.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})i.pseudos[t]=pe(t);for(t in{submit:!0,reset:!0})i.pseudos[t]=me(t);function _e(){}function ye(e){for(var t=0,n=e.length,i="";t<n;t++)i+=e[t].value;return i}function Ee(e,t,n){var i=t.dir,r=t.next,o=r||i,s=n&&"parentNode"===o,a=T++;return t.first?function(t,n,r){for(;t=t[i];)if(1===t.nodeType||s)return e(t,n,r);return!1}:function(t,n,d){var c,l,h,u=[b,a];if(d){for(;t=t[i];)if((1===t.nodeType||s)&&e(t,n,d))return!0}else for(;t=t[i];)if(1===t.nodeType||s)if(l=(h=t[E]||(t[E]={}))[t.uniqueID]||(h[t.uniqueID]={}),r&&r===t.nodeName.toLowerCase())t=t[i]||t;else{if((c=l[o])&&c[0]===b&&c[1]===a)return u[2]=c[2];if((l[o]=u)[2]=e(t,n,d))return!0}return!1}}function Se(e){return 1<e.length?function(t,n,i){for(var r=e.length;r--;)if(!e[r](t,n,i))return!1;return!0}:e[0]}function be(e,t,n,i,r){for(var o,s=[],a=0,d=e.length,c=null!=t;a<d;a++)(o=e[a])&&(n&&!n(o,i,r)||(s.push(o),c&&t.push(a)));return s}function Te(e,t,n,i,r,o){return i&&!i[E]&&(i=Te(i)),r&&!r[E]&&(r=Te(r,o)),ce((function(o,s,a,d){var c,l,h,u=[],p=[],m=s.length,g=o||function(e,t,n){for(var i=0,r=t.length;i<r;i++)ae(e,t[i],n);return n}(t||"*",a.nodeType?[a]:a,[]),f=!e||!o&&t?g:be(g,u,e,a,d),v=n?r||(o?e:m||i)?[]:s:f;if(n&&n(f,v,a,d),i)for(c=be(v,p),i(c,[],a,d),l=c.length;l--;)(h=c[l])&&(v[p[l]]=!(f[p[l]]=h));if(o){if(r||e){if(r){for(c=[],l=v.length;l--;)(h=v[l])&&c.push(f[l]=h);r(null,v=[],c,d)}for(l=v.length;l--;)(h=v[l])&&-1<(c=r?M(o,h):u[l])&&(o[c]=!(s[c]=h))}}else v=be(v===s?v.splice(m,v.length):v),r?r(null,s,v,d):k.apply(s,v)}))}function Ce(e){for(var t,n,r,o=e.length,s=i.relative[e[0].type],a=s||i.relative[" "],d=s?1:0,l=Ee((function(e){return e===t}),a,!0),h=Ee((function(e){return-1<M(t,e)}),a,!0),u=[function(e,n,i){var r=!s&&(i||n!==c)||((t=n).nodeType?l(e,n,i):h(e,n,i));return t=null,r}];d<o;d++)if(n=i.relative[e[d].type])u=[Ee(Se(u),n)];else{if((n=i.filter[e[d].type].apply(null,e[d].matches))[E]){for(r=++d;r<o&&!i.relative[e[r].type];r++);return Te(1<d&&Se(u),1<d&&ye(e.slice(0,d-1).concat({value:" "===e[d-2].type?"*":""})).replace($,"$1"),n,d<r&&Ce(e.slice(d,r)),r<o&&Ce(e=e.slice(r)),r<o&&ye(e))}u.push(n)}return Se(u)}return _e.prototype=i.filters=i.pseudos,i.setFilters=new _e,s=ae.tokenize=function(e,t){var n,r,o,s,a,d,c,l=x[e+" "];if(l)return t?0:l.slice(0);for(a=e,d=[],c=i.preFilter;a;){for(s in n&&!(r=J.exec(a))||(r&&(a=a.slice(r[0].length)||a),d.push(o=[])),n=!1,(r=B.exec(a))&&(n=r.shift(),o.push({value:n,type:r[0].replace($," ")}),a=a.slice(n.length)),i.filter)!(r=K[s].exec(a))||c[s]&&!(r=c[s](r))||(n=r.shift(),o.push({value:n,type:s,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?ae.error(e):x(e,d).slice(0)},a=ae.compile=function(e,t){var n,r,o,a,d,l,h=[],m=[],f=R[e+" "];if(!f){for(t||(t=s(e)),n=t.length;n--;)(f=Ce(t[n]))[E]?h.push(f):m.push(f);(f=R(e,(r=m,a=0<(o=h).length,d=0<r.length,l=function(e,t,n,s,l){var h,m,f,v=0,_="0",y=e&&[],E=[],S=c,T=e||d&&i.find.TAG("*",l),C=b+=null==S?1:Math.random()||.1,x=T.length;for(l&&(c=t==p||t||l);_!==x&&null!=(h=T[_]);_++){if(d&&h){for(m=0,t||h.ownerDocument==p||(u(h),n=!g);f=r[m++];)if(f(h,t||p,n)){s.push(h);break}l&&(b=C)}a&&((h=!f&&h)&&v--,e&&y.push(h))}if(v+=_,a&&_!==v){for(m=0;f=o[m++];)f(y,E,t,n);if(e){if(0<v)for(;_--;)y[_]||E[_]||(E[_]=D.call(s));E=be(E)}k.apply(s,E),l&&!e&&0<E.length&&1<v+o.length&&ae.uniqueSort(s)}return l&&(b=C,c=S),y},a?ce(l):l))).selector=e}return f},d=ae.select=function(e,t,n,r){var o,d,c,l,h,u="function"==typeof e&&e,p=!r&&s(e=u.selector||e);if(n=n||[],1===p.length){if(2<(d=p[0]=p[0].slice(0)).length&&"ID"===(c=d[0]).type&&9===t.nodeType&&g&&i.relative[d[1].type]){if(!(t=(i.find.ID(c.matches[0].replace(te,ne),t)||[])[0]))return n;u&&(t=t.parentNode),e=e.slice(d.shift().value.length)}for(o=K.needsContext.test(e)?0:d.length;o--&&(c=d[o],!i.relative[l=c.type]);)if((h=i.find[l])&&(r=h(c.matches[0].replace(te,ne),ee.test(d[0].type)&&ve(t.parentNode)||t))){if(d.splice(o,1),!(e=r.length&&ye(d)))return k.apply(n,r),n;break}}return(u||a(e,p))(r,t,!g,n,!t||ee.test(e)&&ve(t.parentNode)||t),n},n.sortStable=E.split("").sort(w).join("")===E,n.detectDuplicates=!!h,u(),n.sortDetached=le((function(e){return 1&e.compareDocumentPosition(p.createElement("fieldset"))})),le((function(e){return e.innerHTML="<a href=\'#\'></a>","#"===e.firstChild.getAttribute("href")}))||he("type|href|height|width",(function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)})),n.attributes&&le((function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")}))||he("value",(function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue})),le((function(e){return null==e.getAttribute("disabled")}))||he(L,(function(e,t,n){var i;if(!n)return!0===e[t]?t.toLowerCase():(i=e.getAttributeNode(t))&&i.specified?i.value:null})),ae}(i);C.find=R,C.expr=R.selectors,C.expr[":"]=C.expr.pseudos,C.uniqueSort=C.unique=R.uniqueSort,C.text=R.getText,C.isXMLDoc=R.isXML,C.contains=R.contains,C.escapeSelector=R.escape;var A=function(e,t,n){for(var i=[],r=void 0!==n;(e=e[t])&&9!==e.nodeType;)if(1===e.nodeType){if(r&&C(e).is(n))break;i.push(e)}return i},w=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},I=C.expr.match.needsContext;function P(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var D=/^<([a-z][^\\/\\0>:\\x20\\t\\r\\n\\f]*)[\\x20\\t\\r\\n\\f]*\\/?>(?:<\\/\\1>|)$/i;function O(e,t,n){return v(t)?C.grep(e,(function(e,i){return!!t.call(e,i,e)!==n})):t.nodeType?C.grep(e,(function(e){return e===t!==n})):"string"!=typeof t?C.grep(e,(function(e){return-1<l.call(t,e)!==n})):C.filter(t,e,n)}C.filter=function(e,t,n){var i=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===i.nodeType?C.find.matchesSelector(i,e)?[i]:[]:C.find.matches(e,C.grep(t,(function(e){return 1===e.nodeType})))},C.fn.extend({find:function(e){var t,n,i=this.length,r=this;if("string"!=typeof e)return this.pushStack(C(e).filter((function(){for(t=0;t<i;t++)if(C.contains(r[t],this))return!0})));for(n=this.pushStack([]),t=0;t<i;t++)C.find(e,r[t],n);return 1<i?C.uniqueSort(n):n},filter:function(e){return this.pushStack(O(this,e||[],!1))},not:function(e){return this.pushStack(O(this,e||[],!0))},is:function(e){return!!O(this,"string"==typeof e&&I.test(e)?C(e):e||[],!1).length}});var k,N=/^(?:\\s*(<[\\w\\W]+>)[^>]*|#([\\w-]+))$/;(C.fn.init=function(e,t,n){var i,r;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(i="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:N.exec(e))||!i[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(i[1]){if(t=t instanceof C?t[0]:t,C.merge(this,C.parseHTML(i[1],t&&t.nodeType?t.ownerDocument||t:y,!0)),D.test(i[1])&&C.isPlainObject(t))for(i in t)v(this[i])?this[i](t[i]):this.attr(i,t[i]);return this}return(r=y.getElementById(i[2]))&&(this[0]=r,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(C):C.makeArray(e,this)}).prototype=C.fn,k=C(y);var M=/^(?:parents|prev(?:Until|All))/,L={children:!0,contents:!0,next:!0,prev:!0};function F(e,t){for(;(e=e[t])&&1!==e.nodeType;);return e}C.fn.extend({has:function(e){var t=C(e,this),n=t.length;return this.filter((function(){for(var e=0;e<n;e++)if(C.contains(this,t[e]))return!0}))},closest:function(e,t){var n,i=0,r=this.length,o=[],s="string"!=typeof e&&C(e);if(!I.test(e))for(;i<r;i++)for(n=this[i];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(s?-1<s.index(n):1===n.nodeType&&C.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?C.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?l.call(C(e),this[0]):l.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(C.uniqueSort(C.merge(this.get(),C(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),C.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return A(e,"parentNode")},parentsUntil:function(e,t,n){return A(e,"parentNode",n)},next:function(e){return F(e,"nextSibling")},prev:function(e){return F(e,"previousSibling")},nextAll:function(e){return A(e,"nextSibling")},prevAll:function(e){return A(e,"previousSibling")},nextUntil:function(e,t,n){return A(e,"nextSibling",n)},prevUntil:function(e,t,n){return A(e,"previousSibling",n)},siblings:function(e){return w((e.parentNode||{}).firstChild,e)},children:function(e){return w(e.firstChild)},contents:function(e){return null!=e.contentDocument&&s(e.contentDocument)?e.contentDocument:(P(e,"template")&&(e=e.content||e),C.merge([],e.childNodes))}},(function(e,t){C.fn[e]=function(n,i){var r=C.map(this,t,n);return"Until"!==e.slice(-5)&&(i=n),i&&"string"==typeof i&&(r=C.filter(i,r)),1<this.length&&(L[e]||C.uniqueSort(r),M.test(e)&&r.reverse()),this.pushStack(r)}}));var j=/[^\\x20\\t\\r\\n\\f]+/g;function V(e){return e}function U(e){throw e}function H(e,t,n,i){var r;try{e&&v(r=e.promise)?r.call(e).done(t).fail(n):e&&v(r=e.then)?r.call(e,t,n):t.apply(void 0,[e].slice(i))}catch(e){n.apply(void 0,[e])}}C.Callbacks=function(e){var t,n;e="string"==typeof e?(t=e,n={},C.each(t.match(j)||[],(function(e,t){n[t]=!0})),n):C.extend({},e);var i,r,o,s,a=[],d=[],c=-1,l=function(){for(s=s||e.once,o=i=!0;d.length;c=-1)for(r=d.shift();++c<a.length;)!1===a[c].apply(r[0],r[1])&&e.stopOnFalse&&(c=a.length,r=!1);e.memory||(r=!1),i=!1,s&&(a=r?[]:"")},h={add:function(){return a&&(r&&!i&&(c=a.length-1,d.push(r)),function t(n){C.each(n,(function(n,i){v(i)?e.unique&&h.has(i)||a.push(i):i&&i.length&&"string"!==b(i)&&t(i)}))}(arguments),r&&!i&&l()),this},remove:function(){return C.each(arguments,(function(e,t){for(var n;-1<(n=C.inArray(t,a,n));)a.splice(n,1),n<=c&&c--})),this},has:function(e){return e?-1<C.inArray(e,a):0<a.length},empty:function(){return a&&(a=[]),this},disable:function(){return s=d=[],a=r="",this},disabled:function(){return!a},lock:function(){return s=d=[],r||i||(a=r=""),this},locked:function(){return!!s},fireWith:function(e,t){return s||(t=[e,(t=t||[]).slice?t.slice():t],d.push(t),i||l()),this},fire:function(){return h.fireWith(this,arguments),this},fired:function(){return!!o}};return h},C.extend({Deferred:function(e){var t=[["notify","progress",C.Callbacks("memory"),C.Callbacks("memory"),2],["resolve","done",C.Callbacks("once memory"),C.Callbacks("once memory"),0,"resolved"],["reject","fail",C.Callbacks("once memory"),C.Callbacks("once memory"),1,"rejected"]],n="pending",r={state:function(){return n},always:function(){return o.done(arguments).fail(arguments),this},catch:function(e){return r.then(null,e)},pipe:function(){var e=arguments;return C.Deferred((function(n){C.each(t,(function(t,i){var r=v(e[i[4]])&&e[i[4]];o[i[1]]((function(){var e=r&&r.apply(this,arguments);e&&v(e.promise)?e.promise().progress(n.notify).done(n.resolve).fail(n.reject):n[i[0]+"With"](this,r?[e]:arguments)}))})),e=null})).promise()},then:function(e,n,r){var o=0;function s(e,t,n,r){return function(){var a=this,d=arguments,c=function(){var i,c;if(!(e<o)){if((i=n.apply(a,d))===t.promise())throw new TypeError("Thenable self-resolution");c=i&&("object"==typeof i||"function"==typeof i)&&i.then,v(c)?r?c.call(i,s(o,t,V,r),s(o,t,U,r)):(o++,c.call(i,s(o,t,V,r),s(o,t,U,r),s(o,t,V,t.notifyWith))):(n!==V&&(a=void 0,d=[i]),(r||t.resolveWith)(a,d))}},l=r?c:function(){try{c()}catch(i){C.Deferred.exceptionHook&&C.Deferred.exceptionHook(i,l.stackTrace),o<=e+1&&(n!==U&&(a=void 0,d=[i]),t.rejectWith(a,d))}};e?l():(C.Deferred.getStackHook&&(l.stackTrace=C.Deferred.getStackHook()),i.setTimeout(l))}}return C.Deferred((function(i){t[0][3].add(s(0,i,v(r)?r:V,i.notifyWith)),t[1][3].add(s(0,i,v(e)?e:V)),t[2][3].add(s(0,i,v(n)?n:U))})).promise()},promise:function(e){return null!=e?C.extend(e,r):r}},o={};return C.each(t,(function(e,i){var s=i[2],a=i[5];r[i[1]]=s.add,a&&s.add((function(){n=a}),t[3-e][2].disable,t[3-e][3].disable,t[0][2].lock,t[0][3].lock),s.add(i[3].fire),o[i[0]]=function(){return o[i[0]+"With"](this===o?void 0:this,arguments),this},o[i[0]+"With"]=s.fireWith})),r.promise(o),e&&e.call(o,o),o},when:function(e){var t=arguments.length,n=t,i=Array(n),r=a.call(arguments),o=C.Deferred(),s=function(e){return function(n){i[e]=this,r[e]=1<arguments.length?a.call(arguments):n,--t||o.resolveWith(i,r)}};if(t<=1&&(H(e,o.done(s(n)).resolve,o.reject,!t),"pending"===o.state()||v(r[n]&&r[n].then)))return o.then();for(;n--;)H(r[n],s(n),o.reject);return o.promise()}});var $=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;C.Deferred.exceptionHook=function(e,t){i.console&&i.console.warn&&e&&$.test(e.name)&&i.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},C.readyException=function(e){i.setTimeout((function(){throw e}))};var J=C.Deferred();function B(){y.removeEventListener("DOMContentLoaded",B),i.removeEventListener("load",B),C.ready()}C.fn.ready=function(e){return J.then(e).catch((function(e){C.readyException(e)})),this},C.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--C.readyWait:C.isReady)||(C.isReady=!0)!==e&&0<--C.readyWait||J.resolveWith(y,[C])}}),C.ready.then=J.then,"complete"===y.readyState||"loading"!==y.readyState&&!y.documentElement.doScroll?i.setTimeout(C.ready):(y.addEventListener("DOMContentLoaded",B),i.addEventListener("load",B));var q=function(e,t,n,i,r,o,s){var a=0,d=e.length,c=null==n;if("object"===b(n))for(a in r=!0,n)q(e,t,a,n[a],!0,o,s);else if(void 0!==i&&(r=!0,v(i)||(s=!0),c&&(s?(t.call(e,i),t=null):(c=t,t=function(e,t,n){return c.call(C(e),n)})),t))for(;a<d;a++)t(e[a],n,s?i:i.call(e[a],a,t(e[a],n)));return r?e:c?t.call(e):d?t(e[0],n):o},G=/^-ms-/,z=/-([a-z])/g;function K(e,t){return t.toUpperCase()}function W(e){return e.replace(G,"ms-").replace(z,K)}var X=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function Y(){this.expando=C.expando+Y.uid++}Y.uid=1,Y.prototype={cache:function(e){var t=e[this.expando];return t||(t={},X(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var i,r=this.cache(e);if("string"==typeof t)r[W(t)]=n;else for(i in t)r[W(i)]=t[i];return r},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][W(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,i=e[this.expando];if(void 0!==i){if(void 0!==t){n=(t=Array.isArray(t)?t.map(W):(t=W(t))in i?[t]:t.match(j)||[]).length;for(;n--;)delete i[t[n]]}(void 0===t||C.isEmptyObject(i))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!C.isEmptyObject(t)}};var Q=new Y,Z=new Y,ee=/^(?:\\{[\\w\\W]*\\}|\\[[\\w\\W]*\\])$/,te=/[A-Z]/g;function ne(e,t,n){var i,r;if(void 0===n&&1===e.nodeType)if(i="data-"+t.replace(te,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(i))){try{n="true"===(r=n)||"false"!==r&&("null"===r?null:r===+r+""?+r:ee.test(r)?JSON.parse(r):r)}catch(e){}Z.set(e,t,n)}else n=void 0;return n}C.extend({hasData:function(e){return Z.hasData(e)||Q.hasData(e)},data:function(e,t,n){return Z.access(e,t,n)},removeData:function(e,t){Z.remove(e,t)},_data:function(e,t,n){return Q.access(e,t,n)},_removeData:function(e,t){Q.remove(e,t)}}),C.fn.extend({data:function(e,t){var n,i,r,o=this[0],s=o&&o.attributes;if(void 0===e){if(this.length&&(r=Z.get(o),1===o.nodeType&&!Q.get(o,"hasDataAttrs"))){for(n=s.length;n--;)s[n]&&0===(i=s[n].name).indexOf("data-")&&(i=W(i.slice(5)),ne(o,i,r[i]));Q.set(o,"hasDataAttrs",!0)}return r}return"object"==typeof e?this.each((function(){Z.set(this,e)})):q(this,(function(t){var n;if(o&&void 0===t)return void 0!==(n=Z.get(o,e))||void 0!==(n=ne(o,e))?n:void 0;this.each((function(){Z.set(this,e,t)}))}),null,t,1<arguments.length,null,!0)},removeData:function(e){return this.each((function(){Z.remove(this,e)}))}}),C.extend({queue:function(e,t,n){var i;if(e)return t=(t||"fx")+"queue",i=Q.get(e,t),n&&(!i||Array.isArray(n)?i=Q.access(e,t,C.makeArray(n)):i.push(n)),i||[]},dequeue:function(e,t){t=t||"fx";var n=C.queue(e,t),i=n.length,r=n.shift(),o=C._queueHooks(e,t);"inprogress"===r&&(r=n.shift(),i--),r&&("fx"===t&&n.unshift("inprogress"),delete o.stop,r.call(e,(function(){C.dequeue(e,t)}),o)),!i&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Q.get(e,n)||Q.access(e,n,{empty:C.Callbacks("once memory").add((function(){Q.remove(e,[t+"queue",n])}))})}}),C.fn.extend({queue:function(e,t){var n=2;return"string"!=typeof e&&(t=e,e="fx",n--),arguments.length<n?C.queue(this[0],e):void 0===t?this:this.each((function(){var n=C.queue(this,e,t);C._queueHooks(this,e),"fx"===e&&"inprogress"!==n[0]&&C.dequeue(this,e)}))},dequeue:function(e){return this.each((function(){C.dequeue(this,e)}))},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,i=1,r=C.Deferred(),o=this,s=this.length,a=function(){--i||r.resolveWith(o,[o])};for("string"!=typeof e&&(t=e,e=void 0),e=e||"fx";s--;)(n=Q.get(o[s],e+"queueHooks"))&&n.empty&&(i++,n.empty.add(a));return a(),r.promise(t)}});var ie=/[+-]?(?:\\d*\\.|)\\d+(?:[eE][+-]?\\d+|)/.source,re=new RegExp("^(?:([+-])=|)("+ie+")([a-z%]*)$","i"),oe=["Top","Right","Bottom","Left"],se=y.documentElement,ae=function(e){return C.contains(e.ownerDocument,e)},de={composed:!0};se.getRootNode&&(ae=function(e){return C.contains(e.ownerDocument,e)||e.getRootNode(de)===e.ownerDocument});var ce=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&ae(e)&&"none"===C.css(e,"display")},le={};function he(e,t){for(var n,i,r,o,s,a,d,c=[],l=0,h=e.length;l<h;l++)(i=e[l]).style&&(n=i.style.display,t?("none"===n&&(c[l]=Q.get(i,"display")||null,c[l]||(i.style.display="")),""===i.style.display&&ce(i)&&(c[l]=(d=s=o=void 0,s=(r=i).ownerDocument,a=r.nodeName,(d=le[a])||(o=s.body.appendChild(s.createElement(a)),d=C.css(o,"display"),o.parentNode.removeChild(o),"none"===d&&(d="block"),le[a]=d)))):"none"!==n&&(c[l]="none",Q.set(i,"display",n)));for(l=0;l<h;l++)null!=c[l]&&(e[l].style.display=c[l]);return e}C.fn.extend({show:function(){return he(this,!0)},hide:function(){return he(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each((function(){ce(this)?C(this).show():C(this).hide()}))}});var ue,pe,me=/^(?:checkbox|radio)$/i,ge=/<([a-z][^\\/\\0>\\x20\\t\\r\\n\\f]*)/i,fe=/^$|^module$|\\/(?:java|ecma)script/i;ue=y.createDocumentFragment().appendChild(y.createElement("div")),(pe=y.createElement("input")).setAttribute("type","radio"),pe.setAttribute("checked","checked"),pe.setAttribute("name","t"),ue.appendChild(pe),f.checkClone=ue.cloneNode(!0).cloneNode(!0).lastChild.checked,ue.innerHTML="<textarea>x</textarea>",f.noCloneChecked=!!ue.cloneNode(!0).lastChild.defaultValue,ue.innerHTML="<option></option>",f.option=!!ue.lastChild;var ve={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function _e(e,t){var n;return n=void 0!==e.getElementsByTagName?e.getElementsByTagName(t||"*"):void 0!==e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&P(e,t)?C.merge([e],n):n}function ye(e,t){for(var n=0,i=e.length;n<i;n++)Q.set(e[n],"globalEval",!t||Q.get(t[n],"globalEval"))}ve.tbody=ve.tfoot=ve.colgroup=ve.caption=ve.thead,ve.th=ve.td,f.option||(ve.optgroup=ve.option=[1,"<select multiple=\'multiple\'>","</select>"]);var Ee=/<|&#?\\w+;/;function Se(e,t,n,i,r){for(var o,s,a,d,c,l,h=t.createDocumentFragment(),u=[],p=0,m=e.length;p<m;p++)if((o=e[p])||0===o)if("object"===b(o))C.merge(u,o.nodeType?[o]:o);else if(Ee.test(o)){for(s=s||h.appendChild(t.createElement("div")),a=(ge.exec(o)||["",""])[1].toLowerCase(),d=ve[a]||ve._default,s.innerHTML=d[1]+C.htmlPrefilter(o)+d[2],l=d[0];l--;)s=s.lastChild;C.merge(u,s.childNodes),(s=h.firstChild).textContent=""}else u.push(t.createTextNode(o));for(h.textContent="",p=0;o=u[p++];)if(i&&-1<C.inArray(o,i))r&&r.push(o);else if(c=ae(o),s=_e(h.appendChild(o),"script"),c&&ye(s),n)for(l=0;o=s[l++];)fe.test(o.type||"")&&n.push(o);return h}var be=/^([^.]*)(?:\\.(.+)|)/;function Te(){return!0}function Ce(){return!1}function xe(e,t){return e===function(){try{return y.activeElement}catch(e){}}()==("focus"===t)}function Re(e,t,n,i,r,o){var s,a;if("object"==typeof t){for(a in"string"!=typeof n&&(i=i||n,n=void 0),t)Re(e,a,n,i,t[a],o);return e}if(null==i&&null==r?(r=n,i=n=void 0):null==r&&("string"==typeof n?(r=i,i=void 0):(r=i,i=n,n=void 0)),!1===r)r=Ce;else if(!r)return e;return 1===o&&(s=r,(r=function(e){return C().off(e),s.apply(this,arguments)}).guid=s.guid||(s.guid=C.guid++)),e.each((function(){C.event.add(this,t,r,i,n)}))}function Ae(e,t,n){n?(Q.set(e,t,!1),C.event.add(e,t,{namespace:!1,handler:function(e){var i,r,o=Q.get(this,t);if(1&e.isTrigger&&this[t]){if(o.length)(C.event.special[t]||{}).delegateType&&e.stopPropagation();else if(o=a.call(arguments),Q.set(this,t,o),i=n(this,t),this[t](),o!==(r=Q.get(this,t))||i?Q.set(this,t,!1):r={},o!==r)return e.stopImmediatePropagation(),e.preventDefault(),r&&r.value}else o.length&&(Q.set(this,t,{value:C.event.trigger(C.extend(o[0],C.Event.prototype),o.slice(1),this)}),e.stopImmediatePropagation())}})):void 0===Q.get(e,t)&&C.event.add(e,t,Te)}C.event={global:{},add:function(e,t,n,i,r){var o,s,a,d,c,l,h,u,p,m,g,f=Q.get(e);if(X(e))for(n.handler&&(n=(o=n).handler,r=o.selector),r&&C.find.matchesSelector(se,r),n.guid||(n.guid=C.guid++),(d=f.events)||(d=f.events=Object.create(null)),(s=f.handle)||(s=f.handle=function(t){return void 0!==C&&C.event.triggered!==t.type?C.event.dispatch.apply(e,arguments):void 0}),c=(t=(t||"").match(j)||[""]).length;c--;)p=g=(a=be.exec(t[c])||[])[1],m=(a[2]||"").split(".").sort(),p&&(h=C.event.special[p]||{},p=(r?h.delegateType:h.bindType)||p,h=C.event.special[p]||{},l=C.extend({type:p,origType:g,data:i,handler:n,guid:n.guid,selector:r,needsContext:r&&C.expr.match.needsContext.test(r),namespace:m.join(".")},o),(u=d[p])||((u=d[p]=[]).delegateCount=0,h.setup&&!1!==h.setup.call(e,i,m,s)||e.addEventListener&&e.addEventListener(p,s)),h.add&&(h.add.call(e,l),l.handler.guid||(l.handler.guid=n.guid)),r?u.splice(u.delegateCount++,0,l):u.push(l),C.event.global[p]=!0)},remove:function(e,t,n,i,r){var o,s,a,d,c,l,h,u,p,m,g,f=Q.hasData(e)&&Q.get(e);if(f&&(d=f.events)){for(c=(t=(t||"").match(j)||[""]).length;c--;)if(p=g=(a=be.exec(t[c])||[])[1],m=(a[2]||"").split(".").sort(),p){for(h=C.event.special[p]||{},u=d[p=(i?h.delegateType:h.bindType)||p]||[],a=a[2]&&new RegExp("(^|\\\\.)"+m.join("\\\\.(?:.*\\\\.|)")+"(\\\\.|$)"),s=o=u.length;o--;)l=u[o],!r&&g!==l.origType||n&&n.guid!==l.guid||a&&!a.test(l.namespace)||i&&i!==l.selector&&("**"!==i||!l.selector)||(u.splice(o,1),l.selector&&u.delegateCount--,h.remove&&h.remove.call(e,l));s&&!u.length&&(h.teardown&&!1!==h.teardown.call(e,m,f.handle)||C.removeEvent(e,p,f.handle),delete d[p])}else for(p in d)C.event.remove(e,p+t[c],n,i,!0);C.isEmptyObject(d)&&Q.remove(e,"handle events")}},dispatch:function(e){var t,n,i,r,o,s,a=new Array(arguments.length),d=C.event.fix(e),c=(Q.get(this,"events")||Object.create(null))[d.type]||[],l=C.event.special[d.type]||{};for(a[0]=d,t=1;t<arguments.length;t++)a[t]=arguments[t];if(d.delegateTarget=this,!l.preDispatch||!1!==l.preDispatch.call(this,d)){for(s=C.event.handlers.call(this,d,c),t=0;(r=s[t++])&&!d.isPropagationStopped();)for(d.currentTarget=r.elem,n=0;(o=r.handlers[n++])&&!d.isImmediatePropagationStopped();)d.rnamespace&&!1!==o.namespace&&!d.rnamespace.test(o.namespace)||(d.handleObj=o,d.data=o.data,void 0!==(i=((C.event.special[o.origType]||{}).handle||o.handler).apply(r.elem,a))&&!1===(d.result=i)&&(d.preventDefault(),d.stopPropagation()));return l.postDispatch&&l.postDispatch.call(this,d),d.result}},handlers:function(e,t){var n,i,r,o,s,a=[],d=t.delegateCount,c=e.target;if(d&&c.nodeType&&!("click"===e.type&&1<=e.button))for(;c!==this;c=c.parentNode||this)if(1===c.nodeType&&("click"!==e.type||!0!==c.disabled)){for(o=[],s={},n=0;n<d;n++)void 0===s[r=(i=t[n]).selector+" "]&&(s[r]=i.needsContext?-1<C(r,this).index(c):C.find(r,this,null,[c]).length),s[r]&&o.push(i);o.length&&a.push({elem:c,handlers:o})}return c=this,d<t.length&&a.push({elem:c,handlers:t.slice(d)}),a},addProp:function(e,t){Object.defineProperty(C.Event.prototype,e,{enumerable:!0,configurable:!0,get:v(t)?function(){if(this.originalEvent)return t(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[e]},set:function(t){Object.defineProperty(this,e,{enumerable:!0,configurable:!0,writable:!0,value:t})}})},fix:function(e){return e[C.expando]?e:new C.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return me.test(t.type)&&t.click&&P(t,"input")&&Ae(t,"click",Te),!1},trigger:function(e){var t=this||e;return me.test(t.type)&&t.click&&P(t,"input")&&Ae(t,"click"),!0},_default:function(e){var t=e.target;return me.test(t.type)&&t.click&&P(t,"input")&&Q.get(t,"click")||P(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},C.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},C.Event=function(e,t){if(!(this instanceof C.Event))return new C.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Te:Ce,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&C.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[C.expando]=!0},C.Event.prototype={constructor:C.Event,isDefaultPrevented:Ce,isPropagationStopped:Ce,isImmediatePropagationStopped:Ce,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Te,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Te,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Te,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},C.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},C.event.addProp),C.each({focus:"focusin",blur:"focusout"},(function(e,t){C.event.special[e]={setup:function(){return Ae(this,e,xe),!1},trigger:function(){return Ae(this,e),!0},_default:function(t){return Q.get(t.target,e)},delegateType:t}})),C.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},(function(e,t){C.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,i=e.relatedTarget,r=e.handleObj;return i&&(i===this||C.contains(this,i))||(e.type=r.origType,n=r.handler.apply(this,arguments),e.type=t),n}}})),C.fn.extend({on:function(e,t,n,i){return Re(this,e,t,n,i)},one:function(e,t,n,i){return Re(this,e,t,n,i,1)},off:function(e,t,n){var i,r;if(e&&e.preventDefault&&e.handleObj)return i=e.handleObj,C(e.delegateTarget).off(i.namespace?i.origType+"."+i.namespace:i.origType,i.selector,i.handler),this;if("object"==typeof e){for(r in e)this.off(r,t,e[r]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Ce),this.each((function(){C.event.remove(this,e,n,t)}))}});var we=/<script|<style|<link/i,Ie=/checked\\s*(?:[^=]|=\\s*.checked.)/i,Pe=/^\\s*<!\\[CDATA\\[|\\]\\]>\\s*$/g;function De(e,t){return P(e,"table")&&P(11!==t.nodeType?t:t.firstChild,"tr")&&C(e).children("tbody")[0]||e}function Oe(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function ke(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Ne(e,t){var n,i,r,o,s,a;if(1===t.nodeType){if(Q.hasData(e)&&(a=Q.get(e).events))for(r in Q.remove(t,"handle events"),a)for(n=0,i=a[r].length;n<i;n++)C.event.add(t,r,a[r][n]);Z.hasData(e)&&(o=Z.access(e),s=C.extend({},o),Z.set(t,s))}}function Me(e,t,n,i){t=d(t);var r,o,s,a,c,l,h=0,u=e.length,p=u-1,m=t[0],g=v(m);if(g||1<u&&"string"==typeof m&&!f.checkClone&&Ie.test(m))return e.each((function(r){var o=e.eq(r);g&&(t[0]=m.call(this,r,o.html())),Me(o,t,n,i)}));if(u&&(o=(r=Se(t,e[0].ownerDocument,!1,e,i)).firstChild,1===r.childNodes.length&&(r=o),o||i)){for(a=(s=C.map(_e(r,"script"),Oe)).length;h<u;h++)c=r,h!==p&&(c=C.clone(c,!0,!0),a&&C.merge(s,_e(c,"script"))),n.call(e[h],c,h);if(a)for(l=s[s.length-1].ownerDocument,C.map(s,ke),h=0;h<a;h++)c=s[h],fe.test(c.type||"")&&!Q.access(c,"globalEval")&&C.contains(l,c)&&(c.src&&"module"!==(c.type||"").toLowerCase()?C._evalUrl&&!c.noModule&&C._evalUrl(c.src,{nonce:c.nonce||c.getAttribute("nonce")},l):S(c.textContent.replace(Pe,""),c,l))}return e}function Le(e,t,n){for(var i,r=t?C.filter(t,e):e,o=0;null!=(i=r[o]);o++)n||1!==i.nodeType||C.cleanData(_e(i)),i.parentNode&&(n&&ae(i)&&ye(_e(i,"script")),i.parentNode.removeChild(i));return e}C.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var i,r,o,s,a,d,c,l=e.cloneNode(!0),h=ae(e);if(!(f.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||C.isXMLDoc(e)))for(s=_e(l),i=0,r=(o=_e(e)).length;i<r;i++)a=o[i],"input"===(c=(d=s[i]).nodeName.toLowerCase())&&me.test(a.type)?d.checked=a.checked:"input"!==c&&"textarea"!==c||(d.defaultValue=a.defaultValue);if(t)if(n)for(o=o||_e(e),s=s||_e(l),i=0,r=o.length;i<r;i++)Ne(o[i],s[i]);else Ne(e,l);return 0<(s=_e(l,"script")).length&&ye(s,!h&&_e(e,"script")),l},cleanData:function(e){for(var t,n,i,r=C.event.special,o=0;void 0!==(n=e[o]);o++)if(X(n)){if(t=n[Q.expando]){if(t.events)for(i in t.events)r[i]?C.event.remove(n,i):C.removeEvent(n,i,t.handle);n[Q.expando]=void 0}n[Z.expando]&&(n[Z.expando]=void 0)}}}),C.fn.extend({detach:function(e){return Le(this,e,!0)},remove:function(e){return Le(this,e)},text:function(e){return q(this,(function(e){return void 0===e?C.text(this):this.empty().each((function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)}))}),null,e,arguments.length)},append:function(){return Me(this,arguments,(function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||De(this,e).appendChild(e)}))},prepend:function(){return Me(this,arguments,(function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=De(this,e);t.insertBefore(e,t.firstChild)}}))},before:function(){return Me(this,arguments,(function(e){this.parentNode&&this.parentNode.insertBefore(e,this)}))},after:function(){return Me(this,arguments,(function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)}))},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(C.cleanData(_e(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map((function(){return C.clone(this,e,t)}))},html:function(e){return q(this,(function(e){var t=this[0]||{},n=0,i=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!we.test(e)&&!ve[(ge.exec(e)||["",""])[1].toLowerCase()]){e=C.htmlPrefilter(e);try{for(;n<i;n++)1===(t=this[n]||{}).nodeType&&(C.cleanData(_e(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)}),null,e,arguments.length)},replaceWith:function(){var e=[];return Me(this,arguments,(function(t){var n=this.parentNode;C.inArray(this,e)<0&&(C.cleanData(_e(this)),n&&n.replaceChild(t,this))}),e)}}),C.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},(function(e,t){C.fn[e]=function(e){for(var n,i=[],r=C(e),o=r.length-1,s=0;s<=o;s++)n=s===o?this:this.clone(!0),C(r[s])[t](n),c.apply(i,n.get());return this.pushStack(i)}}));var Fe=new RegExp("^("+ie+")(?!px)[a-z%]+$","i"),je=/^--/,Ve=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=i),t.getComputedStyle(e)},Ue=function(e,t,n){var i,r,o={};for(r in t)o[r]=e.style[r],e.style[r]=t[r];for(r in i=n.call(e),t)e.style[r]=o[r];return i},He=new RegExp(oe.join("|"),"i"),$e="[\\\\x20\\\\t\\\\r\\\\n\\\\f]",Je=new RegExp("^"+$e+"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)"+$e+"+$","g");function Be(e,t,n){var i,r,o,s,a=je.test(t),d=e.style;return(n=n||Ve(e))&&(s=n.getPropertyValue(t)||n[t],a&&(s=s.replace(Je,"$1")),""!==s||ae(e)||(s=C.style(e,t)),!f.pixelBoxStyles()&&Fe.test(s)&&He.test(t)&&(i=d.width,r=d.minWidth,o=d.maxWidth,d.minWidth=d.maxWidth=d.width=s,s=n.width,d.width=i,d.minWidth=r,d.maxWidth=o)),void 0!==s?s+"":s}function qe(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){c.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",se.appendChild(c).appendChild(l);var e=i.getComputedStyle(l);n="1%"!==e.top,d=12===t(e.marginLeft),l.style.right="60%",s=36===t(e.right),r=36===t(e.width),l.style.position="absolute",o=12===t(l.offsetWidth/3),se.removeChild(c),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,o,s,a,d,c=y.createElement("div"),l=y.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",f.clearCloneStyle="content-box"===l.style.backgroundClip,C.extend(f,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),s},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),d},scrollboxSize:function(){return e(),o},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=y.createElement("table"),t=y.createElement("tr"),n=y.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",se.appendChild(e).appendChild(t).appendChild(n),r=i.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,se.removeChild(e)),a}}))}();var Ge=["Webkit","Moz","ms"],ze=y.createElement("div").style,Ke={};function We(e){return C.cssProps[e]||Ke[e]||(e in ze?e:Ke[e]=function(e){for(var t=e[0].toUpperCase()+e.slice(1),n=Ge.length;n--;)if((e=Ge[n]+t)in ze)return e}(e)||e)}var Xe,Ye,Qe=/^(none|table(?!-c[ea]).+)/,Ze={position:"absolute",visibility:"hidden",display:"block"},et={letterSpacing:"0",fontWeight:"400"};function tt(e,t,n){var i=re.exec(t);return i?Math.max(0,i[2]-(n||0))+(i[3]||"px"):t}function nt(e,t,n,i,r,o){var s="width"===t?1:0,a=0,d=0;if(n===(i?"border":"content"))return 0;for(;s<4;s+=2)"margin"===n&&(d+=C.css(e,n+oe[s],!0,r)),i?("content"===n&&(d-=C.css(e,"padding"+oe[s],!0,r)),"margin"!==n&&(d-=C.css(e,"border"+oe[s]+"Width",!0,r))):(d+=C.css(e,"padding"+oe[s],!0,r),"padding"!==n?d+=C.css(e,"border"+oe[s]+"Width",!0,r):a+=C.css(e,"border"+oe[s]+"Width",!0,r));return!i&&0<=o&&(d+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-d-a-.5))||0),d}function it(e,t,n){var i=Ve(e),r=(!f.boxSizingReliable()||n)&&"border-box"===C.css(e,"boxSizing",!1,i),o=r,s=Be(e,t,i),a="offset"+t[0].toUpperCase()+t.slice(1);if(Fe.test(s)){if(!n)return s;s="auto"}return(!f.boxSizingReliable()&&r||!f.reliableTrDimensions()&&P(e,"tr")||"auto"===s||!parseFloat(s)&&"inline"===C.css(e,"display",!1,i))&&e.getClientRects().length&&(r="border-box"===C.css(e,"boxSizing",!1,i),(o=a in e)&&(s=e[a])),(s=parseFloat(s)||0)+nt(e,t,n||(r?"border":"content"),o,i,s)+"px"}C.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Be(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,i){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var r,o,s,a=W(t),d=je.test(t),c=e.style;if(d||(t=We(a)),s=C.cssHooks[t]||C.cssHooks[a],void 0===n)return s&&"get"in s&&void 0!==(r=s.get(e,!1,i))?r:c[t];"string"==(o=typeof n)&&(r=re.exec(n))&&r[1]&&(n=function(e,t,n,i){var r,o,s=20,a=function(){return C.css(e,t,"")},d=a(),c=n&&n[3]||(C.cssNumber[t]?"":"px"),l=e.nodeType&&(C.cssNumber[t]||"px"!==c&&+d)&&re.exec(C.css(e,t));if(l&&l[3]!==c){for(d/=2,c=c||l[3],l=+d||1;s--;)C.style(e,t,l+c),(1-o)*(1-(o=a()/d||.5))<=0&&(s=0),l/=o;l*=2,C.style(e,t,l+c),n=n||[]}return n&&(l=+l||+d||0,r=n[1]?l+(n[1]+1)*n[2]:+n[2]),r}(e,t,r),o="number"),null!=n&&n==n&&("number"!==o||d||(n+=r&&r[3]||(C.cssNumber[a]?"":"px")),f.clearCloneStyle||""!==n||0!==t.indexOf("background")||(c[t]="inherit"),s&&"set"in s&&void 0===(n=s.set(e,n,i))||(d?c.setProperty(t,n):c[t]=n))}},css:function(e,t,n,i){var r,o,s,a=W(t);return je.test(t)||(t=We(a)),(s=C.cssHooks[t]||C.cssHooks[a])&&"get"in s&&(r=s.get(e,!0,n)),void 0===r&&(r=Be(e,t,i)),"normal"===r&&t in et&&(r=et[t]),""===n||n?(o=parseFloat(r),!0===n||isFinite(o)?o||0:r):r}}),C.each(["height","width"],(function(e,t){C.cssHooks[t]={get:function(e,n,i){if(n)return!Qe.test(C.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?it(e,t,i):Ue(e,Ze,(function(){return it(e,t,i)}))},set:function(e,n,i){var r,o=Ve(e),s=!f.scrollboxSize()&&"absolute"===o.position,a=(s||i)&&"border-box"===C.css(e,"boxSizing",!1,o),d=i?nt(e,t,i,a,o):0;return a&&s&&(d-=Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-parseFloat(o[t])-nt(e,t,"border",!1,o)-.5)),d&&(r=re.exec(n))&&"px"!==(r[3]||"px")&&(e.style[t]=n,n=C.css(e,t)),tt(0,n,d)}}})),C.cssHooks.marginLeft=qe(f.reliableMarginLeft,(function(e,t){if(t)return(parseFloat(Be(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},(function(){return e.getBoundingClientRect().left})))+"px"})),C.each({margin:"",padding:"",border:"Width"},(function(e,t){C.cssHooks[e+t]={expand:function(n){for(var i=0,r={},o="string"==typeof n?n.split(" "):[n];i<4;i++)r[e+oe[i]+t]=o[i]||o[i-2]||o[0];return r}},"margin"!==e&&(C.cssHooks[e+t].set=tt)})),C.fn.extend({css:function(e,t){return q(this,(function(e,t,n){var i,r,o={},s=0;if(Array.isArray(t)){for(i=Ve(e),r=t.length;s<r;s++)o[t[s]]=C.css(e,t[s],!1,i);return o}return void 0!==n?C.style(e,t,n):C.css(e,t)}),e,t,1<arguments.length)}}),C.fn.delay=function(e,t){return e=C.fx&&C.fx.speeds[e]||e,t=t||"fx",this.queue(t,(function(t,n){var r=i.setTimeout(t,e);n.stop=function(){i.clearTimeout(r)}}))},Xe=y.createElement("input"),Ye=y.createElement("select").appendChild(y.createElement("option")),Xe.type="checkbox",f.checkOn=""!==Xe.value,f.optSelected=Ye.selected,(Xe=y.createElement("input")).value="t",Xe.type="radio",f.radioValue="t"===Xe.value;var rt,ot=C.expr.attrHandle;C.fn.extend({attr:function(e,t){return q(this,C.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each((function(){C.removeAttr(this,e)}))}}),C.extend({attr:function(e,t,n){var i,r,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return void 0===e.getAttribute?C.prop(e,t,n):(1===o&&C.isXMLDoc(e)||(r=C.attrHooks[t.toLowerCase()]||(C.expr.match.bool.test(t)?rt:void 0)),void 0!==n?null===n?void C.removeAttr(e,t):r&&"set"in r&&void 0!==(i=r.set(e,n,t))?i:(e.setAttribute(t,n+""),n):r&&"get"in r&&null!==(i=r.get(e,t))?i:null==(i=C.find.attr(e,t))?void 0:i)},attrHooks:{type:{set:function(e,t){if(!f.radioValue&&"radio"===t&&P(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,i=0,r=t&&t.match(j);if(r&&1===e.nodeType)for(;n=r[i++];)e.removeAttribute(n)}}),rt={set:function(e,t,n){return!1===t?C.removeAttr(e,n):e.setAttribute(n,n),n}},C.each(C.expr.match.bool.source.match(/\\w+/g),(function(e,t){var n=ot[t]||C.find.attr;ot[t]=function(e,t,i){var r,o,s=t.toLowerCase();return i||(o=ot[s],ot[s]=r,r=null!=n(e,t,i)?s:null,ot[s]=o),r}}));var st=/^(?:input|select|textarea|button)$/i,at=/^(?:a|area)$/i;function dt(e){return(e.match(j)||[]).join(" ")}function ct(e){return e.getAttribute&&e.getAttribute("class")||""}function lt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(j)||[]}C.fn.extend({prop:function(e,t){return q(this,C.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each((function(){delete this[C.propFix[e]||e]}))}}),C.extend({prop:function(e,t,n){var i,r,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&C.isXMLDoc(e)||(t=C.propFix[t]||t,r=C.propHooks[t]),void 0!==n?r&&"set"in r&&void 0!==(i=r.set(e,n,t))?i:e[t]=n:r&&"get"in r&&null!==(i=r.get(e,t))?i:e[t]},propHooks:{tabIndex:{get:function(e){var t=C.find.attr(e,"tabindex");return t?parseInt(t,10):st.test(e.nodeName)||at.test(e.nodeName)&&e.href?0:-1}}},propFix:{for:"htmlFor",class:"className"}}),f.optSelected||(C.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),C.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],(function(){C.propFix[this.toLowerCase()]=this})),C.fn.extend({addClass:function(e){var t,n,i,r,o,s;return v(e)?this.each((function(t){C(this).addClass(e.call(this,t,ct(this)))})):(t=lt(e)).length?this.each((function(){if(i=ct(this),n=1===this.nodeType&&" "+dt(i)+" "){for(o=0;o<t.length;o++)r=t[o],n.indexOf(" "+r+" ")<0&&(n+=r+" ");s=dt(n),i!==s&&this.setAttribute("class",s)}})):this},removeClass:function(e){var t,n,i,r,o,s;return v(e)?this.each((function(t){C(this).removeClass(e.call(this,t,ct(this)))})):arguments.length?(t=lt(e)).length?this.each((function(){if(i=ct(this),n=1===this.nodeType&&" "+dt(i)+" "){for(o=0;o<t.length;o++)for(r=t[o];-1<n.indexOf(" "+r+" ");)n=n.replace(" "+r+" "," ");s=dt(n),i!==s&&this.setAttribute("class",s)}})):this:this.attr("class","")},toggleClass:function(e,t){var n,i,r,o,s=typeof e,a="string"===s||Array.isArray(e);return v(e)?this.each((function(n){C(this).toggleClass(e.call(this,n,ct(this),t),t)})):"boolean"==typeof t&&a?t?this.addClass(e):this.removeClass(e):(n=lt(e),this.each((function(){if(a)for(o=C(this),r=0;r<n.length;r++)i=n[r],o.hasClass(i)?o.removeClass(i):o.addClass(i);else void 0!==e&&"boolean"!==s||((i=ct(this))&&Q.set(this,"__className__",i),this.setAttribute&&this.setAttribute("class",i||!1===e?"":Q.get(this,"__className__")||""))})))},hasClass:function(e){var t,n,i=0;for(t=" "+e+" ";n=this[i++];)if(1===n.nodeType&&-1<(" "+dt(ct(n))+" ").indexOf(t))return!0;return!1}});var ht=/\\r/g;C.fn.extend({val:function(e){var t,n,i,r=this[0];return arguments.length?(i=v(e),this.each((function(n){var r;1===this.nodeType&&(null==(r=i?e.call(this,n,C(this).val()):e)?r="":"number"==typeof r?r+="":Array.isArray(r)&&(r=C.map(r,(function(e){return null==e?"":e+""}))),(t=C.valHooks[this.type]||C.valHooks[this.nodeName.toLowerCase()])&&"set"in t&&void 0!==t.set(this,r,"value")||(this.value=r))}))):r?(t=C.valHooks[r.type]||C.valHooks[r.nodeName.toLowerCase()])&&"get"in t&&void 0!==(n=t.get(r,"value"))?n:"string"==typeof(n=r.value)?n.replace(ht,""):null==n?"":n:void 0}}),C.extend({valHooks:{option:{get:function(e){var t=C.find.attr(e,"value");return null!=t?t:dt(C.text(e))}},select:{get:function(e){var t,n,i,r=e.options,o=e.selectedIndex,s="select-one"===e.type,a=s?null:[],d=s?o+1:r.length;for(i=o<0?d:s?o:0;i<d;i++)if(((n=r[i]).selected||i===o)&&!n.disabled&&(!n.parentNode.disabled||!P(n.parentNode,"optgroup"))){if(t=C(n).val(),s)return t;a.push(t)}return a},set:function(e,t){for(var n,i,r=e.options,o=C.makeArray(t),s=r.length;s--;)((i=r[s]).selected=-1<C.inArray(C.valHooks.option.get(i),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),C.each(["radio","checkbox"],(function(){C.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<C.inArray(C(e).val(),t)}},f.checkOn||(C.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})})),f.focusin="onfocusin"in i;var ut=/^(?:focusinfocus|focusoutblur)$/,pt=function(e){e.stopPropagation()};C.extend(C.event,{trigger:function(e,t,n,r){var o,s,a,d,c,l,h,u,m=[n||y],g=p.call(e,"type")?e.type:e,f=p.call(e,"namespace")?e.namespace.split("."):[];if(s=u=a=n=n||y,3!==n.nodeType&&8!==n.nodeType&&!ut.test(g+C.event.triggered)&&(-1<g.indexOf(".")&&(g=(f=g.split(".")).shift(),f.sort()),c=g.indexOf(":")<0&&"on"+g,(e=e[C.expando]?e:new C.Event(g,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=f.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\\\.)"+f.join("\\\\.(?:.*\\\\.|)")+"(\\\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:C.makeArray(t,[e]),h=C.event.special[g]||{},r||!h.trigger||!1!==h.trigger.apply(n,t))){if(!r&&!h.noBubble&&!_(n)){for(d=h.delegateType||g,ut.test(d+g)||(s=s.parentNode);s;s=s.parentNode)m.push(s),a=s;a===(n.ownerDocument||y)&&m.push(a.defaultView||a.parentWindow||i)}for(o=0;(s=m[o++])&&!e.isPropagationStopped();)u=s,e.type=1<o?d:h.bindType||g,(l=(Q.get(s,"events")||Object.create(null))[e.type]&&Q.get(s,"handle"))&&l.apply(s,t),(l=c&&s[c])&&l.apply&&X(s)&&(e.result=l.apply(s,t),!1===e.result&&e.preventDefault());return e.type=g,r||e.isDefaultPrevented()||h._default&&!1!==h._default.apply(m.pop(),t)||!X(n)||c&&v(n[g])&&!_(n)&&((a=n[c])&&(n[c]=null),C.event.triggered=g,e.isPropagationStopped()&&u.addEventListener(g,pt),n[g](),e.isPropagationStopped()&&u.removeEventListener(g,pt),C.event.triggered=void 0,a&&(n[c]=a)),e.result}},simulate:function(e,t,n){var i=C.extend(new C.Event,n,{type:e,isSimulated:!0});C.event.trigger(i,null,t)}}),C.fn.extend({trigger:function(e,t){return this.each((function(){C.event.trigger(e,t,this)}))},triggerHandler:function(e,t){var n=this[0];if(n)return C.event.trigger(e,t,n,!0)}}),f.focusin||C.each({focus:"focusin",blur:"focusout"},(function(e,t){var n=function(e){C.event.simulate(t,e.target,C.event.fix(e))};C.event.special[t]={setup:function(){var i=this.ownerDocument||this.document||this,r=Q.access(i,t);r||i.addEventListener(e,n,!0),Q.access(i,t,(r||0)+1)},teardown:function(){var i=this.ownerDocument||this.document||this,r=Q.access(i,t)-1;r?Q.access(i,t,r):(i.removeEventListener(e,n,!0),Q.remove(i,t))}}})),C.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new i.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||C.error("Invalid XML: "+(n?C.map(n.childNodes,(function(e){return e.textContent})).join("\\n"):e)),t};var mt,gt=/\\[\\]$/,ft=/\\r?\\n/g,vt=/^(?:submit|button|image|reset|file)$/i,_t=/^(?:input|select|textarea|keygen)/i;function yt(e,t,n,i){var r;if(Array.isArray(t))C.each(t,(function(t,r){n||gt.test(e)?i(e,r):yt(e+"["+("object"==typeof r&&null!=r?t:"")+"]",r,n,i)}));else if(n||"object"!==b(t))i(e,t);else for(r in t)yt(e+"["+r+"]",t[r],n,i)}C.param=function(e,t){var n,i=[],r=function(e,t){var n=v(t)?t():t;i[i.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!C.isPlainObject(e))C.each(e,(function(){r(this.name,this.value)}));else for(n in e)yt(n,e[n],t,r);return i.join("&")},C.fn.extend({serialize:function(){return C.param(this.serializeArray())},serializeArray:function(){return this.map((function(){var e=C.prop(this,"elements");return e?C.makeArray(e):this})).filter((function(){var e=this.type;return this.name&&!C(this).is(":disabled")&&_t.test(this.nodeName)&&!vt.test(e)&&(this.checked||!me.test(e))})).map((function(e,t){var n=C(this).val();return null==n?null:Array.isArray(n)?C.map(n,(function(e){return{name:t.name,value:e.replace(ft,"\\r\\n")}})):{name:t.name,value:n.replace(ft,"\\r\\n")}})).get()}}),C.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=C(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map((function(){for(var e=this;e.firstElementChild;)e=e.firstElementChild;return e})).append(this)),this},wrapInner:function(e){return v(e)?this.each((function(t){C(this).wrapInner(e.call(this,t))})):this.each((function(){var t=C(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)}))},wrap:function(e){var t=v(e);return this.each((function(n){C(this).wrapAll(t?e.call(this,n):e)}))},unwrap:function(e){return this.parent(e).not("body").each((function(){C(this).replaceWith(this.childNodes)})),this}}),C.expr.pseudos.hidden=function(e){return!C.expr.pseudos.visible(e)},C.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},f.createHTMLDocument=((mt=y.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===mt.childNodes.length),C.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(f.createHTMLDocument?((i=(t=y.implementation.createHTMLDocument("")).createElement("base")).href=y.location.href,t.head.appendChild(i)):t=y),o=!n&&[],(r=D.exec(e))?[t.createElement(r[1])]:(r=Se([e],t,o),o&&o.length&&C(o).remove(),C.merge([],r.childNodes)));var i,r,o},C.offset={setOffset:function(e,t,n){var i,r,o,s,a,d,c=C.css(e,"position"),l=C(e),h={};"static"===c&&(e.style.position="relative"),a=l.offset(),o=C.css(e,"top"),d=C.css(e,"left"),("absolute"===c||"fixed"===c)&&-1<(o+d).indexOf("auto")?(s=(i=l.position()).top,r=i.left):(s=parseFloat(o)||0,r=parseFloat(d)||0),v(t)&&(t=t.call(e,n,C.extend({},a))),null!=t.top&&(h.top=t.top-a.top+s),null!=t.left&&(h.left=t.left-a.left+r),"using"in t?t.using.call(e,h):l.css(h)}},C.fn.extend({offset:function(e){if(arguments.length)return void 0===e?this:this.each((function(t){C.offset.setOffset(this,e,t)}));var t,n,i=this[0];return i?i.getClientRects().length?(t=i.getBoundingClientRect(),n=i.ownerDocument.defaultView,{top:t.top+n.pageYOffset,left:t.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,i=this[0],r={top:0,left:0};if("fixed"===C.css(i,"position"))t=i.getBoundingClientRect();else{for(t=this.offset(),n=i.ownerDocument,e=i.offsetParent||n.documentElement;e&&(e===n.body||e===n.documentElement)&&"static"===C.css(e,"position");)e=e.parentNode;e&&e!==i&&1===e.nodeType&&((r=C(e).offset()).top+=C.css(e,"borderTopWidth",!0),r.left+=C.css(e,"borderLeftWidth",!0))}return{top:t.top-r.top-C.css(i,"marginTop",!0),left:t.left-r.left-C.css(i,"marginLeft",!0)}}},offsetParent:function(){return this.map((function(){for(var e=this.offsetParent;e&&"static"===C.css(e,"position");)e=e.offsetParent;return e||se}))}}),C.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},(function(e,t){var n="pageYOffset"===t;C.fn[e]=function(i){return q(this,(function(e,i,r){var o;if(_(e)?o=e:9===e.nodeType&&(o=e.defaultView),void 0===r)return o?o[t]:e[i];o?o.scrollTo(n?o.pageXOffset:r,n?r:o.pageYOffset):e[i]=r}),e,i,arguments.length)}})),C.each(["top","left"],(function(e,t){C.cssHooks[t]=qe(f.pixelPosition,(function(e,n){if(n)return n=Be(e,t),Fe.test(n)?C(e).position()[t]+"px":n}))})),C.each({Height:"height",Width:"width"},(function(e,t){C.each({padding:"inner"+e,content:t,"":"outer"+e},(function(n,i){C.fn[i]=function(r,o){var s=arguments.length&&(n||"boolean"!=typeof r),a=n||(!0===r||!0===o?"margin":"border");return q(this,(function(t,n,r){var o;return _(t)?0===i.indexOf("outer")?t["inner"+e]:t.document.documentElement["client"+e]:9===t.nodeType?(o=t.documentElement,Math.max(t.body["scroll"+e],o["scroll"+e],t.body["offset"+e],o["offset"+e],o["client"+e])):void 0===r?C.css(t,n,a):C.style(t,n,r,a)}),t,s?r:void 0,s)}}))})),C.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,i){return this.on(t,e,n,i)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),C.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),(function(e,t){C.fn[t]=function(e,n){return 0<arguments.length?this.on(t,null,e,n):this.trigger(t)}}));var Et=/^[\\s\\uFEFF\\xA0]+|([^\\s\\uFEFF\\xA0])[\\s\\uFEFF\\xA0]+$/g;C.proxy=function(e,t){var n,i,r;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return i=a.call(arguments,2),(r=function(){return e.apply(t||this,i.concat(a.call(arguments)))}).guid=e.guid=e.guid||C.guid++,r},C.holdReady=function(e){e?C.readyWait++:C.ready(!0)},C.isArray=Array.isArray,C.parseJSON=JSON.parse,C.nodeName=P,C.isFunction=v,C.isWindow=_,C.camelCase=W,C.type=b,C.now=Date.now,C.isNumeric=function(e){var t=C.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},C.trim=function(e){return null==e?"":(e+"").replace(Et,"$1")},void 0===(n=function(){return C}.apply(t,[]))||(e.exports=n);var St=i.jQuery,bt=i.$;return C.noConflict=function(e){return i.$===C&&(i.$=bt),e&&i.jQuery===C&&(i.jQuery=St),C},void 0===r&&(i.jQuery=i.$=C),C}))},478:(module,exports,__webpack_require__)=>{var __WEBPACK_AMD_DEFINE_RESULT__;(function(){"use strict";var ERROR="input is invalid type",WINDOW="object"==typeof window,root=WINDOW?window:{};root.JS_MD5_NO_WINDOW&&(WINDOW=!1);var WEB_WORKER=!WINDOW&&"object"==typeof self,NODE_JS=!root.JS_MD5_NO_NODE_JS&&"object"==typeof process&&process.versions&&process.versions.node;NODE_JS?root=__webpack_require__.g:WEB_WORKER&&(root=self);var COMMON_JS=!root.JS_MD5_NO_COMMON_JS&&module.exports,AMD=__webpack_require__.amdO,ARRAY_BUFFER=!root.JS_MD5_NO_ARRAY_BUFFER&&"undefined"!=typeof ArrayBuffer,HEX_CHARS="0123456789abcdef".split(""),EXTRA=[128,32768,8388608,-2147483648],SHIFT=[0,8,16,24],OUTPUT_TYPES=["hex","array","digest","buffer","arrayBuffer","base64"],BASE64_ENCODE_CHAR="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""),blocks=[],buffer8;if(ARRAY_BUFFER){var buffer=new ArrayBuffer(68);buffer8=new Uint8Array(buffer),blocks=new Uint32Array(buffer)}!root.JS_MD5_NO_NODE_JS&&Array.isArray||(Array.isArray=function(e){return"[object Array]"===Object.prototype.toString.call(e)}),!ARRAY_BUFFER||!root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW&&ArrayBuffer.isView||(ArrayBuffer.isView=function(e){return"object"==typeof e&&e.buffer&&e.buffer.constructor===ArrayBuffer});var createOutputMethod=function(e){return function(t){return new Md5(!0).update(t)[e]()}},createMethod=function(){var e=createOutputMethod("hex");NODE_JS&&(e=nodeWrap(e)),e.create=function(){return new Md5},e.update=function(t){return e.create().update(t)};for(var t=0;t<OUTPUT_TYPES.length;++t){var n=OUTPUT_TYPES[t];e[n]=createOutputMethod(n)}return e},nodeWrap=function(method){var crypto=eval("require(\'crypto\')"),Buffer=eval("require(\'buffer\').Buffer"),nodeMethod=function(e){if("string"==typeof e)return crypto.createHash("md5").update(e,"utf8").digest("hex");if(null==e)throw ERROR;return e.constructor===ArrayBuffer&&(e=new Uint8Array(e)),Array.isArray(e)||ArrayBuffer.isView(e)||e.constructor===Buffer?crypto.createHash("md5").update(new Buffer(e)).digest("hex"):method(e)};return nodeMethod};function Md5(e){if(e)blocks[0]=blocks[16]=blocks[1]=blocks[2]=blocks[3]=blocks[4]=blocks[5]=blocks[6]=blocks[7]=blocks[8]=blocks[9]=blocks[10]=blocks[11]=blocks[12]=blocks[13]=blocks[14]=blocks[15]=0,this.blocks=blocks,this.buffer8=buffer8;else if(ARRAY_BUFFER){var t=new ArrayBuffer(68);this.buffer8=new Uint8Array(t),this.blocks=new Uint32Array(t)}else this.blocks=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];this.h0=this.h1=this.h2=this.h3=this.start=this.bytes=this.hBytes=0,this.finalized=this.hashed=!1,this.first=!0}Md5.prototype.update=function(e){if(!this.finalized){var t,n=typeof e;if("string"!==n){if("object"!==n)throw ERROR;if(null===e)throw ERROR;if(ARRAY_BUFFER&&e.constructor===ArrayBuffer)e=new Uint8Array(e);else if(!(Array.isArray(e)||ARRAY_BUFFER&&ArrayBuffer.isView(e)))throw ERROR;t=!0}for(var i,r,o=0,s=e.length,a=this.blocks,d=this.buffer8;o<s;){if(this.hashed&&(this.hashed=!1,a[0]=a[16],a[16]=a[1]=a[2]=a[3]=a[4]=a[5]=a[6]=a[7]=a[8]=a[9]=a[10]=a[11]=a[12]=a[13]=a[14]=a[15]=0),t)if(ARRAY_BUFFER)for(r=this.start;o<s&&r<64;++o)d[r++]=e[o];else for(r=this.start;o<s&&r<64;++o)a[r>>2]|=e[o]<<SHIFT[3&r++];else if(ARRAY_BUFFER)for(r=this.start;o<s&&r<64;++o)(i=e.charCodeAt(o))<128?d[r++]=i:i<2048?(d[r++]=192|i>>6,d[r++]=128|63&i):i<55296||i>=57344?(d[r++]=224|i>>12,d[r++]=128|i>>6&63,d[r++]=128|63&i):(i=65536+((1023&i)<<10|1023&e.charCodeAt(++o)),d[r++]=240|i>>18,d[r++]=128|i>>12&63,d[r++]=128|i>>6&63,d[r++]=128|63&i);else for(r=this.start;o<s&&r<64;++o)(i=e.charCodeAt(o))<128?a[r>>2]|=i<<SHIFT[3&r++]:i<2048?(a[r>>2]|=(192|i>>6)<<SHIFT[3&r++],a[r>>2]|=(128|63&i)<<SHIFT[3&r++]):i<55296||i>=57344?(a[r>>2]|=(224|i>>12)<<SHIFT[3&r++],a[r>>2]|=(128|i>>6&63)<<SHIFT[3&r++],a[r>>2]|=(128|63&i)<<SHIFT[3&r++]):(i=65536+((1023&i)<<10|1023&e.charCodeAt(++o)),a[r>>2]|=(240|i>>18)<<SHIFT[3&r++],a[r>>2]|=(128|i>>12&63)<<SHIFT[3&r++],a[r>>2]|=(128|i>>6&63)<<SHIFT[3&r++],a[r>>2]|=(128|63&i)<<SHIFT[3&r++]);this.lastByteIndex=r,this.bytes+=r-this.start,r>=64?(this.start=r-64,this.hash(),this.hashed=!0):this.start=r}return this.bytes>4294967295&&(this.hBytes+=this.bytes/4294967296<<0,this.bytes=this.bytes%4294967296),this}},Md5.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var e=this.blocks,t=this.lastByteIndex;e[t>>2]|=EXTRA[3&t],t>=56&&(this.hashed||this.hash(),e[0]=e[16],e[16]=e[1]=e[2]=e[3]=e[4]=e[5]=e[6]=e[7]=e[8]=e[9]=e[10]=e[11]=e[12]=e[13]=e[14]=e[15]=0),e[14]=this.bytes<<3,e[15]=this.hBytes<<3|this.bytes>>>29,this.hash()}},Md5.prototype.hash=function(){var e,t,n,i,r,o,s=this.blocks;this.first?t=((t=((e=((e=s[0]-680876937)<<7|e>>>25)-271733879<<0)^(n=((n=(-271733879^(i=((i=(-1732584194^2004318071&e)+s[1]-117830708)<<12|i>>>20)+e<<0)&(-271733879^e))+s[2]-1126478375)<<17|n>>>15)+i<<0)&(i^e))+s[3]-1316259209)<<22|t>>>10)+n<<0:(e=this.h0,t=this.h1,n=this.h2,t=((t+=((e=((e+=((i=this.h3)^t&(n^i))+s[0]-680876936)<<7|e>>>25)+t<<0)^(n=((n+=(t^(i=((i+=(n^e&(t^n))+s[1]-389564586)<<12|i>>>20)+e<<0)&(e^t))+s[2]+606105819)<<17|n>>>15)+i<<0)&(i^e))+s[3]-1044525330)<<22|t>>>10)+n<<0),t=((t+=((e=((e+=(i^t&(n^i))+s[4]-176418897)<<7|e>>>25)+t<<0)^(n=((n+=(t^(i=((i+=(n^e&(t^n))+s[5]+1200080426)<<12|i>>>20)+e<<0)&(e^t))+s[6]-1473231341)<<17|n>>>15)+i<<0)&(i^e))+s[7]-45705983)<<22|t>>>10)+n<<0,t=((t+=((e=((e+=(i^t&(n^i))+s[8]+1770035416)<<7|e>>>25)+t<<0)^(n=((n+=(t^(i=((i+=(n^e&(t^n))+s[9]-1958414417)<<12|i>>>20)+e<<0)&(e^t))+s[10]-42063)<<17|n>>>15)+i<<0)&(i^e))+s[11]-1990404162)<<22|t>>>10)+n<<0,t=((t+=((e=((e+=(i^t&(n^i))+s[12]+1804603682)<<7|e>>>25)+t<<0)^(n=((n+=(t^(i=((i+=(n^e&(t^n))+s[13]-40341101)<<12|i>>>20)+e<<0)&(e^t))+s[14]-1502002290)<<17|n>>>15)+i<<0)&(i^e))+s[15]+1236535329)<<22|t>>>10)+n<<0,t=((t+=((i=((i+=(t^n&((e=((e+=(n^i&(t^n))+s[1]-165796510)<<5|e>>>27)+t<<0)^t))+s[6]-1069501632)<<9|i>>>23)+e<<0)^e&((n=((n+=(e^t&(i^e))+s[11]+643717713)<<14|n>>>18)+i<<0)^i))+s[0]-373897302)<<20|t>>>12)+n<<0,t=((t+=((i=((i+=(t^n&((e=((e+=(n^i&(t^n))+s[5]-701558691)<<5|e>>>27)+t<<0)^t))+s[10]+38016083)<<9|i>>>23)+e<<0)^e&((n=((n+=(e^t&(i^e))+s[15]-660478335)<<14|n>>>18)+i<<0)^i))+s[4]-405537848)<<20|t>>>12)+n<<0,t=((t+=((i=((i+=(t^n&((e=((e+=(n^i&(t^n))+s[9]+568446438)<<5|e>>>27)+t<<0)^t))+s[14]-1019803690)<<9|i>>>23)+e<<0)^e&((n=((n+=(e^t&(i^e))+s[3]-187363961)<<14|n>>>18)+i<<0)^i))+s[8]+1163531501)<<20|t>>>12)+n<<0,t=((t+=((i=((i+=(t^n&((e=((e+=(n^i&(t^n))+s[13]-1444681467)<<5|e>>>27)+t<<0)^t))+s[2]-51403784)<<9|i>>>23)+e<<0)^e&((n=((n+=(e^t&(i^e))+s[7]+1735328473)<<14|n>>>18)+i<<0)^i))+s[12]-1926607734)<<20|t>>>12)+n<<0,t=((t+=((o=(i=((i+=((r=t^n)^(e=((e+=(r^i)+s[5]-378558)<<4|e>>>28)+t<<0))+s[8]-2022574463)<<11|i>>>21)+e<<0)^e)^(n=((n+=(o^t)+s[11]+1839030562)<<16|n>>>16)+i<<0))+s[14]-35309556)<<23|t>>>9)+n<<0,t=((t+=((o=(i=((i+=((r=t^n)^(e=((e+=(r^i)+s[1]-1530992060)<<4|e>>>28)+t<<0))+s[4]+1272893353)<<11|i>>>21)+e<<0)^e)^(n=((n+=(o^t)+s[7]-155497632)<<16|n>>>16)+i<<0))+s[10]-1094730640)<<23|t>>>9)+n<<0,t=((t+=((o=(i=((i+=((r=t^n)^(e=((e+=(r^i)+s[13]+681279174)<<4|e>>>28)+t<<0))+s[0]-358537222)<<11|i>>>21)+e<<0)^e)^(n=((n+=(o^t)+s[3]-722521979)<<16|n>>>16)+i<<0))+s[6]+76029189)<<23|t>>>9)+n<<0,t=((t+=((o=(i=((i+=((r=t^n)^(e=((e+=(r^i)+s[9]-640364487)<<4|e>>>28)+t<<0))+s[12]-421815835)<<11|i>>>21)+e<<0)^e)^(n=((n+=(o^t)+s[15]+530742520)<<16|n>>>16)+i<<0))+s[2]-995338651)<<23|t>>>9)+n<<0,t=((t+=((i=((i+=(t^((e=((e+=(n^(t|~i))+s[0]-198630844)<<6|e>>>26)+t<<0)|~n))+s[7]+1126891415)<<10|i>>>22)+e<<0)^((n=((n+=(e^(i|~t))+s[14]-1416354905)<<15|n>>>17)+i<<0)|~e))+s[5]-57434055)<<21|t>>>11)+n<<0,t=((t+=((i=((i+=(t^((e=((e+=(n^(t|~i))+s[12]+1700485571)<<6|e>>>26)+t<<0)|~n))+s[3]-1894986606)<<10|i>>>22)+e<<0)^((n=((n+=(e^(i|~t))+s[10]-1051523)<<15|n>>>17)+i<<0)|~e))+s[1]-2054922799)<<21|t>>>11)+n<<0,t=((t+=((i=((i+=(t^((e=((e+=(n^(t|~i))+s[8]+1873313359)<<6|e>>>26)+t<<0)|~n))+s[15]-30611744)<<10|i>>>22)+e<<0)^((n=((n+=(e^(i|~t))+s[6]-1560198380)<<15|n>>>17)+i<<0)|~e))+s[13]+1309151649)<<21|t>>>11)+n<<0,t=((t+=((i=((i+=(t^((e=((e+=(n^(t|~i))+s[4]-145523070)<<6|e>>>26)+t<<0)|~n))+s[11]-1120210379)<<10|i>>>22)+e<<0)^((n=((n+=(e^(i|~t))+s[2]+718787259)<<15|n>>>17)+i<<0)|~e))+s[9]-343485551)<<21|t>>>11)+n<<0,this.first?(this.h0=e+1732584193<<0,this.h1=t-271733879<<0,this.h2=n-1732584194<<0,this.h3=i+271733878<<0,this.first=!1):(this.h0=this.h0+e<<0,this.h1=this.h1+t<<0,this.h2=this.h2+n<<0,this.h3=this.h3+i<<0)},Md5.prototype.hex=function(){this.finalize();var e=this.h0,t=this.h1,n=this.h2,i=this.h3;return HEX_CHARS[e>>4&15]+HEX_CHARS[15&e]+HEX_CHARS[e>>12&15]+HEX_CHARS[e>>8&15]+HEX_CHARS[e>>20&15]+HEX_CHARS[e>>16&15]+HEX_CHARS[e>>28&15]+HEX_CHARS[e>>24&15]+HEX_CHARS[t>>4&15]+HEX_CHARS[15&t]+HEX_CHARS[t>>12&15]+HEX_CHARS[t>>8&15]+HEX_CHARS[t>>20&15]+HEX_CHARS[t>>16&15]+HEX_CHARS[t>>28&15]+HEX_CHARS[t>>24&15]+HEX_CHARS[n>>4&15]+HEX_CHARS[15&n]+HEX_CHARS[n>>12&15]+HEX_CHARS[n>>8&15]+HEX_CHARS[n>>20&15]+HEX_CHARS[n>>16&15]+HEX_CHARS[n>>28&15]+HEX_CHARS[n>>24&15]+HEX_CHARS[i>>4&15]+HEX_CHARS[15&i]+HEX_CHARS[i>>12&15]+HEX_CHARS[i>>8&15]+HEX_CHARS[i>>20&15]+HEX_CHARS[i>>16&15]+HEX_CHARS[i>>28&15]+HEX_CHARS[i>>24&15]},Md5.prototype.toString=Md5.prototype.hex,Md5.prototype.digest=function(){this.finalize();var e=this.h0,t=this.h1,n=this.h2,i=this.h3;return[255&e,e>>8&255,e>>16&255,e>>24&255,255&t,t>>8&255,t>>16&255,t>>24&255,255&n,n>>8&255,n>>16&255,n>>24&255,255&i,i>>8&255,i>>16&255,i>>24&255]},Md5.prototype.array=Md5.prototype.digest,Md5.prototype.arrayBuffer=function(){this.finalize();var e=new ArrayBuffer(16),t=new Uint32Array(e);return t[0]=this.h0,t[1]=this.h1,t[2]=this.h2,t[3]=this.h3,e},Md5.prototype.buffer=Md5.prototype.arrayBuffer,Md5.prototype.base64=function(){for(var e,t,n,i="",r=this.array(),o=0;o<15;)e=r[o++],t=r[o++],n=r[o++],i+=BASE64_ENCODE_CHAR[e>>>2]+BASE64_ENCODE_CHAR[63&(e<<4|t>>>4)]+BASE64_ENCODE_CHAR[63&(t<<2|n>>>6)]+BASE64_ENCODE_CHAR[63&n];return e=r[o],i+(BASE64_ENCODE_CHAR[e>>>2]+BASE64_ENCODE_CHAR[e<<4&63]+"==")};var exports=createMethod();COMMON_JS?module.exports=exports:(root.md5=exports,AMD&&(__WEBPACK_AMD_DEFINE_RESULT__=function(){return exports}.call(exports,__webpack_require__,exports,module),void 0===__WEBPACK_AMD_DEFINE_RESULT__||(module.exports=__WEBPACK_AMD_DEFINE_RESULT__)))})()},138:(e,t,n)=>{e=n.nmd(e);var i="__lodash_hash_undefined__",r=9007199254740991,o="[object Arguments]",s="[object Boolean]",a="[object Date]",d="[object Function]",c="[object GeneratorFunction]",l="[object Map]",h="[object Number]",u="[object Object]",p="[object Promise]",m="[object RegExp]",g="[object Set]",f="[object String]",v="[object Symbol]",_="[object WeakMap]",y="[object ArrayBuffer]",E="[object DataView]",S="[object Float32Array]",b="[object Float64Array]",T="[object Int8Array]",C="[object Int16Array]",x="[object Int32Array]",R="[object Uint8Array]",A="[object Uint8ClampedArray]",w="[object Uint16Array]",I="[object Uint32Array]",P=/\\w*$/,D=/^\\[object .+?Constructor\\]$/,O=/^(?:0|[1-9]\\d*)$/,k={};k[o]=k["[object Array]"]=k[y]=k[E]=k[s]=k[a]=k[S]=k[b]=k[T]=k[C]=k[x]=k[l]=k[h]=k[u]=k[m]=k[g]=k[f]=k[v]=k[R]=k[A]=k[w]=k[I]=!0,k["[object Error]"]=k[d]=k[_]=!1;var N="object"==typeof n.g&&n.g&&n.g.Object===Object&&n.g,M="object"==typeof self&&self&&self.Object===Object&&self,L=N||M||Function("return this")(),F=t&&!t.nodeType&&t,j=F&&e&&!e.nodeType&&e,V=j&&j.exports===F;function U(e,t){return e.set(t[0],t[1]),e}function H(e,t){return e.add(t),e}function $(e,t,n,i){var r=-1,o=e?e.length:0;for(i&&o&&(n=e[++r]);++r<o;)n=t(n,e[r],r,e);return n}function J(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"")}catch(e){}return t}function B(e){var t=-1,n=Array(e.size);return e.forEach((function(e,i){n[++t]=[i,e]})),n}function q(e,t){return function(n){return e(t(n))}}function G(e){var t=-1,n=Array(e.size);return e.forEach((function(e){n[++t]=e})),n}var z,K=Array.prototype,W=Function.prototype,X=Object.prototype,Y=L["__core-js_shared__"],Q=(z=/[^.]+$/.exec(Y&&Y.keys&&Y.keys.IE_PROTO||""))?"Symbol(src)_1."+z:"",Z=W.toString,ee=X.hasOwnProperty,te=X.toString,ne=RegExp("^"+Z.call(ee).replace(/[\\\\^$.*+?()[\\]{}|]/g,"\\\\$&").replace(/hasOwnProperty|(function).*?(?=\\\\\\()| for .+?(?=\\\\\\])/g,"$1.*?")+"$"),ie=V?L.Buffer:void 0,re=L.Symbol,oe=L.Uint8Array,se=q(Object.getPrototypeOf,Object),ae=Object.create,de=X.propertyIsEnumerable,ce=K.splice,le=Object.getOwnPropertySymbols,he=ie?ie.isBuffer:void 0,ue=q(Object.keys,Object),pe=Le(L,"DataView"),me=Le(L,"Map"),ge=Le(L,"Promise"),fe=Le(L,"Set"),ve=Le(L,"WeakMap"),_e=Le(Object,"create"),ye=He(pe),Ee=He(me),Se=He(ge),be=He(fe),Te=He(ve),Ce=re?re.prototype:void 0,xe=Ce?Ce.valueOf:void 0;function Re(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function Ae(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function we(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function Ie(e){this.__data__=new Ae(e)}function Pe(e,t,n){var i=e[t];ee.call(e,t)&&$e(i,n)&&(void 0!==n||t in e)||(e[t]=n)}function De(e,t){for(var n=e.length;n--;)if($e(e[n][0],t))return n;return-1}function Oe(e,t,n,i,r,p,_){var D;if(i&&(D=p?i(e,r,p,_):i(e)),void 0!==D)return D;if(!ze(e))return e;var O=Je(e);if(O){if(D=function(e){var t=e.length,n=e.constructor(t);return t&&"string"==typeof e[0]&&ee.call(e,"index")&&(n.index=e.index,n.input=e.input),n}(e),!t)return function(e,t){var n=-1,i=e.length;for(t||(t=Array(i));++n<i;)t[n]=e[n];return t}(e,D)}else{var N=je(e),M=N==d||N==c;if(qe(e))return function(e,t){if(t)return e.slice();var n=new e.constructor(e.length);return e.copy(n),n}(e,t);if(N==u||N==o||M&&!p){if(J(e))return p?e:{};if(D=function(e){return"function"!=typeof e.constructor||Ue(e)?{}:ze(t=se(e))?ae(t):{};var t}(M?{}:e),!t)return function(e,t){return Ne(e,Fe(e),t)}(e,function(e,t){return e&&Ne(t,Ke(t),e)}(D,e))}else{if(!k[N])return p?e:{};D=function(e,t,n,i){var r,o=e.constructor;switch(t){case y:return ke(e);case s:case a:return new o(+e);case E:return function(e,t){var n=t?ke(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.byteLength)}(e,i);case S:case b:case T:case C:case x:case R:case A:case w:case I:return function(e,t){var n=t?ke(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.length)}(e,i);case l:return function(e,t,n){return $(t?n(B(e),!0):B(e),U,new e.constructor)}(e,i,n);case h:case f:return new o(e);case m:return function(e){var t=new e.constructor(e.source,P.exec(e));return t.lastIndex=e.lastIndex,t}(e);case g:return function(e,t,n){return $(t?n(G(e),!0):G(e),H,new e.constructor)}(e,i,n);case v:return r=e,xe?Object(xe.call(r)):{}}}(e,N,Oe,t)}}_||(_=new Ie);var L=_.get(e);if(L)return L;if(_.set(e,D),!O)var F=n?function(e){return function(e,t,n){var i=t(e);return Je(e)?i:function(e,t){for(var n=-1,i=t.length,r=e.length;++n<i;)e[r+n]=t[n];return e}(i,n(e))}(e,Ke,Fe)}(e):Ke(e);return function(e,t){for(var n=-1,i=e?e.length:0;++n<i&&!1!==t(e[n],n););}(F||e,(function(r,o){F&&(r=e[o=r]),Pe(D,o,Oe(r,t,n,i,o,e,_))})),D}function ke(e){var t=new e.constructor(e.byteLength);return new oe(t).set(new oe(e)),t}function Ne(e,t,n,i){n||(n={});for(var r=-1,o=t.length;++r<o;){var s=t[r],a=i?i(n[s],e[s],s,n,e):void 0;Pe(n,s,void 0===a?e[s]:a)}return n}function Me(e,t){var n,i,r=e.__data__;return("string"==(i=typeof(n=t))||"number"==i||"symbol"==i||"boolean"==i?"__proto__"!==n:null===n)?r["string"==typeof t?"string":"hash"]:r.map}function Le(e,t){var n=function(e,t){return null==e?void 0:e[t]}(e,t);return function(e){return!(!ze(e)||(t=e,Q&&Q in t))&&(Ge(e)||J(e)?ne:D).test(He(e));var t}(n)?n:void 0}Re.prototype.clear=function(){this.__data__=_e?_e(null):{}},Re.prototype.delete=function(e){return this.has(e)&&delete this.__data__[e]},Re.prototype.get=function(e){var t=this.__data__;if(_e){var n=t[e];return n===i?void 0:n}return ee.call(t,e)?t[e]:void 0},Re.prototype.has=function(e){var t=this.__data__;return _e?void 0!==t[e]:ee.call(t,e)},Re.prototype.set=function(e,t){return this.__data__[e]=_e&&void 0===t?i:t,this},Ae.prototype.clear=function(){this.__data__=[]},Ae.prototype.delete=function(e){var t=this.__data__,n=De(t,e);return!(n<0||(n==t.length-1?t.pop():ce.call(t,n,1),0))},Ae.prototype.get=function(e){var t=this.__data__,n=De(t,e);return n<0?void 0:t[n][1]},Ae.prototype.has=function(e){return De(this.__data__,e)>-1},Ae.prototype.set=function(e,t){var n=this.__data__,i=De(n,e);return i<0?n.push([e,t]):n[i][1]=t,this},we.prototype.clear=function(){this.__data__={hash:new Re,map:new(me||Ae),string:new Re}},we.prototype.delete=function(e){return Me(this,e).delete(e)},we.prototype.get=function(e){return Me(this,e).get(e)},we.prototype.has=function(e){return Me(this,e).has(e)},we.prototype.set=function(e,t){return Me(this,e).set(e,t),this},Ie.prototype.clear=function(){this.__data__=new Ae},Ie.prototype.delete=function(e){return this.__data__.delete(e)},Ie.prototype.get=function(e){return this.__data__.get(e)},Ie.prototype.has=function(e){return this.__data__.has(e)},Ie.prototype.set=function(e,t){var n=this.__data__;if(n instanceof Ae){var i=n.__data__;if(!me||i.length<199)return i.push([e,t]),this;n=this.__data__=new we(i)}return n.set(e,t),this};var Fe=le?q(le,Object):function(){return[]},je=function(e){return te.call(e)};function Ve(e,t){return!!(t=null==t?r:t)&&("number"==typeof e||O.test(e))&&e>-1&&e%1==0&&e<t}function Ue(e){var t=e&&e.constructor;return e===("function"==typeof t&&t.prototype||X)}function He(e){if(null!=e){try{return Z.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function $e(e,t){return e===t||e!=e&&t!=t}(pe&&je(new pe(new ArrayBuffer(1)))!=E||me&&je(new me)!=l||ge&&je(ge.resolve())!=p||fe&&je(new fe)!=g||ve&&je(new ve)!=_)&&(je=function(e){var t=te.call(e),n=t==u?e.constructor:void 0,i=n?He(n):void 0;if(i)switch(i){case ye:return E;case Ee:return l;case Se:return p;case be:return g;case Te:return _}return t});var Je=Array.isArray;function Be(e){return null!=e&&function(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=r}(e.length)&&!Ge(e)}var qe=he||function(){return!1};function Ge(e){var t=ze(e)?te.call(e):"";return t==d||t==c}function ze(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function Ke(e){return Be(e)?function(e,t){var n=Je(e)||function(e){return function(e){return function(e){return!!e&&"object"==typeof e}(e)&&Be(e)}(e)&&ee.call(e,"callee")&&(!de.call(e,"callee")||te.call(e)==o)}(e)?function(e,t){for(var n=-1,i=Array(e);++n<e;)i[n]=t(n);return i}(e.length,String):[],i=n.length,r=!!i;for(var s in e)!t&&!ee.call(e,s)||r&&("length"==s||Ve(s,i))||n.push(s);return n}(e):function(e){if(!Ue(e))return ue(e);var t=[];for(var n in Object(e))ee.call(e,n)&&"constructor"!=n&&t.push(n);return t}(e)}e.exports=function(e){return Oe(e,!0,!0)}},509:(e,t,n)=>{var i=NaN,r="[object Symbol]",o=/^\\s+|\\s+$/g,s=/^[-+]0x[0-9a-f]+$/i,a=/^0b[01]+$/i,d=/^0o[0-7]+$/i,c=parseInt,l="object"==typeof n.g&&n.g&&n.g.Object===Object&&n.g,h="object"==typeof self&&self&&self.Object===Object&&self,u=l||h||Function("return this")(),p=Object.prototype.toString,m=Math.max,g=Math.min,f=function(){return u.Date.now()};function v(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function _(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&p.call(e)==r}(e))return i;if(v(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=v(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(o,"");var n=a.test(e);return n||d.test(e)?c(e.slice(2),n?2:8):s.test(e)?i:+e}e.exports=function(e,t,n){var i,r,o,s,a,d,c=0,l=!1,h=!1,u=!0;if("function"!=typeof e)throw new TypeError("Expected a function");function p(t){var n=i,o=r;return i=r=void 0,c=t,s=e.apply(o,n)}function y(e){var n=e-d;return void 0===d||n>=t||n<0||h&&e-c>=o}function E(){var e=f();if(y(e))return S(e);a=setTimeout(E,function(e){var n=t-(e-d);return h?g(n,o-(e-c)):n}(e))}function S(e){return a=void 0,u&&i?p(e):(i=r=void 0,s)}function b(){var e=f(),n=y(e);if(i=arguments,r=this,d=e,n){if(void 0===a)return function(e){return c=e,a=setTimeout(E,t),l?p(e):s}(d);if(h)return a=setTimeout(E,t),p(d)}return void 0===a&&(a=setTimeout(E,t)),s}return t=_(t)||0,v(n)&&(l=!!n.leading,o=(h="maxWait"in n)?m(_(n.maxWait)||0,t):o,u="trailing"in n?!!n.trailing:u),b.cancel=function(){void 0!==a&&clearTimeout(a),c=0,i=d=r=a=void 0},b.flush=function(){return void 0===a?s:S(f())},b}},47:(e,t,n)=>{e=n.nmd(e);var i="__lodash_hash_undefined__",r=1,o=2,s=9007199254740991,a="[object Arguments]",d="[object Array]",c="[object AsyncFunction]",l="[object Boolean]",h="[object Date]",u="[object Error]",p="[object Function]",m="[object GeneratorFunction]",g="[object Map]",f="[object Number]",v="[object Null]",_="[object Object]",y="[object Promise]",E="[object Proxy]",S="[object RegExp]",b="[object Set]",T="[object String]",C="[object Symbol]",x="[object Undefined]",R="[object WeakMap]",A="[object ArrayBuffer]",w="[object DataView]",I=/^\\[object .+?Constructor\\]$/,P=/^(?:0|[1-9]\\d*)$/,D={};D["[object Float32Array]"]=D["[object Float64Array]"]=D["[object Int8Array]"]=D["[object Int16Array]"]=D["[object Int32Array]"]=D["[object Uint8Array]"]=D["[object Uint8ClampedArray]"]=D["[object Uint16Array]"]=D["[object Uint32Array]"]=!0,D[a]=D[d]=D[A]=D[l]=D[w]=D[h]=D[u]=D[p]=D[g]=D[f]=D[_]=D[S]=D[b]=D[T]=D[R]=!1;var O="object"==typeof n.g&&n.g&&n.g.Object===Object&&n.g,k="object"==typeof self&&self&&self.Object===Object&&self,N=O||k||Function("return this")(),M=t&&!t.nodeType&&t,L=M&&e&&!e.nodeType&&e,F=L&&L.exports===M,j=F&&O.process,V=function(){try{return j&&j.binding&&j.binding("util")}catch(e){}}(),U=V&&V.isTypedArray;function H(e,t){for(var n=-1,i=null==e?0:e.length;++n<i;)if(t(e[n],n,e))return!0;return!1}function $(e){var t=-1,n=Array(e.size);return e.forEach((function(e,i){n[++t]=[i,e]})),n}function J(e){var t=-1,n=Array(e.size);return e.forEach((function(e){n[++t]=e})),n}var B,q,G,z=Array.prototype,K=Function.prototype,W=Object.prototype,X=N["__core-js_shared__"],Y=K.toString,Q=W.hasOwnProperty,Z=(B=/[^.]+$/.exec(X&&X.keys&&X.keys.IE_PROTO||""))?"Symbol(src)_1."+B:"",ee=W.toString,te=RegExp("^"+Y.call(Q).replace(/[\\\\^$.*+?()[\\]{}|]/g,"\\\\$&").replace(/hasOwnProperty|(function).*?(?=\\\\\\()| for .+?(?=\\\\\\])/g,"$1.*?")+"$"),ne=F?N.Buffer:void 0,ie=N.Symbol,re=N.Uint8Array,oe=W.propertyIsEnumerable,se=z.splice,ae=ie?ie.toStringTag:void 0,de=Object.getOwnPropertySymbols,ce=ne?ne.isBuffer:void 0,le=(q=Object.keys,G=Object,function(e){return q(G(e))}),he=Le(N,"DataView"),ue=Le(N,"Map"),pe=Le(N,"Promise"),me=Le(N,"Set"),ge=Le(N,"WeakMap"),fe=Le(Object,"create"),ve=Ue(he),_e=Ue(ue),ye=Ue(pe),Ee=Ue(me),Se=Ue(ge),be=ie?ie.prototype:void 0,Te=be?be.valueOf:void 0;function Ce(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function xe(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function Re(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function Ae(e){var t=-1,n=null==e?0:e.length;for(this.__data__=new Re;++t<n;)this.add(e[t])}function we(e){var t=this.__data__=new xe(e);this.size=t.size}function Ie(e,t){for(var n=e.length;n--;)if(He(e[n][0],t))return n;return-1}function Pe(e){return null==e?void 0===e?x:v:ae&&ae in Object(e)?function(e){var t=Q.call(e,ae),n=e[ae];try{e[ae]=void 0;var i=!0}catch(e){}var r=ee.call(e);return i&&(t?e[ae]=n:delete e[ae]),r}(e):function(e){return ee.call(e)}(e)}function De(e){return Ke(e)&&Pe(e)==a}function Oe(e,t,n,i,s){return e===t||(null==e||null==t||!Ke(e)&&!Ke(t)?e!=e&&t!=t:function(e,t,n,i,s,c){var p=Je(e),m=Je(t),v=p?d:je(e),y=m?d:je(t),E=(v=v==a?_:v)==_,x=(y=y==a?_:y)==_,R=v==y;if(R&&Be(e)){if(!Be(t))return!1;p=!0,E=!1}if(R&&!E)return c||(c=new we),p||We(e)?ke(e,t,n,i,s,c):function(e,t,n,i,s,a,d){switch(n){case w:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return!1;e=e.buffer,t=t.buffer;case A:return!(e.byteLength!=t.byteLength||!a(new re(e),new re(t)));case l:case h:case f:return He(+e,+t);case u:return e.name==t.name&&e.message==t.message;case S:case T:return e==t+"";case g:var c=$;case b:var p=i&r;if(c||(c=J),e.size!=t.size&&!p)return!1;var m=d.get(e);if(m)return m==t;i|=o,d.set(e,t);var v=ke(c(e),c(t),i,s,a,d);return d.delete(e),v;case C:if(Te)return Te.call(e)==Te.call(t)}return!1}(e,t,v,n,i,s,c);if(!(n&r)){var I=E&&Q.call(e,"__wrapped__"),P=x&&Q.call(t,"__wrapped__");if(I||P){var D=I?e.value():e,O=P?t.value():t;return c||(c=new we),s(D,O,n,i,c)}}return!!R&&(c||(c=new we),function(e,t,n,i,o,s){var a=n&r,d=Ne(e),c=d.length;if(c!=Ne(t).length&&!a)return!1;for(var l=c;l--;){var h=d[l];if(!(a?h in t:Q.call(t,h)))return!1}var u=s.get(e);if(u&&s.get(t))return u==t;var p=!0;s.set(e,t),s.set(t,e);for(var m=a;++l<c;){var g=e[h=d[l]],f=t[h];if(i)var v=a?i(f,g,h,t,e,s):i(g,f,h,e,t,s);if(!(void 0===v?g===f||o(g,f,n,i,s):v)){p=!1;break}m||(m="constructor"==h)}if(p&&!m){var _=e.constructor,y=t.constructor;_==y||!("constructor"in e)||!("constructor"in t)||"function"==typeof _&&_ instanceof _&&"function"==typeof y&&y instanceof y||(p=!1)}return s.delete(e),s.delete(t),p}(e,t,n,i,s,c))}(e,t,n,i,Oe,s))}function ke(e,t,n,i,s,a){var d=n&r,c=e.length,l=t.length;if(c!=l&&!(d&&l>c))return!1;var h=a.get(e);if(h&&a.get(t))return h==t;var u=-1,p=!0,m=n&o?new Ae:void 0;for(a.set(e,t),a.set(t,e);++u<c;){var g=e[u],f=t[u];if(i)var v=d?i(f,g,u,t,e,a):i(g,f,u,e,t,a);if(void 0!==v){if(v)continue;p=!1;break}if(m){if(!H(t,(function(e,t){if(r=t,!m.has(r)&&(g===e||s(g,e,n,i,a)))return m.push(t);var r}))){p=!1;break}}else if(g!==f&&!s(g,f,n,i,a)){p=!1;break}}return a.delete(e),a.delete(t),p}function Ne(e){return function(e,t,n){var i=t(e);return Je(e)?i:function(e,t){for(var n=-1,i=t.length,r=e.length;++n<i;)e[r+n]=t[n];return e}(i,n(e))}(e,Xe,Fe)}function Me(e,t){var n,i,r=e.__data__;return("string"==(i=typeof(n=t))||"number"==i||"symbol"==i||"boolean"==i?"__proto__"!==n:null===n)?r["string"==typeof t?"string":"hash"]:r.map}function Le(e,t){var n=function(e,t){return null==e?void 0:e[t]}(e,t);return function(e){return!(!ze(e)||function(e){return!!Z&&Z in e}(e))&&(qe(e)?te:I).test(Ue(e))}(n)?n:void 0}Ce.prototype.clear=function(){this.__data__=fe?fe(null):{},this.size=0},Ce.prototype.delete=function(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t},Ce.prototype.get=function(e){var t=this.__data__;if(fe){var n=t[e];return n===i?void 0:n}return Q.call(t,e)?t[e]:void 0},Ce.prototype.has=function(e){var t=this.__data__;return fe?void 0!==t[e]:Q.call(t,e)},Ce.prototype.set=function(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=fe&&void 0===t?i:t,this},xe.prototype.clear=function(){this.__data__=[],this.size=0},xe.prototype.delete=function(e){var t=this.__data__,n=Ie(t,e);return!(n<0||(n==t.length-1?t.pop():se.call(t,n,1),--this.size,0))},xe.prototype.get=function(e){var t=this.__data__,n=Ie(t,e);return n<0?void 0:t[n][1]},xe.prototype.has=function(e){return Ie(this.__data__,e)>-1},xe.prototype.set=function(e,t){var n=this.__data__,i=Ie(n,e);return i<0?(++this.size,n.push([e,t])):n[i][1]=t,this},Re.prototype.clear=function(){this.size=0,this.__data__={hash:new Ce,map:new(ue||xe),string:new Ce}},Re.prototype.delete=function(e){var t=Me(this,e).delete(e);return this.size-=t?1:0,t},Re.prototype.get=function(e){return Me(this,e).get(e)},Re.prototype.has=function(e){return Me(this,e).has(e)},Re.prototype.set=function(e,t){var n=Me(this,e),i=n.size;return n.set(e,t),this.size+=n.size==i?0:1,this},Ae.prototype.add=Ae.prototype.push=function(e){return this.__data__.set(e,i),this},Ae.prototype.has=function(e){return this.__data__.has(e)},we.prototype.clear=function(){this.__data__=new xe,this.size=0},we.prototype.delete=function(e){var t=this.__data__,n=t.delete(e);return this.size=t.size,n},we.prototype.get=function(e){return this.__data__.get(e)},we.prototype.has=function(e){return this.__data__.has(e)},we.prototype.set=function(e,t){var n=this.__data__;if(n instanceof xe){var i=n.__data__;if(!ue||i.length<199)return i.push([e,t]),this.size=++n.size,this;n=this.__data__=new Re(i)}return n.set(e,t),this.size=n.size,this};var Fe=de?function(e){return null==e?[]:(e=Object(e),function(t,n){for(var i=-1,r=null==t?0:t.length,o=0,s=[];++i<r;){var a=t[i];d=a,oe.call(e,d)&&(s[o++]=a)}var d;return s}(de(e)))}:function(){return[]},je=Pe;function Ve(e,t){return!!(t=null==t?s:t)&&("number"==typeof e||P.test(e))&&e>-1&&e%1==0&&e<t}function Ue(e){if(null!=e){try{return Y.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function He(e,t){return e===t||e!=e&&t!=t}(he&&je(new he(new ArrayBuffer(1)))!=w||ue&&je(new ue)!=g||pe&&je(pe.resolve())!=y||me&&je(new me)!=b||ge&&je(new ge)!=R)&&(je=function(e){var t=Pe(e),n=t==_?e.constructor:void 0,i=n?Ue(n):"";if(i)switch(i){case ve:return w;case _e:return g;case ye:return y;case Ee:return b;case Se:return R}return t});var $e=De(function(){return arguments}())?De:function(e){return Ke(e)&&Q.call(e,"callee")&&!oe.call(e,"callee")},Je=Array.isArray,Be=ce||function(){return!1};function qe(e){if(!ze(e))return!1;var t=Pe(e);return t==p||t==m||t==c||t==E}function Ge(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=s}function ze(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}function Ke(e){return null!=e&&"object"==typeof e}var We=U?function(e){return function(t){return e(t)}}(U):function(e){return Ke(e)&&Ge(e.length)&&!!D[Pe(e)]};function Xe(e){return null!=(t=e)&&Ge(t.length)&&!qe(t)?function(e,t){var n=Je(e),i=!n&&$e(e),r=!n&&!i&&Be(e),o=!n&&!i&&!r&&We(e),s=n||i||r||o,a=s?function(e,t){for(var n=-1,i=Array(e);++n<e;)i[n]=t(n);return i}(e.length,String):[],d=a.length;for(var c in e)!t&&!Q.call(e,c)||s&&("length"==c||r&&("offset"==c||"parent"==c)||o&&("buffer"==c||"byteLength"==c||"byteOffset"==c)||Ve(c,d))||a.push(c);return a}(e):function(e){if(n=(t=e)&&t.constructor,t!==("function"==typeof n&&n.prototype||W))return le(e);var t,n,i=[];for(var r in Object(e))Q.call(e,r)&&"constructor"!=r&&i.push(r);return i}(e);var t}e.exports=function(e,t){return Oe(e,t)}},296:e=>{var t=e.exports={v:[{name:"version",reg:/^(\\d*)$/}],o:[{name:"origin",reg:/^(\\S*) (\\d*) (\\d*) (\\S*) IP(\\d) (\\S*)/,names:["username","sessionId","sessionVersion","netType","ipVer","address"],format:"%s %s %d %s IP%d %s"}],s:[{name:"name"}],i:[{name:"description"}],u:[{name:"uri"}],e:[{name:"email"}],p:[{name:"phone"}],z:[{name:"timezones"}],r:[{name:"repeats"}],t:[{name:"timing",reg:/^(\\d*) (\\d*)/,names:["start","stop"],format:"%d %d"}],c:[{name:"connection",reg:/^IN IP(\\d) (\\S*)/,names:["version","ip"],format:"IN IP%d %s"}],b:[{push:"bandwidth",reg:/^(TIAS|AS|CT|RR|RS):(\\d*)/,names:["type","limit"],format:"%s:%s"}],m:[{reg:/^(\\w*) (\\d*) ([\\w\\/]*)(?: (.*))?/,names:["type","port","protocol","payloads"],format:"%s %d %s %s"}],a:[{push:"rtp",reg:/^rtpmap:(\\d*) ([\\w\\-\\.]*)(?:\\s*\\/(\\d*)(?:\\s*\\/(\\S*))?)?/,names:["payload","codec","rate","encoding"],format:function(e){return e.encoding?"rtpmap:%d %s/%s/%s":e.rate?"rtpmap:%d %s/%s":"rtpmap:%d %s"}},{push:"fmtp",reg:/^fmtp:(\\d*) ([\\S| ]*)/,names:["payload","config"],format:"fmtp:%d %s"},{name:"control",reg:/^control:(.*)/,format:"control:%s"},{name:"rtcp",reg:/^rtcp:(\\d*)(?: (\\S*) IP(\\d) (\\S*))?/,names:["port","netType","ipVer","address"],format:function(e){return null!=e.address?"rtcp:%d %s IP%d %s":"rtcp:%d"}},{push:"rtcpFbTrrInt",reg:/^rtcp-fb:(\\*|\\d*) trr-int (\\d*)/,names:["payload","value"],format:"rtcp-fb:%d trr-int %d"},{push:"rtcpFb",reg:/^rtcp-fb:(\\*|\\d*) ([\\w-_]*)(?: ([\\w-_]*))?/,names:["payload","type","subtype"],format:function(e){return null!=e.subtype?"rtcp-fb:%s %s %s":"rtcp-fb:%s %s"}},{push:"ext",reg:/^extmap:(\\d+)(?:\\/(\\w+))? (\\S*)(?: (\\S*))?/,names:["value","direction","uri","config"],format:function(e){return"extmap:%d"+(e.direction?"/%s":"%v")+" %s"+(e.config?" %s":"")}},{push:"crypto",reg:/^crypto:(\\d*) ([\\w_]*) (\\S*)(?: (\\S*))?/,names:["id","suite","config","sessionConfig"],format:function(e){return null!=e.sessionConfig?"crypto:%d %s %s %s":"crypto:%d %s %s"}},{name:"setup",reg:/^setup:(\\w*)/,format:"setup:%s"},{name:"mid",reg:/^mid:([^\\s]*)/,format:"mid:%s"},{name:"msid",reg:/^msid:(.*)/,format:"msid:%s"},{name:"ptime",reg:/^ptime:(\\d*)/,format:"ptime:%d"},{name:"maxptime",reg:/^maxptime:(\\d*)/,format:"maxptime:%d"},{name:"direction",reg:/^(sendrecv|recvonly|sendonly|inactive)/},{name:"icelite",reg:/^(ice-lite)/},{name:"iceUfrag",reg:/^ice-ufrag:(\\S*)/,format:"ice-ufrag:%s"},{name:"icePwd",reg:/^ice-pwd:(\\S*)/,format:"ice-pwd:%s"},{name:"fingerprint",reg:/^fingerprint:(\\S*) (\\S*)/,names:["type","hash"],format:"fingerprint:%s %s"},{push:"candidates",reg:/^candidate:(\\S*) (\\d*) (\\S*) (\\d*) (\\S*) (\\d*) typ (\\S*)(?: raddr (\\S*) rport (\\d*))?(?: tcptype (\\S*))?(?: generation (\\d*))?(?: network-id (\\d*))?(?: network-cost (\\d*))?/,names:["foundation","component","transport","priority","ip","port","type","raddr","rport","tcptype","generation","network-id","network-cost"],format:function(e){var t="candidate:%s %d %s %d %s %d typ %s";return t+=null!=e.raddr?" raddr %s rport %d":"%v%v",t+=null!=e.tcptype?" tcptype %s":"%v",null!=e.generation&&(t+=" generation %d"),(t+=null!=e["network-id"]?" network-id %d":"%v")+(null!=e["network-cost"]?" network-cost %d":"%v")}},{name:"endOfCandidates",reg:/^(end-of-candidates)/},{name:"remoteCandidates",reg:/^remote-candidates:(.*)/,format:"remote-candidates:%s"},{name:"iceOptions",reg:/^ice-options:(\\S*)/,format:"ice-options:%s"},{push:"ssrcs",reg:/^ssrc:(\\d*) ([\\w_]*)(?::(.*))?/,names:["id","attribute","value"],format:function(e){var t="ssrc:%d";return null!=e.attribute&&(t+=" %s",null!=e.value&&(t+=":%s")),t}},{push:"ssrcGroups",reg:/^ssrc-group:([\\x21\\x23\\x24\\x25\\x26\\x27\\x2A\\x2B\\x2D\\x2E\\w]*) (.*)/,names:["semantics","ssrcs"],format:"ssrc-group:%s %s"},{name:"msidSemantic",reg:/^msid-semantic:\\s?(\\w*) (\\S*)/,names:["semantic","token"],format:"msid-semantic: %s %s"},{push:"groups",reg:/^group:(\\w*) (.*)/,names:["type","mids"],format:"group:%s %s"},{name:"rtcpMux",reg:/^(rtcp-mux)/},{name:"rtcpRsize",reg:/^(rtcp-rsize)/},{name:"sctpmap",reg:/^sctpmap:([\\w_\\/]*) (\\S*)(?: (\\S*))?/,names:["sctpmapNumber","app","maxMessageSize"],format:function(e){return null!=e.maxMessageSize?"sctpmap:%s %s %s":"sctpmap:%s %s"}},{name:"xGoogleFlag",reg:/^x-google-flag:([^\\s]*)/,format:"x-google-flag:%s"},{push:"rids",reg:/^rid:([\\d\\w]+) (\\w+)(?: ([\\S| ]*))?/,names:["id","direction","params"],format:function(e){return e.params?"rid:%s %s %s":"rid:%s %s"}},{push:"imageattrs",reg:new RegExp("^imageattr:(\\\\d+|\\\\*)[\\\\s\\\\t]+(send|recv)[\\\\s\\\\t]+(\\\\*|\\\\[\\\\S+\\\\](?:[\\\\s\\\\t]+\\\\[\\\\S+\\\\])*)(?:[\\\\s\\\\t]+(recv|send)[\\\\s\\\\t]+(\\\\*|\\\\[\\\\S+\\\\](?:[\\\\s\\\\t]+\\\\[\\\\S+\\\\])*))?"),names:["pt","dir1","attrs1","dir2","attrs2"],format:function(e){return"imageattr:%s %s %s"+(e.dir2?" %s %s":"")}},{name:"simulcast",reg:new RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\\\-_~;,]+)(?:\\\\s?(send|recv) ([a-zA-Z0-9\\\\-_~;,]+))?$"),names:["dir1","list1","dir2","list2"],format:function(e){return"simulcast:%s %s"+(e.dir2?" %s %s":"")}},{name:"simulcast_03",reg:/^simulcast:[\\s\\t]+([\\S+\\s\\t]+)$/,names:["value"],format:"simulcast: %s"},{name:"framerate",reg:/^framerate:(\\d+(?:$|\\.\\d+))/,format:"framerate:%s"},{push:"invalid",names:["value"]}]};Object.keys(t).forEach((function(e){t[e].forEach((function(e){e.reg||(e.reg=/(.*)/),e.format||(e.format="%s")}))}))},310:(e,t,n)=>{var i=n(415),r=n(159);t.write=r,t.parse=i.parse,t.parseFmtpConfig=i.parseFmtpConfig,t.parseParams=i.parseParams,t.parsePayloads=i.parsePayloads,t.parseRemoteCandidates=i.parseRemoteCandidates,t.parseImageAttributes=i.parseImageAttributes,t.parseSimulcastStreamList=i.parseSimulcastStreamList},415:(e,t,n)=>{var i=function(e){return String(Number(e))===e?Number(e):e},r=function(e,t,n){var r=e.name&&e.names;e.push&&!t[e.push]?t[e.push]=[]:r&&!t[e.name]&&(t[e.name]={});var o=e.push?{}:r?t[e.name]:t;!function(e,t,n,r){if(r&&!n)t[r]=i(e[1]);else for(var o=0;o<n.length;o+=1)null!=e[o+1]&&(t[n[o]]=i(e[o+1]))}(n.match(e.reg),o,e.names,e.name),e.push&&t[e.push].push(o)},o=n(296),s=RegExp.prototype.test.bind(/^([a-z])=(.*)/);t.parse=function(e){var t={},n=[],i=t;return e.split(/(\\r\\n|\\r|\\n)/).filter(s).forEach((function(e){var t=e[0],s=e.slice(2);"m"===t&&(n.push({rtp:[],fmtp:[]}),i=n[n.length-1]);for(var a=0;a<(o[t]||[]).length;a+=1){var d=o[t][a];if(d.reg.test(s))return r(d,i,s)}})),t.media=n,t};var a=function(e,t){var n=t.split(/=(.+)/,2);return 2===n.length&&(e[n[0]]=i(n[1])),e};t.parseParams=function(e){return e.split(/\\;\\s?/).reduce(a,{})},t.parseFmtpConfig=t.parseParams,t.parsePayloads=function(e){return e.split(" ").map(Number)},t.parseRemoteCandidates=function(e){for(var t=[],n=e.split(" ").map(i),r=0;r<n.length;r+=3)t.push({component:n[r],ip:n[r+1],port:n[r+2]});return t},t.parseImageAttributes=function(e){return e.split(" ").map((function(e){return e.substring(1,e.length-1).split(",").reduce(a,{})}))},t.parseSimulcastStreamList=function(e){return e.split(";").map((function(e){return e.split(",").map((function(e){var t,n=!1;return"~"!==e[0]?t=i(e):(t=i(e.substring(1,e.length)),n=!0),{scid:t,paused:n}}))}))}},159:(e,t,n)=>{var i=n(296),r=/%[sdv%]/g,o=function(e){var t=1,n=arguments,i=n.length;return e.replace(r,(function(e){if(t>=i)return e;var r=n[t];switch(t+=1,e){case"%%":return"%";case"%s":return String(r);case"%d":return Number(r);case"%v":return""}}))},s=function(e,t,n){var i=[e+"="+(t.format instanceof Function?t.format(t.push?n:n[t.name]):t.format)];if(t.names)for(var r=0;r<t.names.length;r+=1){var s=t.names[r];t.name?i.push(n[t.name][s]):i.push(n[t.names[r]])}else i.push(n[t.name]);return o.apply(null,i)},a=["v","o","s","i","u","e","p","c","b","t","r","z","a"],d=["i","c","b","a"];e.exports=function(e,t){t=t||{},null==e.version&&(e.version=0),null==e.name&&(e.name=" "),e.media.forEach((function(e){null==e.payloads&&(e.payloads="")}));var n=t.outerOrder||a,r=t.innerOrder||d,o=[];return n.forEach((function(t){i[t].forEach((function(n){n.name in e&&null!=e[n.name]?o.push(s(t,n,e)):n.push in e&&null!=e[n.push]&&e[n.push].forEach((function(e){o.push(s(t,n,e))}))}))})),e.media.forEach((function(e){o.push(s("m",i.m[0],e)),r.forEach((function(t){i[t].forEach((function(n){n.name in e&&null!=e[n.name]?o.push(s(t,n,e)):n.push in e&&null!=e[n.push]&&e[n.push].forEach((function(e){o.push(s(t,n,e))}))}))}))})),o.join("\\r\\n")+"\\r\\n"}},483:e=>{"use strict";const t={generateIdentifier:function(){return Math.random().toString(36).substr(2,10)}};t.localCName=t.generateIdentifier(),t.splitLines=function(e){return e.trim().split("\\n").map((e=>e.trim()))},t.splitSections=function(e){return e.split("\\nm=").map(((e,t)=>(t>0?"m="+e:e).trim()+"\\r\\n"))},t.getDescription=function(e){const n=t.splitSections(e);return n&&n[0]},t.getMediaSections=function(e){const n=t.splitSections(e);return n.shift(),n},t.matchPrefix=function(e,n){return t.splitLines(e).filter((e=>0===e.indexOf(n)))},t.parseCandidate=function(e){let t;t=0===e.indexOf("a=candidate:")?e.substring(12).split(" "):e.substring(10).split(" ");const n={foundation:t[0],component:{1:"rtp",2:"rtcp"}[t[1]]||t[1],protocol:t[2].toLowerCase(),priority:parseInt(t[3],10),ip:t[4],address:t[4],port:parseInt(t[5],10),type:t[7]};for(let e=8;e<t.length;e+=2)switch(t[e]){case"raddr":n.relatedAddress=t[e+1];break;case"rport":n.relatedPort=parseInt(t[e+1],10);break;case"tcptype":n.tcpType=t[e+1];break;case"ufrag":n.ufrag=t[e+1],n.usernameFragment=t[e+1];break;default:void 0===n[t[e]]&&(n[t[e]]=t[e+1])}return n},t.writeCandidate=function(e){const t=[];t.push(e.foundation);const n=e.component;"rtp"===n?t.push(1):"rtcp"===n?t.push(2):t.push(n),t.push(e.protocol.toUpperCase()),t.push(e.priority),t.push(e.address||e.ip),t.push(e.port);const i=e.type;return t.push("typ"),t.push(i),"host"!==i&&e.relatedAddress&&e.relatedPort&&(t.push("raddr"),t.push(e.relatedAddress),t.push("rport"),t.push(e.relatedPort)),e.tcpType&&"tcp"===e.protocol.toLowerCase()&&(t.push("tcptype"),t.push(e.tcpType)),(e.usernameFragment||e.ufrag)&&(t.push("ufrag"),t.push(e.usernameFragment||e.ufrag)),"candidate:"+t.join(" ")},t.parseIceOptions=function(e){return e.substr(14).split(" ")},t.parseRtpMap=function(e){let t=e.substr(9).split(" ");const n={payloadType:parseInt(t.shift(),10)};return t=t[0].split("/"),n.name=t[0],n.clockRate=parseInt(t[1],10),n.channels=3===t.length?parseInt(t[2],10):1,n.numChannels=n.channels,n},t.writeRtpMap=function(e){let t=e.payloadType;void 0!==e.preferredPayloadType&&(t=e.preferredPayloadType);const n=e.channels||e.numChannels||1;return"a=rtpmap:"+t+" "+e.name+"/"+e.clockRate+(1!==n?"/"+n:"")+"\\r\\n"},t.parseExtmap=function(e){const t=e.substr(9).split(" ");return{id:parseInt(t[0],10),direction:t[0].indexOf("/")>0?t[0].split("/")[1]:"sendrecv",uri:t[1]}},t.writeExtmap=function(e){return"a=extmap:"+(e.id||e.preferredId)+(e.direction&&"sendrecv"!==e.direction?"/"+e.direction:"")+" "+e.uri+"\\r\\n"},t.parseFmtp=function(e){const t={};let n;const i=e.substr(e.indexOf(" ")+1).split(";");for(let e=0;e<i.length;e++)n=i[e].trim().split("="),t[n[0].trim()]=n[1];return t},t.writeFmtp=function(e){let t="",n=e.payloadType;if(void 0!==e.preferredPayloadType&&(n=e.preferredPayloadType),e.parameters&&Object.keys(e.parameters).length){const i=[];Object.keys(e.parameters).forEach((t=>{void 0!==e.parameters[t]?i.push(t+"="+e.parameters[t]):i.push(t)})),t+="a=fmtp:"+n+" "+i.join(";")+"\\r\\n"}return t},t.parseRtcpFb=function(e){const t=e.substr(e.indexOf(" ")+1).split(" ");return{type:t.shift(),parameter:t.join(" ")}},t.writeRtcpFb=function(e){let t="",n=e.payloadType;return void 0!==e.preferredPayloadType&&(n=e.preferredPayloadType),e.rtcpFeedback&&e.rtcpFeedback.length&&e.rtcpFeedback.forEach((e=>{t+="a=rtcp-fb:"+n+" "+e.type+(e.parameter&&e.parameter.length?" "+e.parameter:"")+"\\r\\n"})),t},t.parseSsrcMedia=function(e){const t=e.indexOf(" "),n={ssrc:parseInt(e.substr(7,t-7),10)},i=e.indexOf(":",t);return i>-1?(n.attribute=e.substr(t+1,i-t-1),n.value=e.substr(i+1)):n.attribute=e.substr(t+1),n},t.parseSsrcGroup=function(e){const t=e.substr(13).split(" ");return{semantics:t.shift(),ssrcs:t.map((e=>parseInt(e,10)))}},t.getMid=function(e){const n=t.matchPrefix(e,"a=mid:")[0];if(n)return n.substr(6)},t.parseFingerprint=function(e){const t=e.substr(14).split(" ");return{algorithm:t[0].toLowerCase(),value:t[1].toUpperCase()}},t.getDtlsParameters=function(e,n){return{role:"auto",fingerprints:t.matchPrefix(e+n,"a=fingerprint:").map(t.parseFingerprint)}},t.writeDtlsParameters=function(e,t){let n="a=setup:"+t+"\\r\\n";return e.fingerprints.forEach((e=>{n+="a=fingerprint:"+e.algorithm+" "+e.value+"\\r\\n"})),n},t.parseCryptoLine=function(e){const t=e.substr(9).split(" ");return{tag:parseInt(t[0],10),cryptoSuite:t[1],keyParams:t[2],sessionParams:t.slice(3)}},t.writeCryptoLine=function(e){return"a=crypto:"+e.tag+" "+e.cryptoSuite+" "+("object"==typeof e.keyParams?t.writeCryptoKeyParams(e.keyParams):e.keyParams)+(e.sessionParams?" "+e.sessionParams.join(" "):"")+"\\r\\n"},t.parseCryptoKeyParams=function(e){if(0!==e.indexOf("inline:"))return null;const t=e.substr(7).split("|");return{keyMethod:"inline",keySalt:t[0],lifeTime:t[1],mkiValue:t[2]?t[2].split(":")[0]:void 0,mkiLength:t[2]?t[2].split(":")[1]:void 0}},t.writeCryptoKeyParams=function(e){return e.keyMethod+":"+e.keySalt+(e.lifeTime?"|"+e.lifeTime:"")+(e.mkiValue&&e.mkiLength?"|"+e.mkiValue+":"+e.mkiLength:"")},t.getCryptoParameters=function(e,n){return t.matchPrefix(e+n,"a=crypto:").map(t.parseCryptoLine)},t.getIceParameters=function(e,n){const i=t.matchPrefix(e+n,"a=ice-ufrag:")[0],r=t.matchPrefix(e+n,"a=ice-pwd:")[0];return i&&r?{usernameFragment:i.substr(12),password:r.substr(10)}:null},t.writeIceParameters=function(e){let t="a=ice-ufrag:"+e.usernameFragment+"\\r\\na=ice-pwd:"+e.password+"\\r\\n";return e.iceLite&&(t+="a=ice-lite\\r\\n"),t},t.parseRtpParameters=function(e){const n={codecs:[],headerExtensions:[],fecMechanisms:[],rtcp:[]},i=t.splitLines(e)[0].split(" ");for(let r=3;r<i.length;r++){const o=i[r],s=t.matchPrefix(e,"a=rtpmap:"+o+" ")[0];if(s){const i=t.parseRtpMap(s),r=t.matchPrefix(e,"a=fmtp:"+o+" ");switch(i.parameters=r.length?t.parseFmtp(r[0]):{},i.rtcpFeedback=t.matchPrefix(e,"a=rtcp-fb:"+o+" ").map(t.parseRtcpFb),n.codecs.push(i),i.name.toUpperCase()){case"RED":case"ULPFEC":n.fecMechanisms.push(i.name.toUpperCase())}}}return t.matchPrefix(e,"a=extmap:").forEach((e=>{n.headerExtensions.push(t.parseExtmap(e))})),n},t.writeRtpDescription=function(e,n){let i="";i+="m="+e+" ",i+=n.codecs.length>0?"9":"0",i+=" UDP/TLS/RTP/SAVPF ",i+=n.codecs.map((e=>void 0!==e.preferredPayloadType?e.preferredPayloadType:e.payloadType)).join(" ")+"\\r\\n",i+="c=IN IP4 0.0.0.0\\r\\n",i+="a=rtcp:9 IN IP4 0.0.0.0\\r\\n",n.codecs.forEach((e=>{i+=t.writeRtpMap(e),i+=t.writeFmtp(e),i+=t.writeRtcpFb(e)}));let r=0;return n.codecs.forEach((e=>{e.maxptime>r&&(r=e.maxptime)})),r>0&&(i+="a=maxptime:"+r+"\\r\\n"),n.headerExtensions&&n.headerExtensions.forEach((e=>{i+=t.writeExtmap(e)})),i},t.parseRtpEncodingParameters=function(e){const n=[],i=t.parseRtpParameters(e),r=-1!==i.fecMechanisms.indexOf("RED"),o=-1!==i.fecMechanisms.indexOf("ULPFEC"),s=t.matchPrefix(e,"a=ssrc:").map((e=>t.parseSsrcMedia(e))).filter((e=>"cname"===e.attribute)),a=s.length>0&&s[0].ssrc;let d;const c=t.matchPrefix(e,"a=ssrc-group:FID").map((e=>e.substr(17).split(" ").map((e=>parseInt(e,10)))));c.length>0&&c[0].length>1&&c[0][0]===a&&(d=c[0][1]),i.codecs.forEach((e=>{if("RTX"===e.name.toUpperCase()&&e.parameters.apt){let t={ssrc:a,codecPayloadType:parseInt(e.parameters.apt,10)};a&&d&&(t.rtx={ssrc:d}),n.push(t),r&&(t=JSON.parse(JSON.stringify(t)),t.fec={ssrc:a,mechanism:o?"red+ulpfec":"red"},n.push(t))}})),0===n.length&&a&&n.push({ssrc:a});let l=t.matchPrefix(e,"b=");return l.length&&(l=0===l[0].indexOf("b=TIAS:")?parseInt(l[0].substr(7),10):0===l[0].indexOf("b=AS:")?1e3*parseInt(l[0].substr(5),10)*.95-16e3:void 0,n.forEach((e=>{e.maxBitrate=l}))),n},t.parseRtcpParameters=function(e){const n={},i=t.matchPrefix(e,"a=ssrc:").map((e=>t.parseSsrcMedia(e))).filter((e=>"cname"===e.attribute))[0];i&&(n.cname=i.value,n.ssrc=i.ssrc);const r=t.matchPrefix(e,"a=rtcp-rsize");n.reducedSize=r.length>0,n.compound=0===r.length;const o=t.matchPrefix(e,"a=rtcp-mux");return n.mux=o.length>0,n},t.writeRtcpParameters=function(e){let t="";return e.reducedSize&&(t+="a=rtcp-rsize\\r\\n"),e.mux&&(t+="a=rtcp-mux\\r\\n"),void 0!==e.ssrc&&e.cname&&(t+="a=ssrc:"+e.ssrc+" cname:"+e.cname+"\\r\\n"),t},t.parseMsid=function(e){let n;const i=t.matchPrefix(e,"a=msid:");if(1===i.length)return n=i[0].substr(7).split(" "),{stream:n[0],track:n[1]};const r=t.matchPrefix(e,"a=ssrc:").map((e=>t.parseSsrcMedia(e))).filter((e=>"msid"===e.attribute));return r.length>0?(n=r[0].value.split(" "),{stream:n[0],track:n[1]}):void 0},t.parseSctpDescription=function(e){const n=t.parseMLine(e),i=t.matchPrefix(e,"a=max-message-size:");let r;i.length>0&&(r=parseInt(i[0].substr(19),10)),isNaN(r)&&(r=65536);const o=t.matchPrefix(e,"a=sctp-port:");if(o.length>0)return{port:parseInt(o[0].substr(12),10),protocol:n.fmt,maxMessageSize:r};const s=t.matchPrefix(e,"a=sctpmap:");if(s.length>0){const e=s[0].substr(10).split(" ");return{port:parseInt(e[0],10),protocol:e[1],maxMessageSize:r}}},t.writeSctpDescription=function(e,t){let n=[];return n="DTLS/SCTP"!==e.protocol?["m="+e.kind+" 9 "+e.protocol+" "+t.protocol+"\\r\\n","c=IN IP4 0.0.0.0\\r\\n","a=sctp-port:"+t.port+"\\r\\n"]:["m="+e.kind+" 9 "+e.protocol+" "+t.port+"\\r\\n","c=IN IP4 0.0.0.0\\r\\n","a=sctpmap:"+t.port+" "+t.protocol+" 65535\\r\\n"],void 0!==t.maxMessageSize&&n.push("a=max-message-size:"+t.maxMessageSize+"\\r\\n"),n.join("")},t.generateSessionId=function(){return Math.random().toString().substr(2,21)},t.writeSessionBoilerplate=function(e,n,i){let r;const o=void 0!==n?n:2;return r=e||t.generateSessionId(),"v=0\\r\\no="+(i||"thisisadapterortc")+" "+r+" "+o+" IN IP4 127.0.0.1\\r\\ns=-\\r\\nt=0 0\\r\\n"},t.getDirection=function(e,n){const i=t.splitLines(e);for(let e=0;e<i.length;e++)switch(i[e]){case"a=sendrecv":case"a=sendonly":case"a=recvonly":case"a=inactive":return i[e].substr(2)}return n?t.getDirection(n):"sendrecv"},t.getKind=function(e){return t.splitLines(e)[0].split(" ")[0].substr(2)},t.isRejected=function(e){return"0"===e.split(" ",2)[1]},t.parseMLine=function(e){const n=t.splitLines(e)[0].substr(2).split(" ");return{kind:n[0],port:parseInt(n[1],10),protocol:n[2],fmt:n.slice(3).join(" ")}},t.parseOLine=function(e){const n=t.matchPrefix(e,"o=")[0].substr(2).split(" ");return{username:n[0],sessionId:n[1],sessionVersion:parseInt(n[2],10),netType:n[3],addressType:n[4],address:n[5]}},t.isValidSDP=function(e){if("string"!=typeof e||0===e.length)return!1;const n=t.splitLines(e);for(let e=0;e<n.length;e++)if(n[e].length<2||"="!==n[e].charAt(1))return!1;return!0},e.exports=t},33:function(e,t,n){!function(e){"use strict";var t=void 0!==n.g?n.g:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{};const i=function(){let e=t.WebSocket;if(void 0===e)try{e=n(Object(function(){var e=new Error("Cannot find module \'ws\'");throw e.code="MODULE_NOT_FOUND",e}()))}catch(e){throw new Error(\'You must install the "ws" package to use Strophe in nodejs.\')}return e}();const r=function(){let e=t.DOMParser;if(void 0===e)try{e=Object(function(){var e=new Error("Cannot find module \'@xmldom/xmldom\'");throw e.code="MODULE_NOT_FOUND",e}())}catch(e){throw new Error(\'You must install the "@xmldom/xmldom" package to use Strophe in nodejs.\')}return e}();function o(){if("undefined"==typeof document)try{return(new(Object(function(){var e=new Error("Cannot find module \'@xmldom/xmldom\'");throw e.code="MODULE_NOT_FOUND",e}()))).createDocument("jabber:client","strophe",null)}catch(e){throw new Error(\'You must install the "@xmldom/xmldom" package to use Strophe in nodejs.\')}if(void 0===document.implementation.createDocument||document.implementation.createDocument&&document.documentMode&&document.documentMode<10){const e=function(){const e=["Msxml2.DOMDocument.6.0","Msxml2.DOMDocument.5.0","Msxml2.DOMDocument.4.0","MSXML2.DOMDocument.3.0","MSXML2.DOMDocument","MSXML.DOMDocument","Microsoft.XMLDOM"];for(let t=0;t<e.length;t++)try{return new ActiveXObject(e[t])}catch(e){}}();return e.appendChild(e.createElement("strophe")),e}return document.implementation.createDocument("jabber:client","strophe",null)}const s=function(e,t){const n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n},a=function(e){if("string"!=typeof e)throw new Error("str2binl was passed a non-string");const t=[];for(let n=0;n<8*e.length;n+=8)t[n>>5]|=(255&e.charCodeAt(n/8))<<n%32;return t},d=function(e,t,n,i,r,o){return s((a=s(s(t,e),s(i,o)))<<(d=r)|a>>>32-d,n);var a,d},c=function(e,t,n,i,r,o,s){return d(t&n|~t&i,e,t,r,o,s)},l=function(e,t,n,i,r,o,s){return d(t&i|n&~i,e,t,r,o,s)},h=function(e,t,n,i,r,o,s){return d(t^n^i,e,t,r,o,s)},u=function(e,t,n,i,r,o,s){return d(n^(t|~i),e,t,r,o,s)},p=function(e,t){e[t>>5]|=128<<t%32,e[14+(t+64>>>9<<4)]=t;let n,i,r,o,a=1732584193,d=-271733879,p=-1732584194,m=271733878;for(let t=0;t<e.length;t+=16)n=a,i=d,r=p,o=m,a=c(a,d,p,m,e[t+0],7,-680876936),m=c(m,a,d,p,e[t+1],12,-389564586),p=c(p,m,a,d,e[t+2],17,606105819),d=c(d,p,m,a,e[t+3],22,-1044525330),a=c(a,d,p,m,e[t+4],7,-176418897),m=c(m,a,d,p,e[t+5],12,1200080426),p=c(p,m,a,d,e[t+6],17,-1473231341),d=c(d,p,m,a,e[t+7],22,-45705983),a=c(a,d,p,m,e[t+8],7,1770035416),m=c(m,a,d,p,e[t+9],12,-1958414417),p=c(p,m,a,d,e[t+10],17,-42063),d=c(d,p,m,a,e[t+11],22,-1990404162),a=c(a,d,p,m,e[t+12],7,1804603682),m=c(m,a,d,p,e[t+13],12,-40341101),p=c(p,m,a,d,e[t+14],17,-1502002290),d=c(d,p,m,a,e[t+15],22,1236535329),a=l(a,d,p,m,e[t+1],5,-165796510),m=l(m,a,d,p,e[t+6],9,-1069501632),p=l(p,m,a,d,e[t+11],14,643717713),d=l(d,p,m,a,e[t+0],20,-373897302),a=l(a,d,p,m,e[t+5],5,-701558691),m=l(m,a,d,p,e[t+10],9,38016083),p=l(p,m,a,d,e[t+15],14,-660478335),d=l(d,p,m,a,e[t+4],20,-405537848),a=l(a,d,p,m,e[t+9],5,568446438),m=l(m,a,d,p,e[t+14],9,-1019803690),p=l(p,m,a,d,e[t+3],14,-187363961),d=l(d,p,m,a,e[t+8],20,1163531501),a=l(a,d,p,m,e[t+13],5,-1444681467),m=l(m,a,d,p,e[t+2],9,-51403784),p=l(p,m,a,d,e[t+7],14,1735328473),d=l(d,p,m,a,e[t+12],20,-1926607734),a=h(a,d,p,m,e[t+5],4,-378558),m=h(m,a,d,p,e[t+8],11,-2022574463),p=h(p,m,a,d,e[t+11],16,1839030562),d=h(d,p,m,a,e[t+14],23,-35309556),a=h(a,d,p,m,e[t+1],4,-1530992060),m=h(m,a,d,p,e[t+4],11,1272893353),p=h(p,m,a,d,e[t+7],16,-155497632),d=h(d,p,m,a,e[t+10],23,-1094730640),a=h(a,d,p,m,e[t+13],4,681279174),m=h(m,a,d,p,e[t+0],11,-358537222),p=h(p,m,a,d,e[t+3],16,-722521979),d=h(d,p,m,a,e[t+6],23,76029189),a=h(a,d,p,m,e[t+9],4,-640364487),m=h(m,a,d,p,e[t+12],11,-421815835),p=h(p,m,a,d,e[t+15],16,530742520),d=h(d,p,m,a,e[t+2],23,-995338651),a=u(a,d,p,m,e[t+0],6,-198630844),m=u(m,a,d,p,e[t+7],10,1126891415),p=u(p,m,a,d,e[t+14],15,-1416354905),d=u(d,p,m,a,e[t+5],21,-57434055),a=u(a,d,p,m,e[t+12],6,1700485571),m=u(m,a,d,p,e[t+3],10,-1894986606),p=u(p,m,a,d,e[t+10],15,-1051523),d=u(d,p,m,a,e[t+1],21,-2054922799),a=u(a,d,p,m,e[t+8],6,1873313359),m=u(m,a,d,p,e[t+15],10,-30611744),p=u(p,m,a,d,e[t+6],15,-1560198380),d=u(d,p,m,a,e[t+13],21,1309151649),a=u(a,d,p,m,e[t+4],6,-145523070),m=u(m,a,d,p,e[t+11],10,-1120210379),p=u(p,m,a,d,e[t+2],15,718787259),d=u(d,p,m,a,e[t+9],21,-343485551),a=s(a,n),d=s(d,i),p=s(p,r),m=s(m,o);return[a,d,p,m]},m={hexdigest:function(e){return function(e){const t="0123456789abcdef";let n="";for(let i=0;i<4*e.length;i++)n+=t.charAt(e[i>>2]>>i%4*8+4&15)+t.charAt(e[i>>2]>>i%4*8&15);return n}(p(a(e),8*e.length))},hash:function(e){return function(e){let t="";for(let n=0;n<32*e.length;n+=8)t+=String.fromCharCode(e[n>>5]>>>n%32&255);return t}(p(a(e),8*e.length))}};class g{constructor(e,t,n){this.mechname=e,this.isClientFirst=t,this.priority=n}test(){return!0}onStart(e){this._connection=e}onChallenge(e,t){throw new Error("You should implement challenge handling!")}clientChallenge(e){if(!this.isClientFirst)throw new Error("clientChallenge should not be called if isClientFirst is false!");return this.onChallenge(e)}onFailure(){this._connection=null}onSuccess(){this._connection=null}}const f=function(e){var t,n,i="",r=e.length;for(t=0;t<r;t++)(n=e.charCodeAt(t))>=0&&n<=127?i+=e.charAt(t):n>2047?(i+=String.fromCharCode(224|n>>12&15),i+=String.fromCharCode(128|n>>6&63),i+=String.fromCharCode(128|n>>0&63)):(i+=String.fromCharCode(192|n>>6&31),i+=String.fromCharCode(128|n>>0&63));return i},v=function(e){e=e||{};for(const t in e)if(Object.prototype.hasOwnProperty.call(e,t)){let n="",i="",r="";const o=e[t],s="object"==typeof o,a=escape(unescape(s?o.value:o));s&&(n=o.expires?";expires="+o.expires:"",i=o.domain?";domain="+o.domain:"",r=o.path?";path="+o.path:""),document.cookie=t+"="+a+n+i+r}};function _(e,t){e[t>>5]|=128<<24-t%32,e[15+(t+64>>9<<4)]=t;var n,i,r,o,s,a,d,c,l=new Array(80),h=1732584193,u=-271733879,p=-1732584194,m=271733878,g=-1009589776;for(n=0;n<e.length;n+=16){for(o=h,s=u,a=p,d=m,c=g,i=0;i<80;i++)l[i]=i<16?e[n+i]:T(l[i-3]^l[i-8]^l[i-14]^l[i-16],1),r=b(b(T(h,5),y(i,u,p,m)),b(b(g,l[i]),E(i))),g=m,m=p,p=T(u,30),u=h,h=r;h=b(h,o),u=b(u,s),p=b(p,a),m=b(m,d),g=b(g,c)}return[h,u,p,m,g]}function y(e,t,n,i){return e<20?t&n|~t&i:e<40?t^n^i:e<60?t&n|t&i|n&i:t^n^i}function E(e){return e<20?1518500249:e<40?1859775393:e<60?-1894007588:-899497514}function S(e,t){var n=C(e);n.length>16&&(n=_(n,8*e.length));for(var i=new Array(16),r=new Array(16),o=0;o<16;o++)i[o]=909522486^n[o],r[o]=1549556828^n[o];var s=_(i.concat(C(t)),512+8*t.length);return _(r.concat(s),672)}function b(e,t){var n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}function T(e,t){return e<<t|e>>>32-t}function C(e){for(var t=[],n=0;n<8*e.length;n+=8)t[n>>5]|=(255&e.charCodeAt(n/8))<<24-n%32;return t}function x(e){for(var t,n,i="",r=0;r<4*e.length;r+=3)for(t=(e[r>>2]>>8*(3-r%4)&255)<<16|(e[r+1>>2]>>8*(3-(r+1)%4)&255)<<8|e[r+2>>2]>>8*(3-(r+2)%4)&255,n=0;n<4;n++)8*r+6*n>32*e.length?i+="=":i+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(t>>6*(3-n)&63);return i}function R(e){for(var t="",n=0;n<32*e.length;n+=8)t+=String.fromCharCode(e[n>>5]>>>24-n%32&255);return t}const A={b64_hmac_sha1:function(e,t){return x(S(e,t))},b64_sha1:function(e){return x(_(C(e),8*e.length))},binb2str:R,core_hmac_sha1:S,str_hmac_sha1:function(e,t){return R(S(e,t))},str_sha1:function(e){return R(_(C(e),8*e.length))}};const w="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";function I(e){const t=w.indexOf(e);return t<0?void 0:t}const P="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";function D(e){if(e>=0&&e<64)return P[e]}var O={atob:function(e){if(0===arguments.length)throw new TypeError("1 argument required, but only 0 present.");if((e=(e=`${e}`).replace(/[ \\t\\n\\f\\r]/g,"")).length%4==0&&(e=e.replace(/==?$/,"")),e.length%4==1||/[^+/0-9A-Za-z]/.test(e))return null;let t="",n=0,i=0;for(let r=0;r<e.length;r++)n<<=6,n|=I(e[r]),i+=6,24===i&&(t+=String.fromCharCode((16711680&n)>>16),t+=String.fromCharCode((65280&n)>>8),t+=String.fromCharCode(255&n),n=i=0);return 12===i?(n>>=4,t+=String.fromCharCode(n)):18===i&&(n>>=2,t+=String.fromCharCode((65280&n)>>8),t+=String.fromCharCode(255&n)),t},btoa:function(e){if(0===arguments.length)throw new TypeError("1 argument required, but only 0 present.");let t;for(e=`${e}`,t=0;t<e.length;t++)if(e.charCodeAt(t)>255)return null;let n="";for(t=0;t<e.length;t+=3){const i=[void 0,void 0,void 0,void 0];i[0]=e.charCodeAt(t)>>2,i[1]=(3&e.charCodeAt(t))<<4,e.length>t+1&&(i[1]|=e.charCodeAt(t+1)>>4,i[2]=(15&e.charCodeAt(t+1))<<2),e.length>t+2&&(i[2]|=e.charCodeAt(t+2)>>6,i[3]=63&e.charCodeAt(t+2));for(let e=0;e<i.length;e++)void 0===i[e]?n+="=":n+=D(i[e])}return n}};function k(e,t){return new F.Builder(e,t)}function N(e){return new F.Builder("message",e)}function M(e){return new F.Builder("iq",e)}function L(e){return new F.Builder("presence",e)}const F={VERSION:"1.5.0",NS:{HTTPBIND:"http://jabber.org/protocol/httpbind",BOSH:"urn:xmpp:xbosh",CLIENT:"jabber:client",AUTH:"jabber:iq:auth",ROSTER:"jabber:iq:roster",PROFILE:"jabber:iq:profile",DISCO_INFO:"http://jabber.org/protocol/disco#info",DISCO_ITEMS:"http://jabber.org/protocol/disco#items",MUC:"http://jabber.org/protocol/muc",SASL:"urn:ietf:params:xml:ns:xmpp-sasl",STREAM:"http://etherx.jabber.org/streams",FRAMING:"urn:ietf:params:xml:ns:xmpp-framing",BIND:"urn:ietf:params:xml:ns:xmpp-bind",SESSION:"urn:ietf:params:xml:ns:xmpp-session",VERSION:"jabber:iq:version",STANZAS:"urn:ietf:params:xml:ns:xmpp-stanzas",XHTML_IM:"http://jabber.org/protocol/xhtml-im",XHTML:"http://www.w3.org/1999/xhtml"},XHTML:{tags:["a","blockquote","br","cite","em","img","li","ol","p","span","strong","ul","body"],attributes:{a:["href"],blockquote:["style"],br:[],cite:["style"],em:[],img:["src","alt","style","height","width"],li:["style"],ol:["style"],p:["style"],span:["style"],strong:[],ul:["style"],body:[]},css:["background-color","color","font-family","font-size","font-style","font-weight","margin-left","margin-right","text-align","text-decoration"],validTag(e){for(let t=0;t<F.XHTML.tags.length;t++)if(e===F.XHTML.tags[t])return!0;return!1},validAttribute(e,t){if(void 0!==F.XHTML.attributes[e]&&F.XHTML.attributes[e].length>0)for(let n=0;n<F.XHTML.attributes[e].length;n++)if(t===F.XHTML.attributes[e][n])return!0;return!1},validCSS(e){for(let t=0;t<F.XHTML.css.length;t++)if(e===F.XHTML.css[t])return!0;return!1}},Status:{ERROR:0,CONNECTING:1,CONNFAIL:2,AUTHENTICATING:3,AUTHFAIL:4,CONNECTED:5,DISCONNECTED:6,DISCONNECTING:7,ATTACHED:8,REDIRECT:9,CONNTIMEOUT:10,BINDREQUIRED:11,ATTACHFAIL:12},ErrorCondition:{BAD_FORMAT:"bad-format",CONFLICT:"conflict",MISSING_JID_NODE:"x-strophe-bad-non-anon-jid",NO_AUTH_MECH:"no-auth-mech",UNKNOWN_REASON:"unknown"},LogLevel:{DEBUG:0,INFO:1,WARN:2,ERROR:3,FATAL:4},ElementType:{NORMAL:1,TEXT:3,CDATA:4,FRAGMENT:11},TIMEOUT:1.1,SECONDARY_TIMEOUT:.1,addNamespace(e,t){F.NS[e]=t},forEachChild(e,t,n){for(let i=0;i<e.childNodes.length;i++){const r=e.childNodes[i];r.nodeType!==F.ElementType.NORMAL||t&&!this.isTagEqual(r,t)||n(r)}},isTagEqual:(e,t)=>e.tagName===t,_xmlGenerator:null,xmlGenerator:()=>(F._xmlGenerator||(F._xmlGenerator=o()),F._xmlGenerator),xmlElement(e){if(!e)return null;const t=F.xmlGenerator().createElement(e);for(let e=1;e<arguments.length;e++){const n=arguments[e];if(n)if("string"==typeof n||"number"==typeof n)t.appendChild(F.xmlTextNode(n));else if("object"==typeof n&&"function"==typeof n.sort)for(let e=0;e<n.length;e++){const i=n[e];"object"==typeof i&&"function"==typeof i.sort&&void 0!==i[1]&&null!==i[1]&&t.setAttribute(i[0],i[1])}else if("object"==typeof n)for(const e in n)Object.prototype.hasOwnProperty.call(n,e)&&void 0!==n[e]&&null!==n[e]&&t.setAttribute(e,n[e])}return t},xmlescape:e=>(e=(e=(e=(e=e.replace(/\\&/g,"&amp;")).replace(/</g,"&lt;")).replace(/>/g,"&gt;")).replace(/\'/g,"&apos;")).replace(/"/g,"&quot;"),xmlunescape:e=>(e=(e=(e=(e=e.replace(/\\&amp;/g,"&")).replace(/&lt;/g,"<")).replace(/&gt;/g,">")).replace(/&apos;/g,"\'")).replace(/&quot;/g,\'"\'),xmlTextNode:e=>F.xmlGenerator().createTextNode(e),xmlHtmlNode(e){let t;return r?t=(new r).parseFromString(e,"text/xml"):(t=new ActiveXObject("Microsoft.XMLDOM"),t.async="false",t.loadXML(e)),t},getText(e){if(!e)return null;let t="";0===e.childNodes.length&&e.nodeType===F.ElementType.TEXT&&(t+=e.nodeValue);for(let n=0;n<e.childNodes.length;n++)e.childNodes[n].nodeType===F.ElementType.TEXT&&(t+=e.childNodes[n].nodeValue);return F.xmlescape(t)},copyElement(e){let t;if(e.nodeType===F.ElementType.NORMAL){t=F.xmlElement(e.tagName);for(let n=0;n<e.attributes.length;n++)t.setAttribute(e.attributes[n].nodeName,e.attributes[n].value);for(let n=0;n<e.childNodes.length;n++)t.appendChild(F.copyElement(e.childNodes[n]))}else e.nodeType===F.ElementType.TEXT&&(t=F.xmlGenerator().createTextNode(e.nodeValue));return t},createHtml(e){let t;if(e.nodeType===F.ElementType.NORMAL){const n=e.nodeName.toLowerCase();if(F.XHTML.validTag(n))try{t=F.xmlElement(n);for(let i=0;i<F.XHTML.attributes[n].length;i++){const r=F.XHTML.attributes[n][i];let o=e.getAttribute(r);if(null!=o&&""!==o&&!1!==o&&0!==o)if("style"===r&&"object"==typeof o&&void 0!==o.cssText&&(o=o.cssText),"style"===r){const e=[],n=o.split(";");for(let t=0;t<n.length;t++){const i=n[t].split(":"),r=i[0].replace(/^\\s*/,"").replace(/\\s*$/,"").toLowerCase();if(F.XHTML.validCSS(r)){const t=i[1].replace(/^\\s*/,"").replace(/\\s*$/,"");e.push(r+": "+t)}}e.length>0&&(o=e.join("; "),t.setAttribute(r,o))}else t.setAttribute(r,o)}for(let n=0;n<e.childNodes.length;n++)t.appendChild(F.createHtml(e.childNodes[n]))}catch(e){t=F.xmlTextNode("")}else{t=F.xmlGenerator().createDocumentFragment();for(let n=0;n<e.childNodes.length;n++)t.appendChild(F.createHtml(e.childNodes[n]))}}else if(e.nodeType===F.ElementType.FRAGMENT){t=F.xmlGenerator().createDocumentFragment();for(let n=0;n<e.childNodes.length;n++)t.appendChild(F.createHtml(e.childNodes[n]))}else e.nodeType===F.ElementType.TEXT&&(t=F.xmlTextNode(e.nodeValue));return t},escapeNode:e=>"string"!=typeof e?e:e.replace(/^\\s+|\\s+$/g,"").replace(/\\\\/g,"\\\\5c").replace(/ /g,"\\\\20").replace(/\\"/g,"\\\\22").replace(/\\&/g,"\\\\26").replace(/\\\'/g,"\\\\27").replace(/\\//g,"\\\\2f").replace(/:/g,"\\\\3a").replace(/</g,"\\\\3c").replace(/>/g,"\\\\3e").replace(/@/g,"\\\\40"),unescapeNode:e=>"string"!=typeof e?e:e.replace(/\\\\20/g," ").replace(/\\\\22/g,\'"\').replace(/\\\\26/g,"&").replace(/\\\\27/g,"\'").replace(/\\\\2f/g,"/").replace(/\\\\3a/g,":").replace(/\\\\3c/g,"<").replace(/\\\\3e/g,">").replace(/\\\\40/g,"@").replace(/\\\\5c/g,"\\\\"),getNodeFromJid:e=>e.indexOf("@")<0?null:e.split("@")[0],getDomainFromJid(e){const t=F.getBareJidFromJid(e);if(t.indexOf("@")<0)return t;{const e=t.split("@");return e.splice(0,1),e.join("@")}},getResourceFromJid(e){if(!e)return null;const t=e.split("/");return t.length<2?null:(t.splice(0,1),t.join("/"))},getBareJidFromJid:e=>e?e.split("/")[0]:null,_handleError(e){void 0!==e.stack&&F.fatal(e.stack),e.sourceURL?F.fatal("error: "+this.handler+" "+e.sourceURL+":"+e.line+" - "+e.name+": "+e.message):e.fileName?F.fatal("error: "+this.handler+" "+e.fileName+":"+e.lineNumber+" - "+e.name+": "+e.message):F.fatal("error: "+e.message)},log(e,t){var n;e===this.LogLevel.FATAL&&(null===(n=console)||void 0===n||n.error(t))},debug(e){this.log(this.LogLevel.DEBUG,e)},info(e){this.log(this.LogLevel.INFO,e)},warn(e){this.log(this.LogLevel.WARN,e)},error(e){this.log(this.LogLevel.ERROR,e)},fatal(e){this.log(this.LogLevel.FATAL,e)},serialize(e){if(!e)return null;"function"==typeof e.tree&&(e=e.tree());const t=[...Array(e.attributes.length).keys()].map((t=>e.attributes[t].nodeName));t.sort();let n=t.reduce(((t,n)=>`${t} ${n}="${F.xmlescape(e.attributes.getNamedItem(n).value)}"`),`<${e.nodeName}`);if(e.childNodes.length>0){n+=">";for(let t=0;t<e.childNodes.length;t++){const i=e.childNodes[t];switch(i.nodeType){case F.ElementType.NORMAL:n+=F.serialize(i);break;case F.ElementType.TEXT:n+=F.xmlescape(i.nodeValue);break;case F.ElementType.CDATA:n+="<![CDATA["+i.nodeValue+"]]>"}}n+="</"+e.nodeName+">"}else n+="/>";return n},_requestId:0,_connectionPlugins:{},addConnectionPlugin(e,t){F._connectionPlugins[e]=t},Builder:class{constructor(e,t){"presence"!==e&&"message"!==e&&"iq"!==e||(t&&!t.xmlns?t.xmlns=F.NS.CLIENT:t||(t={xmlns:F.NS.CLIENT})),this.nodeTree=F.xmlElement(e,t),this.node=this.nodeTree}tree(){return this.nodeTree}toString(){return F.serialize(this.nodeTree)}up(){return this.node=this.node.parentNode,this}root(){return this.node=this.nodeTree,this}attrs(e){for(const t in e)Object.prototype.hasOwnProperty.call(e,t)&&(void 0===e[t]?this.node.removeAttribute(t):this.node.setAttribute(t,e[t]));return this}c(e,t,n){const i=F.xmlElement(e,t,n);return this.node.appendChild(i),"string"!=typeof n&&"number"!=typeof n&&(this.node=i),this}cnode(e){let t;const n=F.xmlGenerator();try{t=void 0!==n.importNode}catch(e){t=!1}const i=t?n.importNode(e,!0):F.copyElement(e);return this.node.appendChild(i),this.node=i,this}t(e){const t=F.xmlTextNode(e);return this.node.appendChild(t),this}h(e){const t=F.xmlGenerator().createElement("body");t.innerHTML=e;const n=F.createHtml(t);for(;n.childNodes.length>0;)this.node.appendChild(n.childNodes[0]);return this}},Handler:function(e,t,n,i,r,o,s){this.handler=e,this.ns=t,this.name=n,this.type=i,this.id=r,this.options=s||{matchBareFromJid:!1,ignoreNamespaceFragment:!1},this.options.matchBare&&(F.warn(\'The "matchBare" option is deprecated, use "matchBareFromJid" instead.\'),this.options.matchBareFromJid=this.options.matchBare,delete this.options.matchBare),this.options.matchBareFromJid?this.from=o?F.getBareJidFromJid(o):null:this.from=o,this.user=!0}};F.Handler.prototype={getNamespace(e){let t=e.getAttribute("xmlns");return t&&this.options.ignoreNamespaceFragment&&(t=t.split("#")[0]),t},namespaceMatch(e){let t=!1;return!this.ns||(F.forEachChild(e,null,(e=>{this.getNamespace(e)===this.ns&&(t=!0)})),t||this.getNamespace(e)===this.ns)},isMatch(e){let t=e.getAttribute("from");this.options.matchBareFromJid&&(t=F.getBareJidFromJid(t));const n=e.getAttribute("type");return!(!this.namespaceMatch(e)||this.name&&!F.isTagEqual(e,this.name)||this.type&&(Array.isArray(this.type)?-1===this.type.indexOf(n):n!==this.type)||this.id&&e.getAttribute("id")!==this.id||this.from&&t!==this.from)},run(e){let t=null;try{t=this.handler(e)}catch(e){throw F._handleError(e),e}return t},toString(){return"{Handler: "+this.handler+"("+this.name+","+this.id+","+this.ns+")}"}},F.TimedHandler=class{constructor(e,t){this.period=e,this.handler=t,this.lastCalled=(new Date).getTime(),this.user=!0}run(){return this.lastCalled=(new Date).getTime(),this.handler()}reset(){this.lastCalled=(new Date).getTime()}toString(){return"{TimedHandler: "+this.handler+"("+this.period+")}"}},F.Connection=class{constructor(e,t){this.service=e,this.options=t||{},this.setProtocol(),this.jid="",this.domain=null,this.features=null,this._sasl_data={},this.do_bind=!1,this.do_session=!1,this.mechanisms={},this.timedHandlers=[],this.handlers=[],this.removeTimeds=[],this.removeHandlers=[],this.addTimeds=[],this.addHandlers=[],this.protocolErrorHandlers={HTTP:{},websocket:{}},this._idleTimeout=null,this._disconnectTimeout=null,this.authenticated=!1,this.connected=!1,this.disconnecting=!1,this.do_authentication=!0,this.paused=!1,this.restored=!1,this._data=[],this._uniqueId=0,this._sasl_success_handler=null,this._sasl_failure_handler=null,this._sasl_challenge_handler=null,this.maxRetries=5,this._idleTimeout=setTimeout((()=>this._onIdle()),100),v(this.options.cookies),this.registerSASLMechanisms(this.options.mechanisms),this.iqFallbackHandler=new F.Handler((e=>this.send(M({type:"error",id:e.getAttribute("id")}).c("error",{type:"cancel"}).c("service-unavailable",{xmlns:F.NS.STANZAS}))),null,"iq",["get","set"]);for(const e in F._connectionPlugins)if(Object.prototype.hasOwnProperty.call(F._connectionPlugins,e)){const t=function(){};t.prototype=F._connectionPlugins[e],this[e]=new t,this[e].init(this)}}setProtocol(){const e=this.options.protocol||"";this.options.worker?this._proto=new F.WorkerWebsocket(this):0===this.service.indexOf("ws:")||0===this.service.indexOf("wss:")||0===e.indexOf("ws")?this._proto=new F.Websocket(this):this._proto=new F.Bosh(this)}reset(){this._proto._reset(),this.do_session=!1,this.do_bind=!1,this.timedHandlers=[],this.handlers=[],this.removeTimeds=[],this.removeHandlers=[],this.addTimeds=[],this.addHandlers=[],this.authenticated=!1,this.connected=!1,this.disconnecting=!1,this.restored=!1,this._data=[],this._requests=[],this._uniqueId=0}pause(){this.paused=!0}resume(){this.paused=!1}getUniqueId(e){const t="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){const t=16*Math.random()|0;return("x"===e?t:3&t|8).toString(16)}));return"string"==typeof e||"number"==typeof e?t+":"+e:t+""}addProtocolErrorHandler(e,t,n){this.protocolErrorHandlers[e][t]=n}connect(e,t,n,i,r,o,s){let a=arguments.length>7&&void 0!==arguments[7]?arguments[7]:3e3;this.jid=e,this.authzid=F.getBareJidFromJid(this.jid),this.authcid=s||F.getNodeFromJid(this.jid),this.pass=t,this.connect_callback=n,this.disconnecting=!1,this.connected=!1,this.authenticated=!1,this.restored=!1,this.disconnection_timeout=a,this.domain=F.getDomainFromJid(this.jid),this._changeConnectStatus(F.Status.CONNECTING,null),this._proto._connect(i,r,o)}attach(e,t,n,i,r,o,s){if(this._proto._attach)return this._proto._attach(e,t,n,i,r,o,s);{const e=new Error(\'The "attach" method is not available for your connection protocol\');throw e.name="StropheSessionError",e}}restore(e,t,n,i,r){if(!this._sessionCachingSupported()){const e=new Error(\'The "restore" method can only be used with a BOSH connection.\');throw e.name="StropheSessionError",e}this._proto._restore(e,t,n,i,r)}_sessionCachingSupported(){if(this._proto instanceof F.Bosh){if(!JSON)return!1;try{sessionStorage.setItem("_strophe_","_strophe_"),sessionStorage.removeItem("_strophe_")}catch(e){return!1}return!0}return!1}xmlInput(e){}xmlOutput(e){}rawInput(e){}rawOutput(e){}nextValidRid(e){}send(e){if(null!==e){if("function"==typeof e.sort)for(let t=0;t<e.length;t++)this._queueData(e[t]);else"function"==typeof e.tree?this._queueData(e.tree()):this._queueData(e);this._proto._send()}}flush(){clearTimeout(this._idleTimeout),this._onIdle()}sendPresence(e,t,n,i){let r=null;"function"==typeof e.tree&&(e=e.tree());let o=e.getAttribute("id");if(o||(o=this.getUniqueId("sendPresence"),e.setAttribute("id",o)),"function"==typeof t||"function"==typeof n){const e=this.addHandler((e=>{r&&this.deleteTimedHandler(r),"error"===e.getAttribute("type")?n&&n(e):t&&t(e)}),null,"presence",null,o);i&&(r=this.addTimedHandler(i,(()=>(this.deleteHandler(e),n&&n(null),!1))))}return this.send(e),o}sendIQ(e,t,n,i){let r=null;"function"==typeof e.tree&&(e=e.tree());let o=e.getAttribute("id");if(o||(o=this.getUniqueId("sendIQ"),e.setAttribute("id",o)),"function"==typeof t||"function"==typeof n){const e=this.addHandler((e=>{r&&this.deleteTimedHandler(r);const i=e.getAttribute("type");if("result"===i)t&&t(e);else{if("error"!==i){const e=new Error(`Got bad IQ type of ${i}`);throw e.name="StropheError",e}n&&n(e)}}),null,"iq",["error","result"],o);i&&(r=this.addTimedHandler(i,(()=>(this.deleteHandler(e),n&&n(null),!1))))}return this.send(e),o}_queueData(e){if(null===e||!e.tagName||!e.childNodes){const e=new Error("Cannot queue non-DOMElement.");throw e.name="StropheError",e}this._data.push(e)}_sendRestart(){this._data.push("restart"),this._proto._sendRestart(),this._idleTimeout=setTimeout((()=>this._onIdle()),100)}addTimedHandler(e,t){const n=new F.TimedHandler(e,t);return this.addTimeds.push(n),n}deleteTimedHandler(e){this.removeTimeds.push(e)}addHandler(e,t,n,i,r,o,s){const a=new F.Handler(e,t,n,i,r,o,s);return this.addHandlers.push(a),a}deleteHandler(e){this.removeHandlers.push(e);const t=this.addHandlers.indexOf(e);t>=0&&this.addHandlers.splice(t,1)}registerSASLMechanisms(e){this.mechanisms={},(e=e||[F.SASLAnonymous,F.SASLExternal,F.SASLOAuthBearer,F.SASLXOAuth2,F.SASLPlain,F.SASLSHA1]).forEach((e=>this.registerSASLMechanism(e)))}registerSASLMechanism(e){const t=new e;this.mechanisms[t.mechname]=t}disconnect(e){if(this._changeConnectStatus(F.Status.DISCONNECTING,e),e?F.warn("Disconnect was called because: "+e):F.info("Disconnect was called"),this.connected){let e=!1;this.disconnecting=!0,this.authenticated&&(e=L({xmlns:F.NS.CLIENT,type:"unavailable"})),this._disconnectTimeout=this._addSysTimedHandler(this.disconnection_timeout,this._onDisconnectTimeout.bind(this)),this._proto._disconnect(e)}else F.warn("Disconnect was called before Strophe connected to the server"),this._proto._abortAllRequests(),this._doDisconnect()}_changeConnectStatus(e,t,n){for(const n in F._connectionPlugins)if(Object.prototype.hasOwnProperty.call(F._connectionPlugins,n)){const i=this[n];if(i.statusChanged)try{i.statusChanged(e,t)}catch(e){F.error(`${n} plugin caused an exception changing status: ${e}`)}}if(this.connect_callback)try{this.connect_callback(e,t,n)}catch(e){F._handleError(e),F.error(`User connection callback caused an exception: ${e}`)}}_doDisconnect(e){"number"==typeof this._idleTimeout&&clearTimeout(this._idleTimeout),null!==this._disconnectTimeout&&(this.deleteTimedHandler(this._disconnectTimeout),this._disconnectTimeout=null),F.debug("_doDisconnect was called"),this._proto._doDisconnect(),this.authenticated=!1,this.disconnecting=!1,this.restored=!1,this.handlers=[],this.timedHandlers=[],this.removeTimeds=[],this.removeHandlers=[],this.addTimeds=[],this.addHandlers=[],this._changeConnectStatus(F.Status.DISCONNECTED,e),this.connected=!1}_dataRecv(e,t){const n=this._proto._reqToData(e);if(null===n)return;for(this.xmlInput!==F.Connection.prototype.xmlInput&&(n.nodeName===this._proto.strip&&n.childNodes.length?this.xmlInput(n.childNodes[0]):this.xmlInput(n)),this.rawInput!==F.Connection.prototype.rawInput&&(t?this.rawInput(t):this.rawInput(F.serialize(n)));this.removeHandlers.length>0;){const e=this.removeHandlers.pop(),t=this.handlers.indexOf(e);t>=0&&this.handlers.splice(t,1)}for(;this.addHandlers.length>0;)this.handlers.push(this.addHandlers.pop());if(this.disconnecting&&this._proto._emptyQueue())return void this._doDisconnect();const i=n.getAttribute("type");if(null!==i&&"terminate"===i){if(this.disconnecting)return;let e=n.getAttribute("condition");const t=n.getElementsByTagName("conflict");return null!==e?("remote-stream-error"===e&&t.length>0&&(e="conflict"),this._changeConnectStatus(F.Status.CONNFAIL,e)):this._changeConnectStatus(F.Status.CONNFAIL,F.ErrorCondition.UNKOWN_REASON),void this._doDisconnect(e)}F.forEachChild(n,null,(e=>{const t=[];this.handlers=this.handlers.reduce(((n,i)=>{try{!i.isMatch(e)||!this.authenticated&&i.user?n.push(i):(i.run(e)&&n.push(i),t.push(i))}catch(e){F.warn("Removing Strophe handlers due to uncaught exception: "+e.message)}return n}),[]),!t.length&&this.iqFallbackHandler.isMatch(e)&&this.iqFallbackHandler.run(e)}))}_connect_cb(e,t,n){let i,r;F.debug("_connect_cb was called"),this.connected=!0;try{i=this._proto._reqToData(e)}catch(e){if(e.name!==F.ErrorCondition.BAD_FORMAT)throw e;this._changeConnectStatus(F.Status.CONNFAIL,F.ErrorCondition.BAD_FORMAT),this._doDisconnect(F.ErrorCondition.BAD_FORMAT)}if(!i)return;if(this.xmlInput!==F.Connection.prototype.xmlInput&&(i.nodeName===this._proto.strip&&i.childNodes.length?this.xmlInput(i.childNodes[0]):this.xmlInput(i)),this.rawInput!==F.Connection.prototype.rawInput&&(n?this.rawInput(n):this.rawInput(F.serialize(i))),this._proto._connect_cb(i)===F.Status.CONNFAIL)return;if(r=i.getElementsByTagNameNS?i.getElementsByTagNameNS(F.NS.STREAM,"features").length>0:i.getElementsByTagName("stream:features").length>0||i.getElementsByTagName("features").length>0,!r)return void this._proto._no_auth_received(t);const o=Array.from(i.getElementsByTagName("mechanism")).map((e=>this.mechanisms[e.textContent])).filter((e=>e));0!==o.length||0!==i.getElementsByTagName("auth").length?!1!==this.do_authentication&&this.authenticate(o):this._proto._no_auth_received(t)}sortMechanismsByPriority(e){for(let t=0;t<e.length-1;++t){let n=t;for(let i=t+1;i<e.length;++i)e[i].priority>e[n].priority&&(n=i);if(n!==t){const i=e[t];e[t]=e[n],e[n]=i}}return e}authenticate(e){this._attemptSASLAuth(e)||this._attemptLegacyAuth()}_attemptSASLAuth(e){e=this.sortMechanismsByPriority(e||[]);let t=!1;for(let n=0;n<e.length;++n){if(!e[n].test(this))continue;this._sasl_success_handler=this._addSysHandler(this._sasl_success_cb.bind(this),null,"success",null,null),this._sasl_failure_handler=this._addSysHandler(this._sasl_failure_cb.bind(this),null,"failure",null,null),this._sasl_challenge_handler=this._addSysHandler(this._sasl_challenge_cb.bind(this),null,"challenge",null,null),this._sasl_mechanism=e[n],this._sasl_mechanism.onStart(this);const i=k("auth",{xmlns:F.NS.SASL,mechanism:this._sasl_mechanism.mechname});if(this._sasl_mechanism.isClientFirst){const e=this._sasl_mechanism.clientChallenge(this);i.t(O.btoa(e))}this.send(i.tree()),t=!0;break}return t}_sasl_challenge_cb(e){const t=O.atob(F.getText(e)),n=this._sasl_mechanism.onChallenge(this,t),i=k("response",{xmlns:F.NS.SASL});return""!==n&&i.t(O.btoa(n)),this.send(i.tree()),!0}_attemptLegacyAuth(){null===F.getNodeFromJid(this.jid)?(this._changeConnectStatus(F.Status.CONNFAIL,F.ErrorCondition.MISSING_JID_NODE),this.disconnect(F.ErrorCondition.MISSING_JID_NODE)):(this._changeConnectStatus(F.Status.AUTHENTICATING,null),this._addSysHandler(this._onLegacyAuthIQResult.bind(this),null,null,null,"_auth_1"),this.send(M({type:"get",to:this.domain,id:"_auth_1"}).c("query",{xmlns:F.NS.AUTH}).c("username",{}).t(F.getNodeFromJid(this.jid)).tree()))}_onLegacyAuthIQResult(e){const t=M({type:"set",id:"_auth_2"}).c("query",{xmlns:F.NS.AUTH}).c("username",{}).t(F.getNodeFromJid(this.jid)).up().c("password").t(this.pass);return F.getResourceFromJid(this.jid)||(this.jid=F.getBareJidFromJid(this.jid)+"/strophe"),t.up().c("resource",{}).t(F.getResourceFromJid(this.jid)),this._addSysHandler(this._auth2_cb.bind(this),null,null,null,"_auth_2"),this.send(t.tree()),!1}_sasl_success_cb(e){if(this._sasl_data["server-signature"]){let t;const n=/([a-z]+)=([^,]+)(,|$)/,i=O.atob(F.getText(e)).match(n);if("v"===i[1]&&(t=i[2]),t!==this._sasl_data["server-signature"])return this.deleteHandler(this._sasl_failure_handler),this._sasl_failure_handler=null,this._sasl_challenge_handler&&(this.deleteHandler(this._sasl_challenge_handler),this._sasl_challenge_handler=null),this._sasl_data={},this._sasl_failure_cb(null)}F.info("SASL authentication succeeded."),this._sasl_mechanism&&this._sasl_mechanism.onSuccess(),this.deleteHandler(this._sasl_failure_handler),this._sasl_failure_handler=null,this._sasl_challenge_handler&&(this.deleteHandler(this._sasl_challenge_handler),this._sasl_challenge_handler=null);const t=[],n=(e,t)=>{for(;e.length;)this.deleteHandler(e.pop());return this._onStreamFeaturesAfterSASL(t),!1};return t.push(this._addSysHandler((e=>n(t,e)),null,"stream:features",null,null)),t.push(this._addSysHandler((e=>n(t,e)),F.NS.STREAM,"features",null,null)),this._sendRestart(),!1}_onStreamFeaturesAfterSASL(e){this.features=e;for(let t=0;t<e.childNodes.length;t++){const n=e.childNodes[t];"bind"===n.nodeName&&(this.do_bind=!0),"session"===n.nodeName&&(this.do_session=!0)}return this.do_bind?(this.options.explicitResourceBinding?this._changeConnectStatus(F.Status.BINDREQUIRED,null):this.bind(),!1):(this._changeConnectStatus(F.Status.AUTHFAIL,null),!1)}bind(){if(!this.do_bind)return void F.log(F.LogLevel.INFO,\'Strophe.Connection.prototype.bind called but "do_bind" is false\');this._addSysHandler(this._onResourceBindResultIQ.bind(this),null,null,null,"_bind_auth_2");const e=F.getResourceFromJid(this.jid);e?this.send(M({type:"set",id:"_bind_auth_2"}).c("bind",{xmlns:F.NS.BIND}).c("resource",{}).t(e).tree()):this.send(M({type:"set",id:"_bind_auth_2"}).c("bind",{xmlns:F.NS.BIND}).tree())}_onResourceBindResultIQ(e){if("error"===e.getAttribute("type")){let t;return F.warn("Resource binding failed."),e.getElementsByTagName("conflict").length>0&&(t=F.ErrorCondition.CONFLICT),this._changeConnectStatus(F.Status.AUTHFAIL,t,e),!1}const t=e.getElementsByTagName("bind");if(!(t.length>0))return F.warn("Resource binding failed."),this._changeConnectStatus(F.Status.AUTHFAIL,null,e),!1;{const e=t[0].getElementsByTagName("jid");e.length>0&&(this.authenticated=!0,this.jid=F.getText(e[0]),this.do_session?this._establishSession():this._changeConnectStatus(F.Status.CONNECTED,null))}}_establishSession(){if(!this.do_session)throw new Error(`Strophe.Connection.prototype._establishSession called but apparently ${F.NS.SESSION} wasn\'t advertised by the server`);this._addSysHandler(this._onSessionResultIQ.bind(this),null,null,null,"_session_auth_2"),this.send(M({type:"set",id:"_session_auth_2"}).c("session",{xmlns:F.NS.SESSION}).tree())}_onSessionResultIQ(e){if("result"===e.getAttribute("type"))this.authenticated=!0,this._changeConnectStatus(F.Status.CONNECTED,null);else if("error"===e.getAttribute("type"))return this.authenticated=!1,F.warn("Session creation failed."),this._changeConnectStatus(F.Status.AUTHFAIL,null,e),!1;return!1}_sasl_failure_cb(e){return this._sasl_success_handler&&(this.deleteHandler(this._sasl_success_handler),this._sasl_success_handler=null),this._sasl_challenge_handler&&(this.deleteHandler(this._sasl_challenge_handler),this._sasl_challenge_handler=null),this._sasl_mechanism&&this._sasl_mechanism.onFailure(),this._changeConnectStatus(F.Status.AUTHFAIL,null,e),!1}_auth2_cb(e){return"result"===e.getAttribute("type")?(this.authenticated=!0,this._changeConnectStatus(F.Status.CONNECTED,null)):"error"===e.getAttribute("type")&&(this._changeConnectStatus(F.Status.AUTHFAIL,null,e),this.disconnect("authentication failed")),!1}_addSysTimedHandler(e,t){const n=new F.TimedHandler(e,t);return n.user=!1,this.addTimeds.push(n),n}_addSysHandler(e,t,n,i,r){const o=new F.Handler(e,t,n,i,r);return o.user=!1,this.addHandlers.push(o),o}_onDisconnectTimeout(){return F.debug("_onDisconnectTimeout was called"),this._changeConnectStatus(F.Status.CONNTIMEOUT,null),this._proto._onDisconnectTimeout(),this._doDisconnect(),!1}_onIdle(){for(;this.addTimeds.length>0;)this.timedHandlers.push(this.addTimeds.pop());for(;this.removeTimeds.length>0;){const e=this.removeTimeds.pop(),t=this.timedHandlers.indexOf(e);t>=0&&this.timedHandlers.splice(t,1)}const e=(new Date).getTime(),t=[];for(let n=0;n<this.timedHandlers.length;n++){const i=this.timedHandlers[n];!this.authenticated&&i.user||(i.lastCalled+i.period-e<=0?i.run()&&t.push(i):t.push(i))}this.timedHandlers=t,clearTimeout(this._idleTimeout),this._proto._onIdle(),this.connected&&(this._idleTimeout=setTimeout((()=>this._onIdle()),100))}},F.SASLMechanism=g,F.SASLAnonymous=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"ANONYMOUS",arguments.length>1&&void 0!==arguments[1]&&arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:20)}test(e){return null===e.authcid}},F.SASLPlain=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"PLAIN",!(arguments.length>1&&void 0!==arguments[1])||arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:50)}test(e){return null!==e.authcid}onChallenge(e){const{authcid:t,authzid:n,domain:i,pass:r}=e;if(!i)throw new Error("SASLPlain onChallenge: domain is not defined!");let o=n!==`${t}@${i}`?n:"";return o+="\\0",o+=t,o+="\\0",o+=r,f(o)}},F.SASLSHA1=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"SCRAM-SHA-1",!(arguments.length>1&&void 0!==arguments[1])||arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:60)}test(e){return null!==e.authcid}onChallenge(e,t){let n,i,r,o,s,a,d,c,l="c=biws,",h=`${e._sasl_data["client-first-message-bare"]},${t},`;const u=e._sasl_data.cnonce,p=/([a-z]+)=([^,]+)(,|$)/;for(;t.match(p);){const e=t.match(p);switch(t=t.replace(e[0],""),e[1]){case"r":n=e[2];break;case"s":i=e[2];break;case"i":r=e[2]}}if(n.slice(0,u.length)!==u)return e._sasl_data={},e._sasl_failure_cb();l+="r="+n,h+=l,i=atob(i),i+="\\0\\0\\0";const m=f(e.pass);for(o=a=A.core_hmac_sha1(m,i),d=1;d<r;d++){for(s=A.core_hmac_sha1(m,A.binb2str(a)),c=0;c<5;c++)o[c]^=s[c];a=s}o=A.binb2str(o);const g=A.core_hmac_sha1(o,"Client Key"),v=A.str_hmac_sha1(o,"Server Key"),_=A.core_hmac_sha1(A.str_sha1(A.binb2str(g)),h);for(e._sasl_data["server-signature"]=A.b64_hmac_sha1(v,h),c=0;c<5;c++)g[c]^=_[c];return l+=",p="+btoa(A.binb2str(g)),l}clientChallenge(e,t){const n=t||m.hexdigest(""+1234567890*Math.random());let i="n="+f(e.authcid);return i+=",r=",i+=n,e._sasl_data.cnonce=n,e._sasl_data["client-first-message-bare"]=i,i="n,,"+i,i}},F.SASLOAuthBearer=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"OAUTHBEARER",!(arguments.length>1&&void 0!==arguments[1])||arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:40)}test(e){return null!==e.pass}onChallenge(e){let t="n,";return null!==e.authcid&&(t=t+"a="+e.authzid),t+=",",t+="",t+="auth=Bearer ",t+=e.pass,t+="",t+="",f(t)}},F.SASLExternal=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"EXTERNAL",!(arguments.length>1&&void 0!==arguments[1])||arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:10)}onChallenge(e){return e.authcid===e.authzid?"":e.authzid}},F.SASLXOAuth2=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"X-OAUTH2",!(arguments.length>1&&void 0!==arguments[1])||arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:30)}test(e){return null!==e.pass}onChallenge(e){let t="\\0";return null!==e.authcid&&(t+=e.authzid),t+="\\0",t+=e.pass,f(t)}};var j={Strophe:F,$build:k,$iq:M,$msg:N,$pres:L,SHA1:A,MD5:m,b64_hmac_sha1:A.b64_hmac_sha1,b64_sha1:A.b64_sha1,str_hmac_sha1:A.str_hmac_sha1,str_sha1:A.str_sha1};F.Request=class{constructor(e,t,n,i){this.id=++F._requestId,this.xmlData=e,this.data=F.serialize(e),this.origFunc=t,this.func=t,this.rid=n,this.date=NaN,this.sends=i||0,this.abort=!1,this.dead=null,this.age=function(){return this.date?(new Date-this.date)/1e3:0},this.timeDead=function(){return this.dead?(new Date-this.dead)/1e3:0},this.xhr=this._newXHR()}getResponse(){let e=null;if(this.xhr.responseXML&&this.xhr.responseXML.documentElement){if(e=this.xhr.responseXML.documentElement,"parsererror"===e.tagName)throw F.error("invalid response received"),F.error("responseText: "+this.xhr.responseText),F.error("responseXML: "+F.serialize(this.xhr.responseXML)),new Error("parsererror")}else if(this.xhr.responseText){if(F.debug("Got responseText but no responseXML; attempting to parse it with DOMParser..."),e=(new r).parseFromString(this.xhr.responseText,"application/xml").documentElement,!e)throw new Error("Parsing produced null node");if(e.querySelector("parsererror")){F.error("invalid response received: "+e.querySelector("parsererror").textContent),F.error("responseText: "+this.xhr.responseText);const t=new Error;throw t.name=F.ErrorCondition.BAD_FORMAT,t}}return e}_newXHR(){let e=null;return window.XMLHttpRequest?(e=new XMLHttpRequest,e.overrideMimeType&&e.overrideMimeType("text/xml; charset=utf-8")):window.ActiveXObject&&(e=new ActiveXObject("Microsoft.XMLHTTP")),e.onreadystatechange=this.func.bind(null,this),e}},F.Bosh=class e{constructor(e){this._conn=e,this.rid=Math.floor(4294967295*Math.random()),this.sid=null,this.hold=1,this.wait=60,this.window=5,this.errors=0,this.inactivity=null,this.lastResponseHeaders=null,this._requests=[]}_buildBody(){const e=k("body",{rid:this.rid++,xmlns:F.NS.HTTPBIND});return null!==this.sid&&e.attrs({sid:this.sid}),this._conn.options.keepalive&&this._conn._sessionCachingSupported()&&this._cacheSession(),e}_reset(){this.rid=Math.floor(4294967295*Math.random()),this.sid=null,this.errors=0,this._conn._sessionCachingSupported()&&window.sessionStorage.removeItem("strophe-bosh-session"),this._conn.nextValidRid(this.rid)}_connect(e,t,n){this.wait=e||this.wait,this.hold=t||this.hold,this.errors=0;const i=this._buildBody().attrs({to:this._conn.domain,"xml:lang":"en",wait:this.wait,hold:this.hold,content:"text/xml; charset=utf-8",ver:"1.6","xmpp:version":"1.0","xmlns:xmpp":F.NS.BOSH});n&&i.attrs({route:n});const r=this._conn._connect_cb;this._requests.push(new F.Request(i.tree(),this._onRequestStateChange.bind(this,r.bind(this._conn)),i.tree().getAttribute("rid"))),this._throttledRequestHandler()}_attach(e,t,n,i,r,o,s){this._conn.jid=e,this.sid=t,this.rid=n,this._conn.connect_callback=i,this._conn.domain=F.getDomainFromJid(this._conn.jid),this._conn.authenticated=!0,this._conn.connected=!0,this.wait=r||this.wait,this.hold=o||this.hold,this.window=s||this.window,this._conn._changeConnectStatus(F.Status.ATTACHED,null)}_restore(e,t,n,i,r){const o=JSON.parse(window.sessionStorage.getItem("strophe-bosh-session"));if(!(null!=o&&o.rid&&o.sid&&o.jid&&(null==e||F.getBareJidFromJid(o.jid)===F.getBareJidFromJid(e)||null===F.getNodeFromJid(e)&&F.getDomainFromJid(o.jid)===e))){const e=new Error("_restore: no restoreable session.");throw e.name="StropheSessionError",e}this._conn.restored=!0,this._attach(o.jid,o.sid,o.rid,t,n,i,r)}_cacheSession(){this._conn.authenticated?this._conn.jid&&this.rid&&this.sid&&window.sessionStorage.setItem("strophe-bosh-session",JSON.stringify({jid:this._conn.jid,rid:this.rid,sid:this.sid})):window.sessionStorage.removeItem("strophe-bosh-session")}_connect_cb(e){const t=e.getAttribute("type");if(null!==t&&"terminate"===t){let t=e.getAttribute("condition");F.error("BOSH-Connection failed: "+t);const n=e.getElementsByTagName("conflict");return null!==t?("remote-stream-error"===t&&n.length>0&&(t="conflict"),this._conn._changeConnectStatus(F.Status.CONNFAIL,t)):this._conn._changeConnectStatus(F.Status.CONNFAIL,"unknown"),this._conn._doDisconnect(t),F.Status.CONNFAIL}this.sid||(this.sid=e.getAttribute("sid"));const n=e.getAttribute("requests");n&&(this.window=parseInt(n,10));const i=e.getAttribute("hold");i&&(this.hold=parseInt(i,10));const r=e.getAttribute("wait");r&&(this.wait=parseInt(r,10));const o=e.getAttribute("inactivity");o&&(this.inactivity=parseInt(o,10))}_disconnect(e){this._sendTerminate(e)}_doDisconnect(){this.sid=null,this.rid=Math.floor(4294967295*Math.random()),this._conn._sessionCachingSupported()&&window.sessionStorage.removeItem("strophe-bosh-session"),this._conn.nextValidRid(this.rid)}_emptyQueue(){return 0===this._requests.length}_callProtocolErrorHandlers(t){const n=e._getRequestStatus(t),i=this._conn.protocolErrorHandlers.HTTP[n];i&&i.call(this,n)}_hitError(e){this.errors++,F.warn("request errored, status: "+e+", number of errors: "+this.errors),this.errors>4&&this._conn._onDisconnectTimeout()}_no_auth_received(e){F.warn("Server did not yet offer a supported authentication mechanism. Sending a blank poll request."),e=e?e.bind(this._conn):this._conn._connect_cb.bind(this._conn);const t=this._buildBody();this._requests.push(new F.Request(t.tree(),this._onRequestStateChange.bind(this,e),t.tree().getAttribute("rid"))),this._throttledRequestHandler()}_onDisconnectTimeout(){this._abortAllRequests()}_abortAllRequests(){for(;this._requests.length>0;){const e=this._requests.pop();e.abort=!0,e.xhr.abort(),e.xhr.onreadystatechange=function(){}}}_onIdle(){const e=this._conn._data;if(this._conn.authenticated&&0===this._requests.length&&0===e.length&&!this._conn.disconnecting&&(F.debug("no requests during idle cycle, sending blank request"),e.push(null)),!this._conn.paused){if(this._requests.length<2&&e.length>0){const t=this._buildBody();for(let n=0;n<e.length;n++)null!==e[n]&&("restart"===e[n]?t.attrs({to:this._conn.domain,"xml:lang":"en","xmpp:restart":"true","xmlns:xmpp":F.NS.BOSH}):t.cnode(e[n]).up());delete this._conn._data,this._conn._data=[],this._requests.push(new F.Request(t.tree(),this._onRequestStateChange.bind(this,this._conn._dataRecv.bind(this._conn)),t.tree().getAttribute("rid"))),this._throttledRequestHandler()}if(this._requests.length>0){const e=this._requests[0].age();null!==this._requests[0].dead&&this._requests[0].timeDead()>Math.floor(F.SECONDARY_TIMEOUT*this.wait)&&this._throttledRequestHandler(),e>Math.floor(F.TIMEOUT*this.wait)&&(F.warn("Request "+this._requests[0].id+" timed out, over "+Math.floor(F.TIMEOUT*this.wait)+" seconds since last activity"),this._throttledRequestHandler())}}}static _getRequestStatus(e,t){let n;if(4===e.xhr.readyState)try{n=e.xhr.status}catch(e){F.error("Caught an error while retrieving a request\'s status, reqStatus: "+n)}return void 0===n&&(n="number"==typeof t?t:0),n}_onRequestStateChange(t,n){if(F.debug("request id "+n.id+"."+n.sends+" state changed to "+n.xhr.readyState),n.abort)return void(n.abort=!1);if(4!==n.xhr.readyState)return;const i=e._getRequestStatus(n);if(this.lastResponseHeaders=n.xhr.getAllResponseHeaders(),this._conn.disconnecting&&i>=400)return this._hitError(i),void this._callProtocolErrorHandlers(n);const r=this._requests[0]===n,o=this._requests[1]===n,s=i>0&&i<500,a=n.sends>this._conn.maxRetries;(s||a)&&(this._removeRequest(n),F.debug("request id "+n.id+" should now be removed")),200===i?((o||r&&this._requests.length>0&&this._requests[0].age()>Math.floor(F.SECONDARY_TIMEOUT*this.wait))&&this._restartRequest(0),this._conn.nextValidRid(Number(n.rid)+1),F.debug("request id "+n.id+"."+n.sends+" got 200"),t(n),this.errors=0):0===i||i>=400&&i<600||i>=12e3?(F.error("request id "+n.id+"."+n.sends+" error "+i+" happened"),this._hitError(i),this._callProtocolErrorHandlers(n),i>=400&&i<500&&(this._conn._changeConnectStatus(F.Status.DISCONNECTING,null),this._conn._doDisconnect())):F.error("request id "+n.id+"."+n.sends+" error "+i+" happened"),s||a?a&&!this._conn.connected&&this._conn._changeConnectStatus(F.Status.CONNFAIL,"giving-up"):this._throttledRequestHandler()}_processRequest(t){let n=this._requests[t];const i=e._getRequestStatus(n,-1);if(n.sends>this._conn.maxRetries)return void this._conn._onDisconnectTimeout();const r=n.age(),o=!isNaN(r)&&r>Math.floor(F.TIMEOUT*this.wait),s=null!==n.dead&&n.timeDead()>Math.floor(F.SECONDARY_TIMEOUT*this.wait),a=4===n.xhr.readyState&&(i<1||i>=500);if((o||s||a)&&(s&&F.error(`Request ${this._requests[t].id} timed out (secondary), restarting`),n.abort=!0,n.xhr.abort(),n.xhr.onreadystatechange=function(){},this._requests[t]=new F.Request(n.xmlData,n.origFunc,n.rid,n.sends),n=this._requests[t]),0===n.xhr.readyState){F.debug("request id "+n.id+"."+n.sends+" posting");try{const e=this._conn.options.contentType||"text/xml; charset=utf-8";n.xhr.open("POST",this._conn.service,!this._conn.options.sync),void 0!==n.xhr.setRequestHeader&&n.xhr.setRequestHeader("Content-Type",e),this._conn.options.withCredentials&&(n.xhr.withCredentials=!0)}catch(e){return F.error("XHR open failed: "+e.toString()),this._conn.connected||this._conn._changeConnectStatus(F.Status.CONNFAIL,"bad-service"),void this._conn.disconnect()}const e=()=>{if(n.date=new Date,this._conn.options.customHeaders){const e=this._conn.options.customHeaders;for(const t in e)Object.prototype.hasOwnProperty.call(e,t)&&n.xhr.setRequestHeader(t,e[t])}n.xhr.send(n.data)};if(n.sends>1){const t=1e3*Math.min(Math.floor(F.TIMEOUT*this.wait),Math.pow(n.sends,3));setTimeout((function(){e()}),t)}else e();n.sends++,this._conn.xmlOutput!==F.Connection.prototype.xmlOutput&&(n.xmlData.nodeName===this.strip&&n.xmlData.childNodes.length?this._conn.xmlOutput(n.xmlData.childNodes[0]):this._conn.xmlOutput(n.xmlData)),this._conn.rawOutput!==F.Connection.prototype.rawOutput&&this._conn.rawOutput(n.data)}else F.debug("_processRequest: "+(0===t?"first":"second")+" request has readyState of "+n.xhr.readyState)}_removeRequest(e){F.debug("removing request");for(let t=this._requests.length-1;t>=0;t--)e===this._requests[t]&&this._requests.splice(t,1);e.xhr.onreadystatechange=function(){},this._throttledRequestHandler()}_restartRequest(e){const t=this._requests[e];null===t.dead&&(t.dead=new Date),this._processRequest(e)}_reqToData(e){try{return e.getResponse()}catch(e){if("parsererror"!==e.message)throw e;this._conn.disconnect("strophe-parsererror")}}_sendTerminate(e){F.debug("_sendTerminate was called");const t=this._buildBody().attrs({type:"terminate"});e&&t.cnode(e.tree());const n=new F.Request(t.tree(),this._onRequestStateChange.bind(this,this._conn._dataRecv.bind(this._conn)),t.tree().getAttribute("rid"));this._requests.push(n),this._throttledRequestHandler()}_send(){clearTimeout(this._conn._idleTimeout),this._throttledRequestHandler(),this._conn._idleTimeout=setTimeout((()=>this._conn._onIdle()),100)}_sendRestart(){this._throttledRequestHandler(),clearTimeout(this._conn._idleTimeout)}_throttledRequestHandler(){this._requests?F.debug("_throttledRequestHandler called with "+this._requests.length+" requests"):F.debug("_throttledRequestHandler called with undefined requests"),this._requests&&0!==this._requests.length&&(this._requests.length>0&&this._processRequest(0),this._requests.length>1&&Math.abs(this._requests[0].rid-this._requests[1].rid)<this.window&&this._processRequest(1))}},F.Bosh.prototype.strip=null,F.Websocket=class{constructor(e){this._conn=e,this.strip="wrapper";const t=e.service;if(0!==t.indexOf("ws:")&&0!==t.indexOf("wss:")){let n="";"ws"===e.options.protocol&&"https:"!==window.location.protocol?n+="ws":n+="wss",n+="://"+window.location.host,0!==t.indexOf("/")?n+=window.location.pathname+t:n+=t,e.service=n}}_buildStream(){return k("open",{xmlns:F.NS.FRAMING,to:this._conn.domain,version:"1.0"})}_checkStreamError(e,t){let n;if(n=e.getElementsByTagNameNS?e.getElementsByTagNameNS(F.NS.STREAM,"error"):e.getElementsByTagName("stream:error"),0===n.length)return!1;const i=n[0];let r="",o="";for(let e=0;e<i.childNodes.length;e++){const t=i.childNodes[e];if("urn:ietf:params:xml:ns:xmpp-streams"!==t.getAttribute("xmlns"))break;"text"===t.nodeName?o=t.textContent:r=t.nodeName}let s="WebSocket stream error: ";return s+=r||"unknown",o&&(s+=" - "+o),F.error(s),this._conn._changeConnectStatus(t,r),this._conn._doDisconnect(),!0}_reset(){}_connect(){this._closeSocket(),this.socket=new i(this._conn.service,"xmpp"),this.socket.onopen=()=>this._onOpen(),this.socket.onerror=e=>this._onError(e),this.socket.onclose=e=>this._onClose(e),this.socket.onmessage=e=>this._onInitialMessage(e)}_connect_cb(e){if(this._checkStreamError(e,F.Status.CONNFAIL))return F.Status.CONNFAIL}_handleStreamStart(e){let t=!1;const n=e.getAttribute("xmlns");"string"!=typeof n?t="Missing xmlns in <open />":n!==F.NS.FRAMING&&(t="Wrong xmlns in <open />: "+n);const i=e.getAttribute("version");return"string"!=typeof i?t="Missing version in <open />":"1.0"!==i&&(t="Wrong version in <open />: "+i),!t||(this._conn._changeConnectStatus(F.Status.CONNFAIL,t),this._conn._doDisconnect(),!1)}_onInitialMessage(e){if(0===e.data.indexOf("<open ")||0===e.data.indexOf("<?xml")){const t=e.data.replace(/^(<\\?.*?\\?>\\s*)*/,"");if(""===t)return;const n=(new r).parseFromString(t,"text/xml").documentElement;this._conn.xmlInput(n),this._conn.rawInput(e.data),this._handleStreamStart(n)&&this._connect_cb(n)}else if(0===e.data.indexOf("<close ")){const t=(new r).parseFromString(e.data,"text/xml").documentElement;this._conn.xmlInput(t),this._conn.rawInput(e.data);const n=t.getAttribute("see-other-uri");if(n){const e=this._conn.service;(e.indexOf("wss:")>=0&&n.indexOf("wss:")>=0||e.indexOf("ws:")>=0)&&(this._conn._changeConnectStatus(F.Status.REDIRECT,"Received see-other-uri, resetting connection"),this._conn.reset(),this._conn.service=n,this._connect())}else this._conn._changeConnectStatus(F.Status.CONNFAIL,"Received closing stream"),this._conn._doDisconnect()}else{this._replaceMessageHandler();const t=this._streamWrap(e.data),n=(new r).parseFromString(t,"text/xml").documentElement;this._conn._connect_cb(n,null,e.data)}}_replaceMessageHandler(){this.socket.onmessage=e=>this._onMessage(e)}_disconnect(e){if(this.socket&&this.socket.readyState!==i.CLOSED){e&&this._conn.send(e);const t=k("close",{xmlns:F.NS.FRAMING});this._conn.xmlOutput(t.tree());const n=F.serialize(t);this._conn.rawOutput(n);try{this.socket.send(n)}catch(e){F.warn("Couldn\'t send <close /> tag.")}}setTimeout((()=>this._conn._doDisconnect()),0)}_doDisconnect(){F.debug("WebSockets _doDisconnect was called"),this._closeSocket()}_streamWrap(e){return"<wrapper>"+e+"</wrapper>"}_closeSocket(){if(this.socket)try{this.socket.onclose=null,this.socket.onerror=null,this.socket.onmessage=null,this.socket.close()}catch(e){F.debug(e.message)}this.socket=null}_emptyQueue(){return!0}_onClose(e){this._conn.connected&&!this._conn.disconnecting?(F.error("Websocket closed unexpectedly"),this._conn._doDisconnect()):e&&1006===e.code&&!this._conn.connected&&this.socket?(F.error("Websocket closed unexcectedly"),this._conn._changeConnectStatus(F.Status.CONNFAIL,"The WebSocket connection could not be established or was disconnected."),this._conn._doDisconnect()):F.debug("Websocket closed")}_no_auth_received(e){F.error("Server did not offer a supported authentication mechanism"),this._conn._changeConnectStatus(F.Status.CONNFAIL,F.ErrorCondition.NO_AUTH_MECH),e&&e.call(this._conn),this._conn._doDisconnect()}_onDisconnectTimeout(){}_abortAllRequests(){}_onError(e){F.error("Websocket error "+JSON.stringify(e)),this._conn._changeConnectStatus(F.Status.CONNFAIL,"The WebSocket connection could not be established or was disconnected."),this._disconnect()}_onIdle(){const e=this._conn._data;if(e.length>0&&!this._conn.paused){for(let t=0;t<e.length;t++)if(null!==e[t]){let n;n="restart"===e[t]?this._buildStream().tree():e[t];const i=F.serialize(n);this._conn.xmlOutput(n),this._conn.rawOutput(i),this.socket.send(i)}this._conn._data=[]}}_onMessage(e){let t;const n=\'<close xmlns="urn:ietf:params:xml:ns:xmpp-framing" />\';if(e.data===n)return this._conn.rawInput(n),this._conn.xmlInput(e),void(this._conn.disconnecting||this._conn._doDisconnect());if(0===e.data.search("<open ")){if(t=(new r).parseFromString(e.data,"text/xml").documentElement,!this._handleStreamStart(t))return}else{const n=this._streamWrap(e.data);t=(new r).parseFromString(n,"text/xml").documentElement}return this._checkStreamError(t,F.Status.ERROR)?void 0:this._conn.disconnecting&&"presence"===t.firstChild.nodeName&&"unavailable"===t.firstChild.getAttribute("type")?(this._conn.xmlInput(t),void this._conn.rawInput(F.serialize(t))):void this._conn._dataRecv(t,e.data)}_onOpen(){F.debug("Websocket open");const e=this._buildStream();this._conn.xmlOutput(e.tree());const t=F.serialize(e);this._conn.rawOutput(t),this.socket.send(t)}_reqToData(e){return e}_send(){this._conn.flush()}_sendRestart(){clearTimeout(this._conn._idleTimeout),this._conn._onIdle.bind(this._conn)()}};const V={};V.debug=F.LogLevel.DEBUG,V.info=F.LogLevel.INFO,V.warn=F.LogLevel.WARN,V.error=F.LogLevel.ERROR,V.fatal=F.LogLevel.FATAL,F.WorkerWebsocket=class extends F.Websocket{constructor(e){super(e),this._conn=e,this.worker=new SharedWorker(this._conn.options.worker,"Strophe XMPP Connection"),this.worker.onerror=e=>{var t;null===(t=console)||void 0===t||t.error(e),F.log(F.LogLevel.ERROR,`Shared Worker Error: ${e}`)}}get socket(){return{send:e=>this.worker.port.postMessage(["send",e])}}_connect(){this._messageHandler=e=>this._onInitialMessage(e),this.worker.port.start(),this.worker.port.onmessage=e=>this._onWorkerMessage(e),this.worker.port.postMessage(["_connect",this._conn.service,this._conn.jid])}_attach(e){this._messageHandler=e=>this._onMessage(e),this._conn.connect_callback=e,this.worker.port.start(),this.worker.port.onmessage=e=>this._onWorkerMessage(e),this.worker.port.postMessage(["_attach",this._conn.service])}_attachCallback(e,t){e===F.Status.ATTACHED?(this._conn.jid=t,this._conn.authenticated=!0,this._conn.connected=!0,this._conn.restored=!0,this._conn._changeConnectStatus(F.Status.ATTACHED)):e===F.Status.ATTACHFAIL&&(this._conn.authenticated=!1,this._conn.connected=!1,this._conn.restored=!1,this._conn._changeConnectStatus(F.Status.ATTACHFAIL))}_disconnect(e,t){t&&this._conn.send(t);const n=k("close",{xmlns:F.NS.FRAMING});this._conn.xmlOutput(n.tree());const i=F.serialize(n);this._conn.rawOutput(i),this.worker.port.postMessage(["send",i]),this._conn._doDisconnect()}_onClose(e){this._conn.connected&&!this._conn.disconnecting?(F.error("Websocket closed unexpectedly"),this._conn._doDisconnect()):e&&1006===e.code&&!this._conn.connected?(F.error("Websocket closed unexcectedly"),this._conn._changeConnectStatus(F.Status.CONNFAIL,"The WebSocket connection could not be established or was disconnected."),this._conn._doDisconnect()):F.debug("Websocket closed")}_closeSocket(){this.worker.port.postMessage(["_closeSocket"])}_replaceMessageHandler(){this._messageHandler=e=>this._onMessage(e)}_onWorkerMessage(e){const{data:t}=e,n=t[0];if("_onMessage"===n)this._messageHandler(t[1]);else if(n in this)try{this[n].apply(this,e.data.slice(1))}catch(e){F.log(F.LogLevel.ERROR,e)}else if("log"===n){const e=t[1],n=t[2];F.log(V[e],n)}else F.log(F.LogLevel.ERROR,`Found unhandled service worker message: ${t}`)}},t.$build=j.$build,t.$iq=j.$iq,t.$msg=j.$msg,t.$pres=j.$pres,t.Strophe=j.Strophe;const{b64_sha1:U}=A;e.$build=k,e.$iq=M,e.$msg=N,e.$pres=L,e.Strophe=F,e.b64_sha1=U,Object.defineProperty(e,"__esModule",{value:!0})}(t)},352:function(e,t,n){!function(e){"use strict";e.Strophe.addConnectionPlugin("disco",{_connection:null,_identities:[],_features:[],_items:[],init:function(t){this._connection=t,this._identities=[],this._features=[],this._items=[],t.addHandler(this._onDiscoInfo.bind(this),e.Strophe.NS.DISCO_INFO,"iq","get",null,null),t.addHandler(this._onDiscoItems.bind(this),e.Strophe.NS.DISCO_ITEMS,"iq","get",null,null)},addIdentity:function(e,t,n,i){for(var r=0;r<this._identities.length;r++)if(this._identities[r].category==e&&this._identities[r].type==t&&this._identities[r].name==n&&this._identities[r].lang==i)return!1;return this._identities.push({category:e,type:t,name:n,lang:i}),!0},addFeature:function(e){for(var t=0;t<this._features.length;t++)if(this._features[t]==e)return!1;return this._features.push(e),!0},removeFeature:function(e){for(var t=0;t<this._features.length;t++)if(this._features[t]===e)return this._features.splice(t,1),!0;return!1},addItem:function(e,t,n,i){return!(n&&!i||(this._items.push({jid:e,name:t,node:n,call_back:i}),0))},info:function(t,n,i,r,o){var s={xmlns:e.Strophe.NS.DISCO_INFO};n&&(s.node=n);var a=e.$iq({from:this._connection.jid,to:t,type:"get"}).c("query",s);this._connection.sendIQ(a,i,r,o)},items:function(t,n,i,r,o){var s={xmlns:e.Strophe.NS.DISCO_ITEMS};n&&(s.node=n);var a=e.$iq({from:this._connection.jid,to:t,type:"get"}).c("query",s);this._connection.sendIQ(a,i,r,o)},_buildIQResult:function(t,n){var i=t.getAttribute("id"),r=t.getAttribute("from"),o=e.$iq({type:"result",id:i});return null!==r&&o.attrs({to:r}),o.c("query",n)},_onDiscoInfo:function(t){var n,i=t.getElementsByTagName("query")[0].getAttribute("node"),r={xmlns:e.Strophe.NS.DISCO_INFO};i&&(r.node=i);var o=this._buildIQResult(t,r);for(n=0;n<this._identities.length;n++)r={category:this._identities[n].category,type:this._identities[n].type},this._identities[n].name&&(r.name=this._identities[n].name),this._identities[n].lang&&(r["xml:lang"]=this._identities[n].lang),o.c("identity",r).up();for(n=0;n<this._features.length;n++)o.c("feature",{var:this._features[n]}).up();return this._connection.send(o.tree()),!0},_onDiscoItems:function(t){var n,i,r={xmlns:e.Strophe.NS.DISCO_ITEMS},o=t.getElementsByTagName("query")[0].getAttribute("node");if(o){for(r.node=o,n=[],i=0;i<this._items.length;i++)if(this._items[i].node==o){n=this._items[i].call_back(t);break}}else n=this._items;var s=this._buildIQResult(t,r);for(i=0;i<n.length;i++){var a={jid:n[i].jid};n[i].name&&(a.name=n[i].name),n[i].node&&(a.node=n[i].node),s.c("item",a).up()}return this._connection.send(s.tree()),!0}})}(n(33))},617:function(e,t,n){!function(e){"use strict";e.Strophe.addConnectionPlugin("streamManagement",{logging:!1,autoSendCountOnEveryIncomingStanza:!1,requestResponseInterval:5,_c:null,_NS:"urn:xmpp:sm:3",_isStreamManagementEnabled:!1,_serverProcesssedStanzasCounter:null,_clientProcessedStanzasCounter:null,_clientSentStanzasCounter:null,_originalXMLOutput:null,_requestHandler:null,_incomingHandler:null,_requestResponseIntervalCount:0,_isSupported:!1,_unacknowledgedStanzas:[],_acknowledgedStanzaListeners:[],addAcknowledgedStanzaListener:function(e){this._acknowledgedStanzaListeners.push(e)},enable:function(t){if(!this._isSupported)throw new Error("The server doesn\'t support urn:xmpp:sm:3 namespace");if(this._connectionStatus!==e.Strophe.Status.CONNECTED)throw new Error("enable() can only be called in the CONNECTED state");this._c.send(e.$build("enable",{xmlns:this._NS,resume:t})),this._c.flush(),this._c.pause()},getResumeToken:function(){return this._resumeToken},isSupported(){return this._isSupported},resume:function(){if(!this.getResumeToken())throw new Error("No resume token");if(this._connectionStatus!==e.Strophe.Status.DISCONNECTED)throw new Error("resume() can only be called in the DISCONNECTED state");this._c.options.explicitResourceBinding=!0,this._resuming=!0,this._originalConnect.apply(this._c,this._connectArgs)},requestAcknowledgement:function(){if(this._connectionStatus!==e.Strophe.Status.CONNECTED)throw new Error("requestAcknowledgement() can only be called in the CONNECTED state");this._requestResponseIntervalCount=0,this._c.send(e.$build("r",{xmlns:this._NS}))},getOutgoingCounter:function(){return this._clientSentStanzasCounter},getIncomingCounter:function(){return this._clientProcessedStanzasCounter},init:function(t){this._c=t,e.Strophe.addNamespace("SM",this._NS),this._originalXMLOutput=this._c.xmlOutput,this._c.xmlOutput=this.xmlOutput.bind(this),this._originalConnect=this._c.connect,this._c.connect=this._interceptConnectArgs.bind(this),this._originalOnStreamFeaturesAfterSASL=this._c._onStreamFeaturesAfterSASL,this._c._onStreamFeaturesAfterSASL=this._onStreamFeaturesAfterSASL.bind(this),this._originalDoDisconnect=this._c._doDisconnect,this._c._doDisconnect=this._interceptDoDisconnect.bind(this),this._originalDisconnect=this._c.disconnect,this._c.disconnect=this._interceptDisconnect.bind(this)},_interceptDisconnect:function(){this._resumeToken=void 0,this._originalDisconnect.apply(this._c,arguments)},_interceptDoDisconnect:function(){this.getResumeToken()&&!this._resuming&&this._c.connected&&!this._c.disconnecting&&(this._resumeState={handlers:this._c.handlers,timedHandlers:this._c.timedHandlers,removeTimeds:this._c.removeTimeds,removeHandlers:this._c.removeHandlers,addTimeds:this._c.addTimeds,addHandlers:this._c.addHandlers},this._storedJid=this._c.jid,this.logging&&e.Strophe.debug("SM stored resume state, handler count: "+this._resumeState.handlers.length)),this._c._data=[],this._originalDoDisconnect.apply(this._c,arguments)},_interceptConnectArgs:function(){this._connectArgs=arguments,this._originalConnect.apply(this._c,arguments)},_onStreamFeaturesAfterSASL:function(e){return this._isSupported=e.getElementsByTagNameNS(this._NS,"sm").length>0,this._originalOnStreamFeaturesAfterSASL.apply(this._c,arguments)},statusChanged:function(t){if(this._connectionStatus=t,this.getResumeToken()||t!==e.Strophe.Status.CONNECTED&&t!==e.Strophe.Status.DISCONNECTED)if(t===e.Strophe.Status.BINDREQUIRED){this._c.jid=this._storedJid;for(const e of(this._resumeState.handlers||[]).concat(this._resumeState.addHandlers||[]))this._c._addSysHandler(e.handler,e.ns,e.name,e.type,e.id);for(const e of(this._resumeState.timedHandlers||[]).concat(this._resumeState.addTimeds))this._c.addTimedHandler(e.period,e.handler);for(const e of(this._resumeState.removeTimeds||[]).concat(this._resumeState.removeHandlers||[]))this._c.deleteTimedHandler(e);this._c.send(e.$build("resume",{xmlns:this._NS,h:this._clientProcessedStanzasCounter,previd:this._resumeToken})),this._c.flush()}else t===e.Strophe.Status.ERROR&&(this.logging&&e.Strophe.debug("SM cleared resume token on error"),this._resumeToken=void 0);else this.logging&&e.Strophe.debug("SM reset state"),this._serverProcesssedStanzasCounter=0,this._clientProcessedStanzasCounter=0,this._clientSentStanzasCounter=0,this._isStreamManagementEnabled=!1,this._requestResponseIntervalCount=0,this._resuming=!1,t===e.Strophe.Status.DISCONNECTED&&(this._isSupported=!1),this._unacknowledgedStanzas=[],this._requestHandler&&this._c.deleteHandler(this._requestHandler),this._incomingHandler&&this._c.deleteHandler(this._incomingHandler),this._requestHandler=this._c.addHandler(this._handleServerRequestHandler.bind(this),this._NS,"r"),this._ackHandler=this._c.addHandler(this._handleServerAck.bind(this),this._NS,"a"),this._incomingHandler=this._c.addHandler(this._incomingStanzaHandler.bind(this)),this._enabledHandler=this._c._addSysHandler(this._handleEnabled.bind(this),this._NS,"enabled"),this._resumeFailedHandler=this._c._addSysHandler(this._handleResumeFailed.bind(this),this._NS,"failed"),this._resumedHandler=this._c._addSysHandler(this._handleResumed.bind(this),this._NS,"resumed")},xmlOutput:function(t){return(e.Strophe.isTagEqual(t,"iq")||e.Strophe.isTagEqual(t,"presence")||e.Strophe.isTagEqual(t,"message"))&&this._increaseSentStanzasCounter(t),this._originalXMLOutput.call(this._c,t)},_handleEnabled:function(e){return this._isStreamManagementEnabled=!0,this._resumeToken="true"===e.getAttribute("resume")&&e.getAttribute("id"),this._c.resume(),!0},_handleResumeFailed:function(t){const n=t&&(t.firstElementChild&&t.firstElementChild.tagName||t.firstChild&&t.firstChild.tagName);return this._c._changeConnectStatus(e.Strophe.Status.ERROR,n,t),this._c._doDisconnect(),!0},_handleResumed:function(t){var n=parseInt(t.getAttribute("h"));if(this._handleAcknowledgedStanzas(n,this._serverProcesssedStanzasCounter),this._resuming=!1,this._c.do_bind=!1,this._c.authenticated=!0,this._c.restored=!0,this._unacknowledgedStanzas.length>0){this.logging&&e.Strophe.debug("SM Sending unacknowledged stanzas",this._unacknowledgedStanzas);for(const e of this._unacknowledgedStanzas)this._c.send(e)}else this.logging&&e.Strophe.debug("SM No unacknowledged stanzas",this._unacknowledgedStanzas);return this._c._changeConnectStatus(e.Strophe.Status.CONNECTED,null),!0},_incomingStanzaHandler:function(t){return(e.Strophe.isTagEqual(t,"iq")||e.Strophe.isTagEqual(t,"presence")||e.Strophe.isTagEqual(t,"message"))&&(this._increaseReceivedStanzasCounter(),this.autoSendCountOnEveryIncomingStanza&&this._answerProcessedStanzas()),!0},_handleAcknowledgedStanzas:function(t,n){var i=t-n;i<0&&this._throwError("New reported stanza count lower than previous. New: "+t+" - Previous: "+n),i>this._unacknowledgedStanzas.length&&this._throwError("Higher reported acknowledge count than unacknowledged stanzas. Reported Acknowledge Count: "+i+" - Unacknowledge Stanza Count: "+this._unacknowledgedStanzas.length+" - New: "+t+" - Previous: "+n);for(var r=0;r<i;r++)for(var o=this._unacknowledgedStanzas.shift(),s=0;s<this._acknowledgedStanzaListeners.length;s++)this._acknowledgedStanzaListeners[s](o);this.logging&&this._unacknowledgedStanzas.length>0&&e.Strophe.warn("SM Unacknowledged stanzas",this._unacknowledgedStanzas),this._serverProcesssedStanzasCounter=t,this.requestResponseInterval>0&&(this._requestResponseIntervalCount=0)},_handleServerRequestHandler:function(){return this._answerProcessedStanzas(),!0},_handleServerAck:function(e){var t=parseInt(e.getAttribute("h"));return this._handleAcknowledgedStanzas(t,this._serverProcesssedStanzasCounter),!0},_answerProcessedStanzas:function(){this._isStreamManagementEnabled&&this._c.send(e.$build("a",{xmlns:this._NS,h:this._clientProcessedStanzasCounter}))},_increaseSentStanzasCounter:function(t){if(this._isStreamManagementEnabled){if(-1!==this._unacknowledgedStanzas.indexOf(t))return;this._unacknowledgedStanzas.push(t),this._clientSentStanzasCounter++,this.requestResponseInterval>0&&(this._requestResponseIntervalCount++,this._requestResponseIntervalCount===this.requestResponseInterval&&setTimeout((()=>{this._connectionStatus===e.Strophe.Status.CONNECTED&&this.requestAcknowledgement()}),1))}},_increaseReceivedStanzasCounter:function(){this._isStreamManagementEnabled&&this._clientProcessedStanzasCounter++},_throwError:function(t){throw e.Strophe.error(t),new Error(t)}})}(n(33))},144:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;const n=[];for(let e=0;e<256;++e)n.push((e+256).toString(16).substr(1));t.default=function(e,t){const i=t||0,r=n;return(r[e[i+0]]+r[e[i+1]]+r[e[i+2]]+r[e[i+3]]+"-"+r[e[i+4]]+r[e[i+5]]+"-"+r[e[i+6]]+r[e[i+7]]+"-"+r[e[i+8]]+r[e[i+9]]+"-"+r[e[i+10]]+r[e[i+11]]+r[e[i+12]]+r[e[i+13]]+r[e[i+14]]+r[e[i+15]]).toLowerCase()}},433:(e,t,n)=>{"use strict";Object.defineProperty(t,"v1",{enumerable:!0,get:function(){return i.default}}),Object.defineProperty(t,"v3",{enumerable:!0,get:function(){return r.default}}),Object.defineProperty(t,"v4",{enumerable:!0,get:function(){return o.default}}),Object.defineProperty(t,"v5",{enumerable:!0,get:function(){return s.default}});var i=a(n(423)),r=a(n(89)),o=a(n(600)),s=a(n(400));function a(e){return e&&e.__esModule?e:{default:e}}},862:(e,t)=>{"use strict";function n(e){return 14+(e+64>>>9<<4)+1}function i(e,t){const n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}function r(e,t,n,r,o,s){return i((a=i(i(t,e),i(r,s)))<<(d=o)|a>>>32-d,n);var a,d}function o(e,t,n,i,o,s,a){return r(t&n|~t&i,e,t,o,s,a)}function s(e,t,n,i,o,s,a){return r(t&i|n&~i,e,t,o,s,a)}function a(e,t,n,i,o,s,a){return r(t^n^i,e,t,o,s,a)}function d(e,t,n,i,o,s,a){return r(n^(t|~i),e,t,o,s,a)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default=function(e){if("string"==typeof e){const t=unescape(encodeURIComponent(e));e=new Uint8Array(t.length);for(let n=0;n<t.length;++n)e[n]=t.charCodeAt(n)}return function(e){const t=[],n=32*e.length,i="0123456789abcdef";for(let r=0;r<n;r+=8){const n=e[r>>5]>>>r%32&255,o=parseInt(i.charAt(n>>>4&15)+i.charAt(15&n),16);t.push(o)}return t}(function(e,t){e[t>>5]|=128<<t%32,e[n(t)-1]=t;let r=1732584193,c=-271733879,l=-1732584194,h=271733878;for(let t=0;t<e.length;t+=16){const n=r,u=c,p=l,m=h;r=o(r,c,l,h,e[t],7,-680876936),h=o(h,r,c,l,e[t+1],12,-389564586),l=o(l,h,r,c,e[t+2],17,606105819),c=o(c,l,h,r,e[t+3],22,-1044525330),r=o(r,c,l,h,e[t+4],7,-176418897),h=o(h,r,c,l,e[t+5],12,1200080426),l=o(l,h,r,c,e[t+6],17,-1473231341),c=o(c,l,h,r,e[t+7],22,-45705983),r=o(r,c,l,h,e[t+8],7,1770035416),h=o(h,r,c,l,e[t+9],12,-1958414417),l=o(l,h,r,c,e[t+10],17,-42063),c=o(c,l,h,r,e[t+11],22,-1990404162),r=o(r,c,l,h,e[t+12],7,1804603682),h=o(h,r,c,l,e[t+13],12,-40341101),l=o(l,h,r,c,e[t+14],17,-1502002290),c=o(c,l,h,r,e[t+15],22,1236535329),r=s(r,c,l,h,e[t+1],5,-165796510),h=s(h,r,c,l,e[t+6],9,-1069501632),l=s(l,h,r,c,e[t+11],14,643717713),c=s(c,l,h,r,e[t],20,-373897302),r=s(r,c,l,h,e[t+5],5,-701558691),h=s(h,r,c,l,e[t+10],9,38016083),l=s(l,h,r,c,e[t+15],14,-660478335),c=s(c,l,h,r,e[t+4],20,-405537848),r=s(r,c,l,h,e[t+9],5,568446438),h=s(h,r,c,l,e[t+14],9,-1019803690),l=s(l,h,r,c,e[t+3],14,-187363961),c=s(c,l,h,r,e[t+8],20,1163531501),r=s(r,c,l,h,e[t+13],5,-1444681467),h=s(h,r,c,l,e[t+2],9,-51403784),l=s(l,h,r,c,e[t+7],14,1735328473),c=s(c,l,h,r,e[t+12],20,-1926607734),r=a(r,c,l,h,e[t+5],4,-378558),h=a(h,r,c,l,e[t+8],11,-2022574463),l=a(l,h,r,c,e[t+11],16,1839030562),c=a(c,l,h,r,e[t+14],23,-35309556),r=a(r,c,l,h,e[t+1],4,-1530992060),h=a(h,r,c,l,e[t+4],11,1272893353),l=a(l,h,r,c,e[t+7],16,-155497632),c=a(c,l,h,r,e[t+10],23,-1094730640),r=a(r,c,l,h,e[t+13],4,681279174),h=a(h,r,c,l,e[t],11,-358537222),l=a(l,h,r,c,e[t+3],16,-722521979),c=a(c,l,h,r,e[t+6],23,76029189),r=a(r,c,l,h,e[t+9],4,-640364487),h=a(h,r,c,l,e[t+12],11,-421815835),l=a(l,h,r,c,e[t+15],16,530742520),c=a(c,l,h,r,e[t+2],23,-995338651),r=d(r,c,l,h,e[t],6,-198630844),h=d(h,r,c,l,e[t+7],10,1126891415),l=d(l,h,r,c,e[t+14],15,-1416354905),c=d(c,l,h,r,e[t+5],21,-57434055),r=d(r,c,l,h,e[t+12],6,1700485571),h=d(h,r,c,l,e[t+3],10,-1894986606),l=d(l,h,r,c,e[t+10],15,-1051523),c=d(c,l,h,r,e[t+1],21,-2054922799),r=d(r,c,l,h,e[t+8],6,1873313359),h=d(h,r,c,l,e[t+15],10,-30611744),l=d(l,h,r,c,e[t+6],15,-1560198380),c=d(c,l,h,r,e[t+13],21,1309151649),r=d(r,c,l,h,e[t+4],6,-145523070),h=d(h,r,c,l,e[t+11],10,-1120210379),l=d(l,h,r,c,e[t+2],15,718787259),c=d(c,l,h,r,e[t+9],21,-343485551),r=i(r,n),c=i(c,u),l=i(l,p),h=i(h,m)}return[r,c,l,h]}(function(e){if(0===e.length)return[];const t=8*e.length,i=new Uint32Array(n(t));for(let n=0;n<t;n+=8)i[n>>5]|=(255&e[n/8])<<n%32;return i}(e),8*e.length))}},294:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){if(!n)throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return n(i)};const n="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto),i=new Uint8Array(16)},585:(e,t)=>{"use strict";function n(e,t,n,i){switch(e){case 0:return t&n^~t&i;case 1:case 3:return t^n^i;case 2:return t&n^t&i^n&i}}function i(e,t){return e<<t|e>>>32-t}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default=function(e){const t=[1518500249,1859775393,2400959708,3395469782],r=[1732584193,4023233417,2562383102,271733878,3285377520];if("string"==typeof e){const t=unescape(encodeURIComponent(e));e=[];for(let n=0;n<t.length;++n)e.push(t.charCodeAt(n))}e.push(128);const o=e.length/4+2,s=Math.ceil(o/16),a=new Array(s);for(let t=0;t<s;++t){const n=new Uint32Array(16);for(let i=0;i<16;++i)n[i]=e[64*t+4*i]<<24|e[64*t+4*i+1]<<16|e[64*t+4*i+2]<<8|e[64*t+4*i+3];a[t]=n}a[s-1][14]=8*(e.length-1)/Math.pow(2,32),a[s-1][14]=Math.floor(a[s-1][14]),a[s-1][15]=8*(e.length-1)&4294967295;for(let e=0;e<s;++e){const o=new Uint32Array(80);for(let t=0;t<16;++t)o[t]=a[e][t];for(let e=16;e<80;++e)o[e]=i(o[e-3]^o[e-8]^o[e-14]^o[e-16],1);let s=r[0],d=r[1],c=r[2],l=r[3],h=r[4];for(let e=0;e<80;++e){const r=Math.floor(e/20),a=i(s,5)+n(r,d,c,l)+h+t[r]+o[e]>>>0;h=l,l=c,c=i(d,30)>>>0,d=s,s=a}r[0]=r[0]+s>>>0,r[1]=r[1]+d>>>0,r[2]=r[2]+c>>>0,r[3]=r[3]+l>>>0,r[4]=r[4]+h>>>0}return[r[0]>>24&255,r[0]>>16&255,r[0]>>8&255,255&r[0],r[1]>>24&255,r[1]>>16&255,r[1]>>8&255,255&r[1],r[2]>>24&255,r[2]>>16&255,r[2]>>8&255,255&r[2],r[3]>>24&255,r[3]>>16&255,r[3]>>8&255,255&r[3],r[4]>>24&255,r[4]>>16&255,r[4]>>8&255,255&r[4]]}},423:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=o(n(294)),r=o(n(144));function o(e){return e&&e.__esModule?e:{default:e}}let s,a,d=0,c=0;t.default=function(e,t,n){let o=t&&n||0;const l=t||[];let h=(e=e||{}).node||s,u=void 0!==e.clockseq?e.clockseq:a;if(null==h||null==u){const t=e.random||(e.rng||i.default)();null==h&&(h=s=[1|t[0],t[1],t[2],t[3],t[4],t[5]]),null==u&&(u=a=16383&(t[6]<<8|t[7]))}let p=void 0!==e.msecs?e.msecs:Date.now(),m=void 0!==e.nsecs?e.nsecs:c+1;const g=p-d+(m-c)/1e4;if(g<0&&void 0===e.clockseq&&(u=u+1&16383),(g<0||p>d)&&void 0===e.nsecs&&(m=0),m>=1e4)throw new Error("uuid.v1(): Can\'t create more than 10M uuids/sec");d=p,c=m,a=u,p+=122192928e5;const f=(1e4*(268435455&p)+m)%4294967296;l[o++]=f>>>24&255,l[o++]=f>>>16&255,l[o++]=f>>>8&255,l[o++]=255&f;const v=p/4294967296*1e4&268435455;l[o++]=v>>>8&255,l[o++]=255&v,l[o++]=v>>>24&15|16,l[o++]=v>>>16&255,l[o++]=u>>>8|128,l[o++]=255&u;for(let e=0;e<6;++e)l[o+e]=h[e];return t||(0,r.default)(l)}},89:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=o(n(929)),r=o(n(862));function o(e){return e&&e.__esModule?e:{default:e}}var s=(0,i.default)("v3",48,r.default);t.default=s},929:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e,t,n){function i(e,i,o,s){const a=o&&s||0;if("string"==typeof e&&(e=function(e){e=unescape(encodeURIComponent(e));const t=[];for(let n=0;n<e.length;++n)t.push(e.charCodeAt(n));return t}(e)),"string"==typeof i&&(i=function(e){const t=[];return e.replace(/[a-fA-F0-9]{2}/g,(function(e){t.push(parseInt(e,16))})),t}(i)),!Array.isArray(e))throw TypeError("value must be an array of bytes");if(!Array.isArray(i)||16!==i.length)throw TypeError("namespace must be uuid string or an Array of 16 byte values");const d=n(i.concat(e));if(d[6]=15&d[6]|t,d[8]=63&d[8]|128,o)for(let e=0;e<16;++e)o[a+e]=d[e];return o||(0,r.default)(d)}try{i.name=e}catch(e){}return i.DNS=o,i.URL=s,i},t.URL=t.DNS=void 0;var i,r=(i=n(144))&&i.__esModule?i:{default:i};const o="6ba7b810-9dad-11d1-80b4-00c04fd430c8";t.DNS=o;const s="6ba7b811-9dad-11d1-80b4-00c04fd430c8";t.URL=s},600:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=o(n(294)),r=o(n(144));function o(e){return e&&e.__esModule?e:{default:e}}t.default=function(e,t,n){"string"==typeof e&&(t="binary"===e?new Uint8Array(16):null,e=null);const o=(e=e||{}).random||(e.rng||i.default)();if(o[6]=15&o[6]|64,o[8]=63&o[8]|128,t){const e=n||0;for(let n=0;n<16;++n)t[e+n]=o[n];return t}return(0,r.default)(o)}},400:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=o(n(929)),r=o(n(585));function o(e){return e&&e.__esModule?e:{default:e}}var s=(0,i.default)("v5",80,r.default);t.default=s},987:(e,t,n)=>{"use strict";let i;n.r(t),n.d(t,{AUDIO_OUTPUT_DEVICE_CHANGED:()=>T,AUDIO_SSRCS_REMAPPED:()=>O,CREATE_ANSWER_FAILED:()=>r,CREATE_OFFER_FAILED:()=>o,DATA_CHANNEL_CLOSED:()=>a,DATA_CHANNEL_OPEN:()=>s,DEVICE_LIST_AVAILABLE:()=>R,DEVICE_LIST_CHANGED:()=>C,DEVICE_LIST_WILL_CHANGE:()=>x,DOMINANT_SPEAKER_CHANGED:()=>c,ENDPOINT_CONN_STATUS_CHANGED:()=>d,ENDPOINT_MESSAGE_RECEIVED:()=>A,ENDPOINT_STATS_RECEIVED:()=>w,FORWARDED_SOURCES_CHANGED:()=>l,LASTN_VALUE_CHANGED:()=>p,LOCAL_TRACK_MAX_ENABLED_RESOLUTION_CHANGED:()=>g,LOCAL_TRACK_SSRC_UPDATED:()=>m,LOCAL_UFRAG_CHANGED:()=>I,PERMISSIONS_CHANGED:()=>h,REMOTE_TRACK_ADDED:()=>v,REMOTE_TRACK_MUTE:()=>_,REMOTE_TRACK_REMOVED:()=>y,REMOTE_TRACK_UNMUTE:()=>E,REMOTE_UFRAG_CHANGED:()=>P,RTCEvents:()=>i,SENDER_VIDEO_CONSTRAINTS_CHANGED:()=>u,SET_LOCAL_DESCRIPTION_FAILED:()=>S,SET_REMOTE_DESCRIPTION_FAILED:()=>b,TRACK_ATTACHED:()=>f,VIDEO_SSRCS_REMAPPED:()=>D,default:()=>k}),function(e){e.CREATE_ANSWER_FAILED="rtc.create_answer_failed",e.CREATE_OFFER_FAILED="rtc.create_offer_failed",e.DATA_CHANNEL_OPEN="rtc.data_channel_open",e.DATA_CHANNEL_CLOSED="rtc.data_channel_closed",e.ENDPOINT_CONN_STATUS_CHANGED="rtc.endpoint_conn_status_changed",e.DOMINANT_SPEAKER_CHANGED="rtc.dominant_speaker_changed",e.FORWARDED_SOURCES_CHANGED="rtc.forwarded_sources_changed",e.PERMISSIONS_CHANGED="rtc.permissions_changed",e.SENDER_VIDEO_CONSTRAINTS_CHANGED="rtc.sender_video_constraints_changed",e.LASTN_VALUE_CHANGED="rtc.lastn_value_changed",e.LOCAL_TRACK_SSRC_UPDATED="rtc.local_track_ssrc_updated",e.LOCAL_TRACK_MAX_ENABLED_RESOLUTION_CHANGED="rtc.local_track_max_enabled_resolution_changed",e.TRACK_ATTACHED="rtc.track_attached",e.REMOTE_TRACK_ADDED="rtc.remote_track_added",e.REMOTE_TRACK_MUTE="rtc.remote_track_mute",e.REMOTE_TRACK_REMOVED="rtc.remote_track_removed",e.REMOTE_TRACK_UNMUTE="rtc.remote_track_unmute",e.SET_LOCAL_DESCRIPTION_FAILED="rtc.set_local_description_failed",e.SET_REMOTE_DESCRIPTION_FAILED="rtc.set_remote_description_failed",e.AUDIO_OUTPUT_DEVICE_CHANGED="rtc.audio_output_device_changed",e.DEVICE_LIST_CHANGED="rtc.device_list_changed",e.DEVICE_LIST_WILL_CHANGE="rtc.device_list_will_change",e.DEVICE_LIST_AVAILABLE="rtc.device_list_available",e.ENDPOINT_MESSAGE_RECEIVED="rtc.endpoint_message_received",e.ENDPOINT_STATS_RECEIVED="rtc.endpoint_stats_received",e.LOCAL_UFRAG_CHANGED="rtc.local_ufrag_changed",e.REMOTE_UFRAG_CHANGED="rtc.remote_ufrag_changed",e.VIDEO_SSRCS_REMAPPED="rtc.video_ssrcs_remapped",e.AUDIO_SSRCS_REMAPPED="rtc.audio_ssrcs_remapped"}(i||(i={}));const r=i.CREATE_ANSWER_FAILED,o=i.CREATE_OFFER_FAILED,s=i.DATA_CHANNEL_OPEN,a=i.DATA_CHANNEL_CLOSED,d=i.ENDPOINT_CONN_STATUS_CHANGED,c=i.DOMINANT_SPEAKER_CHANGED,l=i.FORWARDED_SOURCES_CHANGED,h=i.PERMISSIONS_CHANGED,u=i.SENDER_VIDEO_CONSTRAINTS_CHANGED,p=i.LASTN_VALUE_CHANGED,m=i.LOCAL_TRACK_SSRC_UPDATED,g=i.LOCAL_TRACK_MAX_ENABLED_RESOLUTION_CHANGED,f=i.TRACK_ATTACHED,v=i.REMOTE_TRACK_ADDED,_=i.REMOTE_TRACK_MUTE,y=i.REMOTE_TRACK_REMOVED,E=i.REMOTE_TRACK_UNMUTE,S=i.SET_LOCAL_DESCRIPTION_FAILED,b=i.SET_REMOTE_DESCRIPTION_FAILED,T=i.AUDIO_OUTPUT_DEVICE_CHANGED,C=i.DEVICE_LIST_CHANGED,x=i.DEVICE_LIST_WILL_CHANGE,R=i.DEVICE_LIST_AVAILABLE,A=i.ENDPOINT_MESSAGE_RECEIVED,w=i.ENDPOINT_STATS_RECEIVED,I=i.LOCAL_UFRAG_CHANGED,P=i.REMOTE_UFRAG_CHANGED,D=i.VIDEO_SSRCS_REMAPPED,O=i.AUDIO_SSRCS_REMAPPED,k=i},125:e=>{e.exports={2160:{width:3840,height:2160},"4k":{width:3840,height:2160},1080:{width:1920,height:1080},fullhd:{width:1920,height:1080},720:{width:1280,height:720},hd:{width:1280,height:720},540:{width:960,height:540},qhd:{width:960,height:540},480:{width:640,height:480},vga:{width:640,height:480},360:{width:640,height:360},240:{width:320,height:240},180:{width:320,height:180}}},408:(e,t,n)=>{"use strict";let i;n.r(t),n.d(t,{VideoType:()=>i}),function(e){e.CAMERA="camera",e.DESKTOP="desktop"}(i||(i={}))},514:e=>{e.exports={IDENTITY_UPDATED:"authentication.identity_updated"}},680:(e,t,n)=>{"use strict";n.d(t,{D:()=>i});const i="local"},609:(e,t,n)=>{"use strict";let i;n.r(t),n.d(t,{XMPPEvents:()=>i}),function(e){e.ADD_ICE_CANDIDATE_FAILED="xmpp.add_ice_candidate_failed",e.AUDIO_MUTED_BY_FOCUS="xmpp.audio_muted_by_focus",e.VIDEO_MUTED_BY_FOCUS="xmpp.video_muted_by_focus",e.AUTHENTICATION_REQUIRED="xmpp.authentication_required",e.BRIDGE_DOWN="xmpp.bridge_down",e.CALL_ACCEPTED="xmpp.callaccepted.jingle",e.CALL_INCOMING="xmpp.callincoming.jingle",e.CALL_ENDED="xmpp.callended.jingle",e.CHAT_ERROR_RECEIVED="xmpp.chat_error_received",e.SETTINGS_ERROR_RECEIVED="xmpp.settings_error_received",e.CONFERENCE_PROPERTIES_CHANGED="xmpp.conference_properties_changed",e.CONNECTION_ESTABLISHED="xmpp.connection.connected",e.CONNECTION_FAILED="xmpp.connection.failed",e.CONNECTION_INTERRUPTED="xmpp.connection.interrupted",e.CONNECTION_RESTORED="xmpp.connection.restored",e.CONNECTION_ICE_FAILED="xmpp.connection.ice.failed",e.CONNECTION_RESTARTED="xmpp.connection.restart",e.CONNECTION_STATUS_CHANGED="xmpp.connection.status.changed",e.DISPLAY_NAME_CHANGED="xmpp.display_name_changed",e.DISPLAY_NAME_REQUIRED="xmpp.display_name_required",e.EMUC_ROOM_ADDED="xmpp.emuc_room_added",e.EMUC_ROOM_REMOVED="xmpp.emuc_room_removed",e.ETHERPAD="xmpp.etherpad",e.FOCUS_DISCONNECTED="xmpp.focus_disconnected",e.FOCUS_LEFT="xmpp.focus_left",e.GRACEFUL_SHUTDOWN="xmpp.graceful_shutdown",e.ICE_RESTARTING="rtc.ice_restarting",e.ICE_RESTART_SUCCESS="rtc.ice_restart_success",e.KICKED="xmpp.kicked",e.LOCAL_ROLE_CHANGED="xmpp.localrole_changed",e.MEETING_ID_SET="xmpp.meeting_id_set",e.MESSAGE_RECEIVED="xmpp.message_received",e.INVITE_MESSAGE_RECEIVED="xmpp.invite_message_received",e.PRIVATE_MESSAGE_RECEIVED="xmpp.private_message_received",e.MUC_MEMBER_BOT_TYPE_CHANGED="xmpp.muc_member_bot_type_changed",e.MUC_DESTROYED="xmpp.muc_destroyed",e.MUC_JOIN_IN_PROGRESS="xmpp.muc_join_in_progress",e.MUC_JOINED="xmpp.muc_joined",e.MUC_MEMBER_JOINED="xmpp.muc_member_joined",e.MUC_MEMBER_LEFT="xmpp.muc_member_left",e.MUC_LOBBY_MEMBER_JOINED="xmpp.muc_lobby_member_joined",e.MUC_LOBBY_MEMBER_UPDATED="xmpp.muc_lobby_member_updated",e.MUC_LOBBY_MEMBER_LEFT="xmpp.muc_lobby_member_left",e.MUC_DENIED_ACCESS="xmpp.muc_denied access",e.MUC_LEFT="xmpp.muc_left",e.MUC_ROLE_CHANGED="xmpp.muc_role_changed",e.MUC_LOCK_CHANGED="xmpp.muc_lock_changed",e.MUC_MEMBERS_ONLY_CHANGED="xmpp.muc_members_only_changed",e.MUC_VISITORS_SUPPORTED_CHANGED="xmpp.muc_visitors_supported_changed",e.PARTICIPANT_AUDIO_MUTED="xmpp.audio_muted",e.PARTICIPANT_VIDEO_MUTED="xmpp.video_muted",e.PARTICIPANT_VIDEO_TYPE_CHANGED="xmpp.video_type",e.PARTICIPANT_FEATURES_CHANGED="xmpp.participant_features_changed",e.PASSWORD_REQUIRED="xmpp.password_required",e.PHONE_NUMBER_CHANGED="conference.phoneNumberChanged",e.PRESENCE_RECEIVED="xmpp.presence_received",e.PRESENCE_STATUS="xmpp.presence_status",e.PROMPT_FOR_LOGIN="xmpp.prompt_for_login",e.READY_TO_JOIN="xmpp.ready_to_join",e.RECORDER_STATE_CHANGED="xmpp.recorderStateChanged",e.REMOTE_STATS="xmpp.remote_stats",e.RENEGOTIATION_FAILED="xmpp.renegotiation_failed",e.RESERVATION_ERROR="xmpp.room_reservation_error",e.ROOM_CONNECT_ERROR="xmpp.room_connect_error",e.ROOM_CONNECT_NOT_ALLOWED_ERROR="xmpp.room_connect_error.not_allowed",e.ROOM_JOIN_ERROR="xmpp.room_join_error",e.ROOM_CONNECT_MEMBERS_ONLY_ERROR="xmpp.room_connect_error.members_only",e.ROOM_DISCO_INFO_UPDATED="xmpp.room_disco_info_updated",e.ROOM_DISCO_INFO_FAILED="xmpp.room_disco_info_failed",e.ROOM_MAX_USERS_ERROR="xmpp.room_max_users_error",e.SENDING_CHAT_MESSAGE="xmpp.sending_chat_message",e.SENDING_PRIVATE_CHAT_MESSAGE="xmpp.sending_private_chat_message",e.SESSION_ACCEPT="xmpp.session_accept",e.SESSION_ACCEPT_ERROR="xmpp.session_accept_error",e.SESSION_ACCEPT_TIMEOUT="xmpp.session_accept_timeout",e.SOURCE_ADD="xmpp.source_add",e.SOURCE_ADD_ERROR="xmpp.source_add_error",e.SOURCE_REMOVE="xmpp.source_remove",e.SOURCE_REMOVE_ERROR="xmpp.source_remove_error",e.SPEAKER_STATS_RECEIVED="xmpp.speaker_stats_received",e.CONFERENCE_TIMESTAMP_RECEIVED="xmpp.conference_timestamp_received",e.AV_MODERATION_APPROVED="xmpp.av_moderation.approved",e.AV_MODERATION_REJECTED="xmpp.av_moderation.rejected",e.AV_MODERATION_RECEIVED="xmpp.av_moderation.received",e.AV_MODERATION_CHANGED="xmpp.av_moderation.changed",e.AV_MODERATION_PARTICIPANT_APPROVED="xmpp.av_moderation.participant.approved",e.AV_MODERATION_PARTICIPANT_REJECTED="xmpp.av_moderation.participant.rejected",e.BREAKOUT_ROOMS_MOVE_TO_ROOM="xmpp.breakout-rooms.move-to-room",e.BREAKOUT_ROOMS_EVENT="xmpp.breakout-rooms.event",e.BREAKOUT_ROOMS_UPDATED="xmpp.breakout-rooms.updated",e.ROOM_METADATA_EVENT="xmpp.room-metadata.event",e.ROOM_METADATA_UPDATED="xmpp.room-metadata.updated",e.START_MUTED_FROM_FOCUS="xmpp.start_muted_from_focus",e.SUBJECT_CHANGED="xmpp.subject_changed",e.SUSPEND_DETECTED="xmpp.suspend_detected",e.TRANSCRIPTION_STATUS_CHANGED="xmpp.transcription_status_changed",e.TRANSPORT_INFO="xmpp.transportinfo.jingle",e.VIDEO_SIP_GW_AVAILABILITY_CHANGED="xmpp.videoSIPGWAvailabilityChanged",e.VIDEO_SIP_GW_SESSION_STATE_CHANGED="xmpp.videoSIPGWSessionStateChanged",e.VISITORS_MESSAGE="xmpp.visitors_message",e.VISITORS_REJECTION="xmpp.visitors_rejection",e.ICE_CONNECTION_STATE_CHANGED="xmpp.ice_connection_state_changed",e.JSON_MESSAGE_RECEIVED="xmmp.json_message_received"}(i||(i={}))},526:(e,t,n)=>{"use strict";n.d(t,{Z:()=>mu});var i={};n.r(i),n.d(i,{AUTHENTICATION_REQUIRED:()=>T,CHAT_ERROR:()=>C,CONFERENCE_ACCESS_DENIED:()=>O,CONFERENCE_DESTROYED:()=>R,CONFERENCE_MAX_USERS:()=>A,CONFERENCE_RESTARTED:()=>I,CONNECTION_ERROR:()=>w,DISPLAY_NAME_REQUIRED:()=>k,FOCUS_DISCONNECTED:()=>N,FOCUS_LEFT:()=>M,GRACEFUL_SHUTDOWN:()=>L,ICE_FAILED:()=>F,INCOMPATIBLE_SERVER_VERSIONS:()=>j,JitsiConferenceErrors:()=>b,MEMBERS_ONLY_ERROR:()=>D,NOT_ALLOWED_ERROR:()=>P,OFFER_ANSWER_FAILED:()=>V,PASSWORD_NOT_SUPPORTED:()=>U,PASSWORD_REQUIRED:()=>H,RESERVATION_ERROR:()=>$,SETTINGS_ERROR:()=>x,VIDEOBRIDGE_NOT_AVAILABLE:()=>J});var r={};n.r(r),n.d(r,{AUDIO_INPUT_STATE_CHANGE:()=>z,AUDIO_UNMUTE_PERMISSIONS_CHANGED:()=>K,AUTH_STATUS_CHANGED:()=>W,AV_MODERATION_APPROVED:()=>X,AV_MODERATION_CHANGED:()=>Y,AV_MODERATION_PARTICIPANT_APPROVED:()=>Q,AV_MODERATION_PARTICIPANT_REJECTED:()=>Z,AV_MODERATION_REJECTED:()=>ee,BEFORE_STATISTICS_DISPOSED:()=>te,BOT_TYPE_CHANGED:()=>ne,BREAKOUT_ROOMS_MOVE_TO_ROOM:()=>ie,BREAKOUT_ROOMS_UPDATED:()=>re,CONFERENCE_CREATED_TIMESTAMP:()=>oe,CONFERENCE_ERROR:()=>se,CONFERENCE_FAILED:()=>ae,CONFERENCE_JOINED:()=>ce,CONFERENCE_JOIN_IN_PROGRESS:()=>de,CONFERENCE_LEFT:()=>le,CONFERENCE_UNIQUE_ID_SET:()=>he,CONFERENCE_VISITOR_CODECS_CHANGED:()=>ue,CONNECTION_ESTABLISHED:()=>pe,CONNECTION_INTERRUPTED:()=>me,CONNECTION_RESTORED:()=>ge,DATA_CHANNEL_CLOSED:()=>fe,DATA_CHANNEL_OPENED:()=>ve,DISPLAY_NAME_CHANGED:()=>_e,DOMINANT_SPEAKER_CHANGED:()=>ye,DTMF_SUPPORT_CHANGED:()=>Ee,E2EE_VERIFICATION_AVAILABLE:()=>Se,E2EE_VERIFICATION_COMPLETED:()=>be,E2EE_VERIFICATION_READY:()=>Te,ENDPOINT_MESSAGE_RECEIVED:()=>Ce,ENDPOINT_STATS_RECEIVED:()=>xe,FORWARDED_SOURCES_CHANGED:()=>Re,JVB121_STATUS:()=>Ae,JitsiConferenceEvents:()=>B,KICKED:()=>we,LAST_N_ENDPOINTS_CHANGED:()=>Ie,LOBBY_USER_JOINED:()=>Pe,LOBBY_USER_LEFT:()=>De,LOBBY_USER_UPDATED:()=>Oe,LOCK_STATE_CHANGED:()=>ke,MEMBERS_ONLY_CHANGED:()=>Ne,MESSAGE_RECEIVED:()=>Me,METADATA_UPDATED:()=>Le,NOISY_MIC:()=>je,NON_PARTICIPANT_MESSAGE_RECEIVED:()=>Ve,NO_AUDIO_INPUT:()=>Fe,P2P_STATUS:()=>Ue,PARTCIPANT_FEATURES_CHANGED:()=>Be,PARTICIPANT_KICKED:()=>He,PARTICIPANT_PROPERTY_CHANGED:()=>qe,PARTICIPANT_SOURCE_UPDATED:()=>$e,PHONE_NUMBER_CHANGED:()=>Ge,PRIVATE_MESSAGE_RECEIVED:()=>Je,PROPERTIES_CHANGED:()=>ze,RECORDER_STATE_CHANGED:()=>Ke,SERVER_REGION_CHANGED:()=>We,STARTED_MUTED:()=>Ye,START_MUTED_POLICY_CHANGED:()=>Xe,SUBJECT_CHANGED:()=>Qe,SUSPEND_DETECTED:()=>Ze,TALK_WHILE_MUTED:()=>et,TRACK_ADDED:()=>tt,TRACK_AUDIO_LEVEL_CHANGED:()=>nt,TRACK_MUTE_CHANGED:()=>it,TRACK_REMOVED:()=>rt,TRACK_UNMUTE_REJECTED:()=>ot,TRANSCRIPTION_STATUS_CHANGED:()=>st,USER_JOINED:()=>at,USER_LEFT:()=>dt,USER_ROLE_CHANGED:()=>ct,USER_STATUS_CHANGED:()=>lt,VIDEO_SIP_GW_AVAILABILITY_CHANGED:()=>ht,VIDEO_SIP_GW_SESSION_STATE_CHANGED:()=>ut,VIDEO_UNMUTE_PERMISSIONS_CHANGED:()=>pt,VISITORS_MESSAGE:()=>gt,VISITORS_REJECTION:()=>ft,VISITORS_SUPPORTED_CHANGED:()=>mt,_MEDIA_SESSION_ACTIVE_CHANGED:()=>G,_MEDIA_SESSION_STARTED:()=>q});var o={};n.r(o),n.d(o,{JitsiTrackEvents:()=>bt,LOCAL_TRACK_STOPPED:()=>Tt,NO_AUDIO_INPUT:()=>It,NO_DATA_FROM_SOURCE:()=>wt,TRACK_AUDIO_LEVEL_CHANGED:()=>Ct,TRACK_AUDIO_OUTPUT_CHANGED:()=>xt,TRACK_MUTE_CHANGED:()=>Rt,TRACK_OWNER_CHANGED:()=>Dt,TRACK_REMOVED:()=>Ot,TRACK_STREAMING_STATUS_CHANGED:()=>Pt,TRACK_VIDEOTYPE_CHANGED:()=>At});var s={};n.r(s),n.d(s,{RTCStatsEvents:()=>Zn,RTC_STATS_PC_EVENT:()=>ti,RTC_STATS_WC_DISCONNECTED:()=>ei});var a={};n.r(a),n.d(a,{CONSTRAINT_FAILED:()=>Gi,ELECTRON_DESKTOP_PICKER_ERROR:()=>zi,ELECTRON_DESKTOP_PICKER_NOT_FOUND:()=>Ki,GENERAL:()=>Wi,JitsiTrackErrors:()=>qi,NOT_FOUND:()=>Xi,PERMISSION_DENIED:()=>Yi,SCREENSHARING_GENERIC_ERROR:()=>Qi,SCREENSHARING_USER_CANCELED:()=>Zi,TIMEOUT:()=>er,TRACK_IS_DISPOSED:()=>tr,TRACK_NO_STREAM_FOUND:()=>nr,TRACK_NO_STREAM_TRACKS_FOUND:()=>or,TRACK_TOO_MANY_TRACKS_IN_STREAM:()=>rr,UNSUPPORTED_RESOLUTION:()=>ir});var d={};n.r(d),n.d(d,{CONNECTION_DISCONNECTED:()=>lr,CONNECTION_ESTABLISHED:()=>hr,CONNECTION_FAILED:()=>ur,CONNECTION_REDIRECTED:()=>pr,DISPLAY_NAME_REQUIRED:()=>gr,JitsiConnectionEvents:()=>cr,PROPERTIES_UPDATED:()=>fr,WRONG_STATE:()=>mr});var c={};n.r(c),n.d(c,{CONNECTION_DROPPED_ERROR:()=>Er,JitsiConnectionErrors:()=>yr,OTHER_ERROR:()=>Sr,PASSWORD_REQUIRED:()=>br,SERVER_ERROR:()=>Tr});var l={};n.r(l),n.d(l,{JitsiTranscriptionStatus:()=>Wo,OFF:()=>Yo,ON:()=>Xo});var h={};n.r(h),n.d(h,{fixNegotiationNeeded:()=>cd,shimAddTrackRemoveTrack:()=>ad,shimAddTrackRemoveTrackWithNative:()=>sd,shimGetDisplayMedia:()=>ed,shimGetSendersWithDtmf:()=>id,shimGetStats:()=>rd,shimGetUserMedia:()=>Za,shimMediaStream:()=>td,shimOnTrack:()=>nd,shimPeerConnection:()=>dd,shimSenderReceiverGetStats:()=>od});var u={};n.r(u),n.d(u,{shimAddTransceiver:()=>_d,shimCreateAnswer:()=>Sd,shimCreateOffer:()=>Ed,shimGetDisplayMedia:()=>hd,shimGetParameters:()=>yd,shimGetUserMedia:()=>ld,shimOnTrack:()=>ud,shimPeerConnection:()=>pd,shimRTCDataChannel:()=>vd,shimReceiverGetStats:()=>gd,shimRemoveStream:()=>fd,shimSenderGetStats:()=>md});var p={};n.r(p),n.d(p,{shimAudioContext:()=>Pd,shimCallbacksAPI:()=>Cd,shimConstraints:()=>Rd,shimCreateOfferLegacy:()=>Id,shimGetUserMedia:()=>xd,shimLocalStreamsAPI:()=>bd,shimRTCIceServerUrls:()=>Ad,shimRemoteStreamsAPI:()=>Td,shimTrackEventTransceiver:()=>wd});var m={};n.r(m),n.d(m,{removeExtmapAllowMixed:()=>Md,shimAddIceCandidateNullOrEmpty:()=>Ld,shimConnectionState:()=>Nd,shimMaxMessageSize:()=>Od,shimParameterlessSetLocalDescription:()=>Fd,shimRTCIceCandidate:()=>Dd,shimSendThrowTypeError:()=>kd});var g={};n.r(g),n.d(g,{ConnectionQualityEvents:()=>cl,LOCAL_STATS_UPDATED:()=>ml,REMOTE_STATS_UPDATED:()=>gl});var f={};n.r(f),n.d(f,{AUDIO_INPUT_STATE_CHANGE:()=>Rl,DETECTOR_STATE_CHANGE:()=>xl,DetectionEvents:()=>Cl,NO_AUDIO_INPUT:()=>Al,VAD_NOISY_DEVICE:()=>wl,VAD_REPORT_PUBLISHED:()=>Il,VAD_SCORE_PUBLISHED:()=>Pl,VAD_TALK_WHILE_MUTED:()=>Dl});var v={};n.r(v),n.d(v,{E2E_RTT_CHANGED:()=>Hl,E2ePingEvents:()=>Ul});var _={};n.r(_),n.d(_,{ERROR_NO_CONNECTION:()=>Ph,ERROR_SESSION_EXISTS:()=>Dh,STATE_FAILED:()=>Ih,STATE_OFF:()=>Rh,STATE_ON:()=>xh,STATE_PENDING:()=>Ah,STATE_RETRYING:()=>wh,STATUS_AVAILABLE:()=>bh,STATUS_BUSY:()=>Ch,STATUS_UNDEFINED:()=>Th,VideoSIPGWErrorConstants:()=>Sh,VideoSIPGWStateConstants:()=>Eh,VideoSIPGWStatusConstants:()=>yh});var y={};n.r(y),n.d(y,{DEVICE_LIST_CHANGED:()=>Gh,JitsiMediaDevicesEvents:()=>qh,PERMISSIONS_CHANGED:()=>zh,PERMISSION_PROMPT_IS_SHOWN:()=>Kh,SLOW_GET_USER_MEDIA:()=>Wh});var E=n(810),S=n.n(E);let b;!function(e){e.AUTHENTICATION_REQUIRED="conference.authenticationRequired",e.CHAT_ERROR="conference.chatError",e.SETTINGS_ERROR="conference.settingsError",e.CONFERENCE_DESTROYED="conference.destroyed",e.CONFERENCE_MAX_USERS="conference.max_users",e.CONNECTION_ERROR="conference.connectionError",e.CONFERENCE_RESTARTED="conference.restarted",e.NOT_ALLOWED_ERROR="conference.connectionError.notAllowed",e.MEMBERS_ONLY_ERROR="conference.connectionError.membersOnly",e.CONFERENCE_ACCESS_DENIED="conference.connectionError.accessDenied",e.DISPLAY_NAME_REQUIRED="conference.display_name_required",e.FOCUS_DISCONNECTED="conference.focusDisconnected",e.FOCUS_LEFT="conference.focusLeft",e.GRACEFUL_SHUTDOWN="conference.gracefulShutdown",e.ICE_FAILED="conference.iceFailed",e.INCOMPATIBLE_SERVER_VERSIONS="conference.incompatible_server_versions",e.OFFER_ANSWER_FAILED="conference.offerAnswerFailed",e.PASSWORD_NOT_SUPPORTED="conference.passwordNotSupported",e.PASSWORD_REQUIRED="conference.passwordRequired",e.RESERVATION_ERROR="conference.reservationError",e.VIDEOBRIDGE_NOT_AVAILABLE="conference.videobridgeNotAvailable"}(b||(b={}));const T=b.AUTHENTICATION_REQUIRED,C=b.CHAT_ERROR,x=b.SETTINGS_ERROR,R=b.CONFERENCE_DESTROYED,A=b.CONFERENCE_MAX_USERS,w=b.CONNECTION_ERROR,I=b.CONFERENCE_RESTARTED,P=b.NOT_ALLOWED_ERROR,D=b.MEMBERS_ONLY_ERROR,O=b.CONFERENCE_ACCESS_DENIED,k=b.DISPLAY_NAME_REQUIRED,N=b.FOCUS_DISCONNECTED,M=b.FOCUS_LEFT,L=b.GRACEFUL_SHUTDOWN,F=b.ICE_FAILED,j=b.INCOMPATIBLE_SERVER_VERSIONS,V=b.OFFER_ANSWER_FAILED,U=b.PASSWORD_NOT_SUPPORTED,H=b.PASSWORD_REQUIRED,$=b.RESERVATION_ERROR,J=b.VIDEOBRIDGE_NOT_AVAILABLE;let B;!function(e){e._MEDIA_SESSION_ACTIVE_CHANGED="conference.media_session.active_changed",e._MEDIA_SESSION_STARTED="conference.media_session.started",e.AUDIO_INPUT_STATE_CHANGE="conference.audio_input_state_changed",e.AUDIO_UNMUTE_PERMISSIONS_CHANGED="conference.audio_unmute_permissions_changed",e.AUTH_STATUS_CHANGED="conference.auth_status_changed",e.AV_MODERATION_APPROVED="conference.av_moderation.approved",e.AV_MODERATION_CHANGED="conference.av_moderation.changed",e.AV_MODERATION_PARTICIPANT_APPROVED="conference.av_moderation.participant.approved",e.AV_MODERATION_PARTICIPANT_REJECTED="conference.av_moderation.participant.rejected",e.AV_MODERATION_REJECTED="conference.av_moderation.rejected",e.BEFORE_STATISTICS_DISPOSED="conference.beforeStatisticsDisposed",e.BOT_TYPE_CHANGED="conference.bot_type_changed",e.BREAKOUT_ROOMS_MOVE_TO_ROOM="conference.breakout-rooms.move-to-room",e.BREAKOUT_ROOMS_UPDATED="conference.breakout-rooms.updated",e.CONFERENCE_CREATED_TIMESTAMP="conference.createdTimestamp",e.CONFERENCE_ERROR="conference.error",e.CONFERENCE_FAILED="conference.failed",e.CONFERENCE_JOIN_IN_PROGRESS="conference.join_in_progress",e.CONFERENCE_JOINED="conference.joined",e.CONFERENCE_LEFT="conference.left",e.CONFERENCE_UNIQUE_ID_SET="conference.unique_id_set",e.CONFERENCE_VISITOR_CODECS_CHANGED="conference.visitor_codecs_changed",e.CONNECTION_ESTABLISHED="conference.connectionEstablished",e.CONNECTION_INTERRUPTED="conference.connectionInterrupted",e.CONNECTION_RESTORED="conference.connectionRestored",e.DATA_CHANNEL_CLOSED="conference.dataChannelClosed",e.DATA_CHANNEL_OPENED="conference.dataChannelOpened",e.DISPLAY_NAME_CHANGED="conference.displayNameChanged",e.DOMINANT_SPEAKER_CHANGED="conference.dominantSpeaker",e.DTMF_SUPPORT_CHANGED="conference.dtmfSupportChanged",e.E2EE_VERIFICATION_AVAILABLE="conference.e2ee.verification.available",e.E2EE_VERIFICATION_COMPLETED="conference.e2ee.verification.completed",e.E2EE_VERIFICATION_READY="conference.e2ee.verification.ready",e.ENDPOINT_MESSAGE_RECEIVED="conference.endpoint_message_received",e.ENDPOINT_STATS_RECEIVED="conference.endpoint_stats_received",e.FORWARDED_SOURCES_CHANGED="conference.forwardedSourcesChanged",e.JVB121_STATUS="conference.jvb121Status",e.KICKED="conference.kicked",e.LAST_N_ENDPOINTS_CHANGED="conference.lastNEndpointsChanged",e.LOBBY_USER_JOINED="conference.lobby.userJoined",e.LOBBY_USER_LEFT="conference.lobby.userLeft",e.LOBBY_USER_UPDATED="conference.lobby.userUpdated",e.LOCK_STATE_CHANGED="conference.lock_state_changed",e.MEMBERS_ONLY_CHANGED="conference.membersOnlyChanged",e.MESSAGE_RECEIVED="conference.messageReceived",e.METADATA_UPDATED="conference.metadata.updated",e.NO_AUDIO_INPUT="conference.no_audio_input",e.NOISY_MIC="conference.noisy_mic",e.NON_PARTICIPANT_MESSAGE_RECEIVED="conference.non_participant_message_received",e.P2P_STATUS="conference.p2pStatus",e.PARTCIPANT_FEATURES_CHANGED="conference.partcipant_features_changed",e.PARTICIPANT_KICKED="conference.participant_kicked",e.PARTICIPANT_PROPERTY_CHANGED="conference.participant_property_changed",e.PARTICIPANT_SOURCE_UPDATED="conference.participant_source_updated",e.PHONE_NUMBER_CHANGED="conference.phoneNumberChanged",e.PRIVATE_MESSAGE_RECEIVED="conference.privateMessageReceived",e.PROPERTIES_CHANGED="conference.propertiesChanged",e.RECORDER_STATE_CHANGED="conference.recorderStateChanged",e.SERVER_REGION_CHANGED="conference.server_region_changed",e.START_MUTED_POLICY_CHANGED="conference.start_muted_policy_changed",e.STARTED_MUTED="conference.started_muted",e.SUBJECT_CHANGED="conference.subjectChanged",e.SUSPEND_DETECTED="conference.suspendDetected",e.TALK_WHILE_MUTED="conference.talk_while_muted",e.TRACK_ADDED="conference.trackAdded",e.TRACK_AUDIO_LEVEL_CHANGED="conference.audioLevelsChanged",e.TRACK_MUTE_CHANGED="conference.trackMuteChanged",e.TRACK_REMOVED="conference.trackRemoved",e.TRACK_UNMUTE_REJECTED="conference.trackUnmuteRejected",e.TRANSCRIPTION_STATUS_CHANGED="conference.transcriptionStatusChanged",e.USER_JOINED="conference.userJoined",e.USER_LEFT="conference.userLeft",e.USER_ROLE_CHANGED="conference.roleChanged",e.USER_STATUS_CHANGED="conference.statusChanged",e.VIDEO_SIP_GW_AVAILABILITY_CHANGED="conference.videoSIPGWAvailabilityChanged",e.VIDEO_SIP_GW_SESSION_STATE_CHANGED="conference.videoSIPGWSessionStateChanged",e.VIDEO_UNMUTE_PERMISSIONS_CHANGED="conference.video_unmute_permissions_changed",e.VISITORS_SUPPORTED_CHANGED="conference.visitorsSupported",e.VISITORS_MESSAGE="conference.visitors_message",e.VISITORS_REJECTION="conference.visitors_rejection"}(B||(B={}));const q=B._MEDIA_SESSION_STARTED,G=B._MEDIA_SESSION_ACTIVE_CHANGED,z=B.AUDIO_INPUT_STATE_CHANGE,K=B.AUDIO_UNMUTE_PERMISSIONS_CHANGED,W=B.AUTH_STATUS_CHANGED,X=B.AV_MODERATION_APPROVED,Y=B.AV_MODERATION_CHANGED,Q=B.AV_MODERATION_PARTICIPANT_APPROVED,Z=B.AV_MODERATION_PARTICIPANT_REJECTED,ee=B.AV_MODERATION_REJECTED,te=B.BEFORE_STATISTICS_DISPOSED,ne=B.BOT_TYPE_CHANGED,ie=B.BREAKOUT_ROOMS_MOVE_TO_ROOM,re=B.BREAKOUT_ROOMS_UPDATED,oe=B.CONFERENCE_CREATED_TIMESTAMP,se=B.CONFERENCE_ERROR,ae=B.CONFERENCE_FAILED,de=B.CONFERENCE_JOIN_IN_PROGRESS,ce=B.CONFERENCE_JOINED,le=B.CONFERENCE_LEFT,he=B.CONFERENCE_UNIQUE_ID_SET,ue=B.CONFERENCE_VISITOR_CODECS_CHANGED,pe=B.CONNECTION_ESTABLISHED,me=B.CONNECTION_INTERRUPTED,ge=B.CONNECTION_RESTORED,fe=B.DATA_CHANNEL_CLOSED,ve=B.DATA_CHANNEL_OPENED,_e=B.DISPLAY_NAME_CHANGED,ye=B.DOMINANT_SPEAKER_CHANGED,Ee=B.DTMF_SUPPORT_CHANGED,Se=B.E2EE_VERIFICATION_AVAILABLE,be=B.E2EE_VERIFICATION_COMPLETED,Te=B.E2EE_VERIFICATION_READY,Ce=B.ENDPOINT_MESSAGE_RECEIVED,xe=B.ENDPOINT_STATS_RECEIVED,Re=B.FORWARDED_SOURCES_CHANGED,Ae=B.JVB121_STATUS,we=B.KICKED,Ie=B.LAST_N_ENDPOINTS_CHANGED,Pe=B.LOBBY_USER_JOINED,De=B.LOBBY_USER_LEFT,Oe=B.LOBBY_USER_UPDATED,ke=B.LOCK_STATE_CHANGED,Ne=B.MEMBERS_ONLY_CHANGED,Me=B.MESSAGE_RECEIVED,Le=B.METADATA_UPDATED,Fe=B.NO_AUDIO_INPUT,je=B.NOISY_MIC,Ve=B.NON_PARTICIPANT_MESSAGE_RECEIVED,Ue=B.P2P_STATUS,He=B.PARTICIPANT_KICKED,$e=B.PARTICIPANT_SOURCE_UPDATED,Je=B.PRIVATE_MESSAGE_RECEIVED,Be=B.PARTCIPANT_FEATURES_CHANGED,qe=B.PARTICIPANT_PROPERTY_CHANGED,Ge=B.PHONE_NUMBER_CHANGED,ze=B.PROPERTIES_CHANGED,Ke=B.RECORDER_STATE_CHANGED,We=B.SERVER_REGION_CHANGED,Xe=B.START_MUTED_POLICY_CHANGED,Ye=B.STARTED_MUTED,Qe=B.SUBJECT_CHANGED,Ze=B.SUSPEND_DETECTED,et=B.TALK_WHILE_MUTED,tt=B.TRACK_ADDED,nt=B.TRACK_AUDIO_LEVEL_CHANGED,it=B.TRACK_MUTE_CHANGED,rt=B.TRACK_REMOVED,ot=B.TRACK_UNMUTE_REJECTED,st=B.TRANSCRIPTION_STATUS_CHANGED,at=B.USER_JOINED,dt=B.USER_LEFT,ct=B.USER_ROLE_CHANGED,lt=B.USER_STATUS_CHANGED,ht=B.VIDEO_SIP_GW_AVAILABILITY_CHANGED,ut=B.VIDEO_SIP_GW_SESSION_STATE_CHANGED,pt=B.VIDEO_UNMUTE_PERMISSIONS_CHANGED,mt=B.VISITORS_SUPPORTED_CHANGED,gt=B.VISITORS_MESSAGE,ft=B.VISITORS_REJECTION;var vt=n(387),_t=n.n(vt),yt=n(47),Et=n.n(yt),St=n(33);let bt;!function(e){e.LOCAL_TRACK_STOPPED="track.stopped",e.TRACK_AUDIO_LEVEL_CHANGED="track.audioLevelsChanged",e.TRACK_AUDIO_OUTPUT_CHANGED="track.audioOutputChanged",e.TRACK_MUTE_CHANGED="track.trackMuteChanged",e.TRACK_VIDEOTYPE_CHANGED="track.videoTypeChanged",e.NO_DATA_FROM_SOURCE="track.no_data_from_source",e.NO_AUDIO_INPUT="track.no_audio_input",e.TRACK_STREAMING_STATUS_CHANGED="track.streaming_status_changed",e.TRACK_OWNER_CHANGED="track.owner_changed",e.TRACK_REMOVED="track.removed"}(bt||(bt={}));const Tt=bt.LOCAL_TRACK_STOPPED,Ct=bt.TRACK_AUDIO_LEVEL_CHANGED,xt=bt.TRACK_AUDIO_OUTPUT_CHANGED,Rt=bt.TRACK_MUTE_CHANGED,At=bt.TRACK_VIDEOTYPE_CHANGED,wt=bt.NO_DATA_FROM_SOURCE,It=bt.NO_AUDIO_INPUT,Pt=bt.TRACK_STREAMING_STATUS_CHANGED,Dt=bt.TRACK_OWNER_CHANGED,Ot=bt.TRACK_REMOVED;let kt;!function(e){e.TYPE_OPERATIONAL="operational",e.TYPE_PAGE="page",e.TYPE_TRACK="track",e.TYPE_UI="ui",e.ACTION_JINGLE_RESTART="restart",e.ACTION_JINGLE_SA_TIMEOUT="session-accept.timeout",e.ACTION_JINGLE_SI_RECEIVED="session-initiate.received",e.ACTION_JINGLE_SI_TIMEOUT="session-initiate.timeout",e.ACTION_JINGLE_TERMINATE="terminate",e.ACTION_JINGLE_TR_RECEIVED="transport-replace.received",e.ACTION_JINGLE_TR_SUCCESS="transport-replace.success",e.ACTION_P2P_DECLINED="decline",e.ACTION_P2P_ESTABLISHED="established",e.ACTION_P2P_FAILED="failed",e.ACTION_P2P_SWITCH_TO_JVB="switch.to.jvb",e.AVAILABLE_DEVICE="available.device",e.CONNECTION_DISCONNECTED="connection.disconnected",e.FEEDBACK="feedback",e.ICE_DURATION="ice.duration",e.ICE_ESTABLISHMENT_DURATION_DIFF="ice.establishment.duration.diff",e.ICE_STATE_CHANGED="ice.state.changed",e.NO_BYTES_SENT="track.no-bytes-sent",e.TRACK_UNMUTED="track.unmuted"}(kt||(kt={}));const Nt=kt.TYPE_OPERATIONAL,Mt=kt.TYPE_PAGE,Lt=kt.TYPE_TRACK,Ft=kt.TYPE_UI,jt=kt.ACTION_JINGLE_RESTART,Vt=kt.ACTION_JINGLE_SA_TIMEOUT,Ut=kt.ACTION_JINGLE_SI_RECEIVED,Ht=kt.ACTION_JINGLE_SI_TIMEOUT,$t=kt.ACTION_JINGLE_TERMINATE,Jt=kt.ACTION_JINGLE_TR_RECEIVED,Bt=kt.ACTION_JINGLE_TR_SUCCESS,qt=kt.ACTION_P2P_DECLINED,Gt=kt.ACTION_P2P_ESTABLISHED,zt=kt.ACTION_P2P_FAILED,Kt=kt.ACTION_P2P_SWITCH_TO_JVB,Wt=kt.AVAILABLE_DEVICE,Xt=kt.CONNECTION_DISCONNECTED,Yt=kt.FEEDBACK,Qt=kt.ICE_DURATION,Zt=kt.ICE_ESTABLISHMENT_DURATION_DIFF,en=kt.ICE_STATE_CHANGED,tn=kt.NO_BYTES_SENT,nn=kt.TRACK_UNMUTED,rn=(e,t,n)=>({type:kt.TYPE_OPERATIONAL,action:"connection.failed",attributes:{error_type:e,error_message:t,...n}}),on=(e,t)=>({action:e,attributes:t,source:"conference",type:kt.TYPE_OPERATIONAL}),sn=(e,t)=>({action:"connection.stage.reached",actionSubject:e,attributes:t,source:"connection.stage.reached",type:kt.TYPE_OPERATIONAL}),an=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return{type:kt.TYPE_OPERATIONAL,source:"get.user.media",action:e,attributes:t}},dn=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return{type:kt.TYPE_OPERATIONAL,action:e,source:"jingle",attributes:t}},cn=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return{type:kt.TYPE_OPERATIONAL,action:e,source:"p2p",attributes:t}},ln=e=>({type:kt.TYPE_OPERATIONAL,action:"remotely.muted",mediaType:e}),hn=e=>({type:kt.TYPE_OPERATIONAL,action:"rtp.stats",attributes:e});let un;!function(e){e.AUDIO_LEVEL="statistics.audioLevel",e.BEFORE_DISPOSED="statistics.before_disposed",e.BYTE_SENT_STATS="statistics.byte_sent_stats",e.CONNECTION_STATS="statistics.connectionstats",e.LONG_TASKS_STATS="statistics.long_tasks_stats"}(un||(un={}));const pn=un.AUDIO_LEVEL,mn=un.BEFORE_DISPOSED,gn=un.BYTE_SENT_STATS,fn=un.CONNECTION_STATS,vn=un.LONG_TASKS_STATS;var _n=n(122);const yn="chrome",En="safari",Sn="electron",bn="react-native",Tn={Chrome:yn,Firefox:"firefox",Safari:En,Electron:Sn},Cn="blink",xn="webkit",Rn="gecko",An={Blink:Cn,WebKit:xn,Gecko:Rn};function wn(e){return{name:Tn[e.name],version:e.version,engine:An[e.engine],engineVersion:e.engineVersion}}class In{constructor(e){this._parser=new _n.UAParser(navigator.userAgent);const{name:t,version:n,engine:i,engineVersion:r}=e?wn(e):function(e){const t=function(){const e=navigator.userAgent.match(/\\b(react[ \\t_-]*native)(?:\\/(\\S+))?/i);let t;if(e||"ReactNative"===navigator.product){let n;return e&&e.length>2&&(n=e[1],t=e[2]),n||(n="react-native"),t||(t="unknown"),{name:bn,version:t}}}();if(t)return t;const{name:n,version:i}=e.getBrowser(),{name:r,version:o}=e.getEngine();return wn({name:n,version:i,engine:r,engineVersion:o})}(this._parser);this._name=t,this._version=n,this._engine=i,this._engineVersion=r}isChrome(){return this._name===yn||this._engine===Cn}isFirefox(){return this._engine===Rn}isSafari(){return this._name===En}isElectron(){return this._name===Sn}isReactNative(){return this._name===bn}isChromiumBased(){return this._engine===Cn}isWebKitBased(){return this._engine===xn}getName(){return this._name?this._name:this._parser.getBrowser().name}getVersion(){return this._version?this._version:this._parser.getBrowser().version}getEngine(){return this._engine}getEngineVersion(){return this._engineVersion}getOS(){return this._parser.getOS().name}getOSVersion(){return this._parser.getOS().version}isVersionGreaterThan(e){if(this._version)return parseInt(this._version,10)>parseInt(e,10)}isVersionLessThan(e){if(this._version)return parseInt(this._version,10)<parseInt(e,10)}isVersionEqualTo(e){if(this._version)return parseInt(this._version,10)===parseInt(e,10)}isEngineVersionGreaterThan(e){if(this._engineVersion)return parseInt(this._engineVersion,10)>parseInt(e,10)}isEngineVersionLessThan(e){if(this._engineVersion)return parseInt(this._engineVersion,10)<parseInt(e,10)}isEngineVersionEqualTo(e){if(this._engineVersion)return parseInt(this._engineVersion,10)===parseInt(e,10)}}const Pn=(0,E.getLogger)("rtctstats");function Dn(e,t){const n=JSON.parse(JSON.stringify(t));Object.keys(n).forEach((t=>{const i=n[t];delete i.id,e[t]&&Object.keys(i).forEach((r=>{i[r]===e[t][r]&&delete n[t][r]}))}));let i=-1/0;return Object.keys(n).forEach((e=>{const t=n[e];t.timestamp>i&&(i=t.timestamp)})),Object.keys(n).forEach((e=>{const t=n[e];t.timestamp===i&&(t.timestamp=0)})),n.timestamp=i,n}function On(e){return{id:e.id,tracks:e.getTracks().map((e=>({id:e.id,kind:e.kind,label:e.label,enabled:e.enabled,muted:e.muted,readyState:e.readyState})))}}var kn,Nn=new Uint8Array(16);function Mn(){if(!kn&&!(kn="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto)))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return kn(Nn)}const Ln=/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;for(var Fn=[],jn=0;jn<256;++jn)Fn.push((jn+256).toString(16).substr(1));const Vn=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=(Fn[e[t+0]]+Fn[e[t+1]]+Fn[e[t+2]]+Fn[e[t+3]]+"-"+Fn[e[t+4]]+Fn[e[t+5]]+"-"+Fn[e[t+6]]+Fn[e[t+7]]+"-"+Fn[e[t+8]]+Fn[e[t+9]]+"-"+Fn[e[t+10]]+Fn[e[t+11]]+Fn[e[t+12]]+Fn[e[t+13]]+Fn[e[t+14]]+Fn[e[t+15]]).toLowerCase();if(!function(e){return"string"==typeof e&&Ln.test(e)}(n))throw TypeError("Stringified UUID is invalid");return n},Un=function(e,t,n){var i=(e=e||{}).random||(e.rng||Mn)();if(i[6]=15&i[6]|64,i[8]=63&i[8]|128,t){n=n||0;for(var r=0;r<16;++r)t[n+r]=i[r];return t}return Vn(i)},Hn="3.1",$n=6e5,Jn={SequenceNumber:"sn"},Bn=3001,qn=3002,Gn=[Bn,qn],zn=1e3;var Kn=n(483),Wn=n.n(Kn);function Xn(e){return 0===e.indexOf("[")||-1!==e.indexOf(":")?"x:x:x:x:x:x:x:x":"x.x.x.x"}function Yn(e){const t=Wn().parseCandidate(e);return"relay"!==t.type&&"ssltcp"!==t.protocol&&(t.ip=Xn(t.ip),t.address=Xn(t.address)),t.relatedAddress&&(t.relatedAddress=Xn(t.relatedAddress)),Wn().writeCandidate(t)}function Qn(e){let t,n,i,r,{endpoint:o,meetingFqn:s,onCloseCallback:a,useLegacy:d,obfuscate:c=!0,pingInterval:l=3e4}=e,h=[],u=Un(),p=0,m=!1,g=1;const f=d?`${Hn}_LEGACY`:`${Hn}_STANDARD`,v=e=>{e.push((new Date).getTime()),e.push(g++)},_=e=>{const t=Object.assign({},e);"identity"!==t.type&&t.data&&(t.data=JSON.stringify(t.data)),n&&n.readyState===WebSocket.OPEN&&m&&n.send(JSON.stringify(t))},y=function(e){_(e),h.length<zn&&e.data&&h.push(e)};return y.isConnected=function(){if(!n)return!1;const{readyState:e}=n;return e===WebSocket.OPEN},y.isClosed=function(){if(!n)return!0;const{readyState:e}=n;return e===WebSocket.CLOSED},y.identity=function(){for(var e=arguments.length,n=new Array(e),i=0;i<e;i++)n[i]=arguments[i];v(n),t&&(n[2].parentStatsSessionId=t),y({statsSessionId:u,type:"identity",data:n})},y.statsEntry=function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];let i=t;if(c){switch(t[0]){case"addIceCandidate":case"onicecandidate":case"setLocalDescription":case"setRemoteDescription":i=JSON.parse(JSON.stringify(i))}!function(e){switch(e[0]){case"addIceCandidate":case"onicecandidate":if(e[2]&&e[2].candidate){const t=e[2];t.candidate=Yn(t.candidate),e[2]=t}break;case"setLocalDescription":case"setRemoteDescription":case"createOfferOnSuccess":case"createAnswerOnSuccess":e[2]&&e[2].sdp&&(e[2].sdp=(n=e[2].sdp,`${Wn().splitLines(n).map((e=>0===e.indexOf("a=candidate:")?`a=${Yn(e)}`:0===e.indexOf("c=")?"c=IN IP4 0.0.0.0":0===e.indexOf("a=rtcp:")?"a=rtcp:9 IN IP4 0.0.0.0":e)).join("\\r\\n").trim()}\\r\\n`));break;case"getStats":case"getstats":e[2]&&(t=e[2],Object.keys(t).forEach((e=>{const n=t[e];n&&(["ipAddress","ip","address"].forEach((e=>{n[e]&&"relay"!==n.candidateType&&(n[e]=Xn(n[e]))})),["googLocalAddress","googRemoteAddress"].forEach((e=>{let t,i,r;n[e]&&(r="["===n[e][0]?"]:":":",[i,t]=n[e].split(r),n[e]=`${Xn(i)}:${t}`)})))})))}var t,n}(i)}v(i),y({statsSessionId:u,type:"stats-entry",data:i})},y.keepAlive=function(){y({statsSessionId:u,type:"keepalive"})},y.close=function(){n&&n.close(Bn)},y.connect=function(e){let d=arguments.length>1&&void 0!==arguments[1]&&arguments[1];e&&!t&&(t=u),t&&(u=Un(),h.forEach((e=>{e.statsSessionId=u}))),n&&n.close(),n=new WebSocket(`${o}/${s}?statsSessionId=${u}&isReconnect=${d}`,f,{headers:{"User-Agent":navigator.userAgent}}),n.onclose=function(t){if(i&&clearInterval(i),m&&(m=!1),a({code:t.code,reason:t.reason}),!Gn.includes(t.code)&&p<$n){const t=2**p*1e3+Math.floor(1e4*Math.random()),n=p+t<$n?t:$n-p;p+=n,r=setTimeout((()=>y.connect(e,!0)),n)}},n.onopen=function(){i=setInterval(y.keepAlive,l)},n.onmessage=async function(e){const{type:t,body:i}=JSON.parse(e.data);if(t===Jn.SequenceNumber){const{value:e,state:t}=i;if(h.length){const t=h[0].data[4],i=h[h.length-1].data[4];if(e<t-1&&e>i)return void(n&&n.close(qn));const r=h.findIndex((t=>t.data[4]===e));h=h.slice(r+1)}if("initial"===t){r&&clearTimeout(r),p=0,m=!0;for(let e=0;e<h.length;e++)_(h[e])}}}},y}let Zn;!function(e){e.RTC_STATS_WC_DISCONNECTED="rtcstats_ws_disconnected",e.RTC_STATS_PC_EVENT="rtstats_pc_event"}(Zn||(Zn={}));const ei=Zn.RTC_STATS_WC_DISCONNECTED,ti=Zn.RTC_STATS_PC_EVENT;var ni=n(857);class ii extends ni.EventEmitter{constructor(){super(),this.addEventListener=this.addListener,this.removeEventListener=this.removeListener}}function ri(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const oi=(0,E.getLogger)("modules/RTCStats/RTCStats.ts"),si=new class{constructor(){ri(this,"_initialized",!1),ri(this,"_trace",null),ri(this,"events",new ii)}init(e){const{analytics:{rtcstatsUseLegacy:t=!1,rtcstatsPollInterval:n=1e4,rtcstatsSendSdp:i=!1,rtcstatsEnabled:r=!1}={}}=e;r&&!this._initialized&&(function(e,t){let{statsEntry:n}=e,{connectionFilter:i,pollInterval:r,useLegacy:o,sendSdp:s=!1,prefixesToWrap:a=[""],eventCallback:d}=t,c=0;const l=new In,h=l.isFirefox(),u=l.isChromiumBased(),p=l.isWebKitBased(),m=l.isReactNative();if(h||u||p||m){if(a.forEach((e=>{if(!window[`${e}RTCPeerConnection`])return;const t=window[`${e}RTCPeerConnection`],a=function(e){let s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};const a={...e},{optional:l=[]}=s;let g=!1;try{l.some((e=>!0===e.rtcStatsSFUP2P))&&(g=!0);const a=new t(e,s);if(i&&i(e))return a;const f="PC_"+c++;a.__rtcStatsId=f,e||(e={nullConfig:!0}),((e=JSON.parse(JSON.stringify(e)))&&e.iceServers||[]).forEach((e=>{delete e.credential})),e.browserType=h?"moz":"webkit",n("create",f,e),a.__dtlsTransport=null,n("constraints",f,s),a.addEventListener("icecandidate",(e=>{n("onicecandidate",f,e.candidate)})),a.addEventListener("addstream",(e=>{n("onaddstream",f,`${e.stream.id} ${e.stream.getTracks().map((e=>`${e.kind}:${e.id}`))}`)})),a.addEventListener("track",(e=>{n("ontrack",f,`${e.track.kind}:${e.track.id} ${e.streams.map((e=>`stream:${e.id}`))}`)})),a.addEventListener("removestream",(e=>{n("onremovestream",f,`${e.stream.id} ${e.stream.getTracks().map((e=>`${e.kind}:${e.id}`))}`)})),a.addEventListener("signalingstatechange",(()=>{n("onsignalingstatechange",f,a.signalingState)})),a.addEventListener("iceconnectionstatechange",(()=>{const{iceConnectionState:e}=a;n("oniceconnectionstatechange",f,e),null==d||d({type:"iceconnectionstatechange",body:{pcId:f,isP2P:g,state:e}})})),a.addEventListener("icegatheringstatechange",(()=>{n("onicegatheringstatechange",f,a.iceGatheringState)})),a.addEventListener("connectionstatechange",(()=>{const{connectionState:e}=a;n("onconnectionstatechange",f,a.connectionState),null==d||d({type:"connectionstatechange",body:{pcId:f,isP2P:g,state:e}})})),a.addEventListener("negotiationneeded",(()=>{n("onnegotiationneeded",f,void 0)})),a.addEventListener("datachannel",(e=>{n("ondatachannel",f,[e.channel.id,e.channel.label])}));let v={};const _=function(){h||p||m||u&&!o?a.getStats(null).then((e=>{const t=function(e){if(!e.entries)return e;const t={};return e.forEach(((e,n)=>{t[n]=e})),t}(e),i=JSON.parse(JSON.stringify(t));n("getstats",f,Dn(v,t)),v=i})):u&&a.getStats((e=>{const t=function(e,t){const n={};return t.result().forEach((e=>{const t={id:e.id,timestamp:e.timestamp.getTime(),type:e.type};e.names().forEach((n=>{t[n]=e.stat(n)})),n[t.id]=t})),n}(0,e),i=JSON.parse(JSON.stringify(t));n("getstats",f,Dn(v,t)),v=i}))};if(r){const e=window.setInterval((()=>{"closed"!==a.signalingState&&"closed"!==a.iceConnectionState?_():window.clearInterval(e)}),r)}return a.addEventListener("connectionstatechange",(()=>{["connected","failed"].includes(a.connectionState)&&_()})),a}catch(e){return console.error("RTCStats PeerConnection bind failed: ",e),new t(a,s)}};["createDataChannel","close"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){try{n(e,this.__rtcStatsId,arguments)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,arguments)})})),["addStream","removeStream"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){try{const t=arguments[0],i=t.getTracks().map((e=>`${e.kind}:${e.id}`)).join(",");n(e,this.__rtcStatsId,`${t.id} ${i}`)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,arguments)})})),["addTrack"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){try{const t=arguments[0],i=[].slice.call(arguments,1);n(e,this.__rtcStatsId,`${t.kind}:${t.id} ${i.map((e=>`stream:${e.id}`)).join(";")||"-"}`)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,arguments)})})),["removeTrack"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){try{const t=arguments[0].track;n(e,this.__rtcStatsId,t?`${t.kind}:${t.id}`:"null")}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,arguments)})})),["addTransceiver"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){try{const t=arguments[0];let i;i="string"==typeof t?t:`${t.kind}:${t.id}`,2===arguments.length&&"object"==typeof arguments[1]&&(i+=` ${JSON.stringify(arguments[1])}`),n(e,this.__rtcStatsId,i)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,arguments)})})),["createOffer","createAnswer"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){const t=this.__rtcStatsId,r=arguments;let o;1===arguments.length&&"object"==typeof arguments[0]?o=arguments[0]:3===arguments.length&&"object"==typeof arguments[2]&&(o=arguments[2]);try{n(e,this.__rtcStatsId,o)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,o?[o]:void 0).then((i=>{try{n(`${e}OnSuccess`,t,s?i:"")}catch(t){console.error(`RTCStats ${e} promise success bind failed: `,t)}if(!(r.length>0&&"function"==typeof r[0]))return i;r[0].apply(null,[i])}),(i=>{try{n(`${e}OnFailure`,t,i.toString())}catch(t){console.error(`RTCStats ${e} promise failure bind failed: `,t)}if(!(r.length>1&&"function"==typeof r[1]))throw i;r[1].apply(null,[i])}))})})),["setLocalDescription","setRemoteDescription","addIceCandidate"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){const t=this.__rtcStatsId,r=arguments;try{const t=s?r[0]:"";n(e,this.__rtcStatsId,t)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,[r[0]]).then((()=>{try{n(`${e}OnSuccess`,t,void 0)}catch(t){console.error(`RTCStats ${e} promise success bind failed: `,t)}this.__dtlsTransport||!e.endsWith("Description")||m||this.getSenders().forEach((e=>{!this.__dtlsTransport&&e.transport&&(this.__dtlsTransport=e.transport,e.transport.addEventListener("error",(e=>{n("ondtlserror",t,e)})),e.transport.addEventListener("statechange",(()=>{const i=e.transport.state;n("ondtlsstatechange",t,i)})))})),r.length>=2&&"function"==typeof r[1]&&r[1].apply(null,[])}),(i=>{try{n(`${e}OnFailure`,t,i.toString())}catch(t){console.error(`RTCStats ${e} promise failure bind failed: `,t)}if(!(r.length>=3&&"function"==typeof r[2]))throw i;r[2].apply(null,[i])}))})})),t.generateCertificate&&Object.defineProperty(a,"generateCertificate",{get(){return arguments.length?t.generateCertificate.apply(null,arguments):t.generateCertificate}}),window[`${e}RTCPeerConnection`]=a,window[`${e}RTCPeerConnection`].prototype=t.prototype})),a.forEach((e=>{const t=e+(e.length?"GetUserMedia":"getUserMedia");if(!navigator[t])return;const i=navigator[t].bind(navigator);navigator[t]=function(){try{n("getUserMedia",null,arguments[0])}catch(e){console.error("RTCStats getUserMedia bind failed: ",e)}const e=arguments[1],t=arguments[2];i(arguments[0],(t=>{try{n("getUserMediaOnSuccess",null,On(t))}catch(e){console.error("RTCStats getUserMediaOnSuccess bind failed: ",e)}e&&e(t)}),(e=>{try{n("getUserMediaOnFailure",null,e.name)}catch(e){console.error("RTCStats getUserMediaOnFailure bind failed: ",e)}t&&t(e)}))}.bind(navigator)})),navigator.mediaDevices&&navigator.mediaDevices.getUserMedia){const e=navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices),t=function(){try{n("navigator.mediaDevices.getUserMedia",null,arguments[0])}catch(e){console.error("RTCStats navigator.mediaDevices.getUserMedia bind failed: ",e)}return e.apply(navigator.mediaDevices,arguments).then((e=>{try{n("navigator.mediaDevices.getUserMediaOnSuccess",null,On(e))}catch(e){console.error("RTCStats navigator.mediaDevices.getUserMediaOnSuccess bind failed: ",e)}return e}),(e=>{try{n("navigator.mediaDevices.getUserMediaOnFailure",null,e.name)}catch(e){console.error("RTCStats navigator.mediaDevices.getUserMediaOnFailure bind failed: ",e)}return Promise.reject(e)}))};navigator.mediaDevices.getUserMedia=t.bind(navigator.mediaDevices)}if(navigator.mediaDevices&&navigator.mediaDevices.getDisplayMedia){const e=navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices),t=function(){try{n("navigator.mediaDevices.getDisplayMedia",null,arguments[0])}catch(e){console.error("RTCStats navigator.mediaDevices.getDisplayMedia bind failed: ",e)}return e.apply(navigator.mediaDevices,arguments).then((e=>{try{n("navigator.mediaDevices.getDisplayMediaOnSuccess",null,On(e))}catch(e){console.error("RTCStats navigator.mediaDevices.getDisplayMediaOnSuccess bind failed: ",e)}return e}),(e=>{try{n("navigator.mediaDevices.getDisplayMediaOnFailure",null,e.name)}catch(e){console.error("RTCStats navigator.mediaDevices.getDisplayMediaOnFailure bind failed: ",e)}return Promise.reject(e)}))};navigator.mediaDevices.getDisplayMedia=t.bind(navigator.mediaDevices)}}else Pn.warn("RTCStats unsupported browser.")}({statsEntry:this.sendStatsEntry.bind(this)},{pollInterval:n,useLegacy:t,sendSdp:i,eventCallback:e=>this.events.emit(ti,e)}),this._initialized=!0)}start(e){const{options:{config:t={},name:n=""}={},_statsCurrentId:i=""}=e,{analytics:{rtcstatsEnabled:r=!1,rtcstatsEndpoint:o="",rtcstatsUseLegacy:s=!1}={}}=t;this.reset(),r&&(this._initialized?(e.once(ce,(()=>{var r;const a={endpoint:o,meetingFqn:n,onCloseCallback:e=>this.events.emit(ei,e),useLegacy:s},d=Boolean(null===(r=e.getBreakoutRooms())||void 0===r?void 0:r.isBreakoutRoom()),c=e.myUserId(),l=e.getMeetingUniqueId();this._trace=Qn(a),this._trace.connect(d);const h={...t,endpointId:c,confName:n,displayName:i,meetingUniqueId:l,isBreakoutRoom:d};this.sendIdentity(h)})),e.once(he,(e=>{this.sendIdentity({meetingUniqueId:e})})),e.once(le,(()=>{this.reset()}))):oi.error("Calling start before RTCStats proxy module is initialized."))}sendIdentity(e){var t;null===(t=this._trace)||void 0===t||t.identity("identity",null,e)}reset(){var e;null===(e=this._trace)||void 0===e||e.close(),this._trace=null}sendStatsEntry(e,t,n){var i;null===(i=this._trace)||void 0===i||i.statsEntry(e,t,n)}};n(478);class ai extends ni{constructor(){var e,t;super(...arguments),t={},(e="_storage")in this?Object.defineProperty(this,e,{value:t,enumerable:!0,configurable:!0,writable:!0}):this[e]=t}clear(){this._storage={}}get length(){return Object.keys(this._storage).length}getItem(e){return this._storage[e]}setItem(e,t){this._storage[e]=t}removeItem(e){delete this._storage[e]}key(e){const t=Object.keys(this._storage);if(!(t.length<=e))return t[e]}serialize(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];if(0===e.length)return JSON.stringify(this._storage);const t={...this._storage};return e.forEach((e=>{delete t[e]})),JSON.stringify(t)}}const di=new class extends ni{constructor(){super();try{this._storage=window.localStorage,this._localStorageDisabled=!1}catch(e){}this._storage||(console.warn("Local storage is disabled."),this._storage=new ai,this._localStorageDisabled=!0)}isLocalStorageDisabled(){return this._localStorageDisabled}setLocalStorageDisabled(e){this._localStorageDisabled=e;try{this._storage=e?new ai:window.localStorage}catch(e){}this._storage||(this._storage=new ai)}clear(){this._storage.clear(),this.emit("changed")}get length(){return this._storage.length}getItem(e){return this._storage.getItem(e)}setItem(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];this._storage.setItem(e,t),n||this.emit("changed")}removeItem(e){this._storage.removeItem(e),this.emit("changed")}key(e){return this._storage.key(e)}serialize(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];if(this.isLocalStorageDisabled())return this._storage.serialize(e);const t=this._storage.length,n={};for(let i=0;i<t;i++){const t=this._storage.key(i);e.includes(t)||(n[t]=this._storage.getItem(t))}return JSON.stringify(n)}},ci=new class extends In{doesVideoMuteByStreamRemove(){return this.isChromiumBased()||this.isWebKitBased()||this.isFirefox()}isAndroidBrowser(){return!this.isReactNative()&&"Android"===this.getOS()}isIosBrowser(){return!this.isReactNative()&&"iOS"===this.getOS()}isMobileDevice(){return this.isAndroidBrowser()||this.isIosBrowser()||this.isReactNative()}isTwa(){return"matchMedia"in window&&window.matchMedia("(display-mode:standalone)").matches}isSupported(){return!(this.isSafari()&&this._getSafariVersion()<14)&&(this.isChromiumBased()&&this.isEngineVersionGreaterThan(71)||this.isFirefox()&&this.isVersionGreaterThan(90)||this.isReactNative()||this.isWebKitBased())}isSupportedAndroidBrowser(){return this.isChromiumBased()||this.isFirefox()}isSupportedIOSBrowser(){return this._getSafariVersion()>=14||this._getIOSVersion()>=14}isUserInteractionRequiredForUnmute(){return this.isFirefox()&&this.isVersionLessThan("68")}supportsVideoMuteOnConnInterrupted(){return this.isChromiumBased()&&this.isVersionLessThan("144")||this.isReactNative()}supportsBandwidthStatistics(){return!this.isFirefox()&&!this.isWebKitBased()}supportsCodecPreferences(){return Boolean(window.RTCRtpTransceiver&&"setCodecPreferences"in window.RTCRtpTransceiver.prototype&&window.RTCRtpReceiver&&void 0!==window.RTCRtpReceiver.getCapabilities)&&!this.isWebKitBased()}supportsDDExtHeaders(){return!this.isFirefox()}supportsDeviceChangeEvent(){return navigator.mediaDevices&&void 0!==navigator.mediaDevices.ondevicechange&&void 0!==navigator.mediaDevices.addEventListener}supportsPerformanceObserver(){return void 0!==window.PerformanceObserver&&PerformanceObserver.supportedEntryTypes.indexOf("longtask")>-1}supportsReceiverStats(){return void 0!==window.RTCRtpReceiver&&Object.keys(RTCRtpReceiver.prototype).indexOf("getSynchronizationSources")>-1}supportsRTTStatistics(){return!this.isFirefox()}supportsScalabilityModeAPI(){return this.isChromiumBased()&&this.isEngineVersionGreaterThan(112)}supportsTrackBasedStats(){return this.isChromiumBased()&&this.isEngineVersionLessThan(112)}supportsVP9(){return this.isChromiumBased()||this.isReactNative()}usesSdpMungingForSimulcast(){return this.isChromiumBased()||this.isReactNative()||this.isWebKitBased()}usesRidsForSimulcast(){return!1}supportsGetDisplayMedia(){return void 0!==navigator.getDisplayMedia||void 0!==navigator.mediaDevices&&void 0!==navigator.mediaDevices.getDisplayMedia}supportsEncodedTransform(){return Boolean(window.RTCRtpScriptTransform)}supportsInsertableStreams(){if(void 0===window.RTCRtpSender||!window.RTCRtpSender.prototype.createEncodedStreams)return!1;const e=new ReadableStream;try{return window.postMessage(e,"*",[e]),!0}catch{return!1}}supportsAudioRed(){return Boolean(window.RTCRtpSender&&window.RTCRtpSender.getCapabilities&&window.RTCRtpSender.getCapabilities("audio").codecs.some((e=>"audio/red"===e.mimeType))&&window.RTCRtpReceiver&&window.RTCRtpReceiver.getCapabilities&&window.RTCRtpReceiver.getCapabilities("audio").codecs.some((e=>"audio/red"===e.mimeType)))}supportsVADDetection(){return this.isChromiumBased()}supportsRTX(){return!(this.isFirefox()&&this.isVersionLessThan("96"))}_getSafariVersion(){return this.isSafari()?Number.parseInt(this.getVersion(),10):-1}_getIOSVersion(){return this.isWebKitBased()?Number.parseInt(this.getOSVersion(),10):-1}};var li=n(803),hi=n.n(li);const ui=S().getLogger("modules/watchRTC/WatchRTC.ts"),pi=new class{init(e){if(function(e){var t;const{analytics:n}=e;return null!==(t=null==n?void 0:n.watchRTCEnabled)&&void 0!==t&&t}(e)){if(ci.isReactNative())return void ui.warn("Cannot initialize WatchRTC in a react native environment!");if(!function(e){const{analytics:t,disableThirdPartyRequests:n}=e;return!(null!=t&&t.disabled||n)}(e))return void ui.error("Cannot initialize WatchRTC when analytics or third party requests are disabled.");try{var t;null!=e&&null!==(t=e.watchRTCConfigParams)&&void 0!==t&&t.rtcApiKey?(hi().init({rtcApiKey:e.watchRTCConfigParams.rtcApiKey}),this.options=e.watchRTCConfigParams,ui.info("WatchRTC initialized.")):ui.error("WatchRTC is enabled but missing API key.")}catch(e){ui.error("Failed to initialize WatchRTC: ",e)}}}start(e,t){try{this.options&&(this.options.rtcRoomId=this.options.rtcRoomId?this.options.rtcRoomId:e,this.options.rtcPeerId=this.options.rtcPeerId?this.options.rtcPeerId:t,hi().setConfig(this.options),ui.info("WatchRTC setConfig."))}catch(e){ui.error("Failed to start WatchRTC session: ",e)}}},mi=(0,E.getLogger)("modules/statistics/AnalyticsAdapter.js"),gi=new class{constructor(){this.reset()}reset(){this.disposed=!1,this.analyticsHandlers=new Set,this.cache=[],this.permanentProperties={},this.conferenceName="",this.addPermanentProperties({user_agent:navigator.userAgent,browser_name:ci.getName()})}dispose(){mi.debug("Disposing of analytics adapter."),this.analyticsHandlers&&this.analyticsHandlers.size>0&&this.analyticsHandlers.forEach((e=>{"function"==typeof e.dispose&&e.dispose()})),this.setAnalyticsHandlers([]),this.disposed=!0}setAnalyticsHandlers(e){if(this.disposed)return;this.analyticsHandlers=new Set(e),this._setUserProperties();const t=this.cache;this.cache=null,t&&t.forEach((e=>this._sendEvent(e)))}_setUserProperties(){this.analyticsHandlers.forEach((e=>{try{e.setUserProperties(this.permanentProperties)}catch(e){mi.warn(`Error in setUserProperties method of one of the analytics handlers: ${e}`)}}))}addPermanentProperties(e){this.permanentProperties={...this.permanentProperties,...e},this._setUserProperties()}setConferenceName(e){this.conferenceName=e,this.addPermanentProperties({conference_name:e})}sendEvent(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(this.disposed)return;let n=null;"string"==typeof e?n={type:Nt,action:e,actionSubject:e,source:e,attributes:t}:"object"==typeof e&&(n=e),this._verifyRequiredFields(n)?this._sendEvent(n):mi.error(`Dropping a mis-formatted event: ${JSON.stringify(n)}`)}_verifyRequiredFields(e){if(!e)return!1;e.type||(e.type=Nt);const t=e.type;return t!==Nt&&t!==Mt&&t!==Ft&&t!==Lt?(mi.error(`Unknown event type: ${t}`),!1):t===Mt?Boolean(e.name):(e.action=e.action||e.name||e.actionSubject,e.actionSubject=e.actionSubject||e.name||e.action,e.source=e.source||e.name||e.action||e.actionSubject,e.action&&e.actionSubject&&e.source?!!(t!==Lt||(e.objectType=e.objectType||"generic-object-type",e.containerType=e.containerType||"conference","conference"!==e.containerType||e.containerId||(e.containerId=this.conferenceName),e.objectType&&e.objectId&&e.containerType&&e.containerId))||(mi.error("Required field missing (containerId, containerType, objectId or objectType)"),!1):(mi.error("Required field missing (action, actionSubject or source)"),!1))}_maybeCacheEvent(e){return!!this.cache&&(this.cache.push(e),this.cache.length>100&&this.cache.splice(0,1),!0)}_sendEvent(e){this._maybeCacheEvent(e)||this.analyticsHandlers.forEach((t=>{try{t.sendEvent(e)}catch(e){mi.warn(`Error sending analytics event: ${e}`)}}))}},fi=n(810).getLogger("modules/statistics/LocalStatsCollector.js");window.AudioContext=window.AudioContext||window.webkitAudioContext;let vi=null;function _i(e,t,n){this.stream=e,this.intervalId=null,this.intervalMilis=t,this.audioLevel=0,this.callback=n,this.source=null,this.analyser=null}function yi(e){let t=e;return e>=Number.MAX_SAFE_INTEGER&&(t=0),t+1}function Ei(e){return e.length>0?e.reduce(((e,t)=>e+t))/e.length:0}function Si(e){return e.filter((e=>e>=0))}_i.prototype.start=function(){_i.isLocalStatsSupported()&&(vi.resume(),this.analyser=vi.createAnalyser(),this.analyser.smoothingTimeConstant=.8,this.analyser.fftSize=2048,this.source=vi.createMediaStreamSource(this.stream),this.source.connect(this.analyser),this.intervalId=setInterval((()=>{const e=new Uint8Array(this.analyser.frequencyBinCount);this.analyser.getByteTimeDomainData(e);const t=function(e){let t=0;const n=e.length;for(let i=0;i<n;i++)t<e[i]&&(t=e[i]);return parseFloat(((t-127)/128).toFixed(3))}(e);this.audioLevel=function(e,t){let n=0;const i=t-e;return n=i>.2?t-.2:i<-.4?t+.4:e,parseFloat(n.toFixed(3))}(t,this.audioLevel),this.callback(this.audioLevel)}),this.intervalMilis))},_i.prototype.stop=function(){var e,t;this.intervalId&&(clearInterval(this.intervalId),this.intervalId=null),null===(e=this.analyser)||void 0===e||e.disconnect(),this.analyser=null,null===(t=this.source)||void 0===t||t.disconnect(),this.source=null},_i.init=function(){_i.connectAudioContext()},_i.isLocalStatsSupported=function(){var e;return Boolean(null===(e=window)||void 0===e?void 0:e.AudioContext)},_i.disconnectAudioContext=async function(){vi&&(fi.info("Disconnecting audio context"),await vi.close(),vi=null)},_i.connectAudioContext=function(){_i.isLocalStatsSupported()&&(fi.info("Connecting audio context"),vi=new AudioContext,vi.suspend())};class bi{constructor(){this.average=0,this.n=0}addNext(e){"number"==typeof e&&(this.n+=1,this.average=this.average+(e-this.average)/this.n)}getAverage(){return this.average}}function Ti(e,t){return isNaN(e)||isNaN(t)?0:e-t}const Ci=(0,E.getLogger)("modules/statistics/PerformanceObserverStats.js");class xi{constructor(e,t){this.eventEmitter=e,this.longTasks=0,this.maxDuration=0,this.performanceStatsInterval=t,this.stats=new bi}getLongTasksStats(){return{avgRatePerMinute:(60*this.stats.getAverage()).toFixed(2),maxDurationMs:this.maxDuration}}startObserver(){this.longTaskEventHandler=e=>{const t=e.getEntries();for(const e of t)this.longTasks++,this.maxDuration=Math.max(this.maxDuration,e.duration).toFixed(3)},Ci.info("Creating a Performance Observer for monitoring Long Tasks"),this.observer=new PerformanceObserver(this.longTaskEventHandler),this.observer.observe({type:"longtask",buffered:!0});const e=Date.now();this.longTasksIntervalId=setInterval((()=>{const t=Date.now(),n=this._lastTimeStamp?(t-this._lastTimeStamp)/1e3:(t-e)/1e3,i=this.longTasks/n;this.stats.addNext(i),this.eventEmitter.emit(vn,this.getLongTasksStats()),this.longTasks=0,this._lastTimeStamp=Date.now()}),this.performanceStatsInterval)}stopObserver(){this.observer&&this.observer.disconnect(),this.longTaskEventHandler=null,this.longTasksIntervalId&&(clearInterval(this.longTasksIntervalId),this.longTasksIntervalId=null)}}let Ri;!function(e){e.AUDIO="audio",e.VIDEO="video"}(Ri||(Ri={}));const Ai=new class{init(e){this._runInLiteMode=Boolean(e.runInLiteMode),this._ssrcRewriting=Boolean(e.ssrcRewritingEnabled)}isRunInLiteModeEnabled(){return this._runInLiteMode&&ci.supportsInsertableStreams()}isSsrcRewritingSupported(){return this._ssrcRewriting}},wi=(0,E.getLogger)("modules/statistics/RTPStatsCollector.js");function Ii(e,t){return e>0&&t>0?Math.round(e/t*100):0}function Pi(){this.loss={},this.bitrate={download:0,upload:0},this.resolution={},this.framerate=0,this.codec=""}function Di(){this.bandwidth={},this.bitrate={},this.packetLoss=null,this.transport=[]}function Oi(e,t,n,i){this.peerconnection=e,this.currentStatsReport=null,this.previousStatsReport=null,this.audioLevelReportHistory={},this.audioLevelsIntervalId=null,this.eventEmitter=i,this.conferenceStats=new Di,this.audioLevelsIntervalMilis=t,this.speakerList=[],this.statsIntervalId=null,this.statsIntervalMilis=n,this.ssrc2stats=new Map}Pi.prototype.setLoss=function(e){this.loss=e||{}},Pi.prototype.setResolution=function(e){this.resolution=e||{}},Pi.prototype.addBitrate=function(e){this.bitrate.download+=e.download,this.bitrate.upload+=e.upload},Pi.prototype.resetBitrate=function(){this.bitrate.download=0,this.bitrate.upload=0},Pi.prototype.setFramerate=function(e){this.framerate=e||0},Pi.prototype.setCodec=function(e){this.codec=e||""},Pi.prototype.setFramesDecoded=function(e){this.framesDecoded="number"==typeof e?e:void 0},Oi.prototype.setSpeakerList=function(e){this.speakerList=e},Oi.prototype.stop=function(){this.audioLevelsIntervalId&&(clearInterval(this.audioLevelsIntervalId),this.audioLevelsIntervalId=null),this.statsIntervalId&&(clearInterval(this.statsIntervalId),this.statsIntervalId=null)},Oi.prototype.errorCallback=function(e){wi.error("Get stats error",e),this.stop()},Oi.prototype.start=function(e){e&&ci.supportsReceiverStats()&&(this.audioLevelsIntervalId=setInterval((()=>{const e=this.peerconnection.getAudioLevels(this.speakerList);for(const t in e)if(e.hasOwnProperty(t)){const n=2.5*e[t];this.eventEmitter.emit(pn,this.peerconnection,Number.parseInt(t,10),n,!1)}}),this.audioLevelsIntervalMilis));const t=()=>{this.peerconnection.getStats().then((e=>{this.currentStatsReport="function"==typeof(null==e?void 0:e.result)?e.result():e;try{this.processStatsReport()}catch(e){wi.error("Processing of RTP stats failed:",e)}this.previousStatsReport=this.currentStatsReport})).catch((e=>this.errorCallback(e)))};t(),this.statsIntervalId=setInterval(t,this.statsIntervalMilis)},Oi.prototype._processAndEmitReport=function(){const e={download:0,upload:0},t={download:0,upload:0};let n=0,i=0;const r={},o={},s={};let a=0,d=0,c=0,l=0;const h=new Map;for(const[m,g]of this.ssrc2stats){var u;const f=g.loss,v=f.isDownloadStream?"download":"upload";e[v]+=f.packetsTotal,t[v]+=f.packetsLost;const _=g.bitrate.download,y=g.bitrate.upload;n+=_,i+=y,g.resetBitrate();const E=this.peerconnection.getTrackBySSRC(m);if(!E)continue;let S,b;f.isDownloadStream&&!E.isLocal()&&E.isVideoTrack()&&"number"==typeof g.framesDecoded&&h.set(m,g.framesDecoded),E.isAudioTrack()?(a+=_,d+=y,S=g.codec):(c+=_,l+=y,b=g.codec);const T=E.getParticipantId();if(!T){Ai.isSsrcRewritingSupported()||wi.error(`No participant ID returned by ${E}`);continue}const C=null!==(u=s[T])&&void 0!==u?u:{};C[m]={audio:S,video:b},s[T]=C;const{resolution:x}=g;if(!E.isVideoTrack()||isNaN(null==x?void 0:x.height)||isNaN(null==x?void 0:x.width)||-1===x.height||-1===x.width)continue;const R=r[T]||{};if(E.isLocal()&&!ci.supportsTrackBasedStats()&&this.peerconnection.doesTrueSimulcast()){const e=this.peerconnection.getLocalVideoSSRCs(E);for(const t of e){var p;const e=null===(p=this.ssrc2stats.get(t))||void 0===p?void 0:p.resolution;null!=e&&e.height&&null!=e&&e.width&&(x.height=Math.max(x.height,e.height),x.width=Math.max(x.width,e.width))}}if(R[m]=x,r[T]=R,g.framerate>0){const e=o[T]||{};e[m]=g.framerate,o[T]=e}}this.conferenceStats.bitrate={upload:i,download:n},this.conferenceStats.bitrate.audio={upload:d,download:a},this.conferenceStats.bitrate.video={upload:l,download:c},this.conferenceStats.packetLoss={total:Ii(t.download+t.upload,e.download+e.upload),download:Ii(t.download,e.download),upload:Ii(t.upload,e.upload)};const m={};let g;Object.keys(this.audioLevelReportHistory).forEach((e=>{const{data:t,isLocal:n}=this.audioLevelReportHistory[e],i=t.reduce(((e,t)=>e+t))/t.length;if(n)g=i;else{const t=this.peerconnection.getTrackBySSRC(Number(e));if(t){const e=t.getParticipantId();e&&(m[e]=i)}}})),this.audioLevelReportHistory={},this.eventEmitter.emit(fn,this.peerconnection,{bandwidth:this.conferenceStats.bandwidth,bitrate:this.conferenceStats.bitrate,codec:s,framerate:o,framesDecoded:h,localAvgAudioLevels:g,avgAudioLevels:m,packetLoss:this.conferenceStats.packetLoss,resolution:r,transport:this.conferenceStats.transport}),this.conferenceStats.transport=[]},Oi.prototype.getNonNegativeValue=function(e){let t=e;return"number"!=typeof t&&(t=Number(t)),isNaN(t)?0:Math.max(0,t)},Oi.prototype._calculateBitrate=function(e,t,n){const i=this.getNonNegativeValue(e[n]),r=this.getNonNegativeValue(t[n]),o=Math.max(0,i-r),s=e.timestamp-t.timestamp;let a=0;return s>0&&(a=Math.round(8*o/s)),a},Oi.prototype._calculateFps=function(e,t,n){const i=e.timestamp-t.timestamp;let r=0;return i>0&&e[n]&&(r=(e[n]-t[n])/i*1e3),r},Oi.prototype.processStatsReport=function(){const e={};this.currentStatsReport.forEach((t=>{const n=this.previousStatsReport?this.previousStatsReport.get(t.id):null;if("candidate-pair"===t.type&&t.nominated&&"succeeded"===t.state){const e=t.availableIncomingBitrate,n=t.availableOutgoingBitrate;(e||n)&&(this.conferenceStats.bandwidth={download:Math.round(e/1e3),upload:Math.round(n/1e3)});const i=this.currentStatsReport.get(t.remoteCandidateId),r=this.currentStatsReport.get(t.localCandidateId);if(i&&r){const e=`${ci.isChromiumBased()?i.ip:i.address}:${i.port}`,n=`${ci.isChromiumBased()?r.ip:r.address}:${r.port}`,o=i.protocol,s=this.conferenceStats.transport;s.some((t=>t.ip===e&&t.type===o&&t.localip===n))||s.push({ip:e,type:o,localip:n,p2p:this.peerconnection.isP2P,localCandidateType:r.candidateType,remoteCandidateType:i.candidateType,networkType:r.networkType,rtt:1e3*t.currentRoundTripTime})}}else if("inbound-rtp"===t.type||"outbound-rtp"===t.type){const r=this.getNonNegativeValue(t.ssrc);if(!r)return;let o=this.ssrc2stats.get(r);o||(o=new Pi,this.ssrc2stats.set(r,o));let s=!0,a="packetsReceived";"outbound-rtp"===t.type&&(s=!1,a="packetsSent");let d,c=t[a];if((!c||c<0)&&(c=0),n){const e=this.getNonNegativeValue(n[a]),i=Math.max(0,c-e),r=this.getNonNegativeValue(t.packetsLost),d=this.getNonNegativeValue(n.packetsLost),l=Math.max(0,r-d);o.setLoss({packetsTotal:i+l,packetsLost:l,isDownloadStream:s})}if(void 0!==t.frameHeight&&void 0!==t.frameWidth){var i;const e=null===(i=t.active)||void 0===i||i;("inbound-rtp"===t.type||!ci.supportsTrackBasedStats()&&e)&&(d={height:t.frameHeight,width:t.frameWidth})}o.setResolution(d);let l=t.framesPerSecond;!l&&n&&(l=this._calculateFps(t,n,"framesSent")),o.setFramerate(Math.round(l||0)),"inbound-rtp"===t.type&&n&&o.addBitrate({download:this._calculateBitrate(t,n,"bytesReceived"),upload:0}),"inbound-rtp"===t.type&&"number"==typeof t.framesDecoded&&o.setFramesDecoded(t.framesDecoded),"inbound-rtp"!==t.type&&n&&(e[r]=this.getNonNegativeValue(t.bytesSent),o.addBitrate({download:0,upload:this._calculateBitrate(t,n,"bytesSent")}));const h=this.currentStatsReport.get(t.codecId);if(h){const e=h.mimeType.split("/")[1];e&&o.setCodec(e)}}else if(ci.supportsTrackBasedStats()&&"track"===t.type&&t.kind===Ri.VIDEO&&!t.remoteSource){const e={height:t.frameHeight,width:t.frameWidth},i=this.peerconnection.getLocalTracks(Ri.VIDEO);if(null==i||!i.length)return;const r=this.peerconnection.getSsrcByTrackId(t.trackIdentifier);if(!r)return;let o=this.ssrc2stats.get(r);o||(o=new Pi,this.ssrc2stats.set(r,o)),e.height&&e.width&&o.setResolution(e);let s=t.framesPerSecond;!s&&n&&(s=this._calculateFps(t,n,"framesSent")),o.setFramerate(s)}})),Object.keys(e).length&&this.eventEmitter.emit(gn,this.peerconnection,e),this._processAndEmitReport()};const ki=n(810).getLogger("modules/statistics/statistics.js");let Ni;function Mi(e,t){this.rtpStatsMap=new Map,this.eventEmitter=new ii,this.conference=e,this.xmpp=null==e?void 0:e.xmpp,this.options=t||{},Mi.instances.add(this),si.start(this.conference),ci.isReactNative()||pi.start(this.options.roomName,this.options.userName)}Mi.init=function(e){Mi.audioLevelsEnabled=!e.disableAudioLevels,"number"==typeof e.pcStatsInterval&&(Mi.pcStatsInterval=e.pcStatsInterval),"number"==typeof e.audioLevelsInterval&&(Mi.audioLevelsInterval=e.audioLevelsInterval),"number"==typeof e.longTasksStatsInterval&&(Mi.longTasksStatsInterval=e.longTasksStatsInterval),Mi.disableThirdPartyRequests=e.disableThirdPartyRequests,_i.init(),pi.init(e),si.init(e)},Mi.audioLevelsEnabled=!1,Mi.audioLevelsInterval=200,Mi.pcStatsInterval=1e4,Mi.disableThirdPartyRequests=!1,Mi.analytics=gi,Object.defineProperty(Mi,"instances",{get:()=>(Ni||(Ni=new Set),Ni)}),Mi.prototype.startRemoteStats=function(e){this.stopRemoteStats(e);try{const t=new Oi(e,Mi.audioLevelsInterval,Mi.pcStatsInterval,this.eventEmitter);t.start(Mi.audioLevelsEnabled),this.rtpStatsMap.set(e.id,t)}catch(e){ki.error(`Failed to start collecting remote statistics: ${e}`)}},Mi.localStats=[],Mi.startLocalStats=function(e,t){if(ci.isIosBrowser()&&e.addEventListener(bt.NO_DATA_FROM_SOURCE,(async e=>{if(e){for(const e of Mi.localStats)e.stop();await _i.disconnectAudioContext()}else{_i.connectAudioContext();for(const e of Mi.localStats)e.start()}})),!Mi.audioLevelsEnabled)return;e.addEventListener(bt.LOCAL_TRACK_STOPPED,(()=>{Mi.stopLocalStats(e)}));const n=new _i(e.getOriginalStream(),Mi.audioLevelsInterval,t);this.localStats.push(n),n.start()},Mi.prototype.addAudioLevelListener=function(e){Mi.audioLevelsEnabled&&this.eventEmitter.on(pn,e)},Mi.prototype.removeAudioLevelListener=function(e){Mi.audioLevelsEnabled&&this.eventEmitter.removeListener(pn,e)},Mi.prototype.addBeforeDisposedListener=function(e){this.eventEmitter.on(mn,e)},Mi.prototype.removeBeforeDisposedListener=function(e){this.eventEmitter.removeListener(mn,e)},Mi.prototype.addConnectionStatsListener=function(e){this.eventEmitter.on(fn,e)},Mi.prototype.removeConnectionStatsListener=function(e){this.eventEmitter.removeListener(fn,e)},Mi.prototype.addByteSentStatsListener=function(e){this.eventEmitter.on(gn,e)},Mi.prototype.removeByteSentStatsListener=function(e){this.eventEmitter.removeListener(gn,e)},Mi.prototype.addLongTasksStatsListener=function(e){this.eventEmitter.on(vn,e)},Mi.prototype.attachLongTasksStats=function(){ci.supportsPerformanceObserver()?(this.performanceObserverStats=new xi(this.eventEmitter,Mi.longTasksStatsInterval),this.conference.on(ce,(()=>this.performanceObserverStats.startObserver())),this.conference.on(le,(()=>this.performanceObserverStats.stopObserver()))):ki.warn("Performance observer for long tasks not supported by browser!")},Mi.prototype.getLongTasksStats=function(){return this.performanceObserverStats?this.performanceObserverStats.getLongTasksStats():null},Mi.prototype.removeLongTasksStatsListener=function(e){this.eventEmitter.removeListener(vn,e)},Mi.prototype.setSpeakerList=function(e){for(const t of Array.from(this.rtpStatsMap.values()))t.peerconnection.isP2P||t.setSpeakerList(e)},Mi.prototype.dispose=function(){try{this.eventEmitter.emit(mn);for(const e of this.rtpStatsMap.keys())this._stopRemoteStats(e);this.eventEmitter&&this.eventEmitter.removeAllListeners()}finally{Mi.instances.delete(this)}},Mi.stopLocalStats=function(e){if(!Mi.audioLevelsEnabled)return;const t=e.getOriginalStream();for(let e=0;e<Mi.localStats.length;e++)if(Mi.localStats[e].stream===t){Mi.localStats.splice(e,1)[0].stop();break}},Mi.prototype._stopRemoteStats=function(e){const t=this.rtpStatsMap.get(e);t&&(t.stop(),this.rtpStatsMap.delete(e))},Mi.prototype.stopRemoteStats=function(e){this._stopRemoteStats(e.id)},Mi.prototype.sendFeedback=function(e,t){return Mi.analytics.sendEvent(Yt,{rating:e,comment:t}),Promise.resolve()},Mi.LOCAL_JID=n(680).D,Mi.sendAnalyticsAndLog=function(e){let t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};e?(t="object"==typeof e?e:{name:e,properties:n},ki.log(JSON.stringify(t)),this.analytics.sendEvent(e,n)):ki.warn("No event or event name given.")},Mi.sendAnalytics=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};this.analytics.sendEvent(e,t)};var Li=n(832),Fi=n.n(Li),ji=n(987),Vi=n(514),Ui=n.n(Vi),Hi=n(609);const $i=(0,E.getLogger)("JitsiConferenceEventManager.js");function Ji(e){this.conference=e,this.xmppListeners={}}Ji.prototype.setupChatRoomListeners=function(){const e=this.conference,t=e.room;this.chatRoomForwarder=new(Fi())(t,this.conference.eventEmitter),t.addListener(Hi.XMPPEvents.ICE_RESTARTING,(t=>{t.isP2P||e.rtc.closeBridgeChannel()})),t.addListener(Hi.XMPPEvents.PARTICIPANT_FEATURES_CHANGED,((t,n)=>{const i=e.getParticipantById(St.Strophe.getResourceFromJid(t));i&&(i.setFeatures(n),e.eventEmitter.emit(Be,i))})),t.addListener(Hi.XMPPEvents.ICE_RESTART_SUCCESS,((t,n)=>{!t.isP2P&&e._setBridgeChannel(n,t.peerconnection)})),t.addListener(Hi.XMPPEvents.AUDIO_MUTED_BY_FOCUS,(t=>{Mi.sendAnalytics(ln(Ri.AUDIO)),e.mutedByFocusActor=t,e.rtc.setAudioMute(!0).then((()=>{e.isMutedByFocus=!0,e.mutedByFocusActor=null})).catch((t=>{e.mutedByFocusActor=null,$i.warn("Error while audio muting due to focus request",t)}))})),t.addListener(Hi.XMPPEvents.VIDEO_MUTED_BY_FOCUS,(t=>{Mi.sendAnalytics(ln(Ri.VIDEO)),e.mutedVideoByFocusActor=t,e.rtc.setVideoMute(!0).then((()=>{e.isVideoMutedByFocus=!0,e.mutedVideoByFocusActor=null})).catch((t=>{e.mutedVideoByFocusActor=null,$i.warn("Error while video muting due to focus request",t)}))})),this.chatRoomForwarder.forward(Hi.XMPPEvents.SUBJECT_CHANGED,Qe),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_JOINED,ce),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_JOIN_IN_PROGRESS,de),this.chatRoomForwarder.forward(Hi.XMPPEvents.MEETING_ID_SET,he),this.chatRoomForwarder.forward(Hi.XMPPEvents.CONFERENCE_TIMESTAMP_RECEIVED,oe),t.addListener(Hi.XMPPEvents.MUC_JOINED,(()=>{this.conference._onMucJoined(),this.conference.isJvbConnectionInterrupted=!1,Object.keys(t.connectionTimes).forEach((e=>{const n=sn(`conference_${e}`,{value:t.connectionTimes[e]});Mi.sendAnalytics(n)})),Object.keys(t.xmpp.connectionTimes).forEach((e=>{const n=sn(`xmpp_${e}`,{value:t.xmpp.connectionTimes[e]});Mi.sendAnalytics(n)}))})),t.addListener(Hi.XMPPEvents.RENEGOTIATION_FAILED,((t,n)=>{n.isP2P||e.eventEmitter.emit(ae,V,t)})),t.addListener(Ot,(t=>{e.eventEmitter.emit(rt,t)})),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_JOIN_ERROR,ae,w),this.chatRoomForwarder.forward(Hi.XMPPEvents.DISPLAY_NAME_REQUIRED,ae,k),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_CONNECT_ERROR,ae,w),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_CONNECT_NOT_ALLOWED_ERROR,ae,P),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_CONNECT_MEMBERS_ONLY_ERROR,ae,D),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_MAX_USERS_ERROR,ae,A),this.chatRoomForwarder.forward(Hi.XMPPEvents.PASSWORD_REQUIRED,ae,H),this.chatRoomForwarder.forward(Hi.XMPPEvents.AUTHENTICATION_REQUIRED,ae,T),this.chatRoomForwarder.forward(Hi.XMPPEvents.BRIDGE_DOWN,ae,J),t.addListener(Hi.XMPPEvents.BRIDGE_DOWN,(()=>Mi.sendAnalytics({action:"bridge.down",actionSubject:"bridge.down",type:Nt}))),t.addListener(Hi.XMPPEvents.CONNECTION_RESTARTED,(t=>{e._onConferenceRestarted(t)})),this.chatRoomForwarder.forward(Hi.XMPPEvents.RESERVATION_ERROR,ae,$),this.chatRoomForwarder.forward(Hi.XMPPEvents.GRACEFUL_SHUTDOWN,ae,L),t.addListener(Hi.XMPPEvents.CONNECTION_ICE_FAILED,(t=>{e._onIceConnectionFailed(t)})),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_DESTROYED,ae,R),this.chatRoomForwarder.forward(Hi.XMPPEvents.CHAT_ERROR_RECEIVED,se,C),this.chatRoomForwarder.forward(Hi.XMPPEvents.SETTINGS_ERROR_RECEIVED,se,x),this.chatRoomForwarder.forward(Hi.XMPPEvents.FOCUS_DISCONNECTED,ae,N),t.addListener(Hi.XMPPEvents.FOCUS_LEFT,(()=>{Mi.sendAnalytics({action:"focus.left",actionSubject:"focus.left",type:kt.TYPE_OPERATIONAL}),e.eventEmitter.emit(ae,M)})),t.addListener(Hi.XMPPEvents.SESSION_ACCEPT_TIMEOUT,(e=>{Mi.sendAnalyticsAndLog(dn(Vt,{p2p:e.isP2P}))})),t.addListener(Hi.XMPPEvents.RECORDER_STATE_CHANGED,((t,n)=>{if(n){const i=St.Strophe.getResourceFromJid(n),r=e.getParticipantById(i)||i;"off"===t.getStatus()?t.setTerminator(r):"on"===t.getStatus()&&t.setInitiator(r)}e.eventEmitter.emit(Ke,t)})),this.chatRoomForwarder.forward(Hi.XMPPEvents.TRANSCRIPTION_STATUS_CHANGED,st),this.chatRoomForwarder.forward(Hi.XMPPEvents.VIDEO_SIP_GW_AVAILABILITY_CHANGED,ht),this.chatRoomForwarder.forward(Hi.XMPPEvents.VIDEO_SIP_GW_SESSION_STATE_CHANGED,ut),this.chatRoomForwarder.forward(Hi.XMPPEvents.PHONE_NUMBER_CHANGED,Ge),t.setParticipantPropertyListener(((t,n)=>{const i=e.getParticipantById(n);i&&i.setProperty(t.tagName.substring("jitsi_participant_".length),t.value)})),t.addListener(Hi.XMPPEvents.KICKED,e.onMemberKicked.bind(e)),t.addListener(Hi.XMPPEvents.SUSPEND_DETECTED,e.onSuspendDetected.bind(e)),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_LOCK_CHANGED,ke),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_MEMBERS_ONLY_CHANGED,Ne),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_VISITORS_SUPPORTED_CHANGED,mt),t.addListener(Hi.XMPPEvents.MUC_MEMBER_JOINED,e.onMemberJoined.bind(e)),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_LOBBY_MEMBER_JOINED,Pe),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_LOBBY_MEMBER_UPDATED,Oe),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_LOBBY_MEMBER_LEFT,De),t.addListener(Hi.XMPPEvents.MUC_MEMBER_BOT_TYPE_CHANGED,e._onMemberBotTypeChanged.bind(e)),t.addListener(Hi.XMPPEvents.MUC_MEMBER_LEFT,e.onMemberLeft.bind(e)),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_LEFT,le),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_DENIED_ACCESS,ae,O),t.addListener(Hi.XMPPEvents.DISPLAY_NAME_CHANGED,e.onDisplayNameChanged.bind(e)),t.addListener(Hi.XMPPEvents.LOCAL_ROLE_CHANGED,(t=>{e.onLocalRoleChanged(t)})),t.addListener(Hi.XMPPEvents.MUC_ROLE_CHANGED,e.onUserRoleChanged.bind(e)),t.addListener(Ui().IDENTITY_UPDATED,((t,n)=>{e.authEnabled=t,e.authIdentity=n,e.eventEmitter.emit(W,t,n)})),t.addListener(Hi.XMPPEvents.MESSAGE_RECEIVED,((t,n,i,r,o,s)=>{const a=St.Strophe.getResourceFromJid(t);e.eventEmitter.emit(Me,a,n,r,o,s)})),t.addListener(Hi.XMPPEvents.PRIVATE_MESSAGE_RECEIVED,((t,n,i,r)=>{const o=St.Strophe.getResourceFromJid(t);e.eventEmitter.emit(Je,o,n,r)})),t.addListener(Hi.XMPPEvents.PRESENCE_STATUS,((t,n)=>{const i=St.Strophe.getResourceFromJid(t),r=e.getParticipantById(i);r&&r._status!==n&&(r._status=n,e.eventEmitter.emit(lt,i,n))})),t.addListener(Hi.XMPPEvents.JSON_MESSAGE_RECEIVED,((t,n)=>{const i=St.Strophe.getResourceFromJid(t),r=e.getParticipantById(i);r?e.eventEmitter.emit(Ce,r,n):e.eventEmitter.emit(Ve,i,n)})),t.addPresenceListener("startmuted",((t,n)=>{if(e.myUserId()===n)return;const i=e.getParticipantById(n);if(!i||!i.isModerator())return;const r="true"===t.attributes.audio,o="true"===t.attributes.video;let s=!1;r!==e.startMutedPolicy.audio&&(e.startMutedPolicy.audio=r,s=!0),o!==e.startMutedPolicy.video&&(e.startMutedPolicy.video=o,s=!0),s&&e.eventEmitter.emit(Xe,e.startMutedPolicy)})),this.chatRoomForwarder.forward(Hi.XMPPEvents.BREAKOUT_ROOMS_MOVE_TO_ROOM,ie),this.chatRoomForwarder.forward(Hi.XMPPEvents.BREAKOUT_ROOMS_UPDATED,re),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_METADATA_UPDATED,Le)},Ji.prototype.setupRTCListeners=function(){const e=this.conference,t=e.rtc;t.addListener(ji.default.REMOTE_TRACK_ADDED,e.onRemoteTrackAdded.bind(e)),t.addListener(ji.default.REMOTE_TRACK_REMOVED,e.onRemoteTrackRemoved.bind(e)),t.addListener(ji.default.DOMINANT_SPEAKER_CHANGED,((t,n,i)=>{if((e.lastDominantSpeaker!==t||e.dominantSpeakerIsSilent!==i)&&e.room&&(e.lastDominantSpeaker=t,e.dominantSpeakerIsSilent=i,e.eventEmitter.emit(ye,t,n,i),e.statistics&&e.myUserId()===t&&e.xmpp.sendDominantSpeakerEvent(e.room.roomjid,i),e.lastDominantSpeaker!==t&&n&&n.length)){const i=n.slice(0);e.myUserId!==t&&i.splice(0,0,t),i.length>5&&i.splice(5,i.length-5),e.statistics&&e.statistics.setSpeakerList(i)}})),t.addListener(ji.default.DATA_CHANNEL_OPEN,(()=>{const t=window.performance.now(),n="data.channel.opened";$i.log(`(TIME) ${n}:\\t`,t),e.room.connectionTimes[n]=t,Mi.sendAnalytics(sn(n,{value:t})),e.eventEmitter.emit(ve)})),t.addListener(ji.default.DATA_CHANNEL_CLOSED,(t=>{e.eventEmitter.emit(fe,t)})),t.addListener(ji.default.VIDEO_SSRCS_REMAPPED,(e=>{for(const t of this.conference.getMediaSessions())t.processSourceMap(e,Ri.VIDEO)})),t.addListener(ji.default.AUDIO_SSRCS_REMAPPED,(e=>{for(const t of this.conference.getMediaSessions())t.processSourceMap(e,Ri.AUDIO)})),t.addListener(ji.default.ENDPOINT_MESSAGE_RECEIVED,((t,n)=>{const i=e.getParticipantById(t);i?e.eventEmitter.emit(Ce,i,n):$i.warn(`Ignored ENDPOINT_MESSAGE_RECEIVED for not existing participant: ${t}`,n)})),t.addListener(ji.default.ENDPOINT_STATS_RECEIVED,((t,n)=>{const i=e.getParticipantById(t);i?e.eventEmitter.emit(xe,i,n):$i.warn(`Ignoring ENDPOINT_STATS_RECEIVED for a non-existant participant: ${t}`)})),t.addListener(ji.default.CREATE_ANSWER_FAILED,((t,n)=>{n.isP2P||e.eventEmitter.emit(ae,V,t)})),t.addListener(ji.default.CREATE_OFFER_FAILED,((t,n)=>{n.isP2P||e.eventEmitter.emit(ae,V,t)})),t.addListener(ji.default.SET_LOCAL_DESCRIPTION_FAILED,((t,n)=>{n.isP2P||e.eventEmitter.emit(ae,V,t)})),t.addListener(ji.default.SET_REMOTE_DESCRIPTION_FAILED,((t,n)=>{n.isP2P||e.eventEmitter.emit(ae,V,t)}))},Ji.prototype.removeXMPPListeners=function(){const e=this.conference;Object.keys(this.xmppListeners).forEach((t=>{e.xmpp.removeListener(t,this.xmppListeners[t])})),this.xmppListeners={}},Ji.prototype.setupXMPPListeners=function(){const e=this.conference;this._addConferenceXMPPListener(Hi.XMPPEvents.CALL_INCOMING,e.onIncomingCall.bind(e)),this._addConferenceXMPPListener(Hi.XMPPEvents.CALL_ACCEPTED,e.onCallAccepted.bind(e)),this._addConferenceXMPPListener(Hi.XMPPEvents.TRANSPORT_INFO,e.onTransportInfo.bind(e)),this._addConferenceXMPPListener(Hi.XMPPEvents.CALL_ENDED,e.onCallEnded.bind(e)),this._addConferenceXMPPListener(Hi.XMPPEvents.START_MUTED_FROM_FOCUS,((t,n)=>{e.options.config.ignoreStartMuted||(e.startAudioMuted=t,e.startVideoMuted=n,t&&(e.isMutedByFocus=!0),n&&(e.isVideoMutedByFocus=!0),e.getLocalTracks().forEach((t=>{switch(t.getType()){case Ri.AUDIO:e.startAudioMuted&&t.mute();break;case Ri.VIDEO:e.startVideoMuted&&t.mute()}})),e.eventEmitter.emit(Ye))})),this._addConferenceXMPPListener(Hi.XMPPEvents.AV_MODERATION_CHANGED,((t,n,i)=>{const r=e.getParticipants().find((e=>e.getJid()===i));e.eventEmitter.emit(Y,{enabled:t,mediaType:n,actor:r})})),this._addConferenceXMPPListener(Hi.XMPPEvents.AV_MODERATION_PARTICIPANT_APPROVED,((t,n)=>{const i=e.getParticipantById(St.Strophe.getResourceFromJid(n));i&&e.eventEmitter.emit(Q,{participant:i,mediaType:t})})),this._addConferenceXMPPListener(Hi.XMPPEvents.AV_MODERATION_PARTICIPANT_REJECTED,((t,n)=>{const i=e.getParticipantById(St.Strophe.getResourceFromJid(n));i&&e.eventEmitter.emit(Z,{participant:i,mediaType:t})})),this._addConferenceXMPPListener(Hi.XMPPEvents.AV_MODERATION_APPROVED,(t=>e.eventEmitter.emit(X,{mediaType:t}))),this._addConferenceXMPPListener(Hi.XMPPEvents.AV_MODERATION_REJECTED,(t=>{e.eventEmitter.emit(ee,{mediaType:t})})),this._addConferenceXMPPListener(Hi.XMPPEvents.VISITORS_MESSAGE,(t=>e.eventEmitter.emit(gt,t))),this._addConferenceXMPPListener(Hi.XMPPEvents.VISITORS_REJECTION,(()=>e.eventEmitter.emit(ft)))},Ji.prototype._addConferenceXMPPListener=function(e,t){this.xmppListeners[e]=t,this.conference.xmpp.addListener(e,t)},Ji.prototype.setupStatisticsListeners=function(){const e=this.conference;e.statistics&&(e.statistics.addAudioLevelListener(((t,n,i,r)=>{e.rtc.setAudioLevel(t,n,i,r)})),e.statistics.addBeforeDisposedListener((()=>{e.eventEmitter.emit(te)})),e.options.config.startSilent||e.statistics.addByteSentStatsListener(((t,n)=>{e.getLocalTracks(Ri.AUDIO).forEach((e=>{const i=t.getLocalSSRC(e);i&&n.hasOwnProperty(i)&&e.onByteSentStatsReceived(t,n[i])}))})))};class Bi{constructor(e,t,n,i,r,o,s,a,d){this._jid=e,this._id=St.Strophe.getResourceFromJid(e),this._conference=t,this._displayName=n,this._supportsDTMF=!1,this._tracks=[],this._role="none",this._status=o,this._hidden=i,this._statsID=r,this._properties={},this._identity=s,this._isReplacing=a,this._isReplaced=d,this._features=new Set,this._sources=new Map}_isMediaTypeMuted(e){return this.getTracks().reduce(((t,n)=>t&&(n.getType()!==e||n.isMuted())),!0)}_setSources(e,t,n,i){var r;let o=this._sources.get(e);const s={muted:t,videoType:i};null!==(r=o)&&void 0!==r&&r.size?o.set(n,s):(o=new Map,o.set(n,s),this._sources.set(e,o))}getBotType(){return this._botType}getConference(){return this._conference}getConnectionJid(){return this._connectionJid}getDisplayName(){return this._displayName}getFeatures(){return Promise.resolve(this._features)}getId(){return this._id}getIdentity(){return this._identity}getJid(){return this._jid}getProperty(e){return this._properties[e]}getRole(){return this._role}getSources(){return this._sources}getStatsID(){return this._statsID}getStatus(){return this._status}getTracks(){return this._tracks.slice()}getTracksByMediaType(e){return this.getTracks().filter((t=>t.getType()===e))}hasFeature(e){return this._features.has(e)}isAudioMuted(){return this._isMediaTypeMuted(Ri.AUDIO)}isHidden(){return this._hidden}isHiddenFromRecorder(){var e,t;return"true"===(null===(e=this._identity)||void 0===e||null===(t=e.user)||void 0===t?void 0:t["hidden-from-recorder"])}isModerator(){return"moderator"===this._role}isReplaced(){return this._isReplaced}isReplacing(){return this._isReplacing}isVideoMuted(){return this._isMediaTypeMuted(Ri.VIDEO)}setBotType(e){this._botType=e}setConnectionJid(e){this._connectionJid=e}setFeatures(e){this._features=e||new Set}setIsReplaced(e){this._isReplaced=e}setIsReplacing(e){this._isReplacing=e}setProperty(e,t){const n=this._properties[e];t!==n&&(this._properties[e]=t,this._conference.eventEmitter.emit(qe,this,e,n,t))}setRole(e){this._role=e}supportsDTMF(){return this._supportsDTMF}}let qi;!function(e){e.CONSTRAINT_FAILED="gum.constraint_failed",e.ELECTRON_DESKTOP_PICKER_ERROR="gum.electron_desktop_picker_error",e.ELECTRON_DESKTOP_PICKER_NOT_FOUND="gum.electron_desktop_picker_not_found",e.GENERAL="gum.general",e.NOT_FOUND="gum.not_found",e.PERMISSION_DENIED="gum.permission_denied",e.SCREENSHARING_GENERIC_ERROR="gum.screensharing_generic_error",e.SCREENSHARING_USER_CANCELED="gum.screensharing_user_canceled",e.TIMEOUT="gum.timeout",e.TRACK_IS_DISPOSED="track.track_is_disposed",e.TRACK_NO_STREAM_FOUND="track.no_stream_found",e.UNSUPPORTED_RESOLUTION="gum.unsupported_resolution",e.TRACK_TOO_MANY_TRACKS_IN_STREAM="track.too_many_tracks_in_stream",e.TRACK_NO_STREAM_TRACKS_FOUND="track.no_stream_tracks_found"}(qi||(qi={}));const Gi=qi.CONSTRAINT_FAILED,zi=qi.ELECTRON_DESKTOP_PICKER_ERROR,Ki=qi.ELECTRON_DESKTOP_PICKER_NOT_FOUND,Wi=qi.GENERAL,Xi=qi.NOT_FOUND,Yi=qi.PERMISSION_DENIED,Qi=qi.SCREENSHARING_GENERIC_ERROR,Zi=qi.SCREENSHARING_USER_CANCELED,er=qi.TIMEOUT,tr=qi.TRACK_IS_DISPOSED,nr=qi.TRACK_NO_STREAM_FOUND,ir=qi.UNSUPPORTED_RESOLUTION,rr=qi.TRACK_TOO_MANY_TRACKS_IN_STREAM,or=qi.TRACK_NO_STREAM_TRACKS_FOUND,sr={};function ar(e,t,n){if("object"==typeof e&&void 0!==e.name)switch(this.gum={error:e,constraints:t,devices:n&&Array.isArray(n)?n.slice(0):void 0},e.name){case"NotAllowedError":case"PermissionDeniedError":case"SecurityError":this.name=Yi,this.message=sr[this.name]+(this.gum.devices||[]).join(", ");break;case"DevicesNotFoundError":case"NotFoundError":this.name=Xi,this.message=sr[this.name]+(this.gum.devices||[]).join(", ");break;case"ConstraintNotSatisfiedError":case"OverconstrainedError":{const i=e.constraintName||e.constraint;t&&t.video&&(!n||n.indexOf("video")>-1)&&("minWidth"===i||"maxWidth"===i||"minHeight"===i||"maxHeight"===i||"width"===i||"height"===i||"deviceId"===i)?(this.name=ir,this.message=sr[this.name]+function(e,t){if(t&&t.video&&t.video.mandatory)switch(e){case"width":return t.video.mandatory.minWidth;case"height":return t.video.mandatory.minHeight;default:return t.video.mandatory[e]||""}return""}(i,t)):(this.name=Gi,this.message=sr[this.name]+e.constraintName);break}default:this.name=Wi,this.message=e.message||sr[this.name]}else{if("string"!=typeof e)throw new Error("Invalid arguments");sr[e]?(this.name=e,this.message=t||sr[e]):this.message=e}this.stack=e.stack||(new Error).stack}sr[ir]="Video resolution is not supported: ",sr[Zi]="User canceled screen sharing prompt",sr[Qi]="Unknown error from screensharing",sr[zi]="Unkown error from desktop picker",sr[Ki]="Failed to detect desktop picker",sr[Wi]="Generic getUserMedia error",sr[Yi]="User denied permission to use device(s): ",sr[Xi]="Requested device(s) was/were not found: ",sr[Gi]="Constraint could not be satisfied: ",sr[er]="Could not start media source. Timeout occured!",sr[tr]="Track has been already disposed",sr[nr]="Track does not have an associated Media Stream",ar.prototype=Object.create(Error.prototype),ar.prototype.constructor=ar;const dr=ar;let cr;!function(e){e.CONNECTION_DISCONNECTED="connection.connectionDisconnected",e.CONNECTION_ESTABLISHED="connection.connectionEstablished",e.CONNECTION_FAILED="connection.connectionFailed",e.CONNECTION_REDIRECTED="connection.redirected",e.WRONG_STATE="connection.wrongState",e.DISPLAY_NAME_REQUIRED="connection.display_name_required",e.PROPERTIES_UPDATED="connection.propertiesUpdated"}(cr||(cr={}));const lr=cr.CONNECTION_DISCONNECTED,hr=cr.CONNECTION_ESTABLISHED,ur=cr.CONNECTION_FAILED,pr=cr.CONNECTION_REDIRECTED,mr=cr.WRONG_STATE,gr=cr.DISPLAY_NAME_REQUIRED,fr=cr.PROPERTIES_UPDATED;var vr=n(32);function _r(e){return vr.parse(e)}let yr;n(352),function(e){e.CONNECTION_DROPPED_ERROR="connection.droppedError",e.OTHER_ERROR="connection.otherError",e.PASSWORD_REQUIRED="connection.passwordRequired",e.SERVER_ERROR="connection.serverError"}(yr||(yr={}));const Er=yr.CONNECTION_DROPPED_ERROR,Sr=yr.OTHER_ERROR,br=yr.PASSWORD_REQUIRED,Tr=yr.SERVER_ERROR;class Cr{constructor(){var e=this;this.promise=new Promise(((t,n)=>{this.resolve=function(){e.clearRejectTimeout(),t(...arguments)},this.reject=function(){e.clearRejectTimeout(),n(...arguments)}})),this.then=this.promise.then.bind(this.promise),this.catch=this.promise.catch.bind(this.promise)}clearRejectTimeout(){clearTimeout(this._timeout)}setRejectTimeout(e){this._timeout=setTimeout((()=>{this.reject(new Error("timeout"))}),e)}}class xr{constructor(){this.eventEmitter=new ii,this.addEventListener=this.on=this.addListener,this.removeEventListener=this.off=this.removeListener}addCancellableListener(e,t){return this.addListener(e,t),()=>this.removeListener(e,t)}addListener(e,t){return this.eventEmitter.addListener(e,t)}removeListener(e,t){return this.eventEmitter.removeListener(e,t)}emit(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];this.eventEmitter.emit(e,...n)}}const Rr=(0,E.getLogger)("modules/e2ee/E2EEContext.js"),Ar=Symbol("kJitsiE2EE");class wr{constructor(){let{sharedKey:e}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t="";const n=document.querySelector(\'script[src*="lib-jitsi-meet"]\');if(n){const e=n.src.lastIndexOf("/");t=`${n.src.substring(0,e)}/`}let i=`${t}lib-jitsi-meet.e2ee-worker.js`;if(t&&"/"!==t){const e=new Blob([`importScripts("${i}");`],{type:"application/javascript"});i=window.URL.createObjectURL(e)}this._worker=new Worker(i,{name:"E2EE Worker"}),this._worker.onerror=e=>Rr.error(e),this._worker.postMessage({operation:"initialize",sharedKey:e})}cleanup(e){this._worker.postMessage({operation:"cleanup",participantId:e})}cleanupAll(){this._worker.postMessage({operation:"cleanupAll"})}handleReceiver(e,t,n){if(!e[Ar])if(e[Ar]=!0,window.RTCRtpScriptTransform){const t={operation:"decode",participantId:n};e.transform=new RTCRtpScriptTransform(this._worker,t)}else{const t=e.createEncodedStreams();this._worker.postMessage({operation:"decode",readableStream:t.readable,writableStream:t.writable,participantId:n},[t.readable,t.writable])}}handleSender(e,t,n){if(!e[Ar])if(e[Ar]=!0,window.RTCRtpScriptTransform){const t={operation:"encode",participantId:n};e.transform=new RTCRtpScriptTransform(this._worker,t)}else{const t=e.createEncodedStreams();this._worker.postMessage({operation:"encode",readableStream:t.readable,writableStream:t.writable,participantId:n},[t.readable,t.writable])}}setKey(e,t,n){this._worker.postMessage({operation:"setKey",key:t,keyIndex:n,participantId:e})}}const Ir=(0,E.getLogger)("modules/e2ee/KeyHandler.js");class Pr extends xr{constructor(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};super(),this.conference=e,this.e2eeCtx=new wr(t),this.enabled=!1,this._enabling=void 0,this.conference.on(q,this._onMediaSessionStarted.bind(this)),this.conference.on(tt,(e=>e.isLocal()&&this._onLocalTrackAdded(e))),this.conference.rtc.on(ji.default.REMOTE_TRACK_ADDED,((e,t)=>this._setupReceiverE2EEForTrack(t,e))),this.conference.on(it,this._trackMuteChanged.bind(this))}isEnabled(){return this.enabled}async setEnabled(e){this._enabling&&await this._enabling,e!==this.enabled&&(this._enabling=new Cr,this.enabled=e,e||this.e2eeCtx.cleanupAll(),this._setEnabled&&await this._setEnabled(e),this.conference.setLocalParticipantProperty("e2ee.enabled",e),this.conference._restartMediaSessions(),this._enabling.resolve())}setEncryptionKey(){throw new Error("Not implemented by subclass")}_onLocalTrackAdded(e){for(const t of this.conference.getMediaSessions())this._setupSenderE2EEForTrack(t,e)}_onMediaSessionStarted(e){const t=this.conference.getLocalTracks();for(const n of t)this._setupSenderE2EEForTrack(e,n)}_setupReceiverE2EEForTrack(e,t){if(!this.enabled)return;const n=e.findReceiverForTrack(t.track);n?this.e2eeCtx.handleReceiver(n,t.getType(),t.getParticipantId()):Ir.warn(`Could not handle E2EE for ${t}: receiver not found in: ${e}`)}_setupSenderE2EEForTrack(e,t){if(!this.enabled)return;const n=e.peerconnection,i=n&&n.findSenderForTrack(t.track);i?this.e2eeCtx.handleSender(i,t.getType(),t.getParticipantId()):Ir.warn(`Could not handle E2EE for ${t}: sender not found in ${n}`)}_trackMuteChanged(e){if(ci.doesVideoMuteByStreamRemove()&&e.isLocal()&&e.isVideoTrack()&&!e.isMuted())for(const t of this.conference.getMediaSessions())this._setupSenderE2EEForTrack(t,e)}}class Dr extends Pr{constructor(e){super(e,{sharedKey:!0})}setKey(e){this.e2eeCtx.setKey(void 0,{encryptionKey:e.encryptionKey},e.index)}}var Or=n(509),kr=n.n(Or),Nr=n(577),Mr=n(433);Mr.v1,Mr.v3;const Lr=Mr.v4;let Fr;Mr.v5,function(e){e.E2EE_SAS_KEYS_MAC_MISMATCH="e2ee.sas.keys-mac-mismatch",e.E2EE_SAS_MAC_MISMATCH="e2ee.sas.mac-mismatch",e.E2EE_SAS_MISSING_KEY="e2ee.sas.missing-key",e.E2EE_SAS_COMMITMENT_MISMATCHED="e2ee.sas.commitment-mismatched",e.E2EE_SAS_CHANNEL_VERIFICATION_FAILED="e2ee.sas.channel-verification-failed",e.E2EE_SAS_INVALID_SAS_VERIFICATION="e2ee.sas.invalid-sas-verification"}(Fr||(Fr={}));const jr=[["🐶","dog"],["🐱","cat"],["🦁","lion"],["🐎","horse"],["🦄","unicorn"],["🐷","pig"],["🐘","elephant"],["🐰","rabbit"],["🐼","panda"],["🐓","rooster"],["🐧","penguin"],["🐢","turtle"],["🐟","fish"],["🐙","octopus"],["🦋","butterfly"],["🌷","flower"],["🌳","tree"],["🌵","cactus"],["🍄","mushroom"],["🌏","globe"],["🌙","moon"],["☁️","cloud"],["🔥","fire"],["🍌","banana"],["🍎","apple"],["🍓","strawberry"],["🌽","corn"],["🍕","pizza"],["🎂","cake"],["❤️","heart"],["🙂","smiley"],["🤖","robot"],["🎩","hat"],["👓","glasses"],["🔧","spanner"],["🎅","santa"],["👍","thumbs up"],["☂️","umbrella"],["⌛","hourglass"],["⏰","clock"],["🎁","gift"],["💡","light bulb"],["📕","book"],["✏️","pencil"],["📎","paperclip"],["✂️","scissors"],["🔒","lock"],["🔑","key"],["🔨","hammer"],["☎️","telephone"],["🏁","flag"],["🚂","train"],["🚲","bicycle"],["✈️","aeroplane"],["🚀","rocket"],["🏆","trophy"],["⚽","ball"],["🎸","guitar"],["🎺","trumpet"],["🔔","bell"],["⚓️","anchor"],["🎧","headphones"],["📁","folder"],["📌","pin"]],Vr={decimal:function(e){return[1e3+(e[0]<<5|e[1]>>3),1e3+((7&e[1])<<10|e[2]<<2|e[3]>>6),1e3+((63&e[3])<<7|e[4]>>1)]},emoji:function(e){return[e[0]>>2,(3&e[0])<<4|e[1]>>4,(15&e[1])<<2|e[2]>>6,63&e[2],e[3]>>2,(3&e[3])<<4|e[4]>>4,(15&e[4])<<2|e[5]>>6].map((e=>jr[e]))}},Ur=(0,E.getLogger)("modules/e2ee/OlmAdapter.js"),Hr=5e3,$r="olm",Jr="error",Br="key-info",qr="key-info-ack",Gr="session-ack",zr="session-init",Kr="sas-start",Wr="sas-accept",Xr="sas-key",Yr="sas-mac",Qr="Jitsi-KEY_VERIFICATION_MAC",Zr="Jitsi-KEY_IDS",eo=Symbol("OlmData"),to={PARTICIPANT_E2EE_CHANNEL_READY:"olm.participant_e2ee_channel_ready",PARTICIPANT_SAS_AVAILABLE:"olm.participant_sas_available",PARTICIPANT_SAS_READY:"olm.participant_sas_ready",PARTICIPANT_KEY_UPDATED:"olm.partitipant_key_updated",PARTICIPANT_VERIFICATION_COMPLETED:"olm.participant_verification_completed"};class no extends xr{constructor(e){super(),this._conf=e,this._init=new Cr,this._mediaKey=void 0,this._mediaKeyIndex=-1,this._reqs=new Map,this._sessionInitialization=void 0,no.isSupported()?(this._bootstrapOlm(),this._conf.on(Ce,this._onEndpointMessageReceived.bind(this)),this._conf.on(le,this._onConferenceLeft.bind(this)),this._conf.on(dt,this._onParticipantLeft.bind(this)),this._conf.on(qe,this._onParticipantPropertyChanged.bind(this))):this._init.reject(new Error("Olm not supported"))}get myId(){return this._conf.myUserId()}async initSessions(){if(this._sessionInitialization)throw new Error("OlmAdapter initSessions called multiple times");{this._sessionInitialization=new Cr,await this._init;const e=[],t=this._conf.myUserId();for(const n of this._conf.getParticipants())n.hasFeature(Ia)&&t<n.getId()&&e.push(this._sendSessionInit(n));await Promise.allSettled(e),this._sessionInitialization.resolve(),this._sessionInitialization=void 0}}static isSupported(){return void 0!==window.Olm}async updateKey(e){this._mediaKey=e,this._mediaKeyIndex++;const t=[];for(const e of this._conf.getParticipants()){const n=e.getId(),i=this._getParticipantOlmData(e);if(!i.session){Ur.warn(`Tried to send key to participant ${n} but we have no session`);continue}const r=Lr(),o={[Aa]:$r,olm:{type:Br,data:{ciphertext:this._encryptKeyInfo(i.session),uuid:r}}},s=new Cr;s.setRejectTimeout(Hr),s.catch((()=>{this._reqs.delete(r)})),this._reqs.set(r,s),t.push(s),this._sendMessage(o,n)}return await Promise.allSettled(t),this._mediaKeyIndex}updateCurrentMediaKey(e){return this._mediaKey=e,this._mediaKeyIndex}clearParticipantSession(e){const t=this._getParticipantOlmData(e);t.session&&(t.session.free(),t.session=void 0)}clearAllParticipantsSessions(){for(const e of this._conf.getParticipants())this.clearParticipantSession(e)}markParticipantVerified(e,t){const n=this._getParticipantOlmData(e),i=e.getId();if(!t)return n.sasVerification=void 0,Ur.warn(`Verification failed for participant ${i}`),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_CHANNEL_VERIFICATION_FAILED);if(!n.sasVerification)return Ur.warn(`Participant ${i} does not have valid sasVerification`),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_INVALID_SAS_VERIFICATION);const{sas:r,sasMacSent:o}=n.sasVerification;r&&r.is_their_key_set()&&!o&&(this._sendSasMac(e),n.sasVerification.sasMacSent=!0)}async _bootstrapOlm(){Ur.debug("Initializing Olm...");try{await Olm.init(),this._olmAccount=new Olm.Account,this._olmAccount.create(),this._idKeys=_r(this._olmAccount.identity_keys()),Ur.debug(`Olm ${Olm.get_library_version().join(".")} initialized`),this._init.resolve(),this._onIdKeysReady(this._idKeys)}catch(e){Ur.error("Failed to initialize Olm",e),this._init.reject(e)}}startVerification(e){const t=e.getId(),n=this._getParticipantOlmData(e);if(!n.session)return void Ur.warn(`Tried to start verification with participant ${t} but we have no session`);if(n.sasVerification)return void Ur.warn(`There is already a verification in progress with participant ${t}`);n.sasVerification={sas:new Olm.SAS,transactionId:Lr()};const i={transactionId:n.sasVerification.transactionId};n.sasVerification.startContent=i,n.sasVerification.isInitiator=!0;const r={[Aa]:$r,olm:{type:Kr,data:i}};this._sendMessage(r,t)}_onIdKeysReady(e){Ur.debug(`Olm id key ready: ${e}`);for(const t in e)if(e.hasOwnProperty(t)){const n=e[t];this._conf.setLocalParticipantProperty(`e2ee.idKey.${t}`,n)}}_onParticipantE2EEChannelReady(e){Ur.debug(`E2EE channel with participant ${e} is ready`)}_encryptKeyInfo(e){const t={};return void 0!==this._mediaKey&&(t.key=!!this._mediaKey&&Nr.fromByteArray(this._mediaKey),t.keyIndex=this._mediaKeyIndex),e.encrypt(JSON.stringify(t))}_getParticipantOlmData(e){return e[eo]=e[eo]||{},e[eo]}async _onConferenceLeft(){Ur.debug("Conference left"),await this._init;for(const e of this._conf.getParticipants())this._onParticipantLeft(e.getId(),e);this._olmAccount&&(this._olmAccount.free(),this._olmAccount=void 0)}async _onEndpointMessageReceived(e,t){if(t[Aa]!==$r)return;if(!t.olm)return void Ur.warn("Incorrectly formatted message");await this._init;const n=t.olm,i=e.getId(),r=this._getParticipantOlmData(e);switch(n.type){case zr:if(r.session)Ur.warn(`Participant ${i} already has a session`),this._sendError(e,"Session already established");else{const e=new Olm.Session;e.create_outbound(this._olmAccount,n.data.idKey,n.data.otKey),r.session=e;const t={[Aa]:$r,olm:{type:Gr,data:{ciphertext:this._encryptKeyInfo(e),uuid:n.data.uuid}}};this._sendMessage(t,i),this._onParticipantE2EEChannelReady(i)}break;case Gr:if(r.session)Ur.warn(`Participant ${i} already has a session`),this._sendError(e,"No session found");else if(n.data.uuid===r.pendingSessionUuid){const{ciphertext:e}=n.data,t=this._reqs.get(n.data.uuid),o=new Olm.Session;o.create_inbound(this._olmAccount,e.body),this._olmAccount.remove_one_time_keys(o);const s=o.decrypt(e.type,e.body);r.session=o,r.pendingSessionUuid=void 0,this._onParticipantE2EEChannelReady(i),this._reqs.delete(n.data.uuid),t.resolve();const a=io(s);if(a.key){const e=Nr.toByteArray(a.key),t=a.keyIndex;r.lastKey=e,this.eventEmitter.emit(to.PARTICIPANT_KEY_UPDATED,i,e,t)}}else Ur.warn("Received ACK with the wrong UUID"),this._sendError(e,"Invalid UUID");break;case Jr:Ur.error(n.data.error);break;case Br:if(r.session){const{ciphertext:e}=n.data,t=io(r.session.decrypt(e.type,e.body));if(void 0!==t.key&&void 0!==t.keyIndex){const e=!!t.key&&Nr.toByteArray(t.key),o=t.keyIndex;Et()(r.lastKey,e)||(r.lastKey=e,this.eventEmitter.emit(to.PARTICIPANT_KEY_UPDATED,i,e,o));const s={[Aa]:$r,olm:{type:qr,data:{ciphertext:this._encryptKeyInfo(r.session),uuid:n.data.uuid}}};this._sendMessage(s,i)}}else Ur.debug(`Received key info message from ${i} but we have no session for them!`),this._sendError(e,"No session found while processing key-info");break;case qr:if(r.session){const{ciphertext:e}=n.data,t=io(r.session.decrypt(e.type,e.body));if(void 0!==t.key&&void 0!==t.keyIndex){const e=!!t.key&&Nr.toByteArray(t.key),n=t.keyIndex;Et()(r.lastKey,e)||(r.lastKey=e,this.eventEmitter.emit(to.PARTICIPANT_KEY_UPDATED,i,e,n))}const o=this._reqs.get(n.data.uuid);this._reqs.delete(n.data.uuid),o.resolve()}else Ur.debug(`Received key info ack message from ${i} but we have no session for them!`),this._sendError(e,"No session found while processing key-info-ack");break;case Kr:{var o;if(!r.session)return Ur.debug(`Received sas init message from ${i} but we have no session for them!`),void this._sendError(e,"No session found while processing sas-init");if(null!==(o=r.sasVerification)&&void 0!==o&&o.sas)return Ur.warn(`SAS already created for participant ${i}`),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_INVALID_SAS_VERIFICATION);const{transactionId:t}=n.data,s=new Olm.SAS;r.sasVerification={sas:s,transactionId:t,isInitiator:!1};const a=r.sasVerification.sas.get_pubkey(),d=this._computeCommitment(a,n.data),c={[Aa]:$r,olm:{type:Wr,data:{transactionId:t,commitment:d}}};this._sendMessage(c,i);break}case Wr:{if(!r.session)return Ur.debug(`Received sas accept message from ${i} but we have no session for them!`),void this._sendError(e,"No session found while processing sas-accept");const{commitment:t,transactionId:o}=n.data;if(!r.sasVerification)return Ur.warn(`SAS_ACCEPT Participant ${i} does not have valid sasVerification`),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_INVALID_SAS_VERIFICATION);if(r.sasVerification.sasCommitment)return Ur.debug(`Already received sas commitment message from ${i}!`),void this._sendError(e,"Already received sas commitment message from ${pId}!");r.sasVerification.sasCommitment=t;const s=r.sasVerification.sas.get_pubkey(),a={[Aa]:$r,olm:{type:Xr,data:{key:s,transactionId:o}}};this._sendMessage(a,i),r.sasVerification.keySent=!0;break}case Xr:{if(!r.session)return Ur.debug(`Received sas key message from ${i} but we have no session for them!`),void this._sendError(e,"No session found while processing sas-key");if(!r.sasVerification)return Ur.warn(`SAS_KEY Participant ${i} does not have valid sasVerification`),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_INVALID_SAS_VERIFICATION);const{isInitiator:t,sas:o,sasCommitment:s,startContent:a,keySent:d}=r.sasVerification;if(o.is_their_key_set())return void Ur.warn("SAS already has their key!");const{key:c,transactionId:l}=n.data;if(s&&s!==this._computeCommitment(c,a))return this._sendError(e,"OlmAdapter commitments mismatched"),this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_COMMITMENT_MISMATCHED),void r.sasVerification.free();o.set_their_key(c);const h=o.get_pubkey(),u=`${this.myId}|${h}`,p=`${i}|${c}`,m=t?`${u}|${p}`:`${p}|${u}`,g=function(e){const t={};for(const n in Vr)Vr.hasOwnProperty(n)&&(t[n]=Vr[n](e));return t}(o.generate_bytes(m,6));if(this.eventEmitter.emit(to.PARTICIPANT_SAS_READY,i,g),d)return;const f={[Aa]:$r,olm:{type:Xr,data:{key:h,transactionId:l}}};this._sendMessage(f,i),r.sasVerification.keySent=!0;break}case Yr:{if(!r.session)return Ur.debug(`Received sas mac message from ${i} but we have no session for them!`),void this._sendError(e,"No session found while processing sas-mac");const{keys:t,mac:o,transactionId:s}=n.data;if(!o||!t)return void Ur.warn("Invalid SAS MAC message");if(!r.sasVerification)return void Ur.warn(`SAS_MAC Participant ${i} does not have valid sasVerification`);const a=r.sasVerification.sas,d=`${Qr}${i}${this.myId}${s}`;if(a.calculate_mac(Object.keys(o).sort().join(","),d+Zr)!==t)return Ur.error("SAS verification error: keys MAC mismatch"),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_KEYS_MAC_MISMATCH);if(!r.ed25519)return Ur.warn("SAS verification error: Missing ed25519 key"),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_MISSING_KEY);for(const[e,t]of Object.entries(o))if(t!==a.calculate_mac(r.ed25519,d+e))return Ur.error("SAS verification error: MAC mismatch"),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_MAC_MISMATCH);Ur.info(`SAS MAC verified for participant ${i}`),this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!0);break}}}_onParticipantLeft(e,t){Ur.debug(`Participant ${e} left`),this.clearParticipantSession(t)}async _onParticipantPropertyChanged(e,t,n,i){const r=e.getId(),o=this._getParticipantOlmData(e);switch(t){case"e2ee.enabled":if(i&&this._conf.isE2EEEnabled()){const t=this._conf.myUserId();if((await e.getFeatures()).has(Ia)&&t<r){this._sessionInitialization&&await this._sessionInitialization,await this._sendSessionInit(e);const t=Lr(),n=new Cr;n.setRejectTimeout(Hr),n.catch((()=>{this._reqs.delete(t),o.pendingSessionUuid=void 0})),this._reqs.set(t,n);const i={[Aa]:$r,olm:{type:Br,data:{ciphertext:this._encryptKeyInfo(o.session),uuid:t}}};this._sendMessage(i,r)}}break;case"e2ee.idKey.ed25519":o.ed25519=i,this.eventEmitter.emit(to.PARTICIPANT_SAS_AVAILABLE,r)}}_sendError(e,t){const n=e.getId(),i={[Aa]:$r,olm:{type:Jr,data:{error:t}}};this._sendMessage(i,n)}_sendMessage(e,t){this._conf.sendMessage(e,t)}_sendSessionInit(e){const t=e.getId(),n=this._getParticipantOlmData(e);if(n.session)return Ur.warn(`Tried to send session-init to ${t} but we already have a session`),Promise.reject();if(void 0!==n.pendingSessionUuid)return Ur.warn(`Tried to send session-init to ${t} but we already have a pending session`),Promise.reject();this._olmAccount.generate_one_time_keys(1);const i=_r(this._olmAccount.one_time_keys()),r=Object.values(i.curve25519)[0];if(!r)return Promise.reject(new Error("No one-time-keys generated"));this._olmAccount.mark_keys_as_published();const o=Lr(),s={[Aa]:$r,olm:{type:zr,data:{idKey:this._idKeys.curve25519,otKey:r,uuid:o}}},a=new Cr;return a.setRejectTimeout(Hr),a.catch((()=>{this._reqs.delete(o),n.pendingSessionUuid=void 0})),this._reqs.set(o,a),this._sendMessage(s,t),n.pendingSessionUuid=o,a}_sendSasMac(e){const t=e.getId(),n=this._getParticipantOlmData(e),{sas:i,transactionId:r}=n.sasVerification,o={},s=[],a=`${Qr}${this.myId}${t}${r}`,d=`ed25519:${t}`;o[d]=i.calculate_mac(this._idKeys.ed25519,a+d),s.push(d);const c=i.calculate_mac(s.sort().join(","),a+Zr),l={[Aa]:$r,olm:{type:Yr,data:{keys:c,mac:o,transactionId:r}}};this._sendMessage(l,t)}_computeCommitment(e,t){const n=new Olm.Utility,i=n.sha256(e+JSON.stringify(t));return n.free(),i}}function io(e){try{return _r(e)}catch(e){return{}}}no.events=to;const ro=(0,E.getLogger)("modules/e2ee/ManagedKeyHandler.js");class oo extends Pr{constructor(e){super(e),this._key=void 0,this._conferenceJoined=!1,this._olmAdapter=new no(e),this._rotateKey=kr()(this._rotateKeyImpl,5e3),this._ratchetKey=kr()(this._ratchetKeyImpl,5e3),this._olmAdapter.on(no.events.PARTICIPANT_KEY_UPDATED,this._onParticipantKeyUpdated.bind(this)),this._olmAdapter.on(no.events.PARTICIPANT_SAS_READY,this._onParticipantSasReady.bind(this)),this._olmAdapter.on(no.events.PARTICIPANT_SAS_AVAILABLE,this._onParticipantSasAvailable.bind(this)),this._olmAdapter.on(no.events.PARTICIPANT_VERIFICATION_COMPLETED,this._onParticipantVerificationCompleted.bind(this)),this.conference.on(qe,this._onParticipantPropertyChanged.bind(this)),this.conference.on(at,this._onParticipantJoined.bind(this)),this.conference.on(dt,this._onParticipantLeft.bind(this)),this.conference.on(ce,(()=>{this._conferenceJoined=!0}))}get sasVerification(){return this._olmAdapter}async _setEnabled(e){e?await this._olmAdapter.initSessions():this._olmAdapter.clearAllParticipantsSessions(),this._key=!!e&&this._generateKey();const t=await this._olmAdapter.updateKey(this._key);this.e2eeCtx.setKey(this.conference.myUserId(),this._key,t)}async _onParticipantPropertyChanged(e,t,n,i){switch(t){case"e2ee.idKey":ro.debug(`Participant ${e.getId()} updated their id key: ${i}`);break;case"e2ee.enabled":!i&&this.enabled&&this._olmAdapter.clearParticipantSession(e)}}_onParticipantJoined(){this._conferenceJoined&&this.enabled&&this._ratchetKey()}_onParticipantLeft(e){this.e2eeCtx.cleanup(e),this.enabled&&this._rotateKey()}async _rotateKeyImpl(){ro.debug("Rotating key"),this._key=this._generateKey();const e=await this._olmAdapter.updateKey(this._key);this.e2eeCtx.setKey(this.conference.myUserId(),this._key,e)}async _ratchetKeyImpl(){ro.debug("Ratchetting key");const e=await async function(e){return crypto.subtle.importKey("raw",e,"HKDF",!1,["deriveBits","deriveKey"])}(this._key),t=await async function(e){const t=new TextEncoder;return crypto.subtle.deriveBits({name:"HKDF",salt:t.encode("JFrameRatchetKey"),hash:"SHA-256",info:new ArrayBuffer},e,256)}(e);this._key=new Uint8Array(t);const n=this._olmAdapter.updateCurrentMediaKey(this._key);this.e2eeCtx.setKey(this.conference.myUserId(),this._key,n)}_onParticipantKeyUpdated(e,t,n){ro.debug(`Participant ${e} updated their key`),this.e2eeCtx.setKey(e,t,n)}_onParticipantSasReady(e,t){this.conference.eventEmitter.emit(Te,e,t)}_onParticipantSasAvailable(e){this.conference.eventEmitter.emit(Se,e)}_onParticipantVerificationCompleted(e,t,n){this.conference.eventEmitter.emit(be,e,t,n)}_generateKey(){return window.crypto.getRandomValues(new Uint8Array(32))}}class so{constructor(e){const{e2ee:t={}}=e.options.config;this._externallyManaged=t.externallyManagedKey,this._externallyManaged?this._keyHandler=new Dr(e):this._keyHandler=new oo(e)}static isSupported(e){const{e2ee:t={}}=e;return!(!t.externallyManagedKey&&!no.isSupported())&&!(e.testing&&e.testing.disableE2EE)&&(ci.supportsInsertableStreams()||e.enableEncodedTransformSupport&&ci.supportsEncodedTransform())}isEnabled(){return this._keyHandler.isEnabled()}async setEnabled(e){await this._keyHandler.setEnabled(e)}setEncryptionKey(e){this._keyHandler.setKey(e)}startVerification(e){var t;null===(t=this._keyHandler.sasVerification)||void 0===t||t.startVerification(e)}markParticipantVerified(e,t){var n;null===(n=this._keyHandler.sasVerification)||void 0===n||n.markParticipantVerified(e,t)}}var ao=n(399),co=n.n(ao);function lo(e,t){e[t>>5]|=128<<24-t%32,e[15+(t+64>>9<<4)]=t;var n,i,r,o,s,a,d,c,l=new Array(80),h=1732584193,u=-271733879,p=-1732584194,m=271733878,g=-1009589776;for(n=0;n<e.length;n+=16){for(o=h,s=u,a=p,d=m,c=g,i=0;i<80;i++)l[i]=i<16?e[n+i]:mo(l[i-3]^l[i-8]^l[i-14]^l[i-16],1),r=po(po(mo(h,5),ho(i,u,p,m)),po(po(g,l[i]),uo(i))),g=m,m=p,p=mo(u,30),u=h,h=r;h=po(h,o),u=po(u,s),p=po(p,a),m=po(m,d),g=po(g,c)}return[h,u,p,m,g]}function ho(e,t,n,i){return e<20?t&n|~t&i:e<40?t^n^i:e<60?t&n|t&i|n&i:t^n^i}function uo(e){return e<20?1518500249:e<40?1859775393:e<60?-1894007588:-899497514}function po(e,t){var n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}function mo(e,t){return e<<t|e>>>32-t}function go(e){for(var t=[],n=0;n<8*e.length;n+=8)t[n>>5]|=(255&e.charCodeAt(n/8))<<24-n%32;return t}function fo(e){for(var t,n,i="",r=0;r<4*e.length;r+=3)for(t=(e[r>>2]>>8*(3-r%4)&255)<<16|(e[r+1>>2]>>8*(3-(r+1)%4)&255)<<8|e[r+2>>2]>>8*(3-(r+2)%4)&255,n=0;n<4;n++)8*r+6*n>32*e.length?i+="=":i+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(t>>6*(3-n)&63);return i}const vo=function(e){return fo(lo(go(e),8*e.length))},_o=["category","type","lang","name"],yo=["category","type","lang"];function Eo(e,t){let n=0;return yo.some((i=>0!==(n=e[i]>t[i]?1:e[i]<t[i]&&-1))),n}function So(e){const t=new Set,n=new Set;return _t()(e).find(">query>feature").each(((e,n)=>t.add(n.getAttribute("var")))),_t()(e).find(">query>identity").each(((e,t)=>n.add({type:t.getAttribute("type"),name:t.getAttribute("name"),category:t.getAttribute("category")}))),{features:t,identities:n}}class bo extends xr{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"http://jitsi.org/jitsimeet";if(super(),this.node=t,this.disco=e.disco,!this.disco)throw new Error("Missing strophe-plugins (disco plugin is required)!");this.version="",this.rooms=new Set,this.externalFeatures=new Set;const n=e.emuc;n.addListener(Hi.XMPPEvents.EMUC_ROOM_ADDED,(e=>this._addChatRoom(e))),n.addListener(Hi.XMPPEvents.EMUC_ROOM_REMOVED,(e=>this._removeChatRoom(e))),Object.keys(n.rooms).forEach((e=>{this._addChatRoom(n.rooms[e])})),St.Strophe.addNamespace("CAPS","http://jabber.org/protocol/caps"),this.disco.addFeature(St.Strophe.NS.CAPS)}addFeature(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];this.disco.addFeature(e),this._generateVersion(),n&&!this.externalFeatures.has(e)&&(this.externalFeatures.add(e),this.rooms.forEach((e=>this._updateRoomWithExternalFeatures(e)))),t&&this.submit()}removeFeature(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];this.disco.removeFeature(e),this._generateVersion(),n&&this.externalFeatures.has(e)&&(this.externalFeatures.delete(e),this.rooms.forEach((e=>this._updateRoomWithExternalFeatures(e)))),t&&this.submit()}submit(){this.rooms.forEach((e=>e.sendPresence()))}_updateRoomWithExternalFeatures(e){if(0===this.externalFeatures.size)e.removeFromPresence("features");else{const t=[];this.externalFeatures.forEach((e=>{t.push({tagName:"feature",attributes:{var:e}})})),e.addOrReplaceInPresence("features",{children:t})}}getFeaturesAndIdentities(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:5e3;return this._getDiscoInfo(e,t,n)}_getDiscoInfo(e,t,n){return new Promise(((i,r)=>this.disco.info(e,t,(e=>{i(So(e))}),r,n)))}_addChatRoom(e){this.rooms.add(e),this._fixChatRoomPresenceMap(e),this._updateRoomWithExternalFeatures(e)}_removeChatRoom(e){this.rooms.delete(e)}_fixChatRoomPresenceMap(e){e.addOrReplaceInPresence("c",{attributes:{xmlns:St.Strophe.NS.CAPS,hash:"sha-1",node:this.node,ver:this.version}})}_notifyVersionChanged(){this.rooms.forEach((e=>this._fixChatRoomPresenceMap(e)))}_generateVersion(){this.version=function(e,t){const n=e.sort(Eo).reduce(((e,t)=>`${_o.reduce(((e,n,i)=>e+(0===i?"":"/")+(t[n]?t[n]:"")),"")}<`),""),i=t.sort().reduce(((e,t)=>`${e+t}<`),"");return vo(n+i)}(this.disco._identities,this.disco._features),this._notifyVersionChanged()}}n(617);const To="NETWORK_INFO_CHANGED",Co=(0,E.getLogger)("modules/connectivity/NetworkInfo.js"),xo=new class extends xr{constructor(){super(),this._current={isOnline:!0}}updateNetworkInfo(e){let{isOnline:t}=e;Co.debug("updateNetworkInfo",{isOnline:t}),this._current={isOnline:!0===t},this.eventEmitter.emit(To,this._current)}isOnline(){return!0===this._current.isOnline}};function Ro(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:500,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:2;return Math.floor(Math.random()*(1e3*Math.pow(n,e)-t)+t)}const Ao=(0,E.getLogger)("modules/xmpp/ResumeTask.js");class wo{constructor(e){this._stropheConn=e,this._resumeRetryN=0,this._retryDelay=void 0}get retryDelay(){return this._retryDelay}schedule(){this._cancelResume(),this._resumeRetryN+=1,this._networkOnlineListener=xo.addCancellableListener(To,(e=>{let{isOnline:t}=e;t?this._scheduleResume():this._cancelResume()})),xo.isOnline()&&this._scheduleResume()}_scheduleResume(){this._resumeTimeout||(this._resumeRetryN=Math.min(3,this._resumeRetryN),this._retryDelay=Ro(this._resumeRetryN,1500*this._resumeRetryN,3),Ao.info(`Will try to resume the XMPP connection in ${this.retryDelay}ms`),this._resumeTimeout=setTimeout((()=>this._resumeConnection()),this.retryDelay))}_cancelResume(){this._resumeTimeout&&(Ao.info("Canceling connection resume task"),clearTimeout(this._resumeTimeout),this._resumeTimeout=void 0,this._retryDelay=void 0)}_resumeConnection(){const{streamManagement:e}=this._stropheConn,t=e.getResumeToken();if(!t)return;Ao.info("Trying to resume the XMPP connection");const n=new URL(this._stropheConn.service);let{search:i}=n;const r=/(previd=)([\\w-]+)/,o=i.match(r);o&&-1===o.indexOf(t)?i=i.replace(r,`$1${t}`):o||(i+=-1===i.indexOf("?")?`?previd=${t}`:`&previd=${t}`),n.search=i,this._stropheConn.service=n.toString(),e.resume()}cancel(){this._cancelResume(),this._resumeRetryN=0,this._networkOnlineListener&&(this._networkOnlineListener(),this._networkOnlineListener=null)}}class Io{constructor(){this._lastSuccess=null,this._lastFailedMessage=null}startTracking(e,t){var n=this;const i=t.rawInput;t.rawInput=function(){for(var r=arguments.length,o=new Array(r),s=0;s<r;s++)o[s]=arguments[s];const a=o[0];a.includes("failure")&&(n._lastFailedMessage=a),e.connected&&(n._lastSuccess=Date.now()),i.apply(t,o)}}getLastFailedMessage(){return this._lastFailedMessage}getTimeSinceLastSuccess(){return this._lastSuccess?Date.now()-this._lastSuccess:null}}function Po(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:class{};return class extends e{constructor(){super(...arguments),this.connection=null}init(e){this.connection=e}}}const Do=Po(),Oo=Po(xr),ko=(0,E.getLogger)("modules/xmpp/strophe.ping.js");class No extends Do{constructor(e){let{getTimeSinceLastServerResponse:t,onPingThresholdExceeded:n,pingOptions:i={}}=e;super(),this.failedPings=0,this._onPingThresholdExceeded=n,this._getTimeSinceLastServerResponse=t,this.pingInterval="number"==typeof i.interval?i.interval:1e4,this.pingTimeout="number"==typeof i.timeout?i.timeout:5e3,this.pingThreshold="number"==typeof i.threshold?i.threshold:2,this.pingTimestampsToKeep=Math.round(12e4/this.pingInterval),this.pingExecIntervals=new Array(this.pingTimestampsToKeep)}init(e){super.init(e),St.Strophe.addNamespace("PING","urn:xmpp:ping")}ping(e,t,n,i){this._addPingExecutionTimestamp();const r=(0,St.$iq)({type:"get",to:e});r.c("ping",{xmlns:St.Strophe.NS.PING}),this.connection.sendIQ2(r,{timeout:i}).then(t,n)}startInterval(e){clearInterval(this.intervalId),this.intervalId=window.setInterval((()=>{const t=Date.now();if(this._getTimeSinceLastServerResponse()<t-this._lastServerCheck)return this._addPingExecutionTimestamp(),this._lastServerCheck=t,void(this.failedPings=0);this.ping(e,(()=>{this._lastServerCheck=this._getTimeSinceLastServerResponse()+Date.now(),this.failedPings=0}),(e=>{this.failedPings+=1;const t="Ping "+(e?"error":"timeout");this.failedPings>=this.pingThreshold?(ko.error(t,e),this._onPingThresholdExceeded&&this._onPingThresholdExceeded()):ko.warn(t,e)}),this.pingTimeout)}),this.pingInterval),ko.info(`XMPP pings will be sent every ${this.pingInterval} ms`)}stopInterval(){this.intervalId&&(window.clearInterval(this.intervalId),this.intervalId=null,this.failedPings=0,ko.info("Ping interval cleared"))}_addPingExecutionTimestamp(){this.pingExecIntervals.push((new Date).getTime()),this.pingExecIntervals.length>this.pingTimestampsToKeep&&this.pingExecIntervals.shift()}getPingSuspendTime(){const e=this.pingExecIntervals.slice();e.push((new Date).getTime());let t=0,n=e[0];return e.forEach((e=>{const i=e-n;i>t&&(t=i),n=e})),t-=this.pingInterval,Math.max(t,0)}}const Mo=(0,E.getLogger)("modules/xmpp/XmppConnection.js");class Lo extends xr{static get Events(){return{CONN_STATUS_CHANGED:"CONN_STATUS_CHANGED",CONN_SHARD_CHANGED:"CONN_SHARD_CHANGED"}}static get Status(){return St.Strophe.Status}constructor(e){let{enableWebsocketResume:t,websocketKeepAlive:n,websocketKeepAliveUrl:i,serviceUrl:r,shard:o,xmppPing:s}=e;super(),this._options={enableWebsocketResume:void 0===t||t,pingOptions:s,shard:o,websocketKeepAlive:void 0===n?6e4:Number(n),websocketKeepAliveUrl:i},this._stropheConn=new St.Strophe.Connection(r),this._usesWebsocket=r.startsWith("ws:")||r.startsWith("wss:"),this._stropheConn.maxRetries=3,this._rawInputTracker=new Io,this._rawInputTracker.startTracking(this,this._stropheConn),this._resumeTask=new wo(this._stropheConn),this._deferredIQs=[],this.addConnectionPlugin("ping",new No({getTimeSinceLastServerResponse:()=>this.getTimeSinceLastSuccess(),onPingThresholdExceeded:()=>this._onPingErrorThresholdExceeded(),pingOptions:s})),this._oneSuccessfulConnect=!1}get connected(){const e=this._stropheConn&&this._stropheConn._proto&&this._stropheConn._proto.socket;return(this._status===St.Strophe.Status.CONNECTED||this._status===St.Strophe.Status.ATTACHED)&&(!this.isUsingWebSocket||e&&e.readyState===WebSocket.OPEN)}get disco(){return this._stropheConn.disco}get disconnecting(){return!0===this._stropheConn.disconnecting}get domain(){return this._stropheConn.domain}get isUsingWebSocket(){return this._usesWebsocket}get jid(){return this._stropheConn.jid}get lastResponseHeaders(){return this._stropheConn._proto&&this._stropheConn._proto.lastResponseHeaders}get logger(){return this._stropheConn.logger}get options(){return this._stropheConn.options}get pingDomain(){var e;return(null===(e=this._options.pingOptions)||void 0===e?void 0:e.domain)||this.domain}get service(){return this._stropheConn.service}set shard(e){this._options.shard=e,this._oneSuccessfulConnect&&this._maybeStartWSKeepAlive()}get status(){return this._status}addConnectionPlugin(e,t){this[e]=t,t.init(this)}addHandler(){return this._stropheConn.addHandler(...arguments)}deleteHandler(){this._stropheConn.deleteHandler(...arguments)}attach(e,t,n,i){for(var r=arguments.length,o=new Array(r>4?r-4:0),s=4;s<r;s++)o[s-4]=arguments[s];this._stropheConn.attach(e,t,n,this._stropheConnectionCb.bind(this,i),...o)}connect(e,t,n){for(var i=arguments.length,r=new Array(i>3?i-3:0),o=3;o<i;o++)r[o-3]=arguments[o];this._stropheConn.connect(e,t,this._stropheConnectionCb.bind(this,n),...r)}_stropheConnectionCb(e,t){this._status=t;let n=!1;var i;if(t===St.Strophe.Status.CONNECTED||t===St.Strophe.Status.ATTACHED?(this._maybeEnableStreamResume(),this._usesWebsocket&&this._oneSuccessfulConnect&&this._keepAliveAndCheckShard(),this._oneSuccessfulConnect=!0,this._maybeStartWSKeepAlive(),this._processDeferredIQs(),this._resumeTask.cancel(),this.ping.startInterval((null===(i=this._options.pingOptions)||void 0===i?void 0:i.domain)||this.domain)):t===St.Strophe.Status.DISCONNECTED&&(this.ping.stopInterval(),n=this._tryResumingConnection(),n||clearTimeout(this._wsKeepAlive)),!n){for(var r=arguments.length,o=new Array(r>2?r-2:0),s=2;s<r;s++)o[s-2]=arguments[s];e(t,...o),this.eventEmitter.emit(Lo.Events.CONN_STATUS_CHANGED,t)}}_clearDeferredIQs(){for(const e of this._deferredIQs)e.reject(new Error("disconnect"));this._deferredIQs=[]}closeWebsocket(){this._stropheConn&&this._stropheConn._proto&&(this._stropheConn._proto._closeSocket(),this._stropheConn._proto._onClose(null))}disconnect(){this._resumeTask.cancel(),clearTimeout(this._wsKeepAlive),this._clearDeferredIQs(),this._stropheConn.disconnect(...arguments)}flush(){this._stropheConn.flush(...arguments)}getTimeSinceLastSuccess(){return this._rawInputTracker.getTimeSinceLastSuccess()}getLastFailedMessage(){return this._rawInputTracker.getLastFailedMessage()}_maybeEnableStreamResume(){if(!this._options.enableWebsocketResume)return;const{streamManagement:e}=this._stropheConn;this.isUsingWebSocket?e?e.isSupported()?e.getResumeToken()||(Mo.info("Enabling XEP-0198 stream management"),e.enable(!0)):Mo.warn("Stream resume enabled, but XEP-0198 is not supported by the server"):Mo.warn("Stream resume enabled, but Strophe streamManagement plugin is not installed"):Mo.warn("Stream resume enabled, but WebSockets are not enabled")}_maybeStartWSKeepAlive(){const{websocketKeepAlive:e}=this._options;if(this._usesWebsocket&&e>0){this._wsKeepAlive||Mo.info(`WebSocket keep alive interval: ${e}ms`),clearTimeout(this._wsKeepAlive);const t=e+60*Math.random()*1e3;Mo.debug(`Scheduling next WebSocket keep-alive in ${t}ms`),this._wsKeepAlive=setTimeout((()=>this._keepAliveAndCheckShard().then((()=>this._maybeStartWSKeepAlive()))),t)}}_keepAliveAndCheckShard(){const{shard:e,websocketKeepAliveUrl:t}=this._options,n=t||this.service.replace("wss://","https://").replace("ws://","http://");return fetch(n).then((t=>{if(!e)return;const n=t.headers.get("x-jitsi-shard");n!==e&&(Mo.error(`Detected that shard changed from ${e} to ${n}`),this.eventEmitter.emit(Lo.Events.CONN_SHARD_CHANGED))})).catch((e=>{Mo.error(`Websocket Keep alive failed for url: ${n}`,{error:e})}))}_processDeferredIQs(){for(const e of this._deferredIQs)if(e.iq){clearTimeout(e.timeout);const t=Date.now()-e.start;this.sendIQ(e.iq,(t=>e.resolve(t)),(t=>e.reject(t)),t)}this._deferredIQs=[]}send(e){var t,n,i;if(!this.connected)throw Mo.error(`Trying to send stanza while not connected. Status:${this._status} Proto:${this.isUsingWebSocket?null===(t=this._stropheConn)||void 0===t||null===(n=t._proto)||void 0===n||null===(i=n.socket)||void 0===i?void 0:i.readyState:"bosh"}`),new Error("Not connected");this._stropheConn.send(e)}sendIQ(e,t,n,i){if(this.connected)return this._stropheConn.sendIQ(e,t,n,i);n("Not connected")}sendIQ2(e,t){let{timeout:n}=t;return new Promise(((t,i)=>{if(this.connected)this.sendIQ(e,(e=>t(e)),(e=>i(e)),n);else{const r={iq:e,resolve:t,reject:i,start:Date.now(),timeout:setTimeout((()=>{r.iq=void 0,i(void 0)}),n)};this._deferredIQs.push(r)}}))}_onPingErrorThresholdExceeded(){this.isUsingWebSocket&&(Mo.warn("Ping error threshold exceeded - killing the WebSocket"),this.closeWebsocket())}sendPresence(e,t,n,i){this.connected?this._stropheConn.sendPresence(e,t,n,i):n("Not connected")}sendUnavailableBeacon(){if(!navigator.sendBeacon||this._stropheConn.disconnecting||!this._stropheConn.connected)return!1;this._stropheConn._changeConnectStatus(St.Strophe.Status.DISCONNECTING),this._stropheConn.disconnecting=!0;const e=this._stropheConn._proto._buildBody().attrs({type:"terminate"}),t=(0,St.$pres)({xmlns:St.Strophe.NS.CLIENT,type:"unavailable"});e.cnode(t.tree());const n=navigator.sendBeacon(-1===this.service.indexOf("https://")?`https:${this.service}`:this.service,St.Strophe.serialize(e.tree()));return Mo.info(`Successfully send unavailable beacon ${n}`),this._stropheConn._proto._abortAllRequests(),this._stropheConn._doDisconnect(),!0}_tryResumingConnection(){const{streamManagement:e}=this._stropheConn;return!(!e||!e.getResumeToken()||(this._resumeTask.schedule(),0))}}var Fo=n(667),jo=n.n(Fo);const Vo=(0,E.getLogger)("modules/settings/Settings.js");let Uo,Ho;const $o={_storage:di,init(e){this._storage=e||di},get callStatsUserName(){return Uo||(Uo=this._storage.getItem("callStatsUserName"),Uo||(Uo=function(){const e=jo().generateUsername();return Vo.log("generated stats id",e),e}(),this._storage.setItem("callStatsUserName",Uo))),Uo},get machineId(){if(!Ho){const e=this._storage.getItem("billingId");Ho=e||this._storage.getItem("jitsiMeetId"),e?this._storage.setItem("jitsiMeetId",e):Ho||(Ho=function(){const e=Jo()+Jo()+Jo()+Jo();return Vo.log("generated id",e),e}(),this._storage.setItem("jitsiMeetId",Ho))}return Ho},get sessionId(){return this._storage.getItem("sessionId")},set sessionId(e){e?this._storage.setItem("sessionId",e):this._storage.removeItem("sessionId")}};function Jo(){return`${Math.random().toString(16)}000000000`.substr(2,8)}const Bo=n(514),{XMPPEvents:qo}=n(609),Go=(0,E.getLogger)("modules/xmpp/moderator.js");function zo(e){let t=1;return function(n){if(n)return void(t=1);const i=Math.pow(2,t-1);return t+=1,Math.min(i*e,12e4)}}class Ko extends xr{constructor(e){var t,n;function i(e){if(e.data&&e.data.sessionId){if(e.origin!==window.location.origin)return void Go.warn(`Ignoring sessionId from different origin: ${e.origin}`);$o.sessionId=e.data.sessionId}}super(),this.getNextTimeout=zo(1e3),this.getNextErrorTimeout=zo(1e3),this.options=e.options,this.sipGatewayEnabled=!1,this.xmpp=e,this.connection=e.connection,this.targetJid=null===(t=this.options.hosts)||void 0===t?void 0:t.focus,this.targetJid||(this.targetJid=`focus.${null===(n=this.options.hosts)||void 0===n?void 0:n.domain}`),this.targetUrl=this.options.conferenceRequestUrl,this.mode=this.targetUrl?"http":"xmpp",Go.info(`Using ${this.mode} for conference requests.`),this.focusUserJids=new Set,this.options.focusUserJid&&this.focusUserJids.add(this.options.focusUserJid),window.addEventListener?window.addEventListener("message",i,!1):window.attachEvent("onmessage",i)}isFocusJid(e){if(!e)return!1;for(const t of this.focusUserJids)if(0===e.indexOf(`${t}/`))return!0;return!1}isSipGatewayEnabled(){return this.sipGatewayEnabled}_createConferenceRequest(e){var t,n;const{sessionId:i}=$o,r=this.options,o={};void 0!==r.startAudioMuted&&(o.startAudioMuted=r.startAudioMuted),void 0!==r.startVideoMuted&&(o.startVideoMuted=r.startVideoMuted),null!==(t=null==r||null===(n=r.analytics)||void 0===n?void 0:n.rtcstatsEnabled)&&void 0!==t&&t||(o.rtcstatsEnabled=!1);const s={properties:o,machineUid:$o.machineId,room:e};return i&&(s.sessionId=i),r.iAmRecorder||r.iAmSipGateway||(s.properties["visitors-version"]=1,this.options.preferVisitor&&(s.properties.visitor=!0)),s}_createConferenceIq(e){const t=this._createConferenceRequest(e),n=(0,St.$iq)({to:this.targetJid,type:"set"});n.c("conference",{xmlns:"http://jitsi.org/protocol/focus",room:e,"machine-uid":t.machineUid}),t.sessionId&&n.attrs({"session-id":t.sessionId});for(const e in t.properties)t.properties.hasOwnProperty(e)&&n.c("property",{name:e,value:t.properties[e]}).up();return n}_parseConferenceIq(e){const t={properties:{}};return t.focusJid=_t()(e).find("conference").attr("focusjid"),t.sessionId=_t()(e).find("conference").attr("session-id"),t.identity=_t()(e).find(">conference").attr("identity"),t.ready="true"===_t()(e).find("conference").attr("ready"),t.vnode=_t()(e).find("conference").attr("vnode"),_t()(e).find(">conference>property[name=\'authentication\'][value=\'true\']").length>0&&(t.properties.authentication="true"),_t()(e).find(">conference>property[name=\'externalAuth\'][value=\'true\']").length>0&&(t.properties.externalAuth="true"),_t()(e).find(">conference>property[name=\'sipGatewayEnabled\'][value=\'true\']").length>0&&(t.properties.sipGatewayEnabled="true"),t}sendConferenceRequest(e){return new Promise((t=>{"xmpp"===this.mode?(Go.info(`Sending conference request over XMPP to ${this.targetJid}`),this.connection.sendIQ(this._createConferenceIq(e),(n=>this._handleIqSuccess(e,n,t)),(n=>this._handleIqError(e,n,t))),this.connection.flush()):(Go.info(`Sending conference request over HTTP to ${this.targetUrl}`),fetch(this.targetUrl,{method:"POST",body:JSON.stringify(this._createConferenceRequest(e)),headers:{"Content-Type":"application/json"}}).then((n=>{n.ok?n.json().then((n=>{this._handleSuccess(e,n,t)})):n.text().then((i=>{Go.warn(`Received HTTP ${n.status} ${n.statusText}. Body: ${i}`);const r=400===n.status&&i.indexOf("400 invalid-session")>0,o=403===n.status;this._handleError(e,r,o,t)})).catch((t=>{Go.warn(`Error: ${t}`),this._handleError(e)}))})).catch((t=>{Go.warn(`Error: ${t}`),this._handleError(e)})))}))}_handleSuccess(e,t,n){this.getNextErrorTimeout(!0),t.focusJid?(Go.info(`Adding focus JID: ${t.focusJid}`),this.focusUserJids.add(t.focusJid)):Go.warn("Conference request response contained no focusJid.");const i="true"===t.properties.authentication;if(Go.info(`Authentication enabled: ${i}`),t.sessionId&&(Go.info(`Received sessionId: ${t.sessionId}`),$o.sessionId=t.sessionId),this.eventEmitter.emit(Bo.IDENTITY_UPDATED,i,t.identity),this.sipGatewayEnabled=t.properties.sipGatewayEnabled,Go.info(`Sip gateway enabled: ${this.sipGatewayEnabled}`),t.ready){if(this.getNextTimeout(!0),t.vnode&&!this.options.iAmRecorder&&!this.options.iAmSipGateway)return Go.warn(`Redirected to: ${t.vnode} with focusJid ${t.focusJid}`),void this.xmpp.eventEmitter.emit(pr,t.vnode,t.focusJid);Go.info("Conference-request successful, ready to join the MUC."),n()}else{const t=this.getNextTimeout();Go.info(`Not ready yet, will retry in ${t} ms.`),window.setTimeout((()=>this.sendConferenceRequest(e).then(n)),t)}}_handleError(e,t,n,i){if(t&&(Go.info("Session expired! - removing"),$o.sessionId=void 0),n)return Go.warn("Unauthorized to start the conference"),void this.eventEmitter.emit(qo.AUTHENTICATION_REQUIRED);const r=this.getNextErrorTimeout();t&&r<6e4?(Go.info(`Invalid session, will retry after ${r} ms.`),this.getNextTimeout(!0),window.setTimeout((()=>this.sendConferenceRequest(e).then(i)),r)):(Go.error("Failed to get a successful response, giving up."),this.eventEmitter.emit(qo.FOCUS_DISCONNECTED))}_handleIqError(e,t,n){const i=_t()(t).find(">error>reservation-error");if(i.length){const e=i.attr("error-code"),n=_t()(t).find(">error>text");let r;return n&&(r=n.text()),void this.eventEmitter.emit(qo.RESERVATION_ERROR,e,r)}const r=Boolean(_t()(t).find(">error>session-invalid").length||_t()(t).find(">error>not-acceptable").length),o=_t()(t).find(">error>not-authorized").length>0;this._handleError(e,r,o,n)}_handleIqSuccess(e,t,n){const i=this._parseConferenceIq(t);this._handleSuccess(e,i,n)}authenticate(e){return new Promise(((t,n)=>{this.connection.sendIQ(this._createConferenceIq(e),(e=>{const n=_t()(e).find("conference").attr("session-id");n?(Go.info(`Received sessionId:  ${n}`),$o.sessionId=n):Go.warn("Response did not contain a session-id"),t()}),(e=>n({error:_t()(e).find("iq>error :first").prop("tagName"),message:_t()(e).find("iq>error>text").text()})))}))}logout(e){const t=(0,St.$iq)({to:this.targetJid,type:"set"}),{sessionId:n}=$o;n?(t.c("logout",{xmlns:"http://jitsi.org/protocol/focus","session-id":n}),this.connection.sendIQ(t,(t=>{Go.info("Log out OK",t),$o.sessionId=void 0,e()}),(e=>{Go.error("Logout error",e)}))):e()}}let Wo;!function(e){e.ON="on",e.OFF="off"}(Wo||(Wo={}));const Xo=Wo.ON,Yo=Wo.OFF;var Qo=n(408);const Zo=(0,E.getLogger)("modules/xmpp/AVModeration.js");class es{constructor(e){this._xmpp=e.xmpp,this._mainRoom=e,this._moderationEnabledByType={[Ri.AUDIO]:!1,[Ri.VIDEO]:!1},this._whitelistAudio=[],this._whitelistVideo=[],this._onMessage=this._onMessage.bind(this),this._xmpp.addListener(Hi.XMPPEvents.AV_MODERATION_RECEIVED,this._onMessage)}dispose(){this._xmpp.removeListener(Hi.XMPPEvents.AV_MODERATION_RECEIVED,this._onMessage)}isSupported(){return Boolean(this._xmpp.avModerationComponentAddress)}enable(e,t){if(!this.isSupported()||!this._mainRoom.isModerator())return void Zo.error(`Cannot enable:${e} AV moderation supported:${this.isSupported()},\\n                moderator:${this._mainRoom.isModerator()}`);if(e===this._moderationEnabledByType[t])return void Zo.warn(`Moderation already in state:${e} for mediaType:${t}`);const n=(0,St.$msg)({to:this._xmpp.avModerationComponentAddress});n.c("av_moderation",{enable:e,mediaType:t}).up(),this._xmpp.connection.send(n)}approve(e,t){if(!this.isSupported()||!this._mainRoom.isModerator())return void Zo.error(`Cannot approve in AV moderation supported:${this.isSupported()},\\n                moderator:${this._mainRoom.isModerator()}`);const n=(0,St.$msg)({to:this._xmpp.avModerationComponentAddress});n.c("av_moderation",{mediaType:e,jidToWhitelist:t}).up(),this._xmpp.connection.send(n)}reject(e,t){if(!this.isSupported()||!this._mainRoom.isModerator())return void Zo.error(`Cannot reject in AV moderation supported:${this.isSupported()},\\n                moderator:${this._mainRoom.isModerator()}`);const n=(0,St.$msg)({to:this._xmpp.avModerationComponentAddress});n.c("av_moderation",{mediaType:e,jidToBlacklist:t}).up(),this._xmpp.connection.send(n)}_onMessage(e){const{removed:t,mediaType:n,enabled:i,approved:r,actor:o,whitelists:s}=e;if(s){const e=n===Ri.AUDIO?this._whitelistAudio:this._whitelistVideo,i=Array.isArray(s[n])?s[n]:[];t?e.filter((e=>!i.includes(e))).forEach((e=>this._xmpp.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_PARTICIPANT_REJECTED,n,e))):i.filter((t=>!e.includes(t))).forEach((e=>this._xmpp.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_PARTICIPANT_APPROVED,n,e))),n===Ri.AUDIO?this._whitelistAudio=i:this._whitelistVideo=i}else void 0!==i&&this._moderationEnabledByType[n]!==i?(this._moderationEnabledByType[n]=i,this._xmpp.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_CHANGED,i,n,o)):t?this._xmpp.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_REJECTED,n):r&&this._xmpp.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_APPROVED,n)}}const ts="features/breakout-rooms",ns={ADD:`${ts}/add`,MOVE_TO_ROOM:`${ts}/move-to-room`,REMOVE:`${ts}/remove`,RENAME:`${ts}/rename`},is=`${ts}/move-to-room`,rs=`${ts}/update`,os=(0,E.getLogger)("modules/xmpp/BreakoutRooms.js");class ss{constructor(e){this.room=e,this._handleMessages=this._handleMessages.bind(this),this.room.xmpp.addListener(Hi.XMPPEvents.BREAKOUT_ROOMS_EVENT,this._handleMessages),this._rooms={}}dispose(){this.room.xmpp.removeListener(Hi.XMPPEvents.BREAKOUT_ROOMS_EVENT,this._handleMessages)}createBreakoutRoom(e){if(!this.isSupported()||!this.room.isModerator())return void os.error(`Cannot create breakout room - supported:${this.isSupported()},\\n                moderator:${this.room.isModerator()}`);const t={type:ns.ADD,subject:e};this._sendMessage(t)}removeBreakoutRoom(e){if(!this.isSupported()||!this.room.isModerator())return void os.error(`Cannot remove breakout room - supported:${this.isSupported()},\\n                moderator:${this.room.isModerator()}`);const t={type:ns.REMOVE,breakoutRoomJid:e};this._sendMessage(t)}renameBreakoutRoom(e,t){if(!this.isSupported()||!this.room.isModerator())return void os.error(`Cannot rename breakout room - supported:${this.isSupported()},\\n                moderator:${this.room.isModerator()}`);const n={type:ns.RENAME,breakoutRoomJid:e,subject:t};this._sendMessage(n)}sendParticipantToRoom(e,t){if(!this.isSupported()||!this.room.isModerator())return void os.error(`Cannot send participant to room - supported:${this.isSupported()},\\n                moderator:${this.room.isModerator()}`);const n={type:ns.MOVE_TO_ROOM,participantJid:e,roomJid:t};this._sendMessage(n)}isFeatureSupported(e){return Boolean((this.room.xmpp.breakoutRoomsFeatures||{})[e])}isSupported(){return Boolean(this.getComponentAddress())}getComponentAddress(){return this.room.xmpp.breakoutRoomsComponentAddress}_setIsBreakoutRoom(e){this._isBreakoutRoom=e}isBreakoutRoom(){return void 0!==this._isBreakoutRoom?this._isBreakoutRoom:St.Strophe.getDomainFromJid(this.room.myroomjid)===this.getComponentAddress()}_setMainRoomJid(e){this._mainRoomJid=e}getMainRoomJid(){return this._mainRoomJid}_handleMessages(e){switch(e.event){case is:this.room.eventEmitter.emit(Hi.XMPPEvents.BREAKOUT_ROOMS_MOVE_TO_ROOM,e.roomJid);break;case rs:{const t=this._filterUpdatePayload(e);this._rooms=t.rooms,this.room.eventEmitter.emit(Hi.XMPPEvents.BREAKOUT_ROOMS_UPDATED,t);break}}}_filterUpdatePayload(e){const t=this.room.options.hiddenDomain,{rooms:n}=e,i={};return Object.entries(n).forEach((e=>{let[n,r]=e;const{participants:o={}}=r,s={};Object.entries(o).forEach((e=>{let[n,i]=e;St.Strophe.getDomainFromJid(i.jid)!==t&&(s[n]=i)})),i[n]={...r,participants:s}})),{...e,rooms:i}}_sendMessage(e){const t=(0,St.$msg)({to:this.getComponentAddress()});t.c("breakout_rooms",e).up(),this.room.xmpp.connection.send(t)}}const as=(0,E.getLogger)("modules/xmpp/Lobby.js"),ds="email";class cs{constructor(e){this.xmpp=e.xmpp,this.mainRoom=e;const t=this._maybeJoinLobbyRoom.bind(this);this.mainRoom.addEventListener(Hi.XMPPEvents.LOCAL_ROLE_CHANGED,t),this.mainRoom.addEventListener(Hi.XMPPEvents.MUC_MEMBERS_ONLY_CHANGED,t),this.mainRoom.addEventListener(Hi.XMPPEvents.ROOM_CONNECT_MEMBERS_ONLY_ERROR,(e=>{this.lobbyRoomJid=e}))}isSupported(){return this.xmpp.lobbySupported}enable(){return this.isSupported()?this.mainRoom.initialDiscoRoomInfoReceived?this.mainRoom.membersOnlyEnabled?Promise.resolve():new Promise(((e,t)=>{this.mainRoom.setMembersOnly(!0,e,t)})):new Promise(((e,t)=>{let n=[];const i=()=>{n.forEach((e=>e())),n=[]};n.push(this.mainRoom.addCancellableListener(Hi.XMPPEvents.ROOM_DISCO_INFO_UPDATED,(()=>{i(),this.mainRoom.membersOnlyEnabled?e():this.mainRoom.setMembersOnly(!0,e,t)}))),n.push(this.mainRoom.addCancellableListener(Hi.XMPPEvents.ROOM_DISCO_INFO_FAILED,(e=>{i(),t(e)})))})):Promise.reject(new Error("Lobby not supported!"))}disable(){this.isSupported()&&this.mainRoom.isModerator()&&this.lobbyRoom&&this.mainRoom.membersOnlyEnabled&&this.mainRoom.setMembersOnly(!1)}sendMessage(e){this.lobbyRoom&&this.lobbyRoom.sendMessage(JSON.stringify(e),"json-message")}sendPrivateMessage(e,t){this.lobbyRoom&&this.lobbyRoom.sendPrivateMessage(e,JSON.stringify(t),"json-message")}getLocalId(){if(this.lobbyRoom)return St.Strophe.getResourceFromJid(this.lobbyRoom.myroomjid)}addMessageListener(e){if(this.lobbyRoom){const t=(t,n)=>{e(n,St.Strophe.getResourceFromJid(t))};return this.lobbyRoom.on(Hi.XMPPEvents.JSON_MESSAGE_RECEIVED,t),t}}removeMessageHandler(e){this.lobbyRoom&&this.lobbyRoom.off(Hi.XMPPEvents.JSON_MESSAGE_RECEIVED,e)}leave(){return this.lobbyRoom?this.lobbyRoom.leave().then((()=>{this.lobbyRoom=void 0,as.info("Lobby room left!")})).catch((()=>{})):Promise.reject(new Error("The lobby has already been left"))}setLobbyRoomJid(e){this.lobbyRoomJid=e}_maybeJoinLobbyRoom(){this.isSupported()&&this.mainRoom.joined&&this.mainRoom.isModerator()&&this.mainRoom.membersOnlyEnabled&&!this.lobbyRoom&&this.join().then((()=>as.info("Joined lobby room"))).catch((e=>as.error("Failed joining lobby",e)))}join(e,t){const n=this.mainRoom.joined&&this.mainRoom.isModerator();if(!this.lobbyRoomJid)return Promise.reject(new Error("Missing lobbyRoomJid, cannot join lobby room."));const i=St.Strophe.getNodeFromJid(this.lobbyRoomJid),r=St.Strophe.getDomainFromJid(this.lobbyRoomJid);return this.lobbyRoom=this.xmpp.createRoom(i,{customDomain:r,disableDiscoInfo:!0,disableFocus:!0,enableLobby:!1}),e&&this.lobbyRoom.addOrReplaceInPresence("nick",{attributes:{xmlns:"http://jabber.org/protocol/nick"},value:e}),n?(this.lobbyRoom.addPresenceListener(ds,((e,t)=>{this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_LOBBY_MEMBER_UPDATED,t,{email:e.value})})),this.lobbyRoom.addEventListener(Hi.XMPPEvents.MUC_MEMBER_JOINED,((e,t,n,i,r,o,s,a,d)=>{if(!Object.values(this.mainRoom.members).find((e=>e.jid===d))){for(const e of Object.values(this.mainRoom.getBreakoutRooms()._rooms))if(Object.values(e.participants).find((e=>e.jid===d)))return;this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_LOBBY_MEMBER_JOINED,St.Strophe.getResourceFromJid(e),t,s?s.avatar:void 0)}})),this.lobbyRoom.addEventListener(Hi.XMPPEvents.MUC_MEMBER_LEFT,(e=>{this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_LOBBY_MEMBER_LEFT,St.Strophe.getResourceFromJid(e))})),this.lobbyRoom.addEventListener(Hi.XMPPEvents.MUC_DESTROYED,(()=>{Object.keys(this.lobbyRoom.members).forEach((e=>this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_LOBBY_MEMBER_LEFT,St.Strophe.getResourceFromJid(e)))),this.lobbyRoom.clean(),this.lobbyRoom=void 0,as.info("Lobby room left(destroyed)!")}))):(this.lobbyRoom.addEventListener(Hi.XMPPEvents.KICKED,(e=>{if(e)return this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_DENIED_ACCESS),void this.lobbyRoom.clean()})),this.mainRoom.addEventListener(Hi.XMPPEvents.INVITE_MESSAGE_RECEIVED,((e,t,n,i)=>{as.debug(`Received approval to join ${e} ${t} ${n}`),e===this.mainRoom.roomjid&&this.mainRoom.join(i)})),this.lobbyRoom.addEventListener(Hi.XMPPEvents.MUC_DESTROYED,((e,t)=>{var n;null===(n=this.lobbyRoom)||void 0===n||n.clean(),this.lobbyRoom=void 0,as.info("Lobby room left(destroyed)!"),t?this.mainRoom.join():this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_DESTROYED,e)})),this.mainRoom.addEventListener(Hi.XMPPEvents.MUC_JOINED,(()=>{this.leave().catch((()=>{}))}))),new Promise(((e,i)=>{this.lobbyRoom.addEventListener(Hi.XMPPEvents.MUC_JOINED,(()=>{e(),t&&!n&&this.lobbyRoom.addOrReplaceInPresence(ds,{value:t})&&this.lobbyRoom.sendPresence()})),this.lobbyRoom.addEventListener(Hi.XMPPEvents.ROOM_JOIN_ERROR,i),this.lobbyRoom.addEventListener(Hi.XMPPEvents.ROOM_CONNECT_NOT_ALLOWED_ERROR,i),this.lobbyRoom.addEventListener(Hi.XMPPEvents.ROOM_CONNECT_ERROR,i),this.lobbyRoom.join()}))}denyAccess(e){if(!this.isSupported()||!this.mainRoom.isModerator())return;const t=Object.keys(this.lobbyRoom.members).find((t=>St.Strophe.getResourceFromJid(t)===e));t?this.lobbyRoom.kick(t):as.error(`Not found member for ${e} in lobby room.`)}approveAccess(e){if(!this.isSupported()||!this.mainRoom.isModerator())return;let t=this.mainRoom.roomjid;this.mainRoom.getBreakoutRooms().isBreakoutRoom()&&(t=this.mainRoom.getBreakoutRooms().getMainRoomJid());const n=[];let i=e;if(Array.isArray(e)||(i=[e]),i.forEach((e=>{const t=Object.keys(this.lobbyRoom.members).find((t=>St.Strophe.getResourceFromJid(t)===e));t?n.push(this.lobbyRoom.members[t].jid):as.error(`Not found member for ${t} in lobby room.`)})),n.length>0){const e=(0,St.$msg)({to:t}).c("x",{xmlns:"http://jabber.org/protocol/muc#user"});n.forEach((t=>{e.c("invite",{to:t}).up()})),this.xmpp.connection.sendIQ(e,(()=>{}),(e=>{as.error(`Error sending invite for ${n}`,e)}))}}}const ls=(0,E.getLogger)("modules/xmpp/RoomMetadata.ts");class hs{constructor(e){this.room=e,this._handleMessages=this._handleMessages.bind(this),this.room.xmpp.addListener(Hi.XMPPEvents.ROOM_METADATA_EVENT,this._handleMessages),this._metadata={}}dispose(){this.room.xmpp.removeListener(Hi.XMPPEvents.ROOM_METADATA_EVENT,this._handleMessages)}setMetadata(e,t){if(!this.isSupported()||!this.room.isModerator())return void ls.error(`Cannot set room metadata - supported:${this.isSupported()},\\n                moderator:${this.room.isModerator()}`);const n={key:e,data:t};this._sendMessage(n)}getMetadata(){return this._metadata}isSupported(){return Boolean(this.getComponentAddress())}getComponentAddress(){return this.room.xmpp.roomMetadataComponentAddress}_handleMessages(e){const{metadata:t}=e;t&&!Et()(this._metadata,t)&&(this._metadata=t,this.room.eventEmitter.emit(Hi.XMPPEvents.ROOM_METADATA_UPDATED,t))}_sendMessage(e){e[Aa]="room_metadata";const t=(0,St.$msg)({to:this.getComponentAddress()});t.c("room_metadata",{room:this.room.roomjid,xmlns:"http://jitsi.org/jitmeet"},JSON.stringify(e)).up(),this.room.xmpp.connection.send(t)}}const us=(0,E.getLogger)("modules/xmpp/ChatRoom.js"),ps={packet2JSON(e,t){for(const n of Array.from(e.children)){const e={attributes:{},children:[],tagName:n.tagName};for(const t of Array.from(n.attributes))e.attributes[t.name]=t.value;const i=St.Strophe.getText(n);i&&(e.value=St.Strophe.xmlunescape(i)),t.push(e),this.packet2JSON(n,e.children)}},json2packet(e,t){for(let n=0;n<e.length;n++){const i=e[n];i&&(t.c(i.tagName,i.attributes),i.value&&t.t(i.value),i.children&&this.json2packet(i.children,t),t.up())}}};function ms(e,t){const n=[];for(let i=0;i<e.length;i++)e[i].tagName===t&&n.push(e[i]);return n}const gs=["owner","admin","member"];function fs(e,t){const n={},i=e.children.find((e=>"user"===e.tagName));if(i){n.user={};const e=["id","name","avatar"];t&&e.push("hidden-from-recorder");for(const t of e){const e=i.children.find((e=>e.tagName===t));e&&(n.user[t]=e.value)}}const r=e.children.find((e=>"group"===e.tagName));return r&&(n.group=r.value),n}class vs extends xr{constructor(e,t,n,i,r){super(),this.xmpp=i,this.connection=e,this.roomjid=St.Strophe.getBareJidFromJid(t),this.myroomjid=t,this.password=n,this.replaceParticipant=!1,us.info(`Joining MUC as ${this.myroomjid}`),this.members={},this.presMap={},this.presHandlers={},this._removeConnListeners=[],this.joined=!1,this.inProgressEmitted=!1,this.role=null,this.focusMucJid=null,this.noBridgeAvailable=!1,this.options=r||{},this.eventsForwarder=new(Fi())(this.xmpp.moderator,this.eventEmitter),this.eventsForwarder.forward(Ui().IDENTITY_UPDATED,Ui().IDENTITY_UPDATED),this.eventsForwarder.forward(Hi.XMPPEvents.AUTHENTICATION_REQUIRED,Hi.XMPPEvents.AUTHENTICATION_REQUIRED),this.eventsForwarder.forward(Hi.XMPPEvents.FOCUS_DISCONNECTED,Hi.XMPPEvents.FOCUS_DISCONNECTED),this.eventsForwarder.forward(Hi.XMPPEvents.RESERVATION_ERROR,Hi.XMPPEvents.RESERVATION_ERROR),(void 0===this.options.enableLobby||this.options.enableLobby)&&(this.lobby=new cs(this)),this.avModeration=new es(this),this.breakoutRooms=new ss(this),this.roomMetadata=new hs(this),this.initPresenceMap(r),this.lastPresences={},this.phoneNumber=null,this.phonePin=null,this.connectionTimes={},this.participantPropertyListener=null,this.locked=!1,this.transcriptionStatus=Yo,this.initialDiscoRoomInfoReceived=!1}initPresenceMap(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.presMap.to=this.myroomjid,this.presMap.xns="http://jabber.org/protocol/muc",this.presMap.nodes=[],e.statsId&&this.presMap.nodes.push({tagName:"stats-id",value:e.statsId}),this.presenceUpdateTime=Date.now()}join(e,t){return this.password=e,this.replaceParticipant=t,new Promise((e=>{this.options.disableFocus&&us.info(`Conference focus disabled for ${this.roomjid}`),(this.options.disableFocus?Promise.resolve():this.xmpp.moderator.sendConferenceRequest(this.roomjid)).then((()=>{this.sendPresence(!0),this._removeConnListeners.push(this.connection.addCancellableListener(Lo.Events.CONN_STATUS_CHANGED,this.onConnStatusChanged.bind(this))),e()}))}))}sendPresence(e){const t=this.presMap.to;if(!this.connection||!this.connection.connected||!t||!this.joined&&!e)return;const n=(0,St.$pres)({to:t});e&&(this.replaceParticipant&&n.c("flip_device").up(),n.c("x",{xmlns:this.presMap.xns}),this.password&&n.c("password").t(this.password).up(),this.xmpp.moderator.targetUrl&&n.c("billingid").t($o.machineId).up(),n.up()),ps.json2packet(this.presMap.nodes,n),this.presenceSyncTime=Date.now(),this.connection.send(n),e&&this.connection.flush()}doLeave(e){us.log("do leave",this.myroomjid);const t=(0,St.$pres)({to:this.myroomjid,type:"unavailable"});e&&t.c("status").t(e).up(),this.presMap.length=0,!this.connection.isUsingWebSocket&&this.connection.flush(),this.connection.send(t),this.connection.flush()}discoRoomInfo(){const e=(0,St.$iq)({type:"get",to:this.roomjid}).c("query",{xmlns:St.Strophe.NS.DISCO_INFO});this.connection.sendIQ(e,(e=>{const t=1===_t()(e).find(\'>query>feature[var="muc_passwordprotected"]\').length;t!==this.locked&&(this.eventEmitter.emit(Hi.XMPPEvents.MUC_LOCK_CHANGED,t),this.locked=t);const n=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_meetingId"]>value\');n.length?this.setMeetingId(n.text()):us.warn("No meeting ID from backend");const i=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_created_timestamp"]>value\');i.length?this.eventEmitter.emit(Hi.XMPPEvents.CONFERENCE_TIMESTAMP_RECEIVED,i.text()):us.warn("No conference duration from backend");const r=1===_t()(e).find(\'>query>feature[var="muc_membersonly"]\').length,o=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_lobbyroom"]>value\');this.lobby&&this.lobby.setLobbyRoomJid(o&&o.length?o.text():void 0);const s=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_isbreakout"]>value\'),a=Boolean(null==s?void 0:s.text());this.breakoutRooms._setIsBreakoutRoom(a);const d=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_breakout_main_room"]>value\');null!=d&&d.length&&this.breakoutRooms._setMainRoomJid(d.text()),r!==this.membersOnlyEnabled&&(this.membersOnlyEnabled=r,this.eventEmitter.emit(Hi.XMPPEvents.MUC_MEMBERS_ONLY_CHANGED,r));const c="1"===_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_visitorsEnabled"]>value\').text();c!==this.visitorsSupported&&(this.visitorsSupported=c,this.eventEmitter.emit(Hi.XMPPEvents.MUC_VISITORS_SUPPORTED_CHANGED,c));const l=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_jitsimetadata"]>value\'),h=null==l?void 0:l.text();if(h)try{this.roomMetadata._handleMessages(_r(h))}catch(e){us.warn("Failed to set room metadata",e)}this.initialDiscoRoomInfoReceived=!0,this.eventEmitter.emit(Hi.XMPPEvents.ROOM_DISCO_INFO_UPDATED)}),(e=>{us.error("Error getting room info: ",e),this.eventEmitter.emit(Hi.XMPPEvents.ROOM_DISCO_INFO_FAILED,e)}),1e4)}setMeetingId(e){this.meetingId!==e&&(this.meetingId&&us.warn(`Meeting Id changed from:${this.meetingId} to:${e}`),this.meetingId=e,this.eventEmitter.emit(Hi.XMPPEvents.MEETING_ID_SET,e))}createNonAnonymousRoom(){if(this.options.disableDiscoInfo)return;const e=(0,St.$iq)({type:"get",to:this.roomjid}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"}).c("x",{xmlns:"jabber:x:data",type:"submit"});this.connection.sendIQ(e,(e=>{if(!_t()(e).find(\'>query>x[xmlns="jabber:x:data"]>field[var="muc#roomconfig_whois"]\').length)return void us.error("non-anonymous rooms not supported");const t=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"});t.c("x",{xmlns:"jabber:x:data",type:"submit"}),t.c("field",{var:"FORM_TYPE"}).c("value").t("http://jabber.org/protocol/muc#roomconfig").up().up(),t.c("field",{var:"muc#roomconfig_whois"}).c("value").t("anyone").up().up(),this.connection.sendIQ(t)}),(e=>{us.error("Error getting room configuration form: ",e)}))}onConnStatusChanged(e){e===Lo.Status.CONNECTED&&this.presenceUpdateTime>this.presenceSyncTime&&this.sendPresence()}onPresence(e){const t=e.getAttribute("from"),n={},i=e.getElementsByTagName("status")[0];i&&(n.status=i.textContent||"");let r=!1,o=!1;const s=e.getElementsByTagNameNS("http://jabber.org/protocol/muc#user","x")[0],a=s&&s.getElementsByTagName("item")[0];n.isReplaceParticipant=e.getElementsByTagName("flip_device").length,n.affiliation=a&&a.getAttribute("affiliation"),n.role=a&&a.getAttribute("role");const d=a&&a.getAttribute("jid");n.jid=d,n.isFocus=this.xmpp.moderator.isFocusJid(d),n.isHiddenDomain=d&&d.indexOf("@")>0&&this.options.hiddenDomain===d.substring(d.indexOf("@")+1,d.indexOf("/")),this.eventEmitter.emit(Hi.XMPPEvents.PRESENCE_RECEIVED,{fromHiddenDomain:n.isHiddenDomain,presence:e});const c=e.querySelector("x");c&&c.remove();const l=[];ps.packet2JSON(e,l),this.lastPresences[t]=l;for(let e=0;e<l.length;e++){const t=l[e];switch(t.tagName){case"bot":{const{attributes:e}=t;if(!e)break;const{type:i}=e;n.botType=i;break}case"nick":n.nick=t.value;break;case"userId":n.id=t.value;break;case"stats-id":n.statsID=t.value;break;case"identity":n.identity=fs(t,this.options.hiddenFromRecorderFeatureEnabled);break;case"features":n.features=this._extractFeatures(t);break;case"stat":{const{attributes:e}=t;if(!e)break;const{name:i}=e;"version"===i&&(n.version=e.value);break}}}if(!this.joined&&!this.inProgressEmitted){const e=this.connectionTimes["muc.join.started"]=window.performance.now();us.log("(TIME) MUC join started:\\t",e),this.eventEmitter.emit(Hi.XMPPEvents.MUC_JOIN_IN_PROGRESS),this.inProgressEmitted=!0}if(t===this.myroomjid){const e="owner"===n.affiliation?n.role:"none";if(this.role!==e&&(this.role=e,this.eventEmitter.emit(Hi.XMPPEvents.LOCAL_ROLE_CHANGED,this.role)),!this.joined){this.joined=!0;const e=this.connectionTimes["muc.joined"]=window.performance.now();us.log("(TIME) MUC joined:\\t",e),this.password&&(this.locked=!0),this.presenceUpdateTime>=this.presenceSyncTime&&this.sendPresence(),this.eventEmitter.emit(Hi.XMPPEvents.MUC_JOINED),!this.options.disableDiscoInfo&&this.discoRoomInfo()}}else if(void 0===d)us.info("Ignoring member with undefined JID");else if(void 0===this.members[t])this.members[t]=n,us.log("entered",t,n),r=void 0!==n.status,o=void 0!==n.version,n.isFocus?this._initFocus(t,n.features):(this.eventEmitter.emit(Hi.XMPPEvents.MUC_MEMBER_JOINED,t,n.nick,n.role,n.isHiddenDomain,n.statsID,n.status,n.identity,n.botType,n.jid,n.features,n.isReplaceParticipant),r=!1);else{const e=this.members[t];e.role!==n.role&&(e.role=n.role,this.eventEmitter.emit(Hi.XMPPEvents.MUC_ROLE_CHANGED,t,n.role)),e.affiliation!==n.affiliation&&(e.affiliation=n.affiliation),e.botType!==n.botType&&(e.botType=n.botType,this.eventEmitter.emit(Hi.XMPPEvents.MUC_MEMBER_BOT_TYPE_CHANGED,t,n.botType)),n.isFocus&&(e.isFocus=!0,this._initFocus(t,n.features)),n.displayName&&(e.displayName=n.displayName),e.status!==n.status&&(r=!0,e.status=n.status),e.version!==n.version&&(o=!0,e.version=n.version),Et()(e.features,n.features)||(e.features=n.features,this.eventEmitter.emit(Hi.XMPPEvents.PARTICIPANT_FEATURES_CHANGED,t,n.features))}for(let e=0;e<l.length;e++){const i=l[e];switch(i.tagName){case"nick":if(!n.isFocus){const e=this.xmpp.options.displayJids?St.Strophe.getResourceFromJid(t):n.nick;this.eventEmitter.emit(Hi.XMPPEvents.DISPLAY_NAME_CHANGED,t,e)}break;case"bridgeNotAvailable":n.isFocus&&!this.noBridgeAvailable&&(this.noBridgeAvailable=!0,this.eventEmitter.emit(Hi.XMPPEvents.BRIDGE_DOWN));break;case"conference-properties":if(n.isFocus){const e={};for(let t=0;t<i.children.length;t++){const{attributes:n}=i.children[t];n&&n.key&&(e[n.key]=n.value)}this.eventEmitter.emit(Hi.XMPPEvents.CONFERENCE_PROPERTIES_CHANGED,e),void 0===this.restartByTerminateSupported&&(this.restartByTerminateSupported="true"===e["support-terminate-restart"],us.info(`Jicofo supports restart by terminate: ${this.supportsRestartByTerminate()}`))}break;case"transcription-status":{const{attributes:e}=i;if(!e)break;const{status:t}=e;t&&t!==this.transcriptionStatus&&(this.transcriptionStatus=t,this.eventEmitter.emit(Hi.XMPPEvents.TRANSCRIPTION_STATUS_CHANGED,t));break}case"call-control":{const e=i.attributes;if(!e)break;this.phoneNumber=e.phone||null,this.phonePin=e.pin||null,this.eventEmitter.emit(Hi.XMPPEvents.PHONE_NUMBER_CHANGED);break}default:this.processNode(i,t)}}r&&this.eventEmitter.emit(Hi.XMPPEvents.PRESENCE_STATUS,t,n.status),o&&us.info(`Received version for ${d}: ${n.version}`)}_extractFeatures(e){const t=new Set;for(let n=0;n<e.children.length;n++){const{attributes:i}=e.children[n];i&&i.var&&t.add(i.var)}return t}_initFocus(e,t){this.focusMucJid=e,this.focusFeatures=t}setParticipantPropertyListener(e){this.participantPropertyListener=e}supportsRestartByTerminate(){return this.restartByTerminateSupported}processNode(e,t){try{let n=this.presHandlers[e.tagName];e.tagName.startsWith("jitsi_participant_")&&(n=[this.participantPropertyListener]),n&&n.forEach((n=>{n(e,St.Strophe.getResourceFromJid(t),t)}))}catch(t){us.error(`Error processing:${e.tagName} node.`,t)}}sendMessage(e,t){const n=(0,St.$msg)({to:this.roomjid,type:"groupchat"});"body"===t?n.c(t,{},e):n.c(t,{xmlns:"http://jitsi.org/jitmeet"},e),this.connection.send(n),this.eventEmitter.emit(Hi.XMPPEvents.SENDING_CHAT_MESSAGE,e)}sendPrivateMessage(e,t,n){const i=(0,St.$msg)({to:`${this.roomjid}/${e}`,type:"chat"});"body"===n?i.c(n,t).up():i.c(n,{xmlns:"http://jitsi.org/jitmeet"},t).up(),this.connection.send(i),this.eventEmitter.emit(Hi.XMPPEvents.SENDING_PRIVATE_CHAT_MESSAGE,t)}setSubject(e){const t=(0,St.$msg)({to:this.roomjid,type:"groupchat"});t.c("subject",e),this.connection.send(t)}onPresenceUnavailable(e,t){if(_t()(e).find(\'>ignore[xmlns="http://jitsi.org/jitmeet/"]\').length)return!0;const n=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>destroy\');if(n.length){let t;const i=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>destroy>reason\');return i.length&&(t=i.text()),this.eventEmitter.emit(Hi.XMPPEvents.MUC_DESTROYED,t,n.attr("jid")),this.connection.emuc.doLeave(this.roomjid),!0}const i=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>status[code="110"]\').length,r=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>status[code="307"]\').length,o=Object.keys(this.members),s=_t()(e).find("flip_device").length;if(r){const n=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>item>actor\');let r,o;n.length&&(r=n.attr("nick"));const a=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>item>reason\');a.length&&(o=a.text()),this.eventEmitter.emit(Hi.XMPPEvents.KICKED,i,r,St.Strophe.getResourceFromJid(t),o,s)}if(i)o.forEach((e=>{const t=this.members[e];delete this.members[e],delete this.lastPresences[e],t.isFocus||this.eventEmitter.emit(Hi.XMPPEvents.MUC_MEMBER_LEFT,e)})),this.connection.emuc.doLeave(this.roomjid),r||this.eventEmitter.emit(Hi.XMPPEvents.MUC_LEFT);else{const n=_t()(e).find(">status"),i=this.members[t];let r;n.length&&(r=n.text()),delete this.members[t],delete this.lastPresences[t],this.eventEmitter.emit(Hi.XMPPEvents.MUC_MEMBER_LEFT,t,r),null!=i&&i.isFocus&&(us.info("Focus has left the room - leaving conference"),this.eventEmitter.emit(Hi.XMPPEvents.FOCUS_LEFT))}}onMessage(e,t){const n=e.getAttribute("type");if("error"===n){const t=_t()(e).find(">settings-error>text").text();if(t.length)return this.eventEmitter.emit(Hi.XMPPEvents.SETTINGS_ERROR_RECEIVED,t),!0;const n=_t()(e).find(">error>text").text();return this.eventEmitter.emit(Hi.XMPPEvents.CHAT_ERROR_RECEIVED,n),!0}const i=_t()(e).find(">body").text(),r=_t()(e).find(">subject");if(r.length){const e=r.text();(e||""===e)&&(this.eventEmitter.emit(Hi.XMPPEvents.SUBJECT_CHANGED,e),us.log(`Subject is changed to ${e}`))}let o=_t()(e).find(">delay").attr("stamp");if(!o&&(o=_t()(e).find(\'>[xmlns="jabber:x:delay"]\').attr("stamp"),o)){const e=o.match(/(\\d{4})(\\d{2})(\\d{2}T\\d{2}:\\d{2}:\\d{2})/);o=`${e[1]}-${e[2]}-${e[3]}Z`}if(t===this.roomjid){let n;if(_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>status[code="104"]\').length)this.discoRoomInfo();else if((n=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>invite\'))&&n.length){const r=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>password\');let o;r&&r.length&&(o=r.text()),this.eventEmitter.emit(Hi.XMPPEvents.INVITE_MESSAGE_RECEIVED,t,n.attr("from"),i,o)}}const s=_t()(e).find(">json-message").text();if(s){const e=this.xmpp.tryParseJSONAndVerify(s);if(e&&void 0===o)return void this.eventEmitter.emit(Hi.XMPPEvents.JSON_MESSAGE_RECEIVED,t,e)}if(i)if("chat"===n)this.eventEmitter.emit(Hi.XMPPEvents.PRIVATE_MESSAGE_RECEIVED,t,i,this.myroomjid,o);else if("groupchat"===n){const n=_t()(e).find(">nick");let r;n.length>0&&(r=n.text()),this.eventEmitter.emit(Hi.XMPPEvents.MESSAGE_RECEIVED,t,i,this.myroomjid,o,r,Boolean(r))}}onPresenceError(e,t){let n;if(_t()(e).find(\'>error[type="auth"]>not-authorized[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]\').length)us.log("on password required",t),this.eventEmitter.emit(Hi.XMPPEvents.PASSWORD_REQUIRED);else if(_t()(e).find(\'>error[type="cancel"]>not-allowed[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]\').length)if(St.Strophe.getDomainFromJid(e.getAttribute("to"))===this.xmpp.options.hosts.anonymousdomain)this.eventEmitter.emit(Hi.XMPPEvents.ROOM_JOIN_ERROR);else{us.warn("onPresError ",e);const t=_t()(e).find(\'>error[type="cancel"]>text[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]\'),n=t.length&&t.text();if("Room creation is restricted"===n&&(this._roomCreationRetries||(this._roomCreationRetries=0),this._roomCreationRetries++,this._roomCreationRetries<=3)){const e=Ro(this._roomCreationRetries,500,1.5);return void setTimeout((()=>this.join(this.password,this.replaceParticipant)),e)}this.eventEmitter.emit(Hi.XMPPEvents.ROOM_CONNECT_NOT_ALLOWED_ERROR,n)}else if(_t()(e).find(">error>service-unavailable").length)us.warn("Maximum users limit for the room has been reached",e),this.eventEmitter.emit(Hi.XMPPEvents.ROOM_MAX_USERS_ERROR);else if(_t()(e).find(\'>error[type="auth"]>registration-required[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]\').length){const t=_t()(e).find(\'>error[type="auth"]>lobbyroom\');let n;t.length&&(n=t.text());const i=_t()(e).find(\'>error[type="auth"]>waiting-for-host\').length>0;this.eventEmitter.emit(Hi.XMPPEvents.ROOM_CONNECT_MEMBERS_ONLY_ERROR,n,i)}else if((n=_t()(e).find(\'>error[type="modify"]>displayname-required[xmlns="http://jitsi.org/jitmeet"]\')).length){var i;us.warn("display name required ",e),this.eventEmitter.emit(Hi.XMPPEvents.DISPLAY_NAME_REQUIRED,null===(i=n[0].attributes.lobby)||void 0===i?void 0:i.value)}else us.warn("onPresError ",e),this.eventEmitter.emit(Hi.XMPPEvents.ROOM_CONNECT_ERROR)}setAffiliation(e,t){const n=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#admin"}).c("item",{affiliation:t,jid:St.Strophe.getBareJidFromJid(e)}).c("reason").t(`Your affiliation has been changed to \'${t}\'.`).up().up().up();this.connection.sendIQ(n,(n=>us.log("Set affiliation of participant with jid: ",e,"to",t,n)),(e=>us.log("Set affiliation of participant error: ",e)))}kick(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"You have been kicked.";const n=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#admin"}).c("item",{nick:St.Strophe.getResourceFromJid(e),role:"none"}).c("reason").t(t).up().up().up();this.connection.sendIQ(n,(t=>us.log("Kick participant with jid: ",e,t)),(e=>us.log("Kick participant error: ",e)))}lockRoom(e,t,n,i){this.connection.sendIQ((0,St.$iq)({to:this.roomjid,type:"get"}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"}),(r=>{if(_t()(r).find(\'>query>x[xmlns="jabber:x:data"]>field[var="muc#roomconfig_roomsecret"]\').length){const i=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"});i.c("x",{xmlns:"jabber:x:data",type:"submit"}),i.c("field",{var:"FORM_TYPE"}).c("value").t("http://jabber.org/protocol/muc#roomconfig").up().up(),i.c("field",{var:"muc#roomconfig_roomsecret"}).c("value").t(e).up().up(),i.c("field",{var:"muc#roomconfig_passwordprotectedroom"}).c("value").t(null===e||0===e.length?"0":"1").up().up(),this.membersOnlyEnabled&&i.c("field",{var:"muc#roomconfig_membersonly"}).c("value").t("true").up().up(),i.c("field",{var:"muc#roomconfig_whois"}).c("value").t("anyone").up().up(),this.connection.sendIQ(i,(()=>{this.password=e,t()}),n)}else i()}),n)}setMembersOnly(e,t,n){if(e&&Object.values(this.members).filter((e=>!e.isFocus)).length){const e=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#admin"});Object.values(this.members).forEach((t=>{t.jid&&!gs.includes(t.affiliation)&&e.c("item",{affiliation:"member",jid:St.Strophe.getBareJidFromJid(t.jid)}).up()})),this.xmpp.connection.sendIQ(e.up())}const i=n||(()=>{});this.xmpp.connection.sendIQ((0,St.$iq)({to:this.roomjid,type:"get"}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"}),(n=>{if(_t()(n).find(\'>query>x[xmlns="jabber:x:data"]>field[var="muc#roomconfig_membersonly"]\').length){const n=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"});n.c("x",{xmlns:"jabber:x:data",type:"submit"}),n.c("field",{var:"FORM_TYPE"}).c("value").t("http://jabber.org/protocol/muc#roomconfig").up().up(),n.c("field",{var:"muc#roomconfig_membersonly"}).c("value").t(e?"true":"false").up().up(),this.locked&&n.c("field",{var:"muc#roomconfig_passwordprotectedroom"}).c("value").t("1").up().up(),this.xmpp.connection.sendIQ(n,t,i)}else i(new Error("Setting members only room not supported!"))}),i)}addToPresence(e,t){return this.addOrReplaceInPresence(e,t)}addOrReplaceInPresence(e,t){t.tagName=e;const n=this.presMap.nodes.filter((t=>e===t.tagName));return!(1===n.length&&Et()(n[0],t)||(this.removeFromPresence(e),this.presMap.nodes.push(t),this.presenceUpdateTime=Date.now(),0))}getFromPresence(e){return this.presMap.nodes.find((t=>e===t.tagName))}removeFromPresence(e){const t=this.presMap.nodes.filter((t=>e!==t.tagName));this.presMap.nodes=t,this.presenceUpdateTime=Date.now()}addPresenceListener(e,t){if("function"!=typeof t)throw new Error(\'"handler" is not a function\');let n=this.presHandlers[e];n||(this.presHandlers[e]=n=[]),-1===n.indexOf(t)?n.push(t):us.warn(`Trying to add the same handler more than once for: ${e}`)}removePresenceListener(e,t){const n=this.presHandlers[e],i=n?n.indexOf(t):-1;-1!==i?n.splice(i,1):us.warn(`Handler for: ${e} was not registered`)}isFocus(e){const t=this.members[e];return t?t.isFocus:null}isModerator(){return"moderator"===this.role}getMediaPresenceInfo(e,t){const n=this.lastPresences[`${this.roomjid}/${e}`];if(!n)return null;const i={muted:!0,videoType:t===Ri.VIDEO?Qo.VideoType.CAMERA:void 0};let r=null;if(t===Ri.AUDIO)r=ms(n,"audiomuted");else{if(t!==Ri.VIDEO)return us.error(`Unsupported media type: ${t}`),null;{r=ms(n,"videomuted");const e=ms(n,"jitsi_participant_codecType"),t=ms(n,"videoType");t.length>0&&(i.videoType=t[0].value),e.length>0&&(i.codecType=e[0].value)}}return r.length>0&&(i.muted="true"===r[0].value),i}getMemberRole(e){return this.members[e]?this.members[e].role:null}getLastPresence(e){return this.lastPresences[`${this.roomjid}/${e}`]}dial(e){return this.connection.rayo.dial(e,"fromnumber",St.Strophe.getBareJidFromJid(this.myroomjid),this.password,this.focusMucJid)}hangup(){return this.connection.rayo.hangup()}getLobby(){return this.lobby}getAVModeration(){return this.avModeration}getBreakoutRooms(){return this.breakoutRooms}getMetadataHandler(){return this.roomMetadata}getPhoneNumber(){return this.phoneNumber}getPhonePin(){return this.phonePin}getMeetingId(){return this.meetingId}muteParticipant(e,t,n){us.info("set mute",t,e);const i=(0,St.$iq)({to:this.focusMucJid,type:"set"}).c("mute",{xmlns:`http://jitsi.org/jitmeet/${n}`,jid:e}).t(t.toString()).up();this.connection.sendIQ(i,(e=>us.log("set mute",e)),(e=>us.log("set mute error",e)))}onMute(e){if(e.getAttribute("from")!==this.focusMucJid)return void us.warn("Ignored mute from non focus peer");const t=_t()(e).find("mute");t.length&&"true"===t.text()?this.eventEmitter.emit(Hi.XMPPEvents.AUDIO_MUTED_BY_FOCUS,t.attr("actor")):us.warn("Ignoring a mute request which does not explicitly specify a positive mute command.")}onMuteVideo(e){if(e.getAttribute("from")!==this.focusMucJid)return void us.warn("Ignored mute from non focus peer");const t=_t()(e).find("mute");t.length&&"true"===t.text()?this.eventEmitter.emit(Hi.XMPPEvents.VIDEO_MUTED_BY_FOCUS,t.attr("actor")):us.warn("Ignoring a mute request which does not explicitly specify a positive mute command.")}clean(){this._removeConnListeners.forEach((e=>e())),this._removeConnListeners=[],this.eventsForwarder.removeListeners(Ui().IDENTITY_UPDATED,Hi.XMPPEvents.AUTHENTICATION_REQUIRED,Hi.XMPPEvents.FOCUS_DISCONNECTED,Hi.XMPPEvents.RESERVATION_ERROR),this.joined=!1,this.inProgressEmitted=!1}leave(e){var t,n=this;this.avModeration.dispose(),this.breakoutRooms.dispose(),this.roomMetadata.dispose();const i=[];return(null===(t=this.lobby)||void 0===t?void 0:t.lobbyRoom)&&i.push(this.lobby.leave()),i.push(new Promise(((t,i)=>{let r=-1;const o=function(){let e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];n.eventEmitter.removeListener(Hi.XMPPEvents.MUC_LEFT,o),clearTimeout(r),n.clean(),e?(n.connection.emuc.doLeave(n.roomjid),i(new Error("The timeout for the confirmation about leaving the room expired."))):t()};this.joined?(r=setTimeout((()=>o(!0)),5e3),this.eventEmitter.on(Hi.XMPPEvents.MUC_LEFT,o),this.doLeave(e)):(this.connection.emuc.doLeave(this.roomjid),this.clean(),t())}))),Promise.allSettled(i)}end(){if(this.breakoutRooms.isBreakoutRoom())return void us.warn("Cannot end conference: this is a breakout room.");const e=(0,St.$msg)({to:this.xmpp.endConferenceComponentAddress});e.c("end_conference").up(),this.xmpp.connection.send(e)}}const _s=(0,E.getLogger)("modules/xmpp/strophe.emuc.js");class ys extends Oo{constructor(e){super(),this.xmpp=e,this.rooms={}}init(e){super.init(e),this.connection.addHandler(this.onPresence.bind(this),null,"presence",null,null,null,null),this.connection.addHandler(this.onPresenceUnavailable.bind(this),null,"presence","unavailable",null),this.connection.addHandler(this.onPresenceError.bind(this),null,"presence","error",null),this.connection.addHandler(this.onMessage.bind(this),null,"message",null,null),this.connection.addHandler(this.onMute.bind(this),"http://jitsi.org/jitmeet/audio","iq","set",null,null),this.connection.addHandler(this.onMuteVideo.bind(this),"http://jitsi.org/jitmeet/video","iq","set",null,null),this.connection.addHandler(this.onVisitors.bind(this),"jitsi:visitors","iq","set",null,null)}createRoom(e,t,n){const i=St.Strophe.getBareJidFromJid(e);if(this.isRoomCreated(i)){const e="You are already in the room!";throw _s.error(e),new Error(e)}return this.rooms[i]=new vs(this.connection,e,t,this.xmpp,n),this.eventEmitter.emit(Hi.XMPPEvents.EMUC_ROOM_ADDED,this.rooms[i]),this.rooms[i]}isRoomCreated(e){return e in this.rooms}doLeave(e){this.eventEmitter.emit(Hi.XMPPEvents.EMUC_ROOM_REMOVED,this.rooms[e]),delete this.rooms[e]}onPresence(e){const t=e.getAttribute("from");if(e.getAttribute("type"))return!0;const n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>status[code="201"]\').length&&n.createNonAnonymousRoom(),n.onPresence(e),!0)}onPresenceUnavailable(e){const t=e.getAttribute("from"),n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(n.onPresenceUnavailable(e,t),!0)}onPresenceError(e){const t=e.getAttribute("from"),n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(n.onPresenceError(e,t),!0)}onMessage(e){const t=e.getAttribute("from"),n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(n.onMessage(e,t),!0)}onMute(e){const t=e.getAttribute("from"),n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(n.onMute(e),!0)}onMuteVideo(e){const t=e.getAttribute("from"),n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(n.onMuteVideo(e),!0)}onVisitors(e){const t=e.getAttribute("from");if(!this.rooms[St.Strophe.getBareJidFromJid(t)])return!0;const n=_t()(e).find(\'>visitors[xmlns="jitsi:visitors"]\'),i=_t()(e).find("promotion-response");return n.length&&i.length&&("true"===String(i.attr("allow")).toLowerCase()?(_s.info("Promotion request accepted. Redirected to main room."),this.xmpp.eventEmitter.emit(pr,void 0,n.attr("focusjid"),i.attr("username"))):(_s.info("Promotion request rejected."),this.xmpp.eventEmitter.emit(Hi.XMPPEvents.VISITORS_REJECTION))),!0}}var Es=n(138),Ss=n.n(Es);const bs=(0,E.getLogger)("modules/xmpp/JingleHelperFunctions.js");function Ts(e,t){const n=(0,St.$build)("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",ssrc:t.s,name:t.n});return t.m&&n.c("parameter",{name:"msid",value:t.m}).up(),n.c("ssrc-info",{xmlns:"http://jitsi.org/jitmeet",owner:e}).up(),n.node}function Cs(e){const t=(0,St.$build)("ssrc-group",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",semantics:(n=e[0],"f"===n?"FID":"s"===n?"SIM":null)});var n;for(let n=1;n<e.length;n++)t.c("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",ssrc:e[n]}).up();return t.node}function xs(e,t){const n=_t()(e).find("jingle")[0];let i,r=_t()(n).find(`content[name="${t}"]`);return r.length?r=r[0]:(r=(0,St.$build)("content",{name:t}).node,n.appendChild(r)),i=_t()(r).find("description"),i.length?i=i[0]:(i=(0,St.$build)("description",{xmlns:"urn:xmpp:jingle:apps:rtp:1",media:t}).node,r.appendChild(i)),i}function Rs(e,t){var n;let i;try{i=_r(t.textContent)}catch(e){return bs.error(`json-message XML contained invalid JSON, ignoring: ${t.textContent}`),null}if(null===(n=i)||void 0===n||!n.sources)return null;const r=xs(e,Ri.AUDIO),o=xs(e,Ri.VIDEO),s=new Map;for(const e in i.sources)if(i.sources.hasOwnProperty(e)){const t=[],n=i.sources[e],c=(null==n?void 0:n.length)&&n[0],l=(null==n?void 0:n.length)>1&&n[1],h=(null==n?void 0:n.length)>2&&n[2],u=(null==n?void 0:n.length)>3&&n[3];if(null!=c&&c.length)for(let n=0;n<c.length;n++){var a;o.appendChild(Ts(e,c[n])),t.push(null===(a=c[n])||void 0===a?void 0:a.s)}if(null!=l&&l.length)for(let e=0;e<l.length;e++)o.appendChild(Cs(l[e]));if(null!=h&&h.length)for(let n=0;n<h.length;n++){var d;r.appendChild(Ts(e,h[n])),t.push(null===(d=h[n])||void 0===d?void 0:d.s)}if(null!=u&&u.length)for(let e=0;e<u.length;e++)r.appendChild(Cs(u[e]));s.set(e,t)}return s}let As;!function(e){e.INACTIVE="inactive",e.RECVONLY="recvonly",e.SENDONLY="sendonly",e.SENDRECV="sendrecv"}(As||(As={}));const ws=n(810).getLogger("modules/RTC/ScreenObtainer.js"),Is={obtainStream:null,init(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.options=e,this.obtainStream=this._createObtainStreamMethod(),this.obtainStream||ws.info("Desktop sharing disabled")},_createObtainStreamMethod(){return ci.isElectron()?this.obtainScreenOnElectron:ci.isReactNative()&&ci.supportsGetDisplayMedia()?this.obtainScreenFromGetDisplayMediaRN:ci.supportsGetDisplayMedia()?this.obtainScreenFromGetDisplayMedia:(ws.log("Screen sharing not supported on ",ci.getName()),null)},_getAudioConstraints(){const{audioQuality:e}=this.options;return null==e||!e.stereo||{autoGainControl:!1,channelCount:2,echoCancellation:!1,noiseSuppression:!1}},isSupported(){return null!==this.obtainStream},obtainScreenOnElectron(e,t){var n=this;let i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(window.JitsiMeetScreenObtainer&&window.JitsiMeetScreenObtainer.openDesktopPicker){const{desktopSharingFrameRate:r,desktopSharingResolution:o,desktopSharingSources:s}=this.options;window.JitsiMeetScreenObtainer.openDesktopPicker({desktopSharingSources:i.desktopSharingSources||s||["screen","window"]},(function(i,s){if(i){var a,d,c,l,h,u,p,m;let g=!1;if(arguments.length>2&&void 0!==arguments[2]&&arguments[2]){g={};const e=n._getAudioConstraints();"boolean"!=typeof e&&(g={optional:e}),"screen"===s&&(g.mandatory={chromeMediaSource:"desktop"})}const f={audio:g,video:{mandatory:{chromeMediaSource:"desktop",chromeMediaSourceId:i,minFrameRate:null!==(a=null==r?void 0:r.min)&&void 0!==a?a:5,maxFrameRate:null!==(d=null==r?void 0:r.max)&&void 0!==d?d:5,minWidth:null==o||null===(c=o.width)||void 0===c?void 0:c.min,minHeight:null==o||null===(l=o.height)||void 0===l?void 0:l.min,maxWidth:null!==(h=null==o||null===(u=o.width)||void 0===u?void 0:u.max)&&void 0!==h?h:window.screen.width,maxHeight:null!==(p=null==o||null===(m=o.height)||void 0===m?void 0:m.max)&&void 0!==p?p:window.screen.height}}};navigator.mediaDevices.getUserMedia(f).then((t=>{n.setContentHint(t),e({stream:t,sourceId:i,sourceType:s})})).catch((e=>t(e)))}else t(new dr(Zi))}),(e=>t(new dr(zi,e))))}else t(new dr(Ki))},obtainScreenFromGetDisplayMedia(e,t){let n;n=navigator.getDisplayMedia?navigator.getDisplayMedia.bind(navigator):navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices);const i=this._getAudioConstraints();let r={};const o={},{desktopSharingFrameRate:s,screenShareSettings:a}=this.options;"object"==typeof s&&(r.frameRate=s),r.frameRate&&delete r.frameRate.min,ci.isChromiumBased()&&(ci.isEngineVersionGreaterThan(93)&&(o.preferCurrentTab=(null==a?void 0:a.desktopPreferCurrentTab)||!1),ci.isEngineVersionGreaterThan(104)&&(o.systemAudio=(null==a?void 0:a.desktopSystemAudio)||"include"),ci.isEngineVersionGreaterThan(106)&&(o.surfaceSwitching=(null==a?void 0:a.desktopSurfaceSwitching)||"include"),ci.isEngineVersionGreaterThan(106)&&(null==a?void 0:a.desktopDisplaySurface)&&(r.displaySurface=null==a?void 0:a.desktopDisplaySurface),ci.isEngineVersionGreaterThan(111)&&(o.selfBrowserSurface=(null==a?void 0:a.desktopSelfBrowserSurface)||"exclude"),(null==s?void 0:s.max)>5||(r.height=99999,r.width=99999)),ci.isSafari()&&null!=a&&a.desktopDisplaySurface&&(r.displaySurface=null==a?void 0:a.desktopDisplaySurface),0===Object.keys(r).length&&(r=!0);const d={video:r,audio:i,...o,cursor:"always"};ws.info("Using getDisplayMedia for screen sharing",d),n(d).then((t=>{if(this.setContentHint(t),ci.isChromiumBased()){const e=t.getVideoTracks()[0];let n=5;"number"==typeof(null==s?void 0:s.min)&&s.min>0&&(n=s.min);const i={frameRate:{min:n}};try{e.applyConstraints(i)}catch(e){ws.warn(`Min fps=${n} constraint could not be applied on the desktop track,${e.message}`)}}e({stream:t,sourceId:t.id})})).catch((e=>{const n={errorName:e&&e.name,errorMsg:e&&e.message,errorStack:e&&e.stack};ws.error("getDisplayMedia error",JSON.stringify(d),JSON.stringify(n)),n.errorMsg&&-1!==n.errorMsg.indexOf("denied by system")?t(new dr(Yi)):t(new dr(Zi))}))},obtainScreenFromGetDisplayMediaRN(e,t){ws.info("Using getDisplayMedia for screen sharing"),navigator.mediaDevices.getDisplayMedia({video:!0}).then((t=>{this.setContentHint(t),e({stream:t,sourceId:t.id})})).catch((()=>{t(new dr(Zi))}))},setContentHint(e){const{desktopSharingFrameRate:t}=this.options,n=e.getVideoTracks()[0];"contentHint"in n?n.contentHint=(null==t?void 0:t.max)>5?"motion":"detail":ws.warn("MediaStreamTrack contentHint attribute not supported")},setDesktopSharingFrameRate(e){ws.info(`Setting the desktop capture rate to ${e}`),this.options.desktopSharingFrameRate={min:5,max:e}}};var Ps=n(310);let Ds;!function(e){e.AV1="av1",e.H264="h264",e.OPUS="opus",e.RED="red",e.ULPFEC="ulpfec",e.VP8="vp8",e.VP9="vp9"}(Ds||(Ds={}));const Os=(0,E.getLogger)("modules/sdp/SDPUtil.js"),ks={filterSpecialChars:e=>e?e.replace(/[\\\\\\/\\{,\\}\\+]/g,""):e,iceparams(e,t){let n,i,r=null;return(i=ks.findLine(e,"a=ice-ufrag:",t))&&(n=ks.findLine(e,"a=ice-pwd:",t))&&(r={ufrag:ks.parseICEUfrag(i),pwd:ks.parseICEPwd(n)}),r},parseICEUfrag:e=>e.substring(12),buildICEUfrag:e=>`a=ice-ufrag:${e}`,parseICEPwd:e=>e.substring(10),buildICEPwd:e=>`a=ice-pwd:${e}`,parseMID:e=>e.substring(6),parseMSIDAttribute(e){const t=e.find((e=>e.indexOf(" msid:")>0));if(!t)return;const n=t.substring(t.indexOf(" msid:")+6);return ks.filterSpecialChars(n)},parseMLine(e){const t={},n=e.substring(2).split(" ");return t.media=n.shift(),t.port=n.shift(),t.proto=n.shift(),""===n[n.length-1]&&n.pop(),t.fmt=n,t},buildMLine:e=>`m=${e.media} ${e.port} ${e.proto} ${e.fmt.join(" ")}`,parseRTPMap(e){const t={};let n=e.substring(9).split(" ");return t.id=n.shift(),n=n[0].split("/"),t.name=n.shift(),t.clockrate=n.shift(),t.channels=n.length?n.shift():"1",t},parseSCTPMap(e){const t=e.substring(10).split(" ");return[t[0],t[1],t.length>2?t[2]:null]},parseSCTPPort:e=>e.substring(12),buildRTPMap(e){let t=`a=rtpmap:${e.getAttribute("id")} ${e.getAttribute("name")}/${e.getAttribute("clockrate")}`;return e.getAttribute("channels")&&"1"!==e.getAttribute("channels")&&(t+=`/${e.getAttribute("channels")}`),t},parseCrypto(e){const t={},n=e.substring(9).split(" ");return t.tag=n.shift(),t["crypto-suite"]=n.shift(),t["key-params"]=n.shift(),n.length&&(t["session-params"]=n.join(" ")),t},parseFingerprint(e){const t={},n=e.substring(14).split(" ");return t.hash=n.shift(),t.fingerprint=n.shift(),t},parseFmtp(e){const t=[];let n=e.split(" ");n.shift(),n=n.join(" ").split(";");for(let e=0;e<n.length;e++){let i=n[e].split("=")[0];for(;i.length&&" "===i[0];)i=i.substring(1);const r=n[e].split("=")[1];i&&r?t.push({name:i,value:r}):i&&t.push({name:"",value:i})}return t},parseICECandidate(e){const t={},n=e.split(" ");t.foundation=n[0].substring(12),t.component=n[1],t.protocol=n[2].toLowerCase(),t.priority=n[3],t.ip=n[4],t.port=n[5],t.type=n[7],t.generation=0;for(let e=8;e<n.length;e+=2)switch(n[e]){case"raddr":t["rel-addr"]=n[e+1];break;case"rport":t["rel-port"]=n[e+1];break;case"generation":t.generation=n[e+1];break;case"tcptype":t.tcptype=n[e+1];break;default:Os.debug(`parseICECandidate not translating "${n[e]}" = "${n[e+1]}"`)}return t.network="1",t.id=Math.random().toString(36).substr(2,10),t},buildICECandidate(e){let t=[`a=candidate:${e.foundation}`,e.component,e.protocol,e.priority,e.ip,e.port,"typ",e.type].join(" ");switch(t+=" ",e.type){case"srflx":case"prflx":case"relay":e.hasOwnAttribute("rel-addr")&&e.hasOwnAttribute("rel-port")&&(t+="raddr",t+=" ",t+=e["rel-addr"],t+=" ",t+="rport",t+=" ",t+=e["rel-port"],t+=" ")}return e.hasOwnAttribute("tcptype")&&(t+="tcptype",t+=" ",t+=e.tcptype,t+=" "),t+="generation",t+=" ",t+=e.hasOwnAttribute("generation")?e.generation:"0",t},parseSSRC(e){const t=new Map,n=e.split("\\r\\n");for(let e=0;e<n.length;e++)if("a=ssrc:"===n[e].substring(0,7)){const i=n[e].split("a=ssrc:")[1].split(" ")[0];t.get(i)||t.set(i,[]),t.get(i).push(n[e])}return t},parseSourceNameLine(e){const t=e.find((e=>e.indexOf(" name:")>0));return null==t?void 0:t.substring(t.indexOf(" name:")+6)},parseVideoTypeLine(e){const t=" videoType:",n=e.find((e=>e.indexOf(t)>0));return null==n?void 0:n.substring(n.indexOf(t)+t.length)},parseRTCPFB(e){const t=e.substr(10).split(" "),n={};return n.pt=t.shift(),n.type=t.shift(),n.params=t,n},parseExtmap(e){const t=e.substr(9).split(" "),n={};return n.value=t.shift(),-1===n.value.indexOf("/")?n.direction="both":(n.direction=n.value.substr(n.value.indexOf("/")+1),n.value=n.value.substr(0,n.value.indexOf("/"))),n.uri=t.shift(),n.params=t,n},findLine(e,t,n){let i=e.split("\\r\\n");for(let e=0;e<i.length;e++)if(i[e].substring(0,t.length)===t)return i[e];if(!n)return!1;i=n.split("\\r\\n");for(let e=0;e<i.length;e++)if(i[e].substring(0,t.length)===t)return i[e];return!1},findLines(e,t,n){let i=e.split("\\r\\n");const r=[];for(let e=0;e<i.length;e++)i[e].substring(0,t.length)===t&&r.push(i[e]);if(r.length||!n)return r;i=n.split("\\r\\n");for(let e=0;e<i.length;e++)i[e].substring(0,t.length)===t&&r.push(i[e]);return r},candidateToJingle(e){if(0===e.indexOf("candidate:"))e=`a=${e}`;else if("a=candidate:"!==e.substring(0,12))return Os.warn("parseCandidate called with a line that is not a candidate line"),Os.warn(e),null;"\\r\\n"===e.substring(e.length-2)&&(e=e.substring(0,e.length-2));const t={},n=e.split(" ");if("typ"!==n[6])return Os.warn("did not find typ in the right place"),Os.warn(e),null;t.foundation=n[0].substring(12),t.component=n[1],t.protocol=n[2].toLowerCase(),t.priority=n[3],t.ip=n[4],t.port=n[5],t.type=n[7],t.generation="0";for(let e=8;e<n.length;e+=2)switch(n[e]){case"raddr":t["rel-addr"]=n[e+1];break;case"rport":t["rel-port"]=n[e+1];break;case"generation":t.generation=n[e+1];break;case"tcptype":t.tcptype=n[e+1];break;default:Os.debug(`not translating "${n[e]}" = "${n[e+1]}"`)}return t.network="1",t.id=Math.random().toString(36).substr(2,10),t},candidateFromJingle(e){let t="a=candidate:";t+=e.getAttribute("foundation"),t+=" ",t+=e.getAttribute("component"),t+=" ";let n=e.getAttribute("protocol");switch(ci.isFirefox()&&"ssltcp"===n.toLowerCase()&&(n="tcp"),t+=n,t+=" ",t+=e.getAttribute("priority"),t+=" ",t+=e.getAttribute("ip"),t+=" ",t+=e.getAttribute("port"),t+=" ",t+="typ",t+=` ${e.getAttribute("type")}`,t+=" ",e.getAttribute("type")){case"srflx":case"prflx":case"relay":e.getAttribute("rel-addr")&&e.getAttribute("rel-port")&&(t+="raddr",t+=" ",t+=e.getAttribute("rel-addr"),t+=" ",t+="rport",t+=" ",t+=e.getAttribute("rel-port"),t+=" ")}return"tcp"===n.toLowerCase()&&(t+="tcptype",t+=" ",t+=e.getAttribute("tcptype"),t+=" "),t+="generation",t+=" ",t+=e.getAttribute("generation")||"0",`${t}\\r\\n`},parsePrimaryVideoSsrc(e){const t=e.ssrcs.map((e=>e.id)).filter(((e,t,n)=>n.indexOf(e)===t)).length,n=e.ssrcGroups&&e.ssrcGroups.length||0;if(t>1&&0===n)return;let i=null;if(1===t)i=e.ssrcs[0].id;else if(2===t){const t=e.ssrcGroups.find((e=>"FID"===e.semantics));t&&(i=t.ssrcs.split(" ")[0])}else if(t>=3){const t=e.ssrcGroups.find((e=>"SIM"===e.semantics));t&&(i=t.ssrcs.split(" ")[0])}return i},generateSsrc:()=>co().randomInt(1,4294967295),getSsrcAttribute(e,t,n){for(let i=0;i<e.ssrcs.length;++i){const r=e.ssrcs[i];if(r.id===t&&r.attribute===n)return r.value}},parseGroupSsrcs:e=>e.ssrcs.split(" ").map((e=>parseInt(e,10))),getMedia:(e,t)=>e.media.find((e=>e.type===t)),getUfrag(e){const t=e.split("\\n").filter((e=>e.startsWith("a=ice-ufrag:")));if(t.length>0)return t[0].substr("a=ice-ufrag:".length)},preferCodec(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!e||!t)return;const i=e.rtp.filter((e=>e.codec&&e.codec.toLowerCase()===t.toLowerCase())).map((e=>e.payload));if(i){if(n&&t===Ds.H264){const t=i.filter((t=>{const n=e.fmtp.find((e=>e.payload===t));return!!n&&n.config.includes("packetization-mode=0")}));for(const e of t.reverse()){const t=i.findIndex((t=>t===e));t>=0&&(i.splice(t,1),i.unshift(e))}}const r=e.payloads.toString().split(" ").map((e=>parseInt(e,10)));for(const e of i.reverse()){const t=r.indexOf(e);r.splice(t,1),r.unshift(e)}e.payloads=r.join(" ")}else Os.error(`No matching RTP payload type found for ${t}, failed to set preferred codecs`)},stripCodec(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!e||!t)return;const i=new Map;let r=[];for(const o of e.rtp)o.codec&&o.codec.toLowerCase()===t.toLowerCase()&&(n?i.set(o.payload,o.codec):r.push(o.payload));if(n&&(r=e.fmtp.filter((e=>{const t=i.get(e.payload);return!!t&&(t.toLowerCase()===Ds.VP9?!e.config.includes("profile-id=0"):!e.config.includes("profile-level-id=42"))})).map((e=>e.payload))),r.length>0){const t=r.map((e=>`apt=${e}`)),n=e.fmtp.filter((e=>-1!==t.indexOf(e.config)));r.push(...n.map((e=>e.payload)));const i=e.payloads.toString().split(" ").map(Number).filter((e=>-1===r.indexOf(e)));0===i.length?(e.port=0,e.direction=As.INACTIVE,e.payloads="*"):e.payloads=i.join(" "),e.rtp=e.rtp.filter((e=>-1!==i.indexOf(e.payload))),e.fmtp=e.fmtp.filter((e=>-1!==i.indexOf(e.payload))),e.rtcpFb&&(e.rtcpFb=e.rtcpFb.filter((e=>-1!==i.indexOf(e.payload))))}}},Ns=ks;function Ms(e){const t=e.split("\\r\\nm=");for(let e=1,n=t.length;e<n;e++){let i=`m=${t[e]}`;e!==n-1&&(i+="\\r\\n"),t[e]=i}const n=`${t.shift()}\\r\\n`;this.media=t,this.raw=n+t.join(""),this.session=n}function Ls(e,t){if(!t)return!1;if(e.length!==t.length)return!1;for(let n=0,i=e.length;n<i;n++)if(e[n]instanceof Array&&t[n]instanceof Array){if(!e[n].equals(t[n]))return!1}else if(e[n]!==t[n])return!1;return!0}function Fs(e,t){if(this.mySDP=e,this.otherSDP=t,!e)throw new Error(\'"mySDP" is undefined!\');if(!t)throw new Error(\'"otherSDP" is undefined!\')}function js(e){return function(){if(null===e)throw new Error("Callback was already called.");var t=e;e=null;for(var n=arguments.length,i=new Array(n),r=0;r<n;r++)i[r]=arguments[r];t.apply(this,i)}}Ms.prototype.failICE=!1,Ms.prototype.removeTcpCandidates=!1,Ms.prototype.removeUdpCandidates=!1,Ms.prototype.addMlineForNewLocalSource=function(e){const t=this.media.length,n=Ps.parse(this.raw),i=Ss()(n.media.find((t=>t.type===e)));i.mid=t,i.direction=As.RECVONLY,i.msid=void 0,i.ssrcs=void 0,i.ssrcGroups=void 0,n.media=n.media.concat(i),n.groups.forEach((e=>{if("BUNDLE"===e.type){const n=e.mids.split(" ");n.push(t),e.mids=n.join(" ")}})),this.raw=Ps.write(n)},Ms.prototype.getMediaSsrcMap=function(){const e={};for(let t=0;t<this.media.length;t++){const n={mediaindex:t,mid:Ns.parseMID(Ns.findLine(this.media[t],"a=mid:")),ssrcs:{},ssrcGroups:[]};e[t]=n,Ns.findLines(this.media[t],"a=ssrc:").forEach((e=>{const t=e.substring(7).split(" ")[0];n.ssrcs[t]||(n.ssrcs[t]={ssrc:t,lines:[]}),n.ssrcs[t].lines.push(e)})),Ns.findLines(this.media[t],"a=ssrc-group:").forEach((e=>{const t=e.indexOf(" "),i=e.substr(0,t).substr(13),r=e.substr(14+i.length).split(" ");r.length&&n.ssrcGroups.push({semantics:i,ssrcs:r})}))}return e},Ms.prototype.containsSSRC=function(e){const t=this.getMediaSsrcMap();let n=!1;return Object.keys(t).forEach((i=>{n||t[i].ssrcs[e]&&(n=!0)})),n},Ms.prototype.toJingle=function(e,t){Ns.findLines(this.session,"a=group:").forEach((t=>{const n=t.split(" "),i=n.shift().substr(8);e.c("group",{xmlns:"urn:xmpp:jingle:apps:grouping:0",semantics:i});for(let t=0;t<n.length;t++)e.c("content",{name:n[t]}).up();e.up()}));for(let n=0;n<this.media.length;n++){const i=Ns.parseMLine(this.media[n].split("\\r\\n")[0]);if("audio"!==i.media&&"video"!==i.media&&"application"!==i.media)continue;let r;const o=Ns.findLine(this.media[n],"a=ssrc:");r=!!o&&o.substring(7).split(" ")[0],e.c("content",{creator:t,name:i.media});const s=Ns.findLine(this.media[n],"a=mid:");if(s){const t=Ns.parseMID(s);e.attrs({name:t})}if("video"===i.media&&"number"==typeof this.initialLastN&&e.c("initial-last-n",{xmlns:"jitsi:colibri2",value:this.initialLastN}).up(),"audio"===i.media||"video"===i.media){e.c("description",{xmlns:"urn:xmpp:jingle:apps:rtp:1",media:i.media}),r&&e.attrs({ssrc:r});for(let t=0;t<i.fmt.length;t++){const r=Ns.findLine(this.media[n],`a=rtpmap:${i.fmt[t]}`);e.c("payload-type",Ns.parseRTPMap(r));const o=Ns.findLine(this.media[n],`a=fmtp:${i.fmt[t]}`);if(o){const t=Ns.parseFmtp(o);for(let n=0;n<t.length;n++)e.c("parameter",t[n]).up()}this.rtcpFbToJingle(n,e,i.fmt[t]),e.up()}if(r){const t=Ns.parseSSRC(this.media[n]);for(const[n,i]of t){const t=Ns.parseSourceNameLine(i),r=Ns.parseVideoTypeLine(i);e.c("source",{ssrc:n,name:t,videoType:r,xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"});const o=Ns.parseMSIDAttribute(i);o&&(e.c("parameter"),e.attrs({name:"msid"}),e.attrs({value:o}),e.up()),e.up()}Ns.findLines(this.media[n],"a=ssrc-group:").forEach((t=>{const n=t.indexOf(" "),i=t.substr(0,n).substr(13),r=t.substr(14+i.length).split(" ");r.length&&(e.c("ssrc-group",{semantics:i,xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"}),r.forEach((t=>e.c("source",{ssrc:t}).up())),e.up())}))}const t=Ns.findLines(this.media[n],"a=rid:");if(t.length&&ci.usesRidsForSimulcast()){const i=t.map((e=>e.split(":")[1])).map((e=>e.split(" ")[0]));i.forEach((t=>{e.c("source",{rid:t,xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"}),e.up()})),Ns.findLine(this.media[n],"a=simulcast:")&&(e.c("rid-group",{semantics:"SIM",xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"}),i.forEach((t=>{e.c("source",{rid:t}).up()})),e.up())}Ns.findLine(this.media[n],"a=rtcp-mux")&&e.c("rtcp-mux").up(),this.rtcpFbToJingle(n,e,"*");const o=Ns.findLines(this.media[n],"a=extmap:",this.session);for(let t=0;t<o.length;t++){const n=Ns.parseExtmap(o[t]);if(e.c("rtp-hdrext",{xmlns:"urn:xmpp:jingle:apps:rtp:rtp-hdrext:0",uri:n.uri,id:n.value}),n.hasOwnProperty("direction"))switch(n.direction){case As.SENDONLY:e.attrs({senders:"responder"});break;case As.RECVONLY:e.attrs({senders:"initiator"});break;case As.SENDRECV:e.attrs({senders:"both"});break;case As.INACTIVE:e.attrs({senders:"none"})}e.up()}Ns.findLine(this.media[n],"a=extmap-allow-mixed",this.session)&&(e.c("extmap-allow-mixed",{xmlns:"urn:xmpp:jingle:apps:rtp:rtp-hdrext:0"}),e.up()),e.up()}this.transportToJingle(n,e);const a=this.media[n];Ns.findLine(a,`a=${As.SENDRECV}`)?e.attrs({senders:"both"}):Ns.findLine(a,`a=${As.SENDONLY}`)?e.attrs({senders:"initiator"}):Ns.findLine(a,`a=${As.RECVONLY}`)?e.attrs({senders:"responder"}):Ns.findLine(a,`a=${As.INACTIVE}`)&&e.attrs({senders:"none"}),"0"!==i.port||Ns.findLine(a,"a=bundle-only",this.session)||e.attrs({senders:"rejected"}),e.up()}return e.up(),e},Ms.prototype.transportToJingle=function(e,t){t.c("transport");const n=Ns.findLine(this.media[e],"a=sctp-port:",this.session),i=Ns.findLine(this.media[e],"a=sctpmap:",this.session);if(n){const e=Ns.parseSCTPPort(n);t.c("sctpmap",{xmlns:"urn:xmpp:jingle:transports:dtls-sctp:1",number:e,protocol:"webrtc-datachannel"}),t.attrs({streams:0}),t.up()}else if(i){const e=Ns.parseSCTPMap(i);t.c("sctpmap",{xmlns:"urn:xmpp:jingle:transports:dtls-sctp:1",number:e[0],protocol:e[1]}),e.length>2?t.attrs({streams:e[2]}):t.attrs({streams:0}),t.up()}Ns.findLines(this.media[e],"a=fingerprint:",this.session).forEach((n=>{const i=Ns.parseFingerprint(n);i.xmlns="urn:xmpp:jingle:apps:dtls:0",t.c("fingerprint").t(i.fingerprint),delete i.fingerprint;const r=Ns.findLine(this.media[e],"a=setup:",this.session);r&&(i.setup=r.substr(8)),t.attrs(i),t.up()}));const r=Ns.iceparams(this.media[e],this.session);r&&(r.xmlns="urn:xmpp:jingle:transports:ice-udp:1",t.attrs(r),Ns.findLines(this.media[e],"a=candidate:",this.session).forEach((e=>{const n=Ns.candidateToJingle(e);this.failICE&&(n.ip="1.1.1.1");const i=n&&"string"==typeof n.protocol?n.protocol.toLowerCase():"";this.removeTcpCandidates&&("tcp"===i||"ssltcp"===i)||this.removeUdpCandidates&&"udp"===i||t.c("candidate",n).up()}))),t.up()},Ms.prototype.rtcpFbToJingle=function(e,t,n){Ns.findLines(this.media[e],`a=rtcp-fb:${n}`).forEach((e=>{const n=Ns.parseRTCPFB(e);"trr-int"===n.type?(t.c("rtcp-fb-trr-int",{xmlns:"urn:xmpp:jingle:apps:rtp:rtcp-fb:0",value:n.params[0]}),t.up()):(t.c("rtcp-fb",{xmlns:"urn:xmpp:jingle:apps:rtp:rtcp-fb:0",type:n.type}),n.params.length>0&&t.attrs({subtype:n.params[0]}),t.up())}))},Ms.prototype.rtcpFbFromJingle=function(e,t){let n="";const i=e.find(\'>rtcp-fb-trr-int[xmlns="urn:xmpp:jingle:apps:rtp:rtcp-fb:0"]\');return i.length&&(n+="a=rtcp-fb:* trr-int ",i.attr("value")?n+=i.attr("value"):n+="0",n+="\\r\\n"),e.find(\'>rtcp-fb[xmlns="urn:xmpp:jingle:apps:rtp:rtcp-fb:0"]\').each(((e,i)=>{n+=`a=rtcp-fb:${t} ${i.getAttribute("type")}`,i.hasAttribute("subtype")&&(n+=` ${i.getAttribute("subtype")}`),n+="\\r\\n"})),n},Ms.prototype.fromJingle=function(e){const t=Date.now();this.raw=`v=0\\r\\no=- ${t} 2 IN IP4 0.0.0.0\\r\\ns=-\\r\\nt=0 0\\r\\n`;const n=_t()(e).find(\'>group[xmlns="urn:xmpp:jingle:apps:grouping:0"]\');n.length&&n.each(((e,t)=>{const n=_t()(t).find(">content").map(((e,t)=>t.getAttribute("name"))).get();n.length>0&&(this.raw+=`a=group:${t.getAttribute("semantics")||t.getAttribute("type")} ${n.join(" ")}\\r\\n`)})),this.session=this.raw,e.find(">content").each(((e,t)=>{const n=this.jingle2media(_t()(t));this.media.push(n)})),this.raw=this.session+this.media.join("")},Ms.prototype.jingle2media=function(e){const t=e.find(">description"),n=e.find(\'>transport[xmlns="urn:xmpp:jingle:transports:ice-udp:1"]\');let i="";const r=n.find(\'>sctpmap[xmlns="urn:xmpp:jingle:transports:dtls-sctp:1"]\'),o={media:t.attr("media"),port:"9"};switch("rejected"===e.attr("senders")&&(o.port="0"),n.find(\'>fingerprint[xmlns="urn:xmpp:jingle:apps:dtls:0"]\').length?o.proto=r.length?"UDP/DTLS/SCTP":"UDP/TLS/RTP/SAVPF":o.proto="UDP/TLS/RTP/SAVPF",r.length?(i+=`m=application ${o.port} UDP/DTLS/SCTP webrtc-datachannel\\r\\n`,i+=`a=sctp-port:${r.attr("number")}\\r\\n`,i+="a=max-message-size:262144\\r\\n"):(o.fmt=t.find(">payload-type").map(((e,t)=>t.getAttribute("id"))).get(),i+=`${Ns.buildMLine(o)}\\r\\n`),i+="c=IN IP4 0.0.0.0\\r\\n",r.length||(i+="a=rtcp:1 IN IP4 0.0.0.0\\r\\n"),n.length&&(n.attr("ufrag")&&(i+=`${Ns.buildICEUfrag(n.attr("ufrag"))}\\r\\n`),n.attr("pwd")&&(i+=`${Ns.buildICEPwd(n.attr("pwd"))}\\r\\n`),n.find(\'>fingerprint[xmlns="urn:xmpp:jingle:apps:dtls:0"]\').each(((e,t)=>{i+=`a=fingerprint:${t.getAttribute("hash")}`,i+=` ${_t()(t).text()}`,i+="\\r\\n",t.hasAttribute("setup")&&(i+=`a=setup:${t.getAttribute("setup")}\\r\\n`)}))),n.find(">candidate").each(((e,t)=>{let n=t.getAttribute("protocol");n="string"==typeof n?n.toLowerCase():"",this.removeTcpCandidates&&("tcp"===n||"ssltcp"===n)||this.removeUdpCandidates&&"udp"===n||(this.failICE&&t.setAttribute("ip","1.1.1.1"),i+=Ns.candidateFromJingle(t))})),e.attr("senders")){case"initiator":i+=`a=${As.SENDONLY}\\r\\n`;break;case"responder":i+=`a=${As.RECVONLY}\\r\\n`;break;case"none":i+=`a=${As.INACTIVE}\\r\\n`;break;case"both":i+=`a=${As.SENDRECV}\\r\\n`}i+=`a=mid:${e.attr("name")}\\r\\n`,t.find(">rtcp-mux").length&&(i+="a=rtcp-mux\\r\\n"),t.find(">payload-type").each(((e,t)=>{i+=`${Ns.buildRTPMap(t)}\\r\\n`,_t()(t).find(">parameter").length&&(i+=`a=fmtp:${t.getAttribute("id")} `,i+=_t()(t).find(">parameter").map(((e,t)=>{const n=t.getAttribute("name");return(n?`${n}=`:"")+t.getAttribute("value")})).get().join(";"),i+="\\r\\n"),i+=this.rtcpFbFromJingle(_t()(t),t.getAttribute("id"))})),i+=this.rtcpFbFromJingle(t,"*"),t.find(\'>rtp-hdrext[xmlns="urn:xmpp:jingle:apps:rtp:rtp-hdrext:0"]\').each(((e,t)=>{i+=`a=extmap:${t.getAttribute("id")} ${t.getAttribute("uri")}\\r\\n`})),t.find(\'>extmap-allow-mixed[xmlns="urn:xmpp:jingle:apps:rtp:rtp-hdrext:0"]\').length>0&&(i+="a=extmap-allow-mixed\\r\\n"),t.find(\'>ssrc-group[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each(((e,t)=>{const n=t.getAttribute("semantics"),r=_t()(t).find(">source").map(((e,t)=>t.getAttribute("ssrc"))).get();r.length&&(i+=`a=ssrc-group:${n} ${r.join(" ")}\\r\\n`)}));let s="",a="";return t.find(\'>source[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each(((e,t)=>{const n=t.getAttribute("ssrc");let i=!0,r="";_t()(t).find(">parameter").each(((e,t)=>{var o;const s=t.getAttribute("name");let a=t.getAttribute("value");a=Ns.filterSpecialChars(a),r+=`a=ssrc:${n} ${s}`,a&&a.length&&(r+=`:${a}`),r+="\\r\\n",null!==(o=a)&&void 0!==o&&o.includes("mixedmslabel")&&(i=!1)})),i?s+=r:a+=r})),i+=a+s,i},Fs.prototype.getNewMedia=function(){const e=this.mySDP.getMediaSsrcMap(),t=this.otherSDP.getMediaSsrcMap(),n={};return Object.keys(t).forEach((i=>{const r=e[i],o=t[i];r||!o?(Object.keys(o.ssrcs).forEach((e=>{(-1===Object.keys(r.ssrcs).indexOf(e)||o.ssrcs[e].lines&&r.ssrcs[e].lines&&void 0!==r.ssrcs[e].lines.find((e=>-1!==e.indexOf("msid")))!=(void 0!==o.ssrcs[e].lines.find((e=>-1!==e.indexOf("msid")))))&&(n[i]||(n[i]={mediaindex:o.mediaindex,mid:o.mid,ssrcs:{},ssrcGroups:[]}),n[i].ssrcs[e]=o.ssrcs[e])})),o.ssrcGroups.forEach((e=>{let t=!1;for(let n=0;n<r.ssrcGroups.length;n++){const i=r.ssrcGroups[n];if(e.semantics===i.semantics&&Ls(e.ssrcs,i.ssrcs)){t=!0;break}}t||(n[i]||(n[i]={mediaindex:o.mediaindex,mid:o.mid,ssrcs:{},ssrcGroups:[]}),n[i].ssrcGroups.push(e))}))):n[i]=o})),n},Fs.prototype.toJingle=function(e){const t=this.getNewMedia();let n=!1;return Object.keys(t).forEach((i=>{n=!0;const r=t[i];e.c("content",{name:r.mid}),e.c("description",{xmlns:"urn:xmpp:jingle:apps:rtp:1",media:r.mid}),Object.keys(r.ssrcs).forEach((t=>{const n=r.ssrcs[t],i=n.lines,o=Ns.parseSourceNameLine(i),s=Ns.parseVideoTypeLine(i);e.c("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"}),e.attrs({name:o,videoType:s,ssrc:n.ssrc});const a=Ns.parseMSIDAttribute(i);a&&(e.c("parameter"),e.attrs({name:"msid"}),e.attrs({value:a}),e.up()),e.up()})),r.ssrcGroups.forEach((t=>{t.ssrcs.length&&(e.c("ssrc-group",{semantics:t.semantics,xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"}),t.ssrcs.forEach((t=>{e.c("source",{ssrc:t}).up()})),e.up())})),e.up(),e.up()})),n};var Vs,Us="function"==typeof queueMicrotask&&queueMicrotask,Hs="function"==typeof setImmediate&&setImmediate,$s="object"==typeof process&&"function"==typeof process.nextTick;Vs=Us?queueMicrotask:Hs?setImmediate:$s?process.nextTick:function(e){setTimeout(e,0)};const Js=(Bs=Vs,function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];return Bs((()=>e(...n)))});var Bs;class qs{constructor(){this.head=this.tail=null,this.length=0}removeLink(e){return e.prev?e.prev.next=e.next:this.head=e.next,e.next?e.next.prev=e.prev:this.tail=e.prev,e.prev=e.next=null,this.length-=1,e}empty(){for(;this.head;)this.shift();return this}insertAfter(e,t){t.prev=e,t.next=e.next,e.next?e.next.prev=t:this.tail=t,e.next=t,this.length+=1}insertBefore(e,t){t.prev=e.prev,t.next=e,e.prev?e.prev.next=t:this.head=t,e.prev=t,this.length+=1}unshift(e){this.head?this.insertBefore(this.head,e):Gs(this,e)}push(e){this.tail?this.insertAfter(this.tail,e):Gs(this,e)}shift(){return this.head&&this.removeLink(this.head)}pop(){return this.tail&&this.removeLink(this.tail)}toArray(){return[...this]}*[Symbol.iterator](){for(var e=this.head;e;)yield e.data,e=e.next}remove(e){for(var t=this.head;t;){var{next:n}=t;e(t)&&this.removeLink(t),t=n}return this}}function Gs(e,t){e.length=1,e.head=e.tail=t}function zs(e,t){return e.then((e=>{Ks(t,null,e)}),(e=>{Ks(t,e&&e.message?e:new Error(e))}))}function Ks(e,t,n){try{e(t,n)}catch(e){Js((e=>{throw e}),e)}}function Ws(e){return"AsyncFunction"===e[Symbol.toStringTag]}const Xs=function(e){if("function"!=typeof e)throw new Error("expected a function");return Ws(e)?Ws(t=e)?function(){for(var e=arguments.length,n=new Array(e),i=0;i<e;i++)n[i]=arguments[i];const r=n.pop();return zs(t.apply(this,n),r)}:(n=function(e,n){var i;try{i=t.apply(this,e)}catch(e){return n(e)}if(i&&"function"==typeof i.then)return zs(i,n);n(null,i)},function(){for(var e=arguments.length,t=new Array(e),i=0;i<e;i++)t[i]=arguments[i];var r=t.pop();return n.call(this,t,r)}):e;var t,n};function Ys(e,t,n){if(null==t)t=1;else if(0===t)throw new RangeError("Concurrency must not be zero");var i=Xs(e),r=0,o=[];const s={error:[],drain:[],saturated:[],unsaturated:[],empty:[]};function a(e,t){return e?t?void(s[e]=s[e].filter((e=>e!==t))):s[e]=[]:Object.keys(s).forEach((e=>s[e]=[]))}function d(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];s[e].forEach((e=>e(...n)))}var c=!1;function l(e,t,n,i){if(null!=i&&"function"!=typeof i)throw new Error("task callback must be a function");var r,o;function s(e){if(e)return n?o(e):r();for(var t=arguments.length,i=new Array(t>1?t-1:0),s=1;s<t;s++)i[s-1]=arguments[s];if(i.length<=1)return r(i[0]);r(i)}g.started=!0;var a=g._createTaskItem(e,n?s:i||s);if(t?g._tasks.unshift(a):g._tasks.push(a),c||(c=!0,Js((()=>{c=!1,g.process()}))),n||!i)return new Promise(((e,t)=>{r=e,o=t}))}function h(e){return function(t){r-=1;for(var n=arguments.length,i=new Array(n>1?n-1:0),s=1;s<n;s++)i[s-1]=arguments[s];for(var a=0,c=e.length;a<c;a++){var l=e[a],h=o.indexOf(l);0===h?o.shift():h>0&&o.splice(h,1),l.callback(t,...i),null!=t&&d("error",t,l.data)}r<=g.concurrency-g.buffer&&d("unsaturated"),g.idle()&&d("drain"),g.process()}}function u(e){return!(0!==e.length||!g.idle()||(Js((()=>d("drain"))),0))}const p=e=>t=>{if(!t)return new Promise(((t,n)=>{!function(e,i){const r=function(){a(e,r),((e,i)=>{if(e)return n(e);t(i)})(...arguments)};s[e].push(r)}(e)}));a(e),function(e,t){s[e].push(t)}(e,t)};var m=!1,g={_tasks:new qs,_createTaskItem:(e,t)=>({data:e,callback:t}),*[Symbol.iterator](){yield*g._tasks[Symbol.iterator]()},concurrency:t,payload:n,buffer:t/4,started:!1,paused:!1,push(e,t){if(Array.isArray(e)){if(u(e))return;return e.map((e=>l(e,!1,!1,t)))}return l(e,!1,!1,t)},pushAsync(e,t){if(Array.isArray(e)){if(u(e))return;return e.map((e=>l(e,!1,!0,t)))}return l(e,!1,!0,t)},kill(){a(),g._tasks.empty()},unshift(e,t){if(Array.isArray(e)){if(u(e))return;return e.map((e=>l(e,!0,!1,t)))}return l(e,!0,!1,t)},unshiftAsync(e,t){if(Array.isArray(e)){if(u(e))return;return e.map((e=>l(e,!0,!0,t)))}return l(e,!0,!0,t)},remove(e){g._tasks.remove(e)},process(){if(!m){for(m=!0;!g.paused&&r<g.concurrency&&g._tasks.length;){var e=[],t=[],n=g._tasks.length;g.payload&&(n=Math.min(n,g.payload));for(var s=0;s<n;s++){var a=g._tasks.shift();e.push(a),o.push(a),t.push(a.data)}r+=1,0===g._tasks.length&&d("empty"),r===g.concurrency&&d("saturated");var c=js(h(e));i(t,c)}m=!1}},length:()=>g._tasks.length,running:()=>r,workersList:()=>o,idle:()=>g._tasks.length+r===0,pause(){g.paused=!0},resume(){!1!==g.paused&&(g.paused=!1,Js(g.process))}};return Object.defineProperties(g,{saturated:{writable:!1,value:p("saturated")},unsaturated:{writable:!1,value:p("unsaturated")},empty:{writable:!1,value:p("empty")},drain:{writable:!1,value:p("drain")},error:{writable:!1,value:p("error")}}),g}const Qs=(0,E.getLogger)("modules/util/AsyncQueue.js");class Zs extends Error{constructor(e){super(e),this.name="ClearedQueueError"}}class ea{constructor(){var e,t;this._queue=(e=this._processQueueTasks.bind(this),1,t=Xs(e),Ys(((e,n)=>{t(e[0],n)}),1,1)),this._stopped=!1,this._taskCallbacks=new Map}clear(){for(const e of this._taskCallbacks.values())try{null==e||e(new Zs("The queue has been cleared"))}catch(e){Qs.error("Error in callback while clearing the queue:",e)}this._queue.kill()}_processQueueTasks(e,t){try{e(t)}catch(e){Qs.error(`Task failed: ${null==e?void 0:e.stack}`),t(e)}finally{this._taskCallbacks.delete(e)}}pause(){this._queue.pause()}push(e,t){this._stopped?t&&t(new Error("The queue has been stopped")):(this._taskCallbacks.set(e,t),this._queue.push(e,t))}resume(){this._queue.resume()}shutdown(){this._stopped=!0}}let ta;!function(e){e.PENDING="pending",e.ACTIVE="active",e.ENDED="ended"}(ta||(ta={}));const na=ta.PENDING,ia=ta.ACTIVE,ra=ta.ENDED,oa=(0,E.getLogger)("modules/xmpp/JingleSession.js");class sa extends xr{constructor(e,t,n,i,r,o,s){super(),this.sid=e,this.localJid=t,this.remoteJid=n,this.connection=i,this.mediaConstraints=r,this.pcConfig=o,this.isInitiator=s,this.usedrip=!0,this.dripContainer=[],this.room=null,this._signalingLayer=null,this.state=null,this.rtc=null}get initiatorJid(){return this.isInitiator?this.localJid:this.remoteJid}get responderJid(){return this.isInitiator?this.remoteJid:this.localJid}initialize(e,t,n,i){if(null!==this.state){const e=`attempt to initiate on session ${this.sid}\\n                   in state ${this.state}`;throw oa.error(e),new Error(e)}this.room=e,this.rtc=t,this._signalingLayer=n,this.state=na,this.doInitialize(i)}doInitialize(e){}addIceCandidates(e){}getState(){return this.state}addSources(e){}removeSources(e){}terminate(e,t,n){}acceptOffer(e,t,n){}}var aa;!function(e){e.REMOTE_SOURCE_CONSTRAINTS_CHANGED="media_session.REMOTE_SOURCE_CONSTRAINTS_CHANGED"}(aa||(aa={}));const da=aa,ca=(0,E.getLogger)("modules/xmpp/JingleSessionPC.js"),la=1e4;function ha(e,t,n,i){e.c("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",ssrc:n,name:t.source}).c("parameter",{name:"msid",value:i}).up().c("ssrc-info",{xmlns:"http://jitsi.org/jitmeet",owner:t.owner}).up().up()}class ua extends sa{static parseVideoSenders(e){const t=e.find(\'>content[name="video"]\');if(t.length){const e=t[0].getAttribute("senders");if("both"===e||"initiator"===e||"responder"===e||"none"===e)return e}return null}static parseSourceMaxFrameHeight(e){const t=[],n=e.find(\'>content[name="video"]>source-frame-height\');let i,r;return n.length?(n.each(((e,n)=>{r=n.getAttribute("sourceName"),i=n.getAttribute("maxHeight"),t.push({maxHeight:i,sourceName:r})})),t):null}constructor(e,t,n,i,r,o,s,a){super(e,t,n,i,r,o,a),this._bridgeSessionId=null,this._cachedOldLocalSdp=void 0,this._cachedNewLocalSdp=void 0,this._iceCheckingStartedTimestamp=null,this._gatheringStartedTimestamp=null,this._sourceReceiverConstraints=void 0,this._localSendReceiveVideoActive=!0,this._remoteSendReceiveVideoActive=!0,this._gatheringReported=!1,this.lasticecandidate=!1,this.closed=!1,this.isP2P=s,this.remoteRecvMaxFrameHeight=void 0,this.numRemoteVideoSources=0,this.numRemoteAudioSources=0,this.remoteSourceMaxFrameHeights=void 0,this.modificationQueue=new ea,this.modificationQueue.pause(),this.wasConnected=!1,this.establishmentDuration=void 0,this._xmppListeners=[],this._xmppListeners.push(i.addCancellableListener(Lo.Events.CONN_STATUS_CHANGED,this.onXmppStatusChanged.bind(this))),this._removeSenderVideoConstraintsChangeListener=void 0}_assertNotEnded(){return this.state!==ra}doInitialize(e){this.failICE=Boolean(e.failICE),this.lasticecandidate=!1,this.options=e,this.isReconnect=!1,this.wasstable=!1,this.webrtcIceUdpDisable=Boolean(e.webrtcIceUdpDisable),this.webrtcIceTcpDisable=Boolean(e.webrtcIceTcpDisable);const t={disableRtx:e.disableRtx};if(e.gatherStats&&(t.maxstats=300),t.capScreenshareBitrate=!1,t.codecSettings=e.codecSettings,t.enableInsertableStreams=e.enableInsertableStreams,e.videoQuality){const n=Object.entries(e.videoQuality).map((e=>(e[0]=e[0].toLowerCase(),e)));t.videoQuality=Object.fromEntries(n)}var n;t.forceTurnRelay=e.forceTurnRelay,t.audioQuality=e.audioQuality,t.disableSimulcast=!!this.isP2P||e.disableSimulcast,this.isP2P||(t.capScreenshareBitrate=!((null===(n=e.desktopSharingFrameRate)||void 0===n?void 0:n.max)>5)),e.startSilent&&(t.startSilent=!0),this.peerconnection=this.rtc.createPeerConnection(this._signalingLayer,this.pcConfig,this.isP2P,t),this.peerconnection.onicecandidate=e=>{if(!e)return;const t=e.candidate,n=window.performance.now();if(t){null===this._gatheringStartedTimestamp&&(this._gatheringStartedTimestamp=n);let e=t.protocol;if("string"==typeof e)if(e=e.toLowerCase(),"tcp"===e||"ssltcp"===e){if(this.webrtcIceTcpDisable)return}else if("udp"===e&&this.webrtcIceUdpDisable)return}else this._gatheringReported||(Mi.sendAnalytics(Qt,{phase:"gathering",value:n-this._gatheringStartedTimestamp,p2p:this.isP2P,initiator:this.isInitiator}),this._gatheringReported=!0);this.isP2P&&this.sendIceCandidate(t)},this.peerconnection.onsignalingstatechange=()=>{"stable"===this.peerconnection.signalingState?this.wasstable=!0:"closed"!==this.peerconnection.signalingState&&"closed"!==this.peerconnection.connectionState||this.room.eventEmitter.emit(Hi.XMPPEvents.SUSPEND_DETECTED,this)},this.peerconnection.oniceconnectionstatechange=()=>{const e=window.performance.now();let t=!1;switch(this.isP2P||(this.room.connectionTimes[`ice.state.${this.peerconnection.iceConnectionState}`]=e),ca.log(`(TIME) ICE ${this.peerconnection.iceConnectionState} ${this.isP2P?"P2P":"JVB"}:\\t`,e),Mi.sendAnalytics(en,{p2p:this.isP2P,state:this.peerconnection.iceConnectionState,signaling_state:this.peerconnection.signalingState,reconnect:this.isReconnect,value:e}),this.room.eventEmitter.emit(Hi.XMPPEvents.ICE_CONNECTION_STATE_CHANGED,this,this.peerconnection.iceConnectionState),this.peerconnection.iceConnectionState){case"checking":this._iceCheckingStartedTimestamp=e;break;case"connected":if("stable"===this.peerconnection.signalingState){t=!0;const e=!this.options.enableIceRestart&&this.room.supportsRestartByTerminate();(this.isReconnect||e)&&this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_RESTORED,this)}if(!this.wasConnected&&(this.wasstable||t||this.isInitiator&&(ci.isChromiumBased()||ci.isReactNative()))){Mi.sendAnalytics(Qt,{phase:"checking",value:e-this._iceCheckingStartedTimestamp,p2p:this.isP2P,initiator:this.isInitiator});const t=Math.min(this._iceCheckingStartedTimestamp,this._gatheringStartedTimestamp);this.establishmentDuration=e-t,Mi.sendAnalytics(Qt,{phase:"establishment",value:this.establishmentDuration,p2p:this.isP2P,initiator:this.isInitiator}),this.wasConnected=!0,this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_ESTABLISHED,this)}this.isReconnect=!1;break;case"disconnected":this.isReconnect=!0,this.wasstable&&this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_INTERRUPTED,this);break;case"failed":this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_ICE_FAILED,this)}},this.peerconnection.onconnectionstatechange=()=>{const e=this.peerconnection.iceConnectionState;"failed"===this.peerconnection.connectionState&&"disconnected"===e&&this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_ICE_FAILED,this)},this.peerconnection.onnegotiationneeded=()=>{const e=this.peerconnection.signalingState,t=this.peerconnection.remoteDescription;if(!this.isP2P&&"stable"===e&&t&&"string"==typeof t.sdp){ca.info(`${this} onnegotiationneeded fired on ${this.peerconnection}`);const e=e=>{this._renegotiate().then((()=>this.peerconnection.configureAudioSenderEncodings())).then((()=>e()),(t=>e(t)))};this.modificationQueue.push(e,(e=>{e?ca.error(`${this} onnegotiationneeded error`,e):ca.debug(`${this} onnegotiationneeded executed - OK`)}))}}}getRemoteRecvMaxFrameHeight(){if(this.isP2P)return this.remoteRecvMaxFrameHeight}getRemoteSourcesRecvMaxFrameHeight(){if(this.isP2P)return this.remoteSourceMaxFrameHeights}sendIceCandidate(e){const t=new Ms(this.peerconnection.localDescription.sdp);if(e&&e.candidate.length&&!this.lasticecandidate){const n=Ns.iceparams(t.media[e.sdpMLineIndex],t.session),i=Ns.candidateToJingle(e.candidate);if(!n||!i)return void ca.error("failed to get ice && jcand");n.xmlns="urn:xmpp:jingle:transports:ice-udp:1",this.usedrip?(0===this.dripContainer.length&&setTimeout((()=>{0!==this.dripContainer.length&&(this.sendIceCandidates(this.dripContainer),this.dripContainer=[])}),150),this.dripContainer.push(e)):this.sendIceCandidates([e])}else ca.log(`${this} sendIceCandidate: last candidate`),this.lasticecandidate=!0}sendIceCandidates(e){if(!this._assertNotEnded("sendIceCandidates"))return;ca.log(`${this} sendIceCandidates ${JSON.stringify(e)}`);const t=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"transport-info",initiator:this.initiatorJid,sid:this.sid}),n=new Ms(this.peerconnection.localDescription.sdp);for(let i=0;i<n.media.length;i++){const r=e.filter((e=>e.sdpMLineIndex===i)),o=Ns.parseMLine(n.media[i].split("\\r\\n")[0]);if(r.length>0){const e=Ns.iceparams(n.media[i],n.session);e.xmlns="urn:xmpp:jingle:transports:ice-udp:1",t.c("content",{creator:this.initiatorJid===this.localJid?"initiator":"responder",name:r[0].sdpMid?r[0].sdpMid:o.media}).c("transport",e);for(let e=0;e<r.length;e++){const n=Ns.candidateToJingle(r[e].candidate);this.failICE&&(n.ip="1.1.1.1"),t.c("candidate",n).up()}const s=Ns.findLine(n.media[i],"a=fingerprint:",n.session);if(s){const e=Ns.parseFingerprint(s);e.required=!0,t.c("fingerprint",{xmlns:"urn:xmpp:jingle:apps:dtls:0"}).t(e.fingerprint),delete e.fingerprint,t.attrs(e),t.up()}t.up(),t.up()}}this.connection.sendIQ(t,null,this.newJingleErrorHandler(t),la)}sendIceFailedNotification(){const e=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"session-info",initiator:this.initiatorJid,sid:this.sid}).c("ice-state",{xmlns:"http://jitsi.org/protocol/focus"}).t("failed").up();this._bridgeSessionId&&e.c("bridge-session",{xmlns:"http://jitsi.org/protocol/focus",id:this._bridgeSessionId}),this.connection.sendIQ2(e,{timeout:65}).catch(this.newJingleErrorHandler(e))}addIceCandidates(e){if("closed"===this.peerconnection.signalingState)return void ca.warn(`${this} Ignored add ICE candidate when in closed state`);const t=[];e.find(">content>transport>candidate").each(((e,n)=>{let i=Ns.candidateFromJingle(n);i=i.replace("\\r\\n","").replace("a=","");const r=new RTCIceCandidate({sdpMLineIndex:0,sdpMid:"",candidate:i});t.push(r)})),t.length?(ca.debug(`${this} Queued add (${t.length}) ICE candidates task`),this.modificationQueue.push((e=>{for(const e of t)this.peerconnection.addIceCandidate(e).then((()=>ca.debug(`${this} addIceCandidate ok!`)),(e=>ca.error(`${this} addIceCandidate failed!`,e)));e(),ca.debug(`${this} ICE candidates task finished`)}))):ca.error(`${this} No ICE candidates to add ?`,e[0]&&e[0].outerHTML)}readSsrcInfo(e){_t()(e).find(\'>description>source[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each(((e,t)=>{const n=Number(t.getAttribute("ssrc"));let i;t.hasAttribute("name")&&(i=t.getAttribute("name")),this.isP2P?this._signalingLayer.setSSRCOwner(n,St.Strophe.getResourceFromJid(this.remoteJid),i):_t()(t).find(\'>ssrc-info[xmlns="http://jitsi.org/jitmeet"]\').each(((e,t)=>{const r=t.getAttribute("owner");var o;null!=r&&r.length&&(isNaN(n)||n<0?ca.warn(`${this} Invalid SSRC ${n} value received for ${r}`):this._signalingLayer.setSSRCOwner(n,(o=r,St.Strophe.getResourceFromJid(o)||o),i))}))}))}acceptOffer(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[];this.setOfferAnswerCycle(e,(()=>{this.sendSessionAccept((()=>{ca.debug(`${this} Resuming the modification queue after session is established!`),this.modificationQueue.resume(),t(),this.room.eventEmitter.emit(Hi.XMPPEvents.SESSION_ACCEPT,this);const e=i.filter((e=>e.getType()===Ri.VIDEO));e.length&&e.splice(0,1),e.length&&this.addTracks(e)}),(e=>{n(e),this.room.eventEmitter.emit(Hi.XMPPEvents.SESSION_ACCEPT_ERROR,this,e)}))}),n,i)}invite(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];if(!this.isInitiator)throw new Error("Trying to invite from the responder session");ca.debug(`${this} Executing invite task`);const t=[];for(const n of e)t.push(this.peerconnection.addTrack(n,this.isInitiator));Promise.all(t).then((()=>this.peerconnection.createOffer(this.mediaConstraints))).then((e=>this.peerconnection.setLocalDescription(e))).then((()=>{this.peerconnection.processLocalSdpForTransceiverInfo(e),this.sendSessionInitiate(this.peerconnection.localDescription.sdp)})).then((()=>{ca.debug(`${this} invite executed - OK`)})).catch((e=>{ca.error(`${this} invite error`,e)}))}sendSessionInitiate(e){let t=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"session-initiate",initiator:this.initiatorJid,sid:this.sid});new Ms(e).toJingle(t,this.isInitiator?"initiator":"responder"),t=t.tree(),ca.debug(`${this} Session-initiate: `,t),this.connection.sendIQ(t,(()=>{ca.info(`${this} Got RESULT for "session-initiate"`)}),(e=>{ca.error(`${this} "session-initiate" error`,e)}),la)}setAnswer(e){if(!this.isInitiator)throw new Error("Trying to set an answer on the responder session");ca.debug(`${this} Executing setAnswer task`);const t=this._processNewJingleOfferIq(e),n=new Ms(this.peerconnection.localDescription.sdp),i=new RTCSessionDescription({type:"answer",sdp:t.raw});this.peerconnection.setRemoteDescription(i).then((()=>{if(this.state===na){this.state=ia,ca.debug(`${this} Resuming the modification queue after session is established!`),this.modificationQueue.resume();const e=new Ms(this.peerconnection.localDescription.sdp);this.sendContentModify(),this.notifyMySSRCUpdate(n,e)}})).then((()=>{ca.debug(`${this} setAnswer task done`)})).catch((e=>{ca.error(`${this} setAnswer task failed: ${e}`)}))}setOfferAnswerCycle(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[];ca.debug(`${this} Executing setOfferAnswerCycle task`);const r=[],o=i.filter((e=>e.getType()===Ri.AUDIO)),s=i.filter((e=>e.getType()===Ri.VIDEO));let a=i;s.length>1&&(a=[...o,s[0]]);for(const e of a)r.push(this.peerconnection.addTrack(e,this.isInitiator));const d=this._processNewJingleOfferIq(e),c=_t()(e).find(\'>bridge-session[xmlns="http://jitsi.org/protocol/focus"]\').attr("id");c!==this._bridgeSessionId&&(this._bridgeSessionId=c),Promise.all(r).then((()=>this._renegotiate(d.raw))).then((()=>{this.peerconnection.processLocalSdpForTransceiverInfo(a),this.state===na&&(this.state=ia,!this.isP2P||this._localSendReceiveVideoActive&&!this._sourceReceiverConstraints||this.sendContentModify())})).then((()=>{ca.debug(`${this} setOfferAnswerCycle task done`),t()})).catch((e=>{ca.error(`${this} setOfferAnswerCycle task failed: ${e}`),n(e)}))}setVideoCodecs(e){if(this._assertNotEnded()){ca.info(`${this} setVideoCodecs: ${e}`),this.peerconnection.setVideoCodecs(e);const t=e=>{this._renegotiate().then((()=>this.peerconnection.configureVideoSenderEncodings())).then((()=>(ca.debug(`${this} setVideoCodecs task is done`),e())),(t=>(ca.error(`${this} setVideoCodecs task failed: ${t}`),e(t))))};ca.debug(`${this} Queued setVideoCodecs task`),this.modificationQueue.push(t)}}replaceTransport(e,t,n){if(this.options.enableForcedReload){const e=new Ms(this.peerconnection.localDescription.sdp);return this.sendTransportAccept(e,t,n),void this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_RESTARTED,this)}this.room.eventEmitter.emit(Hi.XMPPEvents.ICE_RESTARTING,this);const i=e.clone();e.find(">content[name=\'data\']").attr("senders","rejected"),e.find(">content>description>source").remove(),e.find(">content>description>ssrc-group").remove();const r=e.find(">content>transport>fingerprint");r.attr("hash","sha-1"),r.text("00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00"),ca.debug(`${this} Queued ICE restart task`),this.modificationQueue.push((r=>{this.setOfferAnswerCycle(e,(()=>{this.setOfferAnswerCycle(i,(()=>{const e=new Ms(this.peerconnection.localDescription.sdp);"number"==typeof this.options.channelLastN&&this.options.channelLastN>=0&&(e.initialLastN=this.options.channelLastN),this.sendTransportAccept(e,t,n),this.room.eventEmitter.emit(Hi.XMPPEvents.ICE_RESTART_SUCCESS,this,i),r()}),(e=>r(e)))}),(e=>r(e)))}),(e=>{if(e){if(e instanceof Zs)return ca.debug(`${this} ICE restart task aborted: session terminated`),void t();ca.error(`${this} ICE restart task failed: ${e}`),n(e)}else ca.debug(`${this} ICE restart task done`),t()}))}sendSessionAccept(e,t){const n=new Ms(this.peerconnection.localDescription.sdp),i=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"session-accept",initiator:this.initiatorJid,responder:this.responderJid,sid:this.sid});this.webrtcIceTcpDisable&&(n.removeTcpCandidates=!0),this.webrtcIceUdpDisable&&(n.removeUdpCandidates=!0),this.failICE&&(n.failICE=!0),"number"==typeof this.options.channelLastN&&this.options.channelLastN>=0&&(n.initialLastN=this.options.channelLastN),n.toJingle(i,this.initiatorJid===this.localJid?"initiator":"responder"),ca.info(`${this} Sending session-accept`),ca.debug(i.tree()),this.connection.sendIQ(i,e,this.newJingleErrorHandler(i,(e=>{t(e),this.room.eventEmitter.emit(Hi.XMPPEvents.SESSION_ACCEPT_TIMEOUT,this)})),la)}sendContentModify(){const e=this._localSendReceiveVideoActive?"both":"none",t=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"content-modify",initiator:this.initiatorJid,sid:this.sid}).c("content",{name:Ri.VIDEO,senders:e});void 0!==this._sourceReceiverConstraints&&this._sourceReceiverConstraints.forEach(((e,n)=>{t.c("source-frame-height",{xmlns:"http://jitsi.org/jitmeet/video"}).attrs({sourceName:n,maxHeight:e}),t.up(),ca.info(`${this} sending content-modify for source-name: ${n}, maxHeight: ${e}`)})),ca.debug(t.tree()),this.connection.sendIQ(t,null,this.newJingleErrorHandler(t),la)}setReceiverVideoConstraint(e){ca.info(`${this} setReceiverVideoConstraint - constraints: ${JSON.stringify(e)}`),this._sourceReceiverConstraints=e,this.isP2P&&this.state===ia&&this.sendContentModify()}sendTransportAccept(e,t,n){const i=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"transport-accept",initiator:this.initiatorJid,sid:this.sid});e.media.forEach(((t,n)=>{const r=Ns.parseMLine(t.split("\\r\\n")[0]);i.c("content",{creator:this.initiatorJid===this.localJid?"initiator":"responder",name:r.media}),e.transportToJingle(n,i),i.up()})),ca.info(`${this} Sending transport-accept`),ca.debug(i.tree()),this.connection.sendIQ(i,t,this.newJingleErrorHandler(i,n),la)}sendTransportReject(e,t){const n=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"transport-reject",initiator:this.initiatorJid,sid:this.sid});ca.info(`${this} Sending \'transport-reject\'`),ca.debug(n.tree()),this.connection.sendIQ(n,e,this.newJingleErrorHandler(n,t),la)}setSenderVideoConstraint(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(this._assertNotEnded()){ca.info(`${this} setSenderVideoConstraint: ${e}, sourceName: ${t}`);const n=t?this.rtc.getLocalVideoTracks().find((e=>e.getSourceName()===t)):this.rtc.getLocalVideoTrack();return this.peerconnection.setSenderVideoConstraints(e,n)}return Promise.resolve()}terminate(e,t,n){if(this.state!==ra){if(!n||Boolean(n.sendSessionTerminate)){const i=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"session-terminate",initiator:this.initiatorJid,sid:this.sid}).c("reason").c(n&&n.reason||"success").up();n&&n.reasonDescription?i.c("text").t(n.reasonDescription).up().up():i.up(),this._bridgeSessionId&&i.c("bridge-session",{xmlns:"http://jitsi.org/protocol/focus",id:this._bridgeSessionId,restart:n&&!0===n.requestRestart}).up(),ca.info(`${this} Sending session-terminate`),ca.debug(i.tree()),this.connection.sendIQ(i,e,this.newJingleErrorHandler(i,t),la)}else ca.info(`${this} Skipped sending session-terminate`);this.connection.jingle.terminate(this.sid)}}onTerminated(e,t){ca.info(`${this} Session terminated`,e,t),this._xmppListeners.forEach((e=>e())),this._xmppListeners=[],this._removeSenderVideoConstraintsChangeListener&&this._removeSenderVideoConstraintsChangeListener(),Ai.isSsrcRewritingSupported()&&this.peerconnection&&this.peerconnection.getRemoteTracks().forEach((e=>{this.room.eventEmitter.emit(bt.TRACK_REMOVED,e)})),this.close()}onXmppStatusChanged(e){e===Lo.Status.CONNECTED&&this._cachedOldLocalSdp&&(ca.info(`${this} Sending SSRC update on reconnect`),this.notifyMySSRCUpdate(this._cachedOldLocalSdp,this._cachedNewLocalSdp))}_parseSsrcInfoFromSourceAdd(e,t){const n=[],i=this;return _t()(e).each(((e,r)=>{const o=_t()(r).attr("name");let s="";_t()(r).find(\'ssrc-group[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each((function(){const e=this.getAttribute("semantics"),t=_t()(this).find(">source").map((function(){return this.getAttribute("ssrc")})).get();t.length&&(s+=`a=ssrc-group:${e} ${t.join(" ")}\\r\\n`)})),_t()(r).find(\'source[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each((function(){const e=_t()(this).attr("ssrc");t.containsSSRC(e)?!i.isP2P&&ca.warn(`${i} Source-add request for existing SSRC: ${e}`):_t()(this).find(">parameter").each((function(){s+=`a=ssrc:${e} ${_t()(this).attr("name")}`,_t()(this).attr("value")&&_t()(this).attr("value").length&&(s+=`:${_t()(this).attr("value")}`),s+="\\r\\n"}))}));let a=!1;t.media.forEach(((e,t)=>{Ns.findLine(e,`a=mid:${o}`)&&(n[t]||(n[t]=""),n[t]+=s,a=!0)})),!a&&this.isP2P&&(n[o]=s)})),n}addRemoteStream(e){this._addOrRemoveRemoteStream(!0,e)}removeRemoteStream(e){this._addOrRemoveRemoteStream(!1,e)}processSourceMap(e,t){if(!Ai.isSsrcRewritingSupported())return;const n=[];for(const i of e.mappedSources){const{owner:e,source:r,ssrc:o}=i;if(this.peerconnection.addRemoteSsrc(o,r)){n.push(i),ca.debug(`New SSRC signaled ${o}: owner=${e}, source-name=${r}`);const t=this.peerconnection.remoteSources.get(r);if(t){this._signalingLayer.removeSSRCOwners([t]);const e=this.peerconnection.getTrackBySSRC(t);e&&(e.setSourceName(void 0),e.setOwner(void 0),e._setVideoType(void 0))}}else{ca.debug(`Existing SSRC re-mapped ${o}: new owner=${e}, source-name=${r}`);const n=this.peerconnection.getTrackBySSRC(o);this._signalingLayer.setSSRCOwner(o,e,r),n.setSourceName(r),n.setOwner(e);const i=this._signalingLayer.getPeerMediaInfo(e,t,r);i&&(n._setVideoType(i.videoType),this.peerconnection._sourceMutedChanged(r,i.muted))}}if(n.length){let e=(0,St.$build)("content",{xmlns:"urn:xmpp:jingle:1",name:t}).c("description",{xmlns:"urn:xmpp:jingle:apps:rtp:1",media:t});for(const i of n){const{rtx:n,ssrc:r,source:o}=i;let s;if(t===Ri.VIDEO){const t=++this.numRemoteVideoSources;s=`remote-video-${t} remote-video-${t}`,"-1"!==n&&(ha(e,i,n,s),e.c("ssrc-group",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",semantics:"FID"}).c("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",ssrc:r}).up().c("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",ssrc:n}).up().up())}else{const e=++this.numRemoteAudioSources;s=`remote-audio-${e} remote-audio-${e}`}ha(e,i,r,s),this.peerconnection.remoteSources.set(o,r)}e=e.up(),this._addOrRemoveRemoteStream(!0,e.node)}}removeRemoteStreamsOnLeave(e){ca.debug(`${this} Queued removeRemoteStreamsOnLeave task for participant ${e}`),this.modificationQueue.push((t=>{const n=this.peerconnection.getRemoteSourceInfoByParticipant(e);if(n.length){const e=this._processRemoteRemoveSource(n);this._renegotiate(e.raw).then((()=>t()),(e=>t(e)))}else t()}),(e=>{e?ca.error(`${this} removeRemoteStreamsOnLeave error:`,e):ca.info(`${this} removeRemoteStreamsOnLeave done!`)}))}_addOrRemoveRemoteStream(e,t){const n=e?"addRemoteStream":"removeRemoteStream";e&&this.readSsrcInfo(t),ca.debug(`${this} Queued ${n} task`),this.modificationQueue.push((i=>{if(!this.peerconnection.localDescription||!this.peerconnection.localDescription.sdp){const e=`${n} - localDescription not ready yet`;return ca.error(e),void i(e)}ca.log(`${this} Processing ${n}`);const r=new Ms(this.peerconnection.remoteDescription.sdp),o=e?this._parseSsrcInfoFromSourceAdd(t,r):this._parseSsrcInfoFromSourceRemove(t,r),s=e?this._processRemoteAddSource(o):this._processRemoteRemoveSource(o);this._renegotiate(s.raw).then((()=>{ca.log(`${this} ${n} - OK`),i()}),(e=>{ca.error(`${this} ${n} failed:`,e),i(e)}))}))}_processNewJingleOfferIq(e){const t=new Ms("");return this.webrtcIceTcpDisable&&(t.removeTcpCandidates=!0),this.webrtcIceUdpDisable&&(t.removeUdpCandidates=!0),this.failICE&&(t.failICE=!0),t.fromJingle(e),this.readSsrcInfo(_t()(e).find(">content")),t}_processRemoteRemoveSource(e){var t;const n=new Ms(this.peerconnection.peerconnection.remoteDescription.sdp);let i;return e.forEach((e=>{let t;(e=e.split("\\r\\n")).pop(),i=e.map((e=>{var t;return Number(null===(t=e.split("a=ssrc:")[1])||void 0===t?void 0:t.split(" ")[0])})),e.forEach((e=>{if(t=n.media.findIndex((t=>t.includes(e))),t>-1)if(n.media[t]=n.media[t].replace(`${e}\\r\\n`,""),this.isP2P){var i;const e=null===(i=Ns.parseMLine(n.media[t].split("\\r\\n")[0]))||void 0===i?void 0:i.media,r=this.peerconnection.getDesiredMediaDirection(e,!1);[As.SENDRECV,As.SENDONLY].forEach((e=>{n.media[t]=n.media[t].replace(`a=${e}`,`a=${r}`)}))}else{n.media[t]=n.media[t].replace(`a=${As.SENDONLY}`,`a=${As.INACTIVE}`);const{media:e,port:i}=Ns.parseMLine(n.media[t].split("\\r\\n")[0]);n.media[t]=n.media[t].replace(`m=${e} ${i}`,`m=${e} 0`)}}))})),(null===(t=i)||void 0===t?void 0:t.length)&&this._signalingLayer.removeSSRCOwners(i),n.raw=n.session+n.media.join(""),n}_processRemoteAddSource(e){let t=new Ms(this.peerconnection.remoteDescription.sdp);return e.length>t.media.length&&this.isP2P&&(t.addMlineForNewLocalSource(Ri.VIDEO),t=new Ms(t.raw)),e.forEach(((e,n)=>{if(t.media[n]+=e,this.isP2P){var i;const e=null===(i=Ns.parseMLine(t.media[n].split("\\r\\n")[0]))||void 0===i?void 0:i.media,r=this.peerconnection.getDesiredMediaDirection(e,!0);[As.RECVONLY,As.INACTIVE].forEach((e=>{t.media[n]=t.media[n].replace(`a=${e}`,`a=${r}`)}))}})),t.raw=t.session+t.media.join(""),t}_renegotiate(e){if("closed"===this.peerconnection.signalingState){const e=new Error("Attempted to renegotiate in state closed");return this.room.eventEmitter.emit(Hi.XMPPEvents.RENEGOTIATION_FAILED,e,this),Promise.reject(e)}const t=e||this.peerconnection.remoteDescription.sdp;if(!t){const e=new Error(`Can not renegotiate without remote description, current state: ${this.state}`);return this.room.eventEmitter.emit(Hi.XMPPEvents.RENEGOTIATION_FAILED,e,this),Promise.reject(e)}const n=new RTCSessionDescription({type:"offer",sdp:t}),i=this.peerconnection.localDescription.sdp;return ca.debug(`${this} Renegotiate: setting remote description`),this.peerconnection.setRemoteDescription(n).then((()=>(ca.debug(`${this} Renegotiate: creating answer`),this.peerconnection.createAnswer(this.mediaConstraints)))).then((e=>(ca.debug(`${this} Renegotiate: setting local description`),this.peerconnection.setLocalDescription(e)))).then((()=>{i&&this.notifyMySSRCUpdate(new Ms(i),new Ms(this.peerconnection.localDescription.sdp))}))}addTracks(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(null!=e&&e.length||Promise.reject(new Error("No tracks passed")),e.find((e=>e.getType()!==Ri.VIDEO)))return Promise.reject(new Error("Multiple tracks of the given media type are not supported"));const t=[],n=n=>{const i=new Ms(this.peerconnection.peerconnection.remoteDescription.sdp),r=this.peerconnection.peerconnection.getTransceivers().find((e=>e.receiver.track.kind===Ri.VIDEO&&e.direction===As.RECVONLY&&e.currentDirection===As.RECVONLY));for(const t of e)this.isP2P&&r||i.addMlineForNewLocalSource(t.getType());this._renegotiate(i.raw).then((()=>{for(const n of e)t.push(this.peerconnection.replaceTrack(null,n));return Promise.all(t)})).then((()=>this._renegotiate())).then((()=>n()),(e=>n(e)))};return new Promise(((e,t)=>{ca.debug(`${this} Queued renegotiation after addTrack`),this.modificationQueue.push(n,(n=>{if(n){if(n instanceof Zs)return ca.debug(`${this} renegotiation after addTrack aborted: session terminated`),void e();ca.error(`${this} renegotiation after addTrack error`,n),t(n)}else ca.debug(`${this} renegotiation after addTrack executed - OK`),e()}))}))}setMediaTransferActive(e){return this.peerconnection.audioTransferActive!==e||this.peerconnection.videoTransferActive!==e?this.peerconnection.tpcUtils.setMediaTransferActive(e).then((()=>{this.peerconnection.audioTransferActive=e,this.peerconnection.videoTransferActive=e;const t=[];return t.push(this.peerconnection.configureVideoSenderEncodings()),t.push(this.peerconnection.configureAudioSenderEncodings()),Promise.allSettled(t)})):Promise.resolve()}replaceTrack(e,t){const n=n=>{ca.debug(`${this} replaceTrack worker started. oldTrack = ${e}, newTrack = ${t}`),this.peerconnection.replaceTrack(e,t).then((n=>{let i=Promise.resolve();return ca.debug(`${this} TPC.replaceTrack finished. shouldRenegotiate = ${n}, JingleSessionState = ${this.state}`),n&&(e||t)&&this.state===ia&&(i=this._renegotiate()),i.then((()=>{e&&t&&e.isVideoTrack()&&t.setSourceName(e.getSourceName())}))})).then((()=>n()),(e=>n(e)))};return new Promise(((i,r)=>{ca.debug(`${this} Queued replaceTrack task. Old track = ${e}, new track = ${t}`),this.modificationQueue.push(n,(e=>{if(e){if(e instanceof Zs)return ca.debug("Replace track aborted: session terminated"),void i();ca.error(`${this} Replace track error:`,e),r(e)}else ca.info(`${this}  Replace track done!`),i()}))}))}_parseSsrcInfoFromSourceRemove(e,t){const n=[];return _t()(e).each(((e,i)=>{const r=_t()(i).attr("name");let o="";_t()(i).find(\'ssrc-group[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each((function(){const e=this.getAttribute("semantics"),t=_t()(this).find(">source").map((function(){return this.getAttribute("ssrc")})).get();t.length&&(o+=`a=ssrc-group:${e} ${t.join(" ")}\\r\\n`)}));const s=[];_t()(i).find(\'source[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each((function(){const e=_t()(this).attr("ssrc");s.push(e)})),t.media.forEach(((e,t)=>{Ns.findLine(e,`a=mid:${r}`)&&(n[t]||(n[t]=""),s.forEach((i=>{const r=Ns.findLines(e,`a=ssrc:${i}`);r.length&&(n[t]+=`${r.join("\\r\\n")}\\r\\n`)})),n[t]+=o)}))})),n}addTrackToPc(e){return this._addRemoveTrack(!1,e).then((()=>{if(e.isVideoTrack())return this.peerconnection.configureVideoSenderEncodings(e)}))}removeTrackFromPc(e){return this._addRemoveTrack(!0,e)}_addRemoveTrack(e,t){if(!t)return Promise.reject(\'invalid "track" argument value\');const n=e?"removeTrack":"addTrack",i=i=>{const r=this.peerconnection;r?(e?r.removeTrackFromPc(t):r.addTrackToPc(t)).then((e=>{e?this._renegotiate().then(i):i()}),i):i(`Error:  tried ${n} track with no active peer connection`)};return ca.debug(`${this} Queued ${n} task`),new Promise(((e,t)=>{this.modificationQueue.push(i,(i=>{if(i){if(i instanceof Zs)return ca.debug(`${this} ${n} aborted: session terminated`),void e();ca.error(`${this} ${n} failed`),t(i)}else ca.debug(`${this} ${n} done`),e()}))}))}setP2pVideoTransferActive(e){return this.peerconnection?this._localSendReceiveVideoActive!==e?(this._localSendReceiveVideoActive=e,this.isP2P&&this.state===ia&&this.sendContentModify(),this.peerconnection.setVideoTransferActive(this._localSendReceiveVideoActive&&this._remoteSendReceiveVideoActive)):Promise.resolve():Promise.reject(\'Can not modify video transfer active state, before "initialize" is called\')}modifyContents(e){const t=ua.parseVideoSenders(e),n=ua.parseSourceMaxFrameHeight(e);if(n&&(this.remoteSourceMaxFrameHeights=n,this.eventEmitter.emit(da.REMOTE_SOURCE_CONSTRAINTS_CHANGED,this,n)),null===t)return void ca.error(`${this} - failed to parse video "senders" attribute in "content-modify" action`);if(!this._assertNotEnded())return;const i="both"===t||"initiator"===t&&this.isInitiator||"responder"===t&&!this.isInitiator;i!==this._remoteSendReceiveVideoActive&&(ca.debug(`${this} new remote video active: ${i}`),this._remoteSendReceiveVideoActive=i,this.peerconnection.setVideoTransferActive(this._localSendReceiveVideoActive&&this._remoteSendReceiveVideoActive))}notifyMySSRCUpdate(e,t){if(this.state!==ia)return void ca.warn(`${this} Skipping SSRC update in \'${this.state} \' state.`);if(!this.connection.connected)return this._cachedOldLocalSdp||(this._cachedOldLocalSdp=e),this._cachedNewLocalSdp=t,void ca.warn(`${this} Not sending SSRC update while the signaling is disconnected`);this._cachedOldLocalSdp=void 0,this._cachedNewLocalSdp=void 0;const n=e=>{const t=e.getNewMedia();let n=[],i=null;return Object.keys(t).forEach((e=>{const r=Object.keys(t[e].ssrcs);i=t[e].mid,null!=r&&r.length&&(n=n.concat(r))})),{mediaType:i,ssrcs:n}};let i=new Fs(t,e);const r=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"source-remove",initiator:this.initiatorJid,sid:this.sid});i.toJingle(r);const o={},s=n(i);s.ssrcs.length&&(ca.info(`${this} Sending source-remove for ${s.mediaType} ssrcs=${s.ssrcs}`),this.connection.sendIQ(r,(()=>{this.room.eventEmitter.emit(Hi.XMPPEvents.SOURCE_REMOVE,this,o)}),this.newJingleErrorHandler(r,(e=>{this.room.eventEmitter.emit(Hi.XMPPEvents.SOURCE_REMOVE_ERROR,this,e,o)})),la)),i=new Fs(e,t);const a=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"source-add",initiator:this.initiatorJid,sid:this.sid});i.toJingle(a);const d=n(i);d.ssrcs.length&&(ca.info(`${this} Sending source-add for ${d.mediaType} ssrcs=${d.ssrcs}`),this.connection.sendIQ(a,(()=>{this.room.eventEmitter.emit(Hi.XMPPEvents.SOURCE_ADD,this,o)}),this.newJingleErrorHandler(a,(e=>{this.room.eventEmitter.emit(Hi.XMPPEvents.SOURCE_ADD_ERROR,this,e,d.mediaType,o)})),la))}newJingleErrorHandler(e,t){return e=>{const n={},i=_t()(e).find("error");if(i.length){n.code=i.attr("code");const t=_t()(e).find("error :first");t.length&&(n.reason=t[0].tagName);const r=i.find(">text");r.length&&(n.msg=r.text())}e||(n.reason="timeout"),n.session=this.toString(),t?t(n):this.state===ra&&"item-not-found"===n.reason?ca.debug(`${this} Jingle error: ${JSON.stringify(n)}`):ca.error(`Jingle error: ${JSON.stringify(n)}`)}}getIceConnectionState(){return this.peerconnection.getConnectionState()}close(){this.state=ra,this.establishmentDuration=void 0,this.peerconnection&&(this.peerconnection.onicecandidate=null,this.peerconnection.oniceconnectionstatechange=null,this.peerconnection.onnegotiationneeded=null,this.peerconnection.onsignalingstatechange=null),ca.debug(`${this} Clearing modificationQueue`),this.modificationQueue.clear(),ca.debug(`${this} Queued PC close task`),this.modificationQueue.push((e=>{this.peerconnection&&this.peerconnection.close(),e(),ca.debug(`${this} PC close task done!`)})),ca.debug(`${this} Shutdown modificationQueue!`),this.modificationQueue.shutdown()}toString(){return`JingleSessionPC[session=${this.isP2P?"P2P":"JVB"},initiator=${this.isInitiator},sid=${this.sid}]`}}const pa=(0,E.getLogger)("modules/xmpp/strophe.jingle.js");function ma(e){const t=_t()(e).find(">candidate"),n=[];return t.each(((e,t)=>{const i=t.attributes,r=[];for(let e=0;e<i.length;e++){const t=i[e];r.push(`${t.name}: ${t.value}`)}n.push(r.join(" "))})),n}class ga extends Do{constructor(e,t,n){super(),this.xmpp=e,this.eventEmitter=t,this.sessions={},this.jvbIceConfig=n.jvb,this.p2pIceConfig=n.p2p,this.mediaConstraints={offerToReceiveAudio:!0,offerToReceiveVideo:!0}}init(e){super.init(e),this.connection.addHandler(this.onJingle.bind(this),"urn:xmpp:jingle:1","iq","set",null,null)}onJingle(e){const t=_t()(e).find("jingle").attr("sid"),n=_t()(e).find("jingle").attr("action"),i=e.getAttribute("from"),r=(0,St.$iq)({type:"result",to:i,id:e.getAttribute("id")});let o=this.sessions[t];if("session-initiate"!==n){if(!o)return r.attrs({type:"error"}),r.c("error",{type:"cancel"}).c("item-not-found",{xmlns:"urn:ietf:params:xml:ns:xmpp-stanzas"}).up().c("unknown-session",{xmlns:"urn:xmpp:jingle:errors:1"}),pa.warn(`invalid session id: ${t}`),pa.debug(e),this.connection.send(r),!0;if(i!==o.remoteJid)return pa.warn("jid mismatch for session id",t,o.remoteJid,e),r.attrs({type:"error"}),r.c("error",{type:"cancel"}).c("item-not-found",{xmlns:"urn:ietf:params:xml:ns:xmpp-stanzas"}).up().c("unknown-session",{xmlns:"urn:xmpp:jingle:errors:1"}),this.connection.send(r),!0}else if(void 0!==o)return r.attrs({type:"error"}),r.c("error",{type:"cancel"}).c("service-unavailable",{xmlns:"urn:ietf:params:xml:ns:xmpp-stanzas"}).up(),pa.warn("duplicate session id",t,e),this.connection.send(r),!0;const s=window.performance.now(),a="focus"!==St.Strophe.getResourceFromJid(i),d=_t()(e).find("jingle>json-message");if(null!=d&&d.length){var c;let t;pa.info(`Found a JSON-encoded element in ${n}, translating to standard Jingle.`);for(let n=0;n<d.length;n++)t=Rs(e,d[n]);if(null!==(c=t)&&void 0!==c&&c.size){const e=[];for(const n of t.keys())e.push(`${n}:[${t.get(n)}]`);pa.debug(`Received ${n} from ${i} with sources=${e.join(", ")}`)}}switch(n){case"session-initiate":{pa.log("(TIME) received session-initiate:\\t",s);const t=_t()(e).find("jingle>startmuted");if(a&&pa.debug(`Received ${n} from ${i}`),null!=t&&t.length){const e=t.attr(Ri.AUDIO),n=t.attr(Ri.VIDEO);this.eventEmitter.emit(Hi.XMPPEvents.START_MUTED_FROM_FOCUS,"true"===e,"true"===n)}const r=a?this.p2pIceConfig:this.jvbIceConfig;o=new ua(_t()(e).find("jingle").attr("sid"),_t()(e).attr("to"),i,this.connection,this.mediaConstraints,Ss()(r),a,!1),this.sessions[o.sid]=o,this.eventEmitter.emit(Hi.XMPPEvents.CALL_INCOMING,o,_t()(e).find(">jingle"),s);break}case"session-accept":{const t=[],r=_t()(e).find("jingle>content");for(const e of r){const n=_t()(e).find("description").attr("ssrc");n&&t.push(n)}pa.debug(`Received ${n} from ${i} with ssrcs=${t}`),this.eventEmitter.emit(Hi.XMPPEvents.CALL_ACCEPTED,o,_t()(e).find(">jingle"));break}case"content-modify":pa.debug(`Received ${n} from ${i}`),o.modifyContents(_t()(e).find(">jingle"));break;case"transport-info":{const t=ma(_t()(e).find("jingle>content>transport"));pa.debug(`Received ${n} from ${i} for candidates=${t.join(", ")}`),this.eventEmitter.emit(Hi.XMPPEvents.TRANSPORT_INFO,o,_t()(e).find(">jingle"));break}case"session-terminate":{pa.log("terminating...",o.sid);let t=null,r=null;_t()(e).find(">jingle>reason").length&&(t=_t()(e).find(">jingle>reason>:first")[0].tagName,r=_t()(e).find(">jingle>reason>text").text()),pa.debug(`Received ${n} from ${i} disconnect reason=${r}`),this.terminate(o.sid,t,r),this.eventEmitter.emit(Hi.XMPPEvents.CALL_ENDED,o,t,r);break}case"transport-replace":{var l;pa.info("(TIME) Start transport replace:\\t",s);const t=_t()(e).find("jingle>content>transport"),r=ma(t),d=_t()(t).attr("ufrag"),c=_t()(t).attr("pwd"),h=null===(l=_t()(t).find(">fingerprint"))||void 0===l?void 0:l.text();pa.debug(`Received ${n} from ${i} with iceUfrag=${d}, icePwd=${c}, DTLS fingerprint=${h}, candidates=${r.join(", ")}`),Mi.sendAnalytics(dn(Jt,{p2p:a,value:s})),o.replaceTransport(_t()(e).find(">jingle"),(()=>{const e=window.performance.now();pa.info("(TIME) Transport replace success:\\t",e),Mi.sendAnalytics(dn(Bt,{p2p:a,value:e}))}),(e=>{pa.error("Transport replace failed",e),o.sendTransportReject()}));break}case"source-add":o.addRemoteStream(_t()(e).find(">jingle>content"));break;case"source-remove":o.removeRemoteStream(_t()(e).find(">jingle>content"));break;default:pa.warn("jingle action not implemented",n),r.attrs({type:"error"}),r.c("error",{type:"cancel"}).c("bad-request",{xmlns:"urn:ietf:params:xml:ns:xmpp-stanzas"}).up()}return this.connection.send(r),!0}newP2PJingleSession(e,t){const n=new ua(co().randomHexString(12),e,t,this.connection,this.mediaConstraints,this.p2pIceConfig,!0,!0);return this.sessions[n.sid]=n,n}terminate(e,t,n){this.sessions.hasOwnProperty(e)&&("ended"!==this.sessions[e].state&&this.sessions[e].onTerminated(t,n),delete this.sessions[e])}getStunAndTurnCredentials(){this.connection.sendIQ((0,St.$iq)({type:"get",to:this.xmpp.options.hosts.domain}).c("services",{xmlns:"urn:xmpp:extdisco:2"}),(e=>this.onReceiveStunAndTurnCredentials(e)),(()=>{pa.warn("getting turn credentials with extdisco:2 failed, trying extdisco:1"),this.connection.sendIQ((0,St.$iq)({type:"get",to:this.xmpp.options.hosts.domain}).c("services",{xmlns:"urn:xmpp:extdisco:1"}),(e=>this.onReceiveStunAndTurnCredentials(e)),(()=>{pa.warn("getting turn credentials failed"),pa.warn("is mod_turncredentials or similar installed and configured?")}))}))}onReceiveStunAndTurnCredentials(e){let t=[];_t()(e).find(">services>service").each(((e,n)=>{const i={},r=(n=_t()(n)).attr("type");switch(r){case"stun":i.urls=`stun:${n.attr("host")}`,n.attr("port")&&(i.urls+=`:${n.attr("port")}`),t.push(i);break;case"turn":case"turns":{i.urls=`${r}:`,i.username=n.attr("username"),i.urls+=n.attr("host");const e=n.attr("port");e&&(i.urls+=`:${e}`);const o=n.attr("transport");o&&"udp"!==o&&(i.urls+=`?transport=${o}`),i.credential=n.attr("password")||i.credential,t.push(i);break}}}));const n=this.xmpp.options,{iceServersOverride:i=[]}=n;i.forEach((e=>{let{targetType:n,urls:i,username:r,credential:o}=e;if(!["turn","turns","stun"].includes(n))return;const s=`${n}:`;void 0===i&&void 0===r&&void 0===o||(null===i&&(t=t.filter((e=>!e.urls.startsWith(s)))),t.forEach((e=>{e.urls.startsWith(s)&&(e.urls=null!=i?i:e.urls,null===r?delete e.username:e.username=null!=r?r:e.username,null===o?delete e.credential:e.credential=null!=o?o:e.credential)})))}));for(let e=t.length-1;e>0;e--){const n=Math.floor(Math.random()*(e+1)),i=t[e];t[e]=t[n],t[n]=i}let r;return r=n.useTurnUdp?e=>e.urls.startsWith("turn"):e=>e.urls.startsWith("turn")&&e.urls.indexOf("transport=tcp")>=0,this.jvbIceConfig.iceServers=t.filter(r),this.p2pIceConfig.iceServers=t,t.length>0}getLog(){const e={};return Object.keys(this.sessions).forEach((t=>{const n=this.sessions[t].peerconnection;n&&n.updateLog&&(e[`jingle_${t}`]={updateLog:n.updateLog,stats:n.stats,url:window.location.href})})),e}}class fa extends Do{constructor(){super(),this.log=[]}init(e){super.init(e),this.connection.rawInput=this.logIncoming.bind(this),this.connection.rawOutput=this.logOutgoing.bind(this)}logIncoming(e){this.log.push([(new Date).getTime(),"incoming",e])}logOutgoing(e){this.log.push([(new Date).getTime(),"outgoing",e])}}const va=(0,E.getLogger)("modules/xmpp/strophe.rayo.js"),_a="urn:xmpp:rayo:1";class ya extends Do{init(e){super.init(e),this.connection.addHandler(this.onRayo.bind(this),_a,"iq","set",null,null)}onRayo(e){va.info("Rayo IQ",e)}dial(e,t,n,i,r){return new Promise(((o,s)=>{if(!r)return void s(new Error("Internal error!"));const a=(0,St.$iq)({type:"set",to:r});a.c("dial",{xmlns:_a,to:e,from:t}),a.c("header",{name:"JvbRoomName",value:n}).up(),i&&i.length&&a.c("header",{name:"JvbRoomPassword",value:i}).up(),this.connection.sendIQ(a,(e=>{va.info("Dial result ",e);const t=_t()(e).find("ref").attr("uri");this.callResource=t.substr("xmpp:".length),va.info(`Received call resource: ${this.callResource}`),o()}),(e=>{va.info("Dial error ",e),s(e)}))}))}hangup(){return new Promise(((e,t)=>{if(!this.callResource)return t(new Error("No call in progress")),void va.warn("No call in progress");const n=(0,St.$iq)({type:"set",to:this.callResource});n.c("hangup",{xmlns:_a}),this.connection.sendIQ(n,(t=>{va.info("Hangup result ",t),this.callResource=null,e()}),(e=>{va.info("Hangup error ",e),this.callResource=null,t(new Error("Hangup error "))}))}))}}const Ea=(0,E.getLogger)("modules/xmpp/strophe.util.js");let Sa=-1;const ba=/request id \\d+.\\d+ got 200/,Ta=/request errored, status: (\\d+), number of errors: \\d+/,Ca=(0,E.getLogger)("modules/xmpp/xmpp.js"),xa=/<failure.*><not-allowed\\/><text>(.*)<\\/text><\\/failure>/gi;const Ra=[{urls:"stun:meet-jit-si-turnrelay.jitsi.net:443"}],Aa="type",wa="http://jitsi.org/protocol/jigasi",Ia="https://jitsi.org/meet/e2ee";class Pa extends xr{constructor(e,t){if(super(),e.bosh&&!e.serviceUrl)throw new Error(\'The "bosh" option is no longer supported, please use "serviceUrl" instead\');this.connection=null,this.disconnectInProgress=!1,this.connectionTimes={},this.options=e,this.token=t,this.authenticatedUser=!1,this.options.deploymentInfo||(this.options.deploymentInfo={}),this._components=[],St.Strophe.log=function(e,t){switch(Ea.trace("Strophe",e,t),"string"==typeof t&&-1!==t.indexOf("Request ")&&-1!==t.indexOf("timed out (secondary), restarting")&&(e=St.Strophe.LogLevel.WARN),e){case St.Strophe.LogLevel.DEBUG:-1!==Sa&&ba.test(t)&&(Ea.debug("Reset lastErrorStatus"),Sa=-1);break;case St.Strophe.LogLevel.WARN:Ea.warn(`Strophe: ${t}`);const e=Ta.exec(t);e&&2===e.length&&(Sa=parseInt(e[1],10),Ea.debug(`lastErrorStatus set to: ${Sa}`));break;case St.Strophe.LogLevel.ERROR:case St.Strophe.LogLevel.FATAL:Ea.error(`Strophe: ${t}`,t)}},St.Strophe.getLastErrorStatus=function(){return Sa},St.Strophe.getStatusString=function(e){switch(e){case St.Strophe.Status.BINDREQUIRED:return"BINDREQUIRED";case St.Strophe.Status.ERROR:return"ERROR";case St.Strophe.Status.CONNECTING:return"CONNECTING";case St.Strophe.Status.CONNFAIL:return"CONNFAIL";case St.Strophe.Status.AUTHENTICATING:return"AUTHENTICATING";case St.Strophe.Status.AUTHFAIL:return"AUTHFAIL";case St.Strophe.Status.CONNECTED:return"CONNECTED";case St.Strophe.Status.DISCONNECTED:return"DISCONNECTED";case St.Strophe.Status.DISCONNECTING:return"DISCONNECTING";case St.Strophe.Status.ATTACHED:return"ATTACHED";default:return"unknown"}},St.Strophe.addConnectionPlugin("logger",new fa);const n=e.xmppPing||{};n.domain=e.hosts.domain,this.connection=function(e){let{enableWebsocketResume:t,serviceUrl:n="/http-bind",shard:i,token:r,websocketKeepAlive:o,websocketKeepAliveUrl:s,xmppPing:a}=e;return r&&(n+=`${-1===n.indexOf("?")?"?":"&"}token=${r}`),new Lo({enableWebsocketResume:t,serviceUrl:n,websocketKeepAlive:o,websocketKeepAliveUrl:s,xmppPing:a,shard:i})}({enableWebsocketResume:e.enableWebsocketResume,serviceUrl:e.serviceUrl,token:t,websocketKeepAlive:e.websocketKeepAlive,websocketKeepAliveUrl:e.websocketKeepAliveUrl,xmppPing:n,shard:e.deploymentInfo.shard}),this.moderator=new Ko(this),this.connection.on(Lo.Events.CONN_SHARD_CHANGED,(()=>{const e={shard_changed:!0,suspend_time:this.connection.ping.getPingSuspendTime(),time_since_last_success:this.connection.getTimeSinceLastSuccess()};this.eventEmitter.emit(ur,Sr,void 0,void 0,e)})),this._initStrophePlugins(),this.caps=new bo(this.connection,"https://jitsi.org/jitsi-meet"),this.initFeaturesList(),_t()(window).on((this.options.disableBeforeUnloadHandlers?"":"beforeunload ")+"unload",(e=>{this.disconnect(e).catch((()=>{}))}))}initFeaturesList(){this.caps.addFeature("urn:xmpp:jingle:1"),this.caps.addFeature("urn:xmpp:jingle:apps:rtp:1"),this.caps.addFeature("urn:xmpp:jingle:transports:ice-udp:1"),this.caps.addFeature("urn:xmpp:jingle:apps:dtls:0"),this.caps.addFeature("urn:xmpp:jingle:transports:dtls-sctp:1"),this.caps.addFeature("urn:xmpp:jingle:apps:rtp:audio"),this.caps.addFeature("urn:xmpp:jingle:apps:rtp:video"),this.caps.addFeature("http://jitsi.org/json-encoded-sources"),!this.options.disableRtx&&ci.supportsRTX()&&this.caps.addFeature("urn:ietf:rfc:4588"),!0===this.options.enableOpusRed&&ci.supportsAudioRed()&&this.caps.addFeature("http://jitsi.org/opus-red"),(void 0===this.options.enableRemb||this.options.enableRemb)&&this.caps.addFeature("http://jitsi.org/remb"),ci.isFirefox()&&ci.isVersionLessThan(115)||void 0!==this.options.enableTcc&&!this.options.enableTcc||this.caps.addFeature("http://jitsi.org/tcc"),this.connection.rayo&&this.caps.addFeature("urn:xmpp:rayo:client:1"),so.isSupported(this.options)&&this.caps.addFeature(Ia,!1,!0),Ca.debug("Source-name signaling is enabled"),this.caps.addFeature("http://jitsi.org/source-name"),Ca.debug("Receiving multiple video streams is enabled"),this.caps.addFeature("http://jitsi.org/receive-multiple-video-streams"),Ai.isSsrcRewritingSupported()&&this.caps.addFeature("http://jitsi.org/ssrc-rewriting-1"),this.caps.addFeature("http://jitsi.org/visitors-1")}getConnection(){return this.connection}connectionHandler(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1?arguments[1]:void 0,n=arguments.length>2?arguments[2]:void 0;const i=window.performance.now(),r=St.Strophe.getStatusString(t).toLowerCase();if(this.connectionTimes[r]=i,Ca.log(`(TIME) Strophe ${r}${n?`[${n}]`:""}:\\t`,i),this.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_STATUS_CHANGED,e,t,n),this._maybeSendDeploymentInfoStat(),t===St.Strophe.Status.CONNECTED||t===St.Strophe.Status.ATTACHED)this._sysMessageHandler&&(this.connection._stropheConn.deleteHandler(this._sysMessageHandler),this._sysMessageHandler=null),this.sendDiscoInfo&&this.connection.jingle.getStunAndTurnCredentials(),Ca.info(`My Jabber ID: ${this.connection.jid}`),this._resetState(),this.sendDeploymentInfo=!1,this.sendDiscoInfo&&this.caps.getFeaturesAndIdentities(this.options.hosts.domain).then((e=>{let{features:t,identities:n}=e;t.has(St.Strophe.NS.PING)||Ca.error(`Ping NOT supported by ${this.options.hosts.domain} - please enable ping in your XMPP server config`),this._processDiscoInfoIdentities(n,void 0)})).catch((e=>{Ca.error("Feature discovery error",e),this._maybeSendDeploymentInfoStat(!0)})),this.sendDiscoInfo=!1,e.password&&(this.authenticatedUser=!0),this.connection&&this.connection.connected&&St.Strophe.getResourceFromJid(this.connection.jid)&&this.eventEmitter.emit(hr,St.Strophe.getResourceFromJid(this.connection.jid));else if(t===St.Strophe.Status.CONNFAIL)"x-strophe-bad-non-anon-jid"===n?this.anonymousConnectionFailed=!0:this.connectionFailed=!0,this.lastErrorMsg=n,"giving-up"===n&&this.eventEmitter.emit(ur,Sr,n);else if(t===St.Strophe.Status.ERROR)this.lastErrorMsg=n;else if(t===St.Strophe.Status.DISCONNECTED){this.connection.ping.stopInterval();const e=Boolean(this.disconnectInProgress),t=n||this.lastErrorMsg;if(this.anonymousConnectionFailed)this.eventEmitter.emit(ur,br);else if(this.connectionFailed)this.eventEmitter.emit(ur,Sr,t,void 0,this._getConnectionFailedReasonDetails());else if(e)this.eventEmitter.emit(lr,t);else{Ca.error("XMPP connection dropped!");const e=St.Strophe.getLastErrorStatus();e>=500&&e<600?this.eventEmitter.emit(ur,Tr,t||"server-error",void 0,this._getConnectionFailedReasonDetails()):this.eventEmitter.emit(ur,Er,t||"connection-dropped-error",void 0,this._getConnectionFailedReasonDetails())}}else if(t===St.Strophe.Status.AUTHFAIL){const t=this.getConnection().getLastFailedMessage();this.eventEmitter.emit(ur,br,n||this._parseConnectionFailedMessage(t),e)}}_processDiscoInfoIdentities(e,t){e.forEach((e=>{if("av_moderation"===e.type&&(this.avModerationComponentAddress=e.name,this._components.push(this.avModerationComponentAddress)),"end_conference"===e.type&&(this.endConferenceComponentAddress=e.name,this._components.push(this.endConferenceComponentAddress)),"speakerstats"===e.type&&(this.speakerStatsComponentAddress=e.name,this._components.push(this.speakerStatsComponentAddress)),"lobbyrooms"===e.type){this.lobbySupported=!0;const n=e=>{e.forEach((e=>{e.endsWith("#displayname_required")&&this.eventEmitter.emit(gr)}))};t?n(t):e.name&&this.caps.getFeaturesAndIdentities(e.name,e.type).then((e=>{let{features:t}=e;return n(t)})).catch((e=>Ca.warn("Error getting features from lobby.",e&&e.message)))}if("shard"===e.type&&(this.options.deploymentInfo.shard=this.connection.shard=e.name),"region"===e.type&&(this.options.deploymentInfo.region=this.connection.region=e.name),"release"===e.type&&(this.options.deploymentInfo.backendRelease=e.name),"breakout_rooms"===e.type){this.breakoutRoomsComponentAddress=e.name,this._components.push(this.breakoutRoomsComponentAddress);const n=e=>{this.breakoutRoomsFeatures={},e.forEach((e=>{e.endsWith("#rename")&&(this.breakoutRoomsFeatures.rename=!0)}))};t?n(t):e.name&&this.caps.getFeaturesAndIdentities(e.name,e.type).then((e=>{let{features:t}=e;return n(t)})).catch((e=>Ca.warn("Error getting features for breakout rooms.",e&&e.message)))}"room_metadata"===e.type&&(this.roomMetadataComponentAddress=e.name,this._components.push(this.roomMetadataComponentAddress)),"visitors"===e.type&&this._components.push(e.name)})),this._maybeSendDeploymentInfoStat(!0),this._components.length>0&&this.connection.addHandler(this._onPrivateMessage.bind(this),null,"message",null,null)}_parseConnectionFailedMessage(e){if(!e)return null;xa.lastIndex=0;const t=xa.exec(e);return t?t[1]:null}_connect(e,t){this._resetState(),this.sendDiscoInfo=!0,this.sendDeploymentInfo=!0,this.connection._stropheConn&&this.connection._stropheConn._addSysHandler?this._sysMessageHandler=this.connection._stropheConn._addSysHandler(this._onSystemMessage.bind(this),null,"message"):Ca.warn("Cannot attach strophe system handler, jiconop cannot operate"),this.connection.connect(e,t,this.connectionHandler.bind(this,{jid:e,password:t}))}_onSystemMessage(e){if(0===_t()(e).find(">services").length&&0===_t()(e).find(">query").length)return;this.sendDiscoInfo=!1;const t=this.connection.jingle.onReceiveStunAndTurnCredentials(e),{features:n,identities:i}=So(e);this._processDiscoInfoIdentities(i,n),(t||i.size>0||n.size>0)&&(this.connection._stropheConn.deleteHandler(this._sysMessageHandler),this._sysMessageHandler=null)}attach(e){this._resetState(),this.sendDiscoInfo=!0;const t=this.connectionTimes.attaching=window.performance.now();Ca.log("(TIME) Strophe Attaching:\\t",t),this.connection.attach(e.jid,e.sid,parseInt(e.rid,10)+1,this.connectionHandler.bind(this,{jid:e.jid,password:e.password}))}_resetState(){this.anonymousConnectionFailed=!1,this.connectionFailed=!1,this.lastErrorMsg=void 0,this.disconnectInProgress=void 0}connect(e,t){if(!e){const{anonymousdomain:t,domain:n}=this.options.hosts;let i=t||n;const{location:r}=window;if(t){const e=r&&r.search;(e&&-1!==e.indexOf("login=true")||this.token)&&(i=n)}e=i||r&&r.hostname}return this._startConnecting=!0,this._connect(e,t)}createRoom(e,t,n){const i=e.domain||t.customDomain;let r=`${this.getRoomJid(e,i)}/`;const o=n?n(this.connection.jid,this.authenticatedUser):co().randomHexString(8).toLowerCase();return Ca.info(`JID ${this.connection.jid} using MUC nickname ${o}`),r+=o,this.connection.emuc.createRoom(r,null,t)}getRoomJid(e,t){return`${e}@${t||this.options.hosts.muc.toLowerCase()}`}isRoomCreated(e,t){return this.connection.emuc.isRoomCreated(this.getRoomJid(e,t))}getJid(){return this.connection.jid}getJingleLog(){const e=this.connection.jingle;return e?e.getLog():{}}getXmppLog(){return(this.connection.logger||{}).log||null}dial(){this.connection.rayo.dial(...arguments)}ping(e){return new Promise(((t,n)=>{this.connection.ping.ping(this.connection.pingDomain,t,n,e)}))}getSessions(){return this.connection.jingle.sessions}disconnect(e){return this.disconnectInProgress?this.disconnectInProgress:this.connection&&this._startConnecting?(this.disconnectInProgress=new Promise((e=>{const t=(n,i)=>{i===St.Strophe.Status.DISCONNECTED&&(this.eventEmitter.removeListener(Hi.XMPPEvents.CONNECTION_STATUS_CHANGED,t),e())};this.eventEmitter.on(Hi.XMPPEvents.CONNECTION_STATUS_CHANGED,t)})),this._cleanupXmppConnection(e),this.disconnectInProgress):Promise.resolve()}_cleanupXmppConnection(e){if(!this.connection.isUsingWebSocket&&this.connection.flush(),!this.connection.isUsingWebSocket&&null!=e){const t=e.type;if(("beforeunload"===t||"unload"===t)&&(this.connection.options.sync=!0,this.connection.sendUnavailableBeacon()))return}this.connection.disconnect(),this._startConnecting=!1,!0!==this.connection.options.sync&&this.connection.flush()}_initStrophePlugins(){const e={jvb:{iceServers:[]},p2p:{iceServers:[]}},t=this.options.p2p&&this.options.p2p.stunServers||Ra;Array.isArray(t)&&(Ca.info("P2P STUN servers: ",t),e.p2p.iceServers=t),this.options.p2p&&this.options.p2p.iceTransportPolicy&&(Ca.info("P2P ICE transport policy: ",this.options.p2p.iceTransportPolicy),e.p2p.iceTransportPolicy=this.options.p2p.iceTransportPolicy),this.connection.addConnectionPlugin("emuc",new ys(this)),this.connection.addConnectionPlugin("jingle",new ga(this,this.eventEmitter,e)),this.connection.addConnectionPlugin("rayo",new ya)}_getConnectionFailedReasonDetails(){const e={};if(this.options.deploymentInfo&&this.options.deploymentInfo.shard&&this.connection.lastResponseHeaders){const t=this.connection.lastResponseHeaders.trim().split(/[\\r\\n]+/),n={};t.forEach((e=>{const t=e.split(": "),i=t.shift(),r=t.join(": ");n[i]=r})),e.shard_changed=this.options.deploymentInfo.shard!==n["x-jitsi-shard"]}return e.suspend_time=this.connection.ping.getPingSuspendTime(),e.time_since_last_success=this.connection.getTimeSinceLastSuccess(),e}sendDominantSpeakerEvent(e,t){if(!this.speakerStatsComponentAddress||!e)return;const n=(0,St.$msg)({to:this.speakerStatsComponentAddress});n.c("speakerstats",{xmlns:"http://jitsi.org/jitmeet",room:e,silence:t}).up(),this.connection.send(n)}sendFaceLandmarksEvent(e,t){if(!this.speakerStatsComponentAddress||!e)return;const n=(0,St.$msg)({to:this.speakerStatsComponentAddress});n.c("faceLandmarks",{xmlns:"http://jitsi.org/jitmeet",room:e,faceExpression:t.faceExpression,timestamp:t.timestamp,duration:t.duration}).up(),this.connection.send(n)}tryParseJSONAndVerify(e){if(!e)return!1;try{const t=_r(e);if(t&&"object"==typeof t){const e=t[Aa];if(void 0!==e)return t;Ca.debug("parsing valid json but does not have correct structure","topic: ",e)}}catch(t){return Ca.error(`Error parsing json ${e}`,t),!1}return!1}_onPrivateMessage(e){const t=e.getAttribute("from");if(!this._components.includes(t))return!0;const n=_t()(e).find(">json-message").text(),i=this.tryParseJSONAndVerify(n);return!i||("speakerstats"===i[Aa]&&i.users?this.eventEmitter.emit(Hi.XMPPEvents.SPEAKER_STATS_RECEIVED,i.users):"av_moderation"===i[Aa]?this.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_RECEIVED,i):"breakout_rooms"===i[Aa]?this.eventEmitter.emit(Hi.XMPPEvents.BREAKOUT_ROOMS_EVENT,i):"room_metadata"===i[Aa]?this.eventEmitter.emit(Hi.XMPPEvents.ROOM_METADATA_EVENT,i):"visitors"===i[Aa]&&this.eventEmitter.emit(Hi.XMPPEvents.VISITORS_MESSAGE,i),!0)}_maybeSendDeploymentInfoStat(e){const t=[St.Strophe.Status.ERROR,St.Strophe.Status.CONNFAIL,St.Strophe.Status.AUTHFAIL,St.Strophe.Status.DISCONNECTED,St.Strophe.Status.CONNTIMEOUT];if(!(e||t.includes(this.connection.status)&&this.sendDeploymentInfo))return;const n=this.options.deploymentInfo;if(n&&Object.keys(n).length>0){const e={};for(const t in n)n.hasOwnProperty(t)&&(e[t]=n[t]);Mi.analytics.addPermanentProperties({...e}),e.id="deployment_info";const t=JSON.stringify(e);Ca.info(t)}this.sendDeploymentInfo=!1;const{region:i,shard:r}=n;(i||r)&&this.eventEmitter.emit(fr,JSON.parse(JSON.stringify({region:i,shard:r})))}}function Da(e){let t,{id:n,password:i,onCreateResource:r,onLoginSuccessful:o}=e,s=!1,a=new Pa(this.connection.options);const d=new Promise(((e,d)=>{t=d,a.addListener(lr,(()=>{a=void 0})),a.addListener(hr,(()=>{if(s)return;o&&o();const t=a.createRoom(this.options.name,this.options.config,r);t.xmpp.moderator.authenticate(t.roomjid).then((()=>{a&&a.disconnect(),s||this.room.xmpp.moderator.sendConferenceRequest(this.room.roomjid).finally(e)})).catch((e=>{let{error:t,message:n}=e;a.disconnect(),d({authenticationError:t,message:n})}))})),a.addListener(ur,((e,t,n)=>{d({connectionError:e,credentials:n,message:t}),a=void 0})),s||a.connect(n,i)}));return d.cancel=()=>{s=!0,t({}),a&&a.disconnect()},d}const Oa=(0,E.getLogger)("modules/RTC/CodecSelection.js"),ka=[Ds.VP9,Ds.VP8,Ds.H264,Ds.AV1],Na=[Ds.H264,Ds.VP8,Ds.VP9,Ds.AV1],Ma=[Ds.VP8,Ds.VP9,Ds.H264,Ds.AV1];class La{constructor(e,t){this.conference=e,this.options=t,this.codecPreferenceOrder={},this.visitorCodecs=[];for(const e of Object.keys(t)){let{disabledCodec:r,preferredCodec:o,preferenceOrder:s}=t[e];const a=new Set(this._getSupportedVideoCodecs(e));let d=Array.from(a);if(s)s=s.map((e=>e.toLowerCase())),d=s.filter((e=>a.has(e)));else if(o||r){var n,i;r=null===(n=r)||void 0===n?void 0:n.toLowerCase(),o=null===(i=o)||void 0===i?void 0:i.toLowerCase(),r&&r!==Ds.VP8&&(d=d.filter((e=>e!==r)));const e=d.findIndex((e=>e===o));o&&-1!==e&&(d.splice(e,1),d.unshift(o))}if(!(ci.supportsVP9()||ci.isWebKitBased()&&"p2p"===e)||this.conference.isE2EEEnabled()){const e=d.findIndex((e=>e===Ds.VP9));-1!==e&&(d.splice(e,1),this.conference.isE2EEEnabled()||d.push(Ds.VP9))}Oa.info(`Codec preference order for ${e} connection is ${d}`),this.codecPreferenceOrder[e]=d}this.conference.on(q,(e=>this._selectPreferredCodec(e))),this.conference.on(ue,(e=>this._updateVisitorCodecs(e))),this.conference.on(at,(()=>this._selectPreferredCodec())),this.conference.on(dt,(()=>this._selectPreferredCodec()))}_getSupportedVideoCodecs(e){const t=(ci.isMobileDevice()&&"p2p"===e?Na:ci.isMobileDevice()?Ma:ka).filter((e=>{var t,n,i,r;return(null!==(t=null===(n=window.RTCRtpReceiver)||void 0===n||null===(i=n.getCapabilities)||void 0===i||null===(r=i.call(n,Ri.VIDEO))||void 0===r?void 0:r.codecs)&&void 0!==t?t:[]).some((t=>t.mimeType.toLowerCase()===`${Ri.VIDEO}/${e}`))}));return!t.length&&t.push(Ds.VP8),t}_selectPreferredCodec(e){const t=e||this.conference.jvbJingleSession;if(!t)return;const n=t.peerconnection.getConfiguredVideoCodecs(),i=t===this.conference.jvbJingleSession;let r=i?this.codecPreferenceOrder.jvb:this.codecPreferenceOrder.p2p;this.conference.isE2EEEnabled()&&i&&(r=[Ds.VP8]);const o=this.conference.getParticipants().map((e=>e.getId())),s=null==o?void 0:o.map((e=>{const n=t._signalingLayer.getPeerMediaInfo(e,Ri.VIDEO);return null!=n&&n.codecList?n.codecList:null!=n&&n.codecType?[n.codecType]:[]}));this.visitorCodecs.length&&s.push(this.visitorCodecs);const a=r.reduce(((e,n)=>{let i=!1;if(!t.isP2P)for(const e of s)e.length&&(i=i||!e.find((e=>e===n)));return i||e.push(n),e}),[]);a.length?a.every(((e,t)=>e===n[t]))||t.setVideoCodecs(a):Oa.warn("Invalid codec list generated because of a user joining/leaving the call")}_updateVisitorCodecs(e){this.visitorCodecs!==e&&(this.visitorCodecs=e,this._selectPreferredCodec())}getCodecPreferenceList(e){return this.codecPreferenceOrder[e]}}const Fa=(0,E.getLogger)("modules/RTC/BridgeChannel.js");class ja{constructor(e,t,n,i){if(!e&&!t)throw new TypeError("At least peerconnection or wsUrl must be given");if(e&&t)throw new TypeError("Just one of peerconnection or wsUrl must be given");if(e?Fa.debug("constructor() with peerconnection"):Fa.debug(`constructor() with wsUrl:"${t}"`),this._channel=null,this._conference=i,this._connected=void 0,this._eventEmitter=n,this._mode=null,this._areRetriesEnabled=!1,this._closedFromClient=!1,e){const t=e.createDataChannel("JVB data channel",{protocol:"http://jitsi.org/protocols/colibri"});this._handleChannel(t),this._mode="datachannel"}else t&&(this._areRetriesEnabled=!0,this._wsUrl=t,this._initWebSocket())}_initWebSocket(){const e=new WebSocket(this._wsUrl);this._handleChannel(e),this._mode="websocket"}_startConnectionRetries(){let e=1;const t=()=>{!this._channel||"connecting"!==this._channel.readyState&&this._channel.readyState!==WebSocket.CONNECTING?this.isOpen()||(this._initWebSocket(this._wsUrl),e=Math.min(2*e,60),this._retryTimeout=setTimeout(t,1e3*e)):this._retryTimeout=setTimeout(t,1e3*e)};this._retryTimeout=setTimeout(t,1e3*e)}_stopConnectionRetries(){this._retryTimeout&&(clearTimeout(this._retryTimeout),this._retryTimeout=void 0)}_retryWebSocketConnection(e){if(!this._areRetriesEnabled)return;const{code:t,reason:n}=e;Mi.sendAnalytics(((e,t)=>({type:kt.TYPE_OPERATIONAL,action:"bridge-channel.error",attributes:{code:e,reason:t}}))(t,n)),this._areRetriesEnabled=!1,this._eventEmitter.once(ji.default.DATA_CHANNEL_OPEN,(()=>{this._stopConnectionRetries(),this._areRetriesEnabled=!0})),this._startConnectionRetries()}get mode(){return this._mode}close(){if(this._closedFromClient=!0,this._stopConnectionRetries(),this._areRetriesEnabled=!1,this._channel){try{this._channel.close()}catch(e){}this._channel=null}}isOpen(){return this._channel&&("open"===this._channel.readyState||this._channel.readyState===WebSocket.OPEN)}sendEndpointStatsMessage(e){this._send({colibriClass:"EndpointStats",...e})}sendMessage(e,t){this._send({colibriClass:"EndpointMessage",msgPayload:t,to:e})}sendSetLastNMessage(e){Fa.log(`Sending lastN=${e}.`),this._send({colibriClass:"LastNChangedEvent",lastN:e})}sendReceiverVideoConstraintsMessage(e){Fa.log(`Sending ReceiverVideoConstraints with ${JSON.stringify(e)}`),this._send({colibriClass:"ReceiverVideoConstraints",...e})}sendSourceVideoTypeMessage(e,t){Fa.info(`Sending SourceVideoTypeMessage with video type ${e}: ${t}`),this._send({colibriClass:"SourceVideoTypeMessage",sourceName:e,videoType:t})}_handleChannel(e){const t=this._eventEmitter;e.onopen=()=>{Fa.info(`${this._mode} channel opened`),this._connected=!0,t.emit(ji.default.DATA_CHANNEL_OPEN)},e.onerror=e=>{"websocket"!==this._mode&&Fa.error(`Channel error: ${e.message}`)},e.onmessage=e=>{let n,{data:i}=e;try{n=_r(i)}catch(e){return void Fa.error("Failed to parse channel message as JSON: ",i,e)}const r=n.colibriClass;switch(r){case"DominantSpeakerEndpointChangeEvent":{const{dominantSpeakerEndpoint:e,previousSpeakers:i=[],silence:r}=n;Fa.debug(`Dominant speaker: ${e}, previous speakers: ${i}`),t.emit(ji.default.DOMINANT_SPEAKER_CHANGED,e,i,r);break}case"EndpointConnectivityStatusChangeEvent":{const e=n.endpoint,i="true"===n.active;Fa.info(`Endpoint connection status changed: ${e} active=${i}`),t.emit(ji.default.ENDPOINT_CONN_STATUS_CHANGED,e,i);break}case"EndpointMessage":t.emit(ji.default.ENDPOINT_MESSAGE_RECEIVED,n.from,n.msgPayload);break;case"EndpointStats":t.emit(ji.default.ENDPOINT_STATS_RECEIVED,n.from,n);break;case"ForwardedSources":{const e=n.forwardedSources;Fa.info(`New forwarded sources: ${e}`),t.emit(ji.default.FORWARDED_SOURCES_CHANGED,e);break}case"SenderSourceConstraints":"string"==typeof n.sourceName&&"number"==typeof n.maxHeight?(Fa.info(`SenderSourceConstraints: ${n.sourceName} - ${n.maxHeight}`),t.emit(ji.default.SENDER_VIDEO_CONSTRAINTS_CHANGED,n)):Fa.error(`Invalid SenderSourceConstraints: ${n.sourceName} - ${n.maxHeight}`);break;case"ServerHello":Fa.info(`Received ServerHello, version=${n.version}.`);break;case"VideoSourcesMap":Fa.info(`Received VideoSourcesMap: ${JSON.stringify(n.mappedSources)}`),t.emit(ji.default.VIDEO_SSRCS_REMAPPED,n);break;case"AudioSourcesMap":Fa.info(`Received AudioSourcesMap: ${JSON.stringify(n.mappedSources)}`),t.emit(ji.default.AUDIO_SSRCS_REMAPPED,n);break;default:Fa.debug("Channel JSON-formatted message: ",n),t.emit(`rtc.datachannel.${r}`,n)}},e.onclose=n=>{if(Fa.debug("Channel closed by "+(this._closedFromClient?"client":"server")),e===this._channel){if(!(this._closedFromClient||1001===n.code&&1===this._conference.getParticipantCount())){const{code:e,reason:i}=n;Fa.error(`Channel closed: ${e} ${i}`),"websocket"===this._mode&&(this._retryWebSocketConnection(n),!1!==this._connected&&t.emit(ji.default.DATA_CHANNEL_CLOSED,{code:e,reason:i}))}this._connected=!1,this._channel=null}else Fa.debug("Skip close handler, channel instance is not equal to stored one")},this._channel=e}_send(e){const t=this._channel;if(!this.isOpen())throw Fa.error("Bridge Channel send: no opened channel."),new Error("No opened channel");t.send(JSON.stringify(e))}}let Va;!function(e){e.ENVIRONMENT="environment",e.USER="user"}(Va||(Va={}));let Ua=!0,Ha=!0;function $a(e,t,n){const i=e.match(t);return i&&i.length>=n&&parseInt(i[n],10)}function Ja(e,t,n){if(!e.RTCPeerConnection)return;const i=e.RTCPeerConnection.prototype,r=i.addEventListener;i.addEventListener=function(e,i){if(e!==t)return r.apply(this,arguments);const o=e=>{const t=n(e);t&&(i.handleEvent?i.handleEvent(t):i(t))};return this._eventMap=this._eventMap||{},this._eventMap[t]||(this._eventMap[t]=new Map),this._eventMap[t].set(i,o),r.apply(this,[e,o])};const o=i.removeEventListener;i.removeEventListener=function(e,n){if(e!==t||!this._eventMap||!this._eventMap[t])return o.apply(this,arguments);if(!this._eventMap[t].has(n))return o.apply(this,arguments);const i=this._eventMap[t].get(n);return this._eventMap[t].delete(n),0===this._eventMap[t].size&&delete this._eventMap[t],0===Object.keys(this._eventMap).length&&delete this._eventMap,o.apply(this,[e,i])},Object.defineProperty(i,"on"+t,{get(){return this["_on"+t]},set(e){this["_on"+t]&&(this.removeEventListener(t,this["_on"+t]),delete this["_on"+t]),e&&this.addEventListener(t,this["_on"+t]=e)},enumerable:!0,configurable:!0})}function Ba(e){return"boolean"!=typeof e?new Error("Argument type: "+typeof e+". Please use a boolean."):(Ua=e,e?"adapter.js logging disabled":"adapter.js logging enabled")}function qa(e){return"boolean"!=typeof e?new Error("Argument type: "+typeof e+". Please use a boolean."):(Ha=!e,"adapter.js deprecation warnings "+(e?"disabled":"enabled"))}function Ga(){if("object"==typeof window){if(Ua)return;"undefined"!=typeof console&&"function"==typeof console.log&&console.log.apply(console,arguments)}}function za(e,t){Ha&&console.warn(e+" is deprecated, please use "+t+" instead.")}function Ka(e){return"[object Object]"===Object.prototype.toString.call(e)}function Wa(e){return Ka(e)?Object.keys(e).reduce((function(t,n){const i=Ka(e[n]),r=i?Wa(e[n]):e[n],o=i&&!Object.keys(r).length;return void 0===r||o?t:Object.assign(t,{[n]:r})}),{}):e}function Xa(e,t,n){t&&!n.has(t.id)&&(n.set(t.id,t),Object.keys(t).forEach((i=>{i.endsWith("Id")?Xa(e,e.get(t[i]),n):i.endsWith("Ids")&&t[i].forEach((t=>{Xa(e,e.get(t),n)}))})))}function Ya(e,t,n){const i=n?"outbound-rtp":"inbound-rtp",r=new Map;if(null===t)return r;const o=[];return e.forEach((e=>{"track"===e.type&&e.trackIdentifier===t.id&&o.push(e)})),o.forEach((t=>{e.forEach((n=>{n.type===i&&n.trackId===t.id&&Xa(e,n,r)}))})),r}const Qa=Ga;function Za(e,t){const n=e&&e.navigator;if(!n.mediaDevices)return;const i=function(e){if("object"!=typeof e||e.mandatory||e.optional)return e;const t={};return Object.keys(e).forEach((n=>{if("require"===n||"advanced"===n||"mediaSource"===n)return;const i="object"==typeof e[n]?e[n]:{ideal:e[n]};void 0!==i.exact&&"number"==typeof i.exact&&(i.min=i.max=i.exact);const r=function(e,t){return e?e+t.charAt(0).toUpperCase()+t.slice(1):"deviceId"===t?"sourceId":t};if(void 0!==i.ideal){t.optional=t.optional||[];let e={};"number"==typeof i.ideal?(e[r("min",n)]=i.ideal,t.optional.push(e),e={},e[r("max",n)]=i.ideal,t.optional.push(e)):(e[r("",n)]=i.ideal,t.optional.push(e))}void 0!==i.exact&&"number"!=typeof i.exact?(t.mandatory=t.mandatory||{},t.mandatory[r("",n)]=i.exact):["min","max"].forEach((e=>{void 0!==i[e]&&(t.mandatory=t.mandatory||{},t.mandatory[r(e,n)]=i[e])}))})),e.advanced&&(t.optional=(t.optional||[]).concat(e.advanced)),t},r=function(e,r){if(t.version>=61)return r(e);if((e=JSON.parse(JSON.stringify(e)))&&"object"==typeof e.audio){const t=function(e,t,n){t in e&&!(n in e)&&(e[n]=e[t],delete e[t])};t((e=JSON.parse(JSON.stringify(e))).audio,"autoGainControl","googAutoGainControl"),t(e.audio,"noiseSuppression","googNoiseSuppression"),e.audio=i(e.audio)}if(e&&"object"==typeof e.video){let o=e.video.facingMode;o=o&&("object"==typeof o?o:{ideal:o});const s=t.version<66;if(o&&("user"===o.exact||"environment"===o.exact||"user"===o.ideal||"environment"===o.ideal)&&(!n.mediaDevices.getSupportedConstraints||!n.mediaDevices.getSupportedConstraints().facingMode||s)){let t;if(delete e.video.facingMode,"environment"===o.exact||"environment"===o.ideal?t=["back","rear"]:"user"!==o.exact&&"user"!==o.ideal||(t=["front"]),t)return n.mediaDevices.enumerateDevices().then((n=>{let s=(n=n.filter((e=>"videoinput"===e.kind))).find((e=>t.some((t=>e.label.toLowerCase().includes(t)))));return!s&&n.length&&t.includes("back")&&(s=n[n.length-1]),s&&(e.video.deviceId=o.exact?{exact:s.deviceId}:{ideal:s.deviceId}),e.video=i(e.video),Qa("chrome: "+JSON.stringify(e)),r(e)}))}e.video=i(e.video)}return Qa("chrome: "+JSON.stringify(e)),r(e)},o=function(e){return t.version>=64?e:{name:{PermissionDeniedError:"NotAllowedError",PermissionDismissedError:"NotAllowedError",InvalidStateError:"NotAllowedError",DevicesNotFoundError:"NotFoundError",ConstraintNotSatisfiedError:"OverconstrainedError",TrackStartError:"NotReadableError",MediaDeviceFailedDueToShutdown:"NotAllowedError",MediaDeviceKillSwitchOn:"NotAllowedError",TabCaptureError:"AbortError",ScreenCaptureError:"AbortError",DeviceCaptureError:"AbortError"}[e.name]||e.name,message:e.message,constraint:e.constraint||e.constraintName,toString(){return this.name+(this.message&&": ")+this.message}}};if(n.getUserMedia=function(e,t,i){r(e,(e=>{n.webkitGetUserMedia(e,t,(e=>{i&&i(o(e))}))}))}.bind(n),n.mediaDevices.getUserMedia){const e=n.mediaDevices.getUserMedia.bind(n.mediaDevices);n.mediaDevices.getUserMedia=function(t){return r(t,(t=>e(t).then((e=>{if(t.audio&&!e.getAudioTracks().length||t.video&&!e.getVideoTracks().length)throw e.getTracks().forEach((e=>{e.stop()})),new DOMException("","NotFoundError");return e}),(e=>Promise.reject(o(e))))))}}}function ed(e,t){e.navigator.mediaDevices&&"getDisplayMedia"in e.navigator.mediaDevices||e.navigator.mediaDevices&&("function"==typeof t?e.navigator.mediaDevices.getDisplayMedia=function(n){return t(n).then((t=>{const i=n.video&&n.video.width,r=n.video&&n.video.height,o=n.video&&n.video.frameRate;return n.video={mandatory:{chromeMediaSource:"desktop",chromeMediaSourceId:t,maxFrameRate:o||3}},i&&(n.video.mandatory.maxWidth=i),r&&(n.video.mandatory.maxHeight=r),e.navigator.mediaDevices.getUserMedia(n)}))}:console.error("shimGetDisplayMedia: getSourceId argument is not a function"))}function td(e){e.MediaStream=e.MediaStream||e.webkitMediaStream}function nd(e){if("object"==typeof e&&e.RTCPeerConnection&&!("ontrack"in e.RTCPeerConnection.prototype)){Object.defineProperty(e.RTCPeerConnection.prototype,"ontrack",{get(){return this._ontrack},set(e){this._ontrack&&this.removeEventListener("track",this._ontrack),this.addEventListener("track",this._ontrack=e)},enumerable:!0,configurable:!0});const t=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(){return this._ontrackpoly||(this._ontrackpoly=t=>{t.stream.addEventListener("addtrack",(n=>{let i;i=e.RTCPeerConnection.prototype.getReceivers?this.getReceivers().find((e=>e.track&&e.track.id===n.track.id)):{track:n.track};const r=new Event("track");r.track=n.track,r.receiver=i,r.transceiver={receiver:i},r.streams=[t.stream],this.dispatchEvent(r)})),t.stream.getTracks().forEach((n=>{let i;i=e.RTCPeerConnection.prototype.getReceivers?this.getReceivers().find((e=>e.track&&e.track.id===n.id)):{track:n};const r=new Event("track");r.track=n,r.receiver=i,r.transceiver={receiver:i},r.streams=[t.stream],this.dispatchEvent(r)}))},this.addEventListener("addstream",this._ontrackpoly)),t.apply(this,arguments)}}else Ja(e,"track",(e=>(e.transceiver||Object.defineProperty(e,"transceiver",{value:{receiver:e.receiver}}),e)))}function id(e){if("object"==typeof e&&e.RTCPeerConnection&&!("getSenders"in e.RTCPeerConnection.prototype)&&"createDTMFSender"in e.RTCPeerConnection.prototype){const t=function(e,t){return{track:t,get dtmf(){return void 0===this._dtmf&&("audio"===t.kind?this._dtmf=e.createDTMFSender(t):this._dtmf=null),this._dtmf},_pc:e}};if(!e.RTCPeerConnection.prototype.getSenders){e.RTCPeerConnection.prototype.getSenders=function(){return this._senders=this._senders||[],this._senders.slice()};const n=e.RTCPeerConnection.prototype.addTrack;e.RTCPeerConnection.prototype.addTrack=function(e,i){let r=n.apply(this,arguments);return r||(r=t(this,e),this._senders.push(r)),r};const i=e.RTCPeerConnection.prototype.removeTrack;e.RTCPeerConnection.prototype.removeTrack=function(e){i.apply(this,arguments);const t=this._senders.indexOf(e);-1!==t&&this._senders.splice(t,1)}}const n=e.RTCPeerConnection.prototype.addStream;e.RTCPeerConnection.prototype.addStream=function(e){this._senders=this._senders||[],n.apply(this,[e]),e.getTracks().forEach((e=>{this._senders.push(t(this,e))}))};const i=e.RTCPeerConnection.prototype.removeStream;e.RTCPeerConnection.prototype.removeStream=function(e){this._senders=this._senders||[],i.apply(this,[e]),e.getTracks().forEach((e=>{const t=this._senders.find((t=>t.track===e));t&&this._senders.splice(this._senders.indexOf(t),1)}))}}else if("object"==typeof e&&e.RTCPeerConnection&&"getSenders"in e.RTCPeerConnection.prototype&&"createDTMFSender"in e.RTCPeerConnection.prototype&&e.RTCRtpSender&&!("dtmf"in e.RTCRtpSender.prototype)){const t=e.RTCPeerConnection.prototype.getSenders;e.RTCPeerConnection.prototype.getSenders=function(){const e=t.apply(this,[]);return e.forEach((e=>e._pc=this)),e},Object.defineProperty(e.RTCRtpSender.prototype,"dtmf",{get(){return void 0===this._dtmf&&("audio"===this.track.kind?this._dtmf=this._pc.createDTMFSender(this.track):this._dtmf=null),this._dtmf}})}}function rd(e){if(!e.RTCPeerConnection)return;const t=e.RTCPeerConnection.prototype.getStats;e.RTCPeerConnection.prototype.getStats=function(){const[e,n,i]=arguments;if(arguments.length>0&&"function"==typeof e)return t.apply(this,arguments);if(0===t.length&&(0===arguments.length||"function"!=typeof e))return t.apply(this,[]);const r=function(e){const t={};return e.result().forEach((e=>{const n={id:e.id,timestamp:e.timestamp,type:{localcandidate:"local-candidate",remotecandidate:"remote-candidate"}[e.type]||e.type};e.names().forEach((t=>{n[t]=e.stat(t)})),t[n.id]=n})),t},o=function(e){return new Map(Object.keys(e).map((t=>[t,e[t]])))};if(arguments.length>=2){const i=function(e){n(o(r(e)))};return t.apply(this,[i,e])}return new Promise(((e,n)=>{t.apply(this,[function(t){e(o(r(t)))},n])})).then(n,i)}}function od(e){if(!("object"==typeof e&&e.RTCPeerConnection&&e.RTCRtpSender&&e.RTCRtpReceiver))return;if(!("getStats"in e.RTCRtpSender.prototype)){const t=e.RTCPeerConnection.prototype.getSenders;t&&(e.RTCPeerConnection.prototype.getSenders=function(){const e=t.apply(this,[]);return e.forEach((e=>e._pc=this)),e});const n=e.RTCPeerConnection.prototype.addTrack;n&&(e.RTCPeerConnection.prototype.addTrack=function(){const e=n.apply(this,arguments);return e._pc=this,e}),e.RTCRtpSender.prototype.getStats=function(){const e=this;return this._pc.getStats().then((t=>Ya(t,e.track,!0)))}}if(!("getStats"in e.RTCRtpReceiver.prototype)){const t=e.RTCPeerConnection.prototype.getReceivers;t&&(e.RTCPeerConnection.prototype.getReceivers=function(){const e=t.apply(this,[]);return e.forEach((e=>e._pc=this)),e}),Ja(e,"track",(e=>(e.receiver._pc=e.srcElement,e))),e.RTCRtpReceiver.prototype.getStats=function(){const e=this;return this._pc.getStats().then((t=>Ya(t,e.track,!1)))}}if(!("getStats"in e.RTCRtpSender.prototype)||!("getStats"in e.RTCRtpReceiver.prototype))return;const t=e.RTCPeerConnection.prototype.getStats;e.RTCPeerConnection.prototype.getStats=function(){if(arguments.length>0&&arguments[0]instanceof e.MediaStreamTrack){const e=arguments[0];let t,n,i;return this.getSenders().forEach((n=>{n.track===e&&(t?i=!0:t=n)})),this.getReceivers().forEach((t=>(t.track===e&&(n?i=!0:n=t),t.track===e))),i||t&&n?Promise.reject(new DOMException("There are more than one sender or receiver for the track.","InvalidAccessError")):t?t.getStats():n?n.getStats():Promise.reject(new DOMException("There is no sender or receiver for the track.","InvalidAccessError"))}return t.apply(this,arguments)}}function sd(e){e.RTCPeerConnection.prototype.getLocalStreams=function(){return this._shimmedLocalStreams=this._shimmedLocalStreams||{},Object.keys(this._shimmedLocalStreams).map((e=>this._shimmedLocalStreams[e][0]))};const t=e.RTCPeerConnection.prototype.addTrack;e.RTCPeerConnection.prototype.addTrack=function(e,n){if(!n)return t.apply(this,arguments);this._shimmedLocalStreams=this._shimmedLocalStreams||{};const i=t.apply(this,arguments);return this._shimmedLocalStreams[n.id]?-1===this._shimmedLocalStreams[n.id].indexOf(i)&&this._shimmedLocalStreams[n.id].push(i):this._shimmedLocalStreams[n.id]=[n,i],i};const n=e.RTCPeerConnection.prototype.addStream;e.RTCPeerConnection.prototype.addStream=function(e){this._shimmedLocalStreams=this._shimmedLocalStreams||{},e.getTracks().forEach((e=>{if(this.getSenders().find((t=>t.track===e)))throw new DOMException("Track already exists.","InvalidAccessError")}));const t=this.getSenders();n.apply(this,arguments);const i=this.getSenders().filter((e=>-1===t.indexOf(e)));this._shimmedLocalStreams[e.id]=[e].concat(i)};const i=e.RTCPeerConnection.prototype.removeStream;e.RTCPeerConnection.prototype.removeStream=function(e){return this._shimmedLocalStreams=this._shimmedLocalStreams||{},delete this._shimmedLocalStreams[e.id],i.apply(this,arguments)};const r=e.RTCPeerConnection.prototype.removeTrack;e.RTCPeerConnection.prototype.removeTrack=function(e){return this._shimmedLocalStreams=this._shimmedLocalStreams||{},e&&Object.keys(this._shimmedLocalStreams).forEach((t=>{const n=this._shimmedLocalStreams[t].indexOf(e);-1!==n&&this._shimmedLocalStreams[t].splice(n,1),1===this._shimmedLocalStreams[t].length&&delete this._shimmedLocalStreams[t]})),r.apply(this,arguments)}}function ad(e,t){if(!e.RTCPeerConnection)return;if(e.RTCPeerConnection.prototype.addTrack&&t.version>=65)return sd(e);const n=e.RTCPeerConnection.prototype.getLocalStreams;e.RTCPeerConnection.prototype.getLocalStreams=function(){const e=n.apply(this);return this._reverseStreams=this._reverseStreams||{},e.map((e=>this._reverseStreams[e.id]))};const i=e.RTCPeerConnection.prototype.addStream;e.RTCPeerConnection.prototype.addStream=function(t){if(this._streams=this._streams||{},this._reverseStreams=this._reverseStreams||{},t.getTracks().forEach((e=>{if(this.getSenders().find((t=>t.track===e)))throw new DOMException("Track already exists.","InvalidAccessError")})),!this._reverseStreams[t.id]){const n=new e.MediaStream(t.getTracks());this._streams[t.id]=n,this._reverseStreams[n.id]=t,t=n}i.apply(this,[t])};const r=e.RTCPeerConnection.prototype.removeStream;function o(e,t){let n=t.sdp;return Object.keys(e._reverseStreams||[]).forEach((t=>{const i=e._reverseStreams[t],r=e._streams[i.id];n=n.replace(new RegExp(r.id,"g"),i.id)})),new RTCSessionDescription({type:t.type,sdp:n})}e.RTCPeerConnection.prototype.removeStream=function(e){this._streams=this._streams||{},this._reverseStreams=this._reverseStreams||{},r.apply(this,[this._streams[e.id]||e]),delete this._reverseStreams[this._streams[e.id]?this._streams[e.id].id:e.id],delete this._streams[e.id]},e.RTCPeerConnection.prototype.addTrack=function(t,n){if("closed"===this.signalingState)throw new DOMException("The RTCPeerConnection\'s signalingState is \'closed\'.","InvalidStateError");const i=[].slice.call(arguments,1);if(1!==i.length||!i[0].getTracks().find((e=>e===t)))throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.","NotSupportedError");if(this.getSenders().find((e=>e.track===t)))throw new DOMException("Track already exists.","InvalidAccessError");this._streams=this._streams||{},this._reverseStreams=this._reverseStreams||{};const r=this._streams[n.id];if(r)r.addTrack(t),Promise.resolve().then((()=>{this.dispatchEvent(new Event("negotiationneeded"))}));else{const i=new e.MediaStream([t]);this._streams[n.id]=i,this._reverseStreams[i.id]=n,this.addStream(i)}return this.getSenders().find((e=>e.track===t))},["createOffer","createAnswer"].forEach((function(t){const n=e.RTCPeerConnection.prototype[t],i={[t](){const e=arguments;return arguments.length&&"function"==typeof arguments[0]?n.apply(this,[t=>{const n=o(this,t);e[0].apply(null,[n])},t=>{e[1]&&e[1].apply(null,t)},arguments[2]]):n.apply(this,arguments).then((e=>o(this,e)))}};e.RTCPeerConnection.prototype[t]=i[t]}));const s=e.RTCPeerConnection.prototype.setLocalDescription;e.RTCPeerConnection.prototype.setLocalDescription=function(){return arguments.length&&arguments[0].type?(arguments[0]=function(e,t){let n=t.sdp;return Object.keys(e._reverseStreams||[]).forEach((t=>{const i=e._reverseStreams[t],r=e._streams[i.id];n=n.replace(new RegExp(i.id,"g"),r.id)})),new RTCSessionDescription({type:t.type,sdp:n})}(this,arguments[0]),s.apply(this,arguments)):s.apply(this,arguments)};const a=Object.getOwnPropertyDescriptor(e.RTCPeerConnection.prototype,"localDescription");Object.defineProperty(e.RTCPeerConnection.prototype,"localDescription",{get(){const e=a.get.apply(this);return""===e.type?e:o(this,e)}}),e.RTCPeerConnection.prototype.removeTrack=function(e){if("closed"===this.signalingState)throw new DOMException("The RTCPeerConnection\'s signalingState is \'closed\'.","InvalidStateError");if(!e._pc)throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.","TypeError");if(e._pc!==this)throw new DOMException("Sender was not created by this connection.","InvalidAccessError");let t;this._streams=this._streams||{},Object.keys(this._streams).forEach((n=>{this._streams[n].getTracks().find((t=>e.track===t))&&(t=this._streams[n])})),t&&(1===t.getTracks().length?this.removeStream(this._reverseStreams[t.id]):t.removeTrack(e.track),this.dispatchEvent(new Event("negotiationneeded")))}}function dd(e,t){!e.RTCPeerConnection&&e.webkitRTCPeerConnection&&(e.RTCPeerConnection=e.webkitRTCPeerConnection),e.RTCPeerConnection&&t.version<53&&["setLocalDescription","setRemoteDescription","addIceCandidate"].forEach((function(t){const n=e.RTCPeerConnection.prototype[t],i={[t](){return arguments[0]=new("addIceCandidate"===t?e.RTCIceCandidate:e.RTCSessionDescription)(arguments[0]),n.apply(this,arguments)}};e.RTCPeerConnection.prototype[t]=i[t]}))}function cd(e,t){Ja(e,"negotiationneeded",(e=>{const n=e.target;if(!(t.version<72||n.getConfiguration&&"plan-b"===n.getConfiguration().sdpSemantics)||"stable"===n.signalingState)return e}))}function ld(e,t){const n=e&&e.navigator,i=e&&e.MediaStreamTrack;if(n.getUserMedia=function(e,t,i){za("navigator.getUserMedia","navigator.mediaDevices.getUserMedia"),n.mediaDevices.getUserMedia(e).then(t,i)},!(t.version>55&&"autoGainControl"in n.mediaDevices.getSupportedConstraints())){const e=function(e,t,n){t in e&&!(n in e)&&(e[n]=e[t],delete e[t])},t=n.mediaDevices.getUserMedia.bind(n.mediaDevices);if(n.mediaDevices.getUserMedia=function(n){return"object"==typeof n&&"object"==typeof n.audio&&(n=JSON.parse(JSON.stringify(n)),e(n.audio,"autoGainControl","mozAutoGainControl"),e(n.audio,"noiseSuppression","mozNoiseSuppression")),t(n)},i&&i.prototype.getSettings){const t=i.prototype.getSettings;i.prototype.getSettings=function(){const n=t.apply(this,arguments);return e(n,"mozAutoGainControl","autoGainControl"),e(n,"mozNoiseSuppression","noiseSuppression"),n}}if(i&&i.prototype.applyConstraints){const t=i.prototype.applyConstraints;i.prototype.applyConstraints=function(n){return"audio"===this.kind&&"object"==typeof n&&(n=JSON.parse(JSON.stringify(n)),e(n,"autoGainControl","mozAutoGainControl"),e(n,"noiseSuppression","mozNoiseSuppression")),t.apply(this,[n])}}}}function hd(e,t){e.navigator.mediaDevices&&"getDisplayMedia"in e.navigator.mediaDevices||e.navigator.mediaDevices&&(e.navigator.mediaDevices.getDisplayMedia=function(n){if(!n||!n.video){const e=new DOMException("getDisplayMedia without video constraints is undefined");return e.name="NotFoundError",e.code=8,Promise.reject(e)}return!0===n.video?n.video={mediaSource:t}:n.video.mediaSource=t,e.navigator.mediaDevices.getUserMedia(n)})}function ud(e){"object"==typeof e&&e.RTCTrackEvent&&"receiver"in e.RTCTrackEvent.prototype&&!("transceiver"in e.RTCTrackEvent.prototype)&&Object.defineProperty(e.RTCTrackEvent.prototype,"transceiver",{get(){return{receiver:this.receiver}}})}function pd(e,t){if("object"!=typeof e||!e.RTCPeerConnection&&!e.mozRTCPeerConnection)return;!e.RTCPeerConnection&&e.mozRTCPeerConnection&&(e.RTCPeerConnection=e.mozRTCPeerConnection),t.version<53&&["setLocalDescription","setRemoteDescription","addIceCandidate"].forEach((function(t){const n=e.RTCPeerConnection.prototype[t],i={[t](){return arguments[0]=new("addIceCandidate"===t?e.RTCIceCandidate:e.RTCSessionDescription)(arguments[0]),n.apply(this,arguments)}};e.RTCPeerConnection.prototype[t]=i[t]}));const n={inboundrtp:"inbound-rtp",outboundrtp:"outbound-rtp",candidatepair:"candidate-pair",localcandidate:"local-candidate",remotecandidate:"remote-candidate"},i=e.RTCPeerConnection.prototype.getStats;e.RTCPeerConnection.prototype.getStats=function(){const[e,r,o]=arguments;return i.apply(this,[e||null]).then((e=>{if(t.version<53&&!r)try{e.forEach((e=>{e.type=n[e.type]||e.type}))}catch(t){if("TypeError"!==t.name)throw t;e.forEach(((t,i)=>{e.set(i,Object.assign({},t,{type:n[t.type]||t.type}))}))}return e})).then(r,o)}}function md(e){if("object"!=typeof e||!e.RTCPeerConnection||!e.RTCRtpSender)return;if(e.RTCRtpSender&&"getStats"in e.RTCRtpSender.prototype)return;const t=e.RTCPeerConnection.prototype.getSenders;t&&(e.RTCPeerConnection.prototype.getSenders=function(){const e=t.apply(this,[]);return e.forEach((e=>e._pc=this)),e});const n=e.RTCPeerConnection.prototype.addTrack;n&&(e.RTCPeerConnection.prototype.addTrack=function(){const e=n.apply(this,arguments);return e._pc=this,e}),e.RTCRtpSender.prototype.getStats=function(){return this.track?this._pc.getStats(this.track):Promise.resolve(new Map)}}function gd(e){if("object"!=typeof e||!e.RTCPeerConnection||!e.RTCRtpSender)return;if(e.RTCRtpSender&&"getStats"in e.RTCRtpReceiver.prototype)return;const t=e.RTCPeerConnection.prototype.getReceivers;t&&(e.RTCPeerConnection.prototype.getReceivers=function(){const e=t.apply(this,[]);return e.forEach((e=>e._pc=this)),e}),Ja(e,"track",(e=>(e.receiver._pc=e.srcElement,e))),e.RTCRtpReceiver.prototype.getStats=function(){return this._pc.getStats(this.track)}}function fd(e){e.RTCPeerConnection&&!("removeStream"in e.RTCPeerConnection.prototype)&&(e.RTCPeerConnection.prototype.removeStream=function(e){za("removeStream","removeTrack"),this.getSenders().forEach((t=>{t.track&&e.getTracks().includes(t.track)&&this.removeTrack(t)}))})}function vd(e){e.DataChannel&&!e.RTCDataChannel&&(e.RTCDataChannel=e.DataChannel)}function _d(e){if("object"!=typeof e||!e.RTCPeerConnection)return;const t=e.RTCPeerConnection.prototype.addTransceiver;t&&(e.RTCPeerConnection.prototype.addTransceiver=function(){this.setParametersPromises=[];const e=arguments[1],n=e&&"sendEncodings"in e;n&&e.sendEncodings.forEach((e=>{if("rid"in e&&!/^[a-z0-9]{0,16}$/i.test(e.rid))throw new TypeError("Invalid RID value provided.");if("scaleResolutionDownBy"in e&&!(parseFloat(e.scaleResolutionDownBy)>=1))throw new RangeError("scale_resolution_down_by must be >= 1.0");if("maxFramerate"in e&&!(parseFloat(e.maxFramerate)>=0))throw new RangeError("max_framerate must be >= 0.0")}));const i=t.apply(this,arguments);if(n){const{sender:t}=i,n=t.getParameters();(!("encodings"in n)||1===n.encodings.length&&0===Object.keys(n.encodings[0]).length)&&(n.encodings=e.sendEncodings,t.sendEncodings=e.sendEncodings,this.setParametersPromises.push(t.setParameters(n).then((()=>{delete t.sendEncodings})).catch((()=>{delete t.sendEncodings}))))}return i})}function yd(e){if("object"!=typeof e||!e.RTCRtpSender)return;const t=e.RTCRtpSender.prototype.getParameters;t&&(e.RTCRtpSender.prototype.getParameters=function(){const e=t.apply(this,arguments);return"encodings"in e||(e.encodings=[].concat(this.sendEncodings||[{}])),e})}function Ed(e){if("object"!=typeof e||!e.RTCPeerConnection)return;const t=e.RTCPeerConnection.prototype.createOffer;e.RTCPeerConnection.prototype.createOffer=function(){return this.setParametersPromises&&this.setParametersPromises.length?Promise.all(this.setParametersPromises).then((()=>t.apply(this,arguments))).finally((()=>{this.setParametersPromises=[]})):t.apply(this,arguments)}}function Sd(e){if("object"!=typeof e||!e.RTCPeerConnection)return;const t=e.RTCPeerConnection.prototype.createAnswer;e.RTCPeerConnection.prototype.createAnswer=function(){return this.setParametersPromises&&this.setParametersPromises.length?Promise.all(this.setParametersPromises).then((()=>t.apply(this,arguments))).finally((()=>{this.setParametersPromises=[]})):t.apply(this,arguments)}}function bd(e){if("object"==typeof e&&e.RTCPeerConnection){if("getLocalStreams"in e.RTCPeerConnection.prototype||(e.RTCPeerConnection.prototype.getLocalStreams=function(){return this._localStreams||(this._localStreams=[]),this._localStreams}),!("addStream"in e.RTCPeerConnection.prototype)){const t=e.RTCPeerConnection.prototype.addTrack;e.RTCPeerConnection.prototype.addStream=function(e){this._localStreams||(this._localStreams=[]),this._localStreams.includes(e)||this._localStreams.push(e),e.getAudioTracks().forEach((n=>t.call(this,n,e))),e.getVideoTracks().forEach((n=>t.call(this,n,e)))},e.RTCPeerConnection.prototype.addTrack=function(e){for(var n=arguments.length,i=new Array(n>1?n-1:0),r=1;r<n;r++)i[r-1]=arguments[r];return i&&i.forEach((e=>{this._localStreams?this._localStreams.includes(e)||this._localStreams.push(e):this._localStreams=[e]})),t.apply(this,arguments)}}"removeStream"in e.RTCPeerConnection.prototype||(e.RTCPeerConnection.prototype.removeStream=function(e){this._localStreams||(this._localStreams=[]);const t=this._localStreams.indexOf(e);if(-1===t)return;this._localStreams.splice(t,1);const n=e.getTracks();this.getSenders().forEach((e=>{n.includes(e.track)&&this.removeTrack(e)}))})}}function Td(e){if("object"==typeof e&&e.RTCPeerConnection&&("getRemoteStreams"in e.RTCPeerConnection.prototype||(e.RTCPeerConnection.prototype.getRemoteStreams=function(){return this._remoteStreams?this._remoteStreams:[]}),!("onaddstream"in e.RTCPeerConnection.prototype))){Object.defineProperty(e.RTCPeerConnection.prototype,"onaddstream",{get(){return this._onaddstream},set(e){this._onaddstream&&(this.removeEventListener("addstream",this._onaddstream),this.removeEventListener("track",this._onaddstreampoly)),this.addEventListener("addstream",this._onaddstream=e),this.addEventListener("track",this._onaddstreampoly=e=>{e.streams.forEach((e=>{if(this._remoteStreams||(this._remoteStreams=[]),this._remoteStreams.includes(e))return;this._remoteStreams.push(e);const t=new Event("addstream");t.stream=e,this.dispatchEvent(t)}))})}});const t=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(){const e=this;return this._onaddstreampoly||this.addEventListener("track",this._onaddstreampoly=function(t){t.streams.forEach((t=>{if(e._remoteStreams||(e._remoteStreams=[]),e._remoteStreams.indexOf(t)>=0)return;e._remoteStreams.push(t);const n=new Event("addstream");n.stream=t,e.dispatchEvent(n)}))}),t.apply(e,arguments)}}}function Cd(e){if("object"!=typeof e||!e.RTCPeerConnection)return;const t=e.RTCPeerConnection.prototype,n=t.createOffer,i=t.createAnswer,r=t.setLocalDescription,o=t.setRemoteDescription,s=t.addIceCandidate;t.createOffer=function(e,t){const i=arguments.length>=2?arguments[2]:arguments[0],r=n.apply(this,[i]);return t?(r.then(e,t),Promise.resolve()):r},t.createAnswer=function(e,t){const n=arguments.length>=2?arguments[2]:arguments[0],r=i.apply(this,[n]);return t?(r.then(e,t),Promise.resolve()):r};let a=function(e,t,n){const i=r.apply(this,[e]);return n?(i.then(t,n),Promise.resolve()):i};t.setLocalDescription=a,a=function(e,t,n){const i=o.apply(this,[e]);return n?(i.then(t,n),Promise.resolve()):i},t.setRemoteDescription=a,a=function(e,t,n){const i=s.apply(this,[e]);return n?(i.then(t,n),Promise.resolve()):i},t.addIceCandidate=a}function xd(e){const t=e&&e.navigator;if(t.mediaDevices&&t.mediaDevices.getUserMedia){const e=t.mediaDevices,n=e.getUserMedia.bind(e);t.mediaDevices.getUserMedia=e=>n(Rd(e))}!t.getUserMedia&&t.mediaDevices&&t.mediaDevices.getUserMedia&&(t.getUserMedia=function(e,n,i){t.mediaDevices.getUserMedia(e).then(n,i)}.bind(t))}function Rd(e){return e&&void 0!==e.video?Object.assign({},e,{video:Wa(e.video)}):e}function Ad(e){if(!e.RTCPeerConnection)return;const t=e.RTCPeerConnection;e.RTCPeerConnection=function(e,n){if(e&&e.iceServers){const t=[];for(let n=0;n<e.iceServers.length;n++){let i=e.iceServers[n];!i.hasOwnProperty("urls")&&i.hasOwnProperty("url")?(za("RTCIceServer.url","RTCIceServer.urls"),i=JSON.parse(JSON.stringify(i)),i.urls=i.url,delete i.url,t.push(i)):t.push(e.iceServers[n])}e.iceServers=t}return new t(e,n)},e.RTCPeerConnection.prototype=t.prototype,"generateCertificate"in t&&Object.defineProperty(e.RTCPeerConnection,"generateCertificate",{get:()=>t.generateCertificate})}function wd(e){"object"==typeof e&&e.RTCTrackEvent&&"receiver"in e.RTCTrackEvent.prototype&&!("transceiver"in e.RTCTrackEvent.prototype)&&Object.defineProperty(e.RTCTrackEvent.prototype,"transceiver",{get(){return{receiver:this.receiver}}})}function Id(e){const t=e.RTCPeerConnection.prototype.createOffer;e.RTCPeerConnection.prototype.createOffer=function(e){if(e){void 0!==e.offerToReceiveAudio&&(e.offerToReceiveAudio=!!e.offerToReceiveAudio);const t=this.getTransceivers().find((e=>"audio"===e.receiver.track.kind));!1===e.offerToReceiveAudio&&t?"sendrecv"===t.direction?t.setDirection?t.setDirection("sendonly"):t.direction="sendonly":"recvonly"===t.direction&&(t.setDirection?t.setDirection("inactive"):t.direction="inactive"):!0!==e.offerToReceiveAudio||t||this.addTransceiver("audio",{direction:"recvonly"}),void 0!==e.offerToReceiveVideo&&(e.offerToReceiveVideo=!!e.offerToReceiveVideo);const n=this.getTransceivers().find((e=>"video"===e.receiver.track.kind));!1===e.offerToReceiveVideo&&n?"sendrecv"===n.direction?n.setDirection?n.setDirection("sendonly"):n.direction="sendonly":"recvonly"===n.direction&&(n.setDirection?n.setDirection("inactive"):n.direction="inactive"):!0!==e.offerToReceiveVideo||n||this.addTransceiver("video",{direction:"recvonly"})}return t.apply(this,arguments)}}function Pd(e){"object"!=typeof e||e.AudioContext||(e.AudioContext=e.webkitAudioContext)}function Dd(e){if(!e.RTCIceCandidate||e.RTCIceCandidate&&"foundation"in e.RTCIceCandidate.prototype)return;const t=e.RTCIceCandidate;e.RTCIceCandidate=function(e){if("object"==typeof e&&e.candidate&&0===e.candidate.indexOf("a=")&&((e=JSON.parse(JSON.stringify(e))).candidate=e.candidate.substr(2)),e.candidate&&e.candidate.length){const n=new t(e),i=Wn().parseCandidate(e.candidate),r=Object.assign(n,i);return r.toJSON=function(){return{candidate:r.candidate,sdpMid:r.sdpMid,sdpMLineIndex:r.sdpMLineIndex,usernameFragment:r.usernameFragment}},r}return new t(e)},e.RTCIceCandidate.prototype=t.prototype,Ja(e,"icecandidate",(t=>(t.candidate&&Object.defineProperty(t,"candidate",{value:new e.RTCIceCandidate(t.candidate),writable:"false"}),t)))}function Od(e,t){if(!e.RTCPeerConnection)return;"sctp"in e.RTCPeerConnection.prototype||Object.defineProperty(e.RTCPeerConnection.prototype,"sctp",{get(){return void 0===this._sctp?null:this._sctp}});const n=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(){if(this._sctp=null,"chrome"===t.browser&&t.version>=76){const{sdpSemantics:e}=this.getConfiguration();"plan-b"===e&&Object.defineProperty(this,"sctp",{get(){return void 0===this._sctp?null:this._sctp},enumerable:!0,configurable:!0})}if(function(e){if(!e||!e.sdp)return!1;const t=Wn().splitSections(e.sdp);return t.shift(),t.some((e=>{const t=Wn().parseMLine(e);return t&&"application"===t.kind&&-1!==t.protocol.indexOf("SCTP")}))}(arguments[0])){const e=function(e){const t=e.sdp.match(/mozilla...THIS_IS_SDPARTA-(\\d+)/);if(null===t||t.length<2)return-1;const n=parseInt(t[1],10);return n!=n?-1:n}(arguments[0]),n=function(e){let n=65536;return"firefox"===t.browser&&(n=t.version<57?-1===e?16384:2147483637:t.version<60?57===t.version?65535:65536:2147483637),n}(e),i=function(e,n){let i=65536;"firefox"===t.browser&&57===t.version&&(i=65535);const r=Wn().matchPrefix(e.sdp,"a=max-message-size:");return r.length>0?i=parseInt(r[0].substr(19),10):"firefox"===t.browser&&-1!==n&&(i=2147483637),i}(arguments[0],e);let r;r=0===n&&0===i?Number.POSITIVE_INFINITY:0===n||0===i?Math.max(n,i):Math.min(n,i);const o={};Object.defineProperty(o,"maxMessageSize",{get:()=>r}),this._sctp=o}return n.apply(this,arguments)}}function kd(e){if(!e.RTCPeerConnection||!("createDataChannel"in e.RTCPeerConnection.prototype))return;function t(e,t){const n=e.send;e.send=function(){const i=arguments[0],r=i.length||i.size||i.byteLength;if("open"===e.readyState&&t.sctp&&r>t.sctp.maxMessageSize)throw new TypeError("Message too large (can send a maximum of "+t.sctp.maxMessageSize+" bytes)");return n.apply(e,arguments)}}const n=e.RTCPeerConnection.prototype.createDataChannel;e.RTCPeerConnection.prototype.createDataChannel=function(){const e=n.apply(this,arguments);return t(e,this),e},Ja(e,"datachannel",(e=>(t(e.channel,e.target),e)))}function Nd(e){if(!e.RTCPeerConnection||"connectionState"in e.RTCPeerConnection.prototype)return;const t=e.RTCPeerConnection.prototype;Object.defineProperty(t,"connectionState",{get(){return{completed:"connected",checking:"connecting"}[this.iceConnectionState]||this.iceConnectionState},enumerable:!0,configurable:!0}),Object.defineProperty(t,"onconnectionstatechange",{get(){return this._onconnectionstatechange||null},set(e){this._onconnectionstatechange&&(this.removeEventListener("connectionstatechange",this._onconnectionstatechange),delete this._onconnectionstatechange),e&&this.addEventListener("connectionstatechange",this._onconnectionstatechange=e)},enumerable:!0,configurable:!0}),["setLocalDescription","setRemoteDescription"].forEach((e=>{const n=t[e];t[e]=function(){return this._connectionstatechangepoly||(this._connectionstatechangepoly=e=>{const t=e.target;if(t._lastConnectionState!==t.connectionState){t._lastConnectionState=t.connectionState;const n=new Event("connectionstatechange",e);t.dispatchEvent(n)}return e},this.addEventListener("iceconnectionstatechange",this._connectionstatechangepoly)),n.apply(this,arguments)}}))}function Md(e,t){if(!e.RTCPeerConnection)return;if("chrome"===t.browser&&t.version>=71)return;if("safari"===t.browser&&t.version>=605)return;const n=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(t){if(t&&t.sdp&&-1!==t.sdp.indexOf("\\na=extmap-allow-mixed")){const n=t.sdp.split("\\n").filter((e=>"a=extmap-allow-mixed"!==e.trim())).join("\\n");e.RTCSessionDescription&&t instanceof e.RTCSessionDescription?arguments[0]=new e.RTCSessionDescription({type:t.type,sdp:n}):t.sdp=n}return n.apply(this,arguments)}}function Ld(e,t){if(!e.RTCPeerConnection||!e.RTCPeerConnection.prototype)return;const n=e.RTCPeerConnection.prototype.addIceCandidate;n&&0!==n.length&&(e.RTCPeerConnection.prototype.addIceCandidate=function(){return arguments[0]?("chrome"===t.browser&&t.version<78||"firefox"===t.browser&&t.version<68||"safari"===t.browser)&&arguments[0]&&""===arguments[0].candidate?Promise.resolve():n.apply(this,arguments):(arguments[1]&&arguments[1].apply(null),Promise.resolve())})}function Fd(e,t){if(!e.RTCPeerConnection||!e.RTCPeerConnection.prototype)return;const n=e.RTCPeerConnection.prototype.setLocalDescription;n&&0!==n.length&&(e.RTCPeerConnection.prototype.setLocalDescription=function(){let e=arguments[0]||{};if("object"!=typeof e||e.type&&e.sdp)return n.apply(this,arguments);if(e={type:e.type,sdp:e.sdp},!e.type)switch(this.signalingState){case"stable":case"have-local-offer":case"have-remote-pranswer":e.type="offer";break;default:e.type="answer"}return e.sdp||"offer"!==e.type&&"answer"!==e.type?n.apply(this,[e]):("offer"===e.type?this.createOffer:this.createAnswer).apply(this).then((e=>n.apply(this,[e])))})}!function(){let{window:e}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{shimChrome:!0,shimFirefox:!0,shimSafari:!0};const n=Ga,i=function(e){const t={browser:null,version:null};if(void 0===e||!e.navigator)return t.browser="Not a browser.",t;const{navigator:n}=e;if(n.mozGetUserMedia)t.browser="firefox",t.version=$a(n.userAgent,/Firefox\\/(\\d+)\\./,1);else if(n.webkitGetUserMedia||!1===e.isSecureContext&&e.webkitRTCPeerConnection&&!e.RTCIceGatherer)t.browser="chrome",t.version=$a(n.userAgent,/Chrom(e|ium)\\/(\\d+)\\./,2);else{if(!e.RTCPeerConnection||!n.userAgent.match(/AppleWebKit\\/(\\d+)\\./))return t.browser="Not a supported browser.",t;t.browser="safari",t.version=$a(n.userAgent,/AppleWebKit\\/(\\d+)\\./,1),t.supportsUnifiedPlan=e.RTCRtpTransceiver&&"currentDirection"in e.RTCRtpTransceiver.prototype}return t}(e),r={browserDetails:i,commonShim:m,extractVersion:$a,disableLog:Ba,disableWarnings:qa,sdp:Kn};switch(i.browser){case"chrome":if(!h||!dd||!t.shimChrome)return n("Chrome shim is not included in this adapter release."),r;if(null===i.version)return n("Chrome shim can not determine version, not shimming."),r;n("adapter.js shimming chrome."),r.browserShim=h,Ld(e,i),Fd(e),Za(e,i),td(e),dd(e,i),nd(e),ad(e,i),id(e),rd(e),od(e),cd(e,i),Dd(e),Nd(e),Od(e,i),kd(e),Md(e,i);break;case"firefox":if(!u||!pd||!t.shimFirefox)return n("Firefox shim is not included in this adapter release."),r;n("adapter.js shimming firefox."),r.browserShim=u,Ld(e,i),Fd(e),ld(e,i),pd(e,i),ud(e),fd(e),md(e),gd(e),vd(e),_d(e),yd(e),Ed(e),Sd(e),Dd(e),Nd(e),Od(e,i),kd(e);break;case"safari":if(!p||!t.shimSafari)return n("Safari shim is not included in this adapter release."),r;n("adapter.js shimming safari."),r.browserShim=p,Ld(e,i),Fd(e),Ad(e),Id(e),Cd(e),bd(e),Td(e),wd(e),xd(e),Pd(e),Dd(e),Od(e,i),kd(e),Md(e,i);break;default:n("Unsupported browser!")}}({window:"undefined"==typeof window?void 0:window});var jd=n(125),Vd=n.n(jd);const Ud=(0,E.getLogger)("modules/RTC/RTCUtils.js"),Hd={video:{height:{ideal:720,max:720,min:180},width:{ideal:1280,max:1280,min:320}}};let $d="default",Jd=!1,Bd=!1,qd=!1,Gd=!1,zd=!1,Kd=null;const Wd=document.createElement("audio"),Xd=void 0!==Wd.setSinkId;let Yd,Qd=[];function Zd(){}function ec(e){const t=e.filter((e=>"audioinput"===e.kind)).length,n=e.filter((e=>"audiooutput"===e.kind)).length,i=e.filter((e=>"videoinput"===e.kind)).length,r=e.filter((e=>"videooutput"===e.kind)).length;e.forEach((e=>{const o={audio_input_device_count:t,audio_output_device_count:n,video_input_device_count:i,video_output_device_count:r,device_id:e.deviceId,device_group_id:e.groupId,device_kind:e.kind,device_label:e.label};Mi.sendAnalytics(Wt,o)}))}const tc=new class extends xr{init(){var e;let t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};var n;"boolean"==typeof t.disableAEC&&(qd=t.disableAEC,Ud.info(`Disable AEC: ${qd}`)),"boolean"==typeof t.disableNS&&(Gd=t.disableNS,Ud.info(`Disable NS: ${Gd}`)),"boolean"==typeof t.disableAP&&(Bd=t.disableAP,Ud.info(`Disable AP: ${Bd}`)),"boolean"==typeof t.disableAGC&&(zd=t.disableAGC,Ud.info(`Disable AGC: ${zd}`)),"boolean"==typeof(null===(e=t.audioQuality)||void 0===e?void 0:e.stereo)&&(Kd=t.audioQuality.stereo,Ud.info(`Stereo: ${Kd}`)),window.clearInterval(Yd),Yd=void 0,ci.isReactNative()||(this.attachMediaStream=(n=(e,t)=>{e&&(e.srcObject=t)},function(e,t){return n.apply(tc,arguments),t&&tc.isDeviceChangeAvailable("output")&&t.getAudioTracks&&t.getAudioTracks().length&&Jd?e.setSinkId(tc.getAudioOutputDevice()).catch((t=>{const n=new dr(t,null,["audiooutput"]);throw Ud.warn("Failed to set audio output device for the element. Default audio output device will be used instead",null==e?void 0:e.id,n),n})):Promise.resolve()})),this.pcConstraints={},Is.init(t),this.isDeviceListAvailable()&&this.enumerateDevices((e=>{Qd=e.slice(0),Ud.debug("Available devices: ",Qd),ec(Qd),this.eventEmitter.emit(ji.default.DEVICE_LIST_AVAILABLE,Qd),ci.supportsDeviceChangeEvent()?navigator.mediaDevices.addEventListener("devicechange",(()=>this.enumerateDevices(Zd))):Yd=window.setInterval((()=>this.enumerateDevices(Zd)),3e3)}))}enumerateDevices(e){navigator.mediaDevices.enumerateDevices().then((t=>{this._updateKnownDevices(t),e(t)})).catch((t=>{Ud.warn(`Failed to  enumerate devices. ${t}`),this._updateKnownDevices([]),e([])}))}_getUserMedia(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;return new Promise(((i,r)=>{let o,s=!1;"number"==typeof n&&!isNaN(n)&&n>0&&(o=setTimeout((()=>{s=!0,o=void 0,r(new dr(er))}),n)),navigator.mediaDevices.getUserMedia(t).then((t=>{Ud.log("onUserMediaSuccess"),this._updateGrantedPermissions(e,t),s||(void 0!==o&&clearTimeout(o),i(t))})).catch((n=>{Ud.warn(`Failed to get access to local media. ${n} ${JSON.stringify(t)}`);const i=new dr(n,t,e);s||(void 0!==o&&clearTimeout(o),r(i)),i.name===Yi&&this._updateGrantedPermissions(e,void 0)}))}))}_getDesktopMedia(e){return Is.isSupported()?new Promise(((t,n)=>{Is.obtainStream((e=>{t(e)}),(e=>{n(e)}),e)})):Promise.reject(new Error("Desktop sharing is not supported!"))}_getMissingTracks(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1?arguments[1]:void 0;const n=[],i=e.includes("audio"),r=t&&t.getAudioTracks().length>0;i&&!r&&n.push("audio");const o=e.includes("video"),s=t&&t.getVideoTracks().length>0;return o&&!s&&n.push("video"),n}_onMediaDevicesListChanged(e){Qd=e.slice(0),Ud.info("list of media devices has changed:",Qd),ec(Qd),this.eventEmitter.emit(ji.default.DEVICE_LIST_WILL_CHANGE,Qd),this.eventEmitter.emit(ji.default.DEVICE_LIST_CHANGED,Qd)}_updateKnownDevices(e){(function(e){return e.length!==Qd.length||e.map(t).sort().join("")!==Qd.map(t).sort().join("");function t(e){return JSON.stringify({kind:e.kind,deviceId:e.deviceId,groupId:e.groupId,label:e.label,facing:e.facing})}})(e)&&this._onMediaDevicesListChanged(e)}_updateGrantedPermissions(e,t){const n=Boolean(t)&&t.getAudioTracks().length>0,i=Boolean(t)&&t.getVideoTracks().length>0,r={};-1!==e.indexOf("video")&&(r.video=i),-1!==e.indexOf("audio")&&(r.audio=n),this.eventEmitter.emit(ji.default.PERMISSIONS_CHANGED,r)}obtainAudioAndVideoPermissions(e){const{timeout:t,...n}=e,i=[];let r={};const o=function(){if(-1===(n.devices||[]).indexOf("desktop"))return Promise.resolve();const{desktopSharingSourceDevice:e,desktopSharingSources:i}=n;if(e){const n=Qd&&Qd.find((t=>"videoinput"===t.kind&&(t.deviceId===e||t.label===e)));if(!n)return Promise.reject(new dr({name:"ConstraintNotSatisfiedError"},{},[e]));const i=["video"],r={video:{deviceId:n.deviceId}};return this._getUserMedia(i,r,t).then((e=>({sourceType:"device",stream:e})))}return this._getDesktopMedia({desktopSharingSources:i})}.bind(this),s=function(){const e=(n.devices||["audio","video"]).filter((e=>"audio"===e||"video"===e));return e.length?(r=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};const n=Ss()(t.constraints||Hd);if(e.indexOf("video")>=0){if(Vd()[t.resolution]){const e=Vd()[t.resolution];n.video.height={ideal:e.height},n.video.width={ideal:e.width}}if(n.video||(n.video={}),ci.isWebKitBased()&&(n.video.height&&n.video.height.ideal?n.video.height={ideal:n.video.height.ideal}:Ud.warn("Ideal camera height missing, camera may not start properly"),n.video.width&&n.video.width.ideal?n.video.width={ideal:n.video.width.ideal}:Ud.warn("Ideal camera width missing, camera may not start properly")),t.cameraDeviceId)n.video.deviceId={exact:t.cameraDeviceId};else{const e=t.facingMode||Va.USER;n.video.facingMode=e}}else n.video=!1;return e.indexOf("audio")>=0?(n.audio&&"boolean"!=typeof n.audio||(n.audio={}),n.audio={autoGainControl:!zd&&!Bd,echoCancellation:!qd&&!Bd,noiseSuppression:!Gd&&!Bd},t.micDeviceId&&(n.audio.deviceId={exact:t.micDeviceId}),Kd&&Object.assign(n.audio,{channelCount:2})):n.audio=!1,n}(e,n),Ud.info("Got media constraints: ",JSON.stringify(r)),this._getUserMedia(e,r,t)):Promise.resolve()}.bind(this);return o().then((function(e){if(!e)return;const{stream:t,sourceId:n,sourceType:r}=e,o=t.getAudioTracks();if(o.length){const e=new MediaStream(o);i.push({stream:e,sourceId:n,sourceType:r,track:e.getAudioTracks()[0]})}const s=t.getVideoTracks();if(s.length){const e=new MediaStream(s);i.push({stream:e,sourceId:n,sourceType:r,track:e.getVideoTracks()[0],videoType:Qo.VideoType.DESKTOP})}})).then(s).then((function(e){if(!e)return;const t=e.getAudioTracks();if(t.length){const e=new MediaStream(t);i.push({constraints:r.audio,stream:e,track:e.getAudioTracks()[0],effects:n.effects})}const o=e.getVideoTracks();if(o.length){const e=new MediaStream(o);i.push({constraints:r.video,stream:e,track:e.getVideoTracks()[0],videoType:Qo.VideoType.CAMERA,effects:n.effects})}})).then((()=>i)).catch((e=>(i.forEach((e=>{let{stream:t}=e;this.stopMediaStream(t)})),Promise.reject(e))))}isDeviceListAvailable(){return Boolean(navigator.mediaDevices&&navigator.mediaDevices.enumerateDevices)}isDeviceChangeAvailable(e){return"output"!==e&&"audiooutput"!==e||Xd}stopMediaStream(e){e&&(e.getTracks().forEach((e=>{e.stop&&e.stop()})),e.stop&&e.stop(),e.release&&e.release())}isDesktopSharingEnabled(){return Is.isSupported()}setAudioOutputDevice(e){return this.isDeviceChangeAvailable("output")?Wd.setSinkId(e).then((()=>{$d=e,Jd=!0,Ud.log(`Audio output device set to ${e}`),this.eventEmitter.emit(ji.default.AUDIO_OUTPUT_DEVICE_CHANGED,e)})):Promise.reject(new Error("Audio output device change is not supported"))}setDesktopSharingFrameRate(e){Is.setDesktopSharingFrameRate(e)}getAudioOutputDevice(){return $d}getCurrentlyAvailableMediaDevices(){return Qd}arePermissionsGrantedForAvailableDevices(){return Qd.some((e=>Boolean(e.label)))}getEventDataForActiveDevice(e){const t=[],n={deviceId:e.deviceId,kind:e.kind,label:e.label,groupId:e.groupId};return t.push(n),{deviceList:t}}isUserStreamById(e){return e&&"mixedmslabel"!==e&&"default"!==e}},nc=tc,ic=(0,E.getLogger)("modules/RTC/JitsiTrack.js"),rc={track_mute:"onmute",track_unmute:"onunmute",track_ended:"onended"};class oc extends ii{constructor(e,t,n,i,r,o){super(),this.containers=[],this.conference=e,this.audioLevel=-1,this.type=r,this.track=n,this.videoType=o,this.handlers=new Map,this.disposed=!1,this._streamInactiveHandler=i,this._setStream(t)}_addMediaStreamInactiveHandler(e){ci.isFirefox()||ci.isWebKitBased()?this.track.onended=e:this.stream.oninactive=e}_attachTTFMTracker(e){}_onTrackAttach(e){}_onTrackDetach(e){}_setHandler(e,t){if(rc.hasOwnProperty(e)){if(t?this.handlers.set(e,t):this.handlers.delete(e),this.stream)for(const n of this.stream.getTracks())n[rc[e]]=t}else ic.error(`Invalid handler type ${e}`)}_setStream(e){if(this.stream!==e&&(this.stream=e,this.stream)){for(const e of this.handlers.keys())this._setHandler(e,this.handlers.get(e));this._streamInactiveHandler&&this._addMediaStreamInactiveHandler(this._streamInactiveHandler)}}_unregisterHandlers(){if(this.stream){for(const e of this.handlers.keys())for(const t of this.stream.getVideoTracks())t[rc[e]]=void 0;this._streamInactiveHandler&&this._addMediaStreamInactiveHandler(void 0)}else ic.warn(`${this}: unable to unregister handlers - no stream object`)}attach(e){let t=Promise.resolve();return this.stream&&(this._onTrackAttach(e),t=nc.attachMediaStream(e,this.stream)),this.containers.push(e),this._attachTTFMTracker(e),t}detach(e){for(let t=this.containers,n=t.length-1;n>=0;--n){const i=t[n];e||(this._onTrackDetach(i),nc.attachMediaStream(i,null).catch((()=>{ic.error(`Detach for ${this} failed!`)}))),e&&i!==e||t.splice(n,1)}e&&(this._onTrackDetach(e),nc.attachMediaStream(e,null).catch((()=>{ic.error(`Detach for ${this} failed!`)})))}dispose(){return this.removeAllListeners(),this.disposed=!0,Promise.resolve()}getId(){return this.getStreamId()}getOriginalStream(){return this.stream}getSourceName(){}getStreamId(){return this.stream?this.stream.id:null}getTrack(){return this.track}getTrackLabel(){return this.track.label}getTrackId(){return this.track?this.track.id:null}getType(){return this.type}getUsageLabel(){return this.isAudioTrack()?"mic":this.videoType?this.videoType:"default"}getVideoType(){return this.videoType}getHeight(){return Math.min(this.track.getSettings().height,this.track.getSettings().width)}getWidth(){return Math.max(this.track.getSettings().height,this.track.getSettings().width)}isActive(){return void 0===this.stream.active||this.stream.active}isAudioTrack(){return this.getType()===Ri.AUDIO}isLocal(){throw new Error("Not implemented by subclass")}isLocalAudioTrack(){return this.isAudioTrack()&&this.isLocal()}isVideoTrack(){return this.getType()===Ri.VIDEO}isWebRTCTrackMuted(){return this.track&&this.track.muted}setAudioLevel(e,t){let n=e;ci.supportsReceiverStats()&&void 0!==t&&this.isMuted()&&(n=0),this.audioLevel!==n?(this.audioLevel=n,this.emit(Ct,n,t)):0===this.audioLevel&&0===n&&this.isLocal()&&!this.isWebRTCTrackMuted()&&this.emit(It,n)}setAudioOutput(e){return nc.isDeviceChangeAvailable("output")?this.isVideoTrack()?Promise.resolve():Promise.all(this.containers.map((t=>t.setSinkId(e).catch((e=>{throw ic.warn("Failed to change audio output device on element. Default or previously set audio output device will be used.",t,e),e}))))).then((()=>{this.emit(xt,e)})):Promise.reject(new Error("Audio output device change is not supported"))}setSourceName(e){}}const sc=(0,E.getLogger)("modules/RTC/JitsiLocalTrack.js");class ac extends oc{constructor(e){let{constraints:t,deviceId:n,facingMode:i,mediaType:r,rtcId:o,sourceId:s,sourceType:a,stream:d,track:c,videoType:l,effects:h=[]}=e;super(null,d,c,(()=>this.emit(Tt,this)),r,l),this._setEffectInProgress=!1;const u=h.find((e=>e.isEnabled(this)));u&&this._startStreamEffect(u);const p=l===Qo.VideoType.DESKTOP?c.getSettings().displaySurface:null;var m;this.metadata={timestamp:Date.now(),...p?{displaySurface:p}:{}},this.rtcId=o,this.sourceId=s,this.sourceType=null!=a?a:p,this._constraints=c.getConstraints(),r===Ri.VIDEO&&(l===Qo.VideoType.CAMERA&&(Object.keys(this._constraints).length||(this._constraints={height:{ideal:this.getHeight()},width:{ideal:this.getWidth()}}),isNaN(this._constraints.height.ideal)&&isNaN(this._constraints.width.ideal)&&(this._constraints.height={ideal:t.height.ideal},this._constraints.width={ideal:t.width.ideal})),this.resolution=this.getHeight(),isNaN(this.resolution)&&null!==(m=this._constraints.height)&&void 0!==m&&m.ideal&&(this.resolution=this._constraints.height.ideal),this.maxEnabledResolution=this.resolution),this.deviceId=n,this._prevSetMuted=Promise.resolve(),this._facingMode=i,this._trackEnded=!1,this._hasSentData=!1,this._testDataSent=!0,this._realDeviceId=""===this.deviceId?void 0:this.deviceId,this._sourceName=null,this._trackMutedTS=0,this._onDeviceListWillChange=e=>{const t=this._realDeviceId;this._setRealDeviceIdFromDeviceList(e),(void 0===this.getTrack().readyState&&void 0!==this._realDeviceId&&!e.find((e=>e.deviceId===this._realDeviceId))||void 0!==t&&void 0===this._realDeviceId)&&(this._trackEnded=!0)},this.isAudioTrack()&&nc.isDeviceChangeAvailable("output")&&(this._onAudioOutputDeviceChanged=this.setAudioOutput.bind(this),nc.addListener(ji.default.AUDIO_OUTPUT_DEVICE_CHANGED,this._onAudioOutputDeviceChanged)),nc.addListener(ji.default.DEVICE_LIST_WILL_CHANGE,this._onDeviceListWillChange),this._initNoDataFromSourceHandlers()}_addStreamToConferenceAsUnmute(){return this.conference?new Promise(((e,t)=>{this.conference._addLocalTrackToPc(this).then(e,(e=>t(new Error(e))))})):Promise.resolve()}_fireNoDataFromSourceEvent(){const e=!this.isReceivingData();this.emit(wt,e),sc.debug(`NO_DATA_FROM_SOURCE event with value ${e} detected for track: ${this}`),Mi.sendAnalytics(((e,t)=>({attributes:{media_type:e,value:t},action:"track.no.data.from.source",type:kt.TYPE_OPERATIONAL}))(this.getType(),e))}_initNoDataFromSourceHandlers(){this._isNoDataFromSourceEventsEnabled()&&(this._setHandler("track_mute",(()=>{this._trackMutedTS=window.performance.now(),this._fireNoDataFromSourceEvent()})),this._setHandler("track_unmute",(()=>{this._fireNoDataFromSourceEvent(),Mi.sendAnalyticsAndLog(nn,{media_type:this.getType(),track_type:"local",value:window.performance.now()-this._trackMutedTS})})),this.isVideoTrack()&&this.videoType===Qo.VideoType.CAMERA&&this._setHandler("track_ended",(()=>{this.isReceivingData()||this._fireNoDataFromSourceEvent()})))}_isNoDataFromSourceEventsEnabled(){return!this.isVideoTrack()||this.videoType!==Qo.VideoType.DESKTOP}_queueSetMuted(e){const t=this._setMuted.bind(this,e);return this._prevSetMuted=this._prevSetMuted.then(t,t),this._prevSetMuted}_removeStreamFromConferenceAsMute(e,t){this.conference?this.conference._removeLocalTrackFromPc(this).then(e,(e=>t(new Error(e)))):e()}_sendMuteStatus(e){this.conference&&this.conference._setTrackMuteStatus(this.getType(),this,e)&&this.conference.room.sendPresence()}_setMuted(e){if(this.isMuted()===e&&this.videoType!==Qo.VideoType.DESKTOP)return Promise.resolve();if(this.disposed)return Promise.reject(new dr(tr));let t=Promise.resolve();const n=()=>sc.info(`Mute ${this}: ${e}`),i=ci.isReactNative()?this.videoType===Qo.VideoType.DESKTOP:ci.doesVideoMuteByStreamRemove();if(this.isAudioTrack()||!i)n(),this._streamEffect&&this._streamEffect.setMuted?this._streamEffect.setMuted(e):this.track&&(this.track.enabled=!e);else if(e)t=new Promise(((e,t)=>{n(),this._removeStreamFromConferenceAsMute((()=>{this._streamEffect&&this._stopStreamEffect(),this._unregisterHandlers(),this.stopStream(),this._setStream(null),e()}),t)}));else{n();const e={cameraDeviceId:this.getDeviceId(),devices:[Ri.VIDEO],effects:this._streamEffect?[this._streamEffect]:[],facingMode:this.getCameraFacingMode()};t=nc.obtainAudioAndVideoPermissions(Object.assign({},e,{constraints:{video:this._constraints}})),t=t.then((e=>{const t=e.find((e=>e.track.kind===this.getType()));if(!t)throw new dr(nr);return this._setStream(t.stream),this.track=t.track,this.videoType!==t.videoType&&(sc.warn(`${this}: video type has changed after unmute!`,this.videoType,t.videoType),this.videoType=t.videoType),this._streamEffect&&this._startStreamEffect(this._streamEffect),this.containers.map((e=>nc.attachMediaStream(e,this.stream).catch((()=>{sc.error(`Attach media failed for ${this} on video unmute!`)})))),this._addStreamToConferenceAsUnmute()}))}return t.then((()=>{this._sendMuteStatus(e),this.isVideoTrack()&&this.conference&&this.conference._sendBridgeVideoTypeMessage(this),this.emit(Rt,this)}))}_setRealDeviceIdFromDeviceList(e){const t=this.getTrack(),n=`${t.kind}input`;let i=e.find((e=>e.kind===n&&e.label===t.label&&e.deviceId===this.deviceId));if(!i&&"default"===this._realDeviceId){const r=(t.label||"").replace("Default - ","");i=e.find((e=>e.kind===n&&e.label===r))}this._realDeviceId=i?i.deviceId:void 0}_setStream(e){super._setStream(e)}_startStreamEffect(e){this._streamEffect=e,this._originalStream=this.stream,this._setStream(this._streamEffect.startEffect(this._originalStream)),this.track=this.stream.getTracks()[0]}_stopStreamEffect(){this._streamEffect&&(this._streamEffect.stopEffect(),this._setStream(this._originalStream),this._originalStream=null,this.track=this.stream?this.stream.getTracks()[0]:null)}_switchCamera(){this.isVideoTrack()&&this.videoType===Qo.VideoType.CAMERA&&"function"==typeof this.track._switchCamera&&(this.track._switchCamera(),this._facingMode=this._facingMode===Va.ENVIRONMENT?Va.USER:Va.ENVIRONMENT)}_switchStreamEffect(e){this._streamEffect&&(this._stopStreamEffect(),this._streamEffect=void 0),e&&this._startStreamEffect(e)}async dispose(){return this._streamEffect&&await this.setEffect(),this.conference&&await this.conference.removeTrack(this),this.stream&&(this.stopStream(),this.detach()),nc.removeListener(ji.default.DEVICE_LIST_WILL_CHANGE,this._onDeviceListWillChange),this._onAudioOutputDeviceChanged&&nc.removeListener(ji.default.AUDIO_OUTPUT_DEVICE_CHANGED,this._onAudioOutputDeviceChanged),super.dispose()}getCameraFacingMode(){if(this.isVideoTrack()&&this.videoType===Qo.VideoType.CAMERA){var e,t;const n=null===(e=(t=this.track).getSettings)||void 0===e?void 0:e.call(t);return n&&"facingMode"in n?n.facingMode:void 0!==this._facingMode?this._facingMode:Va.USER}}getCaptureResolution(){return this.videoType!==Qo.VideoType.CAMERA&&ci.isWebKitBased()?this.getHeight():this.resolution}getDeviceId(){return this._realDeviceId||this.deviceId}getDuration(){return Date.now()/1e3-this.metadata.timestamp/1e3}getParticipantId(){return this.conference&&this.conference.myUserId()}getSourceName(){return this._sourceName}isEnded(){return this.isVideoTrack()&&this.isMuted()?this._trackEnded:"ended"===this.getTrack().readyState||this._trackEnded}isLocal(){return!0}isMuted(){return!this.stream||!(!this.isVideoTrack()||this.isActive())||(this._streamEffect&&this._streamEffect.isMuted?this._streamEffect.isMuted():!this.track||!this.track.enabled)}isReceivingData(){return!(!this.isVideoTrack()||!this.isMuted()&&!this._stopStreamInProgress&&this.videoType!==Qo.VideoType.DESKTOP)||!!this.stream&&(this._effectEnabled?this._originalStream:this.stream).getTracks().some((e=>!("readyState"in e&&"live"!==e.readyState||"muted"in e&&!0===e.muted)))}mute(){return this._queueSetMuted(!0)}onByteSentStatsReceived(e,t){t>0&&(this._hasSentData=!0);const n=e.getConnectionState();this._testDataSent&&"connected"===n&&(setTimeout((()=>{this._hasSentData||(sc.warn(`${this} \'bytes sent\' <= 0:                         ${t}`),Mi.analytics.sendEvent(tn,{media_type:this.getType()}))}),3e3),this._testDataSent=!1)}setConference(e){this.conference=e}setEffect(e){if(void 0===this._streamEffect&&void 0===e)return Promise.resolve();if(void 0!==e&&!e.isEnabled(this))return Promise.reject(new Error("Incompatible effect instance!"));if(!0===this._setEffectInProgress)return Promise.reject(new Error("setEffect already in progress!"));if(this.isMuted()&&!this.isAudioTrack())return this._streamEffect=e,Promise.resolve();const t=this.conference;return t?(this._setEffectInProgress=!0,t._removeLocalTrackFromPc(this).then((()=>(this._switchStreamEffect(e),this.isVideoTrack()&&this.containers.forEach((e=>{nc.attachMediaStream(e,this.stream).catch((()=>{sc.error(`Attach media failed for ${this} when trying to set effect.`)}))})),t._addLocalTrackToPc(this)))).then((()=>{this._setEffectInProgress=!1})).catch((e=>{throw this._setEffectInProgress=!1,this._switchStreamEffect(),sc.error("Failed to switch to the new stream!",e),e}))):(this._switchStreamEffect(e),this.isVideoTrack()&&this.containers.forEach((e=>{nc.attachMediaStream(e,this.stream).catch((()=>{sc.error(`Attach media failed for ${this} when trying to set effect.`)}))})),Promise.resolve())}setSourceName(e){this._sourceName=e}stopStream(){this._stopStreamInProgress=!0;try{nc.stopMediaStream(this.stream)}finally{this._stopStreamInProgress=!1}}toString(){return`LocalTrack[${this.rtcId},${this.getType()}]`}unmute(){return this._queueSetMuted(!1)}}var dc=n(561);const cc=function(e,t){return void 0!==e&&void 0!==e.media&&Array.isArray(e.media)&&e.media.forEach((e=>{e.sources&&e.sources.length&&(e.ssrcs=[],e.sources.forEach((t=>{Object.keys(t).forEach((n=>{"id"!==n&&e.ssrcs.push({id:t.id,attribute:n,value:t[n]})}))})),delete e.sources),e.ssrcGroups&&e.ssrcGroups.length&&e.ssrcGroups.forEach((e=>{void 0!==e.ssrcs&&Array.isArray(e.ssrcs)&&(e.ssrcs=e.ssrcs.join(" "))}))})),dc.write(e,t)},lc=function(e){const t=dc.parse(e);return void 0!==t&&void 0!==t.media&&Array.isArray(t.media)&&t.media.forEach((e=>{void 0!==e.ssrcs&&Array.isArray(e.ssrcs)&&(e.sources=[],e.ssrcs.forEach((t=>{const n=e.sources.findIndex((e=>e.id===t.id));if(n>-1)e.sources[n][t.attribute]=t.value;else{const n={id:t.id};n[t.attribute]=t.value,e.sources.push(n)}})),delete e.ssrcs),void 0!==e.ssrcGroups&&Array.isArray(e.ssrcGroups)&&e.ssrcGroups.forEach((e=>{"string"==typeof e.ssrcs&&(e.ssrcs=e.ssrcs.split(" "))}))})),t},hc=["audio","video","data"],uc=e=>e.find((e=>"SIM"===e.semantics)),pc=e=>e.find((e=>"FID"===e.semantics));function mc(e,t,n,i){if(!e||!t)return;const r=e=>i.find((t=>t.id.toString()===e));t.ssrcs.forEach((t=>{e.sources.push(r(t));const i=n[parseInt(t,10)].find((e=>"FID"===e.semantics));if(i){const n=i.ssrcs.find((e=>e!==t));e.sources.push(r(n)),e.ssrcGroups.push(i)}})),e.ssrcGroups.push(t)}function gc(e,t,n,i){if(!e||!t)return;if(e.sources=[],e.ssrcGroups=[],!n[t.id])return e.sources.push(t),void(e.msid=t.msid);const r=uc(n[t.id]),o=pc(n[t.id]);if(r)mc(e,r,n,i);else if(o){const r=o.ssrcs.find((e=>e!==t)),s=uc(n[r]);s?mc(e,s,n,i):(o.ssrcs.forEach((t=>{e.sources.push((e=>i.find((t=>t.id.toString()===e)))(t))})),e.ssrcGroups.push(o))}e.msid=e.sources[0].msid}function fc(e,t,n){if(!n.find((t=>!!t.sources&&t.sources.some((t=>t.id===e.id))))){if(!t[e.id])return!1;const i=uc(t[e.id]),r=pc(t[e.id]);return i?n.some((e=>e.sources&&e.sources.some((e=>e.id.toString()===i.ssrcs[0])))):!(!r||e.id.toString()===r.ssrcs[0])&&fc({id:r.ssrcs[0]},t,n)}return!0}class vc{toPlanB(e){if(!e||"string"!=typeof e.sdp)return console.warn("An empty description was passed as an argument."),e;const t=lc(e.sdp);if(!t.media||!t.media.length)return console.warn("The description has no media."),e;if(t.media.every((e=>-1!==hc.indexOf(e.mid))))return console.warn("The description does not look like unified plan sdp"),e;const n={},i=t.media;t.media=[],i.forEach((e=>{const t=e.type;if("application"===t)return e.mid="data",void(n[e.mid]=e);if(void 0===n[t]){const i=Es(e);i.sources&&Array.isArray(i.sources)&&i.sources.forEach((t=>{e.msid?t.msid=e.msid:delete t.msid})),i.ssrcGroups&&e.msid||(i.ssrcGroups=[]),delete i.msid,i.mid=t,n[t]=i}else if(e.msid){const i=Es(e);i.sources&&Array.isArray(i.sources)&&(i.sources.forEach((t=>{t.msid=e.msid})),n[t].sources=(n[t].sources||[]).concat(i.sources)),void 0!==i.ssrcGroups&&Array.isArray(i.ssrcGroups)&&(n[t].ssrcGroups=(n[t].ssrcGroups||[]).concat(i.ssrcGroups))}})),t.media=Object.values(n);const r=[];Object.values(n).forEach((e=>{"inactive"!==e.direction&&r.push(e.mid)})),t.groups.forEach((e=>{"BUNDLE"===e.type&&(e.mids=r.join(" "))})),t.msidSemantic={semantic:"WMS",token:"*"};const o=cc(t);return new RTCSessionDescription({type:e.type,sdp:o})}toUnifiedPlan(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(!e||"string"!=typeof e.sdp)return console.warn("An empty description was passed as an argument."),e;const n=lc(e.sdp);if(!n.media||!n.media.length)return console.warn("The description has no media."),e;if(n.media.length>3||n.media.every((e=>-1===hc.indexOf(e.mid))))return console.warn("The description does not look like plan-b"),e;const i=t?lc(t.sdp):null,r=function(e,t){if(!e||!t||0===e.media.length||0===t.media.length)return!1;const n=e.media[0],i=t.media[0];return n.iceUfrag!==i.iceUfrag||n.icePwd!==i.icePwd}(n,i),o=n.media[0].iceUfrag,s=n.media[0].icePwd,a=n.media[0].fingerprint,d={};n.media.forEach((e=>{const t=e.type;if("application"===t){if(!i||!i.media){const t=Es(e);return t.mid=Object.keys(d).length.toString(),void(d[e.mid]=t)}const n=i.media.findIndex((e=>e.type===t));return void(n&&(i.media[n]=e,i.media[n].mid=n))}const n=function(e){const t={};return e&&Array.isArray(e)?(e.forEach((e=>{e.ssrcs&&Array.isArray(e.ssrcs)&&e.ssrcs.forEach((n=>{void 0===t[n]&&(t[n]=[]),t[n].push(e)}))})),t):t}(e.ssrcGroups);if(e.sources)e.sources.forEach(((t,r)=>{if(!t.msid)return;if(!i||!i.media){if(fc(t,n,Object.values(d)))return;const i=Es(e);return i.mid=Object.keys(d).length.toString(),i.direction=r||"sendonly"===e.direction?"sendonly":"sendrecv",i.bundleOnly=void 0,gc(i,t,n,e.sources),void(d[i.mid]=i)}if(fc(t,n,i.media))return;const o=Es(e);o.mid=i.media.length.toString(),o.direction="sendonly",gc(o,t,n,e.sources),i.media.push(o)}));else if(!i){const t=Es(e);t.mid=Object.keys(d).length.toString(),d[e.mid]=t}})),n.media=i?i.media:Object.values(d);const c=[];n.media.forEach((e=>{c.push(e.mid),r&&(e.iceUfrag=o,e.icePwd=s,e.fingerprint=a)})),n.groups.forEach((e=>{"BUNDLE"===e.type&&(e.mids=c.join(" "))})),n.msidSemantic={semantic:"WMS",token:"*"},n.origin.sessionVersion++;const l=cc(n);return new RTCSessionDescription({type:e.type,sdp:l})}}let _c;!function(e){e.PEER_MUTED_CHANGED="signaling.peerMuted",e.PEER_VIDEO_TYPE_CHANGED="signaling.peerVideoType",e.SOURCE_MUTED_CHANGED="signaling.sourceMuted",e.SOURCE_UPDATED="signaling.sourceUpdated",e.SOURCE_VIDEO_TYPE_CHANGED="signaling.sourceVideoType"}(_c||(_c={}));const yc=_c.PEER_MUTED_CHANGED,Ec=_c.PEER_VIDEO_TYPE_CHANGED,Sc=_c.SOURCE_MUTED_CHANGED,bc=_c.SOURCE_UPDATED,Tc=_c.SOURCE_VIDEO_TYPE_CHANGED;function Cc(e,t,n){return`${e}-${t.substring(0,1)}${n}`}function xc(e){const t=e.lastIndexOf("-")+1;if(t<=0)throw new Error(`Invalid source name: ${e}`);const n=e.substr(t,1);for(const e of Object.values(Ri))if(e.substr(0,1)===n)return e;throw new Error(`Invalid source name: ${e}`)}function Rc(e){const t=e.split("-"),n=Number(t[t.length-1].substring(1));if(Number.isNaN(n))throw new Error(`Failed to parse track idx for source name: ${e}`);return n}class Ac extends xr{getPeerMediaInfo(e,t,n){throw new Error("not implemented")}getPeerSourceInfo(e,t){throw new Error("not implemented")}getSSRCOwner(e){throw new Error("not implemented")}getTrackSourceName(e){throw new Error("not implemented")}removeSSRCOwners(e){}setSSRCOwner(e,t,n){}setTrackMuteStatus(e,t){}setTrackVideoType(e,t){}updateSsrcOwnersOnLeave(e){}}const wc=[{rid:"1",scaleFactor:4},{rid:"2",scaleFactor:2},{rid:"3",scaleFactor:1}],Ic={av1:{maxBitratesVideo:{low:1e5,standard:3e5,high:1e6,fullHd:2e6,ultraHd:4e6,ssHigh:25e5,none:0},scalabilityModeEnabled:ci.supportsScalabilityModeAPI(),useSimulcast:!1,useKSVC:!0},h264:{maxBitratesVideo:{low:2e5,standard:5e5,high:15e5,fullHd:3e6,ultraHd:6e6,ssHigh:25e5,none:0},scalabilityModeEnabled:ci.supportsScalabilityModeAPI()},vp8:{maxBitratesVideo:{low:2e5,standard:5e5,high:15e5,fullHd:3e6,ultraHd:6e6,ssHigh:25e5,none:0},scalabilityModeEnabled:!1},vp9:{maxBitratesVideo:{low:1e5,standard:3e5,high:12e5,fullHd:25e5,ultraHd:5e6,ssHigh:25e5,none:0},scalabilityModeEnabled:ci.supportsScalabilityModeAPI(),useSimulcast:!1,useKSVC:!0}},Pc=[{height:2160,level:"ultraHd"},{height:1080,level:"fullHd"},{height:720,level:"high"},{height:540,level:"standard"},{height:480,level:"standard"},{height:360,level:"standard"},{height:270,level:"low"},{height:180,level:"low"},{height:90,level:"low"},{height:0,level:"none"}];let Dc;function Oc(e){return parseInt(e.ssrcs.split(" ")[0],10)}function kc(e){return parseInt(e.ssrcs.split(" ")[1],10)}function Nc(e){return e.ssrcs?e.ssrcs.map((e=>e.id)).filter(((e,t,n)=>n.indexOf(e)===t)).length:0}!function(e){e.ULTRA="ultraHd",e.FULL="fullHd",e.HIGH="high",e.STANDARD="standard",e.LOW="low",e.NONE="none"}(Dc||(Dc={}));class Mc{constructor(e){if(!e)throw new Error("mLine is undefined");this.mLine=e}get ssrcs(){return this.mLine.ssrcs||(this.mLine.ssrcs=[]),this.mLine.ssrcs}set ssrcs(e){this.mLine.ssrcs=e}get direction(){return this.mLine.direction}set direction(e){this.mLine.direction=e}get ssrcGroups(){return this.mLine.ssrcGroups||(this.mLine.ssrcGroups=[]),this.mLine.ssrcGroups}set ssrcGroups(e){this.mLine.ssrcGroups=e}getSSRCAttrValue(e,t){const n=this.ssrcs.find((n=>n.id===e&&n.attribute===t));return n&&n.value}removeSSRC(e){this.mLine.ssrcs&&this.mLine.ssrcs.length&&(this.mLine.ssrcs=this.mLine.ssrcs.filter((t=>t.id!==e)))}addSSRCAttribute(e){this.ssrcs.push(e)}findGroup(e,t){return this.ssrcGroups.find((n=>n.semantics===e&&(!t||t===n.ssrcs)))}findGroups(e){return this.ssrcGroups.filter((t=>t.semantics===e))}findGroupByPrimarySSRC(e,t){return this.ssrcGroups.find((n=>n.semantics===e&&Oc(n)===t))}findSSRCByMSID(e){return this.ssrcs.find((t=>"msid"===t.attribute&&(null===e||t.value===e)))}getSSRCCount(){return Nc(this.mLine)}containsAnySSRCGroups(){return void 0!==this.mLine.ssrcGroups}getPrimaryVideoSsrc(){const e=this.mLine.type;if("video"!==e)throw new Error(`getPrimarySsrc doesn\'t work with \'${e}\'`);if(1===Nc(this.mLine))return this.mLine.ssrcs[0].id;if(this.mLine.ssrcGroups){const e=this.findGroup("SIM");if(e)return Oc(e);const t=this.findGroup("FID");if(t)return Oc(t);const n=this.findGroup("FEC-FR");if(n)return Oc(n)}}getRtxSSRC(e){const t=this.findGroupByPrimarySSRC("FID",e);return t&&kc(t)}getSSRCs(){return this.ssrcs.map((e=>e.id)).filter(((e,t,n)=>n.indexOf(e)===t))}getPrimaryVideoSSRCs(){const e=this.mLine.type;if("video"!==e)throw new Error(`getPrimaryVideoSSRCs doesn\'t work with ${e}`);const t=this.getSSRCs();for(const e of this.ssrcGroups)if("FID"===e.semantics||"FEC-FR"===e.semantics){const n=kc(e);t.splice(t.indexOf(n),1)}return t}dumpSSRCGroups(){return JSON.stringify(this.mLine.ssrcGroups)}removeGroupsWithSSRC(e){this.mLine.ssrcGroups&&(this.mLine.ssrcGroups=this.mLine.ssrcGroups.filter((t=>-1===t.ssrcs.indexOf(`${e}`))))}removeGroupsBySemantics(e){this.mLine.ssrcGroups&&(this.mLine.ssrcGroups=this.mLine.ssrcGroups.filter((t=>t.semantics!==e)))}replaceSSRC(e,t){this.mLine.ssrcs&&this.mLine.ssrcs.forEach((n=>{n.id===e&&(n.id=t)}))}addSSRCGroup(e){this.ssrcGroups.push(e)}}class Lc{constructor(e){this.parsedSDP=Ps.parse(e)}selectMedia(e){const t=this.parsedSDP.media.filter((t=>t.type===e)).map((e=>new Mc(e)));return null!=t?t:null}toRawSDP(){return Ps.write(this.parsedSDP)}}const Fc=(0,E.getLogger)("modules/sdp/LocalSdpMunger.js");class jc{constructor(e,t){this.tpc=e,this.localEndpointId=t,this.audioSourcesToMsidMap=new Map,this.videoSourcesToMsidMap=new Map}_generateMsidAttribute(e,t,n){if(!e||!t)return Fc.error(`Unable to munge local MSID - track id=${t} or media type=${e} is missing`),null;const i=this.tpc.id;return`${n}-${i} ${t}-${i}`}_transformMediaIdentifiers(e){var t,n,i,r,o;const s=null===(t=e.mLine)||void 0===t?void 0:t.type,a=null===(n=e.mLine)||void 0===n?void 0:n.direction,d=null===(i=e.mLine)||void 0===i?void 0:i.msid,c=[...new Set(null===(r=e.mLine)||void 0===r||null===(o=r.ssrcs)||void 0===o?void 0:o.map((e=>e.id)))],l=`${this.localEndpointId}-${s}`;let h=d?d.split(" ")[1]:`${this.localEndpointId}-${e.mLine.mid}`;for(const t of c){const n=e.ssrcs.find((e=>e.id===t&&"msid"===e.attribute));n&&(h=n.value.split(" ")[1]),this._updateSourcesToMsidMap(s,l,h);const i=s===Ri.VIDEO?this.videoSourcesToMsidMap.get(h):this.audioSourcesToMsidMap.get(h),r=this._generateMsidAttribute(s,h,i);n?n.value=r:a!==As.SENDONLY&&a!==As.SENDRECV||e.ssrcs.push({id:t,attribute:"msid",value:r})}e.ssrcs=e.ssrcs.filter((e=>"msid"===e.attribute)),!ci.isFirefox()||a!==As.RECVONLY&&a!==As.INACTIVE||(s!==Ri.VIDEO||this.tpc._hasHadVideoTrack)&&(s!==Ri.AUDIO||this.tpc._hasHadAudioTrack)||(e.ssrcs=void 0,e.ssrcGroups=void 0)}_updateSourcesToMsidMap(e,t,n){if(e===Ri.VIDEO){if(!this.videoSourcesToMsidMap.has(n)){const e=`${t}-${this.videoSourcesToMsidMap.size}`;this.videoSourcesToMsidMap.set(n,e)}}else if(!this.audioSourcesToMsidMap.has(n)){const e=`${t}-${this.audioSourcesToMsidMap.size}`;this.audioSourcesToMsidMap.set(n,e)}}transformStreamIdentifiers(e){var t;if(!e||!e.sdp||!e.type)return e;const n=new Lc(e.sdp),i=null===(t=n.selectMedia(Ri.AUDIO))||void 0===t?void 0:t[0];i&&(this._transformMediaIdentifiers(i),this._injectSourceNames(i));const r=n.selectMedia(Ri.VIDEO);for(const e of r)this._transformMediaIdentifiers(e),this._injectSourceNames(e);return this.audioSourcesToMsidMap.clear(),this.videoSourcesToMsidMap.clear(),new RTCSessionDescription({type:e.type,sdp:n.toRawSDP()})}_injectSourceNames(e){var t,n,i;const r=[...new Set(null===(t=e.mLine)||void 0===t||null===(n=t.ssrcs)||void 0===n?void 0:n.map((e=>e.id)))],o=null===(i=e.mLine)||void 0===i?void 0:i.type;if(!o)throw new Error("_transformMediaIdentifiers - no media type in mediaSection");for(const t of r){const n=e.ssrcs.find((e=>e.id===t&&"name"===e.attribute)),i=e.ssrcs.find((e=>e.id===t&&"msid"===e.attribute)).value.split(" ")[0].split("-"),r=i[i.length-2],a=Cc(this.localEndpointId,o,r);if(n||e.ssrcs.push({id:t,attribute:"name",value:a}),o===Ri.VIDEO){var s;const n=null===(s=this.tpc.getLocalVideoTracks().find((e=>e.getSourceName()===a)))||void 0===s?void 0:s.getVideoType();n&&e.ssrcs.push({id:t,attribute:"videoType",value:n})}}}}const Vc=(0,E.getLogger)("modules/sdp/RtxModifier.js");function Uc(e,t,n){const i=t.id,r=t.msid,o=t.cname,s=e.getRtxSSRC(i);s!==n&&(s&&(e.removeSSRC(s),e.removeGroupsWithSSRC(s)),e.addSSRCAttribute({id:n,attribute:"cname",value:o}),r&&e.addSSRCAttribute({id:n,attribute:"msid",value:r}),e.addSSRCGroup({semantics:"FID",ssrcs:`${i} ${n}`}))}class Hc{constructor(){this.correspondingRtxSsrcs=new Map}clearSsrcCache(){this.correspondingRtxSsrcs.clear()}setSsrcCache(e){Vc.debug("Setting ssrc cache to ",e),this.correspondingRtxSsrcs=e}modifyRtxSsrcs(e){let t=!1;const n=new Lc(e),i=n.selectMedia(Ri.VIDEO);if(null==i||!i.length)return Vc.debug(`No \'video\' media found in the sdp: ${e}`),e;for(const e of i)this.modifyRtxSsrcs2(e)&&(t=!0);return t?n.toRawSDP():e}modifyRtxSsrcs2(e){if(e.direction===As.RECVONLY)return!1;if(e.getSSRCCount()<1)return!1;const t=e.getPrimaryVideoSSRCs();for(const n of t){const t=e.getSSRCAttrValue(n,"msid"),i=e.getSSRCAttrValue(n,"cname");let r=this.correspondingRtxSsrcs.get(n);if(!r){r=e.getRtxSSRC(n)||Ns.generateSsrc(),this.correspondingRtxSsrcs.set(n,r)}Uc(e,{id:n,cname:i,msid:t},r)}return!0}stripRtx(e){const t=new Lc(e),n=t.selectMedia(Ri.VIDEO);if(null==n||!n.length)return Vc.debug(`No \'video\' media found in the sdp: ${e}`),e;for(const e of n)if(e.direction!==As.RECVONLY&&e.getSSRCCount()&&e.containsAnySSRCGroups()){const t=e.findGroups("FID");e.removeGroupsBySemantics("FID");for(const n of t){const t=kc(n);e.removeSSRC(t)}}return t.toRawSDP()}}class $c{constructor(){this._ssrcCache=new Map,this._numOfLayers=wc.length}_fillSsrcsFromCache(e){const t=e.mid,n=this._ssrcCache.get(t),i=this._parseSimLayers(e),r=this._getSsrcAttribute(e,i[0],"msid"),o=this._getSsrcAttribute(e,i[0],"cname");e.ssrcs=[],e.ssrcGroups=[];for(const t of n)e.ssrcs.push({id:t,attribute:"msid",value:r}),e.ssrcs.push({id:t,attribute:"cname",value:o});return e.ssrcGroups.push({semantics:"SIM",ssrcs:n.join(" ")}),e}_generateNewSsrcsForSimulcast(e,t){const n=this._getSsrcAttribute(e,t,"cname");let i=this._getSsrcAttribute(e,t,"msid");const r=(e,t)=>{e.ssrcs.push({id:t,attribute:"cname",value:n}),e.ssrcs.push({id:t,attribute:"msid",value:i})};i||(i=e.msid,e.ssrcs.forEach((t=>{e.ssrcs.push({id:t.id,attribute:"msid",value:i})})));const o=[];for(let t=0;t<this._numOfLayers-1;++t){const t=this._generateSsrc();r(e,t),o.push(t)}return e.ssrcGroups=e.ssrcGroups||[],e.ssrcGroups.push({semantics:"SIM",ssrcs:t+" "+o.join(" ")}),e}_generateSsrc(){return Math.floor(4294967295*Math.random())}_getSsrcAttribute(e,t,n){var i,r;return null===(i=e.ssrcs)||void 0===i||null===(r=i.find((e=>Number(e.id)===t&&e.attribute===n)))||void 0===r?void 0:r.value}_parseSimLayers(e){var t,n;const i=null===(t=e.ssrcGroups)||void 0===t?void 0:t.find((e=>"SIM"===e.semantics));return i?i.ssrcs.split(" ").map((e=>Number(e))):null!==(n=e.ssrcs)&&void 0!==n&&n.length?[Number(e.ssrcs[0].id)]:null}mungeLocalDescription(e){if(!e||!e.sdp)return e;const t=Ps.parse(e.sdp);for(let e of t.media){var n,i,r;if(e.direction===As.RECVONLY||e.direction===As.INACTIVE)continue;if(e.type!==Ri.VIDEO)continue;const t=e.mid,s=new Set(null===(n=e.ssrcs)||void 0===n?void 0:n.map((e=>e.id))),a=null!==(i=null===(r=e.ssrcGroups)||void 0===r?void 0:r.length)&&void 0!==i?i:0;let d;if(!(0===s.size||s.size>2||2===s.size&&0===a)){if(1===s.size){var o;d=Number(null===(o=e.ssrcs[0])||void 0===o?void 0:o.id)}else{const t=e.ssrcGroups.find((e=>"FID"===e.semantics));t&&(d=Number(t.ssrcs.split(" ")[0]))}if(this._ssrcCache.has(t))e=this._fillSsrcsFromCache(e);else{e=this._generateNewSsrcsForSimulcast(e,d);const n=this._parseSimLayers(e);this._ssrcCache.set(t,n)}}}return new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})}}let Jc;!function(e){e.ACTIVE="active",e.INACTIVE="inactive",e.INTERRUPTED="interrupted",e.RESTORING="restoring"}(Jc||(Jc={}));const Bc=(0,E.getLogger)("modules/connectivity/TrackStreamingStatus.ts");class qc{static _getNewStateForJvbMode(e,t,n,i){return n?Jc.ACTIVE:ci.supportsVideoMuteOnConnInterrupted()||i?i?e?t?Jc.INTERRUPTED:Jc.RESTORING:Jc.INACTIVE:Jc.ACTIVE:e?Jc.ACTIVE:Jc.INACTIVE}static _getNewStateForP2PMode(e,t){return ci.supportsVideoMuteOnConnInterrupted()||t?e||!t?Jc.ACTIVE:Jc.INTERRUPTED:Jc.ACTIVE}constructor(e,t,n,i){this.rtc=e,this.conference=t,this.track=n,this.restoringTimer=null,this.rtcMutedTimestamp=null,this.streamingStatusMap={},this.trackTimer=null,this._lastFramesDecoded=null,this._lastFramesDecodedAt=null,this._statsTrackFrozen=!1,this.outOfForwardedSourcesTimeout="number"==typeof i.outOfForwardedSourcesTimeout?i.outOfForwardedSourcesTimeout:500,this.p2pRtcMuteTimeout="number"==typeof i.p2pRtcMuteTimeout?i.p2pRtcMuteTimeout:2500,this.rtcMuteTimeout="number"==typeof i.rtcMuteTimeout?i.rtcMuteTimeout:1e4,Bc.info(`RtcMuteTimeout set to: ${this.rtcMuteTimeout}`)}_getVideoFrozenTimeout(){const e=this.track.getSourceName();return this.rtc.isInForwardedSources(e)?this.rtcMuteTimeout:this.conference.isP2PActive()?this.p2pRtcMuteTimeout:this.outOfForwardedSourcesTimeout}init(){this._onP2PStatus=this.figureOutStreamingStatus.bind(this),this.conference.on(B.P2P_STATUS,this._onP2PStatus),this._onUserLeft=this.onUserLeft.bind(this),this.conference.on(B.USER_LEFT,this._onUserLeft),ci.supportsVideoMuteOnConnInterrupted()&&(this._onTrackRtcMuted=this.onTrackRtcMuted.bind(this),this.rtc.addListener(ji.default.REMOTE_TRACK_MUTE,this._onTrackRtcMuted),this._onTrackRtcUnmuted=this.onTrackRtcUnmuted.bind(this),this.rtc.addListener(ji.default.REMOTE_TRACK_UNMUTE,this._onTrackRtcUnmuted),this._onSignallingMuteChanged=this.onSignallingMuteChanged.bind(this),this.track.on(Rt,this._onSignallingMuteChanged),this._onTrackVideoTypeChanged=this.onTrackVideoTypeChanged.bind(this),this.track.on(At,this._onTrackVideoTypeChanged)),this._onForwardedSourcesChanged=this.onForwardedSourcesChanged.bind(this),this.conference.on(B.FORWARDED_SOURCES_CHANGED,this._onForwardedSourcesChanged),this._onLastNValueChanged=this.figureOutStreamingStatus.bind(this),this.rtc.on(ji.default.LASTN_VALUE_CHANGED,this._onLastNValueChanged),!ci.supportsVideoMuteOnConnInterrupted()&&this.track.isVideoTrack()&&(this._onConnectionStats=(e,t)=>this._handleFramesDecodedUpdate(t),this.conference.statistics.addConnectionStatsListener(this._onConnectionStats))}dispose(){ci.supportsVideoMuteOnConnInterrupted()?(this.rtc.removeListener(ji.default.REMOTE_TRACK_MUTE,this._onTrackRtcMuted),this.rtc.removeListener(ji.default.REMOTE_TRACK_UNMUTE,this._onTrackRtcUnmuted),this.track.off(Rt,this._onSignallingMuteChanged),this.track.off(At,this._onTrackVideoTypeChanged)):this.track.isVideoTrack()&&(this.conference.statistics.removeConnectionStatsListener(this._onConnectionStats),this._statsTrackFrozen=!1),this.conference.off(B.FORWARDED_SOURCES_CHANGED,this._onForwardedSourcesChanged),this.conference.off(B.P2P_STATUS,this._onP2PStatus),this.conference.off(B.USER_LEFT,this._onUserLeft),this.rtc.removeListener(ji.default.LASTN_VALUE_CHANGED,this._onLastNValueChanged),this.clearTimeout(),this.clearRtcMutedTimestamp(),this.maybeSendTrackStreamingStatusEvent(Date.now()),this.figureOutStreamingStatus()}_changeStreamingStatus(e){if(this.track.getTrackStreamingStatus()!==e){const t=this.track.getSourceName();this.track._setTrackStreamingStatus(e),Bc.debug(`Emit track streaming status(${Date.now()}) ${t}: ${e}`),this.track.emit(Pt,this.track,e)}}clearTimeout(){this.trackTimer&&(window.clearTimeout(this.trackTimer),this.trackTimer=null)}clearRtcMutedTimestamp(){this.rtcMutedTimestamp=null}isVideoTrackFrozen(){if(this._statsTrackFrozen)return!0;if(!ci.supportsVideoMuteOnConnInterrupted())return!1;const e=this.track.isWebRTCTrackMuted(),t=this.rtcMutedTimestamp,n=this._getVideoFrozenTimeout();return e&&"number"==typeof t&&Date.now()-t>=n}_handleFramesDecodedUpdate(e){var t;if(this.track.isP2P!==this.conference.isP2PActive())return this._lastFramesDecoded=null,this._lastFramesDecodedAt=null,void(this._statsTrackFrozen&&(this._statsTrackFrozen=!1,this.figureOutStreamingStatus()));if(this.track.isMuted()||null==e.framesDecoded)return;const n=this.track.getSSRC(),i=e.framesDecoded.get(n),r=Date.now();if(null==i)null===this._lastFramesDecodedAt&&(this._lastFramesDecodedAt=r);else if(i>(null!==(t=this._lastFramesDecoded)&&void 0!==t?t:-1))return this._lastFramesDecodedAt=r,this._lastFramesDecoded=i,void(this._statsTrackFrozen&&(Bc.debug(`Stats-based freeze cleared for ${this.track.getSourceName()}`),this._statsTrackFrozen=!1,this.figureOutStreamingStatus()));null!==this._lastFramesDecodedAt&&r-this._lastFramesDecodedAt>=this._getVideoFrozenTimeout()&&!this._statsTrackFrozen&&(Bc.debug(`Stats-based freeze detected for ${this.track.getSourceName()}`),this._statsTrackFrozen=!0,this.figureOutStreamingStatus())}figureOutStreamingStatus(){const e=this.track.getSourceName(),t=this.conference.isP2PActive(),n=this._isRestoringTimedout(),i=0===this.conference.getLastN(),r=this.track.isMuted()||i,o=this.isVideoTrackFrozen(),s=this.rtc.isInForwardedSources(e),a=t?qc._getNewStateForP2PMode(r,o):qc._getNewStateForJvbMode(s,n,r,o);a!==Jc.RESTORING&&this._clearRestoringTimer(),Bc.debug(`Figure out conn status for ${e}, is video muted: ${r} video track frozen: ${o} p2p mode: ${t} is in forwarded sources: ${s} currentStatus => newStatus: ${this.track.getTrackStreamingStatus()} => ${a}`);const d=this.streamingStatusMap||{};if(!("p2p"in d)||!("streamingStatus"in d)||d.p2p!==t||d.streamingStatus!==a){const e=Date.now();this.maybeSendTrackStreamingStatusEvent(e),this.streamingStatusMap={...d,streamingStatus:a,p2p:t,startedMs:e},"videoType"in this.streamingStatusMap||(this.streamingStatusMap.videoType=this.track.getVideoType())}this._changeStreamingStatus(a)}maybeSendTrackStreamingStatusEvent(e){const t=this.streamingStatusMap;t&&"startedMs"in t&&"videoType"in t&&"streamingStatus"in t&&"p2p"in t&&(t.value=e-t.startedMs,Mi.sendAnalytics(function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return{type:kt.TYPE_OPERATIONAL,source:"track.streaming.status",action:"duration",attributes:e}}(t)))}onForwardedSourcesChanged(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=arguments.length>2?arguments[2]:void 0;const i=this.track.getSourceName();ci.supportsVideoMuteOnConnInterrupted()||this.figureOutStreamingStatus(),e.includes(i)&&(this.track._clearEnteredForwardedSourcesTimestamp(),this._clearRestoringTimer(),ci.supportsVideoMuteOnConnInterrupted()&&this.figureOutStreamingStatus()),t.includes(i)&&(this.track._setEnteredForwardedSourcesTimestamp(n),ci.supportsVideoMuteOnConnInterrupted()&&this.figureOutStreamingStatus())}_clearRestoringTimer(){const e=this.restoringTimer;e&&(clearTimeout(e),this.restoringTimer=null)}_isRestoringTimedout(){const e=this.track._getEnteredForwardedSourcesTimestamp();return!!(e&&Date.now()-e>=1e4)||(this.restoringTimer||(this.restoringTimer=setTimeout((()=>this.figureOutStreamingStatus()),1e4)),!1)}_isCurrentTrack(e){return e.getSourceName()===this.track.getSourceName()}onUserLeft(e){this.track.getParticipantId()===e&&(this.maybeSendTrackStreamingStatusEvent(Date.now()),this.streamingStatusMap={})}onTrackRtcMuted(e){if(!this._isCurrentTrack(e))return;const t=e.getSourceName();if(Bc.debug(`Detector track RTC muted: ${t}`,Date.now()),this.rtcMutedTimestamp=Date.now(),!e.isMuted()){this.clearTimeout();const e=this._getVideoFrozenTimeout();this.trackTimer=window.setTimeout((()=>{Bc.debug(`Set track RTC muted for: ${t} after the timeout of ${e} ms`),this.clearTimeout(),this.figureOutStreamingStatus()}),e)}}onTrackRtcUnmuted(e){if(!this._isCurrentTrack(e))return;const t=this.track.getSourceName();Bc.debug(`Detector track RTC unmuted: ${t}`,Date.now()),this.clearTimeout(),this.clearRtcMutedTimestamp(),this.figureOutStreamingStatus()}onSignallingMuteChanged(e){this._isCurrentTrack(e)&&(this.track.getSourceName(),this.figureOutStreamingStatus())}onTrackVideoTypeChanged(e){const t=Date.now();this.maybeSendTrackStreamingStatusEvent(t),this.streamingStatusMap={...this.streamingStatusMap||{},videoType:e,startedMs:t}}}const Gc=qc,zc=n(810).getLogger("modules/RTC/JitsiRemoteTrack.js"),Kc=n(987);let Wc=!1,Xc=!1;const Yc=["abort","canplaythrough","ended","error","stalled","suspend","waiting"];class Qc extends oc{constructor(e,t,n,i,r,o,s,a,d,c,l){if(super(t,i,r,(()=>{}),o,s),this.rtc=e,"number"!=typeof a)throw new TypeError(`SSRC ${a} is not a number`);this.ssrc=a,this.ownerEndpointId=n,this.muted=d,this.isP2P=c,this._sourceName=l,this._trackStreamingStatus=null,this._trackStreamingStatusImpl=null,this._enteredForwardedSourcesTimestamp=null,this.addEventListener=this.on=this._addEventListener.bind(this),this.removeEventListener=this.off=this._removeEventListener.bind(this),zc.debug(`New remote track created: ${this}`),this.hasBeenMuted=d,this.rtc&&this.track&&this._bindTrackHandlers(),this._containerHandlers={},Yc.forEach((e=>{this._containerHandlers[e]=this._containerEventHandler.bind(this,e)}))}_bindTrackHandlers(){this.track.addEventListener("mute",(()=>this._onTrackMute())),this.track.addEventListener("unmute",(()=>this._onTrackUnmute())),this.track.addEventListener("ended",(()=>{zc.debug(`"onended" event(${Date.now()}): ${this}`)}))}_addEventListener(e,t){super.addListener(e,t),e===Pt&&this.listenerCount(Pt)&&!this._trackStreamingStatusImpl&&(this._initTrackStreamingStatus(),zc.debug(`Initializing track streaming status: ${this._sourceName}`))}_removeEventListener(e,t){super.removeListener(e,t),e!==Pt||this.listenerCount(Pt)||(this._disposeTrackStreamingStatus(),zc.debug(`Disposing track streaming status: ${this._sourceName}`))}_onTrackMute(){zc.debug(`"onmute" event(${Date.now()}): ${this}`),this.videoType!==Qo.VideoType.DESKTOP?this.rtc.eventEmitter.emit(Kc.REMOTE_TRACK_MUTE,this):zc.debug("Ignoring mute event on desktop tracks.")}_onTrackUnmute(){zc.debug(`"onunmute" event(${Date.now()}): ${this}`),this.rtc.eventEmitter.emit(Kc.REMOTE_TRACK_UNMUTE,this)}dispose(){return this._disposeTrackStreamingStatus(),super.dispose()}setMute(e){this.muted!==e&&(e&&(this.hasBeenMuted=!0),this.stream&&(this.stream.muted=e),this.muted=e,zc.info(`Mute ${this}: ${e}`),this.emit(Rt,this))}isMuted(){return this.muted}getParticipantId(){return this.ownerEndpointId}isLocal(){return!1}getSSRC(){return this.ssrc}getSourceName(){return this._sourceName}setOwner(e){this.ownerEndpointId=e,this.emit(Dt,e)}setSourceName(e){this._sourceName=e}_setVideoType(e){this.videoType!==e&&(this.videoType=e,this.emit(At,e))}_playCallback(){if(!this.conference.room)return;const e=this.isVideoTrack()?"video":"audio",t=window.performance.now();zc.info(`(TIME) Render ${e}:\\t`,t),this.conference.getConnectionTimes()[`${e}.render`]=t;const n=window.connectionTimes["obtainPermissions.start"],i=window.connectionTimes["obtainPermissions.end"],r=isNaN(i)||isNaN(n)?0:i-n,o=t-(this.conference.getConnectionTimes()["session.initiate"]-this.conference.getConnectionTimes()["muc.joined"])-r;var s;this.conference.getConnectionTimes()[`${e}.ttfm`]=o,zc.info(`(TIME) TTFM ${e}:\\t`,o),Mi.sendAnalytics((s={media_type:e,muted:this.hasBeenMuted,value:o},sn("ttfm",s)))}_attachTTFMTracker(e){Wc&&this.isAudioTrack()||Xc&&this.isVideoTrack()||(this.isAudioTrack()&&(Wc=!0),this.isVideoTrack()&&(Xc=!0),e.addEventListener("canplay",this._playCallback.bind(this)))}_onTrackAttach(e){Yc.forEach((t=>{e.addEventListener(t,this._containerHandlers[t])}))}_onTrackDetach(e){Yc.forEach((t=>{e.removeEventListener(t,this._containerHandlers[t])}))}_containerEventHandler(e){zc.debug(`${e} handler was called for a container with attached ${this}`)}_getStatus(){const{enabled:e,muted:t,readyState:n}=this.track;return`readyState: ${n}, muted: ${t}, enabled: ${e}`}_initTrackStreamingStatus(){const e=this.conference.options.config;this._trackStreamingStatus=Jc.ACTIVE,this._trackStreamingStatusImpl=new Gc(this.rtc,this.conference,this,{p2pRtcMuteTimeout:e._p2pConnStatusRtcMuteTimeout,rtcMuteTimeout:e._peerConnStatusRtcMuteTimeout,outOfForwardedSourcesTimeout:e._peerConnStatusOutOfLastNTimeout}),this._trackStreamingStatusImpl.init(),!this._trackStreamingStatusImpl.isVideoTrackFrozen()&&this.rtc.eventEmitter.emit(Pt,this,this._trackStreamingStatus)}_disposeTrackStreamingStatus(){this._trackStreamingStatusImpl&&(this._trackStreamingStatusImpl.dispose(),this._trackStreamingStatusImpl=null,this._trackStreamingStatus=null)}_setTrackStreamingStatus(e){this._trackStreamingStatus=e}getTrackStreamingStatus(){return this._trackStreamingStatus}_clearEnteredForwardedSourcesTimestamp(){this._enteredForwardedSourcesTimestamp=null}_setEnteredForwardedSourcesTimestamp(e){this._enteredForwardedSourcesTimestamp=e}_getEnteredForwardedSourcesTimestamp(){return this._enteredForwardedSourcesTimestamp}toString(){return`RemoteTrack[userID: ${this.getParticipantId()}, type: ${this.getType()}, ssrc: ${this.getSSRC()}, p2p: ${this.isP2P}, sourceName: ${this._sourceName}, status: {${this._getStatus()}}]`}}let Zc;!function(e){e.L1T3="L1T3",e.L2T3="L2T3",e.L2T3_KEY="L2T3_KEY",e.L3T3="L3T3",e.L3T3_KEY="L3T3_KEY"}(Zc||(Zc={}));const el=(0,E.getLogger)("modules/RTC/TPCUtils.js"),tl=[Ds.AV1,Ds.H264,Ds.VP8,Ds.VP9];class nl{constructor(e){var t;this.pc=e,this.codecSettings=Ss()(Ic);const n=null===(t=this.pc.options)||void 0===t?void 0:t.videoQuality;if(n)for(const e of tl){var i;const t=n[e],r=null!==(i=null==t?void 0:t.maxBitratesVideo)&&void 0!==i?i:n.maxbitratesvideo&&n.maxbitratesvideo[e.toUpperCase()];r&&[...Object.values(Dc),"ssHigh"].forEach((t=>{r[t]&&(this.codecSettings[e].maxBitratesVideo[t]=r[t])})),t&&(this.codecSettings[e].scalabilityModeEnabled&&(void 0===t.scalabilityModeEnabled||t.scalabilityModeEnabled)?(void 0!==t.useSimulcast&&(this.codecSettings[e].useSimulcast=t.useSimulcast),void 0!==t.useKSVC&&(this.codecSettings[e].useKSVC=t.useKSVC)):this.codecSettings[e].scalabilityModeEnabled=!1)}}_calculateActiveEncodingParams(e,t,n){var i,r;const o=this.codecSettings[t].maxBitratesVideo,s=e.getCaptureResolution(),a=n>s?s:n,d=(null===(i=this.pc.options)||void 0===i||null===(r=i.videoQuality)||void 0===r?void 0:r.desktopbitrate)||o.ssHigh,c=e.getVideoType()===Qo.VideoType.DESKTOP;let l=this.codecSettings[t].useKSVC?Zc.L3T3_KEY:Zc.L3T3;const{height:h,level:u}=Pc.find((e=>e.height<=a));let p,m=wc[2].scaleFactor;this._isScreenshareBitrateCapped(e)?(l=Zc.L1T3,p=d):c?p=o.ssHigh:(p=o[u],a&&(m=s/a),h!==a&&el.debug(`Quality level with height=${h} was picked when requested height=${n} fortrack with capture height=${s}`));const g={active:a>0,maxBitrate:p,scalabilityMode:l,scaleResolutionDownBy:m};if(!g.active||c)return g;switch(u){case Dc.ULTRA:case Dc.FULL:case Dc.HIGH:g.scalabilityMode=this.codecSettings[t].useKSVC?Zc.L3T3_KEY:Zc.L3T3;break;case Dc.STANDARD:g.scalabilityMode=this.codecSettings[t].useKSVC?Zc.L2T3_KEY:Zc.L2T3;break;default:g.scalabilityMode=Zc.L1T3}return g}_configureSenderEncodings(e){var t,n;const i=e.getType(),r=null!=e&&e.track&&e.getOriginalStream()?this.pc.peerconnection.getTransceivers().find((t=>{var n,i;return(null===(n=t.sender)||void 0===n||null===(i=n.track)||void 0===i?void 0:i.id)===e.getTrackId()})):this.pc.peerconnection.getTransceivers().find((e=>{var t,n;return(null===(t=e.receiver)||void 0===t||null===(n=t.track)||void 0===n?void 0:n.kind)===i})),o=null==r||null===(t=r.sender)||void 0===t?void 0:t.getParameters();return null!=o&&null!==(n=o.encodings)&&void 0!==n&&n.length?(o.encodings=this._getStreamEncodings(e),r.sender.setParameters(o)):Promise.resolve()}_enableSenderEncodings(e,t){var n;const i=e.getParameters();if(null!=i&&null!==(n=i.encodings)&&void 0!==n&&n.length)for(const e of i.encodings)e.active=t;return e.setParameters(i)}_getStreamEncodings(e){if(e.isAudioTrack())return[{active:this.pc.audioTransferActive}];const t=this.pc.getConfiguredVideoCodec();return this.pc.isSpatialScalabilityOn()?this._getVideoStreamEncodings(e,t):[{active:this.pc.videoTransferActive,maxBitrate:this.codecSettings[t].maxBitratesVideo.high}]}_getVideoStreamEncodings(e,t){const n=e.getCaptureResolution(),i=this.codecSettings[t].maxBitratesVideo,r=e.getVideoType();let o,s=wc.map((e=>e.scaleFactor));if(r===Qo.VideoType.CAMERA){const{level:e}=Pc.find((e=>e.height<=n));o=i[e],e===Dc.ULTRA?(s[1]=6,s[0]=12):e===Dc.FULL&&(s[1]=3,s[0]=6)}const a=r===Qo.VideoType.DESKTOP?i.ssHigh:o;let d=[i.low,i.standard,a];ci.isFirefox()&&(r===Qo.VideoType.DESKTOP||ci.isVersionLessThan(117))&&(d=d.reverse(),s=s.reverse());const c=[{active:this.pc.videoTransferActive,maxBitrate:d[0],rid:wc[0].rid,scaleResolutionDownBy:s[0]},{active:this.pc.videoTransferActive,maxBitrate:d[1],rid:wc[1].rid,scaleResolutionDownBy:s[1]},{active:this.pc.videoTransferActive,maxBitrate:d[2],rid:wc[2].rid,scaleResolutionDownBy:s[2]}];if(this.codecSettings[t].scalabilityModeEnabled){if(this.codecSettings[t].useSimulcast||t===Ds.H264){for(const e of c)e.scalabilityMode=Zc.L1T3;return c}return[{active:this.pc.videoTransferActive,maxBitrate:d[2],rid:wc[0].rid,scaleResolutionDownBy:s[2],scalabilityMode:this.codecSettings[t].useKSVC?Zc.L3T3_KEY:Zc.L3T3},{active:!1,maxBitrate:0},{active:!1,maxBitrate:0}]}return c}_isRunningInFullSvcMode(e){return(e===Ds.VP9||e===Ds.AV1)&&this.codecSettings[e].scalabilityModeEnabled&&!this.codecSettings[e].useSimulcast}_isScreenshareBitrateCapped(e){return e.getVideoType()===Qo.VideoType.DESKTOP&&this.pc._capScreenshareBitrate&&!ci.isWebKitBased()}_updateSenderEncodings(e,t){var n;const i=e.getParameters();if(null!=i&&null!==(n=i.encodings)&&void 0!==n&&n.length)for(const e of i.encodings)e.active=t;return e.setParameters(i)}addTrack(e,t){const n=e.getTrack();if(t){const t=[];e.getOriginalStream()&&t.push(e.getOriginalStream());const i={direction:As.SENDRECV,streams:t,sendEncodings:[]};ci.isFirefox()||(i.sendEncodings=this._getStreamEncodings(e)),this.pc.peerconnection.addTransceiver(n,i)}else this.pc.peerconnection.addTrack(n)}calculateEncodingsActiveState(e,t,n){const i=e.getCaptureResolution(),r=this._getVideoStreamEncodings(e,t);return r.map((e=>i/e.scaleResolutionDownBy)).map(((i,o)=>{let s=!1;if(!this.pc.videoTransferActive)return s;if(!this.pc.isSpatialScalabilityOn()||this._isRunningInFullSvcMode(t)){const{active:i}=this._calculateActiveEncodingParams(e,t,n);return 0===o?i:s}var a;return n>0&&(s=e.getVideoType()===Qo.VideoType.CAMERA?i<=n||(null===(a=r[o])||void 0===a?void 0:a.scaleResolutionDownBy)===wc[0].scaleFactor:r[o].scaleResolutionDownBy===wc[2].scaleFactor||!this._isScreenshareBitrateCapped(e)),s}))}calculateEncodingsBitrates(e,t,n){var i,r;const o=this.codecSettings[t].maxBitratesVideo,s=(null===(i=this.pc.options)||void 0===i||null===(r=i.videoQuality)||void 0===r?void 0:r.desktopbitrate)||o.ssHigh;return this._getVideoStreamEncodings(e,t).map(((i,r)=>{let o=i.maxBitrate;if(!this.pc.isSpatialScalabilityOn()||this._isRunningInFullSvcMode(t)){const{maxBitrate:i}=this._calculateActiveEncodingParams(e,t,n);return 0===r?i:0}return this._isScreenshareBitrateCapped(e)&&(o=s),o}))}calculateEncodingsScalabilityMode(e,t,n){if(!this.pc.isSpatialScalabilityOn()||!this.codecSettings[t].scalabilityModeEnabled)return;const i=[Zc.L1T3,Zc.L1T3,Zc.L1T3];if(this._isRunningInFullSvcMode(t)){const{scalabilityMode:r}=this._calculateActiveEncodingParams(e,t,n);return i[0]=r,i[1]=void 0,i[2]=void 0,i}return i}calculateEncodingsScaleFactor(e,t,n){if(this.pc.isSpatialScalabilityOn()&&this.isRunningInSimulcastMode(t))return this._getVideoStreamEncodings(e,t).map((e=>e.scaleResolutionDownBy));const{scaleResolutionDownBy:i}=this._calculateActiveEncodingParams(e,t,n);return[i,void 0,void 0]}ensureCorrectOrderOfSsrcs(e){const t=Ps.parse(e.sdp);return t.media.forEach((e=>{if(e.type===Ri.AUDIO)return;if(!e.ssrcGroups||!e.ssrcGroups.length)return;let t=[];const n=new Set;e.ssrcGroups.map((e=>e.ssrcs.split(" ").filter(Boolean).forEach((e=>n.add(e))))),n.forEach((n=>{const i=e.ssrcs.filter((e=>e.id.toString()===n));t=t.concat(i)})),e.ssrcs=t})),new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})}insertUnifiedPlanSimulcastReceive(e){if(ci.usesSdpMungingForSimulcast())return e;const t=[{id:wc[0].rid,direction:"recv"},{id:wc[1].rid,direction:"recv"},{id:wc[2].rid,direction:"recv"}],n=`recv ${t.map((e=>e.id)).join(";")}`,i=Ps.parse(e.sdp),r=i.media.filter((e=>e.type===Ri.VIDEO)),o=Array.from(this.pc._localTrackTransceiverMids.values());return r.forEach(((e,i)=>{o.find((t=>e.mid.toString()===t.toString()))||0===i?e.simulcast_03&&e.simulcast||(e.rids=t,e.simulcast_03={value:n}):(e.rids=void 0,e.simulcast=void 0,e.simulcast_03=void 0)})),new RTCSessionDescription({type:e.type,sdp:Ps.write(i)})}isRunningInSimulcastMode(e){return e===Ds.VP8||!this.codecSettings[e].scalabilityModeEnabled&&e===Ds.VP9||this.codecSettings[e].scalabilityModeEnabled&&(e===Ds.H264||this.codecSettings[e].useSimulcast)}replaceTrack(e,t){var n,i;const r=null!==(n=null==t?void 0:t.getType())&&void 0!==n?n:null==e?void 0:e.getType(),o=this.pc.getLocalTracks(r),s=null!==(i=null==t?void 0:t.getTrack())&&void 0!==i?i:null,a=(null==o?void 0:o.length)&&!e&&t&&!o.find((e=>e===t));let d;if(e&&!e.isMuted())d=this.pc.peerconnection.getTransceivers().find((t=>t.sender.track===e.getTrack()));else if(a)d=this.pc.peerconnection.getTransceivers().find((e=>e.receiver.track.kind===r&&e.direction===As.RECVONLY&&(this.pc.isP2P&&e.currentDirection===As.RECVONLY||e.currentDirection===As.INACTIVE&&!e.stopped)));else{var c;d=this.pc.peerconnection.getTransceivers().find((e=>e.receiver.track.kind===r));const n=null!==(c=null==t?void 0:t.getSourceName())&&void 0!==c?c:null==e?void 0:e.getSourceName();if(n){const t=Rc(n);if(this.pc.isP2P)d=this.pc.peerconnection.getTransceivers().filter((e=>e.receiver.track.kind===r))[t];else if(e){const t=this.pc._localTrackTransceiverMids.get(e.rtcId);d=this.pc.peerconnection.getTransceivers().find((e=>e.mid===t))}else t&&(d=this.pc.peerconnection.getTransceivers().filter((e=>e.receiver.track.kind===r&&e.direction!==As.RECVONLY))[t])}}return d?(el.debug(`${this.pc} Replacing ${e} with ${t}`),d.sender.replaceTrack(s).then((()=>Promise.resolve(d)))):Promise.reject(new Error(`Replace track failed - no transceiver for old: ${e}, new: ${t}`))}setEncodings(e){return e.getType()===Ri.VIDEO?this.pc._updateVideoSenderParameters((()=>this._configureSenderEncodings(e))):this._configureSenderEncodings(e)}setMediaTransferActive(e,t){el.info(`${this.pc} ${e?"Resuming":"Suspending"} media transfer.`);const n=this.pc.peerconnection.getSenders().filter((e=>Boolean(e.track)&&(!t||e.track.kind===t))),i=[];for(const t of n)t.track.kind===Ri.VIDEO?i.push(this.pc._updateVideoSenderParameters((()=>this._enableSenderEncodings(t,e)))):i.push(this._enableSenderEncodings(t,e));return Promise.allSettled(i).then((e=>{const t=e.filter((e=>"rejected"===e.status)).map((e=>e.reason));return t.length?Promise.reject(new Error(`Failed to change encodings on the RTCRtpSenders${t.join(" ")}`)):Promise.resolve()}))}}const il=(0,E.getLogger)("modules/RTC/TraceablePeerConnection.js"),rl="https://aomediacodec.github.io/av1-rtp-spec/#dependency-descriptor-rtp-header-extension";function ol(e,t,n,i,r,o,s){this.audioTransferActive=!(!0===s.startSilent),this._dtmfSender=void 0,this._dtmfTonesQueue=[],this.videoTransferActive=!0,this.rtc=e,this.id=t,this.isP2P=o,this.remoteTracks=new Map,this.localTracks=new Map,this.localSSRCs=new Map,this.remoteSSRCs=new Set,this.remoteSources=new Map,this.localUfrag=null,this.remoteUfrag=null,this._dtlsTransport=null,this.signalingLayer=n,this._peerVideoTypeChanged=this._peerVideoTypeChanged.bind(this),this.signalingLayer.on(Ec,this._peerVideoTypeChanged),this._peerMutedChanged=this._peerMutedChanged.bind(this),this.signalingLayer.on(yc,this._peerMutedChanged),this.options=s,this.signalingLayer.on(Sc,((e,t)=>this._sourceMutedChanged(e,t))),this.signalingLayer.on(Tc,((e,t)=>this._sourceVideoTypeChanged(e,t)));const a=r||{};a.optional=a.optional||[],Array.isArray(a.optional)?a.optional.push({rtcStatsSFUP2P:this.isP2P}):il.warn("Optional param is not an array, rtcstats p2p data is omitted."),this.peerconnection=new RTCPeerConnection(i,a),this.tpcUtils=new nl(this),this.updateLog=[],this.stats={},this.statsinterval=null,this._capScreenshareBitrate=this.options.capScreenshareBitrate,this.codecSettings=this.options.codecSettings,ci.supportsCodecPreferences()&&il.info("Using RTCRtpTransceiver#setCodecPreferences for codec selection"),this._hasHadAudioTrack=!1,this._hasHadVideoTrack=!1,this.maxstats=s.maxstats,this.interop=new vc,this.simulcast=new $c,this.localSdpMunger=new jc(this,this.rtc.getLocalEndpointId()),this.eventEmitter=e.eventEmitter,this.rtxModifier=new Hc,this._senderMaxHeights=new Map,this._supportsDDHeaderExt=!1,this._localTrackTransceiverMids=new Map,this.trace=(e,t)=>{il.trace(e,t),this.updateLog.push({time:new Date,type:e,value:t||""})},this.onicecandidate=null,this.peerconnection.onicecandidate=e=>{this.trace("onicecandidate",JSON.stringify(e.candidate,null," ")),null!==this.onicecandidate&&this.onicecandidate(e)},this.onTrack=e=>{const t=e.streams[0];this._remoteTrackAdded(t,e.track,e.transceiver),t.addEventListener("removetrack",(e=>{this._remoteTrackRemoved(t,e.track)}))},this.peerconnection.addEventListener("track",this.onTrack),this.onsignalingstatechange=null,this.peerconnection.onsignalingstatechange=e=>{this.trace("onsignalingstatechange",this.signalingState),null!==this.onsignalingstatechange&&this.onsignalingstatechange(e)},this.oniceconnectionstatechange=null,this.peerconnection.oniceconnectionstatechange=e=>{this.trace("oniceconnectionstatechange",this.iceConnectionState),null!==this.oniceconnectionstatechange&&this.oniceconnectionstatechange(e)},this.onnegotiationneeded=null,this.peerconnection.onnegotiationneeded=e=>{this.trace("onnegotiationneeded"),null!==this.onnegotiationneeded&&this.onnegotiationneeded(e)},this.onconnectionstatechange=null,this.peerconnection.onconnectionstatechange=e=>{this.trace("onconnectionstatechange",this.connectionState),null!==this.onconnectionstatechange&&this.onconnectionstatechange(e)},this.ondatachannel=null,this.peerconnection.ondatachannel=e=>{this.trace("ondatachannel"),null!==this.ondatachannel&&this.ondatachannel(e)},this.maxstats&&(this.statsinterval=window.setInterval((()=>{this.getStats().then((e=>{if("function"==typeof(null==e?void 0:e.result)){const t=e.result();for(let e=0;e<t.length;++e){const n=t[e];n.names().forEach((e=>{this._processStat(n,e,n.stat(e))}))}}else e.forEach((e=>this._processStat(e,"",e)))}))}),1e3)),this._lastVideoSenderUpdatePromise=Promise.resolve(),il.info(`Create new ${this}`)}ol.prototype._processStat=function(e,t,n){const i=`${e.id}-${t}`;let r=this.stats[i];const o=new Date;r||(this.stats[i]=r={startTime:o,endTime:o,values:[],times:[]}),r.values.push(n),r.times.push(o.getTime()),r.values.length>this.maxstats&&(r.values.shift(),r.times.shift()),r.endTime=o};const sl=function(e){return null==e?"":`type: ${e.type}\\r\\n${e.sdp}`};ol.prototype.getConnectionState=function(){const e=this.peerconnection.iceConnectionState;return"completed"===e?"connected":e},ol.prototype.getDesiredMediaDirection=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];const n=this.hasAnyTracksOfType(e);return t?n?As.SENDRECV:As.SENDONLY:n?As.RECVONLY:As.INACTIVE},ol.prototype._getReceiversByEndpointIds=function(e,t){let n=[],i=[];for(const i of e)n=n.concat(this.getRemoteTracks(i,t));const r=n.map((e=>{var t;return null===(t=e.track)||void 0===t?void 0:t.id}));return i=this.peerconnection.getReceivers().filter((e=>e.track&&e.track.kind===t&&r.find((t=>t===e.track.id)))),i},ol.prototype.isSpatialScalabilityOn=function(){const e=this.tpcUtils.codecSettings[Ds.H264].scalabilityModeEnabled&&this._supportsDDHeaderExt;return!this.options.disableSimulcast&&(this.codecSettings.codecList[0]!==Ds.H264||e)},ol.prototype._peerVideoTypeChanged=function(e,t){if(!e)return void il.error(`${this} No endpointID on peerVideoTypeChanged`);const n=this.getRemoteTracks(e,Ri.VIDEO);n.length&&n[0]._setVideoType(t)},ol.prototype._peerMutedChanged=function(e,t,n){if(!e)return void il.error(`${this} On peerMuteChanged - no endpoint ID`);const i=this.getRemoteTracks(e,t);i.length&&i[0].setMute(n)},ol.prototype._sourceMutedChanged=function(e,t){const n=this.getRemoteTracks().find((t=>t.getSourceName()===e));n?n.setMute(t):Ai.isSsrcRewritingSupported()&&il.debug(`Remote track not found for source=${e}, mute update failed!`)},ol.prototype._sourceVideoTypeChanged=function(e,t){const n=this.getRemoteTracks().find((t=>t.getSourceName()===e));n&&n._setVideoType(t)},ol.prototype.getAudioLevels=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];const t={};return(e.length?this._getReceiversByEndpointIds(e,Ri.AUDIO):this.peerconnection.getReceivers().filter((e=>e.track&&e.track.kind===Ri.AUDIO&&e.track.enabled))).forEach((e=>{const n=e.getSynchronizationSources();n&&n.length&&(t[n[0].source]=n[0].audioLevel)})),t},ol.prototype.doesTrueSimulcast=function(){const e=this.getConfiguredVideoCodec();return this.isSpatialScalabilityOn()&&this.tpcUtils.isRunningInSimulcastMode(e)},ol.prototype.getLocalVideoSSRCs=function(e){var t,n,i;const r=[];if(!e||!e.isVideoTrack())return r;const o=this.isSpatialScalabilityOn()?"SIM":"FID";return(null===(t=this.localSSRCs.get(e.rtcId))||void 0===t||null===(n=t.groups)||void 0===n||null===(i=n.find((e=>e.semantics===o)))||void 0===i?void 0:i.ssrcs)||r},ol.prototype.getLocalTracks=function(e){let t=Array.from(this.localTracks.values());return void 0!==e&&(t=t.filter((t=>t.getType()===e))),t},ol.prototype.getLocalVideoTracks=function(){return this.getLocalTracks(Ri.VIDEO)},ol.prototype.hasAnyTracksOfType=function(e){if(!e)throw new Error(\'"mediaType" is required\');return this.getLocalTracks(e).length>0},ol.prototype.getRemoteTracks=function(e,t){let n=[];const i=e?[e]:this.remoteTracks.keys();for(const e of i){const i=this.remoteTracks.get(e);if(i)for(const e of i.keys())t&&t!==e||(n=n.concat(Array.from(i.get(e))))}return n},ol.prototype.getRemoteSourceInfoByParticipant=function(e){const t=[],n=this.getRemoteTracks(e);if(null==n||!n.length)return t;const i=n.map((e=>e.getSSRC())),r=new Ms(this.remoteDescription.sdp);return i.forEach(((e,n)=>{for(const i of r.media){let r="",o=Ns.findLines(i,`a=ssrc:${e}`);if(o.length){t[n]||(t[n]="");const s=Ns.findLines(i,`a=ssrc-group:FID ${e}`);if(s.length){const e=s[0].split(" ")[2];r+=`${s[0]}\\r\\n`,o=o.concat(Ns.findLines(i,`a=ssrc:${e}`))}t[n]+=`${o.join("\\r\\n")}\\r\\n`,t[n]+=r}}})),t},ol.prototype.getTargetVideoBitrates=function(){const e=this.getConfiguredVideoCodec();return this.tpcUtils.codecSettings[e].maxBitratesVideo},ol.prototype.getTrackBySSRC=function(e){if("number"!=typeof e)throw new Error(`SSRC ${e} is not a number`);for(const t of this.localTracks.values())if(this.getLocalSSRC(t)===e)return t;for(const t of this.getRemoteTracks())if(t.getSSRC()===e)return t;return null},ol.prototype.getSsrcByTrackId=function(e){const t=t=>t.getTrack().id===e,n=this.getLocalTracks().find(t);if(n)return this.getLocalSSRC(n);const i=this.getRemoteTracks().find(t);return i?i.getSSRC():null},ol.prototype._remoteTrackAdded=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;const i=e.id,r=t.kind;if(!this.isP2P&&!nc.isUserStreamById(i))return;if(il.info(`${this} Received track event for remote stream[id=${i},type=${r}]`),!r)return void il.error(`MediaType undefined for remote track, stream id: ${i}, track creation failed!`);const o=new Ms(this.peerconnection.remoteDescription.sdp);let s;if(null!=n&&n.mid){const e=n.mid;s=o.media.find((t=>Ns.findLine(t,`a=mid:${e}`)))}else s=o.media.find((e=>{const t=Ns.findLine(e,"a=msid:");return"string"==typeof t&&i===t.substring(7).split(" ")[0]}));if(!s)return void il.error(`Matching media line not found in remote SDP for remote stream[id=${i},type=${r}],track creation failed!`);let a=Ns.findLines(s,"a=ssrc:");if(a=a.filter((e=>-1!==e.indexOf(`msid:${i}`))),!a.length)return void il.error(`No SSRC lines found in remote SDP for remote stream[msid=${i},type=${r}]track creation failed!`);const d=a[0].substring(7).split(" ")[0],c=Number(d),l=this.signalingLayer.getSSRCOwner(c);if(isNaN(c)||c<0)return void il.error(`Invalid SSRC for remote stream[ssrc=${c},id=${i},type=${r}]track creation failed!`);if(!l)return void il.error(`No SSRC owner known for remote stream[ssrc=${c},id=${i},type=${r}]track creation failed!`);const h=this.signalingLayer.getTrackSourceName(c),u=this.signalingLayer.getPeerMediaInfo(l,r,h);let p=!0,m=r===Ri.VIDEO?Qo.VideoType.CAMERA:void 0;u?(p=u.muted,m=u.videoType):il.info(`${this}: no source-info available for ${l}:${h}, assuming default state`),this._createRemoteTrack(l,e,t,r,m,c,p,h)},ol.prototype._createRemoteTrack=function(e,t,n,i,r,o,s,a){il.info(`${this} creating remote track[endpoint=${e},ssrc=${o},type=${i},sourceName=${a}]`);let d=this.remoteTracks.get(e);d||(d=new Map,d.set(Ri.AUDIO,new Set),d.set(Ri.VIDEO,new Set),this.remoteTracks.set(e,d));const c=d.get(i);if(null!=c&&c.size&&Array.from(c).find((e=>e.getTrack()===n)))return void il.info(`${this} ignored duplicated track event for track[endpoint=${e},type=${i}]`);const l=new Qc(this.rtc,this.rtc.conference,e,t,n,i,r,o,s,this.isP2P,a);c.add(l),this.eventEmitter.emit(ji.default.REMOTE_TRACK_ADDED,l,this)},ol.prototype._remoteTrackRemoved=function(e,t){const n=e.id,i=null==t?void 0:t.id;if(!nc.isUserStreamById(n))return;if(!n)return void il.error(`${this} remote track removal failed - no stream ID`);if(!i)return void il.error(`${this} remote track removal failed - no track ID`);const r=this.getRemoteTracks().find((e=>e.getStreamId()===n&&e.getTrackId()===i));r?this._removeRemoteTrack(r):il.error(`${this} remote track removal failed - track not found`)},ol.prototype.removeRemoteTracks=function(e){let t=[];const n=this.remoteTracks.get(e);return n&&(t=t.concat(Array.from(n.get(Ri.AUDIO))),t=t.concat(Array.from(n.get(Ri.VIDEO))),this.remoteTracks.delete(e)),il.debug(`${this} removed remote tracks[endpoint=${e},count=${t.length}`),t},ol.prototype._removeRemoteTrack=function(e){var t;il.info(`${this} Removing remote track stream[id=${e.getStreamId()},trackId=${e.getTrackId()}]`),e.dispose();const n=e.getParticipantId();if(!n&&Ai.isSsrcRewritingSupported())return;const i=this.remoteTracks.get(n);i?null!==(t=i.get(e.getType()))&&void 0!==t&&t.delete(e)||il.error(`${this} Failed to remove ${e} - type mapping messed up ?`):il.error(`${this} removeRemoteTrack: no remote tracks map for endpoint=${n}`),this.eventEmitter.emit(ji.default.REMOTE_TRACK_REMOVED,e)},ol.prototype._extractSSRCMap=function(e){const t=new Map,n=new Map;if("object"!=typeof e||null===e||"string"!=typeof e.sdp)return il.warn("An empty description was passed as an argument"),t;const i=Ps.parse(e.sdp);if(!Array.isArray(i.media))return t;let r=i.media;r=r.filter((e=>e.direction===As.SENDONLY||e.direction===As.SENDRECV));let o=0;for(const e of r){if(!Array.isArray(e.ssrcs))continue;if(Array.isArray(e.ssrcGroups)){for(const t of e.ssrcGroups)if(void 0!==t.semantics&&void 0!==t.ssrcs){const e=t.ssrcs.split(" ").map((e=>parseInt(e,10))),i=e[0];t.ssrcs=e,n.has(i)||n.set(i,[]),n.get(i).push(t)}if(!e.ssrcGroups.find((e=>"SIM"===e.semantics))){const t=e.ssrcGroups.map((e=>e.ssrcs[0]));n.get(t[0]).push({semantics:"SIM",ssrcs:t})}}let i=e.ssrcs;i=i.filter((e=>"cname"===e.attribute));for(const r of i){const i=`${e.type}-${o}`,s=r.id;let a=t.get(i);if(a||(a={ssrcs:[],groups:[],msid:i},t.set(i,a)),a.ssrcs.push(s),n.has(s)){const e=n.get(s);for(const t of e)a.groups.push(t)}}e.type===Ri.VIDEO&&o++}return t},ol.prototype.getLocalSSRC=function(e){const t=this._getSSRC(e.rtcId);return t&&t.ssrcs[0]},ol.prototype._injectSsrcGroupForUnifiedSimulcast=function(e){const t=Ps.parse(e.sdp),n=t.media.find((e=>"video"===e.type));n.ssrcGroups=n.ssrcGroups||[];const i=n.ssrcGroups.filter((e=>"FID"===e.semantics));if(n.simulcast||n.simulcast_03){const t=[];if(i&&i.length?i.forEach((e=>{t.push(e.ssrcs.split(" ")[0])})):n.ssrcs.forEach((e=>{"msid"===e.attribute&&t.push(e.id)})),n.ssrcGroups.find((e=>"SIM"===e.semantics)))return e;for(let e=0;e<t.length;e+=3){const i=t.slice(e,e+3);n.ssrcGroups.push({semantics:"SIM",ssrcs:i.join(" ")})}}return new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})};const al={signalingState(){return this.peerconnection.signalingState},iceConnectionState(){return this.peerconnection.iceConnectionState},connectionState(){return this.peerconnection.connectionState},localDescription(){let e=this.peerconnection.localDescription;return e?(this.trace("getLocalDescription::preTransform",sl(e)),this.isP2P||(e=this.interop.toPlanB(e),this.trace("getLocalDescription::postTransform (Plan B)",sl(e)),e=this._injectSsrcGroupForUnifiedSimulcast(e),this.trace("getLocalDescription::postTransform (inject ssrc group)",sl(e))),e=this.localSdpMunger.transformStreamIdentifiers(e),e):(il.debug(`${this} getLocalDescription no localDescription found`),{})},remoteDescription(){let e=this.peerconnection.remoteDescription;return e?(this.trace("getRemoteDescription::preTransform",sl(e)),this.isP2P?e=this._adjustRemoteMediaDirection(e):(e=this.interop.toPlanB(e),this.trace("getRemoteDescription::postTransform (Plan B)",sl(e))),e):(il.debug(`${this} getRemoteDescription no remoteDescription found`),{})}};Object.keys(al).forEach((e=>{Object.defineProperty(ol.prototype,e,{get:al[e]})})),ol.prototype._getSSRC=function(e){return this.localSSRCs.get(e)},ol.prototype.isSharingLowFpsScreen=function(){return this._isSharingScreen()&&this._capScreenshareBitrate},ol.prototype._isSharingScreen=function(){const e=this.getLocalVideoTracks();return Boolean(e.find((e=>e.videoType===Qo.VideoType.DESKTOP)))},ol.prototype._mungeCodecOrder=function(e){if(!this.codecSettings)return e;const t=Ps.parse(e.sdp),n=t.media.filter((e=>e.type===this.codecSettings.mediaType));if(!n.length)return e;for(const t of n){const n=this.getConfiguredVideoCodecs(e);for(const e of n)this.isP2P&&(e!==Ds.H264&&e!==Ds.VP9||Ns.stripCodec(t,e,!0),e!==Ds.ULPFEC&&e!==Ds.RED||Ns.stripCodec(t,e,!1));for(const e of this.codecSettings.codecList.slice().reverse())Ns.preferCodec(t,e,this.isP2P)}return new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})},ol.prototype._updateAv1DdHeaders=function(e){const t=Ps.parse(e.sdp),n=t.media.filter((e=>e.type===Ri.VIDEO));return n.length&&ci.supportsDDExtHeaders()?(n.forEach(((e,t)=>{var n;const i=Array.from(this._localTrackTransceiverMids.values()),r=i.length?i.find((t=>e.mid.toString()===t.toString())):0===t,o=e.payloads.split(" ")[0];let{codec:s}=e.rtp.find((e=>e.payload===Number(o)));if(s=s.toLowerCase(),r&&null!==(n=e.ext)&&void 0!==n&&n.length){const t=e.ext.findIndex((e=>e.uri===rl)),n=s===Ds.AV1||s===Ds.H264;!this._supportsDDHeaderExt&&t>=0&&(this._supportsDDHeaderExt=!0),this._supportsDDHeaderExt&&n&&t<0?e.ext.push({value:11,uri:rl}):!n&&t>=0&&e.ext.splice(t,1)}})),new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})):e},ol.prototype.addTrack=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];const n=e.rtcId;if(il.info(`${this} adding ${e}`),this.localTracks.has(n))return Promise.reject(new Error(`${e} is already in ${this}`));this.localTracks.set(n,e);const i=e.getOriginalStream();try{this.tpcUtils.addTrack(e,t),e&&(e.isAudioTrack()?this._hasHadAudioTrack=!0:this._hasHadVideoTrack=!0)}catch(t){return il.error(`${this} Adding track=${e} failed: ${null==t?void 0:t.message}`),Promise.reject(t)}let r=Promise.resolve();return ci.isFirefox()&&(r=r.then((()=>i&&this.tpcUtils.setEncodings(e)))),r},ol.prototype.addTrackToPc=function(e){return il.info(`${this} Adding track=${e} to PC`),this._assertTrackBelongs("addTrackToPc",e)?e.getOriginalStream()?this.tpcUtils.replaceTrack(null,e).then((()=>(e&&(e.isAudioTrack()?this._hasHadAudioTrack=!0:this._hasHadVideoTrack=!0),!1))):(il.error(`${this} Unable to add track=${e} to PC - no WebRTC stream`),Promise.reject("Stream not found")):Promise.reject("Track not found on the peerconnection")},ol.prototype._assertTrackBelongs=function(e,t){const n=this.localTracks.has(null==t?void 0:t.rtcId);return n||il.error(`${this} ${e}: track=${t} does not belong to pc`),n},ol.prototype.getConfiguredVideoCodec=function(){var e;const t=null===(e=this.peerconnection.remoteDescription)||void 0===e?void 0:e.sdp,n=Ds.VP8;if(!t)return n;const i=Ps.parse(t).media.find((e=>e.type===Ri.VIDEO)),r=i.payloads.split(" ")[0],{codec:o}=i.rtp.find((e=>e.payload===Number(r)));return o?Object.values(Ds).find((e=>e===o.toLowerCase())):n},ol.prototype.getConfiguredVideoCodecs=function(e){var t,n;const i=null!==(t=null==e?void 0:e.sdp)&&void 0!==t?t:null===(n=this.peerconnection.localDescription)||void 0===n?void 0:n.sdp;if(!i)return[];const r=Ps.parse(i).media.find((e=>e.type===Ri.VIDEO)),o=new Set(r.rtp.filter((e=>"rtx"!==e.codec.toLowerCase())).map((e=>e.codec.toLowerCase())));return Array.from(o)},ol.prototype.isVideoCodecDisabled=function(e){var t;const n=null===(t=this.peerconnection.localDescription)||void 0===t?void 0:t.sdp;return!!n&&!Ps.parse(n).media.find((e=>e.type===Ri.VIDEO)).rtp.find((t=>t.codec===e))},ol.prototype.setDesktopSharingFrameRate=function(e){const t=e<=5;this._capScreenshareBitrate=this.isSpatialScalabilityOn()&&t},ol.prototype.setVideoCodecs=function(e){this.codecSettings&&null!=e&&e.length&&(this.codecSettings.codecList=e)},ol.prototype.removeTrack=function(e){const t=e.getOriginalStream();this.trace("removeStream",e.rtcId,t?t.id:void 0),this._assertTrackBelongs("removeStream",e)&&(this.localTracks.delete(e.rtcId),this.localSSRCs.delete(e.rtcId),t&&this.peerconnection.removeStream(t))},ol.prototype.findSenderByKind=function(e){if(this.peerconnection.getSenders)return this.peerconnection.getSenders().find((t=>t.track&&t.track.kind===e))},ol.prototype.findReceiverForTrack=function(e){return this.peerconnection.getReceivers().find((t=>t.track===e))},ol.prototype.findSenderForTrack=function(e){if(this.peerconnection.getSenders)return this.peerconnection.getSenders().find((t=>t.track===e))},ol.prototype.processLocalSdpForTransceiverInfo=function(e){var t;const n=null===(t=this.peerconnection.localDescription)||void 0===t?void 0:t.sdp;n&&[Ri.AUDIO,Ri.VIDEO].forEach((t=>{const i=e.filter((e=>e.getType()===t)),r=Ps.parse(n).media.filter((e=>e.type===t));i.forEach(((e,t)=>{this._localTrackTransceiverMids.has(e.rtcId)||this._localTrackTransceiverMids.set(e.rtcId,r[t].mid.toString())}))}))},ol.prototype.replaceTrack=function(e,t){return e||t?(il.info(`${this} TPC.replaceTrack old=${e}, new=${t}`),this.tpcUtils.replaceTrack(e,t).then((n=>{var i;if(e&&(this.localTracks.delete(e.rtcId),this._localTrackTransceiverMids.delete(e.rtcId)),t&&(t.isAudioTrack()?this._hasHadAudioTrack=!0:this._hasHadVideoTrack=!0,this._localTrackTransceiverMids.set(t.rtcId,null==n||null===(i=n.mid)||void 0===i?void 0:i.toString()),this.localTracks.set(t.rtcId,t)),e&&t){const n=this.localSSRCs.get(e.rtcId);n&&(this.localSSRCs.delete(e.rtcId),this.localSSRCs.set(t.rtcId,n))}return n&&(n.direction=t||ci.isFirefox()?As.SENDRECV:As.RECVONLY),(!t||t.getType()===Ri.VIDEO&&ci.usesSdpMungingForSimulcast()?Promise.resolve():this.tpcUtils.setEncodings(t)).then((()=>this.isP2P))}))):(il.info(`${this} replaceTrack called with no new track and no old track`),Promise.resolve())},ol.prototype.removeTrackFromPc=function(e){const t=e.getOriginalStream();return this.trace("removeTrack",e.rtcId,t?t.id:null),this._assertTrackBelongs("removeTrack",e)?this.tpcUtils.replaceTrack(e,null).then((()=>!1)):Promise.reject("Track not found in the peerconnection")},ol.prototype.createDataChannel=function(e,t){return this.trace("createDataChannel",e,t),this.peerconnection.createDataChannel(e,t)},ol.prototype._adjustRemoteMediaDirection=function(e){const t=new Lc(e.sdp);return[Ri.AUDIO,Ri.VIDEO].forEach((e=>{const n=t.selectMedia(e),i=this.getLocalTracks(e).length,r=this.getRemoteTracks(null,e).length;n.forEach(((e,t)=>{e.direction=i&&i===r?As.SENDRECV:i||r?i?r?i>r?t?As.RECVONLY:As.SENDRECV:t?As.SENDONLY:As.SENDRECV:As.RECVONLY:As.SENDONLY:As.INACTIVE}))})),new RTCSessionDescription({type:e.type,sdp:t.toRawSDP()})},ol.prototype._mungeOpus=function(e){const{audioQuality:t}=this.options;if(!(null!=t&&t.enableOpusDtx||null!=t&&t.stereo||null!=t&&t.opusMaxAverageBitrate))return e;const n=Ps.parse(e.sdp),i=n.media;for(const e of i)if("audio"===e.type){const{payload:n}=e.rtp.find((e=>e.codec===Ds.OPUS));if(!n)continue;let i=e.fmtp.find((e=>e.payload===n));i||(i={payload:n,config:""});const r=Ps.parseParams(i.config);let o=!1;if(null!=t&&t.stereo&&(r.stereo=1,o=!0),null!=t&&t.opusMaxAverageBitrate&&(r.maxaveragebitrate=t.opusMaxAverageBitrate,o=!0),!ci.isFirefox()&&null!=t&&t.enableOpusDtx&&(r.usedtx=1,o=!0),!o)continue;let s="";for(const e of Object.keys(r))s+=`${e}=${r[e]}; `;i.config=s.trim()}return new RTCSessionDescription({type:e.type,sdp:Ps.write(n)})},ol.prototype._mungeInactive=function(e){const t=Ps.parse(e.sdp),n=t.media;for(const e of n)e.direction=As.INACTIVE,e.ssrcs=void 0,e.ssrcGroups=void 0;return new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})},ol.prototype._initializeDtlsTransport=function(){if(!this.peerconnection.getSenders||this._dtlsTransport)return;const e=this.peerconnection.getSenders();0!==e.length&&e[0].transport&&(this._dtlsTransport=e[0].transport,this._dtlsTransport.onerror=e=>{il.error(`${this} DtlsTransport error: ${e}`)},this._dtlsTransport.onstatechange=()=>{this.trace("dtlsTransport.onstatechange",this._dtlsTransport.state)})},ol.prototype._setMaxBitrates=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(!this.codecSettings)return e;const n=Ps.parse(e.sdp),i=t?As.RECVONLY:As.SENDONLY,r=n.media.filter((e=>e.type===Ri.VIDEO&&e.direction!==i)),o=this.codecSettings.codecList[0],s=this.tpcUtils.codecSettings[o];for(const e of r){const t=o===Ds.VP9&&!s.scalabilityModeEnabled,n=this.getLocalVideoTracks().find((t=>this._localTrackTransceiverMids.get(t.rtcId)===e.mid.toString()));if((t||this.tpcUtils._isRunningInFullSvcMode(o))&&n){let t;if(n.getVideoType()===Qo.VideoType.DESKTOP)t=s.maxBitratesVideo.ssHigh;else{const{level:e}=Pc.find((e=>e.height<=n.getCaptureResolution()));t=s.maxBitratesVideo[e]}const i=Math.floor(t/1e3);e.bandwidth=[{type:"AS",limit:i}]}else e.bandwidth=void 0}return new RTCSessionDescription({type:e.type,sdp:Ps.write(n)})},ol.prototype.configureAudioSenderEncodings=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(e)return this.tpcUtils.setEncodings(e);const t=[];for(const e of this.getLocalTracks(Ri.AUDIO))t.push(this.tpcUtils.setEncodings(e));return Promise.allSettled(t)},ol.prototype.configureVideoSenderEncodings=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(e)return this.setSenderVideoConstraints(this._senderMaxHeights.get(e.getSourceName()),e);const t=[];for(const e of this.getLocalVideoTracks()){var n;const i=null!==(n=this._senderMaxHeights.get(e.getSourceName()))&&void 0!==n?n:Pc[0].height;t.push(this.setSenderVideoConstraints(i,e))}return Promise.allSettled(t)},ol.prototype.setLocalDescription=function(e){let t=e;return this.trace("setLocalDescription::preTransform",sl(t)),t=this._mungeOpus(t),t=this._mungeCodecOrder(t),t=this._setMaxBitrates(t,!0),t=this._updateAv1DdHeaders(t),this.trace("setLocalDescription::postTransform",sl(t)),new Promise(((e,n)=>{this.peerconnection.setLocalDescription(t).then((()=>{this.trace("setLocalDescriptionOnSuccess");const n=Ns.getUfrag(t.sdp);n!==this.localUfrag&&(this.localUfrag=n,this.eventEmitter.emit(ji.default.LOCAL_UFRAG_CHANGED,this,n)),this._initializeDtlsTransport(),e()}),(e=>{this.trace("setLocalDescriptionOnFailure",e),this.eventEmitter.emit(ji.default.SET_LOCAL_DESCRIPTION_FAILED,e,this),n(e)}))}))},ol.prototype.setRemoteDescription=function(e){let t=e;if(this.trace("setRemoteDescription::preTransform",sl(e)),t=this._mungeOpus(t),!this.isP2P){const e=this.peerconnection.remoteDescription;t=this.interop.toUnifiedPlan(t,e),this.trace("setRemoteDescription::postTransform (Unified)",sl(t))}return this.isSpatialScalabilityOn()&&(t=this.tpcUtils.insertUnifiedPlanSimulcastReceive(t),this.trace("setRemoteDescription::postTransform (sim receive)",sl(t))),t=this.tpcUtils.ensureCorrectOrderOfSsrcs(t),this.trace("setRemoteDescription::postTransform (correct ssrc order)",sl(t)),t=this._mungeCodecOrder(t),t=this._setMaxBitrates(t),t=this._updateAv1DdHeaders(t),this.trace("setRemoteDescription::postTransform (munge codec order)",sl(t)),new Promise(((e,n)=>{this.peerconnection.setRemoteDescription(t).then((()=>{this.trace("setRemoteDescriptionOnSuccess");const n=Ns.getUfrag(t.sdp);n!==this.remoteUfrag&&(this.remoteUfrag=n,this.eventEmitter.emit(ji.default.REMOTE_UFRAG_CHANGED,this,n)),this._initializeDtlsTransport(),e()}),(e=>{this.trace("setRemoteDescriptionOnFailure",e),this.eventEmitter.emit(ji.default.SET_REMOTE_DESCRIPTION_FAILED,e,this),n(e)}))}))},ol.prototype.setSenderVideoConstraints=function(e,t){if(e<0||isNaN(e))throw new Error(`Invalid frameHeight: ${e}`);if(!t)throw new Error("Local video track is missing");const n=t.getSourceName();return t.isMuted()?(this._senderMaxHeights.set(n,e),Promise.resolve()):this._updateVideoSenderParameters((()=>this._updateVideoSenderEncodings(e,t)))},ol.prototype._updateVideoSenderParameters=function(e){const t=this._lastVideoSenderUpdatePromise.finally(e);return this._lastVideoSenderUpdatePromise=t,t},ol.prototype._updateVideoSenderEncodings=function(e,t){var n;const i=this.findSenderForTrack(t.getTrack());if(!i)return Promise.resolve();const r=i.getParameters();if(null==r||null===(n=r.encodings)||void 0===n||!n.length)return Promise.resolve();const o=t.getVideoType()===Qo.VideoType.DESKTOP&&this._capScreenshareBitrate?"maintain-resolution":"maintain-framerate";r.degradationPreference=o;const s=this.getConfiguredVideoCodec(),a=this.tpcUtils.calculateEncodingsBitrates(t,s,e),d=this.tpcUtils.calculateEncodingsActiveState(t,s,e),c=this.tpcUtils.calculateEncodingsScaleFactor(t,s,e),l=this.tpcUtils.calculateEncodingsScalabilityMode(t,s,e),h=t.getSourceName();let u=!1;for(const e in r.encodings)if(r.encodings.hasOwnProperty(e)){const{active:t,maxBitrate:n,scalabilityMode:i,scaleResolutionDownBy:h}=r.encodings[e];t!==d[e]&&(r.encodings[e].active=d[e],u=!0),ci.isFirefox()&&(r.encodings[e].degradationPreference=o),(s!==Ds.VP9||!this.isSpatialScalabilityOn()||ci.supportsScalabilityModeAPI()&&this.tpcUtils.codecSettings[s].scalabilityModeEnabled)&&(h!==c[e]&&(r.encodings[e].scaleResolutionDownBy=c[e],u=!0),n!==a[e]&&(r.encodings[e].maxBitrate=a[e],u=!0)),l?i!==l[e]&&(r.encodings[e].scalabilityMode=l[e],u=!0):r.encodings[e].scalabilityMode=void 0}return u?(il.info(`${this} setting max height=${e},encodings=${JSON.stringify(r.encodings)}`),i.setParameters(r).then((()=>{this._senderMaxHeights.set(h,e),t.maxEnabledResolution=e,this.eventEmitter.emit(ji.default.LOCAL_TRACK_MAX_ENABLED_RESOLUTION_CHANGED,t)}))):(this._senderMaxHeights.set(h,e),Promise.resolve())},ol.prototype.setVideoTransferActive=function(e){il.debug(`${this} video transfer active: ${e}`);const t=this.videoTransferActive!==e;return this.videoTransferActive=e,t?this.tpcUtils.setMediaTransferActive(e,Ri.VIDEO):Promise.resolve()},ol.prototype.sendTones=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:200,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:200;if(!this._dtmfSender){if(this.peerconnection.getSenders){const e=this.peerconnection.getSenders().find((e=>e.dtmf));this._dtmfSender=e&&e.dtmf,this._dtmfSender&&il.info(`${this} initialized DTMFSender using getSenders`)}if(!this._dtmfSender){const e=Array.from(this.localTracks.values()).find((e=>e.isAudioTrack()));this.peerconnection.createDTMFSender&&e&&(this._dtmfSender=this.peerconnection.createDTMFSender(e.getTrack())),this._dtmfSender&&il.info(`${this} initialized DTMFSender using deprecated createDTMFSender`)}this._dtmfSender&&(this._dtmfSender.ontonechange=this._onToneChange.bind(this))}if(this._dtmfSender){if(this._dtmfSender.toneBuffer)return void this._dtmfTonesQueue.push({tones:e,duration:t,interToneGap:n});this._dtmfSender.insertDTMF(e,t,n)}else il.warn(`${this} sendTones - failed to select DTMFSender`)},ol.prototype._onToneChange=function(e){if(this._dtmfSender&&""===e.tone&&this._dtmfTonesQueue.length){const{tones:e,duration:t,interToneGap:n}=this._dtmfTonesQueue.shift();this._dtmfSender.insertDTMF(e,t,n)}},ol.prototype.close=function(){this.trace("stop"),this.signalingLayer.off(yc,this._peerMutedChanged),this.signalingLayer.off(Ec,this._peerVideoTypeChanged),this.peerconnection.removeEventListener("track",this.onTrack);for(const e of this.remoteTracks.values())for(const t of e.values())for(const e of t)this._removeRemoteTrack(e);this.remoteTracks.clear(),this._dtmfSender=null,this._dtmfTonesQueue=[],this.rtc._removePeerConnection(this)||il.error(`${this} rtc._removePeerConnection returned false`),null!==this.statsinterval&&(window.clearInterval(this.statsinterval),this.statsinterval=null),il.info(`${this} Closing peerconnection`),this.peerconnection.close()},ol.prototype.createAnswer=function(e){return this._createOfferOrAnswer(!1,e)},ol.prototype.createOffer=function(e){return this._createOfferOrAnswer(!0,e)},ol.prototype._createOfferOrAnswer=function(e,t){const n=e?"Offer":"Answer";this.trace(`create${n}`,JSON.stringify(t,null," "));const i=(e,t,i)=>{try{this.trace(`create${n}OnSuccess::preTransform`,sl(e)),this.isSpatialScalabilityOn()&&ci.usesSdpMungingForSimulcast()&&(e=this.simulcast.mungeLocalDescription(e),this.trace(`create${n} OnSuccess::postTransform (simulcast)`,sl(e))),!this.options.disableRtx&&ci.usesSdpMungingForSimulcast()&&(e=new RTCSessionDescription({type:e.type,sdp:this.rtxModifier.modifyRtxSsrcs(e.sdp)}),this.trace(`create${n}OnSuccess::postTransform (rtx modifier)`,sl(e)));const i=this._extractSSRCMap(e);this._processLocalSSRCsMap(i),t(e)}catch(t){this.trace(`create${n}OnError`,t),this.trace(`create${n}OnError`,sl(e)),il.error(`${this} create${n}OnError`,t,sl(e)),i(t)}},r=(t,i)=>{this.trace(`create${n}OnFailure`,t);const r=e?ji.default.CREATE_OFFER_FAILED:ji.default.CREATE_ANSWER_FAILED;this.eventEmitter.emit(r,t,this),i(t)};if(ci.supportsCodecPreferences()&&this.codecSettings){var o;const{codecList:e,mediaType:t}=this.codecSettings,n=this.peerconnection.getTransceivers().filter((e=>{var n,i;return e.receiver&&(null===(n=e.receiver)||void 0===n||null===(i=n.track)||void 0===i?void 0:i.kind)===t}));let i=null===(o=RTCRtpReceiver.getCapabilities(t))||void 0===o?void 0:o.codecs;if(n.length&&i){for(const n of e.slice().reverse())i.sort((e=>e.mimeType.toLowerCase()===`${t}/${n}`?-1:1));this.isP2P&&t===Ri.VIDEO&&(i=i.filter((e=>e.mimeType.toLowerCase()!==`${Ri.VIDEO}/${Ds.ULPFEC}`&&e.mimeType.toLowerCase()!==`${Ri.VIDEO}/${Ds.RED}`)));for(const e of n)e.setCodecPreferences(i)}}return new Promise(((n,o)=>{let s;s=e?this.peerconnection.createOffer(t):this.peerconnection.createAnswer(t),s.then((e=>i(e,n,o)),(e=>r(e,o)))}))},ol.prototype._extractPrimarySSRC=function(e){return e&&e.groups&&e.groups.length?e.groups[0].ssrcs[0]:e&&e.ssrcs&&e.ssrcs.length?e.ssrcs[0]:null},ol.prototype._processLocalSSRCsMap=function(e){for(const t of this.localTracks.values()){const n=Rc(t.getSourceName()),i=`${t.getType()}-${n}`;if(e.has(i)){const n=e.get(i);if(!n)return void il.error(`${this} No SSRC found for stream=${i}`);const r=this.localSSRCs.get(t.rtcId),o=this._extractPrimarySSRC(n),s=this._extractPrimarySSRC(r);o!==s&&(s&&il.error(`${this} Overwriting SSRC for track=${t}] with ssrc=${n}`),this.localSSRCs.set(t.rtcId,n),this.eventEmitter.emit(ji.default.LOCAL_TRACK_SSRC_UPDATED,t,o))}else t.isVideoTrack()||t.isMuted()||il.warn(`${this} No SSRCs found in the local SDP for track=${t}, stream=${i}`)}},ol.prototype.addRemoteSsrc=function(e){const t=this.remoteSSRCs.has(e);return t||this.remoteSSRCs.add(e),!t},ol.prototype.addIceCandidate=function(e){return this.trace("addIceCandidate",JSON.stringify({candidate:e.candidate,sdpMid:e.sdpMid,sdpMLineIndex:e.sdpMLineIndex,usernameFragment:e.usernameFragment},null," ")),this.peerconnection.addIceCandidate(e)},ol.prototype.getStats=function(){return this.peerconnection.getStats()},ol.prototype.toString=function(){return`TPC[id=${this.id},type=${this.isP2P?"P2P":"JVB"}]`};const dl=(0,E.getLogger)("modules/RTC/RTC.js");let cl,ll=0,hl=0;function ul(){return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:[]).map((e=>{const{constraints:t,sourceId:n,sourceType:i,stream:r,track:o,videoType:s,effects:a}=e,{deviceId:d,facingMode:c}=o.getSettings();return hl=yi(hl),new ac({constraints:t,deviceId:d,facingMode:c,mediaType:o.kind,rtcId:hl,sourceId:n,sourceType:i,stream:r,track:o,videoType:s||null,effects:a})}))}class pl extends xr{constructor(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};super(),this.conference=e,this.peerConnections=new Map,this.localTracks=[],this.options=t,this._channel=null,this._lastN=void 0,this._forwardedSources=null,this._forwardedSourcesChangeListener=this._onForwardedSourcesChanged.bind(this),this._onDeviceListChanged=this._onDeviceListChanged.bind(this),this._updateAudioOutputForAudioTracks=this._updateAudioOutputForAudioTracks.bind(this),nc.isDeviceChangeAvailable("output")&&(nc.addListener(ji.default.AUDIO_OUTPUT_DEVICE_CHANGED,this._updateAudioOutputForAudioTracks),nc.addListener(ji.default.DEVICE_LIST_CHANGED,this._onDeviceListChanged))}destroy(){nc.removeListener(ji.default.AUDIO_OUTPUT_DEVICE_CHANGED,this._updateAudioOutputForAudioTracks),nc.removeListener(ji.default.DEVICE_LIST_CHANGED,this._onDeviceListChanged),this._channelOpenListener&&this.removeListener(ji.default.DATA_CHANNEL_OPEN,this._channelOpenListener)}static createLocalTracks(e){return ul(e)}static obtainAudioAndVideoPermissions(e){return nc.obtainAudioAndVideoPermissions(e).then((e=>ul(e)))}initializeBridgeChannel(e,t){this._channel=new ja(e,t,this.eventEmitter,this.conference),this._channelOpenListener=()=>{const e=(e,t,n)=>{dl.error(`Cannot send ${t}(${JSON.stringify(n)}) endpoint message`,e)};if(this._receiverVideoConstraints)try{this._channel.sendReceiverVideoConstraintsMessage(this._receiverVideoConstraints)}catch(t){e(t,"ReceiverVideoConstraints",this._receiverVideoConstraints)}if(void 0!==this._lastN&&-1!==this._lastN)try{this._channel.sendSetLastNMessage(this._lastN)}catch(t){e(t,"LastNChangedEvent",this._lastN)}},this.addListener(ji.default.DATA_CHANNEL_OPEN,this._channelOpenListener),this.addListener(ji.default.FORWARDED_SOURCES_CHANGED,this._forwardedSourcesChangeListener)}_onDeviceListChanged(){this._updateAudioOutputForAudioTracks(nc.getAudioOutputDevice())}_onForwardedSourcesChanged(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];const t=this._forwardedSources||[];let n=[],i=[];const r=Date.now();this._forwardedSources=e,n=t.filter((e=>!this.isInForwardedSources(e))),i=e.filter((e=>-1===t.indexOf(e))),dl.debug(`Fowarded sources changed leaving=${n}, entering=${i} at ${r}`),this.conference.eventEmitter.emit(Re,n,i,r)}onCallEnded(){this._channel&&(this._channel&&"websocket"===this._channel.mode&&this._channel.close(),this._channel=null)}setDesktopSharingFrameRate(e){nc.setDesktopSharingFrameRate(e)}setReceiverVideoConstraints(e){this._receiverVideoConstraints=e,this._channel&&this._channel.isOpen()&&this._channel.sendReceiverVideoConstraintsMessage(e)}sendSourceVideoType(e,t){this._channel&&this._channel.isOpen()&&this._channel.sendSourceVideoTypeMessage(e,t)}static addListener(e,t){nc.addListener(e,t)}static removeListener(e,t){nc.removeListener(e,t)}static init(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.options=e,nc.init(this.options)}createPeerConnection(e,t,n,i){const r=Ss()(nc.pcConstraints);i.enableInsertableStreams&&(dl.debug("E2EE - setting insertable streams constraints"),t.encodedInsertableStreams=!0),i.forceTurnRelay&&(t.iceTransportPolicy="relay"),t.bundlePolicy="max-bundle",ll=yi(ll);const o=new ol(this,ll,e,t,r,n,i);return this.peerConnections.set(o.id,o),o}_removePeerConnection(e){const t=e.id;return!!this.peerConnections.has(t)&&(this.peerConnections.delete(t),!0)}addLocalTrack(e){if(!e)throw new Error("track must not be null nor undefined");this.localTracks.push(e),e.conference=this.conference}getForwardedSources(){return this._forwardedSources}getLocalVideoTrack(){const e=this.getLocalTracks(Ri.VIDEO);return e.length?e[0]:void 0}getLocalVideoTracks(){return this.getLocalTracks(Ri.VIDEO)}getLocalAudioTrack(){const e=this.getLocalTracks(Ri.AUDIO);return e.length?e[0]:void 0}getLocalEndpointId(){return this.conference.myUserId()}getLocalTracks(e){let t=this.localTracks.slice();return void 0!==e&&(t=t.filter((t=>t.getType()===e))),t}getRemoteTracks(e){let t=[];for(const n of this.peerConnections.values()){const i=n.getRemoteTracks(void 0,e);i&&(t=t.concat(i))}return t}setAudioMute(e){const t=[];return this.getLocalTracks(Ri.AUDIO).forEach((n=>{t.push(e?n.mute():n.unmute())})),Promise.all(t)}setVideoMute(e){const t=[];return this.getLocalTracks(Ri.VIDEO).forEach((n=>{t.push(e?n.mute():n.unmute())})),Promise.all(t)}removeLocalTrack(e){const t=this.localTracks.indexOf(e);-1!==t&&this.localTracks.splice(t,1)}static attachMediaStream(e,t){return nc.attachMediaStream(e,t)}static isDeviceListAvailable(){return nc.isDeviceListAvailable()}static isDeviceChangeAvailable(e){return nc.isDeviceChangeAvailable(e)}static isWebRtcSupported(){return ci.isSupported()}static getAudioOutputDevice(){return nc.getAudioOutputDevice()}static getCurrentlyAvailableMediaDevices(){return nc.getCurrentlyAvailableMediaDevices()}static arePermissionsGrantedForAvailableDevices(){return nc.arePermissionsGrantedForAvailableDevices()}static getEventDataForActiveDevice(e){return nc.getEventDataForActiveDevice(e)}static setAudioOutputDevice(e){return nc.setAudioOutputDevice(e)}static enumerateDevices(e){nc.enumerateDevices(e)}static stopMediaStream(e){nc.stopMediaStream(e)}static isDesktopSharingEnabled(){return nc.isDesktopSharingEnabled()}closeBridgeChannel(){this._channel&&(this._channel.close(),this._channel=null)}setAudioLevel(e,t,n,i){const r=e.getTrackBySSRC(t);r&&(r.isAudioTrack()?(r.isLocal()!==i&&dl.error(`${r} was expected to ${i?"be":"not be"} local`),r.setAudioLevel(n,e)):dl.warn(`Received audio level for non-audio track: ${t}`))}sendChannelMessage(e,t){if(!this._channel)throw new Error("Channel support is disabled!");this._channel.sendMessage(e,t)}sendEndpointStatsMessage(e){this._channel&&this._channel.isOpen()&&this._channel.sendEndpointStatsMessage(e)}setLastN(e){this._lastN!==e&&(this._lastN=e,this._channel&&this._channel.isOpen()&&this._channel.sendSetLastNMessage(e),this.eventEmitter.emit(ji.default.LASTN_VALUE_CHANGED,e))}isInForwardedSources(e){return!this._forwardedSources||this._forwardedSources.indexOf(e)>-1}_updateAudioOutputForAudioTracks(e){const t=this.getRemoteTracks(Ri.AUDIO);for(const n of t)n.setAudioOutput(e)}}!function(e){e.LOCAL_STATS_UPDATED="cq.local_stats_updated",e.REMOTE_STATS_UPDATED="cq.remote_stats_updated"}(cl||(cl={}));const ml=cl.LOCAL_STATS_UPDATED,gl=cl.REMOTE_STATS_UPDATED,fl=n(125),{VideoType:vl}=n(408),{XMPPEvents:_l}=n(609),yl=(0,E.getLogger)("modules/connectivity/ConnectionQuality.js");let El=800;class Sl{constructor(e,t,n){var i;this.eventEmitter=t,this._conference=e,this._localStats={connectionQuality:100,jvbRTT:void 0},this._lastConnectionQualityUpdate=-1,this._options=n,this._remoteStats={},this._timeIceConnected=-1,this._timeVideoUnmuted=-1,(null===(i=this._options.config)||void 0===i?void 0:i.startBitrate)>0&&(El=this._options.config.startBitrate),e.on(me,(()=>{this._updateLocalConnectionQuality(0),this.eventEmitter.emit(ml,this._localStats),this._broadcastLocalStats()})),e.room.addListener(_l.ICE_CONNECTION_STATE_CHANGED,((e,t)=>{e.isP2P||"connected"!==t||(this._timeIceConnected=window.performance.now())})),e.on(Ce,((e,t)=>{"stats"===t.type&&this._updateRemoteStats(e.getId(),t.values)})),e.on(xe,((e,t)=>{this._updateRemoteStats(e.getId(),t)})),this._options.config.disableLocalStats||e.statistics.addConnectionStatsListener(this._updateLocalStats.bind(this)),e.on(it,(e=>{e.isVideoTrack()&&(e.isMuted()?this._timeVideoUnmuted=-1:this._maybeUpdateUnmuteTime())})),e.on(tt,(e=>{e.isVideoTrack()&&!e.isMuted()&&this._maybeUpdateUnmuteTime()})),e.rtc.on(ji.LOCAL_TRACK_MAX_ENABLED_RESOLUTION_CHANGED,(e=>{this._localStats.maxEnabledResolution=e.maxEnabledResolution})),e.on(We,(e=>{this._localStats.serverRegion=e})),e.on(ze,(e=>{this._localStats.bridgeCount=Number((e||{})["bridge-count"])}))}_maybeUpdateUnmuteTime(){this._timeVideoUnmuted<0&&(this._timeVideoUnmuted=window.performance.now())}_calculateConnectionQuality(e,t,n){const i=fl[n];let r,o=100;if(this._localStats.packetLoss&&(r=this._localStats.packetLoss.upload,t&&(r*=.5)),t||!i||e===vl.DESKTOP||this._timeIceConnected<0||this._timeVideoUnmuted<0)void 0===r?(yl.error("Cannot calculate connection quality, unknown packet loss."),o=100):o=r<=2?100:r<=4?70:r<=6?50:r<=8?30:r<=12?10:0;else{const e=this._conference.getActivePeerConnection();if(e){var s,a;const t=window.performance.now()-Math.max(this._timeVideoUnmuted,this._timeIceConnected),n=null!==(s=null===(a=this._options.config)||void 0===a?void 0:a.pcStatsInterval)&&void 0!==s?s:1e4;let r=function(e,t,n,i){let r=0,o=Math.min(t.height,t.width),s=Pc.find((e=>e.height<=o));if(s&&e)for(o=s.height;o>=180;o/=2){const e=o;if(s=Pc.find((t=>t.height===e)),!s)break;r+=i[s.level]}else s&&(r=i[s.level]);return Math.min(r/1e3,function(e){return e>6e4?Number.MAX_SAFE_INTEGER:El*Math.pow(1.08,e/1e3)}(Math.max(0,n-1e3)))}(e.doesTrueSimulcast(),i,t,e.getTargetVideoBitrates());r=Math.min(r,2500),t>n&&(o=100*this._localStats.bitrate.upload/r)}r&&r>=10&&(o=Math.min(o,30))}if(this._lastConnectionQualityUpdate>0){const e=2,t=this._localStats.connectionQuality,n=(window.performance.now()-this._lastConnectionQualityUpdate)/1e3;o=Math.min(o,t+n*e)}return Math.min(100,o)}_updateLocalConnectionQuality(e){this._localStats.connectionQuality=e,this._lastConnectionQualityUpdate=window.performance.now()}_broadcastLocalStats(){const e={bitrate:this._localStats.bitrate,packetLoss:this._localStats.packetLoss,connectionQuality:this._localStats.connectionQuality,jvbRTT:this._localStats.jvbRTT,serverRegion:this._localStats.serverRegion,maxEnabledResolution:this._localStats.maxEnabledResolution,avgAudioLevels:this._localStats.localAvgAudioLevels};try{this._conference.sendEndpointStatsMessage(e)}catch(e){}}_updateLocalStats(e,t){if(!e.isP2P){const e=t.transport&&t.transport.length&&t.transport[0].rtt;this._localStats.jvbRTT=e||void 0}if(e!==this._conference.getActivePeerConnection())return;let n;const i=!this._conference.isConnectionInterrupted(),r=this._conference.getLocalVideoTrack(),o=r?r.videoType:void 0,s=!r||r.isMuted(),a=r?Math.min(r.resolution,r.maxEnabledResolution):null;for(n in s||this._maybeUpdateUnmuteTime(),t)t.hasOwnProperty(n)&&(this._localStats[n]=t[n]);i&&this._updateLocalConnectionQuality(this._calculateConnectionQuality(o,s,a)),this.eventEmitter.emit(ml,this._localStats),this._broadcastLocalStats()}_updateRemoteStats(e,t){this._remoteStats[e]={bitrate:t.bitrate,packetLoss:t.packetLoss,connectionQuality:t.connectionQuality,jvbRTT:t.jvbRTT,serverRegion:t.serverRegion,maxEnabledResolution:t.maxEnabledResolution,avgAudioLevels:t.avgAudioLevels},this.eventEmitter.emit(gl,e,this._remoteStats[e])}getStats(){return this._localStats}}const bl=(0,E.getLogger)("modules/connectivity/IceFailedHandling.js");class Tl{constructor(e){this._conference=e}_actOnIceFailed(){if(!this._conference.room)return;const{enableForcedReload:e,enableIceRestart:t}=this._conference.options.config,n=void 0!==t&&!t,i=this._conference.room.supportsRestartByTerminate(),r=i&&!t;if(bl.info(`ICE failed, enableForcedReload: ${e}, enableIceRestart: ${t}, supports restart by terminate: ${i}`),n||!t&&!i||e){bl.info("ICE failed, but ICE restarts are disabled");const t=e?I:F;return void this._conference.eventEmitter.emit(ae,t)}const o=this._conference.jvbJingleSession,s=o&&o.getIceConnectionState();o?"connected"===s?bl.info("ICE connection restored - not sending ICE failed"):(bl.info(`Sending ICE failed - the connection did not recover, ICE state: ${s}, use \'session-terminate\': ${r}`),r?this._conference._stopJvbSession({reason:"connectivity-error",reasonDescription:"ICE FAILED",requestRestart:!0,sendSessionTerminate:!0}):this._conference.jvbJingleSession.sendIceFailedNotification()):bl.warn("Not sending ICE failed - no JVB connection")}start(){this._conference.xmpp.ping(65e3).then((()=>{this._canceled||(this._iceFailedTimeout=window.setTimeout((()=>{this._iceFailedTimeout=void 0,this._actOnIceFailed()}),2e3))}),(e=>{bl.error("PING error/timeout - not sending ICE failed",e)}))}cancel(){this._canceled=!0,window.clearTimeout(this._iceFailedTimeout)}}let Cl;!function(e){e.DETECTOR_STATE_CHANGE="detector_state_change",e.AUDIO_INPUT_STATE_CHANGE="audio_input_state_changed",e.NO_AUDIO_INPUT="no_audio_input_detected",e.VAD_NOISY_DEVICE="detection.vad_noise_device",e.VAD_REPORT_PUBLISHED="vad-report-published",e.VAD_SCORE_PUBLISHED="detection.vad_score_published",e.VAD_TALK_WHILE_MUTED="detection.vad_talk_while_muted"}(Cl||(Cl={}));const xl=Cl.DETECTOR_STATE_CHANGE,Rl=Cl.AUDIO_INPUT_STATE_CHANGE,Al=Cl.NO_AUDIO_INPUT,wl=Cl.VAD_NOISY_DEVICE,Il=Cl.VAD_REPORT_PUBLISHED,Pl=Cl.VAD_SCORE_PUBLISHED,Dl=Cl.VAD_TALK_WHILE_MUTED;class Ol extends ii{constructor(e){super(),this._conference=e,this._timeoutTrigger=null,this._hasAudioInput=null,e.on(tt,this._trackAdded.bind(this))}_clearTriggerTimeout(){clearTimeout(this._timeoutTrigger),this._timeoutTrigger=null}_handleAudioInputStateChange(e){const t=0!==e;null!==this._hasAudioInput&&this._hasAudioInput===t||(this._hasAudioInput=t,this.emit(Rl,this._hasAudioInput))}_handleNoAudioInputDetection(e){this._eventFired||(0!==e||this._timeoutTrigger?0!==e&&this._timeoutTrigger&&this._clearTriggerTimeout():this._timeoutTrigger=setTimeout((()=>{this._eventFired=!0,this.emit(Al)}),4e3))}_audioLevel(e,t,n,i){if(!i||!this._audioTrack)return;const r=e.localSSRCs.get(this._audioTrack.rtcId);r&&r.ssrcs.includes(t)&&(this._handleAudioInputStateChange(n),this._handleNoAudioInputDetection(n))}_trackAdded(e){e.isLocalAudioTrack()&&(this._audioTrack=e,this._eventFired=!1,this._clearTriggerTimeout(),e.on(It,(e=>{this._handleNoAudioInputDetection(e)})),e.on(Ct,(e=>{this._handleNoAudioInputDetection(e),this._handleAudioInputStateChange(e)})))}}class kl{constructor(e){this.conference=e,e.addEventListener(nt,this._audioLevel.bind(this)),this.myUserID=this.conference.myUserId()}_audioLevel(e,t){!this.conference.isP2PActive()||t<=.6||e===this.myUserID&&this.conference.getLocalAudioTrack().isMuted()||this.conference.rtc.eventEmitter.emit(ji.default.DOMINANT_SPEAKER_CHANGED,e)}}function Nl(e){const t=window.AudioContext||window.webkitAudioContext;if(t)return new t(e)}class Ml extends ii{constructor(e,t,n){super(),this._procNodeSampleRate=e,this._vadProcessor=t,this._localTrack=n,this._bufferResidue=new Float32Array([]),this._audioContext=Nl({sampleRate:t.getRequiredPCMFrequency()}),this._vadSampleSize=t.getSampleLength(),this._onAudioProcess=this._onAudioProcess.bind(this),this._initializeAudioContext()}static create(e,t,n){return pl.obtainAudioAndVideoPermissions({devices:["audio"],micDeviceId:e}).then((i=>{if(!i[0])throw new Error(`Failed to create jitsi local track for device id: ${e}`);return new Ml(t,n,i[0])}))}_initializeAudioContext(){this._audioSource=this._audioContext.createMediaStreamSource(this._localTrack.stream),this._audioProcessingNode=this._audioContext.createScriptProcessor(this._procNodeSampleRate,1,1)}_onAudioProcess(e){const t=e.inputBuffer.getChannelData(0),n=[...this._bufferResidue,...t],i=Date.now();let r=0;for(;r+this._vadSampleSize<n.length;r+=this._vadSampleSize){const e=n.slice(r,r+this._vadSampleSize),t=this._vadProcessor.calculateAudioFrameVAD(e.slice());this.emit(Pl,{timestamp:i,score:t,pcmData:e,deviceId:this._localTrack.getDeviceId()})}this._bufferResidue=n.slice(r,n.length)}_connectAudioGraph(){this._audioProcessingNode.onaudioprocess=this._onAudioProcess,this._audioSource.connect(this._audioProcessingNode),this._audioProcessingNode.connect(this._audioContext.destination)}_disconnectAudioGraph(){this._audioProcessingNode.onaudioprocess=()=>{},this._audioProcessingNode.disconnect(),this._audioSource.disconnect()}_cleanupResources(){this._disconnectAudioGraph(),this._localTrack.stopStream()}getDeviceId(){return this._localTrack.getDeviceId()}getTrackLabel(){return this._localTrack.getDeviceLabel()}start(){this._connectAudioGraph()}stop(){this._disconnectAudioGraph(),this._bufferResidue=[]}destroy(){this._destroyed||(this._cleanupResources(),this._destroyed=!0)}}const Ll=(0,E.getLogger)("modules/detection/VADAudioAnalyser.js");class Fl extends ii{constructor(e,t){super(),this._createVADProcessor=t,this._vadEmitter=null,this._isVADEmitterRunning=!1,this._detectionServices=[],this._vadInitTracker=Promise.resolve(),this._processVADScore=this._processVADScore.bind(this),e.on(tt,this._trackAdded.bind(this)),e.on(rt,this._trackRemoved.bind(this)),e.on(it,this._trackMuteChanged.bind(this))}addVADDetectionService(e){this._detectionServices.push(e),e.on(xl,(()=>{!this._detectionServices.filter((e=>!0===e.isActive())).length&&this._isVADEmitterRunning?this._stopVADEmitter():this._isVADEmitterRunning||this._startVADEmitter()}))}_startVADEmitter(){this._vadEmitter&&(this._vadEmitter.on(Pl,this._processVADScore),this._vadEmitter.start(),this._isVADEmitterRunning=!0)}_stopVADEmitter(){this._vadEmitter&&(this._vadEmitter.removeListener(Pl,this._processVADScore),this._vadEmitter.stop()),this._isVADEmitterRunning=!1}_processVADScore(e){for(const t of this._detectionServices)t.processVADScore(e)}_changeDetectorsMuteState(e){for(const t of this._detectionServices)t.changeMuteState(e)}_trackAdded(e){e.isLocalAudioTrack()&&(this._vadInitTracker=this._vadInitTracker.then((()=>this._createVADProcessor())).then((t=>Ml.create(e.getDeviceId(),4096,t))).then((t=>{Ll.debug("Created VAD emitter for track: ",e.getTrackLabel()),this._vadEmitter=t,this._changeDetectorsMuteState(e.isMuted())})).catch((e=>{Ll.warn("Failed to start VADAudioAnalyser",e)})))}_trackMuteChanged(e){e.isLocalAudioTrack()&&(this._vadInitTracker=this._vadInitTracker.then((()=>{this._changeDetectorsMuteState(e.isMuted())})))}_trackRemoved(e){e.isLocalAudioTrack()&&(this._vadInitTracker=this._vadInitTracker.then((()=>{Ll.debug("Removing track from VAD detection - ",e.getTrackLabel()),this._vadEmitter&&(this._stopVADEmitter(),this._vadEmitter.destroy(),this._vadEmitter=null);for(const e of this._detectionServices)e.reset()})))}}class jl extends ii{constructor(){super(),this._processing=!1,this._scoreArray=[],this._audioLvlArray=[],this._active=!1,this._calculateNoisyScore=this._calculateNoisyScore.bind(this)}_calculateNoisyScore(){const e=Ei(this._scoreArray),t=Ei(this._audioLvlArray);e<.2&&t>.04&&(this.emit(wl),this._setActiveState(!1)),this.reset()}_recordValues(e,t){this._scoreArray.push(e),this._audioLvlArray.push(t)}_setActiveState(e){this._active=e,this.emit(xl,this._active)}changeMuteState(e){this._setActiveState(!e),this.reset()}isActive(){return this._active}reset(){this._processing=!1,this._scoreArray=[],this._audioLvlArray=[],clearTimeout(this._processTimeout)}processVADScore(e){if(this._active)if(this._processing){const t=Si(e.pcmData);this._recordValues(e.score,Ei(t))}else if(e.score<.2){const t=Ei(Si(e.pcmData));t>.02&&(this._processing=!0,this._recordValues(e.score,t),this._processTimeout=setTimeout(this._calculateNoisyScore,1500))}}}class Vl extends ii{constructor(){super(),this._processing=!1,this._scoreArray=[],this._active=!1,this._calculateVADScore=this._calculateVADScore.bind(this)}_calculateVADScore(){Ei(this._scoreArray)>.6&&(this.emit(Dl),this._setActiveState(!1)),this.reset()}_setActiveState(e){this._active=e,this.emit(xl,this._active)}changeMuteState(e){this._setActiveState(e),this.reset()}isActive(){return this._active}processVADScore(e){this._active&&(this._processing?this._scoreArray.push(e.score):e.score>.9&&(this._processing=!0,this._scoreArray.push(e.score),this._processTimeout=setTimeout(this._calculateVADScore,700)))}reset(){this._processing=!1,this._scoreArray=[],clearTimeout(this._processTimeout)}}let Ul;!function(e){e.E2E_RTT_CHANGED="e2eping.e2e_rtt_changed"}(Ul||(Ul={}));const Hl=Ul.E2E_RTT_CHANGED,$l=(0,E.getLogger)("modules/e2eping/e2eping.js"),Jl="e2e-ping-request",Bl="e2e-ping-response";class ql{constructor(e,t){this.participant=e,this.e2eping=t,this.id=e.getId(),this.requests={},this.lastRequestId=1,this.sendRequest=this.sendRequest.bind(this),this.handleResponse=this.handleResponse.bind(this),this.maybeLogRttAndStop=this.maybeLogRttAndStop.bind(this),this.scheduleNext=this.scheduleNext.bind(this),this.stop=this.stop.bind(this),this.getDelay=this.getDelay.bind(this),this.timeout=this.scheduleNext()}scheduleNext(){return window.setTimeout(this.sendRequest,this.getDelay())}stop(){this.timeout&&window.clearTimeout(this.timeout),this.e2eping.removeParticipant(this.id)}getDelay(){const e=this.e2eping.conference.getParticipants().length,t=e*(e-1)/2*this.e2eping.numRequests/this.e2eping.maxMessagesPerSecond;return(1.5-Math.random())*Math.max(t/this.e2eping.numRequests*1e3,1e3)}sendRequest(){const e=this.lastRequestId++,t={type:Jl,id:e};this.e2eping.sendMessage(t,this.id),this.requests[e]={id:e,timeSent:window.performance.now()}}handleResponse(e){const t=this.requests[e.id];t&&(t.rtt=window.performance.now()-t.timeSent),this.maybeLogRttAndStop()}maybeLogRttAndStop(){let e,t,n=1/0,i=0,r=0;for(t in this.requests)this.requests.hasOwnProperty(t)&&(e=this.requests[t],r++,e.rtt&&(i++,n=Math.min(n,e.rtt)));return i>=this.e2eping.numRequests?($l.info(`Measured RTT=${n} ms to ${this.id} (in ${this.participant.getProperty("region")})`),this.stop(),void this.e2eping.conference.eventEmitter.emit(Hl,this.participant,n)):r>2*this.e2eping.numRequests?($l.info(`Stopping e2eping for ${this.id} because we sent ${r} with only ${i} responses.`),void this.stop()):void(this.timeout=this.scheduleNext())}}class Gl{constructor(e,t,n){this.conference=e,this.eventEmitter=e.eventEmitter,this.sendMessage=n,this.participants={},this.numRequests=5,this.maxConferenceSize=200,this.maxMessagesPerSecond=250,t&&t.e2eping&&("number"==typeof t.e2eping.numRequests&&(this.numRequests=t.e2eping.numRequests),"number"==typeof t.e2eping.maxConferenceSize&&(this.maxConferenceSize=t.e2eping.maxConferenceSize),"number"==typeof t.e2eping.maxMessagesPerSecond&&(this.maxMessagesPerSecond=t.e2eping.maxMessagesPerSecond)),$l.info(`Initializing e2e ping with numRequests=${this.numRequests}, maxConferenceSize=${this.maxConferenceSize}, maxMessagesPerSecond=${this.maxMessagesPerSecond}.`),this.participantJoined=this.participantJoined.bind(this),this.participantLeft=this.participantLeft.bind(this),e.on(dt,this.participantLeft),this.messageReceived=this.messageReceived.bind(this),e.on(Ce,this.messageReceived),this.conferenceJoined=this.conferenceJoined.bind(this),e.on(ce,this.conferenceJoined)}conferenceJoined(){this.conference.getParticipants().forEach((e=>this.participantJoined(e.getId(),e))),this.conference.on(at,this.participantJoined)}messageReceived(e,t){t.type===Jl?this.handleRequest(e.getId(),t):t.type===Bl&&this.handleResponse(e.getId(),t)}participantJoined(e,t){this.participants[e]&&($l.info(`Participant wrapper already exists for ${e}. Clearing.`),this.participants[e].stop()),this.conference.getParticipants().length>this.maxConferenceSize||this.conference.myUserId()>e&&($l.info(`Starting e2eping for participant ${e}`),this.participants[e]=new ql(t,this))}removeParticipant(e){this.participants[e]&&delete this.participants[e]}participantLeft(e){this.participants[e]&&(this.participants[e].stop(),delete this.participants[e])}handleRequest(e,t){if(t&&t.id){const n={type:Bl,id:t.id};this.sendMessage(n,e)}else $l.info(`Received an invalid e2e ping request from ${e}.`)}handleResponse(e,t){const n=this.participants[e];n&&n.handleResponse(t)}stop(){$l.info("Stopping e2eping"),this.conference.off(at,this.participantJoined),this.conference.off(dt,this.participantLeft),this.conference.off(Ce,this.messageReceived);for(const e in this.participants)this.participants.hasOwnProperty(e)&&this.participants[e].stop();this.participants={}}}const zl=(0,E.getLogger)("modules/event/Jvb121EventGenerator.js");class Kl{constructor(e){this._conference=e,this._jvb121=!0,this._conference.addEventListener(at,(()=>this.evaluateStatus())),this._conference.addEventListener(dt,(()=>this.evaluateStatus())),this._conference.addEventListener(Ue,(()=>this.evaluateStatus()))}evaluateStatus(){const e=this._jvb121,t=!this._conference.isP2PActive()&&this._conference.getParticipantCount()<=2;e!==t&&(this._jvb121=t,zl.debug(`JVB121 status ${e} => ${t}`),this._conference.eventEmitter.emit(Ae,e,t))}}const Wl=Symbol("kJitsiLiteMode"),Xl=(0,E.getLogger)("modules/litemode/LiteModeContext.js");class Yl{constructor(e){this.enabled=Ai.isRunInLiteModeEnabled(),this.enabled&&e.rtc.on(ji.default.REMOTE_TRACK_ADDED,((e,t)=>this._setupLiteModeForTrack(t,e)))}_setupLiteModeForTrack(e,t){if(!this.enabled)return;const n=e.findReceiverForTrack(t.track);if(!n)return void Xl.warn(`Could not set up lite mode for ${t}: receiver not found in: ${e}`);if(n[Wl])return;n[Wl]=!0;const i=n.createEncodedStreams(),r=new TransformStream({transform:()=>{}});i.readable.pipeThrough(r).pipeTo(i.writable)}}const Ql=(0,E.getLogger)("modules/qualitycontrol/ReceiveVideoController.js"),Zl=2160;class eh{constructor(e){const{lastN:t,assumedBandwidthBps:n}=e;this._lastN=null!=t?t:-1,this._maxFrameHeight=Zl,this._assumedBandwidthBps=null!=n?n:-1,this._receiverVideoConstraints={assumedBandwidthBps:this._assumedBandwidthBps,constraints:{},defaultConstraints:{maxHeight:this._maxFrameHeight},lastN:this._lastN}}get constraints(){this._receiverVideoConstraints.assumedBandwidthBps=this._assumedBandwidthBps,this._receiverVideoConstraints.lastN=this._lastN;const e=this._receiverVideoConstraints.constraints;if(e&&Object.keys(e).length)for(const[t,n]of Object.entries(e))n.maxHeight=this._maxFrameHeight;else this._receiverVideoConstraints.defaultConstraints={maxHeight:this._maxFrameHeight};return this._receiverVideoConstraints}updateAssumedBandwidthBps(e){const t=this._assumedBandwidthBps!==e;return t&&(this._assumedBandwidthBps=e,Ql.debug(`Updating receive assumedBandwidthBps: ${e}`)),t}updateLastN(e){const t=this._lastN!==e;return t&&(this._lastN=e,Ql.debug(`Updating ReceiverVideoConstraints lastN(${e})`)),t}updateReceiveResolution(e){const t=this._maxFrameHeight!==e;return t&&(this._maxFrameHeight=e,Ql.debug(`Updating receive maxFrameHeight: ${e}`)),t}updateReceiverVideoConstraints(e){const t=!Et()(this._receiverVideoConstraints,e);var n;return t&&(this._receiverVideoConstraints=e,null!==(n=e.defaultConstraints)&&void 0!==n&&n.maxHeight&&this.updateReceiveResolution(e.defaultConstraints.maxHeight),Ql.debug(`Updating ReceiverVideoConstraints ${JSON.stringify(e)}`)),t}}class th{constructor(e,t){var n;this._conference=e,this._rtc=t;const{config:i}=e.options;this._lastN=null!==(n=null==i?void 0:i.startLastN)&&void 0!==n?n:(null==i?void 0:i.channelLastN)||-1,this._maxFrameHeight=Zl,this._sourceReceiverConstraints=new Map,this._assumedBandwidthBps=-1,this._receiverVideoConstraints=new eh({lastN:this._lastN,assumedBandwidthBps:this._assumedBandwidthBps}),this._conference.on(q,(e=>this._onMediaSessionStarted(e)))}_getDefaultSourceReceiverConstraints(e,t){var n;const i=null!=t?t:Zl,r=(null===(n=e.peerconnection)||void 0===n?void 0:n.getRemoteTracks(null,Ri.VIDEO))||[],o=new Map;for(const e of r)o.set(e.getSourceName(),i);return o}_onMediaSessionStarted(e){e.isP2P?e.setReceiverVideoConstraint(this._getDefaultSourceReceiverConstraints(e)):this._rtc.setReceiverVideoConstraints(this._receiverVideoConstraints.constraints)}getLastN(){return this._lastN}setAssumedBandwidthBps(e){this._receiverVideoConstraints.updateAssumedBandwidthBps(e)&&this._rtc.setReceiverVideoConstraints(this._receiverVideoConstraints.constraints)}setLastN(e){this._lastN!==e&&(this._lastN=e,this._receiverVideoConstraints.updateLastN(e)&&this._rtc.setReceiverVideoConstraints(this._receiverVideoConstraints.constraints))}setPreferredReceiveMaxFrameHeight(e){this._maxFrameHeight=e;for(const t of this._conference.getMediaSessions())t.isP2P?t.setReceiverVideoConstraint(this._getDefaultSourceReceiverConstraints(t,e)):this._receiverVideoConstraints.updateReceiveResolution(e)&&this._rtc.setReceiverVideoConstraints(this._receiverVideoConstraints.constraints)}setReceiverConstraints(e){if(e){if(Object.keys(e).includes("onStageEndpoints","selectedEndpoints"))throw new Error(\'"onStageEndpoints" and "selectedEndpoints" are not supported when sourceNameSignaling is enabled.\');if(this._receiverVideoConstraints.updateReceiverVideoConstraints(e)){var t,n;this._assumedBandwidthBps=null!==(t=e.assumedBandwidthBps)&&void 0!==t?t:this._assumedBandwidthBps,this._lastN=null!==(n=e.lastN)&&void 0!==n?n:this._lastN,this._rtc.setReceiverVideoConstraints(e);const i=this._conference.getMediaSessions().find((e=>e.isP2P));if(!i||!e.constraints)return;const r=Array.from(Object.entries(e.constraints)).map((e=>(e[1]=e[1].maxHeight,e)));this._sourceReceiverConstraints=new Map(r),i.setReceiverVideoConstraint(this._sourceReceiverConstraints)}}}}const nh=(0,E.getLogger)("modules/qualitycontrol/SendVideoController.js");class ih{constructor(e,t){this._conference=e,this._preferredSendMaxFrameHeight=2160,this._rtc=t,this._sourceSenderConstraints=new Map,this._conference.on(q,(e=>this._onMediaSessionStarted(e))),this._conference.on(G,(()=>this._configureConstraintsForLocalSources())),this._rtc.on(ji.default.SENDER_VIDEO_CONSTRAINTS_CHANGED,(e=>this._onSenderConstraintsReceived(e)))}_configureConstraintsForLocalSources(){for(const e of this._rtc.getLocalVideoTracks()){const t=e.getSourceName();t&&this._propagateSendMaxFrameHeight(t)}}_onMediaSessionStarted(e){e.addListener(da.REMOTE_SOURCE_CONSTRAINTS_CHANGED,((e,t)=>{e===this._conference.getActiveMediaSession()&&t.forEach((e=>this._onSenderConstraintsReceived(e)))}))}_onSenderConstraintsReceived(e){var t;const{maxHeight:n,sourceName:i}=e,r=null!==(t=this._conference.getLocalVideoTracks())&&void 0!==t?t:[];for(const e of r)e.getSourceName()===i&&this._sourceSenderConstraints.get(i)!==n&&(this._sourceSenderConstraints.set(i,-1===n?Math.min(2160,this._preferredSendMaxFrameHeight):n),nh.debug(`Sender constraints for source:${i} changed to maxHeight:${n}`),this._propagateSendMaxFrameHeight(i))}_propagateSendMaxFrameHeight(e){if(!e)throw new Error("sourceName missing for calculating the sendMaxHeight for video tracks");const t=this._selectSendMaxFrameHeight(e),n=[];if(t>=0)for(const i of this._conference.getMediaSessions())n.push(i.setSenderVideoConstraint(t,e));return Promise.all(n)}_selectSendMaxFrameHeight(e){if(!e)throw new Error("sourceName missing for calculating the sendMaxHeight for video tracks");const t=this._conference.getActiveMediaSession()?this._sourceSenderConstraints.get(e):void 0;return this._preferredSendMaxFrameHeight>=0&&t>=0?Math.min(this._preferredSendMaxFrameHeight,t):t>=0?t:this._preferredSendMaxFrameHeight}setPreferredSendMaxFrameHeight(e){this._preferredSendMaxFrameHeight=e;const t=[];for(const e of this._sourceSenderConstraints.keys())t.push(this._propagateSendMaxFrameHeight(e));return Promise.allSettled(t)}}const rh={getFocusRecordingUpdate(e){const t=e&&e.getElementsByTagName("jibri-recording-status")[0];if(t)return{error:t.getAttribute("failure_reason"),initiator:t.getAttribute("initiator"),recordingMode:t.getAttribute("recording_mode"),sessionID:t.getAttribute("session_id"),status:t.getAttribute("status")}},getHiddenDomainUpdate(e){const t=e.getElementsByTagName("live-stream-view-url")[0],n=t&&t.textContent,i=e.getElementsByTagName("mode")[0],r=i&&i.textContent&&i.textContent.toLowerCase(),o=e.getElementsByTagName("session_id")[0];return{liveStreamViewURL:n,mode:r,sessionID:o&&o.textContent}},getSessionIdFromIq(e){const t=e&&e.getElementsByTagName("jibri")[0];return t&&t.getAttribute("session_id")},getSessionId(e){const t=e.getElementsByTagName("session_id")[0];return t&&t.textContent},isFromFocus:e=>e.getAttribute("from").includes("focus")};class oh{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this._connection=e.connection,this._mode=e.mode,this._jibriJid=null,this._statusFromJicofo="",this._setSessionID(e.sessionID),this.setStatus(e.status)}getError(){return this._error}getID(){return this._sessionID}getInitiator(){return this._initiator}getLiveStreamViewURL(){return this._liveStreamViewURL}getStatus(){return this._status?this._status:this._statusFromJicofo}getJibriJid(){return this._jibriJid}getTerminator(){return this._terminator}getMode(){return this._mode}setError(e){this._error=e}setLiveStreamViewURL(e){this._liveStreamViewURL=e}setStatus(e){this._status=e}setStatusFromJicofo(e){this._statusFromJicofo=e}setJibriJid(e){this._jibriJid=e}setInitiator(e){this._initiator=e}setTerminator(e){this._terminator=e}start(e){let{appData:t,broadcastId:n,focusMucJid:i,streamId:r}=e;return new Promise(((e,o)=>{this._connection.sendIQ(this._createIQ({action:"start",appData:t,focusMucJid:i,broadcastId:n,streamId:r}),(t=>{this.setStatus("pending"),this._setSessionID(rh.getSessionIdFromIq(t)),e()}),(e=>{this._setErrorFromIq(e),o(e)}))}))}stop(e){let{focusMucJid:t}=e;return new Promise(((e,n)=>{this._connection.sendIQ(this._createIQ({action:"stop",focusMucJid:t}),e,n)}))}_createIQ(e){let{action:t,appData:n,broadcastId:i,focusMucJid:r,streamId:o}=e;return(0,St.$iq)({to:r,type:"set"}).c("jibri",{xmlns:"http://jitsi.org/protocol/jibri",action:t,app_data:n,recording_mode:this._mode,streamid:o,you_tube_broadcast_id:i}).up()}_setErrorFromIq(e){const t=e.getElementsByTagName("error")[0];this.setError(t.children[0].tagName)}_setSessionID(e){this._sessionID=e}}const sh=(0,E.getLogger)("modules/recording/RecordingManager.js"),ah=class{constructor(e){this._sessions={},this._chatRoom=e,this.onPresence=this.onPresence.bind(this),this.onMemberLeft=this.onMemberLeft.bind(this),this._chatRoom.eventEmitter.addListener(Hi.XMPPEvents.PRESENCE_RECEIVED,this.onPresence),this._chatRoom.eventEmitter.addListener(Hi.XMPPEvents.MUC_MEMBER_LEFT,this.onMemberLeft)}getSession(e){return this._sessions[e]}getSessionByJibriJid(e){let t;return Object.values(this._sessions).forEach((n=>{n.getJibriJid()===e&&(t=n)})),t}onPresence(e){let{fromHiddenDomain:t,presence:n}=e;rh.isFromFocus(n)?this._handleFocusPresence(n):t&&this._handleJibriPresence(n)}onMemberLeft(e){const t=this.getSessionByJibriJid(e);if(t){const e=t.getStatus();t.setStatus(""),t.setJibriJid(null),t.getStatus()!==e&&this._emitSessionUpdate(t)}}startRecording(e){const t=new oh({...e,connection:this._chatRoom.connection});return t.start({appData:e.appData,broadcastId:e.broadcastId,focusMucJid:this._chatRoom.focusMucJid,streamId:e.streamId}).then((()=>(this.getSession(t.getID())||(this._addSession(t),this._emitSessionUpdate(t)),t))).catch((e=>(this._emitSessionUpdate(t),Promise.reject(e))))}stopRecording(e){const t=this.getSession(e);return t?t.stop({focusMucJid:this._chatRoom.focusMucJid}):Promise.reject(new Error("Could not find session"))}_addSession(e){this._sessions[e.getID()]=e}_createSession(e,t,n){const i=new oh({connection:this._chatRoom.connection,focusMucJid:this._chatRoom.focusMucJid,mode:n,sessionID:e,status:t});return this._addSession(i),i}_emitSessionUpdate(e,t){this._chatRoom.eventEmitter.emit(Hi.XMPPEvents.RECORDER_STATE_CHANGED,e,t)}_handleFocusPresence(e){const t=rh.getFocusRecordingUpdate(e);if(!t)return;const{error:n,initiator:i,recordingMode:r,sessionID:o,status:s}=t;let a=this.getSession(o);a||"off"!==s?a&&a.getStatus()===s&&a.getError()===n?sh.warn("Ignoring duplicate presence update: ",JSON.stringify(t)):(a||(a=this._createSession(o,s,r)),a.setStatusFromJicofo(s),n&&a.setError(n),this._emitSessionUpdate(a,i)):sh.warn("Ignoring recording presence update","Received a new session with status off.")}_handleJibriPresence(e){const{liveStreamViewURL:t,mode:n,sessionID:i}=rh.getHiddenDomainUpdate(e);if(!i)return void sh.warn("Ignoring potential jibri presence due to no session id.");let r=this.getSession(i);r||(r=this._createSession(i,"on",n)),r.setStatus("on"),r.setJibriJid(e.getAttribute("from")),r.setLiveStreamViewURL(t),this._emitSessionUpdate(r)}},dh=(0,E.getLogger)("modules/statistics/AudioOutputProblemDetector.js");class ch{constructor(e){this._conference=e,this._localAudioLevelCache={},this._reportedParticipants=[],this._audioProblemCandidates={},this._numberOfRemoteAudioLevelsReceived={},this._onLocalAudioLevelsReport=this._onLocalAudioLevelsReport.bind(this),this._onRemoteAudioLevelReceived=this._onRemoteAudioLevelReceived.bind(this),this._clearUserData=this._clearUserData.bind(this),this._conference.on(gl,this._onRemoteAudioLevelReceived),this._conference.statistics.addConnectionStatsListener(this._onLocalAudioLevelsReport),this._conference.on(dt,this._clearUserData)}_onRemoteAudioLevelReceived(e,t){let{avgAudioLevels:n}=t;const i=this._numberOfRemoteAudioLevelsReceived[e]+1||0;if(this._numberOfRemoteAudioLevelsReceived[e]=i,-1!==this._reportedParticipants.indexOf(e)||e in this._audioProblemCandidates||n<=0||i<3)return;const r=this._conference.getParticipantById(e);if(r&&r.getTracksByMediaType(Ri.AUDIO).length>0&&r.isAudioMuted())return;const o=this._localAudioLevelCache[e];Array.isArray(o)&&!o.every((e=>0===e))||(this._audioProblemCandidates[e]={remoteAudioLevels:n,localAudioLevels:[]})}_onLocalAudioLevelsReport(e,t){let{avgAudioLevels:n}=t;e===this._conference.getActivePeerConnection()&&(Object.keys(n).forEach((e=>{if(-1!==this._reportedParticipants.indexOf(e))return;const t=this._localAudioLevelCache[e];Array.isArray(t)?t.length>=2&&t.shift():this._localAudioLevelCache[e]=[],this._localAudioLevelCache[e].push(n[e])})),Object.keys(this._audioProblemCandidates).forEach((e=>{const{localAudioLevels:t,remoteAudioLevels:i}=this._audioProblemCandidates[e];if(t.push(n[e]),2===t.length){if(t.every((e=>void 0===e||0===e))){const n=JSON.stringify(t);Mi.sendAnalytics(((e,t,n)=>({type:kt.TYPE_OPERATIONAL,action:"audio.output.problem",attributes:{userID:e,localAudioLevels:t,remoteAudioLevels:n}}))(e,n,i)),dh.warn(`A potential problem is detected with the audio output for participant ${e}, local audio levels: ${n}, remote audio levels: ${i}`),this._reportedParticipants.push(e),this._clearUserData(e)}delete this._audioProblemCandidates[e]}})))}_clearUserData(e){delete this._localAudioLevelCache[e]}dispose(){this._conference.off(gl,this._onRemoteAudioLevelReceived),this._conference.off(dt,this._clearUserData),this._conference.statistics.removeConnectionStatsListener(this._onLocalAudioLevelsReport),this._localAudioLevelCache=void 0,this._audioProblemCandidates=void 0,this._reportedParticipants=void 0,this._numberOfRemoteAudioLevelsReceived=void 0,this._conference=void 0}}const lh=(0,E.getLogger)("modules/statistics/AvgRTPStatsReporter.js");class hh{constructor(e){this.name=e,this.count=0,this.sum=0,this.samples=[]}addNext(e){void 0!==e&&("number"!=typeof e?lh.error(`${this.name} - invalid value for idx: ${this.count}`,e):isNaN(e)||(this.sum+=e,this.samples.push(e),this.count+=1))}calculate(){return this.sum/this.count}appendReport(e){e[`${this.name}_avg`]=this.calculate(),e[`${this.name}_samples`]=JSON.stringify(this.samples)}reset(){this.samples=[],this.sum=0,this.count=0}}class uh{constructor(e,t,n){this.isP2P=t,this._n=n,this._sampleIdx=0,this._avgRTT=new hh("rtt"),this._avgRemoteRTTMap=new Map,this._avgRtpStatsReporter=e,this._avgEnd2EndRTT=void 0,this._onConnectionStats=(e,t)=>{this.isP2P===e.isP2P&&this._calculateAvgStats(t)};const i=e._conference;i.statistics.addConnectionStatsListener(this._onConnectionStats),this.isP2P||(this._onUserLeft=e=>this._avgRemoteRTTMap.delete(e),i.on(dt,this._onUserLeft),this._onRemoteStatsUpdated=(e,t)=>this._processRemoteStats(e,t),i.on(gl,this._onRemoteStatsUpdated))}_calculateAvgStats(e){if(e){if(ci.supportsRTTStatistics()&&e.transport&&e.transport.length&&this._avgRTT.addNext(e.transport[0].rtt),this._sampleIdx+=1,this._sampleIdx>=this._n){if(ci.supportsRTTStatistics()){const t=this._avgRtpStatsReporter._conference,n={p2p:this.isP2P,conference_size:t.getParticipantCount()};if(e.transport&&e.transport.length&&Object.assign(n,{local_candidate_type:e.transport[0].localCandidateType,remote_candidate_type:e.transport[0].remoteCandidateType,transport_type:e.transport[0].type}),this._avgRTT.appendReport(n),this.isP2P){const e=this._avgRtpStatsReporter.jvbStatsMonitor._avgEnd2EndRTT;isNaN(e)||(n.rtt_diff=this._avgRTT.calculate()-e)}else{const e=this._calculateAvgRemoteRTT(),t=this._avgRTT.calculate();this._avgEnd2EndRTT=t+e,isNaN(t)||isNaN(e)||(n.end2end_rtt_avg=this._avgEnd2EndRTT)}Mi.sendAnalytics(hn(n))}this._resetAvgStats()}}else lh.error("No stats")}_calculateAvgRemoteRTT(){let e=0,t=0;for(const n of this._avgRemoteRTTMap.values()){const i=n.calculate();isNaN(i)||(t+=i,e+=1,n.reset())}return t/e}_processRemoteStats(e,t){const n="number"==typeof t.jvbRTT;let i=this._avgRemoteRTTMap.get(e);!i&&n&&(i=new hh(`${e}_stat_rtt`),this._avgRemoteRTTMap.set(e,i)),n?i.addNext(t.jvbRTT):i&&this._avgRemoteRTTMap.delete(e)}_resetAvgStats(){this._avgRTT.reset(),this._avgRemoteRTTMap&&this._avgRemoteRTTMap.clear(),this._sampleIdx=0}dispose(){const e=this._avgRtpStatsReporter._conference;e.statistics.removeConnectionStatsListener(this._onConnectionStats),this.isP2P||(e.off(gl,this._onRemoteStatsUpdated),e.off(dt,this._onUserLeft))}}class ph{constructor(e,t){this._n=t,t>0?(lh.info(`Avg RTP stats will be calculated every ${t} samples`),this._sampleIdx=0,this._conference=e,this._avgAudioBitrateUp=new hh("bitrate_audio_upload"),this._avgAudioBitrateDown=new hh("bitrate_audio_download"),this._avgVideoBitrateUp=new hh("bitrate_video_upload"),this._avgVideoBitrateDown=new hh("bitrate_video_download"),this._avgBandwidthUp=new hh("bandwidth_upload"),this._avgBandwidthDown=new hh("bandwidth_download"),this._avgPacketLossTotal=new hh("packet_loss_total"),this._avgPacketLossUp=new hh("packet_loss_upload"),this._avgPacketLossDown=new hh("packet_loss_download"),this._avgRemoteFPS=new hh("framerate_remote"),this._avgRemoteScreenFPS=new hh("framerate_screen_remote"),this._avgLocalFPS=new hh("framerate_local"),this._avgLocalScreenFPS=new hh("framerate_screen_local"),this._avgRemoteCameraPixels=new hh("pixels_remote"),this._avgRemoteScreenPixels=new hh("pixels_screen_remote"),this._avgLocalCameraPixels=new hh("pixels_local"),this._avgLocalScreenPixels=new hh("pixels_screen_local"),this._avgCQ=new hh("connection_quality"),this._cachedTransportStats=void 0,this._onLocalStatsUpdated=e=>{this._calculateAvgStats(e),this._maybeSendTransportAnalyticsEvent(e)},e.on(ml,this._onLocalStatsUpdated),this._onP2PStatusChanged=()=>{lh.debug("Resetting average stats calculation"),this._resetAvgStats(),this.jvbStatsMonitor._resetAvgStats(),this.p2pStatsMonitor._resetAvgStats()},e.on(Ue,this._onP2PStatusChanged),this._onJvb121StatusChanged=(e,t)=>{!0===t&&(lh.info("Resetting JVB avg RTP stats"),this._resetAvgJvbStats())},e.on(Ae,this._onJvb121StatusChanged),this.jvbStatsMonitor=new uh(this,!1,t),this.p2pStatsMonitor=new uh(this,!0,t)):lh.info("Avg RTP stats reports are disabled.")}_calculateAvgStats(e){if(!e)return void lh.error("No stats");const t=this._conference.isP2PActive(),n=this._conference.getParticipantCount();if(!t&&n<2)return;const i=e.bitrate,r=e.bandwidth,o=e.packetLoss,s=e.framerate,a=e.resolution;if(i)if(r)if(o)if(s)if(a){if(this._avgAudioBitrateUp.addNext(i.audio.upload),this._avgAudioBitrateDown.addNext(i.audio.download),this._avgVideoBitrateUp.addNext(i.video.upload),this._avgVideoBitrateDown.addNext(i.video.download),ci.supportsBandwidthStatistics()&&(this._avgBandwidthUp.addNext(r.upload),this._avgBandwidthDown.addNext(r.download)),this._avgPacketLossUp.addNext(o.upload),this._avgPacketLossDown.addNext(o.download),this._avgPacketLossTotal.addNext(o.total),this._avgCQ.addNext(e.connectionQuality),s&&(this._avgRemoteFPS.addNext(this._calculateAvgVideoFps(s,!1,Qo.VideoType.CAMERA)),this._avgRemoteScreenFPS.addNext(this._calculateAvgVideoFps(s,!1,Qo.VideoType.DESKTOP)),this._avgLocalFPS.addNext(this._calculateAvgVideoFps(s,!0,Qo.VideoType.CAMERA)),this._avgLocalScreenFPS.addNext(this._calculateAvgVideoFps(s,!0,Qo.VideoType.DESKTOP))),a&&(this._avgRemoteCameraPixels.addNext(this._calculateAvgVideoPixels(a,!1,Qo.VideoType.CAMERA)),this._avgRemoteScreenPixels.addNext(this._calculateAvgVideoPixels(a,!1,Qo.VideoType.DESKTOP)),this._avgLocalCameraPixels.addNext(this._calculateAvgVideoPixels(a,!0,Qo.VideoType.CAMERA)),this._avgLocalScreenPixels.addNext(this._calculateAvgVideoPixels(a,!0,Qo.VideoType.DESKTOP))),this._sampleIdx+=1,this._sampleIdx>=this._n){const i={p2p:t,conference_size:n};e.transport&&e.transport.length&&Object.assign(i,{local_candidate_type:e.transport[0].localCandidateType,remote_candidate_type:e.transport[0].remoteCandidateType,transport_type:e.transport[0].type}),this._avgAudioBitrateUp.appendReport(i),this._avgAudioBitrateDown.appendReport(i),this._avgVideoBitrateUp.appendReport(i),this._avgVideoBitrateDown.appendReport(i),ci.supportsBandwidthStatistics()&&(this._avgBandwidthUp.appendReport(i),this._avgBandwidthDown.appendReport(i)),this._avgPacketLossUp.appendReport(i),this._avgPacketLossDown.appendReport(i),this._avgPacketLossTotal.appendReport(i),this._avgRemoteFPS.appendReport(i),isNaN(this._avgRemoteScreenFPS.calculate())||this._avgRemoteScreenFPS.appendReport(i),this._avgLocalFPS.appendReport(i),isNaN(this._avgLocalScreenFPS.calculate())||this._avgLocalScreenFPS.appendReport(i),this._avgRemoteCameraPixels.appendReport(i),isNaN(this._avgRemoteScreenPixels.calculate())||this._avgRemoteScreenPixels.appendReport(i),this._avgLocalCameraPixels.appendReport(i),isNaN(this._avgLocalScreenPixels.calculate())||this._avgLocalScreenPixels.appendReport(i),this._avgCQ.appendReport(i),Mi.sendAnalytics(hn(i)),this._resetAvgStats()}}else lh.error("No resolution");else lh.error(\'No "framerate"\');else lh.error(\'No "packetloss"\');else lh.error(\'No "bandwidth"\');else lh.error(\'No "bitrate"\')}_calculateAvgVideoPixels(e,t,n){let i=0,r=0;const o=this._conference.myUserId();for(const s of Object.keys(e))if(t?s===o:s!==o){const o=t?null:this._conference.getParticipantById(s),a=e[s];if((t||o)&&a){const e=this._calculatePeerAvgVideoPixels(a,o,n);isNaN(e)||(i+=e,r+=1)}}return i/r}_calculatePeerAvgVideoPixels(e,t,n){let i=Object.keys(e).map((e=>Number(e))),r=null;const o=this._conference.getActivePeerConnection();t?(r=t.getTracksByMediaType(Ri.VIDEO),r&&(i=i.filter((e=>r.find((t=>!t.isMuted()&&t.getSSRC()===e&&t.videoType===n)))))):(r=this._conference.getLocalTracks(Ri.VIDEO),i=i.filter((e=>r.find((t=>!t.isMuted()&&o.getLocalSSRC(t)===e&&t.videoType===n)))));let s=0,a=0;for(const t of i){const n=Number(e[t].height)*Number(e[t].width);!isNaN(n)&&n>0&&(s+=n,a+=1)}return s/a}_calculateAvgVideoFps(e,t,n){let i=0,r=0;const o=this._conference.myUserId();for(const s of Object.keys(e))if(t?s===o:s!==o){const o=t?null:this._conference.getParticipantById(s),a=e[s];if((t||o)&&a){const e=this._calculatePeerAvgVideoFps(a,o,n);isNaN(e)||(i+=e,r+=1)}}return i/r}_calculatePeerAvgVideoFps(e,t,n){let i=Object.keys(e).map((e=>Number(e))),r=null;const o=this._conference.getActivePeerConnection();t?(r=t.getTracksByMediaType(Ri.VIDEO),r&&(i=i.filter((e=>r.find((t=>!t.isMuted()&&t.getSSRC()===e&&t.videoType===n)))))):(r=this._conference.getLocalTracks(Ri.VIDEO),i=i.filter((e=>r.find((t=>!t.isMuted()&&o.getLocalSSRC(t)===e&&t.videoType===n)))));let s=0,a=0;for(const t of i){const n=Number(e[t]);!isNaN(n)&&n>0&&(s+=n,a+=1)}return s/a}_maybeSendTransportAnalyticsEvent(e){if(!e||!e.transport||!e.transport.length)return;const t={p2p:e.transport[0].p2p,local_candidate_type:e.transport[0].localCandidateType,remote_candidate_type:e.transport[0].remoteCandidateType,transport_type:e.transport[0].type};var n;this._cachedTransportStats&&Et()(t,this._cachedTransportStats)||(this._cachedTransportStats=t,Mi.sendAnalytics((n=t,{type:kt.TYPE_OPERATIONAL,action:"transport.stats",attributes:n})))}_resetAvgJvbStats(){this._resetAvgStats(),this.jvbStatsMonitor._resetAvgStats()}_resetAvgStats(){this._avgAudioBitrateUp.reset(),this._avgAudioBitrateDown.reset(),this._avgVideoBitrateUp.reset(),this._avgVideoBitrateDown.reset(),this._avgBandwidthUp.reset(),this._avgBandwidthDown.reset(),this._avgPacketLossUp.reset(),this._avgPacketLossDown.reset(),this._avgPacketLossTotal.reset(),this._avgRemoteFPS.reset(),this._avgRemoteScreenFPS.reset(),this._avgLocalFPS.reset(),this._avgLocalScreenFPS.reset(),this._avgRemoteCameraPixels.reset(),this._avgRemoteScreenPixels.reset(),this._avgLocalCameraPixels.reset(),this._avgLocalScreenPixels.reset(),this._avgCQ.reset(),this._sampleIdx=0}dispose(){this._conference.off(Ue,this._onP2PStatusChanged),this._conference.off(ml,this._onLocalStatsUpdated),this._conference.off(Ae,this._onJvb121StatusChanged),this.jvbStatsMonitor.dispose(),this.p2pStatsMonitor.dispose()}}var mh=n(444),gh=n.n(mh);class fh{constructor(e){this.stats={users:{},dominantSpeakerId:null};const t=e.myUserId();this.stats.users[t]=new(gh())(t,null,!0),this.conference=e,e.addEventListener(ye,this._onDominantSpeaker.bind(this)),e.addEventListener(at,this._onUserJoin.bind(this)),e.addEventListener(dt,this._onUserLeave.bind(this)),e.addEventListener(_e,this._onDisplayNameChange.bind(this)),e.on(Ce,((e,t)=>{let{type:n,faceLandmarks:i}=t;"face-landmarks"===n&&this._onFaceLandmarkAdd(e.getId(),i)})),e.xmpp&&e.xmpp.addListener(Hi.XMPPEvents.SPEAKER_STATS_RECEIVED,this._updateStats.bind(this))}_onDominantSpeaker(e,t,n){const i=this.stats.users[this.stats.dominantSpeakerId],r=this.stats.users[e];i&&i.setDominantSpeaker(!1),r&&r.setDominantSpeaker(!0,n),this.stats.dominantSpeakerId=e}_onUserJoin(e,t){t.isHidden()||this.stats.users[e]||(this.stats.users[e]=new(gh())(e,t.getDisplayName()))}_onUserLeave(e){const t=this.stats.users[e];t&&t.markAsHasLeft()}_onDisplayNameChange(e,t){const n=this.stats.users[e];n&&n.setDisplayName(t)}_onFaceLandmarkAdd(e,t){const n=this.stats.users[e];n&&t&&n.addFaceLandmarks(t)}getStats(){return this.stats.users}_updateStats(e){for(const t in e){let n;const i=this.conference.getParticipantById(t);i&&i.isHidden()||(this.stats.users[t]?(n=this.stats.users[t],n.getDisplayName()||n.setDisplayName(e[t].displayName)):(n=new(gh())(t,e[t].displayName),this.stats.users[t]=n,n.markAsHasLeft()),n.totalDominantSpeakerTime=e[t].totalDominantSpeakerTime,Array.isArray(e[t].faceLandmarks)&&n.setFaceLandmarks(e[t].faceLandmarks))}}}const vh=n(810).getLogger("modules/version/ComponentsVersions.js");function _h(e){this.versions={},this.conference=e,this.conference.addCommandListener("versions",this.processVersions.bind(this))}let yh,Eh,Sh;_h.prototype.processVersions=function(e,t,n){this.conference.isFocus(n)?e.children.forEach((e=>{const t=e.attributes.name,n=e.value;this.versions[t]!==n&&(this.versions[t]=n,vh.info(`Got ${t} version: ${n}`))})):vh.warn(`Received versions not from the focus user: ${e}`,n)},_h.prototype.getComponentVersion=function(e){return this.versions[e]},function(e){e.STATUS_AVAILABLE="available",e.STATUS_UNDEFINED="undefined",e.STATUS_BUSY="busy"}(yh||(yh={})),function(e){e.STATE_ON="on",e.STATE_OFF="off",e.STATE_PENDING="pending",e.STATE_RETRYING="retrying",e.STATE_FAILED="failed"}(Eh||(Eh={})),function(e){e.ERROR_NO_CONNECTION="error_no_connection",e.ERROR_SESSION_EXISTS="error_session_already_exists"}(Sh||(Sh={}));const bh=yh.STATUS_AVAILABLE,Th=yh.STATUS_UNDEFINED,Ch=yh.STATUS_BUSY,xh=Eh.STATE_ON,Rh=Eh.STATE_OFF,Ah=Eh.STATE_PENDING,wh=Eh.STATE_RETRYING,Ih=Eh.STATE_FAILED,Ph=Sh.ERROR_NO_CONNECTION,Dh=Sh.ERROR_SESSION_EXISTS,Oh=(0,E.getLogger)("modules/videosipgw/JitsiVideoSIPGWSession.js"),kh="STATE_CHANGED";class Nh extends xr{constructor(e,t,n){super(),this.sipAddress=e,this.displayName=t,this.chatRoom=n,this.state=void 0}stop(){this.state!==Rh&&this.state!==Ih?this._sendJibriIQ("stop"):Oh.warn("Video SIP GW session already stopped or failed!")}start(){this.state!==xh&&this.state!==Rh&&this.state!==Ah&&this.state!==wh?this._sendJibriIQ("start"):Oh.warn("Video SIP GW session already started!")}setState(e,t){if(e===this.state)return;const n=this.state;this.state=e,this.eventEmitter.emit(kh,{address:this.sipAddress,failureReason:t,oldState:n,newState:this.state,displayName:this.displayName})}addStateListener(e){this.addListener(kh,e)}removeStateListener(e){this.removeListener(kh,e)}_sendJibriIQ(e){const t={xmlns:"http://jitsi.org/protocol/jibri",action:e,sipaddress:this.sipAddress};t.displayname=this.displayName;const n=(0,St.$iq)({to:this.chatRoom.focusMucJid,type:"set"}).c("jibri",t).up();Oh.debug(`${e} video SIP GW session`,n.nodeTree),this.chatRoom.connection.sendIQ(n,(()=>{}),(t=>{Oh.error(`Failed to ${e} video SIP GW session, error: `,t),this.setState(Ih)}))}}const Mh=(0,E.getLogger)("modules/videosipgw/VideoSIPGW.js");class Lh{constructor(e){this.chatRoom=e,this.eventEmitter=e.eventEmitter,Mh.debug("creating VideoSIPGW"),this.sessions={},this.sessionStateChangeListener=this.sessionStateChanged.bind(this),e.addPresenceListener("jibri-sip-call-state",this.handleJibriSIPState.bind(this))}handleJibriSIPState(e){const t=e.attributes;if(!t)return;Mh.debug("Handle video sip gw state : ",t);const n=t.state;if(n!==this.state)switch(n){case xh:case Rh:case Ah:case wh:case Ih:{const e=t.sipaddress;if(!e)return;const i=this.sessions[e];i?i.setState(n,t.failure_reason):Mh.warn("Video SIP GW session not found:",e)}}}createVideoSIPGWSession(e,t){if(this.sessions[e])return Mh.warn("There was already a Video SIP GW session for address",e),new Error(Dh);const n=new Nh(e,t,this.chatRoom);return n.addStateListener(this.sessionStateChangeListener),this.sessions[e]=n,n}sessionStateChanged(e){const t=e.address;if(e.newState===Rh||e.newState===Ih){const e=this.sessions[t];if(!e)return void Mh.error("Missing Video SIP GW session with address:",t);e.removeStateListener(this.sessionStateChangeListener),delete this.sessions[t]}this.eventEmitter.emit(Hi.XMPPEvents.VIDEO_SIP_GW_SESSION_STATE_CHANGED,e)}}const Fh=(0,E.getLogger)("modules/xmpp/SignalingLayerImpl.js"),jh="SourceInfo";class Vh extends Ac{constructor(){super(),this.ssrcOwners=new Map,this.chatRoom=null,this._localSourceState={},this._remoteSourceState={}}_addLocalSourceInfoToPresence(){return!!this.chatRoom&&this.chatRoom.addOrReplaceInPresence(jh,{value:JSON.stringify(this._localSourceState)})}_bindChatRoomEventHandlers(e){const t=(e,t)=>{this.eventEmitter.emit(yc,e,Ri.AUDIO,t)};this._audioMuteHandler=(e,n)=>{this._doesEndpointSendNewSourceInfo(n)||t(n,"true"===e.value)},e.addPresenceListener("audiomuted",this._audioMuteHandler);const n=(e,t)=>{this.eventEmitter.emit(yc,e,Ri.VIDEO,t)};this._videoMuteHandler=(e,t)=>{this._doesEndpointSendNewSourceInfo(t)||n(t,"true"===e.value)},e.addPresenceListener("videomuted",this._videoMuteHandler);const i=(e,t)=>{this.eventEmitter.emit(Ec,e,t)};this._videoTypeHandler=(e,t)=>{this._doesEndpointSendNewSourceInfo(t)||i(t,e.value)},e.addPresenceListener("videoType",this._videoTypeHandler),this._sourceInfoHandler=(e,t)=>{const n=t,{value:i}=e,r=_r(i),o=this._doesEndpointSendNewSourceInfo(n),s=this._remoteSourceState[n]||(this._remoteSourceState[n]={});for(const e of Object.keys(r)){var a;let n=!1;const i=xc(e),d=Boolean(r[e].muted),c=s[e]||(s[e]={sourceName:e});c.muted!==d&&(n=!0,c.muted=d,o&&!this._localSourceState[e]&&this.eventEmitter.emit(Sc,e,d));const l=i===Ri.VIDEO?null!==(a=r[e].videoType)&&void 0!==a?a:Qo.VideoType.CAMERA:void 0;c.videoType!==l&&(c.videoType=l,n=!0,o&&!this._localSourceState[e]&&this.eventEmitter.emit(Tc,e,l)),n&&Ai.isSsrcRewritingSupported()&&this.eventEmitter.emit(bc,e,t,d,l)}const d=Object.keys(r);for(const e of Object.keys(s))-1===d.indexOf(e)&&delete s[e]},e.addPresenceListener("SourceInfo",this._sourceInfoHandler),this._memberLeftHandler=e=>{const t=St.Strophe.getResourceFromJid(e);delete this._remoteSourceState[t]},e.addEventListener(Hi.XMPPEvents.MUC_MEMBER_LEFT,this._memberLeftHandler)}_doesEndpointSendNewSourceInfo(e){var t;const n=null===(t=this.chatRoom)||void 0===t?void 0:t.getLastPresence(e);return Boolean(n&&n.find((e=>e.tagName===jh)))}_logOwnerChangedMessage(e){Ai.isSsrcRewritingSupported()?Fh.debug(e):Fh.error(e)}getPeerMediaInfo(e,t,n){var i;const r=null===(i=this.chatRoom)||void 0===i?void 0:i.getLastPresence(e);if(!r)return void Fh.warn(`getPeerMediaInfo - no presence stored for: ${e}`);if(!this._doesEndpointSendNewSourceInfo(e))return(()=>{if(this.chatRoom)return this.chatRoom.getMediaPresenceInfo(e,t);Fh.warn("Requested peer media info, before room was set")})();if(n)return this.getPeerSourceInfo(e,n);const o={muted:!0};if(t===Ri.VIDEO){o.videoType=void 0;const e=ms(r,"jitsi_participant_codecList"),t=ms(r,"jitsi_participant_codecType");var s,a;e.length?o.codecList=null!==(s=null===(a=e[0].value)||void 0===a?void 0:a.split(","))&&void 0!==s?s:[]:t.length>0&&(o.codecType=t[0].value)}return o}getPeerSourceInfo(e,t){var n;const i={muted:!0,videoType:xc(t)===Ri.VIDEO?Qo.VideoType.CAMERA:void 0};return this._remoteSourceState[e]?null!==(n=this._remoteSourceState[e][t])&&void 0!==n?n:i:void 0}getSSRCOwner(e){var t;return null===(t=this.ssrcOwners.get(e))||void 0===t?void 0:t.endpointId}getTrackSourceName(e){var t;return null===(t=this.ssrcOwners.get(e))||void 0===t?void 0:t.sourceName}removeSSRCOwners(e){if(null!=e&&e.length)for(const t of e)this.ssrcOwners.delete(t)}setChatRoom(e){const t=this.chatRoom;this.chatRoom=e,t&&(t.removePresenceListener("audiomuted",this._audioMuteHandler),t.removePresenceListener("videomuted",this._videoMuteHandler),t.removePresenceListener("videoType",this._videoTypeHandler),this._sourceInfoHandler&&t.removePresenceListener(jh,this._sourceInfoHandler),this._memberLeftHandler&&t.removeEventListener(Hi.XMPPEvents.MUC_MEMBER_LEFT,this._memberLeftHandler)),e&&(this._bindChatRoomEventHandlers(e),this._addLocalSourceInfoToPresence())}setSSRCOwner(e,t,n){if("number"!=typeof e)throw new TypeError(`SSRC(${e}) must be a number`);const i=this.ssrcOwners.get(e);if(i){const{endpointId:e,sourceName:r}=i;e===t&&r===n||this._logOwnerChangedMessage(`SSRC owner re-assigned from ${i}(source-name=${r}) to ${t}(source-name=${n})`)}this.ssrcOwners.set(e,{endpointId:t,sourceName:n})}setTrackMuteStatus(e,t){return this._localSourceState[e]||(this._localSourceState[e]={}),this._localSourceState[e].muted=t,Fh.debug(`Mute state of ${e} changed to muted=${t}`),!!this.chatRoom&&this._addLocalSourceInfoToPresence()}setTrackVideoType(e,t){return this._localSourceState[e]||(this._localSourceState[e]={}),this._localSourceState[e].videoType!==t&&(this._localSourceState[e].videoType=t===Qo.VideoType.CAMERA?void 0:t,this._addLocalSourceInfoToPresence())}updateSsrcOwnersOnLeave(e){const t=[];this.ssrcOwners.forEach(((n,i)=>{let{endpointId:r}=n;r===e&&t.push(i)})),null!=t&&t.length&&this.removeSSRCOwners(t)}}let Uh;!function(e){e.CAMERA="camera",e.DESKTOP="desktop",e.DESKTOP_HIGH_FPS="desktop_high_fps",e.NONE="none"}(Uh||(Uh={}));const Hh=(0,E.getLogger)("JitsiConference.js");function $h(e){return"string"==typeof e?Object.values(Ds).find((t=>t===e.toLowerCase())):null}function Jh(e){var t,n,i;if(!e.name||e.name.toLowerCase()!==e.name.toString()){const t="Invalid conference name (no conference name passed or it contains invalid characters like capital letters)!",n=e.name?`roomName=${e.name}; condition - ${e.name.toLowerCase()}!==${e.name.toString()}`:"No room name passed!";throw Hh.error(`${t} ${n}`),new Error(t)}if(this.connection=e.connection,this.xmpp=null===(t=this.connection)||void 0===t?void 0:t.xmpp,this.xmpp.isRoomCreated(e.name,e.customDomain)){const e="A conference with the same name has already been created!";throw delete this.connection,delete this.xmpp,Hh.error(e),new Error(e)}this.eventEmitter=new ii,this.options=e,this.eventManager=new Ji(this),this.participants=new Map,this._signalingLayer=new Vh,this._init(e),this.componentsVersions=new _h(this),this.jvbJingleSession=null,this.lastDominantSpeaker=null,this.dtmfManager=null,this.somebodySupportsDTMF=!1,this.authEnabled=!1,this.startAudioMuted=!1,this.startVideoMuted=!1,this.startMutedPolicy={audio:!1,video:!1},this.isMutedByFocus=!1,this.mutedByFocusActor=null,this.isVideoMutedByFocus=!1,this.mutedVideoByFocusActor=null,this.wasStopped=!1,this.properties={},this.connectionQuality=new Sl(this,this.eventEmitter,e),this.avgRtpStatsReporter=new ph(this,e.config.avgRtpStatsN||15),e.config.disableAudioLevels||(this._audioOutputProblemDetector=new ch(this)),this.isJvbConnectionInterrupted=!1,this.speakerStatsCollector=new fh(this),this.deferredStartP2PTask=null;const r=parseInt(e.config.p2p&&e.config.p2p.backToP2PDelay,10);this.backToP2PDelay=isNaN(r)?5:r,Hh.info(`backToP2PDelay: ${this.backToP2PDelay}`),this.isP2PConnectionInterrupted=!1,this.p2p=!1,this.p2pJingleSession=null,this.videoSIPGWHandler=new Lh(this.room),this.recordingManager=new ah(this.room),this._conferenceJoinAnalyticsEventSent=void 0,this.isE2EESupported()&&(Hh.info("End-to-End Encryption is supported"),this._e2eEncryption=new so(this)),Ai.isRunInLiteModeEnabled()&&(Hh.info("Lite mode enabled"),this._liteModeContext=new Yl(this)),this._audioSenderLimitReached=void 0,this._videoSenderLimitReached=void 0,this._firefoxP2pEnabled=ci.isVersionGreaterThan(109)&&(null===(n=null===(i=this.options.config.testing)||void 0===i?void 0:i.enableFirefoxP2p)||void 0===n||n)}function Bh(e,t,n){this.appID=e,this.token=t,this.options=n,Ai.init(n.flags||{}),this.xmpp=new Pa(n,t),this.addEventListener(ur,((e,t,n,i)=>{Mi.sendAnalyticsAndLog(rn(e,t,i))})),this.addEventListener(lr,(e=>{e&&Mi.sendAnalytics(Xt,{message:e})}))}let qh;Jh.prototype.constructor=Jh,Jh.resourceCreator=function(e,t){let n;var i;t?n=co().randomHexString(8).toLowerCase():(n=null===(i=St.Strophe.getNodeFromJid(e))||void 0===i?void 0:i.substr(0,8).toLowerCase(),n&&/[0-9a-f]{8}/g.test(n)||(n=co().randomHexString(8).toLowerCase()));return n},Jh.prototype._init=function(){var e,t,n,i,r,o,s,a,d;let c=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.eventManager.setupXMPPListeners();const{config:l}=this.options,h={jvb:{preferenceOrder:ci.isMobileDevice()&&null!==(e=l.videoQuality)&&void 0!==e&&e.mobileCodecPreferenceOrder?l.videoQuality.mobileCodecPreferenceOrder:null===(t=l.videoQuality)||void 0===t?void 0:t.codecPreferenceOrder,disabledCodec:$h(null===(n=l.videoQuality)||void 0===n?void 0:n.disabledCodec),preferredCodec:$h(null===(i=l.videoQuality)||void 0===i?void 0:i.preferredCodec)},p2p:{preferenceOrder:ci.isMobileDevice()&&null!==(r=l.p2p)&&void 0!==r&&r.mobileCodecPreferenceOrder?l.p2p.mobileCodecPreferenceOrder:null===(o=l.p2p)||void 0===o?void 0:o.codecPreferenceOrder,disabledCodec:$h(null===(s=l.p2p)||void 0===s?void 0:s.disabledCodec),preferredCodec:$h(null===(a=l.p2p)||void 0===a?void 0:a.preferredCodec)}};if(this.codecSelection=new La(this,h),this._statsCurrentId=l.statisticsId?l.statisticsId:$o.callStatsUserName,this.room=this.xmpp.createRoom(this.options.name,{...l,statsId:this._statsCurrentId},Jh.resourceCreator),this._signalingLayer.setChatRoom(this.room),this._signalingLayer.on(_c.SOURCE_UPDATED,((e,t,n,i)=>{const r=this.participants.get(t),o=xc(e);r&&(r._setSources(o,n,e,i),this.eventEmitter.emit($e,r))})),this._onIceConnectionInterrupted=this._onIceConnectionInterrupted.bind(this),this.room.addListener(Hi.XMPPEvents.CONNECTION_INTERRUPTED,this._onIceConnectionInterrupted),this._onIceConnectionRestored=this._onIceConnectionRestored.bind(this),this.room.addListener(Hi.XMPPEvents.CONNECTION_RESTORED,this._onIceConnectionRestored),this._onIceConnectionEstablished=this._onIceConnectionEstablished.bind(this),this.room.addListener(Hi.XMPPEvents.CONNECTION_ESTABLISHED,this._onIceConnectionEstablished),this._updateProperties=this._updateProperties.bind(this),this.room.addListener(Hi.XMPPEvents.CONFERENCE_PROPERTIES_CHANGED,this._updateProperties),this._sendConferenceJoinAnalyticsEvent=this._sendConferenceJoinAnalyticsEvent.bind(this),this.room.addListener(Hi.XMPPEvents.MEETING_ID_SET,this._sendConferenceJoinAnalyticsEvent),this._removeLocalSourceOnReject=this._removeLocalSourceOnReject.bind(this),this._updateRoomPresence=this._updateRoomPresence.bind(this),this.room.addListener(Hi.XMPPEvents.SESSION_ACCEPT,this._updateRoomPresence),this.room.addListener(Hi.XMPPEvents.SOURCE_ADD,this._updateRoomPresence),this.room.addListener(Hi.XMPPEvents.SOURCE_ADD_ERROR,this._removeLocalSourceOnReject),this.room.addListener(Hi.XMPPEvents.SOURCE_REMOVE,this._updateRoomPresence),null!==(d=l.e2eping)&&void 0!==d&&d.enabled&&(this.e2eping=new Gl(this,l,((e,t)=>{try{this.sendMessage(e,t,!0)}catch(e){Hh.warn("Failed to send E2E ping request or response.",e&&e.msg)}}))),this.rtc||(this.rtc=new pl(this,c),this.eventManager.setupRTCListeners(),this._registerRtcListeners(this.rtc)),this.receiveVideoController=new th(this,this.rtc),this.sendVideoController=new ih(this,this.rtc),this.statistics||(this.statistics=new Mi(this,{aliasName:this._statsCurrentId,userName:l.statisticsDisplayName?l.statisticsDisplayName:this.myUserId(),confID:l.confID||`${this.connection.options.hosts.domain}/${this.options.name}`,roomName:this.options.name,applicationName:l.applicationName}),Mi.analytics.addPermanentProperties({callstats_name:this._statsCurrentId}),l.longTasksStatsInterval&&this.statistics.attachLongTasksStats()),this.eventManager.setupChatRoomListeners(),this.eventManager.setupStatisticsListeners(),l.enableTalkWhileMuted&&ci.supportsVADDetection())if(l.createVADProcessor){Hh.info("Using VAD detection for generating talk while muted events"),this._audioAnalyser||(this._audioAnalyser=new Fl(this,l.createVADProcessor));const e=new Vl;e.on(Dl,(()=>this.eventEmitter.emit(et))),this._audioAnalyser.addVADDetectionService(e)}else Hh.warn("No VAD Processor was provided. Talk while muted detection service was not initialized!");if(l.enableNoisyMicDetection&&ci.supportsVADDetection())if(l.createVADProcessor){this._audioAnalyser||(this._audioAnalyser=new Fl(this,l.createVADProcessor));const e=new jl;e.on(wl,(()=>this.eventEmitter.emit(je))),this._audioAnalyser.addVADDetectionService(e)}else Hh.warn("No VAD Processor was provided. Noisy microphone detection service was not initialized!");l.enableNoAudioDetection&&!l.disableAudioLevels&&_i.isLocalStatsSupported()&&(this._noAudioSignalDetection=new Ol(this),this._noAudioSignalDetection.on(Al,(()=>{this.eventEmitter.emit(Fe)})),this._noAudioSignalDetection.on(Rl,(e=>{this.eventEmitter.emit(z,e)}))),"channelLastN"in l&&this.setLastN(l.channelLastN),this.jvb121Status=new Kl(this),this.p2pDominantSpeakerDetection=new kl(this),l&&l.deploymentInfo&&l.deploymentInfo.userRegion&&this.setLocalParticipantProperty("region",l.deploymentInfo.userRegion),this.setLocalParticipantProperty("codecList",this.codecSelection.getCodecPreferenceList("jvb")),l&&l.transcriptionLanguage&&"en-US"!==l.transcriptionLanguage&&this.setLocalParticipantProperty("transcription_language",l.transcriptionLanguage)},Jh.prototype.join=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];this.room&&this.room.join(e,t).then((()=>this._maybeSetSITimeout()))},Jh.prototype.authenticateAndUpgradeRole=function(e){return Da.call(this,{...e,onCreateResource:Jh.resourceCreator})},Jh.prototype.isJoined=function(){return this.room&&this.room.joined},Jh.prototype.isP2PEnabled=function(){return Boolean(this.options.config.p2p&&this.options.config.p2p.enabled)||void 0===this.options.config.p2p},Jh.prototype.isP2PTestModeEnabled=function(){return Boolean(this.options.config.testing&&this.options.config.testing.p2pTestMode)},Jh.prototype.leave=async function(e){if(this.avgRtpStatsReporter&&(this.avgRtpStatsReporter.dispose(),this.avgRtpStatsReporter=null),this._audioOutputProblemDetector&&(this._audioOutputProblemDetector.dispose(),this._audioOutputProblemDetector=null),this.e2eping&&(this.e2eping.stop(),this.e2eping=null),this.getLocalTracks().forEach((e=>this.onLocalTrackRemoved(e))),this.rtc.closeBridgeChannel(),this._sendConferenceLeftAnalyticsEvent(),this.statistics&&this.statistics.dispose(),this._delayedIceFailed&&this._delayedIceFailed.cancel(),this._maybeClearSITimeout(),this._maybeClearDeferredStartP2P(),this.jvbJingleSession&&(this.jvbJingleSession.close(),this.jvbJingleSession=null),this.p2pJingleSession&&(this.p2pJingleSession.close(),this.p2pJingleSession=null),!this.room)throw new Error("You have already left the conference");const t=this.room;let n;t.removeListener(Hi.XMPPEvents.CONNECTION_INTERRUPTED,this._onIceConnectionInterrupted),t.removeListener(Hi.XMPPEvents.CONNECTION_RESTORED,this._onIceConnectionRestored),t.removeListener(Hi.XMPPEvents.CONNECTION_ESTABLISHED,this._onIceConnectionEstablished),t.removeListener(Hi.XMPPEvents.CONFERENCE_PROPERTIES_CHANGED,this._updateProperties),t.removeListener(Hi.XMPPEvents.MEETING_ID_SET,this._sendConferenceJoinAnalyticsEvent),t.removeListener(Hi.XMPPEvents.SESSION_ACCEPT,this._updateRoomPresence),t.removeListener(Hi.XMPPEvents.SOURCE_ADD,this._updateRoomPresence),t.removeListener(Hi.XMPPEvents.SOURCE_ADD_ERROR,this._removeLocalSourceOnReject),t.removeListener(Hi.XMPPEvents.SOURCE_REMOVE,this._updateRoomPresence),this.eventManager.removeXMPPListeners(),this._signalingLayer.setChatRoom(null),this.room=null;try{await t.leave(e)}catch(e){n=e,this.getParticipants().forEach((e=>this.onMemberLeft(e.getJid())))}if(this.rtc&&this.rtc.destroy(),n)throw n},Jh.prototype.isEndConferenceSupported=function(){return Boolean(this.room&&this.room.xmpp.endConferenceComponentAddress)},Jh.prototype.end=function(){if(this.isEndConferenceSupported()){if(!this.room)throw new Error("You have already left the conference");this.room.end()}else Hh.warn("Cannot end conference: is not supported.")},Jh.prototype.getActiveMediaSession=function(){return this.isP2PActive()?this.p2pJingleSession:this.jvbJingleSession},Jh.prototype.getMediaSessions=function(){const e=[];return this.jvbJingleSession&&e.push(this.jvbJingleSession),this.p2pJingleSession&&e.push(this.p2pJingleSession),e},Jh.prototype._registerRtcListeners=function(e){e.addListener(ji.default.DATA_CHANNEL_OPEN,(()=>{for(const e of this.rtc.localTracks)e.isVideoTrack()&&this._sendBridgeVideoTypeMessage(e)}))},Jh.prototype._sendBridgeVideoTypeMessage=function(e){let t=!e||e.isMuted()?Uh.NONE:e.getVideoType();t===Uh.DESKTOP&&this._desktopSharingFrameRate>5&&(t=Uh.DESKTOP_HIGH_FPS),e&&this.rtc.sendSourceVideoType(e.getSourceName(),t)},Jh.prototype.getName=function(){return this.options.name.toString()},Jh.prototype.getConnection=function(){return this.connection},Jh.prototype.isAuthEnabled=function(){return this.authEnabled},Jh.prototype.isLoggedIn=function(){return Boolean(this.authIdentity)},Jh.prototype.getAuthLogin=function(){return this.authIdentity},Jh.prototype.getLocalTracks=function(e){let t=[];return this.rtc&&(t=this.rtc.getLocalTracks(e)),t},Jh.prototype.getLocalAudioTrack=function(){return this.rtc?this.rtc.getLocalAudioTrack():null},Jh.prototype.getLocalVideoTrack=function(){return this.rtc?this.rtc.getLocalVideoTrack():null},Jh.prototype.getLocalVideoTracks=function(){return this.rtc?this.rtc.getLocalVideoTracks():null},Jh.prototype.getPerformanceStats=function(){return{longTasksStats:this.statistics.getLongTasksStats()}},Jh.prototype.on=function(e,t){this.eventEmitter&&this.eventEmitter.on(e,t)},Jh.prototype.once=function(e,t){this.eventEmitter&&this.eventEmitter.once(e,t)},Jh.prototype.off=function(e,t){this.eventEmitter&&this.eventEmitter.removeListener(e,t)},Jh.prototype.addEventListener=Jh.prototype.on,Jh.prototype.removeEventListener=Jh.prototype.off,Jh.prototype.addCommandListener=function(e,t){this.room&&this.room.addPresenceListener(e,t)},Jh.prototype.removeCommandListener=function(e,t){this.room&&this.room.removePresenceListener(e,t)},Jh.prototype.sendTextMessage=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"body";this.room&&this.room.sendMessage(e,t)},Jh.prototype.sendPrivateTextMessage=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"body";this.room&&this.room.sendPrivateMessage(e,t,n)},Jh.prototype.sendCommand=function(e,t){this.room?this.room.addOrReplaceInPresence(e,t)&&this.room.sendPresence():Hh.warn("Not sending a command, room not initialized.")},Jh.prototype.sendCommandOnce=function(e,t){this.sendCommand(e,t),this.removeCommand(e)},Jh.prototype.removeCommand=function(e){this.room&&this.room.removeFromPresence(e)},Jh.prototype.setDisplayName=function(e){if(this.room){const t="nick";e?this.room.addOrReplaceInPresence(t,{attributes:{xmlns:"http://jabber.org/protocol/nick"},value:e})&&this.room.sendPresence():this.room.getFromPresence(t)&&(this.room.removeFromPresence(t),this.room.sendPresence())}},Jh.prototype.setSubject=function(e){this.room&&this.isModerator()?this.room.setSubject(e):Hh.warn(`Failed to set subject, ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator"}`)},Jh.prototype.getTranscriptionStatus=function(){return this.room.transcriptionStatus},Jh.prototype.addTrack=function(e){if(!e)throw new Error("addTrack - a track is required");const t=e.getType(),n=this.rtc.getLocalTracks(t);if(n.length>0){if(e===n[0])return Promise.resolve(e);if(t===Ri.VIDEO&&!n.find((t=>t.getVideoType()===e.getVideoType()))){var i;const n=Cc(this.myUserId(),t,null===(i=this.getLocalTracks(t))||void 0===i?void 0:i.length);e.setSourceName(n);const r=[];return this.p2pJingleSession&&r.push(this.p2pJingleSession.addTracks([e])),this.jvbJingleSession&&r.push(this.jvbJingleSession.addTracks([e])),Promise.all(r).then((()=>{this._setupNewTrack(e),this._sendBridgeVideoTypeMessage(e),this._updateRoomPresence(this.getActiveMediaSession()),(this.isMutedByFocus||this.isVideoMutedByFocus)&&this._fireMuteChangeEvent(e)}))}return Promise.reject(new Error(`Cannot add second ${t} track to the conference`))}return this.replaceTrack(null,e).then((()=>{e.getVideoType()===Qo.VideoType.DESKTOP&&this._updateRoomPresence(this.getActiveMediaSession())}))},Jh.prototype._fireAudioLevelChangeEvent=function(e,t){const n=this.getActivePeerConnection();t&&n!==t||this.eventEmitter.emit(nt,this.myUserId(),e)},Jh.prototype._fireMuteChangeEvent=function(e){let t;if(this.isMutedByFocus&&e.isAudioTrack()&&!e.isMuted()?(this.isMutedByFocus=!1,this.room.muteParticipant(this.room.myroomjid,!1,Ri.AUDIO)):this.isVideoMutedByFocus&&e.isVideoTrack()&&!e.isMuted()&&(this.isVideoMutedByFocus=!1,this.room.muteParticipant(this.room.myroomjid,!1,Ri.VIDEO)),this.mutedByFocusActor&&e.isAudioTrack()){const e=St.Strophe.getResourceFromJid(this.mutedByFocusActor);t=this.participants.get(e)}else if(this.mutedVideoByFocusActor&&e.isVideoTrack()){const e=St.Strophe.getResourceFromJid(this.mutedVideoByFocusActor);t=this.participants.get(e)}const n=ci.isReactNative()?e.videoType===Qo.VideoType.DESKTOP:ci.doesVideoMuteByStreamRemove();e.isVideoTrack()&&!n&&this._sendBridgeVideoTypeMessage(e),this.eventEmitter.emit(it,e,t)},Jh.prototype._getInitialLocalTracks=function(){return this.getLocalTracks().filter((e=>{const t=e.getType();return!(t!==Ri.AUDIO||(this.isStartAudioMuted()||this.startMutedPolicy.audio)&&!ci.isWebKitBased()&&!ci.isReactNative())||t===Ri.VIDEO&&!this.isStartVideoMuted()&&!this.startMutedPolicy.video||(this.onLocalTrackRemoved(e),!1)}))},Jh.prototype.onLocalTrackRemoved=function(e){e.setConference(null),this.rtc.removeLocalTrack(e),e.removeEventListener(Rt,e.muteHandler),e.isAudioTrack()&&e.removeEventListener(Ct,e.audioLevelHandler),this.eventEmitter.emit(rt,e)},Jh.prototype.removeTrack=function(e){return this.replaceTrack(e,null)},Jh.prototype.replaceTrack=function(e,t){const n=null==e?void 0:e.getVideoType(),i=(null==e?void 0:e.getType())||(null==t?void 0:t.getType()),r=null==t?void 0:t.getVideoType();if(e&&t&&n!==r)throw new Error(`Replacing a track of videoType=${n} with a track of videoType=${r} is not supported in this mode.`);if(t){var o;const n=e?e.getSourceName():Cc(this.myUserId(),i,null===(o=this.getLocalTracks(i))||void 0===o?void 0:o.length);t.setSourceName(n)}const s=this===(null==e?void 0:e.conference);return s&&e.disposed||null!=t&&t.disposed?Promise.reject(new dr(tr)):(e&&!s&&Hh.warn(`JitsiConference.replaceTrack oldTrack (${e} does not belong to this conference`),this._doReplaceTrack(s?e:null,t).then((()=>(!s||e.isMuted()||t||e._sendMuteStatus(!0),s&&this.onLocalTrackRemoved(e),t&&this._setupNewTrack(t),(s&&null!=e&&e.isVideoTrack()||null!=t&&t.isVideoTrack())&&this._sendBridgeVideoTypeMessage(t),this._updateRoomPresence(this.getActiveMediaSession()),null!==t&&(this.isMutedByFocus||this.isVideoMutedByFocus)&&this._fireMuteChangeEvent(t),Promise.resolve()))).catch((e=>(Hh.error(`replaceTrack failed: ${null==e?void 0:e.stack}`),Promise.reject(e)))))},Jh.prototype._doReplaceTrack=function(e,t){const n=[];return this.jvbJingleSession?n.push(this.jvbJingleSession.replaceTrack(e,t)):Hh.info("_doReplaceTrack - no JVB JingleSession"),this.p2pJingleSession?n.push(this.p2pJingleSession.replaceTrack(e,t)):Hh.info("_doReplaceTrack - no P2P JingleSession"),Promise.all(n)},Jh.prototype._removeLocalSourceOnReject=function(e,t,n){if(!e)return;Hh.warn(`Source-add rejected on ${e}, reason="${null==t?void 0:t.reason}", message="${null==t?void 0:t.msg}"`);const i=this.getLocalTracks(n)[0];this.eventEmitter.emit(ot,i)},Jh.prototype._setupNewTrack=function(e){const t=e.getType();if(!e.getSourceName()){var n;const i=Cc(this.myUserId(),t,null===(n=this.getLocalTracks(t))||void 0===n?void 0:n.length);e.setSourceName(i)}this.rtc.addLocalTrack(e),e.setConference(this),e.muteHandler=this._fireMuteChangeEvent.bind(this,e),e.addEventListener(Rt,e.muteHandler),e.isAudioTrack()&&(e.audioLevelHandler=this._fireAudioLevelChangeEvent.bind(this),e.addEventListener(Ct,e.audioLevelHandler)),this.eventEmitter.emit(tt,e)},Jh.prototype._setNewVideoType=function(e){let t=!1;return e&&(t=this._signalingLayer.setTrackVideoType(e.getSourceName(),e.videoType)),t},Jh.prototype._setTrackMuteStatus=function(e,t,n){let i=!1;return t&&(i=this._signalingLayer.setTrackMuteStatus(t.getSourceName(),n),i&&Hh.debug(`Mute state of ${t} changed to muted=${n}`)),i},Jh.prototype._addLocalTrackToPc=function(e){const t=[];return e.conference===this?(this.jvbJingleSession?t.push(this.jvbJingleSession.addTrackToPc(e)):Hh.debug("Add local MediaStream - no JVB Jingle session started yet"),this.p2pJingleSession?t.push(this.p2pJingleSession.addTrackToPc(e)):Hh.debug("Add local MediaStream - no P2P Jingle session started yet")):t.push(this.addTrack(e)),Promise.allSettled(t)},Jh.prototype._removeLocalTrackFromPc=function(e){const t=[];return e.conference===this&&(this.jvbJingleSession?t.push(this.jvbJingleSession.removeTrackFromPc(e)):Hh.debug("Remove local MediaStream - no JVB JingleSession started yet"),this.p2pJingleSession?t.push(this.p2pJingleSession.removeTrackFromPc(e)):Hh.debug("Remove local MediaStream - no P2P JingleSession started yet")),Promise.allSettled(t)},Jh.prototype.getRole=function(){return this.room.role},Jh.prototype.isHidden=function(){return this.connection?St.Strophe.getDomainFromJid(this.connection.getJid())===this.options.config.hiddenDomain:null},Jh.prototype.isModerator=function(){return this.room?this.room.isModerator():null},Jh.prototype.lock=function(e){return this.isModerator()?new Promise(((t,n)=>{this.room.lockRoom(e||"",(()=>t()),(e=>n(e)),(()=>n(U)))})):Promise.reject(new Error("You are not moderator."))},Jh.prototype.unlock=function(){return this.lock()},Jh.prototype.getLastN=function(){return this.receiveVideoController.getLastN()},Jh.prototype.getForwardedSources=function(){return this.rtc.getForwardedSources()},Jh.prototype.setLastN=function(e){if(!Number.isInteger(e)&&!Number.parseInt(e,10))throw new Error(`Invalid value for lastN: ${e}`);const t=Number(e);if(t<-1)throw new RangeError("lastN cannot be smaller than -1");if(this.receiveVideoController.setLastN(t),this.p2pJingleSession){const e=0!==t;this.p2pJingleSession.setP2pVideoTransferActive(e).catch((t=>{Hh.error(`Failed to adjust video transfer status (${e})`,t)}))}},Jh.prototype.getParticipants=function(){return Array.from(this.participants.values())},Jh.prototype.getParticipantCount=function(){let e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this.getParticipants();return e||(t=t.filter((e=>!e.isHidden()))),t.length+1},Jh.prototype.getParticipantById=function(e){return this.participants.get(e)},Jh.prototype.grantOwner=function(e){const t=this.getParticipantById(e);t&&this.room.setAffiliation(t.getConnectionJid(),"owner")},Jh.prototype.revokeOwner=function(e){const t=this.getParticipantById(e),n=this.myUserId()===e,i=this.isMembersOnly()?"member":"none";n?this.room.setAffiliation(this.connection.getJid(),i):t&&this.room.setAffiliation(t.getConnectionJid(),i)},Jh.prototype.kickParticipant=function(e,t){const n=this.getParticipantById(e);n&&this.room.kick(n.getJid(),t)},Jh.prototype._maybeClearSITimeout=function(){this._sessionInitiateTimeout&&(this.jvbJingleSession||this.getParticipantCount()<2)&&(window.clearTimeout(this._sessionInitiateTimeout),this._sessionInitiateTimeout=null)},Jh.prototype._maybeSetSITimeout=function(){!this.jvbJingleSession&&this.getParticipantCount()>=2&&!this._sessionInitiateTimeout&&(this._sessionInitiateTimeout=window.setTimeout((()=>{this._sessionInitiateTimeout=null,Mi.sendAnalytics(dn(Ht,{p2p:!1,value:5e3}))}),5e3))},Jh.prototype.muteParticipant=function(e,t){const n=t||Ri.AUDIO;if(n!==Ri.AUDIO&&n!==Ri.VIDEO)return void Hh.error(`Unsupported media type: ${n}`);const i=this.getParticipantById(e);i&&this.room.muteParticipant(i.getJid(),!0,n)},Jh.prototype.onMemberJoined=function(e,t,n,i,r,o,s,a,d,c,l){var h,u,p,m;const g=St.Strophe.getResourceFromJid(e);if("focus"===g||this.myUserId()===g)return;const f=new Bi(e,this,t,i,r,o,s);f.setConnectionJid(d),f.setRole(n),f.setBotType(a),f.setFeatures(c),f.setIsReplacing(l);const v=this.isP2PActive()?null!==(h=null===(u=this.p2pJingleSession)||void 0===u?void 0:u.peerconnection.getRemoteTracks(g))&&void 0!==h?h:[]:null!==(p=null===(m=this.jvbJingleSession)||void 0===m?void 0:m.peerconnection.getRemoteTracks(g))&&void 0!==p?p:[];for(const e of v)f._tracks.push(e);this.participants.set(g,f),this.eventEmitter.emit(at,g,f),this._updateFeatures(f),this.isJoined()&&this._maybeStartOrStopP2P(),this._maybeSetSITimeout()},Jh.prototype._onMucJoined=function(){this._numberOfParticipantsOnJoin=this.getParticipantCount(),this._maybeStartOrStopP2P()},Jh.prototype._updateFeatures=function(e){e.getFeatures().then((t=>{e._supportsDTMF=t.has("urn:xmpp:jingle:dtmf:0"),this.updateDTMFSupport(),t.has(wa)&&e.setProperty("features_jigasi",!0),t.has(Ia)&&e.setProperty("features_e2ee",!0)})).catch((()=>!1))},Jh.prototype._onMemberBotTypeChanged=function(e,t){const n=this.getParticipants().find((t=>t.getJid()===e));if(n){n.setBotType(t);const i=St.Strophe.getResourceFromJid(e);this.eventEmitter.emit(ne,i,t)}n.getBotType()||this._maybeStartOrStopP2P()},Jh.prototype.onMemberLeft=function(e,t){const n=St.Strophe.getResourceFromJid(e);if("focus"===n||this.myUserId()===n)return;const i=this.getMediaSessions();let r=[];for(const e of i){const t=e.peerconnection.getRemoteTracks(n);t&&(r=[...r,...t]),e._signalingLayer.updateSsrcOwnersOnLeave(n),Ai.isSsrcRewritingSupported()||e.removeRemoteStreamsOnLeave(n)}r.forEach((e=>{Ai.isSsrcRewritingSupported()?(e.setSourceName(null),e.setOwner(null)):this.eventEmitter.emit(rt,e)}));const o=this.participants.get(n);o&&(this.participants.delete(n),this.eventEmitter.emit(dt,n,o,t)),null!==this.room&&(this._maybeStartOrStopP2P(!0),this._maybeClearSITimeout())},Jh.prototype.onMemberKicked=function(e,t,n,i,r){if(t===this.myUserId())return;const o=this.participants.get(t);if(e)return this.leave().finally((()=>this.xmpp.disconnect())),void this.eventEmitter.emit(we,o,i,r);const s=this.participants.get(n);s.setIsReplaced(r),this.eventEmitter.emit(He,o,s,i)},Jh.prototype.onLocalRoleChanged=function(e){this.eventEmitter.emit(ct,this.myUserId(),e)},Jh.prototype.onUserRoleChanged=function(e,t){const n=St.Strophe.getResourceFromJid(e),i=this.getParticipantById(n);i&&(i.setRole(t),this.eventEmitter.emit(ct,n,t))},Jh.prototype.onDisplayNameChanged=function(e,t){const n=St.Strophe.getResourceFromJid(e),i=this.getParticipantById(n);i&&i._displayName!==t&&(i._displayName=t,this.eventEmitter.emit(_e,n,t))},Jh.prototype.onRemoteTrackAdded=function(e){if(e.isP2P&&!this.isP2PActive())return void Hh.info("Trying to add remote P2P track, when not in P2P - IGNORED");if(!e.isP2P&&this.isP2PActive())return void Hh.info("Trying to add remote JVB track, when in P2P - IGNORED");const t=e.getParticipantId(),n=this.getParticipantById(t);n?n._tracks.push(e):Hh.info(`Source signaling received before presence for ${t}`);const i=this.eventEmitter;e.addEventListener(Rt,(()=>i.emit(it,e))),e.isAudioTrack()&&e.addEventListener(Ct,((e,n)=>{this.getActivePeerConnection()===n&&i.emit(nt,t,e)})),i.emit(tt,e)},Jh.prototype.onCallAccepted=function(e,t){this.p2pJingleSession===e&&(Hh.info("P2P setAnswer"),this.p2pJingleSession.setAnswer(t),this.eventEmitter.emit(q,this.p2pJingleSession))},Jh.prototype.onTransportInfo=function(e,t){this.p2pJingleSession===e&&(Hh.info("P2P addIceCandidates"),this.p2pJingleSession.addIceCandidates(t))},Jh.prototype.onRemoteTrackRemoved=function(e){this.getParticipants().forEach((t=>{const n=t.getTracks();for(let i=0;i<n.length;i++)if(n[i]===e){t._tracks.splice(i,1),this.eventEmitter.emit(rt,e);break}}),this)},Jh.prototype._onIncomingCallP2P=function(e,t){let n;const i=t.find(">content").attr("name");"0"===i||"1"===i?!this.isP2PEnabled()&&!this.isP2PTestModeEnabled()||ci.isFirefox()&&!this._firefoxP2pEnabled?n={reason:"decline",reasonDescription:"P2P disabled",errorMsg:"P2P mode disabled in the configuration or browser unsupported"}:this.p2pJingleSession?n={reason:"busy",reasonDescription:"P2P already in progress",errorMsg:\'Duplicated P2P "session-initiate"\'}:this._shouldBeInP2PMode()||(n={reason:"decline",reasonDescription:"P2P requirements not met",errorMsg:\'Received P2P "session-initiate" when should not be in P2P mode\'},Mi.sendAnalytics(dn(qt))):n={reason:"decline",reasonDescription:"P2P disabled",errorMsg:"P2P across two endpoints in different SDP modes is disabled"},n?this._rejectIncomingCall(e,n):this._acceptP2PIncomingCall(e,t)},Jh.prototype.onIncomingCall=function(e,t,n){if(e.isP2P)this._onIncomingCallP2P(e,t);else{if(!this.isFocus(e.remoteJid)){const t="Rejecting session-initiate from non-focus.";return void this._rejectIncomingCall(e,{reason:"security-error",reasonDescription:t,errorMsg:t})}this._acceptJvbIncomingCall(e,t,n)}},Jh.prototype._acceptJvbIncomingCall=function(e,t,n){this.jvbJingleSession=e,this.room.connectionTimes["session.initiate"]=n,this._sendConferenceJoinAnalyticsEvent(),this.wasStopped&&Mi.sendAnalyticsAndLog(dn(jt,{p2p:!1}));const i=_t()(t).find(\'>bridge-session[xmlns="http://jitsi.org/protocol/focus"]\').attr("region");this.eventEmitter.emit(We,i),this._maybeClearSITimeout(),Mi.sendAnalytics(dn(Ut,{p2p:!1,value:n}));try{e.initialize(this.room,this.rtc,this._signalingLayer,{...this.options.config,codecSettings:{mediaType:Ri.VIDEO,codecList:this.codecSelection.getCodecPreferenceList("jvb")},enableInsertableStreams:this.isE2EEEnabled()||Ai.isRunInLiteModeEnabled()})}catch(e){return void Hh.error(e)}this._setBridgeChannel(t,e.peerconnection);const r=this._getInitialLocalTracks();try{e.acceptOffer(t,(()=>{this.isP2PActive()&&this.jvbJingleSession&&this._suspendMediaTransferForJvbConnection(),this.eventEmitter.emit(q,e),this.isP2PActive()||this.eventEmitter.emit(G,e)}),(e=>{Hh.error("Failed to accept incoming Jingle session",e)}),r),this._desktopSharingFrameRate&&e.peerconnection.setDesktopSharingFrameRate(this._desktopSharingFrameRate),this.statistics.startRemoteStats(this.jvbJingleSession.peerconnection)}catch(e){Hh.error(e)}},Jh.prototype._setBridgeChannel=function(e,t){var n,i,r,o,s,a,d;const c=null===(n=this.connection)||void 0===n||null===(i=n.options)||void 0===i||null===(r=i.bridgeChannel)||void 0===r?void 0:r.ignoreDomain,l=null!==(o=null===(s=this.connection)||void 0===s||null===(a=s.options)||void 0===a||null===(d=a.bridgeChannel)||void 0===d?void 0:d.preferSctp)&&void 0!==o&&o,h=1===_t()(e).find(\'>content[name="data"]\').first().length;let u=null;if(Hh.info(`SCTP: offered=${h}, prefered=${l}`),!(h&&l||(_t()(e).find(">content>transport>web-socket").toArray().map((e=>e.getAttribute("url"))).forEach((e=>{u||c&&c===new URL(e).hostname?u||Hh.info(`Ignoring colibri-ws url with domain ${c}`):(u=e,Hh.info(`Using colibri-ws url ${e}`))})),u))){const t=_t()(e).find(">content>transport>web-socket").first();1===t.length&&(u=t[0].getAttribute("url"),Hh.info(`Falling back to ${u}`))}!u||h&&l?h?this.rtc.initializeBridgeChannel(t,null):Hh.warn("Neither SCTP nor a websocket is available. Will not initialize bridge channel."):this.rtc.initializeBridgeChannel(null,u)},Jh.prototype._rejectIncomingCall=function(e,t){null!=t&&t.errorMsg&&Hh.warn(t.errorMsg),e.terminate(null,(e=>{Hh.warn("An error occurred while trying to terminate invalid Jingle session",e)}),{reason:t&&t.reason,reasonDescription:t&&t.reasonDescription,sendSessionTerminate:!0})},Jh.prototype.onCallEnded=function(e,t,n){if(Hh.info(`Call ended: ${t} - ${n} P2P ?${e.isP2P}`),e===this.jvbJingleSession)this.wasStopped=!0,Mi.sendAnalytics(dn($t,{p2p:!1})),this.statistics&&this.statistics.stopRemoteStats(this.jvbJingleSession.peerconnection),this.jvbJingleSession=null,this.rtc.onCallEnded();else if(e===this.p2pJingleSession){const e={};"connectivity-error"===t&&"ICE FAILED"===n?Mi.analytics.addPermanentProperties({p2pFailed:!0}):"success"===t&&"restart"===n&&(e.requestRestart=!0),this._stopP2PSession(e)}else Hh.error("Received onCallEnded for invalid session",e.sid,e.remoteJid,t,n)},Jh.prototype.onSuspendDetected=function(e){e.isP2P||(this.leave(),this.eventEmitter.emit(Ze))},Jh.prototype.updateDTMFSupport=function(){let e=!1;const t=this.getParticipants();for(let n=0;n<t.length;n+=1)if(t[n].supportsDTMF()){e=!0;break}e!==this.somebodySupportsDTMF&&(this.somebodySupportsDTMF=e,this.eventEmitter.emit(Ee,e))},Jh.prototype.isDTMFSupported=function(){return this.somebodySupportsDTMF},Jh.prototype.myUserId=function(){return this.room&&this.room.myroomjid?St.Strophe.getResourceFromJid(this.room.myroomjid):null},Jh.prototype.sendTones=function(e,t,n){const i=this.getActivePeerConnection();i?i.sendTones(e,t,n):Hh.warn("cannot sendTones: no peer connection")},Jh.prototype.startRecording=function(e){return this.room?this.recordingManager.startRecording(e):Promise.reject(new Error("The conference is not created yet!"))},Jh.prototype.stopRecording=function(e){return this.room?this.recordingManager.stopRecording(e):Promise.reject(new Error("The conference is not created yet!"))},Jh.prototype.isSIPCallingSupported=function(){var e,t,n,i;return null!==(e=null===(t=this.room)||void 0===t||null===(n=t.xmpp)||void 0===n||null===(i=n.moderator)||void 0===i?void 0:i.isSipGatewayEnabled())&&void 0!==e&&e},Jh.prototype.dial=function(e){return this.room?this.room.dial(e):Promise.reject(new Error("The conference is not created yet!"))},Jh.prototype.hangup=function(){return this.room?this.room.hangup():Promise.resolve()},Jh.prototype.getPhoneNumber=function(){return this.room?this.room.getPhoneNumber():null},Jh.prototype.getPhonePin=function(){return this.room?this.room.getPhonePin():null},Jh.prototype.getMeetingUniqueId=function(){if(this.room)return this.room.getMeetingId()},Jh.prototype.getActivePeerConnection=function(){const e=this.isP2PActive()?this.p2pJingleSession:this.jvbJingleSession;return e?e.peerconnection:null},Jh.prototype.getConnectionState=function(){const e=this.getActivePeerConnection();return e?e.getConnectionState():null},Jh.prototype.setStartMutedPolicy=function(e){this.isModerator()?this.room.addOrReplaceInPresence("startmuted",{attributes:{audio:e.audio,video:e.video,xmlns:"http://jitsi.org/jitmeet/start-muted"}})&&this.room.sendPresence():Hh.warn(`Failed to set start muted policy, ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator"}`)},Jh.prototype.getStartMutedPolicy=function(){return this.startMutedPolicy},Jh.prototype.isStartAudioMuted=function(){return this.startAudioMuted},Jh.prototype.isStartVideoMuted=function(){return this.startVideoMuted},Jh.prototype.getConnectionTimes=function(){return this.room.connectionTimes},Jh.prototype.setLocalParticipantProperty=function(e,t){this.sendCommand(`jitsi_participant_${e}`,{value:t})},Jh.prototype.removeLocalParticipantProperty=function(e){this.removeCommand(`jitsi_participant_${e}`),this.room.sendPresence()},Jh.prototype.getLocalParticipantProperty=function(e){const t=this.room.presMap.nodes.find((t=>t.tagName===`jitsi_participant_${e}`));return t?t.value:void 0},Jh.prototype.sendFeedback=function(e,t){return this.statistics.sendFeedback(e,t)},Jh.prototype.isCallstatsEnabled=function(){return Hh.warn("Callstats is no longer supported"),!1},Jh.prototype.getSsrcByTrack=function(e){var t;return e.isLocal()?null===(t=this.getActivePeerConnection())||void 0===t?void 0:t.getLocalSSRC(e):e.getSSRC()},Jh.prototype.sendApplicationLog=function(){},Jh.prototype.isFocus=function(e){return this.room?this.room.isFocus(e):null},Jh.prototype._fireIncompatibleVersionsEvent=function(){this.eventEmitter.emit(ae,j)},Jh.prototype.sendEndpointMessage=function(e,t){this.rtc.sendChannelMessage(e,t)},Jh.prototype.sendEndpointStatsMessage=function(e){this.rtc.sendEndpointStatsMessage(e)},Jh.prototype.broadcastEndpointMessage=function(e){this.sendEndpointMessage("",e)},Jh.prototype.sendMessage=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const i=typeof e;if("object"===i||!n&&"string"===i)if(n)this.sendEndpointMessage(t,e);else{let n=e,r="body";if("object"===i){r="json-message",n.hasOwnProperty(Aa)||(n[Aa]="");try{n=JSON.stringify(n)}catch(e){return void Hh.error("Can not send a message, stringify failed: ",e)}}t?this.sendPrivateTextMessage(t,n,r):this.sendTextMessage(n,r)}else Hh.error(`Can not send a message of type ${i}`)},Jh.prototype.isConnectionInterrupted=function(){return this.isP2PActive()?this.isP2PConnectionInterrupted:this.isJvbConnectionInterrupted},Jh.prototype._onConferenceRestarted=function(e){!e.isP2P&&this.options.config.enableForcedReload&&this.eventEmitter.emit(ae,I)},Jh.prototype._onIceConnectionInterrupted=function(e){e.isP2P?this.isP2PConnectionInterrupted=!0:this.isJvbConnectionInterrupted=!0,e.isP2P===this.isP2PActive()&&this.eventEmitter.emit(me)},Jh.prototype._onIceConnectionFailed=function(e){e.isP2P?(Mi.analytics.addPermanentProperties({p2pFailed:!0}),this.p2pJingleSession&&Mi.sendAnalyticsAndLog(cn(zt,{initiator:this.p2pJingleSession.isInitiator})),this._stopP2PSession({reason:"connectivity-error",reasonDescription:"ICE FAILED"})):e&&this.jvbJingleSession===e&&(this._delayedIceFailed=new Tl(this),this._delayedIceFailed.start(e))},Jh.prototype._onIceConnectionRestored=function(e){e.isP2P?this.isP2PConnectionInterrupted=!1:(this.isJvbConnectionInterrupted=!1,this._delayedIceFailed&&this._delayedIceFailed.cancel()),e.isP2P===this.isP2PActive()&&this.eventEmitter.emit(ge)},Jh.prototype._acceptP2PIncomingCall=function(e,t){this.isP2PConnectionInterrupted=!1,this.p2pJingleSession=e,this._sendConferenceJoinAnalyticsEvent(),this.p2pJingleSession.initialize(this.room,this.rtc,this._signalingLayer,{...this.options.config,codecSettings:{mediaType:Ri.VIDEO,codecList:this.codecSelection.getCodecPreferenceList("p2p")},enableInsertableStreams:this.isE2EEEnabled()||Ai.isRunInLiteModeEnabled()});const n=this.getLocalTracks();this.p2pJingleSession.acceptOffer(t,(()=>{Hh.debug(\'Got RESULT for P2P "session-accept"\'),this.eventEmitter.emit(q,e)}),(e=>{Hh.error("Failed to accept incoming P2P Jingle session",e)}),n)},Jh.prototype._addRemoteJVBTracks=function(){this._addRemoteTracks("JVB",this.jvbJingleSession.peerconnection.getRemoteTracks())},Jh.prototype._addRemoteP2PTracks=function(){this._addRemoteTracks("P2P",this.p2pJingleSession.peerconnection.getRemoteTracks())},Jh.prototype._addRemoteTracks=function(e,t){for(const n of t)(Ai.isSsrcRewritingSupported()||this.participants.has(n.ownerEndpointId))&&(Hh.info(`Adding remote ${e} track: ${n}`),this.onRemoteTrackAdded(n))},Jh.prototype._onIceConnectionEstablished=function(e){null!==this.p2pJingleSession&&(this.p2pEstablishmentDuration=this.p2pJingleSession.establishmentDuration),null!==this.jvbJingleSession&&(this.jvbEstablishmentDuration=this.jvbJingleSession.establishmentDuration);let t=!1;if(e.isP2P?this.p2pJingleSession!==e&&(Hh.error("CONNECTION_ESTABLISHED - wrong P2P session instance ?!"),t=!0):t=!0,!isNaN(this.p2pEstablishmentDuration)&&!isNaN(this.jvbEstablishmentDuration)){const e=this.p2pEstablishmentDuration-this.jvbEstablishmentDuration;Mi.sendAnalytics(Zt,{value:e})}e.isP2P===this.isP2PActive()&&this.eventEmitter.emit(pe),t||(this._setP2PStatus(!0),this.jvbJingleSession?this._removeRemoteJVBTracks():Hh.info("Not removing remote JVB tracks - no session yet"),this._addRemoteP2PTracks(),this.jvbJingleSession&&this._suspendMediaTransferForJvbConnection(),Hh.info("Starting remote stats with p2p connection"),this.statistics.startRemoteStats(this.p2pJingleSession.peerconnection),Mi.sendAnalyticsAndLog(cn(Gt,{initiator:this.p2pJingleSession.isInitiator})))},Jh.prototype._updateProperties=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const t=!Et()(e,this.properties);if(this.properties=e,t){var n,i;this.eventEmitter.emit(ze,this.properties);const t="true"===this.properties["audio-limit-reached"],r="true"===this.properties["video-limit-reached"];this._audioSenderLimitReached!==t&&(this._audioSenderLimitReached=t,this.eventEmitter.emit(K,t),Hh.info(`Audio unmute permissions set by Jicofo to ${t}`)),this._videoSenderLimitReached!==r&&(this._videoSenderLimitReached=r,this.eventEmitter.emit(pt,r),Hh.info(`Video unmute permissions set by Jicofo to ${r}`)),["bridge-count"].forEach((t=>{void 0!==e[t]&&Mi.analytics.addPermanentProperties({[t.replace("-","_")]:e[t]})}));let o=null===(n=this.properties["visitor-codecs"])||void 0===n?void 0:n.split(",");null!==(i=o)&&void 0!==i&&i.length&&(o=o.filter((e=>"string"==typeof e&&e.trim().length&&Object.values(Ds).find((t=>t===e))))),this._visitorCodecs!==o&&(this._visitorCodecs=o,this.eventEmitter.emit(ue,this._visitorCodecs));const s=this._hasVisitors;this._hasVisitors=this.properties["visitor-count"]>0,s!==this._hasVisitors&&this._maybeStartOrStopP2P(!0)}},Jh.prototype.getProperty=function(e){return this.properties[e]},Jh.prototype._maybeClearDeferredStartP2P=function(){this.deferredStartP2PTask&&(Hh.info("Cleared deferred start P2P task"),clearTimeout(this.deferredStartP2PTask),this.deferredStartP2PTask=null)},Jh.prototype._removeRemoteJVBTracks=function(){this._removeRemoteTracks("JVB",this.jvbJingleSession.peerconnection.getRemoteTracks())},Jh.prototype._removeRemoteP2PTracks=function(){this._removeRemoteTracks("P2P",this.p2pJingleSession.peerconnection.getRemoteTracks())},Jh.prototype._removeRemoteTracks=function(e,t){for(const n of t)Hh.info(`Removing remote ${e} track: ${n}`),this.onRemoteTrackRemoved(n)},Jh.prototype._resumeMediaTransferForJvbConnection=function(){Hh.info("Resuming media transfer over the JVB connection..."),this.jvbJingleSession.setMediaTransferActive(!0).then((()=>{Hh.info("Resumed media transfer over the JVB connection!")})).catch((e=>{Hh.error("Failed to resume media transfer over the JVB connection:",e)}))},Jh.prototype._setP2PStatus=function(e){if(this.p2p!==e){if(this.p2p=e,e){Hh.info("Peer to peer connection established!"),Mi.analytics.addPermanentProperties({p2pFailed:!1});const e=0!==this.getLastN();this.p2pJingleSession.setP2pVideoTransferActive(e).catch((t=>{Hh.error(`Failed to sync up P2P video transfer status (${e}), ${t}`)}))}else Hh.info("Peer to peer connection closed!");this.dtmfManager=null,this.eventEmitter.emit(Ue,this,this.p2p),this.eventEmitter.emit(G,this.getActiveMediaSession()),this.eventEmitter.emit(this.isConnectionInterrupted()?me:ge)}else Hh.debug(`Called _setP2PStatus with the same status: ${e}`)},Jh.prototype._startP2PSession=function(e){if(this._maybeClearDeferredStartP2P(),this.p2pJingleSession)return void Hh.error("P2P session already started!");if(!this.room)return void Hh.warn("Cannot start P2P session - conference has been left");this.isP2PConnectionInterrupted=!1,this.p2pJingleSession=this.xmpp.connection.jingle.newP2PJingleSession(this.room.myroomjid,e),Hh.info("Created new P2P JingleSession",this.room.myroomjid,e),this._sendConferenceJoinAnalyticsEvent(),this.p2pJingleSession.initialize(this.room,this.rtc,this._signalingLayer,{...this.options.config,codecSettings:{mediaType:Ri.VIDEO,codecList:this.codecSelection.getCodecPreferenceList("p2p")},enableInsertableStreams:this.isE2EEEnabled()||Ai.isRunInLiteModeEnabled()});const t=this.getLocalTracks();this.p2pJingleSession.invite(t)},Jh.prototype._suspendMediaTransferForJvbConnection=function(){Hh.info("Suspending media transfer over the JVB connection..."),this.jvbJingleSession.setMediaTransferActive(!1).then((()=>{Hh.info("Suspended media transfer over the JVB connection !")})).catch((e=>{Hh.error("Failed to suspend media transfer over the JVB connection:",e)}))},Jh.prototype._maybeStartOrStopP2P=function(e){if(!this.isP2PEnabled()||this.isP2PTestModeEnabled()||ci.isFirefox()&&!this._firefoxP2pEnabled||this.isE2EEEnabled())return void Hh.info("Auto P2P disabled");const t=this.getParticipants(),n=t.length,i=this._shouldBeInP2PMode();if(!i&&this.deferredStartP2PTask&&this._maybeClearDeferredStartP2P(),!this.p2pJingleSession&&i){const i=n&&t[0],r=this.myUserId(),o=i.getId();if(r>o)return void Hh.debug("I\'m the bigger peersId - the other peer should start P2P",r,o);if(r===o)return void Hh.error("The same IDs ? ",r,o);const s=i.getJid();if(e){if(this.deferredStartP2PTask)return void Hh.error("Deferred start P2P task\'s been set already!");Hh.info(`Will start P2P with: ${s} after ${this.backToP2PDelay} seconds...`),this.deferredStartP2PTask=setTimeout(this._startP2PSession.bind(this,s),1e3*this.backToP2PDelay)}else Hh.info(`Will start P2P with: ${s}`),this._startP2PSession(s)}else this.p2pJingleSession&&!i&&(Hh.info(`Will stop P2P with: ${this.p2pJingleSession.remoteJid}`),this.p2pJingleSession.isInitiator&&n>1&&Mi.sendAnalyticsAndLog(cn(Kt)),this._stopP2PSession())},Jh.prototype._shouldBeInP2PMode=function(){const e=this.getParticipants(),t=e.length,n=void 0!==e.find((e=>"poltergeist"===e.getBotType()||e.hasFeature(wa))),i=1===t&&!n&&!this._hasVisitors;return Hh.debug(`P2P? peerCount: ${t}, hasBotPeer: ${n} => ${i}`),i},Jh.prototype._stopJvbSession=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const{requestRestart:t=!1,sendSessionTerminate:n=!1}=e;this.jvbJingleSession?(!this.isP2PActive()&&this._removeRemoteJVBTracks(),Hh.info("Stopping stats for jvb connection"),this.statistics.stopRemoteStats(this.jvbJingleSession.peerconnection),this.jvbJingleSession.terminate((()=>{t&&n&&Hh.info("session-terminate for ice restart - done"),this.jvbJingleSession=null}),(e=>{t&&n&&(Hh.error("session-terminate for ice restart failed: reloading the client"),this.eventEmitter.emit(ae,F)),Hh.error(`An error occurred while trying to terminate the JVB session\', reason=${e.reason},msg=${e.msg}`)}),e)):Hh.error("No JVB session to be stopped")},Jh.prototype._stopP2PSession=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const{reason:t="success",reasonDescription:n="Turning off P2P session",requestRestart:i=!1}=e;if(!this.p2pJingleSession)return void Hh.error("No P2P session to be stopped!");const r=this.isP2PActive();r&&(this.jvbJingleSession&&!i&&this._resumeMediaTransferForJvbConnection(),this._removeRemoteP2PTracks()),Hh.info("Stopping remote stats for P2P connection"),this.statistics.stopRemoteStats(this.p2pJingleSession.peerconnection),this.p2pJingleSession.terminate((()=>{Hh.info("P2P session terminate RESULT"),this.p2pJingleSession=null}),(e=>{"success"!==t&&Hh.error("An error occurred while trying to terminate P2P Jingle session",e)}),{reason:t,reasonDescription:n,sendSessionTerminate:this.room&&this.getParticipantById(St.Strophe.getResourceFromJid(this.p2pJingleSession.remoteJid))}),this.p2pJingleSession=null,this._setP2PStatus(!1),r&&(this.jvbJingleSession&&!i?this._addRemoteJVBTracks():Hh.info("Not adding remote JVB tracks - no session yet"))},Jh.prototype._updateRoomPresence=function(e,t){if(!e)return;if(t){if(t.skip)return;t.skip=!0}let n,i,r=!1;const o=e.peerconnection.getLocalTracks();for(const e of o){const t=e.isMuted();n=this._setTrackMuteStatus(e.getType(),e,t),n&&Hh.debug(`Updating mute state of ${e} in presence to muted=${t}`),e.getType()===Ri.VIDEO&&(i=this._setNewVideoType(e),i&&Hh.debug(`Updating videoType in presence to ${e.getVideoType()}`)),r=r||n||i}r&&this.room.sendPresence()},Jh.prototype.isP2PActive=function(){return this.p2p},Jh.prototype.getP2PConnectionState=function(){return this.isP2PActive()?this.p2pJingleSession.peerconnection.getConnectionState():null},Jh.prototype.setDesktopSharingFrameRate=function(e){return"number"!=typeof e||isNaN(e)?(Hh.error(`Invalid value ${e} specified for desktop capture frame rate`),!1):(this._desktopSharingFrameRate=e,this.jvbJingleSession&&this.jvbJingleSession.peerconnection.setDesktopSharingFrameRate(e),this.rtc.setDesktopSharingFrameRate(e),!0)},Jh.prototype.startP2PSession=function(){const e=this.getParticipants();if(1!==e.length)throw new Error("There must be exactly 1 participant to start the P2P session !");{const t=e[0].getJid();this._startP2PSession(t)}},Jh.prototype.stopP2PSession=function(e){this._stopP2PSession(e)},Jh.prototype.getSpeakerStats=function(){return this.speakerStatsCollector.getStats()},Jh.prototype.sendFaceLandmarks=function(e){e.faceExpression&&this.xmpp.sendFaceLandmarksEvent(this.room.roomjid,e)},Jh.prototype.setReceiverConstraints=function(e){this.receiveVideoController.setReceiverConstraints(e)},Jh.prototype.setAssumedBandwidthBps=function(e){this.receiveVideoController.setAssumedBandwidthBps(e)},Jh.prototype.setReceiverVideoConstraint=function(e){this.receiveVideoController.setPreferredReceiveMaxFrameHeight(e)},Jh.prototype.setSenderVideoConstraint=function(e){return this.sendVideoController.setPreferredSendMaxFrameHeight(e)},Jh.prototype.createVideoSIPGWSession=function(e,t){return this.room?this.videoSIPGWHandler.createVideoSIPGWSession(e,t):new Error(Ph)},Jh.prototype._sendConferenceJoinAnalyticsEvent=function(){var e,t,n;const i=this.getMeetingUniqueId();if(this._conferenceJoinAnalyticsEventSent||!i||null===this.getActivePeerConnection())return;const r=this.getConnectionTimes(),o=this.connection.getConnectionTimes(),s=window.connectionTimes["firstObtainPermissions.start"],a=window.connectionTimes["firstObtainPermissions.end"],d=null!==(e=null===(t=window.JitsiMeetJS)||void 0===t||null===(n=t.app)||void 0===n?void 0:n.connectionTimes)&&void 0!==e?e:{},c={...r,...o,...d,gumDuration:Ti(a,s),xmppConnectingTime:Ti(o.connected,o.connecting),connectedToMUCJoinedTime:Ti(r["muc.joined"],o.connected),connectingToMUCJoinedTime:Ti(r["muc.joined"],o.connecting),numberOfParticipantsOnJoin:this._numberOfParticipantsOnJoin};Mi.sendAnalytics(on("joined",{...c,meetingId:i,participantId:`${i}.${this._statsCurrentId}`})),this._conferenceJoinAnalyticsEventSent=Date.now()},Jh.prototype._sendConferenceLeftAnalyticsEvent=function(){const e=this.getMeetingUniqueId();e&&this._conferenceJoinAnalyticsEventSent&&Mi.sendAnalytics(on("left",{meetingId:e,participantId:`${e}.${this._statsCurrentId}`,stats:{duration:Math.floor((Date.now()-this._conferenceJoinAnalyticsEventSent)/1e3),perf:this.getPerformanceStats()}}))},Jh.prototype._restartMediaSessions=function(){this.p2pJingleSession&&this._stopP2PSession({reasonDescription:"restart",requestRestart:!0}),this.jvbJingleSession&&this._stopJvbSession({reason:"success",reasonDescription:"restart required",requestRestart:!0,sendSessionTerminate:!0}),this._maybeStartOrStopP2P(!1)},Jh.prototype.isE2EEEnabled=function(){return Boolean(this._e2eEncryption&&this._e2eEncryption.isEnabled())},Jh.prototype.isE2EESupported=function(){return so.isSupported(this.options.config)},Jh.prototype.toggleE2EE=function(e){this.isE2EESupported()?this._e2eEncryption.setEnabled(e):Hh.warn("Cannot enable / disable E2EE: platform is not supported.")},Jh.prototype.setMediaEncryptionKey=function(e){this._e2eEncryption.setEncryptionKey(e)},Jh.prototype.startVerification=function(e){const t=this.getParticipantById(e);t&&this._e2eEncryption.startVerification(t)},Jh.prototype.markParticipantVerified=function(e,t){const n=this.getParticipantById(e);n&&this._e2eEncryption.markParticipantVerified(n,t)},Jh.prototype.isLobbySupported=function(){return Boolean(this.room&&this.room.getLobby().isSupported())},Jh.prototype.isMembersOnly=function(){return Boolean(this.room&&this.room.membersOnlyEnabled)},Jh.prototype.isVisitorsSupported=function(){return Boolean(this.room&&this.room.visitorsSupported)},Jh.prototype.enableLobby=function(){return this.room&&this.isModerator()?this.room.getLobby().enable():Promise.reject(new Error("The conference not started or user is not moderator"))},Jh.prototype.disableLobby=function(){this.room&&this.isModerator()?this.room.getLobby().disable():Hh.warn(`Failed to disable lobby, ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator"}`)},Jh.prototype.joinLobby=function(e,t){return this.room?this.room.getLobby().join(e,t):Promise.reject(new Error("The conference not started"))},Jh.prototype.myLobbyUserId=function(){if(this.room)return this.room.getLobby().getLocalId()},Jh.prototype.sendLobbyMessage=function(e,t){if(this.room)return t?this.room.getLobby().sendPrivateMessage(t,e):this.room.getLobby().sendMessage(e)},Jh.prototype.addLobbyMessageListener=function(e){if(this.room)return this.room.getLobby().addMessageListener(e)},Jh.prototype.removeLobbyMessageHandler=function(e){if(this.room)return this.room.getLobby().removeMessageHandler(e)},Jh.prototype.lobbyDenyAccess=function(e){this.room&&this.room.getLobby().denyAccess(e)},Jh.prototype.lobbyApproveAccess=function(e){this.room&&this.room.getLobby().approveAccess(e)},Jh.prototype.isAVModerationSupported=function(){return Boolean(this.room&&this.room.getAVModeration().isSupported())},Jh.prototype.enableAVModeration=function(e){this.room&&this.isModerator()&&(e===Ri.AUDIO||e===Ri.VIDEO)?this.room.getAVModeration().enable(!0,e):Hh.warn(`Failed to enable AV moderation, ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator, "}${this.room&&this.isModerator()?"wrong media type passed":""}`)},Jh.prototype.disableAVModeration=function(e){this.room&&this.isModerator()&&(e===Ri.AUDIO||e===Ri.VIDEO)?this.room.getAVModeration().enable(!1,e):Hh.warn(`Failed to disable AV moderation, ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator, "}${this.room&&this.isModerator()?"wrong media type passed":""}`)},Jh.prototype.avModerationApprove=function(e,t){if(this.room&&this.isModerator()&&(e===Ri.AUDIO||e===Ri.VIDEO)){const n=this.getParticipantById(t);if(!n)return;this.room.getAVModeration().approve(e,n.getJid())}else Hh.warn(`AV moderation approve skipped , ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator, "}${this.room&&this.isModerator()?"wrong media type passed":""}`)},Jh.prototype.avModerationReject=function(e,t){if(this.room&&this.isModerator()&&(e===Ri.AUDIO||e===Ri.VIDEO)){const n=this.getParticipantById(t);if(!n)return;this.room.getAVModeration().reject(e,n.getJid())}else Hh.warn(`AV moderation reject skipped , ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator, "}${this.room&&this.isModerator()?"wrong media type passed":""}`)},Jh.prototype.getBreakoutRooms=function(){var e;return null===(e=this.room)||void 0===e?void 0:e.getBreakoutRooms()},Jh.prototype.getMetadataHandler=function(){var e;return null===(e=this.room)||void 0===e?void 0:e.getMetadataHandler()},Bh.prototype.connect=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.xmpp.moderator.targetUrl&&!this.options.disableFocus&&e.name?this.xmpp.moderator.sendConferenceRequest(this.xmpp.getRoomJid(e.name)).then((()=>{this.xmpp.connect(e.id,e.password)})):this.xmpp.connect(e.id,e.password)},Bh.prototype.attach=function(e){this.xmpp.attach(e)},Bh.prototype.disconnect=function(){return this.xmpp.disconnect(...arguments)},Bh.prototype.getJid=function(){return this.xmpp.getJid()},Bh.prototype.setToken=function(e){this.token=e},Bh.prototype.initJitsiConference=function(e,t){return new Jh({name:e,config:t,connection:this})},Bh.prototype.addEventListener=function(e,t){this.xmpp.addListener(e,t)},Bh.prototype.removeEventListener=function(e,t){this.xmpp.removeListener(e,t)},Bh.prototype.getConnectionTimes=function(){return this.xmpp.connectionTimes},Bh.prototype.addFeature=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];this.xmpp.caps.addFeature(e,t,!0)},Bh.prototype.removeFeature=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];this.xmpp.caps.removeFeature(e,t,!0)},Bh.prototype.getLogs=function(){const e=this.xmpp.getJingleLog(),t={};t.time=new Date,t.url=window.location.href,t.ua=navigator.userAgent;const n=this.xmpp.getXmppLog();return n&&(t.xmpp=n),e.metadata=t,e},function(e){e.DEVICE_LIST_CHANGED="mediaDevices.devicechange",e.PERMISSIONS_CHANGED="rtc.permissions_changed",e.PERMISSION_PROMPT_IS_SHOWN="mediaDevices.permissionPromptIsShown",e.SLOW_GET_USER_MEDIA="mediaDevices.slowGetUserMedia"}(qh||(qh={}));const Gh=qh.DEVICE_LIST_CHANGED,zh=qh.PERMISSIONS_CHANGED,Kh=qh.PERMISSION_PROMPT_IS_SHOWN,Wh=qh.SLOW_GET_USER_MEDIA,Xh="microphone",Yh="camera",Qh=new class extends xr{constructor(){super(),this._permissions={},pl.addListener(ji.default.DEVICE_LIST_CHANGED,(e=>this.eventEmitter.emit(Gh,e))),pl.addListener(ji.default.PERMISSIONS_CHANGED,(e=>this._handlePermissionsChange(e))),this._permissionsApiSupported=new Promise((e=>{if(!navigator.permissions)return void e(!1);const t=this,n=[];n.push(navigator.permissions.query({name:Yh}).then((e=>(this._handlePermissionsChange({[Ri.VIDEO]:this._parsePermissionState(e)}),e.onchange=function(){try{t._handlePermissionsChange({[Ri.VIDEO]:t._parsePermissionState(this)})}catch(e){}},!0))).catch((()=>!1))),n.push(navigator.permissions.query({name:Xh}).then((e=>(this._handlePermissionsChange({[Ri.AUDIO]:this._parsePermissionState(e)}),e.onchange=function(){try{t._handlePermissionsChange({[Ri.AUDIO]:t._parsePermissionState(this)})}catch(e){}},!0))).catch((()=>!1))),Promise.all(n).then((t=>e(t.every((e=>e)))))}))}_parsePermissionState(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const t=e.state||e.status;if("string"!=typeof t)throw new TypeError;return"granted"===t}_handlePermissionsChange(e){[Ri.AUDIO,Ri.VIDEO].some((t=>t in e&&e[t]!==this._permissions[t]))&&(this._permissions={...this._permissions,...e},this.eventEmitter.emit(zh,this._permissions),(this._permissions[Ri.AUDIO]||this._permissions[Ri.VIDEO])&&this.enumerateDevices((()=>{})))}enumerateDevices(e){pl.enumerateDevices(e)}isDeviceListAvailable(){return pl.isDeviceListAvailable()}isDeviceChangeAvailable(e){return pl.isDeviceChangeAvailable(e)}isDevicePermissionGranted(e){return new Promise((t=>{e in this._permissions?t(this._permissions[e]):this._permissionsApiSupported.then((n=>{if(!n)return void t(!1);const i=[];switch(e){case Ri.VIDEO:i.push(navigator.permissions.query({name:Yh}));break;case Ri.AUDIO:i.push(navigator.permissions.query({name:Xh}));break;default:i.push(navigator.permissions.query({name:Yh})),i.push(navigator.permissions.query({name:Xh}))}Promise.all(i).then((e=>t(e.every((e=>{try{return this._parsePermissionState(e)}catch{return!1}})))),(()=>t(!1)))}))}))}isMultipleAudioInputSupported(){return!(ci.isFirefox()&&ci.isVersionLessThan("101")||ci.isIosBrowser())}getAudioOutputDevice(){return pl.getAudioOutputDevice()}setAudioOutputDevice(e){return pl.setAudioOutputDevice(e)}},Zh=(0,E.getLogger)("modules/detection/ActiveDeviceDetector.js");function eu(e){for(const t of e)t.stopStream()}const tu=(0,E.getLogger)("modules/proxyconnection/CustomSignalingLayer.js");class nu extends Ac{constructor(){super(),this.ssrcOwners=new Map,this.chatRoom=null}getPeerMediaInfo(e,t,n){return{}}getPeerSourceInfo(e,t){}getSSRCOwner(e){return this.ssrcOwners.get(e)}getTrackSourceName(e){}removeSSRCOwners(e){if(null!=e&&e.length)for(const t of e)this.ssrcOwners.delete(t)}setChatRoom(e){this.chatRoom=e}setSSRCOwner(e,t){if("number"!=typeof e)throw new TypeError(`SSRC(${e}) must be a number`);const n=this.ssrcOwners.get(e);n&&n!==t&&tu.error(`SSRC owner re-assigned from ${n} to ${t}`),this.ssrcOwners.set(e,t)}setTrackMuteStatus(e,t){return!1}setTrackVideoType(e,t){return!1}updateSsrcOwnersOnLeave(e){const t=Array.from(this.ssrcOwners).filter((t=>t[1]===e)).map((e=>e[0]));null!=t&&t.length&&this.removeSSRCOwners(t)}}let iu;!function(e){e.ACCEPT="session-accept",e.CONNECTION_ERROR="connection-error-encountered",e.INITIATE="session-initiate",e.TERMINATE="session-terminate",e.TRANSPORT_INFO="transport-info",e.UNAVAILABLE="unavailable"}(iu||(iu={}));const ru=(0,E.getLogger)("modules/proxyconnection/ProxyConnectionPC.js");class ou{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this._options={pcConfig:{},isInitiator:!1,receiveAudio:!1,receiveVideo:!1,...e},this._tracks=[],this._peerConnection=null,this._onError=this._onError.bind(this),this._onRemoteStream=this._onRemoteStream.bind(this),this._onSendMessage=this._onSendMessage.bind(this)}getPeerJid(){return this._options.peerJid}processMessage(e){switch(e.attr("action")){case iu.ACCEPT:this._onSessionAccept(e);break;case iu.INITIATE:this._onSessionInitiate(e);break;case iu.TERMINATE:this._onSessionTerminate(e);break;case iu.TRANSPORT_INFO:this._onTransportInfo(e)}}start(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];this._peerConnection||(this._tracks=this._tracks.concat(e),this._peerConnection=this._createPeerConnection(),this._peerConnection.invite(e))}stop(){this._peerConnection&&this._peerConnection.terminate(),this._onSessionTerminate()}_createPeerConnection(){const e={connected:!0,jingle:{terminate:()=>{}},sendIQ:this._onSendMessage,addEventListener:()=>()=>{},addCancellableListener:()=>()=>{}},t={iceServers:Ra,...this._options.pcConfig},n={addEventListener:()=>{},addPresenceListener:()=>{},connectionTimes:[],eventEmitter:{emit:e=>{switch(e){case Hi.XMPPEvents.CONNECTION_ICE_FAILED:case Hi.XMPPEvents.CONNECTION_FAILED:this._onError(iu.CONNECTION_ERROR,e)}}},removeEventListener:()=>{},removePresenceListener:()=>{},supportsRestartByTerminate:()=>!1};this._rtc=new pl({myUserId:()=>""},{}),this._rtc.addListener(ji.default.REMOTE_TRACK_ADDED,this._onRemoteStream);const i=new ua(void 0,void 0,this._options.peerJid,e,{offerToReceiveAudio:this._options.receiveAudio,offerToReceiveVideo:this._options.receiveVideo},t,!0,this._options.isInitiator),r=new nu;return r.setChatRoom(n),i.initialize(n,this._rtc,r,{}),i}_onError(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";this._options.onError(this._options.peerJid,e,t)}_onRemoteStream(e){this._tracks.push(e),this._options.onRemoteStream(e)}_onSendMessage(e,t){this._options.onSendMessage(this._options.peerJid,e),t&&setTimeout(t,250)}_onSessionAccept(e){this._peerConnection?this._peerConnection.setAnswer(e):ru.error("Received an answer when no peer connection exists.")}_onSessionInitiate(e){this._peerConnection?ru.error("Received an offer when an offer was already sent."):(this._peerConnection=this._createPeerConnection(),this._peerConnection.acceptOffer(e,(()=>{}),(()=>this._onError(this._options.peerJid,iu.CONNECTION_ERROR,"session initiate error")),[]))}_onSessionTerminate(){this._tracks.forEach((e=>e.dispose())),this._tracks=[],this._peerConnection&&this._peerConnection.onTerminated(),this._rtc&&(this._rtc.removeListener(ji.default.REMOTE_TRACK_ADDED,this._onRemoteStream),this._rtc.destroy())}_onTransportInfo(e){this._peerConnection.addIceCandidates(e)}}const su=(0,E.getLogger)("modules/proxyconnection/ProxyConnectionService.js");var au=n(549),du=n.n(au);const cu=(0,E.getLogger)("modules/webaudio/AudioMixer.js");class lu{constructor(){this._started=!1,this._streamsToMix=[],this._streamMSSArray=[]}addMediaStream(e){e.getAudioTracks()||cu.warn("Added MediaStream doesn\'t contain audio tracks."),this._streamsToMix.push(e)}start(){if(this._started)return this._mixedMSD.stream;if(this._audioContext=Nl(),!this._streamsToMix.length)return cu.warn("No MediaStream\'s added to AudioMixer, nothing will happen."),null;this._started=!0,this._mixedMSD=this._audioContext.createMediaStreamDestination();for(const e of this._streamsToMix){const t=this._audioContext.createMediaStreamSource(e);t.connect(this._mixedMSD),this._streamMSSArray.push(t)}return this._mixedMSD.stream}reset(){this._started=!1,this._streamsToMix=[];for(const e of this._streamMSSArray)e.disconnect();this._streamMSSArray=[],this._audioContext&&(this._audioContext=void 0)}}const hu=S().getLogger("JitsiMeetJS.ts");let uu=!1;function pu(e){const t={};return t.audio_requested=e.devices.includes("audio"),t.video_requested=e.devices.includes("video"),t.screen_sharing_requested=e.devices.includes("desktop"),t.video_requested&&(t.resolution=e.resolution),t}const mu={version:"bbd9796e",JitsiConnection:Bh,ProxyConnectionService:class{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const{jitsiConnection:t,...n}=e;this._options={pcConfig:t&&t.xmpp.connection.jingle.p2pIceConfig,...n},this._peerConnection=null,this._onFatalError=this._onFatalError.bind(this),this._onSendMessage=this._onSendMessage.bind(this),this._onRemoteStream=this._onRemoteStream.bind(this)}processMessage(e){const t=e.from;if(!t)return;if(this._peerConnection&&this._peerConnection.getPeerJid()!==t)return void this._onFatalError(t,iu.CONNECTION_ERROR,"rejected");const n=this._convertStringToXML(e.data.iq),i=n&&n.find("jingle"),r=i&&i.attr("action");r===iu.INITIATE&&(this._peerConnection=this._createPeerConnection(t,{isInitiator:!1,receiveVideo:!0})),this._peerConnection&&this._peerConnection.processMessage(i),r!==iu.CONNECTION_ERROR&&r!==iu.UNAVAILABLE&&r!==iu.TERMINATE||this._selfCloseConnection()}start(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];this._peerConnection=this._createPeerConnection(e,{isInitiator:!0,receiveVideo:!1}),t.forEach(((e,t)=>{const n=Cc("peer",e.getType(),t);e.setSourceName(n)})),this._peerConnection.start(t)}stop(){this._peerConnection&&this._peerConnection.stop(),this._peerConnection=null}_convertStringToXML(e){try{const t=(new DOMParser).parseFromString(e,"text/xml");return _t()(t)}catch(e){return su.error("Attempted to convert incorrectly formatted xml"),null}}_createPeerConnection(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!e)throw new Error("Cannot create ProxyConnectionPC without a peer.");const n={pcConfig:this._options.pcConfig,onError:this._onFatalError,onRemoteStream:this._onRemoteStream,onSendMessage:this._onSendMessage,peerJid:e,...t};return new ou(n)}_onFatalError(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"";su.error("Received a proxy connection error",e,t,n);const i=(0,St.$iq)({to:e,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:t}).c("details").t(n).up();this._onSendMessage(e,i),this._peerConnection&&this._peerConnection.getPeerJid()===e&&this._selfCloseConnection()}_onRemoteStream(e){if(!this._options.onRemoteStream)return su.error("Remote track received without callback."),void e.dispose();const t=e.isVideoTrack();let n;t&&(n=this._options.convertVideoToDesktop?Qo.VideoType.DESKTOP:Qo.VideoType.CAMERA);const i=e.getOriginalStream(),r=pl.createLocalTracks([{deviceId:`proxy:${this._peerConnection.getPeerJid()}`,mediaType:t?Ri.VIDEO:Ri.AUDIO,sourceType:"proxy",stream:i,track:i.getVideoTracks()[0],videoType:n}]);this._options.onRemoteStream(r[0])}_onSendMessage(e,t){if(this._options.onSendMessage)try{const n=(new XMLSerializer).serializeToString(t.nodeTree||t);this._options.onSendMessage(e,{iq:n})}catch(e){su.error("Attempted to send an incorrectly formatted iq.")}}_selfCloseConnection(){this.stop(),this._options.onConnectionClosed&&this._options.onConnectionClosed()}},constants:{recording:{error:{BUSY:"busy",ERROR:"error",RESOURCE_CONSTRAINT:"resource-constraint",UNEXPECTED_REQUEST:"unexpected-request",SERVICE_UNAVAILABLE:"service-unavailable"},mode:{FILE:"file",STREAM:"stream"},status:{OFF:"off",ON:"on",PENDING:"pending"}},sipVideoGW:_,transcriptionStatus:l,trackStreamingStatus:Jc},events:{conference:r,connection:d,detection:f,track:o,mediaDevices:y,connectionQuality:g,e2eping:v,rtcstats:s},errors:{conference:i,connection:c,track:a},errorTypes:{JitsiTrackError:dr},logLevels:S().levels,mediaDevices:Qh,analytics:Mi.analytics,init(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return S().setLogLevel(S().levels.INFO),hu.info(`This appears to be ${ci.getName()}, ver: ${ci.getVersion()}`),$o.init(e.externalStorage),Mi.init(e),window.connectionTimes||(window.connectionTimes={}),!0!==e.enableAnalyticsLogging&&(hu.warn("Analytics disabled, disposing."),this.analytics.dispose()),pl.init(e)},isDesktopSharingEnabled:()=>pl.isDesktopSharingEnabled(),isWebRtcSupported:()=>pl.isWebRtcSupported(),setLogLevel(e){S().setLogLevel(e)},rtcstats:{sendIdentityEntry(e){si.sendIdentity(e)},sendStatsEntry(e,t){si.sendStatsEntry(e,null,t)},on(e,t){si.events.on(e,t)}},setLogLevelById(e,t){S().setLogLevelById(e,t)},addGlobalLogTransport(e){S().addGlobalTransport(e)},removeGlobalLogTransport(e){S().removeGlobalTransport(e)},setGlobalLogOptions(e){S().setGlobalOptions(e)},createLocalTracks(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=!1;const{firePermissionPromptIsShownEvent:n,fireSlowPromiseEvent:i,...r}=e;n&&!pl.arePermissionsGrantedForAvailableDevices()?Qh.emit(Kh,ci.getName()):i&&window.setTimeout((()=>{t||Qh.emit(Wh)}),1e3);let o=!1,s=window.performance.now();return window.connectionTimes||(window.connectionTimes={}),uu||(uu=!0,o=!0,window.connectionTimes["firstObtainPermissions.start"]=s),window.connectionTimes["obtainPermissions.start"]=s,pl.obtainAudioAndVideoPermissions(r).then((e=>{t=!0;let n=window.performance.now();if(window.connectionTimes["obtainPermissions.end"]=n,o&&(window.connectionTimes["firstObtainPermissions.end"]=n),Mi.sendAnalytics(an("success",pu(r))),this.isCollectingLocalStats())for(let t=0;t<e.length;t++){const n=e[t];n.getType()===Ri.AUDIO&&Mi.startLocalStats(n,n.setAudioLevel.bind(n))}const i=pl.getCurrentlyAvailableMediaDevices();if(i)for(let t=0;t<e.length;t++)e[t]._setRealDeviceIdFromDeviceList(i);return e})).catch((n=>{if(t=!0,n.name===Zi)Mi.sendAnalytics(an("warning",{reason:"extension install user canceled"}));else if(n.name===Xi){const t=pu(e);t.reason="device not found",t.devices=n.gum.devices.join("."),Mi.sendAnalytics(an("error",t))}else{const t=pu(e);t.reason=n.name,Mi.sendAnalytics(an("error",t))}let i=window.performance.now();return window.connectionTimes["obtainPermissions.end"]=i,o&&(window.connectionTimes["firstObtainPermissions.end"]=i),Promise.reject(n)}))},createLocalTracksFromMediaStreams:e=>pl.createLocalTracks(e.map((e=>{const t=e.stream.getTracks().filter((t=>t.kind===e.mediaType));if(!t||0===t.length)throw new dr(or,null,null);if(t.length>1)throw new dr(rr,null,null);return e.track=t[0],e}))),createTrackVADEmitter:(e,t,n)=>Ml.create(e,t,n),createAudioMixer:()=>new lu,getActiveAudioDevice:()=>new Promise((e=>{pl.enumerateDevices((t=>{const n=t.filter((e=>"audioinput"===e.kind)),i=[];for(const e of n){const t=pl.obtainAudioAndVideoPermissions({devices:["audio"],micDeviceId:e.deviceId}).then((e=>{const t=e[0];return Mi.startLocalStats(t,t.setAudioLevel.bind(t)),t}));i.push(t)}Promise.allSettled(i).then((t=>{const n=t.filter((e=>"fulfilled"===e.status)),i=t.filter((e=>"rejected"===e.status)),r=n.map((e=>e.value)),o=i.map((e=>e.value));for(const e of o)Zh.error("Failed to acquire audio device with error: ",e);for(const t of r)t.on(Ct,(n=>{n>.008&&(eu(r),e({deviceId:t.deviceId,deviceLabel:t.track.label}))}));setTimeout((()=>{eu(r),e({deviceId:"",deviceLabel:""})}),3e3)}))}))})),isDeviceListAvailable(){return hu.warn("This method is deprecated, use JitsiMeetJS.mediaDevices.isDeviceListAvailable instead"),this.mediaDevices.isDeviceListAvailable()},isDeviceChangeAvailable(e){return hu.warn("This method is deprecated, use JitsiMeetJS.mediaDevices.isDeviceChangeAvailable instead"),this.mediaDevices.isDeviceChangeAvailable(e)},isMultipleAudioInputSupported(){return this.mediaDevices.isMultipleAudioInputSupported()},isCollectingLocalStats:()=>Mi.audioLevelsEnabled&&_i.isLocalStatsSupported(),enumerateDevices(e){hu.warn("This method is deprecated, use JitsiMeetJS.mediaDevices.enumerateDevices instead"),this.mediaDevices.enumerateDevices(e)},setNetworkInfo(e){let{isOnline:t}=e;xo.updateNetworkInfo({isOnline:t})},util:{ScriptUtil:du(),browser:ci}}}},__webpack_module_cache__={};function __webpack_require__(e){var t=__webpack_module_cache__[e];if(void 0!==t)return t.exports;var n=__webpack_module_cache__[e]={id:e,loaded:!1,exports:{}};return __webpack_modules__[e].call(n.exports,n,n.exports,__webpack_require__),n.loaded=!0,n.exports}__webpack_require__.amdO={},__webpack_require__.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return __webpack_require__.d(t,{a:t}),t},__webpack_require__.d=(e,t)=>{for(var n in t)__webpack_require__.o(t,n)&&!__webpack_require__.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},__webpack_require__.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),__webpack_require__.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),__webpack_require__.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},__webpack_require__.nmd=e=>(e.paths=[],e.children||(e.children=[]),e);var __webpack_exports__=__webpack_require__(449);return __webpack_exports__})()));\n//# sourceMappingURL=lib-jitsi-meet.min.map';
if (!window.JitsiMeetJS) {
  const s = document.createElement("script");
  s.text = K4, document.head.appendChild(s);
}
process.env.NODE_ENV === "production" && JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
window.APP = {
  conference: {
    getConnectionState: () => {
      var s;
      return (s = window.APP.conference._room) == null ? void 0 : s.getConnectionState();
    },
    getStats: () => {
      var s, r;
      return (r = (s = window.APP.conference._room) == null ? void 0 : s.connectionQuality) == null ? void 0 : r.getStats();
    }
  }
};
JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
const Ge = JitsiMeetJS;
function q4(s, r) {
  if (s !== "default")
    return s;
  const c = r === "audio" ? Y.getState().audioInputDevices : Y.getState().videoInputDevices, h = c.find((v) => v.deviceId === "default");
  if (!h)
    return s;
  const f = c.find(
    (v) => v.deviceId !== "default" && v.groupId === h.groupId
  );
  return (f == null ? void 0 : f.deviceId) ?? s;
}
async function R6(s, r = null, c = null, h = {}) {
  if (He.getState().iAmRecorder)
    return;
  const { data: v, error: R } = await rr(
    Ge.createLocalTracks({
      devices: [s],
      cameraDeviceId: r,
      micDeviceId: r,
      timeout: c,
      ...h
    })
  );
  if (R)
    throw R;
  return v[0];
}
const nE = {
  audio: Promise.resolve(),
  video: Promise.resolve()
};
function ic(s, r = null, c = Vd.USER) {
  const h = nE[s].then(
    () => $4(s, r, c)
  );
  return nE[s] = h.catch(() => {
  }), h;
}
async function $4(s, r, c) {
  const f = Y.getState().isMobile() ? null : r, v = q4(f, s), { data: R, error: T } = await rr(
    R6(s, v, null, {
      facingMode: c
    })
  );
  R ? (f === "default" && (R._realDeviceId = R.deviceId = "default"), Q6(R)) : (s === "video" ? v2() : s === "audio" && Hv(), T instanceof Error && T.name === "gum.permission_denied" && Je.publish({
    type: Un.notification,
    payload: {
      type: "error",
      message: `Permission denied for ${s} track. Please allow access to your device.`
    }
  }));
}
function e8() {
  var h, f;
  const s = [];
  if (!He.getState().enableCompanionMode) {
    const v = He.getState().audioInputDeviceId ?? ((h = Y.getState().audioInputDevice) == null ? void 0 : h.deviceId);
    s.push(ic("audio", v));
  }
  if (He.getState().sessionType === im.VIDEO) {
    const v = He.getState().videoInputDeviceId, R = (f = Y.getState().videoInputDevice) == null ? void 0 : f.deviceId, T = He.getState().initialCameraFacing, E = Y.getState().cameraFacing;
    v ? s.push(ic("video", v)) : T ? s.push(ic("video", null, E)) : s.push(
      ic("video", R, E)
    );
  }
  return Promise.all(s).then(() => {
  });
}
function t8(s) {
  Y.getState().audioInputDevices.filter((c) => c.deviceId !== "").length > 0 && ic("audio", s);
}
function Uu(s, r = !1) {
  Y.getState().isMobileSDK() || s && Y.setState({
    audioInputDevice: { ...s.toJSON(), skipSubscribe: r }
  });
}
async function wU(s, r) {
  var h;
  if (Y.getState().videoInputDevices.filter((f) => f.deviceId !== "").length > 0)
    ic("video", s, r);
  else if (s === null) {
    const f = (h = fn(We.VIDEO)) == null ? void 0 : h.originalTrack;
    if (f) {
      await f.dispose();
      const v = ke.getState().conference;
      v && v.replaceTrack(f, null);
    }
    ic("video", s, r);
  }
}
function am(s, r = !1) {
  if (!Y.getState().isMobileSDK() && s) {
    const h = s.toJSON ? s.toJSON() : s;
    Y.setState({
      videoInputDevice: { ...h, skipSubscribe: r }
    });
  }
}
function E6(s) {
  Ge.mediaDevices.isDeviceChangeAvailable("output") && Ge.mediaDevices.setAudioOutputDevice(s).then(() => {
    const c = Y.getState().audioOutputDevices.find((h) => h.deviceId === s);
    c && Y.setState({
      audioOutputDevice: c
    });
  });
}
const n8 = { layouts: { tileView: "Tile View", sideLayout: "Side Layout", spotlight: "Spotlight" } }, i8 = { audioControl: { muteMicrophone: "Mute microphone", unmuteMicrophone: "Unmute microphone", audioDeviceOptions: "Audio device options", audioSettings: "Audio settings" }, videoControl: { turnOffCamera: "Turn off camera", turnOnCamera: "Turn on camera", videoDeviceOptions: "Video device options", videoSettings: "Video settings" }, settingsDialog: { todo: "// TODO: Revisit this section", title: "Settings", tabs: { audio: "Audio", video: "Video", closedCaption: "Closed caption" }, deviceLabels: { microphone: "Microphone", speaker: "Speaker", camera: "Camera", frameRate: "Desktop sharing frame rate" }, deviceStates: { noMicrophoneSelected: "No microphone selected", noSpeakerSelected: "No speaker selected", noCameraSelected: "No camera selected" }, audioSettings: { enableNoiseReduction: "Enable noise reduction" }, closedCaptionSettings: { language: "Language", enableClosedCaptions: "Enable closed captions" }, videoSettings: { mirrorMyVideo: "Mirror my video", selectCameraToSeePreview: "Select a camera to see preview", loadingCameraPreview: "Loading camera preview...", frameRateUnit: "frames per second", frameRateNotice: "You need to restart the screen share for the new settings to take effect." }, permissions: { errorTitle: "Some permissions are missing", microphoneBlocked: "Access to your microphone is blocked. Please check your browser settings.", cameraBlocked: "Access to your camera is blocked. Please check your browser settings.", microphoneAndCameraBlocked: "Access to your microphone and camera is blocked. Please check your browser settings." }, buttons: { cancel: "Cancel", done: "Done" } }, recording: { startRecording: "Start recording", stopRecording: "Stop recording", startRecordingConfirmation: "Recording will capture video, audio, and screen sharing from this call.", stopRecordingConfirmation: "Stopping will end the recording of video, audio, and screen sharing from this call.", cancel: "Cancel" }, streaming: { startStreaming: "Start streaming", stopStreaming: "Stop streaming", startStreamingConfirmation: "Enter the RTMP stream URL and stream key to start live streaming.", stopStreamingConfirmation: "Are you sure you want to stop the live stream?", streamUrlPlaceholder: "Enter stream URL", streamKeyPlaceholder: "Enter stream key (optional)", cancel: "Cancel" }, raiseHand: "Raise hand", lowerHand: "Lower hand", startScreenSharing: "Start screen sharing", stopScreenSharing: "Stop screen sharing", moreOptions: "More options", leaveSession: "Leave session", reactions: "Reactions" }, a8 = { title: "Are you still there?", subtitle: "You are the only one here, so this call will end in less than {minutes} minute{plural}. Do you want to stay in this call?", buttons: { stayInCall: "Stay in the call", leaveNow: "Leave now" } }, r8 = { header: { title: "Participants", closeButton: "Close participants list" }, search: { placeholder: "Search Participant" }, emptyState: { title: "No participants found", subtitle: "No participants match your search" } }, o8 = { title: "Virtual Background", addBackground: "Add Background", noCameraFeed: "No camera feed detected", effectError: "Virtual background could not be applied", effectErrorVideoPaused: "Virtual background failed, so your video was paused", buttons: { cancel: "Cancel", done: "Done" } }, s8 = { recording: { label: "REC", tooltip: "This session is being recorded" }, streaming: { label: "LIVE", tooltip: "This session is being streamed" } }, l8 = { recordingStarted: "The session is being recorded", recordingStopped: "Recording has been stopped", streamingStarted: "Live streaming has started", streamingStopped: "Live streaming has stopped" }, c8 = { emptyState: "Waiting for people to speak…" }, d8 = { screenSharePaused: "Screen share paused due to a poor connection" }, u8 = { blockedTitle: "Tap to hear audio", blockedSubtitle: "Your browser needs a tap before it can play the other participants' audio.", blockedButton: "Enable audio" }, h8 = { error: "Something went wrong, please try again." }, m8 = {}, p8 = {
  header: n8,
  controlPanel: i8,
  idealTimeout: a8,
  participantList: r8,
  virtualBackground: o8,
  indicators: s8,
  notifications: l8,
  closedCaptions: c8,
  tile: d8,
  audioPlayback: u8,
  general: h8,
  other: m8
}, iE = {
  translations: {
    "en-US": p8
  },
  currentLocale: "en-US"
}, BU = lc(
  Fd(
    bu(iE, (s) => ({
      reset: () => s(iE),
      setLocale: (r) => s(() => ({
        currentLocale: r
      }))
    }))
  )
);
function AU(s, r) {
  const c = r.split(".");
  let h = s;
  for (const f of c) {
    if (h == null || typeof h != "object")
      return "";
    h = h[f];
  }
  return h;
}
function c2(s) {
  const { translations: r, currentLocale: c } = BU.getState();
  return AU(r, `${c}.${s}`);
}
const Ua = () => {
  const { translations: s, currentLocale: r } = BU();
  return {
    t: (h) => AU(s, `${r}.${h}`),
    currentLocale: r,
    translations: s
  };
}, aE = {
  sessionType: "VIDEO",
  autoStartRecording: !1,
  autoStartTranscription: !1,
  layout: Ai.TILE,
  hideRecordingButton: !0,
  hideStreamingButton: !0,
  hideVirtualBackgroundButton: !1,
  // Explicit so reset() clears it: set(initialState) merges, so a key missing
  // here would survive into the next session.
  virtualBackground: void 0,
  hideAudioModeButton: !1,
  hideSwitchCameraButton: !1,
  devSessionId: "dev-session",
  iAmRecorder: !1,
  hideControlPanel: !1,
  hideHeaderPanel: !1,
  hideRaiseHandButton: !1,
  hideShareInviteButton: !0,
  hideChangeLayoutButton: !1,
  hideLeaveSessionButton: !1,
  hideToggleAudioButton: !1,
  hideParticipantListButton: !1,
  hideChatButton: !0,
  hideToggleVideoButton: !1,
  hideScreenSharingButton: !1,
  hideClosedCaptionButton: !0,
  hideTranscriptionButton: !0,
  captionLanguage: Qv[0].code,
  hideSessionTimer: !1,
  hideNetworkIndicator: !0,
  hideRecordingStatusIndicator: !1,
  hideStreamingStatusIndicator: !1,
  enableParticipantContextMenu: !0,
  // lowBandwidthMode: false,
  displayName: "",
  startAudioMuted: !1,
  startVideoPaused: !1,
  title: "",
  enableNoiseReduction: !1,
  unstable_headlessMode: !1,
  idleTimeoutPeriodBeforePrompt: 6e4,
  idleTimeoutPeriodAfterPrompt: 18e4,
  enableSpotlightDrag: !0,
  enableSpotlightSwap: !0,
  enableIOSPictureInPicture: !1,
  showFrameRate: !1,
  enableCompanionMode: !1,
  isPeerCall: !1,
  enableNotifications: !0
}, He = lc()(
  Fd(
    bu(aE, (s) => ({
      reset: () => s(aE)
    }))
  )
), f8 = (s) => {
  He.setState(s);
}, g8 = {
  avatar: void 0,
  isLocal: !0,
  name: "",
  pid: "local",
  ruid: "local-human",
  role: "none",
  sources: /* @__PURE__ */ new Map(),
  type: "human",
  uid: "unknown"
}, rE = {
  dominantSpeakers: [],
  localParticipant: g8,
  participants: [],
  virtualParticipants: []
}, je = lc()(
  Fd(
    bu(rE, (s, r) => ({
      addParticipant: (c) => {
        s((h) => ({
          participants: h.participants.some((f) => f.pid === c.pid) ? h.participants.map(
            (f) => f.pid === c.pid ? { ...f, ...c } : f
          ) : [...h.participants, c]
        }));
      },
      addVirtualParticipant: (c) => {
        s((h) => ({
          virtualParticipants: h.virtualParticipants.some(
            (f) => f.pid === c.pid && f.type === c.type
          ) ? h.virtualParticipants.map(
            (f) => f.pid === c.pid && f.type === c.type ? { ...f, ...c } : f
          ) : [...h.virtualParticipants, c]
        }));
      },
      clearParticipants: () => s({ participants: [], virtualParticipants: [] }),
      removeParticipant: (c) => {
        const f = je.getState().participants.find((v) => v.pid === c);
        if (f) {
          Cr(
            st.ParticipantEventsListner.onParticipantLeft,
            f.pid,
            { forceEmit: v6() }
          );
          const v = je.getState().pinnedParticipant;
          (v == null ? void 0 : v.pid) === f.pid && je.getState().unpinParticipant();
        }
        s((v) => ({
          participants: v.participants.filter((R) => R.pid !== c)
        }));
      },
      removeVirtualParticipant: (c, h = "screen-share") => {
        const f = je.getState().pinnedParticipant;
        (f == null ? void 0 : f.pid) === c && f.type === h && je.getState().unpinParticipant(), s((v) => ({
          virtualParticipants: v.virtualParticipants.filter(
            (R) => !(R.pid === c && R.type === h)
          )
        }));
      },
      updateLocalParticipant: (c) => {
        s((h) => ({
          localParticipant: {
            ...h.localParticipant,
            ...c
          }
        }));
      },
      updateParticipant: (c, h) => {
        s((f) => c === f.localParticipant.pid ? {
          localParticipant: {
            ...f.localParticipant,
            ...h
          }
        } : {
          participants: f.participants.map(
            (v) => v.pid === c ? { ...v, ...h } : v
          )
        });
      },
      updateParticipantRole: (c, h) => {
        s((f) => ({
          participants: f.participants.map(
            (v) => v.pid === c ? { ...v, role: h } : v
          )
        }));
      },
      pinParticipant: (c, h) => {
        const v = WR().find(
          (R) => R.pid === c && R.type === h
        );
        v && s({ pinnedParticipant: v });
      },
      unpinParticipant: () => {
        s({ pinnedParticipant: void 0 });
      },
      getParticipantById: (c) => {
        const h = r().localParticipant;
        return c === h.pid ? h : r().participants.find((f) => f.pid === c);
      },
      reset: () => s(rE)
    }))
  )
);
function sm() {
  const s = je((f) => f.localParticipant), r = je((f) => f.participants), c = je(
    (f) => f.virtualParticipants
  ), h = He.getState().iAmRecorder;
  return ne.useMemo(() => h ? [...c, ...r] : [s, ...c, ...r], [h, s, r, c]);
}
function WR() {
  const s = je.getState().localParticipant, r = je.getState().participants, c = je.getState().virtualParticipants;
  return [s, ...c, ...r];
}
const v8 = () => {
  const s = je.getState().dominantSpeakers, r = je.getState().participants;
  je.setState({
    dominantSpeakers: s.filter(
      (c) => r.some((h) => h.pid === c)
    )
  });
}, S8 = () => {
  const { participants: s, dominantSpeakers: r } = je.getState(), c = r[0];
  if (!c || s.slice(0, 4).some((v) => v.pid === c))
    return;
  const f = [...s].sort((v, R) => {
    const T = r.indexOf(v.pid), E = r.indexOf(R.pid);
    return T === -1 && E === -1 ? 0 : T === -1 ? 1 : E === -1 ? -1 : T - E;
  });
  je.setState({ participants: f });
};
je.subscribe(
  (s) => s.dominantSpeakers,
  S8
);
const IU = (s, r) => {
  je.getState().pinParticipant(s, r);
}, LU = () => {
  je.getState().unpinParticipant();
};
je.subscribe(
  (s) => s.virtualParticipants,
  (s) => {
    s && s.length > 0 ? yu(Ai.SIDEBAR, !0) : Y.getState().sidebarLayoutSetProgrammatically && yu(Ai.TILE);
  }
);
je.subscribe(
  (s) => s.participants.length,
  () => {
    v8();
  }
);
je.subscribe(
  (s) => s.participants.map(({ pid: r, name: c, avatar: h, uid: f }) => ({
    pid: r,
    name: c,
    avatar: h,
    uid: f
  })),
  () => {
    Y4({ forceEmit: v6() });
  },
  {
    equalityFn: p6
  }
);
je.subscribe(
  (s) => s.localParticipant.pid,
  (s) => {
    it.getState().updateLocalTrack(We.AUDIO, {
      pid: s
    }), it.getState().updateLocalTrack(We.VIDEO, {
      pid: s
    });
  }
);
je.subscribe(
  (s) => !!s.pinnedParticipant,
  (s) => {
    s ? Y.getState().layout === Ai.TILE && yu(Ai.SIDEBAR, !0) : Y.getState().sidebarLayoutSetProgrammatically && yu(Ai.TILE);
  }
);
je.subscribe(
  (s) => s.participants.length,
  (s) => {
    s === 0 ? Y.getState().restartIdealTimeoutTimer() : Y.getState().clearIdealTimeoutTimer();
  }
);
Je.subscribe(
  st.SessionStatusListener.onSessionJoined,
  () => {
    je.getState().participants.length === 0 && Y.getState().restartIdealTimeoutTimer();
  }
);
const U6 = (s) => {
  const {
    pinnedParticipant: r,
    participants: c,
    virtualParticipants: h,
    dominantSpeakers: f,
    localParticipant: v
  } = s;
  if (r)
    return r;
  if (h.length > 0)
    return h[0];
  for (const R of f) {
    const T = c.find((E) => E.pid === R);
    if (T)
      return T;
  }
  return c.length > 0 ? c[0] : v;
}, R8 = (s) => (s == null ? void 0 : s.type) === "screen-share" ? We.SCREENSHARE : We.VIDEO;
je.subscribe(
  (s) => s.participants.filter((r) => r.uid),
  (s, r) => {
    s.length > r.length && JR(
      s,
      r,
      (h) => h.uid
    ).forEach((h) => {
      Cr(
        st.ParticipantEventsListner.onParticipantJoined,
        h.pid,
        { forceEmit: v6() }
      );
    });
  }
);
const oE = 3, NR = {
  toasts: []
};
let E8 = 0;
const Su = lc((s) => ({
  ...NR,
  addToast: (r) => {
    if (!XU() || !T6() || !He.getState().enableNotifications)
      return "";
    const c = r.id ?? `toast-${++E8}-${Date.now()}`, h = {
      ...r,
      id: c,
      createdAt: Date.now()
    };
    return s((f) => {
      const v = f.toasts.findIndex((T) => T.id === c);
      if (v !== -1) {
        const T = [...f.toasts];
        return T[v] = h, { toasts: T };
      }
      const R = [...f.toasts, h];
      return R.length > oE ? { toasts: R.slice(-oE) } : { toasts: R };
    }), c;
  },
  removeToast: (r) => {
    s((c) => ({
      toasts: c.toasts.filter((h) => h.id !== r)
    }));
  },
  clearAll: () => {
    s(NR);
  },
  reset: () => {
    s(NR);
  }
}));
function Kh(s) {
  return Su.getState().addToast({
    id: s.id,
    message: s.message,
    type: s.type ?? "info",
    duration: s.duration ?? 3e3,
    position: s.position ?? "bottom",
    action: s.action
  });
}
const U8 = 8, T8 = 5e3;
let Nv = 0, em = null;
function Wv() {
  em && (clearTimeout(em), em = null), Nv = 0;
}
function y8() {
  if (em)
    return;
  if (Nv >= U8) {
    Wv(), Kh({
      id: "recording-failed",
      type: "error",
      message: "Recording failed"
    });
    return;
  }
  const s = T8 * 2 ** Math.max(0, Nv - 2);
  Nv += 1, em = setTimeout(() => {
    em = null, g2();
  }, s);
}
function JU() {
  var f, v, R;
  const s = ke.getState().conference;
  if (!(s != null && s.room))
    return;
  const r = He.getState(), c = je.getState().localParticipant, h = {
    session_id: r.sessionId,
    is_audio_only: String(r.sessionType === "VOICE"),
    is_audio_muted: String(r.startAudioMuted),
    is_video_muted: String(r.startVideoPaused),
    is_peer_call: String(r.isPeerCall),
    start_recording_on_call_start: String(r.autoStartRecording),
    // Lets the backend tell a prepared (lobby) occupant from a real join. Sent
    // once at conferenceWillJoin and re-sent (idempotent) at the actual join
    // with `joined`; nothing else in the payload changes between the two.
    join_state: zR(),
    uid: c.uid,
    platform: Y.getState().sdkPlatform,
    platform_version: Y.getState().platformVersion,
    user_agent: Y.getState().userAgent,
    meeting_id: ((R = (v = (f = s.room) == null ? void 0 : f.xmpp) == null ? void 0 : v.getJid) == null ? void 0 : R.call(v)) ?? r.sessionId,
    mode: r.layout,
    commit_id: "a6986c0"
  };
  s.room.addOrReplaceInPresence(m6.initialConfig, {
    attributes: h
  });
}
const sE = {
  conference: null,
  conferenceJoined: !1,
  conferenceJoinedAt: null,
  conferenceStartedAt: null,
  sessionPhase: "idle",
  sessionStartedAt: null,
  mediaJoinInFlight: !1,
  pendingAutoStartRecording: !1,
  conferenceStatus: "initial",
  p2p: !1,
  connectionQuality: /* @__PURE__ */ new Map(),
  remoteStatsTimestamps: /* @__PURE__ */ new Map(),
  raiseHandMap: /* @__PURE__ */ new Map(),
  recording: {
    status: Ge.constants.recording.status.OFF,
    mode: Ge.constants.recording.mode.FILE
  },
  isRecording: !1,
  isStreaming: !1
}, ke = lc()(
  Fd(
    bu(sE, (s) => ({
      conferenceWillJoin: (r) => {
        typeof (window == null ? void 0 : window.APP) < "u" && (window.APP.conference._room = r), s({ conference: r, conferenceStatus: "joining" });
      },
      reset: () => {
        Wv(), s(sE);
      },
      raiseHand: (r, c) => {
        s((h) => ({
          raiseHandMap: new Map(h.raiseHandMap).set(
            r,
            c
          )
        })), Cr(
          st.ParticipantEventsListner.onParticipantHandRaised,
          r
        );
      },
      lowerHand: (r) => {
        ke.getState().raiseHandMap.has(r) && (s((h) => {
          const f = new Map(h.raiseHandMap);
          return f.delete(r), { raiseHandMap: f };
        }), Cr(
          st.ParticipantEventsListner.onParticipantHandLowered,
          r
        ));
      },
      leaveConference: async () => {
        const r = ke.getState().conference;
        if (r) {
          const { error: c } = await rr(r.leave(), 500);
          c && Je.publish({
            type: st.SessionStatusListener.onSessionLeft
          });
        }
      },
      endConference: async () => {
        const r = ke.getState().conference;
        if (r) {
          const { error: c } = await rr(r.end());
        }
      }
    }))
  )
), N8 = () => {
  const [s, r] = ne.useState(0), c = ke(
    (h) => h.sessionStartedAt ?? h.conferenceStartedAt
  );
  return ne.useEffect(() => {
    const h = setInterval(() => {
      if (!c) {
        r(0);
        return;
      }
      r(Math.max(Date.now() - c, 0));
    }, 1e3);
    return () => clearInterval(h);
  }, [c]), s;
}, Hn = () => ke.getState().sessionPhase, Tu = (s) => ke.setState({ sessionPhase: s }), b8 = () => ke.getState().mediaJoinInFlight, HR = (s) => ke.setState({ mediaJoinInFlight: s }), T6 = () => Hn() === "joined", zR = () => {
  const s = Hn();
  return s === "joining" || s === "joined" ? "joined" : "prepared";
}, C8 = (s) => {
  const r = typeof s == "number" ? s : parseInt(String(s ?? ""), 10);
  if (!Number.isFinite(r) || r <= 0)
    return;
  const c = ke.getState().sessionStartedAt;
  (c === null || r < c) && ke.setState({ sessionStartedAt: r });
};
function WU() {
  const s = ke.getState().conference;
  if (s) {
    const r = Date.now(), c = je.getState().localParticipant.pid;
    s == null || s.setLocalParticipantProperty("raisedHand", r), ke.getState().raiseHand(c, r);
  }
}
function xv() {
  const s = ke.getState().conference;
  if (s) {
    const r = je.getState().localParticipant.pid;
    s.setLocalParticipantProperty("raisedHand", 0), ke.getState().lowerHand(r);
  }
}
function y6() {
  const s = ke.getState().conference;
  (s == null ? void 0 : s.getLocalParticipantProperty("raisedHand")) ? xv() : WU();
}
const HU = () => {
  const s = ke((c) => c.isRecording);
  return !He((c) => c.iAmRecorder) && s;
}, zU = () => {
  const s = ke((c) => c.isStreaming);
  return !He((c) => c.iAmRecorder) && s;
};
ke.subscribe(
  (s) => s.recording,
  (s) => {
    const r = s.status, c = s.mode, h = s.error, f = s.initiator, v = !h && f && (r === Ge.constants.recording.status.ON || r === Ge.constants.recording.status.PENDING), R = Ge.constants.recording.error;
    if (h) {
      const C = c === Ge.constants.recording.mode.STREAM, N = C ? "streaming-failed" : "recording-failed";
      h === R.UNEXPECTED_REQUEST || (h === R.RESOURCE_CONSTRAINT ? C ? Kh({
        id: N,
        type: "error",
        message: "Streaming failed"
      }) : (Kh({
        id: N,
        type: "error",
        duration: 0,
        message: "Recorders busy, retrying..."
      }), y8()) : h === R.SERVICE_UNAVAILABLE ? Kh({
        id: N,
        type: "error",
        message: C ? "Streaming unavailable" : "Recording unavailable"
      }) : Kh({
        id: N,
        type: "error",
        message: C ? "Streaming failed" : "Recording failed"
      }));
    }
    const T = v && c === Ge.constants.recording.mode.FILE, E = v && c === Ge.constants.recording.mode.STREAM;
    T && (Wv(), Su.getState().removeToast("recording-failed")), E && Su.getState().removeToast("streaming-failed"), ke.setState({
      isRecording: !!T,
      isStreaming: !!E
    });
  }
);
ke.subscribe(
  (s) => s.isRecording,
  (s) => {
    var h, f;
    const r = (f = (h = ke.getState().recording.initiator) == null ? void 0 : h.getId) == null ? void 0 : f.call(h), c = je.getState().localParticipant.pid;
    s ? (r && r !== c ? Cr(
      st.ParticipantEventsListner.onParticipantStartedRecording,
      r
    ) : Je.publish({
      type: st.MediaEventsListener.onRecordingStarted
    }), Je.publish({
      type: Un.notification,
      payload: {
        type: "info",
        message: c2("notifications.recordingStarted")
      }
    })) : (r && r !== c ? Cr(
      st.ParticipantEventsListner.onParticipantStoppedRecording,
      r
    ) : Je.publish({
      type: st.MediaEventsListener.onRecordingStopped
    }), Je.publish({
      type: Un.notification,
      payload: {
        type: "info",
        message: c2("notifications.recordingStopped")
      }
    }));
  }
);
async function g2() {
  const { conference: s, isStreaming: r } = ke.getState();
  if (!r && s) {
    const { data: c, error: h } = await rr(
      s.startRecording({
        mode: Ge.constants.recording.mode.FILE,
        appData: JSON.stringify({
          startedAt: Date.now()
        })
      })
    );
  }
}
async function jU() {
  Wv();
  const { conference: s, recording: r } = ke.getState();
  if (!s || !r.sessionId)
    return;
  const { error: c } = await rr(
    s.stopRecording(r.sessionId)
  );
}
async function PU() {
  const { recording: s } = ke.getState();
  s.mode !== Ge.constants.recording.mode.STREAM && await jU();
}
async function GU() {
  ke.getState().isRecording ? await PU() : await g2();
}
ke.subscribe(
  (s) => s.isStreaming,
  (s) => {
    var h, f;
    const r = (f = (h = ke.getState().recording.initiator) == null ? void 0 : h.getId) == null ? void 0 : f.call(h), c = je.getState().localParticipant.pid;
    s ? (Y.getState().clearIdealTimeoutTimer(), r && r !== c ? Cr(
      st.ParticipantEventsListner.onParticipantStartedStreaming,
      r
    ) : Je.publish({
      type: st.MediaEventsListener.onStreamingStarted
    }), Je.publish({
      type: Un.notification,
      payload: {
        type: "info",
        message: c2("notifications.streamingStarted")
      }
    })) : (Y.getState().restartIdealTimeoutTimer(), r && r !== c ? Cr(
      st.ParticipantEventsListner.onParticipantStoppedStreaming,
      r
    ) : Je.publish({
      type: st.MediaEventsListener.onStreamingStopped
    }), Je.publish({
      type: Un.notification,
      payload: {
        type: "info",
        message: c2("notifications.streamingStopped")
      }
    }));
  }
);
async function jR(s, r) {
  const { conference: c, isRecording: h } = ke.getState();
  if (h)
    return;
  const f = r ? `${s.replace(/\/+$/, "")}/${r}` : s;
  if (c) {
    const { error: v } = await rr(
      c.startRecording({
        mode: Ge.constants.recording.mode.STREAM,
        streamId: f,
        appData: JSON.stringify({
          startedAt: Date.now()
        })
      })
    );
  }
}
async function YU() {
  const { recording: s } = ke.getState();
  s.mode === Ge.constants.recording.mode.STREAM && await jU();
}
const XU = () => {
  const s = ke.getState().conferenceStatus;
  return s === "joined" || s === "restored";
};
ke.subscribe(
  (s) => s.conferenceStatus,
  (s, r) => {
    s === "interrupted" && (r === "joined" || r === "restored") ? Je.publish({
      type: st.SessionStatusListener.onConnectionLost
    }) : r === "interrupted" && (s === "joined" || s === "restored") && Je.publish({
      type: st.SessionStatusListener.onConnectionRestored
    });
  }
);
ke.subscribe(
  (s) => s.conference,
  (s) => {
    if (JU(), s) {
      const r = je.getState().localParticipant;
      s.sendCommand(m6.userInfo, {
        value: JSON.stringify(r)
      });
    }
  }
);
const lE = {
  tracks: [],
  permissions: {
    audio: !1,
    video: !1,
    initialized: !1
  }
}, it = lc()(
  Fd(
    bu(lE, (s, r) => ({
      reset: () => s({
        ...lE,
        // Preserve permissions across resets - they're queried once at SDK init
        // and shouldn't be lost when joining/leaving sessions
        permissions: r().permissions
      }),
      addTrack: (c) => s((h) => {
        const f = c.isLocal(), v = (() => {
          var E;
          return c.getParticipantId() ? c.getParticipantId() : f ? (E = je.getState().localParticipant) == null ? void 0 : E.pid : c.getId();
        })(), R = {
          local: f,
          mediaType: qh(c),
          pid: v,
          videoType: c.getVideoType(),
          muted: c.isMuted() ? 1 : 0,
          streamingStatus: "active",
          originalTrack: c
        }, T = h.tracks.findIndex(
          (E) => E.pid === v && E.mediaType === R.mediaType && E.local === f && E.originalTrack === c
        );
        if (T !== -1) {
          const E = [...h.tracks];
          return E[T] = R, { tracks: E };
        }
        return {
          tracks: [R, ...h.tracks]
        };
      }),
      removeTrack: (c) => s((h) => ({
        tracks: h.tracks.filter(
          (f) => f.originalTrack !== c
        )
      })),
      updateTrack: (c, h) => s((f) => ({
        tracks: f.tracks.map(
          (v) => v.originalTrack === c ? {
            ...v,
            mediaType: v.mediaType ?? qh(c),
            videoType: v.videoType ?? c.getVideoType(),
            ...h
          } : v
        )
      })),
      updateLocalTrack: (c, h) => s((f) => {
        const v = f.tracks.find(
          (R) => R.local && R.mediaType === c
        );
        if (!v) {
          const R = je.getState().localParticipant;
          return {
            tracks: [
              ...f.tracks,
              {
                local: !0,
                mediaType: c,
                pid: R.pid,
                videoType: c === We.SCREENSHARE ? "desktop" : c === We.VIDEO ? "camera" : null,
                muted: h.muted ?? 0,
                streamingStatus: "active",
                ...h
              }
            ]
          };
        }
        return {
          tracks: f.tracks.map(
            (R) => R === v ? {
              ...R,
              ...h,
              mediaType: c,
              videoType: c === We.SCREENSHARE ? "desktop" : c === We.VIDEO ? "camera" : null
            } : R
          )
        };
      })
    }))
  )
), N6 = (s, r = We.VIDEO) => {
  const c = it((f) => f.tracks);
  return ne.useMemo(
    () => c.find((f) => f.pid === s && f.mediaType === r),
    [c, s, r]
  );
}, KU = (s, r = We.VIDEO) => it.getState().tracks.find((h) => h.pid === s && h.mediaType === r), V8 = (s = We.VIDEO) => {
  const r = it((c) => c.tracks);
  return ne.useMemo(
    () => r.find((c) => c.local && c.mediaType === s),
    [r, s]
  );
}, fn = (s = We.VIDEO) => it.getState().tracks.find((c) => c.local && c.mediaType === s), _8 = async () => {
  const s = it.getState().tracks.filter((h) => h.local), r = [];
  for (const { originalTrack: h } of s)
    h && h.disposed !== !0 && r.push(rr(H4(h)));
  const c = await Promise.all(r);
  for (const { error: h } of c)
    h && console.error("Error disposing track:", h);
}, qU = () => {
  const s = Hn();
  return s === "preparing" || s === "prepared" || s === "joining" ? !0 : s === "joined" && b8();
}, Hv = () => {
  it.getState().updateLocalTrack(We.AUDIO, {
    muted: 1
  });
}, PR = async () => {
  let s = fn(We.AUDIO);
  if (!(s != null && s.originalTrack) && qU()) {
    it.getState().updateLocalTrack(We.AUDIO, {
      muted: 0
    });
    return;
  }
  const r = it.getState().permissions, c = Y.getState().isMobileSDK();
  if (!r.audio && r.initialized && !c) {
    Je.publish({
      type: Un.notification,
      payload: {
        type: "error",
        message: "Permission denied for audio track. Please allow access to your device."
      }
    }), Je.publish({
      type: Un.queryPermission
    });
    return;
  }
  s != null && s.originalTrack || (await ic("audio"), s = fn(We.AUDIO)), s != null && s.originalTrack && it.getState().updateLocalTrack(We.AUDIO, {
    muted: 0
  });
}, $U = () => {
  var r;
  ((r = fn(We.AUDIO)) == null ? void 0 : r.muted) ? PR() : Hv();
}, v2 = (s = h6.USER) => {
  var c;
  const r = (((c = fn(We.VIDEO)) == null ? void 0 : c.muted) || 0) | s;
  it.getState().updateLocalTrack(We.VIDEO, {
    muted: r
  });
}, Zv = async (s = h6.USER) => {
  let r = fn(We.VIDEO);
  if (!(r != null && r.originalTrack) && qU()) {
    const v = ((r == null ? void 0 : r.muted) ?? 0) & ~s;
    it.getState().updateLocalTrack(We.VIDEO, {
      muted: v
    });
    return;
  }
  const c = it.getState().permissions, h = Y.getState().isMobileSDK();
  if (!c.video && c.initialized && !h) {
    Je.publish({
      type: Un.notification,
      payload: {
        type: "error",
        message: "Permission denied for video track. Please allow access to your device."
      }
    }), Je.publish({
      type: Un.queryPermission
    });
    return;
  }
  if (r != null && r.originalTrack || (await ic(We.VIDEO), r = fn(We.VIDEO)), !(r != null && r.originalTrack))
    return;
  const f = r.muted & ~s;
  it.getState().updateLocalTrack(We.VIDEO, {
    muted: f
  });
}, eT = () => {
  var r;
  ((r = fn(We.VIDEO)) == null ? void 0 : r.muted) ? Zv() : v2();
};
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.AUDIO && c.local)) == null ? void 0 : r.muted;
  },
  (s, r) => {
    var h;
    const c = (h = fn(We.AUDIO)) == null ? void 0 : h.originalTrack;
    s && c ? c.mute() : c && c.unmute(), typeof s == "number" && typeof r == "number" && Je.publish({
      type: s ? st.MediaEventsListener.onAudioMuted : st.MediaEventsListener.onAudioUnMuted
    });
  }
);
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.VIDEO && c.local)) == null ? void 0 : r.muted;
  },
  (s, r) => {
    var h;
    const c = (h = fn(We.VIDEO)) == null ? void 0 : h.originalTrack;
    s && c ? c.mute() : c && c.unmute(), typeof s == "number" && typeof r == "number" && Je.publish({
      type: s ? st.MediaEventsListener.onVideoPaused : st.MediaEventsListener.onVideoResumed
    });
  }
);
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.SCREENSHARE && c.local)) == null ? void 0 : r.muted;
  },
  (s) => {
    var c;
    const r = (c = fn(We.SCREENSHARE)) == null ? void 0 : c.originalTrack;
    s && r && r.mute();
  }
);
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.AUDIO && c.local)) == null ? void 0 : r.originalTrack;
  },
  (s) => {
    var r;
    s && (((r = fn(We.AUDIO)) == null ? void 0 : r.muted) ? s.mute() : s.unmute());
  }
);
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.VIDEO && c.local)) == null ? void 0 : r.originalTrack;
  },
  (s) => {
    var r;
    s && (((r = fn(We.VIDEO)) == null ? void 0 : r.muted) ? s.mute() : s.unmute());
  }
);
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.AUDIO && c.local)) == null ? void 0 : r.originalTrack;
  },
  (s, r) => {
    const c = ke.getState().conference;
    if (c && (r && s ? c.replaceTrack(r, s) : s ? c.addTrack(s) : r && c.replaceTrack(r, null)), s) {
      const h = s.getDeviceId();
      B4(
        Y,
        (f) => f.audioInputDevices.length > 0
      ).then(() => {
        const v = Y.getState().audioInputDevices.find((R) => R.deviceId === h);
        Uu(v, !0);
      }).catch(() => {
        Uu(void 0, !0);
      });
    }
  }
);
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.VIDEO && c.local)) == null ? void 0 : r.originalTrack;
  },
  (s, r) => {
    const c = ke.getState().conference;
    if (c && (r && s ? c.replaceTrack(r, s) : s ? c.addTrack(s) : r && c.replaceTrack(r, null)), s) {
      const h = s.getDeviceId(), f = Y.getState().videoInputDevices.find((v) => v.deviceId === h);
      am(f, !0);
    }
  }
);
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.SCREENSHARE && c.local)) == null ? void 0 : r.originalTrack;
  },
  (s, r) => {
    const c = ke.getState().conference;
    c && (r && s ? c.replaceTrack(r, s).then(() => {
      r.removeAllListeners(), r.dispose();
    }) : s && c.addTrack(s));
  }
);
it.subscribe(
  (s) => s.tracks.filter((r) => r.mediaType === We.SCREENSHARE && !r.muted).length,
  () => {
    const s = it.getState().tracks.filter((f) => f.mediaType === We.SCREENSHARE && !f.muted), r = je.getState().virtualParticipants.filter((f) => f.type === "screen-share"), c = JR(
      s,
      r,
      (f) => f.pid
    );
    JR(
      r,
      s,
      (f) => f.pid
    ).forEach((f) => {
      r9(f.pid);
    }), c.forEach((f) => {
      f.originalTrack && a9(f.originalTrack);
    });
  }
);
it.subscribe(
  (s) => s.permissions,
  (s, r) => {
    var h;
    const c = ke.getState().conferenceStatus;
    if (!(c !== "joined" && c !== "restored")) {
      if (s.audio === !1 && r.audio === !0) {
        Je.publish({
          type: Un.notification,
          payload: {
            type: "error",
            message: "Permission denied for audio track. Please allow access to your device."
          }
        }), Hv();
        const f = (h = fn(We.AUDIO)) == null ? void 0 : h.originalTrack;
        f && f.dispose().catch(() => {
        });
      }
      s.video === !1 && r.video === !0 && (Je.publish({
        type: Un.notification,
        payload: {
          type: "error",
          message: "Permission denied for video track. Please allow access to your device."
        }
      }), v2());
    }
  }
);
it.subscribe(
  (s) => s.permissions.audio || s.permissions.video,
  (s) => {
    s && TT();
  }
);
it.subscribe(
  (s) => s.tracks.filter((r) => r.mediaType === We.AUDIO && !r.local).map((r) => ({
    muted: r.muted,
    pid: r.pid
  })),
  (s, r) => {
    r.forEach((c) => {
      const h = s.find((f) => f.pid === c.pid);
      h && h.muted !== c.muted && Cr(
        h.muted ? st.ParticipantEventsListner.onParticipantAudioMuted : st.ParticipantEventsListner.onParticipantAudioUnmuted,
        h.pid
      );
    });
  },
  {
    equalityFn: p6
  }
);
it.subscribe(
  (s) => s.tracks.filter((r) => r.mediaType === We.VIDEO && !r.local).map((r) => ({
    muted: r.muted,
    pid: r.pid
  })),
  (s, r) => {
    r.forEach((c) => {
      const h = s.find((f) => f.pid === c.pid);
      h && h.muted !== c.muted && Cr(
        h.muted ? st.ParticipantEventsListner.onParticipantVideoPaused : st.ParticipantEventsListner.onParticipantVideoResumed,
        h.pid
      );
    });
  },
  {
    equalityFn: p6
  }
);
function mv(s) {
  if (f8(s), s.layout && yu(s.layout), typeof s.internalSettings == "string") {
    const r = VU(
      s.internalSettings
    );
    if (!(r != null && r.data))
      return;
    const c = /* @__PURE__ */ f2(
      DU,
      r.data
    );
    if (c.success) {
      const h = He.getState().displayName;
      je.getState().updateLocalParticipant({
        name: h || c.output.user.name,
        avatar: h ? void 0 : c.output.user.avatar,
        uid: c.output.user.uid
      }), He.setState({
        sessionId: c.output.sessionId
      }), Wn.setState({
        jwt: c.output.callToken,
        connectionConfig: c.output.settings.connectionConfig
      });
    } else
      console.error("Invalid internal setting data:", c.issues);
  }
  s.devSessionId && He.setState({
    sessionId: s.devSessionId
  }), s.initialCameraFacing && Y.setState({
    cameraFacing: s.initialCameraFacing === Dv.REAR ? Vd.ENVIRONMENT : Vd.USER
  }), s.displayName && je.getState().updateLocalParticipant({
    name: s.displayName,
    avatar: void 0
  }), typeof s.startAudioMuted == "boolean" && it.getState().updateLocalTrack(We.AUDIO, {
    muted: s.startAudioMuted ? 1 : 0
  }), typeof s.startVideoPaused == "boolean" && it.getState().updateLocalTrack(We.VIDEO, {
    muted: s.startVideoPaused ? h6.USER : 0
  }), typeof s.enableNoiseReduction == "boolean" && Y.setState({
    enableNoiseReduction: s.enableNoiseReduction
  }), s.captionLanguage && zn.setState({
    captionLanguage: s.captionLanguage
  });
}
const cE = {
  audioModeMenuVisible: !1,
  audioModes: [],
  audioInputDevices: [],
  audioOutputDevices: [],
  videoInputDevices: [],
  cameraFacing: Vd.USER,
  isPIPLayoutEnabled: !1,
  layout: Ai.TILE,
  sidebarLayoutSetProgrammatically: !1,
  mainAreaDimension: {
    height: 0,
    width: 0
  },
  tileDimensions: {
    tileHeight: 0,
    tileWidth: 0
  },
  callContainerDimension: {
    height: 0,
    width: 0
  },
  moreMenuVisible: !1,
  participantListVisible: !1,
  subscriptions: [],
  connectionRetryCount: 0,
  settingsDialogVisible: !1,
  settingsDialogTab: "audio",
  virtualBackgroundDialogVisible: !1,
  idleTimeoutModalVisible: !1,
  mirrorLocalVideo: !0,
  isDesktopSharingEnabled: !1,
  isBlurSupported: !1,
  desktopSharingFrameRate: 5,
  chatButtonUnreadCount: 0,
  enableNoiseReduction: !0,
  sdkPlatform: Q4.WEB,
  isMobileBrowser: !1,
  visibleParticipants: {
    startIndex: 0,
    endIndex: 0
  },
  sidebarVisibleParticipants: {
    startIndex: 0,
    endIndex: 0
  }
}, Y = lc()(
  Fd(
    D4(
      bu(cE, (s, r) => ({
        addSubscriptions: (c) => {
          Y.setState((h) => ({
            subscriptions: [...h.subscriptions, ...c]
          }));
        },
        reset: () => s((c) => ({
          ...cE,
          // Preserve persisted properties
          audioInputDevice: c.audioInputDevice,
          audioOutputDevice: c.audioOutputDevice,
          videoInputDevice: c.videoInputDevice,
          enableNoiseReduction: c.enableNoiseReduction,
          isMobileBrowser: c.isMobileBrowser
        })),
        toggleMoreMenuVisible: () => s((c) => ({
          moreMenuVisible: !c.moreMenuVisible
        })),
        toggleParticipantListVisible: () => s((c) => ({
          participantListVisible: !c.participantListVisible
        })),
        incrementConnectionRetryCount: () => s((c) => ({
          connectionRetryCount: c.connectionRetryCount + 1
        })),
        isMobileSDK: () => r().sdkPlatform !== "web",
        isMobile: () => {
          const c = r().sdkPlatform !== "web", h = r().isMobileBrowser;
          return c || h;
        },
        clearIdealTimeoutTimer: () => {
          const c = r().idealTimeoutTimer;
          c && (clearTimeout(c), s({
            idealTimeoutTimer: void 0,
            idleTimeoutModalVisible: !1
          }));
        },
        restartIdealTimeoutTimer: () => {
          if (Y.getState().clearIdealTimeoutTimer(), He.getState().iAmRecorder || je.getState().participants.length > 0 || !XU() || !T6() || ke.getState().isStreaming)
            return;
          const v = He.getState().idleTimeoutPeriodBeforePrompt, R = setTimeout(() => {
            s({
              idleTimeoutModalVisible: !0
            });
          }, v);
          s({ idealTimeoutTimer: R });
        }
      })),
      {
        name: "base-store",
        partialize: (s) => ({
          audioInputDevice: s.audioInputDevice,
          audioOutputDevice: s.audioOutputDevice,
          videoInputDevice: s.videoInputDevice,
          enableNoiseReduction: s.enableNoiseReduction
        })
      }
    )
  )
), tT = Y.getState().toggleParticipantListVisible, nT = () => Y.setState({ participantListVisible: !1 }), F8 = () => Y.setState({ participantListVisible: !0 }), M8 = () => Y.setState((s) => ({
  participantListVisible: !s.participantListVisible
}));
Y.getState().toggleMoreMenuVisible;
const yu = (s, r = !1) => {
  s !== Ai.SIDEBAR && je.setState({ pinnedParticipant: void 0 }), Y.setState({ layout: s, sidebarLayoutSetProgrammatically: r });
}, zv = (s = "audio") => {
  Y.setState({
    settingsDialogVisible: !0,
    settingsDialogTab: s
  });
}, k8 = () => {
  Y.setState({ settingsDialogVisible: !1 });
}, dE = () => {
  Y.setState((s) => ({
    settingsDialogVisible: !s.settingsDialogVisible
  }));
}, iT = () => {
  Y.setState({
    virtualBackgroundDialogVisible: !0,
    participantListVisible: !1
  });
}, r2 = () => {
  Y.setState({ virtualBackgroundDialogVisible: !1 });
}, D8 = () => {
  Y.setState((s) => ({
    mirrorLocalVideo: !s.mirrorLocalVideo
  }));
}, Q8 = () => {
  Y.setState((s) => ({
    enableNoiseReduction: !s.enableNoiseReduction
  }));
}, x8 = (s) => {
  Y.setState({ chatButtonUnreadCount: s });
}, aT = () => Y.getState().layout;
function Z8() {
  const s = [], r = Y.subscribe(
    (N) => N.audioModes,
    (N) => {
      if (Je.publish({
        payload: N,
        type: hu.MediaEventsListener.onAudioModesChanged
      }), N.length > 0) {
        const _ = N.find((V) => V.selected) ?? N[0];
        Y.setState({
          selectedAudioModeType: _.type
        });
      }
    }
  );
  s.push(r);
  const c = Y.subscribe(
    (N) => N.selectedAudioModeType,
    (N) => {
      N && Je.publish({
        payload: N,
        type: hu.MediaEventsListener.onAudioModeChanged
      });
    }
  );
  s.push(c);
  const h = Y.subscribe(
    (N) => N.layout,
    (N) => {
      Je.publish({
        payload: N,
        type: st.CallLayoutListener.onCallLayoutChanged
      });
    }
  );
  s.push(h);
  const f = Y.subscribe(
    (N) => N.participantListVisible,
    (N) => {
      N ? Je.publish({
        type: hu.CallLayoutListener.onParticipantListVisible
      }) : Je.publish({
        type: hu.CallLayoutListener.onParticipantListHidden
      });
    }
  );
  s.push(f);
  const v = Y.subscribe(
    (N) => N.isPIPLayoutEnabled,
    (N) => {
      N ? Je.publish({
        type: hu.CallLayoutListener.onPictureInPictureLayoutEnabled
      }) : Je.publish({
        type: hu.CallLayoutListener.onPictureInPictureLayoutDisabled
      });
    }
  );
  s.push(v);
  const R = Y.subscribe(
    (N) => N.cameraFacing,
    (N) => {
      var V;
      Je.publish({
        payload: N === Vd.USER ? Dv.FRONT : Dv.REAR,
        type: hu.MediaEventsListener.onCameraFacingChanged
      });
      const _ = (V = fn(We.VIDEO)) == null ? void 0 : V.originalTrack;
      _ && _.getCameraFacingMode() !== N && (Y.getState().isMobileBrowser ? wU(null, N) : _._switchCamera());
    }
  );
  s.push(R);
  const T = Y.subscribe(
    (N) => N.audioInputDevices,
    (N) => {
      if (N.length > 0) {
        const _ = Y.getState().audioInputDevice;
        _ ? N.some(
          (B) => B.deviceId === _.deviceId && B.label === _.label
        ) || Uu(Ph(N)) : Uu(
          Ph(N),
          !0
        );
      }
    }
  );
  s.push(T);
  const E = Y.subscribe(
    (N) => N.audioOutputDevices,
    (N) => {
      if (N.length > 0) {
        const _ = Y.getState().audioOutputDevice;
        _ ? N.some(
          (B) => B.deviceId === _.deviceId && B.label === _.label
        ) || Y.setState({
          audioOutputDevice: Ph(N)
        }) : Y.setState({
          audioOutputDevice: Ph(N)
        });
      }
    }
  );
  s.push(E);
  const C = Y.subscribe(
    (N) => N.videoInputDevices,
    (N) => {
      if (N.length > 0) {
        const _ = Y.getState().videoInputDevice;
        _ ? N.some(
          (B) => B.deviceId === _.deviceId && B.label === _.label
        ) || am(Ph(N)) : am(
          Ph(N),
          !0
        );
      }
    }
  );
  s.push(C), Y.subscribe(
    (N) => N.previewVideoTrack,
    (N, _) => {
      _ && _.disposed !== !0 && _.dispose();
    }
  ), Y.getState().addSubscriptions(s);
}
Z8();
const uE = 1e4, O8 = 3e3, w8 = 500, bR = {
  connection: void 0,
  connectionStatus: "initial",
  error: void 0,
  timeEstablished: void 0
}, Wn = lc()(
  Fd(
    bu(bR, (s) => ({
      connectionEstablished: (r) => s({
        connection: r,
        connectionStatus: "connected",
        error: void 0,
        timeEstablished: Date.now()
      }),
      connectionFailed: (r) => s({
        connectionStatus: "error",
        error: r,
        timeEstablished: void 0
      }),
      connectionWillConnect: (r) => {
        typeof (window == null ? void 0 : window.APP) < "u" && (window.APP.connection = r), He.getState().iAmRecorder && r.addFeature("http://jitsi.org/protocol/jibri"), s({
          connection: r,
          connectionStatus: "connecting",
          error: void 0,
          timeEstablished: void 0
        });
      },
      disconnect: async (r = {}) => {
        const c = Wn.getState().connection, h = Wn.getState().connectionStatus;
        c && h !== "disconnecting" && (s({
          connectionStatus: "disconnecting"
        }), Je.publish({
          type: Un.connectionWillClose
        }), Je.stopEmitting(), await rr(
          c.disconnect(),
          B8(h)
        ), r.silent || Je.publish(
          {
            type: st.SessionStatusListener.onConnectionClosed
          },
          !0
        ), s(bR));
      },
      reset: () => s(bR)
    }))
  )
);
function B8(s) {
  if (s === "connecting")
    return O8;
  if (s === "error")
    return w8;
}
function A8() {
  const { connectionStatus: s } = Wn.getState();
  return s === "connected" ? Promise.resolve() : new Promise((r, c) => {
    const h = setTimeout(() => {
      f(), c(
        new Error(
          `Connection timed out after ${uE / 1e3} seconds`
        )
      );
    }, uE), f = Wn.subscribe(
      (v) => v.connectionStatus,
      (v) => {
        v === "connected" ? (clearTimeout(h), f(), r()) : v === "error" && (clearTimeout(h), f(), c(Wn.getState().error));
      }
    );
  });
}
const I8 = "jitsi_meet_transcribe", hE = {
  transcriptionsMessages: /* @__PURE__ */ new Map(),
  showLiveCaption: !1,
  isTranscribing: !1,
  transcriberJoined: !1,
  captionLanguage: Qv[0].code
}, zn = lc()(
  Fd((s) => ({
    ...hE,
    setTranscriptionMessage: (r, c) => {
      s((h) => {
        const f = new Map(h.transcriptionsMessages);
        if (f.set(r, c), f.size > 10) {
          const v = f.keys().next().value;
          f.delete(v);
        }
        return { transcriptionsMessages: f };
      });
    },
    clearTranscriptionMessages: () => {
      s({ transcriptionsMessages: /* @__PURE__ */ new Map() });
    },
    toggleShowLiveCaption: () => {
      s((r) => ({ showLiveCaption: !r.showLiveCaption }));
    },
    reset: () => {
      s({ ...hE, transcriptionsMessages: /* @__PURE__ */ new Map() });
    }
  }))
);
function L8() {
  const s = zn(
    (r) => r.transcriptionsMessages
  );
  return ne.useMemo(
    () => Array.from(s.values()),
    [s]
  );
}
function b6() {
  const s = zn(
    (c) => c.transcriberJoined
  ), r = zn((c) => c.showLiveCaption);
  return s && r;
}
function rT() {
  zn.getState().toggleShowLiveCaption();
}
const J8 = () => zn((s) => s.isTranscribing);
zn.subscribe(
  (s) => s.isTranscribing,
  (s) => {
    const r = ke.getState().conference, c = zn.getState().captionLanguage;
    r == null || r.setLocalParticipantProperty(
      "transcription_language",
      c
    ), r == null || r.setLocalParticipantProperty(
      "requestingTranscription",
      s
    );
  }
);
zn.subscribe(
  (s) => s.captionLanguage,
  (s) => {
    const r = ke.getState().conference;
    r == null || r.setLocalParticipantProperty(
      "transcription_language",
      s
    );
  }
);
async function C6() {
  zn.setState({ isTranscribing: !0 });
  const s = ke.getState().conference, r = zn.getState().transcriberJoined;
  if (s && !r)
    try {
      await s.dial(I8);
    } catch (c) {
      console.error("Error dialing transcriber", c), zn.setState({ isTranscribing: !1 });
    }
}
async function oT() {
  zn.setState({ isTranscribing: !1 }), zn.getState().clearTranscriptionMessages();
}
async function W8() {
  zn.getState().isTranscribing ? await oT() : await C6();
}
const H8 = () => {
  const s = He(
    (c) => c.hideToggleAudioButton
  ), r = He(
    (c) => c.enableCompanionMode
  );
  return s || r;
}, z8 = () => {
  const s = He(
    (c) => c.hideToggleVideoButton
  ), r = He((c) => c.sessionType);
  return s || r !== im.VIDEO;
}, V6 = () => {
  const s = ke((r) => r.conferenceStatus);
  return s === "joined" || s === "restored";
}, sT = () => {
  const s = He(
    (v) => v.hideScreenSharingButton
  ), r = Y((v) => v.sdkPlatform === "android"), c = Y(
    (v) => v.isDesktopSharingEnabled
  ), h = V6(), f = Y.getState().isMobileSDK();
  return s || f || !h || (r ? !1 : !c);
}, j8 = () => He((r) => r.hideChatButton), lT = () => {
  const s = He(
    (c) => c.hideClosedCaptionButton
  ), r = zn(
    (c) => c.transcriberJoined
  );
  return s || !r;
}, P8 = () => {
  const s = He(
    (h) => h.hideTranscriptionButton
  ), r = zn(
    (h) => h.transcriberJoined
  ), c = zn((h) => h.isTranscribing);
  return s || r && !c;
}, lm = (s) => je(
  (r) => r.localParticipant
), G8 = () => {
  const s = V8(We.SCREENSHARE);
  return (s == null ? void 0 : s.originalTrack) && !s.muted;
}, Vu = (s, r) => {
  const c = lm(), h = r ?? c.pid, f = N6(h, s);
  return s === We.VIDEO && (f == null ? void 0 : f.streamingStatus) !== "active" ? !0 : f ? !!f.muted : !(h !== c.pid && s === We.AUDIO);
}, cT = () => {
  const s = je(
    (v) => v.pinnedParticipant
  ), r = je((v) => v.participants), c = je(
    (v) => v.virtualParticipants
  ), h = je((v) => v.dominantSpeakers), f = lm();
  return U6({
    pinnedParticipant: s,
    participants: r,
    virtualParticipants: c,
    dominantSpeakers: h,
    localParticipant: f
  });
}, Ov = () => {
  const s = je.getState();
  return U6({
    pinnedParticipant: s.pinnedParticipant,
    participants: s.participants,
    virtualParticipants: s.virtualParticipants,
    dominantSpeakers: s.dominantSpeakers,
    localParticipant: s.localParticipant
  });
}, Y8 = () => {
  const s = Wn((c) => c.connectionStatus), r = ke((c) => c.conferenceStatus);
  return s === "connected" && r === "interrupted";
}, X8 = () => {
  const s = He(
    (f) => f.hideRecordingButton
  ), r = ke((f) => f.isStreaming), c = V6(), h = lm();
  return r || s || !c || h.role !== "moderator";
}, K8 = () => {
  const s = He(
    (f) => f.hideStreamingButton
  ), r = ke((f) => f.isRecording), c = V6(), h = lm();
  return r || s || !c || h.role !== "moderator";
}, q8 = () => {
  const s = He(
    (h) => h.hideVirtualBackgroundButton
  ), r = fn(We.VIDEO), c = Y((h) => h.isBlurSupported);
  return s || !(r != null && r.originalTrack) || !c;
}, jv = () => Y((r) => r.layout), $8 = () => {
  const s = He(
    (f) => f.enableParticipantContextMenu
  ), r = Y((f) => f.isPIPLayoutEnabled);
  return jv() === Ai.SPOTLIGHT || r ? !1 : s;
}, Pv = (s, r = "human") => {
  const c = lm(), h = ke(
    (f) => f.raiseHandMap.get(s ?? c.pid)
  );
  return r === "human" ? h : void 0;
}, dT = (s, r) => {
  const c = je(
    (h) => h.pinnedParticipant
  );
  return !!(c && c.pid === s && c.type === r);
}, eN = () => {
  const s = sm(), r = ke((h) => h.raiseHandMap);
  return s.sort((h, f) => {
    const v = r.get(h.pid), R = r.get(f.pid);
    return v && !R ? -1 : !v && R ? 1 : h.name.localeCompare(f.name);
  });
}, tN = () => {
  const s = ke((c) => c.conferenceError), r = Wn((c) => c.error);
  if (s)
    return s;
  if (r)
    return r.message || r.name;
}, nN = () => {
  const s = Y((c) => c.isMobileBrowser), r = fn(We.VIDEO);
  return s && (r == null ? void 0 : r.originalTrack);
}, iN = () => {
  const s = it((h) => h.permissions.audio), r = Y((h) => h.audioInputDevices);
  return s && r.length > 0;
}, aN = () => {
  const s = it((h) => h.permissions.video), r = Y((h) => h.videoInputDevices);
  return s && r.length > 0;
}, _6 = () => {
  const s = Y((c) => c.mirrorLocalVideo);
  return Y((c) => c.cameraFacing) === "user" && s;
};
function wv() {
  Y.getState().reset(), ke.getState().reset(), He.getState().reset(), Wn.getState().reset(), je.getState().reset(), Su.getState().reset(), it.getState().reset(), zn.getState().reset();
}
const uT = () => {
  Y.setState((s) => ({
    cameraFacing: s.cameraFacing === Vd.USER ? Vd.ENVIRONMENT : Vd.USER
  }));
};
function rN(s) {
  return s <= yd.LOW ? yd.LOW : s <= yd.STANDARD ? yd.STANDARD : yd.HIGH;
}
function mE(s) {
  return s === "desktop" ? yd.FULL_HD : yd.HIGH;
}
let $f = !1;
function hT() {
  var c, h;
  if (!He.getState().enableIOSPictureInPicture)
    return;
  const s = Ov(), r = KU(
    s.pid,
    R8(s)
  );
  if (!(!r || r.local))
    return (h = (c = r.originalTrack) == null ? void 0 : c.getSourceName) == null ? void 0 : h.call(c);
}
let pE;
function mT() {
  var h, f;
  if (!Y.getState().isMobileSDK())
    return;
  const s = aT();
  if (s !== Ai.SIDEBAR && s !== Ai.SPOTLIGHT)
    return;
  const r = Ov();
  if (r.type !== "screen-share")
    return;
  const c = KU(
    r.pid,
    We.SCREENSHARE
  );
  if (!(!c || c.local))
    return (f = (h = c.originalTrack) == null ? void 0 : h.getSourceName) == null ? void 0 : f.call(h);
}
function oN() {
  var E, C, N;
  const { sessionType: s, unstable_headlessMode: r } = He.getState();
  if (r && s === im.VOICE) {
    (E = ke.getState().conference) == null || E.setReceiverConstraints({
      lastN: 0
    });
    return;
  }
  const { appState: c, isPIPLayoutEnabled: h } = Y.getState();
  if (c === "background" && !h) {
    const _ = ke.getState().conference;
    if (_) {
      const V = He.getState().enableIOSPictureInPicture, B = hT();
      _.setReceiverConstraints({
        lastN: V ? 1 : 0,
        onStageSources: B ? [B] : []
      }), $f = !0;
    }
    return;
  }
  if (Y.getState().isMobileSDK()) {
    const _ = mT(), V = ke.getState().conference;
    V && ($f || _ !== pE) && (V.setReceiverConstraints({
      lastN: -1,
      onStageSources: _ ? [_] : []
    }), $f = !1, pE = _);
    return;
  }
  const v = {
    constraints: {},
    defaultConstraints: { maxHeight: yd.NONE },
    lastN: -1,
    onStageSources: [],
    selectedSources: []
  }, R = aT();
  if (R === "SPOTLIGHT") {
    const _ = (C = Ov().sources) == null ? void 0 : C.get("video");
    _ && _.forEach((V, B) => {
      v.constraints[B] = {
        maxHeight: mE(V == null ? void 0 : V.videoType)
      }, v.onStageSources.push(B);
    });
  } else if (R === "TILE") {
    const _ = rN(
      Y.getState().tileDimensions.tileHeight
    ), V = Y.getState().visibleParticipants;
    WR().slice(
      V.startIndex,
      V.endIndex + 1
    ).forEach((ce) => {
      var ge;
      const oe = ce.isLocal, be = (ge = ce.sources) == null ? void 0 : ge.get("video");
      !oe && be && Array.from(be.keys()).forEach((te) => {
        v.constraints[te] = {
          maxHeight: _
        };
      });
    });
  } else if (R === "SIDEBAR") {
    const { startIndex: _, endIndex: V } = Y.getState().sidebarVisibleParticipants;
    WR().slice(
      _,
      V
    ).forEach((ge) => {
      var _e;
      const te = (_e = ge.sources) == null ? void 0 : _e.get("video");
      te && Array.from(te.keys()).forEach((Ue) => {
        v.constraints[Ue] = {
          maxHeight: 180
        };
      });
    });
    const be = (N = Ov().sources) == null ? void 0 : N.get("video");
    be && be.forEach((ge, te) => {
      v.constraints[te] = {
        maxHeight: mE(ge == null ? void 0 : ge.videoType)
      }, v.onStageSources.push(te);
    });
  }
  const T = ke.getState().conference;
  T && (Object.keys(v.constraints).length > 0 || // Even with no visible video sources, a pending background lastN: 0
  // must be undone (constraints.lastN is -1 here).
  $f) && (T.setReceiverConstraints(v), $f = !1);
}
const oc = kU(
  oN,
  200
);
Y.subscribe(
  (s) => s.visibleParticipants,
  () => {
    oc();
  }
);
Y.subscribe(
  (s) => s.sidebarVisibleParticipants,
  () => {
    oc();
  }
);
Y.subscribe(
  (s) => s.layout,
  () => {
    oc();
  }
);
Y.subscribe(
  (s) => s.appState,
  () => {
    oc();
  }
);
Y.subscribe(
  (s) => s.isPIPLayoutEnabled,
  () => {
    oc();
  }
);
it.subscribe(
  () => Y.getState().appState === "background" ? hT() : mT(),
  () => {
    oc();
  }
);
je.subscribe(
  // Keyed on ruid, not pid: a screen share is a virtual participant that
  // reuses the sharer's pid, so pid alone misses camera <-> screen share
  // switches — which do change the source being rendered.
  (s) => U6(s).ruid,
  () => {
    const { appState: s, layout: r } = Y.getState();
    (s === "background" || r === "SPOTLIGHT" || r === "SIDEBAR") && oc();
  }
);
const sN = 2e3;
let bv = null;
function pT() {
  var c, h, f;
  const s = ke.getState().conference;
  if (!((c = s == null ? void 0 : s.isP2PActive) != null && c.call(s)))
    return !1;
  const r = s.jvbJingleSession;
  return !r || s.isJvbConnectionInterrupted ? !1 : ((f = (h = r.peerconnection) == null ? void 0 : h.getConnectionState) == null ? void 0 : f.call(h)) === "connected";
}
function lN(s) {
  nc(), bv = setInterval(() => {
    pT() || (nc(), s());
  }, sN);
}
function nc() {
  bv && (clearInterval(bv), bv = null);
}
const Ys = /* @__PURE__ */ new Map(), Bv = /* @__PURE__ */ new Map();
function cN(s, r, c) {
  const h = Ys.get(s);
  Ys.set(s, {
    ...h,
    participant: r,
    ...c ? { userInfo: c } : {}
  });
}
function dN(s, r) {
  Bv.set(s, r);
}
function fE(s) {
  const r = Bv.get(s);
  return Bv.delete(s), r;
}
function fT(s) {
  var h, f, v;
  const r = Ys.get(s);
  if (!r || r.connectedAnnounced || !((h = r.userInfo) != null && h.uid))
    return;
  const c = /* @__PURE__ */ f2(g6, {
    pid: s,
    name: ((v = (f = r.participant) == null ? void 0 : f.getDisplayName) == null ? void 0 : v.call(f)) ?? "Unknown",
    uid: r.userInfo.uid,
    avatar: r.userInfo.avatar
  });
  c.success && (r.connectedAnnounced = !0, Je.publish(
    {
      type: st.ParticipantEventsListner.onParticipantConnected,
      payload: c.output
    },
    // The bus is gated while our own session is only prepared; force-emit
    // like onConnected.
    !0
  ));
}
function uN(s) {
  return Ys.has(s);
}
function GR(s, r) {
  const c = Ys.get(s);
  return c ? (Ys.set(s, { ...c, ...r }), !0) : !1;
}
function hN(s) {
  const r = Ys.get(s);
  return Ys.delete(s), r;
}
function mN(s) {
  return Ys.delete(s);
}
function pN() {
  Ys.clear(), Bv.clear();
}
const fN = 1e4, gN = 4e3, gT = 4e3;
let o2 = null, d2 = !1;
function Gv(s) {
  ke.setState((r) => {
    const c = new Map(r.remoteStatsTimestamps);
    return s(c), { remoteStatsTimestamps: c };
  });
}
function vN(s) {
  Gv(
    (r) => r.set(s, Date.now() + gT)
  );
}
function SN(s) {
  Gv((r) => r.delete(s));
}
function RN() {
  const s = Date.now() + gT;
  Gv((r) => {
    for (const c of r.keys())
      r.set(c, s);
  });
}
function vT() {
  const s = ke.getState().conferenceStatus;
  return s === "joined" || s === "restored";
}
function ST() {
  if (!He.getState().isPeerCall)
    return !1;
  const s = je.getState().participants;
  if (s.length === 0)
    return !1;
  const r = ke.getState().remoteStatsTimestamps, c = Date.now();
  return s.some((h) => {
    const f = r.get(h.pid) ?? 0;
    return c - f >= fN;
  });
}
function EN() {
  d2 || !vT() || ST() && (d2 = !0, Je.publish({
    type: st.SessionStatusListener.onRemoteConnectionLost
  }));
}
function UN(s) {
  Gv((r) => r.set(s, Date.now())), !(!d2 || !vT()) && (ST() || (d2 = !1, Je.publish({
    type: st.SessionStatusListener.onRemoteConnectionRestored
  })));
}
function TN() {
  !He.getState().isPeerCall || o2 || (o2 = setInterval(
    EN,
    gN
  ));
}
function pv() {
  o2 && (clearInterval(o2), o2 = null), d2 = !1;
}
const yN = 0.2, NN = "Transcriber", bN = "http://jitsi.org/protocol/transcriber";
async function gE(s) {
  return s.getDisplayName() !== NN ? !1 : (await s.getFeatures()).has(bN);
}
let pu = !1;
function vE() {
  pu = !1, ke.setState({
    conferenceStatus: "interrupted"
  });
}
function SE(s, r) {
  const c = s.getId(), h = s.getDisplayName();
  He.getState().isPeerCall || Je.publish({
    type: Un.notification,
    payload: {
      type: "info",
      message: `${h} has joined the conference`
    }
  }), je.getState().addParticipant({
    name: h ?? "Unknown",
    pid: c,
    ruid: `${c}-human`,
    role: (r == null ? void 0 : r.role) ?? s.getRole(),
    isLocal: !1,
    sources: s.getSources(),
    type: "human",
    // Buffered user-info (uid/avatar) makes the uid subscription fire
    // onParticipantJoined exactly once, at promotion.
    ...(r == null ? void 0 : r.userInfo) ?? {}
  }), r != null && r.raisedHand && ke.getState().raiseHand(c, r.raisedHand), vN(c), TN();
}
class CN {
  onConferenceJoined() {
    const r = Hn();
    r === "idle" || r === "left" || (ke.setState({
      conferenceJoined: !0,
      conferenceStatus: "joined",
      conferenceJoinedAt: Date.now()
    }), jN(), He.getState().autoStartTranscription && setTimeout(() => {
      C6();
    }, 100));
  }
  async onConferenceLeft() {
    pu = !1, nc(), pv(), ke.setState({
      conferenceJoined: !1,
      conferenceStatus: "left"
    }), Je.publish({
      type: st.SessionStatusListener.onSessionLeft
    }), await qN();
  }
  onKicked() {
    pu = !1, nc(), pv(), $i({ forceLeave: !0 });
  }
  onTrackAdded(r) {
    r.isLocal() || Q6(r);
  }
  async onUserJoined(r, c) {
    var v;
    if (await gE(c)) {
      zn.setState({
        transcriberJoined: !0
      });
      return;
    }
    if (c.isHidden())
      return;
    await Promise.resolve();
    const h = c.getId(), f = fE(h);
    if (((v = c.getProperty) == null ? void 0 : v.call(c, "joinState")) === "prepared") {
      cN(h, c, f), fT(h);
      return;
    }
    SE(
      c,
      f ? { userInfo: f } : void 0
    );
  }
  async onUserLeft(r, c) {
    if (await gE(c)) {
      zn.setState({
        transcriberJoined: !1
      });
      return;
    }
    if (c.isHidden())
      return;
    const h = c.getId();
    fE(h), !mN(h) && (He.getState().isPeerCall || Je.publish({
      type: Un.notification,
      payload: {
        type: "info",
        message: `${c.getDisplayName()} has left the conference`
      }
    }), je.getState().removeParticipant(h), SN(h), He.getState().isPeerCall && je.getState().participants.length === 0 && (pv(), $i()));
  }
  onTrackRemoved(r) {
    if (r.isLocal()) {
      const c = qh(r), h = fn(c);
      (h == null ? void 0 : h.originalTrack) === r && it.getState().updateLocalTrack(c, {
        originalTrack: void 0
      });
    } else
      it.getState().removeTrack(r);
    r.removeAllListeners(Ge.events.track.TRACK_MUTE_CHANGED), r.removeAllListeners(Ge.events.track.TRACK_VIDEOTYPE_CHANGED), r.removeAllListeners(Ge.events.track.NO_DATA_FROM_SOURCE), r.removeAllListeners(
      Ge.events.track.TRACK_STREAMING_STATUS_CHANGED
    );
  }
  onConferenceJoinInProgress() {
  }
  onConferenceFailed(r, c, h) {
    if (nc(), pv(), PN(r, h == null ? void 0 : h.toString()), r === Ge.errors.conference.CONFERENCE_DESTROYED) {
      $i({ forceLeave: !0 });
      return;
    }
    console.error("Conference failed:", r, c, h), ke.setState({
      conferenceStatus: "error",
      conferenceJoined: !1,
      conferenceError: (h == null ? void 0 : h.toString()) || "Unknown error"
    });
  }
  onRecorderStateChanged(r) {
    if (r) {
      const c = r.getID(), h = r.getError(), f = r.getMode(), v = r.getStatus();
      if (h === "unexpected-request")
        return;
      if (c) {
        const R = r.getInitiator();
        if (ke.setState({
          recording: { status: v, mode: f, error: h, sessionId: c, initiator: R }
        }), R) {
          const T = typeof R == "string" ? R : R.getId(), E = ke.getState().conference, C = je.getState().localParticipant;
          if (C.pid !== T)
            return;
          E.sendCommandOnce(
            v === "off" ? "stopScreenRecording" : "START_SCREEN_RECORDING",
            {
              attributes: {
                recordId: c,
                ...C,
                id: T
              }
            }
          );
        }
      } else h && ke.setState({
        recording: {
          status: v,
          mode: f,
          error: h
        }
      });
    }
  }
  onConnectionEstablished() {
    pu = !1, nc(), RN(), ke.setState({
      conferenceStatus: "joined"
    }), setTimeout(oc, 500);
  }
  onConnectionInterrupted() {
    if (pT()) {
      lN(vE);
      return;
    }
    nc(), vE();
  }
  onConnectionRestored() {
    if (nc(), ke.getState().conferenceStatus !== "interrupted") {
      ke.setState({
        conferenceStatus: "restored"
      });
      return;
    }
    if (He.getState().isPeerCall && je.getState().participants.length === 1) {
      pu = !0;
      return;
    }
    ke.setState({
      conferenceStatus: "restored"
    });
  }
  onP2PStatus(r, c) {
    nc(), ke.setState({
      p2p: c
    });
  }
  onTrackMuteChanged(r, c) {
    if (r.isLocal() && c) {
      it.getState().updateLocalTrack(qh(r), {
        muted: r.isMuted() ? 1 : 0
      });
      const h = c.getDisplayName();
      h && Je.publish({
        type: Un.notification,
        payload: {
          type: "info",
          message: `${h} has muted you.`
        }
      });
    }
  }
  onParticipantSourceUpdated(r) {
    oc();
  }
  onConferenceCreatedTimestamp(r) {
    ke.setState({
      conferenceStartedAt: r
    });
  }
  onDominantSpeakerChanged(r, c, h) {
    je.setState({
      dominantSpeakers: [r, ...c ?? []]
    }), Cr(
      st.ParticipantEventsListner.onDominantSpeakerChanged,
      r
    );
    const f = je.getState().localParticipant;
    r === f.pid && xv();
  }
  onLocalStatsUpdated(r) {
    const c = je.getState().localParticipant;
    r.connectionQuality && ke.setState((h) => {
      const f = new Map(h.connectionQuality);
      return f.set(c.pid, r.connectionQuality), { connectionQuality: f };
    });
  }
  onRemoteStatsUpdated(r, c) {
    pu && (pu = !1, ke.setState({
      conferenceStatus: "restored"
    })), UN(r), c.connectionQuality && ke.setState((h) => {
      const f = new Map(h.connectionQuality);
      return f.set(r, c.connectionQuality), { connectionQuality: f };
    });
  }
  onParticipantPropertyChanged(r, c, h, f) {
    const v = r.getId();
    if (v) {
      if (c === "joinState") {
        f === "joined" && uN(v) && SE(r, hN(v));
        return;
      }
      if (c === "sessionStartedAt") {
        C8(f);
        return;
      }
      if (c === "raisedHand") {
        const R = f ? parseInt(f, 10) : 0;
        if (GR(v, { raisedHand: R }))
          return;
        R ? ke.getState().raiseHand(v, R) : ke.getState().lowerHand(v);
      }
    }
  }
  onUserRoleChanged(r, c) {
    if (typeof r == "string" && (c === yv.MODERATOR || c === yv.NONE)) {
      if (GR(r, { role: c }))
        return;
      je.getState().updateParticipant(r, {
        role: c
      });
      const h = je.getState().localParticipant.pid;
      if (c === yv.MODERATOR && r === h && He.getState().autoStartRecording) {
        if (!T6()) {
          ke.setState({ pendingAutoStartRecording: !0 });
          return;
        }
        setTimeout(() => {
          g2();
        }, 100);
      }
    }
  }
  onTrackUnmuteRejected(r) {
    if (!r.isLocal())
      return;
    const c = qh(r);
    r.dispose().catch(() => {
    }), it.getState().updateLocalTrack(c, {
      originalTrack: void 0,
      muted: 1
    }), Je.publish({
      type: Un.notification,
      payload: {
        type: "info",
        message: `Your ${c} unmute was rejected.`
      }
    });
  }
  onTalkWhileMuted() {
  }
  onEndpointMessageReceived(r, c) {
    var h;
    if ((c == null ? void 0 : c.type) === "transcription-result" && Array.isArray(c == null ? void 0 : c.transcript) && c.transcript.length > 0) {
      const f = c.transcript.map((R) => (R == null ? void 0 : R.text) ?? "").join(" ").trim(), v = c.message_id;
      if (f && v) {
        const R = je.getState().getParticipantById((h = c.participant) == null ? void 0 : h.id), T = {
          ...c,
          participant: {
            ...c.participant,
            avatar_url: R == null ? void 0 : R.avatar
          }
        };
        zn.getState().setTranscriptionMessage(v, T);
      }
    }
  }
  onConferenceError(r) {
    console.error("Conference error:", r), r instanceof Error ? ke.setState({
      conferenceStatus: "error",
      conferenceJoined: !1,
      conferenceError: r.message
    }) : ke.setState({
      conferenceStatus: "error",
      conferenceJoined: !1,
      conferenceError: r.toString()
    });
  }
  onTrackAudioLevelChanged(r, c) {
    const h = je.getState().localParticipant;
    if (r !== h.pid)
      return;
    const f = fn(We.AUDIO);
    if (f != null && f.muted)
      return;
    ke.getState().raiseHandMap.has(h.pid) && c > yN && xv();
  }
}
const Fn = new CN(), VN = /* @__PURE__ */ ri({
  name: /* @__PURE__ */ $t(),
  pid: /* @__PURE__ */ $t(),
  ruid: /* @__PURE__ */ $t(),
  role: /* @__PURE__ */ TU(Object.values(yv)),
  uid: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
  avatar: /* @__PURE__ */ Ke(/* @__PURE__ */ $t()),
  isLocal: /* @__PURE__ */ Ea(),
  sources: /* @__PURE__ */ Ke(
    /* @__PURE__ */ IR(
      /* @__PURE__ */ NU([/* @__PURE__ */ Tv("video"), /* @__PURE__ */ Tv("audio")]),
      /* @__PURE__ */ IR(/* @__PURE__ */ $t(), /* @__PURE__ */ UU())
    )
  ),
  type: /* @__PURE__ */ Tv("human")
}), _N = /* @__PURE__ */ U4(VN, [
  "avatar",
  "uid"
]), RT = 4e3;
function ET(s) {
  Ge.init(s), Ge.setLogLevel(Ge.logLevels.ERROR);
}
const FN = { min: 5, max: 30 };
function MN(s) {
  s.on(
    Ge.events.conference.USER_JOINED,
    Fn.onUserJoined
  ), s.on(
    Ge.events.conference.USER_LEFT,
    Fn.onUserLeft
  ), s.on(
    Ge.events.conference.TRACK_ADDED,
    Fn.onTrackAdded
  ), s.on(
    Ge.events.conference.TRACK_REMOVED,
    Fn.onTrackRemoved
  ), s.on(
    Ge.events.conference.CONFERENCE_JOIN_IN_PROGRESS,
    Fn.onConferenceJoinInProgress
  ), s.on(
    Ge.events.conference.CONFERENCE_FAILED,
    Fn.onConferenceFailed
  ), s.on(
    Ge.events.conference.RECORDER_STATE_CHANGED,
    Fn.onRecorderStateChanged
  ), s.on(
    Ge.events.conference.CONNECTION_ESTABLISHED,
    Fn.onConnectionEstablished
  ), s.on(
    Ge.events.conference.CONNECTION_INTERRUPTED,
    Fn.onConnectionInterrupted
  ), s.on(
    Ge.events.conference.CONNECTION_RESTORED,
    Fn.onConnectionRestored
  ), s.on(
    Ge.events.conference.P2P_STATUS,
    Fn.onP2PStatus
  ), s.on(
    Ge.events.conference.TRACK_MUTE_CHANGED,
    Fn.onTrackMuteChanged
  ), s.on(
    Ge.events.conference.CONFERENCE_JOINED,
    Fn.onConferenceJoined
  ), s.on(
    Ge.events.conference.CONFERENCE_LEFT,
    Fn.onConferenceLeft
  ), s.on(
    Ge.events.conference.KICKED,
    Fn.onKicked
  ), s.on(
    Ge.events.conference.PARTICIPANT_SOURCE_UPDATED,
    Fn.onParticipantSourceUpdated
  ), s.on(
    Ge.events.conference.CONFERENCE_CREATED_TIMESTAMP,
    Fn.onConferenceCreatedTimestamp
  ), s.on(
    Ge.events.conference.DOMINANT_SPEAKER_CHANGED,
    Fn.onDominantSpeakerChanged
  ), s.on(
    Ge.events.connectionQuality.LOCAL_STATS_UPDATED,
    Fn.onLocalStatsUpdated
  ), s.on(
    Ge.events.connectionQuality.REMOTE_STATS_UPDATED,
    Fn.onRemoteStatsUpdated
  ), s.on(
    Ge.events.conference.PARTICIPANT_PROPERTY_CHANGED,
    Fn.onParticipantPropertyChanged
  ), s.on(
    Ge.events.conference.USER_ROLE_CHANGED,
    Fn.onUserRoleChanged
  ), s.on(
    Ge.events.conference.TALK_WHILE_MUTED,
    Fn.onTalkWhileMuted
  ), s.on(
    Ge.events.conference.TRACK_UNMUTE_REJECTED,
    Fn.onTrackUnmuteRejected
  ), s.on(
    Ge.events.conference.TRACK_AUDIO_LEVEL_CHANGED,
    Fn.onTrackAudioLevelChanged
  ), s.on(
    Ge.events.conference.ENDPOINT_MESSAGE_RECEIVED,
    Fn.onEndpointMessageReceived
  ), s.addCommandListener(
    m6.userInfo,
    (r, c) => {
      const h = /* @__PURE__ */ f2(
        _N,
        VU(r.value)
      );
      if (h.success) {
        const f = {
          avatar: h.output.avatar,
          uid: h.output.uid
        };
        if (GR(c, { userInfo: f })) {
          fT(c);
          return;
        }
        if (c !== s.myUserId() && !je.getState().getParticipantById(c)) {
          dN(c, f);
          return;
        }
        je.getState().updateParticipant(c, f);
      }
    }
  );
}
async function kN() {
  var C, N;
  const s = He.getState().sessionId, r = Wn.getState().connection;
  if (!r)
    throw new Error("No connection available");
  if (Wn.getState().connectionStatus !== "connected" && await A8(), ke.getState().conference)
    return;
  const f = Wn.getState().connectionConfig;
  f && He.getState().isPeerCall && (f.pcStatsInterval = RT), f && (f.startSilent = zR() === "prepared"), f && He.getState().autoStartRecording && (f.p2p = {
    enabled: !1
  });
  const v = f && {
    ...f,
    desktopSharingFrameRate: f.desktopSharingFrameRate ?? FN
  }, R = r.initJitsiConference(
    s,
    v
  ), T = (C = fn(We.AUDIO)) == null ? void 0 : C.originalTrack, E = (N = fn(We.VIDEO)) == null ? void 0 : N.originalTrack;
  T && R.addTrack(T), E && R.addTrack(E), je.getState().updateLocalParticipant({
    pid: R.myUserId()
  }), MN(R), R.setLocalParticipantProperty("joinState", zR()), ke.getState().conferenceWillJoin(R), R.setDisplayName(
    je.getState().localParticipant.name
  ), R.join();
}
async function RE() {
  if (!ke.getState().conference) {
    const r = await rr(kN());
    r.error && (console.error("Error creating conference", r.error), ke.setState({
      conferenceStatus: "error",
      conferenceJoined: !1,
      conferenceError: r.error.message
    }));
  }
}
function UT(s) {
  const r = ke.getState().conference;
  r == null || r.muteParticipant(s, "audio");
}
function DN(s) {
  const r = ke.getState().conference;
  r == null || r.muteParticipant(s, "video");
}
class QN {
  constructor() {
    x(this, "lock", Promise.resolve());
  }
  /**
   * Runs the provided function exclusively, ensuring
   * only one runs at a time in order of requests.
   */
  async run(r) {
    let c;
    const h = new Promise((v) => {
      c = v;
    }), f = this.lock;
    this.lock = f.then(() => h), await f;
    try {
      return await r();
    } finally {
      c();
    }
  }
}
function xN(s) {
  let r = !1, c;
  return function(...h) {
    return r || (r = !0, c = s.apply(this, h)), c;
  };
}
function ZN(s = [], r = []) {
  if (s.length !== r.length)
    return !0;
  for (let c of s)
    if (!r.find(
      ({ deviceId: f, groupId: v, kind: R, label: T }) => c.deviceId === f && c.groupId === v && c.kind === R && c.label === T
    ))
      return !0;
  return !1;
}
function ON() {
  const s = Y.getState().audioInputDevices, r = Y.getState().videoInputDevices, c = [...s, ...r], h = He.getState().sessionType;
  return !!c.filter((f) => f.kind === "audioinput" || h === "VIDEO").some((f) => f.label === "");
}
function YR(s = !1) {
  if (s && ON())
    return;
  const { mediaDevices: r } = Ge;
  r.isDeviceChangeAvailable() && r.enumerateDevices((c) => {
    const h = c.filter(
      (R) => R.kind === "audioinput" && R.deviceId !== ""
    ), f = c.filter(
      (R) => R.kind === "audiooutput" && R.deviceId !== ""
    ), v = c.filter(
      (R) => R.kind === "videoinput" && R.deviceId !== ""
    );
    Y.setState({
      audioInputDevices: h,
      audioOutputDevices: f,
      videoInputDevices: v
    });
  });
}
function wN() {
  const { mediaDevices: s } = Ge;
  s.addEventListener(
    Ge.events.mediaDevices.DEVICE_LIST_CHANGED,
    (r) => {
      const c = Y.getState().audioInputDevices, h = Y.getState().audioOutputDevices, f = Y.getState().videoInputDevices, v = c.concat(
        h,
        f
      );
      setTimeout(() => {
        ZN(v, r) && YR();
      }, 0);
    }
  ), YR();
}
const TT = xN(wN), BN = 5 * 60 * 1e3;
let qi = null, s2 = null, tm = null, XR = !1, KR = 0, Nd = null;
const AN = 3e3, Yv = new QN();
let bd = null;
function EE(s) {
  bd && (bd.aborted = !0);
  const r = {
    aborted: !1,
    onAbort: s,
    dispose() {
      bd === r && !r.aborted && (bd = null);
    }
  };
  return bd = r, r;
}
function IN() {
  var r;
  const s = bd;
  return !s || s.aborted ? !1 : (s.aborted = !0, (r = s.onAbort) == null || r.call(s), Je.publish(
    { type: st.SessionStatusListener.onConnectionClosed },
    !0
  ), !0);
}
function LN() {
  const s = bd;
  return bd = null, (s == null ? void 0 : s.aborted) ?? !1;
}
ET();
function yT() {
  ET(
    He.getState().isPeerCall ? { pcStatsInterval: RT } : void 0
  );
}
function rm(s) {
  return { status: "failed", error: s };
}
function JN(s, r) {
  let c;
  const f = {
    promise: new Promise((v) => {
      c = v;
    }),
    settled: !1,
    intent: s,
    isReconnect: r,
    settle: (v) => {
      f.settled || (f.settled = !0, c(v));
    }
  };
  return f;
}
function Xv(s) {
  qi == null || qi.settle(s);
}
function NT() {
  s2 && (clearTimeout(s2), s2 = null);
}
function bT() {
  NT(), tm = null;
}
function WN(s) {
  NT(), (!s || tm === null) && (tm = Date.now() + BN);
  const r = Math.max(tm - Date.now(), 0);
  s2 = setTimeout(HN, r);
}
async function HN() {
  s2 = null;
  const s = Hn();
  s !== "preparing" && s !== "prepared" || (Xv(
    rm({
      name: "PREPARE_TIMEOUT",
      message: "The prepared session timed out before it was joined."
    })
  ), await $i());
}
function F6(s) {
  var R;
  if (LN())
    return Tu("idle"), Je.stopEmitting(), { status: "cancelled", error: null };
  if ((R = s.configure) == null || R.call(s), !He.getState().sessionId)
    return console.error("Session ID is required to start a session"), rm({
      name: "SESSION_ID_REQUIRED",
      message: "Session ID is required to start a session"
    });
  const { intent: c, isReconnect: h = !1 } = s;
  yT(), Tu(c === "join" ? "joining" : "preparing");
  const f = JN(c, h);
  qi = f, c === "prepare" && WN(h);
  const v = MU(() => i9());
  if (v.error) {
    console.error("Error connecting to session:", v.error);
    const T = {
      name: "connection.otherError",
      message: v.error.message
    };
    Wn.getState().connectionFailed(T), f.settle(
      rm({
        name: "CONNECTION_FAILED",
        message: T.message ?? T.name,
        details: T
      })
    ), c === "prepare" && M6({ silent: !0 }).then(wv);
  }
  return f;
}
async function zN(s = {}) {
  const r = await Yv.run(
    () => {
      const c = Hn();
      return c === "joining" || c === "joined" ? rm({
        name: "SESSION_ALREADY_ACTIVE",
        message: "Cannot prepare a session while one is already active."
      }) : (c === "preparing" || c === "prepared") && qi ? qi : F6({ intent: "prepare", configure: s.configure });
    }
  );
  return "status" in r ? r : r.promise;
}
function jN() {
  Hn() === "preparing" && (Tu("prepared"), (qi == null ? void 0 : qi.intent) === "prepare" && !qi.isReconnect && Je.publish(
    { type: st.SessionStatusListener.onConnected },
    // The bus is gated while prepared; force-emit like onConnectionFailed.
    !0
  )), Xv({ status: "prepared", error: null });
}
function PN(s, r) {
  const c = qi;
  !c || c.settled || (c.settle(
    rm({
      name: "CONFERENCE_FAILED",
      message: r ?? String(s),
      details: { errorName: s }
    })
  ), Hn() === "preparing" && c.intent === "prepare" && $i({ silent: !0 }));
}
function GN(s) {
  const r = Hn();
  if (r === "idle" || r === "left") {
    s.name;
    return;
  }
  const c = FU(s), h = r === "preparing" || r === "prepared";
  if (Wn.getState().connectionFailed(s), (!h || c) && Je.publish(
    {
      type: st.SessionStatusListener.onConnectionFailed,
      payload: s
    },
    h && c
  ), c) {
    $i();
    return;
  }
  if (r === "preparing" && qi !== null && qi.intent === "prepare" && !qi.isReconnect) {
    Xv(
      rm({
        name: "CONNECTION_FAILED",
        message: s.message ?? s.name,
        details: s
      })
    ), $i({ silent: !0 });
    return;
  }
  e9();
}
function YN(s) {
  var f, v, R;
  let r = ke.getState().sessionStartedAt;
  const c = ((f = s.getParticipants) == null ? void 0 : f.call(s)) ?? [];
  for (const T of c) {
    if (((v = T.getProperty) == null ? void 0 : v.call(T, "joinState")) === "prepared")
      continue;
    const E = parseInt(
      String((R = T.getProperty) == null ? void 0 : R.call(T, "sessionStartedAt")),
      10
    );
    Number.isFinite(E) && E > 0 && (r === null || E < r) && (r = E);
  }
  const h = r ?? Date.now();
  ke.setState({ sessionStartedAt: h }), s.setLocalParticipantProperty("sessionStartedAt", h);
}
function XN(s) {
  var c;
  (c = s.options) != null && c.config && (s.options.config.startSilent = !1);
  const r = [
    ["bridge", s.jvbJingleSession],
    ["peer-to-peer", s.p2pJingleSession]
  ];
  for (const [h, f] of r)
    f && Promise.resolve(f.setMediaTransferActive(!0)).catch(
      (v) => {
        console.error(
          `Failed to resume audio transfer over the ${h} connection:`,
          v
        );
      }
    );
}
function KN(s) {
  const { conference: r, conferenceJoined: c } = ke.getState();
  if (!r || !c)
    return !1;
  try {
    return r.sendMessage({
      type: "cc-calls-internal-event",
      event: s
    }), !0;
  } catch (h) {
    return console.error("Failed to announce the call end to the conference:", h), !1;
  }
}
async function CR() {
  var f;
  const s = Hn();
  if (s !== "prepared" && s !== "joining")
    return;
  const r = ke.getState().conference;
  if (!r) {
    console.error("joinMedia: no conference to join");
    return;
  }
  bT(), Tu("joining"), yT(), Je.startEmitting(), Tu("joined"), JU(), YN(r), r.setLocalParticipantProperty("joinState", "joined"), XN(r), Je.publish({
    type: st.SessionStatusListener.onSessionJoined
  }), Je.publish({
    type: Un.onSessionJoined
  });
  const c = ++KR;
  HR(!0), e8().finally(() => {
    c === KR && HR(!1);
  });
  const h = He.getState().audioOutputDeviceId ?? ((f = Y.getState().audioOutputDevice) == null ? void 0 : f.deviceId);
  h && E6(h), TT(), ke.getState().pendingAutoStartRecording && (ke.setState({ pendingAutoStartRecording: !1 }), setTimeout(() => {
    g2();
  }, 100));
}
async function CT() {
  const s = Hn();
  if (s === "joined" || s === "joining")
    return;
  if (s === "prepared") {
    await CR();
    return;
  }
  if (s === "preparing" && qi) {
    (await qi.promise).status === "prepared" && await CR();
    return;
  }
  if (!He.getState().sessionId) {
    console.error("Session ID is required to start a session");
    return;
  }
  Tu("joining"), Je.startEmitting();
  const c = await Yv.run(
    () => F6({ intent: "join" })
  );
  if ("status" in c)
    return;
  (await c.promise).status === "prepared" && await CR();
}
async function M6(s = {}) {
  const r = Hn();
  if (!(r === "idle" || r === "left")) {
    Tu("left"), KR++, HR(!1), bT(), pN(), Xv({ status: "cancelled", error: null }), qi = null, XR = !!s.silent;
    try {
      await Promise.all([
        _8(),
        ke.getState().leaveConference()
      ]), await Wn.getState().disconnect({ silent: s.silent });
    } finally {
      XR = !1;
    }
  }
}
function qN() {
  return Wn.getState().disconnect({ silent: XR });
}
function $i(s = {}) {
  return Yv.run(async () => {
    const r = Hn();
    (r === "idle" || r === "left") && IN();
    const c = He.getState().isPeerCall;
    if (s.shouldEndSession || c && !s.forceLeave) {
      const { conference: f, conferenceJoined: v } = ke.getState();
      if (f && v) {
        ke.getState().endConference();
        return;
      }
    }
    Y.getState().clearIdealTimeoutTimer(), t9(), await M6({ silent: s.silent }), wv();
  });
}
async function $N() {
  Je.publish({
    type: "onSessionTimedOut"
  }), await $i();
}
async function e9() {
  return Nd && (clearTimeout(Nd), Nd = null), new Promise((s, r) => {
    Nd = setTimeout(async () => {
      try {
        await n9(), s();
      } catch (c) {
        r(c);
      } finally {
        Nd = null;
      }
    }, AN);
  });
}
function t9() {
  Nd && (clearTimeout(Nd), Nd = null);
}
async function n9() {
  const s = Hn(), r = s !== "idle" && s !== "left";
  if (Y.getState().connectionRetryCount >= 3 && r) {
    await $i();
    return;
  }
  Y.getState().incrementConnectionRetryCount();
  const h = s === "joined" || s === "joining", f = s === "prepared" || s === "preparing", { sessionStartedAt: v, pendingAutoStartRecording: R } = ke.getState(), T = tm;
  await M6({ silent: f }), Wn.getState().reset(), ke.getState().reset(), it.getState().reset(), h ? (ke.setState({
    sessionStartedAt: v,
    pendingAutoStartRecording: R
  }), await CT()) : f && (tm = T, await Yv.run(
    () => F6({ intent: "prepare", isReconnect: !0 })
  ));
}
async function i9(s = !0) {
  if (Wn.getState().connection) {
    RE();
    return;
  }
  const c = Wn.getState().connectionConfig, h = Wn.getState().jwt, f = He.getState().iAmRecorder;
  c && f && (c.p2p = {
    enabled: !1
  });
  const v = new Ge.JitsiConnection(null, h, c);
  Wn.getState().connectionWillConnect(v), v.addEventListener(
    Ge.events.connection.CONNECTION_ESTABLISHED,
    R
  ), v.addEventListener(
    Ge.events.connection.CONNECTION_FAILED,
    T
  ), v.addEventListener(
    Ge.events.connection.CONNECTION_DISCONNECTED,
    E
  ), v.addEventListener(
    Ge.events.connection.PROPERTIES_UPDATED,
    C
  );
  async function R() {
    v.removeEventListener(
      Ge.events.connection.CONNECTION_ESTABLISHED,
      R
    );
    const B = Hn();
    B === "idle" || B === "left" || Wn.getState().connection !== v || (Wn.getState().connectionEstablished(v), Je.publish({
      type: Un.onConnectionEstablished
    }), s && RE());
  }
  function T(B, ce, ...oe) {
    N();
    const be = oe[1], ge = {
      name: B,
      message: ce,
      details: be,
      recoverable: !FU({ name: B })
    };
    console.error("Connection failed", ge), GN(ge);
  }
  function E() {
  }
  function C(B) {
  }
  function N() {
    v.removeEventListener(
      Ge.events.connection.PROPERTIES_UPDATED,
      C
    ), v.removeEventListener(
      Ge.events.connection.CONNECTION_FAILED,
      T
    ), v.removeEventListener(
      Ge.events.connection.CONNECTION_DISCONNECTED,
      E
    );
  }
  const _ = localStorage.getItem("xmpp_username_override"), V = localStorage.getItem("xmpp_password_override");
  _ && V ? (v.addFeature("http://jitsi.org/protocol/jibri"), v.connect({
    id: _,
    password: V
  })) : v.connect();
}
function k6() {
  const s = Y.getState().desktopSharingFrameRate;
  Ge.createLocalTracks({
    devices: ["desktop"],
    desktopSharingFrameRate: s
  }).then((r) => {
    const c = r.find(
      (f) => f.getType() === "video"
    ), h = r.find(
      (f) => f.getType() === "audio"
    );
    h && h.dispose(), c && c.getTrack().applyConstraints({ width: { max: 1920 }, height: { max: 1080 } }).finally(() => Q6(c));
  }).catch((r) => {
    (r == null ? void 0 : r.name) !== "gum.screensharing_user_canceled" && Je.publish({
      type: Un.notification,
      payload: {
        type: "error",
        message: (r == null ? void 0 : r.message) || "An error occurred while starting screen share."
      }
    });
  });
}
function D6() {
  it.getState().updateLocalTrack(We.SCREENSHARE, {
    muted: 1
  });
}
function a9(s) {
  if (!s || s.isMuted())
    return;
  const r = je.getState().participants, c = je.getState().localParticipant, h = s.isLocal() ? c : r.find((f) => f.pid === s.getParticipantId());
  if (!h) {
    console.error("Participant not found:", s.getParticipantId());
    return;
  }
  je.getState().addVirtualParticipant({
    ...h,
    type: "screen-share",
    name: h.name,
    ruid: `${h.pid}-screen-share`
  }), je.getState().pinParticipant(h.pid, "screen-share"), s.isLocal() ? Je.publish({
    type: st.MediaEventsListener.onScreenShareStarted
  }) : Cr(
    st.ParticipantEventsListner.onParticipantStartedScreenShare,
    h.pid
  );
}
function r9(s) {
  je.getState().removeVirtualParticipant(s, "screen-share"), je.getState().localParticipant.pid === s ? Je.publish({
    type: st.MediaEventsListener.onScreenShareStopped
  }) : Cr(
    st.ParticipantEventsListner.onParticipantStoppedScreenShare,
    s
  );
}
Y.subscribe(
  (s) => s.desktopSharingFrameRate,
  (s) => {
    ke.getState().conference;
  }
);
const fv = /* @__PURE__ */ new Map();
function Q6(s) {
  var r;
  if (s.isLocal()) {
    YR(!0);
    const c = (r = fn(s.getType())) == null ? void 0 : r.muted;
    it.getState().updateLocalTrack(qh(s), {
      originalTrack: s,
      ...s.getVideoType() === "desktop" ? {
        muted: 0
      } : typeof c == "boolean" ? { muted: c } : {}
    }), s.on(Ge.events.track.LOCAL_TRACK_STOPPED, (h) => {
      h.getVideoType() === "desktop" && D6();
    });
  } else
    it.getState().addTrack(s);
  s.removeAllListeners(Ge.events.track.TRACK_MUTE_CHANGED), s.removeAllListeners(Ge.events.track.TRACK_VIDEOTYPE_CHANGED), s.removeAllListeners(
    Ge.events.track.TRACK_STREAMING_STATUS_CHANGED
  ), s.on(Ge.events.track.TRACK_MUTE_CHANGED, (c) => {
    c.isLocal() || it.getState().updateTrack(c, {
      muted: c.isMuted() ? 1 : 0
    });
  }), s.on(
    Ge.events.track.TRACK_VIDEOTYPE_CHANGED,
    (c) => {
      it.getState().updateTrack(s, {
        videoType: c,
        mediaType: c === "desktop" ? "screenshare" : "video"
      });
    }
  ), !s.isLocal() && s.isVideoTrack() && s.on(
    Ge.events.track.TRACK_STREAMING_STATUS_CHANGED,
    (c, h) => {
      var T, E;
      const f = ((T = c.getTrackId) == null ? void 0 : T.call(c)) ?? ((E = c.getId) == null ? void 0 : E.call(c)), v = fv.get(f);
      v && (clearTimeout(v), fv.delete(f));
      const R = ke.getState().conference;
      h === "interrupted" && R.isP2PActive() ? fv.set(
        f,
        setTimeout(() => {
          fv.delete(f), it.getState().updateTrack(c, { streamingStatus: h });
        }, 4e3)
      ) : it.getState().updateTrack(c, { streamingStatus: h });
    }
  );
}
const UE = (s) => {
  let r;
  const c = /* @__PURE__ */ new Set(), h = (C, N) => {
    const _ = typeof C == "function" ? C(r) : C;
    if (!Object.is(_, r)) {
      const V = r;
      r = N ?? (typeof _ != "object" || _ === null) ? _ : Object.assign({}, r, _), c.forEach((B) => B(r, V));
    }
  }, f = () => r, T = { setState: h, getState: f, getInitialState: () => E, subscribe: (C) => (c.add(C), () => c.delete(C)) }, E = r = s(h, f, T);
  return T;
}, o9 = (s) => s ? UE(s) : UE, s9 = (s) => s;
function l9(s, r = s9) {
  const c = rc.useSyncExternalStore(
    s.subscribe,
    () => r(s.getState()),
    () => r(s.getInitialState())
  );
  return rc.useDebugValue(c), c;
}
const TE = (s) => {
  const r = o9(s), c = (h) => l9(r, h);
  return Object.assign(c, r), c;
}, x6 = (s) => s ? TE(s) : TE, c9 = (s) => (r, c, h) => {
  const f = h.subscribe;
  return h.subscribe = (R, T, E) => {
    let C = R;
    if (T) {
      const N = (E == null ? void 0 : E.equalityFn) || Object.is;
      let _ = R(h.getState());
      C = (V) => {
        const B = R(V);
        if (!N(_, B)) {
          const ce = _;
          T(_ = B, ce);
        }
      }, E != null && E.fireImmediately && T(_, _);
    }
    return f(C);
  }, s(r, c, h);
}, d9 = c9;
function Z6(s, r) {
  return (...c) => Object.assign({}, s, r(...c));
}
function u9(s, r) {
  let c;
  try {
    c = s();
  } catch {
    return;
  }
  return {
    getItem: (f) => {
      var v;
      const R = (E) => E === null ? null : JSON.parse(E, void 0), T = (v = c.getItem(f)) != null ? v : null;
      return T instanceof Promise ? T.then(R) : R(T);
    },
    setItem: (f, v) => c.setItem(f, JSON.stringify(v, void 0)),
    removeItem: (f) => c.removeItem(f)
  };
}
const qR = (s) => (r) => {
  try {
    const c = s(r);
    return c instanceof Promise ? c : {
      then(h) {
        return qR(h)(c);
      },
      catch(h) {
        return this;
      }
    };
  } catch (c) {
    return {
      then(h) {
        return this;
      },
      catch(h) {
        return qR(h)(c);
      }
    };
  }
}, h9 = (s, r) => (c, h, f) => {
  let v = {
    storage: u9(() => localStorage),
    partialize: (oe) => oe,
    version: 0,
    merge: (oe, be) => ({
      ...be,
      ...oe
    }),
    ...r
  }, R = !1;
  const T = /* @__PURE__ */ new Set(), E = /* @__PURE__ */ new Set();
  let C = v.storage;
  if (!C)
    return s(
      (...oe) => {
        `${v.name}`, c(...oe);
      },
      h,
      f
    );
  const N = () => {
    const oe = v.partialize({ ...h() });
    return C.setItem(v.name, {
      state: oe,
      version: v.version
    });
  }, _ = f.setState;
  f.setState = (oe, be) => {
    _(oe, be), N();
  };
  const V = s(
    (...oe) => {
      c(...oe), N();
    },
    h,
    f
  );
  f.getInitialState = () => V;
  let B;
  const ce = () => {
    var oe, be;
    if (!C) return;
    R = !1, T.forEach((te) => {
      var _e;
      return te((_e = h()) != null ? _e : V);
    });
    const ge = ((be = v.onRehydrateStorage) == null ? void 0 : be.call(v, (oe = h()) != null ? oe : V)) || void 0;
    return qR(C.getItem.bind(C))(v.name).then((te) => {
      if (te)
        if (typeof te.version == "number" && te.version !== v.version) {
          if (v.migrate) {
            const _e = v.migrate(
              te.state,
              te.version
            );
            return _e instanceof Promise ? _e.then((Ue) => [!0, Ue]) : [!0, _e];
          }
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return [!1, te.state];
      return [!1, void 0];
    }).then((te) => {
      var _e;
      const [Ue, j] = te;
      if (B = v.merge(
        j,
        (_e = h()) != null ? _e : V
      ), c(B, !0), Ue)
        return N();
    }).then(() => {
      ge == null || ge(B, void 0), B = h(), R = !0, E.forEach((te) => te(B));
    }).catch((te) => {
      ge == null || ge(void 0, te);
    });
  };
  return f.persist = {
    setOptions: (oe) => {
      v = {
        ...v,
        ...oe
      }, oe.storage && (C = oe.storage);
    },
    clearStorage: () => {
      C == null || C.removeItem(v.name);
    },
    getOptions: () => v,
    rehydrate: () => ce(),
    hasHydrated: () => R,
    onHydrate: (oe) => (T.add(oe), () => {
      T.delete(oe);
    }),
    onFinishHydration: (oe) => (E.add(oe), () => {
      E.delete(oe);
    })
  }, v.skipHydration || ce(), B || V;
}, m9 = h9, p9 = "https://cdn.cometchat.io/calls/v5/libs/", f9 = !1;
function g9(s) {
  if (s === void 0)
    return;
  const r = /* @__PURE__ */ new Set(), c = [];
  return s.forEach((h) => {
    var R, T;
    const f = typeof h == "string" ? { src: h } : h, v = (R = f == null ? void 0 : f.src) == null ? void 0 : R.trim();
    !v || r.has(v) || (r.add(v), c.push({
      src: v,
      label: ((T = f.label) == null ? void 0 : T.trim()) || `Background ${c.length + 1}`
    }));
  }), c;
}
function v9(s, r) {
  const c = s.endsWith("/") ? s : `${s}/`;
  try {
    return new URL(c, r).href;
  } catch {
    return c;
  }
}
function VT(s, r = typeof location > "u" ? void 0 : location.href) {
  return {
    enableV2: (s == null ? void 0 : s.enableV2) ?? f9,
    assetsBaseUrl: v9(
      (s == null ? void 0 : s.assetsBaseUrl) || p9,
      r
    ),
    images: g9(s == null ? void 0 : s.images),
    allowUserImages: (s == null ? void 0 : s.allowUserImages) ?? !0,
    allowBlur: (s == null ? void 0 : s.allowBlur) ?? !0,
    advanced: s == null ? void 0 : s.advanced
  };
}
function S2() {
  return VT(
    He.getState().virtualBackground
  );
}
function u2(s, r = S2().assetsBaseUrl) {
  return `${r}${s}`;
}
function S9(s = S2().assetsBaseUrl) {
  return u2("vb-inference-worker.87beb979cde699c0.min.js", s);
}
const Gh = "https://cdn.cometchat.io/calls/v5/virtual-backgrounds", _T = Object.freeze(
  [
    { src: `${Gh}/nature.jpg`, label: "Nature" },
    { src: `${Gh}/office.jpg`, label: "Office" },
    { src: `${Gh}/library.jpg`, label: "Library" },
    { src: `${Gh}/home.jpg`, label: "Home" },
    { src: `${Gh}/background-3.jpg`, label: "Night Sky" },
    { src: `${Gh}/background-5.jpg`, label: "Office Lounge" }
  ].map((s) => Object.freeze(s))
), fu = {
  IMAGE: "image",
  BLUR: "blur"
}, nm = {
  TFLITE: "tflite",
  WEBGL: "webgl",
  WEBGPU: "webgpu"
}, Ru = {
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low"
}, yE = 256, NE = 144, $R = {
  TFLITE_MODEL: "selfie_segmentation_landscape.tflite",
  TFJS_MODEL: "selfie_segmentation_landscape_tfjs/model.json"
}, gv = "[VirtualBackground]", bt = {
  debug: (...s) => /* @__PURE__ */ console.debug(gv, ...s),
  info: (...s) => /* @__PURE__ */ console.info(gv, ...s),
  warn: (...s) => /* @__PURE__ */ console.warn(gv, ...s),
  error: (...s) => console.error(gv, ...s)
}, bE = {
  [Ru.HIGH]: {
    backend: nm.WEBGPU,
    segHeight: 288,
    segWidth: 512
  },
  [Ru.MEDIUM]: {
    backend: nm.WEBGL,
    segHeight: 216,
    segWidth: 384
  },
  [Ru.LOW]: {
    backend: nm.TFLITE,
    segHeight: 144,
    segWidth: 256
  }
};
function R9(s) {
  return typeof s == "string" && Object.values(Ru).includes(s);
}
async function E9() {
  var c;
  try {
    if (navigator.gpu && await navigator.gpu.requestAdapter())
      return bt.debug("WebGPU available"), Ru.HIGH;
  } catch {
  }
  const s = document.createElement("canvas"), r = s.getContext("webgl2") ?? s.getContext("webgl");
  return r ? ((c = r.getExtension("WEBGL_lose_context")) == null || c.loseContext(), bt.debug("WebGL available"), Ru.MEDIUM) : (bt.debug("No GPU — using TFLite WASM"), Ru.LOW);
}
async function U9(s, r = E9) {
  const c = await r();
  bt.info(`Hardware tier: ${c}`);
  const h = {
    ...bE[c],
    tier: c
  };
  return s && (s.tierOverride && s.tierOverride !== h.tier && R9(s.tierOverride) && (Object.assign(h, bE[s.tierOverride], {
    tier: s.tierOverride
  }), bt.debug(`Config override: tier forced to ${s.tierOverride}`)), typeof s.segmentationWidth == "number" && (h.segWidth = s.segmentationWidth, bt.debug(`Config override: segmentationWidth = ${h.segWidth}`)), typeof s.segmentationHeight == "number" && (h.segHeight = s.segmentationHeight, bt.debug(`Config override: segmentationHeight = ${h.segHeight}`))), h;
}
function T9() {
  return WebAssembly.validate(
    new Uint8Array([
      0,
      97,
      115,
      109,
      1,
      0,
      0,
      0,
      1,
      5,
      1,
      96,
      0,
      1,
      123,
      3,
      2,
      1,
      0,
      10,
      10,
      1,
      8,
      0,
      65,
      0,
      253,
      15,
      253,
      98,
      11
    ])
  );
}
const CE = 3e4, y9 = Object.values(nm);
class N9 {
  /**
   * @param capabilities - Detected device capabilities.
   * @param assetsBaseUrl - Absolute base URL (trailing slash) of the assets.
   */
  constructor(r, c) {
    x(this, "_assetsBaseUrl");
    x(this, "_capabilities");
    x(this, "_initPromise", null);
    x(this, "_pendingInfer", null);
    x(this, "_worker", null);
    x(this, "_workerReady", !1);
    this._capabilities = { ...r }, this._assetsBaseUrl = c;
  }
  /** Capabilities, possibly updated after a worker-side fallback. */
  get capabilities() {
    return this._capabilities;
  }
  /**
   * Spawns the inference worker and waits for `init_done`.
   *
   * `new Worker(crossOriginUrl)` is not allowed, but `importScripts` of a
   * CDN script is, so the worker is created from a tiny blob shim that
   * imports the real bundle.
   *
   * @throws when the worker signals `init_error`, fails to load (404, CSP)
   * or does not answer within {@link WORKER_INIT_TIMEOUT_MS}.
   */
  init() {
    return this._workerReady ? Promise.resolve() : (this._initPromise || (this._initPromise = this._spawnWorker().finally(() => {
      this._initPromise = null;
    })), this._initPromise);
  }
  _spawnWorker() {
    const r = S9(this._assetsBaseUrl), c = `importScripts(${JSON.stringify(r)});`, h = URL.createObjectURL(
      new Blob([c], { type: "application/javascript" })
    );
    let f;
    try {
      f = new Worker(h, { name: "CometChat VB inference" });
    } finally {
      URL.revokeObjectURL(h);
    }
    return this._worker = f, new Promise((v, R) => {
      let T = !1;
      const E = () => {
        clearTimeout(B), f.removeEventListener("message", _), f.removeEventListener("error", V);
      }, C = (oe) => {
        T || (T = !0, E(), this.stop(), R(oe));
      }, N = () => {
        T || (T = !0, E(), this._workerReady = !0, v());
      }, _ = (oe) => {
        const be = oe.data;
        if (be.type === "init_done") {
          const ge = be.backend;
          if (!ge || !y9.includes(ge)) {
            C(
              new Error(
                `init_done missing or invalid backend: ${ge ?? "<missing>"}`
              )
            );
            return;
          }
          ge !== this._capabilities.backend && (bt.debug(
            `Worker fell back from ${this._capabilities.backend} to ${ge}`
          ), this._capabilities = {
            ...this._capabilities,
            backend: ge,
            segHeight: be.segHeight ?? this._capabilities.segHeight,
            segWidth: be.segWidth ?? this._capabilities.segWidth
          }), bt.debug(
            `Inference worker ready (tier: ${this._capabilities.tier}, backend: ${this._capabilities.backend})`
          ), N();
        } else be.type === "init_error" && C(new Error(`Inference worker init error: ${be.error}`));
      }, V = (oe) => {
        C(
          new Error(
            `Inference worker failed to load ${r}: ${oe.message || "unknown error"}`
          )
        );
      }, B = setTimeout(
        () => C(
          new Error(
            `Inference worker init timed out (${CE}ms)`
          )
        ),
        CE
      );
      f.addEventListener("message", _), f.addEventListener("error", V);
      const ce = {
        type: "init",
        backend: this._capabilities.backend,
        segHeight: this._capabilities.segHeight,
        segWidth: this._capabilities.segWidth,
        assetsBaseUrl: this._assetsBaseUrl,
        tfjsModelUrl: u2(
          $R.TFJS_MODEL,
          this._assetsBaseUrl
        ),
        tfliteModelUrl: u2(
          $R.TFLITE_MODEL,
          this._assetsBaseUrl
        ),
        tfliteWasmBase: this._assetsBaseUrl
      };
      bt.debug(
        `Initialising inference worker — backend: ${ce.backend} | seg: ${ce.segWidth}x${ce.segHeight} | assets: ${this._assetsBaseUrl}`
      ), f.postMessage(ce);
    });
  }
  /**
   * Sends a pre-scaled bitmap to the worker (transferred, zero-copy) and
   * resolves with the raw mask, or `null` when inference failed.
   *
   * Only one inference call may be in flight at a time; the processor
   * enforces that.
   */
  infer(r) {
    const c = this._worker;
    return !c || !this._workerReady ? (r.close(), Promise.resolve(null)) : new Promise((h) => {
      const f = (v) => {
        var T;
        const R = v.data;
        R.type !== "mask" && R.type !== "infer_error" || (c.removeEventListener("message", f), ((T = this._pendingInfer) == null ? void 0 : T.handler) === f && (this._pendingInfer = null), R.type === "mask" ? h(new ImageData(R.data, R.width, R.height)) : (bt.warn("Worker inference error:", R.error), h(null)));
      };
      this._pendingInfer = { handler: f, resolve: h }, c.addEventListener("message", f), c.postMessage({ type: "infer", bitmap: r }, [r]);
    });
  }
  /**
   * Terminates the worker and releases all resources. A pending inference
   * call resolves with `null`.
   */
  stop() {
    var r;
    this._pendingInfer && this._worker && this._worker.removeEventListener("message", this._pendingInfer.handler), (r = this._pendingInfer) == null || r.resolve(null), this._pendingInfer = null, this._worker && (this._worker.terminate(), this._worker = null), this._workerReady = !1, bt.debug("Worker backend stopped");
  }
}
const b9 = 60, C9 = 0.75, V9 = 0.1, _9 = 0.5, F9 = 0.28, M9 = 0.65, k9 = 20, D9 = 32, e6 = 30, Q9 = 2;
function x9(s) {
  const r = s, c = s;
  return {
    width: r.videoWidth ?? c.displayWidth ?? r.width,
    height: r.videoHeight ?? c.displayHeight ?? r.height
  };
}
class Z9 {
  constructor(r) {
    x(this, "_backend");
    x(this, "_backgroundCanvas", null);
    x(this, "_backgroundCtx", null);
    x(this, "_benchmarkAccumTotal", 0);
    x(this, "_benchmarkFrameCount", 0);
    x(this, "_cachedMaskData", null);
    x(this, "_compositor");
    x(this, "_consecutiveFailures", 0);
    x(this, "_disposed", !1);
    x(this, "_edgeHigh");
    x(this, "_edgeLow");
    x(this, "_firstMaskFrame", !0);
    x(this, "_frameCount", 0);
    x(this, "_inferenceSkipCounter", 0);
    x(this, "_initPromise", null);
    x(this, "_isReady", !1);
    x(this, "_maskAccumF32", null);
    x(this, "_options");
    x(this, "_temporalBlendRatio");
    x(this, "_vbConfig");
    x(this, "_virtualImage", null);
    /**
     * Set when the background image fails to load. The effect is created (and
     * the image requested) before the backend finishes initialising, so the
     * error usually fires before `onInferenceFailure` is attached. The effect
     * owner reads this flag to catch that case.
     */
    x(this, "_virtualImageFailed", !1);
    x(this, "_virtualImageLoaded", !1);
    /**
     * Called once when inference fails persistently ({@link FAILURE_THRESHOLD}
     * consecutive failures). The processor stops producing frames after firing.
     * The effect owner uses it to pause the video and revert UI state.
     */
    x(this, "onInferenceFailure", null);
    var h, f, v;
    this._backend = r.backend, this._compositor = r.compositor, this._vbConfig = r.vbConfig, this._options = r.virtualBackground, this._temporalBlendRatio = ((h = r.vbConfig) == null ? void 0 : h.temporalBlendRatio) ?? C9;
    const c = r.backend.capabilities.backend === nm.TFLITE;
    if (this._edgeLow = ((f = r.vbConfig) == null ? void 0 : f.edgeLow) ?? (c ? V9 : F9), this._edgeHigh = ((v = r.vbConfig) == null ? void 0 : v.edgeHigh) ?? (c ? _9 : M9), r.virtualBackground.backgroundType === fu.IMAGE) {
      const R = document.createElement("img");
      R.crossOrigin = "anonymous", R.onload = () => {
        this._virtualImageLoaded = !0;
      }, R.onerror = () => {
        this._virtualImageLoaded = !1, this._virtualImageFailed = !0, bt.warn(
          `Failed to load background image ${r.virtualBackground.virtualSource}`
        );
        const T = this.onInferenceFailure;
        this.onInferenceFailure = null, T == null || T();
      }, R.src = r.virtualBackground.virtualSource ?? "", this._virtualImage = R;
    }
  }
  /**
   * Initialises the backend (worker spawn, model load). Idempotent.
   */
  init() {
    return this._isReady || this._disposed ? Promise.resolve() : (this._initPromise || (this._initPromise = this._backend.init().then(() => {
      this._disposed || (this._isReady = !0, bt.debug("BackgroundFrameProcessor: backend init complete"));
    }).finally(() => {
      this._initPromise = null;
    })), this._initPromise);
  }
  /**
   * Processes one camera frame.
   *
   * @returns The compositor's output canvas, or `null` when there is no
   * processed frame. The caller must then send nothing: the camera frame must
   * never be sent in its place.
   */
  async processFrame(r) {
    var B, ce;
    if (!this._isReady)
      return null;
    const c = performance.now(), h = this._backend.capabilities.backend === nm.TFLITE, f = h ? ((B = this._vbConfig) == null ? void 0 : B.inferenceStride) ?? Q9 : 1, v = this._inferenceSkipCounter % f === 0;
    if (this._inferenceSkipCounter++, v)
      try {
        const { segWidth: oe, segHeight: be } = this._backend.capabilities, ge = await createImageBitmap(r, {
          resizeHeight: be,
          resizeQuality: "medium",
          resizeWidth: oe
        }), te = await this._backend.infer(ge);
        te ? (this._cachedMaskData = this._applyMaskEMA(te), this._consecutiveFailures = 0) : this._recordInferenceFailure();
      } catch (oe) {
        bt.error("BackgroundFrameProcessor: inference error", oe), this._recordInferenceFailure();
      }
    const R = this._cachedMaskData;
    if (this._frameCount++, (ce = this._vbConfig) != null && ce.testMode && (this._benchmarkAccumTotal += performance.now() - c, this._benchmarkFrameCount++, this._benchmarkFrameCount >= b9 && this._logBenchmark()), !R || !this._isReady)
      return null;
    const { width: T, height: E } = x9(r), C = this._ensureBackgroundCanvas();
    (C.width !== T || C.height !== E) && (C.width = T, C.height = E, this._backgroundCtx = C.getContext("2d"), this._compositor.resize(T, E)), this._prepareBackground(r);
    const _ = Math.round(
      (h ? D9 : k9) * R.width / T
    ), V = this._options.backgroundType === fu.BLUR;
    return this._compositor.composite(r, C, R, {
      cssBlurFilter: V ? "blur(8px)" : "blur(4px)",
      edgeHigh: this._edgeHigh,
      edgeLow: this._edgeLow,
      maskBlurRadius: _
    }), this._compositor.outputCanvas;
  }
  /** Releases all resources held by the processor. */
  dispose() {
    this._disposed = !0, this._compositor.dispose(), this._cachedMaskData = null, this._consecutiveFailures = 0, this._firstMaskFrame = !0, this._maskAccumF32 = null, this._inferenceSkipCounter = 0, this._isReady = !1, this._backgroundCtx = null, this._backgroundCanvas = null, this._virtualImage && (this._virtualImage.onload = null, this._virtualImage.onerror = null, this._virtualImage.src = "", this._virtualImage = null), this.onInferenceFailure = null;
  }
  _ensureBackgroundCanvas() {
    return this._backgroundCanvas || (this._backgroundCanvas = document.createElement("canvas")), this._backgroundCanvas;
  }
  /**
   * Counts a failed inference call and drops the cached mask, so that no
   * frame is produced from a stale mask until inference works again.
   */
  _recordInferenceFailure() {
    this._cachedMaskData = null, this._consecutiveFailures++, this._checkFailureThreshold();
  }
  /**
   * Fires `onInferenceFailure` once when the consecutive failure count
   * reaches the threshold, then stops producing frames for good.
   */
  _checkFailureThreshold() {
    if (this._consecutiveFailures >= e6 && this.onInferenceFailure) {
      bt.error(
        `BackgroundFrameProcessor: persistent inference failure (${e6} consecutive) — no more frames are produced`
      );
      const r = this.onInferenceFailure;
      this.onInferenceFailure = null, this._isReady = !1, r();
    }
  }
  /**
   * Applies exponential moving average temporal smoothing to the raw mask,
   * in place. A Float32 accumulator avoids per-step quantisation from
   * `Uint8ClampedArray` rounding. R (read by the WebGL shader) and A (read
   * by the Canvas 2D fallback) are both replaced with the smoothed value.
   */
  _applyMaskEMA(r) {
    const c = r.width * r.height, h = this._temporalBlendRatio, f = 1 - h, v = r.data;
    if (!this._maskAccumF32 || this._maskAccumF32.length !== c || this._firstMaskFrame) {
      this._maskAccumF32 = new Float32Array(c);
      for (let T = 0, E = 0; T < c; T++, E += 4)
        this._maskAccumF32[T] = v[E];
      return this._firstMaskFrame = !1, r;
    }
    const R = this._maskAccumF32;
    for (let T = 0, E = 0; T < c; T++, E += 4)
      R[T] = f * v[E] + h * R[T], v[E] = R[T], v[E + 3] = R[T];
    return r;
  }
  /** Renders the background (blur or image) onto the background canvas. */
  _prepareBackground(r) {
    const c = this._backgroundCtx, h = this._backgroundCanvas;
    !c || !h || (c.filter = "none", this._options.backgroundType === fu.BLUR ? (c.filter = `blur(${this._options.blurValue ?? 8}px)`, c.drawImage(r, 0, 0, h.width, h.height)) : this._options.backgroundType === fu.IMAGE && this._virtualImage && this._virtualImageLoaded ? c.drawImage(this._virtualImage, 0, 0, h.width, h.height) : c.clearRect(0, 0, h.width, h.height), c.filter = "none");
  }
  _logBenchmark() {
    const r = this._benchmarkFrameCount;
    if (r === 0)
      return;
    const c = this._benchmarkAccumTotal, h = (c / r).toFixed(1), f = (1e3 / (c / r)).toFixed(1), v = performance.memory, R = v ? (v.usedJSHeapSize / 1024 / 1024).toFixed(1) : "N/A";
    bt.debug(
      `BENCHMARK avgTotal=${h}ms fps=${f} heap=${R}MB (frames ${this._frameCount - r + 1}-${this._frameCount})`
    ), this._benchmarkAccumTotal = 0, this._benchmarkFrameCount = 0;
  }
}
class O9 {
  constructor() {
    x(this, "_canvas");
    x(this, "_ctx", null);
    x(this, "_maskCanvas", null);
    x(this, "_maskCanvasCtx", null);
    this._canvas = document.createElement("canvas"), this._ctx = this._canvas.getContext("2d"), this._maskCanvas = document.createElement("canvas"), this._maskCanvasCtx = this._maskCanvas.getContext("2d");
  }
  get isAvailable() {
    return this._ctx !== null;
  }
  get outputCanvas() {
    return this._canvas;
  }
  /**
   * 1. Draw the blurred segmentation mask (person silhouette).
   * 2. Clip the camera foreground to the mask via `source-in`.
   * 3. Draw the background behind the person via `destination-over`.
   *
   * The mask is painted onto a helper canvas with `putImageData`, which
   * writes raw bytes without premultiplied-alpha conversion, then scaled to
   * the output size with `drawImage`.
   */
  composite(r, c, h, f) {
    var C;
    const v = this._ctx, R = this._maskCanvas;
    if (!v || !R)
      return;
    const { width: T, height: E } = this._canvas;
    v.globalCompositeOperation = "copy", (R.width !== h.width || R.height !== h.height) && (R.width = h.width, R.height = h.height), (C = this._maskCanvasCtx) == null || C.putImageData(h, 0, 0), v.filter = f.cssBlurFilter, v.drawImage(R, 0, 0, T, E), v.globalCompositeOperation = "source-in", v.filter = "none", v.drawImage(r, 0, 0, T, E), v.globalCompositeOperation = "destination-over", v.drawImage(c, 0, 0, T, E);
  }
  dispose() {
    this._ctx = null, this._maskCanvas = null, this._maskCanvasCtx = null;
  }
  resize(r, c) {
    this._canvas.width = r, this._canvas.height = c;
  }
}
const w9 = `
    attribute vec2 a_position;
    attribute vec2 a_texCoord;
    varying vec2 v_texCoord;
    void main() {
        gl_Position = vec4(a_position, 0.0, 1.0);
        v_texCoord = a_texCoord;
    }
`, B9 = `
    precision mediump float;

    uniform sampler2D u_camera;
    uniform sampler2D u_background;
    uniform sampler2D u_mask;
    uniform float     u_edgeLow;
    uniform float     u_edgeHigh;
    uniform vec2      u_maskTexelSize;
    uniform vec2      u_cameraTexelSize;

    varying vec2 v_texCoord;

    // 3x3 Gaussian blur (sigma~1) sampled in mask-texture space.
    // When u_maskTexelSize is (0,0) all taps collapse to tc — no blur.
    float sampleMaskBlurred(vec2 tc) {
        vec2 t = u_maskTexelSize;
        return
            texture2D(u_mask, tc + vec2(-t.x, -t.y)).r * 0.0625 +
            texture2D(u_mask, tc + vec2( 0.0, -t.y)).r * 0.125  +
            texture2D(u_mask, tc + vec2( t.x, -t.y)).r * 0.0625 +
            texture2D(u_mask, tc + vec2(-t.x,  0.0)).r * 0.125  +
            texture2D(u_mask, tc                    ).r * 0.25   +
            texture2D(u_mask, tc + vec2( t.x,  0.0)).r * 0.125  +
            texture2D(u_mask, tc + vec2(-t.x,  t.y)).r * 0.0625 +
            texture2D(u_mask, tc + vec2( 0.0,  t.y)).r * 0.125  +
            texture2D(u_mask, tc + vec2( t.x,  t.y)).r * 0.0625;
    }

    // Luminance gradient magnitude using a cross-pattern sample.
    // Roughly [0, 0.5] — strong camera edges (shirt vs chair) hit 0.2+.
    float cameraEdgeStrength(vec2 tc) {
        vec2 t  = u_cameraTexelSize;
        vec3 lv = vec3(0.299, 0.587, 0.114);
        float lL = dot(texture2D(u_camera, tc - vec2(t.x, 0.0)).rgb, lv);
        float lR = dot(texture2D(u_camera, tc + vec2(t.x, 0.0)).rgb, lv);
        float lU = dot(texture2D(u_camera, tc - vec2(0.0, t.y)).rgb, lv);
        float lD = dot(texture2D(u_camera, tc + vec2(0.0, t.y)).rgb, lv);
        return length(vec2(lR - lL, lD - lU));
    }

    void main() {
        vec4 fg = texture2D(u_camera,     v_texCoord);
        vec4 bg = texture2D(u_background, v_texCoord);

        float blurred = sampleMaskBlurred(v_texCoord);
        float raw     = texture2D(u_mask, v_texCoord).r;

        // At strong camera colour edges snap toward the raw mask so the
        // person boundary aligns with the image edge. In smooth regions
        // (hair, skin) keep the blurred mask for natural feathering.
        float snapT = smoothstep(0.05, 0.20, cameraEdgeStrength(v_texCoord));
        float curAlpha = mix(blurred, raw, snapT);
        float alpha = smoothstep(u_edgeLow, u_edgeHigh, curAlpha);

        gl_FragColor = mix(bg, fg, alpha);
    }
`, A9 = new Float32Array([
  -1,
  -1,
  0,
  1,
  1,
  -1,
  1,
  1,
  -1,
  1,
  0,
  0,
  1,
  1,
  1,
  0
]);
function VE(s, r, c) {
  const h = s.createShader(r);
  if (!h)
    throw new Error("WebGLCompositor: createShader returned null");
  if (s.shaderSource(h, c), s.compileShader(h), !s.getShaderParameter(h, s.COMPILE_STATUS)) {
    const f = s.getShaderInfoLog(h);
    throw s.deleteShader(h), new Error(`WebGLCompositor: shader compile error — ${f}`);
  }
  return h;
}
function I9(s, r) {
  const c = VE(s, s.VERTEX_SHADER, w9), h = VE(s, s.FRAGMENT_SHADER, r), f = s.createProgram();
  if (!f)
    throw new Error("WebGLCompositor: createProgram returned null");
  if (s.attachShader(f, c), s.attachShader(f, h), s.linkProgram(f), !s.getProgramParameter(f, s.LINK_STATUS)) {
    const v = s.getProgramInfoLog(f);
    throw s.deleteProgram(f), new Error(`WebGLCompositor: program link error — ${v}`);
  }
  return s.deleteShader(c), s.deleteShader(h), f;
}
function VR(s) {
  const r = s.createTexture();
  if (!r)
    throw new Error("WebGLCompositor: createTexture returned null");
  return s.bindTexture(s.TEXTURE_2D, r), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, s.LINEAR), r;
}
class _E {
  constructor(r) {
    x(this, "_canvas");
    x(this, "_gl", null);
    x(this, "_onContextLostBound", null);
    x(this, "_onContextRestoredBound", null);
    x(this, "_program", null);
    x(this, "_quadBuffer", null);
    x(this, "_texBackground", null);
    x(this, "_texCamera", null);
    x(this, "_texMask", null);
    x(this, "_aPosition", -1);
    x(this, "_aTexCoord", -1);
    x(this, "_uBackground", null);
    x(this, "_uCamera", null);
    x(this, "_uCameraTexelSize", null);
    x(this, "_uEdgeHigh", null);
    x(this, "_uEdgeLow", null);
    x(this, "_uMask", null);
    x(this, "_uMaskTexelSize", null);
    this._canvas = r, this._init(), this._onContextLostBound = this._onContextLost.bind(this), this._onContextRestoredBound = this._onContextRestored.bind(this), r.addEventListener(
      "webglcontextlost",
      this._onContextLostBound,
      !1
    ), r.addEventListener(
      "webglcontextrestored",
      this._onContextRestoredBound,
      !1
    );
  }
  get isAvailable() {
    return this._gl !== null && !this._gl.isContextLost();
  }
  get outputCanvas() {
    return this._canvas;
  }
  resize(r, c) {
    this._canvas.width = r, this._canvas.height = c;
  }
  composite(r, c, h, f) {
    this.compositeFromImageData(
      r,
      c,
      h,
      f.edgeLow,
      f.edgeHigh,
      f.maskBlurRadius
    );
  }
  /**
   * Uploads the mask via the `Uint8Array` form of `texImage2D` rather than
   * the `CanvasImageSource` form. The canvas upload path reads the browser's
   * premultiplied-alpha storage; since R and A both hold the confidence, the
   * canvas would store `R = confidence²`. The raw upload bypasses that.
   *
   * @param maskBlurRadius - Gaussian blur radius in mask-texture pixels.
   */
  compositeFromImageData(r, c, h, f, v, R = 0) {
    const T = this._gl;
    !T || !this._program || (T.bindFramebuffer(T.FRAMEBUFFER, null), T.viewport(0, 0, this._canvas.width, this._canvas.height), T.useProgram(this._program), T.activeTexture(T.TEXTURE0), T.bindTexture(T.TEXTURE_2D, this._texCamera), T.texImage2D(
      T.TEXTURE_2D,
      0,
      T.RGBA,
      T.RGBA,
      T.UNSIGNED_BYTE,
      r
    ), T.uniform1i(this._uCamera, 0), T.activeTexture(T.TEXTURE1), T.bindTexture(T.TEXTURE_2D, this._texBackground), T.texImage2D(
      T.TEXTURE_2D,
      0,
      T.RGBA,
      T.RGBA,
      T.UNSIGNED_BYTE,
      c
    ), T.uniform1i(this._uBackground, 1), T.activeTexture(T.TEXTURE2), T.bindTexture(T.TEXTURE_2D, this._texMask), T.texImage2D(
      T.TEXTURE_2D,
      0,
      T.RGBA,
      h.width,
      h.height,
      0,
      T.RGBA,
      T.UNSIGNED_BYTE,
      h.data
    ), T.uniform1i(this._uMask, 2), T.uniform1f(this._uEdgeLow, f), T.uniform1f(this._uEdgeHigh, v), T.uniform2f(
      this._uMaskTexelSize,
      R / h.width,
      R / h.height
    ), T.uniform2f(
      this._uCameraTexelSize,
      1 / this._canvas.width,
      1 / this._canvas.height
    ), this._bindQuadState(T), T.drawArrays(T.TRIANGLE_STRIP, 0, 4));
  }
  dispose() {
    var c;
    this._onContextLostBound && (this._canvas.removeEventListener(
      "webglcontextlost",
      this._onContextLostBound
    ), this._onContextLostBound = null), this._onContextRestoredBound && (this._canvas.removeEventListener(
      "webglcontextrestored",
      this._onContextRestoredBound
    ), this._onContextRestoredBound = null);
    const r = this._gl;
    r && (r.deleteTexture(this._texCamera), r.deleteTexture(this._texBackground), r.deleteTexture(this._texMask), r.deleteBuffer(this._quadBuffer), r.deleteProgram(this._program), this._texCamera = null, this._texBackground = null, this._texMask = null, this._quadBuffer = null, this._program = null, (c = r.getExtension("WEBGL_lose_context")) == null || c.loseContext(), this._gl = null);
  }
  _init() {
    const r = this._canvas.getContext("webgl2") ?? this._canvas.getContext("webgl");
    if (!r) {
      bt.warn(
        "WebGLCompositor: no WebGL context available — falling back to Canvas 2D"
      );
      return;
    }
    this._gl = r;
    try {
      this._program = I9(r, B9);
    } catch (c) {
      bt.error("WebGLCompositor: shader build failed", c), this._gl = null;
      return;
    }
    this._quadBuffer = r.createBuffer(), r.bindBuffer(r.ARRAY_BUFFER, this._quadBuffer), r.bufferData(r.ARRAY_BUFFER, A9, r.STATIC_DRAW), this._aPosition = r.getAttribLocation(this._program, "a_position"), this._aTexCoord = r.getAttribLocation(this._program, "a_texCoord"), this._bindQuadState(r), r.useProgram(this._program), this._uCamera = r.getUniformLocation(this._program, "u_camera"), this._uBackground = r.getUniformLocation(this._program, "u_background"), this._uCameraTexelSize = r.getUniformLocation(
      this._program,
      "u_cameraTexelSize"
    ), this._uMask = r.getUniformLocation(this._program, "u_mask"), this._uMaskTexelSize = r.getUniformLocation(
      this._program,
      "u_maskTexelSize"
    ), this._uEdgeLow = r.getUniformLocation(this._program, "u_edgeLow"), this._uEdgeHigh = r.getUniformLocation(this._program, "u_edgeHigh"), this._texCamera = VR(r), this._texBackground = VR(r), this._texMask = VR(r), bt.info("WebGLCompositor: initialised");
  }
  _onContextLost(r) {
    r.preventDefault(), bt.warn("WebGLCompositor: context lost"), this._gl = null, this._program = null, this._quadBuffer = null, this._texCamera = null, this._texBackground = null, this._texMask = null;
  }
  _onContextRestored() {
    bt.info("WebGLCompositor: context restored — reinitialising"), this._init();
  }
  /**
   * Re-binds the quad vertex buffer and attribute pointers before each draw
   * so no other user of the context can leave our attribute state corrupted.
   */
  _bindQuadState(r) {
    const c = 4 * Float32Array.BYTES_PER_ELEMENT;
    r.bindBuffer(r.ARRAY_BUFFER, this._quadBuffer), r.enableVertexAttribArray(this._aPosition), r.vertexAttribPointer(this._aPosition, 2, r.FLOAT, !1, c, 0), r.enableVertexAttribArray(this._aTexCoord), r.vertexAttribPointer(
      this._aTexCoord,
      2,
      r.FLOAT,
      !1,
      c,
      2 * Float32Array.BYTES_PER_ELEMENT
    );
  }
}
class FE {
  constructor() {
    /** Incremented on every start(); a running loop exits when it changes. */
    x(this, "_generation", 0);
    x(this, "_isRunning", !1);
    x(this, "_processor", null);
    x(this, "_trackGenerator", null);
    x(this, "_trackProcessor", null);
    x(this, "_trackReader", null);
  }
  static isSupported() {
    return typeof window < "u" && typeof window.MediaStreamTrackProcessor == "function" && typeof window.MediaStreamTrackGenerator == "function" && typeof VideoFrame == "function";
  }
  /**
   * Starts the pipeline on the given camera stream.
   *
   * @returns Processed output stream backed by a `MediaStreamTrackGenerator`.
   */
  start(r, c) {
    this._isRunning = !0, this._processor = c;
    const h = r.getVideoTracks()[0], f = window.MediaStreamTrackProcessor, v = window.MediaStreamTrackGenerator;
    this._trackProcessor = new f({
      track: h,
      maxBufferSize: 2
    }), this._trackGenerator = new v({ kind: "video" });
    const R = h.getSettings(), T = this._trackGenerator, E = T.getSettings.bind(T);
    return T.getSettings = () => {
      const C = E();
      return C.width ? C : { ...R, ...C };
    }, bt.debug("InsertableStreamsPipeline: using insertable streams path"), this._runLoop(++this._generation), new MediaStream([T]);
  }
  /**
   * Stops the pipeline. Cancels the reader immediately so any `VideoFrame`s
   * buffered in the processor's queue are flushed and closed.
   */
  async stop() {
    var r;
    this._isRunning = !1, this._processor = null, this._generation++, (r = this._trackReader) == null || r.cancel().catch(() => {
    }), this._trackReader = null, this._trackProcessor = null, this._trackGenerator = null;
  }
  async _runLoop(r) {
    var T;
    const c = this._trackProcessor, h = this._trackGenerator;
    if (!c || !h)
      return;
    const f = c.readable.getReader(), v = h.writable.getWriter();
    this._trackReader = f;
    const R = () => this._isRunning && this._generation === r;
    try {
      for (; R(); ) {
        const { value: E, done: C } = await f.read();
        if (C || !E)
          break;
        if (!R()) {
          E.close();
          break;
        }
        let N = null;
        try {
          N = await ((T = this._processor) == null ? void 0 : T.processFrame(E)) ?? null;
        } catch (_) {
          bt.error(
            "InsertableStreamsPipeline: frame processing error",
            _
          );
        }
        if (N) {
          const _ = new VideoFrame(N, {
            timestamp: E.timestamp
          });
          try {
            await v.write(_);
          } catch (V) {
            bt.error("InsertableStreamsPipeline: write error", V);
          } finally {
            _.close();
          }
        }
        E.close();
      }
    } catch (E) {
      R() && bt.error("InsertableStreamsPipeline: loop error", E);
    } finally {
      this._trackReader === f && (this._trackReader = null);
      try {
        await f.cancel();
      } catch {
      }
      try {
        v.releaseLock();
      } catch {
      }
    }
  }
}
const FT = 1, MT = 2, kT = 3, L9 = `
    var timer;

    onmessage = function(request) {
        switch (request.data.id) {
        case ${FT}: {
            timer = setTimeout(() => {
                postMessage({ id: ${kT} });
            }, request.data.timeMs);
            break;
        }
        case ${MT}: {
            if (timer) {
                clearTimeout(timer);
            }
            break;
        }
        }
    };
`, J9 = URL.createObjectURL(
  new Blob([L9], { type: "application/javascript" })
), W9 = 1e3 / 30;
class DT {
  /**
   * @param model - Loaded TFLite WASM module (V1) or `undefined` (V2).
   * @param virtualBackground - The selected background (type, blur, image).
   * @param v2Init - V2 setup payload. When present, activates the V2 pipeline.
   */
  constructor(r, c, h) {
    x(this, "_backend", null);
    /** V1's count of consecutive frames that failed to render. */
    x(this, "_consecutiveFailures", 0);
    x(this, "_disposed", !1);
    x(this, "_enableV2");
    x(this, "_inputVideoElement");
    x(this, "_maskFrameTimerWorker", null);
    x(this, "_model");
    x(this, "_options");
    x(this, "_outputCanvasCtx", null);
    x(this, "_outputCanvasElement");
    x(this, "_pipeline", null);
    x(this, "_processor", null);
    x(this, "_segmentationMask", null);
    x(this, "_segmentationMaskCanvas", null);
    x(this, "_segmentationMaskCtx", null);
    x(this, "_segmentationPixelCount", 0);
    x(this, "_stream", null);
    x(this, "_virtualImage", null);
    x(this, "_virtualImageFailed", !1);
    x(this, "_virtualImageLoaded", !1);
    /** V1's copy of the callback — V1 has no `_processor` to forward it to. */
    x(this, "_onInferenceFailureCb", null);
    /**
     * Resolves when V2 async initialisation completes. V1 resolves immediately.
     */
    x(this, "initPromise", Promise.resolve());
    if (this._outputCanvasElement = document.createElement("canvas"), this._outputCanvasElement.getContext("2d"), this._inputVideoElement = document.createElement("video"), this._options = {
      height: NE,
      virtualBackground: c,
      width: yE
    }, this._enableV2 = !!h, h) {
      const { capabilities: f, assetsBaseUrl: v, vbConfig: R } = h;
      this._backend = new N9(
        f,
        v
      );
      let T;
      const E = new _E(
        document.createElement("canvas")
      );
      E.isAvailable ? T = E : (bt.debug("WebGL unavailable — using Canvas 2D compositor"), T = new O9()), this._processor = new Z9({
        backend: this._backend,
        compositor: T,
        vbConfig: R,
        virtualBackground: c
      });
      const C = (R == null ? void 0 : R.useInsertableStreams) !== !1 && FE.isSupported();
      C && (this._pipeline = new FE()), bt.debug(
        `V2 effect created — backend: ${this._backend.capabilities.backend}, pipeline: ${C ? "insertable-streams" : "capture-stream"}, compositor: ${T instanceof _E ? "webgl" : "canvas-2d"}`
      );
      return;
    }
    this._model = r, this._segmentationPixelCount = yE * NE, c.backgroundType === fu.IMAGE && (this._virtualImage = document.createElement("img"), this._virtualImage.crossOrigin = "anonymous", this._virtualImage.onload = () => {
      this._virtualImageLoaded = !0;
    }, this._virtualImage.onerror = () => {
      this._virtualImageLoaded = !1, this._virtualImageFailed = !0, bt.warn(
        `Failed to load background image ${c.virtualSource}`
      );
      const f = this._onInferenceFailureCb;
      this._onInferenceFailureCb = null, f == null || f();
    }, this._virtualImage.src = c.virtualSource ?? "");
  }
  /**
   * Called once when inference fails persistently mid-session, or when the
   * configured background image fails to load.
   */
  set onInferenceFailure(r) {
    this._onInferenceFailureCb = r, this._processor && (this._processor.onInferenceFailure = r);
  }
  /** Whether this effect runs the V2 engine. */
  get isV2() {
    return this._enableV2;
  }
  /** Device capabilities in use (V2 only). */
  get capabilities() {
    var r;
    return (r = this._backend) == null ? void 0 : r.capabilities;
  }
  /** Whether the V2 processor is initialised and producing frames. */
  get isReady() {
    var r;
    return this._enableV2 ? !!((r = this._processor) != null && r._isReady) : !0;
  }
  /**
   * Whether the configured background image failed to load. Check it before
   * assigning `onInferenceFailure`: a V2 effect requests the image at
   * construction, so the error can fire while the backend is still
   * initialising, before any callback is attached.
   */
  get backgroundImageFailed() {
    return this._processor ? this._processor._virtualImageFailed : this._virtualImageFailed;
  }
  /** Number of frames processed by the V2 processor. */
  get frameCount() {
    var r;
    return ((r = this._processor) == null ? void 0 : r._frameCount) ?? 0;
  }
  /**
   * Checks if the local track supports this effect.
   */
  isEnabled(r) {
    return r.isVideoTrack() && r.videoType === "camera";
  }
  /**
   * Starts the effect on the given camera stream.
   *
   * @returns The stream with the applied effect.
   */
  startEffect(r) {
    if (this._disposed)
      return bt.warn("startEffect called on a disposed effect — passing through"), r;
    if (this._enableV2 && this._pipeline && this._processor)
      return this.initPromise = this._processor.init(), this.initPromise.catch(() => {
      }), this._pipeline.start(r, this._processor);
    const c = this._setupCaptureStream(r);
    return this._enableV2 && this._processor ? (this.initPromise = this._processor.init(), this.initPromise.catch(() => {
    }), this._startTimerLoop(async () => {
      var v;
      const h = this._outputCanvasCtx;
      if (!h)
        return;
      const f = await ((v = this._processor) == null ? void 0 : v.processFrame(
        this._inputVideoElement
      ));
      f && h.drawImage(f, 0, 0);
    })) : (this._segmentationMask = new ImageData(
      this._options.width,
      this._options.height
    ), this._segmentationMaskCanvas = document.createElement("canvas"), this._segmentationMaskCanvas.width = this._options.width, this._segmentationMaskCanvas.height = this._options.height, this._segmentationMaskCtx = this._segmentationMaskCanvas.getContext(
      "2d",
      { willReadFrequently: !0 }
    ), this._startTimerLoop(() => this._renderMask())), c;
  }
  /**
   * Stops the frame pipeline. Keeps the V2 processor and backend alive so
   * the next `startEffect()` (camera unmute) can process frames immediately.
   */
  stopEffect() {
    if (this._enableV2 && this._pipeline) {
      this._pipeline.stop().catch(() => {
      });
      return;
    }
    this._stopTimerLoop(), this._inputVideoElement.onloadeddata = null, this._inputVideoElement.srcObject = null;
  }
  /**
   * Pre-initialises the V2 backend (worker spawn, model download). No-op for
   * V1, whose model is loaded by the factory.
   */
  async init() {
    this._processor && await this._processor.init();
  }
  /**
   * Releases everything: stops the pipeline, disposes the processor (WebGL
   * context) and terminates the inference worker. Idempotent.
   */
  dispose() {
    var r, c;
    this._disposed || (this._disposed = !0, this.stopEffect(), (r = this._processor) == null || r.dispose(), this._processor = null, (c = this._backend) == null || c.stop(), this._backend = null, this._pipeline = null, this._inputVideoElement.onloadeddata = null, this._inputVideoElement.srcObject = null, this._stream = null, this._segmentationMask = null, this._segmentationMaskCanvas = null, this._segmentationMaskCtx = null, this._outputCanvasCtx = null, this._virtualImage && (this._virtualImage.onload = null, this._virtualImage.onerror = null, this._virtualImage.src = "", this._virtualImage = null));
  }
  /**
   * Sets up the video element and output canvas for captureStream-based
   * frame processing. Shared by V1 and the V2 captureStream fallback.
   */
  _setupCaptureStream(r) {
    this._stream = r;
    const c = r.getVideoTracks()[0], { height: h, frameRate: f, width: v } = c.getSettings ? c.getSettings() : c.getConstraints();
    return this._outputCanvasElement.width = parseInt(String(v), 10), this._outputCanvasElement.height = parseInt(String(h), 10), this._outputCanvasCtx = this._outputCanvasElement.getContext("2d"), this._inputVideoElement.width = parseInt(String(v), 10), this._inputVideoElement.height = parseInt(String(h), 10), this._inputVideoElement.autoplay = !0, this._inputVideoElement.srcObject = r, this._inputVideoElement.play().catch(() => {
    }), this._outputCanvasElement.captureStream(
      parseInt(String(f), 10)
    );
  }
  /**
   * Starts a TimerWorker that calls `onTick` on each tick. The next tick is
   * scheduled after the callback completes, so ticks never overlap.
   */
  _startTimerLoop(r) {
    this._stopTimerLoop();
    const c = new Worker(J9, {
      name: "CometChat VB timer"
    });
    this._maskFrameTimerWorker = c;
    const h = () => {
      this._maskFrameTimerWorker === c && c.postMessage({ id: FT, timeMs: W9 });
    };
    c.onmessage = (f) => {
      f.data.id === kT && Promise.resolve().then(r).catch((v) => bt.error("Frame tick failed", v)).then(h);
    }, this._inputVideoElement.readyState >= 2 ? h() : this._inputVideoElement.onloadeddata = h;
  }
  _stopTimerLoop() {
    this._maskFrameTimerWorker && (this._maskFrameTimerWorker.postMessage({ id: MT }), this._maskFrameTimerWorker.terminate(), this._maskFrameTimerWorker = null);
  }
  /**
   * V1: composites the mask, camera and background with Canvas 2D.
   */
  runPostProcessing() {
    var E;
    const r = this._outputCanvasCtx, c = this._segmentationMaskCanvas, h = (E = this._stream) == null ? void 0 : E.getVideoTracks()[0];
    if (!r || !c || !h)
      return;
    const { height: f, width: v } = h.getSettings() ?? h.getConstraints(), { backgroundType: R, blurValue: T } = this._options.virtualBackground;
    if (this._outputCanvasElement.height = Number(f), this._outputCanvasElement.width = Number(v), r.globalCompositeOperation = "copy", r.filter = R === fu.IMAGE ? "blur(4px)" : "blur(8px)", r.drawImage(
      c,
      0,
      0,
      this._options.width,
      this._options.height,
      0,
      0,
      this._inputVideoElement.width,
      this._inputVideoElement.height
    ), r.globalCompositeOperation = "source-in", r.filter = "none", r.drawImage(this._inputVideoElement, 0, 0), r.globalCompositeOperation = "destination-over", R === fu.IMAGE) {
      if (!this._virtualImage || !this._virtualImageLoaded)
        return;
      r.drawImage(
        this._virtualImage,
        0,
        0,
        this._outputCanvasElement.width,
        this._outputCanvasElement.height
      );
    } else
      r.filter = `blur(${T}px)`, r.drawImage(this._inputVideoElement, 0, 0);
  }
  /**
   * V1: runs TFLite inference on the main thread.
   */
  runInference() {
    var h;
    const r = this._segmentationMask;
    if (!r)
      return;
    this._model._runInference();
    const c = this._model._getOutputMemoryOffset() / 4;
    for (let f = 0; f < this._segmentationPixelCount; f++) {
      const v = this._model.HEAPF32[c + f];
      r.data[f * 4 + 3] = 255 * v;
    }
    (h = this._segmentationMaskCtx) == null || h.putImageData(r, 0, 0);
  }
  /**
   * V1: renders one frame. A frame that fails is not drawn, so the canvas
   * keeps the last one; {@link FAILURE_THRESHOLD} consecutive failures are
   * reported through `onInferenceFailure`, as in V2.
   */
  _renderMask() {
    try {
      this.resizeSource(), this.runInference(), this.runPostProcessing(), this._consecutiveFailures = 0;
    } catch (r) {
      if (bt.error("V1 frame processing error", r), this._consecutiveFailures++, this._consecutiveFailures === e6) {
        const c = this._onInferenceFailureCb;
        this._onInferenceFailureCb = null, c == null || c();
      }
    }
  }
  /**
   * V1: downscales the camera frame into the model's input tensor.
   */
  resizeSource() {
    var h, f;
    (h = this._segmentationMaskCtx) == null || h.drawImage(
      this._inputVideoElement,
      0,
      0,
      this._inputVideoElement.width,
      this._inputVideoElement.height,
      0,
      0,
      this._options.width,
      this._options.height
    );
    const r = (f = this._segmentationMaskCtx) == null ? void 0 : f.getImageData(
      0,
      0,
      this._options.width,
      this._options.height
    ), c = this._model._getInputMemoryOffset() / 4;
    for (let v = 0; v < this._segmentationPixelCount; v++)
      this._model.HEAPF32[c + v * 3] = Number(r == null ? void 0 : r.data[v * 4]) / 255, this._model.HEAPF32[c + v * 3 + 1] = Number(r == null ? void 0 : r.data[v * 4 + 1]) / 255, this._model.HEAPF32[c + v * 3 + 2] = Number(r == null ? void 0 : r.data[v * 4 + 2]) / 255;
  }
}
function ME(s, r) {
  return new Promise((c, h) => {
    setTimeout(() => {
      h(new Error("408"));
    }, s), r.then(c, h);
  });
}
var Cv = function() {
  var s = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return typeof __filename < "u" && (s = s || __filename), function(r) {
    r = r || {};
    var c = typeof r < "u" ? r : {}, h, f;
    c.ready = new Promise(function(Z, H) {
      h = Z, f = H;
    });
    var v = {}, R;
    for (R in c)
      c.hasOwnProperty(R) && (v[R] = c[R]);
    var T = "./this.program", E = function(Z, H) {
      throw H;
    }, C = !1, N = !1, _ = !1;
    C = typeof window == "object", N = typeof importScripts == "function", typeof process == "object" && typeof process.versions == "object" && process.versions.node, _ = !C && !0 && !N;
    var V = "";
    function B(Z) {
      return c.locateFile ? c.locateFile(Z, V) : V + Z;
    }
    var ce, oe;
    _ ? (oe = function(H) {
      var Me;
      return typeof readbuffer == "function" ? new Uint8Array(readbuffer(H)) : (Me = read(H, "binary"), Te(typeof Me == "object"), Me);
    }, typeof scriptArgs < "u" && scriptArgs, typeof quit == "function" && (E = function(Z) {
      quit(Z);
    }), typeof print < "u" && (typeof console > "u" && (console = {}), console.log = print, console.warn = console.error = typeof printErr < "u" ? printErr : print)) : (C || N) && (N ? V = self.location.href : typeof document < "u" && document.currentScript && (V = document.currentScript.src), s && (V = s), V.indexOf("blob:") !== 0 ? V = V.substr(0, V.lastIndexOf("/") + 1) : V = "", N && (oe = function(Z) {
      var H = new XMLHttpRequest();
      return H.open("GET", Z, !1), H.responseType = "arraybuffer", H.send(null), new Uint8Array(H.response);
    }), ce = function(Z, H, Me) {
      var pe = new XMLHttpRequest();
      pe.open("GET", Z, !0), pe.responseType = "arraybuffer", pe.onload = function() {
        if (pe.status == 200 || pe.status == 0 && pe.response) {
          H(pe.response);
          return;
        }
        Me();
      }, pe.onerror = Me, pe.send(null);
    });
    var be = c.print || console.log.bind(console), ge = c.printErr || console.warn.bind(console);
    for (R in v)
      v.hasOwnProperty(R) && (c[R] = v[R]);
    v = null, c.arguments && c.arguments, c.thisProgram && (T = c.thisProgram), c.quit && (E = c.quit);
    var te;
    c.wasmBinary && (te = c.wasmBinary);
    var _e;
    c.noExitRuntime && (_e = c.noExitRuntime), typeof WebAssembly != "object" && Yt("no native wasm support detected");
    var Ue, j = !1;
    function Te(Z, H) {
      Z || Yt("Assertion failed: " + H);
    }
    var Ne = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
    function xe(Z, H, Me) {
      for (var pe = H + Me, mt = H; Z[mt] && !(mt >= pe); ) ++mt;
      if (mt - H > 16 && Z.subarray && Ne)
        return Ne.decode(Z.subarray(H, mt));
      for (var tt = ""; H < mt; ) {
        var et = Z[H++];
        if (!(et & 128)) {
          tt += String.fromCharCode(et);
          continue;
        }
        var _t = Z[H++] & 63;
        if ((et & 224) == 192) {
          tt += String.fromCharCode((et & 31) << 6 | _t);
          continue;
        }
        var Xt = Z[H++] & 63;
        if ((et & 240) == 224 ? et = (et & 15) << 12 | _t << 6 | Xt : et = (et & 7) << 18 | _t << 12 | Xt << 6 | Z[H++] & 63, et < 65536)
          tt += String.fromCharCode(et);
        else {
          var vn = et - 65536;
          tt += String.fromCharCode(55296 | vn >> 10, 56320 | vn & 1023);
        }
      }
      return tt;
    }
    function Fe(Z, H) {
      return Z ? xe(Ie, Z, H) : "";
    }
    function ye(Z, H, Me) {
      for (var pe = 0; pe < Z.length; ++pe)
        Oe[H++ >> 0] = Z.charCodeAt(pe);
      Oe[H >> 0] = 0;
    }
    function Ve(Z, H) {
      return Z % H > 0 && (Z += H - Z % H), Z;
    }
    var we, Oe, Ie, he;
    function O(Z) {
      we = Z, c.HEAP8 = Oe = new Int8Array(Z), c.HEAP16 = new Int16Array(Z), c.HEAP32 = he = new Int32Array(Z), c.HEAPU8 = Ie = new Uint8Array(Z), c.HEAPU16 = new Uint16Array(Z), c.HEAPU32 = new Uint32Array(Z), c.HEAPF32 = new Float32Array(Z), c.HEAPF64 = new Float64Array(Z);
    }
    c.INITIAL_MEMORY;
    var G, se = [], De = [], M = [], W = [];
    De.push({ func: function() {
      yo();
    } });
    function q() {
      if (c.preRun)
        for (typeof c.preRun == "function" && (c.preRun = [c.preRun]); c.preRun.length; )
          Ce(c.preRun.shift());
      Ci(se);
    }
    function Re() {
      Ci(De);
    }
    function $() {
      Ci(M);
    }
    function Be() {
      if (c.postRun)
        for (typeof c.postRun == "function" && (c.postRun = [c.postRun]); c.postRun.length; )
          It(c.postRun.shift());
      Ci(W);
    }
    function Ce(Z) {
      se.unshift(Z);
    }
    function It(Z) {
      W.unshift(Z);
    }
    var Pe = 0, dt = null;
    function dn(Z) {
      Pe++, c.monitorRunDependencies && c.monitorRunDependencies(Pe);
    }
    function xn(Z) {
      if (Pe--, c.monitorRunDependencies && c.monitorRunDependencies(Pe), Pe == 0 && dt) {
        var H = dt;
        dt = null, H();
      }
    }
    c.preloadedImages = {}, c.preloadedAudios = {};
    function Yt(Z) {
      c.onAbort && c.onAbort(Z), Z += "", ge(Z), j = !0, Z = "abort(" + Z + "). Build with -s ASSERTIONS=1 for more info.";
      var H = new WebAssembly.RuntimeError(Z);
      throw f(H), H;
    }
    function hn(Z, H) {
      return String.prototype.startsWith ? Z.startsWith(H) : Z.indexOf(H) === 0;
    }
    var Aa = "data:application/octet-stream;base64,";
    function sr(Z) {
      return hn(Z, Aa);
    }
    var Tn = "file://";
    function yn(Z) {
      return hn(Z, Tn);
    }
    var Bt = "tflite.wasm";
    sr(Bt) || (Bt = B(Bt));
    function Vr(Z) {
      try {
        if (Z == Bt && te)
          return new Uint8Array(te);
        if (oe)
          return oe(Z);
        throw "both async and sync fetching of the wasm failed";
      } catch (H) {
        Yt(H);
      }
    }
    function vt() {
      if (!te && (C || N)) {
        if (typeof fetch == "function" && !yn(Bt))
          return fetch(Bt, { credentials: "same-origin" }).then(function(Z) {
            if (!Z.ok)
              throw "failed to load wasm binary file at '" + Bt + "'";
            return Z.arrayBuffer();
          }).catch(function() {
            return Vr(Bt);
          });
        if (ce)
          return new Promise(function(Z, H) {
            ce(Bt, function(Me) {
              Z(new Uint8Array(Me));
            }, H);
          });
      }
      return Promise.resolve().then(function() {
        return Vr(Bt);
      });
    }
    function ea() {
      var Z = { a: is };
      function H(et, _t) {
        var Xt = et.exports;
        c.asm = Xt, Ue = c.asm.q, O(Ue.buffer), G = c.asm.D, xn();
      }
      dn();
      function Me(et) {
        H(et.instance);
      }
      function pe(et) {
        return vt().then(function(_t) {
          return WebAssembly.instantiate(_t, Z);
        }).then(et, function(_t) {
          ge("failed to asynchronously prepare wasm: " + _t), Yt(_t);
        });
      }
      function mt() {
        return !te && typeof WebAssembly.instantiateStreaming == "function" && !sr(Bt) && !yn(Bt) && typeof fetch == "function" ? fetch(Bt, { credentials: "same-origin" }).then(function(et) {
          var _t = WebAssembly.instantiateStreaming(et, Z);
          return _t.then(Me, function(Xt) {
            return ge("wasm streaming compile failed: " + Xt), ge("falling back to ArrayBuffer instantiation"), pe(Me);
          });
        }) : pe(Me);
      }
      if (c.instantiateWasm)
        try {
          var tt = c.instantiateWasm(Z, H);
          return tt;
        } catch (et) {
          return ge("Module.instantiateWasm callback failed with error: " + et), !1;
        }
      return mt().catch(f), {};
    }
    function Ci(Z) {
      for (; Z.length > 0; ) {
        var H = Z.shift();
        if (typeof H == "function") {
          H(c);
          continue;
        }
        var Me = H.func;
        typeof Me == "number" ? H.arg === void 0 ? G.get(Me)() : G.get(Me)(H.arg) : Me(H.arg === void 0 ? null : H.arg);
      }
    }
    function Ta() {
      Yt();
    }
    var Vi;
    typeof dateNow < "u" ? Vi = dateNow : Vi = function() {
      return performance.now();
    };
    var Uo = !0;
    function ta(Z) {
      return he[gn() >> 2] = Z, Z;
    }
    function jn(Z, H) {
      var Me;
      if (Z === 0)
        Me = Date.now();
      else if ((Z === 1 || Z === 4) && Uo)
        Me = Vi();
      else
        return ta(28), -1;
      return he[H >> 2] = Me / 1e3 | 0, he[H + 4 >> 2] = Me % 1e3 * 1e3 * 1e3 | 0, 0;
    }
    function _i(Z, H) {
      Yt("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
    }
    function Pn(Z, H) {
      Yt("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
    }
    function _r(Z, H, Me) {
      Ie.copyWithin(Z, H, H + Me);
    }
    function To() {
      return Ie.length;
    }
    function Fr(Z) {
      try {
        return Ue.grow(Z - we.byteLength + 65535 >>> 16), O(Ue.buffer), 1;
      } catch {
      }
    }
    function Ii(Z) {
      Z = Z >>> 0;
      var H = To(), Me = 2147483648;
      if (Z > Me)
        return !1;
      for (var pe = 16777216, mt = 1; mt <= 4; mt *= 2) {
        var tt = H * (1 + 0.2 / mt);
        tt = Math.min(tt, Z + 100663296);
        var et = Math.min(Me, Ve(Math.max(pe, Z, tt), 65536)), _t = Fr(et);
        if (_t)
          return !0;
      }
      return !1;
    }
    function oi(Z) {
      for (var H = Vi(); Vi() - H < Z; )
        ;
    }
    var Mn = {};
    function Li() {
      return T || "./this.program";
    }
    function F() {
      if (!F.strings) {
        var Z = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", H = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: Z, _: Li() };
        for (var Me in Mn)
          H[Me] = Mn[Me];
        var pe = [];
        for (var Me in H)
          pe.push(Me + "=" + H[Me]);
        F.strings = pe;
      }
      return F.strings;
    }
    var z = { mappings: {}, buffers: [null, [], []], printChar: function(Z, H) {
      var Me = z.buffers[Z];
      H === 0 || H === 10 ? ((Z === 1 ? be : ge)(xe(Me, 0)), Me.length = 0) : Me.push(H);
    }, varargs: void 0, get: function() {
      z.varargs += 4;
      var Z = he[z.varargs - 4 >> 2];
      return Z;
    }, getStr: function(Z) {
      var H = Fe(Z);
      return H;
    }, get64: function(Z, H) {
      return Z;
    } };
    function Ze(Z, H) {
      var Me = 0;
      return F().forEach(function(pe, mt) {
        var tt = H + Me;
        he[Z + mt * 4 >> 2] = tt, ye(pe, tt), Me += pe.length + 1;
      }), 0;
    }
    function Ae(Z, H) {
      var Me = F();
      he[Z >> 2] = Me.length;
      var pe = 0;
      return Me.forEach(function(mt) {
        pe += mt.length + 1;
      }), he[H >> 2] = pe, 0;
    }
    function Ye(Z) {
      as(Z);
    }
    function ut(Z) {
      return 0;
    }
    function gt(Z, H, Me, pe, mt) {
    }
    function Vt(Z, H, Me, pe) {
      for (var mt = 0, tt = 0; tt < Me; tt++) {
        for (var et = he[H + tt * 8 >> 2], _t = he[H + (tt * 8 + 4) >> 2], Xt = 0; Xt < _t; Xt++)
          z.printChar(Z, Ie[et + Xt]);
        mt += _t;
      }
      return he[pe >> 2] = mt, 0;
    }
    function ht() {
      return 6;
    }
    function Nn() {
      return 28;
    }
    function Ji(Z) {
      switch (Z) {
        case 30:
          return 16384;
        case 85:
          var H = 2147483648;
          return H / 16384;
        case 132:
        case 133:
        case 12:
        case 137:
        case 138:
        case 15:
        case 235:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 149:
        case 13:
        case 10:
        case 236:
        case 153:
        case 9:
        case 21:
        case 22:
        case 159:
        case 154:
        case 14:
        case 77:
        case 78:
        case 139:
        case 82:
        case 68:
        case 67:
        case 164:
        case 11:
        case 29:
        case 47:
        case 48:
        case 95:
        case 52:
        case 51:
        case 46:
          return 200809;
        case 27:
        case 246:
        case 127:
        case 128:
        case 23:
        case 24:
        case 160:
        case 161:
        case 181:
        case 182:
        case 242:
        case 183:
        case 184:
        case 243:
        case 244:
        case 245:
        case 165:
        case 178:
        case 179:
        case 49:
        case 50:
        case 168:
        case 169:
        case 175:
        case 170:
        case 171:
        case 172:
        case 97:
        case 76:
        case 32:
        case 173:
        case 35:
        case 80:
        case 81:
        case 79:
          return -1;
        case 176:
        case 177:
        case 7:
        case 155:
        case 8:
        case 157:
        case 125:
        case 126:
        case 92:
        case 93:
        case 129:
        case 130:
        case 131:
        case 94:
        case 91:
          return 1;
        case 74:
        case 60:
        case 69:
        case 70:
        case 4:
          return 1024;
        case 31:
        case 42:
        case 72:
          return 32;
        case 87:
        case 26:
        case 33:
          return 2147483647;
        case 34:
        case 1:
          return 47839;
        case 38:
        case 36:
          return 99;
        case 43:
        case 37:
          return 2048;
        case 0:
          return 2097152;
        case 3:
          return 65536;
        case 28:
          return 32768;
        case 44:
          return 32767;
        case 75:
          return 16384;
        case 39:
          return 1e3;
        case 89:
          return 700;
        case 71:
          return 256;
        case 40:
          return 255;
        case 2:
          return 100;
        case 180:
          return 64;
        case 25:
          return 20;
        case 5:
          return 16;
        case 6:
          return 6;
        case 73:
          return 4;
        case 84:
          return typeof navigator == "object" && navigator.hardwareConcurrency || 1;
      }
      return ta(28), -1;
    }
    var is = { a: Ta, n: jn, i: _i, e: Pn, l: _r, m: Ii, o: oi, p: Ze, g: Ae, j: Ye, h: ut, k: gt, c: Vt, d: ht, f: Nn, b: Ji };
    ea();
    var yo = c.___wasm_call_ctors = function() {
      return (yo = c.___wasm_call_ctors = c.asm.r).apply(null, arguments);
    };
    c._getModelBufferMemoryOffset = function() {
      return (c._getModelBufferMemoryOffset = c.asm.s).apply(null, arguments);
    }, c._getInputMemoryOffset = function() {
      return (c._getInputMemoryOffset = c.asm.t).apply(null, arguments);
    }, c._getInputHeight = function() {
      return (c._getInputHeight = c.asm.u).apply(null, arguments);
    }, c._getInputWidth = function() {
      return (c._getInputWidth = c.asm.v).apply(null, arguments);
    }, c._getInputChannelCount = function() {
      return (c._getInputChannelCount = c.asm.w).apply(null, arguments);
    }, c._getOutputMemoryOffset = function() {
      return (c._getOutputMemoryOffset = c.asm.x).apply(null, arguments);
    }, c._getOutputHeight = function() {
      return (c._getOutputHeight = c.asm.y).apply(null, arguments);
    }, c._getOutputWidth = function() {
      return (c._getOutputWidth = c.asm.z).apply(null, arguments);
    }, c._getOutputChannelCount = function() {
      return (c._getOutputChannelCount = c.asm.A).apply(null, arguments);
    }, c._loadModel = function() {
      return (c._loadModel = c.asm.B).apply(null, arguments);
    }, c._runInference = function() {
      return (c._runInference = c.asm.C).apply(null, arguments);
    };
    var gn = c.___errno_location = function() {
      return (gn = c.___errno_location = c.asm.E).apply(null, arguments);
    }, rn;
    function qn(Z) {
      this.name = "ExitStatus", this.message = "Program terminated with exit(" + Z + ")", this.status = Z;
    }
    dt = function Z() {
      rn || na(), rn || (dt = Z);
    };
    function na(Z) {
      if (Pe > 0 || (q(), Pe > 0))
        return;
      function H() {
        rn || (rn = !0, c.calledRun = !0, !j && (Re(), $(), h(c), c.onRuntimeInitialized && c.onRuntimeInitialized(), Be()));
      }
      c.setStatus ? (c.setStatus("Running..."), setTimeout(function() {
        setTimeout(function() {
          c.setStatus("");
        }, 1), H();
      }, 1)) : H();
    }
    c.run = na;
    function as(Z, H) {
      _e || (c.onExit && c.onExit(Z), j = !0), E(Z, new qn(Z));
    }
    if (c.preInit)
      for (typeof c.preInit == "function" && (c.preInit = [c.preInit]); c.preInit.length > 0; )
        c.preInit.pop()();
    return _e = !0, na(), r.ready;
  };
}();
typeof exports == "object" && typeof module == "object" ? module.exports = Cv : typeof define == "function" && define.amd ? define([], function() {
  return Cv;
}) : typeof exports == "object" && (exports.createTFLiteModule = Cv);
var Vv = function() {
  var s = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return typeof __filename < "u" && (s = s || __filename), function(r) {
    r = r || {};
    var c = typeof r < "u" ? r : {}, h, f;
    c.ready = new Promise(function(Z, H) {
      h = Z, f = H;
    });
    var v = {}, R;
    for (R in c)
      c.hasOwnProperty(R) && (v[R] = c[R]);
    var T = "./this.program", E = function(Z, H) {
      throw H;
    }, C = !1, N = !1, _ = !1;
    C = typeof window == "object", N = typeof importScripts == "function", typeof process == "object" && typeof process.versions == "object" && process.versions.node, _ = !C && !0 && !N;
    var V = "";
    function B(Z) {
      return c.locateFile ? c.locateFile(Z, V) : V + Z;
    }
    var ce, oe;
    _ ? (oe = function(H) {
      var Me;
      return typeof readbuffer == "function" ? new Uint8Array(readbuffer(H)) : (Me = read(H, "binary"), Te(typeof Me == "object"), Me);
    }, typeof scriptArgs < "u" && scriptArgs, typeof quit == "function" && (E = function(Z) {
      quit(Z);
    }), typeof print < "u" && (typeof console > "u" && (console = {}), console.log = print, console.warn = console.error = typeof printErr < "u" ? printErr : print)) : (C || N) && (N ? V = self.location.href : typeof document < "u" && document.currentScript && (V = document.currentScript.src), s && (V = s), V.indexOf("blob:") !== 0 ? V = V.substr(0, V.lastIndexOf("/") + 1) : V = "", N && (oe = function(Z) {
      var H = new XMLHttpRequest();
      return H.open("GET", Z, !1), H.responseType = "arraybuffer", H.send(null), new Uint8Array(H.response);
    }), ce = function(Z, H, Me) {
      var pe = new XMLHttpRequest();
      pe.open("GET", Z, !0), pe.responseType = "arraybuffer", pe.onload = function() {
        if (pe.status == 200 || pe.status == 0 && pe.response) {
          H(pe.response);
          return;
        }
        Me();
      }, pe.onerror = Me, pe.send(null);
    });
    var be = c.print || console.log.bind(console), ge = c.printErr || console.warn.bind(console);
    for (R in v)
      v.hasOwnProperty(R) && (c[R] = v[R]);
    v = null, c.arguments && c.arguments, c.thisProgram && (T = c.thisProgram), c.quit && (E = c.quit);
    var te;
    c.wasmBinary && (te = c.wasmBinary);
    var _e;
    c.noExitRuntime && (_e = c.noExitRuntime), typeof WebAssembly != "object" && Yt("no native wasm support detected");
    var Ue, j = !1;
    function Te(Z, H) {
      Z || Yt("Assertion failed: " + H);
    }
    var Ne = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
    function xe(Z, H, Me) {
      for (var pe = H + Me, mt = H; Z[mt] && !(mt >= pe); ) ++mt;
      if (mt - H > 16 && Z.subarray && Ne)
        return Ne.decode(Z.subarray(H, mt));
      for (var tt = ""; H < mt; ) {
        var et = Z[H++];
        if (!(et & 128)) {
          tt += String.fromCharCode(et);
          continue;
        }
        var _t = Z[H++] & 63;
        if ((et & 224) == 192) {
          tt += String.fromCharCode((et & 31) << 6 | _t);
          continue;
        }
        var Xt = Z[H++] & 63;
        if ((et & 240) == 224 ? et = (et & 15) << 12 | _t << 6 | Xt : et = (et & 7) << 18 | _t << 12 | Xt << 6 | Z[H++] & 63, et < 65536)
          tt += String.fromCharCode(et);
        else {
          var vn = et - 65536;
          tt += String.fromCharCode(55296 | vn >> 10, 56320 | vn & 1023);
        }
      }
      return tt;
    }
    function Fe(Z, H) {
      return Z ? xe(Ie, Z, H) : "";
    }
    function ye(Z, H, Me) {
      for (var pe = 0; pe < Z.length; ++pe)
        Oe[H++ >> 0] = Z.charCodeAt(pe);
      Oe[H >> 0] = 0;
    }
    function Ve(Z, H) {
      return Z % H > 0 && (Z += H - Z % H), Z;
    }
    var we, Oe, Ie, he;
    function O(Z) {
      we = Z, c.HEAP8 = Oe = new Int8Array(Z), c.HEAP16 = new Int16Array(Z), c.HEAP32 = he = new Int32Array(Z), c.HEAPU8 = Ie = new Uint8Array(Z), c.HEAPU16 = new Uint16Array(Z), c.HEAPU32 = new Uint32Array(Z), c.HEAPF32 = new Float32Array(Z), c.HEAPF64 = new Float64Array(Z);
    }
    c.INITIAL_MEMORY;
    var G, se = [], De = [], M = [], W = [];
    De.push({ func: function() {
      yo();
    } });
    function q() {
      if (c.preRun)
        for (typeof c.preRun == "function" && (c.preRun = [c.preRun]); c.preRun.length; )
          Ce(c.preRun.shift());
      Ci(se);
    }
    function Re() {
      Ci(De);
    }
    function $() {
      Ci(M);
    }
    function Be() {
      if (c.postRun)
        for (typeof c.postRun == "function" && (c.postRun = [c.postRun]); c.postRun.length; )
          It(c.postRun.shift());
      Ci(W);
    }
    function Ce(Z) {
      se.unshift(Z);
    }
    function It(Z) {
      W.unshift(Z);
    }
    var Pe = 0, dt = null;
    function dn(Z) {
      Pe++, c.monitorRunDependencies && c.monitorRunDependencies(Pe);
    }
    function xn(Z) {
      if (Pe--, c.monitorRunDependencies && c.monitorRunDependencies(Pe), Pe == 0 && dt) {
        var H = dt;
        dt = null, H();
      }
    }
    c.preloadedImages = {}, c.preloadedAudios = {};
    function Yt(Z) {
      c.onAbort && c.onAbort(Z), Z += "", ge(Z), j = !0, Z = "abort(" + Z + "). Build with -s ASSERTIONS=1 for more info.";
      var H = new WebAssembly.RuntimeError(Z);
      throw f(H), H;
    }
    function hn(Z, H) {
      return String.prototype.startsWith ? Z.startsWith(H) : Z.indexOf(H) === 0;
    }
    var Aa = "data:application/octet-stream;base64,";
    function sr(Z) {
      return hn(Z, Aa);
    }
    var Tn = "file://";
    function yn(Z) {
      return hn(Z, Tn);
    }
    var Bt = "tflite-simd.wasm";
    sr(Bt) || (Bt = B(Bt));
    function Vr(Z) {
      try {
        if (Z == Bt && te)
          return new Uint8Array(te);
        if (oe)
          return oe(Z);
        throw "both async and sync fetching of the wasm failed";
      } catch (H) {
        Yt(H);
      }
    }
    function vt() {
      if (!te && (C || N)) {
        if (typeof fetch == "function" && !yn(Bt))
          return fetch(Bt, { credentials: "same-origin" }).then(function(Z) {
            if (!Z.ok)
              throw "failed to load wasm binary file at '" + Bt + "'";
            return Z.arrayBuffer();
          }).catch(function() {
            return Vr(Bt);
          });
        if (ce)
          return new Promise(function(Z, H) {
            ce(Bt, function(Me) {
              Z(new Uint8Array(Me));
            }, H);
          });
      }
      return Promise.resolve().then(function() {
        return Vr(Bt);
      });
    }
    function ea() {
      var Z = { a: is };
      function H(et, _t) {
        var Xt = et.exports;
        c.asm = Xt, Ue = c.asm.q, O(Ue.buffer), G = c.asm.D, xn();
      }
      dn();
      function Me(et) {
        H(et.instance);
      }
      function pe(et) {
        return vt().then(function(_t) {
          return WebAssembly.instantiate(_t, Z);
        }).then(et, function(_t) {
          ge("failed to asynchronously prepare wasm: " + _t), Yt(_t);
        });
      }
      function mt() {
        return !te && typeof WebAssembly.instantiateStreaming == "function" && !sr(Bt) && !yn(Bt) && typeof fetch == "function" ? fetch(Bt, { credentials: "same-origin" }).then(function(et) {
          var _t = WebAssembly.instantiateStreaming(et, Z);
          return _t.then(Me, function(Xt) {
            return ge("wasm streaming compile failed: " + Xt), ge("falling back to ArrayBuffer instantiation"), pe(Me);
          });
        }) : pe(Me);
      }
      if (c.instantiateWasm)
        try {
          var tt = c.instantiateWasm(Z, H);
          return tt;
        } catch (et) {
          return ge("Module.instantiateWasm callback failed with error: " + et), !1;
        }
      return mt().catch(f), {};
    }
    function Ci(Z) {
      for (; Z.length > 0; ) {
        var H = Z.shift();
        if (typeof H == "function") {
          H(c);
          continue;
        }
        var Me = H.func;
        typeof Me == "number" ? H.arg === void 0 ? G.get(Me)() : G.get(Me)(H.arg) : Me(H.arg === void 0 ? null : H.arg);
      }
    }
    function Ta() {
      Yt();
    }
    var Vi;
    typeof dateNow < "u" ? Vi = dateNow : Vi = function() {
      return performance.now();
    };
    var Uo = !0;
    function ta(Z) {
      return he[gn() >> 2] = Z, Z;
    }
    function jn(Z, H) {
      var Me;
      if (Z === 0)
        Me = Date.now();
      else if ((Z === 1 || Z === 4) && Uo)
        Me = Vi();
      else
        return ta(28), -1;
      return he[H >> 2] = Me / 1e3 | 0, he[H + 4 >> 2] = Me % 1e3 * 1e3 * 1e3 | 0, 0;
    }
    function _i(Z, H) {
      Yt("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
    }
    function Pn(Z, H) {
      Yt("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
    }
    function _r(Z, H, Me) {
      Ie.copyWithin(Z, H, H + Me);
    }
    function To() {
      return Ie.length;
    }
    function Fr(Z) {
      try {
        return Ue.grow(Z - we.byteLength + 65535 >>> 16), O(Ue.buffer), 1;
      } catch {
      }
    }
    function Ii(Z) {
      Z = Z >>> 0;
      var H = To(), Me = 2147483648;
      if (Z > Me)
        return !1;
      for (var pe = 16777216, mt = 1; mt <= 4; mt *= 2) {
        var tt = H * (1 + 0.2 / mt);
        tt = Math.min(tt, Z + 100663296);
        var et = Math.min(Me, Ve(Math.max(pe, Z, tt), 65536)), _t = Fr(et);
        if (_t)
          return !0;
      }
      return !1;
    }
    function oi(Z) {
      for (var H = Vi(); Vi() - H < Z; )
        ;
    }
    var Mn = {};
    function Li() {
      return T || "./this.program";
    }
    function F() {
      if (!F.strings) {
        var Z = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", H = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: Z, _: Li() };
        for (var Me in Mn)
          H[Me] = Mn[Me];
        var pe = [];
        for (var Me in H)
          pe.push(Me + "=" + H[Me]);
        F.strings = pe;
      }
      return F.strings;
    }
    var z = { mappings: {}, buffers: [null, [], []], printChar: function(Z, H) {
      var Me = z.buffers[Z];
      H === 0 || H === 10 ? ((Z === 1 ? be : ge)(xe(Me, 0)), Me.length = 0) : Me.push(H);
    }, varargs: void 0, get: function() {
      z.varargs += 4;
      var Z = he[z.varargs - 4 >> 2];
      return Z;
    }, getStr: function(Z) {
      var H = Fe(Z);
      return H;
    }, get64: function(Z, H) {
      return Z;
    } };
    function Ze(Z, H) {
      var Me = 0;
      return F().forEach(function(pe, mt) {
        var tt = H + Me;
        he[Z + mt * 4 >> 2] = tt, ye(pe, tt), Me += pe.length + 1;
      }), 0;
    }
    function Ae(Z, H) {
      var Me = F();
      he[Z >> 2] = Me.length;
      var pe = 0;
      return Me.forEach(function(mt) {
        pe += mt.length + 1;
      }), he[H >> 2] = pe, 0;
    }
    function Ye(Z) {
      as(Z);
    }
    function ut(Z) {
      return 0;
    }
    function gt(Z, H, Me, pe, mt) {
    }
    function Vt(Z, H, Me, pe) {
      for (var mt = 0, tt = 0; tt < Me; tt++) {
        for (var et = he[H + tt * 8 >> 2], _t = he[H + (tt * 8 + 4) >> 2], Xt = 0; Xt < _t; Xt++)
          z.printChar(Z, Ie[et + Xt]);
        mt += _t;
      }
      return he[pe >> 2] = mt, 0;
    }
    function ht() {
      return 6;
    }
    function Nn() {
      return 28;
    }
    function Ji(Z) {
      switch (Z) {
        case 30:
          return 16384;
        case 85:
          var H = 2147483648;
          return H / 16384;
        case 132:
        case 133:
        case 12:
        case 137:
        case 138:
        case 15:
        case 235:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 149:
        case 13:
        case 10:
        case 236:
        case 153:
        case 9:
        case 21:
        case 22:
        case 159:
        case 154:
        case 14:
        case 77:
        case 78:
        case 139:
        case 82:
        case 68:
        case 67:
        case 164:
        case 11:
        case 29:
        case 47:
        case 48:
        case 95:
        case 52:
        case 51:
        case 46:
          return 200809;
        case 27:
        case 246:
        case 127:
        case 128:
        case 23:
        case 24:
        case 160:
        case 161:
        case 181:
        case 182:
        case 242:
        case 183:
        case 184:
        case 243:
        case 244:
        case 245:
        case 165:
        case 178:
        case 179:
        case 49:
        case 50:
        case 168:
        case 169:
        case 175:
        case 170:
        case 171:
        case 172:
        case 97:
        case 76:
        case 32:
        case 173:
        case 35:
        case 80:
        case 81:
        case 79:
          return -1;
        case 176:
        case 177:
        case 7:
        case 155:
        case 8:
        case 157:
        case 125:
        case 126:
        case 92:
        case 93:
        case 129:
        case 130:
        case 131:
        case 94:
        case 91:
          return 1;
        case 74:
        case 60:
        case 69:
        case 70:
        case 4:
          return 1024;
        case 31:
        case 42:
        case 72:
          return 32;
        case 87:
        case 26:
        case 33:
          return 2147483647;
        case 34:
        case 1:
          return 47839;
        case 38:
        case 36:
          return 99;
        case 43:
        case 37:
          return 2048;
        case 0:
          return 2097152;
        case 3:
          return 65536;
        case 28:
          return 32768;
        case 44:
          return 32767;
        case 75:
          return 16384;
        case 39:
          return 1e3;
        case 89:
          return 700;
        case 71:
          return 256;
        case 40:
          return 255;
        case 2:
          return 100;
        case 180:
          return 64;
        case 25:
          return 20;
        case 5:
          return 16;
        case 6:
          return 6;
        case 73:
          return 4;
        case 84:
          return typeof navigator == "object" && navigator.hardwareConcurrency || 1;
      }
      return ta(28), -1;
    }
    var is = { a: Ta, n: jn, i: _i, e: Pn, l: _r, m: Ii, o: oi, p: Ze, g: Ae, j: Ye, h: ut, k: gt, c: Vt, d: ht, f: Nn, b: Ji };
    ea();
    var yo = c.___wasm_call_ctors = function() {
      return (yo = c.___wasm_call_ctors = c.asm.r).apply(null, arguments);
    };
    c._getModelBufferMemoryOffset = function() {
      return (c._getModelBufferMemoryOffset = c.asm.s).apply(null, arguments);
    }, c._getInputMemoryOffset = function() {
      return (c._getInputMemoryOffset = c.asm.t).apply(null, arguments);
    }, c._getInputHeight = function() {
      return (c._getInputHeight = c.asm.u).apply(null, arguments);
    }, c._getInputWidth = function() {
      return (c._getInputWidth = c.asm.v).apply(null, arguments);
    }, c._getInputChannelCount = function() {
      return (c._getInputChannelCount = c.asm.w).apply(null, arguments);
    }, c._getOutputMemoryOffset = function() {
      return (c._getOutputMemoryOffset = c.asm.x).apply(null, arguments);
    }, c._getOutputHeight = function() {
      return (c._getOutputHeight = c.asm.y).apply(null, arguments);
    }, c._getOutputWidth = function() {
      return (c._getOutputWidth = c.asm.z).apply(null, arguments);
    }, c._getOutputChannelCount = function() {
      return (c._getOutputChannelCount = c.asm.A).apply(null, arguments);
    }, c._loadModel = function() {
      return (c._loadModel = c.asm.B).apply(null, arguments);
    }, c._runInference = function() {
      return (c._runInference = c.asm.C).apply(null, arguments);
    };
    var gn = c.___errno_location = function() {
      return (gn = c.___errno_location = c.asm.E).apply(null, arguments);
    }, rn;
    function qn(Z) {
      this.name = "ExitStatus", this.message = "Program terminated with exit(" + Z + ")", this.status = Z;
    }
    dt = function Z() {
      rn || na(), rn || (dt = Z);
    };
    function na(Z) {
      if (Pe > 0 || (q(), Pe > 0))
        return;
      function H() {
        rn || (rn = !0, c.calledRun = !0, !j && (Re(), $(), h(c), c.onRuntimeInitialized && c.onRuntimeInitialized(), Be()));
      }
      c.setStatus ? (c.setStatus("Running..."), setTimeout(function() {
        setTimeout(function() {
          c.setStatus("");
        }, 1), H();
      }, 1)) : H();
    }
    c.run = na;
    function as(Z, H) {
      _e || (c.onExit && c.onExit(Z), j = !0), E(Z, new qn(Z));
    }
    if (c.preInit)
      for (typeof c.preInit == "function" && (c.preInit = [c.preInit]); c.preInit.length > 0; )
        c.preInit.pop()();
    return _e = !0, na(), r.ready;
  };
}();
typeof exports == "object" && typeof module == "object" ? module.exports = Vv : typeof define == "function" && define.amd ? define([], function() {
  return Vv;
}) : typeof exports == "object" && (exports.createTFLiteSIMDModule = Vv);
let vv, mu, kE = !1, QT = !1;
async function H9(s) {
  if (!MediaStreamTrack.prototype.getSettings && !MediaStreamTrack.prototype.getConstraints)
    throw new Error("JitsiStreamBackgroundEffect not supported!");
  const r = S2();
  if (r.enableV2 && !QT) {
    const c = await z9(s, r);
    if (c)
      return c;
  }
  return j9(s, r);
}
async function z9(s, r) {
  let c;
  try {
    const h = await U9(r.advanced);
    return bt.info(
      `Using V2 engine — tier: ${h.tier}, backend: ${h.backend}`
    ), c = new DT(void 0, s, {
      capabilities: h,
      assetsBaseUrl: r.assetsBaseUrl,
      vbConfig: r.advanced
    }), await c.init(), c;
  } catch (h) {
    QT = !0, bt.error(
      "V2 engine failed to initialise — falling back to V1 for this page",
      h
    ), c == null || c.dispose();
    return;
  }
}
async function j9(s, r) {
  if (kE)
    return;
  const c = (h) => u2(h, r.assetsBaseUrl);
  if (!mu)
    try {
      T9() ? mu = await ME(
        1e4,
        Vv({ locateFile: c })
      ) : mu = await ME(
        1e4,
        Cv({ locateFile: c })
      );
    } catch (h) {
      (h == null ? void 0 : h.message) === "408" ? bt.error("Failed to download tflite runtime!") : (kE = !0, bt.error(
        "Looks like WebAssembly is disabled or not supported on this browser",
        h
      ));
      return;
    }
  if (!vv) {
    const h = await fetch(
      u2($R.TFLITE_MODEL, r.assetsBaseUrl)
    );
    if (!h.ok)
      throw new Error("Failed to download tflite model!");
    vv = await h.arrayBuffer(), mu.HEAPU8.set(
      new Uint8Array(vv),
      mu._getModelBufferMemoryOffset()
    ), mu._loadModel(vv.byteLength);
  }
  return new DT(mu, s);
}
const h2 = {
  virtualSource: void 0,
  backgroundType: "none",
  blurValue: void 0
}, Kv = "unlisted";
function P9(s) {
  return `image:${s.src}`;
}
function O6(s) {
  const r = [
    { id: "none", type: "none", label: "None", selected: !1 }
  ];
  s.allowBlur && r.push(
    {
      id: "half-blur",
      type: "blur",
      label: "Slightly Blur",
      selected: !1
    },
    { id: "blur", type: "blur", label: "Blur", selected: !1 }
  ), s.allowUserImages && r.push({
    id: "add-background",
    type: "add",
    label: "Add Background",
    selected: !1
  });
  const h = (s.images ?? _T).map((f) => ({
    id: P9(f),
    type: "image",
    src: f.src,
    label: f.label,
    selected: !1
  }));
  return [...r, ...h];
}
const G9 = {
  previewVirtualBackground: {
    backgroundType: "none"
  },
  virtualBackground: {
    backgroundType: "none"
  },
  selectedBackgroundId: "none",
  backgrounds: O6(S2())
};
function Av(s, r) {
  return s === "none" ? h2 : s === "half-blur" ? { virtualSource: void 0, backgroundType: "blur", blurValue: 8 } : s === "blur" ? { virtualSource: void 0, backgroundType: "blur", blurValue: 25 } : { virtualSource: r, backgroundType: "image", blurValue: void 0 };
}
function xT(s) {
  return s.id === "none" || s.id === "half-blur" || s.id === "blur" ? Av(s.id) : s.src ? Av("image", s.src) : void 0;
}
function Y9(s, r) {
  var c;
  return (c = s.find((h) => {
    const f = xT(h);
    return f !== void 0 && f.backgroundType === r.backgroundType && f.blurValue === r.blurValue && f.virtualSource === r.virtualSource;
  })) == null ? void 0 : c.id;
}
const pn = x6()(
  d9(
    m9(
      Z6(G9, (s) => ({
        setPreviewVirtualBackground: (r, ...c) => {
          pn.setState(() => ({
            previewVirtualBackground: Av(r, c[0])
          }));
        },
        setVirtualBackground: (r, ...c) => {
          pn.setState(() => ({
            virtualBackground: Av(r, c[0])
          }));
        },
        promotePreviewVirtualBackground: () => {
          s((r) => ({
            virtualBackground: r.previewVirtualBackground
          }));
        },
        selectBackground: (r) => {
          s((c) => ({ backgrounds: c.backgrounds.map((f) => ({
            ...f,
            selected: f.id === r
          })) }));
        },
        reset: () => s((r) => ({
          backgrounds: O6(
            S2()
          ).map((c) => ({
            ...c,
            selected: c.id === r.selectedBackgroundId
          })),
          virtualBackground: r.virtualBackground,
          previewVirtualBackground: r.previewVirtualBackground,
          selectedBackgroundId: r.selectedBackgroundId
        }))
      })),
      {
        name: "cometchat-vb-store",
        partialize: (s) => ({
          virtualBackground: s.virtualBackground,
          previewVirtualBackground: s.previewVirtualBackground,
          selectedBackgroundId: s.selectedBackgroundId
        })
      }
    )
  )
), qv = {
  local: { seq: 0, chain: Promise.resolve() },
  preview: { seq: 0, chain: Promise.resolve() }
};
function t6(s) {
  return !!s && s.disposed !== !0 && !L4(s);
}
function X9(s) {
  return !!s.backgroundType && s.backgroundType !== "none";
}
async function DE(s, r) {
  const c = s.effect;
  if (s.effect = void 0, t6(r))
    try {
      await Jv(r, void 0);
    } catch (h) {
      bt.warn("Failed to clear effect from track", h);
    }
  c == null || c.dispose();
}
function $v(s, r, c) {
  const h = qv[s], f = ++h.seq;
  return h.chain = h.chain.then(async () => {
    var T;
    if (f !== h.seq)
      return;
    if (!t6(r)) {
      (T = h.effect) == null || T.dispose(), h.effect = void 0;
      return;
    }
    if (!X9(c)) {
      await DE(h, r);
      return;
    }
    let v;
    try {
      v = await H9(c);
    } catch (E) {
      bt.error("Failed to create the virtual background effect", E);
    }
    if (f !== h.seq || !t6(r)) {
      v == null || v.dispose();
      return;
    }
    if (!v) {
      s === "local" ? n6(s, "initialization") : await DE(h, r);
      return;
    }
    if (v.backgroundImageFailed) {
      v.dispose(), n6(s, "image");
      return;
    }
    v.onInferenceFailure = () => QE(
      s,
      v,
      v.backgroundImageFailed ? "image" : "inference"
    );
    const R = h.effect;
    try {
      await Jv(r, v);
    } catch (E) {
      throw v.dispose(), E;
    }
    h.effect = v, R && R !== v && R.dispose();
    try {
      await v.initPromise;
    } catch (E) {
      bt.error("Virtual background effect failed to start", E), QE(s, v, "initialization");
      return;
    }
    s === "local" && Iv && (Iv = !1, Zv());
  }).catch((v) => {
    bt.error(`Failed to apply ${s} virtual background`, v);
  }), h.chain;
}
function ZT(s) {
  const r = qv[s];
  return r.seq++, r.chain = r.chain.then(() => {
    var c;
    (c = r.effect) == null || c.dispose(), r.effect = void 0;
  }), r.chain;
}
function QE(s, r, c) {
  if (qv[s].effect !== r) {
    r.dispose();
    return;
  }
  n6(s, c);
}
let Iv = !1;
function n6(s, r) {
  var R;
  if (bt.error(`Virtual background failure on ${s} track: ${r}`), s === "preview") {
    pn.getState().selectBackground("none"), xE(!1);
    return;
  }
  const c = fn(We.VIDEO), h = (c == null ? void 0 : c.muted) === 0;
  h && (Iv = !0, v2());
  const f = pn.getState().virtualBackground, v = Promise.resolve((R = c == null ? void 0 : c.originalTrack) == null ? void 0 : R.mute());
  v.then(
    () => {
      pn.getState().virtualBackground === f && pn.setState({
        virtualBackground: h2,
        selectedBackgroundId: "none"
      });
    },
    (T) => bt.error("Failed to pause the video after the failure", T)
  ), q9(qv[s], v), Je.publish({
    type: Cu.MediaEventsListener.onVirtualBackgroundFailed,
    payload: { reason: r }
  }), xE(h);
}
const K9 = 5e3;
function q9(s, r) {
  s.chain = s.chain.then(
    () => new Promise((c) => {
      const h = setTimeout(() => {
        bt.warn("The video did not pause in time after the failure"), c();
      }, K9), f = () => {
        clearTimeout(h), c();
      };
      r.then(f, f);
    })
  );
}
function xE(s) {
  Kh({
    id: "virtual-background-failed",
    type: "error",
    message: c2(
      s ? "virtualBackground.effectErrorVideoPaused" : "virtualBackground.effectError"
    )
  });
}
function w6(s) {
  pn.setState((r) => {
    const c = Y9(r.backgrounds, s) ?? Kv;
    return {
      virtualBackground: s,
      previewVirtualBackground: s,
      selectedBackgroundId: c,
      backgrounds: r.backgrounds.map((h) => ({
        ...h,
        selected: h.id === c
      }))
    };
  });
}
const $9 = () => {
  w6(h2);
}, ZE = (s = 8) => {
  w6({
    virtualSource: void 0,
    backgroundType: "blur",
    blurValue: s
  });
}, OE = (s) => {
  w6({
    virtualSource: s,
    backgroundType: "image",
    blurValue: void 0
  });
};
pn.subscribe(
  (s) => s.virtualBackground,
  (s) => {
    var c;
    const r = (c = fn(We.VIDEO)) == null ? void 0 : c.originalTrack;
    r && $v("local", r, s);
  }
);
pn.subscribe(
  (s) => s.previewVirtualBackground,
  (s) => {
    const r = pn.getState().previewTrack;
    r && $v("preview", r, s);
  }
);
pn.subscribe(
  (s) => s.previewTrack,
  (s, r) => {
    if (s) {
      const c = pn.getState().previewVirtualBackground;
      $v("preview", s, c);
    } else
      ZT("preview");
    r && r.disposed !== !0 && r.dispose();
  }
);
pn.subscribe(
  (s) => s.backgrounds,
  (s) => {
    const r = s.find(
      (c) => c.selected
    );
    if (r) {
      const c = xT(r);
      c && pn.setState({ previewVirtualBackground: c });
    } else {
      const c = pn.getState();
      c.selectedBackgroundId === Kv && pn.setState({
        previewVirtualBackground: c.virtualBackground
      });
    }
  }
);
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.VIDEO && c.local)) == null ? void 0 : r.muted;
  },
  (s) => {
    s || (Iv = !1);
  }
);
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.VIDEO && c.local)) == null ? void 0 : r.originalTrack;
  },
  (s) => {
    if (s) {
      const r = pn.getState().virtualBackground;
      $v("local", s, r);
    } else
      ZT("local");
  }
);
function eb(s) {
  pn.setState((r) => {
    const c = s.allowUserImages ? r.backgrounds.filter(
      (R) => R.id.startsWith("custom-")
    ) : [], h = [
      ...O6(s),
      ...c
    ], f = r.selectedBackgroundId === Kv || h.some((R) => R.id === r.selectedBackgroundId), v = f ? r.selectedBackgroundId : "none";
    return {
      backgrounds: h.map((R) => ({
        ...R,
        selected: R.id === v
      })),
      selectedBackgroundId: v,
      virtualBackground: f ? r.virtualBackground : h2,
      previewVirtualBackground: f ? r.previewVirtualBackground : h2
    };
  });
}
He.subscribe(
  (s) => s.virtualBackground,
  (s) => {
    eb(
      VT(s)
    );
  }
);
class OT extends S6 {
  static startScreenSharing() {
    k6();
  }
  static stopScreenSharing() {
    D6();
  }
  static showSettingsDialog() {
    zv();
  }
  static hideSettingsDialog() {
    k8();
  }
  static showVirtualBackgroundDialog() {
    iT();
  }
  static hideVirtualBackgroundDialog() {
    r2();
  }
  static getAudioInputDevices() {
    return Y.getState().audioInputDevices;
  }
  static getAudioOutputDevices() {
    return Y.getState().audioOutputDevices;
  }
  static getVideoInputDevices() {
    return Y.getState().videoInputDevices;
  }
  // TODO: Recheck the implementation of this method
  static setAudioInputDevice(r) {
    const h = Y.getState().audioInputDevices.find((f) => f.deviceId === r);
    h && Uu(h);
  }
  // TODO: Recheck the implementation of this method
  static setAudioOutputDevice(r) {
    Y.getState().audioOutputDevices.find((f) => f.deviceId === r) && E6(r);
  }
  // TODO: Recheck the implementation of this method
  static setVideoInputDevice(r) {
    const h = Y.getState().videoInputDevices.find((f) => f.deviceId === r);
    h && am(h);
  }
  static clearVirtualBackground() {
    $9();
  }
  static setVirtualBackgroundBlurLevel(r) {
    ZE(r);
  }
  static setVirtualBackgroundImage(r) {
    OE(r);
  }
  // Legacy Methods
  /**
   * @deprecated use startScreenSharing() instead
   */
  static startScreenShare() {
    this.startScreenSharing();
  }
  /**
   * @deprecated use stopScreenSharing() instead
   */
  static stopScreenShare() {
    this.stopScreenSharing();
  }
  /**
   * @deprecated use setLayout() instead
   */
  static setMode(r) {
    const c = r === "DEFAULT" ? "SIDEBAR" : r;
    this.setLayout(c);
  }
  /**
   * @deprecated use showVirtualBackgroundDialog() instead
   */
  static openVirtualBackground() {
    this.showVirtualBackgroundDialog();
  }
  /**
   * @deprecated use hideVirtualBackgroundDialog() instead
   */
  static closeVirtualBackground() {
    this.hideVirtualBackgroundDialog();
  }
  /**
   * @deprecated use setVirtualBackgroundBlurLevel() instead
   */
  static setBackgroundBlur(r) {
    ZE(r);
  }
  /**
   * @deprecated use setVirtualBackgroundImage() instead
   */
  static setBackgroundImage(r) {
    OE(r);
  }
}
class wT extends OU {
  /** @internal Created once by `CometChatCalls`. */
  constructor(c) {
    super();
    x(this, "driver");
    this.driver = c;
  }
  /**
   * Joins the session this object describes and mounts the call UI into
   * `container`.
   *
   * - Prepared (or still preparing — the prepare is awaited first): the
   *   actual join. The user becomes visible, `onSessionJoined` fires, then the
   *   local tracks are created. Near-instant.
   * - The prepare failed / expired and nothing is live: a normal direct join
   *   with the settings frozen at prepare.
   * - The prepare was cancelled (`leave()` / `leaveSession()`):
   *   `SESSION_CANCELLED` — `connect()` again to prepare it afresh.
   * - Already joined (through this object or directly): no-op success.
   * - Nothing was ever prepared or joined: `VALIDATION_ERROR`.
   */
  async join(c) {
    for (; this.prepareStatus === "pending"; )
      await this.settled;
    if (this.isSessionActive()) {
      const h = Hn();
      if (h === "joining" || h === "joined")
        return { data: void 0, error: null };
      if (h === "preparing" || h === "prepared")
        return this.driver.joinPrepared(c), { data: void 0, error: null };
    }
    return this.prepareStatus === "cancelled" ? {
      data: null,
      error: {
        name: "SESSION_CANCELLED",
        message: "This session was cancelled by leave() / leaveSession(); call connect() again to join it."
      }
    } : this.callToken === "" ? {
      data: null,
      error: {
        name: "VALIDATION_ERROR",
        message: "Nothing to join: call connect(sessionId) first, or joinSession(callToken, sessionSettings, container)."
      }
    } : this.driver.directJoin(this.callToken, this.settings, c);
  }
}
ZU(wT.prototype, OT, {
  exclude: xU,
  guard: (s, r) => s.guardActive(r)
});
var tc;
// @__NO_SIDE_EFFECTS__
function BT(s) {
  return {
    lang: (s == null ? void 0 : s.lang) ?? (tc == null ? void 0 : tc.lang),
    message: s == null ? void 0 : s.message,
    abortEarly: (s == null ? void 0 : s.abortEarly) ?? (tc == null ? void 0 : tc.abortEarly),
    abortPipeEarly: (s == null ? void 0 : s.abortPipeEarly) ?? (tc == null ? void 0 : tc.abortPipeEarly)
  };
}
var _R;
// @__NO_SIDE_EFFECTS__
function tb(s) {
  return _R == null ? void 0 : _R.get(s);
}
var FR;
// @__NO_SIDE_EFFECTS__
function nb(s) {
  return FR == null ? void 0 : FR.get(s);
}
var MR;
// @__NO_SIDE_EFFECTS__
function ib(s, r) {
  var c;
  return (c = MR == null ? void 0 : MR.get(s)) == null ? void 0 : c.get(r);
}
// @__NO_SIDE_EFFECTS__
function AT(s) {
  var c, h;
  const r = typeof s;
  return r === "string" ? `"${s}"` : r === "number" || r === "bigint" || r === "boolean" ? `${s}` : r === "object" || r === "function" ? (s && ((h = (c = Object.getPrototypeOf(s)) == null ? void 0 : c.constructor) == null ? void 0 : h.name)) ?? "null" : r;
}
function Nu(s, r, c, h, f) {
  const v = f && "input" in f ? f.input : c.value, R = (f == null ? void 0 : f.expected) ?? s.expects ?? null, T = (f == null ? void 0 : f.received) ?? /* @__PURE__ */ AT(v), E = {
    kind: s.kind,
    type: s.type,
    input: v,
    expected: R,
    received: T,
    message: `Invalid ${r}: ${R ? `Expected ${R} but r` : "R"}eceived ${T}`,
    requirement: s.requirement,
    path: f == null ? void 0 : f.path,
    issues: f == null ? void 0 : f.issues,
    lang: h.lang,
    abortEarly: h.abortEarly,
    abortPipeEarly: h.abortPipeEarly
  }, C = s.kind === "schema", N = (f == null ? void 0 : f.message) ?? s.message ?? /* @__PURE__ */ ib(s.reference, E.lang) ?? (C ? /* @__PURE__ */ nb(E.lang) : null) ?? h.message ?? /* @__PURE__ */ tb(E.lang);
  N !== void 0 && (E.message = typeof N == "function" ? (
    // @ts-expect-error
    N(E)
  ) : N), C && (c.typed = !1), c.issues ? c.issues.push(E) : c.issues = [E];
}
// @__NO_SIDE_EFFECTS__
function Md(s) {
  return {
    version: 1,
    vendor: "valibot",
    validate(r) {
      return s["~run"]({ value: r }, /* @__PURE__ */ BT());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ab(s, r) {
  return Object.hasOwn(s, r) && r !== "__proto__" && r !== "prototype" && r !== "constructor";
}
// @__NO_SIDE_EFFECTS__
function rb(s, r) {
  const c = [...new Set(s)];
  return c.length > 1 ? `(${c.join(` ${r} `)})` : c[0] ?? "never";
}
// @__NO_SIDE_EFFECTS__
function IT(s) {
  return {
    kind: "transformation",
    type: "transform",
    reference: IT,
    async: !1,
    operation: s,
    "~run"(r) {
      return r.value = this.operation(r.value), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ob(s, r, c) {
  return typeof s.fallback == "function" ? (
    // @ts-expect-error
    s.fallback(r, c)
  ) : (
    // @ts-expect-error
    s.fallback
  );
}
// @__NO_SIDE_EFFECTS__
function LT(s, r, c) {
  return typeof s.default == "function" ? (
    // @ts-expect-error
    s.default(r, c)
  ) : (
    // @ts-expect-error
    s.default
  );
}
// @__NO_SIDE_EFFECTS__
function ns(s, r) {
  return {
    kind: "schema",
    type: "literal",
    reference: ns,
    expects: /* @__PURE__ */ AT(s),
    async: !1,
    literal: s,
    message: r,
    get "~standard"() {
      return /* @__PURE__ */ Md(this);
    },
    "~run"(c, h) {
      return c.value === this.literal ? c.typed = !0 : Nu(this, "type", c, h), c;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function R2(s, r) {
  return {
    kind: "schema",
    type: "object",
    reference: R2,
    expects: "Object",
    async: !1,
    entries: s,
    message: r,
    get "~standard"() {
      return /* @__PURE__ */ Md(this);
    },
    "~run"(c, h) {
      var v;
      const f = c.value;
      if (f && typeof f == "object") {
        c.typed = !0, c.value = {};
        for (const R in this.entries) {
          const T = this.entries[R];
          if (R in f || (T.type === "exact_optional" || T.type === "optional" || T.type === "nullish") && // @ts-expect-error
          T.default !== void 0) {
            const E = R in f ? (
              // @ts-expect-error
              f[R]
            ) : /* @__PURE__ */ LT(T), C = T["~run"]({ value: E }, h);
            if (C.issues) {
              const N = {
                type: "object",
                origin: "value",
                input: f,
                key: R,
                value: E
              };
              for (const _ of C.issues)
                _.path ? _.path.unshift(N) : _.path = [N], (v = c.issues) == null || v.push(_);
              if (c.issues || (c.issues = C.issues), h.abortEarly) {
                c.typed = !1;
                break;
              }
            }
            C.typed || (c.typed = !1), c.value[R] = C.value;
          } else if (T.fallback !== void 0)
            c.value[R] = /* @__PURE__ */ ob(T);
          else if (T.type !== "exact_optional" && T.type !== "optional" && T.type !== "nullish" && (Nu(this, "key", c, h, {
            input: void 0,
            expected: `"${R}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: f,
                key: R,
                // @ts-expect-error
                value: f[R]
              }
            ]
          }), h.abortEarly))
            break;
        }
      } else
        Nu(this, "type", c, h);
      return c;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function gu(s, r) {
  return {
    kind: "schema",
    type: "optional",
    reference: gu,
    expects: `(${s.expects} | undefined)`,
    async: !1,
    wrapped: s,
    default: r,
    get "~standard"() {
      return /* @__PURE__ */ Md(this);
    },
    "~run"(c, h) {
      return c.value === void 0 && (this.default !== void 0 && (c.value = /* @__PURE__ */ LT(this, c, h)), c.value === void 0) ? (c.typed = !0, c) : this.wrapped["~run"](c, h);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function JT(s, r, c) {
  return {
    kind: "schema",
    type: "record",
    reference: JT,
    expects: "Object",
    async: !1,
    key: s,
    value: r,
    message: c,
    get "~standard"() {
      return /* @__PURE__ */ Md(this);
    },
    "~run"(h, f) {
      var R, T;
      const v = h.value;
      if (v && typeof v == "object") {
        h.typed = !0, h.value = {};
        for (const E in v)
          if (/* @__PURE__ */ ab(v, E)) {
            const C = v[E], N = this.key["~run"]({ value: E }, f);
            if (N.issues) {
              const V = {
                type: "object",
                origin: "key",
                input: v,
                key: E,
                value: C
              };
              for (const B of N.issues)
                B.path = [V], (R = h.issues) == null || R.push(B);
              if (h.issues || (h.issues = N.issues), f.abortEarly) {
                h.typed = !1;
                break;
              }
            }
            const _ = this.value["~run"](
              { value: C },
              f
            );
            if (_.issues) {
              const V = {
                type: "object",
                origin: "value",
                input: v,
                key: E,
                value: C
              };
              for (const B of _.issues)
                B.path ? B.path.unshift(V) : B.path = [V], (T = h.issues) == null || T.push(B);
              if (h.issues || (h.issues = _.issues), f.abortEarly) {
                h.typed = !1;
                break;
              }
            }
            (!N.typed || !_.typed) && (h.typed = !1), N.typed && (h.value[N.value] = _.value);
          }
      } else
        Nu(this, "type", h, f);
      return h;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function bi(s) {
  return {
    kind: "schema",
    type: "string",
    reference: bi,
    expects: "string",
    async: !1,
    message: s,
    get "~standard"() {
      return /* @__PURE__ */ Md(this);
    },
    "~run"(r, c) {
      return typeof r.value == "string" ? r.typed = !0 : Nu(this, "type", r, c), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function wE(s) {
  let r;
  if (s)
    for (const c of s)
      r ? r.push(...c.issues) : r = c.issues;
  return r;
}
// @__NO_SIDE_EFFECTS__
function B6(s, r) {
  return {
    kind: "schema",
    type: "union",
    reference: B6,
    expects: /* @__PURE__ */ rb(
      s.map((c) => c.expects),
      "|"
    ),
    async: !1,
    options: s,
    message: r,
    get "~standard"() {
      return /* @__PURE__ */ Md(this);
    },
    "~run"(c, h) {
      let f, v, R;
      for (const T of this.options) {
        const E = T["~run"]({ value: c.value }, h);
        if (E.typed)
          if (E.issues)
            v ? v.push(E) : v = [E];
          else {
            f = E;
            break;
          }
        else
          R ? R.push(E) : R = [E];
      }
      if (f)
        return f;
      if (v) {
        if (v.length === 1)
          return v[0];
        Nu(this, "type", c, h, {
          issues: /* @__PURE__ */ wE(v)
        }), c.typed = !0;
      } else {
        if ((R == null ? void 0 : R.length) === 1)
          return R[0];
        Nu(this, "type", c, h, {
          issues: /* @__PURE__ */ wE(R)
        });
      }
      return c;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function WT() {
  return {
    kind: "schema",
    type: "unknown",
    reference: WT,
    expects: "unknown",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ Md(this);
    },
    "~run"(s) {
      return s.typed = !0, s;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function sb(...s) {
  return {
    ...s[0],
    pipe: s,
    get "~standard"() {
      return /* @__PURE__ */ Md(this);
    },
    "~run"(r, c) {
      for (const h of s)
        if (h.kind !== "metadata") {
          if (r.issues && (h.kind === "schema" || h.kind === "transformation")) {
            r.typed = !1;
            break;
          }
          (!r.issues || !c.abortEarly && !c.abortPipeEarly) && (r = h["~run"](r, c));
        }
      return r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function sc(s, r, c) {
  const h = s["~run"]({ value: r }, /* @__PURE__ */ BT(c));
  return {
    typed: h.typed,
    success: !h.issues,
    output: h.value,
    issues: h.issues
  };
}
var Sv = { exports: {} }, e2 = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var BE;
function lb() {
  if (BE) return e2;
  BE = 1;
  var s = Symbol.for("react.transitional.element"), r = Symbol.for("react.fragment");
  function c(h, f, v) {
    var R = null;
    if (v !== void 0 && (R = "" + v), f.key !== void 0 && (R = "" + f.key), "key" in f) {
      v = {};
      for (var T in f)
        T !== "key" && (v[T] = f[T]);
    } else v = f;
    return f = v.ref, {
      $$typeof: s,
      type: h,
      key: R,
      ref: f !== void 0 ? f : null,
      props: v
    };
  }
  return e2.Fragment = r, e2.jsx = c, e2.jsxs = c, e2;
}
var t2 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var AE;
function cb() {
  return AE || (AE = 1, process.env.NODE_ENV !== "production" && function() {
    function s(M) {
      if (M == null) return null;
      if (typeof M == "function")
        return M.$$typeof === ye ? null : M.displayName || M.name || null;
      if (typeof M == "string") return M;
      switch (M) {
        case oe:
          return "Fragment";
        case ge:
          return "Profiler";
        case be:
          return "StrictMode";
        case j:
          return "Suspense";
        case Te:
          return "SuspenseList";
        case Fe:
          return "Activity";
      }
      if (typeof M == "object")
        switch (typeof M.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), M.$$typeof) {
          case ce:
            return "Portal";
          case _e:
            return (M.displayName || "Context") + ".Provider";
          case te:
            return (M._context.displayName || "Context") + ".Consumer";
          case Ue:
            var W = M.render;
            return M = M.displayName, M || (M = W.displayName || W.name || "", M = M !== "" ? "ForwardRef(" + M + ")" : "ForwardRef"), M;
          case Ne:
            return W = M.displayName || null, W !== null ? W : s(M.type) || "Memo";
          case xe:
            W = M._payload, M = M._init;
            try {
              return s(M(W));
            } catch {
            }
        }
      return null;
    }
    function r(M) {
      return "" + M;
    }
    function c(M) {
      try {
        r(M);
        var W = !1;
      } catch {
        W = !0;
      }
      if (W) {
        W = console;
        var q = W.error, Re = typeof Symbol == "function" && Symbol.toStringTag && M[Symbol.toStringTag] || M.constructor.name || "Object";
        return q.call(
          W,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          Re
        ), r(M);
      }
    }
    function h(M) {
      if (M === oe) return "<>";
      if (typeof M == "object" && M !== null && M.$$typeof === xe)
        return "<...>";
      try {
        var W = s(M);
        return W ? "<" + W + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function f() {
      var M = Ve.A;
      return M === null ? null : M.getOwner();
    }
    function v() {
      return Error("react-stack-top-frame");
    }
    function R(M) {
      if (we.call(M, "key")) {
        var W = Object.getOwnPropertyDescriptor(M, "key").get;
        if (W && W.isReactWarning) return !1;
      }
      return M.key !== void 0;
    }
    function T(M, W) {
      function q() {
        he || (he = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          W
        ));
      }
      q.isReactWarning = !0, Object.defineProperty(M, "key", {
        get: q,
        configurable: !0
      });
    }
    function E() {
      var M = s(this.type);
      return O[M] || (O[M] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), M = this.props.ref, M !== void 0 ? M : null;
    }
    function C(M, W, q, Re, $, Be, Ce, It) {
      return q = Be.ref, M = {
        $$typeof: B,
        type: M,
        key: W,
        props: Be,
        _owner: $
      }, (q !== void 0 ? q : null) !== null ? Object.defineProperty(M, "ref", {
        enumerable: !1,
        get: E
      }) : Object.defineProperty(M, "ref", { enumerable: !1, value: null }), M._store = {}, Object.defineProperty(M._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(M, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(M, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Ce
      }), Object.defineProperty(M, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: It
      }), Object.freeze && (Object.freeze(M.props), Object.freeze(M)), M;
    }
    function N(M, W, q, Re, $, Be, Ce, It) {
      var Pe = W.children;
      if (Pe !== void 0)
        if (Re)
          if (Oe(Pe)) {
            for (Re = 0; Re < Pe.length; Re++)
              _(Pe[Re]);
            Object.freeze && Object.freeze(Pe);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else _(Pe);
      if (we.call(W, "key")) {
        Pe = s(M);
        var dt = Object.keys(W).filter(function(xn) {
          return xn !== "key";
        });
        Re = 0 < dt.length ? "{key: someKey, " + dt.join(": ..., ") + ": ...}" : "{key: someKey}", De[Pe + Re] || (dt = 0 < dt.length ? "{" + dt.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          Re,
          Pe,
          dt,
          Pe
        ), De[Pe + Re] = !0);
      }
      if (Pe = null, q !== void 0 && (c(q), Pe = "" + q), R(W) && (c(W.key), Pe = "" + W.key), "key" in W) {
        q = {};
        for (var dn in W)
          dn !== "key" && (q[dn] = W[dn]);
      } else q = W;
      return Pe && T(
        q,
        typeof M == "function" ? M.displayName || M.name || "Unknown" : M
      ), C(
        M,
        Pe,
        Be,
        $,
        f(),
        q,
        Ce,
        It
      );
    }
    function _(M) {
      typeof M == "object" && M !== null && M.$$typeof === B && M._store && (M._store.validated = 1);
    }
    var V = om(), B = Symbol.for("react.transitional.element"), ce = Symbol.for("react.portal"), oe = Symbol.for("react.fragment"), be = Symbol.for("react.strict_mode"), ge = Symbol.for("react.profiler"), te = Symbol.for("react.consumer"), _e = Symbol.for("react.context"), Ue = Symbol.for("react.forward_ref"), j = Symbol.for("react.suspense"), Te = Symbol.for("react.suspense_list"), Ne = Symbol.for("react.memo"), xe = Symbol.for("react.lazy"), Fe = Symbol.for("react.activity"), ye = Symbol.for("react.client.reference"), Ve = V.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, we = Object.prototype.hasOwnProperty, Oe = Array.isArray, Ie = console.createTask ? console.createTask : function() {
      return null;
    };
    V = {
      "react-stack-bottom-frame": function(M) {
        return M();
      }
    };
    var he, O = {}, G = V["react-stack-bottom-frame"].bind(
      V,
      v
    )(), se = Ie(h(v)), De = {};
    t2.Fragment = oe, t2.jsx = function(M, W, q, Re, $) {
      var Be = 1e4 > Ve.recentlyCreatedOwnerStacks++;
      return N(
        M,
        W,
        q,
        !1,
        Re,
        $,
        Be ? Error("react-stack-top-frame") : G,
        Be ? Ie(h(M)) : se
      );
    }, t2.jsxs = function(M, W, q, Re, $) {
      var Be = 1e4 > Ve.recentlyCreatedOwnerStacks++;
      return N(
        M,
        W,
        q,
        !0,
        Re,
        $,
        Be ? Error("react-stack-top-frame") : G,
        Be ? Ie(h(M)) : se
      );
    };
  }()), t2;
}
var IE;
function db() {
  return IE || (IE = 1, process.env.NODE_ENV === "production" ? Sv.exports = lb() : Sv.exports = cb()), Sv.exports;
}
var b = db(), Rv = { exports: {} }, n2 = {}, Ev = { exports: {} }, kR = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LE;
function ub() {
  return LE || (LE = 1, function(s) {
    function r(O, G) {
      var se = O.length;
      O.push(G);
      e: for (; 0 < se; ) {
        var De = se - 1 >>> 1, M = O[De];
        if (0 < f(M, G))
          O[De] = G, O[se] = M, se = De;
        else break e;
      }
    }
    function c(O) {
      return O.length === 0 ? null : O[0];
    }
    function h(O) {
      if (O.length === 0) return null;
      var G = O[0], se = O.pop();
      if (se !== G) {
        O[0] = se;
        e: for (var De = 0, M = O.length, W = M >>> 1; De < W; ) {
          var q = 2 * (De + 1) - 1, Re = O[q], $ = q + 1, Be = O[$];
          if (0 > f(Re, se))
            $ < M && 0 > f(Be, Re) ? (O[De] = Be, O[$] = se, De = $) : (O[De] = Re, O[q] = se, De = q);
          else if ($ < M && 0 > f(Be, se))
            O[De] = Be, O[$] = se, De = $;
          else break e;
        }
      }
      return G;
    }
    function f(O, G) {
      var se = O.sortIndex - G.sortIndex;
      return se !== 0 ? se : O.id - G.id;
    }
    if (s.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var v = performance;
      s.unstable_now = function() {
        return v.now();
      };
    } else {
      var R = Date, T = R.now();
      s.unstable_now = function() {
        return R.now() - T;
      };
    }
    var E = [], C = [], N = 1, _ = null, V = 3, B = !1, ce = !1, oe = !1, be = !1, ge = typeof setTimeout == "function" ? setTimeout : null, te = typeof clearTimeout == "function" ? clearTimeout : null, _e = typeof setImmediate < "u" ? setImmediate : null;
    function Ue(O) {
      for (var G = c(C); G !== null; ) {
        if (G.callback === null) h(C);
        else if (G.startTime <= O)
          h(C), G.sortIndex = G.expirationTime, r(E, G);
        else break;
        G = c(C);
      }
    }
    function j(O) {
      if (oe = !1, Ue(O), !ce)
        if (c(E) !== null)
          ce = !0, Te || (Te = !0, we());
        else {
          var G = c(C);
          G !== null && he(j, G.startTime - O);
        }
    }
    var Te = !1, Ne = -1, xe = 5, Fe = -1;
    function ye() {
      return be ? !0 : !(s.unstable_now() - Fe < xe);
    }
    function Ve() {
      if (be = !1, Te) {
        var O = s.unstable_now();
        Fe = O;
        var G = !0;
        try {
          e: {
            ce = !1, oe && (oe = !1, te(Ne), Ne = -1), B = !0;
            var se = V;
            try {
              t: {
                for (Ue(O), _ = c(E); _ !== null && !(_.expirationTime > O && ye()); ) {
                  var De = _.callback;
                  if (typeof De == "function") {
                    _.callback = null, V = _.priorityLevel;
                    var M = De(
                      _.expirationTime <= O
                    );
                    if (O = s.unstable_now(), typeof M == "function") {
                      _.callback = M, Ue(O), G = !0;
                      break t;
                    }
                    _ === c(E) && h(E), Ue(O);
                  } else h(E);
                  _ = c(E);
                }
                if (_ !== null) G = !0;
                else {
                  var W = c(C);
                  W !== null && he(
                    j,
                    W.startTime - O
                  ), G = !1;
                }
              }
              break e;
            } finally {
              _ = null, V = se, B = !1;
            }
            G = void 0;
          }
        } finally {
          G ? we() : Te = !1;
        }
      }
    }
    var we;
    if (typeof _e == "function")
      we = function() {
        _e(Ve);
      };
    else if (typeof MessageChannel < "u") {
      var Oe = new MessageChannel(), Ie = Oe.port2;
      Oe.port1.onmessage = Ve, we = function() {
        Ie.postMessage(null);
      };
    } else
      we = function() {
        ge(Ve, 0);
      };
    function he(O, G) {
      Ne = ge(function() {
        O(s.unstable_now());
      }, G);
    }
    s.unstable_IdlePriority = 5, s.unstable_ImmediatePriority = 1, s.unstable_LowPriority = 4, s.unstable_NormalPriority = 3, s.unstable_Profiling = null, s.unstable_UserBlockingPriority = 2, s.unstable_cancelCallback = function(O) {
      O.callback = null;
    }, s.unstable_forceFrameRate = function(O) {
      0 > O || 125 < O ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : xe = 0 < O ? Math.floor(1e3 / O) : 5;
    }, s.unstable_getCurrentPriorityLevel = function() {
      return V;
    }, s.unstable_next = function(O) {
      switch (V) {
        case 1:
        case 2:
        case 3:
          var G = 3;
          break;
        default:
          G = V;
      }
      var se = V;
      V = G;
      try {
        return O();
      } finally {
        V = se;
      }
    }, s.unstable_requestPaint = function() {
      be = !0;
    }, s.unstable_runWithPriority = function(O, G) {
      switch (O) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          O = 3;
      }
      var se = V;
      V = O;
      try {
        return G();
      } finally {
        V = se;
      }
    }, s.unstable_scheduleCallback = function(O, G, se) {
      var De = s.unstable_now();
      switch (typeof se == "object" && se !== null ? (se = se.delay, se = typeof se == "number" && 0 < se ? De + se : De) : se = De, O) {
        case 1:
          var M = -1;
          break;
        case 2:
          M = 250;
          break;
        case 5:
          M = 1073741823;
          break;
        case 4:
          M = 1e4;
          break;
        default:
          M = 5e3;
      }
      return M = se + M, O = {
        id: N++,
        callback: G,
        priorityLevel: O,
        startTime: se,
        expirationTime: M,
        sortIndex: -1
      }, se > De ? (O.sortIndex = se, r(C, O), c(E) === null && O === c(C) && (oe ? (te(Ne), Ne = -1) : oe = !0, he(j, se - De))) : (O.sortIndex = M, r(E, O), ce || B || (ce = !0, Te || (Te = !0, we()))), O;
    }, s.unstable_shouldYield = ye, s.unstable_wrapCallback = function(O) {
      var G = V;
      return function() {
        var se = V;
        V = G;
        try {
          return O.apply(this, arguments);
        } finally {
          V = se;
        }
      };
    };
  }(kR)), kR;
}
var DR = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JE;
function hb() {
  return JE || (JE = 1, function(s) {
    process.env.NODE_ENV !== "production" && function() {
      function r() {
        if (j = !1, Fe) {
          var O = s.unstable_now();
          we = O;
          var G = !0;
          try {
            e: {
              _e = !1, Ue && (Ue = !1, Ne(ye), ye = -1), te = !0;
              var se = ge;
              try {
                t: {
                  for (R(O), be = h(B); be !== null && !(be.expirationTime > O && E()); ) {
                    var De = be.callback;
                    if (typeof De == "function") {
                      be.callback = null, ge = be.priorityLevel;
                      var M = De(
                        be.expirationTime <= O
                      );
                      if (O = s.unstable_now(), typeof M == "function") {
                        be.callback = M, R(O), G = !0;
                        break t;
                      }
                      be === h(B) && f(B), R(O);
                    } else f(B);
                    be = h(B);
                  }
                  if (be !== null) G = !0;
                  else {
                    var W = h(ce);
                    W !== null && C(
                      T,
                      W.startTime - O
                    ), G = !1;
                  }
                }
                break e;
              } finally {
                be = null, ge = se, te = !1;
              }
              G = void 0;
            }
          } finally {
            G ? Oe() : Fe = !1;
          }
        }
      }
      function c(O, G) {
        var se = O.length;
        O.push(G);
        e: for (; 0 < se; ) {
          var De = se - 1 >>> 1, M = O[De];
          if (0 < v(M, G))
            O[De] = G, O[se] = M, se = De;
          else break e;
        }
      }
      function h(O) {
        return O.length === 0 ? null : O[0];
      }
      function f(O) {
        if (O.length === 0) return null;
        var G = O[0], se = O.pop();
        if (se !== G) {
          O[0] = se;
          e: for (var De = 0, M = O.length, W = M >>> 1; De < W; ) {
            var q = 2 * (De + 1) - 1, Re = O[q], $ = q + 1, Be = O[$];
            if (0 > v(Re, se))
              $ < M && 0 > v(Be, Re) ? (O[De] = Be, O[$] = se, De = $) : (O[De] = Re, O[q] = se, De = q);
            else if ($ < M && 0 > v(Be, se))
              O[De] = Be, O[$] = se, De = $;
            else break e;
          }
        }
        return G;
      }
      function v(O, G) {
        var se = O.sortIndex - G.sortIndex;
        return se !== 0 ? se : O.id - G.id;
      }
      function R(O) {
        for (var G = h(ce); G !== null; ) {
          if (G.callback === null) f(ce);
          else if (G.startTime <= O)
            f(ce), G.sortIndex = G.expirationTime, c(B, G);
          else break;
          G = h(ce);
        }
      }
      function T(O) {
        if (Ue = !1, R(O), !_e)
          if (h(B) !== null)
            _e = !0, Fe || (Fe = !0, Oe());
          else {
            var G = h(ce);
            G !== null && C(
              T,
              G.startTime - O
            );
          }
      }
      function E() {
        return j ? !0 : !(s.unstable_now() - we < Ve);
      }
      function C(O, G) {
        ye = Te(function() {
          O(s.unstable_now());
        }, G);
      }
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), s.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
        var N = performance;
        s.unstable_now = function() {
          return N.now();
        };
      } else {
        var _ = Date, V = _.now();
        s.unstable_now = function() {
          return _.now() - V;
        };
      }
      var B = [], ce = [], oe = 1, be = null, ge = 3, te = !1, _e = !1, Ue = !1, j = !1, Te = typeof setTimeout == "function" ? setTimeout : null, Ne = typeof clearTimeout == "function" ? clearTimeout : null, xe = typeof setImmediate < "u" ? setImmediate : null, Fe = !1, ye = -1, Ve = 5, we = -1;
      if (typeof xe == "function")
        var Oe = function() {
          xe(r);
        };
      else if (typeof MessageChannel < "u") {
        var Ie = new MessageChannel(), he = Ie.port2;
        Ie.port1.onmessage = r, Oe = function() {
          he.postMessage(null);
        };
      } else
        Oe = function() {
          Te(r, 0);
        };
      s.unstable_IdlePriority = 5, s.unstable_ImmediatePriority = 1, s.unstable_LowPriority = 4, s.unstable_NormalPriority = 3, s.unstable_Profiling = null, s.unstable_UserBlockingPriority = 2, s.unstable_cancelCallback = function(O) {
        O.callback = null;
      }, s.unstable_forceFrameRate = function(O) {
        0 > O || 125 < O ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : Ve = 0 < O ? Math.floor(1e3 / O) : 5;
      }, s.unstable_getCurrentPriorityLevel = function() {
        return ge;
      }, s.unstable_next = function(O) {
        switch (ge) {
          case 1:
          case 2:
          case 3:
            var G = 3;
            break;
          default:
            G = ge;
        }
        var se = ge;
        ge = G;
        try {
          return O();
        } finally {
          ge = se;
        }
      }, s.unstable_requestPaint = function() {
        j = !0;
      }, s.unstable_runWithPriority = function(O, G) {
        switch (O) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            O = 3;
        }
        var se = ge;
        ge = O;
        try {
          return G();
        } finally {
          ge = se;
        }
      }, s.unstable_scheduleCallback = function(O, G, se) {
        var De = s.unstable_now();
        switch (typeof se == "object" && se !== null ? (se = se.delay, se = typeof se == "number" && 0 < se ? De + se : De) : se = De, O) {
          case 1:
            var M = -1;
            break;
          case 2:
            M = 250;
            break;
          case 5:
            M = 1073741823;
            break;
          case 4:
            M = 1e4;
            break;
          default:
            M = 5e3;
        }
        return M = se + M, O = {
          id: oe++,
          callback: G,
          priorityLevel: O,
          startTime: se,
          expirationTime: M,
          sortIndex: -1
        }, se > De ? (O.sortIndex = se, c(ce, O), h(B) === null && O === h(ce) && (Ue ? (Ne(ye), ye = -1) : Ue = !0, C(T, se - De))) : (O.sortIndex = M, c(B, O), _e || te || (_e = !0, Fe || (Fe = !0, Oe()))), O;
      }, s.unstable_shouldYield = E, s.unstable_wrapCallback = function(O) {
        var G = ge;
        return function() {
          var se = ge;
          ge = G;
          try {
            return O.apply(this, arguments);
          } finally {
            ge = se;
          }
        };
      }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    }();
  }(DR)), DR;
}
var WE;
function HT() {
  return WE || (WE = 1, process.env.NODE_ENV === "production" ? Ev.exports = ub() : Ev.exports = hb()), Ev.exports;
}
var Uv = { exports: {} }, Sa = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var HE;
function mb() {
  if (HE) return Sa;
  HE = 1;
  var s = om();
  function r(E) {
    var C = "https://react.dev/errors/" + E;
    if (1 < arguments.length) {
      C += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var N = 2; N < arguments.length; N++)
        C += "&args[]=" + encodeURIComponent(arguments[N]);
    }
    return "Minified React error #" + E + "; visit " + C + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function c() {
  }
  var h = {
    d: {
      f: c,
      r: function() {
        throw Error(r(522));
      },
      D: c,
      C: c,
      L: c,
      m: c,
      X: c,
      S: c,
      M: c
    },
    p: 0,
    findDOMNode: null
  }, f = Symbol.for("react.portal");
  function v(E, C, N) {
    var _ = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: f,
      key: _ == null ? null : "" + _,
      children: E,
      containerInfo: C,
      implementation: N
    };
  }
  var R = s.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function T(E, C) {
    if (E === "font") return "";
    if (typeof C == "string")
      return C === "use-credentials" ? C : "";
  }
  return Sa.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = h, Sa.createPortal = function(E, C) {
    var N = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!C || C.nodeType !== 1 && C.nodeType !== 9 && C.nodeType !== 11)
      throw Error(r(299));
    return v(E, C, null, N);
  }, Sa.flushSync = function(E) {
    var C = R.T, N = h.p;
    try {
      if (R.T = null, h.p = 2, E) return E();
    } finally {
      R.T = C, h.p = N, h.d.f();
    }
  }, Sa.preconnect = function(E, C) {
    typeof E == "string" && (C ? (C = C.crossOrigin, C = typeof C == "string" ? C === "use-credentials" ? C : "" : void 0) : C = null, h.d.C(E, C));
  }, Sa.prefetchDNS = function(E) {
    typeof E == "string" && h.d.D(E);
  }, Sa.preinit = function(E, C) {
    if (typeof E == "string" && C && typeof C.as == "string") {
      var N = C.as, _ = T(N, C.crossOrigin), V = typeof C.integrity == "string" ? C.integrity : void 0, B = typeof C.fetchPriority == "string" ? C.fetchPriority : void 0;
      N === "style" ? h.d.S(
        E,
        typeof C.precedence == "string" ? C.precedence : void 0,
        {
          crossOrigin: _,
          integrity: V,
          fetchPriority: B
        }
      ) : N === "script" && h.d.X(E, {
        crossOrigin: _,
        integrity: V,
        fetchPriority: B,
        nonce: typeof C.nonce == "string" ? C.nonce : void 0
      });
    }
  }, Sa.preinitModule = function(E, C) {
    if (typeof E == "string")
      if (typeof C == "object" && C !== null) {
        if (C.as == null || C.as === "script") {
          var N = T(
            C.as,
            C.crossOrigin
          );
          h.d.M(E, {
            crossOrigin: N,
            integrity: typeof C.integrity == "string" ? C.integrity : void 0,
            nonce: typeof C.nonce == "string" ? C.nonce : void 0
          });
        }
      } else C == null && h.d.M(E);
  }, Sa.preload = function(E, C) {
    if (typeof E == "string" && typeof C == "object" && C !== null && typeof C.as == "string") {
      var N = C.as, _ = T(N, C.crossOrigin);
      h.d.L(E, N, {
        crossOrigin: _,
        integrity: typeof C.integrity == "string" ? C.integrity : void 0,
        nonce: typeof C.nonce == "string" ? C.nonce : void 0,
        type: typeof C.type == "string" ? C.type : void 0,
        fetchPriority: typeof C.fetchPriority == "string" ? C.fetchPriority : void 0,
        referrerPolicy: typeof C.referrerPolicy == "string" ? C.referrerPolicy : void 0,
        imageSrcSet: typeof C.imageSrcSet == "string" ? C.imageSrcSet : void 0,
        imageSizes: typeof C.imageSizes == "string" ? C.imageSizes : void 0,
        media: typeof C.media == "string" ? C.media : void 0
      });
    }
  }, Sa.preloadModule = function(E, C) {
    if (typeof E == "string")
      if (C) {
        var N = T(C.as, C.crossOrigin);
        h.d.m(E, {
          as: typeof C.as == "string" && C.as !== "script" ? C.as : void 0,
          crossOrigin: N,
          integrity: typeof C.integrity == "string" ? C.integrity : void 0
        });
      } else h.d.m(E);
  }, Sa.requestFormReset = function(E) {
    h.d.r(E);
  }, Sa.unstable_batchedUpdates = function(E, C) {
    return E(C);
  }, Sa.useFormState = function(E, C, N) {
    return R.H.useFormState(E, C, N);
  }, Sa.useFormStatus = function() {
    return R.H.useHostTransitionStatus();
  }, Sa.version = "19.1.0", Sa;
}
var Ra = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zE;
function pb() {
  return zE || (zE = 1, process.env.NODE_ENV !== "production" && function() {
    function s() {
    }
    function r(_) {
      return "" + _;
    }
    function c(_, V, B) {
      var ce = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      try {
        r(ce);
        var oe = !1;
      } catch {
        oe = !0;
      }
      return oe && (console.error(
        "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
        typeof Symbol == "function" && Symbol.toStringTag && ce[Symbol.toStringTag] || ce.constructor.name || "Object"
      ), r(ce)), {
        $$typeof: C,
        key: ce == null ? null : "" + ce,
        children: _,
        containerInfo: V,
        implementation: B
      };
    }
    function h(_, V) {
      if (_ === "font") return "";
      if (typeof V == "string")
        return V === "use-credentials" ? V : "";
    }
    function f(_) {
      return _ === null ? "`null`" : _ === void 0 ? "`undefined`" : _ === "" ? "an empty string" : 'something with type "' + typeof _ + '"';
    }
    function v(_) {
      return _ === null ? "`null`" : _ === void 0 ? "`undefined`" : _ === "" ? "an empty string" : typeof _ == "string" ? JSON.stringify(_) : typeof _ == "number" ? "`" + _ + "`" : 'something with type "' + typeof _ + '"';
    }
    function R() {
      var _ = N.H;
      return _ === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), _;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var T = om(), E = {
      d: {
        f: s,
        r: function() {
          throw Error(
            "Invalid form element. requestFormReset must be passed a form that was rendered by React."
          );
        },
        D: s,
        C: s,
        L: s,
        m: s,
        X: s,
        S: s,
        M: s
      },
      p: 0,
      findDOMNode: null
    }, C = Symbol.for("react.portal"), N = T.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
    ), Ra.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = E, Ra.createPortal = function(_, V) {
      var B = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!V || V.nodeType !== 1 && V.nodeType !== 9 && V.nodeType !== 11)
        throw Error("Target container is not a DOM element.");
      return c(_, V, null, B);
    }, Ra.flushSync = function(_) {
      var V = N.T, B = E.p;
      try {
        if (N.T = null, E.p = 2, _)
          return _();
      } finally {
        N.T = V, E.p = B, E.d.f() && console.error(
          "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
        );
      }
    }, Ra.preconnect = function(_, V) {
      typeof _ == "string" && _ ? V != null && typeof V != "object" ? console.error(
        "ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.",
        v(V)
      ) : V != null && typeof V.crossOrigin != "string" && console.error(
        "ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.",
        f(V.crossOrigin)
      ) : console.error(
        "ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        f(_)
      ), typeof _ == "string" && (V ? (V = V.crossOrigin, V = typeof V == "string" ? V === "use-credentials" ? V : "" : void 0) : V = null, E.d.C(_, V));
    }, Ra.prefetchDNS = function(_) {
      if (typeof _ != "string" || !_)
        console.error(
          "ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
          f(_)
        );
      else if (1 < arguments.length) {
        var V = arguments[1];
        typeof V == "object" && V.hasOwnProperty("crossOrigin") ? console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          v(V)
        ) : console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          v(V)
        );
      }
      typeof _ == "string" && E.d.D(_);
    }, Ra.preinit = function(_, V) {
      if (typeof _ == "string" && _ ? V == null || typeof V != "object" ? console.error(
        "ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.",
        v(V)
      ) : V.as !== "style" && V.as !== "script" && console.error(
        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
        v(V.as)
      ) : console.error(
        "ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        f(_)
      ), typeof _ == "string" && V && typeof V.as == "string") {
        var B = V.as, ce = h(B, V.crossOrigin), oe = typeof V.integrity == "string" ? V.integrity : void 0, be = typeof V.fetchPriority == "string" ? V.fetchPriority : void 0;
        B === "style" ? E.d.S(
          _,
          typeof V.precedence == "string" ? V.precedence : void 0,
          {
            crossOrigin: ce,
            integrity: oe,
            fetchPriority: be
          }
        ) : B === "script" && E.d.X(_, {
          crossOrigin: ce,
          integrity: oe,
          fetchPriority: be,
          nonce: typeof V.nonce == "string" ? V.nonce : void 0
        });
      }
    }, Ra.preinitModule = function(_, V) {
      var B = "";
      if (typeof _ == "string" && _ || (B += " The `href` argument encountered was " + f(_) + "."), V !== void 0 && typeof V != "object" ? B += " The `options` argument encountered was " + f(V) + "." : V && "as" in V && V.as !== "script" && (B += " The `as` option encountered was " + v(V.as) + "."), B)
        console.error(
          "ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s",
          B
        );
      else
        switch (B = V && typeof V.as == "string" ? V.as : "script", B) {
          case "script":
            break;
          default:
            B = v(B), console.error(
              'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
              B,
              _
            );
        }
      typeof _ == "string" && (typeof V == "object" && V !== null ? (V.as == null || V.as === "script") && (B = h(
        V.as,
        V.crossOrigin
      ), E.d.M(_, {
        crossOrigin: B,
        integrity: typeof V.integrity == "string" ? V.integrity : void 0,
        nonce: typeof V.nonce == "string" ? V.nonce : void 0
      })) : V == null && E.d.M(_));
    }, Ra.preload = function(_, V) {
      var B = "";
      if (typeof _ == "string" && _ || (B += " The `href` argument encountered was " + f(_) + "."), V == null || typeof V != "object" ? B += " The `options` argument encountered was " + f(V) + "." : typeof V.as == "string" && V.as || (B += " The `as` option encountered was " + f(V.as) + "."), B && console.error(
        'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
        B
      ), typeof _ == "string" && typeof V == "object" && V !== null && typeof V.as == "string") {
        B = V.as;
        var ce = h(
          B,
          V.crossOrigin
        );
        E.d.L(_, B, {
          crossOrigin: ce,
          integrity: typeof V.integrity == "string" ? V.integrity : void 0,
          nonce: typeof V.nonce == "string" ? V.nonce : void 0,
          type: typeof V.type == "string" ? V.type : void 0,
          fetchPriority: typeof V.fetchPriority == "string" ? V.fetchPriority : void 0,
          referrerPolicy: typeof V.referrerPolicy == "string" ? V.referrerPolicy : void 0,
          imageSrcSet: typeof V.imageSrcSet == "string" ? V.imageSrcSet : void 0,
          imageSizes: typeof V.imageSizes == "string" ? V.imageSizes : void 0,
          media: typeof V.media == "string" ? V.media : void 0
        });
      }
    }, Ra.preloadModule = function(_, V) {
      var B = "";
      typeof _ == "string" && _ || (B += " The `href` argument encountered was " + f(_) + "."), V !== void 0 && typeof V != "object" ? B += " The `options` argument encountered was " + f(V) + "." : V && "as" in V && typeof V.as != "string" && (B += " The `as` option encountered was " + f(V.as) + "."), B && console.error(
        'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
        B
      ), typeof _ == "string" && (V ? (B = h(
        V.as,
        V.crossOrigin
      ), E.d.m(_, {
        as: typeof V.as == "string" && V.as !== "script" ? V.as : void 0,
        crossOrigin: B,
        integrity: typeof V.integrity == "string" ? V.integrity : void 0
      })) : E.d.m(_));
    }, Ra.requestFormReset = function(_) {
      E.d.r(_);
    }, Ra.unstable_batchedUpdates = function(_, V) {
      return _(V);
    }, Ra.useFormState = function(_, V, B) {
      return R().useFormState(_, V, B);
    }, Ra.useFormStatus = function() {
      return R().useHostTransitionStatus();
    }, Ra.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Ra;
}
var jE;
function zT() {
  if (jE) return Uv.exports;
  jE = 1;
  function s() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(s);
      } catch (r) {
        console.error(r);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (s(), Uv.exports = mb()) : Uv.exports = pb(), Uv.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PE;
function fb() {
  if (PE) return n2;
  PE = 1;
  var s = HT(), r = om(), c = zT();
  function h(n) {
    var a = "https://react.dev/errors/" + n;
    if (1 < arguments.length) {
      a += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var o = 2; o < arguments.length; o++)
        a += "&args[]=" + encodeURIComponent(arguments[o]);
    }
    return "Minified React error #" + n + "; visit " + a + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function f(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
  }
  function v(n) {
    var a = n, o = n;
    if (n.alternate) for (; a.return; ) a = a.return;
    else {
      n = a;
      do
        a = n, (a.flags & 4098) !== 0 && (o = a.return), n = a.return;
      while (n);
    }
    return a.tag === 3 ? o : null;
  }
  function R(n) {
    if (n.tag === 13) {
      var a = n.memoizedState;
      if (a === null && (n = n.alternate, n !== null && (a = n.memoizedState)), a !== null) return a.dehydrated;
    }
    return null;
  }
  function T(n) {
    if (v(n) !== n)
      throw Error(h(188));
  }
  function E(n) {
    var a = n.alternate;
    if (!a) {
      if (a = v(n), a === null) throw Error(h(188));
      return a !== n ? null : n;
    }
    for (var o = n, d = a; ; ) {
      var p = o.return;
      if (p === null) break;
      var g = p.alternate;
      if (g === null) {
        if (d = p.return, d !== null) {
          o = d;
          continue;
        }
        break;
      }
      if (p.child === g.child) {
        for (g = p.child; g; ) {
          if (g === o) return T(p), n;
          if (g === d) return T(p), a;
          g = g.sibling;
        }
        throw Error(h(188));
      }
      if (o.return !== d.return) o = p, d = g;
      else {
        for (var y = !1, k = p.child; k; ) {
          if (k === o) {
            y = !0, o = p, d = g;
            break;
          }
          if (k === d) {
            y = !0, d = p, o = g;
            break;
          }
          k = k.sibling;
        }
        if (!y) {
          for (k = g.child; k; ) {
            if (k === o) {
              y = !0, o = g, d = p;
              break;
            }
            if (k === d) {
              y = !0, d = g, o = p;
              break;
            }
            k = k.sibling;
          }
          if (!y) throw Error(h(189));
        }
      }
      if (o.alternate !== d) throw Error(h(190));
    }
    if (o.tag !== 3) throw Error(h(188));
    return o.stateNode.current === o ? n : a;
  }
  function C(n) {
    var a = n.tag;
    if (a === 5 || a === 26 || a === 27 || a === 6) return n;
    for (n = n.child; n !== null; ) {
      if (a = C(n), a !== null) return a;
      n = n.sibling;
    }
    return null;
  }
  var N = Object.assign, _ = Symbol.for("react.element"), V = Symbol.for("react.transitional.element"), B = Symbol.for("react.portal"), ce = Symbol.for("react.fragment"), oe = Symbol.for("react.strict_mode"), be = Symbol.for("react.profiler"), ge = Symbol.for("react.provider"), te = Symbol.for("react.consumer"), _e = Symbol.for("react.context"), Ue = Symbol.for("react.forward_ref"), j = Symbol.for("react.suspense"), Te = Symbol.for("react.suspense_list"), Ne = Symbol.for("react.memo"), xe = Symbol.for("react.lazy"), Fe = Symbol.for("react.activity"), ye = Symbol.for("react.memo_cache_sentinel"), Ve = Symbol.iterator;
  function we(n) {
    return n === null || typeof n != "object" ? null : (n = Ve && n[Ve] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var Oe = Symbol.for("react.client.reference");
  function Ie(n) {
    if (n == null) return null;
    if (typeof n == "function")
      return n.$$typeof === Oe ? null : n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case ce:
        return "Fragment";
      case be:
        return "Profiler";
      case oe:
        return "StrictMode";
      case j:
        return "Suspense";
      case Te:
        return "SuspenseList";
      case Fe:
        return "Activity";
    }
    if (typeof n == "object")
      switch (n.$$typeof) {
        case B:
          return "Portal";
        case _e:
          return (n.displayName || "Context") + ".Provider";
        case te:
          return (n._context.displayName || "Context") + ".Consumer";
        case Ue:
          var a = n.render;
          return n = n.displayName, n || (n = a.displayName || a.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
        case Ne:
          return a = n.displayName || null, a !== null ? a : Ie(n.type) || "Memo";
        case xe:
          a = n._payload, n = n._init;
          try {
            return Ie(n(a));
          } catch {
          }
      }
    return null;
  }
  var he = Array.isArray, O = r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, G = c.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, se = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, De = [], M = -1;
  function W(n) {
    return { current: n };
  }
  function q(n) {
    0 > M || (n.current = De[M], De[M] = null, M--);
  }
  function Re(n, a) {
    M++, De[M] = n.current, n.current = a;
  }
  var $ = W(null), Be = W(null), Ce = W(null), It = W(null);
  function Pe(n, a) {
    switch (Re(Ce, a), Re(Be, n), Re($, null), a.nodeType) {
      case 9:
      case 11:
        n = (n = a.documentElement) && (n = n.namespaceURI) ? Ho(n) : 0;
        break;
      default:
        if (n = a.tagName, a = a.namespaceURI)
          a = Ho(a), n = qc(a, n);
        else
          switch (n) {
            case "svg":
              n = 1;
              break;
            case "math":
              n = 2;
              break;
            default:
              n = 0;
          }
    }
    q($), Re($, n);
  }
  function dt() {
    q($), q(Be), q(Ce);
  }
  function dn(n) {
    n.memoizedState !== null && Re(It, n);
    var a = $.current, o = qc(a, n.type);
    a !== o && (Re(Be, n), Re($, o));
  }
  function xn(n) {
    Be.current === n && (q($), q(Be)), It.current === n && (q(It), ga._currentValue = se);
  }
  var Yt = Object.prototype.hasOwnProperty, hn = s.unstable_scheduleCallback, Aa = s.unstable_cancelCallback, sr = s.unstable_shouldYield, Tn = s.unstable_requestPaint, yn = s.unstable_now, Bt = s.unstable_getCurrentPriorityLevel, Vr = s.unstable_ImmediatePriority, vt = s.unstable_UserBlockingPriority, ea = s.unstable_NormalPriority, Ci = s.unstable_LowPriority, Ta = s.unstable_IdlePriority, Vi = s.log, Uo = s.unstable_setDisableYieldValue, ta = null, jn = null;
  function _i(n) {
    if (typeof Vi == "function" && Uo(n), jn && typeof jn.setStrictMode == "function")
      try {
        jn.setStrictMode(ta, n);
      } catch {
      }
  }
  var Pn = Math.clz32 ? Math.clz32 : Fr, _r = Math.log, To = Math.LN2;
  function Fr(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (_r(n) / To | 0) | 0;
  }
  var Ii = 256, oi = 4194304;
  function Mn(n) {
    var a = n & 42;
    if (a !== 0) return a;
    switch (n & -n) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return n & 4194048;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return n & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return n;
    }
  }
  function Li(n, a, o) {
    var d = n.pendingLanes;
    if (d === 0) return 0;
    var p = 0, g = n.suspendedLanes, y = n.pingedLanes;
    n = n.warmLanes;
    var k = d & 134217727;
    return k !== 0 ? (d = k & ~g, d !== 0 ? p = Mn(d) : (y &= k, y !== 0 ? p = Mn(y) : o || (o = k & ~n, o !== 0 && (p = Mn(o))))) : (k = d & ~g, k !== 0 ? p = Mn(k) : y !== 0 ? p = Mn(y) : o || (o = d & ~n, o !== 0 && (p = Mn(o)))), p === 0 ? 0 : a !== 0 && a !== p && (a & g) === 0 && (g = p & -p, o = a & -a, g >= o || g === 32 && (o & 4194048) !== 0) ? a : p;
  }
  function F(n, a) {
    return (n.pendingLanes & ~(n.suspendedLanes & ~n.pingedLanes) & a) === 0;
  }
  function z(n, a) {
    switch (n) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return a + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return a + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Ze() {
    var n = Ii;
    return Ii <<= 1, (Ii & 4194048) === 0 && (Ii = 256), n;
  }
  function Ae() {
    var n = oi;
    return oi <<= 1, (oi & 62914560) === 0 && (oi = 4194304), n;
  }
  function Ye(n) {
    for (var a = [], o = 0; 31 > o; o++) a.push(n);
    return a;
  }
  function ut(n, a) {
    n.pendingLanes |= a, a !== 268435456 && (n.suspendedLanes = 0, n.pingedLanes = 0, n.warmLanes = 0);
  }
  function gt(n, a, o, d, p, g) {
    var y = n.pendingLanes;
    n.pendingLanes = o, n.suspendedLanes = 0, n.pingedLanes = 0, n.warmLanes = 0, n.expiredLanes &= o, n.entangledLanes &= o, n.errorRecoveryDisabledLanes &= o, n.shellSuspendCounter = 0;
    var k = n.entanglements, w = n.expirationTimes, K = n.hiddenUpdates;
    for (o = y & ~o; 0 < o; ) {
      var ve = 31 - Pn(o), Ee = 1 << ve;
      k[ve] = 0, w[ve] = -1;
      var ie = K[ve];
      if (ie !== null)
        for (K[ve] = null, ve = 0; ve < ie.length; ve++) {
          var re = ie[ve];
          re !== null && (re.lane &= -536870913);
        }
      o &= ~Ee;
    }
    d !== 0 && Vt(n, d, 0), g !== 0 && p === 0 && n.tag !== 0 && (n.suspendedLanes |= g & ~(y & ~a));
  }
  function Vt(n, a, o) {
    n.pendingLanes |= a, n.suspendedLanes &= ~a;
    var d = 31 - Pn(a);
    n.entangledLanes |= a, n.entanglements[d] = n.entanglements[d] | 1073741824 | o & 4194090;
  }
  function ht(n, a) {
    var o = n.entangledLanes |= a;
    for (n = n.entanglements; o; ) {
      var d = 31 - Pn(o), p = 1 << d;
      p & a | n[d] & a && (n[d] |= a), o &= ~p;
    }
  }
  function Nn(n) {
    switch (n) {
      case 2:
        n = 1;
        break;
      case 8:
        n = 4;
        break;
      case 32:
        n = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        n = 128;
        break;
      case 268435456:
        n = 134217728;
        break;
      default:
        n = 0;
    }
    return n;
  }
  function Ji(n) {
    return n &= -n, 2 < n ? 8 < n ? (n & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function is() {
    var n = G.p;
    return n !== 0 ? n : (n = window.event, n === void 0 ? 32 : mf(n.type));
  }
  function yo(n, a) {
    var o = G.p;
    try {
      return G.p = n, a();
    } finally {
      G.p = o;
    }
  }
  var gn = Math.random().toString(36).slice(2), rn = "__reactFiber$" + gn, qn = "__reactProps$" + gn, na = "__reactContainer$" + gn, as = "__reactEvents$" + gn, Z = "__reactListeners$" + gn, H = "__reactHandles$" + gn, Me = "__reactResources$" + gn, pe = "__reactMarker$" + gn;
  function mt(n) {
    delete n[rn], delete n[qn], delete n[as], delete n[Z], delete n[H];
  }
  function tt(n) {
    var a = n[rn];
    if (a) return a;
    for (var o = n.parentNode; o; ) {
      if (a = o[na] || o[rn]) {
        if (o = a.alternate, a.child !== null || o !== null && o.child !== null)
          for (n = Ei(n); n !== null; ) {
            if (o = n[rn]) return o;
            n = Ei(n);
          }
        return a;
      }
      n = o, o = n.parentNode;
    }
    return null;
  }
  function et(n) {
    if (n = n[rn] || n[na]) {
      var a = n.tag;
      if (a === 5 || a === 6 || a === 13 || a === 26 || a === 27 || a === 3)
        return n;
    }
    return null;
  }
  function _t(n) {
    var a = n.tag;
    if (a === 5 || a === 26 || a === 27 || a === 6) return n.stateNode;
    throw Error(h(33));
  }
  function Xt(n) {
    var a = n[Me];
    return a || (a = n[Me] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), a;
  }
  function vn(n) {
    n[pe] = !0;
  }
  var kd = /* @__PURE__ */ new Set(), ya = {};
  function rs(n, a) {
    os(n, a), os(n + "Capture", a);
  }
  function os(n, a) {
    for (ya[n] = a, n = 0; n < a.length; n++)
      kd.add(a[n]);
  }
  var T2 = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), _u = {}, cm = {};
  function y2(n) {
    return Yt.call(cm, n) ? !0 : Yt.call(_u, n) ? !1 : T2.test(n) ? cm[n] = !0 : (_u[n] = !0, !1);
  }
  function No(n, a, o) {
    if (y2(a))
      if (o === null) n.removeAttribute(a);
      else {
        switch (typeof o) {
          case "undefined":
          case "function":
          case "symbol":
            n.removeAttribute(a);
            return;
          case "boolean":
            var d = a.toLowerCase().slice(0, 5);
            if (d !== "data-" && d !== "aria-") {
              n.removeAttribute(a);
              return;
            }
        }
        n.setAttribute(a, "" + o);
      }
  }
  function Dd(n, a, o) {
    if (o === null) n.removeAttribute(a);
    else {
      switch (typeof o) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          n.removeAttribute(a);
          return;
      }
      n.setAttribute(a, "" + o);
    }
  }
  function Mr(n, a, o, d) {
    if (d === null) n.removeAttribute(o);
    else {
      switch (typeof d) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          n.removeAttribute(o);
          return;
      }
      n.setAttributeNS(a, o, "" + d);
    }
  }
  var Fu, dm;
  function Xs(n) {
    if (Fu === void 0)
      try {
        throw Error();
      } catch (o) {
        var a = o.stack.trim().match(/\n( *(at )?)/);
        Fu = a && a[1] || "", dm = -1 < o.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < o.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Fu + n + dm;
  }
  var Wi = !1;
  function ss(n, a) {
    if (!n || Wi) return "";
    Wi = !0;
    var o = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var d = {
        DetermineComponentFrameRoot: function() {
          try {
            if (a) {
              var Ee = function() {
                throw Error();
              };
              if (Object.defineProperty(Ee.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(Ee, []);
                } catch (re) {
                  var ie = re;
                }
                Reflect.construct(n, [], Ee);
              } else {
                try {
                  Ee.call();
                } catch (re) {
                  ie = re;
                }
                n.call(Ee.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (re) {
                ie = re;
              }
              (Ee = n()) && typeof Ee.catch == "function" && Ee.catch(function() {
              });
            }
          } catch (re) {
            if (re && ie && typeof re.stack == "string")
              return [re.stack, ie.stack];
          }
          return [null, null];
        }
      };
      d.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var p = Object.getOwnPropertyDescriptor(
        d.DetermineComponentFrameRoot,
        "name"
      );
      p && p.configurable && Object.defineProperty(
        d.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var g = d.DetermineComponentFrameRoot(), y = g[0], k = g[1];
      if (y && k) {
        var w = y.split(`
`), K = k.split(`
`);
        for (p = d = 0; d < w.length && !w[d].includes("DetermineComponentFrameRoot"); )
          d++;
        for (; p < K.length && !K[p].includes(
          "DetermineComponentFrameRoot"
        ); )
          p++;
        if (d === w.length || p === K.length)
          for (d = w.length - 1, p = K.length - 1; 1 <= d && 0 <= p && w[d] !== K[p]; )
            p--;
        for (; 1 <= d && 0 <= p; d--, p--)
          if (w[d] !== K[p]) {
            if (d !== 1 || p !== 1)
              do
                if (d--, p--, 0 > p || w[d] !== K[p]) {
                  var ve = `
` + w[d].replace(" at new ", " at ");
                  return n.displayName && ve.includes("<anonymous>") && (ve = ve.replace("<anonymous>", n.displayName)), ve;
                }
              while (1 <= d && 0 <= p);
            break;
          }
      }
    } finally {
      Wi = !1, Error.prepareStackTrace = o;
    }
    return (o = n ? n.displayName || n.name : "") ? Xs(o) : "";
  }
  function Ks(n) {
    switch (n.tag) {
      case 26:
      case 27:
      case 5:
        return Xs(n.type);
      case 16:
        return Xs("Lazy");
      case 13:
        return Xs("Suspense");
      case 19:
        return Xs("SuspenseList");
      case 0:
      case 15:
        return ss(n.type, !1);
      case 11:
        return ss(n.type.render, !1);
      case 1:
        return ss(n.type, !0);
      case 31:
        return Xs("Activity");
      default:
        return "";
    }
  }
  function um(n) {
    try {
      var a = "";
      do
        a += Ks(n), n = n.return;
      while (n);
      return a;
    } catch (o) {
      return `
Error generating stack: ` + o.message + `
` + o.stack;
    }
  }
  function Fi(n) {
    switch (typeof n) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return n;
      case "object":
        return n;
      default:
        return "";
    }
  }
  function Qd(n) {
    var a = n.type;
    return (n = n.nodeName) && n.toLowerCase() === "input" && (a === "checkbox" || a === "radio");
  }
  function hm(n) {
    var a = Qd(n) ? "checked" : "value", o = Object.getOwnPropertyDescriptor(
      n.constructor.prototype,
      a
    ), d = "" + n[a];
    if (!n.hasOwnProperty(a) && typeof o < "u" && typeof o.get == "function" && typeof o.set == "function") {
      var p = o.get, g = o.set;
      return Object.defineProperty(n, a, {
        configurable: !0,
        get: function() {
          return p.call(this);
        },
        set: function(y) {
          d = "" + y, g.call(this, y);
        }
      }), Object.defineProperty(n, a, {
        enumerable: o.enumerable
      }), {
        getValue: function() {
          return d;
        },
        setValue: function(y) {
          d = "" + y;
        },
        stopTracking: function() {
          n._valueTracker = null, delete n[a];
        }
      };
    }
  }
  function ls(n) {
    n._valueTracker || (n._valueTracker = hm(n));
  }
  function qs(n) {
    if (!n) return !1;
    var a = n._valueTracker;
    if (!a) return !0;
    var o = a.getValue(), d = "";
    return n && (d = Qd(n) ? n.checked ? "true" : "false" : n.value), n = d, n !== o ? (a.setValue(n), !0) : !1;
  }
  function cc(n) {
    if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
    try {
      return n.activeElement || n.body;
    } catch {
      return n.body;
    }
  }
  var nS = /[\n"\\]/g;
  function Ia(n) {
    return n.replace(
      nS,
      function(a) {
        return "\\" + a.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Mu(n, a, o, d, p, g, y, k) {
    n.name = "", y != null && typeof y != "function" && typeof y != "symbol" && typeof y != "boolean" ? n.type = y : n.removeAttribute("type"), a != null ? y === "number" ? (a === 0 && n.value === "" || n.value != a) && (n.value = "" + Fi(a)) : n.value !== "" + Fi(a) && (n.value = "" + Fi(a)) : y !== "submit" && y !== "reset" || n.removeAttribute("value"), a != null ? xd(n, y, Fi(a)) : o != null ? xd(n, y, Fi(o)) : d != null && n.removeAttribute("value"), p == null && g != null && (n.defaultChecked = !!g), p != null && (n.checked = p && typeof p != "function" && typeof p != "symbol"), k != null && typeof k != "function" && typeof k != "symbol" && typeof k != "boolean" ? n.name = "" + Fi(k) : n.removeAttribute("name");
  }
  function ku(n, a, o, d, p, g, y, k) {
    if (g != null && typeof g != "function" && typeof g != "symbol" && typeof g != "boolean" && (n.type = g), a != null || o != null) {
      if (!(g !== "submit" && g !== "reset" || a != null))
        return;
      o = o != null ? "" + Fi(o) : "", a = a != null ? "" + Fi(a) : o, k || a === n.value || (n.value = a), n.defaultValue = a;
    }
    d = d ?? p, d = typeof d != "function" && typeof d != "symbol" && !!d, n.checked = k ? n.checked : !!d, n.defaultChecked = !!d, y != null && typeof y != "function" && typeof y != "symbol" && typeof y != "boolean" && (n.name = y);
  }
  function xd(n, a, o) {
    a === "number" && cc(n.ownerDocument) === n || n.defaultValue === "" + o || (n.defaultValue = "" + o);
  }
  function $s(n, a, o, d) {
    if (n = n.options, a) {
      a = {};
      for (var p = 0; p < o.length; p++)
        a["$" + o[p]] = !0;
      for (o = 0; o < n.length; o++)
        p = a.hasOwnProperty("$" + n[o].value), n[o].selected !== p && (n[o].selected = p), p && d && (n[o].defaultSelected = !0);
    } else {
      for (o = "" + Fi(o), a = null, p = 0; p < n.length; p++) {
        if (n[p].value === o) {
          n[p].selected = !0, d && (n[p].defaultSelected = !0);
          return;
        }
        a !== null || n[p].disabled || (a = n[p]);
      }
      a !== null && (a.selected = !0);
    }
  }
  function mm(n, a, o) {
    if (a != null && (a = "" + Fi(a), a !== n.value && (n.value = a), o == null)) {
      n.defaultValue !== a && (n.defaultValue = a);
      return;
    }
    n.defaultValue = o != null ? "" + Fi(o) : "";
  }
  function pm(n, a, o, d) {
    if (a == null) {
      if (d != null) {
        if (o != null) throw Error(h(92));
        if (he(d)) {
          if (1 < d.length) throw Error(h(93));
          d = d[0];
        }
        o = d;
      }
      o == null && (o = ""), a = o;
    }
    o = Fi(a), n.defaultValue = o, d = n.textContent, d === o && d !== "" && d !== null && (n.value = d);
  }
  function dc(n, a) {
    if (a) {
      var o = n.firstChild;
      if (o && o === n.lastChild && o.nodeType === 3) {
        o.nodeValue = a;
        return;
      }
    }
    n.textContent = a;
  }
  var N2 = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function Du(n, a, o) {
    var d = a.indexOf("--") === 0;
    o == null || typeof o == "boolean" || o === "" ? d ? n.setProperty(a, "") : a === "float" ? n.cssFloat = "" : n[a] = "" : d ? n.setProperty(a, o) : typeof o != "number" || o === 0 || N2.has(a) ? a === "float" ? n.cssFloat = o : n[a] = ("" + o).trim() : n[a] = o + "px";
  }
  function Zd(n, a, o) {
    if (a != null && typeof a != "object")
      throw Error(h(62));
    if (n = n.style, o != null) {
      for (var d in o)
        !o.hasOwnProperty(d) || a != null && a.hasOwnProperty(d) || (d.indexOf("--") === 0 ? n.setProperty(d, "") : d === "float" ? n.cssFloat = "" : n[d] = "");
      for (var p in a)
        d = a[p], a.hasOwnProperty(p) && o[p] !== d && Du(n, p, d);
    } else
      for (var g in a)
        a.hasOwnProperty(g) && Du(n, g, a[g]);
  }
  function el(n) {
    if (n.indexOf("-") === -1) return !1;
    switch (n) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var iS = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), b2 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Od(n) {
    return b2.test("" + n) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : n;
  }
  var tl = null;
  function Qu(n) {
    return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
  }
  var uc = null, hc = null;
  function C2(n) {
    var a = et(n);
    if (a && (n = a.stateNode)) {
      var o = n[qn] || null;
      e: switch (n = a.stateNode, a.type) {
        case "input":
          if (Mu(
            n,
            o.value,
            o.defaultValue,
            o.defaultValue,
            o.checked,
            o.defaultChecked,
            o.type,
            o.name
          ), a = o.name, o.type === "radio" && a != null) {
            for (o = n; o.parentNode; ) o = o.parentNode;
            for (o = o.querySelectorAll(
              'input[name="' + Ia(
                "" + a
              ) + '"][type="radio"]'
            ), a = 0; a < o.length; a++) {
              var d = o[a];
              if (d !== n && d.form === n.form) {
                var p = d[qn] || null;
                if (!p) throw Error(h(90));
                Mu(
                  d,
                  p.value,
                  p.defaultValue,
                  p.defaultValue,
                  p.checked,
                  p.defaultChecked,
                  p.type,
                  p.name
                );
              }
            }
            for (a = 0; a < o.length; a++)
              d = o[a], d.form === n.form && qs(d);
          }
          break e;
        case "textarea":
          mm(n, o.value, o.defaultValue);
          break e;
        case "select":
          a = o.value, a != null && $s(n, !!o.multiple, a, !1);
      }
    }
  }
  var fm = !1;
  function mc(n, a, o) {
    if (fm) return n(a, o);
    fm = !0;
    try {
      var d = n(a);
      return d;
    } finally {
      if (fm = !1, (uc !== null || hc !== null) && (Ql(), uc && (a = uc, n = hc, hc = uc = null, C2(a), n)))
        for (a = 0; a < n.length; a++) C2(n[a]);
    }
  }
  function nl(n, a) {
    var o = n.stateNode;
    if (o === null) return null;
    var d = o[qn] || null;
    if (d === null) return null;
    o = d[a];
    e: switch (a) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d = !d.disabled) || (n = n.type, d = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !d;
        break e;
      default:
        n = !1;
    }
    if (n) return null;
    if (o && typeof o != "function")
      throw Error(
        h(231, a, typeof o)
      );
    return o;
  }
  var kr = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), xu = !1;
  if (kr)
    try {
      var bo = {};
      Object.defineProperty(bo, "passive", {
        get: function() {
          xu = !0;
        }
      }), window.addEventListener("test", bo, bo), window.removeEventListener("test", bo, bo);
    } catch {
      xu = !1;
    }
  var Co = null, pc = null, il = null;
  function gm() {
    if (il) return il;
    var n, a = pc, o = a.length, d, p = "value" in Co ? Co.value : Co.textContent, g = p.length;
    for (n = 0; n < o && a[n] === p[n]; n++) ;
    var y = o - n;
    for (d = 1; d <= y && a[o - d] === p[g - d]; d++) ;
    return il = p.slice(n, 1 < d ? 1 - d : void 0);
  }
  function pi(n) {
    var a = n.keyCode;
    return "charCode" in n ? (n = n.charCode, n === 0 && a === 13 && (n = 13)) : n = a, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
  }
  function Zu() {
    return !0;
  }
  function Ou() {
    return !1;
  }
  function Hi(n) {
    function a(o, d, p, g, y) {
      this._reactName = o, this._targetInst = p, this.type = d, this.nativeEvent = g, this.target = y, this.currentTarget = null;
      for (var k in n)
        n.hasOwnProperty(k) && (o = n[k], this[k] = o ? o(g) : g[k]);
      return this.isDefaultPrevented = (g.defaultPrevented != null ? g.defaultPrevented : g.returnValue === !1) ? Zu : Ou, this.isPropagationStopped = Ou, this;
    }
    return N(a.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var o = this.nativeEvent;
        o && (o.preventDefault ? o.preventDefault() : typeof o.returnValue != "unknown" && (o.returnValue = !1), this.isDefaultPrevented = Zu);
      },
      stopPropagation: function() {
        var o = this.nativeEvent;
        o && (o.stopPropagation ? o.stopPropagation() : typeof o.cancelBubble != "unknown" && (o.cancelBubble = !0), this.isPropagationStopped = Zu);
      },
      persist: function() {
      },
      isPersistent: Zu
    }), a;
  }
  var cs = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(n) {
      return n.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, wu = Hi(cs), wd = N({}, cs, { view: 0, detail: 0 }), V2 = Hi(wd), vm, Bu, Bd, al = N({}, wd, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Vo,
    button: 0,
    buttons: 0,
    relatedTarget: function(n) {
      return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
    },
    movementX: function(n) {
      return "movementX" in n ? n.movementX : (n !== Bd && (Bd && n.type === "mousemove" ? (vm = n.screenX - Bd.screenX, Bu = n.screenY - Bd.screenY) : Bu = vm = 0, Bd = n), vm);
    },
    movementY: function(n) {
      return "movementY" in n ? n.movementY : Bu;
    }
  }), Sm = Hi(al), _2 = N({}, al, { dataTransfer: 0 }), F2 = Hi(_2), aS = N({}, wd, { relatedTarget: 0 }), Rm = Hi(aS), rS = N({}, cs, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), oS = Hi(rS), sS = N({}, cs, {
    clipboardData: function(n) {
      return "clipboardData" in n ? n.clipboardData : window.clipboardData;
    }
  }), Ad = Hi(sS), M2 = N({}, cs, { data: 0 }), Em = Hi(M2), k2 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, D2 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Um = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Q2(n) {
    var a = this.nativeEvent;
    return a.getModifierState ? a.getModifierState(n) : (n = Um[n]) ? !!a[n] : !1;
  }
  function Vo() {
    return Q2;
  }
  var rl = N({}, wd, {
    key: function(n) {
      if (n.key) {
        var a = k2[n.key] || n.key;
        if (a !== "Unidentified") return a;
      }
      return n.type === "keypress" ? (n = pi(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? D2[n.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Vo,
    charCode: function(n) {
      return n.type === "keypress" ? pi(n) : 0;
    },
    keyCode: function(n) {
      return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
    },
    which: function(n) {
      return n.type === "keypress" ? pi(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
    }
  }), lr = Hi(rl), Na = N({}, al, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), Id = Hi(Na), Au = N({}, wd, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Vo
  }), Tm = Hi(Au), ia = N({}, cs, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), x2 = Hi(ia), Iu = N({}, al, {
    deltaX: function(n) {
      return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
    },
    deltaY: function(n) {
      return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), ol = Hi(Iu), ym = N({}, cs, {
    newState: 0,
    oldState: 0
  }), Z2 = Hi(ym), O2 = [9, 13, 27, 32], Ld = kr && "CompositionEvent" in window, Jd = null;
  kr && "documentMode" in document && (Jd = document.documentMode);
  var Nm = kr && "TextEvent" in window && !Jd, Dr = kr && (!Ld || Jd && 8 < Jd && 11 >= Jd), bm = " ", Lu = !1;
  function Wd(n, a) {
    switch (n) {
      case "keyup":
        return O2.indexOf(a.keyCode) !== -1;
      case "keydown":
        return a.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function ds(n) {
    return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
  }
  var us = !1;
  function Cm(n, a) {
    switch (n) {
      case "compositionend":
        return ds(a);
      case "keypress":
        return a.which !== 32 ? null : (Lu = !0, bm);
      case "textInput":
        return n = a.data, n === bm && Lu ? null : n;
      default:
        return null;
    }
  }
  function sl(n, a) {
    if (us)
      return n === "compositionend" || !Ld && Wd(n, a) ? (n = gm(), il = pc = Co = null, us = !1, n) : null;
    switch (n) {
      case "paste":
        return null;
      case "keypress":
        if (!(a.ctrlKey || a.altKey || a.metaKey) || a.ctrlKey && a.altKey) {
          if (a.char && 1 < a.char.length)
            return a.char;
          if (a.which) return String.fromCharCode(a.which);
        }
        return null;
      case "compositionend":
        return Dr && a.locale !== "ko" ? null : a.data;
      default:
        return null;
    }
  }
  var w2 = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function Ju(n) {
    var a = n && n.nodeName && n.nodeName.toLowerCase();
    return a === "input" ? !!w2[n.type] : a === "textarea";
  }
  function Wu(n, a, o, d) {
    uc ? hc ? hc.push(d) : hc = [d] : uc = d, a = Kc(a, "onChange"), 0 < a.length && (o = new wu(
      "onChange",
      "change",
      null,
      o,
      d
    ), n.push({ event: o, listeners: a }));
  }
  var cr = null, dr = null;
  function Vm(n) {
    wl(n, 0);
  }
  function Qr(n) {
    var a = _t(n);
    if (qs(a)) return n;
  }
  function _m(n, a) {
    if (n === "change") return a;
  }
  var Fm = !1;
  if (kr) {
    var ll;
    if (kr) {
      var cl = "oninput" in document;
      if (!cl) {
        var Mm = document.createElement("div");
        Mm.setAttribute("oninput", "return;"), cl = typeof Mm.oninput == "function";
      }
      ll = cl;
    } else ll = !1;
    Fm = ll && (!document.documentMode || 9 < document.documentMode);
  }
  function fc() {
    cr && (cr.detachEvent("onpropertychange", km), dr = cr = null);
  }
  function km(n) {
    if (n.propertyName === "value" && Qr(dr)) {
      var a = [];
      Wu(
        a,
        dr,
        n,
        Qu(n)
      ), mc(Vm, a);
    }
  }
  function Hu(n, a, o) {
    n === "focusin" ? (fc(), cr = a, dr = o, cr.attachEvent("onpropertychange", km)) : n === "focusout" && fc();
  }
  function hs(n) {
    if (n === "selectionchange" || n === "keyup" || n === "keydown")
      return Qr(dr);
  }
  function _o(n, a) {
    if (n === "click") return Qr(a);
  }
  function Dm(n, a) {
    if (n === "input" || n === "change")
      return Qr(a);
  }
  function Qm(n, a) {
    return n === a && (n !== 0 || 1 / n === 1 / a) || n !== n && a !== a;
  }
  var fi = typeof Object.is == "function" ? Object.is : Qm;
  function ms(n, a) {
    if (fi(n, a)) return !0;
    if (typeof n != "object" || n === null || typeof a != "object" || a === null)
      return !1;
    var o = Object.keys(n), d = Object.keys(a);
    if (o.length !== d.length) return !1;
    for (d = 0; d < o.length; d++) {
      var p = o[d];
      if (!Yt.call(a, p) || !fi(n[p], a[p]))
        return !1;
    }
    return !0;
  }
  function ps(n) {
    for (; n && n.firstChild; ) n = n.firstChild;
    return n;
  }
  function Sn(n, a) {
    var o = ps(n);
    n = 0;
    for (var d; o; ) {
      if (o.nodeType === 3) {
        if (d = n + o.textContent.length, n <= a && d >= a)
          return { node: o, offset: a - n };
        n = d;
      }
      e: {
        for (; o; ) {
          if (o.nextSibling) {
            o = o.nextSibling;
            break e;
          }
          o = o.parentNode;
        }
        o = void 0;
      }
      o = ps(o);
    }
  }
  function Hd(n, a) {
    return n && a ? n === a ? !0 : n && n.nodeType === 3 ? !1 : a && a.nodeType === 3 ? Hd(n, a.parentNode) : "contains" in n ? n.contains(a) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(a) & 16) : !1 : !1;
  }
  function xm(n) {
    n = n != null && n.ownerDocument != null && n.ownerDocument.defaultView != null ? n.ownerDocument.defaultView : window;
    for (var a = cc(n.document); a instanceof n.HTMLIFrameElement; ) {
      try {
        var o = typeof a.contentWindow.location.href == "string";
      } catch {
        o = !1;
      }
      if (o) n = a.contentWindow;
      else break;
      a = cc(n.document);
    }
    return a;
  }
  function zd(n) {
    var a = n && n.nodeName && n.nodeName.toLowerCase();
    return a && (a === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || a === "textarea" || n.contentEditable === "true");
  }
  var dl = kr && "documentMode" in document && 11 >= document.documentMode, xr = null, ur = null, fs = null, ul = !1;
  function zu(n, a, o) {
    var d = o.window === o ? o.document : o.nodeType === 9 ? o : o.ownerDocument;
    ul || xr == null || xr !== cc(d) || (d = xr, "selectionStart" in d && zd(d) ? d = { start: d.selectionStart, end: d.selectionEnd } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
      anchorNode: d.anchorNode,
      anchorOffset: d.anchorOffset,
      focusNode: d.focusNode,
      focusOffset: d.focusOffset
    }), fs && ms(fs, d) || (fs = d, d = Kc(ur, "onSelect"), 0 < d.length && (a = new wu(
      "onSelect",
      "select",
      null,
      a,
      o
    ), n.push({ event: a, listeners: d }), a.target = xr)));
  }
  function Fo(n, a) {
    var o = {};
    return o[n.toLowerCase()] = a.toLowerCase(), o["Webkit" + n] = "webkit" + a, o["Moz" + n] = "moz" + a, o;
  }
  var hl = {
    animationend: Fo("Animation", "AnimationEnd"),
    animationiteration: Fo("Animation", "AnimationIteration"),
    animationstart: Fo("Animation", "AnimationStart"),
    transitionrun: Fo("Transition", "TransitionRun"),
    transitionstart: Fo("Transition", "TransitionStart"),
    transitioncancel: Fo("Transition", "TransitionCancel"),
    transitionend: Fo("Transition", "TransitionEnd")
  }, La = {}, hr = {};
  kr && (hr = document.createElement("div").style, "AnimationEvent" in window || (delete hl.animationend.animation, delete hl.animationiteration.animation, delete hl.animationstart.animation), "TransitionEvent" in window || delete hl.transitionend.transition);
  function Zr(n) {
    if (La[n]) return La[n];
    if (!hl[n]) return n;
    var a = hl[n], o;
    for (o in a)
      if (a.hasOwnProperty(o) && o in hr)
        return La[n] = a[o];
    return n;
  }
  var B2 = Zr("animationend"), Zm = Zr("animationiteration"), A2 = Zr("animationstart"), Om = Zr("transitionrun"), ju = Zr("transitionstart"), I2 = Zr("transitioncancel"), wm = Zr("transitionend"), Bm = /* @__PURE__ */ new Map(), gc = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  gc.push("scrollEnd");
  function Ja(n, a) {
    Bm.set(n, a), rs(a, [n]);
  }
  var Am = /* @__PURE__ */ new WeakMap();
  function ba(n, a) {
    if (typeof n == "object" && n !== null) {
      var o = Am.get(n);
      return o !== void 0 ? o : (a = {
        value: n,
        source: a,
        stack: um(a)
      }, Am.set(n, a), a);
    }
    return {
      value: n,
      source: a,
      stack: um(a)
    };
  }
  var aa = [], gs = 0, Or = 0;
  function mr() {
    for (var n = gs, a = Or = gs = 0; a < n; ) {
      var o = aa[a];
      aa[a++] = null;
      var d = aa[a];
      aa[a++] = null;
      var p = aa[a];
      aa[a++] = null;
      var g = aa[a];
      if (aa[a++] = null, d !== null && p !== null) {
        var y = d.pending;
        y === null ? p.next = p : (p.next = y.next, y.next = p), d.pending = p;
      }
      g !== 0 && Sc(o, p, g);
    }
  }
  function vs(n, a, o, d) {
    aa[gs++] = n, aa[gs++] = a, aa[gs++] = o, aa[gs++] = d, Or |= d, n.lanes |= d, n = n.alternate, n !== null && (n.lanes |= d);
  }
  function vc(n, a, o, d) {
    return vs(n, a, o, d), jd(n);
  }
  function wr(n, a) {
    return vs(n, null, null, a), jd(n);
  }
  function Sc(n, a, o) {
    n.lanes |= o;
    var d = n.alternate;
    d !== null && (d.lanes |= o);
    for (var p = !1, g = n.return; g !== null; )
      g.childLanes |= o, d = g.alternate, d !== null && (d.childLanes |= o), g.tag === 22 && (n = g.stateNode, n === null || n._visibility & 1 || (p = !0)), n = g, g = g.return;
    return n.tag === 3 ? (g = n.stateNode, p && a !== null && (p = 31 - Pn(o), n = g.hiddenUpdates, d = n[p], d === null ? n[p] = [a] : d.push(a), a.lane = o | 536870912), g) : null;
  }
  function jd(n) {
    if (50 < zc)
      throw zc = 0, Ap = null, Error(h(185));
    for (var a = n.return; a !== null; )
      n = a, a = n.return;
    return n.tag === 3 ? n.stateNode : null;
  }
  var Rc = {};
  function L2(n, a, o, d) {
    this.tag = n, this.key = o, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = a, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = d, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ra(n, a, o, d) {
    return new L2(n, a, o, d);
  }
  function Pd(n) {
    return n = n.prototype, !(!n || !n.isReactComponent);
  }
  function pr(n, a) {
    var o = n.alternate;
    return o === null ? (o = ra(
      n.tag,
      a,
      n.key,
      n.mode
    ), o.elementType = n.elementType, o.type = n.type, o.stateNode = n.stateNode, o.alternate = n, n.alternate = o) : (o.pendingProps = a, o.type = n.type, o.flags = 0, o.subtreeFlags = 0, o.deletions = null), o.flags = n.flags & 65011712, o.childLanes = n.childLanes, o.lanes = n.lanes, o.child = n.child, o.memoizedProps = n.memoizedProps, o.memoizedState = n.memoizedState, o.updateQueue = n.updateQueue, a = n.dependencies, o.dependencies = a === null ? null : { lanes: a.lanes, firstContext: a.firstContext }, o.sibling = n.sibling, o.index = n.index, o.ref = n.ref, o.refCleanup = n.refCleanup, o;
  }
  function Ft(n, a) {
    n.flags &= 65011714;
    var o = n.alternate;
    return o === null ? (n.childLanes = 0, n.lanes = a, n.child = null, n.subtreeFlags = 0, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null) : (n.childLanes = o.childLanes, n.lanes = o.lanes, n.child = o.child, n.subtreeFlags = 0, n.deletions = null, n.memoizedProps = o.memoizedProps, n.memoizedState = o.memoizedState, n.updateQueue = o.updateQueue, n.type = o.type, a = o.dependencies, n.dependencies = a === null ? null : {
      lanes: a.lanes,
      firstContext: a.firstContext
    }), n;
  }
  function Qe(n, a, o, d, p, g) {
    var y = 0;
    if (d = n, typeof n == "function") Pd(n) && (y = 1);
    else if (typeof n == "string")
      y = Ug(
        n,
        o,
        $.current
      ) ? 26 : n === "html" || n === "head" || n === "body" ? 27 : 5;
    else
      e: switch (n) {
        case Fe:
          return n = ra(31, o, a, p), n.elementType = Fe, n.lanes = g, n;
        case ce:
          return Wa(o.children, p, g, a);
        case oe:
          y = 8, p |= 24;
          break;
        case be:
          return n = ra(12, o, a, p | 2), n.elementType = be, n.lanes = g, n;
        case j:
          return n = ra(13, o, a, p), n.elementType = j, n.lanes = g, n;
        case Te:
          return n = ra(19, o, a, p), n.elementType = Te, n.lanes = g, n;
        default:
          if (typeof n == "object" && n !== null)
            switch (n.$$typeof) {
              case ge:
              case _e:
                y = 10;
                break e;
              case te:
                y = 9;
                break e;
              case Ue:
                y = 11;
                break e;
              case Ne:
                y = 14;
                break e;
              case xe:
                y = 16, d = null;
                break e;
            }
          y = 29, o = Error(
            h(130, n === null ? "null" : typeof n, "")
          ), d = null;
      }
    return a = ra(y, o, a, p), a.elementType = n, a.type = d, a.lanes = g, a;
  }
  function Wa(n, a, o, d) {
    return n = ra(7, n, d, a), n.lanes = o, n;
  }
  function Ec(n, a, o) {
    return n = ra(6, n, null, a), n.lanes = o, n;
  }
  function kn(n, a, o) {
    return a = ra(
      4,
      n.children !== null ? n.children : [],
      n.key,
      a
    ), a.lanes = o, a.stateNode = {
      containerInfo: n.containerInfo,
      pendingChildren: null,
      implementation: n.implementation
    }, a;
  }
  var Ss = [], Rs = 0, Gd = null, Uc = 0, Ha = [], oa = 0, Mo = null, fr = 1, Zn = "";
  function Lt(n, a) {
    Ss[Rs++] = Uc, Ss[Rs++] = Gd, Gd = n, Uc = a;
  }
  function Pu(n, a, o) {
    Ha[oa++] = fr, Ha[oa++] = Zn, Ha[oa++] = Mo, Mo = n;
    var d = fr;
    n = Zn;
    var p = 32 - Pn(d) - 1;
    d &= ~(1 << p), o += 1;
    var g = 32 - Pn(a) + p;
    if (30 < g) {
      var y = p - p % 5;
      g = (d & (1 << y) - 1).toString(32), d >>= y, p -= y, fr = 1 << 32 - Pn(a) + p | o << p | d, Zn = g + n;
    } else
      fr = 1 << g | o << p | d, Zn = n;
  }
  function ml(n) {
    n.return !== null && (Lt(n, 1), Pu(n, 1, 0));
  }
  function Br(n) {
    for (; n === Gd; )
      Gd = Ss[--Rs], Ss[Rs] = null, Uc = Ss[--Rs], Ss[Rs] = null;
    for (; n === Mo; )
      Mo = Ha[--oa], Ha[oa] = null, Zn = Ha[--oa], Ha[oa] = null, fr = Ha[--oa], Ha[oa] = null;
  }
  var Gn = null, zt = null, Ht = !1, za = null, ja = !1, pl = Error(h(519));
  function ko(n) {
    var a = Error(h(418, ""));
    throw Nc(ba(a, n)), pl;
  }
  function Yd(n) {
    var a = n.stateNode, o = n.type, d = n.memoizedProps;
    switch (a[rn] = n, a[qn] = d, o) {
      case "dialog":
        Ut("cancel", a), Ut("close", a);
        break;
      case "iframe":
      case "object":
      case "embed":
        Ut("load", a);
        break;
      case "video":
      case "audio":
        for (o = 0; o < x0.length; o++)
          Ut(x0[o], a);
        break;
      case "source":
        Ut("error", a);
        break;
      case "img":
      case "image":
      case "link":
        Ut("error", a), Ut("load", a);
        break;
      case "details":
        Ut("toggle", a);
        break;
      case "input":
        Ut("invalid", a), ku(
          a,
          d.value,
          d.defaultValue,
          d.checked,
          d.defaultChecked,
          d.type,
          d.name,
          !0
        ), ls(a);
        break;
      case "select":
        Ut("invalid", a);
        break;
      case "textarea":
        Ut("invalid", a), pm(a, d.value, d.defaultValue, d.children), ls(a);
    }
    o = d.children, typeof o != "string" && typeof o != "number" && typeof o != "bigint" || a.textContent === "" + o || d.suppressHydrationWarning === !0 || $p(a.textContent, o) ? (d.popover != null && (Ut("beforetoggle", a), Ut("toggle", a)), d.onScroll != null && Ut("scroll", a), d.onScrollEnd != null && Ut("scrollend", a), d.onClick != null && (a.onclick = ih), a = !0) : a = !1, a || ko(n);
  }
  function Im(n) {
    for (Gn = n.return; Gn; )
      switch (Gn.tag) {
        case 5:
        case 13:
          ja = !1;
          return;
        case 27:
        case 3:
          ja = !0;
          return;
        default:
          Gn = Gn.return;
      }
  }
  function Tc(n) {
    if (n !== Gn) return !1;
    if (!Ht) return Im(n), Ht = !0, !1;
    var a = n.tag, o;
    if ((o = a !== 3 && a !== 27) && ((o = a === 5) && (o = n.type, o = !(o !== "form" && o !== "button") || ao(n.type, n.memoizedProps)), o = !o), o && zt && ko(n), Im(n), a === 13) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(h(317));
      e: {
        for (n = n.nextSibling, a = 0; n; ) {
          if (n.nodeType === 8)
            if (o = n.data, o === "/$") {
              if (a === 0) {
                zt = Ur(n.nextSibling);
                break e;
              }
              a--;
            } else
              o !== "$" && o !== "$!" && o !== "$?" || a++;
          n = n.nextSibling;
        }
        zt = null;
      }
    } else
      a === 27 ? (a = zt, ws(n.type) ? (n = Bs, Bs = null, zt = n) : zt = a) : zt = Gn ? Ur(n.stateNode.nextSibling) : null;
    return !0;
  }
  function yc() {
    zt = Gn = null, Ht = !1;
  }
  function Lm() {
    var n = za;
    return n !== null && (ha === null ? ha = n : ha.push.apply(
      ha,
      n
    ), za = null), n;
  }
  function Nc(n) {
    za === null ? za = [n] : za.push(n);
  }
  var Xd = W(null), Do = null, gr = null;
  function Qo(n, a, o) {
    Re(Xd, a._currentValue), a._currentValue = o;
  }
  function Ar(n) {
    n._currentValue = Xd.current, q(Xd);
  }
  function Gu(n, a, o) {
    for (; n !== null; ) {
      var d = n.alternate;
      if ((n.childLanes & a) !== a ? (n.childLanes |= a, d !== null && (d.childLanes |= a)) : d !== null && (d.childLanes & a) !== a && (d.childLanes |= a), n === o) break;
      n = n.return;
    }
  }
  function Jm(n, a, o, d) {
    var p = n.child;
    for (p !== null && (p.return = n); p !== null; ) {
      var g = p.dependencies;
      if (g !== null) {
        var y = p.child;
        g = g.firstContext;
        e: for (; g !== null; ) {
          var k = g;
          g = p;
          for (var w = 0; w < a.length; w++)
            if (k.context === a[w]) {
              g.lanes |= o, k = g.alternate, k !== null && (k.lanes |= o), Gu(
                g.return,
                o,
                n
              ), d || (y = null);
              break e;
            }
          g = k.next;
        }
      } else if (p.tag === 18) {
        if (y = p.return, y === null) throw Error(h(341));
        y.lanes |= o, g = y.alternate, g !== null && (g.lanes |= o), Gu(y, o, n), y = null;
      } else y = p.child;
      if (y !== null) y.return = p;
      else
        for (y = p; y !== null; ) {
          if (y === n) {
            y = null;
            break;
          }
          if (p = y.sibling, p !== null) {
            p.return = y.return, y = p;
            break;
          }
          y = y.return;
        }
      p = y;
    }
  }
  function bc(n, a, o, d) {
    n = null;
    for (var p = a, g = !1; p !== null; ) {
      if (!g) {
        if ((p.flags & 524288) !== 0) g = !0;
        else if ((p.flags & 262144) !== 0) break;
      }
      if (p.tag === 10) {
        var y = p.alternate;
        if (y === null) throw Error(h(387));
        if (y = y.memoizedProps, y !== null) {
          var k = p.type;
          fi(p.pendingProps.value, y.value) || (n !== null ? n.push(k) : n = [k]);
        }
      } else if (p === It.current) {
        if (y = p.alternate, y === null) throw Error(h(387));
        y.memoizedState.memoizedState !== p.memoizedState.memoizedState && (n !== null ? n.push(ga) : n = [ga]);
      }
      p = p.return;
    }
    n !== null && Jm(
      a,
      n,
      o,
      d
    ), a.flags |= 262144;
  }
  function Kd(n) {
    for (n = n.firstContext; n !== null; ) {
      if (!fi(
        n.context._currentValue,
        n.memoizedValue
      ))
        return !0;
      n = n.next;
    }
    return !1;
  }
  function Es(n) {
    Do = n, gr = null, n = n.dependencies, n !== null && (n.firstContext = null);
  }
  function si(n) {
    return Wm(Do, n);
  }
  function qd(n, a) {
    return Do === null && Es(n), Wm(n, a);
  }
  function Wm(n, a) {
    var o = a._currentValue;
    if (a = { context: a, memoizedValue: o, next: null }, gr === null) {
      if (n === null) throw Error(h(308));
      gr = a, n.dependencies = { lanes: 0, firstContext: a }, n.flags |= 524288;
    } else gr = gr.next = a;
    return o;
  }
  var Cc = typeof AbortController < "u" ? AbortController : function() {
    var n = [], a = this.signal = {
      aborted: !1,
      addEventListener: function(o, d) {
        n.push(d);
      }
    };
    this.abort = function() {
      a.aborted = !0, n.forEach(function(o) {
        return o();
      });
    };
  }, Yu = s.unstable_scheduleCallback, J2 = s.unstable_NormalPriority, $n = {
    $$typeof: _e,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Vc() {
    return {
      controller: new Cc(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function Ir(n) {
    n.refCount--, n.refCount === 0 && Yu(J2, function() {
      n.controller.abort();
    });
  }
  var Us = null, $d = 0, Pa = 0, ei = null;
  function Xu(n, a) {
    if (Us === null) {
      var o = Us = [];
      $d = 0, Pa = Ol(), ei = {
        status: "pending",
        value: void 0,
        then: function(d) {
          o.push(d);
        }
      };
    }
    return $d++, a.then(Ku, Ku), a;
  }
  function Ku() {
    if (--$d === 0 && Us !== null) {
      ei !== null && (ei.status = "fulfilled");
      var n = Us;
      Us = null, Pa = 0, ei = null;
      for (var a = 0; a < n.length; a++) (0, n[a])();
    }
  }
  function W2(n, a) {
    var o = [], d = {
      status: "pending",
      value: null,
      reason: null,
      then: function(p) {
        o.push(p);
      }
    };
    return n.then(
      function() {
        d.status = "fulfilled", d.value = a;
        for (var p = 0; p < o.length; p++) (0, o[p])(a);
      },
      function(p) {
        for (d.status = "rejected", d.reason = p, p = 0; p < o.length; p++)
          (0, o[p])(void 0);
      }
    ), d;
  }
  var qu = O.S;
  O.S = function(n, a) {
    typeof a == "object" && a !== null && typeof a.then == "function" && Xu(n, a), qu !== null && qu(n, a);
  };
  var Lr = W(null);
  function e0() {
    var n = Lr.current;
    return n !== null ? n : un.pooledCache;
  }
  function fl(n, a) {
    a === null ? Re(Lr, Lr.current) : Re(Lr, a.pool);
  }
  function $u() {
    var n = e0();
    return n === null ? null : { parent: $n._currentValue, pool: n };
  }
  var Ts = Error(h(460)), e1 = Error(h(474)), t0 = Error(h(542)), t1 = { then: function() {
  } };
  function n1(n) {
    return n = n.status, n === "fulfilled" || n === "rejected";
  }
  function n0() {
  }
  function Hm(n, a, o) {
    switch (o = n[o], o === void 0 ? n.push(a) : o !== a && (a.then(n0, n0), a = o), a.status) {
      case "fulfilled":
        return a.value;
      case "rejected":
        throw n = a.reason, jm(n), n;
      default:
        if (typeof a.status == "string") a.then(n0, n0);
        else {
          if (n = un, n !== null && 100 < n.shellSuspendCounter)
            throw Error(h(482));
          n = a, n.status = "pending", n.then(
            function(d) {
              if (a.status === "pending") {
                var p = a;
                p.status = "fulfilled", p.value = d;
              }
            },
            function(d) {
              if (a.status === "pending") {
                var p = a;
                p.status = "rejected", p.reason = d;
              }
            }
          );
        }
        switch (a.status) {
          case "fulfilled":
            return a.value;
          case "rejected":
            throw n = a.reason, jm(n), n;
        }
        throw gl = a, Ts;
    }
  }
  var gl = null;
  function zm() {
    if (gl === null) throw Error(h(459));
    var n = gl;
    return gl = null, n;
  }
  function jm(n) {
    if (n === Ts || n === t0)
      throw Error(h(483));
  }
  var Jr = !1;
  function i1(n) {
    n.updateQueue = {
      baseState: n.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function a1(n, a) {
    n = n.updateQueue, a.updateQueue === n && (a.updateQueue = {
      baseState: n.baseState,
      firstBaseUpdate: n.firstBaseUpdate,
      lastBaseUpdate: n.lastBaseUpdate,
      shared: n.shared,
      callbacks: null
    });
  }
  function sa(n) {
    return { lane: n, tag: 0, payload: null, callback: null, next: null };
  }
  function Wr(n, a, o) {
    var d = n.updateQueue;
    if (d === null) return null;
    if (d = d.shared, (qt & 2) !== 0) {
      var p = d.pending;
      return p === null ? a.next = a : (a.next = p.next, p.next = a), d.pending = a, a = jd(n), Sc(n, null, o), a;
    }
    return vs(n, d, a, o), jd(n);
  }
  function vl(n, a, o) {
    if (a = a.updateQueue, a !== null && (a = a.shared, (o & 4194048) !== 0)) {
      var d = a.lanes;
      d &= n.pendingLanes, o |= d, a.lanes = o, ht(n, o);
    }
  }
  function Pm(n, a) {
    var o = n.updateQueue, d = n.alternate;
    if (d !== null && (d = d.updateQueue, o === d)) {
      var p = null, g = null;
      if (o = o.firstBaseUpdate, o !== null) {
        do {
          var y = {
            lane: o.lane,
            tag: o.tag,
            payload: o.payload,
            callback: null,
            next: null
          };
          g === null ? p = g = y : g = g.next = y, o = o.next;
        } while (o !== null);
        g === null ? p = g = a : g = g.next = a;
      } else p = g = a;
      o = {
        baseState: d.baseState,
        firstBaseUpdate: p,
        lastBaseUpdate: g,
        shared: d.shared,
        callbacks: d.callbacks
      }, n.updateQueue = o;
      return;
    }
    n = o.lastBaseUpdate, n === null ? o.firstBaseUpdate = a : n.next = a, o.lastBaseUpdate = a;
  }
  var Gm = !1;
  function _c() {
    if (Gm) {
      var n = ei;
      if (n !== null) throw n;
    }
  }
  function xo(n, a, o, d) {
    Gm = !1;
    var p = n.updateQueue;
    Jr = !1;
    var g = p.firstBaseUpdate, y = p.lastBaseUpdate, k = p.shared.pending;
    if (k !== null) {
      p.shared.pending = null;
      var w = k, K = w.next;
      w.next = null, y === null ? g = K : y.next = K, y = w;
      var ve = n.alternate;
      ve !== null && (ve = ve.updateQueue, k = ve.lastBaseUpdate, k !== y && (k === null ? ve.firstBaseUpdate = K : k.next = K, ve.lastBaseUpdate = w));
    }
    if (g !== null) {
      var Ee = p.baseState;
      y = 0, ve = K = w = null, k = g;
      do {
        var ie = k.lane & -536870913, re = ie !== k.lane;
        if (re ? (Zt & ie) === ie : (d & ie) === ie) {
          ie !== 0 && ie === Pa && (Gm = !0), ve !== null && (ve = ve.next = {
            lane: 0,
            tag: k.tag,
            payload: k.payload,
            callback: null,
            next: null
          });
          e: {
            var at = n, rt = k;
            ie = a;
            var Pt = o;
            switch (rt.tag) {
              case 1:
                if (at = rt.payload, typeof at == "function") {
                  Ee = at.call(Pt, Ee, ie);
                  break e;
                }
                Ee = at;
                break e;
              case 3:
                at.flags = at.flags & -65537 | 128;
              case 0:
                if (at = rt.payload, ie = typeof at == "function" ? at.call(Pt, Ee, ie) : at, ie == null) break e;
                Ee = N({}, Ee, ie);
                break e;
              case 2:
                Jr = !0;
            }
          }
          ie = k.callback, ie !== null && (n.flags |= 64, re && (n.flags |= 8192), re = p.callbacks, re === null ? p.callbacks = [ie] : re.push(ie));
        } else
          re = {
            lane: ie,
            tag: k.tag,
            payload: k.payload,
            callback: k.callback,
            next: null
          }, ve === null ? (K = ve = re, w = Ee) : ve = ve.next = re, y |= ie;
        if (k = k.next, k === null) {
          if (k = p.shared.pending, k === null)
            break;
          re = k, k = re.next, re.next = null, p.lastBaseUpdate = re, p.shared.pending = null;
        }
      } while (!0);
      ve === null && (w = Ee), p.baseState = w, p.firstBaseUpdate = K, p.lastBaseUpdate = ve, g === null && (p.shared.lanes = 0), Lo |= y, n.lanes = y, n.memoizedState = Ee;
    }
  }
  function r1(n, a) {
    if (typeof n != "function")
      throw Error(h(191, n));
    n.call(a);
  }
  function i0(n, a) {
    var o = n.callbacks;
    if (o !== null)
      for (n.callbacks = null, n = 0; n < o.length; n++)
        r1(o[n], a);
  }
  var Sl = W(null), a0 = W(0);
  function li(n, a) {
    n = Io, Re(a0, n), Re(Sl, a), Io = n | a.baseLanes;
  }
  function Fc() {
    Re(a0, Io), Re(Sl, Sl.current);
  }
  function Mc() {
    Io = a0.current, q(Sl), q(a0);
  }
  var Ga = 0, Et = null, Kt = null, Dn = null, r0 = !1, Ca = !1, ys = !1, vr = 0, Va = 0, Zo = null, Ym = 0;
  function Qn() {
    throw Error(h(321));
  }
  function o1(n, a) {
    if (a === null) return !1;
    for (var o = 0; o < a.length && o < n.length; o++)
      if (!fi(n[o], a[o])) return !1;
    return !0;
  }
  function s1(n, a, o, d, p, g) {
    return Ga = g, Et = a, a.memoizedState = null, a.updateQueue = null, a.lanes = 0, O.H = n === null || n.memoizedState === null ? dp : up, ys = !1, g = o(d, p), ys = !1, Ca && (g = Xm(
      a,
      o,
      d,
      p
    )), Ns(n), g;
  }
  function Ns(n) {
    O.H = N1;
    var a = Kt !== null && Kt.next !== null;
    if (Ga = 0, Dn = Kt = Et = null, r0 = !1, Va = 0, Zo = null, a) throw Error(h(300));
    n === null || ti || (n = n.dependencies, n !== null && Kd(n) && (ti = !0));
  }
  function Xm(n, a, o, d) {
    Et = n;
    var p = 0;
    do {
      if (Ca && (Zo = null), Va = 0, Ca = !1, 25 <= p) throw Error(h(301));
      if (p += 1, Dn = Kt = null, n.updateQueue != null) {
        var g = n.updateQueue;
        g.lastEffect = null, g.events = null, g.stores = null, g.memoCache != null && (g.memoCache.index = 0);
      }
      O.H = Oo, g = a(o, d);
    } while (Ca);
    return g;
  }
  function H2() {
    var n = O.H, a = n.useState()[0];
    return a = typeof a.then == "function" ? s0(a) : a, n = n.useState()[0], (Kt !== null ? Kt.memoizedState : null) !== n && (Et.flags |= 1024), a;
  }
  function l1() {
    var n = vr !== 0;
    return vr = 0, n;
  }
  function kc(n, a, o) {
    a.updateQueue = n.updateQueue, a.flags &= -2053, n.lanes &= ~o;
  }
  function c1(n) {
    if (r0) {
      for (n = n.memoizedState; n !== null; ) {
        var a = n.queue;
        a !== null && (a.pending = null), n = n.next;
      }
      r0 = !1;
    }
    Ga = 0, Dn = Kt = Et = null, Ca = !1, Va = vr = 0, Zo = null;
  }
  function Mi() {
    var n = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Dn === null ? Et.memoizedState = Dn = n : Dn = Dn.next = n, Dn;
  }
  function On() {
    if (Kt === null) {
      var n = Et.alternate;
      n = n !== null ? n.memoizedState : null;
    } else n = Kt.next;
    var a = Dn === null ? Et.memoizedState : Dn.next;
    if (a !== null)
      Dn = a, Kt = n;
    else {
      if (n === null)
        throw Et.alternate === null ? Error(h(467)) : Error(h(310));
      Kt = n, n = {
        memoizedState: Kt.memoizedState,
        baseState: Kt.baseState,
        baseQueue: Kt.baseQueue,
        queue: Kt.queue,
        next: null
      }, Dn === null ? Et.memoizedState = Dn = n : Dn = Dn.next = n;
    }
    return Dn;
  }
  function o0() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function s0(n) {
    var a = Va;
    return Va += 1, Zo === null && (Zo = []), n = Hm(Zo, n, a), a = Et, (Dn === null ? a.memoizedState : Dn.next) === null && (a = a.alternate, O.H = a === null || a.memoizedState === null ? dp : up), n;
  }
  function Yn(n) {
    if (n !== null && typeof n == "object") {
      if (typeof n.then == "function") return s0(n);
      if (n.$$typeof === _e) return si(n);
    }
    throw Error(h(438, String(n)));
  }
  function d1(n) {
    var a = null, o = Et.updateQueue;
    if (o !== null && (a = o.memoCache), a == null) {
      var d = Et.alternate;
      d !== null && (d = d.updateQueue, d !== null && (d = d.memoCache, d != null && (a = {
        data: d.data.map(function(p) {
          return p.slice();
        }),
        index: 0
      })));
    }
    if (a == null && (a = { data: [], index: 0 }), o === null && (o = o0(), Et.updateQueue = o), o.memoCache = a, o = a.data[a.index], o === void 0)
      for (o = a.data[a.index] = Array(n), d = 0; d < n; d++)
        o[d] = ye;
    return a.index++, o;
  }
  function Hr(n, a) {
    return typeof a == "function" ? a(n) : a;
  }
  function l0(n) {
    var a = On();
    return u1(a, Kt, n);
  }
  function u1(n, a, o) {
    var d = n.queue;
    if (d === null) throw Error(h(311));
    d.lastRenderedReducer = o;
    var p = n.baseQueue, g = d.pending;
    if (g !== null) {
      if (p !== null) {
        var y = p.next;
        p.next = g.next, g.next = y;
      }
      a.baseQueue = p = g, d.pending = null;
    }
    if (g = n.baseState, p === null) n.memoizedState = g;
    else {
      a = p.next;
      var k = y = null, w = null, K = a, ve = !1;
      do {
        var Ee = K.lane & -536870913;
        if (Ee !== K.lane ? (Zt & Ee) === Ee : (Ga & Ee) === Ee) {
          var ie = K.revertLane;
          if (ie === 0)
            w !== null && (w = w.next = {
              lane: 0,
              revertLane: 0,
              action: K.action,
              hasEagerState: K.hasEagerState,
              eagerState: K.eagerState,
              next: null
            }), Ee === Pa && (ve = !0);
          else if ((Ga & ie) === ie) {
            K = K.next, ie === Pa && (ve = !0);
            continue;
          } else
            Ee = {
              lane: 0,
              revertLane: K.revertLane,
              action: K.action,
              hasEagerState: K.hasEagerState,
              eagerState: K.eagerState,
              next: null
            }, w === null ? (k = w = Ee, y = g) : w = w.next = Ee, Et.lanes |= ie, Lo |= ie;
          Ee = K.action, ys && o(g, Ee), g = K.hasEagerState ? K.eagerState : o(g, Ee);
        } else
          ie = {
            lane: Ee,
            revertLane: K.revertLane,
            action: K.action,
            hasEagerState: K.hasEagerState,
            eagerState: K.eagerState,
            next: null
          }, w === null ? (k = w = ie, y = g) : w = w.next = ie, Et.lanes |= Ee, Lo |= Ee;
        K = K.next;
      } while (K !== null && K !== a);
      if (w === null ? y = g : w.next = k, !fi(g, n.memoizedState) && (ti = !0, ve && (o = ei, o !== null)))
        throw o;
      n.memoizedState = g, n.baseState = y, n.baseQueue = w, d.lastRenderedState = g;
    }
    return p === null && (d.lanes = 0), [n.memoizedState, d.dispatch];
  }
  function h1(n) {
    var a = On(), o = a.queue;
    if (o === null) throw Error(h(311));
    o.lastRenderedReducer = n;
    var d = o.dispatch, p = o.pending, g = a.memoizedState;
    if (p !== null) {
      o.pending = null;
      var y = p = p.next;
      do
        g = n(g, y.action), y = y.next;
      while (y !== p);
      fi(g, a.memoizedState) || (ti = !0), a.memoizedState = g, a.baseQueue === null && (a.baseState = g), o.lastRenderedState = g;
    }
    return [g, d];
  }
  function c0(n, a, o) {
    var d = Et, p = On(), g = Ht;
    if (g) {
      if (o === void 0) throw Error(h(407));
      o = o();
    } else o = a();
    var y = !fi(
      (Kt || p).memoizedState,
      o
    );
    y && (p.memoizedState = o, ti = !0), p = p.queue;
    var k = qm.bind(null, d, p, n);
    if (on(2048, 8, k, [n]), p.getSnapshot !== a || y || Dn !== null && Dn.memoizedState.tag & 1) {
      if (d.flags |= 2048, la(
        9,
        h0(),
        Km.bind(
          null,
          d,
          p,
          o,
          a
        ),
        null
      ), un === null) throw Error(h(349));
      g || (Ga & 124) !== 0 || m1(d, a, o);
    }
    return o;
  }
  function m1(n, a, o) {
    n.flags |= 16384, n = { getSnapshot: a, value: o }, a = Et.updateQueue, a === null ? (a = o0(), Et.updateQueue = a, a.stores = [n]) : (o = a.stores, o === null ? a.stores = [n] : o.push(n));
  }
  function Km(n, a, o, d) {
    a.value = o, a.getSnapshot = d, $m(a) && p1(n);
  }
  function qm(n, a, o) {
    return o(function() {
      $m(a) && p1(n);
    });
  }
  function $m(n) {
    var a = n.getSnapshot;
    n = n.value;
    try {
      var o = a();
      return !fi(n, o);
    } catch {
      return !0;
    }
  }
  function p1(n) {
    var a = wr(n, 2);
    a !== null && Ma(a, n, 2);
  }
  function d0(n) {
    var a = Mi();
    if (typeof n == "function") {
      var o = n;
      if (n = o(), ys) {
        _i(!0);
        try {
          o();
        } finally {
          _i(!1);
        }
      }
    }
    return a.memoizedState = a.baseState = n, a.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Hr,
      lastRenderedState: n
    }, a;
  }
  function f1(n, a, o, d) {
    return n.baseState = o, u1(
      n,
      Kt,
      typeof d == "function" ? d : Hr
    );
  }
  function z2(n, a, o, d, p) {
    if (Tl(n)) throw Error(h(485));
    if (n = a.action, n !== null) {
      var g = {
        payload: p,
        action: n,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(y) {
          g.listeners.push(y);
        }
      };
      O.T !== null ? o(!0) : g.isTransition = !1, d(g), o = a.pending, o === null ? (g.next = a.pending = g, g1(a, g)) : (g.next = o.next, a.pending = o.next = g);
    }
  }
  function g1(n, a) {
    var o = a.action, d = a.payload, p = n.state;
    if (a.isTransition) {
      var g = O.T, y = {};
      O.T = y;
      try {
        var k = o(p, d), w = O.S;
        w !== null && w(y, k), u0(n, a, k);
      } catch (K) {
        S1(n, a, K);
      } finally {
        O.T = g;
      }
    } else
      try {
        g = o(p, d), u0(n, a, g);
      } catch (K) {
        S1(n, a, K);
      }
  }
  function u0(n, a, o) {
    o !== null && typeof o == "object" && typeof o.then == "function" ? o.then(
      function(d) {
        v1(n, a, d);
      },
      function(d) {
        return S1(n, a, d);
      }
    ) : v1(n, a, o);
  }
  function v1(n, a, o) {
    a.status = "fulfilled", a.value = o, ep(a), n.state = o, a = n.pending, a !== null && (o = a.next, o === a ? n.pending = null : (o = o.next, a.next = o, g1(n, o)));
  }
  function S1(n, a, o) {
    var d = n.pending;
    if (n.pending = null, d !== null) {
      d = d.next;
      do
        a.status = "rejected", a.reason = o, ep(a), a = a.next;
      while (a !== d);
    }
    n.action = null;
  }
  function ep(n) {
    n = n.listeners;
    for (var a = 0; a < n.length; a++) (0, n[a])();
  }
  function R1(n, a) {
    return a;
  }
  function tp(n, a) {
    if (Ht) {
      var o = un.formState;
      if (o !== null) {
        e: {
          var d = Et;
          if (Ht) {
            if (zt) {
              t: {
                for (var p = zt, g = ja; p.nodeType !== 8; ) {
                  if (!g) {
                    p = null;
                    break t;
                  }
                  if (p = Ur(
                    p.nextSibling
                  ), p === null) {
                    p = null;
                    break t;
                  }
                }
                g = p.data, p = g === "F!" || g === "F" ? p : null;
              }
              if (p) {
                zt = Ur(
                  p.nextSibling
                ), d = p.data === "F!";
                break e;
              }
            }
            ko(d);
          }
          d = !1;
        }
        d && (a = o[0]);
      }
    }
    return o = Mi(), o.memoizedState = o.baseState = a, d = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: R1,
      lastRenderedState: a
    }, o.queue = d, o = lp.bind(
      null,
      Et,
      d
    ), d.dispatch = o, d = d0(!1), g = f0.bind(
      null,
      Et,
      !1,
      d.queue
    ), d = Mi(), p = {
      state: a,
      dispatch: null,
      action: n,
      pending: null
    }, d.queue = p, o = z2.bind(
      null,
      Et,
      p,
      g,
      o
    ), p.dispatch = o, d.memoizedState = n, [a, o, !1];
  }
  function zr(n) {
    var a = On();
    return E1(a, Kt, n);
  }
  function E1(n, a, o) {
    if (a = u1(
      n,
      a,
      R1
    )[0], n = l0(Hr)[0], typeof a == "object" && a !== null && typeof a.then == "function")
      try {
        var d = s0(a);
      } catch (y) {
        throw y === Ts ? t0 : y;
      }
    else d = a;
    a = On();
    var p = a.queue, g = p.dispatch;
    return o !== a.memoizedState && (Et.flags |= 2048, la(
      9,
      h0(),
      lS.bind(null, p, o),
      null
    )), [d, g, n];
  }
  function lS(n, a) {
    n.action = a;
  }
  function U1(n) {
    var a = On(), o = Kt;
    if (o !== null)
      return E1(a, o, n);
    On(), a = a.memoizedState, o = On();
    var d = o.queue.dispatch;
    return o.memoizedState = n, [a, d, !1];
  }
  function la(n, a, o, d) {
    return n = { tag: n, create: o, deps: d, inst: a, next: null }, a = Et.updateQueue, a === null && (a = o0(), Et.updateQueue = a), o = a.lastEffect, o === null ? a.lastEffect = n.next = n : (d = o.next, o.next = n, n.next = d, a.lastEffect = n), n;
  }
  function h0() {
    return { destroy: void 0, resource: void 0 };
  }
  function m0() {
    return On().memoizedState;
  }
  function bs(n, a, o, d) {
    var p = Mi();
    d = d === void 0 ? null : d, Et.flags |= n, p.memoizedState = la(
      1 | a,
      h0(),
      o,
      d
    );
  }
  function on(n, a, o, d) {
    var p = On();
    d = d === void 0 ? null : d;
    var g = p.memoizedState.inst;
    Kt !== null && d !== null && o1(d, Kt.memoizedState.deps) ? p.memoizedState = la(a, g, o, d) : (Et.flags |= n, p.memoizedState = la(
      1 | a,
      g,
      o,
      d
    ));
  }
  function j2(n, a) {
    bs(8390656, 8, n, a);
  }
  function P2(n, a) {
    on(2048, 8, n, a);
  }
  function np(n, a) {
    return on(4, 2, n, a);
  }
  function Sr(n, a) {
    return on(4, 4, n, a);
  }
  function ip(n, a) {
    if (typeof a == "function") {
      n = n();
      var o = a(n);
      return function() {
        typeof o == "function" ? o() : a(null);
      };
    }
    if (a != null)
      return n = n(), a.current = n, function() {
        a.current = null;
      };
  }
  function T1(n, a, o) {
    o = o != null ? o.concat([n]) : null, on(4, 4, ip.bind(null, a, n), o);
  }
  function Rl() {
  }
  function El(n, a) {
    var o = On();
    a = a === void 0 ? null : a;
    var d = o.memoizedState;
    return a !== null && o1(a, d[1]) ? d[0] : (o.memoizedState = [n, a], n);
  }
  function ap(n, a) {
    var o = On();
    a = a === void 0 ? null : a;
    var d = o.memoizedState;
    if (a !== null && o1(a, d[1]))
      return d[0];
    if (d = n(), ys) {
      _i(!0);
      try {
        n();
      } finally {
        _i(!1);
      }
    }
    return o.memoizedState = [d, a], d;
  }
  function p0(n, a, o) {
    return o === void 0 || (Ga & 1073741824) !== 0 ? n.memoizedState = a : (n.memoizedState = o, n = Ip(), Et.lanes |= n, Lo |= n, o);
  }
  function rp(n, a, o, d) {
    return fi(o, a) ? o : Sl.current !== null ? (n = p0(n, o, d), fi(n, a) || (ti = !0), n) : (Ga & 42) === 0 ? (ti = !0, n.memoizedState = o) : (n = Ip(), Et.lanes |= n, Lo |= n, a);
  }
  function G2(n, a, o, d, p) {
    var g = G.p;
    G.p = g !== 0 && 8 > g ? g : 8;
    var y = O.T, k = {};
    O.T = k, f0(n, !1, a, o);
    try {
      var w = p(), K = O.S;
      if (K !== null && K(k, w), w !== null && typeof w == "object" && typeof w.then == "function") {
        var ve = W2(
          w,
          d
        );
        Ul(
          n,
          a,
          ve,
          Fa(n)
        );
      } else
        Ul(
          n,
          a,
          d,
          Fa(n)
        );
    } catch (Ee) {
      Ul(
        n,
        a,
        { then: function() {
        }, status: "rejected", reason: Ee },
        Fa()
      );
    } finally {
      G.p = g, O.T = y;
    }
  }
  function cS() {
  }
  function y1(n, a, o, d) {
    if (n.tag !== 5) throw Error(h(476));
    var p = Y2(n).queue;
    G2(
      n,
      p,
      a,
      se,
      o === null ? cS : function() {
        return Dc(n), o(d);
      }
    );
  }
  function Y2(n) {
    var a = n.memoizedState;
    if (a !== null) return a;
    a = {
      memoizedState: se,
      baseState: se,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Hr,
        lastRenderedState: se
      },
      next: null
    };
    var o = {};
    return a.next = {
      memoizedState: o,
      baseState: o,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Hr,
        lastRenderedState: o
      },
      next: null
    }, n.memoizedState = a, n = n.alternate, n !== null && (n.memoizedState = a), a;
  }
  function Dc(n) {
    var a = Y2(n).next.queue;
    Ul(n, a, {}, Fa());
  }
  function Ya() {
    return si(ga);
  }
  function op() {
    return On().memoizedState;
  }
  function X2() {
    return On().memoizedState;
  }
  function K2(n) {
    for (var a = n.return; a !== null; ) {
      switch (a.tag) {
        case 24:
        case 3:
          var o = Fa();
          n = sa(o);
          var d = Wr(a, n, o);
          d !== null && (Ma(d, a, o), vl(d, a, o)), a = { cache: Vc() }, n.payload = a;
          return;
      }
      a = a.return;
    }
  }
  function sp(n, a, o) {
    var d = Fa();
    o = {
      lane: d,
      revertLane: 0,
      action: o,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Tl(n) ? q2(a, o) : (o = vc(n, a, o, d), o !== null && (Ma(o, n, d), cp(o, a, d)));
  }
  function lp(n, a, o) {
    var d = Fa();
    Ul(n, a, o, d);
  }
  function Ul(n, a, o, d) {
    var p = {
      lane: d,
      revertLane: 0,
      action: o,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Tl(n)) q2(a, p);
    else {
      var g = n.alternate;
      if (n.lanes === 0 && (g === null || g.lanes === 0) && (g = a.lastRenderedReducer, g !== null))
        try {
          var y = a.lastRenderedState, k = g(y, o);
          if (p.hasEagerState = !0, p.eagerState = k, fi(k, y))
            return vs(n, a, p, 0), un === null && mr(), !1;
        } catch {
        } finally {
        }
      if (o = vc(n, a, p, d), o !== null)
        return Ma(o, n, d), cp(o, a, d), !0;
    }
    return !1;
  }
  function f0(n, a, o, d) {
    if (d = {
      lane: 2,
      revertLane: Ol(),
      action: d,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Tl(n)) {
      if (a) throw Error(h(479));
    } else
      a = vc(
        n,
        o,
        d,
        2
      ), a !== null && Ma(a, n, 2);
  }
  function Tl(n) {
    var a = n.alternate;
    return n === Et || a !== null && a === Et;
  }
  function q2(n, a) {
    Ca = r0 = !0;
    var o = n.pending;
    o === null ? a.next = a : (a.next = o.next, o.next = a), n.pending = a;
  }
  function cp(n, a, o) {
    if ((o & 4194048) !== 0) {
      var d = a.lanes;
      d &= n.pendingLanes, o |= d, a.lanes = o, ht(n, o);
    }
  }
  var N1 = {
    readContext: si,
    use: Yn,
    useCallback: Qn,
    useContext: Qn,
    useEffect: Qn,
    useImperativeHandle: Qn,
    useLayoutEffect: Qn,
    useInsertionEffect: Qn,
    useMemo: Qn,
    useReducer: Qn,
    useRef: Qn,
    useState: Qn,
    useDebugValue: Qn,
    useDeferredValue: Qn,
    useTransition: Qn,
    useSyncExternalStore: Qn,
    useId: Qn,
    useHostTransitionStatus: Qn,
    useFormState: Qn,
    useActionState: Qn,
    useOptimistic: Qn,
    useMemoCache: Qn,
    useCacheRefresh: Qn
  }, dp = {
    readContext: si,
    use: Yn,
    useCallback: function(n, a) {
      return Mi().memoizedState = [
        n,
        a === void 0 ? null : a
      ], n;
    },
    useContext: si,
    useEffect: j2,
    useImperativeHandle: function(n, a, o) {
      o = o != null ? o.concat([n]) : null, bs(
        4194308,
        4,
        ip.bind(null, a, n),
        o
      );
    },
    useLayoutEffect: function(n, a) {
      return bs(4194308, 4, n, a);
    },
    useInsertionEffect: function(n, a) {
      bs(4, 2, n, a);
    },
    useMemo: function(n, a) {
      var o = Mi();
      a = a === void 0 ? null : a;
      var d = n();
      if (ys) {
        _i(!0);
        try {
          n();
        } finally {
          _i(!1);
        }
      }
      return o.memoizedState = [d, a], d;
    },
    useReducer: function(n, a, o) {
      var d = Mi();
      if (o !== void 0) {
        var p = o(a);
        if (ys) {
          _i(!0);
          try {
            o(a);
          } finally {
            _i(!1);
          }
        }
      } else p = a;
      return d.memoizedState = d.baseState = p, n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: p
      }, d.queue = n, n = n.dispatch = sp.bind(
        null,
        Et,
        n
      ), [d.memoizedState, n];
    },
    useRef: function(n) {
      var a = Mi();
      return n = { current: n }, a.memoizedState = n;
    },
    useState: function(n) {
      n = d0(n);
      var a = n.queue, o = lp.bind(null, Et, a);
      return a.dispatch = o, [n.memoizedState, o];
    },
    useDebugValue: Rl,
    useDeferredValue: function(n, a) {
      var o = Mi();
      return p0(o, n, a);
    },
    useTransition: function() {
      var n = d0(!1);
      return n = G2.bind(
        null,
        Et,
        n.queue,
        !0,
        !1
      ), Mi().memoizedState = n, [!1, n];
    },
    useSyncExternalStore: function(n, a, o) {
      var d = Et, p = Mi();
      if (Ht) {
        if (o === void 0)
          throw Error(h(407));
        o = o();
      } else {
        if (o = a(), un === null)
          throw Error(h(349));
        (Zt & 124) !== 0 || m1(d, a, o);
      }
      p.memoizedState = o;
      var g = { value: o, getSnapshot: a };
      return p.queue = g, j2(qm.bind(null, d, g, n), [
        n
      ]), d.flags |= 2048, la(
        9,
        h0(),
        Km.bind(
          null,
          d,
          g,
          o,
          a
        ),
        null
      ), o;
    },
    useId: function() {
      var n = Mi(), a = un.identifierPrefix;
      if (Ht) {
        var o = Zn, d = fr;
        o = (d & ~(1 << 32 - Pn(d) - 1)).toString(32) + o, a = "«" + a + "R" + o, o = vr++, 0 < o && (a += "H" + o.toString(32)), a += "»";
      } else
        o = Ym++, a = "«" + a + "r" + o.toString(32) + "»";
      return n.memoizedState = a;
    },
    useHostTransitionStatus: Ya,
    useFormState: tp,
    useActionState: tp,
    useOptimistic: function(n) {
      var a = Mi();
      a.memoizedState = a.baseState = n;
      var o = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return a.queue = o, a = f0.bind(
        null,
        Et,
        !0,
        o
      ), o.dispatch = a, [n, a];
    },
    useMemoCache: d1,
    useCacheRefresh: function() {
      return Mi().memoizedState = K2.bind(
        null,
        Et
      );
    }
  }, up = {
    readContext: si,
    use: Yn,
    useCallback: El,
    useContext: si,
    useEffect: P2,
    useImperativeHandle: T1,
    useInsertionEffect: np,
    useLayoutEffect: Sr,
    useMemo: ap,
    useReducer: l0,
    useRef: m0,
    useState: function() {
      return l0(Hr);
    },
    useDebugValue: Rl,
    useDeferredValue: function(n, a) {
      var o = On();
      return rp(
        o,
        Kt.memoizedState,
        n,
        a
      );
    },
    useTransition: function() {
      var n = l0(Hr)[0], a = On().memoizedState;
      return [
        typeof n == "boolean" ? n : s0(n),
        a
      ];
    },
    useSyncExternalStore: c0,
    useId: op,
    useHostTransitionStatus: Ya,
    useFormState: zr,
    useActionState: zr,
    useOptimistic: function(n, a) {
      var o = On();
      return f1(o, Kt, n, a);
    },
    useMemoCache: d1,
    useCacheRefresh: X2
  }, Oo = {
    readContext: si,
    use: Yn,
    useCallback: El,
    useContext: si,
    useEffect: P2,
    useImperativeHandle: T1,
    useInsertionEffect: np,
    useLayoutEffect: Sr,
    useMemo: ap,
    useReducer: h1,
    useRef: m0,
    useState: function() {
      return h1(Hr);
    },
    useDebugValue: Rl,
    useDeferredValue: function(n, a) {
      var o = On();
      return Kt === null ? p0(o, n, a) : rp(
        o,
        Kt.memoizedState,
        n,
        a
      );
    },
    useTransition: function() {
      var n = h1(Hr)[0], a = On().memoizedState;
      return [
        typeof n == "boolean" ? n : s0(n),
        a
      ];
    },
    useSyncExternalStore: c0,
    useId: op,
    useHostTransitionStatus: Ya,
    useFormState: U1,
    useActionState: U1,
    useOptimistic: function(n, a) {
      var o = On();
      return Kt !== null ? f1(o, Kt, n, a) : (o.baseState = n, [n, o.queue.dispatch]);
    },
    useMemoCache: d1,
    useCacheRefresh: X2
  }, yl = null, Qc = 0;
  function b1(n) {
    var a = Qc;
    return Qc += 1, yl === null && (yl = []), Hm(yl, n, a);
  }
  function Nl(n, a) {
    a = a.props.ref, n.ref = a !== void 0 ? a : null;
  }
  function ki(n, a) {
    throw a.$$typeof === _ ? Error(h(525)) : (n = Object.prototype.toString.call(a), Error(
      h(
        31,
        n === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : n
      )
    ));
  }
  function hp(n) {
    var a = n._init;
    return a(n._payload);
  }
  function ca(n) {
    function a(P, J) {
      if (n) {
        var X = P.deletions;
        X === null ? (P.deletions = [J], P.flags |= 16) : X.push(J);
      }
    }
    function o(P, J) {
      if (!n) return null;
      for (; J !== null; )
        a(P, J), J = J.sibling;
      return null;
    }
    function d(P) {
      for (var J = /* @__PURE__ */ new Map(); P !== null; )
        P.key !== null ? J.set(P.key, P) : J.set(P.index, P), P = P.sibling;
      return J;
    }
    function p(P, J) {
      return P = pr(P, J), P.index = 0, P.sibling = null, P;
    }
    function g(P, J, X) {
      return P.index = X, n ? (X = P.alternate, X !== null ? (X = X.index, X < J ? (P.flags |= 67108866, J) : X) : (P.flags |= 67108866, J)) : (P.flags |= 1048576, J);
    }
    function y(P) {
      return n && P.alternate === null && (P.flags |= 67108866), P;
    }
    function k(P, J, X, Se) {
      return J === null || J.tag !== 6 ? (J = Ec(X, P.mode, Se), J.return = P, J) : (J = p(J, X), J.return = P, J);
    }
    function w(P, J, X, Se) {
      var Xe = X.type;
      return Xe === ce ? ve(
        P,
        J,
        X.props.children,
        Se,
        X.key
      ) : J !== null && (J.elementType === Xe || typeof Xe == "object" && Xe !== null && Xe.$$typeof === xe && hp(Xe) === J.type) ? (J = p(J, X.props), Nl(J, X), J.return = P, J) : (J = Qe(
        X.type,
        X.key,
        X.props,
        null,
        P.mode,
        Se
      ), Nl(J, X), J.return = P, J);
    }
    function K(P, J, X, Se) {
      return J === null || J.tag !== 4 || J.stateNode.containerInfo !== X.containerInfo || J.stateNode.implementation !== X.implementation ? (J = kn(X, P.mode, Se), J.return = P, J) : (J = p(J, X.children || []), J.return = P, J);
    }
    function ve(P, J, X, Se, Xe) {
      return J === null || J.tag !== 7 ? (J = Wa(
        X,
        P.mode,
        Se,
        Xe
      ), J.return = P, J) : (J = p(J, X), J.return = P, J);
    }
    function Ee(P, J, X) {
      if (typeof J == "string" && J !== "" || typeof J == "number" || typeof J == "bigint")
        return J = Ec(
          "" + J,
          P.mode,
          X
        ), J.return = P, J;
      if (typeof J == "object" && J !== null) {
        switch (J.$$typeof) {
          case V:
            return X = Qe(
              J.type,
              J.key,
              J.props,
              null,
              P.mode,
              X
            ), Nl(X, J), X.return = P, X;
          case B:
            return J = kn(
              J,
              P.mode,
              X
            ), J.return = P, J;
          case xe:
            var Se = J._init;
            return J = Se(J._payload), Ee(P, J, X);
        }
        if (he(J) || we(J))
          return J = Wa(
            J,
            P.mode,
            X,
            null
          ), J.return = P, J;
        if (typeof J.then == "function")
          return Ee(P, b1(J), X);
        if (J.$$typeof === _e)
          return Ee(
            P,
            qd(P, J),
            X
          );
        ki(P, J);
      }
      return null;
    }
    function ie(P, J, X, Se) {
      var Xe = J !== null ? J.key : null;
      if (typeof X == "string" && X !== "" || typeof X == "number" || typeof X == "bigint")
        return Xe !== null ? null : k(P, J, "" + X, Se);
      if (typeof X == "object" && X !== null) {
        switch (X.$$typeof) {
          case V:
            return X.key === Xe ? w(P, J, X, Se) : null;
          case B:
            return X.key === Xe ? K(P, J, X, Se) : null;
          case xe:
            return Xe = X._init, X = Xe(X._payload), ie(P, J, X, Se);
        }
        if (he(X) || we(X))
          return Xe !== null ? null : ve(P, J, X, Se, null);
        if (typeof X.then == "function")
          return ie(
            P,
            J,
            b1(X),
            Se
          );
        if (X.$$typeof === _e)
          return ie(
            P,
            J,
            qd(P, X),
            Se
          );
        ki(P, X);
      }
      return null;
    }
    function re(P, J, X, Se, Xe) {
      if (typeof Se == "string" && Se !== "" || typeof Se == "number" || typeof Se == "bigint")
        return P = P.get(X) || null, k(J, P, "" + Se, Xe);
      if (typeof Se == "object" && Se !== null) {
        switch (Se.$$typeof) {
          case V:
            return P = P.get(
              Se.key === null ? X : Se.key
            ) || null, w(J, P, Se, Xe);
          case B:
            return P = P.get(
              Se.key === null ? X : Se.key
            ) || null, K(J, P, Se, Xe);
          case xe:
            var Mt = Se._init;
            return Se = Mt(Se._payload), re(
              P,
              J,
              X,
              Se,
              Xe
            );
        }
        if (he(Se) || we(Se))
          return P = P.get(X) || null, ve(J, P, Se, Xe, null);
        if (typeof Se.then == "function")
          return re(
            P,
            J,
            X,
            b1(Se),
            Xe
          );
        if (Se.$$typeof === _e)
          return re(
            P,
            J,
            X,
            qd(J, Se),
            Xe
          );
        ki(J, Se);
      }
      return null;
    }
    function at(P, J, X, Se) {
      for (var Xe = null, Mt = null, nt = J, ct = J = 0, ui = null; nt !== null && ct < X.length; ct++) {
        nt.index > ct ? (ui = nt, nt = null) : ui = nt.sibling;
        var Wt = ie(
          P,
          nt,
          X[ct],
          Se
        );
        if (Wt === null) {
          nt === null && (nt = ui);
          break;
        }
        n && nt && Wt.alternate === null && a(P, nt), J = g(Wt, J, ct), Mt === null ? Xe = Wt : Mt.sibling = Wt, Mt = Wt, nt = ui;
      }
      if (ct === X.length)
        return o(P, nt), Ht && Lt(P, ct), Xe;
      if (nt === null) {
        for (; ct < X.length; ct++)
          nt = Ee(P, X[ct], Se), nt !== null && (J = g(
            nt,
            J,
            ct
          ), Mt === null ? Xe = nt : Mt.sibling = nt, Mt = nt);
        return Ht && Lt(P, ct), Xe;
      }
      for (nt = d(nt); ct < X.length; ct++)
        ui = re(
          nt,
          P,
          ct,
          X[ct],
          Se
        ), ui !== null && (n && ui.alternate !== null && nt.delete(
          ui.key === null ? ct : ui.key
        ), J = g(
          ui,
          J,
          ct
        ), Mt === null ? Xe = ui : Mt.sibling = ui, Mt = ui);
      return n && nt.forEach(function(Ws) {
        return a(P, Ws);
      }), Ht && Lt(P, ct), Xe;
    }
    function rt(P, J, X, Se) {
      if (X == null) throw Error(h(151));
      for (var Xe = null, Mt = null, nt = J, ct = J = 0, ui = null, Wt = X.next(); nt !== null && !Wt.done; ct++, Wt = X.next()) {
        nt.index > ct ? (ui = nt, nt = null) : ui = nt.sibling;
        var Ws = ie(P, nt, Wt.value, Se);
        if (Ws === null) {
          nt === null && (nt = ui);
          break;
        }
        n && nt && Ws.alternate === null && a(P, nt), J = g(Ws, J, ct), Mt === null ? Xe = Ws : Mt.sibling = Ws, Mt = Ws, nt = ui;
      }
      if (Wt.done)
        return o(P, nt), Ht && Lt(P, ct), Xe;
      if (nt === null) {
        for (; !Wt.done; ct++, Wt = X.next())
          Wt = Ee(P, Wt.value, Se), Wt !== null && (J = g(Wt, J, ct), Mt === null ? Xe = Wt : Mt.sibling = Wt, Mt = Wt);
        return Ht && Lt(P, ct), Xe;
      }
      for (nt = d(nt); !Wt.done; ct++, Wt = X.next())
        Wt = re(nt, P, ct, Wt.value, Se), Wt !== null && (n && Wt.alternate !== null && nt.delete(Wt.key === null ? ct : Wt.key), J = g(Wt, J, ct), Mt === null ? Xe = Wt : Mt.sibling = Wt, Mt = Wt);
      return n && nt.forEach(function(US) {
        return a(P, US);
      }), Ht && Lt(P, ct), Xe;
    }
    function Pt(P, J, X, Se) {
      if (typeof X == "object" && X !== null && X.type === ce && X.key === null && (X = X.props.children), typeof X == "object" && X !== null) {
        switch (X.$$typeof) {
          case V:
            e: {
              for (var Xe = X.key; J !== null; ) {
                if (J.key === Xe) {
                  if (Xe = X.type, Xe === ce) {
                    if (J.tag === 7) {
                      o(
                        P,
                        J.sibling
                      ), Se = p(
                        J,
                        X.props.children
                      ), Se.return = P, P = Se;
                      break e;
                    }
                  } else if (J.elementType === Xe || typeof Xe == "object" && Xe !== null && Xe.$$typeof === xe && hp(Xe) === J.type) {
                    o(
                      P,
                      J.sibling
                    ), Se = p(J, X.props), Nl(Se, X), Se.return = P, P = Se;
                    break e;
                  }
                  o(P, J);
                  break;
                } else a(P, J);
                J = J.sibling;
              }
              X.type === ce ? (Se = Wa(
                X.props.children,
                P.mode,
                Se,
                X.key
              ), Se.return = P, P = Se) : (Se = Qe(
                X.type,
                X.key,
                X.props,
                null,
                P.mode,
                Se
              ), Nl(Se, X), Se.return = P, P = Se);
            }
            return y(P);
          case B:
            e: {
              for (Xe = X.key; J !== null; ) {
                if (J.key === Xe)
                  if (J.tag === 4 && J.stateNode.containerInfo === X.containerInfo && J.stateNode.implementation === X.implementation) {
                    o(
                      P,
                      J.sibling
                    ), Se = p(J, X.children || []), Se.return = P, P = Se;
                    break e;
                  } else {
                    o(P, J);
                    break;
                  }
                else a(P, J);
                J = J.sibling;
              }
              Se = kn(X, P.mode, Se), Se.return = P, P = Se;
            }
            return y(P);
          case xe:
            return Xe = X._init, X = Xe(X._payload), Pt(
              P,
              J,
              X,
              Se
            );
        }
        if (he(X))
          return at(
            P,
            J,
            X,
            Se
          );
        if (we(X)) {
          if (Xe = we(X), typeof Xe != "function") throw Error(h(150));
          return X = Xe.call(X), rt(
            P,
            J,
            X,
            Se
          );
        }
        if (typeof X.then == "function")
          return Pt(
            P,
            J,
            b1(X),
            Se
          );
        if (X.$$typeof === _e)
          return Pt(
            P,
            J,
            qd(P, X),
            Se
          );
        ki(P, X);
      }
      return typeof X == "string" && X !== "" || typeof X == "number" || typeof X == "bigint" ? (X = "" + X, J !== null && J.tag === 6 ? (o(P, J.sibling), Se = p(J, X), Se.return = P, P = Se) : (o(P, J), Se = Ec(X, P.mode, Se), Se.return = P, P = Se), y(P)) : o(P, J);
    }
    return function(P, J, X, Se) {
      try {
        Qc = 0;
        var Xe = Pt(
          P,
          J,
          X,
          Se
        );
        return yl = null, Xe;
      } catch (nt) {
        if (nt === Ts || nt === t0) throw nt;
        var Mt = ra(29, nt, null, P.mode);
        return Mt.lanes = Se, Mt.return = P, Mt;
      } finally {
      }
    };
  }
  var bl = ca(!0), jr = ca(!1), _a = W(null), Di = null;
  function wo(n) {
    var a = n.alternate;
    Re(sn, sn.current & 1), Re(_a, n), Di === null && (a === null || Sl.current !== null || a.memoizedState !== null) && (Di = n);
  }
  function Pr(n) {
    if (n.tag === 22) {
      if (Re(sn, sn.current), Re(_a, n), Di === null) {
        var a = n.alternate;
        a !== null && a.memoizedState !== null && (Di = n);
      }
    } else Gr();
  }
  function Gr() {
    Re(sn, sn.current), Re(_a, _a.current);
  }
  function Rr(n) {
    q(_a), Di === n && (Di = null), q(sn);
  }
  var sn = W(0);
  function g0(n) {
    for (var a = n; a !== null; ) {
      if (a.tag === 13) {
        var o = a.memoizedState;
        if (o !== null && (o = o.dehydrated, o === null || o.data === "$?" || A0(o)))
          return a;
      } else if (a.tag === 19 && a.memoizedProps.revealOrder !== void 0) {
        if ((a.flags & 128) !== 0) return a;
      } else if (a.child !== null) {
        a.child.return = a, a = a.child;
        continue;
      }
      if (a === n) break;
      for (; a.sibling === null; ) {
        if (a.return === null || a.return === n) return null;
        a = a.return;
      }
      a.sibling.return = a.return, a = a.sibling;
    }
    return null;
  }
  function Cs(n, a, o, d) {
    a = n.memoizedState, o = o(d, a), o = o == null ? a : N({}, a, o), n.memoizedState = o, n.lanes === 0 && (n.updateQueue.baseState = o);
  }
  var C1 = {
    enqueueSetState: function(n, a, o) {
      n = n._reactInternals;
      var d = Fa(), p = sa(d);
      p.payload = a, o != null && (p.callback = o), a = Wr(n, p, d), a !== null && (Ma(a, n, d), vl(a, n, d));
    },
    enqueueReplaceState: function(n, a, o) {
      n = n._reactInternals;
      var d = Fa(), p = sa(d);
      p.tag = 1, p.payload = a, o != null && (p.callback = o), a = Wr(n, p, d), a !== null && (Ma(a, n, d), vl(a, n, d));
    },
    enqueueForceUpdate: function(n, a) {
      n = n._reactInternals;
      var o = Fa(), d = sa(o);
      d.tag = 2, a != null && (d.callback = a), a = Wr(n, d, o), a !== null && (Ma(a, n, o), vl(a, n, o));
    }
  };
  function xc(n, a, o, d, p, g, y) {
    return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(d, g, y) : a.prototype && a.prototype.isPureReactComponent ? !ms(o, d) || !ms(p, g) : !0;
  }
  function Cl(n, a, o, d) {
    n = a.state, typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(o, d), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(o, d), a.state !== n && C1.enqueueReplaceState(a, a.state, null);
  }
  function Vs(n, a) {
    var o = a;
    if ("ref" in a) {
      o = {};
      for (var d in a)
        d !== "ref" && (o[d] = a[d]);
    }
    if (n = n.defaultProps) {
      o === a && (o = N({}, o));
      for (var p in n)
        o[p] === void 0 && (o[p] = n[p]);
    }
    return o;
  }
  var v0 = typeof reportError == "function" ? reportError : function(n) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var a = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof n == "object" && n !== null && typeof n.message == "string" ? String(n.message) : String(n),
        error: n
      });
      if (!window.dispatchEvent(a)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", n);
      return;
    }
    console.error(n);
  };
  function Zc(n) {
    v0(n);
  }
  function mp(n) {
    console.error(n);
  }
  function S0(n) {
    v0(n);
  }
  function R0(n, a) {
    try {
      var o = n.onUncaughtError;
      o(a.value, { componentStack: a.stack });
    } catch (d) {
      setTimeout(function() {
        throw d;
      });
    }
  }
  function pp(n, a, o) {
    try {
      var d = n.onCaughtError;
      d(o.value, {
        componentStack: o.stack,
        errorBoundary: a.tag === 1 ? a.stateNode : null
      });
    } catch (p) {
      setTimeout(function() {
        throw p;
      });
    }
  }
  function fp(n, a, o) {
    return o = sa(o), o.tag = 3, o.payload = { element: null }, o.callback = function() {
      R0(n, a);
    }, o;
  }
  function gp(n) {
    return n = sa(n), n.tag = 3, n;
  }
  function da(n, a, o, d) {
    var p = o.type.getDerivedStateFromError;
    if (typeof p == "function") {
      var g = d.value;
      n.payload = function() {
        return p(g);
      }, n.callback = function() {
        pp(a, o, d);
      };
    }
    var y = o.stateNode;
    y !== null && typeof y.componentDidCatch == "function" && (n.callback = function() {
      pp(a, o, d), typeof p != "function" && (ks === null ? ks = /* @__PURE__ */ new Set([this]) : ks.add(this));
      var k = d.stack;
      this.componentDidCatch(d.value, {
        componentStack: k !== null ? k : ""
      });
    });
  }
  function $2(n, a, o, d, p) {
    if (o.flags |= 32768, d !== null && typeof d == "object" && typeof d.then == "function") {
      if (a = o.alternate, a !== null && bc(
        a,
        o,
        p,
        !0
      ), o = _a.current, o !== null) {
        switch (o.tag) {
          case 13:
            return Di === null ? Zl() : o.alternate === null && In === 0 && (In = 3), o.flags &= -257, o.flags |= 65536, o.lanes = p, d === t1 ? o.flags |= 16384 : (a = o.updateQueue, a === null ? o.updateQueue = /* @__PURE__ */ new Set([d]) : a.add(d), q1(n, d, p)), !1;
          case 22:
            return o.flags |= 65536, d === t1 ? o.flags |= 16384 : (a = o.updateQueue, a === null ? (a = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([d])
            }, o.updateQueue = a) : (o = a.retryQueue, o === null ? a.retryQueue = /* @__PURE__ */ new Set([d]) : o.add(d)), q1(n, d, p)), !1;
        }
        throw Error(h(435, o.tag));
      }
      return q1(n, d, p), Zl(), !1;
    }
    if (Ht)
      return a = _a.current, a !== null ? ((a.flags & 65536) === 0 && (a.flags |= 256), a.flags |= 65536, a.lanes = p, d !== pl && (n = Error(h(422), { cause: d }), Nc(ba(n, o)))) : (d !== pl && (a = Error(h(423), {
        cause: d
      }), Nc(
        ba(a, o)
      )), n = n.current.alternate, n.flags |= 65536, p &= -p, n.lanes |= p, d = ba(d, o), p = fp(
        n.stateNode,
        d,
        p
      ), Pm(n, p), In !== 4 && (In = 2)), !1;
    var g = Error(h(520), { cause: d });
    if (g = ba(g, o), Jc === null ? Jc = [g] : Jc.push(g), In !== 4 && (In = 2), a === null) return !0;
    d = ba(d, o), o = a;
    do {
      switch (o.tag) {
        case 3:
          return o.flags |= 65536, n = p & -p, o.lanes |= n, n = fp(o.stateNode, d, n), Pm(o, n), !1;
        case 1:
          if (a = o.type, g = o.stateNode, (o.flags & 128) === 0 && (typeof a.getDerivedStateFromError == "function" || g !== null && typeof g.componentDidCatch == "function" && (ks === null || !ks.has(g))))
            return o.flags |= 65536, p &= -p, o.lanes |= p, p = gp(p), da(
              p,
              n,
              o,
              d
            ), Pm(o, p), !1;
      }
      o = o.return;
    } while (o !== null);
    return !1;
  }
  var wn = Error(h(461)), ti = !1;
  function ci(n, a, o, d) {
    a.child = n === null ? jr(a, null, o, d) : bl(
      a,
      n.child,
      o,
      d
    );
  }
  function eg(n, a, o, d, p) {
    o = o.render;
    var g = a.ref;
    if ("ref" in d) {
      var y = {};
      for (var k in d)
        k !== "ref" && (y[k] = d[k]);
    } else y = d;
    return Es(a), d = s1(
      n,
      a,
      o,
      y,
      g,
      p
    ), k = l1(), n !== null && !ti ? (kc(n, a, p), Yr(n, a, p)) : (Ht && k && ml(a), a.flags |= 1, ci(n, a, d, p), a.child);
  }
  function Bo(n, a, o, d, p) {
    if (n === null) {
      var g = o.type;
      return typeof g == "function" && !Pd(g) && g.defaultProps === void 0 && o.compare === null ? (a.tag = 15, a.type = g, Vl(
        n,
        a,
        g,
        d,
        p
      )) : (n = Qe(
        o.type,
        null,
        d,
        a,
        a.mode,
        p
      ), n.ref = a.ref, n.return = a, a.child = n);
    }
    if (g = n.child, !O1(n, p)) {
      var y = g.memoizedProps;
      if (o = o.compare, o = o !== null ? o : ms, o(y, d) && n.ref === a.ref)
        return Yr(n, a, p);
    }
    return a.flags |= 1, n = pr(g, d), n.ref = a.ref, n.return = a, a.child = n;
  }
  function Vl(n, a, o, d, p) {
    if (n !== null) {
      var g = n.memoizedProps;
      if (ms(g, d) && n.ref === a.ref)
        if (ti = !1, a.pendingProps = d = g, O1(n, p))
          (n.flags & 131072) !== 0 && (ti = !0);
        else
          return a.lanes = n.lanes, Yr(n, a, p);
    }
    return _1(
      n,
      a,
      o,
      d,
      p
    );
  }
  function V1(n, a, o) {
    var d = a.pendingProps, p = d.children, g = n !== null ? n.memoizedState : null;
    if (d.mode === "hidden") {
      if ((a.flags & 128) !== 0) {
        if (d = g !== null ? g.baseLanes | o : o, n !== null) {
          for (p = a.child = n.child, g = 0; p !== null; )
            g = g | p.lanes | p.childLanes, p = p.sibling;
          a.childLanes = g & ~d;
        } else a.childLanes = 0, a.child = null;
        return _l(
          n,
          a,
          d,
          o
        );
      }
      if ((o & 536870912) !== 0)
        a.memoizedState = { baseLanes: 0, cachePool: null }, n !== null && fl(
          a,
          g !== null ? g.cachePool : null
        ), g !== null ? li(a, g) : Fc(), Pr(a);
      else
        return a.lanes = a.childLanes = 536870912, _l(
          n,
          a,
          g !== null ? g.baseLanes | o : o,
          o
        );
    } else
      g !== null ? (fl(a, g.cachePool), li(a, g), Gr(), a.memoizedState = null) : (n !== null && fl(a, null), Fc(), Gr());
    return ci(n, a, p, o), a.child;
  }
  function _l(n, a, o, d) {
    var p = e0();
    return p = p === null ? null : { parent: $n._currentValue, pool: p }, a.memoizedState = {
      baseLanes: o,
      cachePool: p
    }, n !== null && fl(a, null), Fc(), Pr(a), n !== null && bc(n, a, d, !0), null;
  }
  function E0(n, a) {
    var o = a.ref;
    if (o === null)
      n !== null && n.ref !== null && (a.flags |= 4194816);
    else {
      if (typeof o != "function" && typeof o != "object")
        throw Error(h(284));
      (n === null || n.ref !== o) && (a.flags |= 4194816);
    }
  }
  function _1(n, a, o, d, p) {
    return Es(a), o = s1(
      n,
      a,
      o,
      d,
      void 0,
      p
    ), d = l1(), n !== null && !ti ? (kc(n, a, p), Yr(n, a, p)) : (Ht && d && ml(a), a.flags |= 1, ci(n, a, o, p), a.child);
  }
  function vp(n, a, o, d, p, g) {
    return Es(a), a.updateQueue = null, o = Xm(
      a,
      d,
      o,
      p
    ), Ns(n), d = l1(), n !== null && !ti ? (kc(n, a, g), Yr(n, a, g)) : (Ht && d && ml(a), a.flags |= 1, ci(n, a, o, g), a.child);
  }
  function F1(n, a, o, d, p) {
    if (Es(a), a.stateNode === null) {
      var g = Rc, y = o.contextType;
      typeof y == "object" && y !== null && (g = si(y)), g = new o(d, g), a.memoizedState = g.state !== null && g.state !== void 0 ? g.state : null, g.updater = C1, a.stateNode = g, g._reactInternals = a, g = a.stateNode, g.props = d, g.state = a.memoizedState, g.refs = {}, i1(a), y = o.contextType, g.context = typeof y == "object" && y !== null ? si(y) : Rc, g.state = a.memoizedState, y = o.getDerivedStateFromProps, typeof y == "function" && (Cs(
        a,
        o,
        y,
        d
      ), g.state = a.memoizedState), typeof o.getDerivedStateFromProps == "function" || typeof g.getSnapshotBeforeUpdate == "function" || typeof g.UNSAFE_componentWillMount != "function" && typeof g.componentWillMount != "function" || (y = g.state, typeof g.componentWillMount == "function" && g.componentWillMount(), typeof g.UNSAFE_componentWillMount == "function" && g.UNSAFE_componentWillMount(), y !== g.state && C1.enqueueReplaceState(g, g.state, null), xo(a, d, g, p), _c(), g.state = a.memoizedState), typeof g.componentDidMount == "function" && (a.flags |= 4194308), d = !0;
    } else if (n === null) {
      g = a.stateNode;
      var k = a.memoizedProps, w = Vs(o, k);
      g.props = w;
      var K = g.context, ve = o.contextType;
      y = Rc, typeof ve == "object" && ve !== null && (y = si(ve));
      var Ee = o.getDerivedStateFromProps;
      ve = typeof Ee == "function" || typeof g.getSnapshotBeforeUpdate == "function", k = a.pendingProps !== k, ve || typeof g.UNSAFE_componentWillReceiveProps != "function" && typeof g.componentWillReceiveProps != "function" || (k || K !== y) && Cl(
        a,
        g,
        d,
        y
      ), Jr = !1;
      var ie = a.memoizedState;
      g.state = ie, xo(a, d, g, p), _c(), K = a.memoizedState, k || ie !== K || Jr ? (typeof Ee == "function" && (Cs(
        a,
        o,
        Ee,
        d
      ), K = a.memoizedState), (w = Jr || xc(
        a,
        o,
        w,
        d,
        ie,
        K,
        y
      )) ? (ve || typeof g.UNSAFE_componentWillMount != "function" && typeof g.componentWillMount != "function" || (typeof g.componentWillMount == "function" && g.componentWillMount(), typeof g.UNSAFE_componentWillMount == "function" && g.UNSAFE_componentWillMount()), typeof g.componentDidMount == "function" && (a.flags |= 4194308)) : (typeof g.componentDidMount == "function" && (a.flags |= 4194308), a.memoizedProps = d, a.memoizedState = K), g.props = d, g.state = K, g.context = y, d = w) : (typeof g.componentDidMount == "function" && (a.flags |= 4194308), d = !1);
    } else {
      g = a.stateNode, a1(n, a), y = a.memoizedProps, ve = Vs(o, y), g.props = ve, Ee = a.pendingProps, ie = g.context, K = o.contextType, w = Rc, typeof K == "object" && K !== null && (w = si(K)), k = o.getDerivedStateFromProps, (K = typeof k == "function" || typeof g.getSnapshotBeforeUpdate == "function") || typeof g.UNSAFE_componentWillReceiveProps != "function" && typeof g.componentWillReceiveProps != "function" || (y !== Ee || ie !== w) && Cl(
        a,
        g,
        d,
        w
      ), Jr = !1, ie = a.memoizedState, g.state = ie, xo(a, d, g, p), _c();
      var re = a.memoizedState;
      y !== Ee || ie !== re || Jr || n !== null && n.dependencies !== null && Kd(n.dependencies) ? (typeof k == "function" && (Cs(
        a,
        o,
        k,
        d
      ), re = a.memoizedState), (ve = Jr || xc(
        a,
        o,
        ve,
        d,
        ie,
        re,
        w
      ) || n !== null && n.dependencies !== null && Kd(n.dependencies)) ? (K || typeof g.UNSAFE_componentWillUpdate != "function" && typeof g.componentWillUpdate != "function" || (typeof g.componentWillUpdate == "function" && g.componentWillUpdate(d, re, w), typeof g.UNSAFE_componentWillUpdate == "function" && g.UNSAFE_componentWillUpdate(
        d,
        re,
        w
      )), typeof g.componentDidUpdate == "function" && (a.flags |= 4), typeof g.getSnapshotBeforeUpdate == "function" && (a.flags |= 1024)) : (typeof g.componentDidUpdate != "function" || y === n.memoizedProps && ie === n.memoizedState || (a.flags |= 4), typeof g.getSnapshotBeforeUpdate != "function" || y === n.memoizedProps && ie === n.memoizedState || (a.flags |= 1024), a.memoizedProps = d, a.memoizedState = re), g.props = d, g.state = re, g.context = w, d = ve) : (typeof g.componentDidUpdate != "function" || y === n.memoizedProps && ie === n.memoizedState || (a.flags |= 4), typeof g.getSnapshotBeforeUpdate != "function" || y === n.memoizedProps && ie === n.memoizedState || (a.flags |= 1024), d = !1);
    }
    return g = d, E0(n, a), d = (a.flags & 128) !== 0, g || d ? (g = a.stateNode, o = d && typeof o.getDerivedStateFromError != "function" ? null : g.render(), a.flags |= 1, n !== null && d ? (a.child = bl(
      a,
      n.child,
      null,
      p
    ), a.child = bl(
      a,
      null,
      o,
      p
    )) : ci(n, a, o, p), a.memoizedState = g.state, n = a.child) : n = Yr(
      n,
      a,
      p
    ), n;
  }
  function M1(n, a, o, d) {
    return yc(), a.flags |= 256, ci(n, a, o, d), a.child;
  }
  var k1 = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function Sp(n) {
    return { baseLanes: n, cachePool: $u() };
  }
  function Rp(n, a, o) {
    return n = n !== null ? n.childLanes & ~o : 0, a && (n |= qa), n;
  }
  function Ep(n, a, o) {
    var d = a.pendingProps, p = !1, g = (a.flags & 128) !== 0, y;
    if ((y = g) || (y = n !== null && n.memoizedState === null ? !1 : (sn.current & 2) !== 0), y && (p = !0, a.flags &= -129), y = (a.flags & 32) !== 0, a.flags &= -33, n === null) {
      if (Ht) {
        if (p ? wo(a) : Gr(), Ht) {
          var k = zt, w;
          if (w = k) {
            e: {
              for (w = k, k = ja; w.nodeType !== 8; ) {
                if (!k) {
                  k = null;
                  break e;
                }
                if (w = Ur(
                  w.nextSibling
                ), w === null) {
                  k = null;
                  break e;
                }
              }
              k = w;
            }
            k !== null ? (a.memoizedState = {
              dehydrated: k,
              treeContext: Mo !== null ? { id: fr, overflow: Zn } : null,
              retryLane: 536870912,
              hydrationErrors: null
            }, w = ra(
              18,
              null,
              null,
              0
            ), w.stateNode = k, w.return = a, a.child = w, Gn = a, zt = null, w = !0) : w = !1;
          }
          w || ko(a);
        }
        if (k = a.memoizedState, k !== null && (k = k.dehydrated, k !== null))
          return A0(k) ? a.lanes = 32 : a.lanes = 536870912, null;
        Rr(a);
      }
      return k = d.children, d = d.fallback, p ? (Gr(), p = a.mode, k = Q1(
        { mode: "hidden", children: k },
        p
      ), d = Wa(
        d,
        p,
        o,
        null
      ), k.return = a, d.return = a, k.sibling = d, a.child = k, p = a.child, p.memoizedState = Sp(o), p.childLanes = Rp(
        n,
        y,
        o
      ), a.memoizedState = k1, d) : (wo(a), D1(a, k));
    }
    if (w = n.memoizedState, w !== null && (k = w.dehydrated, k !== null)) {
      if (g)
        a.flags & 256 ? (wo(a), a.flags &= -257, a = _s(
          n,
          a,
          o
        )) : a.memoizedState !== null ? (Gr(), a.child = n.child, a.flags |= 128, a = null) : (Gr(), p = d.fallback, k = a.mode, d = Q1(
          { mode: "visible", children: d.children },
          k
        ), p = Wa(
          p,
          k,
          o,
          null
        ), p.flags |= 2, d.return = a, p.return = a, d.sibling = p, a.child = d, bl(
          a,
          n.child,
          null,
          o
        ), d = a.child, d.memoizedState = Sp(o), d.childLanes = Rp(
          n,
          y,
          o
        ), a.memoizedState = k1, a = p);
      else if (wo(a), A0(k)) {
        if (y = k.nextSibling && k.nextSibling.dataset, y) var K = y.dgst;
        y = K, d = Error(h(419)), d.stack = "", d.digest = y, Nc({ value: d, source: null, stack: null }), a = _s(
          n,
          a,
          o
        );
      } else if (ti || bc(n, a, o, !1), y = (o & n.childLanes) !== 0, ti || y) {
        if (y = un, y !== null && (d = o & -o, d = (d & 42) !== 0 ? 1 : Nn(d), d = (d & (y.suspendedLanes | o)) !== 0 ? 0 : d, d !== 0 && d !== w.retryLane))
          throw w.retryLane = d, wr(n, d), Ma(y, n, d), wn;
        k.data === "$?" || Zl(), a = _s(
          n,
          a,
          o
        );
      } else
        k.data === "$?" ? (a.flags |= 192, a.child = n.child, a = null) : (n = w.treeContext, zt = Ur(
          k.nextSibling
        ), Gn = a, Ht = !0, za = null, ja = !1, n !== null && (Ha[oa++] = fr, Ha[oa++] = Zn, Ha[oa++] = Mo, fr = n.id, Zn = n.overflow, Mo = a), a = D1(
          a,
          d.children
        ), a.flags |= 4096);
      return a;
    }
    return p ? (Gr(), p = d.fallback, k = a.mode, w = n.child, K = w.sibling, d = pr(w, {
      mode: "hidden",
      children: d.children
    }), d.subtreeFlags = w.subtreeFlags & 65011712, K !== null ? p = pr(K, p) : (p = Wa(
      p,
      k,
      o,
      null
    ), p.flags |= 2), p.return = a, d.return = a, d.sibling = p, a.child = d, d = p, p = a.child, k = n.child.memoizedState, k === null ? k = Sp(o) : (w = k.cachePool, w !== null ? (K = $n._currentValue, w = w.parent !== K ? { parent: K, pool: K } : w) : w = $u(), k = {
      baseLanes: k.baseLanes | o,
      cachePool: w
    }), p.memoizedState = k, p.childLanes = Rp(
      n,
      y,
      o
    ), a.memoizedState = k1, d) : (wo(a), o = n.child, n = o.sibling, o = pr(o, {
      mode: "visible",
      children: d.children
    }), o.return = a, o.sibling = null, n !== null && (y = a.deletions, y === null ? (a.deletions = [n], a.flags |= 16) : y.push(n)), a.child = o, a.memoizedState = null, o);
  }
  function D1(n, a) {
    return a = Q1(
      { mode: "visible", children: a },
      n.mode
    ), a.return = n, n.child = a;
  }
  function Q1(n, a) {
    return n = ra(22, n, null, a), n.lanes = 0, n.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }, n;
  }
  function _s(n, a, o) {
    return bl(a, n.child, null, o), n = D1(
      a,
      a.pendingProps.children
    ), n.flags |= 2, a.memoizedState = null, n;
  }
  function U0(n, a, o) {
    n.lanes |= a;
    var d = n.alternate;
    d !== null && (d.lanes |= a), Gu(n.return, a, o);
  }
  function x1(n, a, o, d, p) {
    var g = n.memoizedState;
    g === null ? n.memoizedState = {
      isBackwards: a,
      rendering: null,
      renderingStartTime: 0,
      last: d,
      tail: o,
      tailMode: p
    } : (g.isBackwards = a, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = o, g.tailMode = p);
  }
  function Z1(n, a, o) {
    var d = a.pendingProps, p = d.revealOrder, g = d.tail;
    if (ci(n, a, d.children, o), d = sn.current, (d & 2) !== 0)
      d = d & 1 | 2, a.flags |= 128;
    else {
      if (n !== null && (n.flags & 128) !== 0)
        e: for (n = a.child; n !== null; ) {
          if (n.tag === 13)
            n.memoizedState !== null && U0(n, o, a);
          else if (n.tag === 19)
            U0(n, o, a);
          else if (n.child !== null) {
            n.child.return = n, n = n.child;
            continue;
          }
          if (n === a) break e;
          for (; n.sibling === null; ) {
            if (n.return === null || n.return === a)
              break e;
            n = n.return;
          }
          n.sibling.return = n.return, n = n.sibling;
        }
      d &= 1;
    }
    switch (Re(sn, d), p) {
      case "forwards":
        for (o = a.child, p = null; o !== null; )
          n = o.alternate, n !== null && g0(n) === null && (p = o), o = o.sibling;
        o = p, o === null ? (p = a.child, a.child = null) : (p = o.sibling, o.sibling = null), x1(
          a,
          !1,
          p,
          o,
          g
        );
        break;
      case "backwards":
        for (o = null, p = a.child, a.child = null; p !== null; ) {
          if (n = p.alternate, n !== null && g0(n) === null) {
            a.child = p;
            break;
          }
          n = p.sibling, p.sibling = o, o = p, p = n;
        }
        x1(
          a,
          !0,
          o,
          null,
          g
        );
        break;
      case "together":
        x1(a, !1, null, null, void 0);
        break;
      default:
        a.memoizedState = null;
    }
    return a.child;
  }
  function Yr(n, a, o) {
    if (n !== null && (a.dependencies = n.dependencies), Lo |= a.lanes, (o & a.childLanes) === 0)
      if (n !== null) {
        if (bc(
          n,
          a,
          o,
          !1
        ), (o & a.childLanes) === 0)
          return null;
      } else return null;
    if (n !== null && a.child !== n.child)
      throw Error(h(153));
    if (a.child !== null) {
      for (n = a.child, o = pr(n, n.pendingProps), a.child = o, o.return = a; n.sibling !== null; )
        n = n.sibling, o = o.sibling = pr(n, n.pendingProps), o.return = a;
      o.sibling = null;
    }
    return a.child;
  }
  function O1(n, a) {
    return (n.lanes & a) !== 0 ? !0 : (n = n.dependencies, !!(n !== null && Kd(n)));
  }
  function tg(n, a, o) {
    switch (a.tag) {
      case 3:
        Pe(a, a.stateNode.containerInfo), Qo(a, $n, n.memoizedState.cache), yc();
        break;
      case 27:
      case 5:
        dn(a);
        break;
      case 4:
        Pe(a, a.stateNode.containerInfo);
        break;
      case 10:
        Qo(
          a,
          a.type,
          a.memoizedProps.value
        );
        break;
      case 13:
        var d = a.memoizedState;
        if (d !== null)
          return d.dehydrated !== null ? (wo(a), a.flags |= 128, null) : (o & a.child.childLanes) !== 0 ? Ep(n, a, o) : (wo(a), n = Yr(
            n,
            a,
            o
          ), n !== null ? n.sibling : null);
        wo(a);
        break;
      case 19:
        var p = (n.flags & 128) !== 0;
        if (d = (o & a.childLanes) !== 0, d || (bc(
          n,
          a,
          o,
          !1
        ), d = (o & a.childLanes) !== 0), p) {
          if (d)
            return Z1(
              n,
              a,
              o
            );
          a.flags |= 128;
        }
        if (p = a.memoizedState, p !== null && (p.rendering = null, p.tail = null, p.lastEffect = null), Re(sn, sn.current), d) break;
        return null;
      case 22:
      case 23:
        return a.lanes = 0, V1(n, a, o);
      case 24:
        Qo(a, $n, n.memoizedState.cache);
    }
    return Yr(n, a, o);
  }
  function ng(n, a, o) {
    if (n !== null)
      if (n.memoizedProps !== a.pendingProps)
        ti = !0;
      else {
        if (!O1(n, o) && (a.flags & 128) === 0)
          return ti = !1, tg(
            n,
            a,
            o
          );
        ti = (n.flags & 131072) !== 0;
      }
    else
      ti = !1, Ht && (a.flags & 1048576) !== 0 && Pu(a, Uc, a.index);
    switch (a.lanes = 0, a.tag) {
      case 16:
        e: {
          n = a.pendingProps;
          var d = a.elementType, p = d._init;
          if (d = p(d._payload), a.type = d, typeof d == "function")
            Pd(d) ? (n = Vs(d, n), a.tag = 1, a = F1(
              null,
              a,
              d,
              n,
              o
            )) : (a.tag = 0, a = _1(
              null,
              a,
              d,
              n,
              o
            ));
          else {
            if (d != null) {
              if (p = d.$$typeof, p === Ue) {
                a.tag = 11, a = eg(
                  null,
                  a,
                  d,
                  n,
                  o
                );
                break e;
              } else if (p === Ne) {
                a.tag = 14, a = Bo(
                  null,
                  a,
                  d,
                  n,
                  o
                );
                break e;
              }
            }
            throw a = Ie(d) || d, Error(h(306, a, ""));
          }
        }
        return a;
      case 0:
        return _1(
          n,
          a,
          a.type,
          a.pendingProps,
          o
        );
      case 1:
        return d = a.type, p = Vs(
          d,
          a.pendingProps
        ), F1(
          n,
          a,
          d,
          p,
          o
        );
      case 3:
        e: {
          if (Pe(
            a,
            a.stateNode.containerInfo
          ), n === null) throw Error(h(387));
          d = a.pendingProps;
          var g = a.memoizedState;
          p = g.element, a1(n, a), xo(a, d, null, o);
          var y = a.memoizedState;
          if (d = y.cache, Qo(a, $n, d), d !== g.cache && Jm(
            a,
            [$n],
            o,
            !0
          ), _c(), d = y.element, g.isDehydrated)
            if (g = {
              element: d,
              isDehydrated: !1,
              cache: y.cache
            }, a.updateQueue.baseState = g, a.memoizedState = g, a.flags & 256) {
              a = M1(
                n,
                a,
                d,
                o
              );
              break e;
            } else if (d !== p) {
              p = ba(
                Error(h(424)),
                a
              ), Nc(p), a = M1(
                n,
                a,
                d,
                o
              );
              break e;
            } else {
              switch (n = a.stateNode.containerInfo, n.nodeType) {
                case 9:
                  n = n.body;
                  break;
                default:
                  n = n.nodeName === "HTML" ? n.ownerDocument.body : n;
              }
              for (zt = Ur(n.firstChild), Gn = a, Ht = !0, za = null, ja = !0, o = jr(
                a,
                null,
                d,
                o
              ), a.child = o; o; )
                o.flags = o.flags & -3 | 4096, o = o.sibling;
            }
          else {
            if (yc(), d === p) {
              a = Yr(
                n,
                a,
                o
              );
              break e;
            }
            ci(
              n,
              a,
              d,
              o
            );
          }
          a = a.child;
        }
        return a;
      case 26:
        return E0(n, a), n === null ? (o = Sg(
          a.type,
          null,
          a.pendingProps,
          null
        )) ? a.memoizedState = o : Ht || (o = a.type, n = a.pendingProps, d = er(
          Ce.current
        ).createElement(o), d[rn] = a, d[qn] = n, pt(d, o, n), vn(d), a.stateNode = d) : a.memoizedState = Sg(
          a.type,
          n.memoizedProps,
          a.pendingProps,
          n.memoizedState
        ), null;
      case 27:
        return dn(a), n === null && Ht && (d = a.stateNode = ze(
          a.type,
          a.pendingProps,
          Ce.current
        ), Gn = a, ja = !0, p = zt, ws(a.type) ? (Bs = p, zt = Ur(
          d.firstChild
        )) : zt = p), ci(
          n,
          a,
          a.pendingProps.children,
          o
        ), E0(n, a), n === null && (a.flags |= 4194304), a.child;
      case 5:
        return n === null && Ht && ((p = d = zt) && (d = ed(
          d,
          a.type,
          a.pendingProps,
          ja
        ), d !== null ? (a.stateNode = d, Gn = a, zt = Ur(
          d.firstChild
        ), ja = !1, p = !0) : p = !1), p || ko(a)), dn(a), p = a.type, g = a.pendingProps, y = n !== null ? n.memoizedProps : null, d = g.children, ao(p, g) ? d = null : y !== null && ao(p, y) && (a.flags |= 32), a.memoizedState !== null && (p = s1(
          n,
          a,
          H2,
          null,
          null,
          o
        ), ga._currentValue = p), E0(n, a), ci(n, a, d, o), a.child;
      case 6:
        return n === null && Ht && ((n = o = zt) && (o = SS(
          o,
          a.pendingProps,
          ja
        ), o !== null ? (a.stateNode = o, Gn = a, zt = null, n = !0) : n = !1), n || ko(a)), null;
      case 13:
        return Ep(n, a, o);
      case 4:
        return Pe(
          a,
          a.stateNode.containerInfo
        ), d = a.pendingProps, n === null ? a.child = bl(
          a,
          null,
          d,
          o
        ) : ci(
          n,
          a,
          d,
          o
        ), a.child;
      case 11:
        return eg(
          n,
          a,
          a.type,
          a.pendingProps,
          o
        );
      case 7:
        return ci(
          n,
          a,
          a.pendingProps,
          o
        ), a.child;
      case 8:
        return ci(
          n,
          a,
          a.pendingProps.children,
          o
        ), a.child;
      case 12:
        return ci(
          n,
          a,
          a.pendingProps.children,
          o
        ), a.child;
      case 10:
        return d = a.pendingProps, Qo(a, a.type, d.value), ci(
          n,
          a,
          d.children,
          o
        ), a.child;
      case 9:
        return p = a.type._context, d = a.pendingProps.children, Es(a), p = si(p), d = d(p), a.flags |= 1, ci(n, a, d, o), a.child;
      case 14:
        return Bo(
          n,
          a,
          a.type,
          a.pendingProps,
          o
        );
      case 15:
        return Vl(
          n,
          a,
          a.type,
          a.pendingProps,
          o
        );
      case 19:
        return Z1(n, a, o);
      case 31:
        return d = a.pendingProps, o = a.mode, d = {
          mode: d.mode,
          children: d.children
        }, n === null ? (o = Q1(
          d,
          o
        ), o.ref = a.ref, a.child = o, o.return = a, a = o) : (o = pr(n.child, d), o.ref = a.ref, a.child = o, o.return = a, a = o), a;
      case 22:
        return V1(n, a, o);
      case 24:
        return Es(a), d = si($n), n === null ? (p = e0(), p === null && (p = un, g = Vc(), p.pooledCache = g, g.refCount++, g !== null && (p.pooledCacheLanes |= o), p = g), a.memoizedState = {
          parent: d,
          cache: p
        }, i1(a), Qo(a, $n, p)) : ((n.lanes & o) !== 0 && (a1(n, a), xo(a, null, null, o), _c()), p = n.memoizedState, g = a.memoizedState, p.parent !== d ? (p = { parent: d, cache: d }, a.memoizedState = p, a.lanes === 0 && (a.memoizedState = a.updateQueue.baseState = p), Qo(a, $n, d)) : (d = g.cache, Qo(a, $n, d), d !== p.cache && Jm(
          a,
          [$n],
          o,
          !0
        ))), ci(
          n,
          a,
          a.pendingProps.children,
          o
        ), a.child;
      case 29:
        throw a.pendingProps;
    }
    throw Error(h(156, a.tag));
  }
  function Xr(n) {
    n.flags |= 4;
  }
  function Oc(n, a) {
    if (a.type !== "stylesheet" || (a.state.loading & 4) !== 0)
      n.flags &= -16777217;
    else if (n.flags |= 16777216, !af(a)) {
      if (a = _a.current, a !== null && ((Zt & 4194048) === Zt ? Di !== null : (Zt & 62914560) !== Zt && (Zt & 536870912) === 0 || a !== Di))
        throw gl = t1, e1;
      n.flags |= 8192;
    }
  }
  function T0(n, a) {
    a !== null && (n.flags |= 4), n.flags & 16384 && (a = n.tag !== 22 ? Ae() : 536870912, n.lanes |= a, Lc |= a);
  }
  function wc(n, a) {
    if (!Ht)
      switch (n.tailMode) {
        case "hidden":
          a = n.tail;
          for (var o = null; a !== null; )
            a.alternate !== null && (o = a), a = a.sibling;
          o === null ? n.tail = null : o.sibling = null;
          break;
        case "collapsed":
          o = n.tail;
          for (var d = null; o !== null; )
            o.alternate !== null && (d = o), o = o.sibling;
          d === null ? a || n.tail === null ? n.tail = null : n.tail.sibling = null : d.sibling = null;
      }
  }
  function lt(n) {
    var a = n.alternate !== null && n.alternate.child === n.child, o = 0, d = 0;
    if (a)
      for (var p = n.child; p !== null; )
        o |= p.lanes | p.childLanes, d |= p.subtreeFlags & 65011712, d |= p.flags & 65011712, p.return = n, p = p.sibling;
    else
      for (p = n.child; p !== null; )
        o |= p.lanes | p.childLanes, d |= p.subtreeFlags, d |= p.flags, p.return = n, p = p.sibling;
    return n.subtreeFlags |= d, n.childLanes = o, a;
  }
  function Up(n, a, o) {
    var d = a.pendingProps;
    switch (Br(a), a.tag) {
      case 31:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return lt(a), null;
      case 1:
        return lt(a), null;
      case 3:
        return o = a.stateNode, d = null, n !== null && (d = n.memoizedState.cache), a.memoizedState.cache !== d && (a.flags |= 2048), Ar($n), dt(), o.pendingContext && (o.context = o.pendingContext, o.pendingContext = null), (n === null || n.child === null) && (Tc(a) ? Xr(a) : n === null || n.memoizedState.isDehydrated && (a.flags & 256) === 0 || (a.flags |= 1024, Lm())), lt(a), null;
      case 26:
        return o = a.memoizedState, n === null ? (Xr(a), o !== null ? (lt(a), Oc(a, o)) : (lt(a), a.flags &= -16777217)) : o ? o !== n.memoizedState ? (Xr(a), lt(a), Oc(a, o)) : (lt(a), a.flags &= -16777217) : (n.memoizedProps !== d && Xr(a), lt(a), a.flags &= -16777217), null;
      case 27:
        xn(a), o = Ce.current;
        var p = a.type;
        if (n !== null && a.stateNode != null)
          n.memoizedProps !== d && Xr(a);
        else {
          if (!d) {
            if (a.stateNode === null)
              throw Error(h(166));
            return lt(a), null;
          }
          n = $.current, Tc(a) ? Yd(a) : (n = ze(p, d, o), a.stateNode = n, Xr(a));
        }
        return lt(a), null;
      case 5:
        if (xn(a), o = a.type, n !== null && a.stateNode != null)
          n.memoizedProps !== d && Xr(a);
        else {
          if (!d) {
            if (a.stateNode === null)
              throw Error(h(166));
            return lt(a), null;
          }
          if (n = $.current, Tc(a))
            Yd(a);
          else {
            switch (p = er(
              Ce.current
            ), n) {
              case 1:
                n = p.createElementNS(
                  "http://www.w3.org/2000/svg",
                  o
                );
                break;
              case 2:
                n = p.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  o
                );
                break;
              default:
                switch (o) {
                  case "svg":
                    n = p.createElementNS(
                      "http://www.w3.org/2000/svg",
                      o
                    );
                    break;
                  case "math":
                    n = p.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      o
                    );
                    break;
                  case "script":
                    n = p.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(n.firstChild);
                    break;
                  case "select":
                    n = typeof d.is == "string" ? p.createElement("select", { is: d.is }) : p.createElement("select"), d.multiple ? n.multiple = !0 : d.size && (n.size = d.size);
                    break;
                  default:
                    n = typeof d.is == "string" ? p.createElement(o, { is: d.is }) : p.createElement(o);
                }
            }
            n[rn] = a, n[qn] = d;
            e: for (p = a.child; p !== null; ) {
              if (p.tag === 5 || p.tag === 6)
                n.appendChild(p.stateNode);
              else if (p.tag !== 4 && p.tag !== 27 && p.child !== null) {
                p.child.return = p, p = p.child;
                continue;
              }
              if (p === a) break e;
              for (; p.sibling === null; ) {
                if (p.return === null || p.return === a)
                  break e;
                p = p.return;
              }
              p.sibling.return = p.return, p = p.sibling;
            }
            a.stateNode = n;
            e: switch (pt(n, o, d), o) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                n = !!d.autoFocus;
                break e;
              case "img":
                n = !0;
                break e;
              default:
                n = !1;
            }
            n && Xr(a);
          }
        }
        return lt(a), a.flags &= -16777217, null;
      case 6:
        if (n && a.stateNode != null)
          n.memoizedProps !== d && Xr(a);
        else {
          if (typeof d != "string" && a.stateNode === null)
            throw Error(h(166));
          if (n = Ce.current, Tc(a)) {
            if (n = a.stateNode, o = a.memoizedProps, d = null, p = Gn, p !== null)
              switch (p.tag) {
                case 27:
                case 5:
                  d = p.memoizedProps;
              }
            n[rn] = a, n = !!(n.nodeValue === o || d !== null && d.suppressHydrationWarning === !0 || $p(n.nodeValue, o)), n || ko(a);
          } else
            n = er(n).createTextNode(
              d
            ), n[rn] = a, a.stateNode = n;
        }
        return lt(a), null;
      case 13:
        if (d = a.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
          if (p = Tc(a), d !== null && d.dehydrated !== null) {
            if (n === null) {
              if (!p) throw Error(h(318));
              if (p = a.memoizedState, p = p !== null ? p.dehydrated : null, !p) throw Error(h(317));
              p[rn] = a;
            } else
              yc(), (a.flags & 128) === 0 && (a.memoizedState = null), a.flags |= 4;
            lt(a), p = !1;
          } else
            p = Lm(), n !== null && n.memoizedState !== null && (n.memoizedState.hydrationErrors = p), p = !0;
          if (!p)
            return a.flags & 256 ? (Rr(a), a) : (Rr(a), null);
        }
        if (Rr(a), (a.flags & 128) !== 0)
          return a.lanes = o, a;
        if (o = d !== null, n = n !== null && n.memoizedState !== null, o) {
          d = a.child, p = null, d.alternate !== null && d.alternate.memoizedState !== null && d.alternate.memoizedState.cachePool !== null && (p = d.alternate.memoizedState.cachePool.pool);
          var g = null;
          d.memoizedState !== null && d.memoizedState.cachePool !== null && (g = d.memoizedState.cachePool.pool), g !== p && (d.flags |= 2048);
        }
        return o !== n && o && (a.child.flags |= 8192), T0(a, a.updateQueue), lt(a), null;
      case 4:
        return dt(), n === null && Kp(a.stateNode.containerInfo), lt(a), null;
      case 10:
        return Ar(a.type), lt(a), null;
      case 19:
        if (q(sn), p = a.memoizedState, p === null) return lt(a), null;
        if (d = (a.flags & 128) !== 0, g = p.rendering, g === null)
          if (d) wc(p, !1);
          else {
            if (In !== 0 || n !== null && (n.flags & 128) !== 0)
              for (n = a.child; n !== null; ) {
                if (g = g0(n), g !== null) {
                  for (a.flags |= 128, wc(p, !1), n = g.updateQueue, a.updateQueue = n, T0(a, n), a.subtreeFlags = 0, n = o, o = a.child; o !== null; )
                    Ft(o, n), o = o.sibling;
                  return Re(
                    sn,
                    sn.current & 1 | 2
                  ), a.child;
                }
                n = n.sibling;
              }
            p.tail !== null && yn() > z1 && (a.flags |= 128, d = !0, wc(p, !1), a.lanes = 4194304);
          }
        else {
          if (!d)
            if (n = g0(g), n !== null) {
              if (a.flags |= 128, d = !0, n = n.updateQueue, a.updateQueue = n, T0(a, n), wc(p, !0), p.tail === null && p.tailMode === "hidden" && !g.alternate && !Ht)
                return lt(a), null;
            } else
              2 * yn() - p.renderingStartTime > z1 && o !== 536870912 && (a.flags |= 128, d = !0, wc(p, !1), a.lanes = 4194304);
          p.isBackwards ? (g.sibling = a.child, a.child = g) : (n = p.last, n !== null ? n.sibling = g : a.child = g, p.last = g);
        }
        return p.tail !== null ? (a = p.tail, p.rendering = a, p.tail = a.sibling, p.renderingStartTime = yn(), a.sibling = null, n = sn.current, Re(sn, d ? n & 1 | 2 : n & 1), a) : (lt(a), null);
      case 22:
      case 23:
        return Rr(a), Mc(), d = a.memoizedState !== null, n !== null ? n.memoizedState !== null !== d && (a.flags |= 8192) : d && (a.flags |= 8192), d ? (o & 536870912) !== 0 && (a.flags & 128) === 0 && (lt(a), a.subtreeFlags & 6 && (a.flags |= 8192)) : lt(a), o = a.updateQueue, o !== null && T0(a, o.retryQueue), o = null, n !== null && n.memoizedState !== null && n.memoizedState.cachePool !== null && (o = n.memoizedState.cachePool.pool), d = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (d = a.memoizedState.cachePool.pool), d !== o && (a.flags |= 2048), n !== null && q(Lr), null;
      case 24:
        return o = null, n !== null && (o = n.memoizedState.cache), a.memoizedState.cache !== o && (a.flags |= 2048), Ar($n), lt(a), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(h(156, a.tag));
  }
  function dS(n, a) {
    switch (Br(a), a.tag) {
      case 1:
        return n = a.flags, n & 65536 ? (a.flags = n & -65537 | 128, a) : null;
      case 3:
        return Ar($n), dt(), n = a.flags, (n & 65536) !== 0 && (n & 128) === 0 ? (a.flags = n & -65537 | 128, a) : null;
      case 26:
      case 27:
      case 5:
        return xn(a), null;
      case 13:
        if (Rr(a), n = a.memoizedState, n !== null && n.dehydrated !== null) {
          if (a.alternate === null)
            throw Error(h(340));
          yc();
        }
        return n = a.flags, n & 65536 ? (a.flags = n & -65537 | 128, a) : null;
      case 19:
        return q(sn), null;
      case 4:
        return dt(), null;
      case 10:
        return Ar(a.type), null;
      case 22:
      case 23:
        return Rr(a), Mc(), n !== null && q(Lr), n = a.flags, n & 65536 ? (a.flags = n & -65537 | 128, a) : null;
      case 24:
        return Ar($n), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Tp(n, a) {
    switch (Br(a), a.tag) {
      case 3:
        Ar($n), dt();
        break;
      case 26:
      case 27:
      case 5:
        xn(a);
        break;
      case 4:
        dt();
        break;
      case 13:
        Rr(a);
        break;
      case 19:
        q(sn);
        break;
      case 10:
        Ar(a.type);
        break;
      case 22:
      case 23:
        Rr(a), Mc(), n !== null && q(Lr);
        break;
      case 24:
        Ar($n);
    }
  }
  function y0(n, a) {
    try {
      var o = a.updateQueue, d = o !== null ? o.lastEffect : null;
      if (d !== null) {
        var p = d.next;
        o = p;
        do {
          if ((o.tag & n) === n) {
            d = void 0;
            var g = o.create, y = o.inst;
            d = g(), y.destroy = d;
          }
          o = o.next;
        } while (o !== p);
      }
    } catch (k) {
      tn(a, a.return, k);
    }
  }
  function Fs(n, a, o) {
    try {
      var d = a.updateQueue, p = d !== null ? d.lastEffect : null;
      if (p !== null) {
        var g = p.next;
        d = g;
        do {
          if ((d.tag & n) === n) {
            var y = d.inst, k = y.destroy;
            if (k !== void 0) {
              y.destroy = void 0, p = a;
              var w = o, K = k;
              try {
                K();
              } catch (ve) {
                tn(
                  p,
                  w,
                  ve
                );
              }
            }
          }
          d = d.next;
        } while (d !== g);
      }
    } catch (ve) {
      tn(a, a.return, ve);
    }
  }
  function w1(n) {
    var a = n.updateQueue;
    if (a !== null) {
      var o = n.stateNode;
      try {
        i0(a, o);
      } catch (d) {
        tn(n, n.return, d);
      }
    }
  }
  function yp(n, a, o) {
    o.props = Vs(
      n.type,
      n.memoizedProps
    ), o.state = n.memoizedState;
    try {
      o.componentWillUnmount();
    } catch (d) {
      tn(n, a, d);
    }
  }
  function Bc(n, a) {
    try {
      var o = n.ref;
      if (o !== null) {
        switch (n.tag) {
          case 26:
          case 27:
          case 5:
            var d = n.stateNode;
            break;
          case 30:
            d = n.stateNode;
            break;
          default:
            d = n.stateNode;
        }
        typeof o == "function" ? n.refCleanup = o(d) : o.current = d;
      }
    } catch (p) {
      tn(n, a, p);
    }
  }
  function Er(n, a) {
    var o = n.ref, d = n.refCleanup;
    if (o !== null)
      if (typeof d == "function")
        try {
          d();
        } catch (p) {
          tn(n, a, p);
        } finally {
          n.refCleanup = null, n = n.alternate, n != null && (n.refCleanup = null);
        }
      else if (typeof o == "function")
        try {
          o(null);
        } catch (p) {
          tn(n, a, p);
        }
      else o.current = null;
  }
  function Ac(n) {
    var a = n.type, o = n.memoizedProps, d = n.stateNode;
    try {
      e: switch (a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          o.autoFocus && d.focus();
          break e;
        case "img":
          o.src ? d.src = o.src : o.srcSet && (d.srcset = o.srcSet);
      }
    } catch (p) {
      tn(n, n.return, p);
    }
  }
  function Np(n, a, o) {
    try {
      var d = n.stateNode;
      fS(d, n.type, o, a), d[qn] = a;
    } catch (p) {
      tn(n, n.return, p);
    }
  }
  function ig(n) {
    return n.tag === 5 || n.tag === 3 || n.tag === 26 || n.tag === 27 && ws(n.type) || n.tag === 4;
  }
  function Xa(n) {
    e: for (; ; ) {
      for (; n.sibling === null; ) {
        if (n.return === null || ig(n.return)) return null;
        n = n.return;
      }
      for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
        if (n.tag === 27 && ws(n.type) || n.flags & 2 || n.child === null || n.tag === 4) continue e;
        n.child.return = n, n = n.child;
      }
      if (!(n.flags & 2)) return n.stateNode;
    }
  }
  function Fl(n, a, o) {
    var d = n.tag;
    if (d === 5 || d === 6)
      n = n.stateNode, a ? (o.nodeType === 9 ? o.body : o.nodeName === "HTML" ? o.ownerDocument.body : o).insertBefore(n, a) : (a = o.nodeType === 9 ? o.body : o.nodeName === "HTML" ? o.ownerDocument.body : o, a.appendChild(n), o = o._reactRootContainer, o != null || a.onclick !== null || (a.onclick = ih));
    else if (d !== 4 && (d === 27 && ws(n.type) && (o = n.stateNode, a = null), n = n.child, n !== null))
      for (Fl(n, a, o), n = n.sibling; n !== null; )
        Fl(n, a, o), n = n.sibling;
  }
  function B1(n, a, o) {
    var d = n.tag;
    if (d === 5 || d === 6)
      n = n.stateNode, a ? o.insertBefore(n, a) : o.appendChild(n);
    else if (d !== 4 && (d === 27 && ws(n.type) && (o = n.stateNode), n = n.child, n !== null))
      for (B1(n, a, o), n = n.sibling; n !== null; )
        B1(n, a, o), n = n.sibling;
  }
  function A1(n) {
    var a = n.stateNode, o = n.memoizedProps;
    try {
      for (var d = n.type, p = a.attributes; p.length; )
        a.removeAttributeNode(p[0]);
      pt(a, d, o), a[rn] = n, a[qn] = o;
    } catch (g) {
      tn(n, n.return, g);
    }
  }
  var Kr = !1, Bn = !1, I1 = !1, L1 = typeof WeakSet == "function" ? WeakSet : Set, ni = null;
  function bp(n, a) {
    if (n = n.containerInfo, O0 = J0, n = xm(n), zd(n)) {
      if ("selectionStart" in n)
        var o = {
          start: n.selectionStart,
          end: n.selectionEnd
        };
      else
        e: {
          o = (o = n.ownerDocument) && o.defaultView || window;
          var d = o.getSelection && o.getSelection();
          if (d && d.rangeCount !== 0) {
            o = d.anchorNode;
            var p = d.anchorOffset, g = d.focusNode;
            d = d.focusOffset;
            try {
              o.nodeType, g.nodeType;
            } catch {
              o = null;
              break e;
            }
            var y = 0, k = -1, w = -1, K = 0, ve = 0, Ee = n, ie = null;
            t: for (; ; ) {
              for (var re; Ee !== o || p !== 0 && Ee.nodeType !== 3 || (k = y + p), Ee !== g || d !== 0 && Ee.nodeType !== 3 || (w = y + d), Ee.nodeType === 3 && (y += Ee.nodeValue.length), (re = Ee.firstChild) !== null; )
                ie = Ee, Ee = re;
              for (; ; ) {
                if (Ee === n) break t;
                if (ie === o && ++K === p && (k = y), ie === g && ++ve === d && (w = y), (re = Ee.nextSibling) !== null) break;
                Ee = ie, ie = Ee.parentNode;
              }
              Ee = re;
            }
            o = k === -1 || w === -1 ? null : { start: k, end: w };
          } else o = null;
        }
      o = o || { start: 0, end: 0 };
    } else o = null;
    for (w0 = { focusedElem: n, selectionRange: o }, J0 = !1, ni = a; ni !== null; )
      if (a = ni, n = a.child, (a.subtreeFlags & 1024) !== 0 && n !== null)
        n.return = a, ni = n;
      else
        for (; ni !== null; ) {
          switch (a = ni, g = a.alternate, n = a.flags, a.tag) {
            case 0:
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((n & 1024) !== 0 && g !== null) {
                n = void 0, o = a, p = g.memoizedProps, g = g.memoizedState, d = o.stateNode;
                try {
                  var at = Vs(
                    o.type,
                    p,
                    o.elementType === o.type
                  );
                  n = d.getSnapshotBeforeUpdate(
                    at,
                    g
                  ), d.__reactInternalSnapshotBeforeUpdate = n;
                } catch (rt) {
                  tn(
                    o,
                    o.return,
                    rt
                  );
                }
              }
              break;
            case 3:
              if ((n & 1024) !== 0) {
                if (n = a.stateNode.containerInfo, o = n.nodeType, o === 9)
                  B0(n);
                else if (o === 1)
                  switch (n.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      B0(n);
                      break;
                    default:
                      n.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((n & 1024) !== 0) throw Error(h(163));
          }
          if (n = a.sibling, n !== null) {
            n.return = a.return, ni = n;
            break;
          }
          ni = a.return;
        }
  }
  function Cp(n, a, o) {
    var d = o.flags;
    switch (o.tag) {
      case 0:
      case 11:
      case 15:
        $r(n, o), d & 4 && y0(5, o);
        break;
      case 1:
        if ($r(n, o), d & 4)
          if (n = o.stateNode, a === null)
            try {
              n.componentDidMount();
            } catch (y) {
              tn(o, o.return, y);
            }
          else {
            var p = Vs(
              o.type,
              a.memoizedProps
            );
            a = a.memoizedState;
            try {
              n.componentDidUpdate(
                p,
                a,
                n.__reactInternalSnapshotBeforeUpdate
              );
            } catch (y) {
              tn(
                o,
                o.return,
                y
              );
            }
          }
        d & 64 && w1(o), d & 512 && Bc(o, o.return);
        break;
      case 3:
        if ($r(n, o), d & 64 && (n = o.updateQueue, n !== null)) {
          if (a = null, o.child !== null)
            switch (o.child.tag) {
              case 27:
              case 5:
                a = o.child.stateNode;
                break;
              case 1:
                a = o.child.stateNode;
            }
          try {
            i0(n, a);
          } catch (y) {
            tn(o, o.return, y);
          }
        }
        break;
      case 27:
        a === null && d & 4 && A1(o);
      case 26:
      case 5:
        $r(n, o), a === null && d & 4 && Ac(o), d & 512 && Bc(o, o.return);
        break;
      case 12:
        $r(n, o);
        break;
      case 13:
        $r(n, o), d & 4 && J1(n, o), d & 64 && (n = o.memoizedState, n !== null && (n = n.dehydrated, n !== null && (o = uS.bind(
          null,
          o
        ), RS(n, o))));
        break;
      case 22:
        if (d = o.memoizedState !== null || Kr, !d) {
          a = a !== null && a.memoizedState !== null || Bn, p = Kr;
          var g = Bn;
          Kr = d, (Bn = a) && !g ? Ms(
            n,
            o,
            (o.subtreeFlags & 8772) !== 0
          ) : $r(n, o), Kr = p, Bn = g;
        }
        break;
      case 30:
        break;
      default:
        $r(n, o);
    }
  }
  function Vp(n) {
    var a = n.alternate;
    a !== null && (n.alternate = null, Vp(a)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (a = n.stateNode, a !== null && mt(a)), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
  }
  var bn = null, gi = !1;
  function qr(n, a, o) {
    for (o = o.child; o !== null; )
      Qt(n, a, o), o = o.sibling;
  }
  function Qt(n, a, o) {
    if (jn && typeof jn.onCommitFiberUnmount == "function")
      try {
        jn.onCommitFiberUnmount(ta, o);
      } catch {
      }
    switch (o.tag) {
      case 26:
        Bn || Er(o, a), qr(
          n,
          a,
          o
        ), o.memoizedState ? o.memoizedState.count-- : o.stateNode && (o = o.stateNode, o.parentNode.removeChild(o));
        break;
      case 27:
        Bn || Er(o, a);
        var d = bn, p = gi;
        ws(o.type) && (bn = o.stateNode, gi = !1), qr(
          n,
          a,
          o
        ), pa(o.stateNode), bn = d, gi = p;
        break;
      case 5:
        Bn || Er(o, a);
      case 6:
        if (d = bn, p = gi, bn = null, qr(
          n,
          a,
          o
        ), bn = d, gi = p, bn !== null)
          if (gi)
            try {
              (bn.nodeType === 9 ? bn.body : bn.nodeName === "HTML" ? bn.ownerDocument.body : bn).removeChild(o.stateNode);
            } catch (g) {
              tn(
                o,
                a,
                g
              );
            }
          else
            try {
              bn.removeChild(o.stateNode);
            } catch (g) {
              tn(
                o,
                a,
                g
              );
            }
        break;
      case 18:
        bn !== null && (gi ? (n = bn, rh(
          n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n,
          o.stateNode
        ), so(n)) : rh(bn, o.stateNode));
        break;
      case 4:
        d = bn, p = gi, bn = o.stateNode.containerInfo, gi = !0, qr(
          n,
          a,
          o
        ), bn = d, gi = p;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Bn || Fs(2, o, a), Bn || Fs(4, o, a), qr(
          n,
          a,
          o
        );
        break;
      case 1:
        Bn || (Er(o, a), d = o.stateNode, typeof d.componentWillUnmount == "function" && yp(
          o,
          a,
          d
        )), qr(
          n,
          a,
          o
        );
        break;
      case 21:
        qr(
          n,
          a,
          o
        );
        break;
      case 22:
        Bn = (d = Bn) || o.memoizedState !== null, qr(
          n,
          a,
          o
        ), Bn = d;
        break;
      default:
        qr(
          n,
          a,
          o
        );
    }
  }
  function J1(n, a) {
    if (a.memoizedState === null && (n = a.alternate, n !== null && (n = n.memoizedState, n !== null && (n = n.dehydrated, n !== null))))
      try {
        so(n);
      } catch (o) {
        tn(a, a.return, o);
      }
  }
  function _p(n) {
    switch (n.tag) {
      case 13:
      case 19:
        var a = n.stateNode;
        return a === null && (a = n.stateNode = new L1()), a;
      case 22:
        return n = n.stateNode, a = n._retryCache, a === null && (a = n._retryCache = new L1()), a;
      default:
        throw Error(h(435, n.tag));
    }
  }
  function W1(n, a) {
    var o = _p(n);
    a.forEach(function(d) {
      var p = hS.bind(null, n, d);
      o.has(d) || (o.add(d), d.then(p, p));
    });
  }
  function zi(n, a) {
    var o = a.deletions;
    if (o !== null)
      for (var d = 0; d < o.length; d++) {
        var p = o[d], g = n, y = a, k = y;
        e: for (; k !== null; ) {
          switch (k.tag) {
            case 27:
              if (ws(k.type)) {
                bn = k.stateNode, gi = !1;
                break e;
              }
              break;
            case 5:
              bn = k.stateNode, gi = !1;
              break e;
            case 3:
            case 4:
              bn = k.stateNode.containerInfo, gi = !0;
              break e;
          }
          k = k.return;
        }
        if (bn === null) throw Error(h(160));
        Qt(g, y, p), bn = null, gi = !1, g = p.alternate, g !== null && (g.return = null), p.return = null;
      }
    if (a.subtreeFlags & 13878)
      for (a = a.child; a !== null; )
        N0(a, n), a = a.sibling;
  }
  var ji = null;
  function N0(n, a) {
    var o = n.alternate, d = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        zi(a, n), di(n), d & 4 && (Fs(3, n, n.return), y0(3, n), Fs(5, n, n.return));
        break;
      case 1:
        zi(a, n), di(n), d & 512 && (Bn || o === null || Er(o, o.return)), d & 64 && Kr && (n = n.updateQueue, n !== null && (d = n.callbacks, d !== null && (o = n.shared.hiddenCallbacks, n.shared.hiddenCallbacks = o === null ? d : o.concat(d))));
        break;
      case 26:
        var p = ji;
        if (zi(a, n), di(n), d & 512 && (Bn || o === null || Er(o, o.return)), d & 4) {
          var g = o !== null ? o.memoizedState : null;
          if (d = n.memoizedState, o === null)
            if (d === null)
              if (n.stateNode === null) {
                e: {
                  d = n.type, o = n.memoizedProps, p = p.ownerDocument || p;
                  t: switch (d) {
                    case "title":
                      g = p.getElementsByTagName("title")[0], (!g || g[pe] || g[rn] || g.namespaceURI === "http://www.w3.org/2000/svg" || g.hasAttribute("itemprop")) && (g = p.createElement(d), p.head.insertBefore(
                        g,
                        p.querySelector("head > title")
                      )), pt(g, d, o), g[rn] = n, vn(g), d = g;
                      break e;
                    case "link":
                      var y = tf(
                        "link",
                        "href",
                        p
                      ).get(d + (o.href || ""));
                      if (y) {
                        for (var k = 0; k < y.length; k++)
                          if (g = y[k], g.getAttribute("href") === (o.href == null || o.href === "" ? null : o.href) && g.getAttribute("rel") === (o.rel == null ? null : o.rel) && g.getAttribute("title") === (o.title == null ? null : o.title) && g.getAttribute("crossorigin") === (o.crossOrigin == null ? null : o.crossOrigin)) {
                            y.splice(k, 1);
                            break t;
                          }
                      }
                      g = p.createElement(d), pt(g, d, o), p.head.appendChild(g);
                      break;
                    case "meta":
                      if (y = tf(
                        "meta",
                        "content",
                        p
                      ).get(d + (o.content || ""))) {
                        for (k = 0; k < y.length; k++)
                          if (g = y[k], g.getAttribute("content") === (o.content == null ? null : "" + o.content) && g.getAttribute("name") === (o.name == null ? null : o.name) && g.getAttribute("property") === (o.property == null ? null : o.property) && g.getAttribute("http-equiv") === (o.httpEquiv == null ? null : o.httpEquiv) && g.getAttribute("charset") === (o.charSet == null ? null : o.charSet)) {
                            y.splice(k, 1);
                            break t;
                          }
                      }
                      g = p.createElement(d), pt(g, d, o), p.head.appendChild(g);
                      break;
                    default:
                      throw Error(h(468, d));
                  }
                  g[rn] = n, vn(g), d = g;
                }
                n.stateNode = d;
              } else
                nf(
                  p,
                  n.type,
                  n.stateNode
                );
            else
              n.stateNode = Eg(
                p,
                d,
                n.memoizedProps
              );
          else
            g !== d ? (g === null ? o.stateNode !== null && (o = o.stateNode, o.parentNode.removeChild(o)) : g.count--, d === null ? nf(
              p,
              n.type,
              n.stateNode
            ) : Eg(
              p,
              d,
              n.memoizedProps
            )) : d === null && n.stateNode !== null && Np(
              n,
              n.memoizedProps,
              o.memoizedProps
            );
        }
        break;
      case 27:
        zi(a, n), di(n), d & 512 && (Bn || o === null || Er(o, o.return)), o !== null && d & 4 && Np(
          n,
          n.memoizedProps,
          o.memoizedProps
        );
        break;
      case 5:
        if (zi(a, n), di(n), d & 512 && (Bn || o === null || Er(o, o.return)), n.flags & 32) {
          p = n.stateNode;
          try {
            dc(p, "");
          } catch (re) {
            tn(n, n.return, re);
          }
        }
        d & 4 && n.stateNode != null && (p = n.memoizedProps, Np(
          n,
          p,
          o !== null ? o.memoizedProps : p
        )), d & 1024 && (I1 = !0);
        break;
      case 6:
        if (zi(a, n), di(n), d & 4) {
          if (n.stateNode === null)
            throw Error(h(162));
          d = n.memoizedProps, o = n.stateNode;
          try {
            o.nodeValue = d;
          } catch (re) {
            tn(n, n.return, re);
          }
        }
        break;
      case 3:
        if (Ls = null, p = ji, ji = oh(a.containerInfo), zi(a, n), ji = p, di(n), d & 4 && o !== null && o.memoizedState.isDehydrated)
          try {
            so(a.containerInfo);
          } catch (re) {
            tn(n, n.return, re);
          }
        I1 && (I1 = !1, Fp(n));
        break;
      case 4:
        d = ji, ji = oh(
          n.stateNode.containerInfo
        ), zi(a, n), di(n), ji = d;
        break;
      case 12:
        zi(a, n), di(n);
        break;
      case 13:
        zi(a, n), di(n), n.child.flags & 8192 && n.memoizedState !== null != (o !== null && o.memoizedState !== null) && (wp = yn()), d & 4 && (d = n.updateQueue, d !== null && (n.updateQueue = null, W1(n, d)));
        break;
      case 22:
        p = n.memoizedState !== null;
        var w = o !== null && o.memoizedState !== null, K = Kr, ve = Bn;
        if (Kr = K || p, Bn = ve || w, zi(a, n), Bn = ve, Kr = K, di(n), d & 8192)
          e: for (a = n.stateNode, a._visibility = p ? a._visibility & -2 : a._visibility | 1, p && (o === null || w || Kr || Bn || Cn(n)), o = null, a = n; ; ) {
            if (a.tag === 5 || a.tag === 26) {
              if (o === null) {
                w = o = a;
                try {
                  if (g = w.stateNode, p)
                    y = g.style, typeof y.setProperty == "function" ? y.setProperty("display", "none", "important") : y.display = "none";
                  else {
                    k = w.stateNode;
                    var Ee = w.memoizedProps.style, ie = Ee != null && Ee.hasOwnProperty("display") ? Ee.display : null;
                    k.style.display = ie == null || typeof ie == "boolean" ? "" : ("" + ie).trim();
                  }
                } catch (re) {
                  tn(w, w.return, re);
                }
              }
            } else if (a.tag === 6) {
              if (o === null) {
                w = a;
                try {
                  w.stateNode.nodeValue = p ? "" : w.memoizedProps;
                } catch (re) {
                  tn(w, w.return, re);
                }
              }
            } else if ((a.tag !== 22 && a.tag !== 23 || a.memoizedState === null || a === n) && a.child !== null) {
              a.child.return = a, a = a.child;
              continue;
            }
            if (a === n) break e;
            for (; a.sibling === null; ) {
              if (a.return === null || a.return === n) break e;
              o === a && (o = null), a = a.return;
            }
            o === a && (o = null), a.sibling.return = a.return, a = a.sibling;
          }
        d & 4 && (d = n.updateQueue, d !== null && (o = d.retryQueue, o !== null && (d.retryQueue = null, W1(n, o))));
        break;
      case 19:
        zi(a, n), di(n), d & 4 && (d = n.updateQueue, d !== null && (n.updateQueue = null, W1(n, d)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        zi(a, n), di(n);
    }
  }
  function di(n) {
    var a = n.flags;
    if (a & 2) {
      try {
        for (var o, d = n.return; d !== null; ) {
          if (ig(d)) {
            o = d;
            break;
          }
          d = d.return;
        }
        if (o == null) throw Error(h(160));
        switch (o.tag) {
          case 27:
            var p = o.stateNode, g = Xa(n);
            B1(n, g, p);
            break;
          case 5:
            var y = o.stateNode;
            o.flags & 32 && (dc(y, ""), o.flags &= -33);
            var k = Xa(n);
            B1(n, k, y);
            break;
          case 3:
          case 4:
            var w = o.stateNode.containerInfo, K = Xa(n);
            Fl(
              n,
              K,
              w
            );
            break;
          default:
            throw Error(h(161));
        }
      } catch (ve) {
        tn(n, n.return, ve);
      }
      n.flags &= -3;
    }
    a & 4096 && (n.flags &= -4097);
  }
  function Fp(n) {
    if (n.subtreeFlags & 1024)
      for (n = n.child; n !== null; ) {
        var a = n;
        Fp(a), a.tag === 5 && a.flags & 1024 && a.stateNode.reset(), n = n.sibling;
      }
  }
  function $r(n, a) {
    if (a.subtreeFlags & 8772)
      for (a = a.child; a !== null; )
        Cp(n, a.alternate, a), a = a.sibling;
  }
  function Cn(n) {
    for (n = n.child; n !== null; ) {
      var a = n;
      switch (a.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Fs(4, a, a.return), Cn(a);
          break;
        case 1:
          Er(a, a.return);
          var o = a.stateNode;
          typeof o.componentWillUnmount == "function" && yp(
            a,
            a.return,
            o
          ), Cn(a);
          break;
        case 27:
          pa(a.stateNode);
        case 26:
        case 5:
          Er(a, a.return), Cn(a);
          break;
        case 22:
          a.memoizedState === null && Cn(a);
          break;
        case 30:
          Cn(a);
          break;
        default:
          Cn(a);
      }
      n = n.sibling;
    }
  }
  function Ms(n, a, o) {
    for (o = o && (a.subtreeFlags & 8772) !== 0, a = a.child; a !== null; ) {
      var d = a.alternate, p = n, g = a, y = g.flags;
      switch (g.tag) {
        case 0:
        case 11:
        case 15:
          Ms(
            p,
            g,
            o
          ), y0(4, g);
          break;
        case 1:
          if (Ms(
            p,
            g,
            o
          ), d = g, p = d.stateNode, typeof p.componentDidMount == "function")
            try {
              p.componentDidMount();
            } catch (K) {
              tn(d, d.return, K);
            }
          if (d = g, p = d.updateQueue, p !== null) {
            var k = d.stateNode;
            try {
              var w = p.shared.hiddenCallbacks;
              if (w !== null)
                for (p.shared.hiddenCallbacks = null, p = 0; p < w.length; p++)
                  r1(w[p], k);
            } catch (K) {
              tn(d, d.return, K);
            }
          }
          o && y & 64 && w1(g), Bc(g, g.return);
          break;
        case 27:
          A1(g);
        case 26:
        case 5:
          Ms(
            p,
            g,
            o
          ), o && d === null && y & 4 && Ac(g), Bc(g, g.return);
          break;
        case 12:
          Ms(
            p,
            g,
            o
          );
          break;
        case 13:
          Ms(
            p,
            g,
            o
          ), o && y & 4 && J1(p, g);
          break;
        case 22:
          g.memoizedState === null && Ms(
            p,
            g,
            o
          ), Bc(g, g.return);
          break;
        case 30:
          break;
        default:
          Ms(
            p,
            g,
            o
          );
      }
      a = a.sibling;
    }
  }
  function Ka(n, a) {
    var o = null;
    n !== null && n.memoizedState !== null && n.memoizedState.cachePool !== null && (o = n.memoizedState.cachePool.pool), n = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (n = a.memoizedState.cachePool.pool), n !== o && (n != null && n.refCount++, o != null && Ir(o));
  }
  function H1(n, a) {
    n = null, a.alternate !== null && (n = a.alternate.memoizedState.cache), a = a.memoizedState.cache, a !== n && (a.refCount++, n != null && Ir(n));
  }
  function vi(n, a, o, d) {
    if (a.subtreeFlags & 10256)
      for (a = a.child; a !== null; )
        Mp(
          n,
          a,
          o,
          d
        ), a = a.sibling;
  }
  function Mp(n, a, o, d) {
    var p = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 15:
        vi(
          n,
          a,
          o,
          d
        ), p & 2048 && y0(9, a);
        break;
      case 1:
        vi(
          n,
          a,
          o,
          d
        );
        break;
      case 3:
        vi(
          n,
          a,
          o,
          d
        ), p & 2048 && (n = null, a.alternate !== null && (n = a.alternate.memoizedState.cache), a = a.memoizedState.cache, a !== n && (a.refCount++, n != null && Ir(n)));
        break;
      case 12:
        if (p & 2048) {
          vi(
            n,
            a,
            o,
            d
          ), n = a.stateNode;
          try {
            var g = a.memoizedProps, y = g.id, k = g.onPostCommit;
            typeof k == "function" && k(
              y,
              a.alternate === null ? "mount" : "update",
              n.passiveEffectDuration,
              -0
            );
          } catch (w) {
            tn(a, a.return, w);
          }
        } else
          vi(
            n,
            a,
            o,
            d
          );
        break;
      case 13:
        vi(
          n,
          a,
          o,
          d
        );
        break;
      case 23:
        break;
      case 22:
        g = a.stateNode, y = a.alternate, a.memoizedState !== null ? g._visibility & 2 ? vi(
          n,
          a,
          o,
          d
        ) : jt(n, a) : g._visibility & 2 ? vi(
          n,
          a,
          o,
          d
        ) : (g._visibility |= 2, Ao(
          n,
          a,
          o,
          d,
          (a.subtreeFlags & 10256) !== 0
        )), p & 2048 && Ka(y, a);
        break;
      case 24:
        vi(
          n,
          a,
          o,
          d
        ), p & 2048 && H1(a.alternate, a);
        break;
      default:
        vi(
          n,
          a,
          o,
          d
        );
    }
  }
  function Ao(n, a, o, d, p) {
    for (p = p && (a.subtreeFlags & 10256) !== 0, a = a.child; a !== null; ) {
      var g = n, y = a, k = o, w = d, K = y.flags;
      switch (y.tag) {
        case 0:
        case 11:
        case 15:
          Ao(
            g,
            y,
            k,
            w,
            p
          ), y0(8, y);
          break;
        case 23:
          break;
        case 22:
          var ve = y.stateNode;
          y.memoizedState !== null ? ve._visibility & 2 ? Ao(
            g,
            y,
            k,
            w,
            p
          ) : jt(
            g,
            y
          ) : (ve._visibility |= 2, Ao(
            g,
            y,
            k,
            w,
            p
          )), p && K & 2048 && Ka(
            y.alternate,
            y
          );
          break;
        case 24:
          Ao(
            g,
            y,
            k,
            w,
            p
          ), p && K & 2048 && H1(y.alternate, y);
          break;
        default:
          Ao(
            g,
            y,
            k,
            w,
            p
          );
      }
      a = a.sibling;
    }
  }
  function jt(n, a) {
    if (a.subtreeFlags & 10256)
      for (a = a.child; a !== null; ) {
        var o = n, d = a, p = d.flags;
        switch (d.tag) {
          case 22:
            jt(o, d), p & 2048 && Ka(
              d.alternate,
              d
            );
            break;
          case 24:
            jt(o, d), p & 2048 && H1(d.alternate, d);
            break;
          default:
            jt(o, d);
        }
        a = a.sibling;
      }
  }
  var Ml = 8192;
  function An(n) {
    if (n.subtreeFlags & Ml)
      for (n = n.child; n !== null; )
        ag(n), n = n.sibling;
  }
  function ag(n) {
    switch (n.tag) {
      case 26:
        An(n), n.flags & Ml && n.memoizedState !== null && yg(
          ji,
          n.memoizedState,
          n.memoizedProps
        );
        break;
      case 5:
        An(n);
        break;
      case 3:
      case 4:
        var a = ji;
        ji = oh(n.stateNode.containerInfo), An(n), ji = a;
        break;
      case 22:
        n.memoizedState === null && (a = n.alternate, a !== null && a.memoizedState !== null ? (a = Ml, Ml = 16777216, An(n), Ml = a) : An(n));
        break;
      default:
        An(n);
    }
  }
  function kp(n) {
    var a = n.alternate;
    if (a !== null && (n = a.child, n !== null)) {
      a.child = null;
      do
        a = n.sibling, n.sibling = null, n = a;
      while (n !== null);
    }
  }
  function kl(n) {
    var a = n.deletions;
    if ((n.flags & 16) !== 0) {
      if (a !== null)
        for (var o = 0; o < a.length; o++) {
          var d = a[o];
          ni = d, Qp(
            d,
            n
          );
        }
      kp(n);
    }
    if (n.subtreeFlags & 10256)
      for (n = n.child; n !== null; )
        Dp(n), n = n.sibling;
  }
  function Dp(n) {
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        kl(n), n.flags & 2048 && Fs(9, n, n.return);
        break;
      case 3:
        kl(n);
        break;
      case 12:
        kl(n);
        break;
      case 22:
        var a = n.stateNode;
        n.memoizedState !== null && a._visibility & 2 && (n.return === null || n.return.tag !== 13) ? (a._visibility &= -3, Pi(n)) : kl(n);
        break;
      default:
        kl(n);
    }
  }
  function Pi(n) {
    var a = n.deletions;
    if ((n.flags & 16) !== 0) {
      if (a !== null)
        for (var o = 0; o < a.length; o++) {
          var d = a[o];
          ni = d, Qp(
            d,
            n
          );
        }
      kp(n);
    }
    for (n = n.child; n !== null; ) {
      switch (a = n, a.tag) {
        case 0:
        case 11:
        case 15:
          Fs(8, a, a.return), Pi(a);
          break;
        case 22:
          o = a.stateNode, o._visibility & 2 && (o._visibility &= -3, Pi(a));
          break;
        default:
          Pi(a);
      }
      n = n.sibling;
    }
  }
  function Qp(n, a) {
    for (; ni !== null; ) {
      var o = ni;
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          Fs(8, o, a);
          break;
        case 23:
        case 22:
          if (o.memoizedState !== null && o.memoizedState.cachePool !== null) {
            var d = o.memoizedState.cachePool.pool;
            d != null && d.refCount++;
          }
          break;
        case 24:
          Ir(o.memoizedState.cache);
      }
      if (d = o.child, d !== null) d.return = o, ni = d;
      else
        e: for (o = n; ni !== null; ) {
          d = ni;
          var p = d.sibling, g = d.return;
          if (Vp(d), d === o) {
            ni = null;
            break e;
          }
          if (p !== null) {
            p.return = g, ni = p;
            break e;
          }
          ni = g;
        }
    }
  }
  var xp = {
    getCacheForType: function(n) {
      var a = si($n), o = a.data.get(n);
      return o === void 0 && (o = n(), a.data.set(n, o)), o;
    }
  }, rg = typeof WeakMap == "function" ? WeakMap : Map, qt = 0, un = null, xt = null, Zt = 0, en = 0, ua = null, eo = !1, Ic = !1, Zp = !1, Io = 0, In = 0, Lo = 0, Dl = 0, to = 0, qa = 0, Lc = 0, Jc = null, ha = null, Op = !1, wp = 0, z1 = 1 / 0, Wc = null, ks = null, Si = 0, no = null, Hc = null, Ri = 0, j1 = 0, P1 = null, Bp = null, zc = 0, Ap = null;
  function Fa() {
    if ((qt & 2) !== 0 && Zt !== 0)
      return Zt & -Zt;
    if (O.T !== null) {
      var n = Pa;
      return n !== 0 ? n : Ol();
    }
    return is();
  }
  function Ip() {
    qa === 0 && (qa = (Zt & 536870912) === 0 || Ht ? Ze() : 536870912);
    var n = _a.current;
    return n !== null && (n.flags |= 32), qa;
  }
  function Ma(n, a, o) {
    (n === un && (en === 2 || en === 9) || n.cancelPendingCommit !== null) && (io(n, 0), Jo(
      n,
      Zt,
      qa,
      !1
    )), ut(n, o), ((qt & 2) === 0 || n !== un) && (n === un && ((qt & 2) === 0 && (Dl |= o), In === 4 && Jo(
      n,
      Zt,
      qa,
      !1
    )), ma(n));
  }
  function jc(n, a, o) {
    if ((qt & 6) !== 0) throw Error(h(327));
    var d = !o && (a & 124) === 0 && (a & n.expiredLanes) === 0 || F(n, a), p = d ? Jp(n, a) : G1(n, a, !0), g = d;
    do {
      if (p === 0) {
        Ic && !d && Jo(n, a, 0, !1);
        break;
      } else {
        if (o = n.current.alternate, g && !og(o)) {
          p = G1(n, a, !1), g = !1;
          continue;
        }
        if (p === 2) {
          if (g = a, n.errorRecoveryDisabledLanes & g)
            var y = 0;
          else
            y = n.pendingLanes & -536870913, y = y !== 0 ? y : y & 536870912 ? 536870912 : 0;
          if (y !== 0) {
            a = y;
            e: {
              var k = n;
              p = Jc;
              var w = k.current.memoizedState.isDehydrated;
              if (w && (io(k, y).flags |= 256), y = G1(
                k,
                y,
                !1
              ), y !== 2) {
                if (Zp && !w) {
                  k.errorRecoveryDisabledLanes |= g, Dl |= g, p = 4;
                  break e;
                }
                g = ha, ha = p, g !== null && (ha === null ? ha = g : ha.push.apply(
                  ha,
                  g
                ));
              }
              p = y;
            }
            if (g = !1, p !== 2) continue;
          }
        }
        if (p === 1) {
          io(n, 0), Jo(n, a, 0, !0);
          break;
        }
        e: {
          switch (d = n, g = p, g) {
            case 0:
            case 1:
              throw Error(h(345));
            case 4:
              if ((a & 4194048) !== a) break;
            case 6:
              Jo(
                d,
                a,
                qa,
                !eo
              );
              break e;
            case 2:
              ha = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(h(329));
          }
          if ((a & 62914560) === a && (p = wp + 300 - yn(), 10 < p)) {
            if (Jo(
              d,
              a,
              qa,
              !eo
            ), Li(d, 0, !0) !== 0) break e;
            d.timeoutHandle = ah(
              b0.bind(
                null,
                d,
                o,
                ha,
                Wc,
                Op,
                a,
                qa,
                Dl,
                Lc,
                eo,
                g,
                2,
                -0,
                0
              ),
              p
            );
            break e;
          }
          b0(
            d,
            o,
            ha,
            Wc,
            Op,
            a,
            qa,
            Dl,
            Lc,
            eo,
            g,
            0,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    ma(n);
  }
  function b0(n, a, o, d, p, g, y, k, w, K, ve, Ee, ie, re) {
    if (n.timeoutHandle = -1, Ee = a.subtreeFlags, (Ee & 8192 || (Ee & 16785408) === 16785408) && (ad = { stylesheets: null, count: 0, unsuspend: Tg }, ag(a), Ee = rf(), Ee !== null)) {
      n.cancelPendingCommit = Ee(
        cg.bind(
          null,
          n,
          a,
          g,
          o,
          d,
          p,
          y,
          k,
          w,
          ve,
          1,
          ie,
          re
        )
      ), Jo(n, g, y, !K);
      return;
    }
    cg(
      n,
      a,
      g,
      o,
      d,
      p,
      y,
      k,
      w
    );
  }
  function og(n) {
    for (var a = n; ; ) {
      var o = a.tag;
      if ((o === 0 || o === 11 || o === 15) && a.flags & 16384 && (o = a.updateQueue, o !== null && (o = o.stores, o !== null)))
        for (var d = 0; d < o.length; d++) {
          var p = o[d], g = p.getSnapshot;
          p = p.value;
          try {
            if (!fi(g(), p)) return !1;
          } catch {
            return !1;
          }
        }
      if (o = a.child, a.subtreeFlags & 16384 && o !== null)
        o.return = a, a = o;
      else {
        if (a === n) break;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === n) return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
    }
    return !0;
  }
  function Jo(n, a, o, d) {
    a &= ~to, a &= ~Dl, n.suspendedLanes |= a, n.pingedLanes &= ~a, d && (n.warmLanes |= a), d = n.expirationTimes;
    for (var p = a; 0 < p; ) {
      var g = 31 - Pn(p), y = 1 << g;
      d[g] = -1, p &= ~y;
    }
    o !== 0 && Vt(n, o, a);
  }
  function Ql() {
    return (qt & 6) === 0 ? (F0(0), !1) : !0;
  }
  function Ds() {
    if (xt !== null) {
      if (en === 0)
        var n = xt.return;
      else
        n = xt, gr = Do = null, c1(n), yl = null, Qc = 0, n = xt;
      for (; n !== null; )
        Tp(n.alternate, n), n = n.return;
      xt = null;
    }
  }
  function io(n, a) {
    var o = n.timeoutHandle;
    o !== -1 && (n.timeoutHandle = -1, gS(o)), o = n.cancelPendingCommit, o !== null && (n.cancelPendingCommit = null, o()), Ds(), un = n, xt = o = pr(n.current, null), Zt = a, en = 0, ua = null, eo = !1, Ic = F(n, a), Zp = !1, Lc = qa = to = Dl = Lo = In = 0, ha = Jc = null, Op = !1, (a & 8) !== 0 && (a |= a & 32);
    var d = n.entangledLanes;
    if (d !== 0)
      for (n = n.entanglements, d &= a; 0 < d; ) {
        var p = 31 - Pn(d), g = 1 << p;
        a |= n[p], d &= ~g;
      }
    return Io = a, mr(), o;
  }
  function Lp(n, a) {
    Et = null, O.H = N1, a === Ts || a === t0 ? (a = zm(), en = 3) : a === e1 ? (a = zm(), en = 4) : en = a === wn ? 8 : a !== null && typeof a == "object" && typeof a.then == "function" ? 6 : 1, ua = a, xt === null && (In = 1, R0(
      n,
      ba(a, n.current)
    ));
  }
  function sg() {
    var n = O.H;
    return O.H = N1, n === null ? N1 : n;
  }
  function xl() {
    var n = O.A;
    return O.A = xp, n;
  }
  function Zl() {
    In = 4, eo || (Zt & 4194048) !== Zt && _a.current !== null || (Ic = !0), (Lo & 134217727) === 0 && (Dl & 134217727) === 0 || un === null || Jo(
      un,
      Zt,
      qa,
      !1
    );
  }
  function G1(n, a, o) {
    var d = qt;
    qt |= 2;
    var p = sg(), g = xl();
    (un !== n || Zt !== a) && (Wc = null, io(n, a)), a = !1;
    var y = In;
    e: do
      try {
        if (en !== 0 && xt !== null) {
          var k = xt, w = ua;
          switch (en) {
            case 8:
              Ds(), y = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              _a.current === null && (a = !0);
              var K = en;
              if (en = 0, ua = null, Pc(n, k, w, K), o && Ic) {
                y = 0;
                break e;
              }
              break;
            default:
              K = en, en = 0, ua = null, Pc(n, k, w, K);
          }
        }
        Y1(), y = In;
        break;
      } catch (ve) {
        Lp(n, ve);
      }
    while (!0);
    return a && n.shellSuspendCounter++, gr = Do = null, qt = d, O.H = p, O.A = g, xt === null && (un = null, Zt = 0, mr()), y;
  }
  function Y1() {
    for (; xt !== null; ) Hp(xt);
  }
  function Jp(n, a) {
    var o = qt;
    qt |= 2;
    var d = sg(), p = xl();
    un !== n || Zt !== a ? (Wc = null, z1 = yn() + 500, io(n, a)) : Ic = F(
      n,
      a
    );
    e: do
      try {
        if (en !== 0 && xt !== null) {
          a = xt;
          var g = ua;
          t: switch (en) {
            case 1:
              en = 0, ua = null, Pc(n, a, g, 1);
              break;
            case 2:
            case 9:
              if (n1(g)) {
                en = 0, ua = null, zp(a);
                break;
              }
              a = function() {
                en !== 2 && en !== 9 || un !== n || (en = 7), ma(n);
              }, g.then(a, a);
              break e;
            case 3:
              en = 7;
              break e;
            case 4:
              en = 5;
              break e;
            case 7:
              n1(g) ? (en = 0, ua = null, zp(a)) : (en = 0, ua = null, Pc(n, a, g, 7));
              break;
            case 5:
              var y = null;
              switch (xt.tag) {
                case 26:
                  y = xt.memoizedState;
                case 5:
                case 27:
                  var k = xt;
                  if (!y || af(y)) {
                    en = 0, ua = null;
                    var w = k.sibling;
                    if (w !== null) xt = w;
                    else {
                      var K = k.return;
                      K !== null ? (xt = K, C0(K)) : xt = null;
                    }
                    break t;
                  }
              }
              en = 0, ua = null, Pc(n, a, g, 5);
              break;
            case 6:
              en = 0, ua = null, Pc(n, a, g, 6);
              break;
            case 8:
              Ds(), In = 6;
              break e;
            default:
              throw Error(h(462));
          }
        }
        Wp();
        break;
      } catch (ve) {
        Lp(n, ve);
      }
    while (!0);
    return gr = Do = null, O.H = d, O.A = p, qt = o, xt !== null ? 0 : (un = null, Zt = 0, mr(), In);
  }
  function Wp() {
    for (; xt !== null && !sr(); )
      Hp(xt);
  }
  function Hp(n) {
    var a = ng(n.alternate, n, Io);
    n.memoizedProps = n.pendingProps, a === null ? C0(n) : xt = a;
  }
  function zp(n) {
    var a = n, o = a.alternate;
    switch (a.tag) {
      case 15:
      case 0:
        a = vp(
          o,
          a,
          a.pendingProps,
          a.type,
          void 0,
          Zt
        );
        break;
      case 11:
        a = vp(
          o,
          a,
          a.pendingProps,
          a.type.render,
          a.ref,
          Zt
        );
        break;
      case 5:
        c1(a);
      default:
        Tp(o, a), a = xt = Ft(a, Io), a = ng(o, a, Io);
    }
    n.memoizedProps = n.pendingProps, a === null ? C0(n) : xt = a;
  }
  function Pc(n, a, o, d) {
    gr = Do = null, c1(a), yl = null, Qc = 0;
    var p = a.return;
    try {
      if ($2(
        n,
        p,
        a,
        o,
        Zt
      )) {
        In = 1, R0(
          n,
          ba(o, n.current)
        ), xt = null;
        return;
      }
    } catch (g) {
      if (p !== null) throw xt = p, g;
      In = 1, R0(
        n,
        ba(o, n.current)
      ), xt = null;
      return;
    }
    a.flags & 32768 ? (Ht || d === 1 ? n = !0 : Ic || (Zt & 536870912) !== 0 ? n = !1 : (eo = n = !0, (d === 2 || d === 9 || d === 3 || d === 6) && (d = _a.current, d !== null && d.tag === 13 && (d.flags |= 16384))), lg(a, n)) : C0(a);
  }
  function C0(n) {
    var a = n;
    do {
      if ((a.flags & 32768) !== 0) {
        lg(
          a,
          eo
        );
        return;
      }
      n = a.return;
      var o = Up(
        a.alternate,
        a,
        Io
      );
      if (o !== null) {
        xt = o;
        return;
      }
      if (a = a.sibling, a !== null) {
        xt = a;
        return;
      }
      xt = a = n;
    } while (a !== null);
    In === 0 && (In = 5);
  }
  function lg(n, a) {
    do {
      var o = dS(n.alternate, n);
      if (o !== null) {
        o.flags &= 32767, xt = o;
        return;
      }
      if (o = n.return, o !== null && (o.flags |= 32768, o.subtreeFlags = 0, o.deletions = null), !a && (n = n.sibling, n !== null)) {
        xt = n;
        return;
      }
      xt = n = o;
    } while (n !== null);
    In = 6, xt = null;
  }
  function cg(n, a, o, d, p, g, y, k, w) {
    n.cancelPendingCommit = null;
    do
      K1();
    while (Si !== 0);
    if ((qt & 6) !== 0) throw Error(h(327));
    if (a !== null) {
      if (a === n.current) throw Error(h(177));
      if (g = a.lanes | a.childLanes, g |= Or, gt(
        n,
        o,
        g,
        y,
        k,
        w
      ), n === un && (xt = un = null, Zt = 0), Hc = a, no = n, Ri = o, j1 = g, P1 = p, Bp = d, (a.subtreeFlags & 10256) !== 0 || (a.flags & 10256) !== 0 ? (n.callbackNode = null, n.callbackPriority = 0, mS(ea, function() {
        return jp(), null;
      })) : (n.callbackNode = null, n.callbackPriority = 0), d = (a.flags & 13878) !== 0, (a.subtreeFlags & 13878) !== 0 || d) {
        d = O.T, O.T = null, p = G.p, G.p = 2, y = qt, qt |= 4;
        try {
          bp(n, a, o);
        } finally {
          qt = y, G.p = p, O.T = d;
        }
      }
      Si = 1, dg(), V0(), X1();
    }
  }
  function dg() {
    if (Si === 1) {
      Si = 0;
      var n = no, a = Hc, o = (a.flags & 13878) !== 0;
      if ((a.subtreeFlags & 13878) !== 0 || o) {
        o = O.T, O.T = null;
        var d = G.p;
        G.p = 2;
        var p = qt;
        qt |= 4;
        try {
          N0(a, n);
          var g = w0, y = xm(n.containerInfo), k = g.focusedElem, w = g.selectionRange;
          if (y !== k && k && k.ownerDocument && Hd(
            k.ownerDocument.documentElement,
            k
          )) {
            if (w !== null && zd(k)) {
              var K = w.start, ve = w.end;
              if (ve === void 0 && (ve = K), "selectionStart" in k)
                k.selectionStart = K, k.selectionEnd = Math.min(
                  ve,
                  k.value.length
                );
              else {
                var Ee = k.ownerDocument || document, ie = Ee && Ee.defaultView || window;
                if (ie.getSelection) {
                  var re = ie.getSelection(), at = k.textContent.length, rt = Math.min(w.start, at), Pt = w.end === void 0 ? rt : Math.min(w.end, at);
                  !re.extend && rt > Pt && (y = Pt, Pt = rt, rt = y);
                  var P = Sn(
                    k,
                    rt
                  ), J = Sn(
                    k,
                    Pt
                  );
                  if (P && J && (re.rangeCount !== 1 || re.anchorNode !== P.node || re.anchorOffset !== P.offset || re.focusNode !== J.node || re.focusOffset !== J.offset)) {
                    var X = Ee.createRange();
                    X.setStart(P.node, P.offset), re.removeAllRanges(), rt > Pt ? (re.addRange(X), re.extend(J.node, J.offset)) : (X.setEnd(J.node, J.offset), re.addRange(X));
                  }
                }
              }
            }
            for (Ee = [], re = k; re = re.parentNode; )
              re.nodeType === 1 && Ee.push({
                element: re,
                left: re.scrollLeft,
                top: re.scrollTop
              });
            for (typeof k.focus == "function" && k.focus(), k = 0; k < Ee.length; k++) {
              var Se = Ee[k];
              Se.element.scrollLeft = Se.left, Se.element.scrollTop = Se.top;
            }
          }
          J0 = !!O0, w0 = O0 = null;
        } finally {
          qt = p, G.p = d, O.T = o;
        }
      }
      n.current = a, Si = 2;
    }
  }
  function V0() {
    if (Si === 2) {
      Si = 0;
      var n = no, a = Hc, o = (a.flags & 8772) !== 0;
      if ((a.subtreeFlags & 8772) !== 0 || o) {
        o = O.T, O.T = null;
        var d = G.p;
        G.p = 2;
        var p = qt;
        qt |= 4;
        try {
          Cp(n, a.alternate, a);
        } finally {
          qt = p, G.p = d, O.T = o;
        }
      }
      Si = 3;
    }
  }
  function X1() {
    if (Si === 4 || Si === 3) {
      Si = 0, Tn();
      var n = no, a = Hc, o = Ri, d = Bp;
      (a.subtreeFlags & 10256) !== 0 || (a.flags & 10256) !== 0 ? Si = 5 : (Si = 0, Hc = no = null, ug(n, n.pendingLanes));
      var p = n.pendingLanes;
      if (p === 0 && (ks = null), Ji(o), a = a.stateNode, jn && typeof jn.onCommitFiberRoot == "function")
        try {
          jn.onCommitFiberRoot(
            ta,
            a,
            void 0,
            (a.current.flags & 128) === 128
          );
        } catch {
        }
      if (d !== null) {
        a = O.T, p = G.p, G.p = 2, O.T = null;
        try {
          for (var g = n.onRecoverableError, y = 0; y < d.length; y++) {
            var k = d[y];
            g(k.value, {
              componentStack: k.stack
            });
          }
        } finally {
          O.T = a, G.p = p;
        }
      }
      (Ri & 3) !== 0 && K1(), ma(n), p = n.pendingLanes, (o & 4194090) !== 0 && (p & 42) !== 0 ? n === Ap ? zc++ : (zc = 0, Ap = n) : zc = 0, F0(0);
    }
  }
  function ug(n, a) {
    (n.pooledCacheLanes &= a) === 0 && (a = n.pooledCache, a != null && (n.pooledCache = null, Ir(a)));
  }
  function K1(n) {
    return dg(), V0(), X1(), jp();
  }
  function jp() {
    if (Si !== 5) return !1;
    var n = no, a = j1;
    j1 = 0;
    var o = Ji(Ri), d = O.T, p = G.p;
    try {
      G.p = 32 > o ? 32 : o, O.T = null, o = P1, P1 = null;
      var g = no, y = Ri;
      if (Si = 0, Hc = no = null, Ri = 0, (qt & 6) !== 0) throw Error(h(331));
      var k = qt;
      if (qt |= 4, Dp(g.current), Mp(
        g,
        g.current,
        y,
        o
      ), qt = k, F0(0, !1), jn && typeof jn.onPostCommitFiberRoot == "function")
        try {
          jn.onPostCommitFiberRoot(ta, g);
        } catch {
        }
      return !0;
    } finally {
      G.p = p, O.T = d, ug(n, a);
    }
  }
  function Pp(n, a, o) {
    a = ba(o, a), a = fp(n.stateNode, a, 2), n = Wr(n, a, 2), n !== null && (ut(n, 2), ma(n));
  }
  function tn(n, a, o) {
    if (n.tag === 3)
      Pp(n, n, o);
    else
      for (; a !== null; ) {
        if (a.tag === 3) {
          Pp(
            a,
            n,
            o
          );
          break;
        } else if (a.tag === 1) {
          var d = a.stateNode;
          if (typeof a.type.getDerivedStateFromError == "function" || typeof d.componentDidCatch == "function" && (ks === null || !ks.has(d))) {
            n = ba(o, n), o = gp(2), d = Wr(a, o, 2), d !== null && (da(
              o,
              d,
              a,
              n
            ), ut(d, 2), ma(d));
            break;
          }
        }
        a = a.return;
      }
  }
  function q1(n, a, o) {
    var d = n.pingCache;
    if (d === null) {
      d = n.pingCache = new rg();
      var p = /* @__PURE__ */ new Set();
      d.set(a, p);
    } else
      p = d.get(a), p === void 0 && (p = /* @__PURE__ */ new Set(), d.set(a, p));
    p.has(o) || (Zp = !0, p.add(o), n = Gp.bind(null, n, a, o), a.then(n, n));
  }
  function Gp(n, a, o) {
    var d = n.pingCache;
    d !== null && d.delete(a), n.pingedLanes |= n.suspendedLanes & o, n.warmLanes &= ~o, un === n && (Zt & o) === o && (In === 4 || In === 3 && (Zt & 62914560) === Zt && 300 > yn() - wp ? (qt & 2) === 0 && io(n, 0) : to |= o, Lc === Zt && (Lc = 0)), ma(n);
  }
  function Yp(n, a) {
    a === 0 && (a = Ae()), n = wr(n, a), n !== null && (ut(n, a), ma(n));
  }
  function uS(n) {
    var a = n.memoizedState, o = 0;
    a !== null && (o = a.retryLane), Yp(n, o);
  }
  function hS(n, a) {
    var o = 0;
    switch (n.tag) {
      case 13:
        var d = n.stateNode, p = n.memoizedState;
        p !== null && (o = p.retryLane);
        break;
      case 19:
        d = n.stateNode;
        break;
      case 22:
        d = n.stateNode._retryCache;
        break;
      default:
        throw Error(h(314));
    }
    d !== null && d.delete(a), Yp(n, o);
  }
  function mS(n, a) {
    return hn(n, a);
  }
  var $1 = null, Qs = null, _0 = !1, Gc = !1, eh = !1, xs = 0;
  function ma(n) {
    n !== Qs && n.next === null && (Qs === null ? $1 = Qs = n : Qs = Qs.next = n), Gc = !0, _0 || (_0 = !0, pg());
  }
  function F0(n, a) {
    if (!eh && Gc) {
      eh = !0;
      do
        for (var o = !1, d = $1; d !== null; ) {
          if (n !== 0) {
            var p = d.pendingLanes;
            if (p === 0) var g = 0;
            else {
              var y = d.suspendedLanes, k = d.pingedLanes;
              g = (1 << 31 - Pn(42 | n) + 1) - 1, g &= p & ~(y & ~k), g = g & 201326741 ? g & 201326741 | 1 : g ? g | 2 : 0;
            }
            g !== 0 && (o = !0, k0(d, g));
          } else
            g = Zt, g = Li(
              d,
              d === un ? g : 0,
              d.cancelPendingCommit !== null || d.timeoutHandle !== -1
            ), (g & 3) === 0 || F(d, g) || (o = !0, k0(d, g));
          d = d.next;
        }
      while (o);
      eh = !1;
    }
  }
  function hg() {
    M0();
  }
  function M0() {
    Gc = _0 = !1;
    var n = 0;
    xs !== 0 && (zo() && (n = xs), xs = 0);
    for (var a = yn(), o = null, d = $1; d !== null; ) {
      var p = d.next, g = Xp(d, a);
      g === 0 ? (d.next = null, o === null ? $1 = p : o.next = p, p === null && (Qs = o)) : (o = d, (n !== 0 || (g & 3) !== 0) && (Gc = !0)), d = p;
    }
    F0(n);
  }
  function Xp(n, a) {
    for (var o = n.suspendedLanes, d = n.pingedLanes, p = n.expirationTimes, g = n.pendingLanes & -62914561; 0 < g; ) {
      var y = 31 - Pn(g), k = 1 << y, w = p[y];
      w === -1 ? ((k & o) === 0 || (k & d) !== 0) && (p[y] = z(k, a)) : w <= a && (n.expiredLanes |= k), g &= ~k;
    }
    if (a = un, o = Zt, o = Li(
      n,
      n === a ? o : 0,
      n.cancelPendingCommit !== null || n.timeoutHandle !== -1
    ), d = n.callbackNode, o === 0 || n === a && (en === 2 || en === 9) || n.cancelPendingCommit !== null)
      return d !== null && d !== null && Aa(d), n.callbackNode = null, n.callbackPriority = 0;
    if ((o & 3) === 0 || F(n, o)) {
      if (a = o & -o, a === n.callbackPriority) return a;
      switch (d !== null && Aa(d), Ji(o)) {
        case 2:
        case 8:
          o = vt;
          break;
        case 32:
          o = ea;
          break;
        case 268435456:
          o = Ta;
          break;
        default:
          o = ea;
      }
      return d = mg.bind(null, n), o = hn(o, d), n.callbackPriority = a, n.callbackNode = o, a;
    }
    return d !== null && d !== null && Aa(d), n.callbackPriority = 2, n.callbackNode = null, 2;
  }
  function mg(n, a) {
    if (Si !== 0 && Si !== 5)
      return n.callbackNode = null, n.callbackPriority = 0, null;
    var o = n.callbackNode;
    if (K1() && n.callbackNode !== o)
      return null;
    var d = Zt;
    return d = Li(
      n,
      n === un ? d : 0,
      n.cancelPendingCommit !== null || n.timeoutHandle !== -1
    ), d === 0 ? null : (jc(n, d, a), Xp(n, yn()), n.callbackNode != null && n.callbackNode === o ? mg.bind(null, n) : null);
  }
  function k0(n, a) {
    if (K1()) return null;
    jc(n, a, !0);
  }
  function pg() {
    vS(function() {
      (qt & 6) !== 0 ? hn(
        Vr,
        hg
      ) : M0();
    });
  }
  function Ol() {
    return xs === 0 && (xs = Ze()), xs;
  }
  function th(n) {
    return n == null || typeof n == "symbol" || typeof n == "boolean" ? null : typeof n == "function" ? n : Od("" + n);
  }
  function D0(n, a) {
    var o = a.ownerDocument.createElement("input");
    return o.name = a.name, o.value = a.value, n.id && o.setAttribute("form", n.id), a.parentNode.insertBefore(o, a), n = new FormData(n), o.parentNode.removeChild(o), n;
  }
  function fg(n, a, o, d, p) {
    if (a === "submit" && o && o.stateNode === p) {
      var g = th(
        (p[qn] || null).action
      ), y = d.submitter;
      y && (a = (a = y[qn] || null) ? th(a.formAction) : y.getAttribute("formAction"), a !== null && (g = a, y = null));
      var k = new wu(
        "action",
        "action",
        null,
        d,
        p
      );
      n.push({
        event: k,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (d.defaultPrevented) {
                if (xs !== 0) {
                  var w = y ? D0(p, y) : new FormData(p);
                  y1(
                    o,
                    {
                      pending: !0,
                      data: w,
                      method: p.method,
                      action: g
                    },
                    null,
                    w
                  );
                }
              } else
                typeof g == "function" && (k.preventDefault(), w = y ? D0(p, y) : new FormData(p), y1(
                  o,
                  {
                    pending: !0,
                    data: w,
                    method: p.method,
                    action: g
                  },
                  g,
                  w
                ));
            },
            currentTarget: p
          }
        ]
      });
    }
  }
  for (var Ln = 0; Ln < gc.length; Ln++) {
    var Q0 = gc[Ln], pS = Q0.toLowerCase(), Ct = Q0[0].toUpperCase() + Q0.slice(1);
    Ja(
      pS,
      "on" + Ct
    );
  }
  Ja(B2, "onAnimationEnd"), Ja(Zm, "onAnimationIteration"), Ja(A2, "onAnimationStart"), Ja("dblclick", "onDoubleClick"), Ja("focusin", "onFocus"), Ja("focusout", "onBlur"), Ja(Om, "onTransitionRun"), Ja(ju, "onTransitionStart"), Ja(I2, "onTransitionCancel"), Ja(wm, "onTransitionEnd"), os("onMouseEnter", ["mouseout", "mouseover"]), os("onMouseLeave", ["mouseout", "mouseover"]), os("onPointerEnter", ["pointerout", "pointerover"]), os("onPointerLeave", ["pointerout", "pointerover"]), rs(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), rs(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), rs("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), rs(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), rs(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), rs(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var x0 = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), Zs = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(x0)
  );
  function wl(n, a) {
    a = (a & 4) !== 0;
    for (var o = 0; o < n.length; o++) {
      var d = n[o], p = d.event;
      d = d.listeners;
      e: {
        var g = void 0;
        if (a)
          for (var y = d.length - 1; 0 <= y; y--) {
            var k = d[y], w = k.instance, K = k.currentTarget;
            if (k = k.listener, w !== g && p.isPropagationStopped())
              break e;
            g = k, p.currentTarget = K;
            try {
              g(p);
            } catch (ve) {
              v0(ve);
            }
            p.currentTarget = null, g = w;
          }
        else
          for (y = 0; y < d.length; y++) {
            if (k = d[y], w = k.instance, K = k.currentTarget, k = k.listener, w !== g && p.isPropagationStopped())
              break e;
            g = k, p.currentTarget = K;
            try {
              g(p);
            } catch (ve) {
              v0(ve);
            }
            p.currentTarget = null, g = w;
          }
      }
    }
  }
  function Ut(n, a) {
    var o = a[as];
    o === void 0 && (o = a[as] = /* @__PURE__ */ new Set());
    var d = n + "__bubble";
    o.has(d) || (nh(a, n, 2, !1), o.add(d));
  }
  function Yc(n, a, o) {
    var d = 0;
    a && (d |= 4), nh(
      o,
      n,
      d,
      a
    );
  }
  var Xc = "_reactListening" + Math.random().toString(36).slice(2);
  function Kp(n) {
    if (!n[Xc]) {
      n[Xc] = !0, kd.forEach(function(o) {
        o !== "selectionchange" && (Zs.has(o) || Yc(o, !1, n), Yc(o, !0, n));
      });
      var a = n.nodeType === 9 ? n : n.ownerDocument;
      a === null || a[Xc] || (a[Xc] = !0, Yc("selectionchange", !1, a));
    }
  }
  function nh(n, a, o, d) {
    switch (mf(a)) {
      case 2:
        var p = Ng;
        break;
      case 8:
        p = bg;
        break;
      default:
        p = uf;
    }
    o = p.bind(
      null,
      a,
      o,
      n
    ), p = void 0, !xu || a !== "touchstart" && a !== "touchmove" && a !== "wheel" || (p = !0), d ? p !== void 0 ? n.addEventListener(a, o, {
      capture: !0,
      passive: p
    }) : n.addEventListener(a, o, !0) : p !== void 0 ? n.addEventListener(a, o, {
      passive: p
    }) : n.addEventListener(a, o, !1);
  }
  function $a(n, a, o, d, p) {
    var g = d;
    if ((a & 1) === 0 && (a & 2) === 0 && d !== null)
      e: for (; ; ) {
        if (d === null) return;
        var y = d.tag;
        if (y === 3 || y === 4) {
          var k = d.stateNode.containerInfo;
          if (k === p) break;
          if (y === 4)
            for (y = d.return; y !== null; ) {
              var w = y.tag;
              if ((w === 3 || w === 4) && y.stateNode.containerInfo === p)
                return;
              y = y.return;
            }
          for (; k !== null; ) {
            if (y = tt(k), y === null) return;
            if (w = y.tag, w === 5 || w === 6 || w === 26 || w === 27) {
              d = g = y;
              continue e;
            }
            k = k.parentNode;
          }
        }
        d = d.return;
      }
    mc(function() {
      var K = g, ve = Qu(o), Ee = [];
      e: {
        var ie = Bm.get(n);
        if (ie !== void 0) {
          var re = wu, at = n;
          switch (n) {
            case "keypress":
              if (pi(o) === 0) break e;
            case "keydown":
            case "keyup":
              re = lr;
              break;
            case "focusin":
              at = "focus", re = Rm;
              break;
            case "focusout":
              at = "blur", re = Rm;
              break;
            case "beforeblur":
            case "afterblur":
              re = Rm;
              break;
            case "click":
              if (o.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              re = Sm;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              re = F2;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              re = Tm;
              break;
            case B2:
            case Zm:
            case A2:
              re = oS;
              break;
            case wm:
              re = x2;
              break;
            case "scroll":
            case "scrollend":
              re = V2;
              break;
            case "wheel":
              re = ol;
              break;
            case "copy":
            case "cut":
            case "paste":
              re = Ad;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              re = Id;
              break;
            case "toggle":
            case "beforetoggle":
              re = Z2;
          }
          var rt = (a & 4) !== 0, Pt = !rt && (n === "scroll" || n === "scrollend"), P = rt ? ie !== null ? ie + "Capture" : null : ie;
          rt = [];
          for (var J = K, X; J !== null; ) {
            var Se = J;
            if (X = Se.stateNode, Se = Se.tag, Se !== 5 && Se !== 26 && Se !== 27 || X === null || P === null || (Se = nl(J, P), Se != null && rt.push(
              Wo(J, Se, X)
            )), Pt) break;
            J = J.return;
          }
          0 < rt.length && (ie = new re(
            ie,
            at,
            null,
            o,
            ve
          ), Ee.push({ event: ie, listeners: rt }));
        }
      }
      if ((a & 7) === 0) {
        e: {
          if (ie = n === "mouseover" || n === "pointerover", re = n === "mouseout" || n === "pointerout", ie && o !== tl && (at = o.relatedTarget || o.fromElement) && (tt(at) || at[na]))
            break e;
          if ((re || ie) && (ie = ve.window === ve ? ve : (ie = ve.ownerDocument) ? ie.defaultView || ie.parentWindow : window, re ? (at = o.relatedTarget || o.toElement, re = K, at = at ? tt(at) : null, at !== null && (Pt = v(at), rt = at.tag, at !== Pt || rt !== 5 && rt !== 27 && rt !== 6) && (at = null)) : (re = null, at = K), re !== at)) {
            if (rt = Sm, Se = "onMouseLeave", P = "onMouseEnter", J = "mouse", (n === "pointerout" || n === "pointerover") && (rt = Id, Se = "onPointerLeave", P = "onPointerEnter", J = "pointer"), Pt = re == null ? ie : _t(re), X = at == null ? ie : _t(at), ie = new rt(
              Se,
              J + "leave",
              re,
              o,
              ve
            ), ie.target = Pt, ie.relatedTarget = X, Se = null, tt(ve) === K && (rt = new rt(
              P,
              J + "enter",
              at,
              o,
              ve
            ), rt.target = X, rt.relatedTarget = Pt, Se = rt), Pt = Se, re && at)
              t: {
                for (rt = re, P = at, J = 0, X = rt; X; X = Os(X))
                  J++;
                for (X = 0, Se = P; Se; Se = Os(Se))
                  X++;
                for (; 0 < J - X; )
                  rt = Os(rt), J--;
                for (; 0 < X - J; )
                  P = Os(P), X--;
                for (; J--; ) {
                  if (rt === P || P !== null && rt === P.alternate)
                    break t;
                  rt = Os(rt), P = Os(P);
                }
                rt = null;
              }
            else rt = null;
            re !== null && Z0(
              Ee,
              ie,
              re,
              rt,
              !1
            ), at !== null && Pt !== null && Z0(
              Ee,
              Pt,
              at,
              rt,
              !0
            );
          }
        }
        e: {
          if (ie = K ? _t(K) : window, re = ie.nodeName && ie.nodeName.toLowerCase(), re === "select" || re === "input" && ie.type === "file")
            var Xe = _m;
          else if (Ju(ie))
            if (Fm)
              Xe = Dm;
            else {
              Xe = hs;
              var Mt = Hu;
            }
          else
            re = ie.nodeName, !re || re.toLowerCase() !== "input" || ie.type !== "checkbox" && ie.type !== "radio" ? K && el(K.elementType) && (Xe = _m) : Xe = _o;
          if (Xe && (Xe = Xe(n, K))) {
            Wu(
              Ee,
              Xe,
              o,
              ve
            );
            break e;
          }
          Mt && Mt(n, ie, K), n === "focusout" && K && ie.type === "number" && K.memoizedProps.value != null && xd(ie, "number", ie.value);
        }
        switch (Mt = K ? _t(K) : window, n) {
          case "focusin":
            (Ju(Mt) || Mt.contentEditable === "true") && (xr = Mt, ur = K, fs = null);
            break;
          case "focusout":
            fs = ur = xr = null;
            break;
          case "mousedown":
            ul = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            ul = !1, zu(Ee, o, ve);
            break;
          case "selectionchange":
            if (dl) break;
          case "keydown":
          case "keyup":
            zu(Ee, o, ve);
        }
        var nt;
        if (Ld)
          e: {
            switch (n) {
              case "compositionstart":
                var ct = "onCompositionStart";
                break e;
              case "compositionend":
                ct = "onCompositionEnd";
                break e;
              case "compositionupdate":
                ct = "onCompositionUpdate";
                break e;
            }
            ct = void 0;
          }
        else
          us ? Wd(n, o) && (ct = "onCompositionEnd") : n === "keydown" && o.keyCode === 229 && (ct = "onCompositionStart");
        ct && (Dr && o.locale !== "ko" && (us || ct !== "onCompositionStart" ? ct === "onCompositionEnd" && us && (nt = gm()) : (Co = ve, pc = "value" in Co ? Co.value : Co.textContent, us = !0)), Mt = Kc(K, ct), 0 < Mt.length && (ct = new Em(
          ct,
          n,
          null,
          o,
          ve
        ), Ee.push({ event: ct, listeners: Mt }), nt ? ct.data = nt : (nt = ds(o), nt !== null && (ct.data = nt)))), (nt = Nm ? Cm(n, o) : sl(n, o)) && (ct = Kc(K, "onBeforeInput"), 0 < ct.length && (Mt = new Em(
          "onBeforeInput",
          "beforeinput",
          null,
          o,
          ve
        ), Ee.push({
          event: Mt,
          listeners: ct
        }), Mt.data = nt)), fg(
          Ee,
          n,
          K,
          o,
          ve
        );
      }
      wl(Ee, a);
    });
  }
  function Wo(n, a, o) {
    return {
      instance: n,
      listener: a,
      currentTarget: o
    };
  }
  function Kc(n, a) {
    for (var o = a + "Capture", d = []; n !== null; ) {
      var p = n, g = p.stateNode;
      if (p = p.tag, p !== 5 && p !== 26 && p !== 27 || g === null || (p = nl(n, o), p != null && d.unshift(
        Wo(n, p, g)
      ), p = nl(n, a), p != null && d.push(
        Wo(n, p, g)
      )), n.tag === 3) return d;
      n = n.return;
    }
    return [];
  }
  function Os(n) {
    if (n === null) return null;
    do
      n = n.return;
    while (n && n.tag !== 5 && n.tag !== 27);
    return n || null;
  }
  function Z0(n, a, o, d, p) {
    for (var g = a._reactName, y = []; o !== null && o !== d; ) {
      var k = o, w = k.alternate, K = k.stateNode;
      if (k = k.tag, w !== null && w === d) break;
      k !== 5 && k !== 26 && k !== 27 || K === null || (w = K, p ? (K = nl(o, g), K != null && y.unshift(
        Wo(o, K, w)
      )) : p || (K = nl(o, g), K != null && y.push(
        Wo(o, K, w)
      ))), o = o.return;
    }
    y.length !== 0 && n.push({ event: a, listeners: y });
  }
  var ka = /\r\n?/g, qp = /\u0000|\uFFFD/g;
  function gg(n) {
    return (typeof n == "string" ? n : "" + n).replace(ka, `
`).replace(qp, "");
  }
  function $p(n, a) {
    return a = gg(a), gg(n) === a;
  }
  function ih() {
  }
  function St(n, a, o, d, p, g) {
    switch (o) {
      case "children":
        typeof d == "string" ? a === "body" || a === "textarea" && d === "" || dc(n, d) : (typeof d == "number" || typeof d == "bigint") && a !== "body" && dc(n, "" + d);
        break;
      case "className":
        Dd(n, "class", d);
        break;
      case "tabIndex":
        Dd(n, "tabindex", d);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Dd(n, o, d);
        break;
      case "style":
        Zd(n, d, g);
        break;
      case "data":
        if (a !== "object") {
          Dd(n, "data", d);
          break;
        }
      case "src":
      case "href":
        if (d === "" && (a !== "a" || o !== "href")) {
          n.removeAttribute(o);
          break;
        }
        if (d == null || typeof d == "function" || typeof d == "symbol" || typeof d == "boolean") {
          n.removeAttribute(o);
          break;
        }
        d = Od("" + d), n.setAttribute(o, d);
        break;
      case "action":
      case "formAction":
        if (typeof d == "function") {
          n.setAttribute(
            o,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof g == "function" && (o === "formAction" ? (a !== "input" && St(n, a, "name", p.name, p, null), St(
            n,
            a,
            "formEncType",
            p.formEncType,
            p,
            null
          ), St(
            n,
            a,
            "formMethod",
            p.formMethod,
            p,
            null
          ), St(
            n,
            a,
            "formTarget",
            p.formTarget,
            p,
            null
          )) : (St(n, a, "encType", p.encType, p, null), St(n, a, "method", p.method, p, null), St(n, a, "target", p.target, p, null)));
        if (d == null || typeof d == "symbol" || typeof d == "boolean") {
          n.removeAttribute(o);
          break;
        }
        d = Od("" + d), n.setAttribute(o, d);
        break;
      case "onClick":
        d != null && (n.onclick = ih);
        break;
      case "onScroll":
        d != null && Ut("scroll", n);
        break;
      case "onScrollEnd":
        d != null && Ut("scrollend", n);
        break;
      case "dangerouslySetInnerHTML":
        if (d != null) {
          if (typeof d != "object" || !("__html" in d))
            throw Error(h(61));
          if (o = d.__html, o != null) {
            if (p.children != null) throw Error(h(60));
            n.innerHTML = o;
          }
        }
        break;
      case "multiple":
        n.multiple = d && typeof d != "function" && typeof d != "symbol";
        break;
      case "muted":
        n.muted = d && typeof d != "function" && typeof d != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (d == null || typeof d == "function" || typeof d == "boolean" || typeof d == "symbol") {
          n.removeAttribute("xlink:href");
          break;
        }
        o = Od("" + d), n.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          o
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        d != null && typeof d != "function" && typeof d != "symbol" ? n.setAttribute(o, "" + d) : n.removeAttribute(o);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        d && typeof d != "function" && typeof d != "symbol" ? n.setAttribute(o, "") : n.removeAttribute(o);
        break;
      case "capture":
      case "download":
        d === !0 ? n.setAttribute(o, "") : d !== !1 && d != null && typeof d != "function" && typeof d != "symbol" ? n.setAttribute(o, d) : n.removeAttribute(o);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        d != null && typeof d != "function" && typeof d != "symbol" && !isNaN(d) && 1 <= d ? n.setAttribute(o, d) : n.removeAttribute(o);
        break;
      case "rowSpan":
      case "start":
        d == null || typeof d == "function" || typeof d == "symbol" || isNaN(d) ? n.removeAttribute(o) : n.setAttribute(o, d);
        break;
      case "popover":
        Ut("beforetoggle", n), Ut("toggle", n), No(n, "popover", d);
        break;
      case "xlinkActuate":
        Mr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          d
        );
        break;
      case "xlinkArcrole":
        Mr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          d
        );
        break;
      case "xlinkRole":
        Mr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          d
        );
        break;
      case "xlinkShow":
        Mr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          d
        );
        break;
      case "xlinkTitle":
        Mr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          d
        );
        break;
      case "xlinkType":
        Mr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          d
        );
        break;
      case "xmlBase":
        Mr(
          n,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          d
        );
        break;
      case "xmlLang":
        Mr(
          n,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          d
        );
        break;
      case "xmlSpace":
        Mr(
          n,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          d
        );
        break;
      case "is":
        No(n, "is", d);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < o.length) || o[0] !== "o" && o[0] !== "O" || o[1] !== "n" && o[1] !== "N") && (o = iS.get(o) || o, No(n, o, d));
    }
  }
  function le(n, a, o, d, p, g) {
    switch (o) {
      case "style":
        Zd(n, d, g);
        break;
      case "dangerouslySetInnerHTML":
        if (d != null) {
          if (typeof d != "object" || !("__html" in d))
            throw Error(h(61));
          if (o = d.__html, o != null) {
            if (p.children != null) throw Error(h(60));
            n.innerHTML = o;
          }
        }
        break;
      case "children":
        typeof d == "string" ? dc(n, d) : (typeof d == "number" || typeof d == "bigint") && dc(n, "" + d);
        break;
      case "onScroll":
        d != null && Ut("scroll", n);
        break;
      case "onScrollEnd":
        d != null && Ut("scrollend", n);
        break;
      case "onClick":
        d != null && (n.onclick = ih);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!ya.hasOwnProperty(o))
          e: {
            if (o[0] === "o" && o[1] === "n" && (p = o.endsWith("Capture"), a = o.slice(2, p ? o.length - 7 : void 0), g = n[qn] || null, g = g != null ? g[o] : null, typeof g == "function" && n.removeEventListener(a, g, p), typeof d == "function")) {
              typeof g != "function" && g !== null && (o in n ? n[o] = null : n.hasAttribute(o) && n.removeAttribute(o)), n.addEventListener(a, d, p);
              break e;
            }
            o in n ? n[o] = d : d === !0 ? n.setAttribute(o, "") : No(n, o, d);
          }
    }
  }
  function pt(n, a, o) {
    switch (a) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Ut("error", n), Ut("load", n);
        var d = !1, p = !1, g;
        for (g in o)
          if (o.hasOwnProperty(g)) {
            var y = o[g];
            if (y != null)
              switch (g) {
                case "src":
                  d = !0;
                  break;
                case "srcSet":
                  p = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(h(137, a));
                default:
                  St(n, a, g, y, o, null);
              }
          }
        p && St(n, a, "srcSet", o.srcSet, o, null), d && St(n, a, "src", o.src, o, null);
        return;
      case "input":
        Ut("invalid", n);
        var k = g = y = p = null, w = null, K = null;
        for (d in o)
          if (o.hasOwnProperty(d)) {
            var ve = o[d];
            if (ve != null)
              switch (d) {
                case "name":
                  p = ve;
                  break;
                case "type":
                  y = ve;
                  break;
                case "checked":
                  w = ve;
                  break;
                case "defaultChecked":
                  K = ve;
                  break;
                case "value":
                  g = ve;
                  break;
                case "defaultValue":
                  k = ve;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (ve != null)
                    throw Error(h(137, a));
                  break;
                default:
                  St(n, a, d, ve, o, null);
              }
          }
        ku(
          n,
          g,
          k,
          w,
          K,
          y,
          p,
          !1
        ), ls(n);
        return;
      case "select":
        Ut("invalid", n), d = y = g = null;
        for (p in o)
          if (o.hasOwnProperty(p) && (k = o[p], k != null))
            switch (p) {
              case "value":
                g = k;
                break;
              case "defaultValue":
                y = k;
                break;
              case "multiple":
                d = k;
              default:
                St(n, a, p, k, o, null);
            }
        a = g, o = y, n.multiple = !!d, a != null ? $s(n, !!d, a, !1) : o != null && $s(n, !!d, o, !0);
        return;
      case "textarea":
        Ut("invalid", n), g = p = d = null;
        for (y in o)
          if (o.hasOwnProperty(y) && (k = o[y], k != null))
            switch (y) {
              case "value":
                d = k;
                break;
              case "defaultValue":
                p = k;
                break;
              case "children":
                g = k;
                break;
              case "dangerouslySetInnerHTML":
                if (k != null) throw Error(h(91));
                break;
              default:
                St(n, a, y, k, o, null);
            }
        pm(n, d, p, g), ls(n);
        return;
      case "option":
        for (w in o)
          if (o.hasOwnProperty(w) && (d = o[w], d != null))
            switch (w) {
              case "selected":
                n.selected = d && typeof d != "function" && typeof d != "symbol";
                break;
              default:
                St(n, a, w, d, o, null);
            }
        return;
      case "dialog":
        Ut("beforetoggle", n), Ut("toggle", n), Ut("cancel", n), Ut("close", n);
        break;
      case "iframe":
      case "object":
        Ut("load", n);
        break;
      case "video":
      case "audio":
        for (d = 0; d < x0.length; d++)
          Ut(x0[d], n);
        break;
      case "image":
        Ut("error", n), Ut("load", n);
        break;
      case "details":
        Ut("toggle", n);
        break;
      case "embed":
      case "source":
      case "link":
        Ut("error", n), Ut("load", n);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (K in o)
          if (o.hasOwnProperty(K) && (d = o[K], d != null))
            switch (K) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(h(137, a));
              default:
                St(n, a, K, d, o, null);
            }
        return;
      default:
        if (el(a)) {
          for (ve in o)
            o.hasOwnProperty(ve) && (d = o[ve], d !== void 0 && le(
              n,
              a,
              ve,
              d,
              o,
              void 0
            ));
          return;
        }
    }
    for (k in o)
      o.hasOwnProperty(k) && (d = o[k], d != null && St(n, a, k, d, o, null));
  }
  function fS(n, a, o, d) {
    switch (a) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var p = null, g = null, y = null, k = null, w = null, K = null, ve = null;
        for (re in o) {
          var Ee = o[re];
          if (o.hasOwnProperty(re) && Ee != null)
            switch (re) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                w = Ee;
              default:
                d.hasOwnProperty(re) || St(n, a, re, null, d, Ee);
            }
        }
        for (var ie in d) {
          var re = d[ie];
          if (Ee = o[ie], d.hasOwnProperty(ie) && (re != null || Ee != null))
            switch (ie) {
              case "type":
                g = re;
                break;
              case "name":
                p = re;
                break;
              case "checked":
                K = re;
                break;
              case "defaultChecked":
                ve = re;
                break;
              case "value":
                y = re;
                break;
              case "defaultValue":
                k = re;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (re != null)
                  throw Error(h(137, a));
                break;
              default:
                re !== Ee && St(
                  n,
                  a,
                  ie,
                  re,
                  d,
                  Ee
                );
            }
        }
        Mu(
          n,
          y,
          k,
          w,
          K,
          ve,
          g,
          p
        );
        return;
      case "select":
        re = y = k = ie = null;
        for (g in o)
          if (w = o[g], o.hasOwnProperty(g) && w != null)
            switch (g) {
              case "value":
                break;
              case "multiple":
                re = w;
              default:
                d.hasOwnProperty(g) || St(
                  n,
                  a,
                  g,
                  null,
                  d,
                  w
                );
            }
        for (p in d)
          if (g = d[p], w = o[p], d.hasOwnProperty(p) && (g != null || w != null))
            switch (p) {
              case "value":
                ie = g;
                break;
              case "defaultValue":
                k = g;
                break;
              case "multiple":
                y = g;
              default:
                g !== w && St(
                  n,
                  a,
                  p,
                  g,
                  d,
                  w
                );
            }
        a = k, o = y, d = re, ie != null ? $s(n, !!o, ie, !1) : !!d != !!o && (a != null ? $s(n, !!o, a, !0) : $s(n, !!o, o ? [] : "", !1));
        return;
      case "textarea":
        re = ie = null;
        for (k in o)
          if (p = o[k], o.hasOwnProperty(k) && p != null && !d.hasOwnProperty(k))
            switch (k) {
              case "value":
                break;
              case "children":
                break;
              default:
                St(n, a, k, null, d, p);
            }
        for (y in d)
          if (p = d[y], g = o[y], d.hasOwnProperty(y) && (p != null || g != null))
            switch (y) {
              case "value":
                ie = p;
                break;
              case "defaultValue":
                re = p;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (p != null) throw Error(h(91));
                break;
              default:
                p !== g && St(n, a, y, p, d, g);
            }
        mm(n, ie, re);
        return;
      case "option":
        for (var at in o)
          if (ie = o[at], o.hasOwnProperty(at) && ie != null && !d.hasOwnProperty(at))
            switch (at) {
              case "selected":
                n.selected = !1;
                break;
              default:
                St(
                  n,
                  a,
                  at,
                  null,
                  d,
                  ie
                );
            }
        for (w in d)
          if (ie = d[w], re = o[w], d.hasOwnProperty(w) && ie !== re && (ie != null || re != null))
            switch (w) {
              case "selected":
                n.selected = ie && typeof ie != "function" && typeof ie != "symbol";
                break;
              default:
                St(
                  n,
                  a,
                  w,
                  ie,
                  d,
                  re
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var rt in o)
          ie = o[rt], o.hasOwnProperty(rt) && ie != null && !d.hasOwnProperty(rt) && St(n, a, rt, null, d, ie);
        for (K in d)
          if (ie = d[K], re = o[K], d.hasOwnProperty(K) && ie !== re && (ie != null || re != null))
            switch (K) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (ie != null)
                  throw Error(h(137, a));
                break;
              default:
                St(
                  n,
                  a,
                  K,
                  ie,
                  d,
                  re
                );
            }
        return;
      default:
        if (el(a)) {
          for (var Pt in o)
            ie = o[Pt], o.hasOwnProperty(Pt) && ie !== void 0 && !d.hasOwnProperty(Pt) && le(
              n,
              a,
              Pt,
              void 0,
              d,
              ie
            );
          for (ve in d)
            ie = d[ve], re = o[ve], !d.hasOwnProperty(ve) || ie === re || ie === void 0 && re === void 0 || le(
              n,
              a,
              ve,
              ie,
              d,
              re
            );
          return;
        }
    }
    for (var P in o)
      ie = o[P], o.hasOwnProperty(P) && ie != null && !d.hasOwnProperty(P) && St(n, a, P, null, d, ie);
    for (Ee in d)
      ie = d[Ee], re = o[Ee], !d.hasOwnProperty(Ee) || ie === re || ie == null && re == null || St(n, a, Ee, ie, d, re);
  }
  var O0 = null, w0 = null;
  function er(n) {
    return n.nodeType === 9 ? n : n.ownerDocument;
  }
  function Ho(n) {
    switch (n) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function qc(n, a) {
    if (n === 0)
      switch (a) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return n === 1 && a === "foreignObject" ? 0 : n;
  }
  function ao(n, a) {
    return n === "textarea" || n === "noscript" || typeof a.children == "string" || typeof a.children == "number" || typeof a.children == "bigint" || typeof a.dangerouslySetInnerHTML == "object" && a.dangerouslySetInnerHTML !== null && a.dangerouslySetInnerHTML.__html != null;
  }
  var $c = null;
  function zo() {
    var n = window.event;
    return n && n.type === "popstate" ? n === $c ? !1 : ($c = n, !0) : ($c = null, !1);
  }
  var ah = typeof setTimeout == "function" ? setTimeout : void 0, gS = typeof clearTimeout == "function" ? clearTimeout : void 0, vg = typeof Promise == "function" ? Promise : void 0, vS = typeof queueMicrotask == "function" ? queueMicrotask : typeof vg < "u" ? function(n) {
    return vg.resolve(null).then(n).catch(ro);
  } : ah;
  function ro(n) {
    setTimeout(function() {
      throw n;
    });
  }
  function ws(n) {
    return n === "head";
  }
  function rh(n, a) {
    var o = a, d = 0, p = 0;
    do {
      var g = o.nextSibling;
      if (n.removeChild(o), g && g.nodeType === 8)
        if (o = g.data, o === "/$") {
          if (0 < d && 8 > d) {
            o = d;
            var y = n.ownerDocument;
            if (o & 1 && pa(y.documentElement), o & 2 && pa(y.body), o & 4)
              for (o = y.head, pa(o), y = o.firstChild; y; ) {
                var k = y.nextSibling, w = y.nodeName;
                y[pe] || w === "SCRIPT" || w === "STYLE" || w === "LINK" && y.rel.toLowerCase() === "stylesheet" || o.removeChild(y), y = k;
              }
          }
          if (p === 0) {
            n.removeChild(g), so(a);
            return;
          }
          p--;
        } else
          o === "$" || o === "$?" || o === "$!" ? p++ : d = o.charCodeAt(0) - 48;
      else d = 0;
      o = g;
    } while (o);
    so(a);
  }
  function B0(n) {
    var a = n.firstChild;
    for (a && a.nodeType === 10 && (a = a.nextSibling); a; ) {
      var o = a;
      switch (a = a.nextSibling, o.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          B0(o), mt(o);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (o.rel.toLowerCase() === "stylesheet") continue;
      }
      n.removeChild(o);
    }
  }
  function ed(n, a, o, d) {
    for (; n.nodeType === 1; ) {
      var p = o;
      if (n.nodeName.toLowerCase() !== a.toLowerCase()) {
        if (!d && (n.nodeName !== "INPUT" || n.type !== "hidden"))
          break;
      } else if (d) {
        if (!n[pe])
          switch (a) {
            case "meta":
              if (!n.hasAttribute("itemprop")) break;
              return n;
            case "link":
              if (g = n.getAttribute("rel"), g === "stylesheet" && n.hasAttribute("data-precedence"))
                break;
              if (g !== p.rel || n.getAttribute("href") !== (p.href == null || p.href === "" ? null : p.href) || n.getAttribute("crossorigin") !== (p.crossOrigin == null ? null : p.crossOrigin) || n.getAttribute("title") !== (p.title == null ? null : p.title))
                break;
              return n;
            case "style":
              if (n.hasAttribute("data-precedence")) break;
              return n;
            case "script":
              if (g = n.getAttribute("src"), (g !== (p.src == null ? null : p.src) || n.getAttribute("type") !== (p.type == null ? null : p.type) || n.getAttribute("crossorigin") !== (p.crossOrigin == null ? null : p.crossOrigin)) && g && n.hasAttribute("async") && !n.hasAttribute("itemprop"))
                break;
              return n;
            default:
              return n;
          }
      } else if (a === "input" && n.type === "hidden") {
        var g = p.name == null ? null : "" + p.name;
        if (p.type === "hidden" && n.getAttribute("name") === g)
          return n;
      } else return n;
      if (n = Ur(n.nextSibling), n === null) break;
    }
    return null;
  }
  function SS(n, a, o) {
    if (a === "") return null;
    for (; n.nodeType !== 3; )
      if ((n.nodeType !== 1 || n.nodeName !== "INPUT" || n.type !== "hidden") && !o || (n = Ur(n.nextSibling), n === null)) return null;
    return n;
  }
  function A0(n) {
    return n.data === "$!" || n.data === "$?" && n.ownerDocument.readyState === "complete";
  }
  function RS(n, a) {
    var o = n.ownerDocument;
    if (n.data !== "$?" || o.readyState === "complete")
      a();
    else {
      var d = function() {
        a(), o.removeEventListener("DOMContentLoaded", d);
      };
      o.addEventListener("DOMContentLoaded", d), n._reactRetry = d;
    }
  }
  function Ur(n) {
    for (; n != null; n = n.nextSibling) {
      var a = n.nodeType;
      if (a === 1 || a === 3) break;
      if (a === 8) {
        if (a = n.data, a === "$" || a === "$!" || a === "$?" || a === "F!" || a === "F")
          break;
        if (a === "/$") return null;
      }
    }
    return n;
  }
  var Bs = null;
  function Ei(n) {
    n = n.previousSibling;
    for (var a = 0; n; ) {
      if (n.nodeType === 8) {
        var o = n.data;
        if (o === "$" || o === "$!" || o === "$?") {
          if (a === 0) return n;
          a--;
        } else o === "/$" && a++;
      }
      n = n.previousSibling;
    }
    return null;
  }
  function ze(n, a, o) {
    switch (a = er(o), n) {
      case "html":
        if (n = a.documentElement, !n) throw Error(h(452));
        return n;
      case "head":
        if (n = a.head, !n) throw Error(h(453));
        return n;
      case "body":
        if (n = a.body, !n) throw Error(h(454));
        return n;
      default:
        throw Error(h(451));
    }
  }
  function pa(n) {
    for (var a = n.attributes; a.length; )
      n.removeAttributeNode(a[0]);
    mt(n);
  }
  var Jn = /* @__PURE__ */ new Map(), Qi = /* @__PURE__ */ new Set();
  function oh(n) {
    return typeof n.getRootNode == "function" ? n.getRootNode() : n.nodeType === 9 ? n : n.ownerDocument;
  }
  var jo = G.d;
  G.d = {
    f: sh,
    r: lh,
    D: Po,
    C: ch,
    L: As,
    m: xi,
    X: Is,
    S: fa,
    M: ef
  };
  function sh() {
    var n = jo.f(), a = Ql();
    return n || a;
  }
  function lh(n) {
    var a = et(n);
    a !== null && a.tag === 5 && a.type === "form" ? Dc(a) : jo.r(n);
  }
  var Ui = typeof document > "u" ? null : document;
  function Tr(n, a, o) {
    var d = Ui;
    if (d && typeof a == "string" && a) {
      var p = Ia(a);
      p = 'link[rel="' + n + '"][href="' + p + '"]', typeof o == "string" && (p += '[crossorigin="' + o + '"]'), Qi.has(p) || (Qi.add(p), n = { rel: n, crossOrigin: o, href: a }, d.querySelector(p) === null && (a = d.createElement("link"), pt(a, "link", n), vn(a), d.head.appendChild(a)));
    }
  }
  function Po(n) {
    jo.D(n), Tr("dns-prefetch", n, null);
  }
  function ch(n, a) {
    jo.C(n, a), Tr("preconnect", n, a);
  }
  function As(n, a, o) {
    jo.L(n, a, o);
    var d = Ui;
    if (d && n && a) {
      var p = 'link[rel="preload"][as="' + Ia(a) + '"]';
      a === "image" && o && o.imageSrcSet ? (p += '[imagesrcset="' + Ia(
        o.imageSrcSet
      ) + '"]', typeof o.imageSizes == "string" && (p += '[imagesizes="' + Ia(
        o.imageSizes
      ) + '"]')) : p += '[href="' + Ia(n) + '"]';
      var g = p;
      switch (a) {
        case "style":
          g = td(n);
          break;
        case "script":
          g = tr(n);
      }
      Jn.has(g) || (n = N(
        {
          rel: "preload",
          href: a === "image" && o && o.imageSrcSet ? void 0 : n,
          as: a
        },
        o
      ), Jn.set(g, n), d.querySelector(p) !== null || a === "style" && d.querySelector(nd(g)) || a === "script" && d.querySelector(Bl(g)) || (a = d.createElement("link"), pt(a, "link", n), vn(a), d.head.appendChild(a)));
    }
  }
  function xi(n, a) {
    jo.m(n, a);
    var o = Ui;
    if (o && n) {
      var d = a && typeof a.as == "string" ? a.as : "script", p = 'link[rel="modulepreload"][as="' + Ia(d) + '"][href="' + Ia(n) + '"]', g = p;
      switch (d) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          g = tr(n);
      }
      if (!Jn.has(g) && (n = N({ rel: "modulepreload", href: n }, a), Jn.set(g, n), o.querySelector(p) === null)) {
        switch (d) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (o.querySelector(Bl(g)))
              return;
        }
        d = o.createElement("link"), pt(d, "link", n), vn(d), o.head.appendChild(d);
      }
    }
  }
  function fa(n, a, o) {
    jo.S(n, a, o);
    var d = Ui;
    if (d && n) {
      var p = Xt(d).hoistableStyles, g = td(n);
      a = a || "default";
      var y = p.get(g);
      if (!y) {
        var k = { loading: 0, preload: null };
        if (y = d.querySelector(
          nd(g)
        ))
          k.loading = 5;
        else {
          n = N(
            { rel: "stylesheet", href: n, "data-precedence": a },
            o
          ), (o = Jn.get(g)) && uh(n, o);
          var w = y = d.createElement("link");
          vn(w), pt(w, "link", n), w._p = new Promise(function(K, ve) {
            w.onload = K, w.onerror = ve;
          }), w.addEventListener("load", function() {
            k.loading |= 1;
          }), w.addEventListener("error", function() {
            k.loading |= 2;
          }), k.loading |= 4, dh(y, a, d);
        }
        y = {
          type: "stylesheet",
          instance: y,
          count: 1,
          state: k
        }, p.set(g, y);
      }
    }
  }
  function Is(n, a) {
    jo.X(n, a);
    var o = Ui;
    if (o && n) {
      var d = Xt(o).hoistableScripts, p = tr(n), g = d.get(p);
      g || (g = o.querySelector(Bl(p)), g || (n = N({ src: n, async: !0 }, a), (a = Jn.get(p)) && hh(n, a), g = o.createElement("script"), vn(g), pt(g, "link", n), o.head.appendChild(g)), g = {
        type: "script",
        instance: g,
        count: 1,
        state: null
      }, d.set(p, g));
    }
  }
  function ef(n, a) {
    jo.M(n, a);
    var o = Ui;
    if (o && n) {
      var d = Xt(o).hoistableScripts, p = tr(n), g = d.get(p);
      g || (g = o.querySelector(Bl(p)), g || (n = N({ src: n, async: !0, type: "module" }, a), (a = Jn.get(p)) && hh(n, a), g = o.createElement("script"), vn(g), pt(g, "link", n), o.head.appendChild(g)), g = {
        type: "script",
        instance: g,
        count: 1,
        state: null
      }, d.set(p, g));
    }
  }
  function Sg(n, a, o, d) {
    var p = (p = Ce.current) ? oh(p) : null;
    if (!p) throw Error(h(446));
    switch (n) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof o.precedence == "string" && typeof o.href == "string" ? (a = td(o.href), o = Xt(
          p
        ).hoistableStyles, d = o.get(a), d || (d = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, o.set(a, d)), d) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (o.rel === "stylesheet" && typeof o.href == "string" && typeof o.precedence == "string") {
          n = td(o.href);
          var g = Xt(
            p
          ).hoistableStyles, y = g.get(n);
          if (y || (p = p.ownerDocument || p, y = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, g.set(n, y), (g = p.querySelector(
            nd(n)
          )) && !g._p && (y.instance = g, y.state.loading = 5), Jn.has(n) || (o = {
            rel: "preload",
            as: "style",
            href: o.href,
            crossOrigin: o.crossOrigin,
            integrity: o.integrity,
            media: o.media,
            hrefLang: o.hrefLang,
            referrerPolicy: o.referrerPolicy
          }, Jn.set(n, o), g || Rg(
            p,
            n,
            o,
            y.state
          ))), a && d === null)
            throw Error(h(528, ""));
          return y;
        }
        if (a && d !== null)
          throw Error(h(529, ""));
        return null;
      case "script":
        return a = o.async, o = o.src, typeof o == "string" && a && typeof a != "function" && typeof a != "symbol" ? (a = tr(o), o = Xt(
          p
        ).hoistableScripts, d = o.get(a), d || (d = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, o.set(a, d)), d) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(h(444, n));
    }
  }
  function td(n) {
    return 'href="' + Ia(n) + '"';
  }
  function nd(n) {
    return 'link[rel="stylesheet"][' + n + "]";
  }
  function id(n) {
    return N({}, n, {
      "data-precedence": n.precedence,
      precedence: null
    });
  }
  function Rg(n, a, o, d) {
    n.querySelector('link[rel="preload"][as="style"][' + a + "]") ? d.loading = 1 : (a = n.createElement("link"), d.preload = a, a.addEventListener("load", function() {
      return d.loading |= 1;
    }), a.addEventListener("error", function() {
      return d.loading |= 2;
    }), pt(a, "link", o), vn(a), n.head.appendChild(a));
  }
  function tr(n) {
    return '[src="' + Ia(n) + '"]';
  }
  function Bl(n) {
    return "script[async]" + n;
  }
  function Eg(n, a, o) {
    if (a.count++, a.instance === null)
      switch (a.type) {
        case "style":
          var d = n.querySelector(
            'style[data-href~="' + Ia(o.href) + '"]'
          );
          if (d)
            return a.instance = d, vn(d), d;
          var p = N({}, o, {
            "data-href": o.href,
            "data-precedence": o.precedence,
            href: null,
            precedence: null
          });
          return d = (n.ownerDocument || n).createElement(
            "style"
          ), vn(d), pt(d, "style", p), dh(d, o.precedence, n), a.instance = d;
        case "stylesheet":
          p = td(o.href);
          var g = n.querySelector(
            nd(p)
          );
          if (g)
            return a.state.loading |= 4, a.instance = g, vn(g), g;
          d = id(o), (p = Jn.get(p)) && uh(d, p), g = (n.ownerDocument || n).createElement("link"), vn(g);
          var y = g;
          return y._p = new Promise(function(k, w) {
            y.onload = k, y.onerror = w;
          }), pt(g, "link", d), a.state.loading |= 4, dh(g, o.precedence, n), a.instance = g;
        case "script":
          return g = tr(o.src), (p = n.querySelector(
            Bl(g)
          )) ? (a.instance = p, vn(p), p) : (d = o, (p = Jn.get(g)) && (d = N({}, o), hh(d, p)), n = n.ownerDocument || n, p = n.createElement("script"), vn(p), pt(p, "link", d), n.head.appendChild(p), a.instance = p);
        case "void":
          return null;
        default:
          throw Error(h(443, a.type));
      }
    else
      a.type === "stylesheet" && (a.state.loading & 4) === 0 && (d = a.instance, a.state.loading |= 4, dh(d, o.precedence, n));
    return a.instance;
  }
  function dh(n, a, o) {
    for (var d = o.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), p = d.length ? d[d.length - 1] : null, g = p, y = 0; y < d.length; y++) {
      var k = d[y];
      if (k.dataset.precedence === a) g = k;
      else if (g !== p) break;
    }
    g ? g.parentNode.insertBefore(n, g.nextSibling) : (a = o.nodeType === 9 ? o.head : o, a.insertBefore(n, a.firstChild));
  }
  function uh(n, a) {
    n.crossOrigin == null && (n.crossOrigin = a.crossOrigin), n.referrerPolicy == null && (n.referrerPolicy = a.referrerPolicy), n.title == null && (n.title = a.title);
  }
  function hh(n, a) {
    n.crossOrigin == null && (n.crossOrigin = a.crossOrigin), n.referrerPolicy == null && (n.referrerPolicy = a.referrerPolicy), n.integrity == null && (n.integrity = a.integrity);
  }
  var Ls = null;
  function tf(n, a, o) {
    if (Ls === null) {
      var d = /* @__PURE__ */ new Map(), p = Ls = /* @__PURE__ */ new Map();
      p.set(o, d);
    } else
      p = Ls, d = p.get(o), d || (d = /* @__PURE__ */ new Map(), p.set(o, d));
    if (d.has(n)) return d;
    for (d.set(n, null), o = o.getElementsByTagName(n), p = 0; p < o.length; p++) {
      var g = o[p];
      if (!(g[pe] || g[rn] || n === "link" && g.getAttribute("rel") === "stylesheet") && g.namespaceURI !== "http://www.w3.org/2000/svg") {
        var y = g.getAttribute(a) || "";
        y = n + y;
        var k = d.get(y);
        k ? k.push(g) : d.set(y, [g]);
      }
    }
    return d;
  }
  function nf(n, a, o) {
    n = n.ownerDocument || n, n.head.insertBefore(
      o,
      a === "title" ? n.querySelector("head > title") : null
    );
  }
  function Ug(n, a, o) {
    if (o === 1 || a.itemProp != null) return !1;
    switch (n) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof a.precedence != "string" || typeof a.href != "string" || a.href === "")
          break;
        return !0;
      case "link":
        if (typeof a.rel != "string" || typeof a.href != "string" || a.href === "" || a.onLoad || a.onError)
          break;
        switch (a.rel) {
          case "stylesheet":
            return n = a.disabled, typeof a.precedence == "string" && n == null;
          default:
            return !0;
        }
      case "script":
        if (a.async && typeof a.async != "function" && typeof a.async != "symbol" && !a.onLoad && !a.onError && a.src && typeof a.src == "string")
          return !0;
    }
    return !1;
  }
  function af(n) {
    return !(n.type === "stylesheet" && (n.state.loading & 3) === 0);
  }
  var ad = null;
  function Tg() {
  }
  function yg(n, a, o) {
    if (ad === null) throw Error(h(475));
    var d = ad;
    if (a.type === "stylesheet" && (typeof o.media != "string" || matchMedia(o.media).matches !== !1) && (a.state.loading & 4) === 0) {
      if (a.instance === null) {
        var p = td(o.href), g = n.querySelector(
          nd(p)
        );
        if (g) {
          n = g._p, n !== null && typeof n == "object" && typeof n.then == "function" && (d.count++, d = I0.bind(d), n.then(d, d)), a.state.loading |= 4, a.instance = g, vn(g);
          return;
        }
        g = n.ownerDocument || n, o = id(o), (p = Jn.get(p)) && uh(o, p), g = g.createElement("link"), vn(g);
        var y = g;
        y._p = new Promise(function(k, w) {
          y.onload = k, y.onerror = w;
        }), pt(g, "link", o), a.instance = g;
      }
      d.stylesheets === null && (d.stylesheets = /* @__PURE__ */ new Map()), d.stylesheets.set(a, n), (n = a.state.preload) && (a.state.loading & 3) === 0 && (d.count++, a = I0.bind(d), n.addEventListener("load", a), n.addEventListener("error", a));
    }
  }
  function rf() {
    if (ad === null) throw Error(h(475));
    var n = ad;
    return n.stylesheets && n.count === 0 && L0(n, n.stylesheets), 0 < n.count ? function(a) {
      var o = setTimeout(function() {
        if (n.stylesheets && L0(n, n.stylesheets), n.unsuspend) {
          var d = n.unsuspend;
          n.unsuspend = null, d();
        }
      }, 6e4);
      return n.unsuspend = a, function() {
        n.unsuspend = null, clearTimeout(o);
      };
    } : null;
  }
  function I0() {
    if (this.count--, this.count === 0) {
      if (this.stylesheets) L0(this, this.stylesheets);
      else if (this.unsuspend) {
        var n = this.unsuspend;
        this.unsuspend = null, n();
      }
    }
  }
  var rd = null;
  function L0(n, a) {
    n.stylesheets = null, n.unsuspend !== null && (n.count++, rd = /* @__PURE__ */ new Map(), a.forEach(Da, n), rd = null, I0.call(n));
  }
  function Da(n, a) {
    if (!(a.state.loading & 4)) {
      var o = rd.get(n);
      if (o) var d = o.get(null);
      else {
        o = /* @__PURE__ */ new Map(), rd.set(n, o);
        for (var p = n.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), g = 0; g < p.length; g++) {
          var y = p[g];
          (y.nodeName === "LINK" || y.getAttribute("media") !== "not all") && (o.set(y.dataset.precedence, y), d = y);
        }
        d && o.set(null, d);
      }
      p = a.instance, y = p.getAttribute("data-precedence"), g = o.get(y) || d, g === d && o.set(null, p), o.set(y, p), this.count++, d = I0.bind(this), p.addEventListener("load", d), p.addEventListener("error", d), g ? g.parentNode.insertBefore(p, g.nextSibling) : (n = n.nodeType === 9 ? n.head : n, n.insertBefore(p, n.firstChild)), a.state.loading |= 4;
    }
  }
  var ga = {
    $$typeof: _e,
    Provider: null,
    Consumer: null,
    _currentValue: se,
    _currentValue2: se,
    _threadCount: 0
  };
  function ES(n, a, o, d, p, g, y, k) {
    this.tag = 1, this.containerInfo = n, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Ye(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ye(0), this.hiddenUpdates = Ye(null), this.identifierPrefix = d, this.onUncaughtError = p, this.onCaughtError = g, this.onRecoverableError = y, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = k, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function of(n, a, o, d, p, g, y, k, w, K, ve, Ee) {
    return n = new ES(
      n,
      a,
      o,
      y,
      k,
      w,
      K,
      Ee
    ), a = 1, g === !0 && (a |= 24), g = ra(3, null, null, a), n.current = g, g.stateNode = n, a = Vc(), a.refCount++, n.pooledCache = a, a.refCount++, g.memoizedState = {
      element: d,
      isDehydrated: o,
      cache: a
    }, i1(g), n;
  }
  function sf(n) {
    return n ? (n = Rc, n) : Rc;
  }
  function lf(n, a, o, d, p, g) {
    p = sf(p), d.context === null ? d.context = p : d.pendingContext = p, d = sa(a), d.payload = { element: o }, g = g === void 0 ? null : g, g !== null && (d.callback = g), o = Wr(n, d, a), o !== null && (Ma(o, n, a), vl(o, n, a));
  }
  function cf(n, a) {
    if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
      var o = n.retryLane;
      n.retryLane = o !== 0 && o < a ? o : a;
    }
  }
  function mh(n, a) {
    cf(n, a), (n = n.alternate) && cf(n, a);
  }
  function df(n) {
    if (n.tag === 13) {
      var a = wr(n, 67108864);
      a !== null && Ma(a, n, 67108864), mh(n, 67108864);
    }
  }
  var J0 = !0;
  function Ng(n, a, o, d) {
    var p = O.T;
    O.T = null;
    var g = G.p;
    try {
      G.p = 2, uf(n, a, o, d);
    } finally {
      G.p = g, O.T = p;
    }
  }
  function bg(n, a, o, d) {
    var p = O.T;
    O.T = null;
    var g = G.p;
    try {
      G.p = 8, uf(n, a, o, d);
    } finally {
      G.p = g, O.T = p;
    }
  }
  function uf(n, a, o, d) {
    if (J0) {
      var p = ph(d);
      if (p === null)
        $a(
          n,
          a,
          d,
          fh,
          o
        ), Al(n, d);
      else if (Vg(
        p,
        n,
        a,
        o,
        d
      ))
        d.stopPropagation();
      else if (Al(n, d), a & 4 && -1 < Cg.indexOf(n)) {
        for (; p !== null; ) {
          var g = et(p);
          if (g !== null)
            switch (g.tag) {
              case 3:
                if (g = g.stateNode, g.current.memoizedState.isDehydrated) {
                  var y = Mn(g.pendingLanes);
                  if (y !== 0) {
                    var k = g;
                    for (k.pendingLanes |= 2, k.entangledLanes |= 2; y; ) {
                      var w = 1 << 31 - Pn(y);
                      k.entanglements[1] |= w, y &= ~w;
                    }
                    ma(g), (qt & 6) === 0 && (z1 = yn() + 500, F0(0));
                  }
                }
                break;
              case 13:
                k = wr(g, 2), k !== null && Ma(k, g, 2), Ql(), mh(g, 2);
            }
          if (g = ph(d), g === null && $a(
            n,
            a,
            d,
            fh,
            o
          ), g === p) break;
          p = g;
        }
        p !== null && d.stopPropagation();
      } else
        $a(
          n,
          a,
          d,
          null,
          o
        );
    }
  }
  function ph(n) {
    return n = Qu(n), hf(n);
  }
  var fh = null;
  function hf(n) {
    if (fh = null, n = tt(n), n !== null) {
      var a = v(n);
      if (a === null) n = null;
      else {
        var o = a.tag;
        if (o === 13) {
          if (n = R(a), n !== null) return n;
          n = null;
        } else if (o === 3) {
          if (a.stateNode.current.memoizedState.isDehydrated)
            return a.tag === 3 ? a.stateNode.containerInfo : null;
          n = null;
        } else a !== n && (n = null);
      }
    }
    return fh = n, null;
  }
  function mf(n) {
    switch (n) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (Bt()) {
          case Vr:
            return 2;
          case vt:
            return 8;
          case ea:
          case Ci:
            return 32;
          case Ta:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var od = !1, oo = null, Go = null, Yo = null, W0 = /* @__PURE__ */ new Map(), H0 = /* @__PURE__ */ new Map(), Js = [], Cg = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Al(n, a) {
    switch (n) {
      case "focusin":
      case "focusout":
        oo = null;
        break;
      case "dragenter":
      case "dragleave":
        Go = null;
        break;
      case "mouseover":
      case "mouseout":
        Yo = null;
        break;
      case "pointerover":
      case "pointerout":
        W0.delete(a.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        H0.delete(a.pointerId);
    }
  }
  function Il(n, a, o, d, p, g) {
    return n === null || n.nativeEvent !== g ? (n = {
      blockedOn: a,
      domEventName: o,
      eventSystemFlags: d,
      nativeEvent: g,
      targetContainers: [p]
    }, a !== null && (a = et(a), a !== null && df(a)), n) : (n.eventSystemFlags |= d, a = n.targetContainers, p !== null && a.indexOf(p) === -1 && a.push(p), n);
  }
  function Vg(n, a, o, d, p) {
    switch (a) {
      case "focusin":
        return oo = Il(
          oo,
          n,
          a,
          o,
          d,
          p
        ), !0;
      case "dragenter":
        return Go = Il(
          Go,
          n,
          a,
          o,
          d,
          p
        ), !0;
      case "mouseover":
        return Yo = Il(
          Yo,
          n,
          a,
          o,
          d,
          p
        ), !0;
      case "pointerover":
        var g = p.pointerId;
        return W0.set(
          g,
          Il(
            W0.get(g) || null,
            n,
            a,
            o,
            d,
            p
          )
        ), !0;
      case "gotpointercapture":
        return g = p.pointerId, H0.set(
          g,
          Il(
            H0.get(g) || null,
            n,
            a,
            o,
            d,
            p
          )
        ), !0;
    }
    return !1;
  }
  function pf(n) {
    var a = tt(n.target);
    if (a !== null) {
      var o = v(a);
      if (o !== null) {
        if (a = o.tag, a === 13) {
          if (a = R(o), a !== null) {
            n.blockedOn = a, yo(n.priority, function() {
              if (o.tag === 13) {
                var d = Fa();
                d = Nn(d);
                var p = wr(o, d);
                p !== null && Ma(p, o, d), mh(o, d);
              }
            });
            return;
          }
        } else if (a === 3 && o.stateNode.current.memoizedState.isDehydrated) {
          n.blockedOn = o.tag === 3 ? o.stateNode.containerInfo : null;
          return;
        }
      }
    }
    n.blockedOn = null;
  }
  function z0(n) {
    if (n.blockedOn !== null) return !1;
    for (var a = n.targetContainers; 0 < a.length; ) {
      var o = ph(n.nativeEvent);
      if (o === null) {
        o = n.nativeEvent;
        var d = new o.constructor(
          o.type,
          o
        );
        tl = d, o.target.dispatchEvent(d), tl = null;
      } else
        return a = et(o), a !== null && df(a), n.blockedOn = o, !1;
      a.shift();
    }
    return !0;
  }
  function j0(n, a, o) {
    z0(n) && o.delete(a);
  }
  function sd() {
    od = !1, oo !== null && z0(oo) && (oo = null), Go !== null && z0(Go) && (Go = null), Yo !== null && z0(Yo) && (Yo = null), W0.forEach(j0), H0.forEach(j0);
  }
  function gh(n, a) {
    n.blockedOn === a && (n.blockedOn = null, od || (od = !0, s.unstable_scheduleCallback(
      s.unstable_NormalPriority,
      sd
    )));
  }
  var Ll = null;
  function ff(n) {
    Ll !== n && (Ll = n, s.unstable_scheduleCallback(
      s.unstable_NormalPriority,
      function() {
        Ll === n && (Ll = null);
        for (var a = 0; a < n.length; a += 3) {
          var o = n[a], d = n[a + 1], p = n[a + 2];
          if (typeof d != "function") {
            if (hf(d || o) === null)
              continue;
            break;
          }
          var g = et(o);
          g !== null && (n.splice(a, 3), a -= 3, y1(
            g,
            {
              pending: !0,
              data: p,
              method: o.method,
              action: d
            },
            d,
            p
          ));
        }
      }
    ));
  }
  function so(n) {
    function a(w) {
      return gh(w, n);
    }
    oo !== null && gh(oo, n), Go !== null && gh(Go, n), Yo !== null && gh(Yo, n), W0.forEach(a), H0.forEach(a);
    for (var o = 0; o < Js.length; o++) {
      var d = Js[o];
      d.blockedOn === n && (d.blockedOn = null);
    }
    for (; 0 < Js.length && (o = Js[0], o.blockedOn === null); )
      pf(o), o.blockedOn === null && Js.shift();
    if (o = (n.ownerDocument || n).$$reactFormReplay, o != null)
      for (d = 0; d < o.length; d += 3) {
        var p = o[d], g = o[d + 1], y = p[qn] || null;
        if (typeof g == "function")
          y || ff(o);
        else if (y) {
          var k = null;
          if (g && g.hasAttribute("formAction")) {
            if (p = g, y = g[qn] || null)
              k = y.formAction;
            else if (hf(p) !== null) continue;
          } else k = y.action;
          typeof k == "function" ? o[d + 1] = k : (o.splice(d, 3), d -= 3), ff(o);
        }
      }
  }
  function gf(n) {
    this._internalRoot = n;
  }
  vh.prototype.render = gf.prototype.render = function(n) {
    var a = this._internalRoot;
    if (a === null) throw Error(h(409));
    var o = a.current, d = Fa();
    lf(o, d, n, a, null, null);
  }, vh.prototype.unmount = gf.prototype.unmount = function() {
    var n = this._internalRoot;
    if (n !== null) {
      this._internalRoot = null;
      var a = n.containerInfo;
      lf(n.current, 2, null, n, null, null), Ql(), a[na] = null;
    }
  };
  function vh(n) {
    this._internalRoot = n;
  }
  vh.prototype.unstable_scheduleHydration = function(n) {
    if (n) {
      var a = is();
      n = { blockedOn: null, target: n, priority: a };
      for (var o = 0; o < Js.length && a !== 0 && a < Js[o].priority; o++) ;
      Js.splice(o, 0, n), o === 0 && pf(n);
    }
  };
  var vf = r.version;
  if (vf !== "19.1.0")
    throw Error(
      h(
        527,
        vf,
        "19.1.0"
      )
    );
  G.findDOMNode = function(n) {
    var a = n._reactInternals;
    if (a === void 0)
      throw typeof n.render == "function" ? Error(h(188)) : (n = Object.keys(n).join(","), Error(h(268, n)));
    return n = E(a), n = n !== null ? C(n) : null, n = n === null ? null : n.stateNode, n;
  };
  var Gi = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: O,
    reconcilerVersion: "19.1.0"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var P0 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!P0.isDisabled && P0.supportsFiber)
      try {
        ta = P0.inject(
          Gi
        ), jn = P0;
      } catch {
      }
  }
  return n2.createRoot = function(n, a) {
    if (!f(n)) throw Error(h(299));
    var o = !1, d = "", p = Zc, g = mp, y = S0, k = null;
    return a != null && (a.unstable_strictMode === !0 && (o = !0), a.identifierPrefix !== void 0 && (d = a.identifierPrefix), a.onUncaughtError !== void 0 && (p = a.onUncaughtError), a.onCaughtError !== void 0 && (g = a.onCaughtError), a.onRecoverableError !== void 0 && (y = a.onRecoverableError), a.unstable_transitionCallbacks !== void 0 && (k = a.unstable_transitionCallbacks)), a = of(
      n,
      1,
      !1,
      null,
      null,
      o,
      d,
      p,
      g,
      y,
      k,
      null
    ), n[na] = a.current, Kp(n), new gf(a);
  }, n2.hydrateRoot = function(n, a, o) {
    if (!f(n)) throw Error(h(299));
    var d = !1, p = "", g = Zc, y = mp, k = S0, w = null, K = null;
    return o != null && (o.unstable_strictMode === !0 && (d = !0), o.identifierPrefix !== void 0 && (p = o.identifierPrefix), o.onUncaughtError !== void 0 && (g = o.onUncaughtError), o.onCaughtError !== void 0 && (y = o.onCaughtError), o.onRecoverableError !== void 0 && (k = o.onRecoverableError), o.unstable_transitionCallbacks !== void 0 && (w = o.unstable_transitionCallbacks), o.formState !== void 0 && (K = o.formState)), a = of(
      n,
      1,
      !0,
      a,
      o ?? null,
      d,
      p,
      g,
      y,
      k,
      w,
      K
    ), a.context = sf(null), o = a.current, d = Fa(), d = Nn(d), p = sa(d), p.callback = null, Wr(o, p, d), o = d, a.current.lanes = o, ut(a, o), ma(a), n[na] = a.current, Kp(n), new vh(a);
  }, n2.version = "19.1.0", n2;
}
var i2 = {};
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var GE;
function gb() {
  return GE || (GE = 1, process.env.NODE_ENV !== "production" && function() {
    function s(e, t) {
      for (e = e.memoizedState; e !== null && 0 < t; )
        e = e.next, t--;
      return e;
    }
    function r(e, t, i, l) {
      if (i >= t.length) return l;
      var u = t[i], m = St(e) ? e.slice() : Ct({}, e);
      return m[u] = r(e[u], t, i + 1, l), m;
    }
    function c(e, t, i) {
      if (t.length === i.length) {
        for (var l = 0; l < i.length - 1; l++)
          if (t[l] !== i[l])
            return;
        return h(e, t, i, 0);
      }
    }
    function h(e, t, i, l) {
      var u = t[l], m = St(e) ? e.slice() : Ct({}, e);
      return l + 1 === t.length ? (m[i[l]] = m[u], St(m) ? m.splice(u, 1) : delete m[u]) : m[u] = h(
        e[u],
        t,
        i,
        l + 1
      ), m;
    }
    function f(e, t, i) {
      var l = t[i], u = St(e) ? e.slice() : Ct({}, e);
      return i + 1 === t.length ? (St(u) ? u.splice(l, 1) : delete u[l], u) : (u[l] = f(e[l], t, i + 1), u);
    }
    function v() {
      return !1;
    }
    function R() {
      return null;
    }
    function T() {
    }
    function E() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function C() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function N() {
    }
    function _(e) {
      var t = [];
      return e.forEach(function(i) {
        t.push(i);
      }), t.sort().join(", ");
    }
    function V(e, t, i, l) {
      return new Jd(e, t, i, l);
    }
    function B(e, t) {
      e.context === ld && (tn(e.current, 2, t, e, null, null), Vl());
    }
    function ce(e, t) {
      if (co !== null) {
        var i = t.staleFamilies;
        t = t.updatedFamilies, Oc(), Ld(
          e.current,
          t,
          i
        ), Vl();
      }
    }
    function oe(e) {
      co = e;
    }
    function be(e) {
      return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
    }
    function ge(e) {
      var t = e, i = e;
      if (e.alternate) for (; t.return; ) t = t.return;
      else {
        e = t;
        do
          t = e, (t.flags & 4098) !== 0 && (i = t.return), e = t.return;
        while (e);
      }
      return t.tag === 3 ? i : null;
    }
    function te(e) {
      if (e.tag === 13) {
        var t = e.memoizedState;
        if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
      }
      return null;
    }
    function _e(e) {
      if (ge(e) !== e)
        throw Error("Unable to find node on an unmounted component.");
    }
    function Ue(e) {
      var t = e.alternate;
      if (!t) {
        if (t = ge(e), t === null)
          throw Error("Unable to find node on an unmounted component.");
        return t !== e ? null : e;
      }
      for (var i = e, l = t; ; ) {
        var u = i.return;
        if (u === null) break;
        var m = u.alternate;
        if (m === null) {
          if (l = u.return, l !== null) {
            i = l;
            continue;
          }
          break;
        }
        if (u.child === m.child) {
          for (m = u.child; m; ) {
            if (m === i) return _e(u), e;
            if (m === l) return _e(u), t;
            m = m.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (i.return !== l.return) i = u, l = m;
        else {
          for (var S = !1, U = u.child; U; ) {
            if (U === i) {
              S = !0, i = u, l = m;
              break;
            }
            if (U === l) {
              S = !0, l = u, i = m;
              break;
            }
            U = U.sibling;
          }
          if (!S) {
            for (U = m.child; U; ) {
              if (U === i) {
                S = !0, i = m, l = u;
                break;
              }
              if (U === l) {
                S = !0, l = m, i = u;
                break;
              }
              U = U.sibling;
            }
            if (!S)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (i.alternate !== l)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (i.tag !== 3)
        throw Error("Unable to find node on an unmounted component.");
      return i.stateNode.current === i ? e : t;
    }
    function j(e) {
      var t = e.tag;
      if (t === 5 || t === 26 || t === 27 || t === 6) return e;
      for (e = e.child; e !== null; ) {
        if (t = j(e), t !== null) return t;
        e = e.sibling;
      }
      return null;
    }
    function Te(e) {
      return e === null || typeof e != "object" ? null : (e = $p && e[$p] || e["@@iterator"], typeof e == "function" ? e : null);
    }
    function Ne(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === ih ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case Ut:
          return "Fragment";
        case Xc:
          return "Profiler";
        case Yc:
          return "StrictMode";
        case Kc:
          return "Suspense";
        case Os:
          return "SuspenseList";
        case qp:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case wl:
            return "Portal";
          case $a:
            return (e.displayName || "Context") + ".Provider";
          case nh:
            return (e._context.displayName || "Context") + ".Consumer";
          case Wo:
            var t = e.render;
            return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case Z0:
            return t = e.displayName || null, t !== null ? t : Ne(e.type) || "Memo";
          case ka:
            t = e._payload, e = e._init;
            try {
              return Ne(e(t));
            } catch {
            }
        }
      return null;
    }
    function xe(e) {
      return typeof e.tag == "number" ? Fe(e) : typeof e.name == "string" ? e.name : null;
    }
    function Fe(e) {
      var t = e.type;
      switch (e.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (t._context.displayName || "Context") + ".Consumer";
        case 10:
          return (t.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return t;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return Ne(t);
        case 8:
          return t === Yc ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if (typeof t == "function")
            return t.displayName || t.name || null;
          if (typeof t == "string") return t;
          break;
        case 29:
          if (t = e._debugInfo, t != null) {
            for (var i = t.length - 1; 0 <= i; i--)
              if (typeof t[i].name == "string") return t[i].name;
          }
          if (e.return !== null)
            return Fe(e.return);
      }
      return null;
    }
    function ye(e) {
      return { current: e };
    }
    function Ve(e, t) {
      0 > er ? console.error("Unexpected pop.") : (t !== w0[er] && console.error("Unexpected Fiber popped."), e.current = O0[er], O0[er] = null, w0[er] = null, er--);
    }
    function we(e, t, i) {
      er++, O0[er] = e.current, w0[er] = i, e.current = t;
    }
    function Oe(e) {
      return e === null && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      ), e;
    }
    function Ie(e, t) {
      we(ao, t, e), we(qc, e, e), we(Ho, null, e);
      var i = t.nodeType;
      switch (i) {
        case 9:
        case 11:
          i = i === 9 ? "#document" : "#fragment", t = (t = t.documentElement) && (t = t.namespaceURI) ? en(t) : Kl;
          break;
        default:
          if (i = t.tagName, t = t.namespaceURI)
            t = en(t), t = ua(
              t,
              i
            );
          else
            switch (i) {
              case "svg":
                t = zh;
                break;
              case "math":
                t = iv;
                break;
              default:
                t = Kl;
            }
      }
      i = i.toLowerCase(), i = mm(null, i), i = {
        context: t,
        ancestorInfo: i
      }, Ve(Ho, e), we(Ho, i, e);
    }
    function he(e) {
      Ve(Ho, e), Ve(qc, e), Ve(ao, e);
    }
    function O() {
      return Oe(Ho.current);
    }
    function G(e) {
      e.memoizedState !== null && we($c, e, e);
      var t = Oe(Ho.current), i = e.type, l = ua(t.context, i);
      i = mm(t.ancestorInfo, i), l = { context: l, ancestorInfo: i }, t !== l && (we(qc, e, e), we(Ho, l, e));
    }
    function se(e) {
      qc.current === e && (Ve(Ho, e), Ve(qc, e)), $c.current === e && (Ve($c, e), Yf._currentValue = uu);
    }
    function De(e) {
      return typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
    }
    function M(e) {
      try {
        return W(e), !1;
      } catch {
        return !0;
      }
    }
    function W(e) {
      return "" + e;
    }
    function q(e, t) {
      if (M(e))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          t,
          De(e)
        ), W(e);
    }
    function Re(e, t) {
      if (M(e))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          t,
          De(e)
        ), W(e);
    }
    function $(e) {
      if (M(e))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          De(e)
        ), W(e);
    }
    function Be(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled) return !0;
      if (!t.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), !0;
      try {
        Bs = t.inject(e), Ei = t;
      } catch (i) {
        console.error("React instrumentation encountered an error: %s.", i);
      }
      return !!t.checkDCE;
    }
    function Ce(e) {
      if (typeof RS == "function" && Ur(e), Ei && typeof Ei.setStrictMode == "function")
        try {
          Ei.setStrictMode(Bs, e);
        } catch (t) {
          pa || (pa = !0, console.error(
            "React instrumentation encountered an error: %s",
            t
          ));
        }
    }
    function It(e) {
      ze = e;
    }
    function Pe() {
      ze !== null && typeof ze.markCommitStopped == "function" && ze.markCommitStopped();
    }
    function dt(e) {
      ze !== null && typeof ze.markComponentRenderStarted == "function" && ze.markComponentRenderStarted(e);
    }
    function dn() {
      ze !== null && typeof ze.markComponentRenderStopped == "function" && ze.markComponentRenderStopped();
    }
    function xn(e) {
      ze !== null && typeof ze.markRenderStarted == "function" && ze.markRenderStarted(e);
    }
    function Yt() {
      ze !== null && typeof ze.markRenderStopped == "function" && ze.markRenderStopped();
    }
    function hn(e, t) {
      ze !== null && typeof ze.markStateUpdateScheduled == "function" && ze.markStateUpdateScheduled(e, t);
    }
    function Aa(e) {
      return e >>>= 0, e === 0 ? 32 : 31 - (oh(e) / jo | 0) | 0;
    }
    function sr(e) {
      if (e & 1) return "SyncHydrationLane";
      if (e & 2) return "Sync";
      if (e & 4) return "InputContinuousHydration";
      if (e & 8) return "InputContinuous";
      if (e & 16) return "DefaultHydration";
      if (e & 32) return "Default";
      if (e & 128) return "TransitionHydration";
      if (e & 4194048) return "Transition";
      if (e & 62914560) return "Retry";
      if (e & 67108864) return "SelectiveHydration";
      if (e & 134217728) return "IdleHydration";
      if (e & 268435456) return "Idle";
      if (e & 536870912) return "Offscreen";
      if (e & 1073741824) return "Deferred";
    }
    function Tn(e) {
      var t = e & 42;
      if (t !== 0) return t;
      switch (e & -e) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return e & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return e & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), e;
      }
    }
    function yn(e, t, i) {
      var l = e.pendingLanes;
      if (l === 0) return 0;
      var u = 0, m = e.suspendedLanes, S = e.pingedLanes;
      e = e.warmLanes;
      var U = l & 134217727;
      return U !== 0 ? (l = U & ~m, l !== 0 ? u = Tn(l) : (S &= U, S !== 0 ? u = Tn(S) : i || (i = U & ~e, i !== 0 && (u = Tn(i))))) : (U = l & ~m, U !== 0 ? u = Tn(U) : S !== 0 ? u = Tn(S) : i || (i = l & ~e, i !== 0 && (u = Tn(i)))), u === 0 ? 0 : t !== 0 && t !== u && (t & m) === 0 && (m = u & -u, i = t & -t, m >= i || m === 32 && (i & 4194048) !== 0) ? t : u;
    }
    function Bt(e, t) {
      return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
    }
    function Vr(e, t) {
      switch (e) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return t + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return t + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function vt() {
      var e = sh;
      return sh <<= 1, (sh & 4194048) === 0 && (sh = 256), e;
    }
    function ea() {
      var e = lh;
      return lh <<= 1, (lh & 62914560) === 0 && (lh = 4194304), e;
    }
    function Ci(e) {
      for (var t = [], i = 0; 31 > i; i++) t.push(e);
      return t;
    }
    function Ta(e, t) {
      e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
    }
    function Vi(e, t, i, l, u, m) {
      var S = e.pendingLanes;
      e.pendingLanes = i, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= i, e.entangledLanes &= i, e.errorRecoveryDisabledLanes &= i, e.shellSuspendCounter = 0;
      var U = e.entanglements, D = e.expirationTimes, Q = e.hiddenUpdates;
      for (i = S & ~i; 0 < i; ) {
        var ae = 31 - Qi(i), ue = 1 << ae;
        U[ae] = 0, D[ae] = -1;
        var ee = Q[ae];
        if (ee !== null)
          for (Q[ae] = null, ae = 0; ae < ee.length; ae++) {
            var me = ee[ae];
            me !== null && (me.lane &= -536870913);
          }
        i &= ~ue;
      }
      l !== 0 && Uo(e, l, 0), m !== 0 && u === 0 && e.tag !== 0 && (e.suspendedLanes |= m & ~(S & ~t));
    }
    function Uo(e, t, i) {
      e.pendingLanes |= t, e.suspendedLanes &= ~t;
      var l = 31 - Qi(t);
      e.entangledLanes |= t, e.entanglements[l] = e.entanglements[l] | 1073741824 | i & 4194090;
    }
    function ta(e, t) {
      var i = e.entangledLanes |= t;
      for (e = e.entanglements; i; ) {
        var l = 31 - Qi(i), u = 1 << l;
        u & t | e[l] & t && (e[l] |= t), i &= ~u;
      }
    }
    function jn(e) {
      switch (e) {
        case 2:
          e = 1;
          break;
        case 8:
          e = 4;
          break;
        case 32:
          e = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          e = 128;
          break;
        case 268435456:
          e = 134217728;
          break;
        default:
          e = 0;
      }
      return e;
    }
    function _i(e, t, i) {
      if (Jn)
        for (e = e.pendingUpdatersLaneMap; 0 < i; ) {
          var l = 31 - Qi(i), u = 1 << l;
          e[l].add(t), i &= ~u;
        }
    }
    function Pn(e, t) {
      if (Jn)
        for (var i = e.pendingUpdatersLaneMap, l = e.memoizedUpdaters; 0 < t; ) {
          var u = 31 - Qi(t);
          e = 1 << u, u = i[u], 0 < u.size && (u.forEach(function(m) {
            var S = m.alternate;
            S !== null && l.has(S) || l.add(m);
          }), u.clear()), t &= ~e;
        }
    }
    function _r(e) {
      return e &= -e, Ui < e ? Tr < e ? (e & 134217727) !== 0 ? Po : ch : Tr : Ui;
    }
    function To() {
      var e = pt.p;
      return e !== 0 ? e : (e = window.event, e === void 0 ? Po : eh(e.type));
    }
    function Fr(e, t) {
      var i = pt.p;
      try {
        return pt.p = e, t();
      } finally {
        pt.p = i;
      }
    }
    function Ii(e) {
      delete e[xi], delete e[fa], delete e[ef], delete e[Sg], delete e[td];
    }
    function oi(e) {
      var t = e[xi];
      if (t) return t;
      for (var i = e.parentNode; i; ) {
        if (t = i[Is] || i[xi]) {
          if (i = t.alternate, t.child !== null || i !== null && i.child !== null)
            for (e = zc(e); e !== null; ) {
              if (i = e[xi])
                return i;
              e = zc(e);
            }
          return t;
        }
        e = i, i = e.parentNode;
      }
      return null;
    }
    function Mn(e) {
      if (e = e[xi] || e[Is]) {
        var t = e.tag;
        if (t === 5 || t === 6 || t === 13 || t === 26 || t === 27 || t === 3)
          return e;
      }
      return null;
    }
    function Li(e) {
      var t = e.tag;
      if (t === 5 || t === 26 || t === 27 || t === 6)
        return e.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function F(e) {
      var t = e[nd];
      return t || (t = e[nd] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
    }
    function z(e) {
      e[id] = !0;
    }
    function Ze(e, t) {
      Ae(e, t), Ae(e + "Capture", t);
    }
    function Ae(e, t) {
      tr[e] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        e
      ), tr[e] = t;
      var i = e.toLowerCase();
      for (Bl[i] = e, e === "onDoubleClick" && (Bl.ondblclick = e), e = 0; e < t.length; e++)
        Rg.add(t[e]);
    }
    function Ye(e, t) {
      Eg[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || console.error(
        e === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ), t.onChange || t.readOnly || t.disabled || t.checked == null || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function ut(e) {
      return zo.call(hh, e) ? !0 : zo.call(uh, e) ? !1 : dh.test(e) ? hh[e] = !0 : (uh[e] = !0, console.error("Invalid attribute name: `%s`", e), !1);
    }
    function gt(e, t, i) {
      if (ut(t)) {
        if (!e.hasAttribute(t)) {
          switch (typeof i) {
            case "symbol":
            case "object":
              return i;
            case "function":
              return i;
            case "boolean":
              if (i === !1) return i;
          }
          return i === void 0 ? void 0 : null;
        }
        return e = e.getAttribute(t), e === "" && i === !0 ? !0 : (q(i, t), e === "" + i ? i : e);
      }
    }
    function Vt(e, t, i) {
      if (ut(t))
        if (i === null) e.removeAttribute(t);
        else {
          switch (typeof i) {
            case "undefined":
            case "function":
            case "symbol":
              e.removeAttribute(t);
              return;
            case "boolean":
              var l = t.toLowerCase().slice(0, 5);
              if (l !== "data-" && l !== "aria-") {
                e.removeAttribute(t);
                return;
              }
          }
          q(i, t), e.setAttribute(t, "" + i);
        }
    }
    function ht(e, t, i) {
      if (i === null) e.removeAttribute(t);
      else {
        switch (typeof i) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            e.removeAttribute(t);
            return;
        }
        q(i, t), e.setAttribute(t, "" + i);
      }
    }
    function Nn(e, t, i, l) {
      if (l === null) e.removeAttribute(i);
      else {
        switch (typeof l) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            e.removeAttribute(i);
            return;
        }
        q(l, i), e.setAttributeNS(t, i, "" + l);
      }
    }
    function Ji() {
    }
    function is() {
      if (Ls === 0) {
        tf = console.log, nf = console.info, Ug = console.warn, af = console.error, ad = console.group, Tg = console.groupCollapsed, yg = console.groupEnd;
        var e = {
          configurable: !0,
          enumerable: !0,
          value: Ji,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }
      Ls++;
    }
    function yo() {
      if (Ls--, Ls === 0) {
        var e = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: Ct({}, e, { value: tf }),
          info: Ct({}, e, { value: nf }),
          warn: Ct({}, e, { value: Ug }),
          error: Ct({}, e, { value: af }),
          group: Ct({}, e, { value: ad }),
          groupCollapsed: Ct({}, e, { value: Tg }),
          groupEnd: Ct({}, e, { value: yg })
        });
      }
      0 > Ls && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function gn(e) {
      if (rf === void 0)
        try {
          throw Error();
        } catch (i) {
          var t = i.stack.trim().match(/\n( *(at )?)/);
          rf = t && t[1] || "", I0 = -1 < i.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < i.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + rf + e + I0;
    }
    function rn(e, t) {
      if (!e || rd) return "";
      var i = L0.get(e);
      if (i !== void 0) return i;
      rd = !0, i = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var l = null;
      l = le.H, le.H = null, is();
      try {
        var u = {
          DetermineComponentFrameRoot: function() {
            try {
              if (t) {
                var ee = function() {
                  throw Error();
                };
                if (Object.defineProperty(ee.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(ee, []);
                  } catch (qe) {
                    var me = qe;
                  }
                  Reflect.construct(e, [], ee);
                } else {
                  try {
                    ee.call();
                  } catch (qe) {
                    me = qe;
                  }
                  e.call(ee.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (qe) {
                  me = qe;
                }
                (ee = e()) && typeof ee.catch == "function" && ee.catch(function() {
                });
              }
            } catch (qe) {
              if (qe && me && typeof qe.stack == "string")
                return [qe.stack, me.stack];
            }
            return [null, null];
          }
        };
        u.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var m = Object.getOwnPropertyDescriptor(
          u.DetermineComponentFrameRoot,
          "name"
        );
        m && m.configurable && Object.defineProperty(
          u.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var S = u.DetermineComponentFrameRoot(), U = S[0], D = S[1];
        if (U && D) {
          var Q = U.split(`
`), ae = D.split(`
`);
          for (S = m = 0; m < Q.length && !Q[m].includes(
            "DetermineComponentFrameRoot"
          ); )
            m++;
          for (; S < ae.length && !ae[S].includes(
            "DetermineComponentFrameRoot"
          ); )
            S++;
          if (m === Q.length || S === ae.length)
            for (m = Q.length - 1, S = ae.length - 1; 1 <= m && 0 <= S && Q[m] !== ae[S]; )
              S--;
          for (; 1 <= m && 0 <= S; m--, S--)
            if (Q[m] !== ae[S]) {
              if (m !== 1 || S !== 1)
                do
                  if (m--, S--, 0 > S || Q[m] !== ae[S]) {
                    var ue = `
` + Q[m].replace(
                      " at new ",
                      " at "
                    );
                    return e.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", e.displayName)), typeof e == "function" && L0.set(e, ue), ue;
                  }
                while (1 <= m && 0 <= S);
              break;
            }
        }
      } finally {
        rd = !1, le.H = l, yo(), Error.prepareStackTrace = i;
      }
      return Q = (Q = e ? e.displayName || e.name : "") ? gn(Q) : "", typeof e == "function" && L0.set(e, Q), Q;
    }
    function qn(e) {
      var t = Error.prepareStackTrace;
      if (Error.prepareStackTrace = void 0, e = e.stack, Error.prepareStackTrace = t, e.startsWith(`Error: react-stack-top-frame
`) && (e = e.slice(29)), t = e.indexOf(`
`), t !== -1 && (e = e.slice(t + 1)), t = e.indexOf("react-stack-bottom-frame"), t !== -1 && (t = e.lastIndexOf(
        `
`,
        t
      )), t !== -1)
        e = e.slice(0, t);
      else return "";
      return e;
    }
    function na(e) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return gn(e.type);
        case 16:
          return gn("Lazy");
        case 13:
          return gn("Suspense");
        case 19:
          return gn("SuspenseList");
        case 0:
        case 15:
          return rn(e.type, !1);
        case 11:
          return rn(e.type.render, !1);
        case 1:
          return rn(e.type, !0);
        case 31:
          return gn("Activity");
        default:
          return "";
      }
    }
    function as(e) {
      try {
        var t = "";
        do {
          t += na(e);
          var i = e._debugInfo;
          if (i)
            for (var l = i.length - 1; 0 <= l; l--) {
              var u = i[l];
              if (typeof u.name == "string") {
                var m = t, S = u.env, U = gn(
                  u.name + (S ? " [" + S + "]" : "")
                );
                t = m + U;
              }
            }
          e = e.return;
        } while (e);
        return t;
      } catch (D) {
        return `
Error generating stack: ` + D.message + `
` + D.stack;
      }
    }
    function Z(e) {
      return (e = e ? e.displayName || e.name : "") ? gn(e) : "";
    }
    function H() {
      if (Da === null) return null;
      var e = Da._debugOwner;
      return e != null ? xe(e) : null;
    }
    function Me() {
      if (Da === null) return "";
      var e = Da;
      try {
        var t = "";
        switch (e.tag === 6 && (e = e.return), e.tag) {
          case 26:
          case 27:
          case 5:
            t += gn(e.type);
            break;
          case 13:
            t += gn("Suspense");
            break;
          case 19:
            t += gn("SuspenseList");
            break;
          case 31:
            t += gn("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            e._debugOwner || t !== "" || (t += Z(
              e.type
            ));
            break;
          case 11:
            e._debugOwner || t !== "" || (t += Z(
              e.type.render
            ));
        }
        for (; e; )
          if (typeof e.tag == "number") {
            var i = e;
            e = i._debugOwner;
            var l = i._debugStack;
            e && l && (typeof l != "string" && (i._debugStack = l = qn(l)), l !== "" && (t += `
` + l));
          } else if (e.debugStack != null) {
            var u = e.debugStack;
            (e = e.owner) && u && (t += `
` + qn(u));
          } else break;
        var m = t;
      } catch (S) {
        m = `
Error generating stack: ` + S.message + `
` + S.stack;
      }
      return m;
    }
    function pe(e, t, i, l, u, m, S) {
      var U = Da;
      mt(e);
      try {
        return e !== null && e._debugTask ? e._debugTask.run(
          t.bind(null, i, l, u, m, S)
        ) : t(i, l, u, m, S);
      } finally {
        mt(U);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function mt(e) {
      le.getCurrentStack = e === null ? null : Me, ga = !1, Da = e;
    }
    function tt(e) {
      switch (typeof e) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return $(e), e;
        default:
          return "";
      }
    }
    function et(e) {
      var t = e.type;
      return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
    }
    function _t(e) {
      var t = et(e) ? "checked" : "value", i = Object.getOwnPropertyDescriptor(
        e.constructor.prototype,
        t
      );
      $(e[t]);
      var l = "" + e[t];
      if (!e.hasOwnProperty(t) && typeof i < "u" && typeof i.get == "function" && typeof i.set == "function") {
        var u = i.get, m = i.set;
        return Object.defineProperty(e, t, {
          configurable: !0,
          get: function() {
            return u.call(this);
          },
          set: function(S) {
            $(S), l = "" + S, m.call(this, S);
          }
        }), Object.defineProperty(e, t, {
          enumerable: i.enumerable
        }), {
          getValue: function() {
            return l;
          },
          setValue: function(S) {
            $(S), l = "" + S;
          },
          stopTracking: function() {
            e._valueTracker = null, delete e[t];
          }
        };
      }
    }
    function Xt(e) {
      e._valueTracker || (e._valueTracker = _t(e));
    }
    function vn(e) {
      if (!e) return !1;
      var t = e._valueTracker;
      if (!t) return !0;
      var i = t.getValue(), l = "";
      return e && (l = et(e) ? e.checked ? "true" : "false" : e.value), e = l, e !== i ? (t.setValue(e), !0) : !1;
    }
    function kd(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    function ya(e) {
      return e.replace(
        ES,
        function(t) {
          return "\\" + t.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function rs(e, t) {
      t.checked === void 0 || t.defaultChecked === void 0 || sf || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        H() || "A component",
        t.type
      ), sf = !0), t.value === void 0 || t.defaultValue === void 0 || of || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        H() || "A component",
        t.type
      ), of = !0);
    }
    function os(e, t, i, l, u, m, S, U) {
      e.name = "", S != null && typeof S != "function" && typeof S != "symbol" && typeof S != "boolean" ? (q(S, "type"), e.type = S) : e.removeAttribute("type"), t != null ? S === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + tt(t)) : e.value !== "" + tt(t) && (e.value = "" + tt(t)) : S !== "submit" && S !== "reset" || e.removeAttribute("value"), t != null ? _u(e, S, tt(t)) : i != null ? _u(e, S, tt(i)) : l != null && e.removeAttribute("value"), u == null && m != null && (e.defaultChecked = !!m), u != null && (e.checked = u && typeof u != "function" && typeof u != "symbol"), U != null && typeof U != "function" && typeof U != "symbol" && typeof U != "boolean" ? (q(U, "name"), e.name = "" + tt(U)) : e.removeAttribute("name");
    }
    function T2(e, t, i, l, u, m, S, U) {
      if (m != null && typeof m != "function" && typeof m != "symbol" && typeof m != "boolean" && (q(m, "type"), e.type = m), t != null || i != null) {
        if (!(m !== "submit" && m !== "reset" || t != null))
          return;
        i = i != null ? "" + tt(i) : "", t = t != null ? "" + tt(t) : i, U || t === e.value || (e.value = t), e.defaultValue = t;
      }
      l = l ?? u, l = typeof l != "function" && typeof l != "symbol" && !!l, e.checked = U ? e.checked : !!l, e.defaultChecked = !!l, S != null && typeof S != "function" && typeof S != "symbol" && typeof S != "boolean" && (q(S, "name"), e.name = S);
    }
    function _u(e, t, i) {
      t === "number" && kd(e.ownerDocument) === e || e.defaultValue === "" + i || (e.defaultValue = "" + i);
    }
    function cm(e, t) {
      t.value == null && (typeof t.children == "object" && t.children !== null ? Q0.Children.forEach(t.children, function(i) {
        i == null || typeof i == "string" || typeof i == "number" || typeof i == "bigint" || cf || (cf = !0, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : t.dangerouslySetInnerHTML == null || mh || (mh = !0, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      ))), t.selected == null || lf || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), lf = !0);
    }
    function y2() {
      var e = H();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    function No(e, t, i, l) {
      if (e = e.options, t) {
        t = {};
        for (var u = 0; u < i.length; u++)
          t["$" + i[u]] = !0;
        for (i = 0; i < e.length; i++)
          u = t.hasOwnProperty("$" + e[i].value), e[i].selected !== u && (e[i].selected = u), u && l && (e[i].defaultSelected = !0);
      } else {
        for (i = "" + tt(i), t = null, u = 0; u < e.length; u++) {
          if (e[u].value === i) {
            e[u].selected = !0, l && (e[u].defaultSelected = !0);
            return;
          }
          t !== null || e[u].disabled || (t = e[u]);
        }
        t !== null && (t.selected = !0);
      }
    }
    function Dd(e, t) {
      for (e = 0; e < J0.length; e++) {
        var i = J0[e];
        if (t[i] != null) {
          var l = St(t[i]);
          t.multiple && !l ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            i,
            y2()
          ) : !t.multiple && l && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            i,
            y2()
          );
        }
      }
      t.value === void 0 || t.defaultValue === void 0 || df || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), df = !0);
    }
    function Mr(e, t) {
      t.value === void 0 || t.defaultValue === void 0 || Ng || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        H() || "A component"
      ), Ng = !0), t.children != null && t.value == null && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function Fu(e, t, i) {
      if (t != null && (t = "" + tt(t), t !== e.value && (e.value = t), i == null)) {
        e.defaultValue !== t && (e.defaultValue = t);
        return;
      }
      e.defaultValue = i != null ? "" + tt(i) : "";
    }
    function dm(e, t, i, l) {
      if (t == null) {
        if (l != null) {
          if (i != null)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (St(l)) {
            if (1 < l.length)
              throw Error("<textarea> can only have at most one child.");
            l = l[0];
          }
          i = l;
        }
        i == null && (i = ""), t = i;
      }
      i = tt(t), e.defaultValue = i, l = e.textContent, l === i && l !== "" && l !== null && (e.value = l);
    }
    function Xs(e, t) {
      return e.serverProps === void 0 && e.serverTail.length === 0 && e.children.length === 1 && 3 < e.distanceFromLeaf && e.distanceFromLeaf > 15 - t ? Xs(e.children[0], t) : e;
    }
    function Wi(e) {
      return "  " + "  ".repeat(e);
    }
    function ss(e) {
      return "+ " + "  ".repeat(e);
    }
    function Ks(e) {
      return "- " + "  ".repeat(e);
    }
    function um(e) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return e.type;
        case 16:
          return "Lazy";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return e = e.type, e.displayName || e.name || null;
        case 11:
          return e = e.type.render, e.displayName || e.name || null;
        case 1:
          return e = e.type, e.displayName || e.name || null;
        default:
          return null;
      }
    }
    function Fi(e, t) {
      return bg.test(e) ? (e = JSON.stringify(e), e.length > t - 2 ? 8 > t ? '{"..."}' : "{" + e.slice(0, t - 7) + '..."}' : "{" + e + "}") : e.length > t ? 5 > t ? '{"..."}' : e.slice(0, t - 3) + "..." : e;
    }
    function Qd(e, t, i) {
      var l = 120 - 2 * i;
      if (t === null)
        return ss(i) + Fi(e, l) + `
`;
      if (typeof t == "string") {
        for (var u = 0; u < t.length && u < e.length && t.charCodeAt(u) === e.charCodeAt(u); u++) ;
        return u > l - 8 && 10 < u && (e = "..." + e.slice(u - 8), t = "..." + t.slice(u - 8)), ss(i) + Fi(e, l) + `
` + Ks(i) + Fi(t, l) + `
`;
      }
      return Wi(i) + Fi(e, l) + `
`;
    }
    function hm(e) {
      return Object.prototype.toString.call(e).replace(/^\[object (.*)\]$/, function(t, i) {
        return i;
      });
    }
    function ls(e, t) {
      switch (typeof e) {
        case "string":
          return e = JSON.stringify(e), e.length > t ? 5 > t ? '"..."' : e.slice(0, t - 4) + '..."' : e;
        case "object":
          if (e === null) return "null";
          if (St(e)) return "[...]";
          if (e.$$typeof === Zs)
            return (t = Ne(e.type)) ? "<" + t + ">" : "<...>";
          var i = hm(e);
          if (i === "Object") {
            i = "", t -= 2;
            for (var l in e)
              if (e.hasOwnProperty(l)) {
                var u = JSON.stringify(l);
                if (u !== '"' + l + '"' && (l = u), t -= l.length - 2, u = ls(
                  e[l],
                  15 > t ? t : 15
                ), t -= u.length, 0 > t) {
                  i += i === "" ? "..." : ", ...";
                  break;
                }
                i += (i === "" ? "" : ",") + l + ":" + u;
              }
            return "{" + i + "}";
          }
          return i;
        case "function":
          return (t = e.displayName || e.name) ? "function " + t : "function";
        default:
          return String(e);
      }
    }
    function qs(e, t) {
      return typeof e != "string" || bg.test(e) ? "{" + ls(e, t - 2) + "}" : e.length > t - 2 ? 5 > t ? '"..."' : '"' + e.slice(0, t - 5) + '..."' : '"' + e + '"';
    }
    function cc(e, t, i) {
      var l = 120 - i.length - e.length, u = [], m;
      for (m in t)
        if (t.hasOwnProperty(m) && m !== "children") {
          var S = qs(
            t[m],
            120 - i.length - m.length - 1
          );
          l -= m.length + S.length + 2, u.push(m + "=" + S);
        }
      return u.length === 0 ? i + "<" + e + `>
` : 0 < l ? i + "<" + e + " " + u.join(" ") + `>
` : i + "<" + e + `
` + i + "  " + u.join(`
` + i + "  ") + `
` + i + `>
`;
    }
    function nS(e, t, i) {
      var l = "", u = Ct({}, t), m;
      for (m in e)
        if (e.hasOwnProperty(m)) {
          delete u[m];
          var S = 120 - 2 * i - m.length - 2, U = ls(e[m], S);
          t.hasOwnProperty(m) ? (S = ls(t[m], S), l += ss(i) + m + ": " + U + `
`, l += Ks(i) + m + ": " + S + `
`) : l += ss(i) + m + ": " + U + `
`;
        }
      for (var D in u)
        u.hasOwnProperty(D) && (e = ls(
          u[D],
          120 - 2 * i - D.length - 2
        ), l += Ks(i) + D + ": " + e + `
`);
      return l;
    }
    function Ia(e, t, i, l) {
      var u = "", m = /* @__PURE__ */ new Map();
      for (Q in i)
        i.hasOwnProperty(Q) && m.set(
          Q.toLowerCase(),
          Q
        );
      if (m.size === 1 && m.has("children"))
        u += cc(
          e,
          t,
          Wi(l)
        );
      else {
        for (var S in t)
          if (t.hasOwnProperty(S) && S !== "children") {
            var U = 120 - 2 * (l + 1) - S.length - 1, D = m.get(S.toLowerCase());
            if (D !== void 0) {
              m.delete(S.toLowerCase());
              var Q = t[S];
              D = i[D];
              var ae = qs(
                Q,
                U
              );
              U = qs(
                D,
                U
              ), typeof Q == "object" && Q !== null && typeof D == "object" && D !== null && hm(Q) === "Object" && hm(D) === "Object" && (2 < Object.keys(Q).length || 2 < Object.keys(D).length || -1 < ae.indexOf("...") || -1 < U.indexOf("...")) ? u += Wi(l + 1) + S + `={{
` + nS(
                Q,
                D,
                l + 2
              ) + Wi(l + 1) + `}}
` : (u += ss(l + 1) + S + "=" + ae + `
`, u += Ks(l + 1) + S + "=" + U + `
`);
            } else
              u += Wi(l + 1) + S + "=" + qs(t[S], U) + `
`;
          }
        m.forEach(function(ue) {
          if (ue !== "children") {
            var ee = 120 - 2 * (l + 1) - ue.length - 1;
            u += Ks(l + 1) + ue + "=" + qs(i[ue], ee) + `
`;
          }
        }), u = u === "" ? Wi(l) + "<" + e + `>
` : Wi(l) + "<" + e + `
` + u + Wi(l) + `>
`;
      }
      return e = i.children, t = t.children, typeof e == "string" || typeof e == "number" || typeof e == "bigint" ? (m = "", (typeof t == "string" || typeof t == "number" || typeof t == "bigint") && (m = "" + t), u += Qd(m, "" + e, l + 1)) : (typeof t == "string" || typeof t == "number" || typeof t == "bigint") && (u = e == null ? u + Qd("" + t, null, l + 1) : u + Qd("" + t, void 0, l + 1)), u;
    }
    function Mu(e, t) {
      var i = um(e);
      if (i === null) {
        for (i = "", e = e.child; e; )
          i += Mu(e, t), e = e.sibling;
        return i;
      }
      return Wi(t) + "<" + i + `>
`;
    }
    function ku(e, t) {
      var i = Xs(e, t);
      if (i !== e && (e.children.length !== 1 || e.children[0] !== i))
        return Wi(t) + `...
` + ku(i, t + 1);
      i = "";
      var l = e.fiber._debugInfo;
      if (l)
        for (var u = 0; u < l.length; u++) {
          var m = l[u].name;
          typeof m == "string" && (i += Wi(t) + "<" + m + `>
`, t++);
        }
      if (l = "", u = e.fiber.pendingProps, e.fiber.tag === 6)
        l = Qd(u, e.serverProps, t), t++;
      else if (m = um(e.fiber), m !== null)
        if (e.serverProps === void 0) {
          l = t;
          var S = 120 - 2 * l - m.length - 2, U = "";
          for (Q in u)
            if (u.hasOwnProperty(Q) && Q !== "children") {
              var D = qs(u[Q], 15);
              if (S -= Q.length + D.length + 2, 0 > S) {
                U += " ...";
                break;
              }
              U += " " + Q + "=" + D;
            }
          l = Wi(l) + "<" + m + U + `>
`, t++;
        } else
          e.serverProps === null ? (l = cc(
            m,
            u,
            ss(t)
          ), t++) : typeof e.serverProps == "string" ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (l = Ia(
            m,
            u,
            e.serverProps,
            t
          ), t++);
      var Q = "";
      for (u = e.fiber.child, m = 0; u && m < e.children.length; )
        S = e.children[m], S.fiber === u ? (Q += ku(S, t), m++) : Q += Mu(u, t), u = u.sibling;
      for (u && 0 < e.children.length && (Q += Wi(t) + `...
`), u = e.serverTail, e.serverProps === null && t--, e = 0; e < u.length; e++)
        m = u[e], Q = typeof m == "string" ? Q + (Ks(t) + Fi(m, 120 - 2 * t) + `
`) : Q + cc(
          m.type,
          m.props,
          Ks(t)
        );
      return i + l + Q;
    }
    function xd(e) {
      try {
        return `

` + ku(e, 0);
      } catch {
        return "";
      }
    }
    function $s(e, t, i) {
      for (var l = t, u = null, m = 0; l; )
        l === e && (m = 0), u = {
          fiber: l,
          children: u !== null ? [u] : [],
          serverProps: l === t ? i : l === e ? null : void 0,
          serverTail: [],
          distanceFromLeaf: m
        }, m++, l = l.return;
      return u !== null ? xd(u).replaceAll(/^[+-]/gm, ">") : "";
    }
    function mm(e, t) {
      var i = Ct({}, e || mf), l = { tag: t };
      return ph.indexOf(t) !== -1 && (i.aTagInScope = null, i.buttonTagInScope = null, i.nobrTagInScope = null), fh.indexOf(t) !== -1 && (i.pTagInButtonScope = null), uf.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (i.listItemTagAutoclosing = null, i.dlItemTagAutoclosing = null), i.current = l, t === "form" && (i.formTag = l), t === "a" && (i.aTagInScope = l), t === "button" && (i.buttonTagInScope = l), t === "nobr" && (i.nobrTagInScope = l), t === "p" && (i.pTagInButtonScope = l), t === "li" && (i.listItemTagAutoclosing = l), (t === "dd" || t === "dt") && (i.dlItemTagAutoclosing = l), t === "#document" || t === "html" ? i.containerTagInScope = null : i.containerTagInScope || (i.containerTagInScope = l), e !== null || t !== "#document" && t !== "html" && t !== "body" ? i.implicitRootScope === !0 && (i.implicitRootScope = !1) : i.implicitRootScope = !0, i;
    }
    function pm(e, t, i) {
      switch (t) {
        case "select":
          return e === "hr" || e === "option" || e === "optgroup" || e === "script" || e === "template" || e === "#text";
        case "optgroup":
          return e === "option" || e === "#text";
        case "option":
          return e === "#text";
        case "tr":
          return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
        case "tbody":
        case "thead":
        case "tfoot":
          return e === "tr" || e === "style" || e === "script" || e === "template";
        case "colgroup":
          return e === "col" || e === "template";
        case "table":
          return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
        case "head":
          return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
        case "html":
          if (i) break;
          return e === "head" || e === "body" || e === "frameset";
        case "frameset":
          return e === "frame";
        case "#document":
          if (!i) return e === "html";
      }
      switch (e) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
        case "rp":
        case "rt":
          return hf.indexOf(t) === -1;
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return t == null;
        case "head":
          return i || t === null;
        case "html":
          return i && t === "#document" || t === null;
        case "body":
          return i && (t === "#document" || t === "html") || t === null;
      }
      return !0;
    }
    function dc(e, t) {
      switch (e) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return t.pTagInButtonScope;
        case "form":
          return t.formTag || t.pTagInButtonScope;
        case "li":
          return t.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return t.dlItemTagAutoclosing;
        case "button":
          return t.buttonTagInScope;
        case "a":
          return t.aTagInScope;
        case "nobr":
          return t.nobrTagInScope;
      }
      return null;
    }
    function N2(e, t) {
      for (; e; ) {
        switch (e.tag) {
          case 5:
          case 26:
          case 27:
            if (e.type === t) return e;
        }
        e = e.return;
      }
      return null;
    }
    function Du(e, t) {
      t = t || mf;
      var i = t.current;
      if (t = (i = pm(
        e,
        i && i.tag,
        t.implicitRootScope
      ) ? null : i) ? null : dc(e, t), t = i || t, !t) return !0;
      var l = t.tag;
      if (t = String(!!i) + "|" + e + "|" + l, od[t]) return !1;
      od[t] = !0;
      var u = (t = Da) ? N2(t.return, l) : null, m = t !== null && u !== null ? $s(u, t, null) : "", S = "<" + e + ">";
      return i ? (i = "", l === "table" && e === "tr" && (i += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        `In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`,
        S,
        l,
        i,
        m
      )) : console.error(
        `In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`,
        S,
        l,
        m
      ), t && (e = t.return, u === null || e === null || u === e && e._debugOwner === t._debugOwner || pe(u, function() {
        console.error(
          `<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`,
          l,
          S
        );
      })), !1;
    }
    function Zd(e, t, i) {
      if (i || pm("#text", t, !1))
        return !0;
      if (i = "#text|" + t, od[i]) return !1;
      od[i] = !0;
      var l = (i = Da) ? N2(i, t) : null;
      return i = i !== null && l !== null ? $s(
        l,
        i,
        i.tag !== 6 ? { children: null } : null
      ) : "", /\S/.test(e) ? console.error(
        `In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`,
        t,
        i
      ) : console.error(
        `In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`,
        t,
        i
      ), !1;
    }
    function el(e, t) {
      if (t) {
        var i = e.firstChild;
        if (i && i === e.lastChild && i.nodeType === 3) {
          i.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }
    function iS(e) {
      return e.replace(Js, function(t, i) {
        return i.toUpperCase();
      });
    }
    function b2(e, t, i) {
      var l = t.indexOf("--") === 0;
      l || (-1 < t.indexOf("-") ? Al.hasOwnProperty(t) && Al[t] || (Al[t] = !0, console.error(
        "Unsupported style property %s. Did you mean %s?",
        t,
        iS(t.replace(H0, "ms-"))
      )) : W0.test(t) ? Al.hasOwnProperty(t) && Al[t] || (Al[t] = !0, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        t,
        t.charAt(0).toUpperCase() + t.slice(1)
      )) : !Cg.test(i) || Il.hasOwnProperty(i) && Il[i] || (Il[i] = !0, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        t,
        i.replace(Cg, "")
      )), typeof i == "number" && (isNaN(i) ? Vg || (Vg = !0, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        t
      )) : isFinite(i) || pf || (pf = !0, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        t
      )))), i == null || typeof i == "boolean" || i === "" ? l ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : l ? e.setProperty(t, i) : typeof i != "number" || i === 0 || z0.has(t) ? t === "float" ? e.cssFloat = i : (Re(i, t), e[t] = ("" + i).trim()) : e[t] = i + "px";
    }
    function Od(e, t, i) {
      if (t != null && typeof t != "object")
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      if (t && Object.freeze(t), e = e.style, i != null) {
        if (t) {
          var l = {};
          if (i) {
            for (var u in i)
              if (i.hasOwnProperty(u) && !t.hasOwnProperty(u))
                for (var m = oo[u] || [u], S = 0; S < m.length; S++)
                  l[m[S]] = u;
          }
          for (var U in t)
            if (t.hasOwnProperty(U) && (!i || i[U] !== t[U]))
              for (u = oo[U] || [U], m = 0; m < u.length; m++)
                l[u[m]] = U;
          U = {};
          for (var D in t)
            for (u = oo[D] || [D], m = 0; m < u.length; m++)
              U[u[m]] = D;
          D = {};
          for (var Q in l)
            if (u = l[Q], (m = U[Q]) && u !== m && (S = u + "," + m, !D[S])) {
              D[S] = !0, S = console;
              var ae = t[u];
              S.error.call(
                S,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                ae == null || typeof ae == "boolean" || ae === "" ? "Removing" : "Updating",
                u,
                m
              );
            }
        }
        for (var ue in i)
          !i.hasOwnProperty(ue) || t != null && t.hasOwnProperty(ue) || (ue.indexOf("--") === 0 ? e.setProperty(ue, "") : ue === "float" ? e.cssFloat = "" : e[ue] = "");
        for (var ee in t)
          Q = t[ee], t.hasOwnProperty(ee) && i[ee] !== Q && b2(e, ee, Q);
      } else
        for (l in t)
          t.hasOwnProperty(l) && b2(e, l, t[l]);
    }
    function tl(e) {
      if (e.indexOf("-") === -1) return !1;
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function Qu(e) {
      return gh.get(e) || e;
    }
    function uc(e, t) {
      if (zo.call(so, t) && so[t])
        return !0;
      if (vh.test(t)) {
        if (e = "aria-" + t.slice(4).toLowerCase(), e = ff.hasOwnProperty(e) ? e : null, e == null)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            t
          ), so[t] = !0;
        if (t !== e)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            t,
            e
          ), so[t] = !0;
      }
      if (gf.test(t)) {
        if (e = t.toLowerCase(), e = ff.hasOwnProperty(e) ? e : null, e == null) return so[t] = !0, !1;
        t !== e && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          t,
          e
        ), so[t] = !0);
      }
      return !0;
    }
    function hc(e, t) {
      var i = [], l;
      for (l in t)
        uc(e, l) || i.push(l);
      t = i.map(function(u) {
        return "`" + u + "`";
      }).join(", "), i.length === 1 ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        t,
        e
      ) : 1 < i.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        t,
        e
      );
    }
    function C2(e, t, i, l) {
      if (zo.call(Gi, t) && Gi[t])
        return !0;
      var u = t.toLowerCase();
      if (u === "onfocusin" || u === "onfocusout")
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), Gi[t] = !0;
      if (typeof i == "function" && (e === "form" && t === "action" || e === "input" && t === "formAction" || e === "button" && t === "formAction"))
        return !0;
      if (l != null) {
        if (e = l.possibleRegistrationNames, l.registrationNameDependencies.hasOwnProperty(t))
          return !0;
        if (l = e.hasOwnProperty(u) ? e[u] : null, l != null)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            t,
            l
          ), Gi[t] = !0;
        if (P0.test(t))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            t
          ), Gi[t] = !0;
      } else if (P0.test(t))
        return n.test(t) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          t
        ), Gi[t] = !0;
      if (a.test(t) || o.test(t)) return !0;
      if (u === "innerhtml")
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), Gi[t] = !0;
      if (u === "aria")
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), Gi[t] = !0;
      if (u === "is" && i !== null && i !== void 0 && typeof i != "string")
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof i
        ), Gi[t] = !0;
      if (typeof i == "number" && isNaN(i))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          t
        ), Gi[t] = !0;
      if (Ll.hasOwnProperty(u)) {
        if (u = Ll[u], u !== t)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            t,
            u
          ), Gi[t] = !0;
      } else if (t !== u)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          t,
          u
        ), Gi[t] = !0;
      switch (t) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return !0;
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof i) {
        case "boolean":
          switch (t) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return u = t.toLowerCase().slice(0, 5), u === "data-" || u === "aria-" ? !0 : (i ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                i,
                t,
                t,
                i,
                t
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                i,
                t,
                t,
                i,
                t,
                t,
                t
              ), Gi[t] = !0);
          }
        case "function":
        case "symbol":
          return Gi[t] = !0, !1;
        case "string":
          if (i === "false" || i === "true") {
            switch (t) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              i,
              t,
              i === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              t,
              i
            ), Gi[t] = !0;
          }
      }
      return !0;
    }
    function fm(e, t, i) {
      var l = [], u;
      for (u in t)
        C2(e, u, t[u], i) || l.push(u);
      t = l.map(function(m) {
        return "`" + m + "`";
      }).join(", "), l.length === 1 ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        t,
        e
      ) : 1 < l.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        t,
        e
      );
    }
    function mc(e) {
      return d.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
    }
    function nl(e) {
      return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
    }
    function kr(e) {
      var t = Mn(e);
      if (t && (e = t.stateNode)) {
        var i = e[fa] || null;
        e: switch (e = t.stateNode, t.type) {
          case "input":
            if (os(
              e,
              i.value,
              i.defaultValue,
              i.defaultValue,
              i.checked,
              i.defaultChecked,
              i.type,
              i.name
            ), t = i.name, i.type === "radio" && t != null) {
              for (i = e; i.parentNode; ) i = i.parentNode;
              for (q(t, "name"), i = i.querySelectorAll(
                'input[name="' + ya(
                  "" + t
                ) + '"][type="radio"]'
              ), t = 0; t < i.length; t++) {
                var l = i[t];
                if (l !== e && l.form === e.form) {
                  var u = l[fa] || null;
                  if (!u)
                    throw Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                    );
                  os(
                    l,
                    u.value,
                    u.defaultValue,
                    u.defaultValue,
                    u.checked,
                    u.defaultChecked,
                    u.type,
                    u.name
                  );
                }
              }
              for (t = 0; t < i.length; t++)
                l = i[t], l.form === e.form && vn(l);
            }
            break e;
          case "textarea":
            Fu(e, i.value, i.defaultValue);
            break e;
          case "select":
            t = i.value, t != null && No(e, !!i.multiple, t, !1);
        }
      }
    }
    function xu(e, t, i) {
      if (k) return e(t, i);
      k = !0;
      try {
        var l = e(t);
        return l;
      } finally {
        if (k = !1, (g !== null || y !== null) && (Vl(), g && (t = g, e = y, y = g = null, kr(t), e)))
          for (t = 0; t < e.length; t++) kr(e[t]);
      }
    }
    function bo(e, t) {
      var i = e.stateNode;
      if (i === null) return null;
      var l = i[fa] || null;
      if (l === null) return null;
      i = l[t];
      e: switch (t) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (l = !l.disabled) || (e = e.type, l = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !l;
          break e;
        default:
          e = !1;
      }
      if (e) return null;
      if (i && typeof i != "function")
        throw Error(
          "Expected `" + t + "` listener to be a function, instead got a value of `" + typeof i + "` type."
        );
      return i;
    }
    function Co() {
      if (re) return re;
      var e, t = ie, i = t.length, l, u = "value" in Ee ? Ee.value : Ee.textContent, m = u.length;
      for (e = 0; e < i && t[e] === u[e]; e++) ;
      var S = i - e;
      for (l = 1; l <= S && t[i - l] === u[m - l]; l++) ;
      return re = u.slice(e, 1 < l ? 1 - l : void 0);
    }
    function pc(e) {
      var t = e.keyCode;
      return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
    }
    function il() {
      return !0;
    }
    function gm() {
      return !1;
    }
    function pi(e) {
      function t(i, l, u, m, S) {
        this._reactName = i, this._targetInst = u, this.type = l, this.nativeEvent = m, this.target = S, this.currentTarget = null;
        for (var U in e)
          e.hasOwnProperty(U) && (i = e[U], this[U] = i ? i(m) : m[U]);
        return this.isDefaultPrevented = (m.defaultPrevented != null ? m.defaultPrevented : m.returnValue === !1) ? il : gm, this.isPropagationStopped = gm, this;
      }
      return Ct(t.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var i = this.nativeEvent;
          i && (i.preventDefault ? i.preventDefault() : typeof i.returnValue != "unknown" && (i.returnValue = !1), this.isDefaultPrevented = il);
        },
        stopPropagation: function() {
          var i = this.nativeEvent;
          i && (i.stopPropagation ? i.stopPropagation() : typeof i.cancelBubble != "unknown" && (i.cancelBubble = !0), this.isPropagationStopped = il);
        },
        persist: function() {
        },
        isPersistent: il
      }), t;
    }
    function Zu(e) {
      var t = this.nativeEvent;
      return t.getModifierState ? t.getModifierState(e) : (e = fy[e]) ? !!t[e] : !1;
    }
    function Ou() {
      return Zu;
    }
    function Hi(e, t) {
      switch (e) {
        case "keyup":
          return Vy.indexOf(t.keyCode) !== -1;
        case "keydown":
          return t.keyCode !== K6;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function cs(e) {
      return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
    }
    function wu(e, t) {
      switch (e) {
        case "compositionend":
          return cs(t);
        case "keypress":
          return t.which !== $6 ? null : (t3 = !0, e3);
        case "textInput":
          return e = t.data, e === e3 && t3 ? null : e;
        default:
          return null;
      }
    }
    function wd(e, t) {
      if (Sh)
        return e === "compositionend" || !TS && Hi(e, t) ? (e = Co(), re = ie = Ee = null, Sh = !1, e) : null;
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
            if (t.char && 1 < t.char.length)
              return t.char;
            if (t.which)
              return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return q6 && t.locale !== "ko" ? null : t.data;
        default:
          return null;
      }
    }
    function V2(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === "input" ? !!Fy[e.type] : t === "textarea";
    }
    function vm(e) {
      if (!w) return !1;
      e = "on" + e;
      var t = e in document;
      return t || (t = document.createElement("div"), t.setAttribute(e, "return;"), t = typeof t[e] == "function"), t;
    }
    function Bu(e, t, i, l) {
      g ? y ? y.push(l) : y = [l] : g = l, t = N0(t, "onChange"), 0 < t.length && (i = new rt(
        "onChange",
        "change",
        null,
        i,
        l
      ), e.push({ event: i, listeners: t }));
    }
    function Bd(e) {
      qr(e, 0);
    }
    function al(e) {
      var t = Li(e);
      if (vn(t)) return e;
    }
    function Sm(e, t) {
      if (e === "change") return t;
    }
    function _2() {
      Rf && (Rf.detachEvent("onpropertychange", F2), Ef = Rf = null);
    }
    function F2(e) {
      if (e.propertyName === "value" && al(Ef)) {
        var t = [];
        Bu(
          t,
          Ef,
          e,
          nl(e)
        ), xu(Bd, t);
      }
    }
    function aS(e, t, i) {
      e === "focusin" ? (_2(), Rf = t, Ef = i, Rf.attachEvent("onpropertychange", F2)) : e === "focusout" && _2();
    }
    function Rm(e) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return al(Ef);
    }
    function rS(e, t) {
      if (e === "click") return al(t);
    }
    function oS(e, t) {
      if (e === "input" || e === "change")
        return al(t);
    }
    function sS(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    function Ad(e, t) {
      if (Qa(e, t)) return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      var i = Object.keys(e), l = Object.keys(t);
      if (i.length !== l.length) return !1;
      for (l = 0; l < i.length; l++) {
        var u = i[l];
        if (!zo.call(t, u) || !Qa(e[u], t[u]))
          return !1;
      }
      return !0;
    }
    function M2(e) {
      for (; e && e.firstChild; ) e = e.firstChild;
      return e;
    }
    function Em(e, t) {
      var i = M2(e);
      e = 0;
      for (var l; i; ) {
        if (i.nodeType === 3) {
          if (l = e + i.textContent.length, e <= t && l >= t)
            return { node: i, offset: t - e };
          e = l;
        }
        e: {
          for (; i; ) {
            if (i.nextSibling) {
              i = i.nextSibling;
              break e;
            }
            i = i.parentNode;
          }
          i = void 0;
        }
        i = M2(i);
      }
    }
    function k2(e, t) {
      return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? k2(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
    }
    function D2(e) {
      e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
      for (var t = kd(e.document); t instanceof e.HTMLIFrameElement; ) {
        try {
          var i = typeof t.contentWindow.location.href == "string";
        } catch {
          i = !1;
        }
        if (i) e = t.contentWindow;
        else break;
        t = kd(e.document);
      }
      return t;
    }
    function Um(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
    }
    function Q2(e, t, i) {
      var l = i.window === i ? i.document : i.nodeType === 9 ? i : i.ownerDocument;
      NS || Rh == null || Rh !== kd(l) || (l = Rh, "selectionStart" in l && Um(l) ? l = { start: l.selectionStart, end: l.selectionEnd } : (l = (l.ownerDocument && l.ownerDocument.defaultView || window).getSelection(), l = {
        anchorNode: l.anchorNode,
        anchorOffset: l.anchorOffset,
        focusNode: l.focusNode,
        focusOffset: l.focusOffset
      }), Uf && Ad(Uf, l) || (Uf = l, l = N0(yS, "onSelect"), 0 < l.length && (t = new rt(
        "onSelect",
        "select",
        null,
        t,
        i
      ), e.push({ event: t, listeners: l }), t.target = Rh)));
    }
    function Vo(e, t) {
      var i = {};
      return i[e.toLowerCase()] = t.toLowerCase(), i["Webkit" + e] = "webkit" + t, i["Moz" + e] = "moz" + t, i;
    }
    function rl(e) {
      if (bS[e]) return bS[e];
      if (!Eh[e]) return e;
      var t = Eh[e], i;
      for (i in t)
        if (t.hasOwnProperty(i) && i in i3)
          return bS[e] = t[i];
      return e;
    }
    function lr(e, t) {
      l3.set(e, t), Ze(t, [e]);
    }
    function Na(e, t) {
      if (typeof e == "object" && e !== null) {
        var i = VS.get(e);
        return i !== void 0 ? i : (t = {
          value: e,
          source: t,
          stack: as(t)
        }, VS.set(e, t), t);
      }
      return {
        value: e,
        source: t,
        stack: as(t)
      };
    }
    function Id() {
      for (var e = Uh, t = _S = Uh = 0; t < e; ) {
        var i = lo[t];
        lo[t++] = null;
        var l = lo[t];
        lo[t++] = null;
        var u = lo[t];
        lo[t++] = null;
        var m = lo[t];
        if (lo[t++] = null, l !== null && u !== null) {
          var S = l.pending;
          S === null ? u.next = u : (u.next = S.next, S.next = u), l.pending = u;
        }
        m !== 0 && x2(i, u, m);
      }
    }
    function Au(e, t, i, l) {
      lo[Uh++] = e, lo[Uh++] = t, lo[Uh++] = i, lo[Uh++] = l, _S |= l, e.lanes |= l, e = e.alternate, e !== null && (e.lanes |= l);
    }
    function Tm(e, t, i, l) {
      return Au(e, t, i, l), Iu(e);
    }
    function ia(e, t) {
      return Au(e, null, null, t), Iu(e);
    }
    function x2(e, t, i) {
      e.lanes |= i;
      var l = e.alternate;
      l !== null && (l.lanes |= i);
      for (var u = !1, m = e.return; m !== null; )
        m.childLanes |= i, l = m.alternate, l !== null && (l.childLanes |= i), m.tag === 22 && (e = m.stateNode, e === null || e._visibility & _g || (u = !0)), e = m, m = m.return;
      return e.tag === 3 ? (m = e.stateNode, u && t !== null && (u = 31 - Qi(i), e = m.hiddenUpdates, l = e[u], l === null ? e[u] = [t] : l.push(t), t.lane = i | 536870912), m) : null;
    }
    function Iu(e) {
      if (Wf > qy)
        throw ou = Wf = 0, Hf = aR = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      ou > $y && (ou = 0, Hf = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      )), e.alternate === null && (e.flags & 4098) !== 0 && Er(e);
      for (var t = e, i = t.return; i !== null; )
        t.alternate === null && (t.flags & 4098) !== 0 && Er(e), t = i, i = t.return;
      return t.tag === 3 ? t.stateNode : null;
    }
    function ol(e) {
      if (co === null) return e;
      var t = co(e);
      return t === void 0 ? e : t.current;
    }
    function ym(e) {
      if (co === null) return e;
      var t = co(e);
      return t === void 0 ? e != null && typeof e.render == "function" && (t = ol(e.render), e.render !== t) ? (t = { $$typeof: Wo, render: t }, e.displayName !== void 0 && (t.displayName = e.displayName), t) : e : t.current;
    }
    function Z2(e, t) {
      if (co === null) return !1;
      var i = e.elementType;
      t = t.type;
      var l = !1, u = typeof t == "object" && t !== null ? t.$$typeof : null;
      switch (e.tag) {
        case 1:
          typeof t == "function" && (l = !0);
          break;
        case 0:
          (typeof t == "function" || u === ka) && (l = !0);
          break;
        case 11:
          (u === Wo || u === ka) && (l = !0);
          break;
        case 14:
        case 15:
          (u === Z0 || u === ka) && (l = !0);
          break;
        default:
          return !1;
      }
      return !!(l && (e = co(i), e !== void 0 && e === co(t)));
    }
    function O2(e) {
      co !== null && typeof WeakSet == "function" && (Th === null && (Th = /* @__PURE__ */ new WeakSet()), Th.add(e));
    }
    function Ld(e, t, i) {
      var l = e.alternate, u = e.child, m = e.sibling, S = e.tag, U = e.type, D = null;
      switch (S) {
        case 0:
        case 15:
        case 1:
          D = U;
          break;
        case 11:
          D = U.render;
      }
      if (co === null)
        throw Error("Expected resolveFamily to be set during hot reload.");
      var Q = !1;
      U = !1, D !== null && (D = co(D), D !== void 0 && (i.has(D) ? U = !0 : t.has(D) && (S === 1 ? U = !0 : Q = !0))), Th !== null && (Th.has(e) || l !== null && Th.has(l)) && (U = !0), U && (e._debugNeedsRemount = !0), (U || Q) && (l = ia(e, 2), l !== null && wn(l, e, 2)), u === null || U || Ld(
        u,
        t,
        i
      ), m !== null && Ld(
        m,
        t,
        i
      );
    }
    function Jd(e, t, i, l) {
      this.tag = e, this.key = i, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = l, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null, this.actualDuration = -0, this.actualStartTime = -1.1, this.treeBaseDuration = this.selfBaseDuration = -0, this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, d3 || typeof Object.preventExtensions != "function" || Object.preventExtensions(this);
    }
    function Nm(e) {
      return e = e.prototype, !(!e || !e.isReactComponent);
    }
    function Dr(e, t) {
      var i = e.alternate;
      switch (i === null ? (i = V(
        e.tag,
        t,
        e.key,
        e.mode
      ), i.elementType = e.elementType, i.type = e.type, i.stateNode = e.stateNode, i._debugOwner = e._debugOwner, i._debugStack = e._debugStack, i._debugTask = e._debugTask, i._debugHookTypes = e._debugHookTypes, i.alternate = e, e.alternate = i) : (i.pendingProps = t, i.type = e.type, i.flags = 0, i.subtreeFlags = 0, i.deletions = null, i.actualDuration = -0, i.actualStartTime = -1.1), i.flags = e.flags & 65011712, i.childLanes = e.childLanes, i.lanes = e.lanes, i.child = e.child, i.memoizedProps = e.memoizedProps, i.memoizedState = e.memoizedState, i.updateQueue = e.updateQueue, t = e.dependencies, i.dependencies = t === null ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext,
        _debugThenableState: t._debugThenableState
      }, i.sibling = e.sibling, i.index = e.index, i.ref = e.ref, i.refCleanup = e.refCleanup, i.selfBaseDuration = e.selfBaseDuration, i.treeBaseDuration = e.treeBaseDuration, i._debugInfo = e._debugInfo, i._debugNeedsRemount = e._debugNeedsRemount, i.tag) {
        case 0:
        case 15:
          i.type = ol(e.type);
          break;
        case 1:
          i.type = ol(e.type);
          break;
        case 11:
          i.type = ym(e.type);
      }
      return i;
    }
    function bm(e, t) {
      e.flags &= 65011714;
      var i = e.alternate;
      return i === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0) : (e.childLanes = i.childLanes, e.lanes = i.lanes, e.child = i.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = i.memoizedProps, e.memoizedState = i.memoizedState, e.updateQueue = i.updateQueue, e.type = i.type, t = i.dependencies, e.dependencies = t === null ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext,
        _debugThenableState: t._debugThenableState
      }, e.selfBaseDuration = i.selfBaseDuration, e.treeBaseDuration = i.treeBaseDuration), e;
    }
    function Lu(e, t, i, l, u, m) {
      var S = 0, U = e;
      if (typeof e == "function")
        Nm(e) && (S = 1), U = ol(U);
      else if (typeof e == "string")
        S = O(), S = Pc(e, i, S) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
      else
        e: switch (e) {
          case qp:
            return t = V(31, i, t, u), t.elementType = qp, t.lanes = m, t;
          case Ut:
            return ds(
              i.children,
              u,
              m,
              t
            );
          case Yc:
            S = 8, u |= va, u |= Xo;
            break;
          case Xc:
            return e = i, l = u, typeof e.id != "string" && console.error(
              'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
              typeof e.id
            ), t = V(12, e, t, l | Yi), t.elementType = Xc, t.lanes = m, t.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, t;
          case Kc:
            return t = V(13, i, t, u), t.elementType = Kc, t.lanes = m, t;
          case Os:
            return t = V(19, i, t, u), t.elementType = Os, t.lanes = m, t;
          default:
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case Kp:
                case $a:
                  S = 10;
                  break e;
                case nh:
                  S = 9;
                  break e;
                case Wo:
                  S = 11, U = ym(U);
                  break e;
                case Z0:
                  S = 14;
                  break e;
                case ka:
                  S = 16, U = null;
                  break e;
              }
            U = "", (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (U += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), e === null ? i = "null" : St(e) ? i = "array" : e !== void 0 && e.$$typeof === Zs ? (i = "<" + (Ne(e.type) || "Unknown") + " />", U = " Did you accidentally export a JSX literal instead of a component?") : i = typeof e, (S = l ? xe(l) : null) && (U += `

Check the render method of \`` + S + "`."), S = 29, i = Error(
              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (i + "." + U)
            ), U = null;
        }
      return t = V(S, i, t, u), t.elementType = e, t.type = U, t.lanes = m, t._debugOwner = l, t;
    }
    function Wd(e, t, i) {
      return t = Lu(
        e.type,
        e.key,
        e.props,
        e._owner,
        t,
        i
      ), t._debugOwner = e._owner, t._debugStack = e._debugStack, t._debugTask = e._debugTask, t;
    }
    function ds(e, t, i, l) {
      return e = V(7, e, l, t), e.lanes = i, e;
    }
    function us(e, t, i) {
      return e = V(6, e, null, t), e.lanes = i, e;
    }
    function Cm(e, t, i) {
      return t = V(
        4,
        e.children !== null ? e.children : [],
        e.key,
        t
      ), t.lanes = i, t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
      }, t;
    }
    function sl(e, t) {
      cr(), yh[Nh++] = Mg, yh[Nh++] = Fg, Fg = e, Mg = t;
    }
    function w2(e, t, i) {
      cr(), uo[ho++] = Wl, uo[ho++] = Hl, uo[ho++] = G0, G0 = e;
      var l = Wl;
      e = Hl;
      var u = 32 - Qi(l) - 1;
      l &= ~(1 << u), i += 1;
      var m = 32 - Qi(t) + u;
      if (30 < m) {
        var S = u - u % 5;
        m = (l & (1 << S) - 1).toString(32), l >>= S, u -= S, Wl = 1 << 32 - Qi(t) + u | i << u | l, Hl = m + e;
      } else
        Wl = 1 << m | i << u | l, Hl = e;
    }
    function Ju(e) {
      cr(), e.return !== null && (sl(e, 1), w2(e, 1, 0));
    }
    function Wu(e) {
      for (; e === Fg; )
        Fg = yh[--Nh], yh[Nh] = null, Mg = yh[--Nh], yh[Nh] = null;
      for (; e === G0; )
        G0 = uo[--ho], uo[ho] = null, Hl = uo[--ho], uo[ho] = null, Wl = uo[--ho], uo[ho] = null;
    }
    function cr() {
      Gt || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function dr(e, t) {
      if (e.return === null) {
        if (mo === null)
          mo = {
            fiber: e,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: t
          };
        else {
          if (mo.fiber !== e)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          mo.distanceFromLeaf > t && (mo.distanceFromLeaf = t);
        }
        return mo;
      }
      var i = dr(
        e.return,
        t + 1
      ).children;
      return 0 < i.length && i[i.length - 1].fiber === e ? (i = i[i.length - 1], i.distanceFromLeaf > t && (i.distanceFromLeaf = t), i) : (t = {
        fiber: e,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf: t
      }, i.push(t), t);
    }
    function Vm(e, t) {
      zl || (e = dr(e, 0), e.serverProps = null, t !== null && (t = j1(t), e.serverTail.push(t)));
    }
    function Qr(e) {
      var t = "", i = mo;
      throw i !== null && (mo = null, t = xd(i)), fc(
        Na(
          Error(
            `Hydration failed because the server rendered HTML didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + t
          ),
          e
        )
      ), FS;
    }
    function _m(e) {
      var t = e.stateNode, i = e.type, l = e.memoizedProps;
      switch (t[xi] = e, t[fa] = l, $r(i, l), i) {
        case "dialog":
          Qt("cancel", t), Qt("close", t);
          break;
        case "iframe":
        case "object":
        case "embed":
          Qt("load", t);
          break;
        case "video":
        case "audio":
          for (i = 0; i < zf.length; i++)
            Qt(zf[i], t);
          break;
        case "source":
          Qt("error", t);
          break;
        case "img":
        case "image":
        case "link":
          Qt("error", t), Qt("load", t);
          break;
        case "details":
          Qt("toggle", t);
          break;
        case "input":
          Ye("input", l), Qt("invalid", t), rs(t, l), T2(
            t,
            l.value,
            l.defaultValue,
            l.checked,
            l.defaultChecked,
            l.type,
            l.name,
            !0
          ), Xt(t);
          break;
        case "option":
          cm(t, l);
          break;
        case "select":
          Ye("select", l), Qt("invalid", t), Dd(t, l);
          break;
        case "textarea":
          Ye("textarea", l), Qt("invalid", t), Mr(t, l), dm(
            t,
            l.value,
            l.defaultValue,
            l.children
          ), Xt(t);
      }
      i = l.children, typeof i != "string" && typeof i != "number" && typeof i != "bigint" || t.textContent === "" + i || l.suppressHydrationWarning === !0 || Mp(t.textContent, i) ? (l.popover != null && (Qt("beforetoggle", t), Qt("toggle", t)), l.onScroll != null && Qt("scroll", t), l.onScrollEnd != null && Qt("scrollend", t), l.onClick != null && (t.onclick = Ao), t = !0) : t = !1, t || Qr(e);
    }
    function Fm(e) {
      for (xa = e.return; xa; )
        switch (xa.tag) {
          case 5:
          case 13:
            Hs = !1;
            return;
          case 27:
          case 3:
            Hs = !0;
            return;
          default:
            xa = xa.return;
        }
    }
    function ll(e) {
      if (e !== xa) return !1;
      if (!Gt)
        return Fm(e), Gt = !0, !1;
      var t = e.tag, i;
      if ((i = t !== 3 && t !== 27) && ((i = t === 5) && (i = e.type, i = !(i !== "form" && i !== "button") || eo(e.type, e.memoizedProps)), i = !i), i && Xn) {
        for (i = Xn; i; ) {
          var l = dr(e, 0), u = j1(i);
          l.serverTail.push(u), i = u.type === "Suspense" ? Bp(i) : Ri(i.nextSibling);
        }
        Qr(e);
      }
      if (Fm(e), t === 13) {
        if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        Xn = Bp(e);
      } else
        t === 27 ? (t = Xn, to(e.type) ? (e = gR, gR = null, Xn = e) : Xn = t) : Xn = xa ? Ri(e.stateNode.nextSibling) : null;
      return !0;
    }
    function cl() {
      Xn = xa = null, zl = Gt = !1;
    }
    function Mm() {
      var e = Y0;
      return e !== null && (wa === null ? wa = e : wa.push.apply(
        wa,
        e
      ), Y0 = null), e;
    }
    function fc(e) {
      Y0 === null ? Y0 = [e] : Y0.push(e);
    }
    function km() {
      var e = mo;
      if (e !== null) {
        mo = null;
        for (var t = xd(e); 0 < e.children.length; )
          e = e.children[0];
        pe(e.fiber, function() {
          console.error(
            `A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`,
            "https://react.dev/link/hydration-mismatch",
            t
          );
        });
      }
    }
    function Hu() {
      bh = kg = null, Ch = !1;
    }
    function hs(e, t, i) {
      we(MS, t._currentValue, e), t._currentValue = i, we(kS, t._currentRenderer, e), t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== p3 && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      ), t._currentRenderer = p3;
    }
    function _o(e, t) {
      e._currentValue = MS.current;
      var i = kS.current;
      Ve(kS, t), e._currentRenderer = i, Ve(MS, t);
    }
    function Dm(e, t, i) {
      for (; e !== null; ) {
        var l = e.alternate;
        if ((e.childLanes & t) !== t ? (e.childLanes |= t, l !== null && (l.childLanes |= t)) : l !== null && (l.childLanes & t) !== t && (l.childLanes |= t), e === i) break;
        e = e.return;
      }
      e !== i && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function Qm(e, t, i, l) {
      var u = e.child;
      for (u !== null && (u.return = e); u !== null; ) {
        var m = u.dependencies;
        if (m !== null) {
          var S = u.child;
          m = m.firstContext;
          e: for (; m !== null; ) {
            var U = m;
            m = u;
            for (var D = 0; D < t.length; D++)
              if (U.context === t[D]) {
                m.lanes |= i, U = m.alternate, U !== null && (U.lanes |= i), Dm(
                  m.return,
                  i,
                  e
                ), l || (S = null);
                break e;
              }
            m = U.next;
          }
        } else if (u.tag === 18) {
          if (S = u.return, S === null)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          S.lanes |= i, m = S.alternate, m !== null && (m.lanes |= i), Dm(
            S,
            i,
            e
          ), S = null;
        } else S = u.child;
        if (S !== null) S.return = u;
        else
          for (S = u; S !== null; ) {
            if (S === e) {
              S = null;
              break;
            }
            if (u = S.sibling, u !== null) {
              u.return = S.return, S = u;
              break;
            }
            S = S.return;
          }
        u = S;
      }
    }
    function fi(e, t, i, l) {
      e = null;
      for (var u = t, m = !1; u !== null; ) {
        if (!m) {
          if ((u.flags & 524288) !== 0) m = !0;
          else if ((u.flags & 262144) !== 0) break;
        }
        if (u.tag === 10) {
          var S = u.alternate;
          if (S === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          if (S = S.memoizedProps, S !== null) {
            var U = u.type;
            Qa(u.pendingProps.value, S.value) || (e !== null ? e.push(U) : e = [U]);
          }
        } else if (u === $c.current) {
          if (S = u.alternate, S === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          S.memoizedState.memoizedState !== u.memoizedState.memoizedState && (e !== null ? e.push(Yf) : e = [Yf]);
        }
        u = u.return;
      }
      e !== null && Qm(
        t,
        e,
        i,
        l
      ), t.flags |= 262144;
    }
    function ms(e) {
      for (e = e.firstContext; e !== null; ) {
        if (!Qa(
          e.context._currentValue,
          e.memoizedValue
        ))
          return !0;
        e = e.next;
      }
      return !1;
    }
    function ps(e) {
      kg = e, bh = null, e = e.dependencies, e !== null && (e.firstContext = null);
    }
    function Sn(e) {
      return Ch && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      ), xm(kg, e);
    }
    function Hd(e, t) {
      return kg === null && ps(e), xm(e, t);
    }
    function xm(e, t) {
      var i = t._currentValue;
      if (t = { context: t, memoizedValue: i, next: null }, bh === null) {
        if (e === null)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        bh = t, e.dependencies = {
          lanes: 0,
          firstContext: t,
          _debugThenableState: null
        }, e.flags |= 524288;
      } else bh = bh.next = t;
      return i;
    }
    function zd() {
      return {
        controller: new wy(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function dl(e) {
      e.controller.signal.aborted, e.refCount++;
    }
    function xr(e) {
      e.refCount--, 0 > e.refCount, e.refCount === 0 && By(Ay, function() {
        e.controller.abort();
      });
    }
    function ur() {
      var e = X0;
      return X0 = 0, e;
    }
    function fs(e) {
      var t = X0;
      return X0 = e, t;
    }
    function ul(e) {
      var t = X0;
      return X0 += e, t;
    }
    function zu(e) {
      nr = Vh(), 0 > e.actualStartTime && (e.actualStartTime = nr);
    }
    function Fo(e) {
      if (0 <= nr) {
        var t = Vh() - nr;
        e.actualDuration += t, e.selfBaseDuration = t, nr = -1;
      }
    }
    function hl(e) {
      if (0 <= nr) {
        var t = Vh() - nr;
        e.actualDuration += t, nr = -1;
      }
    }
    function La() {
      if (0 <= nr) {
        var e = Vh() - nr;
        nr = -1, X0 += e;
      }
    }
    function hr() {
      nr = Vh();
    }
    function Zr(e) {
      for (var t = e.child; t; )
        e.actualDuration += t.actualDuration, t = t.sibling;
    }
    function B2(e, t) {
      if (Tf === null) {
        var i = Tf = [];
        DS = 0, K0 = bp(), _h = {
          status: "pending",
          value: void 0,
          then: function(l) {
            i.push(l);
          }
        };
      }
      return DS++, t.then(Zm, Zm), t;
    }
    function Zm() {
      if (--DS === 0 && Tf !== null) {
        _h !== null && (_h.status = "fulfilled");
        var e = Tf;
        Tf = null, K0 = 0, _h = null;
        for (var t = 0; t < e.length; t++) (0, e[t])();
      }
    }
    function A2(e, t) {
      var i = [], l = {
        status: "pending",
        value: null,
        reason: null,
        then: function(u) {
          i.push(u);
        }
      };
      return e.then(
        function() {
          l.status = "fulfilled", l.value = t;
          for (var u = 0; u < i.length; u++) (0, i[u])(t);
        },
        function(u) {
          for (l.status = "rejected", l.reason = u, u = 0; u < i.length; u++)
            (0, i[u])(void 0);
        }
      ), l;
    }
    function Om() {
      var e = q0.current;
      return e !== null ? e : Rn.pooledCache;
    }
    function ju(e, t) {
      t === null ? we(q0, q0.current, e) : we(q0, t.pool, e);
    }
    function I2() {
      var e = Om();
      return e === null ? null : { parent: Ti._currentValue, pool: e };
    }
    function wm() {
      return { didWarnAboutUncachedPromise: !1, thenables: [] };
    }
    function Bm(e) {
      return e = e.status, e === "fulfilled" || e === "rejected";
    }
    function gc() {
    }
    function Ja(e, t, i) {
      le.actQueue !== null && (le.didUsePromise = !0);
      var l = e.thenables;
      switch (i = l[i], i === void 0 ? l.push(t) : i !== t && (e.didWarnAboutUncachedPromise || (e.didWarnAboutUncachedPromise = !0, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), t.then(gc, gc), t = i), t.status) {
        case "fulfilled":
          return t.value;
        case "rejected":
          throw e = t.reason, ba(e), e;
        default:
          if (typeof t.status == "string")
            t.then(gc, gc);
          else {
            if (e = Rn, e !== null && 100 < e.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            e = t, e.status = "pending", e.then(
              function(u) {
                if (t.status === "pending") {
                  var m = t;
                  m.status = "fulfilled", m.value = u;
                }
              },
              function(u) {
                if (t.status === "pending") {
                  var m = t;
                  m.status = "rejected", m.reason = u;
                }
              }
            );
          }
          switch (t.status) {
            case "fulfilled":
              return t.value;
            case "rejected":
              throw e = t.reason, ba(e), e;
          }
          throw Mf = t, wg = !0, Ff;
      }
    }
    function Am() {
      if (Mf === null)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var e = Mf;
      return Mf = null, wg = !1, e;
    }
    function ba(e) {
      if (e === Ff || e === Og)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function aa(e) {
      e.updateQueue = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function gs(e, t) {
      e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        callbacks: null
      });
    }
    function Or(e) {
      return {
        lane: e,
        tag: R3,
        payload: null,
        callback: null,
        next: null
      };
    }
    function mr(e, t, i) {
      var l = e.updateQueue;
      if (l === null) return null;
      if (l = l.shared, ZS === l && !T3) {
        var u = Fe(e);
        console.error(
          `An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`,
          u
        ), T3 = !0;
      }
      return (nn & Oa) !== yr ? (u = l.pending, u === null ? t.next = t : (t.next = u.next, u.next = t), l.pending = t, t = Iu(e), x2(e, null, i), t) : (Au(e, l, t, i), Iu(e));
    }
    function vs(e, t, i) {
      if (t = t.updateQueue, t !== null && (t = t.shared, (i & 4194048) !== 0)) {
        var l = t.lanes;
        l &= e.pendingLanes, i |= l, t.lanes = i, ta(e, i);
      }
    }
    function vc(e, t) {
      var i = e.updateQueue, l = e.alternate;
      if (l !== null && (l = l.updateQueue, i === l)) {
        var u = null, m = null;
        if (i = i.firstBaseUpdate, i !== null) {
          do {
            var S = {
              lane: i.lane,
              tag: i.tag,
              payload: i.payload,
              callback: null,
              next: null
            };
            m === null ? u = m = S : m = m.next = S, i = i.next;
          } while (i !== null);
          m === null ? u = m = t : m = m.next = t;
        } else u = m = t;
        i = {
          baseState: l.baseState,
          firstBaseUpdate: u,
          lastBaseUpdate: m,
          shared: l.shared,
          callbacks: l.callbacks
        }, e.updateQueue = i;
        return;
      }
      e = i.lastBaseUpdate, e === null ? i.firstBaseUpdate = t : e.next = t, i.lastBaseUpdate = t;
    }
    function wr() {
      if (OS) {
        var e = _h;
        if (e !== null) throw e;
      }
    }
    function Sc(e, t, i, l) {
      OS = !1;
      var u = e.updateQueue;
      cd = !1, ZS = u.shared;
      var m = u.firstBaseUpdate, S = u.lastBaseUpdate, U = u.shared.pending;
      if (U !== null) {
        u.shared.pending = null;
        var D = U, Q = D.next;
        D.next = null, S === null ? m = Q : S.next = Q, S = D;
        var ae = e.alternate;
        ae !== null && (ae = ae.updateQueue, U = ae.lastBaseUpdate, U !== S && (U === null ? ae.firstBaseUpdate = Q : U.next = Q, ae.lastBaseUpdate = D));
      }
      if (m !== null) {
        var ue = u.baseState;
        S = 0, ae = Q = D = null, U = m;
        do {
          var ee = U.lane & -536870913, me = ee !== U.lane;
          if (me ? (At & ee) === ee : (l & ee) === ee) {
            ee !== 0 && ee === K0 && (OS = !0), ae !== null && (ae = ae.next = {
              lane: 0,
              tag: U.tag,
              payload: U.payload,
              callback: null,
              next: null
            });
            e: {
              ee = e;
              var qe = U, ft = t, En = i;
              switch (qe.tag) {
                case E3:
                  if (qe = qe.payload, typeof qe == "function") {
                    Ch = !0;
                    var Jt = qe.call(
                      En,
                      ue,
                      ft
                    );
                    if (ee.mode & va) {
                      Ce(!0);
                      try {
                        qe.call(En, ue, ft);
                      } finally {
                        Ce(!1);
                      }
                    }
                    Ch = !1, ue = Jt;
                    break e;
                  }
                  ue = qe;
                  break e;
                case xS:
                  ee.flags = ee.flags & -65537 | 128;
                case R3:
                  if (Jt = qe.payload, typeof Jt == "function") {
                    if (Ch = !0, qe = Jt.call(
                      En,
                      ue,
                      ft
                    ), ee.mode & va) {
                      Ce(!0);
                      try {
                        Jt.call(En, ue, ft);
                      } finally {
                        Ce(!1);
                      }
                    }
                    Ch = !1;
                  } else qe = Jt;
                  if (qe == null) break e;
                  ue = Ct({}, ue, qe);
                  break e;
                case U3:
                  cd = !0;
              }
            }
            ee = U.callback, ee !== null && (e.flags |= 64, me && (e.flags |= 8192), me = u.callbacks, me === null ? u.callbacks = [ee] : me.push(ee));
          } else
            me = {
              lane: ee,
              tag: U.tag,
              payload: U.payload,
              callback: U.callback,
              next: null
            }, ae === null ? (Q = ae = me, D = ue) : ae = ae.next = me, S |= ee;
          if (U = U.next, U === null) {
            if (U = u.shared.pending, U === null)
              break;
            me = U, U = me.next, me.next = null, u.lastBaseUpdate = me, u.shared.pending = null;
          }
        } while (!0);
        ae === null && (D = ue), u.baseState = D, u.firstBaseUpdate = Q, u.lastBaseUpdate = ae, m === null && (u.shared.lanes = 0), md |= S, e.lanes = S, e.memoizedState = ue;
      }
      ZS = null;
    }
    function jd(e, t) {
      if (typeof e != "function")
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + e
        );
      e.call(t);
    }
    function Rc(e, t) {
      var i = e.shared.hiddenCallbacks;
      if (i !== null)
        for (e.shared.hiddenCallbacks = null, e = 0; e < i.length; e++)
          jd(i[e], t);
    }
    function L2(e, t) {
      var i = e.callbacks;
      if (i !== null)
        for (e.callbacks = null, e = 0; e < i.length; e++)
          jd(i[e], t);
    }
    function ra(e, t) {
      var i = Ps;
      we(Bg, i, e), we(Fh, t, e), Ps = i | t.baseLanes;
    }
    function Pd(e) {
      we(Bg, Ps, e), we(
        Fh,
        Fh.current,
        e
      );
    }
    function pr(e) {
      Ps = Bg.current, Ve(Fh, e), Ve(Bg, e);
    }
    function Ft() {
      var e = de;
      go === null ? go = [e] : go.push(e);
    }
    function Qe() {
      var e = de;
      if (go !== null && (Pl++, go[Pl] !== e)) {
        var t = Fe(Rt);
        if (!y3.has(t) && (y3.add(t), go !== null)) {
          for (var i = "", l = 0; l <= Pl; l++) {
            var u = go[l], m = l === Pl ? e : u;
            for (u = l + 1 + ". " + u; 30 > u.length; )
              u += " ";
            u += m + `
`, i += u;
          }
          console.error(
            `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
            t,
            i
          );
        }
      }
    }
    function Wa(e) {
      e == null || St(e) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        de,
        typeof e
      );
    }
    function Ec() {
      var e = Fe(Rt);
      b3.has(e) || (b3.add(e), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        e
      ));
    }
    function kn() {
      throw Error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      );
    }
    function Ss(e, t) {
      if (Df) return !1;
      if (t === null)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          de
        ), !1;
      e.length !== t.length && console.error(
        `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
        de,
        "[" + t.join(", ") + "]",
        "[" + e.join(", ") + "]"
      );
      for (var i = 0; i < t.length && i < e.length; i++)
        if (!Qa(e[i], t[i])) return !1;
      return !0;
    }
    function Rs(e, t, i, l, u, m) {
      dd = m, Rt = t, go = e !== null ? e._debugHookTypes : null, Pl = -1, Df = e !== null && e.type !== t.type, (Object.prototype.toString.call(i) === "[object AsyncFunction]" || Object.prototype.toString.call(i) === "[object AsyncGeneratorFunction]") && (m = Fe(Rt), wS.has(m) || (wS.add(m), console.error(
        "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
        m === null ? "An unknown Component" : "<" + m + ">"
      ))), t.memoizedState = null, t.updateQueue = null, t.lanes = 0, le.H = e !== null && e.memoizedState !== null ? AS : go !== null ? C3 : BS, eu = m = (t.mode & va) !== Vn;
      var S = IS(i, l, u);
      if (eu = !1, kh && (S = Uc(
        t,
        i,
        l,
        u
      )), m) {
        Ce(!0);
        try {
          S = Uc(
            t,
            i,
            l,
            u
          );
        } finally {
          Ce(!1);
        }
      }
      return Gd(e, t), S;
    }
    function Gd(e, t) {
      t._debugHookTypes = go, t.dependencies === null ? jl !== null && (t.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: jl
      }) : t.dependencies._debugThenableState = jl, le.H = Lg;
      var i = mn !== null && mn.next !== null;
      if (dd = 0, go = de = hi = mn = Rt = null, Pl = -1, e !== null && (e.flags & 65011712) !== (t.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      ), Ag = !1, kf = 0, jl = null, i)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      e === null || Zi || (e = e.dependencies, e !== null && ms(e) && (Zi = !0)), wg ? (wg = !1, e = !0) : e = !1, e && (t = Fe(t) || "Unknown", N3.has(t) || wS.has(t) || (N3.add(t), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function Uc(e, t, i, l) {
      Rt = e;
      var u = 0;
      do {
        if (kh && (jl = null), kf = 0, kh = !1, u >= Ly)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        if (u += 1, Df = !1, hi = mn = null, e.updateQueue != null) {
          var m = e.updateQueue;
          m.lastEffect = null, m.events = null, m.stores = null, m.memoCache != null && (m.memoCache.index = 0);
        }
        Pl = -1, le.H = V3, m = IS(t, i, l);
      } while (kh);
      return m;
    }
    function Ha() {
      var e = le.H, t = e.useState()[0];
      return t = typeof t.then == "function" ? ml(t) : t, e = e.useState()[0], (mn !== null ? mn.memoizedState : null) !== e && (Rt.flags |= 1024), t;
    }
    function oa() {
      var e = Ig !== 0;
      return Ig = 0, e;
    }
    function Mo(e, t, i) {
      t.updateQueue = e.updateQueue, t.flags = (t.mode & Xo) !== Vn ? t.flags & -402655237 : t.flags & -2053, e.lanes &= ~i;
    }
    function fr(e) {
      if (Ag) {
        for (e = e.memoizedState; e !== null; ) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        Ag = !1;
      }
      dd = 0, go = hi = mn = Rt = null, Pl = -1, de = null, kh = !1, kf = Ig = 0, jl = null;
    }
    function Zn() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return hi === null ? Rt.memoizedState = hi = e : hi = hi.next = e, hi;
    }
    function Lt() {
      if (mn === null) {
        var e = Rt.alternate;
        e = e !== null ? e.memoizedState : null;
      } else e = mn.next;
      var t = hi === null ? Rt.memoizedState : hi.next;
      if (t !== null)
        hi = t, mn = e;
      else {
        if (e === null)
          throw Rt.alternate === null ? Error(
            "Update hook called on initial render. This is likely a bug in React. Please file an issue."
          ) : Error("Rendered more hooks than during the previous render.");
        mn = e, e = {
          memoizedState: mn.memoizedState,
          baseState: mn.baseState,
          baseQueue: mn.baseQueue,
          queue: mn.queue,
          next: null
        }, hi === null ? Rt.memoizedState = hi = e : hi = hi.next = e;
      }
      return hi;
    }
    function Pu() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function ml(e) {
      var t = kf;
      return kf += 1, jl === null && (jl = wm()), e = Ja(jl, e, t), t = Rt, (hi === null ? t.memoizedState : hi.next) === null && (t = t.alternate, le.H = t !== null && t.memoizedState !== null ? AS : BS), e;
    }
    function Br(e) {
      if (e !== null && typeof e == "object") {
        if (typeof e.then == "function") return ml(e);
        if (e.$$typeof === $a) return Sn(e);
      }
      throw Error("An unsupported type was passed to use(): " + String(e));
    }
    function Gn(e) {
      var t = null, i = Rt.updateQueue;
      if (i !== null && (t = i.memoCache), t == null) {
        var l = Rt.alternate;
        l !== null && (l = l.updateQueue, l !== null && (l = l.memoCache, l != null && (t = {
          data: l.data.map(function(u) {
            return u.slice();
          }),
          index: 0
        })));
      }
      if (t == null && (t = { data: [], index: 0 }), i === null && (i = Pu(), Rt.updateQueue = i), i.memoCache = t, i = t.data[t.index], i === void 0 || Df)
        for (i = t.data[t.index] = Array(e), l = 0; l < e; l++)
          i[l] = gg;
      else
        i.length !== e && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          i.length,
          e
        );
      return t.index++, i;
    }
    function zt(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function Ht(e, t, i) {
      var l = Zn();
      if (i !== void 0) {
        var u = i(t);
        if (eu) {
          Ce(!0);
          try {
            i(t);
          } finally {
            Ce(!1);
          }
        }
      } else u = t;
      return l.memoizedState = l.baseState = u, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: u
      }, l.queue = e, e = e.dispatch = Gm.bind(
        null,
        Rt,
        e
      ), [l.memoizedState, e];
    }
    function za(e) {
      var t = Lt();
      return ja(t, mn, e);
    }
    function ja(e, t, i) {
      var l = e.queue;
      if (l === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      l.lastRenderedReducer = i;
      var u = e.baseQueue, m = l.pending;
      if (m !== null) {
        if (u !== null) {
          var S = u.next;
          u.next = m.next, m.next = S;
        }
        t.baseQueue !== u && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        ), t.baseQueue = u = m, l.pending = null;
      }
      if (m = e.baseState, u === null) e.memoizedState = m;
      else {
        t = u.next;
        var U = S = null, D = null, Q = t, ae = !1;
        do {
          var ue = Q.lane & -536870913;
          if (ue !== Q.lane ? (At & ue) === ue : (dd & ue) === ue) {
            var ee = Q.revertLane;
            if (ee === 0)
              D !== null && (D = D.next = {
                lane: 0,
                revertLane: 0,
                action: Q.action,
                hasEagerState: Q.hasEagerState,
                eagerState: Q.eagerState,
                next: null
              }), ue === K0 && (ae = !0);
            else if ((dd & ee) === ee) {
              Q = Q.next, ee === K0 && (ae = !0);
              continue;
            } else
              ue = {
                lane: 0,
                revertLane: Q.revertLane,
                action: Q.action,
                hasEagerState: Q.hasEagerState,
                eagerState: Q.eagerState,
                next: null
              }, D === null ? (U = D = ue, S = m) : D = D.next = ue, Rt.lanes |= ee, md |= ee;
            ue = Q.action, eu && i(m, ue), m = Q.hasEagerState ? Q.eagerState : i(m, ue);
          } else
            ee = {
              lane: ue,
              revertLane: Q.revertLane,
              action: Q.action,
              hasEagerState: Q.hasEagerState,
              eagerState: Q.eagerState,
              next: null
            }, D === null ? (U = D = ee, S = m) : D = D.next = ee, Rt.lanes |= ue, md |= ue;
          Q = Q.next;
        } while (Q !== null && Q !== t);
        if (D === null ? S = m : D.next = U, !Qa(m, e.memoizedState) && (Zi = !0, ae && (i = _h, i !== null)))
          throw i;
        e.memoizedState = m, e.baseState = S, e.baseQueue = D, l.lastRenderedState = m;
      }
      return u === null && (l.lanes = 0), [e.memoizedState, l.dispatch];
    }
    function pl(e) {
      var t = Lt(), i = t.queue;
      if (i === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      i.lastRenderedReducer = e;
      var l = i.dispatch, u = i.pending, m = t.memoizedState;
      if (u !== null) {
        i.pending = null;
        var S = u = u.next;
        do
          m = e(m, S.action), S = S.next;
        while (S !== u);
        Qa(m, t.memoizedState) || (Zi = !0), t.memoizedState = m, t.baseQueue === null && (t.baseState = m), i.lastRenderedState = m;
      }
      return [m, l];
    }
    function ko(e, t, i) {
      var l = Rt, u = Zn();
      if (Gt) {
        if (i === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var m = i();
        Mh || m === i() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), Mh = !0);
      } else {
        if (m = t(), Mh || (i = t(), Qa(m, i) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), Mh = !0)), Rn === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        (At & 124) !== 0 || Im(l, t, m);
      }
      return u.memoizedState = m, i = { value: m, getSnapshot: t }, u.queue = i, Xu(
        yc.bind(null, l, i, e),
        [e]
      ), l.flags |= 2048, Ir(
        fo | yi,
        Us(),
        Tc.bind(
          null,
          l,
          i,
          m,
          t
        ),
        null
      ), m;
    }
    function Yd(e, t, i) {
      var l = Rt, u = Lt(), m = Gt;
      if (m) {
        if (i === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        i = i();
      } else if (i = t(), !Mh) {
        var S = t();
        Qa(i, S) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), Mh = !0);
      }
      (S = !Qa(
        (mn || u).memoizedState,
        i
      )) && (u.memoizedState = i, Zi = !0), u = u.queue;
      var U = yc.bind(null, l, u, e);
      if (ei(2048, yi, U, [e]), u.getSnapshot !== t || S || hi !== null && hi.memoizedState.tag & fo) {
        if (l.flags |= 2048, Ir(
          fo | yi,
          Us(),
          Tc.bind(
            null,
            l,
            u,
            i,
            t
          ),
          null
        ), Rn === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        m || (dd & 124) !== 0 || Im(l, t, i);
      }
      return i;
    }
    function Im(e, t, i) {
      e.flags |= 16384, e = { getSnapshot: t, value: i }, t = Rt.updateQueue, t === null ? (t = Pu(), Rt.updateQueue = t, t.stores = [e]) : (i = t.stores, i === null ? t.stores = [e] : i.push(e));
    }
    function Tc(e, t, i, l) {
      t.value = i, t.getSnapshot = l, Lm(t) && Nc(e);
    }
    function yc(e, t, i) {
      return i(function() {
        Lm(t) && Nc(e);
      });
    }
    function Lm(e) {
      var t = e.getSnapshot;
      e = e.value;
      try {
        var i = t();
        return !Qa(e, i);
      } catch {
        return !0;
      }
    }
    function Nc(e) {
      var t = ia(e, 2);
      t !== null && wn(t, e, 2);
    }
    function Xd(e) {
      var t = Zn();
      if (typeof e == "function") {
        var i = e;
        if (e = i(), eu) {
          Ce(!0);
          try {
            i();
          } finally {
            Ce(!1);
          }
        }
      }
      return t.memoizedState = t.baseState = e, t.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: zt,
        lastRenderedState: e
      }, t;
    }
    function Do(e) {
      e = Xd(e);
      var t = e.queue, i = _c.bind(null, Rt, t);
      return t.dispatch = i, [e.memoizedState, i];
    }
    function gr(e) {
      var t = Zn();
      t.memoizedState = t.baseState = e;
      var i = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = i, t = r1.bind(
        null,
        Rt,
        !0,
        i
      ), i.dispatch = t, [e, t];
    }
    function Qo(e, t) {
      var i = Lt();
      return Ar(i, mn, e, t);
    }
    function Ar(e, t, i, l) {
      return e.baseState = i, ja(
        e,
        mn,
        typeof l == "function" ? l : zt
      );
    }
    function Gu(e, t) {
      var i = Lt();
      return mn !== null ? Ar(i, mn, e, t) : (i.baseState = e, [e, i.queue.dispatch]);
    }
    function Jm(e, t, i, l, u) {
      if (i0(e))
        throw Error("Cannot update form state while rendering.");
      if (e = t.action, e !== null) {
        var m = {
          payload: u,
          action: e,
          next: null,
          isTransition: !0,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(S) {
            m.listeners.push(S);
          }
        };
        le.T !== null ? i(!0) : m.isTransition = !1, l(m), i = t.pending, i === null ? (m.next = t.pending = m, bc(t, m)) : (m.next = i.next, t.pending = i.next = m);
      }
    }
    function bc(e, t) {
      var i = t.action, l = t.payload, u = e.state;
      if (t.isTransition) {
        var m = le.T, S = {};
        le.T = S, le.T._updatedFibers = /* @__PURE__ */ new Set();
        try {
          var U = i(u, l), D = le.S;
          D !== null && D(S, U), Kd(e, t, U);
        } catch (Q) {
          si(e, t, Q);
        } finally {
          le.T = m, m === null && S._updatedFibers && (e = S._updatedFibers.size, S._updatedFibers.clear(), 10 < e);
        }
      } else
        try {
          S = i(u, l), Kd(e, t, S);
        } catch (Q) {
          si(e, t, Q);
        }
    }
    function Kd(e, t, i) {
      i !== null && typeof i == "object" && typeof i.then == "function" ? (i.then(
        function(l) {
          Es(e, t, l);
        },
        function(l) {
          return si(e, t, l);
        }
      ), t.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : Es(e, t, i);
    }
    function Es(e, t, i) {
      t.status = "fulfilled", t.value = i, qd(t), e.state = i, t = e.pending, t !== null && (i = t.next, i === t ? e.pending = null : (i = i.next, t.next = i, bc(e, i)));
    }
    function si(e, t, i) {
      var l = e.pending;
      if (e.pending = null, l !== null) {
        l = l.next;
        do
          t.status = "rejected", t.reason = i, qd(t), t = t.next;
        while (t !== l);
      }
      e.action = null;
    }
    function qd(e) {
      e = e.listeners;
      for (var t = 0; t < e.length; t++) (0, e[t])();
    }
    function Wm(e, t) {
      return t;
    }
    function Cc(e, t) {
      if (Gt) {
        var i = Rn.formState;
        if (i !== null) {
          e: {
            var l = Rt;
            if (Gt) {
              if (Xn) {
                t: {
                  for (var u = Xn, m = Hs; u.nodeType !== 8; ) {
                    if (!m) {
                      u = null;
                      break t;
                    }
                    if (u = Ri(
                      u.nextSibling
                    ), u === null) {
                      u = null;
                      break t;
                    }
                  }
                  m = u.data, u = m === hR || m === b5 ? u : null;
                }
                if (u) {
                  Xn = Ri(
                    u.nextSibling
                  ), l = u.data === hR;
                  break e;
                }
              }
              Qr(l);
            }
            l = !1;
          }
          l && (t = i[0]);
        }
      }
      return i = Zn(), i.memoizedState = i.baseState = t, l = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Wm,
        lastRenderedState: t
      }, i.queue = l, i = _c.bind(
        null,
        Rt,
        l
      ), l.dispatch = i, l = Xd(!1), m = r1.bind(
        null,
        Rt,
        !1,
        l.queue
      ), l = Zn(), u = {
        state: t,
        dispatch: null,
        action: e,
        pending: null
      }, l.queue = u, i = Jm.bind(
        null,
        Rt,
        u,
        m,
        i
      ), u.dispatch = i, l.memoizedState = e, [t, i, !1];
    }
    function Yu(e) {
      var t = Lt();
      return J2(t, mn, e);
    }
    function J2(e, t, i) {
      if (t = ja(
        e,
        t,
        Wm
      )[0], e = za(zt)[0], typeof t == "object" && t !== null && typeof t.then == "function")
        try {
          var l = ml(t);
        } catch (S) {
          throw S === Ff ? Og : S;
        }
      else l = t;
      t = Lt();
      var u = t.queue, m = u.dispatch;
      return i !== t.memoizedState && (Rt.flags |= 2048, Ir(
        fo | yi,
        Us(),
        $n.bind(null, u, i),
        null
      )), [l, m, e];
    }
    function $n(e, t) {
      e.action = t;
    }
    function Vc(e) {
      var t = Lt(), i = mn;
      if (i !== null)
        return J2(t, i, e);
      Lt(), t = t.memoizedState, i = Lt();
      var l = i.queue.dispatch;
      return i.memoizedState = e, [t, l, !1];
    }
    function Ir(e, t, i, l) {
      return e = {
        tag: e,
        create: i,
        deps: l,
        inst: t,
        next: null
      }, t = Rt.updateQueue, t === null && (t = Pu(), Rt.updateQueue = t), i = t.lastEffect, i === null ? t.lastEffect = e.next = e : (l = i.next, i.next = e, e.next = l, t.lastEffect = e), e;
    }
    function Us() {
      return { destroy: void 0, resource: void 0 };
    }
    function $d(e) {
      var t = Zn();
      return e = { current: e }, t.memoizedState = e;
    }
    function Pa(e, t, i, l) {
      var u = Zn();
      l = l === void 0 ? null : l, Rt.flags |= e, u.memoizedState = Ir(
        fo | t,
        Us(),
        i,
        l
      );
    }
    function ei(e, t, i, l) {
      var u = Lt();
      l = l === void 0 ? null : l;
      var m = u.memoizedState.inst;
      mn !== null && l !== null && Ss(l, mn.memoizedState.deps) ? u.memoizedState = Ir(t, m, i, l) : (Rt.flags |= e, u.memoizedState = Ir(
        fo | t,
        m,
        i,
        l
      ));
    }
    function Xu(e, t) {
      (Rt.mode & Xo) !== Vn && (Rt.mode & c3) === Vn ? Pa(276826112, yi, e, t) : Pa(8390656, yi, e, t);
    }
    function Ku(e, t) {
      var i = 4194308;
      return (Rt.mode & Xo) !== Vn && (i |= 134217728), Pa(i, Xi, e, t);
    }
    function W2(e, t) {
      if (typeof t == "function") {
        e = e();
        var i = t(e);
        return function() {
          typeof i == "function" ? i() : t(null);
        };
      }
      if (t != null)
        return t.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(t).join(", ") + "}"
        ), e = e(), t.current = e, function() {
          t.current = null;
        };
    }
    function qu(e, t, i) {
      typeof t != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        t !== null ? typeof t : "null"
      ), i = i != null ? i.concat([e]) : null;
      var l = 4194308;
      (Rt.mode & Xo) !== Vn && (l |= 134217728), Pa(
        l,
        Xi,
        W2.bind(null, t, e),
        i
      );
    }
    function Lr(e, t, i) {
      typeof t != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        t !== null ? typeof t : "null"
      ), i = i != null ? i.concat([e]) : null, ei(
        4,
        Xi,
        W2.bind(null, t, e),
        i
      );
    }
    function e0(e, t) {
      return Zn().memoizedState = [
        e,
        t === void 0 ? null : t
      ], e;
    }
    function fl(e, t) {
      var i = Lt();
      t = t === void 0 ? null : t;
      var l = i.memoizedState;
      return t !== null && Ss(t, l[1]) ? l[0] : (i.memoizedState = [e, t], e);
    }
    function $u(e, t) {
      var i = Zn();
      t = t === void 0 ? null : t;
      var l = e();
      if (eu) {
        Ce(!0);
        try {
          e();
        } finally {
          Ce(!1);
        }
      }
      return i.memoizedState = [l, t], l;
    }
    function Ts(e, t) {
      var i = Lt();
      t = t === void 0 ? null : t;
      var l = i.memoizedState;
      if (t !== null && Ss(t, l[1]))
        return l[0];
      if (l = e(), eu) {
        Ce(!0);
        try {
          e();
        } finally {
          Ce(!1);
        }
      }
      return i.memoizedState = [l, t], l;
    }
    function e1(e, t) {
      var i = Zn();
      return n1(i, e, t);
    }
    function t0(e, t) {
      var i = Lt();
      return n0(
        i,
        mn.memoizedState,
        e,
        t
      );
    }
    function t1(e, t) {
      var i = Lt();
      return mn === null ? n1(i, e, t) : n0(
        i,
        mn.memoizedState,
        e,
        t
      );
    }
    function n1(e, t, i) {
      return i === void 0 || (dd & 1073741824) !== 0 ? e.memoizedState = t : (e.memoizedState = i, e = $2(), Rt.lanes |= e, md |= e, i);
    }
    function n0(e, t, i, l) {
      return Qa(i, t) ? i : Fh.current !== null ? (e = n1(e, i, l), Qa(e, t) || (Zi = !0), e) : (dd & 42) === 0 ? (Zi = !0, e.memoizedState = i) : (e = $2(), Rt.lanes |= e, md |= e, t);
    }
    function Hm(e, t, i, l, u) {
      var m = pt.p;
      pt.p = m !== 0 && m < Tr ? m : Tr;
      var S = le.T, U = {};
      le.T = U, r1(e, !1, t, i), U._updatedFibers = /* @__PURE__ */ new Set();
      try {
        var D = u(), Q = le.S;
        if (Q !== null && Q(U, D), D !== null && typeof D == "object" && typeof D.then == "function") {
          var ae = A2(
            D,
            l
          );
          xo(
            e,
            t,
            ae,
            da(e)
          );
        } else
          xo(
            e,
            t,
            l,
            da(e)
          );
      } catch (ue) {
        xo(
          e,
          t,
          { then: function() {
          }, status: "rejected", reason: ue },
          da(e)
        );
      } finally {
        pt.p = m, le.T = S, S === null && U._updatedFibers && (e = U._updatedFibers.size, U._updatedFibers.clear(), 10 < e);
      }
    }
    function gl(e, t, i, l) {
      if (e.tag !== 5)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var u = zm(e).queue;
      Hm(
        e,
        u,
        t,
        uu,
        i === null ? N : function() {
          return jm(e), i(l);
        }
      );
    }
    function zm(e) {
      var t = e.memoizedState;
      if (t !== null) return t;
      t = {
        memoizedState: uu,
        baseState: uu,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: zt,
          lastRenderedState: uu
        },
        next: null
      };
      var i = {};
      return t.next = {
        memoizedState: i,
        baseState: i,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: zt,
          lastRenderedState: i
        },
        next: null
      }, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
    }
    function jm(e) {
      le.T === null && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var t = zm(e).next.queue;
      xo(
        e,
        t,
        {},
        da(e)
      );
    }
    function Jr() {
      var e = Xd(!1);
      return e = Hm.bind(
        null,
        Rt,
        e.queue,
        !0,
        !1
      ), Zn().memoizedState = e, [!1, e];
    }
    function i1() {
      var e = za(zt)[0], t = Lt().memoizedState;
      return [
        typeof e == "boolean" ? e : ml(e),
        t
      ];
    }
    function a1() {
      var e = pl(zt)[0], t = Lt().memoizedState;
      return [
        typeof e == "boolean" ? e : ml(e),
        t
      ];
    }
    function sa() {
      return Sn(Yf);
    }
    function Wr() {
      var e = Zn(), t = Rn.identifierPrefix;
      if (Gt) {
        var i = Hl, l = Wl;
        i = (l & ~(1 << 32 - Qi(l) - 1)).toString(32) + i, t = "«" + t + "R" + i, i = Ig++, 0 < i && (t += "H" + i.toString(32)), t += "»";
      } else
        i = Iy++, t = "«" + t + "r" + i.toString(32) + "»";
      return e.memoizedState = t;
    }
    function vl() {
      return Zn().memoizedState = Pm.bind(
        null,
        Rt
      );
    }
    function Pm(e, t) {
      for (var i = e.return; i !== null; ) {
        switch (i.tag) {
          case 24:
          case 3:
            var l = da(i);
            e = Or(l);
            var u = mr(i, e, l);
            u !== null && (wn(u, i, l), vs(u, i, l)), i = zd(), t != null && u !== null && console.error(
              "The seed argument is not enabled outside experimental channels."
            ), e.payload = { cache: i };
            return;
        }
        i = i.return;
      }
    }
    function Gm(e, t, i) {
      var l = arguments;
      typeof l[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), l = da(e);
      var u = {
        lane: l,
        revertLane: 0,
        action: i,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      i0(e) ? Sl(t, u) : (u = Tm(e, t, u, l), u !== null && (wn(u, e, l), a0(u, t, l))), hn(e, l);
    }
    function _c(e, t, i) {
      var l = arguments;
      typeof l[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), l = da(e), xo(e, t, i, l), hn(e, l);
    }
    function xo(e, t, i, l) {
      var u = {
        lane: l,
        revertLane: 0,
        action: i,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (i0(e)) Sl(t, u);
      else {
        var m = e.alternate;
        if (e.lanes === 0 && (m === null || m.lanes === 0) && (m = t.lastRenderedReducer, m !== null)) {
          var S = le.H;
          le.H = qo;
          try {
            var U = t.lastRenderedState, D = m(U, i);
            if (u.hasEagerState = !0, u.eagerState = D, Qa(D, U))
              return Au(e, t, u, 0), Rn === null && Id(), !1;
          } catch {
          } finally {
            le.H = S;
          }
        }
        if (i = Tm(e, t, u, l), i !== null)
          return wn(i, e, l), a0(i, t, l), !0;
      }
      return !1;
    }
    function r1(e, t, i, l) {
      if (le.T === null && K0 === 0 && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      ), l = {
        lane: 2,
        revertLane: bp(),
        action: l,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, i0(e)) {
        if (t)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        t = Tm(
          e,
          i,
          l,
          2
        ), t !== null && wn(t, e, 2);
      hn(e, 2);
    }
    function i0(e) {
      var t = e.alternate;
      return e === Rt || t !== null && t === Rt;
    }
    function Sl(e, t) {
      kh = Ag = !0;
      var i = e.pending;
      i === null ? t.next = t : (t.next = i.next, i.next = t), e.pending = t;
    }
    function a0(e, t, i) {
      if ((i & 4194048) !== 0) {
        var l = t.lanes;
        l &= e.pendingLanes, i |= l, t.lanes = i, ta(e, i);
      }
    }
    function li(e) {
      var t = kt;
      return e != null && (kt = t === null ? e : t.concat(e)), t;
    }
    function Fc(e, t, i) {
      for (var l = Object.keys(e.props), u = 0; u < l.length; u++) {
        var m = l[u];
        if (m !== "children" && m !== "key") {
          t === null && (t = Wd(e, i.mode, 0), t._debugInfo = kt, t.return = i), pe(
            t,
            function(S) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                S
              );
            },
            m
          );
          break;
        }
      }
    }
    function Mc(e) {
      var t = Qf;
      return Qf += 1, Dh === null && (Dh = wm()), Ja(Dh, e, t);
    }
    function Ga(e, t) {
      t = t.props.ref, e.ref = t !== void 0 ? t : null;
    }
    function Et(e, t) {
      throw t.$$typeof === x0 ? Error(
        `A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`
      ) : (e = Object.prototype.toString.call(t), Error(
        "Objects are not valid as a React child (found: " + (e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e) + "). If you meant to render a collection of children, use an array instead."
      ));
    }
    function Kt(e, t) {
      var i = Fe(e) || "Component";
      J3[i] || (J3[i] = !0, t = t.displayName || t.name || "Component", e.tag === 3 ? console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`,
        t,
        t,
        t
      ) : console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`,
        t,
        t,
        i,
        t,
        i
      ));
    }
    function Dn(e, t) {
      var i = Fe(e) || "Component";
      W3[i] || (W3[i] = !0, t = String(t), e.tag === 3 ? console.error(
        `Symbols are not valid as a React child.
  root.render(%s)`,
        t
      ) : console.error(
        `Symbols are not valid as a React child.
  <%s>%s</%s>`,
        i,
        t,
        i
      ));
    }
    function r0(e) {
      function t(A, I) {
        if (e) {
          var L = A.deletions;
          L === null ? (A.deletions = [I], A.flags |= 16) : L.push(I);
        }
      }
      function i(A, I) {
        if (!e) return null;
        for (; I !== null; )
          t(A, I), I = I.sibling;
        return null;
      }
      function l(A) {
        for (var I = /* @__PURE__ */ new Map(); A !== null; )
          A.key !== null ? I.set(A.key, A) : I.set(A.index, A), A = A.sibling;
        return I;
      }
      function u(A, I) {
        return A = Dr(A, I), A.index = 0, A.sibling = null, A;
      }
      function m(A, I, L) {
        return A.index = L, e ? (L = A.alternate, L !== null ? (L = L.index, L < I ? (A.flags |= 67108866, I) : L) : (A.flags |= 67108866, I)) : (A.flags |= 1048576, I);
      }
      function S(A) {
        return e && A.alternate === null && (A.flags |= 67108866), A;
      }
      function U(A, I, L, fe) {
        return I === null || I.tag !== 6 ? (I = us(
          L,
          A.mode,
          fe
        ), I.return = A, I._debugOwner = A, I._debugTask = A._debugTask, I._debugInfo = kt, I) : (I = u(I, L), I.return = A, I._debugInfo = kt, I);
      }
      function D(A, I, L, fe) {
        var Le = L.type;
        return Le === Ut ? (I = ae(
          A,
          I,
          L.props.children,
          fe,
          L.key
        ), Fc(L, I, A), I) : I !== null && (I.elementType === Le || Z2(I, L) || typeof Le == "object" && Le !== null && Le.$$typeof === ka && ud(Le) === I.type) ? (I = u(I, L.props), Ga(I, L), I.return = A, I._debugOwner = L._owner, I._debugInfo = kt, I) : (I = Wd(L, A.mode, fe), Ga(I, L), I.return = A, I._debugInfo = kt, I);
      }
      function Q(A, I, L, fe) {
        return I === null || I.tag !== 4 || I.stateNode.containerInfo !== L.containerInfo || I.stateNode.implementation !== L.implementation ? (I = Cm(L, A.mode, fe), I.return = A, I._debugInfo = kt, I) : (I = u(I, L.children || []), I.return = A, I._debugInfo = kt, I);
      }
      function ae(A, I, L, fe, Le) {
        return I === null || I.tag !== 7 ? (I = ds(
          L,
          A.mode,
          fe,
          Le
        ), I.return = A, I._debugOwner = A, I._debugTask = A._debugTask, I._debugInfo = kt, I) : (I = u(I, L), I.return = A, I._debugInfo = kt, I);
      }
      function ue(A, I, L) {
        if (typeof I == "string" && I !== "" || typeof I == "number" || typeof I == "bigint")
          return I = us(
            "" + I,
            A.mode,
            L
          ), I.return = A, I._debugOwner = A, I._debugTask = A._debugTask, I._debugInfo = kt, I;
        if (typeof I == "object" && I !== null) {
          switch (I.$$typeof) {
            case Zs:
              return L = Wd(
                I,
                A.mode,
                L
              ), Ga(L, I), L.return = A, A = li(I._debugInfo), L._debugInfo = kt, kt = A, L;
            case wl:
              return I = Cm(
                I,
                A.mode,
                L
              ), I.return = A, I._debugInfo = kt, I;
            case ka:
              var fe = li(I._debugInfo);
              return I = ud(I), A = ue(A, I, L), kt = fe, A;
          }
          if (St(I) || Te(I))
            return L = ds(
              I,
              A.mode,
              L,
              null
            ), L.return = A, L._debugOwner = A, L._debugTask = A._debugTask, A = li(I._debugInfo), L._debugInfo = kt, kt = A, L;
          if (typeof I.then == "function")
            return fe = li(I._debugInfo), A = ue(
              A,
              Mc(I),
              L
            ), kt = fe, A;
          if (I.$$typeof === $a)
            return ue(
              A,
              Hd(A, I),
              L
            );
          Et(A, I);
        }
        return typeof I == "function" && Kt(A, I), typeof I == "symbol" && Dn(A, I), null;
      }
      function ee(A, I, L, fe) {
        var Le = I !== null ? I.key : null;
        if (typeof L == "string" && L !== "" || typeof L == "number" || typeof L == "bigint")
          return Le !== null ? null : U(A, I, "" + L, fe);
        if (typeof L == "object" && L !== null) {
          switch (L.$$typeof) {
            case Zs:
              return L.key === Le ? (Le = li(L._debugInfo), A = D(
                A,
                I,
                L,
                fe
              ), kt = Le, A) : null;
            case wl:
              return L.key === Le ? Q(A, I, L, fe) : null;
            case ka:
              return Le = li(L._debugInfo), L = ud(L), A = ee(
                A,
                I,
                L,
                fe
              ), kt = Le, A;
          }
          if (St(L) || Te(L))
            return Le !== null ? null : (Le = li(L._debugInfo), A = ae(
              A,
              I,
              L,
              fe,
              null
            ), kt = Le, A);
          if (typeof L.then == "function")
            return Le = li(L._debugInfo), A = ee(
              A,
              I,
              Mc(L),
              fe
            ), kt = Le, A;
          if (L.$$typeof === $a)
            return ee(
              A,
              I,
              Hd(A, L),
              fe
            );
          Et(A, L);
        }
        return typeof L == "function" && Kt(A, L), typeof L == "symbol" && Dn(A, L), null;
      }
      function me(A, I, L, fe, Le) {
        if (typeof fe == "string" && fe !== "" || typeof fe == "number" || typeof fe == "bigint")
          return A = A.get(L) || null, U(I, A, "" + fe, Le);
        if (typeof fe == "object" && fe !== null) {
          switch (fe.$$typeof) {
            case Zs:
              return L = A.get(
                fe.key === null ? L : fe.key
              ) || null, A = li(fe._debugInfo), I = D(
                I,
                L,
                fe,
                Le
              ), kt = A, I;
            case wl:
              return A = A.get(
                fe.key === null ? L : fe.key
              ) || null, Q(I, A, fe, Le);
            case ka:
              var Tt = li(fe._debugInfo);
              return fe = ud(fe), I = me(
                A,
                I,
                L,
                fe,
                Le
              ), kt = Tt, I;
          }
          if (St(fe) || Te(fe))
            return L = A.get(L) || null, A = li(fe._debugInfo), I = ae(
              I,
              L,
              fe,
              Le,
              null
            ), kt = A, I;
          if (typeof fe.then == "function")
            return Tt = li(fe._debugInfo), I = me(
              A,
              I,
              L,
              Mc(fe),
              Le
            ), kt = Tt, I;
          if (fe.$$typeof === $a)
            return me(
              A,
              I,
              L,
              Hd(I, fe),
              Le
            );
          Et(I, fe);
        }
        return typeof fe == "function" && Kt(I, fe), typeof fe == "symbol" && Dn(I, fe), null;
      }
      function qe(A, I, L, fe) {
        if (typeof L != "object" || L === null) return fe;
        switch (L.$$typeof) {
          case Zs:
          case wl:
            T(A, I, L);
            var Le = L.key;
            if (typeof Le != "string") break;
            if (fe === null) {
              fe = /* @__PURE__ */ new Set(), fe.add(Le);
              break;
            }
            if (!fe.has(Le)) {
              fe.add(Le);
              break;
            }
            pe(I, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                Le
              );
            });
            break;
          case ka:
            L = ud(L), qe(A, I, L, fe);
        }
        return fe;
      }
      function ft(A, I, L, fe) {
        for (var Le = null, Tt = null, $e = null, yt = I, Nt = I = 0, _n = null; yt !== null && Nt < L.length; Nt++) {
          yt.index > Nt ? (_n = yt, yt = null) : _n = yt.sibling;
          var ai = ee(
            A,
            yt,
            L[Nt],
            fe
          );
          if (ai === null) {
            yt === null && (yt = _n);
            break;
          }
          Le = qe(
            A,
            ai,
            L[Nt],
            Le
          ), e && yt && ai.alternate === null && t(A, yt), I = m(ai, I, Nt), $e === null ? Tt = ai : $e.sibling = ai, $e = ai, yt = _n;
        }
        if (Nt === L.length)
          return i(A, yt), Gt && sl(A, Nt), Tt;
        if (yt === null) {
          for (; Nt < L.length; Nt++)
            yt = ue(A, L[Nt], fe), yt !== null && (Le = qe(
              A,
              yt,
              L[Nt],
              Le
            ), I = m(
              yt,
              I,
              Nt
            ), $e === null ? Tt = yt : $e.sibling = yt, $e = yt);
          return Gt && sl(A, Nt), Tt;
        }
        for (yt = l(yt); Nt < L.length; Nt++)
          _n = me(
            yt,
            A,
            Nt,
            L[Nt],
            fe
          ), _n !== null && (Le = qe(
            A,
            _n,
            L[Nt],
            Le
          ), e && _n.alternate !== null && yt.delete(
            _n.key === null ? Nt : _n.key
          ), I = m(
            _n,
            I,
            Nt
          ), $e === null ? Tt = _n : $e.sibling = _n, $e = _n);
        return e && yt.forEach(function($l) {
          return t(A, $l);
        }), Gt && sl(A, Nt), Tt;
      }
      function En(A, I, L, fe) {
        if (L == null)
          throw Error("An iterable object provided no iterator.");
        for (var Le = null, Tt = null, $e = I, yt = I = 0, Nt = null, _n = null, ai = L.next(); $e !== null && !ai.done; yt++, ai = L.next()) {
          $e.index > yt ? (Nt = $e, $e = null) : Nt = $e.sibling;
          var $l = ee(A, $e, ai.value, fe);
          if ($l === null) {
            $e === null && ($e = Nt);
            break;
          }
          _n = qe(
            A,
            $l,
            ai.value,
            _n
          ), e && $e && $l.alternate === null && t(A, $e), I = m($l, I, yt), Tt === null ? Le = $l : Tt.sibling = $l, Tt = $l, $e = Nt;
        }
        if (ai.done)
          return i(A, $e), Gt && sl(A, yt), Le;
        if ($e === null) {
          for (; !ai.done; yt++, ai = L.next())
            $e = ue(A, ai.value, fe), $e !== null && (_n = qe(
              A,
              $e,
              ai.value,
              _n
            ), I = m(
              $e,
              I,
              yt
            ), Tt === null ? Le = $e : Tt.sibling = $e, Tt = $e);
          return Gt && sl(A, yt), Le;
        }
        for ($e = l($e); !ai.done; yt++, ai = L.next())
          Nt = me(
            $e,
            A,
            yt,
            ai.value,
            fe
          ), Nt !== null && (_n = qe(
            A,
            Nt,
            ai.value,
            _n
          ), e && Nt.alternate !== null && $e.delete(
            Nt.key === null ? yt : Nt.key
          ), I = m(
            Nt,
            I,
            yt
          ), Tt === null ? Le = Nt : Tt.sibling = Nt, Tt = Nt);
        return e && $e.forEach(function(m4) {
          return t(A, m4);
        }), Gt && sl(A, yt), Le;
      }
      function Jt(A, I, L, fe) {
        if (typeof L == "object" && L !== null && L.type === Ut && L.key === null && (Fc(L, null, A), L = L.props.children), typeof L == "object" && L !== null) {
          switch (L.$$typeof) {
            case Zs:
              var Le = li(L._debugInfo);
              e: {
                for (var Tt = L.key; I !== null; ) {
                  if (I.key === Tt) {
                    if (Tt = L.type, Tt === Ut) {
                      if (I.tag === 7) {
                        i(
                          A,
                          I.sibling
                        ), fe = u(
                          I,
                          L.props.children
                        ), fe.return = A, fe._debugOwner = L._owner, fe._debugInfo = kt, Fc(L, fe, A), A = fe;
                        break e;
                      }
                    } else if (I.elementType === Tt || Z2(
                      I,
                      L
                    ) || typeof Tt == "object" && Tt !== null && Tt.$$typeof === ka && ud(Tt) === I.type) {
                      i(
                        A,
                        I.sibling
                      ), fe = u(I, L.props), Ga(fe, L), fe.return = A, fe._debugOwner = L._owner, fe._debugInfo = kt, A = fe;
                      break e;
                    }
                    i(A, I);
                    break;
                  } else t(A, I);
                  I = I.sibling;
                }
                L.type === Ut ? (fe = ds(
                  L.props.children,
                  A.mode,
                  fe,
                  L.key
                ), fe.return = A, fe._debugOwner = A, fe._debugTask = A._debugTask, fe._debugInfo = kt, Fc(L, fe, A), A = fe) : (fe = Wd(
                  L,
                  A.mode,
                  fe
                ), Ga(fe, L), fe.return = A, fe._debugInfo = kt, A = fe);
              }
              return A = S(A), kt = Le, A;
            case wl:
              e: {
                for (Le = L, L = Le.key; I !== null; ) {
                  if (I.key === L)
                    if (I.tag === 4 && I.stateNode.containerInfo === Le.containerInfo && I.stateNode.implementation === Le.implementation) {
                      i(
                        A,
                        I.sibling
                      ), fe = u(
                        I,
                        Le.children || []
                      ), fe.return = A, A = fe;
                      break e;
                    } else {
                      i(A, I);
                      break;
                    }
                  else t(A, I);
                  I = I.sibling;
                }
                fe = Cm(
                  Le,
                  A.mode,
                  fe
                ), fe.return = A, A = fe;
              }
              return S(A);
            case ka:
              return Le = li(L._debugInfo), L = ud(L), A = Jt(
                A,
                I,
                L,
                fe
              ), kt = Le, A;
          }
          if (St(L))
            return Le = li(L._debugInfo), A = ft(
              A,
              I,
              L,
              fe
            ), kt = Le, A;
          if (Te(L)) {
            if (Le = li(L._debugInfo), Tt = Te(L), typeof Tt != "function")
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var $e = Tt.call(L);
            return $e === L ? (A.tag !== 0 || Object.prototype.toString.call(A.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call($e) !== "[object Generator]") && (I3 || console.error(
              "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
            ), I3 = !0) : L.entries !== Tt || JS || (console.error(
              "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
            ), JS = !0), A = En(
              A,
              I,
              $e,
              fe
            ), kt = Le, A;
          }
          if (typeof L.then == "function")
            return Le = li(L._debugInfo), A = Jt(
              A,
              I,
              Mc(L),
              fe
            ), kt = Le, A;
          if (L.$$typeof === $a)
            return Jt(
              A,
              I,
              Hd(A, L),
              fe
            );
          Et(A, L);
        }
        return typeof L == "string" && L !== "" || typeof L == "number" || typeof L == "bigint" ? (Le = "" + L, I !== null && I.tag === 6 ? (i(
          A,
          I.sibling
        ), fe = u(I, Le), fe.return = A, A = fe) : (i(A, I), fe = us(
          Le,
          A.mode,
          fe
        ), fe.return = A, fe._debugOwner = A, fe._debugTask = A._debugTask, fe._debugInfo = kt, A = fe), S(A)) : (typeof L == "function" && Kt(A, L), typeof L == "symbol" && Dn(A, L), i(A, I));
      }
      return function(A, I, L, fe) {
        var Le = kt;
        kt = null;
        try {
          Qf = 0;
          var Tt = Jt(
            A,
            I,
            L,
            fe
          );
          return Dh = null, Tt;
        } catch (_n) {
          if (_n === Ff || _n === Og) throw _n;
          var $e = V(29, _n, null, A.mode);
          $e.lanes = fe, $e.return = A;
          var yt = $e._debugInfo = kt;
          if ($e._debugOwner = A._debugOwner, $e._debugTask = A._debugTask, yt != null) {
            for (var Nt = yt.length - 1; 0 <= Nt; Nt--)
              if (typeof yt[Nt].stack == "string") {
                $e._debugOwner = yt[Nt], $e._debugTask = yt[Nt].debugTask;
                break;
              }
          }
          return $e;
        } finally {
          kt = Le;
        }
      };
    }
    function Ca(e) {
      var t = e.alternate;
      we(
        Ni,
        Ni.current & xh,
        e
      ), we(vo, e, e), js === null && (t === null || Fh.current !== null || t.memoizedState !== null) && (js = e);
    }
    function ys(e) {
      if (e.tag === 22) {
        if (we(Ni, Ni.current, e), we(vo, e, e), js === null) {
          var t = e.alternate;
          t !== null && t.memoizedState !== null && (js = e);
        }
      } else vr(e);
    }
    function vr(e) {
      we(Ni, Ni.current, e), we(
        vo,
        vo.current,
        e
      );
    }
    function Va(e) {
      Ve(vo, e), js === e && (js = null), Ve(Ni, e);
    }
    function Zo(e) {
      for (var t = e; t !== null; ) {
        if (t.tag === 13) {
          var i = t.memoizedState;
          if (i !== null && (i = i.dehydrated, i === null || i.data === Xl || no(i)))
            return t;
        } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
          if ((t.flags & 128) !== 0) return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    function Ym(e) {
      if (e !== null && typeof e != "function") {
        var t = String(e);
        t5.has(t) || (t5.add(t), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          e
        ));
      }
    }
    function Qn(e, t, i, l) {
      var u = e.memoizedState, m = i(l, u);
      if (e.mode & va) {
        Ce(!0);
        try {
          m = i(l, u);
        } finally {
          Ce(!1);
        }
      }
      m === void 0 && (t = Ne(t) || "Component", K3.has(t) || (K3.add(t), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        t
      ))), u = m == null ? u : Ct({}, u, m), e.memoizedState = u, e.lanes === 0 && (e.updateQueue.baseState = u);
    }
    function o1(e, t, i, l, u, m, S) {
      var U = e.stateNode;
      if (typeof U.shouldComponentUpdate == "function") {
        if (i = U.shouldComponentUpdate(
          l,
          m,
          S
        ), e.mode & va) {
          Ce(!0);
          try {
            i = U.shouldComponentUpdate(
              l,
              m,
              S
            );
          } finally {
            Ce(!1);
          }
        }
        return i === void 0 && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          Ne(t) || "Component"
        ), i;
      }
      return t.prototype && t.prototype.isPureReactComponent ? !Ad(i, l) || !Ad(u, m) : !0;
    }
    function s1(e, t, i, l) {
      var u = t.state;
      typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(i, l), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(i, l), t.state !== u && (e = Fe(e) || "Component", j3.has(e) || (j3.add(e), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        e
      )), WS.enqueueReplaceState(
        t,
        t.state,
        null
      ));
    }
    function Ns(e, t) {
      var i = t;
      if ("ref" in t) {
        i = {};
        for (var l in t)
          l !== "ref" && (i[l] = t[l]);
      }
      if (e = e.defaultProps) {
        i === t && (i = Ct({}, i));
        for (var u in e)
          i[u] === void 0 && (i[u] = e[u]);
      }
      return i;
    }
    function Xm(e) {
      HS(e), Zh && "" + Zh;
    }
    function H2(e) {
      var t = Zh ? "The above error occurred in the <" + Zh + "> component." : "The above error occurred in one of your React components.", i = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((zS || "Anonymous") + ".");
      if (typeof e == "object" && e !== null && typeof e.environmentName == "string") {
        var l = e.environmentName;
        e = [
          `%o

%s

%s
`,
          e,
          t,
          i
        ].slice(0), typeof e[0] == "string" ? e.splice(
          0,
          1,
          Q5 + e[0],
          x5,
          ov + l + ov,
          Z5
        ) : e.splice(
          0,
          0,
          Q5,
          x5,
          ov + l + ov,
          Z5
        ), e.unshift(console), l = u4.apply(console.error, e), l();
      } else
        console.error(
          `%o

%s

%s
`,
          e,
          t,
          i
        );
    }
    function l1(e) {
      HS(e);
    }
    function kc(e, t) {
      try {
        Zh = t.source ? Fe(t.source) : null, zS = null;
        var i = t.value;
        if (le.actQueue !== null)
          le.thrownErrors.push(i);
        else {
          var l = e.onUncaughtError;
          l(i, { componentStack: t.stack });
        }
      } catch (u) {
        setTimeout(function() {
          throw u;
        });
      }
    }
    function c1(e, t, i) {
      try {
        Zh = i.source ? Fe(i.source) : null, zS = Fe(t);
        var l = e.onCaughtError;
        l(i.value, {
          componentStack: i.stack,
          errorBoundary: t.tag === 1 ? t.stateNode : null
        });
      } catch (u) {
        setTimeout(function() {
          throw u;
        });
      }
    }
    function Mi(e, t, i) {
      return i = Or(i), i.tag = xS, i.payload = { element: null }, i.callback = function() {
        pe(t.source, kc, e, t);
      }, i;
    }
    function On(e) {
      return e = Or(e), e.tag = xS, e;
    }
    function o0(e, t, i, l) {
      var u = i.type.getDerivedStateFromError;
      if (typeof u == "function") {
        var m = l.value;
        e.payload = function() {
          return u(m);
        }, e.callback = function() {
          O2(i), pe(
            l.source,
            c1,
            t,
            i,
            l
          );
        };
      }
      var S = i.stateNode;
      S !== null && typeof S.componentDidCatch == "function" && (e.callback = function() {
        O2(i), pe(
          l.source,
          c1,
          t,
          i,
          l
        ), typeof u != "function" && (fd === null ? fd = /* @__PURE__ */ new Set([this]) : fd.add(this)), Jy(this, l), typeof u == "function" || (i.lanes & 2) === 0 && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          Fe(i) || "Unknown"
        );
      });
    }
    function s0(e, t, i, l, u) {
      if (i.flags |= 32768, Jn && Ac(e, u), l !== null && typeof l == "object" && typeof l.then == "function") {
        if (t = i.alternate, t !== null && fi(
          t,
          i,
          u,
          !0
        ), Gt && (zl = !0), i = vo.current, i !== null) {
          switch (i.tag) {
            case 13:
              return js === null ? F1() : i.alternate === null && Kn === Yl && (Kn = YS), i.flags &= -257, i.flags |= 65536, i.lanes = u, l === QS ? i.flags |= 16384 : (t = i.updateQueue, t === null ? i.updateQueue = /* @__PURE__ */ new Set([l]) : t.add(l), Up(e, l, u)), !1;
            case 22:
              return i.flags |= 65536, l === QS ? i.flags |= 16384 : (t = i.updateQueue, t === null ? (t = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([l])
              }, i.updateQueue = t) : (i = t.retryQueue, i === null ? t.retryQueue = /* @__PURE__ */ new Set([l]) : i.add(l)), Up(e, l, u)), !1;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + i.tag + "). This is a bug in React."
          );
        }
        return Up(e, l, u), F1(), !1;
      }
      if (Gt)
        return zl = !0, t = vo.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = u, l !== FS && fc(
          Na(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: l }
            ),
            i
          )
        )) : (l !== FS && fc(
          Na(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: l }
            ),
            i
          )
        ), e = e.current.alternate, e.flags |= 65536, u &= -u, e.lanes |= u, l = Na(l, i), u = Mi(
          e.stateNode,
          l,
          u
        ), vc(e, u), Kn !== tu && (Kn = Ah)), !1;
      var m = Na(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: l }
        ),
        i
      );
      if (Lf === null ? Lf = [m] : Lf.push(m), Kn !== tu && (Kn = Ah), t === null) return !0;
      l = Na(l, i), i = t;
      do {
        switch (i.tag) {
          case 3:
            return i.flags |= 65536, e = u & -u, i.lanes |= e, e = Mi(
              i.stateNode,
              l,
              e
            ), vc(i, e), !1;
          case 1:
            if (t = i.type, m = i.stateNode, (i.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || m !== null && typeof m.componentDidCatch == "function" && (fd === null || !fd.has(m))))
              return i.flags |= 65536, u &= -u, i.lanes |= u, u = On(u), o0(
                u,
                e,
                i,
                l
              ), vc(i, u), !1;
        }
        i = i.return;
      } while (i !== null);
      return !1;
    }
    function Yn(e, t, i, l) {
      t.child = e === null ? H3(t, null, i, l) : Qh(
        t,
        e.child,
        i,
        l
      );
    }
    function d1(e, t, i, l, u) {
      i = i.render;
      var m = t.ref;
      if ("ref" in l) {
        var S = {};
        for (var U in l)
          U !== "ref" && (S[U] = l[U]);
      } else S = l;
      return ps(t), dt(t), l = Rs(
        e,
        t,
        i,
        S,
        m,
        u
      ), U = oa(), dn(), e !== null && !Zi ? (Mo(e, t, u), zr(e, t, u)) : (Gt && U && Ju(t), t.flags |= 1, Yn(e, t, l, u), t.child);
    }
    function Hr(e, t, i, l, u) {
      if (e === null) {
        var m = i.type;
        return typeof m == "function" && !Nm(m) && m.defaultProps === void 0 && i.compare === null ? (i = ol(m), t.tag = 15, t.type = i, p1(t, m), l0(
          e,
          t,
          i,
          l,
          u
        )) : (e = Lu(
          i.type,
          null,
          l,
          t,
          t.mode,
          u
        ), e.ref = t.ref, e.return = t, t.child = e);
      }
      if (m = e.child, !E1(e, u)) {
        var S = m.memoizedProps;
        if (i = i.compare, i = i !== null ? i : Ad, i(S, l) && e.ref === t.ref)
          return zr(
            e,
            t,
            u
          );
      }
      return t.flags |= 1, e = Dr(m, l), e.ref = t.ref, e.return = t, t.child = e;
    }
    function l0(e, t, i, l, u) {
      if (e !== null) {
        var m = e.memoizedProps;
        if (Ad(m, l) && e.ref === t.ref && t.type === e.type)
          if (Zi = !1, t.pendingProps = l = m, E1(e, u))
            (e.flags & 131072) !== 0 && (Zi = !0);
          else
            return t.lanes = e.lanes, zr(e, t, u);
      }
      return m1(
        e,
        t,
        i,
        l,
        u
      );
    }
    function u1(e, t, i) {
      var l = t.pendingProps, u = l.children, m = e !== null ? e.memoizedState : null;
      if (l.mode === "hidden") {
        if ((t.flags & 128) !== 0) {
          if (l = m !== null ? m.baseLanes | i : i, e !== null) {
            for (u = t.child = e.child, m = 0; u !== null; )
              m = m | u.lanes | u.childLanes, u = u.sibling;
            t.childLanes = m & ~l;
          } else t.childLanes = 0, t.child = null;
          return h1(
            e,
            t,
            l,
            i
          );
        }
        if ((i & 536870912) !== 0)
          t.memoizedState = { baseLanes: 0, cachePool: null }, e !== null && ju(
            t,
            m !== null ? m.cachePool : null
          ), m !== null ? ra(t, m) : Pd(t), ys(t);
        else
          return t.lanes = t.childLanes = 536870912, h1(
            e,
            t,
            m !== null ? m.baseLanes | i : i,
            i
          );
      } else
        m !== null ? (ju(t, m.cachePool), ra(t, m), vr(t), t.memoizedState = null) : (e !== null && ju(t, null), Pd(t), vr(t));
      return Yn(e, t, u, i), t.child;
    }
    function h1(e, t, i, l) {
      var u = Om();
      return u = u === null ? null : {
        parent: Ti._currentValue,
        pool: u
      }, t.memoizedState = {
        baseLanes: i,
        cachePool: u
      }, e !== null && ju(t, null), Pd(t), ys(t), e !== null && fi(e, t, l, !0), null;
    }
    function c0(e, t) {
      var i = t.ref;
      if (i === null)
        e !== null && e.ref !== null && (t.flags |= 4194816);
      else {
        if (typeof i != "function" && typeof i != "object")
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        (e === null || e.ref !== i) && (t.flags |= 4194816);
      }
    }
    function m1(e, t, i, l, u) {
      if (i.prototype && typeof i.prototype.render == "function") {
        var m = Ne(i) || "Unknown";
        i5[m] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          m,
          m
        ), i5[m] = !0);
      }
      return t.mode & va && Ko.recordLegacyContextWarning(
        t,
        null
      ), e === null && (p1(t, t.type), i.contextTypes && (m = Ne(i) || "Unknown", r5[m] || (r5[m] = !0, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        m
      )))), ps(t), dt(t), i = Rs(
        e,
        t,
        i,
        l,
        void 0,
        u
      ), l = oa(), dn(), e !== null && !Zi ? (Mo(e, t, u), zr(e, t, u)) : (Gt && l && Ju(t), t.flags |= 1, Yn(e, t, i, u), t.child);
    }
    function Km(e, t, i, l, u, m) {
      return ps(t), dt(t), Pl = -1, Df = e !== null && e.type !== t.type, t.updateQueue = null, i = Uc(
        t,
        l,
        i,
        u
      ), Gd(e, t), l = oa(), dn(), e !== null && !Zi ? (Mo(e, t, m), zr(e, t, m)) : (Gt && l && Ju(t), t.flags |= 1, Yn(e, t, i, m), t.child);
    }
    function qm(e, t, i, l, u) {
      switch (R(t)) {
        case !1:
          var m = t.stateNode, S = new t.type(
            t.memoizedProps,
            m.context
          ).state;
          m.updater.enqueueSetState(m, S, null);
          break;
        case !0:
          t.flags |= 128, t.flags |= 65536, m = Error("Simulated error coming from DevTools");
          var U = u & -u;
          if (t.lanes |= U, S = Rn, S === null)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          U = On(U), o0(
            U,
            S,
            t,
            Na(m, t)
          ), vc(t, U);
      }
      if (ps(t), t.stateNode === null) {
        if (S = ld, m = i.contextType, "contextType" in i && m !== null && (m === void 0 || m.$$typeof !== $a) && !e5.has(i) && (e5.add(i), U = m === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof m != "object" ? " However, it is set to a " + typeof m + "." : m.$$typeof === nh ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(m).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          Ne(i) || "Component",
          U
        )), typeof m == "object" && m !== null && (S = Sn(m)), m = new i(l, S), t.mode & va) {
          Ce(!0);
          try {
            m = new i(l, S);
          } finally {
            Ce(!1);
          }
        }
        if (S = t.memoizedState = m.state !== null && m.state !== void 0 ? m.state : null, m.updater = WS, t.stateNode = m, m._reactInternals = t, m._reactInternalInstance = z3, typeof i.getDerivedStateFromProps == "function" && S === null && (S = Ne(i) || "Component", P3.has(S) || (P3.add(S), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          S,
          m.state === null ? "null" : "undefined",
          S
        ))), typeof i.getDerivedStateFromProps == "function" || typeof m.getSnapshotBeforeUpdate == "function") {
          var D = U = S = null;
          if (typeof m.componentWillMount == "function" && m.componentWillMount.__suppressDeprecationWarning !== !0 ? S = "componentWillMount" : typeof m.UNSAFE_componentWillMount == "function" && (S = "UNSAFE_componentWillMount"), typeof m.componentWillReceiveProps == "function" && m.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? U = "componentWillReceiveProps" : typeof m.UNSAFE_componentWillReceiveProps == "function" && (U = "UNSAFE_componentWillReceiveProps"), typeof m.componentWillUpdate == "function" && m.componentWillUpdate.__suppressDeprecationWarning !== !0 ? D = "componentWillUpdate" : typeof m.UNSAFE_componentWillUpdate == "function" && (D = "UNSAFE_componentWillUpdate"), S !== null || U !== null || D !== null) {
            m = Ne(i) || "Component";
            var Q = typeof i.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Y3.has(m) || (Y3.add(m), console.error(
              `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
              m,
              Q,
              S !== null ? `
  ` + S : "",
              U !== null ? `
  ` + U : "",
              D !== null ? `
  ` + D : ""
            ));
          }
        }
        m = t.stateNode, S = Ne(i) || "Component", m.render || (i.prototype && typeof i.prototype.render == "function" ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          S
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          S
        )), !m.getInitialState || m.getInitialState.isReactClassApproved || m.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          S
        ), m.getDefaultProps && !m.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          S
        ), m.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          S
        ), i.childContextTypes && !$3.has(i) && ($3.add(i), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          S
        )), i.contextTypes && !q3.has(i) && (q3.add(i), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          S
        )), typeof m.componentShouldUpdate == "function" && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          S
        ), i.prototype && i.prototype.isPureReactComponent && typeof m.shouldComponentUpdate < "u" && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          Ne(i) || "A pure component"
        ), typeof m.componentDidUnmount == "function" && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          S
        ), typeof m.componentDidReceiveProps == "function" && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          S
        ), typeof m.componentWillRecieveProps == "function" && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          S
        ), typeof m.UNSAFE_componentWillRecieveProps == "function" && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          S
        ), U = m.props !== l, m.props !== void 0 && U && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          S
        ), m.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          S,
          S
        ), typeof m.getSnapshotBeforeUpdate != "function" || typeof m.componentDidUpdate == "function" || G3.has(i) || (G3.add(i), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          Ne(i)
        )), typeof m.getDerivedStateFromProps == "function" && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          S
        ), typeof m.getDerivedStateFromError == "function" && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          S
        ), typeof i.getSnapshotBeforeUpdate == "function" && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          S
        ), (U = m.state) && (typeof U != "object" || St(U)) && console.error("%s.state: must be set to an object or null", S), typeof m.getChildContext == "function" && typeof i.childContextTypes != "object" && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          S
        ), m = t.stateNode, m.props = l, m.state = t.memoizedState, m.refs = {}, aa(t), S = i.contextType, m.context = typeof S == "object" && S !== null ? Sn(S) : ld, m.state === l && (S = Ne(i) || "Component", X3.has(S) || (X3.add(S), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          S
        ))), t.mode & va && Ko.recordLegacyContextWarning(
          t,
          m
        ), Ko.recordUnsafeLifecycleWarnings(
          t,
          m
        ), m.state = t.memoizedState, S = i.getDerivedStateFromProps, typeof S == "function" && (Qn(
          t,
          i,
          S,
          l
        ), m.state = t.memoizedState), typeof i.getDerivedStateFromProps == "function" || typeof m.getSnapshotBeforeUpdate == "function" || typeof m.UNSAFE_componentWillMount != "function" && typeof m.componentWillMount != "function" || (S = m.state, typeof m.componentWillMount == "function" && m.componentWillMount(), typeof m.UNSAFE_componentWillMount == "function" && m.UNSAFE_componentWillMount(), S !== m.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          Fe(t) || "Component"
        ), WS.enqueueReplaceState(
          m,
          m.state,
          null
        )), Sc(t, l, m, u), wr(), m.state = t.memoizedState), typeof m.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & Xo) !== Vn && (t.flags |= 134217728), m = !0;
      } else if (e === null) {
        m = t.stateNode;
        var ae = t.memoizedProps;
        U = Ns(i, ae), m.props = U;
        var ue = m.context;
        D = i.contextType, S = ld, typeof D == "object" && D !== null && (S = Sn(D)), Q = i.getDerivedStateFromProps, D = typeof Q == "function" || typeof m.getSnapshotBeforeUpdate == "function", ae = t.pendingProps !== ae, D || typeof m.UNSAFE_componentWillReceiveProps != "function" && typeof m.componentWillReceiveProps != "function" || (ae || ue !== S) && s1(
          t,
          m,
          l,
          S
        ), cd = !1;
        var ee = t.memoizedState;
        m.state = ee, Sc(t, l, m, u), wr(), ue = t.memoizedState, ae || ee !== ue || cd ? (typeof Q == "function" && (Qn(
          t,
          i,
          Q,
          l
        ), ue = t.memoizedState), (U = cd || o1(
          t,
          i,
          U,
          l,
          ee,
          ue,
          S
        )) ? (D || typeof m.UNSAFE_componentWillMount != "function" && typeof m.componentWillMount != "function" || (typeof m.componentWillMount == "function" && m.componentWillMount(), typeof m.UNSAFE_componentWillMount == "function" && m.UNSAFE_componentWillMount()), typeof m.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & Xo) !== Vn && (t.flags |= 134217728)) : (typeof m.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & Xo) !== Vn && (t.flags |= 134217728), t.memoizedProps = l, t.memoizedState = ue), m.props = l, m.state = ue, m.context = S, m = U) : (typeof m.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & Xo) !== Vn && (t.flags |= 134217728), m = !1);
      } else {
        m = t.stateNode, gs(e, t), S = t.memoizedProps, D = Ns(i, S), m.props = D, Q = t.pendingProps, ee = m.context, ue = i.contextType, U = ld, typeof ue == "object" && ue !== null && (U = Sn(ue)), ae = i.getDerivedStateFromProps, (ue = typeof ae == "function" || typeof m.getSnapshotBeforeUpdate == "function") || typeof m.UNSAFE_componentWillReceiveProps != "function" && typeof m.componentWillReceiveProps != "function" || (S !== Q || ee !== U) && s1(
          t,
          m,
          l,
          U
        ), cd = !1, ee = t.memoizedState, m.state = ee, Sc(t, l, m, u), wr();
        var me = t.memoizedState;
        S !== Q || ee !== me || cd || e !== null && e.dependencies !== null && ms(e.dependencies) ? (typeof ae == "function" && (Qn(
          t,
          i,
          ae,
          l
        ), me = t.memoizedState), (D = cd || o1(
          t,
          i,
          D,
          l,
          ee,
          me,
          U
        ) || e !== null && e.dependencies !== null && ms(e.dependencies)) ? (ue || typeof m.UNSAFE_componentWillUpdate != "function" && typeof m.componentWillUpdate != "function" || (typeof m.componentWillUpdate == "function" && m.componentWillUpdate(l, me, U), typeof m.UNSAFE_componentWillUpdate == "function" && m.UNSAFE_componentWillUpdate(
          l,
          me,
          U
        )), typeof m.componentDidUpdate == "function" && (t.flags |= 4), typeof m.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof m.componentDidUpdate != "function" || S === e.memoizedProps && ee === e.memoizedState || (t.flags |= 4), typeof m.getSnapshotBeforeUpdate != "function" || S === e.memoizedProps && ee === e.memoizedState || (t.flags |= 1024), t.memoizedProps = l, t.memoizedState = me), m.props = l, m.state = me, m.context = U, m = D) : (typeof m.componentDidUpdate != "function" || S === e.memoizedProps && ee === e.memoizedState || (t.flags |= 4), typeof m.getSnapshotBeforeUpdate != "function" || S === e.memoizedProps && ee === e.memoizedState || (t.flags |= 1024), m = !1);
      }
      if (U = m, c0(e, t), S = (t.flags & 128) !== 0, U || S) {
        if (U = t.stateNode, mt(t), S && typeof i.getDerivedStateFromError != "function")
          i = null, nr = -1;
        else {
          if (dt(t), i = M3(U), t.mode & va) {
            Ce(!0);
            try {
              M3(U);
            } finally {
              Ce(!1);
            }
          }
          dn();
        }
        t.flags |= 1, e !== null && S ? (t.child = Qh(
          t,
          e.child,
          null,
          u
        ), t.child = Qh(
          t,
          null,
          i,
          u
        )) : Yn(e, t, i, u), t.memoizedState = U.state, e = t.child;
      } else
        e = zr(
          e,
          t,
          u
        );
      return u = t.stateNode, m && u.props !== l && (Oh || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        Fe(t) || "a component"
      ), Oh = !0), e;
    }
    function $m(e, t, i, l) {
      return cl(), t.flags |= 256, Yn(e, t, i, l), t.child;
    }
    function p1(e, t) {
      t && t.childContextTypes && console.error(
        `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
        t.displayName || t.name || "Component"
      ), typeof t.getDerivedStateFromProps == "function" && (e = Ne(t) || "Unknown", o5[e] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        e
      ), o5[e] = !0)), typeof t.contextType == "object" && t.contextType !== null && (t = Ne(t) || "Unknown", a5[t] || (console.error(
        "%s: Function components do not support contextType.",
        t
      ), a5[t] = !0));
    }
    function d0(e) {
      return { baseLanes: e, cachePool: I2() };
    }
    function f1(e, t, i) {
      return e = e !== null ? e.childLanes & ~i : 0, t && (e |= br), e;
    }
    function z2(e, t, i) {
      var l, u = t.pendingProps;
      v(t) && (t.flags |= 128);
      var m = !1, S = (t.flags & 128) !== 0;
      if ((l = S) || (l = e !== null && e.memoizedState === null ? !1 : (Ni.current & xf) !== 0), l && (m = !0, t.flags &= -129), l = (t.flags & 32) !== 0, t.flags &= -33, e === null) {
        if (Gt) {
          if (m ? Ca(t) : vr(t), Gt) {
            var U = Xn, D;
            if (!(D = !U)) {
              e: {
                var Q = U;
                for (D = Hs; Q.nodeType !== 8; ) {
                  if (!D) {
                    D = null;
                    break e;
                  }
                  if (Q = Ri(Q.nextSibling), Q === null) {
                    D = null;
                    break e;
                  }
                }
                D = Q;
              }
              D !== null ? (cr(), t.memoizedState = {
                dehydrated: D,
                treeContext: G0 !== null ? { id: Wl, overflow: Hl } : null,
                retryLane: 536870912,
                hydrationErrors: null
              }, Q = V(18, null, null, Vn), Q.stateNode = D, Q.return = t, t.child = Q, xa = t, Xn = null, D = !0) : D = !1, D = !D;
            }
            D && (Vm(
              t,
              U
            ), Qr(t));
          }
          if (U = t.memoizedState, U !== null && (U = U.dehydrated, U !== null))
            return no(U) ? t.lanes = 32 : t.lanes = 536870912, null;
          Va(t);
        }
        return U = u.children, u = u.fallback, m ? (vr(t), m = t.mode, U = u0(
          {
            mode: "hidden",
            children: U
          },
          m
        ), u = ds(
          u,
          m,
          i,
          null
        ), U.return = t, u.return = t, U.sibling = u, t.child = U, m = t.child, m.memoizedState = d0(i), m.childLanes = f1(
          e,
          l,
          i
        ), t.memoizedState = PS, u) : (Ca(t), g1(
          t,
          U
        ));
      }
      var ae = e.memoizedState;
      if (ae !== null && (U = ae.dehydrated, U !== null)) {
        if (S)
          t.flags & 256 ? (Ca(t), t.flags &= -257, t = v1(
            e,
            t,
            i
          )) : t.memoizedState !== null ? (vr(t), t.child = e.child, t.flags |= 128, t = null) : (vr(t), m = u.fallback, U = t.mode, u = u0(
            {
              mode: "visible",
              children: u.children
            },
            U
          ), m = ds(
            m,
            U,
            i,
            null
          ), m.flags |= 2, u.return = t, m.return = t, u.sibling = m, t.child = u, Qh(
            t,
            e.child,
            null,
            i
          ), u = t.child, u.memoizedState = d0(i), u.childLanes = f1(
            e,
            l,
            i
          ), t.memoizedState = PS, t = m);
        else if (Ca(t), Gt && console.error(
          "We should not be hydrating here. This is a bug in React. Please file a bug."
        ), no(U)) {
          if (l = U.nextSibling && U.nextSibling.dataset, l) {
            D = l.dgst;
            var ue = l.msg;
            Q = l.stck;
            var ee = l.cstck;
          }
          U = ue, l = D, u = Q, D = m = ee, m = Error(U || "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), m.stack = u || "", m.digest = l, l = D === void 0 ? null : D, u = {
            value: m,
            source: null,
            stack: l
          }, typeof l == "string" && VS.set(
            m,
            u
          ), fc(u), t = v1(
            e,
            t,
            i
          );
        } else if (Zi || fi(
          e,
          t,
          i,
          !1
        ), l = (i & e.childLanes) !== 0, Zi || l) {
          if (l = Rn, l !== null && (u = i & -i, u = (u & 42) !== 0 ? 1 : jn(
            u
          ), u = (u & (l.suspendedLanes | i)) !== 0 ? 0 : u, u !== 0 && u !== ae.retryLane))
            throw ae.retryLane = u, ia(
              e,
              u
            ), wn(
              l,
              e,
              u
            ), n5;
          U.data === Xl || F1(), t = v1(
            e,
            t,
            i
          );
        } else
          U.data === Xl ? (t.flags |= 192, t.child = e.child, t = null) : (e = ae.treeContext, Xn = Ri(
            U.nextSibling
          ), xa = t, Gt = !0, Y0 = null, zl = !1, mo = null, Hs = !1, e !== null && (cr(), uo[ho++] = Wl, uo[ho++] = Hl, uo[ho++] = G0, Wl = e.id, Hl = e.overflow, G0 = t), t = g1(
            t,
            u.children
          ), t.flags |= 4096);
        return t;
      }
      return m ? (vr(t), m = u.fallback, U = t.mode, D = e.child, Q = D.sibling, u = Dr(
        D,
        {
          mode: "hidden",
          children: u.children
        }
      ), u.subtreeFlags = D.subtreeFlags & 65011712, Q !== null ? m = Dr(
        Q,
        m
      ) : (m = ds(
        m,
        U,
        i,
        null
      ), m.flags |= 2), m.return = t, u.return = t, u.sibling = m, t.child = u, u = m, m = t.child, U = e.child.memoizedState, U === null ? U = d0(i) : (D = U.cachePool, D !== null ? (Q = Ti._currentValue, D = D.parent !== Q ? { parent: Q, pool: Q } : D) : D = I2(), U = {
        baseLanes: U.baseLanes | i,
        cachePool: D
      }), m.memoizedState = U, m.childLanes = f1(
        e,
        l,
        i
      ), t.memoizedState = PS, u) : (Ca(t), i = e.child, e = i.sibling, i = Dr(i, {
        mode: "visible",
        children: u.children
      }), i.return = t, i.sibling = null, e !== null && (l = t.deletions, l === null ? (t.deletions = [e], t.flags |= 16) : l.push(e)), t.child = i, t.memoizedState = null, i);
    }
    function g1(e, t) {
      return t = u0(
        { mode: "visible", children: t },
        e.mode
      ), t.return = e, e.child = t;
    }
    function u0(e, t) {
      return e = V(22, e, null, t), e.lanes = 0, e.stateNode = {
        _visibility: _g,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }, e;
    }
    function v1(e, t, i) {
      return Qh(t, e.child, null, i), e = g1(
        t,
        t.pendingProps.children
      ), e.flags |= 2, t.memoizedState = null, e;
    }
    function S1(e, t, i) {
      e.lanes |= t;
      var l = e.alternate;
      l !== null && (l.lanes |= t), Dm(
        e.return,
        t,
        i
      );
    }
    function ep(e, t) {
      var i = St(e);
      return e = !i && typeof Te(e) == "function", i || e ? (i = i ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        i,
        t,
        i
      ), !1) : !0;
    }
    function R1(e, t, i, l, u) {
      var m = e.memoizedState;
      m === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: l,
        tail: i,
        tailMode: u
      } : (m.isBackwards = t, m.rendering = null, m.renderingStartTime = 0, m.last = l, m.tail = i, m.tailMode = u);
    }
    function tp(e, t, i) {
      var l = t.pendingProps, u = l.revealOrder, m = l.tail;
      if (l = l.children, u !== void 0 && u !== "forwards" && u !== "backwards" && u !== "together" && !s5[u])
        if (s5[u] = !0, typeof u == "string")
          switch (u.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                u,
                u.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                u,
                u.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                u
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
            u
          );
      m === void 0 || jS[m] || (m !== "collapsed" && m !== "hidden" ? (jS[m] = !0, console.error(
        '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',
        m
      )) : u !== "forwards" && u !== "backwards" && (jS[m] = !0, console.error(
        '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
        m
      )));
      e: if ((u === "forwards" || u === "backwards") && l !== void 0 && l !== null && l !== !1)
        if (St(l)) {
          for (var S = 0; S < l.length; S++)
            if (!ep(l[S], S)) break e;
        } else if (S = Te(l), typeof S == "function") {
          if (S = S.call(l))
            for (var U = S.next(), D = 0; !U.done; U = S.next()) {
              if (!ep(U.value, D)) break e;
              D++;
            }
        } else
          console.error(
            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
            u
          );
      if (Yn(e, t, l, i), l = Ni.current, (l & xf) !== 0)
        l = l & xh | xf, t.flags |= 128;
      else {
        if (e !== null && (e.flags & 128) !== 0)
          e: for (e = t.child; e !== null; ) {
            if (e.tag === 13)
              e.memoizedState !== null && S1(
                e,
                i,
                t
              );
            else if (e.tag === 19)
              S1(e, i, t);
            else if (e.child !== null) {
              e.child.return = e, e = e.child;
              continue;
            }
            if (e === t) break e;
            for (; e.sibling === null; ) {
              if (e.return === null || e.return === t)
                break e;
              e = e.return;
            }
            e.sibling.return = e.return, e = e.sibling;
          }
        l &= xh;
      }
      switch (we(Ni, l, t), u) {
        case "forwards":
          for (i = t.child, u = null; i !== null; )
            e = i.alternate, e !== null && Zo(e) === null && (u = i), i = i.sibling;
          i = u, i === null ? (u = t.child, t.child = null) : (u = i.sibling, i.sibling = null), R1(
            t,
            !1,
            u,
            i,
            m
          );
          break;
        case "backwards":
          for (i = null, u = t.child, t.child = null; u !== null; ) {
            if (e = u.alternate, e !== null && Zo(e) === null) {
              t.child = u;
              break;
            }
            e = u.sibling, u.sibling = i, i = u, u = e;
          }
          R1(
            t,
            !0,
            i,
            null,
            m
          );
          break;
        case "together":
          R1(t, !1, null, null, void 0);
          break;
        default:
          t.memoizedState = null;
      }
      return t.child;
    }
    function zr(e, t, i) {
      if (e !== null && (t.dependencies = e.dependencies), nr = -1, md |= t.lanes, (i & t.childLanes) === 0)
        if (e !== null) {
          if (fi(
            e,
            t,
            i,
            !1
          ), (i & t.childLanes) === 0)
            return null;
        } else return null;
      if (e !== null && t.child !== e.child)
        throw Error("Resuming work not yet implemented.");
      if (t.child !== null) {
        for (e = t.child, i = Dr(e, e.pendingProps), t.child = i, i.return = t; e.sibling !== null; )
          e = e.sibling, i = i.sibling = Dr(e, e.pendingProps), i.return = t;
        i.sibling = null;
      }
      return t.child;
    }
    function E1(e, t) {
      return (e.lanes & t) !== 0 ? !0 : (e = e.dependencies, !!(e !== null && ms(e)));
    }
    function lS(e, t, i) {
      switch (t.tag) {
        case 3:
          Ie(
            t,
            t.stateNode.containerInfo
          ), hs(
            t,
            Ti,
            e.memoizedState.cache
          ), cl();
          break;
        case 27:
        case 5:
          G(t);
          break;
        case 4:
          Ie(
            t,
            t.stateNode.containerInfo
          );
          break;
        case 10:
          hs(
            t,
            t.type,
            t.memoizedProps.value
          );
          break;
        case 12:
          (i & t.childLanes) !== 0 && (t.flags |= 4), t.flags |= 2048;
          var l = t.stateNode;
          l.effectDuration = -0, l.passiveEffectDuration = -0;
          break;
        case 13:
          if (l = t.memoizedState, l !== null)
            return l.dehydrated !== null ? (Ca(t), t.flags |= 128, null) : (i & t.child.childLanes) !== 0 ? z2(
              e,
              t,
              i
            ) : (Ca(t), e = zr(
              e,
              t,
              i
            ), e !== null ? e.sibling : null);
          Ca(t);
          break;
        case 19:
          var u = (e.flags & 128) !== 0;
          if (l = (i & t.childLanes) !== 0, l || (fi(
            e,
            t,
            i,
            !1
          ), l = (i & t.childLanes) !== 0), u) {
            if (l)
              return tp(
                e,
                t,
                i
              );
            t.flags |= 128;
          }
          if (u = t.memoizedState, u !== null && (u.rendering = null, u.tail = null, u.lastEffect = null), we(
            Ni,
            Ni.current,
            t
          ), l) break;
          return null;
        case 22:
        case 23:
          return t.lanes = 0, u1(e, t, i);
        case 24:
          hs(
            t,
            Ti,
            e.memoizedState.cache
          );
      }
      return zr(e, t, i);
    }
    function U1(e, t, i) {
      if (t._debugNeedsRemount && e !== null) {
        i = Lu(
          t.type,
          t.key,
          t.pendingProps,
          t._debugOwner || null,
          t.mode,
          t.lanes
        ), i._debugStack = t._debugStack, i._debugTask = t._debugTask;
        var l = t.return;
        if (l === null) throw Error("Cannot swap the root fiber.");
        if (e.alternate = null, t.alternate = null, i.index = t.index, i.sibling = t.sibling, i.return = t.return, i.ref = t.ref, i._debugInfo = t._debugInfo, t === l.child)
          l.child = i;
        else {
          var u = l.child;
          if (u === null)
            throw Error("Expected parent to have a child.");
          for (; u.sibling !== t; )
            if (u = u.sibling, u === null)
              throw Error("Expected to find the previous sibling.");
          u.sibling = i;
        }
        return t = l.deletions, t === null ? (l.deletions = [e], l.flags |= 16) : t.push(e), i.flags |= 2, i;
      }
      if (e !== null)
        if (e.memoizedProps !== t.pendingProps || t.type !== e.type)
          Zi = !0;
        else {
          if (!E1(e, i) && (t.flags & 128) === 0)
            return Zi = !1, lS(
              e,
              t,
              i
            );
          Zi = (e.flags & 131072) !== 0;
        }
      else
        Zi = !1, (l = Gt) && (cr(), l = (t.flags & 1048576) !== 0), l && (l = t.index, cr(), w2(t, Mg, l));
      switch (t.lanes = 0, t.tag) {
        case 16:
          e: if (l = t.pendingProps, e = ud(t.elementType), t.type = e, typeof e == "function")
            Nm(e) ? (l = Ns(
              e,
              l
            ), t.tag = 1, t.type = e = ol(e), t = qm(
              null,
              t,
              e,
              l,
              i
            )) : (t.tag = 0, p1(t, e), t.type = e = ol(e), t = m1(
              null,
              t,
              e,
              l,
              i
            ));
          else {
            if (e != null) {
              if (u = e.$$typeof, u === Wo) {
                t.tag = 11, t.type = e = ym(e), t = d1(
                  null,
                  t,
                  e,
                  l,
                  i
                );
                break e;
              } else if (u === Z0) {
                t.tag = 14, t = Hr(
                  null,
                  t,
                  e,
                  l,
                  i
                );
                break e;
              }
            }
            throw t = "", e !== null && typeof e == "object" && e.$$typeof === ka && (t = " Did you wrap a component in React.lazy() more than once?"), e = Ne(e) || e, Error(
              "Element type is invalid. Received a promise that resolves to: " + e + ". Lazy element type must resolve to a class or function." + t
            );
          }
          return t;
        case 0:
          return m1(
            e,
            t,
            t.type,
            t.pendingProps,
            i
          );
        case 1:
          return l = t.type, u = Ns(
            l,
            t.pendingProps
          ), qm(
            e,
            t,
            l,
            u,
            i
          );
        case 3:
          e: {
            if (Ie(
              t,
              t.stateNode.containerInfo
            ), e === null)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            l = t.pendingProps;
            var m = t.memoizedState;
            u = m.element, gs(e, t), Sc(t, l, null, i);
            var S = t.memoizedState;
            if (l = S.cache, hs(t, Ti, l), l !== m.cache && Qm(
              t,
              [Ti],
              i,
              !0
            ), wr(), l = S.element, m.isDehydrated)
              if (m = {
                element: l,
                isDehydrated: !1,
                cache: S.cache
              }, t.updateQueue.baseState = m, t.memoizedState = m, t.flags & 256) {
                t = $m(
                  e,
                  t,
                  l,
                  i
                );
                break e;
              } else if (l !== u) {
                u = Na(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  t
                ), fc(u), t = $m(
                  e,
                  t,
                  l,
                  i
                );
                break e;
              } else {
                switch (e = t.stateNode.containerInfo, e.nodeType) {
                  case 9:
                    e = e.body;
                    break;
                  default:
                    e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
                }
                for (Xn = Ri(e.firstChild), xa = t, Gt = !0, Y0 = null, zl = !1, mo = null, Hs = !0, e = H3(
                  t,
                  null,
                  l,
                  i
                ), t.child = e; e; )
                  e.flags = e.flags & -3 | 4096, e = e.sibling;
              }
            else {
              if (cl(), l === u) {
                t = zr(
                  e,
                  t,
                  i
                );
                break e;
              }
              Yn(
                e,
                t,
                l,
                i
              );
            }
            t = t.child;
          }
          return t;
        case 26:
          return c0(e, t), e === null ? (e = Jo(
            t.type,
            null,
            t.pendingProps,
            null
          )) ? t.memoizedState = e : Gt || (e = t.type, i = t.pendingProps, l = Oe(
            ao.current
          ), l = Zt(
            l
          ).createElement(e), l[xi] = t, l[fa] = i, An(l, e, i), z(l), t.stateNode = l) : t.memoizedState = Jo(
            t.type,
            e.memoizedProps,
            t.pendingProps,
            e.memoizedState
          ), null;
        case 27:
          return G(t), e === null && Gt && (l = Oe(ao.current), u = O(), l = t.stateNode = Ip(
            t.type,
            t.pendingProps,
            l,
            u,
            !1
          ), zl || (u = un(
            l,
            t.type,
            t.pendingProps,
            u
          ), u !== null && (dr(t, 0).serverProps = u)), xa = t, Hs = !0, u = Xn, to(t.type) ? (gR = u, Xn = Ri(
            l.firstChild
          )) : Xn = u), Yn(
            e,
            t,
            t.pendingProps.children,
            i
          ), c0(e, t), e === null && (t.flags |= 4194304), t.child;
        case 5:
          return e === null && Gt && (m = O(), l = Du(
            t.type,
            m.ancestorInfo
          ), u = Xn, (S = !u) || (S = ks(
            u,
            t.type,
            t.pendingProps,
            Hs
          ), S !== null ? (t.stateNode = S, zl || (m = un(
            S,
            t.type,
            t.pendingProps,
            m
          ), m !== null && (dr(t, 0).serverProps = m)), xa = t, Xn = Ri(
            S.firstChild
          ), Hs = !1, m = !0) : m = !1, S = !m), S && (l && Vm(t, u), Qr(t))), G(t), u = t.type, m = t.pendingProps, S = e !== null ? e.memoizedProps : null, l = m.children, eo(u, m) ? l = null : S !== null && eo(u, S) && (t.flags |= 32), t.memoizedState !== null && (u = Rs(
            e,
            t,
            Ha,
            null,
            null,
            i
          ), Yf._currentValue = u), c0(e, t), Yn(
            e,
            t,
            l,
            i
          ), t.child;
        case 6:
          return e === null && Gt && (e = t.pendingProps, i = O(), l = i.ancestorInfo.current, e = l != null ? Zd(
            e,
            l.tag,
            i.ancestorInfo.implicitRootScope
          ) : !0, i = Xn, (l = !i) || (l = Si(
            i,
            t.pendingProps,
            Hs
          ), l !== null ? (t.stateNode = l, xa = t, Xn = null, l = !0) : l = !1, l = !l), l && (e && Vm(t, i), Qr(t))), null;
        case 13:
          return z2(e, t, i);
        case 4:
          return Ie(
            t,
            t.stateNode.containerInfo
          ), l = t.pendingProps, e === null ? t.child = Qh(
            t,
            null,
            l,
            i
          ) : Yn(
            e,
            t,
            l,
            i
          ), t.child;
        case 11:
          return d1(
            e,
            t,
            t.type,
            t.pendingProps,
            i
          );
        case 7:
          return Yn(
            e,
            t,
            t.pendingProps,
            i
          ), t.child;
        case 8:
          return Yn(
            e,
            t,
            t.pendingProps.children,
            i
          ), t.child;
        case 12:
          return t.flags |= 4, t.flags |= 2048, l = t.stateNode, l.effectDuration = -0, l.passiveEffectDuration = -0, Yn(
            e,
            t,
            t.pendingProps.children,
            i
          ), t.child;
        case 10:
          return l = t.type, u = t.pendingProps, m = u.value, "value" in u || l5 || (l5 = !0, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), hs(t, l, m), Yn(
            e,
            t,
            u.children,
            i
          ), t.child;
        case 9:
          return u = t.type._context, l = t.pendingProps.children, typeof l != "function" && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), ps(t), u = Sn(u), dt(t), l = IS(
            l,
            u,
            void 0
          ), dn(), t.flags |= 1, Yn(
            e,
            t,
            l,
            i
          ), t.child;
        case 14:
          return Hr(
            e,
            t,
            t.type,
            t.pendingProps,
            i
          );
        case 15:
          return l0(
            e,
            t,
            t.type,
            t.pendingProps,
            i
          );
        case 19:
          return tp(
            e,
            t,
            i
          );
        case 31:
          return l = t.pendingProps, i = t.mode, l = {
            mode: l.mode,
            children: l.children
          }, e === null ? (e = u0(
            l,
            i
          ), e.ref = t.ref, t.child = e, e.return = t, t = e) : (e = Dr(e.child, l), e.ref = t.ref, t.child = e, e.return = t, t = e), t;
        case 22:
          return u1(e, t, i);
        case 24:
          return ps(t), l = Sn(Ti), e === null ? (u = Om(), u === null && (u = Rn, m = zd(), u.pooledCache = m, dl(m), m !== null && (u.pooledCacheLanes |= i), u = m), t.memoizedState = {
            parent: l,
            cache: u
          }, aa(t), hs(t, Ti, u)) : ((e.lanes & i) !== 0 && (gs(e, t), Sc(t, null, null, i), wr()), u = e.memoizedState, m = t.memoizedState, u.parent !== l ? (u = {
            parent: l,
            cache: l
          }, t.memoizedState = u, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = u), hs(t, Ti, l)) : (l = m.cache, hs(t, Ti, l), l !== u.cache && Qm(
            t,
            [Ti],
            i,
            !0
          ))), Yn(
            e,
            t,
            t.pendingProps.children,
            i
          ), t.child;
        case 29:
          throw t.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function la(e) {
      e.flags |= 4;
    }
    function h0(e, t) {
      if (t.type !== "stylesheet" || (t.state.loading & So) !== du)
        e.flags &= -16777217;
      else if (e.flags |= 16777216, !C0(t)) {
        if (t = vo.current, t !== null && ((At & 4194048) === At ? js !== null : (At & 62914560) !== At && (At & 536870912) === 0 || t !== js))
          throw Mf = QS, S3;
        e.flags |= 8192;
      }
    }
    function m0(e, t) {
      t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag !== 22 ? ea() : 536870912, e.lanes |= t, au |= t);
    }
    function bs(e, t) {
      if (!Gt)
        switch (e.tailMode) {
          case "hidden":
            t = e.tail;
            for (var i = null; t !== null; )
              t.alternate !== null && (i = t), t = t.sibling;
            i === null ? e.tail = null : i.sibling = null;
            break;
          case "collapsed":
            i = e.tail;
            for (var l = null; i !== null; )
              i.alternate !== null && (l = i), i = i.sibling;
            l === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : l.sibling = null;
        }
    }
    function on(e) {
      var t = e.alternate !== null && e.alternate.child === e.child, i = 0, l = 0;
      if (t)
        if ((e.mode & Yi) !== Vn) {
          for (var u = e.selfBaseDuration, m = e.child; m !== null; )
            i |= m.lanes | m.childLanes, l |= m.subtreeFlags & 65011712, l |= m.flags & 65011712, u += m.treeBaseDuration, m = m.sibling;
          e.treeBaseDuration = u;
        } else
          for (u = e.child; u !== null; )
            i |= u.lanes | u.childLanes, l |= u.subtreeFlags & 65011712, l |= u.flags & 65011712, u.return = e, u = u.sibling;
      else if ((e.mode & Yi) !== Vn) {
        u = e.actualDuration, m = e.selfBaseDuration;
        for (var S = e.child; S !== null; )
          i |= S.lanes | S.childLanes, l |= S.subtreeFlags, l |= S.flags, u += S.actualDuration, m += S.treeBaseDuration, S = S.sibling;
        e.actualDuration = u, e.treeBaseDuration = m;
      } else
        for (u = e.child; u !== null; )
          i |= u.lanes | u.childLanes, l |= u.subtreeFlags, l |= u.flags, u.return = e, u = u.sibling;
      return e.subtreeFlags |= l, e.childLanes = i, t;
    }
    function j2(e, t, i) {
      var l = t.pendingProps;
      switch (Wu(t), t.tag) {
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return on(t), null;
        case 1:
          return on(t), null;
        case 3:
          return i = t.stateNode, l = null, e !== null && (l = e.memoizedState.cache), t.memoizedState.cache !== l && (t.flags |= 2048), _o(Ti, t), he(t), i.pendingContext && (i.context = i.pendingContext, i.pendingContext = null), (e === null || e.child === null) && (ll(t) ? (km(), la(t)) : e === null || e.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, Mm())), on(t), null;
        case 26:
          return i = t.memoizedState, e === null ? (la(t), i !== null ? (on(t), h0(
            t,
            i
          )) : (on(t), t.flags &= -16777217)) : i ? i !== e.memoizedState ? (la(t), on(t), h0(
            t,
            i
          )) : (on(t), t.flags &= -16777217) : (e.memoizedProps !== l && la(t), on(t), t.flags &= -16777217), null;
        case 27:
          se(t), i = Oe(ao.current);
          var u = t.type;
          if (e !== null && t.stateNode != null)
            e.memoizedProps !== l && la(t);
          else {
            if (!l) {
              if (t.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return on(t), null;
            }
            e = O(), ll(t) ? _m(t) : (e = Ip(
              u,
              l,
              i,
              e,
              !0
            ), t.stateNode = e, la(t));
          }
          return on(t), null;
        case 5:
          if (se(t), i = t.type, e !== null && t.stateNode != null)
            e.memoizedProps !== l && la(t);
          else {
            if (!l) {
              if (t.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return on(t), null;
            }
            if (u = O(), ll(t))
              _m(t);
            else {
              switch (e = Oe(ao.current), Du(i, u.ancestorInfo), u = u.context, e = Zt(e), u) {
                case zh:
                  e = e.createElementNS(sd, i);
                  break;
                case iv:
                  e = e.createElementNS(
                    j0,
                    i
                  );
                  break;
                default:
                  switch (i) {
                    case "svg":
                      e = e.createElementNS(
                        sd,
                        i
                      );
                      break;
                    case "math":
                      e = e.createElementNS(
                        j0,
                        i
                      );
                      break;
                    case "script":
                      e = e.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild);
                      break;
                    case "select":
                      e = typeof l.is == "string" ? e.createElement("select", { is: l.is }) : e.createElement("select"), l.multiple ? e.multiple = !0 : l.size && (e.size = l.size);
                      break;
                    default:
                      e = typeof l.is == "string" ? e.createElement(i, {
                        is: l.is
                      }) : e.createElement(i), i.indexOf("-") === -1 && (i !== i.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        i
                      ), Object.prototype.toString.call(e) !== "[object HTMLUnknownElement]" || zo.call(
                        V5,
                        i
                      ) || (V5[i] = !0, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        i
                      )));
                  }
              }
              e[xi] = t, e[fa] = l;
              e: for (u = t.child; u !== null; ) {
                if (u.tag === 5 || u.tag === 6)
                  e.appendChild(u.stateNode);
                else if (u.tag !== 4 && u.tag !== 27 && u.child !== null) {
                  u.child.return = u, u = u.child;
                  continue;
                }
                if (u === t) break e;
                for (; u.sibling === null; ) {
                  if (u.return === null || u.return === t)
                    break e;
                  u = u.return;
                }
                u.sibling.return = u.return, u = u.sibling;
              }
              t.stateNode = e;
              e: switch (An(e, i, l), i) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  e = !!l.autoFocus;
                  break e;
                case "img":
                  e = !0;
                  break e;
                default:
                  e = !1;
              }
              e && la(t);
            }
          }
          return on(t), t.flags &= -16777217, null;
        case 6:
          if (e && t.stateNode != null)
            e.memoizedProps !== l && la(t);
          else {
            if (typeof l != "string" && t.stateNode === null)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            if (e = Oe(ao.current), i = O(), ll(t)) {
              e = t.stateNode, i = t.memoizedProps, u = !zl, l = null;
              var m = xa;
              if (m !== null)
                switch (m.tag) {
                  case 3:
                    u && (u = P1(
                      e,
                      i,
                      l
                    ), u !== null && (dr(t, 0).serverProps = u));
                    break;
                  case 27:
                  case 5:
                    l = m.memoizedProps, u && (u = P1(
                      e,
                      i,
                      l
                    ), u !== null && (dr(
                      t,
                      0
                    ).serverProps = u));
                }
              e[xi] = t, e = !!(e.nodeValue === i || l !== null && l.suppressHydrationWarning === !0 || Mp(e.nodeValue, i)), e || Qr(t);
            } else
              u = i.ancestorInfo.current, u != null && Zd(
                l,
                u.tag,
                i.ancestorInfo.implicitRootScope
              ), e = Zt(e).createTextNode(
                l
              ), e[xi] = t, t.stateNode = e;
          }
          return on(t), null;
        case 13:
          if (l = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            if (u = ll(t), l !== null && l.dehydrated !== null) {
              if (e === null) {
                if (!u)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (u = t.memoizedState, u = u !== null ? u.dehydrated : null, !u)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                u[xi] = t, on(t), (t.mode & Yi) !== Vn && l !== null && (u = t.child, u !== null && (t.treeBaseDuration -= u.treeBaseDuration));
              } else
                km(), cl(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4, on(t), (t.mode & Yi) !== Vn && l !== null && (u = t.child, u !== null && (t.treeBaseDuration -= u.treeBaseDuration));
              u = !1;
            } else
              u = Mm(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = u), u = !0;
            if (!u)
              return t.flags & 256 ? (Va(t), t) : (Va(t), null);
          }
          return Va(t), (t.flags & 128) !== 0 ? (t.lanes = i, (t.mode & Yi) !== Vn && Zr(t), t) : (i = l !== null, e = e !== null && e.memoizedState !== null, i && (l = t.child, u = null, l.alternate !== null && l.alternate.memoizedState !== null && l.alternate.memoizedState.cachePool !== null && (u = l.alternate.memoizedState.cachePool.pool), m = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (m = l.memoizedState.cachePool.pool), m !== u && (l.flags |= 2048)), i !== e && i && (t.child.flags |= 8192), m0(t, t.updateQueue), on(t), (t.mode & Yi) !== Vn && i && (e = t.child, e !== null && (t.treeBaseDuration -= e.treeBaseDuration)), null);
        case 4:
          return he(t), e === null && _p(
            t.stateNode.containerInfo
          ), on(t), null;
        case 10:
          return _o(t.type, t), on(t), null;
        case 19:
          if (Ve(Ni, t), u = t.memoizedState, u === null) return on(t), null;
          if (l = (t.flags & 128) !== 0, m = u.rendering, m === null)
            if (l) bs(u, !1);
            else {
              if (Kn !== Yl || e !== null && (e.flags & 128) !== 0)
                for (e = t.child; e !== null; ) {
                  if (m = Zo(e), m !== null) {
                    for (t.flags |= 128, bs(u, !1), e = m.updateQueue, t.updateQueue = e, m0(t, e), t.subtreeFlags = 0, e = i, i = t.child; i !== null; )
                      bm(i, e), i = i.sibling;
                    return we(
                      Ni,
                      Ni.current & xh | xf,
                      t
                    ), t.child;
                  }
                  e = e.sibling;
                }
              u.tail !== null && ro() > zg && (t.flags |= 128, l = !0, bs(u, !1), t.lanes = 4194304);
            }
          else {
            if (!l)
              if (e = Zo(m), e !== null) {
                if (t.flags |= 128, l = !0, e = e.updateQueue, t.updateQueue = e, m0(t, e), bs(u, !0), u.tail === null && u.tailMode === "hidden" && !m.alternate && !Gt)
                  return on(t), null;
              } else
                2 * ro() - u.renderingStartTime > zg && i !== 536870912 && (t.flags |= 128, l = !0, bs(u, !1), t.lanes = 4194304);
            u.isBackwards ? (m.sibling = t.child, t.child = m) : (e = u.last, e !== null ? e.sibling = m : t.child = m, u.last = m);
          }
          return u.tail !== null ? (e = u.tail, u.rendering = e, u.tail = e.sibling, u.renderingStartTime = ro(), e.sibling = null, i = Ni.current, i = l ? i & xh | xf : i & xh, we(Ni, i, t), e) : (on(t), null);
        case 22:
        case 23:
          return Va(t), pr(t), l = t.memoizedState !== null, e !== null ? e.memoizedState !== null !== l && (t.flags |= 8192) : l && (t.flags |= 8192), l ? (i & 536870912) !== 0 && (t.flags & 128) === 0 && (on(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : on(t), i = t.updateQueue, i !== null && m0(t, i.retryQueue), i = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (i = e.memoizedState.cachePool.pool), l = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (l = t.memoizedState.cachePool.pool), l !== i && (t.flags |= 2048), e !== null && Ve(q0, t), null;
        case 24:
          return i = null, e !== null && (i = e.memoizedState.cache), t.memoizedState.cache !== i && (t.flags |= 2048), _o(Ti, t), on(t), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function P2(e, t) {
      switch (Wu(t), t.tag) {
        case 1:
          return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & Yi) !== Vn && Zr(t), t) : null;
        case 3:
          return _o(Ti, t), he(t), e = t.flags, (e & 65536) !== 0 && (e & 128) === 0 ? (t.flags = e & -65537 | 128, t) : null;
        case 26:
        case 27:
        case 5:
          return se(t), null;
        case 13:
          if (Va(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
            if (t.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            cl();
          }
          return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & Yi) !== Vn && Zr(t), t) : null;
        case 19:
          return Ve(Ni, t), null;
        case 4:
          return he(t), null;
        case 10:
          return _o(t.type, t), null;
        case 22:
        case 23:
          return Va(t), pr(t), e !== null && Ve(q0, t), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & Yi) !== Vn && Zr(t), t) : null;
        case 24:
          return _o(Ti, t), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function np(e, t) {
      switch (Wu(t), t.tag) {
        case 3:
          _o(Ti, t), he(t);
          break;
        case 26:
        case 27:
        case 5:
          se(t);
          break;
        case 4:
          he(t);
          break;
        case 13:
          Va(t);
          break;
        case 19:
          Ve(Ni, t);
          break;
        case 10:
          _o(t.type, t);
          break;
        case 22:
        case 23:
          Va(t), pr(t), e !== null && Ve(q0, t);
          break;
        case 24:
          _o(Ti, t);
      }
    }
    function Sr(e) {
      return (e.mode & Yi) !== Vn;
    }
    function ip(e, t) {
      Sr(e) ? (hr(), Rl(t, e), La()) : Rl(t, e);
    }
    function T1(e, t, i) {
      Sr(e) ? (hr(), El(
        i,
        e,
        t
      ), La()) : El(
        i,
        e,
        t
      );
    }
    function Rl(e, t) {
      try {
        var i = t.updateQueue, l = i !== null ? i.lastEffect : null;
        if (l !== null) {
          var u = l.next;
          i = u;
          do {
            if ((i.tag & e) === e && ((e & yi) !== po ? ze !== null && typeof ze.markComponentPassiveEffectMountStarted == "function" && ze.markComponentPassiveEffectMountStarted(
              t
            ) : (e & Xi) !== po && ze !== null && typeof ze.markComponentLayoutEffectMountStarted == "function" && ze.markComponentLayoutEffectMountStarted(
              t
            ), l = void 0, (e & Za) !== po && (Wh = !0), l = pe(
              t,
              Wy,
              i
            ), (e & Za) !== po && (Wh = !1), (e & yi) !== po ? ze !== null && typeof ze.markComponentPassiveEffectMountStopped == "function" && ze.markComponentPassiveEffectMountStopped() : (e & Xi) !== po && ze !== null && typeof ze.markComponentLayoutEffectMountStopped == "function" && ze.markComponentLayoutEffectMountStopped(), l !== void 0 && typeof l != "function")) {
              var m = void 0;
              m = (i.tag & Xi) !== 0 ? "useLayoutEffect" : (i.tag & Za) !== 0 ? "useInsertionEffect" : "useEffect";
              var S = void 0;
              S = l === null ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof l.then == "function" ? `

It looks like you wrote ` + m + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + m + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching` : " You returned: " + l, pe(
                t,
                function(U, D) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    U,
                    D
                  );
                },
                m,
                S
              );
            }
            i = i.next;
          } while (i !== u);
        }
      } catch (U) {
        lt(t, t.return, U);
      }
    }
    function El(e, t, i) {
      try {
        var l = t.updateQueue, u = l !== null ? l.lastEffect : null;
        if (u !== null) {
          var m = u.next;
          l = m;
          do {
            if ((l.tag & e) === e) {
              var S = l.inst, U = S.destroy;
              U !== void 0 && (S.destroy = void 0, (e & yi) !== po ? ze !== null && typeof ze.markComponentPassiveEffectUnmountStarted == "function" && ze.markComponentPassiveEffectUnmountStarted(
                t
              ) : (e & Xi) !== po && ze !== null && typeof ze.markComponentLayoutEffectUnmountStarted == "function" && ze.markComponentLayoutEffectUnmountStarted(
                t
              ), (e & Za) !== po && (Wh = !0), u = t, pe(
                u,
                Hy,
                u,
                i,
                U
              ), (e & Za) !== po && (Wh = !1), (e & yi) !== po ? ze !== null && typeof ze.markComponentPassiveEffectUnmountStopped == "function" && ze.markComponentPassiveEffectUnmountStopped() : (e & Xi) !== po && ze !== null && typeof ze.markComponentLayoutEffectUnmountStopped == "function" && ze.markComponentLayoutEffectUnmountStopped());
            }
            l = l.next;
          } while (l !== m);
        }
      } catch (D) {
        lt(t, t.return, D);
      }
    }
    function ap(e, t) {
      Sr(e) ? (hr(), Rl(t, e), La()) : Rl(t, e);
    }
    function p0(e, t, i) {
      Sr(e) ? (hr(), El(
        i,
        e,
        t
      ), La()) : El(
        i,
        e,
        t
      );
    }
    function rp(e) {
      var t = e.updateQueue;
      if (t !== null) {
        var i = e.stateNode;
        e.type.defaultProps || "ref" in e.memoizedProps || Oh || (i.props !== e.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          Fe(e) || "instance"
        ), i.state !== e.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          Fe(e) || "instance"
        ));
        try {
          pe(
            e,
            L2,
            t,
            i
          );
        } catch (l) {
          lt(e, e.return, l);
        }
      }
    }
    function G2(e, t, i) {
      return e.getSnapshotBeforeUpdate(t, i);
    }
    function cS(e, t) {
      var i = t.memoizedProps, l = t.memoizedState;
      t = e.stateNode, e.type.defaultProps || "ref" in e.memoizedProps || Oh || (t.props !== e.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        Fe(e) || "instance"
      ), t.state !== e.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        Fe(e) || "instance"
      ));
      try {
        var u = Ns(
          e.type,
          i,
          e.elementType === e.type
        ), m = pe(
          e,
          G2,
          t,
          u,
          l
        );
        i = c5, m !== void 0 || i.has(e.type) || (i.add(e.type), pe(e, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            Fe(e)
          );
        })), t.__reactInternalSnapshotBeforeUpdate = m;
      } catch (S) {
        lt(e, e.return, S);
      }
    }
    function y1(e, t, i) {
      i.props = Ns(
        e.type,
        e.memoizedProps
      ), i.state = e.memoizedState, Sr(e) ? (hr(), pe(
        e,
        O3,
        e,
        t,
        i
      ), La()) : pe(
        e,
        O3,
        e,
        t,
        i
      );
    }
    function Y2(e) {
      var t = e.ref;
      if (t !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var i = e.stateNode;
            break;
          case 30:
            i = e.stateNode;
            break;
          default:
            i = e.stateNode;
        }
        if (typeof t == "function")
          if (Sr(e))
            try {
              hr(), e.refCleanup = t(i);
            } finally {
              La();
            }
          else e.refCleanup = t(i);
        else
          typeof t == "string" ? console.error("String refs are no longer supported.") : t.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            Fe(e)
          ), t.current = i;
      }
    }
    function Dc(e, t) {
      try {
        pe(e, Y2, e);
      } catch (i) {
        lt(e, t, i);
      }
    }
    function Ya(e, t) {
      var i = e.ref, l = e.refCleanup;
      if (i !== null)
        if (typeof l == "function")
          try {
            if (Sr(e))
              try {
                hr(), pe(e, l);
              } finally {
                La(e);
              }
            else pe(e, l);
          } catch (u) {
            lt(e, t, u);
          } finally {
            e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
          }
        else if (typeof i == "function")
          try {
            if (Sr(e))
              try {
                hr(), pe(e, i, null);
              } finally {
                La(e);
              }
            else pe(e, i, null);
          } catch (u) {
            lt(e, t, u);
          }
        else i.current = null;
    }
    function op(e, t, i, l) {
      var u = e.memoizedProps, m = u.id, S = u.onCommit;
      u = u.onRender, t = t === null ? "mount" : "update", Qg && (t = "nested-update"), typeof u == "function" && u(
        m,
        t,
        e.actualDuration,
        e.treeBaseDuration,
        e.actualStartTime,
        i
      ), typeof S == "function" && S(
        e.memoizedProps.id,
        t,
        l,
        i
      );
    }
    function X2(e, t, i, l) {
      var u = e.memoizedProps;
      e = u.id, u = u.onPostCommit, t = t === null ? "mount" : "update", Qg && (t = "nested-update"), typeof u == "function" && u(
        e,
        t,
        l,
        i
      );
    }
    function K2(e) {
      var t = e.type, i = e.memoizedProps, l = e.stateNode;
      try {
        pe(
          e,
          Io,
          l,
          t,
          i,
          e
        );
      } catch (u) {
        lt(e, e.return, u);
      }
    }
    function sp(e, t, i) {
      try {
        pe(
          e,
          In,
          e.stateNode,
          e.type,
          i,
          t,
          e
        );
      } catch (l) {
        lt(e, e.return, l);
      }
    }
    function lp(e) {
      return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && to(e.type) || e.tag === 4;
    }
    function Ul(e) {
      e: for (; ; ) {
        for (; e.sibling === null; ) {
          if (e.return === null || lp(e.return)) return null;
          e = e.return;
        }
        for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
          if (e.tag === 27 && to(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue e;
          e.child.return = e, e = e.child;
        }
        if (!(e.flags & 2)) return e.stateNode;
      }
    }
    function f0(e, t, i) {
      var l = e.tag;
      if (l === 5 || l === 6)
        e = e.stateNode, t ? (i.nodeType === 9 ? i.body : i.nodeName === "HTML" ? i.ownerDocument.body : i).insertBefore(e, t) : (t = i.nodeType === 9 ? i.body : i.nodeName === "HTML" ? i.ownerDocument.body : i, t.appendChild(e), i = i._reactRootContainer, i != null || t.onclick !== null || (t.onclick = Ao));
      else if (l !== 4 && (l === 27 && to(e.type) && (i = e.stateNode, t = null), e = e.child, e !== null))
        for (f0(e, t, i), e = e.sibling; e !== null; )
          f0(e, t, i), e = e.sibling;
    }
    function Tl(e, t, i) {
      var l = e.tag;
      if (l === 5 || l === 6)
        e = e.stateNode, t ? i.insertBefore(e, t) : i.appendChild(e);
      else if (l !== 4 && (l === 27 && to(e.type) && (i = e.stateNode), e = e.child, e !== null))
        for (Tl(e, t, i), e = e.sibling; e !== null; )
          Tl(e, t, i), e = e.sibling;
    }
    function q2(e) {
      for (var t, i = e.return; i !== null; ) {
        if (lp(i)) {
          t = i;
          break;
        }
        i = i.return;
      }
      if (t == null)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (t.tag) {
        case 27:
          t = t.stateNode, i = Ul(e), Tl(
            e,
            i,
            t
          );
          break;
        case 5:
          i = t.stateNode, t.flags & 32 && (Lo(i), t.flags &= -33), t = Ul(e), Tl(
            e,
            t,
            i
          );
          break;
        case 3:
        case 4:
          t = t.stateNode.containerInfo, i = Ul(e), f0(
            e,
            i,
            t
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function cp(e) {
      var t = e.stateNode, i = e.memoizedProps;
      try {
        pe(
          e,
          Ma,
          e.type,
          i,
          t,
          e
        );
      } catch (l) {
        lt(e, e.return, l);
      }
    }
    function N1(e, t) {
      if (e = e.containerInfo, mR = sv, e = D2(e), Um(e)) {
        if ("selectionStart" in e)
          var i = {
            start: e.selectionStart,
            end: e.selectionEnd
          };
        else
          e: {
            i = (i = e.ownerDocument) && i.defaultView || window;
            var l = i.getSelection && i.getSelection();
            if (l && l.rangeCount !== 0) {
              i = l.anchorNode;
              var u = l.anchorOffset, m = l.focusNode;
              l = l.focusOffset;
              try {
                i.nodeType, m.nodeType;
              } catch {
                i = null;
                break e;
              }
              var S = 0, U = -1, D = -1, Q = 0, ae = 0, ue = e, ee = null;
              t: for (; ; ) {
                for (var me; ue !== i || u !== 0 && ue.nodeType !== 3 || (U = S + u), ue !== m || l !== 0 && ue.nodeType !== 3 || (D = S + l), ue.nodeType === 3 && (S += ue.nodeValue.length), (me = ue.firstChild) !== null; )
                  ee = ue, ue = me;
                for (; ; ) {
                  if (ue === e) break t;
                  if (ee === i && ++Q === u && (U = S), ee === m && ++ae === l && (D = S), (me = ue.nextSibling) !== null) break;
                  ue = ee, ee = ue.parentNode;
                }
                ue = me;
              }
              i = U === -1 || D === -1 ? null : { start: U, end: D };
            } else i = null;
          }
        i = i || { start: 0, end: 0 };
      } else i = null;
      for (pR = {
        focusedElem: e,
        selectionRange: i
      }, sv = !1, Oi = t; Oi !== null; )
        if (t = Oi, e = t.child, (t.subtreeFlags & 1024) !== 0 && e !== null)
          e.return = t, Oi = e;
        else
          for (; Oi !== null; ) {
            switch (e = t = Oi, i = e.alternate, u = e.flags, e.tag) {
              case 0:
                break;
              case 11:
              case 15:
                break;
              case 1:
                (u & 1024) !== 0 && i !== null && cS(e, i);
                break;
              case 3:
                if ((u & 1024) !== 0) {
                  if (e = e.stateNode.containerInfo, i = e.nodeType, i === 9)
                    Wc(e);
                  else if (i === 1)
                    switch (e.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        Wc(e);
                        break;
                      default:
                        e.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if ((u & 1024) !== 0)
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            if (e = t.sibling, e !== null) {
              e.return = t.return, Oi = e;
              break;
            }
            Oi = t.return;
          }
    }
    function dp(e, t, i) {
      var l = i.flags;
      switch (i.tag) {
        case 0:
        case 11:
        case 15:
          jr(e, i), l & 4 && ip(i, Xi | fo);
          break;
        case 1:
          if (jr(e, i), l & 4)
            if (e = i.stateNode, t === null)
              i.type.defaultProps || "ref" in i.memoizedProps || Oh || (e.props !== i.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                Fe(i) || "instance"
              ), e.state !== i.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                Fe(i) || "instance"
              )), Sr(i) ? (hr(), pe(
                i,
                LS,
                i,
                e
              ), La()) : pe(
                i,
                LS,
                i,
                e
              );
            else {
              var u = Ns(
                i.type,
                t.memoizedProps
              );
              t = t.memoizedState, i.type.defaultProps || "ref" in i.memoizedProps || Oh || (e.props !== i.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                Fe(i) || "instance"
              ), e.state !== i.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                Fe(i) || "instance"
              )), Sr(i) ? (hr(), pe(
                i,
                Q3,
                i,
                e,
                u,
                t,
                e.__reactInternalSnapshotBeforeUpdate
              ), La()) : pe(
                i,
                Q3,
                i,
                e,
                u,
                t,
                e.__reactInternalSnapshotBeforeUpdate
              );
            }
          l & 64 && rp(i), l & 512 && Dc(i, i.return);
          break;
        case 3:
          if (t = ur(), jr(e, i), l & 64 && (l = i.updateQueue, l !== null)) {
            if (u = null, i.child !== null)
              switch (i.child.tag) {
                case 27:
                case 5:
                  u = i.child.stateNode;
                  break;
                case 1:
                  u = i.child.stateNode;
              }
            try {
              pe(
                i,
                L2,
                l,
                u
              );
            } catch (S) {
              lt(i, i.return, S);
            }
          }
          e.effectDuration += fs(t);
          break;
        case 27:
          t === null && l & 4 && cp(i);
        case 26:
        case 5:
          jr(e, i), t === null && l & 4 && K2(i), l & 512 && Dc(i, i.return);
          break;
        case 12:
          if (l & 4) {
            l = ur(), jr(e, i), e = i.stateNode, e.effectDuration += ul(l);
            try {
              pe(
                i,
                op,
                i,
                t,
                Dg,
                e.effectDuration
              );
            } catch (S) {
              lt(i, i.return, S);
            }
          } else jr(e, i);
          break;
        case 13:
          jr(e, i), l & 4 && Qc(e, i), l & 64 && (e = i.memoizedState, e !== null && (e = e.dehydrated, e !== null && (i = y0.bind(
            null,
            i
          ), Hc(e, i))));
          break;
        case 22:
          if (l = i.memoizedState !== null || Gl, !l) {
            t = t !== null && t.memoizedState !== null || ii, u = Gl;
            var m = ii;
            Gl = l, (ii = t) && !m ? Pr(
              e,
              i,
              (i.subtreeFlags & 8772) !== 0
            ) : jr(e, i), Gl = u, ii = m;
          }
          break;
        case 30:
          break;
        default:
          jr(e, i);
      }
    }
    function up(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, up(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && Ii(t)), e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
    }
    function Oo(e, t, i) {
      for (i = i.child; i !== null; )
        yl(
          e,
          t,
          i
        ), i = i.sibling;
    }
    function yl(e, t, i) {
      if (Ei && typeof Ei.onCommitFiberUnmount == "function")
        try {
          Ei.onCommitFiberUnmount(Bs, i);
        } catch (m) {
          pa || (pa = !0, console.error(
            "React instrumentation encountered an error: %s",
            m
          ));
        }
      switch (i.tag) {
        case 26:
          ii || Ya(i, t), Oo(
            e,
            t,
            i
          ), i.memoizedState ? i.memoizedState.count-- : i.stateNode && (i = i.stateNode, i.parentNode.removeChild(i));
          break;
        case 27:
          ii || Ya(i, t);
          var l = mi, u = ir;
          to(i.type) && (mi = i.stateNode, ir = !1), Oo(
            e,
            t,
            i
          ), pe(
            i,
            jc,
            i.stateNode
          ), mi = l, ir = u;
          break;
        case 5:
          ii || Ya(i, t);
        case 6:
          if (l = mi, u = ir, mi = null, Oo(
            e,
            t,
            i
          ), mi = l, ir = u, mi !== null)
            if (ir)
              try {
                pe(
                  i,
                  Lc,
                  mi,
                  i.stateNode
                );
              } catch (m) {
                lt(
                  i,
                  t,
                  m
                );
              }
            else
              try {
                pe(
                  i,
                  qa,
                  mi,
                  i.stateNode
                );
              } catch (m) {
                lt(
                  i,
                  t,
                  m
                );
              }
          break;
        case 18:
          mi !== null && (ir ? (e = mi, Jc(
            e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e,
            i.stateNode
          ), Ol(e)) : Jc(mi, i.stateNode));
          break;
        case 4:
          l = mi, u = ir, mi = i.stateNode.containerInfo, ir = !0, Oo(
            e,
            t,
            i
          ), mi = l, ir = u;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          ii || El(
            Za,
            i,
            t
          ), ii || T1(
            i,
            t,
            Xi
          ), Oo(
            e,
            t,
            i
          );
          break;
        case 1:
          ii || (Ya(i, t), l = i.stateNode, typeof l.componentWillUnmount == "function" && y1(
            i,
            t,
            l
          )), Oo(
            e,
            t,
            i
          );
          break;
        case 21:
          Oo(
            e,
            t,
            i
          );
          break;
        case 22:
          ii = (l = ii) || i.memoizedState !== null, Oo(
            e,
            t,
            i
          ), ii = l;
          break;
        default:
          Oo(
            e,
            t,
            i
          );
      }
    }
    function Qc(e, t) {
      if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null))))
        try {
          pe(
            t,
            Fa,
            e
          );
        } catch (i) {
          lt(t, t.return, i);
        }
    }
    function b1(e) {
      switch (e.tag) {
        case 13:
        case 19:
          var t = e.stateNode;
          return t === null && (t = e.stateNode = new d5()), t;
        case 22:
          return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new d5()), t;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + e.tag + "). This is a bug in React."
          );
      }
    }
    function Nl(e, t) {
      var i = b1(e);
      t.forEach(function(l) {
        var u = Fs.bind(null, e, l);
        if (!i.has(l)) {
          if (i.add(l), Jn)
            if (wh !== null && Bh !== null)
              Ac(Bh, wh);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          l.then(u, u);
        }
      });
    }
    function ki(e, t) {
      var i = t.deletions;
      if (i !== null)
        for (var l = 0; l < i.length; l++) {
          var u = e, m = t, S = i[l], U = m;
          e: for (; U !== null; ) {
            switch (U.tag) {
              case 27:
                if (to(U.type)) {
                  mi = U.stateNode, ir = !1;
                  break e;
                }
                break;
              case 5:
                mi = U.stateNode, ir = !1;
                break e;
              case 3:
              case 4:
                mi = U.stateNode.containerInfo, ir = !0;
                break e;
            }
            U = U.return;
          }
          if (mi === null)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          yl(u, m, S), mi = null, ir = !1, u = S, m = u.alternate, m !== null && (m.return = null), u.return = null;
        }
      if (t.subtreeFlags & 13878)
        for (t = t.child; t !== null; )
          hp(t, e), t = t.sibling;
    }
    function hp(e, t) {
      var i = e.alternate, l = e.flags;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          ki(t, e), ca(e), l & 4 && (El(
            Za | fo,
            e,
            e.return
          ), Rl(Za | fo, e), T1(
            e,
            e.return,
            Xi | fo
          ));
          break;
        case 1:
          ki(t, e), ca(e), l & 512 && (ii || i === null || Ya(i, i.return)), l & 64 && Gl && (e = e.updateQueue, e !== null && (l = e.callbacks, l !== null && (i = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = i === null ? l : i.concat(l))));
          break;
        case 26:
          var u = $o;
          if (ki(t, e), ca(e), l & 512 && (ii || i === null || Ya(i, i.return)), l & 4)
            if (t = i !== null ? i.memoizedState : null, l = e.memoizedState, i === null)
              if (l === null)
                if (e.stateNode === null) {
                  e: {
                    l = e.type, i = e.memoizedProps, t = u.ownerDocument || u;
                    t: switch (l) {
                      case "title":
                        u = t.getElementsByTagName("title")[0], (!u || u[id] || u[xi] || u.namespaceURI === sd || u.hasAttribute("itemprop")) && (u = t.createElement(l), t.head.insertBefore(
                          u,
                          t.querySelector("head > title")
                        )), An(u, l, i), u[xi] = e, z(u), l = u;
                        break e;
                      case "link":
                        var m = Hp(
                          "link",
                          "href",
                          t
                        ).get(l + (i.href || ""));
                        if (m) {
                          for (var S = 0; S < m.length; S++)
                            if (u = m[S], u.getAttribute("href") === (i.href == null || i.href === "" ? null : i.href) && u.getAttribute("rel") === (i.rel == null ? null : i.rel) && u.getAttribute("title") === (i.title == null ? null : i.title) && u.getAttribute("crossorigin") === (i.crossOrigin == null ? null : i.crossOrigin)) {
                              m.splice(S, 1);
                              break t;
                            }
                        }
                        u = t.createElement(l), An(u, l, i), t.head.appendChild(u);
                        break;
                      case "meta":
                        if (m = Hp(
                          "meta",
                          "content",
                          t
                        ).get(l + (i.content || ""))) {
                          for (S = 0; S < m.length; S++)
                            if (u = m[S], q(
                              i.content,
                              "content"
                            ), u.getAttribute("content") === (i.content == null ? null : "" + i.content) && u.getAttribute("name") === (i.name == null ? null : i.name) && u.getAttribute("property") === (i.property == null ? null : i.property) && u.getAttribute("http-equiv") === (i.httpEquiv == null ? null : i.httpEquiv) && u.getAttribute("charset") === (i.charSet == null ? null : i.charSet)) {
                              m.splice(S, 1);
                              break t;
                            }
                        }
                        u = t.createElement(l), An(u, l, i), t.head.appendChild(u);
                        break;
                      default:
                        throw Error(
                          'getNodesForType encountered a type it did not expect: "' + l + '". This is a bug in React.'
                        );
                    }
                    u[xi] = e, z(u), l = u;
                  }
                  e.stateNode = l;
                } else
                  zp(
                    u,
                    e.type,
                    e.stateNode
                  );
              else
                e.stateNode = G1(
                  u,
                  l,
                  e.memoizedProps
                );
            else
              t !== l ? (t === null ? i.stateNode !== null && (i = i.stateNode, i.parentNode.removeChild(i)) : t.count--, l === null ? zp(
                u,
                e.type,
                e.stateNode
              ) : G1(
                u,
                l,
                e.memoizedProps
              )) : l === null && e.stateNode !== null && sp(
                e,
                e.memoizedProps,
                i.memoizedProps
              );
          break;
        case 27:
          ki(t, e), ca(e), l & 512 && (ii || i === null || Ya(i, i.return)), i !== null && l & 4 && sp(
            e,
            e.memoizedProps,
            i.memoizedProps
          );
          break;
        case 5:
          if (ki(t, e), ca(e), l & 512 && (ii || i === null || Ya(i, i.return)), e.flags & 32) {
            t = e.stateNode;
            try {
              pe(e, Lo, t);
            } catch (ae) {
              lt(e, e.return, ae);
            }
          }
          l & 4 && e.stateNode != null && (t = e.memoizedProps, sp(
            e,
            t,
            i !== null ? i.memoizedProps : t
          )), l & 1024 && (GS = !0, e.type !== "form" && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          if (ki(t, e), ca(e), l & 4) {
            if (e.stateNode === null)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            l = e.memoizedProps, i = i !== null ? i.memoizedProps : l, t = e.stateNode;
            try {
              pe(
                e,
                Dl,
                t,
                i,
                l
              );
            } catch (ae) {
              lt(e, e.return, ae);
            }
          }
          break;
        case 3:
          if (u = ur(), av = null, m = $o, $o = b0(t.containerInfo), ki(t, e), $o = m, ca(e), l & 4 && i !== null && i.memoizedState.isDehydrated)
            try {
              pe(
                e,
                Ap,
                t.containerInfo
              );
            } catch (ae) {
              lt(e, e.return, ae);
            }
          GS && (GS = !1, bl(e)), t.effectDuration += fs(u);
          break;
        case 4:
          l = $o, $o = b0(
            e.stateNode.containerInfo
          ), ki(t, e), ca(e), $o = l;
          break;
        case 12:
          l = ur(), ki(t, e), ca(e), e.stateNode.effectDuration += ul(l);
          break;
        case 13:
          ki(t, e), ca(e), e.child.flags & 8192 && e.memoizedState !== null != (i !== null && i.memoizedState !== null) && (eR = ro()), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, Nl(e, l)));
          break;
        case 22:
          u = e.memoizedState !== null;
          var U = i !== null && i.memoizedState !== null, D = Gl, Q = ii;
          if (Gl = D || u, ii = Q || U, ki(t, e), ii = Q, Gl = D, ca(e), l & 8192)
            e: for (t = e.stateNode, t._visibility = u ? t._visibility & ~_g : t._visibility | _g, u && (i === null || U || Gl || ii || Di(e)), i = null, t = e; ; ) {
              if (t.tag === 5 || t.tag === 26) {
                if (i === null) {
                  U = i = t;
                  try {
                    m = U.stateNode, u ? pe(U, ha, m) : pe(
                      U,
                      wp,
                      U.stateNode,
                      U.memoizedProps
                    );
                  } catch (ae) {
                    lt(U, U.return, ae);
                  }
                }
              } else if (t.tag === 6) {
                if (i === null) {
                  U = t;
                  try {
                    S = U.stateNode, u ? pe(U, Op, S) : pe(
                      U,
                      z1,
                      S,
                      U.memoizedProps
                    );
                  } catch (ae) {
                    lt(U, U.return, ae);
                  }
                }
              } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
                t.child.return = t, t = t.child;
                continue;
              }
              if (t === e) break e;
              for (; t.sibling === null; ) {
                if (t.return === null || t.return === e)
                  break e;
                i === t && (i = null), t = t.return;
              }
              i === t && (i = null), t.sibling.return = t.return, t = t.sibling;
            }
          l & 4 && (l = e.updateQueue, l !== null && (i = l.retryQueue, i !== null && (l.retryQueue = null, Nl(e, i))));
          break;
        case 19:
          ki(t, e), ca(e), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, Nl(e, l)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          ki(t, e), ca(e);
      }
    }
    function ca(e) {
      var t = e.flags;
      if (t & 2) {
        try {
          pe(e, q2, e);
        } catch (i) {
          lt(e, e.return, i);
        }
        e.flags &= -3;
      }
      t & 4096 && (e.flags &= -4097);
    }
    function bl(e) {
      if (e.subtreeFlags & 1024)
        for (e = e.child; e !== null; ) {
          var t = e;
          bl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
        }
    }
    function jr(e, t) {
      if (t.subtreeFlags & 8772)
        for (t = t.child; t !== null; )
          dp(e, t.alternate, t), t = t.sibling;
    }
    function _a(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          T1(
            e,
            e.return,
            Xi
          ), Di(e);
          break;
        case 1:
          Ya(e, e.return);
          var t = e.stateNode;
          typeof t.componentWillUnmount == "function" && y1(
            e,
            e.return,
            t
          ), Di(e);
          break;
        case 27:
          pe(
            e,
            jc,
            e.stateNode
          );
        case 26:
        case 5:
          Ya(e, e.return), Di(e);
          break;
        case 22:
          e.memoizedState === null && Di(e);
          break;
        case 30:
          Di(e);
          break;
        default:
          Di(e);
      }
    }
    function Di(e) {
      for (e = e.child; e !== null; )
        _a(e), e = e.sibling;
    }
    function wo(e, t, i, l) {
      var u = i.flags;
      switch (i.tag) {
        case 0:
        case 11:
        case 15:
          Pr(
            e,
            i,
            l
          ), ip(i, Xi);
          break;
        case 1:
          if (Pr(
            e,
            i,
            l
          ), t = i.stateNode, typeof t.componentDidMount == "function" && pe(
            i,
            LS,
            i,
            t
          ), t = i.updateQueue, t !== null) {
            e = i.stateNode;
            try {
              pe(
                i,
                Rc,
                t,
                e
              );
            } catch (m) {
              lt(i, i.return, m);
            }
          }
          l && u & 64 && rp(i), Dc(i, i.return);
          break;
        case 27:
          cp(i);
        case 26:
        case 5:
          Pr(
            e,
            i,
            l
          ), l && t === null && u & 4 && K2(i), Dc(i, i.return);
          break;
        case 12:
          if (l && u & 4) {
            u = ur(), Pr(
              e,
              i,
              l
            ), l = i.stateNode, l.effectDuration += ul(u);
            try {
              pe(
                i,
                op,
                i,
                t,
                Dg,
                l.effectDuration
              );
            } catch (m) {
              lt(i, i.return, m);
            }
          } else
            Pr(
              e,
              i,
              l
            );
          break;
        case 13:
          Pr(
            e,
            i,
            l
          ), l && u & 4 && Qc(e, i);
          break;
        case 22:
          i.memoizedState === null && Pr(
            e,
            i,
            l
          ), Dc(i, i.return);
          break;
        case 30:
          break;
        default:
          Pr(
            e,
            i,
            l
          );
      }
    }
    function Pr(e, t, i) {
      for (i = i && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; )
        wo(
          e,
          t.alternate,
          t,
          i
        ), t = t.sibling;
    }
    function Gr(e, t) {
      var i = null;
      e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (i = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== i && (e != null && dl(e), i != null && xr(i));
    }
    function Rr(e, t) {
      e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (dl(t), e != null && xr(e));
    }
    function sn(e, t, i, l) {
      if (t.subtreeFlags & 10256)
        for (t = t.child; t !== null; )
          g0(
            e,
            t,
            i,
            l
          ), t = t.sibling;
    }
    function g0(e, t, i, l) {
      var u = t.flags;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          sn(
            e,
            t,
            i,
            l
          ), u & 2048 && ap(t, yi | fo);
          break;
        case 1:
          sn(
            e,
            t,
            i,
            l
          );
          break;
        case 3:
          var m = ur();
          sn(
            e,
            t,
            i,
            l
          ), u & 2048 && (i = null, t.alternate !== null && (i = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== i && (dl(t), i != null && xr(i))), e.passiveEffectDuration += fs(m);
          break;
        case 12:
          if (u & 2048) {
            u = ur(), sn(
              e,
              t,
              i,
              l
            ), e = t.stateNode, e.passiveEffectDuration += ul(u);
            try {
              pe(
                t,
                X2,
                t,
                t.alternate,
                Dg,
                e.passiveEffectDuration
              );
            } catch (U) {
              lt(t, t.return, U);
            }
          } else
            sn(
              e,
              t,
              i,
              l
            );
          break;
        case 13:
          sn(
            e,
            t,
            i,
            l
          );
          break;
        case 23:
          break;
        case 22:
          m = t.stateNode;
          var S = t.alternate;
          t.memoizedState !== null ? m._visibility & Jl ? sn(
            e,
            t,
            i,
            l
          ) : xc(
            e,
            t
          ) : m._visibility & Jl ? sn(
            e,
            t,
            i,
            l
          ) : (m._visibility |= Jl, Cs(
            e,
            t,
            i,
            l,
            (t.subtreeFlags & 10256) !== 0
          )), u & 2048 && Gr(S, t);
          break;
        case 24:
          sn(
            e,
            t,
            i,
            l
          ), u & 2048 && Rr(t.alternate, t);
          break;
        default:
          sn(
            e,
            t,
            i,
            l
          );
      }
    }
    function Cs(e, t, i, l, u) {
      for (u = u && (t.subtreeFlags & 10256) !== 0, t = t.child; t !== null; )
        C1(
          e,
          t,
          i,
          l,
          u
        ), t = t.sibling;
    }
    function C1(e, t, i, l, u) {
      var m = t.flags;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          Cs(
            e,
            t,
            i,
            l,
            u
          ), ap(t, yi);
          break;
        case 23:
          break;
        case 22:
          var S = t.stateNode;
          t.memoizedState !== null ? S._visibility & Jl ? Cs(
            e,
            t,
            i,
            l,
            u
          ) : xc(
            e,
            t
          ) : (S._visibility |= Jl, Cs(
            e,
            t,
            i,
            l,
            u
          )), u && m & 2048 && Gr(
            t.alternate,
            t
          );
          break;
        case 24:
          Cs(
            e,
            t,
            i,
            l,
            u
          ), u && m & 2048 && Rr(t.alternate, t);
          break;
        default:
          Cs(
            e,
            t,
            i,
            l,
            u
          );
      }
    }
    function xc(e, t) {
      if (t.subtreeFlags & 10256)
        for (t = t.child; t !== null; ) {
          var i = e, l = t, u = l.flags;
          switch (l.tag) {
            case 22:
              xc(
                i,
                l
              ), u & 2048 && Gr(
                l.alternate,
                l
              );
              break;
            case 24:
              xc(
                i,
                l
              ), u & 2048 && Rr(
                l.alternate,
                l
              );
              break;
            default:
              xc(
                i,
                l
              );
          }
          t = t.sibling;
        }
    }
    function Cl(e) {
      if (e.subtreeFlags & Zf)
        for (e = e.child; e !== null; )
          Vs(e), e = e.sibling;
    }
    function Vs(e) {
      switch (e.tag) {
        case 26:
          Cl(e), e.flags & Zf && e.memoizedState !== null && cg(
            $o,
            e.memoizedState,
            e.memoizedProps
          );
          break;
        case 5:
          Cl(e);
          break;
        case 3:
        case 4:
          var t = $o;
          $o = b0(
            e.stateNode.containerInfo
          ), Cl(e), $o = t;
          break;
        case 22:
          e.memoizedState === null && (t = e.alternate, t !== null && t.memoizedState !== null ? (t = Zf, Zf = 16777216, Cl(e), Zf = t) : Cl(e));
          break;
        default:
          Cl(e);
      }
    }
    function v0(e) {
      var t = e.alternate;
      if (t !== null && (e = t.child, e !== null)) {
        t.child = null;
        do
          t = e.sibling, e.sibling = null, e = t;
        while (e !== null);
      }
    }
    function Zc(e) {
      var t = e.deletions;
      if ((e.flags & 16) !== 0) {
        if (t !== null)
          for (var i = 0; i < t.length; i++) {
            var l = t[i];
            Oi = l, pp(
              l,
              e
            );
          }
        v0(e);
      }
      if (e.subtreeFlags & 10256)
        for (e = e.child; e !== null; )
          mp(e), e = e.sibling;
    }
    function mp(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          Zc(e), e.flags & 2048 && p0(
            e,
            e.return,
            yi | fo
          );
          break;
        case 3:
          var t = ur();
          Zc(e), e.stateNode.passiveEffectDuration += fs(t);
          break;
        case 12:
          t = ur(), Zc(e), e.stateNode.passiveEffectDuration += ul(t);
          break;
        case 22:
          t = e.stateNode, e.memoizedState !== null && t._visibility & Jl && (e.return === null || e.return.tag !== 13) ? (t._visibility &= ~Jl, S0(e)) : Zc(e);
          break;
        default:
          Zc(e);
      }
    }
    function S0(e) {
      var t = e.deletions;
      if ((e.flags & 16) !== 0) {
        if (t !== null)
          for (var i = 0; i < t.length; i++) {
            var l = t[i];
            Oi = l, pp(
              l,
              e
            );
          }
        v0(e);
      }
      for (e = e.child; e !== null; )
        R0(e), e = e.sibling;
    }
    function R0(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          p0(
            e,
            e.return,
            yi
          ), S0(e);
          break;
        case 22:
          var t = e.stateNode;
          t._visibility & Jl && (t._visibility &= ~Jl, S0(e));
          break;
        default:
          S0(e);
      }
    }
    function pp(e, t) {
      for (; Oi !== null; ) {
        var i = Oi, l = i;
        switch (l.tag) {
          case 0:
          case 11:
          case 15:
            p0(
              l,
              t,
              yi
            );
            break;
          case 23:
          case 22:
            l.memoizedState !== null && l.memoizedState.cachePool !== null && (l = l.memoizedState.cachePool.pool, l != null && dl(l));
            break;
          case 24:
            xr(l.memoizedState.cache);
        }
        if (l = i.child, l !== null) l.return = i, Oi = l;
        else
          e: for (i = e; Oi !== null; ) {
            l = Oi;
            var u = l.sibling, m = l.return;
            if (up(l), l === i) {
              Oi = null;
              break e;
            }
            if (u !== null) {
              u.return = m, Oi = u;
              break e;
            }
            Oi = m;
          }
      }
    }
    function fp() {
      jy.forEach(function(e) {
        return e();
      });
    }
    function gp() {
      var e = typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
      return e || le.actQueue === null || console.error(
        "The current testing environment is not configured to support act(...)"
      ), e;
    }
    function da(e) {
      if ((nn & Oa) !== yr && At !== 0)
        return At & -At;
      var t = le.T;
      return t !== null ? (t._updatedFibers || (t._updatedFibers = /* @__PURE__ */ new Set()), t._updatedFibers.add(e), e = K0, e !== 0 ? e : bp()) : To();
    }
    function $2() {
      br === 0 && (br = (At & 536870912) === 0 || Gt ? vt() : 536870912);
      var e = vo.current;
      return e !== null && (e.flags |= 32), br;
    }
    function wn(e, t, i) {
      if (Wh && console.error("useInsertionEffect must not schedule updates."), rR && (jg = !0), (e === Rn && (ln === nu || ln === iu) || e.cancelPendingCommit !== null) && (_l(e, 0), Bo(
        e,
        At,
        br,
        !1
      )), Ta(e, i), (nn & Oa) !== 0 && e === Rn) {
        if (ga)
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              e = Ot && Fe(Ot) || "Unknown", E5.has(e) || (E5.add(e), t = Fe(t) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                t,
                e,
                e
              ));
              break;
            case 1:
              R5 || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), R5 = !0);
          }
      } else
        Jn && _i(e, t, i), ig(t), e === Rn && ((nn & Oa) === yr && (pd |= i), Kn === tu && Bo(
          e,
          At,
          br,
          !1
        )), Xa(e);
    }
    function ti(e, t, i) {
      if ((nn & (Oa | es)) !== yr)
        throw Error("Should not already be working.");
      var l = !i && (t & 124) === 0 && (t & e.expiredLanes) === 0 || Bt(e, t), u = l ? Sp(e, t) : M1(e, t, !0), m = l;
      do {
        if (u === Yl) {
          Lh && !l && Bo(e, t, 0, !1);
          break;
        } else {
          if (i = e.current.alternate, m && !eg(i)) {
            u = M1(e, t, !1), m = !1;
            continue;
          }
          if (u === Ah) {
            if (m = t, e.errorRecoveryDisabledLanes & m)
              var S = 0;
            else
              S = e.pendingLanes & -536870913, S = S !== 0 ? S : S & 536870912 ? 536870912 : 0;
            if (S !== 0) {
              t = S;
              e: {
                u = e;
                var U = S;
                S = Lf;
                var D = u.current.memoizedState.isDehydrated;
                if (D && (_l(
                  u,
                  U
                ).flags |= 256), U = M1(
                  u,
                  U,
                  !1
                ), U !== Ah) {
                  if (qS && !D) {
                    u.errorRecoveryDisabledLanes |= m, pd |= m, u = tu;
                    break e;
                  }
                  u = wa, wa = S, u !== null && (wa === null ? wa = u : wa.push.apply(
                    wa,
                    u
                  ));
                }
                u = U;
              }
              if (m = !1, u !== Ah) continue;
            }
          }
          if (u === wf) {
            _l(e, 0), Bo(e, t, 0, !0);
            break;
          }
          e: {
            switch (l = e, u) {
              case Yl:
              case wf:
                throw Error("Root did not complete. This is a bug in React.");
              case tu:
                if ((t & 4194048) !== t) break;
              case Wg:
                Bo(
                  l,
                  t,
                  br,
                  !hd
                );
                break e;
              case Ah:
                wa = null;
                break;
              case YS:
              case u5:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (le.actQueue !== null)
              Z1(
                l,
                i,
                t,
                wa,
                Jf,
                Hg,
                br,
                pd,
                au
              );
            else {
              if ((t & 62914560) === t && (m = eR + m5 - ro(), 10 < m)) {
                if (Bo(
                  l,
                  t,
                  br,
                  !hd
                ), yn(l, 0, !0) !== 0) break e;
                l.timeoutHandle = _5(
                  ci.bind(
                    null,
                    l,
                    i,
                    wa,
                    Jf,
                    Hg,
                    t,
                    br,
                    pd,
                    au,
                    hd,
                    u,
                    Xy,
                    f3,
                    0
                  ),
                  m
                );
                break e;
              }
              ci(
                l,
                i,
                wa,
                Jf,
                Hg,
                t,
                br,
                pd,
                au,
                hd,
                u,
                Gy,
                f3,
                0
              );
            }
          }
        }
        break;
      } while (!0);
      Xa(e);
    }
    function ci(e, t, i, l, u, m, S, U, D, Q, ae, ue, ee, me) {
      if (e.timeoutHandle = cu, ue = t.subtreeFlags, (ue & 8192 || (ue & 16785408) === 16785408) && (Gf = { stylesheets: null, count: 0, unsuspend: lg }, Vs(t), ue = dg(), ue !== null)) {
        e.cancelPendingCommit = ue(
          Z1.bind(
            null,
            e,
            t,
            m,
            i,
            l,
            u,
            S,
            U,
            D,
            ae,
            Yy,
            ee,
            me
          )
        ), Bo(
          e,
          m,
          S,
          !Q
        );
        return;
      }
      Z1(
        e,
        t,
        m,
        i,
        l,
        u,
        S,
        U,
        D
      );
    }
    function eg(e) {
      for (var t = e; ; ) {
        var i = t.tag;
        if ((i === 0 || i === 11 || i === 15) && t.flags & 16384 && (i = t.updateQueue, i !== null && (i = i.stores, i !== null)))
          for (var l = 0; l < i.length; l++) {
            var u = i[l], m = u.getSnapshot;
            u = u.value;
            try {
              if (!Qa(m(), u)) return !1;
            } catch {
              return !1;
            }
          }
        if (i = t.child, t.subtreeFlags & 16384 && i !== null)
          i.return = t, t = i;
        else {
          if (t === e) break;
          for (; t.sibling === null; ) {
            if (t.return === null || t.return === e) return !0;
            t = t.return;
          }
          t.sibling.return = t.return, t = t.sibling;
        }
      }
      return !0;
    }
    function Bo(e, t, i, l) {
      t &= ~$S, t &= ~pd, e.suspendedLanes |= t, e.pingedLanes &= ~t, l && (e.warmLanes |= t), l = e.expirationTimes;
      for (var u = t; 0 < u; ) {
        var m = 31 - Qi(u), S = 1 << m;
        l[m] = -1, u &= ~S;
      }
      i !== 0 && Uo(e, i, t);
    }
    function Vl() {
      return (nn & (Oa | es)) === yr ? (Fl(0), !1) : !0;
    }
    function V1() {
      if (Ot !== null) {
        if (ln === ar)
          var e = Ot.return;
        else
          e = Ot, Hu(), fr(e), Dh = null, Qf = 0, e = Ot;
        for (; e !== null; )
          np(e.alternate, e), e = e.return;
        Ot = null;
      }
    }
    function _l(e, t) {
      var i = e.timeoutHandle;
      i !== cu && (e.timeoutHandle = cu, c4(i)), i = e.cancelPendingCommit, i !== null && (e.cancelPendingCommit = null, i()), V1(), Rn = e, Ot = i = Dr(e.current, null), At = t, ln = ar, Nr = null, hd = !1, Lh = Bt(e, t), qS = !1, Kn = Yl, au = br = $S = pd = md = 0, wa = Lf = null, Hg = !1, (t & 8) !== 0 && (t |= t & 32);
      var l = e.entangledLanes;
      if (l !== 0)
        for (e = e.entanglements, l &= t; 0 < l; ) {
          var u = 31 - Qi(l), m = 1 << u;
          t |= e[u], l &= ~m;
        }
      return Ps = t, Id(), t = m3(), 1e3 < t - h3 && (le.recentlyCreatedOwnerStacks = 0, h3 = t), Ko.discardPendingWarnings(), i;
    }
    function E0(e, t) {
      Rt = null, le.H = Lg, le.getCurrentStack = null, ga = !1, Da = null, t === Ff || t === Og ? (t = Am(), ln = Af) : t === S3 ? (t = Am(), ln = h5) : ln = t === n5 ? KS : t !== null && typeof t == "object" && typeof t.then == "function" ? Ih : Bf, Nr = t;
      var i = Ot;
      if (i === null)
        Kn = wf, kc(
          e,
          Na(t, e.current)
        );
      else
        switch (i.mode & Yi && Fo(i), dn(), ln) {
          case Bf:
            ze !== null && typeof ze.markComponentErrored == "function" && ze.markComponentErrored(
              i,
              t,
              At
            );
            break;
          case nu:
          case iu:
          case Af:
          case Ih:
          case If:
            ze !== null && typeof ze.markComponentSuspended == "function" && ze.markComponentSuspended(
              i,
              t,
              At
            );
        }
    }
    function _1() {
      var e = le.H;
      return le.H = Lg, e === null ? Lg : e;
    }
    function vp() {
      var e = le.A;
      return le.A = zy, e;
    }
    function F1() {
      Kn = tu, hd || (At & 4194048) !== At && vo.current !== null || (Lh = !0), (md & 134217727) === 0 && (pd & 134217727) === 0 || Rn === null || Bo(
        Rn,
        At,
        br,
        !1
      );
    }
    function M1(e, t, i) {
      var l = nn;
      nn |= Oa;
      var u = _1(), m = vp();
      if (Rn !== e || At !== t) {
        if (Jn) {
          var S = e.memoizedUpdaters;
          0 < S.size && (Ac(e, At), S.clear()), Pn(e, t);
        }
        Jf = null, _l(e, t);
      }
      xn(t), t = !1, S = Kn;
      e: do
        try {
          if (ln !== ar && Ot !== null) {
            var U = Ot, D = Nr;
            switch (ln) {
              case KS:
                V1(), S = Wg;
                break e;
              case Af:
              case nu:
              case iu:
              case Ih:
                vo.current === null && (t = !0);
                var Q = ln;
                if (ln = ar, Nr = null, _s(e, U, D, Q), i && Lh) {
                  S = Yl;
                  break e;
                }
                break;
              default:
                Q = ln, ln = ar, Nr = null, _s(e, U, D, Q);
            }
          }
          k1(), S = Kn;
          break;
        } catch (ae) {
          E0(e, ae);
        }
      while (!0);
      return t && e.shellSuspendCounter++, Hu(), nn = l, le.H = u, le.A = m, Yt(), Ot === null && (Rn = null, At = 0, Id()), S;
    }
    function k1() {
      for (; Ot !== null; ) Ep(Ot);
    }
    function Sp(e, t) {
      var i = nn;
      nn |= Oa;
      var l = _1(), u = vp();
      if (Rn !== e || At !== t) {
        if (Jn) {
          var m = e.memoizedUpdaters;
          0 < m.size && (Ac(e, At), m.clear()), Pn(e, t);
        }
        Jf = null, zg = ro() + p5, _l(e, t);
      } else
        Lh = Bt(
          e,
          t
        );
      xn(t);
      e: do
        try {
          if (ln !== ar && Ot !== null)
            t: switch (t = Ot, m = Nr, ln) {
              case Bf:
                ln = ar, Nr = null, _s(
                  e,
                  t,
                  m,
                  Bf
                );
                break;
              case nu:
              case iu:
                if (Bm(m)) {
                  ln = ar, Nr = null, D1(t);
                  break;
                }
                t = function() {
                  ln !== nu && ln !== iu || Rn !== e || (ln = If), Xa(e);
                }, m.then(t, t);
                break e;
              case Af:
                ln = If;
                break e;
              case h5:
                ln = XS;
                break e;
              case If:
                Bm(m) ? (ln = ar, Nr = null, D1(t)) : (ln = ar, Nr = null, _s(
                  e,
                  t,
                  m,
                  If
                ));
                break;
              case XS:
                var S = null;
                switch (Ot.tag) {
                  case 26:
                    S = Ot.memoizedState;
                  case 5:
                  case 27:
                    var U = Ot;
                    if (!S || C0(S)) {
                      ln = ar, Nr = null;
                      var D = U.sibling;
                      if (D !== null) Ot = D;
                      else {
                        var Q = U.return;
                        Q !== null ? (Ot = Q, U0(Q)) : Ot = null;
                      }
                      break t;
                    }
                    break;
                  default:
                    console.error(
                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                    );
                }
                ln = ar, Nr = null, _s(
                  e,
                  t,
                  m,
                  XS
                );
                break;
              case Ih:
                ln = ar, Nr = null, _s(
                  e,
                  t,
                  m,
                  Ih
                );
                break;
              case KS:
                V1(), Kn = Wg;
                break e;
              default:
                throw Error(
                  "Unexpected SuspendedReason. This is a bug in React."
                );
            }
          le.actQueue !== null ? k1() : Rp();
          break;
        } catch (ae) {
          E0(e, ae);
        }
      while (!0);
      return Hu(), le.H = l, le.A = u, nn = i, Ot !== null ? (ze !== null && typeof ze.markRenderYielded == "function" && ze.markRenderYielded(), Yl) : (Yt(), Rn = null, At = 0, Id(), Kn);
    }
    function Rp() {
      for (; Ot !== null && !vg(); )
        Ep(Ot);
    }
    function Ep(e) {
      var t = e.alternate;
      (e.mode & Yi) !== Vn ? (zu(e), t = pe(
        e,
        U1,
        t,
        e,
        Ps
      ), Fo(e)) : t = pe(
        e,
        U1,
        t,
        e,
        Ps
      ), e.memoizedProps = e.pendingProps, t === null ? U0(e) : Ot = t;
    }
    function D1(e) {
      var t = pe(e, Q1, e);
      e.memoizedProps = e.pendingProps, t === null ? U0(e) : Ot = t;
    }
    function Q1(e) {
      var t = e.alternate, i = (e.mode & Yi) !== Vn;
      switch (i && zu(e), e.tag) {
        case 15:
        case 0:
          t = Km(
            t,
            e,
            e.pendingProps,
            e.type,
            void 0,
            At
          );
          break;
        case 11:
          t = Km(
            t,
            e,
            e.pendingProps,
            e.type.render,
            e.ref,
            At
          );
          break;
        case 5:
          fr(e);
        default:
          np(t, e), e = Ot = bm(e, Ps), t = U1(t, e, Ps);
      }
      return i && Fo(e), t;
    }
    function _s(e, t, i, l) {
      Hu(), fr(t), Dh = null, Qf = 0;
      var u = t.return;
      try {
        if (s0(
          e,
          u,
          t,
          i,
          At
        )) {
          Kn = wf, kc(
            e,
            Na(i, e.current)
          ), Ot = null;
          return;
        }
      } catch (m) {
        if (u !== null) throw Ot = u, m;
        Kn = wf, kc(
          e,
          Na(i, e.current)
        ), Ot = null;
        return;
      }
      t.flags & 32768 ? (Gt || l === Bf ? e = !0 : Lh || (At & 536870912) !== 0 ? e = !1 : (hd = e = !0, (l === nu || l === iu || l === Af || l === Ih) && (l = vo.current, l !== null && l.tag === 13 && (l.flags |= 16384))), x1(t, e)) : U0(t);
    }
    function U0(e) {
      var t = e;
      do {
        if ((t.flags & 32768) !== 0) {
          x1(
            t,
            hd
          );
          return;
        }
        var i = t.alternate;
        if (e = t.return, zu(t), i = pe(
          t,
          j2,
          i,
          t,
          Ps
        ), (t.mode & Yi) !== Vn && hl(t), i !== null) {
          Ot = i;
          return;
        }
        if (t = t.sibling, t !== null) {
          Ot = t;
          return;
        }
        Ot = t = e;
      } while (t !== null);
      Kn === Yl && (Kn = u5);
    }
    function x1(e, t) {
      do {
        var i = P2(e.alternate, e);
        if (i !== null) {
          i.flags &= 32767, Ot = i;
          return;
        }
        if ((e.mode & Yi) !== Vn) {
          hl(e), i = e.actualDuration;
          for (var l = e.child; l !== null; )
            i += l.actualDuration, l = l.sibling;
          e.actualDuration = i;
        }
        if (i = e.return, i !== null && (i.flags |= 32768, i.subtreeFlags = 0, i.deletions = null), !t && (e = e.sibling, e !== null)) {
          Ot = e;
          return;
        }
        Ot = e = i;
      } while (e !== null);
      Kn = Wg, Ot = null;
    }
    function Z1(e, t, i, l, u, m, S, U, D) {
      e.cancelPendingCommit = null;
      do
        Oc();
      while (Ki !== ru);
      if (Ko.flushLegacyContextWarning(), Ko.flushPendingUnsafeLifecycleWarnings(), (nn & (Oa | es)) !== yr)
        throw Error("Should not already be working.");
      if (ze !== null && typeof ze.markCommitStarted == "function" && ze.markCommitStarted(i), t === null) Pe();
      else {
        if (i === 0 && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        ), t === e.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        if (m = t.lanes | t.childLanes, m |= _S, Vi(
          e,
          i,
          m,
          S,
          U,
          D
        ), e === Rn && (Ot = Rn = null, At = 0), Jh = t, gd = e, vd = i, nR = m, iR = u, S5 = l, (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (e.callbackNode = null, e.callbackPriority = 0, Np(ed, function() {
          return T0(), null;
        })) : (e.callbackNode = null, e.callbackPriority = 0), Dg = Vh(), l = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || l) {
          l = le.T, le.T = null, u = pt.p, pt.p = Ui, S = nn, nn |= es;
          try {
            N1(e, t, i);
          } finally {
            nn = S, pt.p = u, le.T = l;
          }
        }
        Ki = f5, Yr(), O1(), tg();
      }
    }
    function Yr() {
      if (Ki === f5) {
        Ki = ru;
        var e = gd, t = Jh, i = vd, l = (t.flags & 13878) !== 0;
        if ((t.subtreeFlags & 13878) !== 0 || l) {
          l = le.T, le.T = null;
          var u = pt.p;
          pt.p = Ui;
          var m = nn;
          nn |= es;
          try {
            wh = i, Bh = e, hp(t, e), Bh = wh = null, i = pR;
            var S = D2(e.containerInfo), U = i.focusedElem, D = i.selectionRange;
            if (S !== U && U && U.ownerDocument && k2(
              U.ownerDocument.documentElement,
              U
            )) {
              if (D !== null && Um(U)) {
                var Q = D.start, ae = D.end;
                if (ae === void 0 && (ae = Q), "selectionStart" in U)
                  U.selectionStart = Q, U.selectionEnd = Math.min(
                    ae,
                    U.value.length
                  );
                else {
                  var ue = U.ownerDocument || document, ee = ue && ue.defaultView || window;
                  if (ee.getSelection) {
                    var me = ee.getSelection(), qe = U.textContent.length, ft = Math.min(
                      D.start,
                      qe
                    ), En = D.end === void 0 ? ft : Math.min(D.end, qe);
                    !me.extend && ft > En && (S = En, En = ft, ft = S);
                    var Jt = Em(
                      U,
                      ft
                    ), A = Em(
                      U,
                      En
                    );
                    if (Jt && A && (me.rangeCount !== 1 || me.anchorNode !== Jt.node || me.anchorOffset !== Jt.offset || me.focusNode !== A.node || me.focusOffset !== A.offset)) {
                      var I = ue.createRange();
                      I.setStart(Jt.node, Jt.offset), me.removeAllRanges(), ft > En ? (me.addRange(I), me.extend(A.node, A.offset)) : (I.setEnd(A.node, A.offset), me.addRange(I));
                    }
                  }
                }
              }
              for (ue = [], me = U; me = me.parentNode; )
                me.nodeType === 1 && ue.push({
                  element: me,
                  left: me.scrollLeft,
                  top: me.scrollTop
                });
              for (typeof U.focus == "function" && U.focus(), U = 0; U < ue.length; U++) {
                var L = ue[U];
                L.element.scrollLeft = L.left, L.element.scrollTop = L.top;
              }
            }
            sv = !!mR, pR = mR = null;
          } finally {
            nn = m, pt.p = u, le.T = l;
          }
        }
        e.current = t, Ki = g5;
      }
    }
    function O1() {
      if (Ki === g5) {
        Ki = ru;
        var e = gd, t = Jh, i = vd, l = (t.flags & 8772) !== 0;
        if ((t.subtreeFlags & 8772) !== 0 || l) {
          l = le.T, le.T = null;
          var u = pt.p;
          pt.p = Ui;
          var m = nn;
          nn |= es;
          try {
            ze !== null && typeof ze.markLayoutEffectsStarted == "function" && ze.markLayoutEffectsStarted(i), wh = i, Bh = e, dp(
              e,
              t.alternate,
              t
            ), Bh = wh = null, ze !== null && typeof ze.markLayoutEffectsStopped == "function" && ze.markLayoutEffectsStopped();
          } finally {
            nn = m, pt.p = u, le.T = l;
          }
        }
        Ki = v5;
      }
    }
    function tg() {
      if (Ki === Ky || Ki === v5) {
        Ki = ru, vS();
        var e = gd, t = Jh, i = vd, l = S5, u = (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0;
        u ? Ki = tR : (Ki = ru, Jh = gd = null, Xr(e, e.pendingLanes), ou = 0, Hf = null);
        var m = e.pendingLanes;
        if (m === 0 && (fd = null), u || Bc(e), u = _r(i), t = t.stateNode, Ei && typeof Ei.onCommitFiberRoot == "function")
          try {
            var S = (t.current.flags & 128) === 128;
            switch (u) {
              case Ui:
                var U = rh;
                break;
              case Tr:
                U = B0;
                break;
              case Po:
                U = ed;
                break;
              case ch:
                U = A0;
                break;
              default:
                U = ed;
            }
            Ei.onCommitFiberRoot(
              Bs,
              t,
              U,
              S
            );
          } catch (ue) {
            pa || (pa = !0, console.error(
              "React instrumentation encountered an error: %s",
              ue
            ));
          }
        if (Jn && e.memoizedUpdaters.clear(), fp(), l !== null) {
          S = le.T, U = pt.p, pt.p = Ui, le.T = null;
          try {
            var D = e.onRecoverableError;
            for (t = 0; t < l.length; t++) {
              var Q = l[t], ae = ng(Q.stack);
              pe(
                Q.source,
                D,
                Q.value,
                ae
              );
            }
          } finally {
            le.T = S, pt.p = U;
          }
        }
        (vd & 3) !== 0 && Oc(), Xa(e), m = e.pendingLanes, (i & 4194090) !== 0 && (m & 42) !== 0 ? (xg = !0, e === aR ? Wf++ : (Wf = 0, aR = e)) : Wf = 0, Fl(0), Pe();
      }
    }
    function ng(e) {
      return e = { componentStack: e }, Object.defineProperty(e, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      }), e;
    }
    function Xr(e, t) {
      (e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, xr(t)));
    }
    function Oc(e) {
      return Yr(), O1(), tg(), T0();
    }
    function T0() {
      if (Ki !== tR) return !1;
      var e = gd, t = nR;
      nR = 0;
      var i = _r(vd), l = Po > i ? Po : i;
      i = le.T;
      var u = pt.p;
      try {
        pt.p = l, le.T = null, l = iR, iR = null;
        var m = gd, S = vd;
        if (Ki = ru, Jh = gd = null, vd = 0, (nn & (Oa | es)) !== yr)
          throw Error("Cannot flush passive effects while already rendering.");
        rR = !0, jg = !1, ze !== null && typeof ze.markPassiveEffectsStarted == "function" && ze.markPassiveEffectsStarted(S);
        var U = nn;
        if (nn |= es, mp(m.current), g0(
          m,
          m.current,
          S,
          l
        ), ze !== null && typeof ze.markPassiveEffectsStopped == "function" && ze.markPassiveEffectsStopped(), Bc(m), nn = U, Fl(0, !1), jg ? m === Hf ? ou++ : (ou = 0, Hf = m) : ou = 0, jg = rR = !1, Ei && typeof Ei.onPostCommitFiberRoot == "function")
          try {
            Ei.onPostCommitFiberRoot(Bs, m);
          } catch (Q) {
            pa || (pa = !0, console.error(
              "React instrumentation encountered an error: %s",
              Q
            ));
          }
        var D = m.current.stateNode;
        return D.effectDuration = 0, D.passiveEffectDuration = 0, !0;
      } finally {
        pt.p = u, le.T = i, Xr(e, t);
      }
    }
    function wc(e, t, i) {
      t = Na(i, t), t = Mi(e.stateNode, t, 2), e = mr(e, t, 2), e !== null && (Ta(e, 2), Xa(e));
    }
    function lt(e, t, i) {
      if (Wh = !1, e.tag === 3)
        wc(e, e, i);
      else {
        for (; t !== null; ) {
          if (t.tag === 3) {
            wc(
              t,
              e,
              i
            );
            return;
          }
          if (t.tag === 1) {
            var l = t.stateNode;
            if (typeof t.type.getDerivedStateFromError == "function" || typeof l.componentDidCatch == "function" && (fd === null || !fd.has(l))) {
              e = Na(i, e), i = On(2), l = mr(t, i, 2), l !== null && (o0(
                i,
                l,
                t,
                e
              ), Ta(l, 2), Xa(l));
              return;
            }
          }
          t = t.return;
        }
        console.error(
          `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
          i
        );
      }
    }
    function Up(e, t, i) {
      var l = e.pingCache;
      if (l === null) {
        l = e.pingCache = new Py();
        var u = /* @__PURE__ */ new Set();
        l.set(t, u);
      } else
        u = l.get(t), u === void 0 && (u = /* @__PURE__ */ new Set(), l.set(t, u));
      u.has(i) || (qS = !0, u.add(i), l = dS.bind(null, e, t, i), Jn && Ac(e, i), t.then(l, l));
    }
    function dS(e, t, i) {
      var l = e.pingCache;
      l !== null && l.delete(t), e.pingedLanes |= e.suspendedLanes & i, e.warmLanes &= ~i, gp() && le.actQueue === null && console.error(
        `A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`
      ), Rn === e && (At & i) === i && (Kn === tu || Kn === YS && (At & 62914560) === At && ro() - eR < m5 ? (nn & Oa) === yr && _l(e, 0) : $S |= i, au === At && (au = 0)), Xa(e);
    }
    function Tp(e, t) {
      t === 0 && (t = ea()), e = ia(e, t), e !== null && (Ta(e, t), Xa(e));
    }
    function y0(e) {
      var t = e.memoizedState, i = 0;
      t !== null && (i = t.retryLane), Tp(e, i);
    }
    function Fs(e, t) {
      var i = 0;
      switch (e.tag) {
        case 13:
          var l = e.stateNode, u = e.memoizedState;
          u !== null && (i = u.retryLane);
          break;
        case 19:
          l = e.stateNode;
          break;
        case 22:
          l = e.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      l !== null && l.delete(t), Tp(e, i);
    }
    function w1(e, t, i) {
      if ((t.subtreeFlags & 67117056) !== 0)
        for (t = t.child; t !== null; ) {
          var l = e, u = t, m = u.type === Yc;
          m = i || m, u.tag !== 22 ? u.flags & 67108864 ? m && pe(
            u,
            yp,
            l,
            u,
            (u.mode & c3) === Vn
          ) : w1(
            l,
            u,
            m
          ) : u.memoizedState === null && (m && u.flags & 8192 ? pe(
            u,
            yp,
            l,
            u
          ) : u.subtreeFlags & 67108864 && pe(
            u,
            w1,
            l,
            u,
            m
          )), t = t.sibling;
        }
    }
    function yp(e, t) {
      var i = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : !0;
      Ce(!0);
      try {
        _a(t), i && R0(t), wo(e, t.alternate, t, !1), i && C1(e, t, 0, null, !1, 0);
      } finally {
        Ce(!1);
      }
    }
    function Bc(e) {
      var t = !0;
      e.current.mode & (va | Xo) || (t = !1), w1(
        e,
        e.current,
        t
      );
    }
    function Er(e) {
      if ((nn & Oa) === yr) {
        var t = e.tag;
        if (t === 3 || t === 1 || t === 0 || t === 11 || t === 14 || t === 15) {
          if (t = Fe(e) || "ReactComponent", Pg !== null) {
            if (Pg.has(t)) return;
            Pg.add(t);
          } else Pg = /* @__PURE__ */ new Set([t]);
          pe(e, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function Ac(e, t) {
      Jn && e.memoizedUpdaters.forEach(function(i) {
        _i(e, i, t);
      });
    }
    function Np(e, t) {
      var i = le.actQueue;
      return i !== null ? (i.push(t), e4) : ah(e, t);
    }
    function ig(e) {
      gp() && le.actQueue === null && pe(e, function() {
        console.error(
          `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`,
          Fe(e)
        );
      });
    }
    function Xa(e) {
      e !== Hh && e.next === null && (Hh === null ? Gg = Hh = e : Hh = Hh.next = e), Yg = !0, le.actQueue !== null ? sR || (sR = !0, ni()) : oR || (oR = !0, ni());
    }
    function Fl(e, t) {
      if (!lR && Yg) {
        lR = !0;
        do
          for (var i = !1, l = Gg; l !== null; ) {
            if (e !== 0) {
              var u = l.pendingLanes;
              if (u === 0) var m = 0;
              else {
                var S = l.suspendedLanes, U = l.pingedLanes;
                m = (1 << 31 - Qi(42 | e) + 1) - 1, m &= u & ~(S & ~U), m = m & 201326741 ? m & 201326741 | 1 : m ? m | 2 : 0;
              }
              m !== 0 && (i = !0, I1(l, m));
            } else
              m = At, m = yn(
                l,
                l === Rn ? m : 0,
                l.cancelPendingCommit !== null || l.timeoutHandle !== cu
              ), (m & 3) === 0 || Bt(l, m) || (i = !0, I1(l, m));
            l = l.next;
          }
        while (i);
        lR = !1;
      }
    }
    function B1() {
      A1();
    }
    function A1() {
      Yg = sR = oR = !1;
      var e = 0;
      su !== 0 && (Ic() && (e = su), su = 0);
      for (var t = ro(), i = null, l = Gg; l !== null; ) {
        var u = l.next, m = Kr(l, t);
        m === 0 ? (l.next = null, i === null ? Gg = u : i.next = u, u === null && (Hh = i)) : (i = l, (e !== 0 || (m & 3) !== 0) && (Yg = !0)), l = u;
      }
      Fl(e);
    }
    function Kr(e, t) {
      for (var i = e.suspendedLanes, l = e.pingedLanes, u = e.expirationTimes, m = e.pendingLanes & -62914561; 0 < m; ) {
        var S = 31 - Qi(m), U = 1 << S, D = u[S];
        D === -1 ? ((U & i) === 0 || (U & l) !== 0) && (u[S] = Vr(U, t)) : D <= t && (e.expiredLanes |= U), m &= ~U;
      }
      if (t = Rn, i = At, i = yn(
        e,
        e === t ? i : 0,
        e.cancelPendingCommit !== null || e.timeoutHandle !== cu
      ), l = e.callbackNode, i === 0 || e === t && (ln === nu || ln === iu) || e.cancelPendingCommit !== null)
        return l !== null && L1(l), e.callbackNode = null, e.callbackPriority = 0;
      if ((i & 3) === 0 || Bt(e, i)) {
        if (t = i & -i, t !== e.callbackPriority || le.actQueue !== null && l !== cR)
          L1(l);
        else return t;
        switch (_r(i)) {
          case Ui:
          case Tr:
            i = B0;
            break;
          case Po:
            i = ed;
            break;
          case ch:
            i = A0;
            break;
          default:
            i = ed;
        }
        return l = Bn.bind(null, e), le.actQueue !== null ? (le.actQueue.push(l), i = cR) : i = ah(i, l), e.callbackPriority = t, e.callbackNode = i, t;
      }
      return l !== null && L1(l), e.callbackPriority = 2, e.callbackNode = null, 2;
    }
    function Bn(e, t) {
      if (xg = Qg = !1, Ki !== ru && Ki !== tR)
        return e.callbackNode = null, e.callbackPriority = 0, null;
      var i = e.callbackNode;
      if (Oc() && e.callbackNode !== i)
        return null;
      var l = At;
      return l = yn(
        e,
        e === Rn ? l : 0,
        e.cancelPendingCommit !== null || e.timeoutHandle !== cu
      ), l === 0 ? null : (ti(
        e,
        l,
        t
      ), Kr(e, ro()), e.callbackNode != null && e.callbackNode === i ? Bn.bind(null, e) : null);
    }
    function I1(e, t) {
      if (Oc()) return null;
      Qg = xg, xg = !1, ti(e, t, !0);
    }
    function L1(e) {
      e !== cR && e !== null && gS(e);
    }
    function ni() {
      le.actQueue !== null && le.actQueue.push(function() {
        return A1(), null;
      }), d4(function() {
        (nn & (Oa | es)) !== yr ? ah(
          rh,
          B1
        ) : A1();
      });
    }
    function bp() {
      return su === 0 && (su = vt()), su;
    }
    function Cp(e) {
      return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : (q(e, "action"), mc("" + e));
    }
    function Vp(e, t) {
      var i = t.ownerDocument.createElement("input");
      return i.name = t.name, i.value = t.value, e.id && i.setAttribute("form", e.id), t.parentNode.insertBefore(i, t), e = new FormData(e), i.parentNode.removeChild(i), e;
    }
    function bn(e, t, i, l, u) {
      if (t === "submit" && i && i.stateNode === u) {
        var m = Cp(
          (u[fa] || null).action
        ), S = l.submitter;
        S && (t = (t = S[fa] || null) ? Cp(t.formAction) : S.getAttribute("formAction"), t !== null && (m = t, S = null));
        var U = new rt(
          "action",
          "action",
          null,
          l,
          u
        );
        e.push({
          event: U,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (l.defaultPrevented) {
                  if (su !== 0) {
                    var D = S ? Vp(
                      u,
                      S
                    ) : new FormData(u), Q = {
                      pending: !0,
                      data: D,
                      method: u.method,
                      action: m
                    };
                    Object.freeze(Q), gl(
                      i,
                      Q,
                      null,
                      D
                    );
                  }
                } else
                  typeof m == "function" && (U.preventDefault(), D = S ? Vp(
                    u,
                    S
                  ) : new FormData(u), Q = {
                    pending: !0,
                    data: D,
                    method: u.method,
                    action: m
                  }, Object.freeze(Q), gl(
                    i,
                    Q,
                    m,
                    D
                  ));
              },
              currentTarget: u
            }
          ]
        });
      }
    }
    function gi(e, t, i) {
      e.currentTarget = i;
      try {
        t(e);
      } catch (l) {
        HS(l);
      }
      e.currentTarget = null;
    }
    function qr(e, t) {
      t = (t & 4) !== 0;
      for (var i = 0; i < e.length; i++) {
        var l = e[i];
        e: {
          var u = void 0, m = l.event;
          if (l = l.listeners, t)
            for (var S = l.length - 1; 0 <= S; S--) {
              var U = l[S], D = U.instance, Q = U.currentTarget;
              if (U = U.listener, D !== u && m.isPropagationStopped())
                break e;
              D !== null ? pe(
                D,
                gi,
                m,
                U,
                Q
              ) : gi(m, U, Q), u = D;
            }
          else
            for (S = 0; S < l.length; S++) {
              if (U = l[S], D = U.instance, Q = U.currentTarget, U = U.listener, D !== u && m.isPropagationStopped())
                break e;
              D !== null ? pe(
                D,
                gi,
                m,
                U,
                Q
              ) : gi(m, U, Q), u = D;
            }
        }
      }
    }
    function Qt(e, t) {
      dR.has(e) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        e
      );
      var i = t[ef];
      i === void 0 && (i = t[ef] = /* @__PURE__ */ new Set());
      var l = e + "__bubble";
      i.has(l) || (W1(t, e, 2, !1), i.add(l));
    }
    function J1(e, t, i) {
      dR.has(e) && !t && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        e
      );
      var l = 0;
      t && (l |= 4), W1(
        i,
        e,
        l,
        t
      );
    }
    function _p(e) {
      if (!e[Xg]) {
        e[Xg] = !0, Rg.forEach(function(i) {
          i !== "selectionchange" && (dR.has(i) || J1(i, !1, e), J1(i, !0, e));
        });
        var t = e.nodeType === 9 ? e : e.ownerDocument;
        t === null || t[Xg] || (t[Xg] = !0, J1("selectionchange", !1, t));
      }
    }
    function W1(e, t, i, l) {
      switch (eh(t)) {
        case Ui:
          var u = mS;
          break;
        case Tr:
          u = $1;
          break;
        default:
          u = Qs;
      }
      i = u.bind(
        null,
        t,
        i,
        e
      ), u = void 0, !K || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (u = !0), l ? u !== void 0 ? e.addEventListener(t, i, {
        capture: !0,
        passive: u
      }) : e.addEventListener(t, i, !0) : u !== void 0 ? e.addEventListener(t, i, {
        passive: u
      }) : e.addEventListener(
        t,
        i,
        !1
      );
    }
    function zi(e, t, i, l, u) {
      var m = l;
      if ((t & 1) === 0 && (t & 2) === 0 && l !== null)
        e: for (; ; ) {
          if (l === null) return;
          var S = l.tag;
          if (S === 3 || S === 4) {
            var U = l.stateNode.containerInfo;
            if (U === u) break;
            if (S === 4)
              for (S = l.return; S !== null; ) {
                var D = S.tag;
                if ((D === 3 || D === 4) && S.stateNode.containerInfo === u)
                  return;
                S = S.return;
              }
            for (; U !== null; ) {
              if (S = oi(U), S === null) return;
              if (D = S.tag, D === 5 || D === 6 || D === 26 || D === 27) {
                l = m = S;
                continue e;
              }
              U = U.parentNode;
            }
          }
          l = l.return;
        }
      xu(function() {
        var Q = m, ae = nl(i), ue = [];
        e: {
          var ee = l3.get(e);
          if (ee !== void 0) {
            var me = rt, qe = e;
            switch (e) {
              case "keypress":
                if (pc(i) === 0) break e;
              case "keydown":
              case "keyup":
                me = vy;
                break;
              case "focusin":
                qe = "focus", me = Wt;
                break;
              case "focusout":
                qe = "blur", me = Wt;
                break;
              case "beforeblur":
              case "afterblur":
                me = Wt;
                break;
              case "click":
                if (i.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                me = Mt;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                me = ct;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                me = Ey;
                break;
              case a3:
              case r3:
              case o3:
                me = US;
                break;
              case s3:
                me = Ty;
                break;
              case "scroll":
              case "scrollend":
                me = P;
                break;
              case "wheel":
                me = Ny;
                break;
              case "copy":
              case "cut":
              case "paste":
                me = dy;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                me = X6;
                break;
              case "toggle":
              case "beforetoggle":
                me = Cy;
            }
            var ft = (t & 4) !== 0, En = !ft && (e === "scroll" || e === "scrollend"), Jt = ft ? ee !== null ? ee + "Capture" : null : ee;
            ft = [];
            for (var A = Q, I; A !== null; ) {
              var L = A;
              if (I = L.stateNode, L = L.tag, L !== 5 && L !== 26 && L !== 27 || I === null || Jt === null || (L = bo(A, Jt), L != null && ft.push(
                ji(
                  A,
                  L,
                  I
                )
              )), En) break;
              A = A.return;
            }
            0 < ft.length && (ee = new me(
              ee,
              qe,
              null,
              i,
              ae
            ), ue.push({
              event: ee,
              listeners: ft
            }));
          }
        }
        if ((t & 7) === 0) {
          e: {
            if (ee = e === "mouseover" || e === "pointerover", me = e === "mouseout" || e === "pointerout", ee && i !== p && (qe = i.relatedTarget || i.fromElement) && (oi(qe) || qe[Is]))
              break e;
            if ((me || ee) && (ee = ae.window === ae ? ae : (ee = ae.ownerDocument) ? ee.defaultView || ee.parentWindow : window, me ? (qe = i.relatedTarget || i.toElement, me = Q, qe = qe ? oi(qe) : null, qe !== null && (En = ge(qe), ft = qe.tag, qe !== En || ft !== 5 && ft !== 27 && ft !== 6) && (qe = null)) : (me = null, qe = Q), me !== qe)) {
              if (ft = Mt, L = "onMouseLeave", Jt = "onMouseEnter", A = "mouse", (e === "pointerout" || e === "pointerover") && (ft = X6, L = "onPointerLeave", Jt = "onPointerEnter", A = "pointer"), En = me == null ? ee : Li(me), I = qe == null ? ee : Li(qe), ee = new ft(
                L,
                A + "leave",
                me,
                i,
                ae
              ), ee.target = En, ee.relatedTarget = I, L = null, oi(ae) === Q && (ft = new ft(
                Jt,
                A + "enter",
                qe,
                i,
                ae
              ), ft.target = I, ft.relatedTarget = En, L = ft), En = L, me && qe)
                t: {
                  for (ft = me, Jt = qe, A = 0, I = ft; I; I = di(I))
                    A++;
                  for (I = 0, L = Jt; L; L = di(L))
                    I++;
                  for (; 0 < A - I; )
                    ft = di(ft), A--;
                  for (; 0 < I - A; )
                    Jt = di(Jt), I--;
                  for (; A--; ) {
                    if (ft === Jt || Jt !== null && ft === Jt.alternate)
                      break t;
                    ft = di(ft), Jt = di(Jt);
                  }
                  ft = null;
                }
              else ft = null;
              me !== null && Fp(
                ue,
                ee,
                me,
                ft,
                !1
              ), qe !== null && En !== null && Fp(
                ue,
                En,
                qe,
                ft,
                !0
              );
            }
          }
          e: {
            if (ee = Q ? Li(Q) : window, me = ee.nodeName && ee.nodeName.toLowerCase(), me === "select" || me === "input" && ee.type === "file")
              var fe = Sm;
            else if (V2(ee))
              if (n3)
                fe = oS;
              else {
                fe = Rm;
                var Le = aS;
              }
            else
              me = ee.nodeName, !me || me.toLowerCase() !== "input" || ee.type !== "checkbox" && ee.type !== "radio" ? Q && tl(Q.elementType) && (fe = Sm) : fe = rS;
            if (fe && (fe = fe(e, Q))) {
              Bu(
                ue,
                fe,
                i,
                ae
              );
              break e;
            }
            Le && Le(e, ee, Q), e === "focusout" && Q && ee.type === "number" && Q.memoizedProps.value != null && _u(ee, "number", ee.value);
          }
          switch (Le = Q ? Li(Q) : window, e) {
            case "focusin":
              (V2(Le) || Le.contentEditable === "true") && (Rh = Le, yS = Q, Uf = null);
              break;
            case "focusout":
              Uf = yS = Rh = null;
              break;
            case "mousedown":
              NS = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              NS = !1, Q2(
                ue,
                i,
                ae
              );
              break;
            case "selectionchange":
              if (My) break;
            case "keydown":
            case "keyup":
              Q2(
                ue,
                i,
                ae
              );
          }
          var Tt;
          if (TS)
            e: {
              switch (e) {
                case "compositionstart":
                  var $e = "onCompositionStart";
                  break e;
                case "compositionend":
                  $e = "onCompositionEnd";
                  break e;
                case "compositionupdate":
                  $e = "onCompositionUpdate";
                  break e;
              }
              $e = void 0;
            }
          else
            Sh ? Hi(e, i) && ($e = "onCompositionEnd") : e === "keydown" && i.keyCode === K6 && ($e = "onCompositionStart");
          $e && (q6 && i.locale !== "ko" && (Sh || $e !== "onCompositionStart" ? $e === "onCompositionEnd" && Sh && (Tt = Co()) : (Ee = ae, ie = "value" in Ee ? Ee.value : Ee.textContent, Sh = !0)), Le = N0(
            Q,
            $e
          ), 0 < Le.length && ($e = new Y6(
            $e,
            e,
            null,
            i,
            ae
          ), ue.push({
            event: $e,
            listeners: Le
          }), Tt ? $e.data = Tt : (Tt = cs(i), Tt !== null && ($e.data = Tt)))), (Tt = _y ? wu(e, i) : wd(e, i)) && ($e = N0(
            Q,
            "onBeforeInput"
          ), 0 < $e.length && (Le = new hy(
            "onBeforeInput",
            "beforeinput",
            null,
            i,
            ae
          ), ue.push({
            event: Le,
            listeners: $e
          }), Le.data = Tt)), bn(
            ue,
            e,
            Q,
            i,
            ae
          );
        }
        qr(ue, t);
      });
    }
    function ji(e, t, i) {
      return {
        instance: e,
        listener: t,
        currentTarget: i
      };
    }
    function N0(e, t) {
      for (var i = t + "Capture", l = []; e !== null; ) {
        var u = e, m = u.stateNode;
        if (u = u.tag, u !== 5 && u !== 26 && u !== 27 || m === null || (u = bo(e, i), u != null && l.unshift(
          ji(e, u, m)
        ), u = bo(e, t), u != null && l.push(
          ji(e, u, m)
        )), e.tag === 3) return l;
        e = e.return;
      }
      return [];
    }
    function di(e) {
      if (e === null) return null;
      do
        e = e.return;
      while (e && e.tag !== 5 && e.tag !== 27);
      return e || null;
    }
    function Fp(e, t, i, l, u) {
      for (var m = t._reactName, S = []; i !== null && i !== l; ) {
        var U = i, D = U.alternate, Q = U.stateNode;
        if (U = U.tag, D !== null && D === l) break;
        U !== 5 && U !== 26 && U !== 27 || Q === null || (D = Q, u ? (Q = bo(i, m), Q != null && S.unshift(
          ji(i, Q, D)
        )) : u || (Q = bo(i, m), Q != null && S.push(
          ji(i, Q, D)
        ))), i = i.return;
      }
      S.length !== 0 && e.push({ event: t, listeners: S });
    }
    function $r(e, t) {
      hc(e, t), e !== "input" && e !== "textarea" && e !== "select" || t == null || t.value !== null || vf || (vf = !0, e === "select" && t.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        e
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        e
      ));
      var i = {
        registrationNameDependencies: tr,
        possibleRegistrationNames: Bl
      };
      tl(e) || typeof t.is == "string" || fm(e, t, i), t.contentEditable && !t.suppressContentEditableWarning && t.children != null && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function Cn(e, t, i, l) {
      t !== i && (i = vi(i), vi(t) !== i && (l[e] = t));
    }
    function Ms(e, t, i) {
      t.forEach(function(l) {
        i[kp(l)] = l === "style" ? kl(e) : e.getAttribute(l);
      });
    }
    function Ka(e, t) {
      t === !1 ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        e,
        e,
        e
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        e,
        typeof t
      );
    }
    function H1(e, t) {
      return e = e.namespaceURI === j0 || e.namespaceURI === sd ? e.ownerDocument.createElementNS(
        e.namespaceURI,
        e.tagName
      ) : e.ownerDocument.createElement(e.tagName), e.innerHTML = t, e.innerHTML;
    }
    function vi(e) {
      return M(e) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        De(e)
      ), W(e)), (typeof e == "string" ? e : "" + e).replace(t4, `
`).replace(n4, "");
    }
    function Mp(e, t) {
      return t = vi(t), vi(e) === t;
    }
    function Ao() {
    }
    function jt(e, t, i, l, u, m) {
      switch (i) {
        case "children":
          typeof l == "string" ? (Zd(l, t, !1), t === "body" || t === "textarea" && l === "" || el(e, l)) : (typeof l == "number" || typeof l == "bigint") && (Zd("" + l, t, !1), t !== "body" && el(e, "" + l));
          break;
        case "className":
          ht(e, "class", l);
          break;
        case "tabIndex":
          ht(e, "tabindex", l);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          ht(e, i, l);
          break;
        case "style":
          Od(e, l, m);
          break;
        case "data":
          if (t !== "object") {
            ht(e, "data", l);
            break;
          }
        case "src":
        case "href":
          if (l === "" && (t !== "a" || i !== "href")) {
            console.error(
              i === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              i,
              i
            ), e.removeAttribute(i);
            break;
          }
          if (l == null || typeof l == "function" || typeof l == "symbol" || typeof l == "boolean") {
            e.removeAttribute(i);
            break;
          }
          q(l, i), l = mc("" + l), e.setAttribute(i, l);
          break;
        case "action":
        case "formAction":
          if (l != null && (t === "form" ? i === "formAction" ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : typeof l == "function" && (u.encType == null && u.method == null || $g || ($g = !0, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), u.target == null || qg || (qg = !0, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : t === "input" || t === "button" ? i === "action" ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : t !== "input" || u.type === "submit" || u.type === "image" || Kg ? t !== "button" || u.type == null || u.type === "submit" || Kg ? typeof l == "function" && (u.name == null || y5 || (y5 = !0, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), u.formEncType == null && u.formMethod == null || $g || ($g = !0, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), u.formTarget == null || qg || (qg = !0, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (Kg = !0, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (Kg = !0, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : console.error(
            i === "action" ? "You can only pass the action prop to <form>." : "You can only pass the formAction prop to <input> or <button>."
          )), typeof l == "function") {
            e.setAttribute(
              i,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            typeof m == "function" && (i === "formAction" ? (t !== "input" && jt(e, t, "name", u.name, u, null), jt(
              e,
              t,
              "formEncType",
              u.formEncType,
              u,
              null
            ), jt(
              e,
              t,
              "formMethod",
              u.formMethod,
              u,
              null
            ), jt(
              e,
              t,
              "formTarget",
              u.formTarget,
              u,
              null
            )) : (jt(
              e,
              t,
              "encType",
              u.encType,
              u,
              null
            ), jt(e, t, "method", u.method, u, null), jt(
              e,
              t,
              "target",
              u.target,
              u,
              null
            )));
          if (l == null || typeof l == "symbol" || typeof l == "boolean") {
            e.removeAttribute(i);
            break;
          }
          q(l, i), l = mc("" + l), e.setAttribute(i, l);
          break;
        case "onClick":
          l != null && (typeof l != "function" && Ka(i, l), e.onclick = Ao);
          break;
        case "onScroll":
          l != null && (typeof l != "function" && Ka(i, l), Qt("scroll", e));
          break;
        case "onScrollEnd":
          l != null && (typeof l != "function" && Ka(i, l), Qt("scrollend", e));
          break;
        case "dangerouslySetInnerHTML":
          if (l != null) {
            if (typeof l != "object" || !("__html" in l))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (i = l.__html, i != null) {
              if (u.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              e.innerHTML = i;
            }
          }
          break;
        case "multiple":
          e.multiple = l && typeof l != "function" && typeof l != "symbol";
          break;
        case "muted":
          e.muted = l && typeof l != "function" && typeof l != "symbol";
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (l == null || typeof l == "function" || typeof l == "boolean" || typeof l == "symbol") {
            e.removeAttribute("xlink:href");
            break;
          }
          q(l, i), i = mc("" + l), e.setAttributeNS(lu, "xlink:href", i);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          l != null && typeof l != "function" && typeof l != "symbol" ? (q(l, i), e.setAttribute(i, "" + l)) : e.removeAttribute(i);
          break;
        case "inert":
          l !== "" || ev[i] || (ev[i] = !0, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            i
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          l && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(i, "") : e.removeAttribute(i);
          break;
        case "capture":
        case "download":
          l === !0 ? e.setAttribute(i, "") : l !== !1 && l != null && typeof l != "function" && typeof l != "symbol" ? (q(l, i), e.setAttribute(i, l)) : e.removeAttribute(i);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          l != null && typeof l != "function" && typeof l != "symbol" && !isNaN(l) && 1 <= l ? (q(l, i), e.setAttribute(i, l)) : e.removeAttribute(i);
          break;
        case "rowSpan":
        case "start":
          l == null || typeof l == "function" || typeof l == "symbol" || isNaN(l) ? e.removeAttribute(i) : (q(l, i), e.setAttribute(i, l));
          break;
        case "popover":
          Qt("beforetoggle", e), Qt("toggle", e), Vt(e, "popover", l);
          break;
        case "xlinkActuate":
          Nn(
            e,
            lu,
            "xlink:actuate",
            l
          );
          break;
        case "xlinkArcrole":
          Nn(
            e,
            lu,
            "xlink:arcrole",
            l
          );
          break;
        case "xlinkRole":
          Nn(
            e,
            lu,
            "xlink:role",
            l
          );
          break;
        case "xlinkShow":
          Nn(
            e,
            lu,
            "xlink:show",
            l
          );
          break;
        case "xlinkTitle":
          Nn(
            e,
            lu,
            "xlink:title",
            l
          );
          break;
        case "xlinkType":
          Nn(
            e,
            lu,
            "xlink:type",
            l
          );
          break;
        case "xmlBase":
          Nn(
            e,
            uR,
            "xml:base",
            l
          );
          break;
        case "xmlLang":
          Nn(
            e,
            uR,
            "xml:lang",
            l
          );
          break;
        case "xmlSpace":
          Nn(
            e,
            uR,
            "xml:space",
            l
          );
          break;
        case "is":
          m != null && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          ), Vt(e, "is", l);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          N5 || l == null || typeof l != "object" || (N5 = !0, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            l
          ));
        default:
          !(2 < i.length) || i[0] !== "o" && i[0] !== "O" || i[1] !== "n" && i[1] !== "N" ? (i = Qu(i), Vt(e, i, l)) : tr.hasOwnProperty(i) && l != null && typeof l != "function" && Ka(i, l);
      }
    }
    function Ml(e, t, i, l, u, m) {
      switch (i) {
        case "style":
          Od(e, l, m);
          break;
        case "dangerouslySetInnerHTML":
          if (l != null) {
            if (typeof l != "object" || !("__html" in l))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (i = l.__html, i != null) {
              if (u.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              e.innerHTML = i;
            }
          }
          break;
        case "children":
          typeof l == "string" ? el(e, l) : (typeof l == "number" || typeof l == "bigint") && el(e, "" + l);
          break;
        case "onScroll":
          l != null && (typeof l != "function" && Ka(i, l), Qt("scroll", e));
          break;
        case "onScrollEnd":
          l != null && (typeof l != "function" && Ka(i, l), Qt("scrollend", e));
          break;
        case "onClick":
          l != null && (typeof l != "function" && Ka(i, l), e.onclick = Ao);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (tr.hasOwnProperty(i))
            l != null && typeof l != "function" && Ka(i, l);
          else
            e: {
              if (i[0] === "o" && i[1] === "n" && (u = i.endsWith("Capture"), t = i.slice(2, u ? i.length - 7 : void 0), m = e[fa] || null, m = m != null ? m[i] : null, typeof m == "function" && e.removeEventListener(t, m, u), typeof l == "function")) {
                typeof m != "function" && m !== null && (i in e ? e[i] = null : e.hasAttribute(i) && e.removeAttribute(i)), e.addEventListener(t, l, u);
                break e;
              }
              i in e ? e[i] = l : l === !0 ? e.setAttribute(i, "") : Vt(e, i, l);
            }
      }
    }
    function An(e, t, i) {
      switch ($r(t, i), t) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          Qt("error", e), Qt("load", e);
          var l = !1, u = !1, m;
          for (m in i)
            if (i.hasOwnProperty(m)) {
              var S = i[m];
              if (S != null)
                switch (m) {
                  case "src":
                    l = !0;
                    break;
                  case "srcSet":
                    u = !0;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    jt(e, t, m, S, i, null);
                }
            }
          u && jt(e, t, "srcSet", i.srcSet, i, null), l && jt(e, t, "src", i.src, i, null);
          return;
        case "input":
          Ye("input", i), Qt("invalid", e);
          var U = m = S = u = null, D = null, Q = null;
          for (l in i)
            if (i.hasOwnProperty(l)) {
              var ae = i[l];
              if (ae != null)
                switch (l) {
                  case "name":
                    u = ae;
                    break;
                  case "type":
                    S = ae;
                    break;
                  case "checked":
                    D = ae;
                    break;
                  case "defaultChecked":
                    Q = ae;
                    break;
                  case "value":
                    m = ae;
                    break;
                  case "defaultValue":
                    U = ae;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (ae != null)
                      throw Error(
                        t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    jt(e, t, l, ae, i, null);
                }
            }
          rs(e, i), T2(
            e,
            m,
            U,
            D,
            Q,
            S,
            u,
            !1
          ), Xt(e);
          return;
        case "select":
          Ye("select", i), Qt("invalid", e), l = S = m = null;
          for (u in i)
            if (i.hasOwnProperty(u) && (U = i[u], U != null))
              switch (u) {
                case "value":
                  m = U;
                  break;
                case "defaultValue":
                  S = U;
                  break;
                case "multiple":
                  l = U;
                default:
                  jt(
                    e,
                    t,
                    u,
                    U,
                    i,
                    null
                  );
              }
          Dd(e, i), t = m, i = S, e.multiple = !!l, t != null ? No(e, !!l, t, !1) : i != null && No(e, !!l, i, !0);
          return;
        case "textarea":
          Ye("textarea", i), Qt("invalid", e), m = u = l = null;
          for (S in i)
            if (i.hasOwnProperty(S) && (U = i[S], U != null))
              switch (S) {
                case "value":
                  l = U;
                  break;
                case "defaultValue":
                  u = U;
                  break;
                case "children":
                  m = U;
                  break;
                case "dangerouslySetInnerHTML":
                  if (U != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  jt(
                    e,
                    t,
                    S,
                    U,
                    i,
                    null
                  );
              }
          Mr(e, i), dm(e, l, u, m), Xt(e);
          return;
        case "option":
          cm(e, i);
          for (D in i)
            if (i.hasOwnProperty(D) && (l = i[D], l != null))
              switch (D) {
                case "selected":
                  e.selected = l && typeof l != "function" && typeof l != "symbol";
                  break;
                default:
                  jt(e, t, D, l, i, null);
              }
          return;
        case "dialog":
          Qt("beforetoggle", e), Qt("toggle", e), Qt("cancel", e), Qt("close", e);
          break;
        case "iframe":
        case "object":
          Qt("load", e);
          break;
        case "video":
        case "audio":
          for (l = 0; l < zf.length; l++)
            Qt(zf[l], e);
          break;
        case "image":
          Qt("error", e), Qt("load", e);
          break;
        case "details":
          Qt("toggle", e);
          break;
        case "embed":
        case "source":
        case "link":
          Qt("error", e), Qt("load", e);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (Q in i)
            if (i.hasOwnProperty(Q) && (l = i[Q], l != null))
              switch (Q) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  jt(e, t, Q, l, i, null);
              }
          return;
        default:
          if (tl(t)) {
            for (ae in i)
              i.hasOwnProperty(ae) && (l = i[ae], l !== void 0 && Ml(
                e,
                t,
                ae,
                l,
                i,
                void 0
              ));
            return;
          }
      }
      for (U in i)
        i.hasOwnProperty(U) && (l = i[U], l != null && jt(e, t, U, l, i, null));
    }
    function ag(e, t, i, l) {
      switch ($r(t, l), t) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var u = null, m = null, S = null, U = null, D = null, Q = null, ae = null;
          for (me in i) {
            var ue = i[me];
            if (i.hasOwnProperty(me) && ue != null)
              switch (me) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  D = ue;
                default:
                  l.hasOwnProperty(me) || jt(
                    e,
                    t,
                    me,
                    null,
                    l,
                    ue
                  );
              }
          }
          for (var ee in l) {
            var me = l[ee];
            if (ue = i[ee], l.hasOwnProperty(ee) && (me != null || ue != null))
              switch (ee) {
                case "type":
                  m = me;
                  break;
                case "name":
                  u = me;
                  break;
                case "checked":
                  Q = me;
                  break;
                case "defaultChecked":
                  ae = me;
                  break;
                case "value":
                  S = me;
                  break;
                case "defaultValue":
                  U = me;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (me != null)
                    throw Error(
                      t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  me !== ue && jt(
                    e,
                    t,
                    ee,
                    me,
                    l,
                    ue
                  );
              }
          }
          t = i.type === "checkbox" || i.type === "radio" ? i.checked != null : i.value != null, l = l.type === "checkbox" || l.type === "radio" ? l.checked != null : l.value != null, t || !l || T5 || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), T5 = !0), !t || l || U5 || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), U5 = !0), os(
            e,
            S,
            U,
            D,
            Q,
            ae,
            m,
            u
          );
          return;
        case "select":
          me = S = U = ee = null;
          for (m in i)
            if (D = i[m], i.hasOwnProperty(m) && D != null)
              switch (m) {
                case "value":
                  break;
                case "multiple":
                  me = D;
                default:
                  l.hasOwnProperty(m) || jt(
                    e,
                    t,
                    m,
                    null,
                    l,
                    D
                  );
              }
          for (u in l)
            if (m = l[u], D = i[u], l.hasOwnProperty(u) && (m != null || D != null))
              switch (u) {
                case "value":
                  ee = m;
                  break;
                case "defaultValue":
                  U = m;
                  break;
                case "multiple":
                  S = m;
                default:
                  m !== D && jt(
                    e,
                    t,
                    u,
                    m,
                    l,
                    D
                  );
              }
          l = U, t = S, i = me, ee != null ? No(e, !!t, ee, !1) : !!i != !!t && (l != null ? No(e, !!t, l, !0) : No(e, !!t, t ? [] : "", !1));
          return;
        case "textarea":
          me = ee = null;
          for (U in i)
            if (u = i[U], i.hasOwnProperty(U) && u != null && !l.hasOwnProperty(U))
              switch (U) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  jt(e, t, U, null, l, u);
              }
          for (S in l)
            if (u = l[S], m = i[S], l.hasOwnProperty(S) && (u != null || m != null))
              switch (S) {
                case "value":
                  ee = u;
                  break;
                case "defaultValue":
                  me = u;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (u != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  u !== m && jt(e, t, S, u, l, m);
              }
          Fu(e, ee, me);
          return;
        case "option":
          for (var qe in i)
            if (ee = i[qe], i.hasOwnProperty(qe) && ee != null && !l.hasOwnProperty(qe))
              switch (qe) {
                case "selected":
                  e.selected = !1;
                  break;
                default:
                  jt(
                    e,
                    t,
                    qe,
                    null,
                    l,
                    ee
                  );
              }
          for (D in l)
            if (ee = l[D], me = i[D], l.hasOwnProperty(D) && ee !== me && (ee != null || me != null))
              switch (D) {
                case "selected":
                  e.selected = ee && typeof ee != "function" && typeof ee != "symbol";
                  break;
                default:
                  jt(
                    e,
                    t,
                    D,
                    ee,
                    l,
                    me
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var ft in i)
            ee = i[ft], i.hasOwnProperty(ft) && ee != null && !l.hasOwnProperty(ft) && jt(
              e,
              t,
              ft,
              null,
              l,
              ee
            );
          for (Q in l)
            if (ee = l[Q], me = i[Q], l.hasOwnProperty(Q) && ee !== me && (ee != null || me != null))
              switch (Q) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (ee != null)
                    throw Error(
                      t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  jt(
                    e,
                    t,
                    Q,
                    ee,
                    l,
                    me
                  );
              }
          return;
        default:
          if (tl(t)) {
            for (var En in i)
              ee = i[En], i.hasOwnProperty(En) && ee !== void 0 && !l.hasOwnProperty(En) && Ml(
                e,
                t,
                En,
                void 0,
                l,
                ee
              );
            for (ae in l)
              ee = l[ae], me = i[ae], !l.hasOwnProperty(ae) || ee === me || ee === void 0 && me === void 0 || Ml(
                e,
                t,
                ae,
                ee,
                l,
                me
              );
            return;
          }
      }
      for (var Jt in i)
        ee = i[Jt], i.hasOwnProperty(Jt) && ee != null && !l.hasOwnProperty(Jt) && jt(e, t, Jt, null, l, ee);
      for (ue in l)
        ee = l[ue], me = i[ue], !l.hasOwnProperty(ue) || ee === me || ee == null && me == null || jt(e, t, ue, ee, l, me);
    }
    function kp(e) {
      switch (e) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return e;
      }
    }
    function kl(e) {
      var t = {};
      e = e.style;
      for (var i = 0; i < e.length; i++) {
        var l = e[i];
        t[l] = e.getPropertyValue(l);
      }
      return t;
    }
    function Dp(e, t, i) {
      if (t != null && typeof t != "object")
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var l, u = l = "", m;
        for (m in t)
          if (t.hasOwnProperty(m)) {
            var S = t[m];
            S != null && typeof S != "boolean" && S !== "" && (m.indexOf("--") === 0 ? (Re(S, m), l += u + m + ":" + ("" + S).trim()) : typeof S != "number" || S === 0 || z0.has(m) ? (Re(S, m), l += u + m.replace(Go, "-$1").toLowerCase().replace(Yo, "-ms-") + ":" + ("" + S).trim()) : l += u + m.replace(Go, "-$1").toLowerCase().replace(Yo, "-ms-") + ":" + S + "px", u = ";");
          }
        l = l || null, t = e.getAttribute("style"), t !== l && (l = vi(l), vi(t) !== l && (i.style = kl(e)));
      }
    }
    function Pi(e, t, i, l, u, m) {
      if (u.delete(i), e = e.getAttribute(i), e === null)
        switch (typeof l) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (l != null)
        switch (typeof l) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (q(l, t), e === "" + l)
              return;
        }
      Cn(t, e, l, m);
    }
    function Qp(e, t, i, l, u, m) {
      if (u.delete(i), e = e.getAttribute(i), e === null) {
        switch (typeof l) {
          case "function":
          case "symbol":
            return;
        }
        if (!l) return;
      } else
        switch (typeof l) {
          case "function":
          case "symbol":
            break;
          default:
            if (l) return;
        }
      Cn(t, e, l, m);
    }
    function xp(e, t, i, l, u, m) {
      if (u.delete(i), e = e.getAttribute(i), e === null)
        switch (typeof l) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (l != null)
        switch (typeof l) {
          case "function":
          case "symbol":
            break;
          default:
            if (q(l, i), e === "" + l)
              return;
        }
      Cn(t, e, l, m);
    }
    function rg(e, t, i, l, u, m) {
      if (u.delete(i), e = e.getAttribute(i), e === null)
        switch (typeof l) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(l)) return;
        }
      else if (l != null)
        switch (typeof l) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(l) && (q(l, t), e === "" + l))
              return;
        }
      Cn(t, e, l, m);
    }
    function qt(e, t, i, l, u, m) {
      if (u.delete(i), e = e.getAttribute(i), e === null)
        switch (typeof l) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (l != null)
        switch (typeof l) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (q(l, t), i = mc("" + l), e === i)
              return;
        }
      Cn(t, e, l, m);
    }
    function un(e, t, i, l) {
      for (var u = {}, m = /* @__PURE__ */ new Set(), S = e.attributes, U = 0; U < S.length; U++)
        switch (S[U].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            m.add(S[U].name);
        }
      if (tl(t)) {
        for (var D in i)
          if (i.hasOwnProperty(D)) {
            var Q = i[D];
            if (Q != null) {
              if (tr.hasOwnProperty(D))
                typeof Q != "function" && Ka(D, Q);
              else if (i.suppressHydrationWarning !== !0)
                switch (D) {
                  case "children":
                    typeof Q != "string" && typeof Q != "number" || Cn(
                      "children",
                      e.textContent,
                      Q,
                      u
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    S = e.innerHTML, Q = Q ? Q.__html : void 0, Q != null && (Q = H1(e, Q), Cn(
                      D,
                      S,
                      Q,
                      u
                    ));
                    continue;
                  case "style":
                    m.delete(D), Dp(e, Q, u);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    m.delete(D.toLowerCase()), console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      D
                    );
                    continue;
                  case "className":
                    m.delete("class"), S = gt(
                      e,
                      "class",
                      Q
                    ), Cn(
                      "className",
                      S,
                      Q,
                      u
                    );
                    continue;
                  default:
                    l.context === Kl && t !== "svg" && t !== "math" ? m.delete(D.toLowerCase()) : m.delete(D), S = gt(
                      e,
                      D,
                      Q
                    ), Cn(
                      D,
                      S,
                      Q,
                      u
                    );
                }
            }
          }
      } else
        for (Q in i)
          if (i.hasOwnProperty(Q) && (D = i[Q], D != null)) {
            if (tr.hasOwnProperty(Q))
              typeof D != "function" && Ka(Q, D);
            else if (i.suppressHydrationWarning !== !0)
              switch (Q) {
                case "children":
                  typeof D != "string" && typeof D != "number" || Cn(
                    "children",
                    e.textContent,
                    D,
                    u
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  S = e.innerHTML, D = D ? D.__html : void 0, D != null && (D = H1(e, D), S !== D && (u[Q] = { __html: S }));
                  continue;
                case "className":
                  Pi(
                    e,
                    Q,
                    "class",
                    D,
                    m,
                    u
                  );
                  continue;
                case "tabIndex":
                  Pi(
                    e,
                    Q,
                    "tabindex",
                    D,
                    m,
                    u
                  );
                  continue;
                case "style":
                  m.delete(Q), Dp(e, D, u);
                  continue;
                case "multiple":
                  m.delete(Q), Cn(
                    Q,
                    e.multiple,
                    D,
                    u
                  );
                  continue;
                case "muted":
                  m.delete(Q), Cn(
                    Q,
                    e.muted,
                    D,
                    u
                  );
                  continue;
                case "autoFocus":
                  m.delete("autofocus"), Cn(
                    Q,
                    e.autofocus,
                    D,
                    u
                  );
                  continue;
                case "data":
                  if (t !== "object") {
                    m.delete(Q), S = e.getAttribute("data"), Cn(
                      Q,
                      S,
                      D,
                      u
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!(D !== "" || t === "a" && Q === "href" || t === "object" && Q === "data")) {
                    console.error(
                      Q === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      Q,
                      Q
                    );
                    continue;
                  }
                  qt(
                    e,
                    Q,
                    Q,
                    D,
                    m,
                    u
                  );
                  continue;
                case "action":
                case "formAction":
                  if (S = e.getAttribute(Q), typeof D == "function") {
                    m.delete(Q.toLowerCase()), Q === "formAction" ? (m.delete("name"), m.delete("formenctype"), m.delete("formmethod"), m.delete("formtarget")) : (m.delete("enctype"), m.delete("method"), m.delete("target"));
                    continue;
                  } else if (S === i4) {
                    m.delete(Q.toLowerCase()), Cn(
                      Q,
                      "function",
                      D,
                      u
                    );
                    continue;
                  }
                  qt(
                    e,
                    Q,
                    Q.toLowerCase(),
                    D,
                    m,
                    u
                  );
                  continue;
                case "xlinkHref":
                  qt(
                    e,
                    Q,
                    "xlink:href",
                    D,
                    m,
                    u
                  );
                  continue;
                case "contentEditable":
                  xp(
                    e,
                    Q,
                    "contenteditable",
                    D,
                    m,
                    u
                  );
                  continue;
                case "spellCheck":
                  xp(
                    e,
                    Q,
                    "spellcheck",
                    D,
                    m,
                    u
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  xp(
                    e,
                    Q,
                    Q,
                    D,
                    m,
                    u
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  Qp(
                    e,
                    Q,
                    Q.toLowerCase(),
                    D,
                    m,
                    u
                  );
                  continue;
                case "capture":
                case "download":
                  e: {
                    U = e;
                    var ae = S = Q, ue = u;
                    if (m.delete(ae), U = U.getAttribute(ae), U === null)
                      switch (typeof D) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break e;
                        default:
                          if (D === !1) break e;
                      }
                    else if (D != null)
                      switch (typeof D) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (D === !0 && U === "") break e;
                          break;
                        default:
                          if (q(D, S), U === "" + D)
                            break e;
                      }
                    Cn(
                      S,
                      U,
                      D,
                      ue
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  e: {
                    if (U = e, ae = S = Q, ue = u, m.delete(ae), U = U.getAttribute(ae), U === null)
                      switch (typeof D) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break e;
                        default:
                          if (isNaN(D) || 1 > D) break e;
                      }
                    else if (D != null)
                      switch (typeof D) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(D) || 1 > D) && (q(D, S), U === "" + D))
                            break e;
                      }
                    Cn(
                      S,
                      U,
                      D,
                      ue
                    );
                  }
                  continue;
                case "rowSpan":
                  rg(
                    e,
                    Q,
                    "rowspan",
                    D,
                    m,
                    u
                  );
                  continue;
                case "start":
                  rg(
                    e,
                    Q,
                    Q,
                    D,
                    m,
                    u
                  );
                  continue;
                case "xHeight":
                  Pi(
                    e,
                    Q,
                    "x-height",
                    D,
                    m,
                    u
                  );
                  continue;
                case "xlinkActuate":
                  Pi(
                    e,
                    Q,
                    "xlink:actuate",
                    D,
                    m,
                    u
                  );
                  continue;
                case "xlinkArcrole":
                  Pi(
                    e,
                    Q,
                    "xlink:arcrole",
                    D,
                    m,
                    u
                  );
                  continue;
                case "xlinkRole":
                  Pi(
                    e,
                    Q,
                    "xlink:role",
                    D,
                    m,
                    u
                  );
                  continue;
                case "xlinkShow":
                  Pi(
                    e,
                    Q,
                    "xlink:show",
                    D,
                    m,
                    u
                  );
                  continue;
                case "xlinkTitle":
                  Pi(
                    e,
                    Q,
                    "xlink:title",
                    D,
                    m,
                    u
                  );
                  continue;
                case "xlinkType":
                  Pi(
                    e,
                    Q,
                    "xlink:type",
                    D,
                    m,
                    u
                  );
                  continue;
                case "xmlBase":
                  Pi(
                    e,
                    Q,
                    "xml:base",
                    D,
                    m,
                    u
                  );
                  continue;
                case "xmlLang":
                  Pi(
                    e,
                    Q,
                    "xml:lang",
                    D,
                    m,
                    u
                  );
                  continue;
                case "xmlSpace":
                  Pi(
                    e,
                    Q,
                    "xml:space",
                    D,
                    m,
                    u
                  );
                  continue;
                case "inert":
                  D !== "" || ev[Q] || (ev[Q] = !0, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    Q
                  )), Qp(
                    e,
                    Q,
                    Q,
                    D,
                    m,
                    u
                  );
                  continue;
                default:
                  if (!(2 < Q.length) || Q[0] !== "o" && Q[0] !== "O" || Q[1] !== "n" && Q[1] !== "N") {
                    U = Qu(Q), S = !1, l.context === Kl && t !== "svg" && t !== "math" ? m.delete(U.toLowerCase()) : (ae = Q.toLowerCase(), ae = Ll.hasOwnProperty(
                      ae
                    ) && Ll[ae] || null, ae !== null && ae !== Q && (S = !0, m.delete(ae)), m.delete(U));
                    e: if (ae = e, ue = U, U = D, ut(ue))
                      if (ae.hasAttribute(ue))
                        ae = ae.getAttribute(
                          ue
                        ), q(
                          U,
                          ue
                        ), U = ae === "" + U ? U : ae;
                      else {
                        switch (typeof U) {
                          case "function":
                          case "symbol":
                            break e;
                          case "boolean":
                            if (ae = ue.toLowerCase().slice(0, 5), ae !== "data-" && ae !== "aria-")
                              break e;
                        }
                        U = U === void 0 ? void 0 : null;
                      }
                    else U = void 0;
                    S || Cn(
                      Q,
                      U,
                      D,
                      u
                    );
                  }
              }
          }
      return 0 < m.size && i.suppressHydrationWarning !== !0 && Ms(e, m, u), Object.keys(u).length === 0 ? null : u;
    }
    function xt(e, t) {
      switch (e.length) {
        case 0:
          return "";
        case 1:
          return e[0];
        case 2:
          return e[0] + " " + t + " " + e[1];
        default:
          return e.slice(0, -1).join(", ") + ", " + t + " " + e[e.length - 1];
      }
    }
    function Zt(e) {
      return e.nodeType === 9 ? e : e.ownerDocument;
    }
    function en(e) {
      switch (e) {
        case sd:
          return zh;
        case j0:
          return iv;
        default:
          return Kl;
      }
    }
    function ua(e, t) {
      if (e === Kl)
        switch (t) {
          case "svg":
            return zh;
          case "math":
            return iv;
          default:
            return Kl;
        }
      return e === zh && t === "foreignObject" ? Kl : e;
    }
    function eo(e, t) {
      return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    function Ic() {
      var e = window.event;
      return e && e.type === "popstate" ? e === fR ? !1 : (fR = e, !0) : (fR = null, !1);
    }
    function Zp(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function Io(e, t, i) {
      switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          i.autoFocus && e.focus();
          break;
        case "img":
          i.src ? e.src = i.src : i.srcSet && (e.srcset = i.srcSet);
      }
    }
    function In(e, t, i, l) {
      ag(e, t, i, l), e[fa] = l;
    }
    function Lo(e) {
      el(e, "");
    }
    function Dl(e, t, i) {
      e.nodeValue = i;
    }
    function to(e) {
      return e === "head";
    }
    function qa(e, t) {
      e.removeChild(t);
    }
    function Lc(e, t) {
      (e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).removeChild(t);
    }
    function Jc(e, t) {
      var i = t, l = 0, u = 0;
      do {
        var m = i.nextSibling;
        if (e.removeChild(i), m && m.nodeType === 8)
          if (i = m.data, i === nv) {
            if (0 < l && 8 > l) {
              i = l;
              var S = e.ownerDocument;
              if (i & r4 && jc(S.documentElement), i & o4 && jc(S.body), i & s4)
                for (i = S.head, jc(i), S = i.firstChild; S; ) {
                  var U = S.nextSibling, D = S.nodeName;
                  S[id] || D === "SCRIPT" || D === "STYLE" || D === "LINK" && S.rel.toLowerCase() === "stylesheet" || i.removeChild(S), S = U;
                }
            }
            if (u === 0) {
              e.removeChild(m), Ol(t);
              return;
            }
            u--;
          } else
            i === tv || i === Xl || i === jf ? u++ : l = i.charCodeAt(0) - 48;
        else l = 0;
        i = m;
      } while (i);
      Ol(t);
    }
    function ha(e) {
      e = e.style, typeof e.setProperty == "function" ? e.setProperty("display", "none", "important") : e.display = "none";
    }
    function Op(e) {
      e.nodeValue = "";
    }
    function wp(e, t) {
      t = t[l4], t = t != null && t.hasOwnProperty("display") ? t.display : null, e.style.display = t == null || typeof t == "boolean" ? "" : ("" + t).trim();
    }
    function z1(e, t) {
      e.nodeValue = t;
    }
    function Wc(e) {
      var t = e.firstChild;
      for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
        var i = t;
        switch (t = t.nextSibling, i.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            Wc(i), Ii(i);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if (i.rel.toLowerCase() === "stylesheet") continue;
        }
        e.removeChild(i);
      }
    }
    function ks(e, t, i, l) {
      for (; e.nodeType === 1; ) {
        var u = i;
        if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
          if (!l && (e.nodeName !== "INPUT" || e.type !== "hidden"))
            break;
        } else if (l) {
          if (!e[id])
            switch (t) {
              case "meta":
                if (!e.hasAttribute("itemprop")) break;
                return e;
              case "link":
                if (m = e.getAttribute("rel"), m === "stylesheet" && e.hasAttribute("data-precedence"))
                  break;
                if (m !== u.rel || e.getAttribute("href") !== (u.href == null || u.href === "" ? null : u.href) || e.getAttribute("crossorigin") !== (u.crossOrigin == null ? null : u.crossOrigin) || e.getAttribute("title") !== (u.title == null ? null : u.title))
                  break;
                return e;
              case "style":
                if (e.hasAttribute("data-precedence")) break;
                return e;
              case "script":
                if (m = e.getAttribute("src"), (m !== (u.src == null ? null : u.src) || e.getAttribute("type") !== (u.type == null ? null : u.type) || e.getAttribute("crossorigin") !== (u.crossOrigin == null ? null : u.crossOrigin)) && m && e.hasAttribute("async") && !e.hasAttribute("itemprop"))
                  break;
                return e;
              default:
                return e;
            }
        } else if (t === "input" && e.type === "hidden") {
          q(u.name, "name");
          var m = u.name == null ? null : "" + u.name;
          if (u.type === "hidden" && e.getAttribute("name") === m)
            return e;
        } else return e;
        if (e = Ri(e.nextSibling), e === null) break;
      }
      return null;
    }
    function Si(e, t, i) {
      if (t === "") return null;
      for (; e.nodeType !== 3; )
        if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !i || (e = Ri(e.nextSibling), e === null)) return null;
      return e;
    }
    function no(e) {
      return e.data === jf || e.data === Xl && e.ownerDocument.readyState === C5;
    }
    function Hc(e, t) {
      var i = e.ownerDocument;
      if (e.data !== Xl || i.readyState === C5)
        t();
      else {
        var l = function() {
          t(), i.removeEventListener("DOMContentLoaded", l);
        };
        i.addEventListener("DOMContentLoaded", l), e._reactRetry = l;
      }
    }
    function Ri(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === 1 || t === 3) break;
        if (t === 8) {
          if (t = e.data, t === tv || t === jf || t === Xl || t === hR || t === b5)
            break;
          if (t === nv) return null;
        }
      }
      return e;
    }
    function j1(e) {
      if (e.nodeType === 1) {
        for (var t = e.nodeName.toLowerCase(), i = {}, l = e.attributes, u = 0; u < l.length; u++) {
          var m = l[u];
          i[kp(m.name)] = m.name.toLowerCase() === "style" ? kl(e) : m.value;
        }
        return { type: t, props: i };
      }
      return e.nodeType === 8 ? { type: "Suspense", props: {} } : e.nodeValue;
    }
    function P1(e, t, i) {
      return i === null || i[a4] !== !0 ? (e.nodeValue === t ? e = null : (t = vi(t), e = vi(e.nodeValue) === t ? null : e.nodeValue), e) : null;
    }
    function Bp(e) {
      e = e.nextSibling;
      for (var t = 0; e; ) {
        if (e.nodeType === 8) {
          var i = e.data;
          if (i === nv) {
            if (t === 0)
              return Ri(e.nextSibling);
            t--;
          } else
            i !== tv && i !== jf && i !== Xl || t++;
        }
        e = e.nextSibling;
      }
      return null;
    }
    function zc(e) {
      e = e.previousSibling;
      for (var t = 0; e; ) {
        if (e.nodeType === 8) {
          var i = e.data;
          if (i === tv || i === jf || i === Xl) {
            if (t === 0) return e;
            t--;
          } else i === nv && t++;
        }
        e = e.previousSibling;
      }
      return null;
    }
    function Ap(e) {
      Ol(e);
    }
    function Fa(e) {
      Ol(e);
    }
    function Ip(e, t, i, l, u) {
      switch (u && Du(e, l.ancestorInfo), t = Zt(i), e) {
        case "html":
          if (e = t.documentElement, !e)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        case "head":
          if (e = t.head, !e)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        case "body":
          if (e = t.body, !e)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function Ma(e, t, i, l) {
      if (!i[Is] && Mn(i)) {
        var u = i.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          u,
          u,
          u
        );
      }
      switch (e) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (u = i.attributes; u.length; )
        i.removeAttributeNode(u[0]);
      An(i, e, t), i[xi] = l, i[fa] = t;
    }
    function jc(e) {
      for (var t = e.attributes; t.length; )
        e.removeAttributeNode(t[0]);
      Ii(e);
    }
    function b0(e) {
      return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
    }
    function og(e, t, i) {
      var l = jh;
      if (l && typeof t == "string" && t) {
        var u = ya(t);
        u = 'link[rel="' + e + '"][href="' + u + '"]', typeof i == "string" && (u += '[crossorigin="' + i + '"]'), D5.has(u) || (D5.add(u), e = { rel: e, crossOrigin: i, href: t }, l.querySelector(u) === null && (t = l.createElement("link"), An(t, "link", e), z(t), l.head.appendChild(t)));
      }
    }
    function Jo(e, t, i, l) {
      var u = (u = ao.current) ? b0(u) : null;
      if (!u)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (e) {
        case "meta":
        case "title":
          return null;
        case "style":
          return typeof i.precedence == "string" && typeof i.href == "string" ? (i = Ds(i.href), t = F(u).hoistableStyles, l = t.get(i), l || (l = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, t.set(i, l)), l) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if (i.rel === "stylesheet" && typeof i.href == "string" && typeof i.precedence == "string") {
            e = Ds(i.href);
            var m = F(u).hoistableStyles, S = m.get(e);
            if (!S && (u = u.ownerDocument || u, S = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: du, preload: null }
            }, m.set(e, S), (m = u.querySelector(
              io(e)
            )) && !m._p && (S.instance = m, S.state.loading = Pf | So), !Ro.has(e))) {
              var U = {
                rel: "preload",
                as: "style",
                href: i.href,
                crossOrigin: i.crossOrigin,
                integrity: i.integrity,
                media: i.media,
                hrefLang: i.hrefLang,
                referrerPolicy: i.referrerPolicy
              };
              Ro.set(e, U), m || sg(
                u,
                e,
                U,
                S.state
              );
            }
            if (t && l === null)
              throw i = `

  - ` + Ql(t) + `
  + ` + Ql(i), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + i
              );
            return S;
          }
          if (t && l !== null)
            throw i = `

  - ` + Ql(t) + `
  + ` + Ql(i), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + i
            );
          return null;
        case "script":
          return t = i.async, i = i.src, typeof i == "string" && t && typeof t != "function" && typeof t != "symbol" ? (i = xl(i), t = F(u).hoistableScripts, l = t.get(i), l || (l = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, t.set(i, l)), l) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + e + '". this is a bug in React.'
          );
      }
    }
    function Ql(e) {
      var t = 0, i = "<link";
      return typeof e.rel == "string" ? (t++, i += ' rel="' + e.rel + '"') : zo.call(e, "rel") && (t++, i += ' rel="' + (e.rel === null ? "null" : "invalid type " + typeof e.rel) + '"'), typeof e.href == "string" ? (t++, i += ' href="' + e.href + '"') : zo.call(e, "href") && (t++, i += ' href="' + (e.href === null ? "null" : "invalid type " + typeof e.href) + '"'), typeof e.precedence == "string" ? (t++, i += ' precedence="' + e.precedence + '"') : zo.call(e, "precedence") && (t++, i += " precedence={" + (e.precedence === null ? "null" : "invalid type " + typeof e.precedence) + "}"), Object.getOwnPropertyNames(e).length > t && (i += " ..."), i + " />";
    }
    function Ds(e) {
      return 'href="' + ya(e) + '"';
    }
    function io(e) {
      return 'link[rel="stylesheet"][' + e + "]";
    }
    function Lp(e) {
      return Ct({}, e, {
        "data-precedence": e.precedence,
        precedence: null
      });
    }
    function sg(e, t, i, l) {
      e.querySelector(
        'link[rel="preload"][as="style"][' + t + "]"
      ) ? l.loading = Pf : (t = e.createElement("link"), l.preload = t, t.addEventListener("load", function() {
        return l.loading |= Pf;
      }), t.addEventListener("error", function() {
        return l.loading |= M5;
      }), An(t, "link", i), z(t), e.head.appendChild(t));
    }
    function xl(e) {
      return '[src="' + ya(e) + '"]';
    }
    function Zl(e) {
      return "script[async]" + e;
    }
    function G1(e, t, i) {
      if (t.count++, t.instance === null)
        switch (t.type) {
          case "style":
            var l = e.querySelector(
              'style[data-href~="' + ya(i.href) + '"]'
            );
            if (l)
              return t.instance = l, z(l), l;
            var u = Ct({}, i, {
              "data-href": i.href,
              "data-precedence": i.precedence,
              href: null,
              precedence: null
            });
            return l = (e.ownerDocument || e).createElement("style"), z(l), An(l, "style", u), Y1(l, i.precedence, e), t.instance = l;
          case "stylesheet":
            u = Ds(i.href);
            var m = e.querySelector(
              io(u)
            );
            if (m)
              return t.state.loading |= So, t.instance = m, z(m), m;
            l = Lp(i), (u = Ro.get(u)) && Jp(l, u), m = (e.ownerDocument || e).createElement("link"), z(m);
            var S = m;
            return S._p = new Promise(function(U, D) {
              S.onload = U, S.onerror = D;
            }), An(m, "link", l), t.state.loading |= So, Y1(m, i.precedence, e), t.instance = m;
          case "script":
            return m = xl(i.src), (u = e.querySelector(
              Zl(m)
            )) ? (t.instance = u, z(u), u) : (l = i, (u = Ro.get(m)) && (l = Ct({}, i), Wp(l, u)), e = e.ownerDocument || e, u = e.createElement("script"), z(u), An(u, "link", l), e.head.appendChild(u), t.instance = u);
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + t.type + '". this is a bug in React.'
            );
        }
      else
        t.type === "stylesheet" && (t.state.loading & So) === du && (l = t.instance, t.state.loading |= So, Y1(l, i.precedence, e));
      return t.instance;
    }
    function Y1(e, t, i) {
      for (var l = i.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), u = l.length ? l[l.length - 1] : null, m = u, S = 0; S < l.length; S++) {
        var U = l[S];
        if (U.dataset.precedence === t) m = U;
        else if (m !== u) break;
      }
      m ? m.parentNode.insertBefore(e, m.nextSibling) : (t = i.nodeType === 9 ? i.head : i, t.insertBefore(e, t.firstChild));
    }
    function Jp(e, t) {
      e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.title == null && (e.title = t.title);
    }
    function Wp(e, t) {
      e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.integrity == null && (e.integrity = t.integrity);
    }
    function Hp(e, t, i) {
      if (av === null) {
        var l = /* @__PURE__ */ new Map(), u = av = /* @__PURE__ */ new Map();
        u.set(i, l);
      } else
        u = av, l = u.get(i), l || (l = /* @__PURE__ */ new Map(), u.set(i, l));
      if (l.has(e)) return l;
      for (l.set(e, null), i = i.getElementsByTagName(e), u = 0; u < i.length; u++) {
        var m = i[u];
        if (!(m[id] || m[xi] || e === "link" && m.getAttribute("rel") === "stylesheet") && m.namespaceURI !== sd) {
          var S = m.getAttribute(t) || "";
          S = e + S;
          var U = l.get(S);
          U ? U.push(m) : l.set(S, [m]);
        }
      }
      return l;
    }
    function zp(e, t, i) {
      e = e.ownerDocument || e, e.head.insertBefore(
        i,
        t === "title" ? e.querySelector("head > title") : null
      );
    }
    function Pc(e, t, i) {
      var l = !i.ancestorInfo.containerTagInScope;
      if (i.context === zh || t.itemProp != null)
        return !l || t.itemProp == null || e !== "meta" && e !== "title" && e !== "style" && e !== "link" && e !== "script" || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          e,
          e
        ), !1;
      switch (e) {
        case "meta":
        case "title":
          return !0;
        case "style":
          if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") {
            l && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return !0;
        case "link":
          if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) {
            if (t.rel === "stylesheet" && typeof t.precedence == "string") {
              e = t.href;
              var u = t.onError, m = t.disabled;
              i = [], t.onLoad && i.push("`onLoad`"), u && i.push("`onError`"), m != null && i.push("`disabled`"), u = xt(i, "and"), u += i.length === 1 ? " prop" : " props", m = i.length === 1 ? "an " + u : "the " + u, i.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                e,
                m,
                u
              );
            }
            l && (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (t.onError || t.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (t.rel) {
            case "stylesheet":
              return e = t.precedence, t = t.disabled, typeof e != "string" && l && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), typeof e == "string" && t == null;
            default:
              return !0;
          }
        case "script":
          if (e = t.async && typeof t.async != "function" && typeof t.async != "symbol", !e || t.onLoad || t.onError || !t.src || typeof t.src != "string") {
            l && (e ? t.onLoad || t.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return !0;
        case "noscript":
        case "template":
          l && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            e
          );
      }
      return !1;
    }
    function C0(e) {
      return !(e.type === "stylesheet" && (e.state.loading & k5) === du);
    }
    function lg() {
    }
    function cg(e, t, i) {
      if (Gf === null)
        throw Error(
          "Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug."
        );
      var l = Gf;
      if (t.type === "stylesheet" && (typeof i.media != "string" || matchMedia(i.media).matches !== !1) && (t.state.loading & So) === du) {
        if (t.instance === null) {
          var u = Ds(i.href), m = e.querySelector(
            io(u)
          );
          if (m) {
            e = m._p, e !== null && typeof e == "object" && typeof e.then == "function" && (l.count++, l = V0.bind(l), e.then(l, l)), t.state.loading |= So, t.instance = m, z(m);
            return;
          }
          m = e.ownerDocument || e, i = Lp(i), (u = Ro.get(u)) && Jp(i, u), m = m.createElement("link"), z(m);
          var S = m;
          S._p = new Promise(function(U, D) {
            S.onload = U, S.onerror = D;
          }), An(m, "link", i), t.instance = m;
        }
        l.stylesheets === null && (l.stylesheets = /* @__PURE__ */ new Map()), l.stylesheets.set(t, e), (e = t.state.preload) && (t.state.loading & k5) === du && (l.count++, t = V0.bind(l), e.addEventListener("load", t), e.addEventListener("error", t));
      }
    }
    function dg() {
      if (Gf === null)
        throw Error(
          "Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug."
        );
      var e = Gf;
      return e.stylesheets && e.count === 0 && X1(e, e.stylesheets), 0 < e.count ? function(t) {
        var i = setTimeout(function() {
          if (e.stylesheets && X1(e, e.stylesheets), e.unsuspend) {
            var l = e.unsuspend;
            e.unsuspend = null, l();
          }
        }, 6e4);
        return e.unsuspend = t, function() {
          e.unsuspend = null, clearTimeout(i);
        };
      } : null;
    }
    function V0() {
      if (this.count--, this.count === 0) {
        if (this.stylesheets)
          X1(this, this.stylesheets);
        else if (this.unsuspend) {
          var e = this.unsuspend;
          this.unsuspend = null, e();
        }
      }
    }
    function X1(e, t) {
      e.stylesheets = null, e.unsuspend !== null && (e.count++, rv = /* @__PURE__ */ new Map(), t.forEach(ug, e), rv = null, V0.call(e));
    }
    function ug(e, t) {
      if (!(t.state.loading & So)) {
        var i = rv.get(e);
        if (i) var l = i.get(vR);
        else {
          i = /* @__PURE__ */ new Map(), rv.set(e, i);
          for (var u = e.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), m = 0; m < u.length; m++) {
            var S = u[m];
            (S.nodeName === "LINK" || S.getAttribute("media") !== "not all") && (i.set(S.dataset.precedence, S), l = S);
          }
          l && i.set(vR, l);
        }
        u = t.instance, S = u.getAttribute("data-precedence"), m = i.get(S) || l, m === l && i.set(vR, u), i.set(S, u), this.count++, l = V0.bind(this), u.addEventListener("load", l), u.addEventListener("error", l), m ? m.parentNode.insertBefore(u, m.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(u, e.firstChild)), t.state.loading |= So;
      }
    }
    function K1(e, t, i, l, u, m, S, U) {
      for (this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = cu, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Ci(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ci(0), this.hiddenUpdates = Ci(null), this.identifierPrefix = l, this.onUncaughtError = u, this.onCaughtError = m, this.onRecoverableError = S, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = U, this.incompleteTransitions = /* @__PURE__ */ new Map(), this.passiveEffectDuration = this.effectDuration = -0, this.memoizedUpdaters = /* @__PURE__ */ new Set(), e = this.pendingUpdatersLaneMap = [], t = 0; 31 > t; t++) e.push(/* @__PURE__ */ new Set());
      this._debugRootType = i ? "hydrateRoot()" : "createRoot()";
    }
    function jp(e, t, i, l, u, m, S, U, D, Q, ae, ue) {
      return e = new K1(
        e,
        t,
        i,
        S,
        U,
        D,
        Q,
        ue
      ), t = xy, m === !0 && (t |= va | Xo), Jn && (t |= Yi), m = V(3, null, null, t), e.current = m, m.stateNode = e, t = zd(), dl(t), e.pooledCache = t, dl(t), m.memoizedState = {
        element: l,
        isDehydrated: i,
        cache: t
      }, aa(m), e;
    }
    function Pp(e) {
      return e ? (e = ld, e) : ld;
    }
    function tn(e, t, i, l, u, m) {
      if (Ei && typeof Ei.onScheduleFiberRoot == "function")
        try {
          Ei.onScheduleFiberRoot(Bs, l, i);
        } catch (S) {
          pa || (pa = !0, console.error(
            "React instrumentation encountered an error: %s",
            S
          ));
        }
      ze !== null && typeof ze.markRenderScheduled == "function" && ze.markRenderScheduled(t), u = Pp(u), l.context === null ? l.context = u : l.pendingContext = u, ga && Da !== null && !O5 && (O5 = !0, console.error(
        `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
        Fe(Da) || "Unknown"
      )), l = Or(t), l.payload = { element: i }, m = m === void 0 ? null : m, m !== null && (typeof m != "function" && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        m
      ), l.callback = m), i = mr(e, l, t), i !== null && (wn(i, e, t), vs(i, e, t));
    }
    function q1(e, t) {
      if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
        var i = e.retryLane;
        e.retryLane = i !== 0 && i < t ? i : t;
      }
    }
    function Gp(e, t) {
      q1(e, t), (e = e.alternate) && q1(e, t);
    }
    function Yp(e) {
      if (e.tag === 13) {
        var t = ia(e, 67108864);
        t !== null && wn(t, e, 67108864), Gp(e, 67108864);
      }
    }
    function uS() {
      return Da;
    }
    function hS() {
      for (var e = /* @__PURE__ */ new Map(), t = 1, i = 0; 31 > i; i++) {
        var l = sr(t);
        e.set(t, l), t *= 2;
      }
      return e;
    }
    function mS(e, t, i, l) {
      var u = le.T;
      le.T = null;
      var m = pt.p;
      try {
        pt.p = Ui, Qs(e, t, i, l);
      } finally {
        pt.p = m, le.T = u;
      }
    }
    function $1(e, t, i, l) {
      var u = le.T;
      le.T = null;
      var m = pt.p;
      try {
        pt.p = Tr, Qs(e, t, i, l);
      } finally {
        pt.p = m, le.T = u;
      }
    }
    function Qs(e, t, i, l) {
      if (sv) {
        var u = _0(l);
        if (u === null)
          zi(
            e,
            t,
            l,
            lv,
            i
          ), xs(e, l);
        else if (F0(
          u,
          e,
          t,
          i,
          l
        ))
          l.stopPropagation();
        else if (xs(e, l), t & 4 && -1 < h4.indexOf(e)) {
          for (; u !== null; ) {
            var m = Mn(u);
            if (m !== null)
              switch (m.tag) {
                case 3:
                  if (m = m.stateNode, m.current.memoizedState.isDehydrated) {
                    var S = Tn(m.pendingLanes);
                    if (S !== 0) {
                      var U = m;
                      for (U.pendingLanes |= 2, U.entangledLanes |= 2; S; ) {
                        var D = 1 << 31 - Qi(S);
                        U.entanglements[1] |= D, S &= ~D;
                      }
                      Xa(m), (nn & (Oa | es)) === yr && (zg = ro() + p5, Fl(0));
                    }
                  }
                  break;
                case 13:
                  U = ia(m, 2), U !== null && wn(U, m, 2), Vl(), Gp(m, 2);
              }
            if (m = _0(l), m === null && zi(
              e,
              t,
              l,
              lv,
              i
            ), m === u) break;
            u = m;
          }
          u !== null && l.stopPropagation();
        } else
          zi(
            e,
            t,
            l,
            null,
            i
          );
      }
    }
    function _0(e) {
      return e = nl(e), Gc(e);
    }
    function Gc(e) {
      if (lv = null, e = oi(e), e !== null) {
        var t = ge(e);
        if (t === null) e = null;
        else {
          var i = t.tag;
          if (i === 13) {
            if (e = te(t), e !== null) return e;
            e = null;
          } else if (i === 3) {
            if (t.stateNode.current.memoizedState.isDehydrated)
              return t.tag === 3 ? t.stateNode.containerInfo : null;
            e = null;
          } else t !== e && (e = null);
        }
      }
      return lv = e, null;
    }
    function eh(e) {
      switch (e) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Ui;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Tr;
        case "message":
          switch (ws()) {
            case rh:
              return Ui;
            case B0:
              return Tr;
            case ed:
            case SS:
              return Po;
            case A0:
              return ch;
            default:
              return Po;
          }
        default:
          return Po;
      }
    }
    function xs(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          Sd = null;
          break;
        case "dragenter":
        case "dragleave":
          Rd = null;
          break;
        case "mouseover":
        case "mouseout":
          Ed = null;
          break;
        case "pointerover":
        case "pointerout":
          Xf.delete(t.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          Kf.delete(t.pointerId);
      }
    }
    function ma(e, t, i, l, u, m) {
      return e === null || e.nativeEvent !== m ? (e = {
        blockedOn: t,
        domEventName: i,
        eventSystemFlags: l,
        nativeEvent: m,
        targetContainers: [u]
      }, t !== null && (t = Mn(t), t !== null && Yp(t)), e) : (e.eventSystemFlags |= l, t = e.targetContainers, u !== null && t.indexOf(u) === -1 && t.push(u), e);
    }
    function F0(e, t, i, l, u) {
      switch (t) {
        case "focusin":
          return Sd = ma(
            Sd,
            e,
            t,
            i,
            l,
            u
          ), !0;
        case "dragenter":
          return Rd = ma(
            Rd,
            e,
            t,
            i,
            l,
            u
          ), !0;
        case "mouseover":
          return Ed = ma(
            Ed,
            e,
            t,
            i,
            l,
            u
          ), !0;
        case "pointerover":
          var m = u.pointerId;
          return Xf.set(
            m,
            ma(
              Xf.get(m) || null,
              e,
              t,
              i,
              l,
              u
            )
          ), !0;
        case "gotpointercapture":
          return m = u.pointerId, Kf.set(
            m,
            ma(
              Kf.get(m) || null,
              e,
              t,
              i,
              l,
              u
            )
          ), !0;
      }
      return !1;
    }
    function hg(e) {
      var t = oi(e.target);
      if (t !== null) {
        var i = ge(t);
        if (i !== null) {
          if (t = i.tag, t === 13) {
            if (t = te(i), t !== null) {
              e.blockedOn = t, Fr(e.priority, function() {
                if (i.tag === 13) {
                  var l = da(i);
                  l = jn(l);
                  var u = ia(
                    i,
                    l
                  );
                  u !== null && wn(u, i, l), Gp(i, l);
                }
              });
              return;
            }
          } else if (t === 3 && i.stateNode.current.memoizedState.isDehydrated) {
            e.blockedOn = i.tag === 3 ? i.stateNode.containerInfo : null;
            return;
          }
        }
      }
      e.blockedOn = null;
    }
    function M0(e) {
      if (e.blockedOn !== null) return !1;
      for (var t = e.targetContainers; 0 < t.length; ) {
        var i = _0(e.nativeEvent);
        if (i === null) {
          i = e.nativeEvent;
          var l = new i.constructor(
            i.type,
            i
          ), u = l;
          p !== null && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          ), p = u, i.target.dispatchEvent(l), p === null && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          ), p = null;
        } else
          return t = Mn(i), t !== null && Yp(t), e.blockedOn = i, !1;
        t.shift();
      }
      return !0;
    }
    function Xp(e, t, i) {
      M0(e) && i.delete(t);
    }
    function mg() {
      SR = !1, Sd !== null && M0(Sd) && (Sd = null), Rd !== null && M0(Rd) && (Rd = null), Ed !== null && M0(Ed) && (Ed = null), Xf.forEach(Xp), Kf.forEach(Xp);
    }
    function k0(e, t) {
      e.blockedOn === t && (e.blockedOn = null, SR || (SR = !0, Ln.unstable_scheduleCallback(
        Ln.unstable_NormalPriority,
        mg
      )));
    }
    function pg(e) {
      cv !== e && (cv = e, Ln.unstable_scheduleCallback(
        Ln.unstable_NormalPriority,
        function() {
          cv === e && (cv = null);
          for (var t = 0; t < e.length; t += 3) {
            var i = e[t], l = e[t + 1], u = e[t + 2];
            if (typeof l != "function") {
              if (Gc(l || i) === null)
                continue;
              break;
            }
            var m = Mn(i);
            m !== null && (e.splice(t, 3), t -= 3, i = {
              pending: !0,
              data: u,
              method: i.method,
              action: l
            }, Object.freeze(i), gl(
              m,
              i,
              l,
              u
            ));
          }
        }
      ));
    }
    function Ol(e) {
      function t(D) {
        return k0(D, e);
      }
      Sd !== null && k0(Sd, e), Rd !== null && k0(Rd, e), Ed !== null && k0(Ed, e), Xf.forEach(t), Kf.forEach(t);
      for (var i = 0; i < Ud.length; i++) {
        var l = Ud[i];
        l.blockedOn === e && (l.blockedOn = null);
      }
      for (; 0 < Ud.length && (i = Ud[0], i.blockedOn === null); )
        hg(i), i.blockedOn === null && Ud.shift();
      if (i = (e.ownerDocument || e).$$reactFormReplay, i != null)
        for (l = 0; l < i.length; l += 3) {
          var u = i[l], m = i[l + 1], S = u[fa] || null;
          if (typeof m == "function")
            S || pg(i);
          else if (S) {
            var U = null;
            if (m && m.hasAttribute("formAction")) {
              if (u = m, S = m[fa] || null)
                U = S.formAction;
              else if (Gc(u) !== null) continue;
            } else U = S.action;
            typeof U == "function" ? i[l + 1] = U : (i.splice(l, 3), l -= 3), pg(i);
          }
        }
    }
    function th(e) {
      this._internalRoot = e;
    }
    function D0(e) {
      this._internalRoot = e;
    }
    function fg(e) {
      e[Is] && (e._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Ln = HT(), Q0 = om(), pS = zT(), Ct = Object.assign, x0 = Symbol.for("react.element"), Zs = Symbol.for("react.transitional.element"), wl = Symbol.for("react.portal"), Ut = Symbol.for("react.fragment"), Yc = Symbol.for("react.strict_mode"), Xc = Symbol.for("react.profiler"), Kp = Symbol.for("react.provider"), nh = Symbol.for("react.consumer"), $a = Symbol.for("react.context"), Wo = Symbol.for("react.forward_ref"), Kc = Symbol.for("react.suspense"), Os = Symbol.for("react.suspense_list"), Z0 = Symbol.for("react.memo"), ka = Symbol.for("react.lazy"), qp = Symbol.for("react.activity"), gg = Symbol.for("react.memo_cache_sentinel"), $p = Symbol.iterator, ih = Symbol.for("react.client.reference"), St = Array.isArray, le = Q0.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, pt = pS.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, fS = Object.freeze({
      pending: !1,
      data: null,
      method: null,
      action: null
    }), O0 = [], w0 = [], er = -1, Ho = ye(null), qc = ye(null), ao = ye(null), $c = ye(null), zo = Object.prototype.hasOwnProperty, ah = Ln.unstable_scheduleCallback, gS = Ln.unstable_cancelCallback, vg = Ln.unstable_shouldYield, vS = Ln.unstable_requestPaint, ro = Ln.unstable_now, ws = Ln.unstable_getCurrentPriorityLevel, rh = Ln.unstable_ImmediatePriority, B0 = Ln.unstable_UserBlockingPriority, ed = Ln.unstable_NormalPriority, SS = Ln.unstable_LowPriority, A0 = Ln.unstable_IdlePriority, RS = Ln.log, Ur = Ln.unstable_setDisableYieldValue, Bs = null, Ei = null, ze = null, pa = !1, Jn = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u", Qi = Math.clz32 ? Math.clz32 : Aa, oh = Math.log, jo = Math.LN2, sh = 256, lh = 4194304, Ui = 2, Tr = 8, Po = 32, ch = 268435456, As = Math.random().toString(36).slice(2), xi = "__reactFiber$" + As, fa = "__reactProps$" + As, Is = "__reactContainer$" + As, ef = "__reactEvents$" + As, Sg = "__reactListeners$" + As, td = "__reactHandles$" + As, nd = "__reactResources$" + As, id = "__reactMarker$" + As, Rg = /* @__PURE__ */ new Set(), tr = {}, Bl = {}, Eg = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    }, dh = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), uh = {}, hh = {}, Ls = 0, tf, nf, Ug, af, ad, Tg, yg;
    Ji.__reactDisabledLog = !0;
    var rf, I0, rd = !1, L0 = new (typeof WeakMap == "function" ? WeakMap : Map)(), Da = null, ga = !1, ES = /[\n"\\]/g, of = !1, sf = !1, lf = !1, cf = !1, mh = !1, df = !1, J0 = ["value", "defaultValue"], Ng = !1, bg = /["'&<>\n\t]|^\s|\s$/, uf = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), ph = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), fh = ph.concat(["button"]), hf = "dd dt li option optgroup p rp rt".split(" "), mf = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: !1
    }, od = {}, oo = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, Go = /([A-Z])/g, Yo = /^ms-/, W0 = /^(?:webkit|moz|o)[A-Z]/, H0 = /^-ms-/, Js = /-(.)/g, Cg = /;\s*$/, Al = {}, Il = {}, Vg = !1, pf = !1, z0 = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), j0 = "http://www.w3.org/1998/Math/MathML", sd = "http://www.w3.org/2000/svg", gh = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), Ll = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, ff = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, so = {}, gf = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), vh = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), vf = !1, Gi = {}, P0 = /^on./, n = /^on[^A-Z]/, a = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), o = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), d = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, p = null, g = null, y = null, k = !1, w = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), K = !1;
    if (w)
      try {
        var ve = {};
        Object.defineProperty(ve, "passive", {
          get: function() {
            K = !0;
          }
        }), window.addEventListener("test", ve, ve), window.removeEventListener("test", ve, ve);
      } catch {
        K = !1;
      }
    var Ee = null, ie = null, re = null, at = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, rt = pi(at), Pt = Ct({}, at, { view: 0, detail: 0 }), P = pi(Pt), J, X, Se, Xe = Ct({}, Pt, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Ou,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (e !== Se && (Se && e.type === "mousemove" ? (J = e.screenX - Se.screenX, X = e.screenY - Se.screenY) : X = J = 0, Se = e), J);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : X;
      }
    }), Mt = pi(Xe), nt = Ct({}, Xe, { dataTransfer: 0 }), ct = pi(nt), ui = Ct({}, Pt, { relatedTarget: 0 }), Wt = pi(ui), Ws = Ct({}, at, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), US = pi(Ws), cy = Ct({}, at, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), dy = pi(cy), uy = Ct({}, at, { data: 0 }), Y6 = pi(
      uy
    ), hy = Y6, my = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, py = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, fy = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, gy = Ct({}, Pt, {
      key: function(e) {
        if (e.key) {
          var t = my[e.key] || e.key;
          if (t !== "Unidentified") return t;
        }
        return e.type === "keypress" ? (e = pc(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? py[e.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Ou,
      charCode: function(e) {
        return e.type === "keypress" ? pc(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? pc(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), vy = pi(gy), Sy = Ct({}, Xe, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), X6 = pi(Sy), Ry = Ct({}, Pt, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Ou
    }), Ey = pi(Ry), Uy = Ct({}, at, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Ty = pi(Uy), yy = Ct({}, Xe, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), Ny = pi(yy), by = Ct({}, at, {
      newState: 0,
      oldState: 0
    }), Cy = pi(by), Vy = [9, 13, 27, 32], K6 = 229, TS = w && "CompositionEvent" in window, Sf = null;
    w && "documentMode" in document && (Sf = document.documentMode);
    var _y = w && "TextEvent" in window && !Sf, q6 = w && (!TS || Sf && 8 < Sf && 11 >= Sf), $6 = 32, e3 = String.fromCharCode($6), t3 = !1, Sh = !1, Fy = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    }, Rf = null, Ef = null, n3 = !1;
    w && (n3 = vm("input") && (!document.documentMode || 9 < document.documentMode));
    var Qa = typeof Object.is == "function" ? Object.is : sS, My = w && "documentMode" in document && 11 >= document.documentMode, Rh = null, yS = null, Uf = null, NS = !1, Eh = {
      animationend: Vo("Animation", "AnimationEnd"),
      animationiteration: Vo("Animation", "AnimationIteration"),
      animationstart: Vo("Animation", "AnimationStart"),
      transitionrun: Vo("Transition", "TransitionRun"),
      transitionstart: Vo("Transition", "TransitionStart"),
      transitioncancel: Vo("Transition", "TransitionCancel"),
      transitionend: Vo("Transition", "TransitionEnd")
    }, bS = {}, i3 = {};
    w && (i3 = document.createElement("div").style, "AnimationEvent" in window || (delete Eh.animationend.animation, delete Eh.animationiteration.animation, delete Eh.animationstart.animation), "TransitionEvent" in window || delete Eh.transitionend.transition);
    var a3 = rl("animationend"), r3 = rl("animationiteration"), o3 = rl("animationstart"), ky = rl("transitionrun"), Dy = rl("transitionstart"), Qy = rl("transitioncancel"), s3 = rl("transitionend"), l3 = /* @__PURE__ */ new Map(), CS = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    CS.push("scrollEnd");
    var VS = /* @__PURE__ */ new WeakMap(), _g = 1, Jl = 2, lo = [], Uh = 0, _S = 0, ld = {};
    Object.freeze(ld);
    var co = null, Th = null, Vn = 0, xy = 1, Yi = 2, va = 8, Xo = 16, c3 = 64, d3 = !1;
    try {
      var u3 = Object.preventExtensions({});
    } catch {
      d3 = !0;
    }
    var yh = [], Nh = 0, Fg = null, Mg = 0, uo = [], ho = 0, G0 = null, Wl = 1, Hl = "", xa = null, Xn = null, Gt = !1, zl = !1, mo = null, Y0 = null, Hs = !1, FS = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), h3 = 0;
    if (typeof performance == "object" && typeof performance.now == "function")
      var Zy = performance, m3 = function() {
        return Zy.now();
      };
    else {
      var Oy = Date;
      m3 = function() {
        return Oy.now();
      };
    }
    var MS = ye(null), kS = ye(null), p3 = {}, kg = null, bh = null, Ch = !1, wy = typeof AbortController < "u" ? AbortController : function() {
      var e = [], t = this.signal = {
        aborted: !1,
        addEventListener: function(i, l) {
          e.push(l);
        }
      };
      this.abort = function() {
        t.aborted = !0, e.forEach(function(i) {
          return i();
        });
      };
    }, By = Ln.unstable_scheduleCallback, Ay = Ln.unstable_NormalPriority, Ti = {
      $$typeof: $a,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, Vh = Ln.unstable_now, f3 = -0, Dg = -0, nr = -1.1, X0 = -0, Qg = !1, xg = !1, Tf = null, DS = 0, K0 = 0, _h = null, g3 = le.S;
    le.S = function(e, t) {
      typeof t == "object" && t !== null && typeof t.then == "function" && B2(e, t), g3 !== null && g3(e, t);
    };
    var q0 = ye(null), Ko = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, yf = [], Nf = [], bf = [], Cf = [], Vf = [], _f = [], $0 = /* @__PURE__ */ new Set();
    Ko.recordUnsafeLifecycleWarnings = function(e, t) {
      $0.has(e.type) || (typeof t.componentWillMount == "function" && t.componentWillMount.__suppressDeprecationWarning !== !0 && yf.push(e), e.mode & va && typeof t.UNSAFE_componentWillMount == "function" && Nf.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && bf.push(e), e.mode & va && typeof t.UNSAFE_componentWillReceiveProps == "function" && Cf.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && Vf.push(e), e.mode & va && typeof t.UNSAFE_componentWillUpdate == "function" && _f.push(e));
    }, Ko.flushPendingUnsafeLifecycleWarnings = function() {
      var e = /* @__PURE__ */ new Set();
      0 < yf.length && (yf.forEach(function(U) {
        e.add(
          Fe(U) || "Component"
        ), $0.add(U.type);
      }), yf = []);
      var t = /* @__PURE__ */ new Set();
      0 < Nf.length && (Nf.forEach(function(U) {
        t.add(
          Fe(U) || "Component"
        ), $0.add(U.type);
      }), Nf = []);
      var i = /* @__PURE__ */ new Set();
      0 < bf.length && (bf.forEach(function(U) {
        i.add(
          Fe(U) || "Component"
        ), $0.add(U.type);
      }), bf = []);
      var l = /* @__PURE__ */ new Set();
      0 < Cf.length && (Cf.forEach(
        function(U) {
          l.add(
            Fe(U) || "Component"
          ), $0.add(U.type);
        }
      ), Cf = []);
      var u = /* @__PURE__ */ new Set();
      0 < Vf.length && (Vf.forEach(function(U) {
        u.add(
          Fe(U) || "Component"
        ), $0.add(U.type);
      }), Vf = []);
      var m = /* @__PURE__ */ new Set();
      if (0 < _f.length && (_f.forEach(function(U) {
        m.add(
          Fe(U) || "Component"
        ), $0.add(U.type);
      }), _f = []), 0 < t.size) {
        var S = _(
          t
        );
        console.error(
          `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
          S
        );
      }
      0 < l.size && (S = _(
        l
      ), console.error(
        `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`,
        S
      )), 0 < m.size && (S = _(
        m
      ), console.error(
        `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
        S
      )), 0 < e.size && (S = _(e)), 0 < i.size && (S = _(
        i
      )), 0 < u.size && (S = _(u));
    };
    var Zg = /* @__PURE__ */ new Map(), v3 = /* @__PURE__ */ new Set();
    Ko.recordLegacyContextWarning = function(e, t) {
      for (var i = null, l = e; l !== null; )
        l.mode & va && (i = l), l = l.return;
      i === null ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !v3.has(e.type) && (l = Zg.get(i), e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (l === void 0 && (l = [], Zg.set(i, l)), l.push(e));
    }, Ko.flushLegacyContextWarning = function() {
      Zg.forEach(function(e) {
        if (e.length !== 0) {
          var t = e[0], i = /* @__PURE__ */ new Set();
          e.forEach(function(u) {
            i.add(Fe(u) || "Component"), v3.add(u.type);
          });
          var l = _(i);
          pe(t, function() {
            console.error(
              `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`,
              l
            );
          });
        }
      });
    }, Ko.discardPendingWarnings = function() {
      yf = [], Nf = [], bf = [], Cf = [], Vf = [], _f = [], Zg = /* @__PURE__ */ new Map();
    };
    var Ff = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), S3 = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), Og = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), QS = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, Mf = null, wg = !1, po = 0, fo = 1, Za = 2, Xi = 4, yi = 8, R3 = 0, E3 = 1, U3 = 2, xS = 3, cd = !1, T3 = !1, ZS = null, OS = !1, Fh = ye(null), Bg = ye(0), Mh, y3 = /* @__PURE__ */ new Set(), N3 = /* @__PURE__ */ new Set(), wS = /* @__PURE__ */ new Set(), b3 = /* @__PURE__ */ new Set(), dd = 0, Rt = null, mn = null, hi = null, Ag = !1, kh = !1, eu = !1, Ig = 0, kf = 0, jl = null, Iy = 0, Ly = 25, de = null, go = null, Pl = -1, Df = !1, Lg = {
      readContext: Sn,
      use: Br,
      useCallback: kn,
      useContext: kn,
      useEffect: kn,
      useImperativeHandle: kn,
      useLayoutEffect: kn,
      useInsertionEffect: kn,
      useMemo: kn,
      useReducer: kn,
      useRef: kn,
      useState: kn,
      useDebugValue: kn,
      useDeferredValue: kn,
      useTransition: kn,
      useSyncExternalStore: kn,
      useId: kn,
      useHostTransitionStatus: kn,
      useFormState: kn,
      useActionState: kn,
      useOptimistic: kn,
      useMemoCache: kn,
      useCacheRefresh: kn
    }, BS = null, C3 = null, AS = null, V3 = null, zs = null, qo = null, Jg = null;
    BS = {
      readContext: function(e) {
        return Sn(e);
      },
      use: Br,
      useCallback: function(e, t) {
        return de = "useCallback", Ft(), Wa(t), e0(e, t);
      },
      useContext: function(e) {
        return de = "useContext", Ft(), Sn(e);
      },
      useEffect: function(e, t) {
        return de = "useEffect", Ft(), Wa(t), Xu(e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return de = "useImperativeHandle", Ft(), Wa(i), qu(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        de = "useInsertionEffect", Ft(), Wa(t), Pa(4, Za, e, t);
      },
      useLayoutEffect: function(e, t) {
        return de = "useLayoutEffect", Ft(), Wa(t), Ku(e, t);
      },
      useMemo: function(e, t) {
        de = "useMemo", Ft(), Wa(t);
        var i = le.H;
        le.H = zs;
        try {
          return $u(e, t);
        } finally {
          le.H = i;
        }
      },
      useReducer: function(e, t, i) {
        de = "useReducer", Ft();
        var l = le.H;
        le.H = zs;
        try {
          return Ht(e, t, i);
        } finally {
          le.H = l;
        }
      },
      useRef: function(e) {
        return de = "useRef", Ft(), $d(e);
      },
      useState: function(e) {
        de = "useState", Ft();
        var t = le.H;
        le.H = zs;
        try {
          return Do(e);
        } finally {
          le.H = t;
        }
      },
      useDebugValue: function() {
        de = "useDebugValue", Ft();
      },
      useDeferredValue: function(e, t) {
        return de = "useDeferredValue", Ft(), e1(e, t);
      },
      useTransition: function() {
        return de = "useTransition", Ft(), Jr();
      },
      useSyncExternalStore: function(e, t, i) {
        return de = "useSyncExternalStore", Ft(), ko(
          e,
          t,
          i
        );
      },
      useId: function() {
        return de = "useId", Ft(), Wr();
      },
      useFormState: function(e, t) {
        return de = "useFormState", Ft(), Ec(), Cc(e, t);
      },
      useActionState: function(e, t) {
        return de = "useActionState", Ft(), Cc(e, t);
      },
      useOptimistic: function(e) {
        return de = "useOptimistic", Ft(), gr(e);
      },
      useHostTransitionStatus: sa,
      useMemoCache: Gn,
      useCacheRefresh: function() {
        return de = "useCacheRefresh", Ft(), vl();
      }
    }, C3 = {
      readContext: function(e) {
        return Sn(e);
      },
      use: Br,
      useCallback: function(e, t) {
        return de = "useCallback", Qe(), e0(e, t);
      },
      useContext: function(e) {
        return de = "useContext", Qe(), Sn(e);
      },
      useEffect: function(e, t) {
        return de = "useEffect", Qe(), Xu(e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return de = "useImperativeHandle", Qe(), qu(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        de = "useInsertionEffect", Qe(), Pa(4, Za, e, t);
      },
      useLayoutEffect: function(e, t) {
        return de = "useLayoutEffect", Qe(), Ku(e, t);
      },
      useMemo: function(e, t) {
        de = "useMemo", Qe();
        var i = le.H;
        le.H = zs;
        try {
          return $u(e, t);
        } finally {
          le.H = i;
        }
      },
      useReducer: function(e, t, i) {
        de = "useReducer", Qe();
        var l = le.H;
        le.H = zs;
        try {
          return Ht(e, t, i);
        } finally {
          le.H = l;
        }
      },
      useRef: function(e) {
        return de = "useRef", Qe(), $d(e);
      },
      useState: function(e) {
        de = "useState", Qe();
        var t = le.H;
        le.H = zs;
        try {
          return Do(e);
        } finally {
          le.H = t;
        }
      },
      useDebugValue: function() {
        de = "useDebugValue", Qe();
      },
      useDeferredValue: function(e, t) {
        return de = "useDeferredValue", Qe(), e1(e, t);
      },
      useTransition: function() {
        return de = "useTransition", Qe(), Jr();
      },
      useSyncExternalStore: function(e, t, i) {
        return de = "useSyncExternalStore", Qe(), ko(
          e,
          t,
          i
        );
      },
      useId: function() {
        return de = "useId", Qe(), Wr();
      },
      useActionState: function(e, t) {
        return de = "useActionState", Qe(), Cc(e, t);
      },
      useFormState: function(e, t) {
        return de = "useFormState", Qe(), Ec(), Cc(e, t);
      },
      useOptimistic: function(e) {
        return de = "useOptimistic", Qe(), gr(e);
      },
      useHostTransitionStatus: sa,
      useMemoCache: Gn,
      useCacheRefresh: function() {
        return de = "useCacheRefresh", Qe(), vl();
      }
    }, AS = {
      readContext: function(e) {
        return Sn(e);
      },
      use: Br,
      useCallback: function(e, t) {
        return de = "useCallback", Qe(), fl(e, t);
      },
      useContext: function(e) {
        return de = "useContext", Qe(), Sn(e);
      },
      useEffect: function(e, t) {
        de = "useEffect", Qe(), ei(2048, yi, e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return de = "useImperativeHandle", Qe(), Lr(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        return de = "useInsertionEffect", Qe(), ei(4, Za, e, t);
      },
      useLayoutEffect: function(e, t) {
        return de = "useLayoutEffect", Qe(), ei(4, Xi, e, t);
      },
      useMemo: function(e, t) {
        de = "useMemo", Qe();
        var i = le.H;
        le.H = qo;
        try {
          return Ts(e, t);
        } finally {
          le.H = i;
        }
      },
      useReducer: function(e, t, i) {
        de = "useReducer", Qe();
        var l = le.H;
        le.H = qo;
        try {
          return za(e, t, i);
        } finally {
          le.H = l;
        }
      },
      useRef: function() {
        return de = "useRef", Qe(), Lt().memoizedState;
      },
      useState: function() {
        de = "useState", Qe();
        var e = le.H;
        le.H = qo;
        try {
          return za(zt);
        } finally {
          le.H = e;
        }
      },
      useDebugValue: function() {
        de = "useDebugValue", Qe();
      },
      useDeferredValue: function(e, t) {
        return de = "useDeferredValue", Qe(), t0(e, t);
      },
      useTransition: function() {
        return de = "useTransition", Qe(), i1();
      },
      useSyncExternalStore: function(e, t, i) {
        return de = "useSyncExternalStore", Qe(), Yd(
          e,
          t,
          i
        );
      },
      useId: function() {
        return de = "useId", Qe(), Lt().memoizedState;
      },
      useFormState: function(e) {
        return de = "useFormState", Qe(), Ec(), Yu(e);
      },
      useActionState: function(e) {
        return de = "useActionState", Qe(), Yu(e);
      },
      useOptimistic: function(e, t) {
        return de = "useOptimistic", Qe(), Qo(e, t);
      },
      useHostTransitionStatus: sa,
      useMemoCache: Gn,
      useCacheRefresh: function() {
        return de = "useCacheRefresh", Qe(), Lt().memoizedState;
      }
    }, V3 = {
      readContext: function(e) {
        return Sn(e);
      },
      use: Br,
      useCallback: function(e, t) {
        return de = "useCallback", Qe(), fl(e, t);
      },
      useContext: function(e) {
        return de = "useContext", Qe(), Sn(e);
      },
      useEffect: function(e, t) {
        de = "useEffect", Qe(), ei(2048, yi, e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return de = "useImperativeHandle", Qe(), Lr(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        return de = "useInsertionEffect", Qe(), ei(4, Za, e, t);
      },
      useLayoutEffect: function(e, t) {
        return de = "useLayoutEffect", Qe(), ei(4, Xi, e, t);
      },
      useMemo: function(e, t) {
        de = "useMemo", Qe();
        var i = le.H;
        le.H = Jg;
        try {
          return Ts(e, t);
        } finally {
          le.H = i;
        }
      },
      useReducer: function(e, t, i) {
        de = "useReducer", Qe();
        var l = le.H;
        le.H = Jg;
        try {
          return pl(e, t, i);
        } finally {
          le.H = l;
        }
      },
      useRef: function() {
        return de = "useRef", Qe(), Lt().memoizedState;
      },
      useState: function() {
        de = "useState", Qe();
        var e = le.H;
        le.H = Jg;
        try {
          return pl(zt);
        } finally {
          le.H = e;
        }
      },
      useDebugValue: function() {
        de = "useDebugValue", Qe();
      },
      useDeferredValue: function(e, t) {
        return de = "useDeferredValue", Qe(), t1(e, t);
      },
      useTransition: function() {
        return de = "useTransition", Qe(), a1();
      },
      useSyncExternalStore: function(e, t, i) {
        return de = "useSyncExternalStore", Qe(), Yd(
          e,
          t,
          i
        );
      },
      useId: function() {
        return de = "useId", Qe(), Lt().memoizedState;
      },
      useFormState: function(e) {
        return de = "useFormState", Qe(), Ec(), Vc(e);
      },
      useActionState: function(e) {
        return de = "useActionState", Qe(), Vc(e);
      },
      useOptimistic: function(e, t) {
        return de = "useOptimistic", Qe(), Gu(e, t);
      },
      useHostTransitionStatus: sa,
      useMemoCache: Gn,
      useCacheRefresh: function() {
        return de = "useCacheRefresh", Qe(), Lt().memoizedState;
      }
    }, zs = {
      readContext: function(e) {
        return C(), Sn(e);
      },
      use: function(e) {
        return E(), Br(e);
      },
      useCallback: function(e, t) {
        return de = "useCallback", E(), Ft(), e0(e, t);
      },
      useContext: function(e) {
        return de = "useContext", E(), Ft(), Sn(e);
      },
      useEffect: function(e, t) {
        return de = "useEffect", E(), Ft(), Xu(e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return de = "useImperativeHandle", E(), Ft(), qu(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        de = "useInsertionEffect", E(), Ft(), Pa(4, Za, e, t);
      },
      useLayoutEffect: function(e, t) {
        return de = "useLayoutEffect", E(), Ft(), Ku(e, t);
      },
      useMemo: function(e, t) {
        de = "useMemo", E(), Ft();
        var i = le.H;
        le.H = zs;
        try {
          return $u(e, t);
        } finally {
          le.H = i;
        }
      },
      useReducer: function(e, t, i) {
        de = "useReducer", E(), Ft();
        var l = le.H;
        le.H = zs;
        try {
          return Ht(e, t, i);
        } finally {
          le.H = l;
        }
      },
      useRef: function(e) {
        return de = "useRef", E(), Ft(), $d(e);
      },
      useState: function(e) {
        de = "useState", E(), Ft();
        var t = le.H;
        le.H = zs;
        try {
          return Do(e);
        } finally {
          le.H = t;
        }
      },
      useDebugValue: function() {
        de = "useDebugValue", E(), Ft();
      },
      useDeferredValue: function(e, t) {
        return de = "useDeferredValue", E(), Ft(), e1(e, t);
      },
      useTransition: function() {
        return de = "useTransition", E(), Ft(), Jr();
      },
      useSyncExternalStore: function(e, t, i) {
        return de = "useSyncExternalStore", E(), Ft(), ko(
          e,
          t,
          i
        );
      },
      useId: function() {
        return de = "useId", E(), Ft(), Wr();
      },
      useFormState: function(e, t) {
        return de = "useFormState", E(), Ft(), Cc(e, t);
      },
      useActionState: function(e, t) {
        return de = "useActionState", E(), Ft(), Cc(e, t);
      },
      useOptimistic: function(e) {
        return de = "useOptimistic", E(), Ft(), gr(e);
      },
      useMemoCache: function(e) {
        return E(), Gn(e);
      },
      useHostTransitionStatus: sa,
      useCacheRefresh: function() {
        return de = "useCacheRefresh", Ft(), vl();
      }
    }, qo = {
      readContext: function(e) {
        return C(), Sn(e);
      },
      use: function(e) {
        return E(), Br(e);
      },
      useCallback: function(e, t) {
        return de = "useCallback", E(), Qe(), fl(e, t);
      },
      useContext: function(e) {
        return de = "useContext", E(), Qe(), Sn(e);
      },
      useEffect: function(e, t) {
        de = "useEffect", E(), Qe(), ei(2048, yi, e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return de = "useImperativeHandle", E(), Qe(), Lr(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        return de = "useInsertionEffect", E(), Qe(), ei(4, Za, e, t);
      },
      useLayoutEffect: function(e, t) {
        return de = "useLayoutEffect", E(), Qe(), ei(4, Xi, e, t);
      },
      useMemo: function(e, t) {
        de = "useMemo", E(), Qe();
        var i = le.H;
        le.H = qo;
        try {
          return Ts(e, t);
        } finally {
          le.H = i;
        }
      },
      useReducer: function(e, t, i) {
        de = "useReducer", E(), Qe();
        var l = le.H;
        le.H = qo;
        try {
          return za(e, t, i);
        } finally {
          le.H = l;
        }
      },
      useRef: function() {
        return de = "useRef", E(), Qe(), Lt().memoizedState;
      },
      useState: function() {
        de = "useState", E(), Qe();
        var e = le.H;
        le.H = qo;
        try {
          return za(zt);
        } finally {
          le.H = e;
        }
      },
      useDebugValue: function() {
        de = "useDebugValue", E(), Qe();
      },
      useDeferredValue: function(e, t) {
        return de = "useDeferredValue", E(), Qe(), t0(e, t);
      },
      useTransition: function() {
        return de = "useTransition", E(), Qe(), i1();
      },
      useSyncExternalStore: function(e, t, i) {
        return de = "useSyncExternalStore", E(), Qe(), Yd(
          e,
          t,
          i
        );
      },
      useId: function() {
        return de = "useId", E(), Qe(), Lt().memoizedState;
      },
      useFormState: function(e) {
        return de = "useFormState", E(), Qe(), Yu(e);
      },
      useActionState: function(e) {
        return de = "useActionState", E(), Qe(), Yu(e);
      },
      useOptimistic: function(e, t) {
        return de = "useOptimistic", E(), Qe(), Qo(e, t);
      },
      useMemoCache: function(e) {
        return E(), Gn(e);
      },
      useHostTransitionStatus: sa,
      useCacheRefresh: function() {
        return de = "useCacheRefresh", Qe(), Lt().memoizedState;
      }
    }, Jg = {
      readContext: function(e) {
        return C(), Sn(e);
      },
      use: function(e) {
        return E(), Br(e);
      },
      useCallback: function(e, t) {
        return de = "useCallback", E(), Qe(), fl(e, t);
      },
      useContext: function(e) {
        return de = "useContext", E(), Qe(), Sn(e);
      },
      useEffect: function(e, t) {
        de = "useEffect", E(), Qe(), ei(2048, yi, e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return de = "useImperativeHandle", E(), Qe(), Lr(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        return de = "useInsertionEffect", E(), Qe(), ei(4, Za, e, t);
      },
      useLayoutEffect: function(e, t) {
        return de = "useLayoutEffect", E(), Qe(), ei(4, Xi, e, t);
      },
      useMemo: function(e, t) {
        de = "useMemo", E(), Qe();
        var i = le.H;
        le.H = qo;
        try {
          return Ts(e, t);
        } finally {
          le.H = i;
        }
      },
      useReducer: function(e, t, i) {
        de = "useReducer", E(), Qe();
        var l = le.H;
        le.H = qo;
        try {
          return pl(e, t, i);
        } finally {
          le.H = l;
        }
      },
      useRef: function() {
        return de = "useRef", E(), Qe(), Lt().memoizedState;
      },
      useState: function() {
        de = "useState", E(), Qe();
        var e = le.H;
        le.H = qo;
        try {
          return pl(zt);
        } finally {
          le.H = e;
        }
      },
      useDebugValue: function() {
        de = "useDebugValue", E(), Qe();
      },
      useDeferredValue: function(e, t) {
        return de = "useDeferredValue", E(), Qe(), t1(e, t);
      },
      useTransition: function() {
        return de = "useTransition", E(), Qe(), a1();
      },
      useSyncExternalStore: function(e, t, i) {
        return de = "useSyncExternalStore", E(), Qe(), Yd(
          e,
          t,
          i
        );
      },
      useId: function() {
        return de = "useId", E(), Qe(), Lt().memoizedState;
      },
      useFormState: function(e) {
        return de = "useFormState", E(), Qe(), Vc(e);
      },
      useActionState: function(e) {
        return de = "useActionState", E(), Qe(), Vc(e);
      },
      useOptimistic: function(e, t) {
        return de = "useOptimistic", E(), Qe(), Gu(e, t);
      },
      useMemoCache: function(e) {
        return E(), Gn(e);
      },
      useHostTransitionStatus: sa,
      useCacheRefresh: function() {
        return de = "useCacheRefresh", Qe(), Lt().memoizedState;
      }
    };
    var _3 = {
      "react-stack-bottom-frame": function(e, t, i) {
        var l = ga;
        ga = !0;
        try {
          return e(t, i);
        } finally {
          ga = l;
        }
      }
    }, IS = _3["react-stack-bottom-frame"].bind(_3), F3 = {
      "react-stack-bottom-frame": function(e) {
        var t = ga;
        ga = !0;
        try {
          return e.render();
        } finally {
          ga = t;
        }
      }
    }, M3 = F3["react-stack-bottom-frame"].bind(F3), k3 = {
      "react-stack-bottom-frame": function(e, t) {
        try {
          t.componentDidMount();
        } catch (i) {
          lt(e, e.return, i);
        }
      }
    }, LS = k3["react-stack-bottom-frame"].bind(k3), D3 = {
      "react-stack-bottom-frame": function(e, t, i, l, u) {
        try {
          t.componentDidUpdate(i, l, u);
        } catch (m) {
          lt(e, e.return, m);
        }
      }
    }, Q3 = D3["react-stack-bottom-frame"].bind(D3), x3 = {
      "react-stack-bottom-frame": function(e, t) {
        var i = t.stack;
        e.componentDidCatch(t.value, {
          componentStack: i !== null ? i : ""
        });
      }
    }, Jy = x3["react-stack-bottom-frame"].bind(x3), Z3 = {
      "react-stack-bottom-frame": function(e, t, i) {
        try {
          i.componentWillUnmount();
        } catch (l) {
          lt(e, t, l);
        }
      }
    }, O3 = Z3["react-stack-bottom-frame"].bind(Z3), w3 = {
      "react-stack-bottom-frame": function(e) {
        e.resourceKind != null && console.error(
          "Expected only SimpleEffects when enableUseEffectCRUDOverload is disabled, got %s",
          e.resourceKind
        );
        var t = e.create;
        return e = e.inst, t = t(), e.destroy = t;
      }
    }, Wy = w3["react-stack-bottom-frame"].bind(w3), B3 = {
      "react-stack-bottom-frame": function(e, t, i) {
        try {
          i();
        } catch (l) {
          lt(e, t, l);
        }
      }
    }, Hy = B3["react-stack-bottom-frame"].bind(B3), A3 = {
      "react-stack-bottom-frame": function(e) {
        var t = e._init;
        return t(e._payload);
      }
    }, ud = A3["react-stack-bottom-frame"].bind(A3), Dh = null, Qf = 0, kt = null, JS, I3 = JS = !1, L3 = {}, J3 = {}, W3 = {};
    T = function(e, t, i) {
      if (i !== null && typeof i == "object" && i._store && (!i._store.validated && i.key == null || i._store.validated === 2)) {
        if (typeof i._store != "object")
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        i._store.validated = 1;
        var l = Fe(e), u = l || "null";
        if (!L3[u]) {
          L3[u] = !0, i = i._owner, e = e._debugOwner;
          var m = "";
          e && typeof e.tag == "number" && (u = Fe(e)) && (m = `

Check the render method of \`` + u + "`."), m || l && (m = `

Check the top-level render call using <` + l + ">.");
          var S = "";
          i != null && e !== i && (l = null, typeof i.tag == "number" ? l = Fe(i) : typeof i.name == "string" && (l = i.name), l && (S = " It was passed a child from " + l + ".")), pe(t, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              m,
              S
            );
          });
        }
      }
    };
    var Qh = r0(!0), H3 = r0(!1), vo = ye(null), js = null, xh = 1, xf = 2, Ni = ye(0), z3 = {}, j3 = /* @__PURE__ */ new Set(), P3 = /* @__PURE__ */ new Set(), G3 = /* @__PURE__ */ new Set(), Y3 = /* @__PURE__ */ new Set(), X3 = /* @__PURE__ */ new Set(), K3 = /* @__PURE__ */ new Set(), q3 = /* @__PURE__ */ new Set(), $3 = /* @__PURE__ */ new Set(), e5 = /* @__PURE__ */ new Set(), t5 = /* @__PURE__ */ new Set();
    Object.freeze(z3);
    var WS = {
      enqueueSetState: function(e, t, i) {
        e = e._reactInternals;
        var l = da(e), u = Or(l);
        u.payload = t, i != null && (Ym(i), u.callback = i), t = mr(e, u, l), t !== null && (wn(t, e, l), vs(t, e, l)), hn(e, l);
      },
      enqueueReplaceState: function(e, t, i) {
        e = e._reactInternals;
        var l = da(e), u = Or(l);
        u.tag = E3, u.payload = t, i != null && (Ym(i), u.callback = i), t = mr(e, u, l), t !== null && (wn(t, e, l), vs(t, e, l)), hn(e, l);
      },
      enqueueForceUpdate: function(e, t) {
        e = e._reactInternals;
        var i = da(e), l = Or(i);
        l.tag = U3, t != null && (Ym(t), l.callback = t), t = mr(e, l, i), t !== null && (wn(t, e, i), vs(t, e, i)), ze !== null && typeof ze.markForceUpdateScheduled == "function" && ze.markForceUpdateScheduled(e, i);
      }
    }, HS = typeof reportError == "function" ? reportError : function(e) {
      if (typeof window == "object" && typeof window.ErrorEvent == "function") {
        var t = new window.ErrorEvent("error", {
          bubbles: !0,
          cancelable: !0,
          message: typeof e == "object" && e !== null && typeof e.message == "string" ? String(e.message) : String(e),
          error: e
        });
        if (!window.dispatchEvent(t)) return;
      } else if (typeof process == "object" && typeof process.emit == "function") {
        process.emit("uncaughtException", e);
        return;
      }
      console.error(e);
    }, Zh = null, zS = null, n5 = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), Zi = !1, i5 = {}, a5 = {}, r5 = {}, o5 = {}, Oh = !1, s5 = {}, jS = {}, PS = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, l5 = !1, c5 = null;
    c5 = /* @__PURE__ */ new Set();
    var Gl = !1, ii = !1, GS = !1, d5 = typeof WeakSet == "function" ? WeakSet : Set, Oi = null, wh = null, Bh = null, mi = null, ir = !1, $o = null, Zf = 8192, zy = {
      getCacheForType: function(e) {
        var t = Sn(Ti), i = t.data.get(e);
        return i === void 0 && (i = e(), t.data.set(e, i)), i;
      },
      getOwner: function() {
        return Da;
      }
    };
    if (typeof Symbol == "function" && Symbol.for) {
      var Of = Symbol.for;
      Of("selector.component"), Of("selector.has_pseudo_class"), Of("selector.role"), Of("selector.test_id"), Of("selector.text");
    }
    var jy = [], Py = typeof WeakMap == "function" ? WeakMap : Map, yr = 0, Oa = 2, es = 4, Yl = 0, wf = 1, Ah = 2, YS = 3, tu = 4, Wg = 6, u5 = 5, nn = yr, Rn = null, Ot = null, At = 0, ar = 0, Bf = 1, nu = 2, Af = 3, h5 = 4, XS = 5, Ih = 6, If = 7, KS = 8, iu = 9, ln = ar, Nr = null, hd = !1, Lh = !1, qS = !1, Ps = 0, Kn = Yl, md = 0, pd = 0, $S = 0, br = 0, au = 0, Lf = null, wa = null, Hg = !1, eR = 0, m5 = 300, zg = 1 / 0, p5 = 500, Jf = null, fd = null, Gy = 0, Yy = 1, Xy = 2, ru = 0, f5 = 1, g5 = 2, v5 = 3, Ky = 4, tR = 5, Ki = 0, gd = null, Jh = null, vd = 0, nR = 0, iR = null, S5 = null, qy = 50, Wf = 0, aR = null, rR = !1, jg = !1, $y = 50, ou = 0, Hf = null, Wh = !1, Pg = null, R5 = !1, E5 = /* @__PURE__ */ new Set(), e4 = {}, Gg = null, Hh = null, oR = !1, sR = !1, Yg = !1, lR = !1, su = 0, cR = {};
    (function() {
      for (var e = 0; e < CS.length; e++) {
        var t = CS[e], i = t.toLowerCase();
        t = t[0].toUpperCase() + t.slice(1), lr(i, "on" + t);
      }
      lr(a3, "onAnimationEnd"), lr(r3, "onAnimationIteration"), lr(o3, "onAnimationStart"), lr("dblclick", "onDoubleClick"), lr("focusin", "onFocus"), lr("focusout", "onBlur"), lr(ky, "onTransitionRun"), lr(Dy, "onTransitionStart"), lr(Qy, "onTransitionCancel"), lr(s3, "onTransitionEnd");
    })(), Ae("onMouseEnter", ["mouseout", "mouseover"]), Ae("onMouseLeave", ["mouseout", "mouseover"]), Ae("onPointerEnter", ["pointerout", "pointerover"]), Ae("onPointerLeave", ["pointerout", "pointerover"]), Ze(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    ), Ze(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    ), Ze("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]), Ze(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    ), Ze(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    ), Ze(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), dR = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(zf)
    ), Xg = "_reactListening" + Math.random().toString(36).slice(2), U5 = !1, T5 = !1, Kg = !1, y5 = !1, qg = !1, $g = !1, N5 = !1, ev = {}, t4 = /\r\n?/g, n4 = /\u0000|\uFFFD/g, lu = "http://www.w3.org/1999/xlink", uR = "http://www.w3.org/XML/1998/namespace", i4 = "javascript:throw new Error('React form unexpectedly submitted.')", a4 = "suppressHydrationWarning", tv = "$", nv = "/$", Xl = "$?", jf = "$!", r4 = 1, o4 = 2, s4 = 4, hR = "F!", b5 = "F", C5 = "complete", l4 = "style", Kl = 0, zh = 1, iv = 2, mR = null, pR = null, V5 = { dialog: !0, webview: !0 }, fR = null, _5 = typeof setTimeout == "function" ? setTimeout : void 0, c4 = typeof clearTimeout == "function" ? clearTimeout : void 0, cu = -1, F5 = typeof Promise == "function" ? Promise : void 0, d4 = typeof queueMicrotask == "function" ? queueMicrotask : typeof F5 < "u" ? function(e) {
      return F5.resolve(null).then(e).catch(Zp);
    } : _5, gR = null, du = 0, Pf = 1, M5 = 2, k5 = 3, So = 4, Ro = /* @__PURE__ */ new Map(), D5 = /* @__PURE__ */ new Set(), ql = pt.d;
    pt.d = {
      f: function() {
        var e = ql.f(), t = Vl();
        return e || t;
      },
      r: function(e) {
        var t = Mn(e);
        t !== null && t.tag === 5 && t.type === "form" ? jm(t) : ql.r(e);
      },
      D: function(e) {
        ql.D(e), og("dns-prefetch", e, null);
      },
      C: function(e, t) {
        ql.C(e, t), og("preconnect", e, t);
      },
      L: function(e, t, i) {
        ql.L(e, t, i);
        var l = jh;
        if (l && e && t) {
          var u = 'link[rel="preload"][as="' + ya(t) + '"]';
          t === "image" && i && i.imageSrcSet ? (u += '[imagesrcset="' + ya(
            i.imageSrcSet
          ) + '"]', typeof i.imageSizes == "string" && (u += '[imagesizes="' + ya(
            i.imageSizes
          ) + '"]')) : u += '[href="' + ya(e) + '"]';
          var m = u;
          switch (t) {
            case "style":
              m = Ds(e);
              break;
            case "script":
              m = xl(e);
          }
          Ro.has(m) || (e = Ct(
            {
              rel: "preload",
              href: t === "image" && i && i.imageSrcSet ? void 0 : e,
              as: t
            },
            i
          ), Ro.set(m, e), l.querySelector(u) !== null || t === "style" && l.querySelector(
            io(m)
          ) || t === "script" && l.querySelector(Zl(m)) || (t = l.createElement("link"), An(t, "link", e), z(t), l.head.appendChild(t)));
        }
      },
      m: function(e, t) {
        ql.m(e, t);
        var i = jh;
        if (i && e) {
          var l = t && typeof t.as == "string" ? t.as : "script", u = 'link[rel="modulepreload"][as="' + ya(l) + '"][href="' + ya(e) + '"]', m = u;
          switch (l) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              m = xl(e);
          }
          if (!Ro.has(m) && (e = Ct({ rel: "modulepreload", href: e }, t), Ro.set(m, e), i.querySelector(u) === null)) {
            switch (l) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (i.querySelector(Zl(m)))
                  return;
            }
            l = i.createElement("link"), An(l, "link", e), z(l), i.head.appendChild(l);
          }
        }
      },
      X: function(e, t) {
        ql.X(e, t);
        var i = jh;
        if (i && e) {
          var l = F(i).hoistableScripts, u = xl(e), m = l.get(u);
          m || (m = i.querySelector(
            Zl(u)
          ), m || (e = Ct({ src: e, async: !0 }, t), (t = Ro.get(u)) && Wp(e, t), m = i.createElement("script"), z(m), An(m, "link", e), i.head.appendChild(m)), m = {
            type: "script",
            instance: m,
            count: 1,
            state: null
          }, l.set(u, m));
        }
      },
      S: function(e, t, i) {
        ql.S(e, t, i);
        var l = jh;
        if (l && e) {
          var u = F(l).hoistableStyles, m = Ds(e);
          t = t || "default";
          var S = u.get(m);
          if (!S) {
            var U = { loading: du, preload: null };
            if (S = l.querySelector(
              io(m)
            ))
              U.loading = Pf | So;
            else {
              e = Ct(
                {
                  rel: "stylesheet",
                  href: e,
                  "data-precedence": t
                },
                i
              ), (i = Ro.get(m)) && Jp(e, i);
              var D = S = l.createElement("link");
              z(D), An(D, "link", e), D._p = new Promise(function(Q, ae) {
                D.onload = Q, D.onerror = ae;
              }), D.addEventListener("load", function() {
                U.loading |= Pf;
              }), D.addEventListener("error", function() {
                U.loading |= M5;
              }), U.loading |= So, Y1(S, t, l);
            }
            S = {
              type: "stylesheet",
              instance: S,
              count: 1,
              state: U
            }, u.set(m, S);
          }
        }
      },
      M: function(e, t) {
        ql.M(e, t);
        var i = jh;
        if (i && e) {
          var l = F(i).hoistableScripts, u = xl(e), m = l.get(u);
          m || (m = i.querySelector(
            Zl(u)
          ), m || (e = Ct({ src: e, async: !0, type: "module" }, t), (t = Ro.get(u)) && Wp(e, t), m = i.createElement("script"), z(m), An(m, "link", e), i.head.appendChild(m)), m = {
            type: "script",
            instance: m,
            count: 1,
            state: null
          }, l.set(u, m));
        }
      }
    };
    var jh = typeof document > "u" ? null : document, av = null, Gf = null, vR = null, rv = null, uu = fS, Yf = {
      $$typeof: $a,
      Provider: null,
      Consumer: null,
      _currentValue: uu,
      _currentValue2: uu,
      _threadCount: 0
    }, Q5 = "%c%s%c ", x5 = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", Z5 = "", ov = " ", u4 = Function.prototype.bind, O5 = !1, w5 = null, B5 = null, A5 = null, I5 = null, L5 = null, J5 = null, W5 = null, H5 = null, z5 = null;
    w5 = function(e, t, i, l) {
      t = s(e, t), t !== null && (i = r(t.memoizedState, i, 0, l), t.memoizedState = i, t.baseState = i, e.memoizedProps = Ct({}, e.memoizedProps), i = ia(e, 2), i !== null && wn(i, e, 2));
    }, B5 = function(e, t, i) {
      t = s(e, t), t !== null && (i = f(t.memoizedState, i, 0), t.memoizedState = i, t.baseState = i, e.memoizedProps = Ct({}, e.memoizedProps), i = ia(e, 2), i !== null && wn(i, e, 2));
    }, A5 = function(e, t, i, l) {
      t = s(e, t), t !== null && (i = c(t.memoizedState, i, l), t.memoizedState = i, t.baseState = i, e.memoizedProps = Ct({}, e.memoizedProps), i = ia(e, 2), i !== null && wn(i, e, 2));
    }, I5 = function(e, t, i) {
      e.pendingProps = r(e.memoizedProps, t, 0, i), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = ia(e, 2), t !== null && wn(t, e, 2);
    }, L5 = function(e, t) {
      e.pendingProps = f(e.memoizedProps, t, 0), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = ia(e, 2), t !== null && wn(t, e, 2);
    }, J5 = function(e, t, i) {
      e.pendingProps = c(
        e.memoizedProps,
        t,
        i
      ), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = ia(e, 2), t !== null && wn(t, e, 2);
    }, W5 = function(e) {
      var t = ia(e, 2);
      t !== null && wn(t, e, 2);
    }, H5 = function(e) {
      R = e;
    }, z5 = function(e) {
      v = e;
    };
    var sv = !0, lv = null, SR = !1, Sd = null, Rd = null, Ed = null, Xf = /* @__PURE__ */ new Map(), Kf = /* @__PURE__ */ new Map(), Ud = [], h4 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), cv = null;
    if (D0.prototype.render = th.prototype.render = function(e) {
      var t = this._internalRoot;
      if (t === null) throw Error("Cannot update an unmounted root.");
      var i = arguments;
      typeof i[1] == "function" ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : be(i[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : typeof i[1] < "u" && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      ), i = e;
      var l = t.current, u = da(l);
      tn(l, u, i, t, null, null);
    }, D0.prototype.unmount = th.prototype.unmount = function() {
      var e = arguments;
      if (typeof e[0] == "function" && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ), e = this._internalRoot, e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        (nn & (Oa | es)) !== yr && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        ), tn(e.current, 2, null, e, null, null), Vl(), t[Is] = null;
      }
    }, D0.prototype.unstable_scheduleHydration = function(e) {
      if (e) {
        var t = To();
        e = { blockedOn: null, target: e, priority: t };
        for (var i = 0; i < Ud.length && t !== 0 && t < Ud[i].priority; i++) ;
        Ud.splice(i, 0, e), i === 0 && hg(e);
      }
    }, function() {
      var e = Q0.version;
      if (e !== "19.1.0")
        throw Error(
          `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` + (e + `
  - react-dom:  19.1.0
Learn more: https://react.dev/warnings/version-mismatch`)
        );
    }(), typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    ), pt.findDOMNode = function(e) {
      var t = e._reactInternals;
      if (t === void 0)
        throw typeof e.render == "function" ? Error("Unable to find node on an unmounted component.") : (e = Object.keys(e).join(","), Error(
          "Argument appears to not be a ReactComponent. Keys: " + e
        ));
      return e = Ue(t), e = e !== null ? j(e) : null, e = e === null ? null : e.stateNode, e;
    }, !function() {
      var e = {
        bundleType: 1,
        version: "19.1.0",
        rendererPackageName: "react-dom",
        currentDispatcherRef: le,
        reconcilerVersion: "19.1.0"
      };
      return e.overrideHookState = w5, e.overrideHookStateDeletePath = B5, e.overrideHookStateRenamePath = A5, e.overrideProps = I5, e.overridePropsDeletePath = L5, e.overridePropsRenamePath = J5, e.scheduleUpdate = W5, e.setErrorHandler = H5, e.setSuspenseHandler = z5, e.scheduleRefresh = ce, e.scheduleRoot = B, e.setRefreshHandler = oe, e.getCurrentFiber = uS, e.getLaneLabelMap = hS, e.injectProfilingHooks = It, Be(e);
    }() && w && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && navigator.userAgent.indexOf("Edge") === -1 || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var j5 = window.location.protocol;
      /^(https?|file):$/.test(j5) && "" + (j5 === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq` : "");
    }
    i2.createRoot = function(e, t) {
      if (!be(e))
        throw Error("Target container is not a DOM element.");
      fg(e);
      var i = !1, l = "", u = Xm, m = H2, S = l1, U = null;
      return t != null && (t.hydrate || typeof t == "object" && t !== null && t.$$typeof === Zs && console.error(
        `You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`
      ), t.unstable_strictMode === !0 && (i = !0), t.identifierPrefix !== void 0 && (l = t.identifierPrefix), t.onUncaughtError !== void 0 && (u = t.onUncaughtError), t.onCaughtError !== void 0 && (m = t.onCaughtError), t.onRecoverableError !== void 0 && (S = t.onRecoverableError), t.unstable_transitionCallbacks !== void 0 && (U = t.unstable_transitionCallbacks)), t = jp(
        e,
        1,
        !1,
        null,
        null,
        i,
        l,
        u,
        m,
        S,
        U,
        null
      ), e[Is] = t.current, _p(e), new th(t);
    }, i2.hydrateRoot = function(e, t, i) {
      if (!be(e))
        throw Error("Target container is not a DOM element.");
      fg(e), t === void 0 && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var l = !1, u = "", m = Xm, S = H2, U = l1, D = null, Q = null;
      return i != null && (i.unstable_strictMode === !0 && (l = !0), i.identifierPrefix !== void 0 && (u = i.identifierPrefix), i.onUncaughtError !== void 0 && (m = i.onUncaughtError), i.onCaughtError !== void 0 && (S = i.onCaughtError), i.onRecoverableError !== void 0 && (U = i.onRecoverableError), i.unstable_transitionCallbacks !== void 0 && (D = i.unstable_transitionCallbacks), i.formState !== void 0 && (Q = i.formState)), t = jp(
        e,
        1,
        !0,
        t,
        i ?? null,
        l,
        u,
        m,
        S,
        U,
        D,
        Q
      ), t.context = Pp(null), i = t.current, l = da(i), l = jn(l), u = Or(l), u.callback = null, mr(i, u, l), i = l, t.current.lanes = i, Ta(t, i), Xa(t), e[Is] = t.current, _p(e), new D0(t);
    }, i2.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), i2;
}
var YE;
function vb() {
  if (YE) return Rv.exports;
  YE = 1;
  function s() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(s);
      } catch (r) {
        console.error(r);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (s(), Rv.exports = fb()) : Rv.exports = gb(), Rv.exports;
}
var Sb = vb();
function jT(s) {
  var r, c, h = "";
  if (typeof s == "string" || typeof s == "number") h += s;
  else if (typeof s == "object") if (Array.isArray(s)) {
    var f = s.length;
    for (r = 0; r < f; r++) s[r] && (c = jT(s[r])) && (h && (h += " "), h += c);
  } else for (c in s) s[c] && (h && (h += " "), h += c);
  return h;
}
function wt() {
  for (var s, r, c = 0, h = "", f = arguments.length; c < f; c++) (s = arguments[c]) && (r = jT(s)) && (h && (h += " "), h += r);
  return h;
}
function Rb() {
  const r = navigator.userAgentData;
  if (r && typeof r == "object" && "platform" in r)
    return r.platform;
  if (typeof navigator > "u" || !navigator.userAgent)
    return "unknown";
  const c = navigator.userAgent.toLowerCase();
  return /android/.test(c) ? "Android" : /iphone|ipad|ipod/.test(c) ? "iOS" : /mac os x/.test(c) ? "macOS" : /win/.test(c) ? "Windows" : /linux/.test(c) ? "Linux" : "unknown";
}
function Eb() {
  const s = Rb();
  return s === "Android" || s === "iOS";
}
Y.setState({
  isMobileBrowser: Eb(),
  userAgent: navigator.userAgent
});
Y.subscribe(
  (s) => s.audioInputDevice,
  async (s, r) => {
    var v;
    if (Y.getState().isMobileSDK() && (s == null ? void 0 : s.deviceId) !== null || s != null && s.skipSubscribe || (r == null ? void 0 : r.deviceId) === "")
      return;
    const h = fn(We.AUDIO);
    if (h != null && h.originalTrack && !h.muted && s && r) {
      const R = Y.getState().isMobileBrowser;
      (s.deviceId === r.deviceId || R) && h && await ((v = h.originalTrack) == null ? void 0 : v.stopStream()), t8(s.deviceId);
      const T = Y.getState().audioInputDevice;
      T && Je.publish({
        type: Cu.MediaEventsListener.onAudioInputDeviceChanged,
        payload: T
      });
    }
  },
  {
    equalityFn: _U
  }
);
Y.subscribe(
  (s) => s.audioInputDevices,
  (s) => {
    Je.publish({
      type: Cu.MediaEventsListener.onAudioInputDevicesChanged,
      payload: s
    });
  }
);
Y.subscribe(
  (s) => s.videoInputDevices,
  (s) => {
    Je.publish({
      type: Cu.MediaEventsListener.onVideoInputDevicesChanged,
      payload: s
    });
  }
);
Y.subscribe(
  (s) => s.audioOutputDevices,
  (s) => {
    Je.publish({
      type: Cu.MediaEventsListener.onAudioOutputDevicesChanged,
      payload: s
    });
  }
);
Y.subscribe(
  (s) => {
    var r;
    return (r = s.audioOutputDevice) == null ? void 0 : r.deviceId;
  },
  (s) => {
    if (typeof s == "string") {
      E6(s);
      const r = Y.getState().audioOutputDevice;
      r && Je.publish({
        type: Cu.MediaEventsListener.onAudioOutputDeviceChanged,
        payload: r
      });
    }
  }
);
Y.subscribe(
  (s) => s.videoInputDevice,
  async (s, r) => {
    if (!(Y.getState().isMobile() && (s == null ? void 0 : s.deviceId) !== null) && r && s) {
      wU(s.deviceId);
      const h = Y.getState().videoInputDevice;
      if (s.deviceId === r.deviceId) {
        const f = fn(We.VIDEO);
        f && await f.originalTrack.dispose();
      }
      h && Je.publish({
        type: Cu.MediaEventsListener.onVideoInputDeviceChanged,
        payload: h
      });
    }
  },
  {
    equalityFn: _U
  }
);
Je.subscribe(Un.onConnectionEstablished, () => {
  Y.setState({
    isDesktopSharingEnabled: Ge.isDesktopSharingEnabled()
  });
  {
    const s = document.createElement("canvas"), r = s.getContext("2d"), c = typeof (r == null ? void 0 : r.filter) < "u";
    Y.setState({ isBlurSupported: c }), s.remove();
  }
});
const Ub = "data:text/javascript;base64,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";
let Cd;
class Tb {
  /**
   * Instantiates a noise suppressor audio effect which will use rnnoise.
   */
  constructor() {
    /**
     * Source that will be attached to the track affected by the effect.
     */
    x(this, "_audioSource");
    /**
     * Destination that will contain denoised audio from the audio worklet.
     */
    x(this, "_audioDestination");
    /**
     * `AudioWorkletProcessor` associated node.
     */
    x(this, "_noiseSuppressorNode");
    /**
     * Audio track extracted from the original MediaStream to which the effect is applied.
     */
    x(this, "_originalMediaTrack");
    /**
     * Noise suppressed audio track extracted from the media destination node.
     */
    x(this, "_outputMediaTrack");
  }
  /**
   * Effect interface called by source JitsiLocalTrack.
   * Applies effect that uses a {@code NoiseSuppressor} service initialized with {@code RnnoiseProcessor}
   * for denoising.
   *
   * @param {MediaStream} audioStream - Audio stream which will be mixed with _mixAudio.
   * @returns {MediaStream} - MediaStream containing both audio tracks mixed together.
   */
  startEffect(r) {
    return this._originalMediaTrack = r.getAudioTracks()[0], Cd || (Cd = new AudioContext()), this._audioSource = Cd.createMediaStreamSource(r), this._audioDestination = Cd.createMediaStreamDestination(), this._outputMediaTrack = this._audioDestination.stream.getAudioTracks()[0], yb().then((h) => {
      this._noiseSuppressorNode = h;
    }).then(() => {
      this._noiseSuppressorNode && (this._audioSource.connect(this._noiseSuppressorNode), this._noiseSuppressorNode.connect(this._audioDestination));
    }), this._outputMediaTrack.enabled = this._originalMediaTrack.enabled, this._originalMediaTrack.enabled = !0, this._audioDestination.stream;
  }
  /**
   * Checks if the JitsiLocalTrack supports this effect.
   *
   * @param {JitsiLocalTrack} sourceLocalTrack - Track to which the effect will be applied.
   * @returns {boolean} - Returns true if this effect can run on the specified track, false otherwise.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isEnabled(r) {
    return r.isAudioTrack();
  }
  /**
   * Clean up resources acquired by noise suppressor and rnnoise processor.
   *
   * @returns {void}
   */
  stopEffect() {
    var r, c, h, f, v;
    this._originalMediaTrack.enabled = this._outputMediaTrack.enabled, (c = (r = this._noiseSuppressorNode) == null ? void 0 : r.port) == null || c.close(), (h = this._audioDestination) == null || h.disconnect(), (f = this._noiseSuppressorNode) == null || f.disconnect(), (v = this._audioSource) == null || v.disconnect(), Cd.suspend();
  }
}
async function yb() {
  await Cd.resume();
  try {
    await Cd.audioWorklet.addModule(Ub);
  } catch (s) {
    console.error("Error while adding audio worklet module: ", s);
    return;
  }
  return new AudioWorkletNode(Cd, "NoiseSuppressorWorklet");
}
function PT() {
  var c;
  if (Y.getState().isMobileBrowser)
    return;
  const r = (c = fn(We.AUDIO)) == null ? void 0 : c.originalTrack;
  r && Jv(r, new Tb()).then(() => {
  }).catch((h) => {
    console.error("Error applying noise suppression effect:", h);
  });
}
function Nb() {
  var r;
  const s = (r = fn(We.AUDIO)) == null ? void 0 : r.originalTrack;
  s && Jv(s, void 0).then(() => {
  }).catch((c) => {
    console.error("Error removing noise suppression effect:", c);
  });
}
it.subscribe(
  (s) => {
    var r;
    return (r = s.tracks.find((c) => c.mediaType === We.AUDIO && c.local)) == null ? void 0 : r.originalTrack;
  },
  (s) => {
    s && Y.getState().enableNoiseReduction && PT();
  }
);
Y.subscribe(
  (s) => s.enableNoiseReduction,
  (s) => {
    s ? PT() : Nb();
  }
);
async function bb() {
  try {
    const [s, r] = await Promise.all([
      navigator.permissions.query({ name: "camera" }),
      navigator.permissions.query({ name: "microphone" })
    ]);
    it.setState((c) => ({
      permissions: {
        ...c.permissions,
        video: s.state === "granted",
        audio: r.state === "granted",
        initialized: !0
      }
    }));
  } catch {
  }
}
function Cb() {
  const { mediaDevices: s } = Ge;
  s.addEventListener(
    Ge.events.mediaDevices.PERMISSIONS_CHANGED,
    (r) => {
      it.setState((c) => ({
        permissions: {
          ...c.permissions,
          ...r
        }
      }));
    }
  );
}
Je.subscribe(Un.lifecycle.SDKInitialized, () => {
  bb(), Cb();
});
let Eu, eS = !1;
function Vb() {
  Eu = void 0, eS && document.visibilityState === "visible" && A6();
}
function i6() {
  eS && document.visibilityState === "visible" && (!Eu || Eu.released) && A6();
}
async function A6() {
  var s;
  if (!(!((s = navigator.wakeLock) != null && s.request) || document.visibilityState !== "visible"))
    try {
      const r = await navigator.wakeLock.request("screen");
      Eu = r, r.addEventListener("release", Vb, { once: !0 });
    } catch (r) {
      console.error("Failed to acquire wake lock:", r);
    }
}
async function _b() {
  if (Eu) {
    try {
      await Eu.release();
    } catch {
    }
    Eu = void 0;
  }
}
Je.subscribe(Un.onConnectionEstablished, () => {
  eS = !0, document.removeEventListener("visibilitychange", i6), document.addEventListener("visibilitychange", i6), A6();
});
Je.subscribe(Un.connectionWillClose, () => {
  eS = !1, document.removeEventListener("visibilitychange", i6), _b();
});
const Fb = ({
  isOpen: s,
  title: r,
  subtitle: c,
  primaryButtonText: h,
  secondaryButtonText: f = "Cancel",
  onPrimaryClick: v,
  onSecondaryClick: R,
  className: T = ""
}) => {
  if (!s)
    return null;
  const E = (N) => {
    N.target === N.currentTarget && R && R();
  }, C = (N) => {
    N.key === "Escape" && R && R();
  };
  return /* @__PURE__ */ b.jsx(
    "div",
    {
      className: "cometchat-calls-modal-overlay",
      onClick: E,
      role: "presentation",
      "aria-hidden": "false",
      children: /* @__PURE__ */ b.jsx(
        "div",
        {
          className: `cometchat-calls-modal ${T}`,
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "modal-title",
          "aria-describedby": c ? "modal-subtitle" : void 0,
          onKeyDown: C,
          tabIndex: -1,
          children: /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-modal__content", children: [
            /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-modal__header", children: /* @__PURE__ */ b.jsx("span", { id: "modal-title", className: "cometchat-calls-modal__title", children: r }) }),
            c && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-modal__body", children: /* @__PURE__ */ b.jsx(
              "p",
              {
                id: "modal-subtitle",
                className: "cometchat-calls-modal__subtitle",
                children: c
              }
            ) }),
            /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-modal__footer", children: [
              R && /* @__PURE__ */ b.jsx(
                "button",
                {
                  className: "cometchat-calls-modal__button cometchat-calls-modal__button--secondary",
                  onClick: R,
                  type: "button",
                  "aria-label": `${f} - closes the dialog`,
                  children: f
                }
              ),
              /* @__PURE__ */ b.jsx(
                "button",
                {
                  className: "cometchat-calls-modal__button cometchat-calls-modal__button--primary",
                  onClick: v,
                  type: "button",
                  "aria-label": `${h} - confirms the action`,
                  autoFocus: !0,
                  children: h
                }
              )
            ] })
          ] })
        }
      )
    }
  );
}, E2 = /* @__PURE__ */ new Map(), XE = {
  blockedIds: []
}, GT = x6(
  Z6(XE, (s) => ({
    reset: () => {
      E2.clear(), s(XE);
    }
  }))
);
function YT() {
  GT.setState({ blockedIds: Array.from(E2.keys()) });
}
function Mb(s, r) {
  E2.set(s, r), YT();
}
function KE(s) {
  E2.delete(s) && YT();
}
function kb() {
  for (const s of Array.from(E2.values()))
    s();
}
const Db = () => GT((s) => s.blockedIds.length > 0), Qb = () => {
  const s = Db(), { t: r } = Ua();
  return /* @__PURE__ */ b.jsx(
    Fb,
    {
      isOpen: s,
      className: "cometchat-calls-audio-playback-blocked-dialog",
      title: r("audioPlayback.blockedTitle"),
      subtitle: r("audioPlayback.blockedSubtitle"),
      primaryButtonText: r("audioPlayback.blockedButton"),
      onPrimaryClick: kb
    }
  );
}, xb = 3, Zb = 1e3, Ob = ({ autoPlay: s = !0, audioTrack: r, id: c }) => {
  const h = ne.useRef(null), f = ne.useRef(void 0);
  return ne.useEffect(() => {
    const v = h.current;
    if (!v || !r)
      return;
    const R = () => {
      f.current !== void 0 && (window.clearTimeout(f.current), f.current = void 0);
    }, T = (_ = 0) => {
      s && v.play().then(
        () => {
          KE(c), _ !== 0 && (f.current = void 0);
        },
        (V) => {
          if (console.error(
            `Failed to play audio track on element ${c} (retry ${_}):`,
            V
          ), V.name === "NotAllowedError") {
            f.current = void 0, Mb(c, () => T(0));
            return;
          }
          _ < xb ? f.current = window.setTimeout(
            () => T(_ + 1),
            Zb
          ) : f.current = void 0;
        }
      );
    }, E = () => {
      r.attach(v).catch((_) => {
        console.error("Error attaching audio track:", _);
      }).finally(() => {
        T();
      });
    }, C = () => {
      R(), KE(c), r.detach(v);
    }, N = (_) => {
      console.error(
        `Error on audio element ${c}; re-attaching the audio track and playing it again`,
        _
      ), C(), E();
    };
    return v.addEventListener("error", N), E(), () => {
      v.removeEventListener("error", N), C();
    };
  }, [r, s, c]), /* @__PURE__ */ b.jsx("audio", { autoPlay: s, id: c, ref: h });
}, XT = () => {
  const s = it((h) => h.tracks);
  if (He(
    (h) => h.enableCompanionMode
  ))
    return null;
  const c = s.filter(
    (h) => h.mediaType === We.AUDIO && !h.local && h.originalTrack
  );
  return /* @__PURE__ */ b.jsx(b.Fragment, { children: c.map((h, f) => {
    var v, R, T, E;
    return /* @__PURE__ */ b.jsx(
      Ob,
      {
        id: `cc-rt-${((R = (v = h.originalTrack).getId) == null ? void 0 : R.call(v)) || ""}`,
        audioTrack: h.originalTrack
      },
      ((E = (T = h.originalTrack).getId) == null ? void 0 : E.call(T)) || f
    );
  }) });
}, QR = {
  add: "M17.5 20.5H3.5V6.5H12.5V4.5H3.5C2.4 4.5 1.5 5.4 1.5 6.5V20.5C1.5 21.6 2.4 22.5 3.5 22.5H17.5C18.6 22.5 19.5 21.6 19.5 20.5V11.5H17.5V20.5ZM9.71 17.33L7.75 14.97L5 18.5H16L12.46 13.79L9.71 17.33ZM19.5 4.5V1.5H17.5V4.5H14.5C14.51 4.51 14.5 6.5 14.5 6.5H17.5V9.49C17.51 9.5 19.5 9.49 19.5 9.49V6.5H22.5V4.5H19.5Z",
  alert: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 15C9.45 15 9 14.55 9 14V10C9 9.45 9.45 9 10 9C10.55 9 11 9.45 11 10V14C11 14.55 10.55 15 10 15ZM11 7H9V5H11V7Z",
  "arrow-down": "M12.0005 13.5462L16.0735 9.473C16.2118 9.33467 16.3859 9.26383 16.5955 9.2605C16.805 9.25733 16.9823 9.32817 17.1273 9.473C17.2721 9.618 17.3445 9.79367 17.3445 10C17.3445 10.2063 17.2721 10.382 17.1273 10.527L12.633 15.0212C12.4521 15.2019 12.2413 15.2922 12.0003 15.2922C11.7593 15.2922 11.5484 15.2019 11.3675 15.0212L6.87325 10.527C6.73492 10.3885 6.66408 10.2144 6.66075 10.0047C6.65758 9.79517 6.72842 9.618 6.87325 9.473C7.01825 9.32817 7.19392 9.25575 7.40025 9.25575C7.60658 9.25575 7.78225 9.32817 7.92725 9.473L12.0005 13.5462Z",
  "arrow-down-2": "M11.0046 5.20898V16.379L6.12461 11.499C5.73461 11.109 5.09461 11.109 4.70461 11.499C4.31461 11.889 4.31461 12.519 4.70461 12.909L11.2946 19.499C11.6846 19.889 12.3146 19.889 12.7046 19.499L19.2946 12.909C19.6846 12.519 19.6846 11.889 19.2946 11.499C18.9046 11.109 18.2746 11.109 17.8846 11.499L13.0046 16.379V5.20898C13.0046 4.65898 12.5546 4.20898 12.0046 4.20898C11.4546 4.20898 11.0046 4.65898 11.0046 5.20898Z",
  "arrow-left": "M10.4538 12.0005L14.527 16.0735C14.6653 16.212 14.7362 16.3861 14.7395 16.5958C14.7427 16.8053 14.6718 16.9825 14.527 17.1275C14.382 17.2723 14.2063 17.3448 14 17.3448C13.7937 17.3448 13.618 17.2723 13.473 17.1275L8.97876 12.6333C8.7981 12.4524 8.70776 12.2415 8.70776 12.0005C8.70776 11.7595 8.7981 11.5486 8.97876 11.3678L13.473 6.8735C13.6115 6.73517 13.7856 6.66433 13.9953 6.661C14.2048 6.65783 14.382 6.72867 14.527 6.8735C14.6718 7.0185 14.7443 7.19417 14.7443 7.4005C14.7443 7.60683 14.6718 7.7825 14.527 7.9275L10.4538 12.0005Z",
  "arrow-right": "M13.5462 12.0005L9.473 7.9275C9.33467 7.789 9.26383 7.61492 9.2605 7.40525C9.25733 7.19575 9.32817 7.0185 9.473 6.8735C9.618 6.72867 9.79367 6.65625 10 6.65625C10.2063 6.65625 10.382 6.72867 10.527 6.8735L15.0212 11.3678C15.2019 11.5486 15.2922 11.7595 15.2922 12.0005C15.2922 12.2415 15.2019 12.4524 15.0212 12.6333L10.527 17.1275C10.3885 17.2658 10.2144 17.3367 10.0047 17.34C9.79517 17.3432 9.618 17.2723 9.473 17.1275C9.32817 16.9825 9.25575 16.8068 9.25575 16.6005C9.25575 16.3942 9.32817 16.2185 9.473 16.0735L13.5462 12.0005Z",
  "arrow-up": "M12.0005 10.4538L7.9275 14.527C7.789 14.6653 7.61492 14.7362 7.40525 14.7395C7.19575 14.7427 7.0185 14.6718 6.8735 14.527C6.72867 14.382 6.65625 14.2063 6.65625 14C6.65625 13.7937 6.72867 13.618 6.8735 13.473L11.3678 8.97876C11.5486 8.7981 11.7595 8.70776 12.0005 8.70776C12.2415 8.70776 12.4524 8.7981 12.6333 8.97876L17.1275 13.473C17.2658 13.6115 17.3367 13.7856 17.34 13.9953C17.3432 14.2048 17.2723 14.382 17.1275 14.527C16.9825 14.6718 16.8068 14.7443 16.6005 14.7443C16.3942 14.7443 16.2185 14.6718 16.0735 14.527L12.0005 10.4538Z",
  bluetooth: "M17.65 6.99663L13.36 2.70663C12.73 2.07663 11.65 2.51663 11.65 3.40663V9.58663L7.76 5.69663C7.37 5.30663 6.74 5.30663 6.35 5.69663C5.96 6.08663 5.96 6.71663 6.35 7.10663L11.24 11.9966L6.35 16.8866C5.96 17.2766 5.96 17.9066 6.35 18.2966C6.74 18.6866 7.37 18.6866 7.76 18.2966L11.65 14.4066V20.5866C11.65 21.4766 12.73 21.9266 13.36 21.2966L17.65 16.9966C18.04 16.6066 18.04 15.9766 17.65 15.5866L14.06 11.9966L17.65 8.41663C18.04 8.02663 18.04 7.38663 17.65 6.99663ZM13.65 5.82663L15.53 7.70663L13.65 9.58663V5.82663ZM15.53 16.2866L13.65 18.1666V14.4066L15.53 16.2866Z",
  "call-end": "M4.58108 16.0302L6.58108 14.4402C7.06108 14.0602 7.34108 13.4802 7.34108 12.8702V10.2702C10.3611 9.29016 13.6311 9.28016 16.6611 10.2702V12.8802C16.6611 13.4902 16.9411 14.0702 17.4211 14.4502L19.4111 16.0302C20.2111 16.6602 21.3511 16.6002 22.0711 15.8802L23.2911 14.6602C24.0911 13.8602 24.0911 12.5302 23.2411 11.7802C16.8311 6.12016 7.17108 6.12016 0.76108 11.7802C-0.0889204 12.5302 -0.0889204 13.8602 0.71108 14.6602L1.93108 15.8802C2.64108 16.6002 3.78108 16.6602 4.58108 16.0302Z",
  car: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3.11 10.68C3.04 10.89 3 11.11 3 11.34V18.5C3 19.33 3.67 20 4.5 20C5.33 20 6 19.33 6 18.5V18H18V18.5C18 19.32 18.67 20 19.5 20C20.32 20 21 19.33 21 18.5V11.34C21 11.12 20.96 10.89 20.89 10.68L18.92 5.01ZM6.5 15C5.67 15 5 14.33 5 13.5C5 12.67 5.67 12 6.5 12C7.33 12 8 12.67 8 13.5C8 14.33 7.33 15 6.5 15ZM17.5 15C16.67 15 16 14.33 16 13.5C16 12.67 16.67 12 17.5 12C18.33 12 19 12.67 19 13.5C19 14.33 18.33 15 17.5 15ZM5 10L6.27 6.18C6.41 5.78 6.79 5.5 7.22 5.5H16.78C17.21 5.5 17.59 5.78 17.73 6.18L19 10H5Z",
  chat: "M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM7 9H17C17.55 9 18 9.45 18 10C18 10.55 17.55 11 17 11H7C6.45 11 6 10.55 6 10C6 9.45 6.45 9 7 9ZM13 14H7C6.45 14 6 13.55 6 13C6 12.45 6.45 12 7 12H13C13.55 12 14 12.45 14 13C14 13.55 13.55 14 13 14ZM17 8H7C6.45 8 6 7.55 6 7C6 6.45 6.45 6 7 6H17C17.55 6 18 6.45 18 7C18 7.55 17.55 8 17 8Z",
  "check-fill": "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM9.29 16.29L5.7 12.7C5.31 12.31 5.31 11.68 5.7 11.29C6.09 10.9 6.72 10.9 7.11 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.7 16.29C10.32 16.68 9.68 16.68 9.29 16.29Z",
  close: "M11.999 13.1163L6.89479 18.2203C6.73379 18.3815 6.54629 18.4614 6.33229 18.4601C6.11845 18.4586 5.93379 18.3773 5.77829 18.2163C5.61995 18.0552 5.54287 17.8697 5.54704 17.6601C5.5512 17.4502 5.62962 17.269 5.78229 17.1163L10.8823 11.9996L5.78229 6.88283C5.62962 6.73016 5.55329 6.54891 5.55329 6.33908C5.55329 6.12941 5.62962 5.944 5.78229 5.78283C5.93512 5.62183 6.11845 5.54058 6.33229 5.53908C6.54629 5.53775 6.73379 5.61483 6.89479 5.77033L11.999 10.8828L17.1115 5.77033C17.267 5.61483 17.4518 5.53775 17.6658 5.53908C17.8796 5.54058 18.0671 5.62183 18.2283 5.78283C18.381 5.944 18.4552 6.12941 18.451 6.33908C18.4469 6.54891 18.3685 6.73016 18.2158 6.88283L13.1158 11.9996L18.2158 17.1163C18.3685 17.269 18.4448 17.4502 18.4448 17.6601C18.4448 17.8697 18.3685 18.0552 18.2158 18.2163C18.063 18.3773 17.8796 18.4586 17.6658 18.4601C17.4518 18.4614 17.267 18.3815 17.1115 18.2203L11.999 13.1163Z",
  "closed-caption": "M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM11 10.5C11 10.78 10.78 11 10.5 11H10C9.72 11 9.5 10.78 9.5 10.5H7.5V13.5H9.5C9.5 13.22 9.72 13 10 13H10.5C10.78 13 11 13.22 11 13.5V14C11 14.55 10.55 15 10 15H7C6.45 15 6 14.55 6 14V10C6 9.45 6.45 9 7 9H10C10.55 9 11 9.45 11 10V10.5ZM18 10.5C18 10.78 17.78 11 17.5 11H17C16.72 11 16.5 10.78 16.5 10.5H14.5V13.5H16.5C16.5 13.22 16.72 13 17 13H17.5C17.78 13 18 13.22 18 13.5V14C18 14.55 17.55 15 17 15H14C13.45 15 13 14.55 13 14V10C13 9.45 13.45 9 14 9H17C17.55 9 18 9.45 18 10V10.5Z",
  earpiece: "M19.7885 11.7299C19.5858 11.7299 19.4076 11.658 19.2538 11.5144C19.0999 11.3709 19.0096 11.1927 18.9828 10.9799C18.7661 9.36569 18.0863 7.98719 16.9433 6.84436C15.8003 5.70136 14.4218 5.02153 12.8078 4.80486C12.5949 4.77786 12.4167 4.69003 12.273 4.54136C12.1295 4.39269 12.0578 4.21194 12.0578 3.99911C12.0578 3.78628 12.1321 3.60811 12.2808 3.46461C12.4294 3.32094 12.6051 3.26261 12.8078 3.28961C14.8436 3.51011 16.5792 4.33794 18.0145 5.77311C19.4497 7.20844 20.2775 8.94403 20.498 10.9799C20.525 11.1824 20.4667 11.358 20.323 11.5069C20.1795 11.6555 20.0013 11.7299 19.7885 11.7299ZM15.652 11.7299C15.4865 11.7299 15.3413 11.6741 15.2163 11.5626C15.0913 11.4511 14.9968 11.3024 14.9328 11.1164C14.7801 10.5754 14.5002 10.0981 14.0933 9.68461C13.6863 9.27111 13.2123 8.99136 12.6713 8.84536C12.4853 8.78119 12.3365 8.68661 12.225 8.56161C12.1135 8.43661 12.0578 8.28628 12.0578 8.11061C12.0578 7.86061 12.1439 7.65869 12.3163 7.50486C12.4888 7.35103 12.6846 7.30103 12.9038 7.35486C13.7794 7.55869 14.5339 7.97728 15.1673 8.61061C15.8006 9.24394 16.2224 10.0016 16.4328 10.8836C16.4866 11.1029 16.4324 11.2988 16.2703 11.4711C16.1081 11.6436 15.902 11.7299 15.652 11.7299ZM19.4403 20.4991C17.5558 20.4991 15.6625 20.0609 13.7605 19.1846C11.8587 18.3083 10.1097 17.0721 8.5135 15.4761C6.92383 13.8799 5.69083 12.1324 4.8145 10.2336C3.93817 8.33494 3.5 6.44336 3.5 4.55886C3.5 4.25886 3.6 4.00719 3.8 3.80386C4 3.60069 4.25 3.49911 4.55 3.49911H7.8115C8.064 3.49911 8.28675 3.58153 8.47975 3.74636C8.67275 3.91103 8.7955 4.11453 8.848 4.35686L9.42125 7.29911C9.46092 7.57211 9.45258 7.80669 9.39625 8.00286C9.33975 8.19903 9.23842 8.36378 9.09225 8.49711L6.78275 10.7454C7.15442 11.426 7.57908 12.0699 8.05675 12.6771C8.53425 13.2841 9.05125 13.8639 9.60775 14.4164C10.1564 14.9652 10.7398 15.4749 11.3578 15.9454C11.9757 16.4159 12.6431 16.8537 13.3598 17.2589L15.6038 14.9954C15.7603 14.8325 15.9498 14.7184 16.1723 14.6529C16.3946 14.5875 16.6257 14.5715 16.8655 14.6049L19.6423 15.1704C19.8948 15.237 20.1008 15.3659 20.2605 15.5569C20.4202 15.7479 20.5 15.9645 20.5 16.2069V19.4491C20.5 19.7491 20.3984 19.9991 20.1953 20.1991C19.9919 20.3991 19.7403 20.4991 19.4403 20.4991Z",
  "empty-search": "M11.0001 11.6921C10.0348 11.6921 9.2101 11.3501 8.5261 10.6661C7.8421 9.98228 7.5001 9.15761 7.5001 8.19211C7.5001 7.22678 7.8421 6.40211 8.5261 5.71811C9.2101 5.03411 10.0348 4.69211 11.0001 4.69211C11.9654 4.69211 12.7901 5.03411 13.4741 5.71811C14.1581 6.40211 14.5001 7.22678 14.5001 8.19211C14.5001 9.15761 14.1581 9.98228 13.4741 10.6661C12.7901 11.3501 11.9654 11.6921 11.0001 11.6921ZM21.1308 22.1844L18.7271 19.7806C18.3899 19.9934 18.0341 20.1601 17.6596 20.2806C17.2853 20.4011 16.8988 20.4614 16.5001 20.4614C15.3976 20.4614 14.4617 20.0768 13.6923 19.3076C12.9232 18.5383 12.5386 17.6024 12.5386 16.4999C12.5386 15.3974 12.9232 14.4614 13.6923 13.6921C14.4617 12.9229 15.3976 12.5384 16.5001 12.5384C17.6026 12.5384 18.5385 12.9229 19.3078 13.6921C20.077 14.4614 20.4616 15.3974 20.4616 16.4999C20.4616 16.8985 20.4013 17.285 20.2808 17.6594C20.1603 18.0339 19.9937 18.3897 19.7808 18.7269L22.1846 21.1306C22.3231 21.2691 22.3939 21.4431 22.3971 21.6526C22.4003 21.8623 22.3294 22.0395 22.1846 22.1844C22.0398 22.3292 21.8642 22.4016 21.6578 22.4016C21.4513 22.4016 21.2757 22.3292 21.1308 22.1844ZM16.5001 18.9614C17.1938 18.9614 17.7774 18.7245 18.2511 18.2509C18.7248 17.7772 18.9616 17.1935 18.9616 16.4999C18.9616 15.8062 18.7248 15.2225 18.2511 14.7489C17.7774 14.2752 17.1938 14.0384 16.5001 14.0384C15.8064 14.0384 15.2228 14.2752 14.7491 14.7489C14.2754 15.2225 14.0386 15.8062 14.0386 16.4999C14.0386 17.1935 14.2754 17.7772 14.7491 18.2509C15.2228 18.7245 15.8064 18.9614 16.5001 18.9614ZM5.01935 19.3076C4.59751 19.3076 4.23885 19.1599 3.94335 18.8644C3.64785 18.5687 3.5001 18.21 3.5001 17.7884V17.0999C3.5001 16.6037 3.6306 16.1476 3.8916 15.7316C4.15243 15.3156 4.51043 14.9922 4.9656 14.7614C5.66426 14.4037 6.49018 14.0842 7.44335 13.8029C8.39651 13.5214 9.43726 13.3614 10.5656 13.3229C10.7591 13.3127 10.9058 13.3944 11.0058 13.5681C11.1058 13.7418 11.1174 13.9254 11.0406 14.1191C10.8764 14.5038 10.7518 14.8977 10.6666 15.3009C10.5813 15.704 10.5386 16.1114 10.5386 16.5229C10.5386 16.8472 10.5648 17.1741 10.6173 17.5036C10.67 17.8331 10.7592 18.1498 10.8848 18.4536C10.9592 18.6678 10.9396 18.8636 10.8261 19.0411C10.7126 19.2188 10.5488 19.3076 10.3348 19.3076H5.01935Z",
  error: "M9.16602 12.5003H10.8327V14.167H9.16602V12.5003ZM9.16602 5.83366H10.8327V10.8337H9.16602V5.83366ZM9.99102 1.66699C5.39102 1.66699 1.66602 5.40033 1.66602 10.0003C1.66602 14.6003 5.39102 18.3337 9.99102 18.3337C14.5993 18.3337 18.3327 14.6003 18.3327 10.0003C18.3327 5.40033 14.5993 1.66699 9.99102 1.66699ZM9.99935 16.667C6.31602 16.667 3.33268 13.6837 3.33268 10.0003C3.33268 6.31699 6.31602 3.33366 9.99935 3.33366C13.6827 3.33366 16.666 6.31699 16.666 10.0003C16.666 13.6837 13.6827 16.667 9.99935 16.667Z",
  headphones: "M3 12V19C3 20.1 3.9 21 5 21H7C8.1 21 9 20.1 9 19V15C9 13.9 8.1 13 7 13H5V12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12V13H17C15.9 13 15 13.9 15 15V19C15 20.1 15.9 21 17 21H19C20.1 21 21 20.1 21 19V12C21 7.03 16.97 3 12 3C7.03 3 3 7.03 3 12Z",
  image: "M17.5 20.5H3.5V6.5H12.5V4.5H3.5C2.4 4.5 1.5 5.4 1.5 6.5V20.5C1.5 21.6 2.4 22.5 3.5 22.5H17.5C18.6 22.5 19.5 21.6 19.5 20.5V11.5H17.5V20.5ZM9.71 17.33L7.75 14.97L5 18.5H16L12.46 13.79L9.71 17.33ZM19.5 4.5V1.5H17.5V4.5H14.5C14.51 4.51 14.5 6.5 14.5 6.5H17.5V9.49C17.51 9.5 19.5 9.49 19.5 9.49V6.5H22.5V4.5H19.5Z",
  invite: "M18.125 10.7501H15.875C15.6625 10.7501 15.4844 10.6782 15.3408 10.5344C15.1969 10.3905 15.125 10.2124 15.125 9.99988C15.125 9.78722 15.1969 9.60913 15.3408 9.46563C15.4844 9.32197 15.6625 9.25013 15.875 9.25013H18.125V7.00013C18.125 6.78763 18.1969 6.60955 18.3407 6.46588C18.4846 6.32205 18.6628 6.25013 18.8752 6.25013C19.0879 6.25013 19.266 6.32205 19.4095 6.46588C19.5532 6.60955 19.625 6.78763 19.625 7.00013V9.25013H21.875C22.0875 9.25013 22.2656 9.32205 22.4093 9.46588C22.5531 9.60972 22.625 9.78788 22.625 10.0004C22.625 10.213 22.5531 10.3911 22.4093 10.5346C22.2656 10.6783 22.0875 10.7501 21.875 10.7501H19.625V13.0001C19.625 13.2126 19.5531 13.3907 19.4093 13.5344C19.2654 13.6782 19.0872 13.7501 18.8748 13.7501C18.6621 13.7501 18.484 13.6782 18.3405 13.5344C18.1968 13.3907 18.125 13.2126 18.125 13.0001V10.7501ZM9 11.6924C8.0375 11.6924 7.21358 11.3497 6.52825 10.6644C5.84275 9.97888 5.5 9.15488 5.5 8.19238C5.5 7.22988 5.84275 6.40597 6.52825 5.72063C7.21358 5.03513 8.0375 4.69238 9 4.69238C9.9625 4.69238 10.7864 5.03513 11.4718 5.72063C12.1573 6.40597 12.5 7.22988 12.5 8.19238C12.5 9.15488 12.1573 9.97888 11.4718 10.6644C10.7864 11.3497 9.9625 11.6924 9 11.6924ZM1.5 17.7886V17.0846C1.5 16.595 1.633 16.1415 1.899 15.7241C2.165 15.3068 2.5205 14.986 2.9655 14.7616C3.95383 14.2771 4.95092 13.9137 5.95675 13.6714C6.96258 13.429 7.977 13.3079 9 13.3079C10.023 13.3079 11.0374 13.429 12.0433 13.6714C13.0491 13.9137 14.0462 14.2771 15.0345 14.7616C15.4795 14.986 15.835 15.3068 16.101 15.7241C16.367 16.1415 16.5 16.595 16.5 17.0846V17.7886C16.5 18.2103 16.3523 18.569 16.0568 18.8646C15.7613 19.1601 15.4026 19.3079 14.9808 19.3079H3.01925C2.59742 19.3079 2.23875 19.1601 1.94325 18.8646C1.64775 18.569 1.5 18.2103 1.5 17.7886ZM3 17.8079H15V17.0846C15 16.8821 14.9413 16.6946 14.824 16.5221C14.7067 16.3498 14.5474 16.2091 14.3462 16.1001C13.4846 15.6758 12.6061 15.3543 11.7107 15.1356C10.8153 14.9171 9.91167 14.8079 9 14.8079C8.08833 14.8079 7.18475 14.9171 6.28925 15.1356C5.39392 15.3543 4.51542 15.6758 3.65375 16.1001C3.45258 16.2091 3.29333 16.3498 3.176 16.5221C3.05867 16.6946 3 16.8821 3 17.0846V17.8079ZM9 10.1924C9.55 10.1924 10.0208 9.99655 10.4125 9.60488C10.8042 9.21322 11 8.74238 11 8.19238C11 7.64238 10.8042 7.17155 10.4125 6.77988C10.0208 6.38822 9.55 6.19238 9 6.19238C8.45 6.19238 7.97917 6.38822 7.5875 6.77988C7.19583 7.17155 7 7.64238 7 8.19238C7 8.74238 7.19583 9.21322 7.5875 9.60488C7.97917 9.99655 8.45 10.1924 9 10.1924Z",
  mic: "M12 14.5C13.66 14.5 15 13.16 15 11.5V5.5C15 3.84 13.66 2.5 12 2.5C10.34 2.5 9 3.84 9 5.5V11.5C9 13.16 10.34 14.5 12 14.5ZM11 5.5C11 4.95 11.45 4.5 12 4.5C12.55 4.5 13 4.95 13 5.5V11.5C13 12.05 12.55 12.5 12 12.5C11.45 12.5 11 12.05 11 11.5V5.5ZM17 11.5C17 14.26 14.76 16.5 12 16.5C9.24 16.5 7 14.26 7 11.5H5C5 15.03 7.61 17.93 11 18.42V21.5H13V18.42C16.39 17.93 19 15.03 19 11.5H17Z",
  "mic-fill": "M11.999 14.5C13.659 14.5 14.999 13.16 14.999 11.5V5.5C14.999 3.84 13.659 2.5 11.999 2.5C10.339 2.5 8.99901 3.84 8.99901 5.5V11.5C8.99901 13.16 10.339 14.5 11.999 14.5ZM17.909 11.5C17.419 11.5 17.009 11.86 16.929 12.35C16.519 14.7 14.469 16.5 11.999 16.5C9.52901 16.5 7.47901 14.7 7.06901 12.35C6.98901 11.86 6.57901 11.5 6.08901 11.5C5.47901 11.5 4.99901 12.04 5.08901 12.64C5.57901 15.64 7.97901 17.99 10.999 18.42V20.5C10.999 21.05 11.449 21.5 11.999 21.5C12.549 21.5 12.999 21.05 12.999 20.5V18.42C16.019 17.99 18.419 15.64 18.909 12.64C19.009 12.04 18.519 11.5 17.909 11.5Z",
  "mic-off": "M10.7219 5.38999C10.7219 4.72999 11.2619 4.18999 11.9219 4.18999C12.5819 4.18999 13.1219 4.72999 13.1219 5.38999L13.1119 9.29999L14.9219 11.09V5.48999C14.9219 3.82999 13.5819 2.48999 11.9219 2.48999C10.3819 2.48999 9.13188 3.64999 8.96187 5.13999L10.7219 6.89999V5.38999ZM18.9219 11.49H17.2219C17.2219 12.07 17.1219 12.62 16.9519 13.13L18.2219 14.4C18.6619 13.52 18.9219 12.53 18.9219 11.49ZM4.33187 3.34999L2.92188 4.75999L8.92188 10.76V11.49C8.92188 13.15 10.2619 14.49 11.9219 14.49C12.1519 14.49 12.3619 14.46 12.5719 14.41L14.2319 16.07C13.5219 16.4 12.7319 16.59 11.9219 16.59C9.16187 16.59 6.62187 14.49 6.62187 11.49H4.92188C4.92188 14.9 7.64188 17.72 10.9219 18.21V21.49H12.9219V18.21C13.8319 18.08 14.6919 17.76 15.4719 17.31L19.6719 21.51L21.0819 20.1L4.33187 3.34999Z",
  "mic-off-fill": "M16.5203 13.9018C16.3446 13.8069 16.2282 13.6557 16.171 13.448C16.114 13.2403 16.133 13.0487 16.2278 12.873C16.3253 12.7025 16.4003 12.5211 16.4528 12.3287C16.5055 12.1364 16.5452 11.9416 16.572 11.7443C16.6195 11.5314 16.715 11.3542 16.8585 11.2125C17.0022 11.0708 17.1805 11 17.3933 11C17.6061 11 17.7817 11.0776 17.92 11.2327C18.0585 11.3877 18.1175 11.5717 18.097 11.7845C18.0599 12.0973 17.998 12.4067 17.9115 12.7125C17.825 13.0182 17.7042 13.3088 17.549 13.5845C17.4542 13.7667 17.3045 13.8888 17.1 13.951C16.8955 14.0132 16.7023 13.9968 16.5203 13.9018ZM12.8278 9.7385L9.67029 6.5615C9.50612 6.39733 9.37729 6.20408 9.28379 5.98175C9.19012 5.75925 9.14329 5.5275 9.14329 5.2865V5C9.14329 4.30133 9.38529 3.71 9.86929 3.226C10.3533 2.742 10.9446 2.5 11.6433 2.5C12.342 2.5 12.9333 2.742 13.4173 3.226C13.9013 3.71 14.1433 4.30133 14.1433 5V9.1865C14.1433 9.534 13.9855 9.77442 13.67 9.90775C13.3547 10.0411 13.074 9.98467 12.8278 9.7385ZM10.8933 20V17.4578C9.40479 17.2832 8.12912 16.6704 7.06629 15.6193C6.00346 14.5679 5.38104 13.2865 5.19904 11.775C5.17221 11.5622 5.22796 11.3798 5.36629 11.228C5.50479 11.076 5.68046 11 5.89329 11C6.10612 11 6.28429 11.0734 6.42779 11.2203C6.57146 11.3669 6.66696 11.5467 6.71429 11.7595C6.89646 12.984 7.45646 13.9968 8.39429 14.798C9.33212 15.5993 10.4151 16 11.6433 16C12.2868 16 12.8916 15.8852 13.4578 15.6557C14.0238 15.4262 14.5247 15.1083 14.9605 14.702L16.0298 15.771C15.5465 16.225 14.9965 16.5988 14.3798 16.8923C13.7631 17.1859 13.101 17.3744 12.3933 17.4578V20C12.3933 20.2128 12.3215 20.391 12.1778 20.5345C12.0343 20.6782 11.8561 20.75 11.6433 20.75C11.4305 20.75 11.2522 20.6782 11.1085 20.5345C10.965 20.391 10.8933 20.2128 10.8933 20ZM19.3395 21.1885L2.20479 4.05375C2.06629 3.91525 1.99546 3.74125 1.99229 3.53175C1.98912 3.32208 2.05996 3.14483 2.20479 3C2.34962 2.85517 2.52529 2.78275 2.73179 2.78275C2.93812 2.78275 3.11371 2.85517 3.25854 3L20.3933 20.1345C20.5318 20.273 20.6026 20.4471 20.6058 20.6568C20.609 20.8663 20.5381 21.0435 20.3933 21.1885C20.2485 21.3333 20.0728 21.4058 19.8663 21.4058C19.66 21.4058 19.4844 21.3333 19.3395 21.1885Z",
  "mood-fill": "M15.406 10.8077C15.77 10.8077 16.0786 10.6803 16.3318 10.4255C16.5849 10.1708 16.7115 9.86158 16.7115 9.49775C16.7115 9.13392 16.5842 8.82542 16.3295 8.57225C16.0748 8.31892 15.7655 8.19225 15.4015 8.19225C15.0377 8.19225 14.7292 8.31967 14.476 8.5745C14.2228 8.82917 14.0962 9.13842 14.0962 9.50225C14.0962 9.86608 14.2236 10.1746 14.4783 10.4277C14.7329 10.6811 15.0422 10.8077 15.406 10.8077ZM8.5985 10.8077C8.96233 10.8077 9.27083 10.6803 9.524 10.4255C9.77717 10.1708 9.90375 9.86158 9.90375 9.49775C9.90375 9.13392 9.77642 8.82542 9.52175 8.57225C9.26708 8.31892 8.95783 8.19225 8.594 8.19225C8.23 8.19225 7.92142 8.31967 7.66825 8.5745C7.41508 8.82917 7.2885 9.13842 7.2885 9.50225C7.2885 9.86608 7.41583 10.1746 7.6705 10.4277C7.92517 10.6811 8.2345 10.8077 8.5985 10.8077ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 17.1923C12.8975 17.1923 13.7254 16.9798 14.4837 16.5548C15.2421 16.1298 15.8578 15.5532 16.331 14.825C16.4257 14.643 16.4227 14.46 16.322 14.276C16.2215 14.092 16.0642 14 15.85 14H8.15C7.93583 14 7.7785 14.092 7.678 14.276C7.57733 14.46 7.57433 14.643 7.669 14.825C8.14217 15.5532 8.76183 16.1298 9.528 16.5548C10.294 16.9798 11.118 17.1923 12 17.1923Z",
  more: "M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z",
  "noise-reduction": [
    "M15.6204 16.45C15.9804 15.8 15.4704 15 14.7204 15C14.3804 15 14.0404 15.16 13.8804 15.47C13.7204 15.78 13.3804 16 13.0004 16C12.5704 16 12.1904 15.73 12.0504 15.32C11.9004 14.88 11.6504 14.24 11.1204 13.71L9.76039 12.35C9.28039 11.87 9.00039 11.19 9.00039 10.5C9.00039 9.12 10.1204 8 11.5004 8C12.4804 8 13.3404 8.57 13.7404 9.4C13.9204 9.76 14.2604 10 14.6504 10C15.4004 10 15.8704 9.21 15.5404 8.54C14.8204 7.04 13.2804 6 11.5004 6C8.61038 6 6.35038 8.74 7.17038 11.76C7.39038 12.56 7.85038 13.27 8.44038 13.86L9.71039 15.13C9.86039 15.29 9.99039 15.51 10.1104 15.84C10.5204 16.97 11.4904 17.88 12.6904 18C13.9504 18.11 15.0704 17.46 15.6204 16.45Z",
    "M13.5004 14C14.3288 14 15.0004 13.3284 15.0004 12.5C15.0004 11.6716 14.3288 11 13.5004 11C12.672 11 12.0004 11.6716 12.0004 12.5C12.0004 13.3284 12.672 14 13.5004 14Z",
    "M12.0004 4C12.5527 4 13.0004 3.55228 13.0004 3C13.0004 2.44772 12.5527 2 12.0004 2C11.4481 2 11.0004 2.44772 11.0004 3C11.0004 3.55228 11.4481 4 12.0004 4Z",
    "M12.0004 22C12.5527 22 13.0004 21.5523 13.0004 21C13.0004 20.4477 12.5527 20 12.0004 20C11.4481 20 11.0004 20.4477 11.0004 21C11.0004 21.5523 11.4481 22 12.0004 22Z",
    "M5.75038 7.01C6.09038 6.58 6.02039 5.95 5.59038 5.6C5.16038 5.26 4.53038 5.33 4.18038 5.77C3.84038 6.2 3.91038 6.83 4.34038 7.17C4.77039 7.51 5.40038 7.44 5.75038 7.01Z",
    "M18.2504 16.99C17.9104 17.42 17.9804 18.05 18.4104 18.4C18.8404 18.75 19.4704 18.67 19.8204 18.24C20.1604 17.81 20.0904 17.18 19.6604 16.83C19.2304 16.49 18.6004 16.56 18.2504 16.99Z",
    "M4.20038 13.78C4.08038 13.24 3.54038 12.9 3.00038 13.03C2.46038 13.16 2.12038 13.69 2.25038 14.23C2.37038 14.77 2.91038 15.11 3.45038 14.98C3.99038 14.86 4.32038 14.32 4.20038 13.78Z",
    "M19.8004 10.22C19.9204 10.76 20.4604 11.1 21.0004 10.97C21.5404 10.84 21.8804 10.31 21.7504 9.77C21.6204 9.23 21.0904 8.89 20.5504 9.02C20.0104 9.14 19.6804 9.68 19.8004 10.22Z",
    "M8.53038 19.21C8.03038 18.97 7.43038 19.18 7.20038 19.68C6.96038 20.18 7.17038 20.78 7.67038 21.01C8.17038 21.25 8.77038 21.04 9.00038 20.54C9.24038 20.05 9.03038 19.45 8.53038 19.21Z",
    "M15.4704 4.79C15.9704 5.03 16.5704 4.82 16.8004 4.32C17.0404 3.82 16.8304 3.22 16.3304 2.99C15.8304 2.75 15.2304 2.96 15.0004 3.46C14.7604 3.95 14.9704 4.55 15.4704 4.79Z",
    "M15.4704 19.21C14.9704 19.45 14.7604 20.05 15.0004 20.54C15.2404 21.03 15.8404 21.25 16.3304 21.01C16.8304 20.77 17.0404 20.17 16.8004 19.68C16.5704 19.18 15.9704 18.97 15.4704 19.21Z",
    "M8.53038 4.79C9.03038 4.55 9.23038 3.96 9.00038 3.46C8.76039 2.96 8.16039 2.75 7.67038 2.99C7.18038 3.23 6.95039 3.83 7.19038 4.33C7.43038 4.83 8.03038 5.03 8.53038 4.79Z",
    "M21.0004 13.03C20.4604 12.91 19.9304 13.24 19.8004 13.78C19.6804 14.32 20.0104 14.85 20.5504 14.98C21.0904 15.1 21.6204 14.77 21.7504 14.23C21.8704 13.69 21.5404 13.15 21.0004 13.03Z",
    "M3.00038 10.97C3.54038 11.09 4.07038 10.76 4.20038 10.22C4.32038 9.68 3.99038 9.15 3.45038 9.02C2.91038 8.89 2.38038 9.23 2.25038 9.77C2.13038 10.31 2.46038 10.85 3.00038 10.97Z",
    "M19.6604 7.17C20.0904 6.83 20.1604 6.2 19.8204 5.76C19.4804 5.32 18.8504 5.26 18.4104 5.6C17.9804 5.94 17.9104 6.57 18.2504 7.01C18.6004 7.44 19.2304 7.51 19.6604 7.17Z",
    "M4.34038 16.83C3.91038 17.17 3.84038 17.8 4.18038 18.24C4.52038 18.67 5.15038 18.74 5.59038 18.4C6.02039 18.06 6.09038 17.43 5.75038 16.99C5.41038 16.55 4.77039 16.49 4.34038 16.83Z"
  ],
  participants: "M1.79688 17.0837C1.79688 16.5683 1.92987 16.1084 2.19588 15.7039C2.46188 15.2994 2.81713 14.9847 3.26163 14.7599C4.21196 14.2951 5.16754 13.9367 6.12838 13.6847C7.08938 13.4328 8.14546 13.3069 9.29663 13.3069C10.448 13.3069 11.504 13.4328 12.4649 13.6847C13.4259 13.9367 14.3815 14.2951 15.3319 14.7599C15.7764 14.9847 16.1316 15.2994 16.3976 15.7039C16.6636 16.1084 16.7966 16.5683 16.7966 17.0837V17.7877C16.7966 18.1902 16.6489 18.544 16.3534 18.8492C16.0579 19.1543 15.6992 19.3069 15.2774 19.3069H3.31588C2.89421 19.3069 2.53563 19.1592 2.24013 18.8637C1.94463 18.568 1.79688 18.2093 1.79688 17.7877V17.0837ZM18.4101 19.3069C18.5358 19.0774 18.6316 18.8332 18.6976 18.5742C18.7636 18.3152 18.7966 18.053 18.7966 17.7877V16.9607C18.7966 16.3043 18.636 15.6787 18.3146 15.0839C17.9931 14.4892 17.5371 13.979 16.9466 13.5532C17.6171 13.6532 18.2537 13.8079 18.8564 14.0174C19.4589 14.2271 20.0339 14.4748 20.5814 14.7607C21.098 15.0363 21.497 15.3612 21.7784 15.7354C22.0597 16.1094 22.2004 16.5178 22.2004 16.9607V17.7877C22.2004 18.2093 22.0526 18.568 21.7571 18.8637C21.4616 19.1592 21.103 19.3069 20.6814 19.3069H18.4101ZM9.29663 11.6914C8.33413 11.6914 7.51021 11.3487 6.82488 10.6634C6.13954 9.97791 5.79688 9.15391 5.79688 8.19141C5.79688 7.22891 6.13954 6.40499 6.82488 5.71966C7.51021 5.03416 8.33413 4.69141 9.29663 4.69141C10.2591 4.69141 11.0831 5.03416 11.7686 5.71966C12.454 6.40499 12.7966 7.22891 12.7966 8.19141C12.7966 9.15391 12.454 9.97791 11.7686 10.6634C11.0831 11.3487 10.2591 11.6914 9.29663 11.6914ZM17.9311 8.19141C17.9311 9.15391 17.5885 9.97791 16.9031 10.6634C16.2178 11.3487 15.3939 11.6914 14.4314 11.6914C14.3185 11.6914 14.175 11.6786 14.0006 11.6529C13.8261 11.6272 13.6825 11.5991 13.5699 11.5684C13.9642 11.0942 14.2673 10.5682 14.4791 9.99041C14.6908 9.41257 14.7966 8.81257 14.7966 8.19041C14.7966 7.56807 14.6886 6.97032 14.4726 6.39716C14.2566 5.82416 13.9557 5.29666 13.5699 4.81466C13.7134 4.76332 13.857 4.72999 14.0006 4.71466C14.1441 4.69916 14.2877 4.69141 14.4314 4.69141C15.3939 4.69141 16.2178 5.03416 16.9031 5.71966C17.5885 6.40499 17.9311 7.22891 17.9311 8.19141Z",
  pin: "M15.4994 5.6V12.8115L17.0647 14.377C17.139 14.4513 17.1949 14.535 17.2322 14.628C17.2694 14.7208 17.2879 14.8168 17.2879 14.916V15.3435C17.2879 15.5542 17.2151 15.7329 17.0694 15.8797C16.9239 16.0266 16.7435 16.1 16.5282 16.1H12.7494V21.4885C12.7494 21.701 12.6775 21.8791 12.5337 22.0227C12.3899 22.1664 12.2117 22.2382 11.9992 22.2382C11.7865 22.2382 11.6084 22.1664 11.4649 22.0227C11.3213 21.8791 11.2494 21.701 11.2494 21.4885V16.1H7.47069C7.25535 16.1 7.07494 16.0266 6.92944 15.8797C6.78377 15.7329 6.71094 15.5542 6.71094 15.3435V14.916C6.71094 14.8168 6.72952 14.7208 6.76669 14.628C6.80402 14.535 6.85985 14.4513 6.93419 14.377L8.49944 12.8115V5.6H8.24944C8.03694 5.6 7.85885 5.52808 7.71519 5.38425C7.57135 5.24041 7.49944 5.06225 7.49944 4.84975C7.49944 4.63708 7.57135 4.459 7.71519 4.3155C7.85885 4.17183 8.03694 4.1 8.24944 4.1H15.7494C15.9619 4.1 16.14 4.17192 16.2837 4.31575C16.4275 4.45958 16.4994 4.63775 16.4994 4.85025C16.4994 5.06292 16.4275 5.241 16.2837 5.3845C16.14 5.52817 15.9619 5.6 15.7494 5.6H15.4994Z",
  "raise-hand": "M18.37 23.9949H11.82C10.74 23.9949 9.68 23.5449 8.93 22.7649L1.63 15.1549L3.7 13.3249C4.32 12.7749 5.23 12.6649 5.96 13.0549L8.37 14.3349V4.78488C8.37 3.40488 9.49 2.28488 10.87 2.28488C11.04 2.28488 11.21 2.30488 11.38 2.33488C11.47 1.03488 12.55 0.00488281 13.87 0.00488281C14.73 0.00488281 15.48 0.434883 15.93 1.09488C16.22 0.974883 16.54 0.914883 16.87 0.914883C18.25 0.914883 19.37 2.03488 19.37 3.41488V3.69488C19.53 3.66488 19.7 3.64488 19.87 3.64488C21.25 3.64488 22.37 4.76488 22.37 6.14488V19.9949C22.37 22.2049 20.58 23.9949 18.37 23.9949ZM4.51 15.2749L10.37 21.3749C10.75 21.7649 11.27 21.9949 11.81 21.9949H18.37C19.47 21.9949 20.37 21.0949 20.37 19.9949V6.14488C20.37 5.86488 20.15 5.64488 19.87 5.64488C19.59 5.64488 19.37 5.86488 19.37 6.14488V11.9949H17.37V3.41488C17.37 3.13488 17.15 2.91488 16.87 2.91488C16.59 2.91488 16.37 3.13488 16.37 3.41488V11.9949H14.37V2.50488C14.37 2.22488 14.15 2.00488 13.87 2.00488C13.59 2.00488 13.37 2.22488 13.37 2.50488V11.9949H11.37V4.78488C11.37 4.50488 11.15 4.28488 10.87 4.28488C10.59 4.28488 10.37 4.51488 10.37 4.78488V17.6549L5.02 14.8249L4.51 15.2749Z",
  "raise-hand-fill": "M21.1818 4C20.3518 4 19.6818 4.67 19.6818 5.5V10.5C19.6818 10.78 19.4618 11 19.1818 11C18.9018 11 18.6818 10.78 18.6818 10.5V2.5C18.6818 1.67 18.0118 1 17.1818 1C16.3518 1 15.6818 1.67 15.6818 2.5V10.5C15.6818 10.78 15.4618 11 15.1818 11C14.9018 11 14.6818 10.78 14.6818 10.5V1.5C14.6818 0.67 14.0118 0 13.1818 0C12.3518 0 11.6818 0.67 11.6818 1.5V10.49C11.6818 10.77 11.4618 10.99 11.1818 10.99C10.9018 10.99 10.6818 10.77 10.6818 10.49V4.5C10.6818 3.67 10.0118 3 9.18176 3C8.35176 3 7.68176 3.67 7.68176 4.5V15.91L3.56176 13.56C2.98176 13.23 2.26176 13.32 1.78176 13.78C1.18176 14.36 1.16176 15.32 1.75176 15.91L8.53176 22.8C9.28176 23.57 10.3018 24 11.3818 24H18.6818C20.8918 24 22.6818 22.21 22.6818 20V5.5C22.6818 4.67 22.0118 4 21.1818 4Z",
  "record-fill": "M12 16.5C13.2487 16.5 14.3108 16.0622 15.1865 15.1865C16.0622 14.3108 16.5 13.2487 16.5 12C16.5 10.7513 16.0622 9.68917 15.1865 8.8135C14.3108 7.93783 13.2487 7.5 12 7.5C10.7513 7.5 9.68917 7.93783 8.8135 8.8135C7.93783 9.68917 7.5 10.7513 7.5 12C7.5 13.2487 7.93783 14.3108 8.8135 15.1865C9.68917 16.0622 10.7513 16.5 12 16.5ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
  "record-stop-fill": "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15 16H9C8.45 16 8 15.55 8 15V9C8 8.45 8.45 8 9 8H15C15.55 8 16 8.45 16 9V15C16 15.55 15.55 16 15 16Z",
  recording: [
    "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
  ],
  remove: "M12.0022 21.8335C10.6404 21.8335 9.36222 21.5752 8.16772 21.0587C6.97322 20.5421 5.9323 19.8407 5.04497 18.9545C4.15747 18.0683 3.45605 17.0284 2.94072 15.8347C2.42555 14.6409 2.16797 13.3631 2.16797 12.0012C2.16797 10.6394 2.42622 9.36124 2.94272 8.16674C3.45939 6.97224 4.1608 5.93133 5.04697 5.04399C5.93314 4.15649 6.97305 3.45508 8.16672 2.93974C9.36055 2.42458 10.6384 2.16699 12.0002 2.16699C13.3621 2.16699 14.6402 2.42524 15.8347 2.94174C17.0292 3.45841 18.0701 4.15983 18.9575 5.04599C19.845 5.93216 20.5464 6.97208 21.0617 8.16574C21.5769 9.35958 21.8345 10.6374 21.8345 11.9992C21.8345 13.3611 21.5762 14.6392 21.0597 15.8337C20.5431 17.0282 19.8416 18.0692 18.9555 18.9565C18.0693 19.844 17.0294 20.5454 15.8357 21.0607C14.6419 21.5759 13.3641 21.8335 12.0022 21.8335ZM12.0012 20.2502C12.9807 20.2502 13.9197 20.0877 14.8182 19.7627C15.7169 19.4377 16.5335 18.9669 17.268 18.3502L5.65472 6.73349C5.04689 7.47799 4.57764 8.29791 4.24697 9.19324C3.91647 10.0886 3.75122 11.0242 3.75122 12.0002C3.75122 14.3016 4.55089 16.2519 6.15022 17.8512C7.74955 19.4506 9.69989 20.2502 12.0012 20.2502ZM18.3312 17.267C18.9279 16.5337 19.3971 15.7175 19.7387 14.8185C20.0804 13.9195 20.2512 12.9801 20.2512 12.0002C20.2512 9.69891 19.4516 7.74858 17.8522 6.14924C16.2529 4.54991 14.3026 3.75024 12.0012 3.75024C11.0257 3.75024 10.0905 3.91549 9.19547 4.24599C8.30047 4.57666 7.48014 5.05033 6.73447 5.66699L18.3312 17.267Z",
  "screen-share": "M11.1348 10.8075H13.1348V11.919C13.1348 12.0228 13.1799 12.094 13.2703 12.1325C13.3606 12.1708 13.4443 12.1516 13.5213 12.0747L15.2173 10.3785C15.3109 10.285 15.3578 10.178 15.3578 10.0575C15.3578 9.93697 15.3109 9.82989 15.2173 9.73622L13.5213 8.04022C13.4443 7.96322 13.3606 7.94397 13.2703 7.98247C13.1799 8.02097 13.1348 8.09214 13.1348 8.19597V9.30747H11.1348C10.3719 9.30747 9.72285 9.57505 9.18752 10.1102C8.65235 10.6456 8.38477 11.2946 8.38477 12.0575V13.3075C8.38477 13.5203 8.45652 13.6985 8.60002 13.842C8.74368 13.9856 8.92193 14.0575 9.13477 14.0575C9.34743 14.0575 9.5256 13.9856 9.66927 13.842C9.81277 13.6985 9.88452 13.5203 9.88452 13.3075V12.0575C9.88452 11.71 10.006 11.4147 10.249 11.1717C10.492 10.9289 10.7873 10.8075 11.1348 10.8075ZM2.13477 20.2305C1.92193 20.2305 1.74368 20.1586 1.60002 20.015C1.45652 19.8715 1.38477 19.6933 1.38477 19.4805C1.38477 19.2676 1.45652 19.0895 1.60002 18.946C1.74368 18.8023 1.92193 18.7305 2.13477 18.7305H21.8653C22.0781 18.7305 22.2563 18.8023 22.4 18.946C22.5435 19.0895 22.6153 19.2676 22.6153 19.4805C22.6153 19.6933 22.5435 19.8715 22.4 20.015C22.2563 20.1586 22.0781 20.2305 21.8653 20.2305H2.13477ZM4.30777 17.7305C3.8026 17.7305 3.37502 17.5555 3.02502 17.2055C2.67502 16.8555 2.50002 16.4279 2.50002 15.9227V5.53822C2.50002 5.03305 2.67502 4.60547 3.02502 4.25547C3.37502 3.90547 3.8026 3.73047 4.30777 3.73047H19.6923C20.1974 3.73047 20.625 3.90547 20.975 4.25547C21.325 4.60547 21.5 5.03305 21.5 5.53822V15.9227C21.5 16.4279 21.325 16.8555 20.975 17.2055C20.625 17.5555 20.1974 17.7305 19.6923 17.7305H4.30777Z",
  "screen-share-stop": "M23 17.8602H21.8L23.59 19.6502C23.83 19.4702 24 19.1902 24 18.8602C24 18.3102 23.55 17.8602 23 17.8602ZM3.23 2.14016C2.84 1.75016 2.2 1.75016 1.81 2.14016C1.42 2.53016 1.42 3.16016 1.81 3.55016L2.65 4.41016C2.65 4.41016 1.99 4.98016 1.99 5.88016C2 6.78016 2 15.8602 2 15.8602L2.01 15.8702C2.01 16.9602 2.89 17.8502 3.98 17.8602H1C0.45 17.8602 0 18.3102 0 18.8602C0 19.4102 0.45 19.8602 1 19.8602H18.13L20.13 21.8602C20.52 22.2502 21.15 22.2502 21.54 21.8602C21.93 21.4702 21.93 20.8402 21.54 20.4502L3.23 2.14016ZM7 14.8602C7.31 13.3802 7.94 11.9302 9.08 10.8102L10.67 12.4002C9.13 12.7802 7.96 13.5702 7 14.8602ZM13 8.99016V8.01016C13 7.57016 13.52 7.35016 13.84 7.64016L15 8.73016L16.61 10.2302C16.82 10.4302 16.82 10.7602 16.61 10.9602L15.72 11.7902L21.3 17.3702C21.73 17.0002 22 16.4702 22 15.8602V5.86016C22 4.77016 21.11 3.88016 20.02 3.88016H7.8L12.94 9.01016C12.96 9.00016 12.98 8.99016 13 8.99016Z",
  search: "M9.50244 15.7502C7.7266 15.7502 6.22369 15.1352 4.99369 13.9052C3.76352 12.675 3.14844 11.1847 3.14844 9.43419C3.14844 7.68369 3.76194 6.19319 4.98894 4.96269C6.21594 3.73219 7.70902 3.11694 9.46819 3.11694C11.2274 3.11694 12.7194 3.73228 13.9444 4.96294C15.1694 6.19361 15.7819 7.68553 15.7819 9.43869C15.7819 10.1464 15.6666 10.8287 15.4359 11.4857C15.2054 12.1425 14.8721 12.7474 14.4359 13.3002L20.3014 19.1204C20.4551 19.2743 20.5319 19.4635 20.5319 19.6882C20.5319 19.9129 20.4528 20.1058 20.2944 20.2669C20.1361 20.4279 19.9432 20.5084 19.7157 20.5084C19.4882 20.5084 19.3002 20.429 19.1517 20.2702L13.3067 14.4209C12.8124 14.8488 12.2363 15.1773 11.5784 15.4064C10.9204 15.6356 10.2284 15.7502 9.50244 15.7502ZM9.48194 14.1669C10.7929 14.1669 11.9068 13.7062 12.8234 12.7847C13.7401 11.8632 14.1984 10.7458 14.1984 9.43244C14.1984 8.11928 13.7401 7.00228 12.8234 6.08144C11.9068 5.16061 10.7915 4.70019 9.47769 4.70019C8.15452 4.70019 7.03277 5.16094 6.11244 6.08244C5.1921 7.00394 4.73194 8.12128 4.73194 9.43444C4.73194 10.7478 5.19235 11.8649 6.11319 12.7857C7.03402 13.7065 8.15694 14.1669 9.48194 14.1669Z",
  settings: "M19.5006 12C19.5006 11.77 19.4906 11.55 19.4706 11.32L21.3306 9.91C21.7306 9.61 21.8406 9.05 21.5906 8.61L19.7206 5.38C19.4706 4.94 18.9306 4.76 18.4706 4.96L16.3206 5.87C15.9506 5.61 15.5606 5.38 15.1506 5.19L14.8606 2.88C14.8006 2.38 14.3706 2 13.8706 2H10.1406C9.63064 2 9.20064 2.38 9.14064 2.88L8.85064 5.19C8.44064 5.38 8.05064 5.61 7.68064 5.87L5.53064 4.96C5.07064 4.76 4.53064 4.94 4.28064 5.38L2.41064 8.62C2.16064 9.06 2.27064 9.61 2.67064 9.92L4.53064 11.33C4.51064 11.55 4.50064 11.77 4.50064 12C4.50064 12.23 4.51064 12.45 4.53064 12.68L2.67064 14.09C2.27064 14.39 2.16064 14.95 2.41064 15.39L4.28064 18.62C4.53064 19.06 5.07064 19.24 5.53064 19.04L7.68064 18.13C8.05064 18.39 8.44064 18.62 8.85064 18.81L9.14064 21.12C9.20064 21.62 9.63064 22 10.1306 22H13.8606C14.3606 22 14.7906 21.62 14.8506 21.12L15.1406 18.81C15.5506 18.62 15.9406 18.39 16.3106 18.13L18.4606 19.04C18.9206 19.24 19.4606 19.06 19.7106 18.62L21.5806 15.39C21.8306 14.95 21.7206 14.4 21.3206 14.09L19.4606 12.68C19.4906 12.45 19.5006 12.23 19.5006 12ZM12.0406 15.5C10.1106 15.5 8.54064 13.93 8.54064 12C8.54064 10.07 10.1106 8.5 12.0406 8.5C13.9706 8.5 15.5406 10.07 15.5406 12C15.5406 13.93 13.9706 15.5 12.0406 15.5Z",
  sidebar: "M15 20H3C2.45 20 2 19.55 2 19V5C2 4.45 2.45 4 3 4H15C15.55 4 16 4.45 16 5V19C16 19.55 15.55 20 15 20ZM19 8H21C21.55 8 22 7.55 22 7V5C22 4.45 21.55 4 21 4H19C18.45 4 18 4.45 18 5V7C18 7.55 18.45 8 19 8ZM19 20H21C21.55 20 22 19.55 22 19V17C22 16.45 21.55 16 21 16H19C18.45 16 18 16.45 18 17V19C18 19.55 18.45 20 19 20ZM19 14H21C21.55 14 22 13.55 22 13V11C22 10.45 21.55 10 21 10H19C18.45 10 18 10.45 18 11V13C18 13.55 18.45 14 19 14Z",
  signal: "M18 4C18.83 4 19.5 4.67 19.5 5.5V18.5C19.5 19.33 18.83 20 18 20C17.17 20 16.5 19.33 16.5 18.5V5.5C16.5 4.67 17.17 4 18 4ZM6 14C6.83 14 7.5 14.67 7.5 15.5V18.5C7.5 19.33 6.83 20 6 20C5.17 20 4.5 19.33 4.5 18.5V15.5C4.5 14.67 5.17 14 6 14ZM12 9C12.83 9 13.5 9.67 13.5 10.5V18.5C13.5 19.33 12.83 20 12 20C11.17 20 10.5 19.33 10.5 18.5V10.5C10.5 9.67 11.17 9 12 9Z",
  "speaker-fill": "M3 10.002V14.002C3 14.552 3.45 15.002 4 15.002H7L10.29 18.292C10.92 18.922 12 18.472 12 17.582V6.41204C12 5.52204 10.92 5.07204 10.29 5.70204L7 9.00204H4C3.45 9.00204 3 9.45204 3 10.002ZM16.5 12.002C16.5 10.232 15.48 8.71204 14 7.97204V16.022C15.48 15.292 16.5 13.772 16.5 12.002ZM14 4.45204V4.65204C14 5.03204 14.25 5.36204 14.6 5.50204C17.18 6.53204 19 9.06204 19 12.002C19 14.942 17.18 17.472 14.6 18.502C14.24 18.642 14 18.972 14 19.352V19.552C14 20.182 14.63 20.622 15.21 20.402C18.6 19.112 21 15.842 21 12.002C21 8.16204 18.6 4.89204 15.21 3.60204C14.63 3.37204 14 3.82204 14 4.45204Z",
  spotlight: "M2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6Z",
  stats: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM8 17C7.45 17 7 16.55 7 16V11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11V16C9 16.55 8.55 17 8 17ZM12 17C11.45 17 11 16.55 11 16V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V16C13 16.55 12.55 17 12 17ZM16 17C15.45 17 15 16.55 15 16V14C15 13.45 15.45 13 16 13C16.55 13 17 13.45 17 14V16C17 16.55 16.55 17 16 17Z",
  streaming: [
    "M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z",
    "M7.5 8C6.5 9 6 10.5 6 12C6 13.5 6.5 15 7.5 16C7.1 16.4 6.6 16.4 6.2 16C4.9 14.7 4.2 13.4 4.2 12C4.2 10.6 4.9 9.3 6.2 8C6.6 7.6 7.1 7.6 7.5 8ZM4.5 6C3.1 7.5 2 9.5 2 12C2 14.5 3.1 16.5 4.5 18C4.1 18.4 3.6 18.4 3.2 18C1.5 16.2 0.5 14.2 0.5 12C0.5 9.8 1.5 7.8 3.2 6C3.6 5.6 4.1 5.6 4.5 6ZM16.5 8C17.5 9 18 10.5 18 12C18 13.5 17.5 15 16.5 16C16.9 16.4 17.4 16.4 17.8 16C19.1 14.7 19.8 13.4 19.8 12C19.8 10.6 19.1 9.3 17.8 8C17.4 7.6 16.9 7.6 16.5 8ZM19.5 6C20.9 7.5 22 9.5 22 12C22 14.5 20.9 16.5 19.5 18C19.9 18.4 20.4 18.4 20.8 18C22.5 16.2 23.5 14.2 23.5 12C23.5 9.8 22.5 7.8 20.8 6C20.4 5.6 19.9 5.6 19.5 6Z"
  ],
  "streaming-stop": [
    "M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z",
    "M7.5 8C6.5 9 6 10.5 6 12C6 13.5 6.5 15 7.5 16C7.1 16.4 6.6 16.4 6.2 16C4.9 14.7 4.2 13.4 4.2 12C4.2 10.6 4.9 9.3 6.2 8C6.6 7.6 7.1 7.6 7.5 8ZM4.5 6C3.1 7.5 2 9.5 2 12C2 14.5 3.1 16.5 4.5 18C4.1 18.4 3.6 18.4 3.2 18C1.5 16.2 0.5 14.2 0.5 12C0.5 9.8 1.5 7.8 3.2 6C3.6 5.6 4.1 5.6 4.5 6ZM16.5 8C17.5 9 18 10.5 18 12C18 13.5 17.5 15 16.5 16C16.9 16.4 17.4 16.4 17.8 16C19.1 14.7 19.8 13.4 19.8 12C19.8 10.6 19.1 9.3 17.8 8C17.4 7.6 16.9 7.6 16.5 8ZM19.5 6C20.9 7.5 22 9.5 22 12C22 14.5 20.9 16.5 19.5 18C19.9 18.4 20.4 18.4 20.8 18C22.5 16.2 23.5 14.2 23.5 12C23.5 9.8 22.5 7.8 20.8 6C20.4 5.6 19.9 5.6 19.5 6Z",
    "M3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L3.70711 2.29289Z"
  ],
  "switch-camera": "M4.30775 20.5C3.80258 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V7.30775C2.5 6.80258 2.675 6.375 3.025 6.025C3.375 5.675 3.80258 5.5 4.30775 5.5H7.3615L8.66925 4.08275C8.83342 3.90192 9.03183 3.75958 9.2645 3.65575C9.49717 3.55192 9.74233 3.5 10 3.5H14C14.2577 3.5 14.5028 3.55192 14.7355 3.65575C14.9682 3.75958 15.1666 3.90192 15.3307 4.08275L16.6385 5.5H19.6923C20.1974 5.5 20.625 5.675 20.975 6.025C21.325 6.375 21.5 6.80258 21.5 7.30775V18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5H4.30775ZM15.6038 13.0345C15.5166 14.0333 15.1384 14.8863 14.4693 15.5933C13.8001 16.3003 12.977 16.6538 12 16.6538C11.8603 16.6538 11.7206 16.6438 11.5808 16.624C11.4411 16.6042 11.3013 16.5776 11.1615 16.5443C11.041 16.5173 10.9153 16.5204 10.7845 16.5538C10.6538 16.5871 10.5513 16.6506 10.477 16.7443C10.3513 16.8891 10.3119 17.057 10.3588 17.248C10.4054 17.439 10.5166 17.5666 10.6923 17.6308C10.9064 17.7141 11.1228 17.7708 11.3413 17.801C11.5599 17.8312 11.7795 17.8463 12 17.8463C13.3167 17.8463 14.4292 17.3748 15.3375 16.4318C16.2458 15.4888 16.7321 14.3461 16.7962 13.0038L17.2807 13.4443C17.4051 13.5519 17.5464 13.6042 17.7048 13.601C17.8631 13.5978 17.9961 13.5423 18.1038 13.4345C18.2281 13.3102 18.2928 13.1679 18.298 13.0078C18.3032 12.8474 18.2436 12.7051 18.1193 12.5808L16.8828 11.3443C16.7123 11.1738 16.5013 11.0885 16.25 11.0885C15.9987 11.0885 15.7878 11.1738 15.6173 11.3443L14.3807 12.5808C14.2564 12.7051 14.1943 12.8448 14.1943 13C14.1943 13.1552 14.2564 13.2949 14.3807 13.4193C14.5051 13.5436 14.6448 13.6058 14.8 13.6058C14.9552 13.6058 15.0949 13.5436 15.2193 13.4193L15.6038 13.0345ZM7.20375 12.9963L6.71925 12.5558C6.59492 12.4481 6.45358 12.3958 6.29525 12.399C6.13692 12.4022 6.00392 12.4577 5.89625 12.5655C5.77192 12.6898 5.70717 12.8321 5.702 12.9923C5.69683 13.1526 5.75642 13.2949 5.88075 13.4193L7.11725 14.6558C7.28775 14.8263 7.49867 14.9115 7.75 14.9115C8.00133 14.9115 8.21225 14.8263 8.38275 14.6558L9.61925 13.4193C9.74358 13.2949 9.80575 13.1552 9.80575 13C9.80575 12.8448 9.74358 12.7051 9.61925 12.5808C9.49492 12.4564 9.35517 12.3943 9.2 12.3943C9.04483 12.3943 8.90508 12.4564 8.78075 12.5808L8.39625 12.9655C8.48342 11.9667 8.86158 11.1138 9.53075 10.4068C10.1999 9.69975 11.023 9.34625 12 9.34625C12.1397 9.34625 12.2794 9.35617 12.4192 9.376C12.5589 9.39583 12.6954 9.42242 12.8288 9.45575C12.9493 9.48908 13.0765 9.48908 13.2105 9.45575C13.3445 9.42242 13.4487 9.35575 13.523 9.25575C13.6487 9.11092 13.6897 8.943 13.6462 8.752C13.6026 8.561 13.4929 8.43342 13.3173 8.36925C13.0968 8.29875 12.8788 8.24525 12.6635 8.20875C12.4482 8.17208 12.227 8.15375 12 8.15375C10.6833 8.15375 9.57083 8.62525 8.6625 9.56825C7.75417 10.5113 7.26792 11.6539 7.20375 12.9963Z",
  "tile-fill": "M5 11C4.591 11 4.23875 10.8523 3.94325 10.5568C3.64775 10.2613 3.5 9.909 3.5 9.5V5C3.5 4.591 3.64775 4.23875 3.94325 3.94325C4.23875 3.64775 4.591 3.5 5 3.5H9.5C9.909 3.5 10.2613 3.64775 10.5568 3.94325C10.8523 4.23875 11 4.591 11 5V9.5C11 9.909 10.8523 10.2613 10.5568 10.5568C10.2613 10.8523 9.909 11 9.5 11H5ZM5 20.5C4.591 20.5 4.23875 20.3523 3.94325 20.0568C3.64775 19.7613 3.5 19.409 3.5 19V14.5C3.5 14.091 3.64775 13.7388 3.94325 13.4433C4.23875 13.1478 4.591 13 5 13H9.5C9.909 13 10.2613 13.1478 10.5568 13.4433C10.8523 13.7388 11 14.091 11 14.5V19C11 19.409 10.8523 19.7613 10.5568 20.0568C10.2613 20.3523 9.909 20.5 9.5 20.5H5ZM14.5 11C14.091 11 13.7388 10.8523 13.4433 10.5568C13.1478 10.2613 13 9.909 13 9.5V5C13 4.591 13.1478 4.23875 13.4433 3.94325C13.7388 3.64775 14.091 3.5 14.5 3.5H19C19.409 3.5 19.7613 3.64775 20.0568 3.94325C20.3523 4.23875 20.5 4.591 20.5 5V9.5C20.5 9.909 20.3523 10.2613 20.0568 10.5568C19.7613 10.8523 19.409 11 19 11H14.5ZM14.5 20.5C14.091 20.5 13.7388 20.3523 13.4433 20.0568C13.1478 19.7613 13 19.409 13 19V14.5C13 14.091 13.1478 13.7388 13.4433 13.4433C13.7388 13.1478 14.091 13 14.5 13H19C19.409 13 19.7613 13.1478 20.0568 13.4433C20.3523 13.7388 20.5 14.091 20.5 14.5V19C20.5 19.409 20.3523 19.7613 20.0568 20.0568C19.7613 20.3523 19.409 20.5 19 20.5H14.5Z",
  "transcription-start": [
    "M9.00195 13.2252C11.2111 13.2252 13.002 11.4343 13.002 9.2252C13.002 7.01606 11.2111 5.2252 9.00195 5.2252C6.79281 5.2252 5.00195 7.01606 5.00195 9.2252C5.00195 11.4343 6.79281 13.2252 9.00195 13.2252Z",
    "M9.00195 15.2252C6.33195 15.2252 1.00195 16.5652 1.00195 19.2252V20.2252C1.00195 20.7752 1.45195 21.2252 2.00195 21.2252H16.002C16.552 21.2252 17.002 20.7752 17.002 20.2252V19.2252C17.002 16.5652 11.672 15.2252 9.00195 15.2252ZM15.472 7.9952C15.792 8.7852 15.792 9.6652 15.472 10.4552C15.282 10.9252 15.362 11.4552 15.722 11.8152L15.752 11.8452C16.332 12.4252 17.322 12.3052 17.702 11.5752C18.462 10.1252 18.462 8.4252 17.682 6.9152C17.302 6.1752 16.302 6.0352 15.712 6.6252L15.702 6.6352C15.362 6.9852 15.282 7.5252 15.472 7.9952ZM19.182 3.1152C18.782 3.5152 18.722 4.1352 19.052 4.5952C21.022 7.3352 21.012 11.0052 19.022 13.8452C18.702 14.2952 18.772 14.9152 19.162 15.3052L19.192 15.3352C19.682 15.8252 20.512 15.7852 20.932 15.2352C23.682 11.6952 23.692 6.8652 20.932 3.2152C20.512 2.6652 19.672 2.6252 19.182 3.1152Z"
  ],
  "transcription-stop": "M15.72 6.63575C15.37 6.98575 15.28 7.51575 15.47 7.98575C15.77 8.73575 15.79 9.56575 15.52 10.3258C15.36 10.7858 15.46 11.3058 15.81 11.6458C16.41 12.2458 17.47 12.1158 17.83 11.3358C18.47 9.94575 18.43 8.34575 17.71 6.92575C17.31 6.17575 16.3 6.04575 15.72 6.63575ZM19.18 3.11575C18.78 3.51575 18.72 4.13575 19.05 4.59575C20.98 7.27575 21 10.8458 19.14 13.6658C18.83 14.1258 18.91 14.7458 19.3 15.1358C19.81 15.6458 20.68 15.5958 21.11 15.0058C23.68 11.4958 23.63 6.80575 20.94 3.23575C20.51 2.67575 19.68 2.61575 19.18 3.11575ZM9.43 5.26575L12.96 8.79575C12.76 6.93575 11.29 5.46575 9.43 5.26575ZM3.71 3.78575C3.32 4.17575 3.32 4.80575 3.71 5.19575L5.62 7.10575C5.06 7.99575 4.83 9.11575 5.15 10.3058C5.51 11.6358 6.59 12.7058 7.92 13.0758C9.11 13.4058 10.23 13.1658 11.12 12.6058L15.52 17.0058C13.74 15.8258 10.78 15.2258 9 15.2258C6.33 15.2258 1 16.5658 1 19.2258V20.2258C1 20.7758 1.45 21.2258 2 21.2258H16C16.55 21.2258 17 20.7758 17 20.2258V19.2258C17 18.8558 16.89 18.5258 16.71 18.2058L19.02 20.5158C19.41 20.9058 20.04 20.9058 20.43 20.5158C20.82 20.1258 20.82 19.4958 20.43 19.1058L5.12 3.78575C4.73 3.39575 4.1 3.39575 3.71 3.78575Z",
  unpin: "M14.1851 11.3595L7.56988 4.74425C7.49172 4.66608 7.43655 4.58658 7.40438 4.50575C7.37238 4.42508 7.35638 4.33791 7.35638 4.24425C7.35638 4.05458 7.42022 3.88308 7.54788 3.72975C7.67538 3.57658 7.8513 3.5 8.07563 3.5H15.7506C15.9631 3.5 16.1412 3.57216 16.2849 3.7165C16.4287 3.86066 16.5006 4.03941 16.5006 4.25275C16.5006 4.45341 16.4135 4.59991 16.2391 4.69225C16.0648 4.78458 15.902 4.88716 15.7506 5H15.5006V10.8077C15.5006 11.1531 15.343 11.3929 15.0276 11.5272C14.7121 11.6616 14.4313 11.6057 14.1851 11.3595ZM11.2506 21V15.5H8.17963C7.81247 15.5 7.51872 15.3717 7.29838 15.1152C7.07822 14.8589 6.96813 14.5731 6.96813 14.2577C6.96813 14.1001 6.99955 13.9438 7.06238 13.789C7.12522 13.6343 7.22647 13.4867 7.36613 13.3462L8.50063 12.2115V10.6385L2.65838 4.76525C2.51988 4.62691 2.44647 4.4555 2.43813 4.251C2.4298 4.0465 2.50388 3.866 2.66038 3.7095C2.80388 3.566 2.97888 3.49425 3.18538 3.49425C3.39172 3.49425 3.5673 3.56666 3.71213 3.7115L19.8891 19.8885C20.0378 20.0372 20.1111 20.2137 20.1091 20.4182C20.1073 20.6227 20.0288 20.8032 19.8736 20.9597C19.7185 21.1032 19.5428 21.1775 19.3466 21.1825C19.1506 21.1877 18.975 21.1127 18.8199 20.9575L13.3621 15.5H12.7506V21C12.7506 21.2125 12.6787 21.3906 12.5349 21.5342C12.391 21.6781 12.2129 21.75 12.0004 21.75C11.7877 21.75 11.6096 21.6781 11.4661 21.5342C11.3225 21.3906 11.2506 21.2125 11.2506 21Z",
  video: "M15 8V16H5V8H15ZM16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6Z",
  "video-fill": "M17.332 10.5V7C17.332 6.45 16.882 6 16.332 6H4.33203C3.78203 6 3.33203 6.45 3.33203 7V17C3.33203 17.55 3.78203 18 4.33203 18H16.332C16.882 18 17.332 17.55 17.332 17V13.5L19.622 15.79C20.252 16.42 21.332 15.97 21.332 15.08V8.91C21.332 8.02 20.252 7.57 19.622 8.2L17.332 10.5Z",
  "video-off": "M9.98969 8.57005L7.98969 6.57005L3.83969 2.43005L2.42969 3.84005L5.15969 6.57005H4.42969C3.87969 6.57005 3.42969 7.02005 3.42969 7.57005V17.5701C3.42969 18.1201 3.87969 18.5701 4.42969 18.5701H16.4297C16.6397 18.5701 16.8197 18.4901 16.9797 18.3901L20.1597 21.5701L21.5697 20.1601L12.7097 11.3001L9.98969 8.57005ZM5.42969 16.5701V8.57005H7.15969L15.1597 16.5701H5.42969ZM15.4297 8.57005V11.1801L21.4297 17.1801V7.07005L17.4297 11.0701V7.57005C17.4297 7.02005 16.9797 6.57005 16.4297 6.57005H10.8197L12.8197 8.57005H15.4297Z",
  "video-off-fill": "M17.768 10.8844L20.514 8.13811C20.6615 7.99061 20.8273 7.95378 21.0113 8.02761C21.1953 8.10128 21.2873 8.24194 21.2873 8.44961V15.5496C21.2873 15.7573 21.1953 15.8979 21.0113 15.9716C20.8273 16.0454 20.6615 16.0086 20.514 15.8611L17.6603 13.0074V13.1804C17.5578 13.4522 17.3523 13.6275 17.044 13.7064C16.7357 13.7852 16.4648 13.7079 16.2315 13.4746L8.79301 6.03611C8.64551 5.88878 8.56092 5.73144 8.53926 5.56411C8.51742 5.39678 8.54176 5.23103 8.61226 5.06686C8.68276 4.90286 8.78659 4.76728 8.92376 4.66011C9.06092 4.55311 9.23334 4.49961 9.44101 4.49961H15.9603C16.4654 4.49961 16.893 4.67461 17.243 5.02461C17.593 5.37461 17.768 5.80219 17.768 6.30736V10.8844ZM19.4448 21.6304L2.06026 4.24586C1.92192 4.10736 1.85109 3.93328 1.84776 3.72361C1.84459 3.51411 1.91542 3.33686 2.06026 3.19186C2.20526 3.04703 2.38092 2.97461 2.58726 2.97461C2.79359 2.97461 2.96926 3.04703 3.11426 3.19186L20.4988 20.5764C20.6373 20.7149 20.7081 20.8889 20.7113 21.0986C20.7144 21.3083 20.6436 21.4855 20.4988 21.6304C20.3539 21.7752 20.1783 21.8476 19.9718 21.8476C19.7654 21.8476 19.5898 21.7752 19.4448 21.6304ZM4.44101 4.51886L17.7488 17.8266C17.7168 18.2933 17.5305 18.6888 17.19 19.0131C16.8497 19.3374 16.4398 19.4996 15.9603 19.4996H4.57576C4.07059 19.4996 3.64301 19.3246 3.29301 18.9746C2.94301 18.6246 2.76801 18.197 2.76801 17.6919V6.30736C2.76801 5.82786 2.93017 5.41794 3.25451 5.07761C3.57884 4.73711 3.97434 4.55086 4.44101 4.51886Z",
  "virtual-background": "M4 5C4 4.45 4.45 4 5 4H10C10.55 4 11 3.55 11 3C11 2.45 10.55 2 10 2H4C2.9 2 2 2.9 2 4V10C2 10.55 2.45 11 3 11C3.55 11 4 10.55 4 10V5ZM9.61 13.49L6.65 17.19C6.39 17.52 6.62 18 7.04 18H17C17.41 18 17.65 17.53 17.4 17.2L15.4 14.53C15.2 14.26 14.8 14.26 14.6 14.53L12.97 16.71L10.39 13.49C10.19 13.24 9.81 13.24 9.61 13.49ZM17 8.5C17 7.67 16.33 7 15.5 7C14.67 7 14 7.67 14 8.5C14 9.33 14.67 10 15.5 10C16.33 10 17 9.33 17 8.5ZM20 2H14C13.45 2 13 2.45 13 3C13 3.55 13.45 4 14 4H19C19.55 4 20 4.45 20 5V10C20 10.55 20.45 11 21 11C21.55 11 22 10.55 22 10V4C22 2.9 21.1 2 20 2ZM20 19C20 19.55 19.55 20 19 20H14C13.45 20 13 20.45 13 21C13 21.55 13.45 22 14 22H20C21.1 22 22 21.1 22 20V14C22 13.45 21.55 13 21 13C20.45 13 20 13.45 20 14V19ZM3 13C2.45 13 2 13.45 2 14V20C2 21.1 2.9 22 4 22H10C10.55 22 11 21.55 11 21C11 20.45 10.55 20 10 20H5C4.45 20 4 19.55 4 19V14C4 13.45 3.55 13 3 13Z",
  wave: "M7.375 16.8077V7.19225C7.375 6.97975 7.44692 6.80167 7.59075 6.658C7.73458 6.51417 7.91275 6.44225 8.12525 6.44225C8.33792 6.44225 8.516 6.51417 8.6595 6.658C8.80317 6.80167 8.875 6.97975 8.875 7.19225V16.8077C8.875 17.0203 8.80308 17.1983 8.65925 17.342C8.51542 17.4858 8.33725 17.5577 8.12475 17.5577C7.91208 17.5577 7.734 17.4858 7.5905 17.342C7.44683 17.1983 7.375 17.0203 7.375 16.8077ZM11.25 20.75V3.25C11.25 3.0375 11.3219 2.85942 11.4658 2.71575C11.6096 2.57192 11.7878 2.5 12.0003 2.5C12.2129 2.5 12.391 2.57192 12.5345 2.71575C12.6782 2.85942 12.75 3.0375 12.75 3.25V20.75C12.75 20.9625 12.6781 21.1406 12.5343 21.2843C12.3904 21.4281 12.2122 21.5 11.9998 21.5C11.7871 21.5 11.609 21.4281 11.4655 21.2843C11.3218 21.1406 11.25 20.9625 11.25 20.75ZM3.5 12.9038V11.0962C3.5 10.8837 3.57192 10.7056 3.71575 10.5617C3.85958 10.4181 4.03775 10.3462 4.25025 10.3462C4.46292 10.3462 4.641 10.4181 4.7845 10.5617C4.92817 10.7056 5 10.8837 5 11.0962V12.9038C5 13.1163 4.92808 13.2944 4.78425 13.4383C4.64042 13.5819 4.46225 13.6538 4.24975 13.6538C4.03708 13.6538 3.859 13.5819 3.7155 13.4383C3.57183 13.2944 3.5 13.1163 3.5 12.9038ZM15.125 16.8077V7.19225C15.125 6.97975 15.1969 6.80167 15.3408 6.658C15.4846 6.51417 15.6628 6.44225 15.8753 6.44225C16.0879 6.44225 16.266 6.51417 16.4095 6.658C16.5532 6.80167 16.625 6.97975 16.625 7.19225V16.8077C16.625 17.0203 16.5531 17.1983 16.4093 17.342C16.2654 17.4858 16.0872 17.5577 15.8748 17.5577C15.6621 17.5577 15.484 17.4858 15.3405 17.342C15.1968 17.1983 15.125 17.0203 15.125 16.8077ZM19 12.9038V11.0962C19 10.8837 19.0719 10.7056 19.2158 10.5617C19.3596 10.4181 19.5378 10.3462 19.7502 10.3462C19.9629 10.3462 20.141 10.4181 20.2845 10.5617C20.4282 10.7056 20.5 10.8837 20.5 11.0962V12.9038C20.5 13.1163 20.4281 13.2944 20.2843 13.4383C20.1404 13.5819 19.9622 13.6538 19.7498 13.6538C19.5371 13.6538 19.359 13.5819 19.2155 13.4383C19.0718 13.2944 19 13.1163 19 12.9038Z"
}, ot = ({
  name: s,
  size: r = 24,
  viewBox: c = "0 0 24 24",
  className: h,
  style: f
}) => {
  const v = typeof QR[s] == "string" ? [QR[s]] : QR[s];
  return /* @__PURE__ */ b.jsx(
    "svg",
    {
      width: r,
      height: r,
      viewBox: c,
      fill: "currentColor",
      className: wt("cometchat-calls-icon", h),
      style: f,
      children: v.map((R, T) => /* @__PURE__ */ b.jsx("path", { d: R }, T))
    }
  );
}, I6 = ne.memo(({ name: s, imageUrl: r, size: c, fontSize: h }) => /* @__PURE__ */ b.jsx(
  "div",
  {
    className: "cometchat-calls-avatar-wrapper",
    style: c ? { width: c, height: c } : {},
    children: r ? /* @__PURE__ */ b.jsx(
      "img",
      {
        src: r,
        alt: s,
        className: "cometchat-calls-avatar-image"
      }
    ) : /* @__PURE__ */ b.jsx(
      "div",
      {
        className: "cometchat-calls-avatar-fallback",
        style: h ? { fontSize: h } : {},
        children: w4(s)
      }
    )
  }
)), wb = ({ videoTrack: s }) => {
  const [r, c] = ne.useState(null);
  return ne.useEffect(() => {
    if (!s) {
      c(null);
      return;
    }
    const h = () => {
      var R, T;
      const v = (T = (R = s == null ? void 0 : s.track) == null ? void 0 : R.getSettings) == null ? void 0 : T.call(R);
      v != null && v.frameRate && c(Math.round(v.frameRate));
    };
    h();
    const f = setInterval(h, 1e3);
    return () => clearInterval(f);
  }, [s]), r === null ? null : /* @__PURE__ */ b.jsxs("span", { className: "cometchat-calls-frame-rate-indicator", children: [
    r,
    " fps"
  ] });
}, KT = ({ ruid: s, closeMenu: r }) => {
  const [c, h] = ne.useState(!1), [f, v] = ne.useState(window.innerWidth < 768), [R, T] = ne.useState("below"), E = ne.useRef(null), C = ne.useRef(null), N = sm().find((ge) => ge.ruid === s), _ = je((ge) => ge.localParticipant), V = dT(
    (N == null ? void 0 : N.pid) ?? "",
    (N == null ? void 0 : N.type) ?? "human"
  ), B = Vu(We.AUDIO, N == null ? void 0 : N.pid);
  ne.useEffect(() => {
    const ge = () => {
      v(window.innerWidth < 768);
    };
    return window.addEventListener("resize", ge), () => window.removeEventListener("resize", ge);
  }, []), ne.useEffect(() => {
    r && c && h(!1);
  }, [r, c]), ne.useEffect(() => {
    const ge = (te) => {
      var _e;
      C.current && !C.current.contains(te.target) && !((_e = E.current) != null && _e.contains(te.target)) && h(!1);
    };
    if (c)
      return document.addEventListener("mousedown", ge), () => document.removeEventListener("mousedown", ge);
  }, [c]);
  const ce = ne.useMemo(() => {
    const ge = [
      {
        label: V ? "Unpin" : "Pin to screen",
        iconName: V ? "unpin" : "pin",
        onPress: () => {
          V ? LU() : N && IU(N.pid, N.type), h(!1);
        }
      }
    ];
    return N && _.role === "moderator" && N.pid !== _.pid && (N == null ? void 0 : N.type) === "human" && (B || ge.push({
      label: "Mute Audio",
      iconName: "mic-off",
      onPress: () => {
        UT(N.pid), h(!1);
      }
    })), ge;
  }, [
    V,
    N,
    _.role,
    _.pid,
    B
  ]);
  if (!N)
    return null;
  const oe = () => {
    if (!c && E.current) {
      const ge = E.current.getBoundingClientRect(), te = ge.top + ge.height / 2, _e = window.innerHeight / 2, Ue = te > _e;
      T(Ue ? "above" : "below");
    }
    h(!c);
  }, be = (ge) => {
    ge.key === "Escape" && h(!1);
  };
  return /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-more-option-container", children: [
    /* @__PURE__ */ b.jsx(
      "button",
      {
        ref: E,
        className: `cometchat-calls-more-option-button ${c ? "cometchat-calls-more-option-button--active" : ""}`,
        onClick: oe,
        onKeyDown: be,
        "aria-label": `More options for ${N.name}`,
        "aria-expanded": c,
        "aria-haspopup": "menu",
        type: "button",
        children: /* @__PURE__ */ b.jsx(ot, { name: "more", size: 20 })
      }
    ),
    c && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
      /* @__PURE__ */ b.jsx(
        "div",
        {
          className: "cometchat-calls-more-option-overlay",
          onClick: () => h(!1)
        }
      ),
      /* @__PURE__ */ b.jsx(
        "div",
        {
          ref: C,
          className: `cometchat-calls-more-option-menu ${f ? "cometchat-calls-more-option-menu--mobile" : ""} ${R === "above" ? "cometchat-calls-more-option-menu--above" : ""}`,
          role: "menu",
          "aria-orientation": "vertical",
          children: ce.map((ge, te) => /* @__PURE__ */ b.jsxs(
            "button",
            {
              className: `cometchat-calls-more-option-menu__item ${ge.selected ? "cometchat-calls-more-option-menu__item--selected" : ""}`,
              onClick: ge.onPress,
              role: "menuitem",
              "aria-label": ge.label,
              type: "button",
              children: [
                ge.iconName && /* @__PURE__ */ b.jsx(ot, { name: ge.iconName, size: 24 }),
                /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-more-option-menu__item-text", children: ge.label })
              ]
            },
            te
          ))
        }
      )
    ] })
  ] });
}, Bb = ne.memo(({ pid: s }) => {
  var v;
  const r = ne.useRef(null), c = ne.useRef([]), h = (v = N6(s, We.AUDIO)) == null ? void 0 : v.originalTrack, f = ne.useCallback((R) => {
    const T = Math.max(100, Math.min(1200 * R, 200));
    if (r.current && r.current.style.setProperty("--wave-scale", `${T}%`), T <= 100)
      c.current.forEach((E) => {
        E && (E.style.transform = "scaleY(1)");
      });
    else {
      const E = [
        1 + Math.random(),
        1 + Math.random() * 1.5,
        1 + Math.random()
      ];
      c.current.forEach((C, N) => {
        C && (C.style.transform = `scaleY(calc(var(--wave-scale) * ${E[N]}))`);
      });
    }
  }, []);
  return ne.useEffect(() => (h == null || h.on(Ge.events.track.TRACK_AUDIO_LEVEL_CHANGED, f), () => {
    h == null || h.off(
      Ge.events.track.TRACK_AUDIO_LEVEL_CHANGED,
      f
    );
  }), [f, h]), /* @__PURE__ */ b.jsxs("div", { ref: r, className: "cometchat-calls-wave-container", children: [
    /* @__PURE__ */ b.jsx(
      "div",
      {
        ref: (R) => {
          c.current[0] = R;
        },
        className: "cometchat-calls-wave-rect"
      }
    ),
    /* @__PURE__ */ b.jsx(
      "div",
      {
        ref: (R) => {
          c.current[1] = R;
        },
        className: "cometchat-calls-wave-rect"
      }
    ),
    /* @__PURE__ */ b.jsx(
      "div",
      {
        ref: (R) => {
          c.current[2] = R;
        },
        className: "cometchat-calls-wave-rect"
      }
    )
  ] });
}), Ab = ne.memo(
  ({
    type: s,
    muted: r,
    raisedHandTimestamp: c,
    pid: h
  }) => s === "screen-share" ? /* @__PURE__ */ b.jsx(ot, { name: "screen-share", size: 16 }) : c ? /* @__PURE__ */ b.jsx(ot, { name: "raise-hand-fill", size: 16 }) : r ? /* @__PURE__ */ b.jsx(ot, { name: "mic-off-fill", size: 16 }) : /* @__PURE__ */ b.jsx(Bb, { pid: h })
), Ib = ({ participant: s, className: r }) => {
  const { name: c, isLocal: h, type: f, pid: v } = s, R = Vu(We.AUDIO, v), T = Pv(v, f), E = He(
    (V) => V.enableCompanionMode
  ), C = !!T && f === "human", N = ne.useMemo(
    () => wt(
      "cometchat-calls-tile-label",
      C && "cometchat-calls-tile-label--raised-hand",
      r
    ),
    [C, r]
  ), _ = ne.useMemo(() => `cometchat-calls-tile-label-name ${C ? "cometchat-calls-tile-label-name--raised-hand" : ""}`, [C]);
  return /* @__PURE__ */ b.jsxs("div", { className: N, children: [
    /* @__PURE__ */ b.jsx(
      Ab,
      {
        type: f,
        muted: h && E ? !0 : R,
        raisedHandTimestamp: T,
        pid: v
      }
    ),
    /* @__PURE__ */ b.jsxs("span", { className: _, children: [
      c,
      " ",
      h && "(You)"
    ] })
  ] });
}, Lb = ({
  autoPlay: s = !0,
  className: r = "",
  muted: c = !0,
  playsinline: h = !0,
  style: f = {},
  videoTrack: v
}) => {
  const R = ne.useRef(null);
  return ne.useEffect(() => {
    const T = R.current;
    return T && v && v.attach(T).catch((E) => {
      console.error("Error attaching video track:", E);
    }), () => {
      T && v && v.detach(T);
    };
  }, [v]), /* @__PURE__ */ b.jsx(
    "video",
    {
      autoPlay: s,
      className: wt("cometchat-calls-video", r),
      muted: c,
      playsInline: h,
      ref: R,
      style: f
    }
  );
}, L6 = rc.memo(Lb), m2 = ({ participant: s }) => {
  const { name: r, avatar: c, isLocal: h, type: f, pid: v, ruid: R } = s, [T, E] = ne.useState(!1), C = $8(), N = He((ce) => ce.showFrameRate), _ = N6(
    v,
    f === "screen-share" ? We.SCREENSHARE : We.VIDEO
  ), V = Vu(
    f === "screen-share" ? We.SCREENSHARE : We.VIDEO,
    v
  ), B = _6();
  return /* @__PURE__ */ b.jsxs(
    "div",
    {
      className: "cometchat-calls-tile-container",
      onMouseEnter: () => E(!0),
      onMouseLeave: () => E(!1),
      children: [
        C && /* @__PURE__ */ b.jsx(KT, { ruid: R, closeMenu: !T }),
        /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-tile-content", children: [
          /* @__PURE__ */ b.jsx(
            L6,
            {
              videoTrack: _ == null ? void 0 : _.originalTrack,
              className: wt(
                V ? "cometchat-calls-video--fade-out" : "cometchat-calls-video--fade-in",
                {
                  "cometchat-calls-video--mirrored": h && f !== "screen-share" && B,
                  "cometchat-calls-tile-video--contain": f === "screen-share"
                }
              )
            }
          ),
          /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-tile-avatar-container", children: /* @__PURE__ */ b.jsx(I6, { name: r, imageUrl: c }) }),
          /* @__PURE__ */ b.jsx(Ib, { participant: s }),
          N && !V && /* @__PURE__ */ b.jsx(wb, { videoTrack: _ == null ? void 0 : _.originalTrack })
        ] })
      ]
    }
  );
};
function Jb(s) {
  const r = s.rows * s.columns;
  if (r === 0 || s.participantCount === 0)
    return {
      itemsPerPage: r,
      totalPages: 0,
      startIndex: 0,
      endIndex: 0,
      needsPagination: !1
    };
  const c = Math.ceil(s.participantCount / r), h = s.currentPage * r, f = Math.min(h + r, s.participantCount);
  return {
    itemsPerPage: r,
    totalPages: c,
    startIndex: h,
    endIndex: f,
    needsPagination: c > 1
  };
}
const xR = 160, Wb = 8, qE = 4 / 3;
function Hb(s) {
  const { participantCount: r, containerWidth: c, containerHeight: h } = s;
  if (r <= 1) return { rows: 0, columns: 0 };
  const f = c >= h, v = f ? h : c, R = f ? c : h, T = f ? qE : 1 / qE, E = Math.floor(v / xR);
  if (r <= E)
    return f ? { rows: E, columns: 1 } : { rows: 1, columns: E };
  const C = R - v * T - Wb;
  if (C <= xR)
    return f ? { rows: E, columns: 1 } : { rows: 1, columns: E };
  const N = Math.min(
    Math.floor(C / xR),
    3
  ), _ = Math.floor(r / E), V = Math.min(_, N);
  return f ? { rows: E, columns: V } : { rows: V, columns: E };
}
const zb = () => {
  const s = sm(), r = cT(), c = ne.useRef(null), [h, f] = ne.useState({ width: 0, height: 0 }), [v, R] = ne.useState(0);
  ne.useLayoutEffect(() => {
    const ce = c.current;
    if (!ce) return;
    const oe = () => {
      const { width: ge, height: te } = ce.getBoundingClientRect();
      f({ width: ge, height: te });
    };
    oe();
    const be = new ResizeObserver(oe);
    return be.observe(ce), () => be.disconnect();
  }, []);
  const T = s.length > 1, E = Hb({
    participantCount: s.length,
    containerWidth: h.width,
    containerHeight: h.height
  }), C = h.width >= h.height, N = Jb({
    participantCount: s.length,
    rows: E.rows,
    columns: E.columns,
    currentPage: v
  });
  ne.useEffect(() => {
    N.totalPages > 0 && v >= N.totalPages && R(0);
  }, [s.length, N.totalPages, v]), ne.useEffect(() => {
    Y.setState({
      sidebarVisibleParticipants: {
        startIndex: N.startIndex,
        endIndex: N.endIndex
      }
    });
  }, [N.startIndex, N.endIndex]);
  const _ = N.itemsPerPage > 0 ? s.slice(N.startIndex, N.endIndex) : s, V = N.needsPagination && v > 0, B = N.needsPagination && v < N.totalPages - 1;
  return s.length === 0 ? null : /* @__PURE__ */ b.jsxs(
    "div",
    {
      ref: c,
      className: wt(
        "cometchat-calls-sidebar-layout-container",
        C && "cometchat-calls-sidebar-layout-container--landscape",
        T && "cometchat-calls-sidebar-layout-container--has-sidebar"
      ),
      children: [
        /* @__PURE__ */ b.jsx(
          "div",
          {
            "data-testid": "main-tile",
            className: "cometchat-calls-sidebar-layout-main-tile",
            children: /* @__PURE__ */ b.jsx(m2, { participant: r })
          }
        ),
        T && /* @__PURE__ */ b.jsxs(
          "div",
          {
            "data-testid": "sidebar",
            className: "cometchat-calls-sidebar-layout-sidebar",
            children: [
              V && /* @__PURE__ */ b.jsx(
                "button",
                {
                  "data-testid": "pagination-prev",
                  className: `cometchat-calls-pagination-btn cometchat-calls-pagination-btn--${C ? "up" : "left"}`,
                  onClick: () => R((ce) => ce - 1),
                  "aria-label": "Previous page",
                  children: /* @__PURE__ */ b.jsx(ot, { name: C ? "arrow-up" : "arrow-left", size: 28 })
                }
              ),
              /* @__PURE__ */ b.jsx(
                "div",
                {
                  className: "cometchat-calls-sidebar-layout-grid",
                  style: {
                    gridTemplateRows: E.rows > 0 ? `repeat(${E.rows}, 1fr)` : void 0,
                    gridTemplateColumns: E.columns > 0 ? `repeat(${E.columns}, 1fr)` : void 0,
                    ...C ? { minWidth: 205 * E.columns } : { minHeight: 150 * E.rows }
                  },
                  children: _.map((ce) => /* @__PURE__ */ b.jsx(m2, { participant: ce }, ce.ruid))
                }
              ),
              B && /* @__PURE__ */ b.jsx(
                "button",
                {
                  "data-testid": "pagination-next",
                  className: `cometchat-calls-pagination-btn cometchat-calls-pagination-btn--${C ? "down" : "right"}`,
                  onClick: () => R((ce) => ce + 1),
                  "aria-label": "Next page",
                  children: /* @__PURE__ */ b.jsx(
                    ot,
                    {
                      name: C ? "arrow-down" : "arrow-right",
                      size: 28
                    }
                  )
                }
              ),
              N.needsPagination && /* @__PURE__ */ b.jsx(
                "div",
                {
                  className: wt(
                    "cometchat-calls-pagination-dots",
                    C && "cometchat-calls-pagination-dots--landscape"
                  ),
                  children: Array.from({ length: N.totalPages }, (ce, oe) => /* @__PURE__ */ b.jsx(
                    "div",
                    {
                      className: wt(
                        "cometchat-calls-pagination-dot",
                        oe === v && "cometchat-calls-pagination-dot--active"
                      )
                    },
                    oe
                  ))
                }
              )
            ]
          }
        )
      ]
    }
  );
};
function jb({ className: s, size: r = 40 }) {
  return /* @__PURE__ */ b.jsx(
    "svg",
    {
      className: wt("cometchat-calls-loading-spinner", s),
      style: { width: r, height: r },
      viewBox: "0 0 33 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M16.4963 31.8337C14.3288 31.8337 12.2826 31.4184 10.3576 30.5878C8.43283 29.7573 6.752 28.6235 5.31505 27.1866C3.87811 25.7496 2.74436 24.0688 1.9138 22.1441C1.08325 20.2191 0.667969 18.1728 0.667969 16.0053C0.667969 13.8114 1.08408 11.7563 1.9163 9.83991C2.74852 7.92324 3.88158 6.2481 5.31547 4.81449C6.74908 3.3806 8.43019 2.24755 10.3588 1.41533C12.2874 0.583104 14.3349 0.166992 16.5013 0.166992C16.8555 0.166992 17.1523 0.286853 17.3917 0.526576C17.6314 0.766298 17.7513 1.06324 17.7513 1.41741C17.7513 1.77185 17.6314 2.06866 17.3917 2.30783C17.1523 2.54727 16.8555 2.66699 16.5013 2.66699C12.8069 2.66699 9.66102 3.9656 7.0638 6.56283C4.46658 9.16005 3.16797 12.3059 3.16797 16.0003C3.16797 19.6948 4.46658 22.8406 7.0638 25.4378C9.66102 28.035 12.8069 29.3337 16.5013 29.3337C20.1957 29.3337 23.3416 28.035 25.9388 25.4378C28.536 22.8406 29.8346 19.6948 29.8346 16.0003C29.8346 15.6456 29.9545 15.3487 30.1942 15.1095C30.4339 14.87 30.7309 14.7503 31.0851 14.7503C31.4395 14.7503 31.7363 14.8702 31.9755 15.1099C32.2149 15.3494 32.3346 15.6462 32.3346 16.0003C32.3346 18.1667 31.9185 20.2142 31.0863 22.1428C30.2541 24.0714 29.121 25.7525 27.6871 27.1862C26.2535 28.62 24.5784 29.7531 22.6617 30.5853C20.7453 31.4175 18.6902 31.8337 16.4963 31.8337Z",
          fill: "white"
        }
      )
    }
  );
}
function $E({
  message: s,
  showLoading: r = !0,
  description: c = "",
  className: h = ""
}) {
  return /* @__PURE__ */ b.jsxs("div", { className: `cometchat-calls-processing-overlay ${h}`, children: [
    r && /* @__PURE__ */ b.jsx(jb, {}),
    /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-processing-message", children: s }),
    /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-processing-message cometchat-calls-description", children: c })
  ] });
}
const wi = 10, Pb = ({
  containerBounds: s,
  disableDrag: r = !0
}) => {
  const c = lm(), h = ne.useRef(null), [f, v] = ne.useState(!1), [R, T] = ne.useState(!1), [E, C] = ne.useState({ x: 0, y: 0 }), [N, _] = ne.useState({ x: 99999, y: 99999 }), [V, B] = ne.useState({ width: 230, height: 130 }), [ce, oe] = ne.useState(!1), [be, ge] = ne.useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }), [te, _e] = ne.useState("bottom-right"), Ue = { width: 200, height: 100 }, j = { width: 400, height: 200 }, Te = 2, Ne = ne.useCallback(
    (Oe) => {
      const { width: Ie, height: he } = s, { width: O, height: G } = V, se = Ie / 2, De = he / 2, M = Oe.x + O / 2, W = Oe.y + G / 2;
      let q;
      return M < se && W < De ? q = "top-left" : M >= se && W < De ? q = "top-right" : M < se && W >= De ? q = "bottom-left" : q = "bottom-right", _e(q), q;
    },
    [s, V]
  ), xe = ne.useCallback(
    (Oe) => {
      const { width: Ie, height: he } = s, { width: O, height: G } = V, se = [
        { x: wi, y: wi, name: "top-left" },
        // top-left
        {
          x: Ie - O - wi,
          y: wi,
          name: "top-right"
        },
        // top-right
        {
          x: wi,
          y: he - G - wi,
          name: "bottom-left"
        },
        // bottom-left
        {
          x: Ie - O - wi,
          y: he - G - wi,
          name: "bottom-right"
        }
        // bottom-right
      ];
      let De = se[0], M = 1 / 0;
      return se.forEach((W) => {
        const q = Math.sqrt(
          Math.pow(Oe.x - W.x, 2) + Math.pow(Oe.y - W.y, 2)
        );
        q < M && (M = q, De = W);
      }), { x: De.x, y: De.y };
    },
    [s, V]
  );
  ne.useEffect(() => {
    Ne(N);
  }, [N, Ne]);
  const Fe = ne.useCallback(
    (Oe) => {
      if (r || Oe.target.classList.contains(
        "cometchat-calls-draggable-tile-resize-handle"
      ))
        return;
      Oe.preventDefault(), v(!0);
      const Ie = h.current.getBoundingClientRect();
      C({
        x: Oe.clientX - Ie.left,
        y: Oe.clientY - Ie.top
      });
    },
    [r]
  ), ye = ne.useCallback(
    (Oe) => {
      Oe.preventDefault(), Oe.stopPropagation(), T(!0), ge({
        x: Oe.clientX,
        y: Oe.clientY,
        width: V.width,
        height: V.height
      });
    },
    [V]
  );
  ne.useEffect(() => {
    const Oe = (he) => {
      var O;
      if (f && !R) {
        const G = (O = h.current) == null ? void 0 : O.parentElement;
        if (!G) return;
        const se = G.getBoundingClientRect(), De = he.clientX - se.left - E.x, M = he.clientY - se.top - E.y, W = Math.max(
          0,
          Math.min(De, s.width - V.width)
        ), q = Math.max(
          0,
          Math.min(M, s.height - V.height)
        );
        _({ x: W, y: q });
      } else if (R) {
        let G = he.clientX - be.x, se = he.clientY - be.y;
        te === "top-left" || (te === "top-right" ? G = -G : te === "bottom-left" ? se = -se : te === "bottom-right" && (G = -G, se = -se));
        const De = Math.abs(G) > Math.abs(se) ? G : se, M = Math.max(
          De,
          -(be.width - Ue.width)
        );
        let W = be.width + M, q = W / Te;
        W < Ue.width ? (W = Ue.width, q = Ue.height) : W > j.width && (W = j.width, q = j.height);
        let Re = s.width - 2 * wi, $ = s.height - wi;
        te === "top-left" ? (Re = s.width - N.x - wi, $ = s.height - N.y - wi) : te === "top-right" ? (Re = N.x + V.width - wi, $ = s.height - N.y - wi) : te === "bottom-left" ? (Re = s.width - N.x - wi, $ = N.y + V.height - wi) : te === "bottom-right" && (Re = N.x + V.width - wi, $ = N.y + V.height - wi), W > Re && (W = Re, q = W / Te), q > $ && (q = $, W = q * Te);
        const Be = { ...N };
        te === "top-left" || (te === "top-right" ? Be.x = N.x - (W - V.width) : te === "bottom-left" ? Be.y = N.y - (q - V.height) : te === "bottom-right" && (Be.x = N.x - (W - V.width), Be.y = N.y - (q - V.height))), Be.x = Math.max(
          0,
          Math.min(Be.x, s.width - W)
        ), Be.y = Math.max(
          0,
          Math.min(Be.y, s.height - q)
        ), B({ width: W, height: q }), _(Be);
      }
    }, Ie = () => {
      if (f && !R) {
        oe(!0);
        const he = xe(N);
        _(he), setTimeout(() => {
          oe(!1);
        }, 300);
      }
      v(!1), T(!1);
    };
    if (f || R)
      return document.addEventListener("mousemove", Oe), document.addEventListener("mouseup", Ie), () => {
        document.removeEventListener("mousemove", Oe), document.removeEventListener("mouseup", Ie);
      };
  }, [
    f,
    R,
    E,
    N,
    V,
    xe,
    s,
    be,
    te
  ]);
  const Ve = ne.useCallback(
    (Oe) => {
      if (r || Oe.target.classList.contains(
        "cometchat-calls-draggable-tile-resize-handle"
      ))
        return;
      Oe.preventDefault(), v(!0);
      const Ie = h.current.getBoundingClientRect(), he = Oe.touches[0];
      C({
        x: he.clientX - Ie.left,
        y: he.clientY - Ie.top
      });
    },
    [r]
  );
  ne.useEffect(() => {
    const Oe = (he) => {
      var O;
      if (f && !R) {
        he.preventDefault();
        const G = he.touches[0], se = (O = h.current) == null ? void 0 : O.parentElement;
        if (!se) return;
        const De = se.getBoundingClientRect(), M = G.clientX - De.left - E.x, W = G.clientY - De.top - E.y, q = Math.max(
          0,
          Math.min(M, s.width - V.width)
        ), Re = Math.max(
          0,
          Math.min(W, s.height - V.height)
        );
        _({ x: q, y: Re });
      }
    }, Ie = () => {
      if (f && !R) {
        oe(!0);
        const he = xe(N);
        _(he), setTimeout(() => {
          oe(!1);
        }, 300);
      }
      v(!1), T(!1);
    };
    if (f || R)
      return document.addEventListener("touchmove", Oe, {
        passive: !1
      }), document.addEventListener("touchend", Ie), () => {
        document.removeEventListener("touchmove", Oe), document.removeEventListener("touchend", Ie);
      };
  }, [
    f,
    R,
    E,
    N,
    V,
    xe,
    s
  ]), ne.useEffect(() => {
    const Oe = Math.max(0, s.width - V.width), Ie = Math.max(0, s.height - V.height);
    let he = Math.max(0, Math.min(N.x, Oe)), O = Math.max(0, Math.min(N.y, Ie));
    const G = xe({ x: he, y: O });
    he = G.x, O = G.y, (he !== N.x || O !== N.y) && _({ x: he, y: O }), setTimeout(() => {
      Ne({ x: he, y: O });
    }, 0);
  }, [
    s.width,
    s.height,
    V.width,
    V.height,
    xe
  ]);
  const we = () => {
    switch (te) {
      case "top-left":
        return "cometchat-calls-draggable-tile-resize-handle--bottom-right";
      case "top-right":
        return "cometchat-calls-draggable-tile-resize-handle--bottom-left";
      case "bottom-left":
        return "cometchat-calls-draggable-tile-resize-handle--top-right";
      case "bottom-right":
        return "cometchat-calls-draggable-tile-resize-handle--top-left";
      default:
        return "cometchat-calls-draggable-tile-resize-handle--bottom-right";
    }
  };
  return /* @__PURE__ */ b.jsxs(
    "div",
    {
      ref: h,
      className: wt("cometchat-calls-draggable-tile", {
        "cometchat-calls-draggable-tile--dragging": f,
        "cometchat-calls-draggable-tile--animating": ce
      }),
      style: {
        position: "absolute",
        left: N.x,
        top: N.y,
        width: V.width,
        height: V.height,
        zIndex: 100,
        cursor: r ? "default" : f ? "grabbing" : "grab"
      },
      onMouseDown: Fe,
      onTouchStart: Ve,
      children: [
        /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-draggable-tile-content", children: /* @__PURE__ */ b.jsx(m2, { participant: c }) }),
        !r && /* @__PURE__ */ b.jsx(
          "div",
          {
            className: wt(
              "cometchat-calls-draggable-tile-resize-handle",
              we()
            ),
            onMouseDown: ye,
            onTouchStart: (Oe) => {
              Oe.preventDefault(), Oe.stopPropagation();
              const Ie = Oe.touches[0];
              T(!0), ge({
                x: Ie.clientX,
                y: Ie.clientY,
                width: V.width,
                height: V.height
              });
            }
          }
        )
      ]
    }
  );
}, Gb = () => {
  const s = sm(), r = cT(), c = ne.useRef(null), h = He(
    (T) => T.enableSpotlightDrag
  ), [f, v] = ne.useState({
    width: 0,
    height: 0
  });
  ne.useEffect(() => {
    (() => {
      if (c.current) {
        const C = c.current.getBoundingClientRect(), N = {
          width: C.width,
          height: C.height
        };
        v((_) => _.width !== N.width || _.height !== N.height ? N : _);
      }
    })();
    let E = null;
    return c.current && (E = new ResizeObserver((C) => {
      for (const N of C) {
        const { width: _, height: V } = N.contentRect, B = { width: _, height: V };
        v((ce) => ce.width !== B.width || ce.height !== B.height ? B : ce);
      }
    }), E.observe(c.current)), () => {
      E && c.current && (E.unobserve(c.current), E.disconnect());
    };
  }, []);
  const R = s.find((T) => !T.isLocal) || r;
  return /* @__PURE__ */ b.jsxs("div", { ref: c, className: "cometchat-calls-spotlight-container", children: [
    /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-spotlight-main-view", children: /* @__PURE__ */ b.jsx(m2, { participant: R }) }),
    s.length > 1 && f.width > 0 && f.height > 0 && /* @__PURE__ */ b.jsx(
      Pb,
      {
        disableDrag: !h,
        containerBounds: f
      }
    )
  ] });
};
function a6() {
  return a6 = Object.assign ? Object.assign.bind() : function(s) {
    for (var r = 1; r < arguments.length; r++) {
      var c = arguments[r];
      for (var h in c) ({}).hasOwnProperty.call(c, h) && (s[h] = c[h]);
    }
    return s;
  }, a6.apply(null, arguments);
}
function eU(s) {
  if (s === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return s;
}
function r6(s, r) {
  return r6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(c, h) {
    return c.__proto__ = h, c;
  }, r6(s, r);
}
function Yb(s, r) {
  s.prototype = Object.create(r.prototype), s.prototype.constructor = s, r6(s, r);
}
var tU = Number.isNaN || function(r) {
  return typeof r == "number" && r !== r;
};
function Xb(s, r) {
  return !!(s === r || tU(s) && tU(r));
}
function Kb(s, r) {
  if (s.length !== r.length)
    return !1;
  for (var c = 0; c < s.length; c++)
    if (!Xb(s[c], r[c]))
      return !1;
  return !0;
}
function ZR(s, r) {
  r === void 0 && (r = Kb);
  var c, h = [], f, v = !1;
  function R() {
    for (var T = [], E = 0; E < arguments.length; E++)
      T[E] = arguments[E];
    return v && c === this && r(T, h) || (f = s.apply(this, T), v = !0, c = this, h = T), f;
  }
  return R;
}
var qb = typeof performance == "object" && typeof performance.now == "function", nU = qb ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function iU(s) {
  cancelAnimationFrame(s.id);
}
function $b(s, r) {
  var c = nU();
  function h() {
    nU() - c >= r ? s.call(null) : f.id = requestAnimationFrame(h);
  }
  var f = {
    id: requestAnimationFrame(h)
  };
  return f;
}
var OR = -1;
function eC(s) {
  if (s === void 0 && (s = !1), OR === -1 || s) {
    var r = document.createElement("div"), c = r.style;
    c.width = "50px", c.height = "50px", c.overflow = "scroll", document.body.appendChild(r), OR = r.offsetWidth - r.clientWidth, document.body.removeChild(r);
  }
  return OR;
}
var Yh = null;
function aU(s) {
  if (s === void 0 && (s = !1), Yh === null || s) {
    var r = document.createElement("div"), c = r.style;
    c.width = "50px", c.height = "50px", c.overflow = "scroll", c.direction = "rtl";
    var h = document.createElement("div"), f = h.style;
    return f.width = "100px", f.height = "100px", r.appendChild(h), document.body.appendChild(r), r.scrollLeft > 0 ? Yh = "positive-descending" : (r.scrollLeft = 1, r.scrollLeft === 0 ? Yh = "negative" : Yh = "positive-ascending"), document.body.removeChild(r), Yh;
  }
  return Yh;
}
var tC = 150, nC = function(r) {
  var c = r.columnIndex;
  r.data;
  var h = r.rowIndex;
  return h + ":" + c;
}, _v = null, Fv = null, Mv = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (_v = /* @__PURE__ */ new WeakSet(), Fv = /* @__PURE__ */ new WeakSet(), Mv = /* @__PURE__ */ new WeakSet());
function iC(s) {
  var r, c = s.getColumnOffset, h = s.getColumnStartIndexForOffset, f = s.getColumnStopIndexForStartIndex, v = s.getColumnWidth, R = s.getEstimatedTotalHeight, T = s.getEstimatedTotalWidth, E = s.getOffsetForColumnAndAlignment, C = s.getOffsetForRowAndAlignment, N = s.getRowHeight, _ = s.getRowOffset, V = s.getRowStartIndexForOffset, B = s.getRowStopIndexForStartIndex, ce = s.initInstanceProps, oe = s.shouldResetStyleCacheOnItemSizeChange, be = s.validateProps;
  return r = /* @__PURE__ */ function(ge) {
    Yb(te, ge);
    function te(Ue) {
      var j;
      return j = ge.call(this, Ue) || this, j._instanceProps = ce(j.props, eU(j)), j._resetIsScrollingTimeoutId = null, j._outerRef = void 0, j.state = {
        instance: eU(j),
        isScrolling: !1,
        horizontalScrollDirection: "forward",
        scrollLeft: typeof j.props.initialScrollLeft == "number" ? j.props.initialScrollLeft : 0,
        scrollTop: typeof j.props.initialScrollTop == "number" ? j.props.initialScrollTop : 0,
        scrollUpdateWasRequested: !1,
        verticalScrollDirection: "forward"
      }, j._callOnItemsRendered = void 0, j._callOnItemsRendered = ZR(function(Te, Ne, xe, Fe, ye, Ve, we, Oe) {
        return j.props.onItemsRendered({
          overscanColumnStartIndex: Te,
          overscanColumnStopIndex: Ne,
          overscanRowStartIndex: xe,
          overscanRowStopIndex: Fe,
          visibleColumnStartIndex: ye,
          visibleColumnStopIndex: Ve,
          visibleRowStartIndex: we,
          visibleRowStopIndex: Oe
        });
      }), j._callOnScroll = void 0, j._callOnScroll = ZR(function(Te, Ne, xe, Fe, ye) {
        return j.props.onScroll({
          horizontalScrollDirection: xe,
          scrollLeft: Te,
          scrollTop: Ne,
          verticalScrollDirection: Fe,
          scrollUpdateWasRequested: ye
        });
      }), j._getItemStyle = void 0, j._getItemStyle = function(Te, Ne) {
        var xe = j.props, Fe = xe.columnWidth, ye = xe.direction, Ve = xe.rowHeight, we = j._getItemStyleCache(oe && Fe, oe && ye, oe && Ve), Oe = Te + ":" + Ne, Ie;
        if (we.hasOwnProperty(Oe))
          Ie = we[Oe];
        else {
          var he = c(j.props, Ne, j._instanceProps), O = ye === "rtl";
          we[Oe] = Ie = {
            position: "absolute",
            left: O ? void 0 : he,
            right: O ? he : void 0,
            top: _(j.props, Te, j._instanceProps),
            height: N(j.props, Te, j._instanceProps),
            width: v(j.props, Ne, j._instanceProps)
          };
        }
        return Ie;
      }, j._getItemStyleCache = void 0, j._getItemStyleCache = ZR(function(Te, Ne, xe) {
        return {};
      }), j._onScroll = function(Te) {
        var Ne = Te.currentTarget, xe = Ne.clientHeight, Fe = Ne.clientWidth, ye = Ne.scrollLeft, Ve = Ne.scrollTop, we = Ne.scrollHeight, Oe = Ne.scrollWidth;
        j.setState(function(Ie) {
          if (Ie.scrollLeft === ye && Ie.scrollTop === Ve)
            return null;
          var he = j.props.direction, O = ye;
          if (he === "rtl")
            switch (aU()) {
              case "negative":
                O = -ye;
                break;
              case "positive-descending":
                O = Oe - Fe - ye;
                break;
            }
          O = Math.max(0, Math.min(O, Oe - Fe));
          var G = Math.max(0, Math.min(Ve, we - xe));
          return {
            isScrolling: !0,
            horizontalScrollDirection: Ie.scrollLeft < ye ? "forward" : "backward",
            scrollLeft: O,
            scrollTop: G,
            verticalScrollDirection: Ie.scrollTop < Ve ? "forward" : "backward",
            scrollUpdateWasRequested: !1
          };
        }, j._resetIsScrollingDebounced);
      }, j._outerRefSetter = function(Te) {
        var Ne = j.props.outerRef;
        j._outerRef = Te, typeof Ne == "function" ? Ne(Te) : Ne != null && typeof Ne == "object" && Ne.hasOwnProperty("current") && (Ne.current = Te);
      }, j._resetIsScrollingDebounced = function() {
        j._resetIsScrollingTimeoutId !== null && iU(j._resetIsScrollingTimeoutId), j._resetIsScrollingTimeoutId = $b(j._resetIsScrolling, tC);
      }, j._resetIsScrolling = function() {
        j._resetIsScrollingTimeoutId = null, j.setState({
          isScrolling: !1
        }, function() {
          j._getItemStyleCache(-1);
        });
      }, j;
    }
    te.getDerivedStateFromProps = function(j, Te) {
      return aC(j, Te), be(j), null;
    };
    var _e = te.prototype;
    return _e.scrollTo = function(j) {
      var Te = j.scrollLeft, Ne = j.scrollTop;
      Te !== void 0 && (Te = Math.max(0, Te)), Ne !== void 0 && (Ne = Math.max(0, Ne)), this.setState(function(xe) {
        return Te === void 0 && (Te = xe.scrollLeft), Ne === void 0 && (Ne = xe.scrollTop), xe.scrollLeft === Te && xe.scrollTop === Ne ? null : {
          horizontalScrollDirection: xe.scrollLeft < Te ? "forward" : "backward",
          scrollLeft: Te,
          scrollTop: Ne,
          scrollUpdateWasRequested: !0,
          verticalScrollDirection: xe.scrollTop < Ne ? "forward" : "backward"
        };
      }, this._resetIsScrollingDebounced);
    }, _e.scrollToItem = function(j) {
      var Te = j.align, Ne = Te === void 0 ? "auto" : Te, xe = j.columnIndex, Fe = j.rowIndex, ye = this.props, Ve = ye.columnCount, we = ye.height, Oe = ye.rowCount, Ie = ye.width, he = this.state, O = he.scrollLeft, G = he.scrollTop, se = eC();
      xe !== void 0 && (xe = Math.max(0, Math.min(xe, Ve - 1))), Fe !== void 0 && (Fe = Math.max(0, Math.min(Fe, Oe - 1)));
      var De = R(this.props, this._instanceProps), M = T(this.props, this._instanceProps), W = M > Ie ? se : 0, q = De > we ? se : 0;
      this.scrollTo({
        scrollLeft: xe !== void 0 ? E(this.props, xe, Ne, O, this._instanceProps, q) : O,
        scrollTop: Fe !== void 0 ? C(this.props, Fe, Ne, G, this._instanceProps, W) : G
      });
    }, _e.componentDidMount = function() {
      var j = this.props, Te = j.initialScrollLeft, Ne = j.initialScrollTop;
      if (this._outerRef != null) {
        var xe = this._outerRef;
        typeof Te == "number" && (xe.scrollLeft = Te), typeof Ne == "number" && (xe.scrollTop = Ne);
      }
      this._callPropsCallbacks();
    }, _e.componentDidUpdate = function() {
      var j = this.props.direction, Te = this.state, Ne = Te.scrollLeft, xe = Te.scrollTop, Fe = Te.scrollUpdateWasRequested;
      if (Fe && this._outerRef != null) {
        var ye = this._outerRef;
        if (j === "rtl")
          switch (aU()) {
            case "negative":
              ye.scrollLeft = -Ne;
              break;
            case "positive-ascending":
              ye.scrollLeft = Ne;
              break;
            default:
              var Ve = ye.clientWidth, we = ye.scrollWidth;
              ye.scrollLeft = we - Ve - Ne;
              break;
          }
        else
          ye.scrollLeft = Math.max(0, Ne);
        ye.scrollTop = Math.max(0, xe);
      }
      this._callPropsCallbacks();
    }, _e.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && iU(this._resetIsScrollingTimeoutId);
    }, _e.render = function() {
      var j = this.props, Te = j.children, Ne = j.className, xe = j.columnCount, Fe = j.direction, ye = j.height, Ve = j.innerRef, we = j.innerElementType, Oe = j.innerTagName, Ie = j.itemData, he = j.itemKey, O = he === void 0 ? nC : he, G = j.outerElementType, se = j.outerTagName, De = j.rowCount, M = j.style, W = j.useIsScrolling, q = j.width, Re = this.state.isScrolling, $ = this._getHorizontalRangeToRender(), Be = $[0], Ce = $[1], It = this._getVerticalRangeToRender(), Pe = It[0], dt = It[1], dn = [];
      if (xe > 0 && De)
        for (var xn = Pe; xn <= dt; xn++)
          for (var Yt = Be; Yt <= Ce; Yt++)
            dn.push(ne.createElement(Te, {
              columnIndex: Yt,
              data: Ie,
              isScrolling: W ? Re : void 0,
              key: O({
                columnIndex: Yt,
                data: Ie,
                rowIndex: xn
              }),
              rowIndex: xn,
              style: this._getItemStyle(xn, Yt)
            }));
      var hn = R(this.props, this._instanceProps), Aa = T(this.props, this._instanceProps);
      return ne.createElement(G || se || "div", {
        className: Ne,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: a6({
          position: "relative",
          height: ye,
          width: q,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: Fe
        }, M)
      }, ne.createElement(we || Oe || "div", {
        children: dn,
        ref: Ve,
        style: {
          height: hn,
          pointerEvents: Re ? "none" : void 0,
          width: Aa
        }
      }));
    }, _e._callPropsCallbacks = function() {
      var j = this.props, Te = j.columnCount, Ne = j.onItemsRendered, xe = j.onScroll, Fe = j.rowCount;
      if (typeof Ne == "function" && Te > 0 && Fe > 0) {
        var ye = this._getHorizontalRangeToRender(), Ve = ye[0], we = ye[1], Oe = ye[2], Ie = ye[3], he = this._getVerticalRangeToRender(), O = he[0], G = he[1], se = he[2], De = he[3];
        this._callOnItemsRendered(Ve, we, O, G, Oe, Ie, se, De);
      }
      if (typeof xe == "function") {
        var M = this.state, W = M.horizontalScrollDirection, q = M.scrollLeft, Re = M.scrollTop, $ = M.scrollUpdateWasRequested, Be = M.verticalScrollDirection;
        this._callOnScroll(q, Re, W, Be, $);
      }
    }, _e._getHorizontalRangeToRender = function() {
      var j = this.props, Te = j.columnCount, Ne = j.overscanColumnCount, xe = j.overscanColumnsCount, Fe = j.overscanCount, ye = j.rowCount, Ve = this.state, we = Ve.horizontalScrollDirection, Oe = Ve.isScrolling, Ie = Ve.scrollLeft, he = Ne || xe || Fe || 1;
      if (Te === 0 || ye === 0)
        return [0, 0, 0, 0];
      var O = h(this.props, Ie, this._instanceProps), G = f(this.props, O, Ie, this._instanceProps), se = !Oe || we === "backward" ? Math.max(1, he) : 1, De = !Oe || we === "forward" ? Math.max(1, he) : 1;
      return [Math.max(0, O - se), Math.max(0, Math.min(Te - 1, G + De)), O, G];
    }, _e._getVerticalRangeToRender = function() {
      var j = this.props, Te = j.columnCount, Ne = j.overscanCount, xe = j.overscanRowCount, Fe = j.overscanRowsCount, ye = j.rowCount, Ve = this.state, we = Ve.isScrolling, Oe = Ve.verticalScrollDirection, Ie = Ve.scrollTop, he = xe || Fe || Ne || 1;
      if (Te === 0 || ye === 0)
        return [0, 0, 0, 0];
      var O = V(this.props, Ie, this._instanceProps), G = B(this.props, O, Ie, this._instanceProps), se = !we || Oe === "backward" ? Math.max(1, he) : 1, De = !we || Oe === "forward" ? Math.max(1, he) : 1;
      return [Math.max(0, O - se), Math.max(0, Math.min(ye - 1, G + De)), O, G];
    }, te;
  }(ne.PureComponent), r.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    useIsScrolling: !1
  }, r;
}
var aC = function(r, c) {
  var h = r.children, f = r.direction, v = r.height, R = r.innerTagName, T = r.outerTagName, E = r.overscanColumnsCount, C = r.overscanCount, N = r.overscanRowsCount, _ = r.width, V = c.instance;
  if (process.env.NODE_ENV !== "production") {
    if (typeof C == "number" && _v && !_v.has(V) && _v.add(V), (typeof E == "number" || typeof N == "number") && Fv && !Fv.has(V) && Fv.add(V), (R != null || T != null) && Mv && !Mv.has(V) && Mv.add(V), h == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (h === null ? "null" : typeof h) + '" was specified.'));
    switch (f) {
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + f + '" was specified.'));
    }
    if (typeof _ != "number")
      throw Error('An invalid "width" prop has been specified. Grids must specify a number for width. ' + ('"' + (_ === null ? "null" : typeof _) + '" was specified.'));
    if (typeof v != "number")
      throw Error('An invalid "height" prop has been specified. Grids must specify a number for height. ' + ('"' + (v === null ? "null" : typeof v) + '" was specified.'));
  }
};
process.env.NODE_ENV;
var rC = /* @__PURE__ */ iC({
  getColumnOffset: function(r, c) {
    var h = r.columnWidth;
    return c * h;
  },
  getColumnWidth: function(r, c) {
    var h = r.columnWidth;
    return h;
  },
  getRowOffset: function(r, c) {
    var h = r.rowHeight;
    return c * h;
  },
  getRowHeight: function(r, c) {
    var h = r.rowHeight;
    return h;
  },
  getEstimatedTotalHeight: function(r) {
    var c = r.rowCount, h = r.rowHeight;
    return h * c;
  },
  getEstimatedTotalWidth: function(r) {
    var c = r.columnCount, h = r.columnWidth;
    return h * c;
  },
  getOffsetForColumnAndAlignment: function(r, c, h, f, v, R) {
    var T = r.columnCount, E = r.columnWidth, C = r.width, N = Math.max(0, T * E - C), _ = Math.min(N, c * E), V = Math.max(0, c * E - C + R + E);
    switch (h === "smart" && (f >= V - C && f <= _ + C ? h = "auto" : h = "center"), h) {
      case "start":
        return _;
      case "end":
        return V;
      case "center":
        var B = Math.round(V + (_ - V) / 2);
        return B < Math.ceil(C / 2) ? 0 : B > N + Math.floor(C / 2) ? N : B;
      case "auto":
      default:
        return f >= V && f <= _ ? f : V > _ || f < V ? V : _;
    }
  },
  getOffsetForRowAndAlignment: function(r, c, h, f, v, R) {
    var T = r.rowHeight, E = r.height, C = r.rowCount, N = Math.max(0, C * T - E), _ = Math.min(N, c * T), V = Math.max(0, c * T - E + R + T);
    switch (h === "smart" && (f >= V - E && f <= _ + E ? h = "auto" : h = "center"), h) {
      case "start":
        return _;
      case "end":
        return V;
      case "center":
        var B = Math.round(V + (_ - V) / 2);
        return B < Math.ceil(E / 2) ? 0 : B > N + Math.floor(E / 2) ? N : B;
      case "auto":
      default:
        return f >= V && f <= _ ? f : V > _ || f < V ? V : _;
    }
  },
  getColumnStartIndexForOffset: function(r, c) {
    var h = r.columnWidth, f = r.columnCount;
    return Math.max(0, Math.min(f - 1, Math.floor(c / h)));
  },
  getColumnStopIndexForStartIndex: function(r, c, h) {
    var f = r.columnWidth, v = r.columnCount, R = r.width, T = c * f, E = Math.ceil((R + h - T) / f);
    return Math.max(0, Math.min(
      v - 1,
      c + E - 1
      // -1 is because stop index is inclusive
    ));
  },
  getRowStartIndexForOffset: function(r, c) {
    var h = r.rowHeight, f = r.rowCount;
    return Math.max(0, Math.min(f - 1, Math.floor(c / h)));
  },
  getRowStopIndexForStartIndex: function(r, c, h) {
    var f = r.rowHeight, v = r.rowCount, R = r.height, T = c * f, E = Math.ceil((R + h - T) / f);
    return Math.max(0, Math.min(
      v - 1,
      c + E - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(r) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(r) {
    var c = r.columnWidth, h = r.rowHeight;
    if (process.env.NODE_ENV !== "production") {
      if (typeof c != "number")
        throw Error('An invalid "columnWidth" prop has been specified. Value should be a number. ' + ('"' + (c === null ? "null" : typeof c) + '" was specified.'));
      if (typeof h != "number")
        throw Error('An invalid "rowHeight" prop has been specified. Value should be a number. ' + ('"' + (h === null ? "null" : typeof h) + '" was specified.'));
    }
  }
});
function oC(s) {
  return ne.forwardRef(
    ({ style: r, ...c }, h) => /* @__PURE__ */ b.jsx(
      "div",
      {
        ref: h,
        style: {
          ...r,
          position: "relative",
          top: s
        },
        ...c
      }
    )
  );
}
const sC = ({
  columnIndex: s,
  rowIndex: r,
  style: c,
  data: h
}) => {
  const { tileCount: f, columnCount: v, rowCount: R, allocatedWidth: T, TileComponent: E } = h, C = r * v + s;
  if (C + 1 > f)
    return null;
  const N = r === R - 1;
  let _ = 0, V = 0;
  if (N) {
    const B = f - v * r;
    if (B < v && typeof c.height == "number" && typeof c.width == "number") {
      const ce = Math.min(
        c.height * 1.7777777777777777 * B,
        T
      );
      V = ce / B - c.width, _ = (T - ce) / 2 + V * s;
    }
  }
  return /* @__PURE__ */ b.jsx(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...c,
        left: typeof c.left == "number" ? c.left + s * 0 + _ : c.left,
        width: typeof c.width == "number" ? c.width + V : c.width,
        padding: ac >> 1,
        boxSizing: "border-box"
      },
      children: /* @__PURE__ */ b.jsx(
        E,
        {
          columnIndex: s,
          rowIndex: r,
          index: C
        }
      )
    }
  );
};
function lC({
  TileComponent: s,
  listData: r,
  keyExtractor: c
}) {
  const h = ne.useRef(null), [f, v] = ne.useState({
    rows: 1,
    columns: 1,
    tileWidth: 0,
    tileHeight: 0,
    paddingVertical: 0,
    allocatedWidth: 0,
    allocatedHeight: 0
  });
  ne.useEffect(() => {
    Y.setState({
      tileDimensions: {
        tileHeight: f.tileHeight,
        tileWidth: f.tileWidth
      }
    });
  }, [f.tileHeight, f.tileWidth]), ne.useLayoutEffect(() => {
    const C = h.current;
    if (!C)
      return;
    const N = new ResizeObserver((_) => {
      const { inlineSize: V, blockSize: B } = _[0].borderBoxSize[0];
      V <= 0 || B <= 0 || r.length <= 0 || v(
        x4(V, B, r.length)
      );
    });
    return N.observe(C), () => {
      N.unobserve(C);
    };
  }, [r.length, h]);
  const R = f.rows * (f.tileHeight + ac), T = R < f.allocatedHeight ? (f.allocatedHeight - R) / 2 : 0, E = ne.useMemo(
    () => oC(T),
    [T]
  );
  return /* @__PURE__ */ b.jsx(
    "div",
    {
      className: "cometchat-calls-tile-grid-container",
      ref: h,
      style: {
        height: "calc(100% - var(--cometchat-calls-call-footer-height) - var(--cometchat-calls-call-header-height))",
        width: "100%",
        display: "flex",
        paddingTop: f.paddingVertical,
        paddingBottom: f.paddingVertical,
        boxSizing: "border-box",
        justifyContent: "center",
        alignItems: "center"
      },
      children: /* @__PURE__ */ b.jsx(
        rC,
        {
          initialScrollLeft: 0,
          initialScrollTop: 0,
          overscanRowCount: 1,
          columnCount: f.columns,
          columnWidth: f.tileWidth + ac,
          height: f.allocatedHeight,
          rowCount: f.rows,
          rowHeight: f.tileHeight + ac,
          itemKey: ({ rowIndex: C, columnIndex: N, data: _ }) => {
            const V = C * _.columnCount + N;
            return V + 1 > _.tileCount ? `empty-${C}-${N}` : c(r[V]);
          },
          width: f.allocatedWidth,
          innerElementType: E,
          onItemsRendered: ({
            visibleRowStartIndex: C,
            visibleRowStopIndex: N,
            visibleColumnStartIndex: _,
            visibleColumnStopIndex: V
          }) => {
            const B = C * f.columns + _, ce = N * f.columns + V;
            Y.setState({
              visibleParticipants: {
                startIndex: B,
                endIndex: ce
              }
            });
          },
          style: {
            overflow: "scroll",
            scrollbarWidth: "none"
          },
          itemData: {
            tileCount: r.length,
            columnCount: f.columns,
            rowCount: f.rows,
            allocatedWidth: f.allocatedWidth,
            allocatedHeight: f.allocatedHeight,
            TileComponent: s
          },
          children: sC
        }
      )
    }
  );
}
const cC = ({ index: s }) => {
  const r = sm()[s];
  return /* @__PURE__ */ b.jsx(m2, { participant: r });
};
function dC() {
  const s = sm(), r = jv(), c = Y8(), h = tN(), { t: f } = Ua();
  return s.length <= 0 ? null : /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    r === Ai.SPOTLIGHT && /* @__PURE__ */ b.jsx(Gb, {}),
    r === Ai.SIDEBAR && /* @__PURE__ */ b.jsx(zb, {}),
    r === Ai.TILE && /* @__PURE__ */ b.jsx(
      lC,
      {
        listData: s,
        TileComponent: cC,
        keyExtractor: (v) => v.ruid
      }
    ),
    c && /* @__PURE__ */ b.jsx($E, { message: "You've been disconnected. Attempting to reconnect…" }),
    h && /* @__PURE__ */ b.jsx(
      $E,
      {
        message: f("general.error"),
        description: h,
        showLoading: !1
      }
    ),
    /* @__PURE__ */ b.jsx(XT, {})
  ] });
}
const uC = 24;
function hC() {
  const s = L8(), r = b6(), { t: c } = Ua(), h = ne.useRef(null), f = ne.useRef(!0), [v, R] = ne.useState(!0), T = (N) => {
    f.current = N, R((_) => _ === N ? _ : N);
  }, E = () => {
    const N = h.current;
    if (!N)
      return;
    const _ = N.scrollHeight - N.scrollTop - N.clientHeight;
    T(_ <= uC);
  }, C = () => {
    const N = h.current;
    N && (N.scrollTop = N.scrollHeight, T(!0));
  };
  return ne.useLayoutEffect(() => {
    const N = h.current;
    !N || !f.current || (N.scrollTop = N.scrollHeight);
  }, [s]), r ? /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-closed-captions__wrapper", children: [
    /* @__PURE__ */ b.jsx(
      "button",
      {
        type: "button",
        className: "cometchat-calls-closed-captions__settings-button",
        "aria-label": c("controlPanel.settingsDialog.title"),
        title: c("controlPanel.settingsDialog.title"),
        onClick: () => zv("closedCaption"),
        children: /* @__PURE__ */ b.jsx(ot, { name: "settings", size: 20 })
      }
    ),
    /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-closed-captions__container", children: [
      /* @__PURE__ */ b.jsx(
        "div",
        {
          ref: h,
          onScroll: E,
          className: "cometchat-calls-closed-captions",
          "aria-label": "Closed captions",
          children: s.length < 1 ? /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-closed-captions__empty", children: /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-closed-captions__empty-text", children: c("closedCaptions.emptyState") }) }) : s.map((N) => {
            var ce, oe;
            const _ = ((ce = N.participant) == null ? void 0 : ce.name) ?? "", V = (oe = N.participant) == null ? void 0 : oe.avatar_url, B = N.transcript.map((be) => be.text).join(" ");
            return /* @__PURE__ */ b.jsxs(
              "div",
              {
                className: "cometchat-calls-closed-captions__row",
                children: [
                  /* @__PURE__ */ b.jsx(I6, { name: _, imageUrl: V, size: 40 }),
                  /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-closed-captions__content", children: [
                    /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-closed-captions__name", children: _ }),
                    /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-closed-captions__text", children: B })
                  ] })
                ]
              },
              N.message_id
            );
          })
        }
      ),
      !v && /* @__PURE__ */ b.jsx(
        "button",
        {
          type: "button",
          className: "cometchat-calls-closed-captions__scroll-button",
          "aria-label": "Scroll to latest caption",
          onClick: C,
          children: /* @__PURE__ */ b.jsx(ot, { name: "arrow-down-2", size: 24 })
        }
      )
    ] })
  ] }) : null;
}
const o6 = {
  title: "",
  description: "",
  cancelText: "",
  confirmText: "",
  visible: !1,
  inputPlaceholder: "",
  inputValue: "",
  secondInputPlaceholder: "",
  secondInputValue: ""
}, Gs = x6(
  Z6(o6, (s) => ({
    onCancel: () => {
      s({ visible: !1 });
    },
    onConfirm: () => {
      s({ visible: !1 });
    },
    onBackdropClick: () => {
      s({ visible: !1 });
    },
    reset: () => {
      s(o6);
    }
  }))
);
function rU() {
  Gs.setState(o6), Gs.setState({
    onCancel: () => {
      Gs.setState({ visible: !1 });
    },
    onConfirm: () => {
      Gs.setState({ visible: !1 });
    },
    onBackdropClick: () => {
      Gs.setState({ visible: !1 });
    }
  });
}
function wR(s, r, c, h, f = () => {
}, v = () => {
}, R, T) {
  Gs.setState({
    title: s,
    description: r,
    confirmText: c,
    cancelText: h,
    inputPlaceholder: R,
    inputValue: "",
    secondInputPlaceholder: T,
    secondInputValue: "",
    onConfirm: () => {
      const { inputValue: E, secondInputValue: C } = Gs.getState();
      f(
        R ? E.trim() : void 0,
        T ? C.trim() : void 0
      ), rU();
    },
    onCancel: () => {
      v(), rU();
    },
    visible: !0
  });
}
function mC() {
  const {
    title: s,
    description: r,
    cancelText: c,
    confirmText: h,
    onCancel: f,
    onConfirm: v,
    onBackdropClick: R,
    visible: T,
    inputPlaceholder: E,
    inputValue: C,
    secondInputPlaceholder: N,
    secondInputValue: _
  } = Gs(), V = (B) => {
    B.target === B.currentTarget && R && R();
  };
  return T ? /* @__PURE__ */ b.jsx(
    "div",
    {
      className: "cometchat-calls-confirmation-dialog-backdrop",
      onClick: V,
      children: /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-confirmation-dialog", children: /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-confirmation-dialog-content", children: [
        /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-confirmation-dialog-text", children: [
          /* @__PURE__ */ b.jsx("h2", { className: "cometchat-calls-confirmation-dialog-title", children: s }),
          /* @__PURE__ */ b.jsx("p", { className: "cometchat-calls-confirmation-dialog-description", children: r })
        ] }),
        E && /* @__PURE__ */ b.jsx(
          "input",
          {
            className: "cometchat-calls-confirmation-dialog-input",
            type: "text",
            placeholder: E,
            value: C,
            onChange: (B) => Gs.setState({
              inputValue: B.target.value
            })
          }
        ),
        N && /* @__PURE__ */ b.jsx(
          "input",
          {
            className: "cometchat-calls-confirmation-dialog-input",
            type: "text",
            placeholder: N,
            value: _,
            onChange: (B) => Gs.setState({
              secondInputValue: B.target.value
            })
          }
        ),
        /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-confirmation-dialog-buttons", children: [
          /* @__PURE__ */ b.jsx(
            "button",
            {
              className: "cometchat-calls-confirmation-dialog-button cometchat-calls-confirmation-dialog-button-secondary",
              "data-testid": "cometchat-confirmation-dialog-cancel-button",
              onClick: f,
              children: c
            }
          ),
          /* @__PURE__ */ b.jsx(
            "button",
            {
              className: "cometchat-calls-confirmation-dialog-button cometchat-calls-confirmation-dialog-button-primary",
              "data-testid": "cometchat-confirmation-dialog-confirm-button",
              onClick: v,
              disabled: !!E && !C.trim(),
              children: h
            }
          )
        ] })
      ] }) })
    }
  ) : null;
}
const pC = () => {
  const s = Vu(We.AUDIO), r = H8(), { t: c } = Ua(), [h, f] = ne.useState(!1), [v, R] = ne.useState(!1), T = it((ye) => ye.permissions.audio), E = iN(), [C, N] = ne.useState("microphone"), _ = ne.useRef(null), V = Y((ye) => ye.audioInputDevices), B = Y((ye) => ye.audioOutputDevices), ce = Y((ye) => ye.audioInputDevice), oe = Y((ye) => ye.audioOutputDevice);
  ne.useEffect(() => {
    const ye = (Ve) => {
      _.current && !_.current.contains(Ve.target) && (f(!1), R(!1));
    };
    if (h)
      return document.addEventListener("mousedown", ye), () => document.removeEventListener("mousedown", ye);
  }, [h]), ne.useEffect(() => {
    const ye = (Ve) => {
      Ve.key === "Escape" && (h || v) && (f(!1), R(!1));
    };
    if (h || v)
      return document.addEventListener("keydown", ye), () => document.removeEventListener("keydown", ye);
  }, [h, v]);
  const be = ne.useCallback(() => {
    f((ye) => !ye), R(!1);
  }, []), ge = ne.useCallback((ye) => {
    R((Ve) => !Ve), N(ye);
  }, []), te = ne.useCallback(() => {
    R(!1), f(!1), zv("audio");
  }, []), _e = ne.useCallback((ye) => {
    Uu(ye), R(!1);
  }, []), Ue = ne.useCallback((ye) => {
    Y.setState({
      audioOutputDevice: ye
    }), R(!1);
  }, []), j = ne.useCallback(() => {
    Je.publish({
      type: st.ButtonClickListener.onToggleAudioButtonClicked
    }), $U();
  }, []);
  if (r)
    return null;
  const Te = (ye, Ve) => {
    const we = Ve === "microphone" ? ce : oe, Oe = C === Ve;
    return we ? /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-audio-selector", children: /* @__PURE__ */ b.jsx(
      "button",
      {
        className: "cometchat-calls-audio-selector__button",
        onClick: () => ge(Ve),
        "aria-expanded": v && Oe,
        "aria-haspopup": "listbox",
        children: /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-audio-selector__content", children: [
          /* @__PURE__ */ b.jsx(ot, { name: ye, size: 24 }),
          /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-audio-selector__device-label", children: we.label }),
          /* @__PURE__ */ b.jsx(
            "div",
            {
              className: wt("cometchat-calls-audio-selector__arrow", {
                "cometchat-calls-audio-selector__arrow--open": v && Oe
              }),
              children: /* @__PURE__ */ b.jsx(ot, { name: "arrow-up", size: 24 })
            }
          )
        ] })
      }
    ) }) : null;
  }, Ne = C === "microphone" ? V : B, xe = C === "microphone" ? ce : oe, Fe = C === "microphone" ? _e : Ue;
  return /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-audio-control", ref: _, children: [
    !T && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-audio-control__warning", children: /* @__PURE__ */ b.jsx(ot, { name: "alert", size: 20 }) }),
    h && /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-audio-control__dropdown-wrapper", children: [
      v && /* @__PURE__ */ b.jsx(
        "div",
        {
          className: wt("cometchat-calls-audio-control__device-menu", {
            "cometchat-calls-audio-control__device-menu-speaker": C == "speaker"
          }),
          role: "listbox",
          children: Ne.map((ye) => /* @__PURE__ */ b.jsxs(
            "div",
            {
              className: wt(
                "cometchat-calls-audio-control__device-menu-item",
                {
                  "cometchat-calls-audio-control__device-menu-item--selected": ye.deviceId === (xe == null ? void 0 : xe.deviceId)
                }
              ),
              onClick: () => Fe(ye),
              onKeyDown: (Ve) => {
                (Ve.key === "Enter" || Ve.key === " ") && (Ve.preventDefault(), Fe(ye));
              },
              role: "option",
              "aria-selected": ye.deviceId === (xe == null ? void 0 : xe.deviceId),
              tabIndex: 0,
              children: [
                /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-audio-control__device-menu-icon", children: ye.deviceId === (xe == null ? void 0 : xe.deviceId) ? /* @__PURE__ */ b.jsx(ot, { name: "check-fill", size: 24 }) : null }),
                /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-audio-control__device-menu-label", children: ye.label })
              ]
            },
            ye.deviceId
          ))
        }
      ),
      /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-audio-control__dropdown-bar", children: [
        ce && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-audio-control__section", children: Te("mic-fill", "microphone") }),
        oe && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-audio-control__section", children: Te("speaker-fill", "speaker") }),
        /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-audio-control__section cometchat-calls-audio-control__section--settings", children: /* @__PURE__ */ b.jsx(
          "button",
          {
            className: "cometchat-calls-audio-control__settings-button",
            onClick: te,
            "aria-label": c("controlPanel.audioControl.audioSettings"),
            title: c("controlPanel.audioControl.audioSettings"),
            children: /* @__PURE__ */ b.jsx(ot, { name: "settings", size: 24 })
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ b.jsxs(
      "div",
      {
        className: wt("cometchat-calls-audio-control__wrapper", {
          "cometchat-calls-audio-control__wrapper--active": s
        }),
        children: [
          /* @__PURE__ */ b.jsx(
            "div",
            {
              className: "cometchat-calls-audio-control__button-wrapper",
              onClick: j,
              "data-testid": "cometchat-audio-toggle-button",
              "aria-label": c(s ? "controlPanel.audioControl.unmuteMicrophone" : "controlPanel.audioControl.muteMicrophone"),
              children: /* @__PURE__ */ b.jsx(
                "button",
                {
                  className: "cometchat-calls-audio-control__button",
                  title: c(s ? "controlPanel.audioControl.unmuteMicrophone" : "controlPanel.audioControl.muteMicrophone"),
                  children: /* @__PURE__ */ b.jsx(ot, { name: s ? "mic-off-fill" : "mic-fill" })
                }
              )
            }
          ),
          /* @__PURE__ */ b.jsx(
            "div",
            {
              className: "cometchat-calls-audio-control__divider",
              onClick: j
            }
          ),
          /* @__PURE__ */ b.jsx(
            "div",
            {
              className: "cometchat-calls-audio-control__arrow-wrapper",
              onClick: E ? be : void 0,
              "aria-label": c("controlPanel.audioControl.audioDeviceOptions"),
              "aria-expanded": h,
              "aria-disabled": !E,
              children: /* @__PURE__ */ b.jsx(
                "button",
                {
                  disabled: !E,
                  className: wt("cometchat-calls-audio-control__arrow-button", {
                    "cometchat-calls-audio-control__arrow-button-open": h
                  }),
                  title: c("controlPanel.audioControl.audioDeviceOptions"),
                  children: /* @__PURE__ */ b.jsx(ot, { name: "arrow-up", size: 16 })
                }
              )
            }
          )
        ]
      }
    )
  ] });
}, fC = () => {
  const s = Vu(We.VIDEO), { t: r } = Ua(), c = z8(), [h, f] = ne.useState(!1), [v, R] = ne.useState(!1), T = ne.useRef(null), E = Y((te) => te.videoInputDevices), C = it((te) => te.permissions.video), N = aN(), _ = Y((te) => te.videoInputDevice), V = ne.useCallback(() => {
    R(!1), f(!1), zv("video");
  }, []);
  ne.useEffect(() => {
    const te = (_e) => {
      T.current && !T.current.contains(_e.target) && (f(!1), R(!1));
    };
    if (h)
      return document.addEventListener("mousedown", te), () => document.removeEventListener("mousedown", te);
  }, [h]), ne.useEffect(() => {
    const te = (_e) => {
      _e.key === "Escape" && (h || v) && (f(!1), R(!1));
    };
    if (h || v)
      return document.addEventListener("keydown", te), () => document.removeEventListener("keydown", te);
  }, [h, v]);
  const B = ne.useCallback(() => {
    f((te) => !te), R(!1);
  }, []), ce = ne.useCallback(() => {
    R((te) => !te);
  }, []), oe = ne.useCallback(
    async (te) => {
      am(te), R(!1);
    },
    []
  ), be = ne.useCallback(() => {
    Je.publish({
      type: st.ButtonClickListener.onToggleVideoButtonClicked
    }), eT();
  }, []);
  if (c)
    return null;
  const ge = () => _ ? /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-video-selector", children: /* @__PURE__ */ b.jsx(
    "button",
    {
      className: "cometchat-calls-video-selector__button",
      onClick: ce,
      "aria-expanded": v,
      "aria-haspopup": "listbox",
      children: /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-video-selector__content", children: [
        /* @__PURE__ */ b.jsx(ot, { name: "video-fill", size: 24 }),
        /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-video-selector__device-label", children: _.label }),
        /* @__PURE__ */ b.jsx(
          "div",
          {
            className: wt("cometchat-calls-video-selector__arrow", {
              "cometchat-calls-video-selector__arrow--open": v
            }),
            children: /* @__PURE__ */ b.jsx(ot, { name: "arrow-up", size: 24 })
          }
        )
      ] })
    }
  ) }) : null;
  return /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-video-control", ref: T, children: [
    !C && /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-video-control__warning", children: [
      " ",
      /* @__PURE__ */ b.jsx(ot, { name: "alert", size: 20 })
    ] }),
    h && /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-video-control__dropdown-wrapper", children: [
      v && /* @__PURE__ */ b.jsx(
        "div",
        {
          className: "cometchat-calls-video-control__device-menu",
          role: "listbox",
          children: E.map((te) => /* @__PURE__ */ b.jsxs(
            "div",
            {
              className: wt(
                "cometchat-calls-video-control__device-menu-item",
                {
                  "cometchat-calls-video-control__device-menu-item--selected": te.deviceId === (_ == null ? void 0 : _.deviceId)
                }
              ),
              onClick: () => oe(te),
              onKeyDown: (_e) => {
                (_e.key === "Enter" || _e.key === " ") && (_e.preventDefault(), oe(te));
              },
              role: "option",
              "aria-selected": te.deviceId === (_ == null ? void 0 : _.deviceId),
              tabIndex: 0,
              children: [
                /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-video-control__device-menu-icon", children: te.deviceId === (_ == null ? void 0 : _.deviceId) ? /* @__PURE__ */ b.jsx(ot, { name: "check-fill", size: 24 }) : null }),
                /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-video-control__device-menu-label", children: te.label })
              ]
            },
            te.deviceId
          ))
        }
      ),
      /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-video-control__dropdown-bar", children: [
        /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-video-control__section", children: ge() }),
        /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-video-control__section cometchat-calls-video-control__section--settings", children: /* @__PURE__ */ b.jsx(
          "button",
          {
            className: "cometchat-calls-video-control__settings-button",
            onClick: V,
            "aria-label": r("controlPanel.videoControl.videoSettings"),
            title: r("controlPanel.videoControl.videoSettings"),
            children: /* @__PURE__ */ b.jsx(ot, { name: "settings", size: 24 })
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ b.jsxs(
      "div",
      {
        className: wt("cometchat-calls-video-control__wrapper", {
          "cometchat-calls-video-control__wrapper--active": s
        }),
        children: [
          /* @__PURE__ */ b.jsx(
            "div",
            {
              className: "cometchat-calls-video-control__button-wrapper",
              onClick: be,
              "data-testid": "cometchat-video-toggle-button",
              "aria-label": r(s ? "controlPanel.videoControl.turnOnCamera" : "controlPanel.videoControl.turnOffCamera"),
              children: /* @__PURE__ */ b.jsx(
                "button",
                {
                  className: "cometchat-calls-video-control__button",
                  title: r(s ? "controlPanel.videoControl.turnOnCamera" : "controlPanel.videoControl.turnOffCamera"),
                  children: /* @__PURE__ */ b.jsx(ot, { name: s ? "video-off-fill" : "video-fill" })
                }
              )
            }
          ),
          /* @__PURE__ */ b.jsx(
            "div",
            {
              className: "cometchat-calls-video-control__divider",
              onClick: be
            }
          ),
          /* @__PURE__ */ b.jsx(
            "div",
            {
              className: "cometchat-calls-video-control__arrow-wrapper",
              onClick: N ? B : void 0,
              "aria-disabled": !N,
              children: /* @__PURE__ */ b.jsx(
                "button",
                {
                  disabled: !N,
                  className: wt("cometchat-calls-video-control__arrow-button", {
                    "cometchat-calls-video-control__arrow-button-open": h
                  }),
                  "aria-label": r("controlPanel.videoControl.videoDeviceOptions"),
                  "aria-expanded": h,
                  title: r("controlPanel.videoControl.videoDeviceOptions"),
                  children: /* @__PURE__ */ b.jsx(ot, { name: "arrow-up", size: 16 })
                }
              )
            }
          )
        ]
      }
    )
  ] });
}, gC = ({
  iconName: s,
  label: r,
  onClick: c,
  selected: h = !1,
  disabled: f = !1
}) => /* @__PURE__ */ b.jsxs(
  "div",
  {
    className: wt(
      "cometchat-calls-more-menu-item",
      h && "cometchat-calls-more-menu-item--selected",
      f && "cometchat-calls-more-menu-item--disabled"
    ),
    onClick: () => {
      f || c();
    },
    role: "menuitem",
    tabIndex: f ? -1 : 0,
    "aria-selected": h,
    "aria-disabled": f,
    onKeyDown: (v) => {
      !f && (v.key === "Enter" || v.key === " ") && c();
    },
    children: [
      /* @__PURE__ */ b.jsx(ot, { name: s, size: 24 }),
      " ",
      /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-more-menu-item-label", children: r })
    ]
  }
), vC = ({
  isVisible: s,
  onClose: r,
  anchorElement: c,
  toggleSettings: h,
  toggleVirtualBackground: f,
  isMobileView: v = !1
}) => {
  const R = ne.useRef(null), { t: T } = Ua(), E = Y((he) => he.isMobileBrowser), C = nN(), N = ne.useCallback(() => {
    if (!c || !R.current)
      return;
    const he = c.getBoundingClientRect(), O = R.current, G = O.getBoundingClientRect(), se = window.innerWidth, De = window.innerHeight;
    let M = De - he.top + 8, W = he.left + he.width / 2 - G.width / 2;
    W < 8 ? W = 8 : W + G.width > se - 8 && (W = se - G.width - 8), M + G.height > De - 8 && (M = De - he.bottom - 8), M + G.height > De - 8 && (M = 8), O.style.bottom = `${M}px`, O.style.left = `${W}px`, O.style.top = "auto";
  }, [c]);
  ne.useEffect(() => {
    const he = () => {
      s && c && R.current && N();
    };
    if (s)
      return window.addEventListener("resize", he), () => window.removeEventListener("resize", he);
  }, [s, c, N]), ne.useEffect(() => {
    s && c && R.current && requestAnimationFrame(() => {
      N();
    });
  }, [s, c, N, v]), ne.useEffect(() => {
    const he = (O) => {
      R.current && !R.current.contains(O.target) && !(c != null && c.contains(O.target)) && (r == null || r());
    };
    if (s)
      return document.addEventListener("mousedown", he), () => document.removeEventListener("mousedown", he);
  }, [s, r, c]);
  const _ = Pv(), V = HU(), B = zU(), ce = X8(), oe = K8(), be = J8(), ge = P8(), te = q8(), _e = He(
    (he) => he.hideRaiseHandButton
  ), Ue = sT(), j = ke((he) => he.recording.status), Te = ne.useCallback(
    (he) => {
      he(), r == null || r();
    },
    [r]
  ), Ne = ne.useCallback(() => {
    j !== "pending" && (Je.publish({
      type: st.ButtonClickListener.onRecordingToggleButtonClicked
    }), wR(
      T(V ? "controlPanel.recording.stopRecording" : "controlPanel.recording.startRecording"),
      T(V ? "controlPanel.recording.stopRecordingConfirmation" : "controlPanel.recording.startRecordingConfirmation"),
      T(V ? "controlPanel.recording.stopRecording" : "controlPanel.recording.startRecording"),
      T("controlPanel.recording.cancel"),
      () => {
        GU();
      }
    ));
  }, [V, j, T]), xe = ne.useCallback(() => {
    if (j !== "pending")
      if (B)
        wR(
          T("controlPanel.streaming.stopStreaming"),
          T("controlPanel.streaming.stopStreamingConfirmation"),
          T("controlPanel.streaming.stopStreaming"),
          T("controlPanel.streaming.cancel"),
          () => YU()
        );
      else {
        const { streamUrl: he, streamKey: O } = He.getState();
        if (he) {
          jR(he, O ?? "");
          return;
        }
        wR(
          T("controlPanel.streaming.startStreaming"),
          T("controlPanel.streaming.startStreamingConfirmation"),
          T("controlPanel.streaming.startStreaming"),
          T("controlPanel.streaming.cancel"),
          (G, se) => {
            G && jR(G, se ?? "");
          },
          () => {
          },
          T("controlPanel.streaming.streamUrlPlaceholder"),
          T("controlPanel.streaming.streamKeyPlaceholder")
        );
      }
  }, [B, j, T]), Fe = ne.useCallback(() => {
    W8();
  }, []), ye = () => {
    f && f();
  }, Ve = () => {
    h && h();
  }, we = [
    !te && {
      iconName: "virtual-background",
      label: "Virtual Background",
      onClick: () => Te(ye),
      id: "vb"
    },
    !oe && {
      iconName: B ? "streaming-stop" : "streaming",
      label: T(B ? "controlPanel.streaming.stopStreaming" : "controlPanel.streaming.startStreaming"),
      onClick: () => Te(xe),
      id: "streaming",
      disabled: j === "pending"
    },
    !ce && {
      iconName: V ? "record-stop-fill" : "record-fill",
      label: T(V ? "controlPanel.recording.stopRecording" : "controlPanel.recording.startRecording"),
      onClick: () => Te(Ne),
      id: "rec",
      disabled: j === "pending"
    },
    !ge && {
      iconName: be ? "transcription-stop" : "transcription-start",
      label: be ? "Stop Transcription" : "Start Transcription",
      onClick: () => Te(Fe),
      id: "transcription"
    },
    // {
    //   iconName: 'stats' as IconName,
    //   label: 'Participants Stats',
    //   onClick: () => handleItemClick(handleParticipantsStats),
    //   id: 'pstats',
    // },
    !E && {
      iconName: "settings",
      label: "Settings",
      onClick: () => Te(Ve),
      id: "settings"
    },
    C && {
      iconName: "switch-camera",
      label: "Switch Camera",
      onClick: () => {
        Te(uT);
      },
      id: "switch-camera"
    }
  ].filter(Boolean), Oe = [
    !_e && {
      iconName: "raise-hand-fill",
      label: _ ? "Lower Hand" : "Raise Hand",
      onClick: () => Te(y6),
      selected: !!_,
      id: "raisehand"
    },
    !Ue && {
      iconName: "screen-share",
      label: "Start Screen Share",
      onClick: () => Te(k6),
      id: "screenshare"
    }
  ].filter(Boolean), Ie = v ? [...Oe, ...we] : we;
  return s ? /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
    /* @__PURE__ */ b.jsx(
      "div",
      {
        className: "cometchat-calls-more-menu-overlay",
        onClick: r,
        "data-testid": "more-menu-overlay"
      }
    ),
    /* @__PURE__ */ b.jsx(
      "div",
      {
        ref: R,
        className: "cometchat-calls-more-menu-container",
        role: "menu",
        "aria-orientation": "vertical",
        children: Ie.map((he) => /* @__PURE__ */ b.jsx(
          gC,
          {
            iconName: he.iconName,
            label: he.label,
            onClick: he.onClick,
            selected: he.selected || !1,
            disabled: he.disabled || !1
          },
          he.id
        ))
      }
    )
  ] }) : null;
}, SC = [5, 15, 30], RC = () => {
  const { t: s } = Ua(), r = Y((f) => f.previewVideoTrack), c = _6(), h = Y(
    (f) => f.previewVideoInputDevice
  );
  return ne.useEffect(() => (R6("video", h == null ? void 0 : h.deviceId).then((f) => {
    Y.setState({ previewVideoTrack: f });
  }).catch((f) => {
    console.error("Error creating local video track:", f);
  }), () => {
    Y.setState({ previewVideoTrack: void 0 });
  }), [h]), /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-video-preview__container", children: [
    /* @__PURE__ */ b.jsx(
      L6,
      {
        videoTrack: r,
        className: wt({
          "cometchat-calls-settings-video-preview__video--mirrored": c
        })
      }
    ),
    !r && /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-video-preview__placeholder", children: [
      /* @__PURE__ */ b.jsx(ot, { name: "video-fill", size: 48 }),
      /* @__PURE__ */ b.jsx("span", { children: s(
        "controlPanel.settingsDialog.videoSettings.selectCameraToSeePreview"
      ) })
    ] })
  ] });
}, EC = ({
  visible: s = !1,
  onClose: r,
  selectedTab: c = "audio"
}) => {
  const [h, f] = ne.useState(c);
  ne.useEffect(() => {
    s && f(c);
  }, [s, c]);
  const v = Y(($) => $.audioInputDevices), R = Y(($) => $.audioOutputDevices), T = Y(($) => $.videoInputDevices), E = Y(($) => $.audioInputDevice), C = Y(($) => $.audioOutputDevice), N = Y(($) => $.videoInputDevice), _ = He(($) => $.sessionType), V = Y(($) => $.previewVideoInputDevice) || N, [B, ce] = ne.useState(null), oe = Y(
    ($) => $.desktopSharingFrameRate
  ), [be, ge] = ne.useState(oe), { t: te } = Ua(), _e = it(($) => $.permissions.audio), Ue = it(($) => $.permissions.video), j = Y(
    ($) => $.enableNoiseReduction
  ), Te = ne.useRef(null), Ne = Y(($) => $.mirrorLocalVideo), xe = zn(($) => $.captionLanguage), Fe = b6(), ye = lT();
  ne.useEffect(() => {
    ye && h === "closedCaption" && f("audio");
  }, [ye, h]);
  const Ve = ne.useCallback(($) => {
    Uu($);
  }, []), we = ne.useCallback(($) => {
    Y.setState({
      audioOutputDevice: $
    });
  }, []), Oe = ne.useCallback(
    async ($) => {
      Y.setState({
        previewVideoInputDevice: $
      });
    },
    []
  ), Ie = ne.useCallback(() => {
    am(V), Y.setState({ desktopSharingFrameRate: be }), r == null || r();
  }, [r, V, be]), he = ($) => {
    switch ($) {
      case "Microphone":
        return "mic-fill";
      case "Speaker":
        return "speaker-fill";
      case "Camera":
        return "video-fill";
      default:
        return "mic-fill";
    }
  }, O = ne.useCallback(() => {
    ce(null);
  }, []);
  if (ne.useEffect(() => {
    if (B === "framerate") {
      const $ = setTimeout(() => {
        const Be = document.querySelector(
          '.cometchat-calls-settings-dropdown__list[aria-label="Frame rate options"]'
        ), Ce = document.querySelector(
          ".cometchat-calls-settings-content"
        );
        if (Be && Ce) {
          const It = Be.getBoundingClientRect(), Pe = Ce.getBoundingClientRect();
          if (It.bottom, Pe.bottom, It.bottom > Pe.bottom) {
            const dt = It.bottom - Pe.bottom + 30;
            Ce.scrollBy({
              top: dt,
              behavior: "smooth"
            });
          }
        }
      }, 10);
      return () => clearTimeout($);
    }
  }, [B]), ne.useEffect(() => {
    const $ = (Be) => {
      if (B && Be.target instanceof Element) {
        const Ce = document.querySelectorAll(
          ".cometchat-calls-settings-dropdown"
        );
        let It = !1;
        Ce.forEach((Pe) => {
          Pe.contains(Be.target) && (It = !0);
        }), It || O();
      }
    };
    if (s && B)
      return document.addEventListener("mousedown", $), () => {
        document.removeEventListener("mousedown", $);
      };
  }, [s, B, O]), !s)
    return null;
  const G = ($, Be, Ce) => /* @__PURE__ */ b.jsxs(
    "button",
    {
      className: `cometchat-calls-settings-tab ${h === $ ? "cometchat-calls-settings-tab--active" : ""}`,
      onClick: () => f($),
      "aria-label": `${Be} settings`,
      "aria-pressed": h === $,
      children: [
        /* @__PURE__ */ b.jsx(ot, { name: Ce, size: 24 }),
        /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-settings-tab__label", children: Be })
      ]
    },
    $
  ), se = () => {
    if (Ue && _e)
      return null;
    const $ = [];
    return _e || $.push("microphone"), Ue || $.push("camera"), /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-error-notification", children: [
      /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-settings-error-notification__icon", children: /* @__PURE__ */ b.jsx(ot, { name: "error", size: 20 }) }),
      /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-error-notification__content", children: [
        /* @__PURE__ */ b.jsx("h4", { className: "cometchat-calls-settings-error-notification__title", children: "Some permissions are missing" }),
        /* @__PURE__ */ b.jsxs("p", { className: "cometchat-calls-settings-error-notification__message", children: [
          "Access to your ",
          $.join(" and "),
          " is blocked. Please check your browser settings."
        ] })
      ] })
    ] });
  }, De = ($, Be, Ce, It, Pe, dt = !1) => {
    const dn = B === Pe, xn = () => {
      dt || ce(dn ? null : Pe);
    }, Yt = (hn) => {
      dt || (It(hn), O());
    };
    return /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-device-section", children: [
      /* @__PURE__ */ b.jsx("label", { className: "cometchat-calls-settings-device-label", children: $ }),
      /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-dropdown", children: [
        /* @__PURE__ */ b.jsxs(
          "button",
          {
            className: `cometchat-calls-settings-dropdown__header ${dn ? "cometchat-calls-settings-dropdown__header--open" : ""} ${dt ? "cometchat-calls-settings-dropdown__header--disabled" : ""}`,
            onClick: xn,
            "aria-expanded": dn,
            "aria-haspopup": "listbox",
            "aria-label": `Select ${$.toLowerCase()}`,
            disabled: dt,
            children: [
              /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-dropdown__selected", children: [
                Ce && !dt && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-settings-dropdown__icon", children: /* @__PURE__ */ b.jsx(ot, { name: he($), size: 16 }) }),
                /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-settings-dropdown__text", children: (Ce == null ? void 0 : Ce.label) || `No ${$.toLowerCase()} selected` })
              ] }),
              !dt && /* @__PURE__ */ b.jsx(
                "div",
                {
                  className: `cometchat-calls-settings-dropdown__arrow ${dn ? "cometchat-calls-settings-dropdown__arrow--rotated" : ""}`,
                  children: /* @__PURE__ */ b.jsx(ot, { name: "arrow-up", size: 20 })
                }
              )
            ]
          }
        ),
        dn && !dt && /* @__PURE__ */ b.jsx(
          "ul",
          {
            className: "cometchat-calls-settings-dropdown__list",
            role: "listbox",
            "aria-label": `${$} options`,
            children: Be.map((hn) => /* @__PURE__ */ b.jsx(
              "li",
              {
                className: `cometchat-calls-settings-dropdown__option ${hn.deviceId === (Ce == null ? void 0 : Ce.deviceId) ? "cometchat-calls-settings-dropdown__option--selected" : ""}`,
                onClick: () => Yt(hn),
                role: "option",
                "aria-selected": hn.deviceId === (Ce == null ? void 0 : Ce.deviceId),
                children: /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-settings-dropdown__option-text", children: hn.label })
              },
              hn.deviceId
            ))
          }
        )
      ] })
    ] });
  }, M = () => /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-tab-content cometchat-calls-settings-tab-content--audio", children: [
    De(
      te("controlPanel.settingsDialog.deviceLabels.microphone"),
      v,
      E,
      Ve,
      "microphone"
    ),
    De(
      te("controlPanel.settingsDialog.deviceLabels.speaker"),
      R,
      C,
      we,
      "speaker"
    ),
    /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-settings-checkbox", children: /* @__PURE__ */ b.jsxs("label", { className: "cometchat-calls-settings-checkbox__container", children: [
      /* @__PURE__ */ b.jsx(
        "input",
        {
          type: "checkbox",
          checked: j,
          onChange: Q8,
          className: "cometchat-calls-settings-checkbox__input"
        }
      ),
      /* @__PURE__ */ b.jsx(
        "span",
        {
          className: "cometchat-calls-settings-checkbox__custom",
          "aria-hidden": "true"
        }
      ),
      /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-settings-checkbox__label", children: te(
        "controlPanel.settingsDialog.audioSettings.enableNoiseReduction"
      ) })
    ] }) })
  ] }), W = () => /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-tab-content cometchat-calls-settings-tab-content--video", children: [
    Ue && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-settings-video-preview", children: /* @__PURE__ */ b.jsx(RC, {}) }),
    /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-video-controls", children: [
      De(
        te("controlPanel.settingsDialog.deviceLabels.camera"),
        T,
        V,
        Oe,
        "camera"
      ),
      Ue && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
        /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-settings-checkbox", children: /* @__PURE__ */ b.jsxs("label", { className: "cometchat-calls-settings-checkbox__container", children: [
          /* @__PURE__ */ b.jsx(
            "input",
            {
              type: "checkbox",
              checked: Ne,
              onChange: D8,
              className: "cometchat-calls-settings-checkbox__input",
              "aria-describedby": "mirror-video-description"
            }
          ),
          /* @__PURE__ */ b.jsx(
            "span",
            {
              className: "cometchat-calls-settings-checkbox__custom",
              "aria-hidden": "true"
            }
          ),
          /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-settings-checkbox__label", children: te("controlPanel.settingsDialog.videoSettings.mirrorMyVideo") })
        ] }) }),
        /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-device-section", children: [
          /* @__PURE__ */ b.jsx("label", { className: "cometchat-calls-settings-device-label", children: te("controlPanel.settingsDialog.deviceLabels.frameRate") }),
          /* @__PURE__ */ b.jsxs(
            "div",
            {
              className: "cometchat-calls-settings-dropdown",
              ref: Te,
              children: [
                /* @__PURE__ */ b.jsxs(
                  "button",
                  {
                    className: `cometchat-calls-settings-dropdown__header ${B === "framerate" ? "cometchat-calls-settings-dropdown__header--open" : ""}`,
                    onClick: () => ce(
                      B === "framerate" ? null : "framerate"
                    ),
                    "aria-expanded": B === "framerate",
                    "aria-haspopup": "listbox",
                    "aria-label": "Select frame rate",
                    children: [
                      /* @__PURE__ */ b.jsxs("span", { className: "cometchat-calls-settings-dropdown__text", children: [
                        be,
                        " ",
                        te(
                          "controlPanel.settingsDialog.videoSettings.frameRateUnit"
                        )
                      ] }),
                      /* @__PURE__ */ b.jsx(
                        "div",
                        {
                          className: `cometchat-calls-settings-dropdown__arrow ${B === "framerate" ? "cometchat-calls-settings-dropdown__arrow--rotated" : ""}`,
                          children: /* @__PURE__ */ b.jsx(ot, { name: "arrow-up", size: 20 })
                        }
                      )
                    ]
                  }
                ),
                B === "framerate" && /* @__PURE__ */ b.jsx(
                  "ul",
                  {
                    className: "cometchat-calls-settings-dropdown__list",
                    role: "listbox",
                    "aria-label": "Frame rate options",
                    children: SC.map(($) => /* @__PURE__ */ b.jsx(
                      "li",
                      {
                        className: `cometchat-calls-settings-dropdown__option ${$ === be ? "cometchat-calls-settings-dropdown__option--selected" : ""}`,
                        onClick: () => {
                          ge($), O();
                        },
                        role: "option",
                        "aria-selected": $ === be,
                        children: /* @__PURE__ */ b.jsxs("span", { className: "cometchat-calls-settings-dropdown__option-text", children: [
                          $,
                          " ",
                          te(
                            "controlPanel.settingsDialog.videoSettings.frameRateUnit"
                          )
                        ] })
                      },
                      $
                    ))
                  }
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-settings-notice", children: /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-settings-notice__text", children: te("controlPanel.settingsDialog.videoSettings.frameRateNotice") }) })
      ] })
    ] })
  ] }), q = () => {
    const $ = B === "language", Be = Qv.find(
      (Ce) => Ce.code === xe
    );
    return /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-tab-content cometchat-calls-settings-tab-content--closed-caption", children: [
      /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-device-section", children: [
        /* @__PURE__ */ b.jsx("label", { className: "cometchat-calls-settings-device-label", children: te("controlPanel.settingsDialog.closedCaptionSettings.language") }),
        /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-dropdown", children: [
          /* @__PURE__ */ b.jsxs(
            "button",
            {
              className: `cometchat-calls-settings-dropdown__header ${$ ? "cometchat-calls-settings-dropdown__header--open" : ""}`,
              onClick: () => ce($ ? null : "language"),
              "aria-expanded": $,
              "aria-haspopup": "listbox",
              "aria-label": "Select caption language",
              children: [
                /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-settings-dropdown__text", children: Be == null ? void 0 : Be.label }),
                /* @__PURE__ */ b.jsx(
                  "div",
                  {
                    className: `cometchat-calls-settings-dropdown__arrow ${$ ? "cometchat-calls-settings-dropdown__arrow--rotated" : ""}`,
                    children: /* @__PURE__ */ b.jsx(ot, { name: "arrow-up", size: 20 })
                  }
                )
              ]
            }
          ),
          $ && /* @__PURE__ */ b.jsx(
            "ul",
            {
              className: "cometchat-calls-settings-dropdown__list",
              role: "listbox",
              "aria-label": "Caption language options",
              children: Qv.map((Ce) => /* @__PURE__ */ b.jsx(
                "li",
                {
                  className: `cometchat-calls-settings-dropdown__option ${Ce.code === xe ? "cometchat-calls-settings-dropdown__option--selected" : ""}`,
                  onClick: () => {
                    zn.setState({
                      captionLanguage: Ce.code
                    }), O();
                  },
                  role: "option",
                  "aria-selected": Ce.code === xe,
                  children: /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-settings-dropdown__option-text", children: Ce.label })
                },
                Ce.code
              ))
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-settings-checkbox", children: /* @__PURE__ */ b.jsxs("label", { className: "cometchat-calls-settings-checkbox__container", children: [
        /* @__PURE__ */ b.jsx(
          "input",
          {
            type: "checkbox",
            checked: Fe,
            onChange: rT,
            className: "cometchat-calls-settings-checkbox__input"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "span",
          {
            className: "cometchat-calls-settings-checkbox__custom",
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-settings-checkbox__label", children: te(
          "controlPanel.settingsDialog.closedCaptionSettings.enableClosedCaptions"
        ) })
      ] }) })
    ] });
  }, Re = () => {
    switch (h) {
      case "audio":
        return M();
      case "video":
        return W();
      case "closedCaption":
        return q();
      default:
        return /* @__PURE__ */ b.jsx(b.Fragment, {});
    }
  };
  return /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-settings-overlay", onClick: r, children: /* @__PURE__ */ b.jsxs(
    "div",
    {
      className: "cometchat-calls-settings-modal",
      onClick: ($) => $.stopPropagation(),
      children: [
        /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-sidebar-wrapper", children: [
          /* @__PURE__ */ b.jsx("h2", { className: "cometchat-calls-settings-sidebar__header", children: te("controlPanel.settingsDialog.title") }),
          /* @__PURE__ */ b.jsxs(
            "nav",
            {
              className: "cometchat-calls-settings-sidebar",
              role: "navigation",
              "aria-label": te("controlPanel.settingsDialog.title"),
              children: [
                G(
                  "audio",
                  te("controlPanel.settingsDialog.tabs.audio"),
                  "mic-fill"
                ),
                _ === "VIDEO" && G(
                  "video",
                  te("controlPanel.settingsDialog.tabs.video"),
                  "video-fill"
                ),
                !ye && G(
                  "closedCaption",
                  te("controlPanel.settingsDialog.tabs.closedCaption"),
                  "closed-caption"
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-content-wrapper", children: [
          /* @__PURE__ */ b.jsx("main", { className: "cometchat-calls-settings-body", children: /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-settings-content", children: [
            se(),
            Re()
          ] }) }),
          /* @__PURE__ */ b.jsxs("footer", { className: "cometchat-calls-settings-footer", children: [
            /* @__PURE__ */ b.jsx(
              "button",
              {
                className: "cometchat-calls-settings-button cometchat-calls-settings-button--secondary",
                onClick: r,
                children: te("controlPanel.settingsDialog.buttons.cancel")
              }
            ),
            /* @__PURE__ */ b.jsx(
              "button",
              {
                className: "cometchat-calls-settings-button cometchat-calls-settings-button--primary",
                onClick: Ie,
                children: te("controlPanel.settingsDialog.buttons.done")
              }
            )
          ] })
        ] })
      ]
    }
  ) });
}, UC = () => /* @__PURE__ */ b.jsxs(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ b.jsx(
        "mask",
        {
          id: "mask0_11949_91557",
          style: { maskType: "alpha" },
          maskUnits: "userSpaceOnUse",
          x: "6",
          y: "6",
          width: "20",
          height: "20",
          children: /* @__PURE__ */ b.jsx("rect", { x: "6", y: "6", width: "20", height: "20", fill: "#D9D9D9" })
        }
      ),
      /* @__PURE__ */ b.jsx("g", { mask: "url(#mask0_11949_91557)", children: /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M16 15.7435C15.1956 15.7435 14.5083 15.4585 13.9383 14.8885C13.3683 14.3186 13.0833 13.6314 13.0833 12.8268C13.0833 12.0224 13.3683 11.3352 13.9383 10.7652C14.5083 10.1952 15.1956 9.91016 16 9.91016C16.8044 9.91016 17.4917 10.1952 18.0617 10.7652C18.6317 11.3352 18.9167 12.0224 18.9167 12.8268C18.9167 13.6314 18.6317 14.3186 18.0617 14.8885C17.4917 15.4585 16.8044 15.7435 16 15.7435ZM9.75 20.8237V20.237C9.75 19.829 9.86083 19.4511 10.0825 19.1033C10.3042 18.7555 10.6004 18.4881 10.9712 18.3012C11.7949 17.8974 12.6258 17.5946 13.464 17.3927C14.3022 17.1907 15.1475 17.0897 16 17.0897C16.8525 17.0897 17.6978 17.1907 18.536 17.3927C19.3742 17.5946 20.2051 17.8974 21.0287 18.3012C21.3996 18.4881 21.6958 18.7555 21.9175 19.1033C22.1392 19.4511 22.25 19.829 22.25 20.237V20.8237C22.25 21.1751 22.1269 21.474 21.8806 21.7204C21.6344 21.9666 21.3355 22.0897 20.984 22.0897H11.016C10.6645 22.0897 10.3656 21.9666 10.1194 21.7204C9.87312 21.474 9.75 21.1751 9.75 20.8237Z",
          fill: "white"
        }
      ) }),
      /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M2.00065 21C1.82287 21 1.66732 20.9333 1.53398 20.8C1.40065 20.6667 1.33398 20.5111 1.33398 20.3333C1.33398 20.1556 1.40065 20 1.53398 19.8667C1.66732 19.7333 1.82287 19.6667 2.00065 19.6667C2.17843 19.6667 2.33398 19.7333 2.46732 19.8667C2.60065 20 2.66732 20.1556 2.66732 20.3333C2.66732 20.5111 2.60065 20.6667 2.46732 20.8C2.33398 20.9333 2.17843 21 2.00065 21ZM2.00065 14.6667C1.82287 14.6667 1.66732 14.6 1.53398 14.4667C1.40065 14.3333 1.33398 14.1778 1.33398 14C1.33398 13.8222 1.40065 13.6667 1.53398 13.5333C1.66732 13.4 1.82287 13.3333 2.00065 13.3333C2.17843 13.3333 2.33398 13.4 2.46732 13.5333C2.60065 13.6667 2.66732 13.8222 2.66732 14C2.66732 14.1778 2.60065 14.3333 2.46732 14.4667C2.33398 14.6 2.17843 14.6667 2.00065 14.6667ZM7.00065 27C6.62287 27 6.30621 26.8722 6.05065 26.6167C5.7951 26.3611 5.66732 26.0444 5.66732 25.6667C5.66732 25.2889 5.7951 24.9722 6.05065 24.7167C6.30621 24.4611 6.62287 24.3333 7.00065 24.3333C7.37843 24.3333 7.6951 24.4611 7.95065 24.7167C8.20621 24.9722 8.33398 25.2889 8.33398 25.6667C8.33398 26.0444 8.20621 26.3611 7.95065 26.6167C7.6951 26.8722 7.37843 27 7.00065 27ZM6.00065 21.6667C5.62287 21.6667 5.30621 21.5389 5.05065 21.2833C4.7951 21.0278 4.66732 20.7111 4.66732 20.3333C4.66732 19.9556 4.7951 19.6389 5.05065 19.3833C5.30621 19.1278 5.62287 19 6.00065 19C6.37843 19 6.6951 19.1278 6.95065 19.3833C7.20621 19.6389 7.33398 19.9556 7.33398 20.3333C7.33398 20.7111 7.20621 21.0278 6.95065 21.2833C6.6951 21.5389 6.37843 21.6667 6.00065 21.6667ZM8.00065 15.3333C7.62287 15.3333 7.30621 15.2056 7.05065 14.95C6.7951 14.6944 6.66732 14.3778 6.66732 14C6.66732 13.6222 6.7951 13.3056 7.05065 13.05C7.30621 12.7944 7.62287 12.6667 8.00065 12.6667C8.37843 12.6667 8.6951 12.7944 8.95065 13.05C9.20621 13.3056 9.33398 13.6222 9.33398 14C9.33398 14.3778 9.20621 14.6944 8.95065 14.95C8.6951 15.2056 8.37843 15.3333 8.00065 15.3333ZM13.334 28.3333C13.1562 28.3333 13.0007 28.2667 12.8673 28.1333C12.734 28 12.6673 27.8444 12.6673 27.6667C12.6673 27.4889 12.734 27.3333 12.8673 27.2C13.0007 27.0667 13.1562 27 13.334 27C13.5118 27 13.6673 27.0667 13.8007 27.2C13.934 27.3333 14.0007 27.4889 14.0007 27.6667C14.0007 27.8444 13.934 28 13.8007 28.1333C13.6673 28.2667 13.5118 28.3333 13.334 28.3333ZM13.334 6.33333C13.1562 6.33333 13.0007 6.26667 12.8673 6.13333C12.734 6 12.6673 5.84444 12.6673 5.66667C12.6673 5.48889 12.734 5.33333 12.8673 5.2C13.0007 5.06667 13.1562 5 13.334 5C13.5118 5 13.6673 5.06667 13.8007 5.2C13.934 5.33333 14.0007 5.48889 14.0007 5.66667C14.0007 5.84444 13.934 6 13.8007 6.13333C13.6673 6.26667 13.5118 6.33333 13.334 6.33333ZM18.6673 28.3333C18.4895 28.3333 18.334 28.2667 18.2007 28.1333C18.0673 28 18.0007 27.8444 18.0007 27.6667C18.0007 27.4889 18.0673 27.3333 18.2007 27.2C18.334 27.0667 18.4895 27 18.6673 27C18.8451 27 19.0007 27.0667 19.134 27.2C19.2673 27.3333 19.334 27.4889 19.334 27.6667C19.334 27.8444 19.2673 28 19.134 28.1333C19.0007 28.2667 18.8451 28.3333 18.6673 28.3333ZM18.6673 6.33333C18.4895 6.33333 18.334 6.26667 18.2007 6.13333C18.0673 6 18.0007 5.84444 18.0007 5.66667C18.0007 5.48889 18.0673 5.33333 18.2007 5.2C18.334 5.06667 18.4895 5 18.6673 5C18.8451 5 19.0007 5.06667 19.134 5.2C19.2673 5.33333 19.334 5.48889 19.334 5.66667C19.334 5.84444 19.2673 6 19.134 6.13333C19.0007 6.26667 18.8451 6.33333 18.6673 6.33333ZM26.0007 27C25.6229 27 25.3062 26.8722 25.0507 26.6167C24.7951 26.3611 24.6673 26.0444 24.6673 25.6667C24.6673 25.2889 24.7951 24.9722 25.0507 24.7167C25.3062 24.4611 25.6229 24.3333 26.0007 24.3333C26.3784 24.3333 26.6951 24.4611 26.9507 24.7167C27.2062 24.9722 27.334 25.2889 27.334 25.6667C27.334 26.0444 27.2062 26.3611 26.9507 26.6167C26.6951 26.8722 26.3784 27 26.0007 27ZM27.0007 21.6667C26.6229 21.6667 26.3062 21.5389 26.0507 21.2833C25.7951 21.0278 25.6673 20.7111 25.6673 20.3333C25.6673 19.9556 25.7951 19.6389 26.0507 19.3833C26.3062 19.1278 26.6229 19 27.0007 19C27.3784 19 27.6951 19.1278 27.9507 19.3833C28.2062 19.6389 28.334 19.9556 28.334 20.3333C28.334 20.7111 28.2062 21.0278 27.9507 21.2833C27.6951 21.5389 27.3784 21.6667 27.0007 21.6667ZM25.0007 15.3333C24.6229 15.3333 24.3062 15.2056 24.0507 14.95C23.7951 14.6944 23.6673 14.3778 23.6673 14C23.6673 13.6222 23.7951 13.3056 24.0507 13.05C24.3062 12.7944 24.6229 12.6667 25.0007 12.6667C25.3784 12.6667 25.6951 12.7944 25.9507 13.05C26.2062 13.3056 26.334 13.6222 26.334 14C26.334 14.3778 26.2062 14.6944 25.9507 14.95C25.6951 15.2056 25.3784 15.3333 25.0007 15.3333ZM31.0007 21C30.8229 21 30.6673 20.9333 30.534 20.8C30.4007 20.6667 30.334 20.5111 30.334 20.3333C30.334 20.1556 30.4007 20 30.534 19.8667C30.6673 19.7333 30.8229 19.6667 31.0007 19.6667C31.1784 19.6667 31.334 19.7333 31.4673 19.8667C31.6007 20 31.6673 20.1556 31.6673 20.3333C31.6673 20.5111 31.6007 20.6667 31.4673 20.8C31.334 20.9333 31.1784 21 31.0007 21ZM30.0007 14.6667C29.8229 14.6667 29.6673 14.6 29.534 14.4667C29.4007 14.3333 29.334 14.1778 29.334 14C29.334 13.8222 29.4007 13.6667 29.534 13.5333C29.6673 13.4 29.8229 13.3333 30.0007 13.3333C30.1784 13.3333 30.334 13.4 30.4673 13.5333C30.6007 13.6667 30.6673 13.8222 30.6673 14C30.6673 14.1778 30.6007 14.3333 30.4673 14.4667C30.334 14.6 30.1784 14.6667 30.0007 14.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M9.86797 4.13333C10.0013 4.26667 10.1569 4.33333 10.3346 4.33333C10.5124 4.33333 10.668 4.26667 10.8013 4.13333C10.9346 4 11.0013 3.84444 11.0013 3.66667C11.0013 3.48889 10.9346 3.33333 10.8013 3.2C10.668 3.06667 10.5124 3 10.3346 3C10.1569 3 10.0013 3.06667 9.86797 3.2C9.73464 3.33333 9.66797 3.48889 9.66797 3.66667C9.66797 3.84444 9.73464 4 9.86797 4.13333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M21.868 4.13333C22.0013 4.26667 22.1569 4.33333 22.3346 4.33333C22.5124 4.33333 22.668 4.26667 22.8013 4.13333C22.9346 4 23.0013 3.84444 23.0013 3.66667C23.0013 3.48889 22.9346 3.33333 22.8013 3.2C22.668 3.06667 22.5124 3 22.3346 3C22.1569 3 22.0013 3.06667 21.868 3.2C21.7346 3.33333 21.668 3.48889 21.668 3.66667C21.668 3.84444 21.7346 4 21.868 4.13333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M15.868 2.13333C16.0013 2.26667 16.1569 2.33333 16.3346 2.33333C16.5124 2.33333 16.668 2.26667 16.8013 2.13333C16.9346 2 17.0013 1.84444 17.0013 1.66667C17.0013 1.48889 16.9346 1.33333 16.8013 1.2C16.668 1.06667 16.5124 1 16.3346 1C16.1569 1 16.0013 1.06667 15.868 1.2C15.7346 1.33333 15.668 1.48889 15.668 1.66667C15.668 1.84444 15.7346 2 15.868 2.13333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M3.53398 7.46634C3.66732 7.59967 3.82287 7.66634 4.00065 7.66634C4.17843 7.66634 4.33398 7.59967 4.46732 7.46634C4.60065 7.33301 4.66732 7.17745 4.66732 6.99967C4.66732 6.8219 4.60065 6.66634 4.46732 6.53301C4.33398 6.39967 4.17843 6.33301 4.00065 6.33301C3.82287 6.33301 3.66732 6.39967 3.53398 6.53301C3.40065 6.66634 3.33398 6.8219 3.33398 6.99967C3.33398 7.17745 3.40065 7.33301 3.53398 7.46634Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M28.534 7.46634C28.6673 7.59967 28.8229 7.66634 29.0007 7.66634C29.1784 7.66634 29.334 7.59967 29.4673 7.46634C29.6006 7.33301 29.6673 7.17745 29.6673 6.99967C29.6673 6.8219 29.6006 6.66634 29.4673 6.53301C29.334 6.39967 29.1784 6.33301 29.0007 6.33301C28.8229 6.33301 28.6673 6.39967 28.534 6.53301C28.4007 6.66634 28.334 6.8219 28.334 6.99967C28.334 7.17745 28.4007 7.33301 28.534 7.46634Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M8.73464 9.65C8.86797 9.78333 9.02352 9.85 9.2013 9.85C9.37908 9.85 9.53464 9.78333 9.66797 9.65C9.8013 9.51667 9.86797 9.36111 9.86797 9.18333C9.86797 9.00556 9.8013 8.85 9.66797 8.71667C9.53464 8.58333 9.37908 8.51667 9.2013 8.51667C9.02352 8.51667 8.86797 8.58333 8.73464 8.71667C8.6013 8.85 8.53464 9.00556 8.53464 9.18333C8.53464 9.36111 8.6013 9.51667 8.73464 9.65Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M22.3346 9.65C22.468 9.78333 22.6235 9.85 22.8013 9.85C22.9791 9.85 23.1346 9.78333 23.268 9.65C23.4013 9.51667 23.468 9.36111 23.468 9.18333C23.468 9.00556 23.4013 8.85 23.268 8.71667C23.1346 8.58333 22.9791 8.51667 22.8013 8.51667C22.6235 8.51667 22.468 8.58333 22.3346 8.71667C22.2013 8.85 22.1346 9.00556 22.1346 9.18333C22.1346 9.36111 22.2013 9.51667 22.3346 9.65Z",
          fill: "white"
        }
      )
    ]
  }
), TC = () => /* @__PURE__ */ b.jsxs(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ b.jsx(
        "mask",
        {
          id: "mask0_12042_100098",
          style: { maskType: "alpha" },
          maskUnits: "userSpaceOnUse",
          x: "6",
          y: "6",
          width: "20",
          height: "20",
          children: /* @__PURE__ */ b.jsx("rect", { x: "6", y: "6", width: "20", height: "20", fill: "#D9D9D9" })
        }
      ),
      /* @__PURE__ */ b.jsx("g", { mask: "url(#mask0_12042_100098)", children: /* @__PURE__ */ b.jsx(
        "path",
        {
          d: "M16 15.7435C15.1956 15.7435 14.5083 15.4585 13.9383 14.8885C13.3683 14.3186 13.0833 13.6314 13.0833 12.8268C13.0833 12.0224 13.3683 11.3352 13.9383 10.7652C14.5083 10.1952 15.1956 9.91016 16 9.91016C16.8044 9.91016 17.4917 10.1952 18.0617 10.7652C18.6317 11.3352 18.9167 12.0224 18.9167 12.8268C18.9167 13.6314 18.6317 14.3186 18.0617 14.8885C17.4917 15.4585 16.8044 15.7435 16 15.7435ZM9.75 20.8237V20.237C9.75 19.829 9.86083 19.4511 10.0825 19.1033C10.3042 18.7555 10.6004 18.4881 10.9712 18.3012C11.7949 17.8974 12.6258 17.5946 13.464 17.3927C14.3022 17.1907 15.1475 17.0897 16 17.0897C16.8525 17.0897 17.6978 17.1907 18.536 17.3927C19.3742 17.5946 20.2051 17.8974 21.0287 18.3012C21.3996 18.4881 21.6958 18.7555 21.9175 19.1033C22.1392 19.4511 22.25 19.829 22.25 20.237V20.8237C22.25 21.1751 22.1269 21.474 21.8806 21.7204C21.6344 21.9666 21.3355 22.0897 20.984 22.0897H11.016C10.6645 22.0897 10.3656 21.9666 10.1194 21.7204C9.87312 21.474 9.75 21.1751 9.75 20.8237Z",
          fill: "white"
        }
      ) }),
      /* @__PURE__ */ b.jsxs("g", { opacity: "0.67", children: [
        /* @__PURE__ */ b.jsx(
          "path",
          {
            d: "M2.00065 19C1.82287 19 1.66732 18.9333 1.53398 18.8C1.40065 18.6667 1.33398 18.5111 1.33398 18.3333C1.33398 18.1556 1.40065 18 1.53398 17.8667C1.66732 17.7333 1.82287 17.6667 2.00065 17.6667C2.17843 17.6667 2.33398 17.7333 2.46732 17.8667C2.60065 18 2.66732 18.1556 2.66732 18.3333C2.66732 18.5111 2.60065 18.6667 2.46732 18.8C2.33398 18.9333 2.17843 19 2.00065 19ZM7.00065 27C6.62287 27 6.30621 26.8722 6.05065 26.6167C5.7951 26.3611 5.66732 26.0444 5.66732 25.6667C5.66732 25.2889 5.7951 24.9722 6.05065 24.7167C6.30621 24.4611 6.62287 24.3333 7.00065 24.3333C7.37843 24.3333 7.6951 24.4611 7.95065 24.7167C8.20621 24.9722 8.33398 25.2889 8.33398 25.6667C8.33398 26.0444 8.20621 26.3611 7.95065 26.6167C7.6951 26.8722 7.37843 27 7.00065 27ZM6.00065 21.6667C5.62287 21.6667 5.30621 21.5389 5.05065 21.2833C4.7951 21.0278 4.66732 20.7111 4.66732 20.3333C4.66732 19.9556 4.7951 19.6389 5.05065 19.3833C5.30621 19.1278 5.62287 19 6.00065 19C6.37843 19 6.6951 19.1278 6.95065 19.3833C7.20621 19.6389 7.33398 19.9556 7.33398 20.3333C7.33398 20.7111 7.20621 21.0278 6.95065 21.2833C6.6951 21.5389 6.37843 21.6667 6.00065 21.6667ZM8.00065 15.3333C7.62287 15.3333 7.30621 15.2056 7.05065 14.95C6.7951 14.6944 6.66732 14.3778 6.66732 14C6.66732 13.6222 6.7951 13.3056 7.05065 13.05C7.30621 12.7944 7.62287 12.6667 8.00065 12.6667C8.37843 12.6667 8.6951 12.7944 8.95065 13.05C9.20621 13.3056 9.33398 13.6222 9.33398 14C9.33398 14.3778 9.20621 14.6944 8.95065 14.95C8.6951 15.2056 8.37843 15.3333 8.00065 15.3333ZM13.334 28.3333C13.1562 28.3333 13.0007 28.2667 12.8673 28.1333C12.734 28 12.6673 27.8444 12.6673 27.6667C12.6673 27.4889 12.734 27.3333 12.8673 27.2C13.0007 27.0667 13.1562 27 13.334 27C13.5118 27 13.6673 27.0667 13.8007 27.2C13.934 27.3333 14.0007 27.4889 14.0007 27.6667C14.0007 27.8444 13.934 28 13.8007 28.1333C13.6673 28.2667 13.5118 28.3333 13.334 28.3333ZM13.334 6.33333C13.1562 6.33333 13.0007 6.26667 12.8673 6.13333C12.734 6 12.6673 5.84444 12.6673 5.66667C12.6673 5.48889 12.734 5.33333 12.8673 5.2C13.0007 5.06667 13.1562 5 13.334 5C13.5118 5 13.6673 5.06667 13.8007 5.2C13.934 5.33333 14.0007 5.48889 14.0007 5.66667C14.0007 5.84444 13.934 6 13.8007 6.13333C13.6673 6.26667 13.5118 6.33333 13.334 6.33333ZM18.6673 28.3333C18.4895 28.3333 18.334 28.2667 18.2007 28.1333C18.0673 28 18.0007 27.8444 18.0007 27.6667C18.0007 27.4889 18.0673 27.3333 18.2007 27.2C18.334 27.0667 18.4895 27 18.6673 27C18.8451 27 19.0007 27.0667 19.134 27.2C19.2673 27.3333 19.334 27.4889 19.334 27.6667C19.334 27.8444 19.2673 28 19.134 28.1333C19.0007 28.2667 18.8451 28.3333 18.6673 28.3333ZM18.6673 6.33333C18.4895 6.33333 18.334 6.26667 18.2007 6.13333C18.0673 6 18.0007 5.84444 18.0007 5.66667C18.0007 5.48889 18.0673 5.33333 18.2007 5.2C18.334 5.06667 18.4895 5 18.6673 5C18.8451 5 19.0007 5.06667 19.134 5.2C19.2673 5.33333 19.334 5.48889 19.334 5.66667C19.334 5.84444 19.2673 6 19.134 6.13333C19.0007 6.26667 18.8451 6.33333 18.6673 6.33333ZM26.0007 27C25.6229 27 25.3062 26.8722 25.0507 26.6167C24.7951 26.3611 24.6673 26.0444 24.6673 25.6667C24.6673 25.2889 24.7951 24.9722 25.0507 24.7167C25.3062 24.4611 25.6229 24.3333 26.0007 24.3333C26.3784 24.3333 26.6951 24.4611 26.9507 24.7167C27.2062 24.9722 27.334 25.2889 27.334 25.6667C27.334 26.0444 27.2062 26.3611 26.9507 26.6167C26.6951 26.8722 26.3784 27 26.0007 27ZM27.0007 21.6667C26.6229 21.6667 26.3062 21.5389 26.0507 21.2833C25.7951 21.0278 25.6673 20.7111 25.6673 20.3333C25.6673 19.9556 25.7951 19.6389 26.0507 19.3833C26.3062 19.1278 26.6229 19 27.0007 19C27.3784 19 27.6951 19.1278 27.9507 19.3833C28.2062 19.6389 28.334 19.9556 28.334 20.3333C28.334 20.7111 28.2062 21.0278 27.9507 21.2833C27.6951 21.5389 27.3784 21.6667 27.0007 21.6667ZM25.0007 15.3333C24.6229 15.3333 24.3062 15.2056 24.0507 14.95C23.7951 14.6944 23.6673 14.3778 23.6673 14C23.6673 13.6222 23.7951 13.3056 24.0507 13.05C24.3062 12.7944 24.6229 12.6667 25.0007 12.6667C25.3784 12.6667 25.6951 12.7944 25.9507 13.05C26.2062 13.3056 26.334 13.6222 26.334 14C26.334 14.3778 26.2062 14.6944 25.9507 14.95C25.6951 15.2056 25.3784 15.3333 25.0007 15.3333ZM31.0007 19C30.8229 19 30.6673 18.9333 30.534 18.8C30.4007 18.6667 30.334 18.5111 30.334 18.3333C30.334 18.1556 30.4007 18 30.534 17.8667C30.6673 17.7333 30.8229 17.6667 31.0007 17.6667C31.1784 17.6667 31.334 17.7333 31.4673 17.8667C31.6007 18 31.6673 18.1556 31.6673 18.3333C31.6673 18.5111 31.6007 18.6667 31.4673 18.8C31.334 18.9333 31.1784 19 31.0007 19Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "path",
          {
            d: "M8.73464 9.65C8.86797 9.78333 9.02352 9.85 9.2013 9.85C9.37908 9.85 9.53464 9.78333 9.66797 9.65C9.8013 9.51667 9.86797 9.36111 9.86797 9.18333C9.86797 9.00556 9.8013 8.85 9.66797 8.71667C9.53464 8.58333 9.37908 8.51667 9.2013 8.51667C9.02352 8.51667 8.86797 8.58333 8.73464 8.71667C8.6013 8.85 8.53464 9.00556 8.53464 9.18333C8.53464 9.36111 8.6013 9.51667 8.73464 9.65Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "path",
          {
            d: "M22.3346 9.65C22.468 9.78333 22.6235 9.85 22.8013 9.85C22.9791 9.85 23.1346 9.78333 23.268 9.65C23.4013 9.51667 23.468 9.36111 23.468 9.18333C23.468 9.00556 23.4013 8.85 23.268 8.71667C23.1346 8.58333 22.9791 8.51667 22.8013 8.51667C22.6235 8.51667 22.468 8.58333 22.3346 8.71667C22.2013 8.85 22.1346 9.00556 22.1346 9.18333C22.1346 9.36111 22.2013 9.51667 22.3346 9.65Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "path",
          {
            d: "M3.53398 10.8003C3.66732 10.9337 3.82287 11.0003 4.00065 11.0003C4.17843 11.0003 4.33398 10.9337 4.46732 10.8003C4.60065 10.667 4.66732 10.5114 4.66732 10.3337C4.66732 10.1559 4.60065 10.0003 4.46732 9.86699C4.33398 9.73366 4.17843 9.66699 4.00065 9.66699C3.82287 9.66699 3.66732 9.73366 3.53398 9.86699C3.40065 10.0003 3.33398 10.1559 3.33398 10.3337C3.33398 10.5114 3.40065 10.667 3.53398 10.8003Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "path",
          {
            d: "M27.534 10.8003C27.6673 10.9337 27.8229 11.0003 28.0007 11.0003C28.1784 11.0003 28.334 10.9337 28.4673 10.8003C28.6006 10.667 28.6673 10.5114 28.6673 10.3337C28.6673 10.1559 28.6006 10.0003 28.4673 9.86699C28.334 9.73366 28.1784 9.66699 28.0007 9.66699C27.8229 9.66699 27.6673 9.73366 27.534 9.86699C27.4007 10.0003 27.334 10.1559 27.334 10.3337C27.334 10.5114 27.4007 10.667 27.534 10.8003Z",
            fill: "white"
          }
        )
      ] })
    ]
  }
), oU = ({
  option: s,
  onSelect: r,
  selected: c,
  broken: h,
  onImageError: f
}) => {
  const { t: v } = Ua(), R = ne.useCallback(() => {
    const T = document.createElement("input");
    T.type = "file", T.accept = "image/*", T.onchange = (E) => {
      var N;
      const C = (N = E.target.files) == null ? void 0 : N[0];
      if (C) {
        const _ = {
          id: `custom-${Date.now()}`,
          type: "image",
          src: URL.createObjectURL(C),
          label: C.name,
          selected: !1
        };
        pn.setState((V) => ({
          backgrounds: [...V.backgrounds, _]
        }));
      }
    }, T.click();
  }, []);
  return s.type === "add" ? /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-virtual-background-option-wrapper", children: /* @__PURE__ */ b.jsx(
    "button",
    {
      className: "cometchat-calls-virtual-background-option cometchat-calls-virtual-background-option--add",
      onClick: R,
      "aria-label": v("virtualBackground.addBackground"),
      title: s.label,
      tabIndex: 0,
      children: /* @__PURE__ */ b.jsx(ot, { name: "add", size: 20 })
    }
  ) }) : /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-virtual-background-option-wrapper", children: [
    c && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-virtual-background-option-checkbox", children: /* @__PURE__ */ b.jsx(ot, { name: "check-fill", size: 16 }) }),
    /* @__PURE__ */ b.jsxs(
      "button",
      {
        className: wt("cometchat-calls-virtual-background-option", {
          "cometchat-calls-virtual-background-option--selected": c
        }),
        onClick: () => r(s.id),
        "aria-label": `${s.label} background${c ? ", selected" : ""}`,
        "aria-pressed": c,
        title: s.label,
        children: [
          s.type === "none" && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-virtual-background-option-none", children: /* @__PURE__ */ b.jsx(ot, { name: "remove", size: 24 }) }),
          s.type === "blur" && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-virtual-background-option-blur", children: s.id == "blur" ? /* @__PURE__ */ b.jsx(UC, {}) : /* @__PURE__ */ b.jsx(TC, {}) }),
          s.type === "image" && (h ? /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-virtual-background-option-image-fallback", children: /* @__PURE__ */ b.jsx(ot, { name: "virtual-background", size: 20, "aria-hidden": "true" }) }) : /* @__PURE__ */ b.jsx(
            "img",
            {
              className: "cometchat-calls-virtual-background-option-image",
              crossOrigin: "anonymous",
              src: s.src,
              alt: s.label ?? "",
              onError: () => f(s.id)
            }
          )),
          c && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-virtual-background-option-selected-indicator" })
        ]
      },
      s.id
    )
  ] });
}, yC = () => {
  const [s, r] = ne.useState(window.innerWidth < 768), [c, h] = ne.useState(!1), [f, v] = ne.useState(
    () => /* @__PURE__ */ new Set()
  ), { t: R } = Ua(), T = ne.useCallback((Ue) => {
    v((j) => j.has(Ue) ? j : new Set(j).add(Ue));
  }, []), E = pn((Ue) => Ue.backgrounds), C = pn(
    (Ue) => Ue.selectedBackgroundId
  );
  ne.useEffect(() => {
    var j;
    const Ue = ((j = E.find((Te) => Te.selected)) == null ? void 0 : j.id) ?? Kv;
    h(Ue !== C);
  }, [E, C]);
  const N = E.filter((Ue) => Ue.type !== "image"), _ = E.filter((Ue) => Ue.type === "image"), V = pn((Ue) => Ue.previewTrack), B = Vu(We.VIDEO), ce = _6(), oe = Y(
    (Ue) => Ue.virtualBackgroundDialogVisible
  );
  ne.useEffect(() => {
    pn.getState().selectBackground(C);
  }, [C, oe]), ne.useEffect(() => {
    const Ue = () => {
      r(window.innerWidth < 768);
    };
    return window.addEventListener("resize", Ue), () => window.removeEventListener("resize", Ue);
  }, []), ne.useEffect(() => (oe && R6("video").then((Ue) => {
    pn.setState({ previewTrack: Ue });
  }).catch((Ue) => {
    console.error("Error creating local video track:", Ue);
  }), () => {
    pn.setState({ previewTrack: void 0 });
  }), [oe]), ne.useEffect(() => {
    const Ue = (j) => {
      j.key === "Escape" && oe && r2();
    };
    if (oe)
      return document.addEventListener("keydown", Ue), () => document.removeEventListener("keydown", Ue);
  }, [oe]);
  const be = ne.useCallback((Ue) => {
    pn.getState().selectBackground(Ue);
  }, []), ge = ne.useCallback(() => {
    var j;
    const Ue = (j = E.find((Te) => Te.selected)) == null ? void 0 : j.id;
    pn.setState({
      selectedBackgroundId: Ue
    }), pn.getState().promotePreviewVirtualBackground(), r2();
  }, [E]), te = () => /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-virtual-background-preview-video-container", children: [
    /* @__PURE__ */ b.jsx(
      L6,
      {
        videoTrack: V,
        className: wt(
          "cometchat-calls-virtual-background-preview-video",
          ce && "cometchat-calls-video--mirrored"
        )
      }
    ),
    B && /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-virtual-background-preview-placeholder", children: [
      /* @__PURE__ */ b.jsx(ot, { name: "video-off", size: 48, "aria-hidden": "true" }),
      /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-virtual-background-preview-placeholder-text", children: R("virtualBackground.noCameraFeed") })
    ] })
  ] }), _e = () => /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-virtual-background-options", children: [
    /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-virtual-background-controls-row", children: N.map((Ue) => /* @__PURE__ */ b.jsx(
      oU,
      {
        option: Ue,
        selected: Ue.selected,
        onSelect: be,
        broken: !1,
        onImageError: T
      },
      Ue.id
    )) }),
    _.length > 0 && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-virtual-background-images-row", children: _.map((Ue) => /* @__PURE__ */ b.jsx(
      oU,
      {
        option: Ue,
        selected: Ue.selected,
        onSelect: be,
        broken: f.has(Ue.id),
        onImageError: T
      },
      Ue.id
    )) })
  ] });
  return oe ? /* @__PURE__ */ b.jsx(
    "div",
    {
      className: "cometchat-calls-virtual-background-overlay",
      onClick: r2,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "virtual-background-modal-title",
      children: /* @__PURE__ */ b.jsxs(
        "div",
        {
          className: `cometchat-calls-virtual-background-modal ${s ? "cometchat-calls-virtual-background-modal--mobile" : "cometchat-calls-virtual-background-modal--desktop"}`,
          onClick: (Ue) => Ue.stopPropagation(),
          children: [
            /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-virtual-background-header", children: /* @__PURE__ */ b.jsx(
              "h2",
              {
                className: "cometchat-calls-virtual-background-header-title",
                id: "virtual-background-modal-title",
                children: R("virtualBackground.title")
              }
            ) }),
            /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-virtual-background-content", children: [
              /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-virtual-background-preview", children: te() }),
              _e()
            ] }),
            /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-virtual-background-footer", children: [
              /* @__PURE__ */ b.jsx(
                "button",
                {
                  className: "cometchat-calls-virtual-background-button cometchat-calls-virtual-background-button--secondary",
                  onClick: r2,
                  "aria-label": R("virtualBackground.buttons.cancel"),
                  tabIndex: N.length + _.length + 2,
                  children: R("virtualBackground.buttons.cancel")
                }
              ),
              /* @__PURE__ */ b.jsx(
                "button",
                {
                  className: "cometchat-calls-virtual-background-button cometchat-calls-virtual-background-button--primary",
                  onClick: ge,
                  "aria-label": R("virtualBackground.buttons.done"),
                  tabIndex: N.length + _.length + 3,
                  disabled: !c,
                  children: R("virtualBackground.buttons.done")
                }
              )
            ] })
          ]
        }
      )
    }
  ) : null;
}, NC = () => {
  const [s, r] = ne.useState(!1), c = Y(
    (Te) => Te.settingsDialogVisible
  ), h = Y((Te) => Te.settingsDialogTab), [f, v] = ne.useState(!1), [R, T] = ne.useState(0), { t: E } = Ua(), C = G8(), N = lT(), _ = b6(), V = ne.useRef(null);
  ne.useEffect(() => {
    const Te = document.querySelector(
      ".cometchat-calls-control-pane"
    );
    if (!Te)
      return;
    const Ne = new ResizeObserver((Fe) => {
      for (const ye of Fe) {
        const Ve = ye.contentRect.width;
        v(Ve < 767), T(Ve);
      }
    });
    Ne.observe(Te);
    const xe = Te.offsetWidth;
    return v(xe < 767), T(xe), () => {
      Ne.disconnect();
    };
  }, []);
  const B = () => {
    r((Te) => !Te);
  }, ce = Pv(), oe = ne.useCallback(() => R < 480, [R]), be = ne.useCallback(() => N || R < 550, [R, N]), ge = He((Te) => Te.hideControlPanel), te = sT(), _e = He(
    (Te) => Te.hideLeaveSessionButton
  ), Ue = ne.useCallback(() => {
    Je.publish({
      type: st.ButtonClickListener.onLeaveSessionButtonClicked
    }), $i();
  }, []), j = ne.useCallback(() => {
    Je.publish({
      type: st.ButtonClickListener.onRaiseHandButtonClicked
    }), y6();
  }, []);
  return ge ? null : /* @__PURE__ */ b.jsxs(
    "div",
    {
      className: wt("cometchat-calls-control-pane", {
        "cometchat-calls-control-pane--mobile": f
      }),
      children: [
        /* @__PURE__ */ b.jsx(pC, {}),
        /* @__PURE__ */ b.jsx(fC, {}),
        /* @__PURE__ */ b.jsx(
          "button",
          {
            className: wt(
              "cometchat-calls-control-button",
              "cometchat-calls-control-button--raise-hand",
              {
                "cometchat-calls-control-button--active": ce,
                "cometchat-calls-control-button--hidden": oe()
              }
            ),
            onClick: j,
            "aria-label": E(ce ? "controlPanel.lowerHand" : "controlPanel.raiseHand"),
            title: E(ce ? "controlPanel.lowerHand" : "controlPanel.raiseHand"),
            children: /* @__PURE__ */ b.jsx(ot, { name: "raise-hand-fill" })
          }
        ),
        !te && /* @__PURE__ */ b.jsx(
          "button",
          {
            className: wt(
              "cometchat-calls-control-button",
              "cometchat-calls-control-button--screen-share",
              {
                "cometchat-calls-control-button--hidden": oe(),
                "cometchat-calls-control-button--active": C
              }
            ),
            onClick: C ? D6 : k6,
            "aria-label": E(C ? "controlPanel.stopScreenSharing" : "controlPanel.startScreenSharing"),
            title: E(C ? "controlPanel.stopScreenSharing" : "controlPanel.startScreenSharing"),
            children: /* @__PURE__ */ b.jsx(
              ot,
              {
                name: C ? "screen-share-stop" : "screen-share"
              }
            )
          }
        ),
        /* @__PURE__ */ b.jsx(
          "button",
          {
            className: wt(
              "cometchat-calls-control-button",
              "cometchat-calls-control-button--closed-caption",
              {
                "cometchat-calls-control-button--active": _,
                "cometchat-calls-control-button--hidden": be()
              }
            ),
            onClick: rT,
            "aria-label": "Closed Caption",
            title: "Closed Caption",
            children: /* @__PURE__ */ b.jsx(ot, { name: "closed-caption" })
          }
        ),
        /* @__PURE__ */ b.jsx(
          "button",
          {
            ref: V,
            className: wt(
              "cometchat-calls-control-button",
              "cometchat-calls-control-button--more",
              {
                "cometchat-calls-control-button--active": s
              }
            ),
            onClick: B,
            "data-testid": "cometchat-more-options-button",
            "aria-label": E("controlPanel.moreOptions"),
            title: E("controlPanel.moreOptions"),
            children: /* @__PURE__ */ b.jsx(ot, { name: "more" })
          }
        ),
        !_e && /* @__PURE__ */ b.jsx(
          "button",
          {
            className: "cometchat-calls-control-button cometchat-calls-control-button--call-end",
            onClick: Ue,
            "aria-label": E("controlPanel.leaveSession"),
            title: E("controlPanel.leaveSession"),
            children: /* @__PURE__ */ b.jsx(ot, { name: "call-end" })
          }
        ),
        /* @__PURE__ */ b.jsx(
          EC,
          {
            visible: c,
            selectedTab: h,
            onClose: dE
          }
        ),
        /* @__PURE__ */ b.jsx(yC, {}),
        /* @__PURE__ */ b.jsx(
          vC,
          {
            toggleSettings: dE,
            toggleVirtualBackground: iT,
            isVisible: s,
            onClose: B,
            anchorElement: V.current,
            isMobileView: oe()
          }
        )
      ]
    }
  );
}, bC = ({
  className: s
}) => {
  const r = HU(), c = He(
    (v) => v.hideRecordingStatusIndicator
  ), { t: h } = Ua();
  if (!r || c)
    return null;
  const f = h("indicators.recording.tooltip");
  return /* @__PURE__ */ b.jsxs(
    "div",
    {
      className: wt("cometchat-calls-recording-indicator", s),
      role: "status",
      "aria-live": "polite",
      "aria-label": f,
      title: f,
      "data-testid": "cometchat-calls-recording-indicator",
      children: [
        /* @__PURE__ */ b.jsx(
          "span",
          {
            className: "cometchat-calls-recording-indicator-dot",
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-recording-indicator-label", children: h("indicators.recording.label") })
      ]
    }
  );
}, CC = ({
  className: s
}) => {
  const r = zU(), c = He(
    (v) => v.hideStreamingStatusIndicator
  ), { t: h } = Ua();
  if (!r || c)
    return null;
  const f = h("indicators.streaming.tooltip");
  return /* @__PURE__ */ b.jsxs(
    "div",
    {
      className: wt("cometchat-calls-streaming-indicator", s),
      role: "status",
      "aria-live": "polite",
      "aria-label": f,
      title: f,
      "data-testid": "cometchat-calls-streaming-indicator",
      children: [
        /* @__PURE__ */ b.jsx(
          "span",
          {
            className: "cometchat-calls-streaming-indicator-dot",
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-streaming-indicator-label", children: h("indicators.streaming.label") })
      ]
    }
  );
}, VC = () => {
  const s = j8(), r = Y(
    (h) => h.chatButtonUnreadCount
  ), c = ne.useCallback(() => {
    nT(), Je.publish({
      type: st.ButtonClickListener.onChatButtonClicked
    });
  }, []);
  return s ? null : /* @__PURE__ */ b.jsxs(
    "button",
    {
      className: "cometchat-calls-header-action-button",
      onClick: c,
      "aria-label": "Chat",
      title: "Chat",
      "data-testid": "cometchat-calls-chat-button",
      children: [
        /* @__PURE__ */ b.jsx(ot, { name: "chat" }),
        r > 0 ? /* @__PURE__ */ b.jsx(
          "div",
          {
            className: "cometchat-calls-header-badge",
            "data-test-id": "cometchat-calls-header-badge",
            children: r > 99 ? "99+" : r
          }
        ) : null
      ]
    }
  );
}, _C = () => {
  const s = N8();
  return He((c) => c.hideSessionTimer) || s < 0 ? null : /* @__PURE__ */ b.jsx(
    "div",
    {
      className: "cometchat-calls-header-session-timer",
      "data-testid": "cometchat-session-timer",
      children: CU(s)
    }
  );
}, FC = () => {
  const [s, r] = ne.useState(!1), [c, h] = ne.useState(!1), f = ne.useRef(null), v = jv(), { t: R } = Ua(), T = [
    { id: Ai.TILE, name: R("header.layouts.tileView"), icon: "tile-fill" },
    {
      id: Ai.SIDEBAR,
      name: R("header.layouts.sideLayout"),
      icon: "sidebar"
    },
    {
      id: Ai.SPOTLIGHT,
      name: R("header.layouts.spotlight"),
      icon: "spotlight"
    }
  ];
  function E(N) {
    r(N), N ? h(N) : setTimeout(() => {
      h(N);
    }, 150);
  }
  ne.useEffect(() => {
    const N = (_) => {
      f.current && !f.current.contains(_.target) && E(!1);
    };
    return document.addEventListener("mousedown", N), () => document.removeEventListener("mousedown", N);
  }, []);
  const C = (N) => {
    yu(N), E(!1);
  };
  return /* @__PURE__ */ b.jsxs(
    "div",
    {
      className: "cometchat-calls-header-layout-dropdown",
      ref: f,
      "data-testid": "cometchat-calls-header-layout-dropdown",
      children: [
        /* @__PURE__ */ b.jsx(
          "button",
          {
            className: wt(
              "cometchat-calls-header-action-button",
              s && "cometchat-calls-header-action-button--active"
            ),
            onClick: () => {
              Je.publish({
                type: st.ButtonClickListener.onChangeLayoutButtonClicked
              }), E(!s);
            },
            children: /* @__PURE__ */ b.jsx(ot, { name: "tile-fill" })
          }
        ),
        c && /* @__PURE__ */ b.jsx(
          "div",
          {
            className: wt("cometchat-calls-header-dropdown-menu", {
              "cometchat-calls-header-dropdown-menu--opening": s,
              "cometchat-calls-header-dropdown-menu--closing": !s
            }),
            children: T.map((N) => /* @__PURE__ */ b.jsxs(
              "button",
              {
                className: wt(
                  "cometchat-calls-header-dropdown-item",
                  v === N.id && "active"
                ),
                onClick: () => C(N.id),
                children: [
                  /* @__PURE__ */ b.jsx(ot, { name: N.icon, size: 20 }),
                  /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-header-dropdown-item-name", children: N.name })
                ]
              },
              N.id
            ))
          }
        )
      ]
    }
  );
}, MC = () => {
  const s = Y(
    (v) => v.participantListVisible
  ), r = He(
    (v) => v.hideParticipantListButton
  ), c = He(
    (v) => v.hideChangeLayoutButton
  ), h = He((v) => v.title);
  return He((v) => v.hideHeaderPanel) ? null : /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-header-container", children: [
    /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-header-session-info", children: [
      /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-header-title", children: h }),
      /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-header-session-meta", children: [
        /* @__PURE__ */ b.jsx(_C, {}),
        /* @__PURE__ */ b.jsx(bC, {}),
        /* @__PURE__ */ b.jsx(CC, {})
      ] })
    ] }),
    /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-header-actions", children: [
      !r && /* @__PURE__ */ b.jsx(
        "button",
        {
          "data-testid": "cometchat-participant-list-button",
          className: wt(
            "cometchat-calls-header-action-button",
            s && "cometchat-calls-header-action-button--active"
          ),
          onClick: () => {
            tT(), Je.publish({
              type: st.ButtonClickListener.onParticipantListButtonClicked
            });
          },
          children: /* @__PURE__ */ b.jsx(ot, { name: "participants" })
        }
      ),
      /* @__PURE__ */ b.jsx(VC, {}),
      !c && /* @__PURE__ */ b.jsx(FC, {})
    ] })
  ] });
}, kC = ({
  className: s = ""
}) => {
  const r = Y(
    (_) => _.idleTimeoutModalVisible
  ), c = He(
    (_) => _.idleTimeoutPeriodAfterPrompt
  ), [h, f] = rc.useState(c), v = CU(h), R = Math.ceil(h / 6e4), { t: T } = Ua(), E = () => {
    Y.getState().restartIdealTimeoutTimer();
  }, C = (_) => {
    _.target === _.currentTarget && E();
  }, N = (_) => {
    _.key === "Escape" && E();
  };
  return ne.useEffect(() => {
    const _ = setInterval(() => {
      if (!r) {
        clearInterval(_);
        return;
      }
      f((V) => V <= 1e3 ? (clearInterval(_), $N(), 0) : V - 1e3);
    }, 1e3);
    return () => clearInterval(_);
  }, [r]), ne.useEffect(() => {
    r && f(c);
  }, [r, c]), r ? /* @__PURE__ */ b.jsx(
    "div",
    {
      className: "cometchat-calls-ideal-timeout-modal-overlay",
      onClick: C,
      role: "presentation",
      "aria-hidden": "false",
      children: /* @__PURE__ */ b.jsx(
        "div",
        {
          className: wt("cometchat-calls-ideal-timeout-modal", s),
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "ideal-timeout-title",
          "aria-describedby": "ideal-timeout-subtitle",
          onKeyDown: N,
          tabIndex: -1,
          children: /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-ideal-timeout-modal__content", children: [
            /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-ideal-timeout-modal__timer-icon", children: /* @__PURE__ */ b.jsx("span", { className: "cometchat-calls-ideal-timeout-modal__timer-text", children: v }) }),
            /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-ideal-timeout-modal__text-content", children: [
              /* @__PURE__ */ b.jsx(
                "h2",
                {
                  id: "ideal-timeout-title",
                  className: "cometchat-calls-ideal-timeout-modal__title",
                  children: T("idealTimeout.title")
                }
              ),
              /* @__PURE__ */ b.jsx(
                "p",
                {
                  id: "ideal-timeout-subtitle",
                  className: "cometchat-calls-ideal-timeout-modal__subtitle",
                  children: T("idealTimeout.subtitle").replace("{minutes}", R.toString()).replace("{plural}", R > 1 ? "s" : "")
                }
              )
            ] }),
            /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-ideal-timeout-modal__actions", children: [
              /* @__PURE__ */ b.jsx(
                "button",
                {
                  className: "cometchat-calls-ideal-timeout-modal__button cometchat-calls-ideal-timeout-modal__button--secondary",
                  onClick: E,
                  type: "button",
                  "aria-label": T("idealTimeout.buttons.stayInCall"),
                  children: T("idealTimeout.buttons.stayInCall")
                }
              ),
              /* @__PURE__ */ b.jsx(
                "button",
                {
                  className: "cometchat-calls-ideal-timeout-modal__button cometchat-calls-ideal-timeout-modal__button--primary",
                  onClick: () => $i(),
                  type: "button",
                  "aria-label": T("idealTimeout.buttons.leaveNow"),
                  autoFocus: !0,
                  children: T("idealTimeout.buttons.leaveNow")
                }
              )
            ] })
          ] })
        }
      )
    }
  ) : null;
}, DC = ({ text: s }) => /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-info-view-container", children: /* @__PURE__ */ b.jsx("p", { className: "cometchat-calls-info-view-message", children: s }) }), QC = {
  1: "var(--cometchat-calls-error-color)",
  // Poor - Red
  2: "var(--cometchat-calls-warning-color)",
  // Fair - Orange
  3: "var(--cometchat-calls-success-color)",
  // Good - Green
  4: "var(--cometchat-calls-success-color)"
  // Excellent - Green
}, xC = ({
  participantId: s
}) => {
  const r = ke(
    (v) => v.connectionQuality.get(s)
  );
  if (He(
    (v) => v.hideNetworkIndicator
  ) || r === void 0)
    return null;
  const h = (r >> 5) + 1, f = QC[h];
  return /* @__PURE__ */ b.jsx(
    ot,
    {
      name: "signal",
      size: 24,
      className: "cometchat-calls-participant-signal",
      style: { "--signal-color": f }
    }
  );
}, ZC = ({ participant: s }) => {
  const { pid: r, name: c, avatar: h, type: f, ruid: v } = s, R = s.type === "screen-share" ? "Presentation" : "", T = Vu(We.AUDIO, r), E = T ? "mic-off" : "mic", C = Pv(r, f), N = dT(
    (s == null ? void 0 : s.pid) ?? "",
    (s == null ? void 0 : s.type) ?? "human"
  );
  return /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-participant-item", children: [
    /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-participant-avatar", children: [
      /* @__PURE__ */ b.jsx(I6, { name: c, imageUrl: h, fontSize: 20 }),
      N && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-participant-pin-icon", children: /* @__PURE__ */ b.jsx(ot, { name: "pin", size: 15 }) })
    ] }),
    /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-participant-text", children: [
      /* @__PURE__ */ b.jsx("h4", { className: "cometchat-calls-participant-name", children: c }),
      R && /* @__PURE__ */ b.jsx("p", { className: "cometchat-calls-participant-description", children: R })
    ] }),
    /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-participant-icons", children: [
      C && f === "human" && /* @__PURE__ */ b.jsx(
        ot,
        {
          name: "raise-hand-fill",
          size: 22,
          className: "cometchat-calls-participant-raise-hand"
        }
      ),
      f === "screen-share" && /* @__PURE__ */ b.jsx(
        ot,
        {
          name: "screen-share",
          size: 24,
          className: "cometchat-calls-participant-screen-share"
        }
      ),
      /* @__PURE__ */ b.jsx(xC, { participantId: r }),
      /* @__PURE__ */ b.jsx(
        ot,
        {
          name: E,
          size: 24,
          className: wt(
            "cometchat-calls-participant-mic",
            T && "cometchat-calls-participant-mic--muted"
          )
        }
      ),
      /* @__PURE__ */ b.jsx(KT, { ruid: v })
    ] })
  ] });
}, OC = () => {
  const [s, r] = ne.useState(""), c = eN(), { t: h } = Ua(), f = He(
    (R) => R.hideShareInviteButton
  ), v = rc.useMemo(
    () => c.filter(
      (R) => R.name.toLowerCase().includes(s.toLowerCase())
    ),
    [c, s]
  );
  return /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-participant-list-container", children: [
    /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-participant-list-header", children: [
      /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-participant-list-header-text", children: /* @__PURE__ */ b.jsxs("h2", { className: "cometchat-calls-participant-list-title", children: [
        h("participantList.header.title"),
        " (",
        v.length,
        ")"
      ] }) }),
      /* @__PURE__ */ b.jsx(
        "button",
        {
          className: "cometchat-calls-participant-list-close-button",
          onClick: tT,
          "aria-label": h("participantList.header.closeButton"),
          children: /* @__PURE__ */ b.jsx(ot, { name: "close", size: 24 })
        }
      )
    ] }),
    /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-participant-search-container", children: [
      !f && /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-participant-list-share-invite-button-container", children: /* @__PURE__ */ b.jsxs(
        "button",
        {
          className: "cometchat-calls-participant-list-share-invite-button",
          "data-testid": "cometchat-calls-share-invite-button",
          onClick: () => {
            Je.publish({
              type: st.ButtonClickListener.onShareInviteButtonClicked
            });
          },
          type: "button",
          children: [
            /* @__PURE__ */ b.jsx(ot, { name: "invite", size: 24 }),
            "Invite User"
          ]
        }
      ) }),
      /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-participant-search-input-container", children: /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-participant-search-input-wrapper", children: [
        /* @__PURE__ */ b.jsx(ot, { name: "search", size: 24 }),
        /* @__PURE__ */ b.jsx(
          "input",
          {
            type: "text",
            placeholder: h("participantList.search.placeholder"),
            className: "cometchat-calls-participant-search-input",
            value: s,
            onChange: (R) => r(R.target.value)
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-participants-scroll-area", children: v.length === 0 ? /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-participant-list-empty-state", children: [
      /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-participant-list-empty-state-icon", children: /* @__PURE__ */ b.jsx(ot, { name: "empty-search", size: 120 }) }),
      /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-participant-list-empty-state-text", children: [
        /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-participant-list-empty-state-title", children: h("participantList.emptyState.title") }),
        /* @__PURE__ */ b.jsx("p", { className: "cometchat-calls-participant-list-empty-state-subtitle", children: h("participantList.emptyState.subtitle") })
      ] })
    ] }) : v.map((R) => /* @__PURE__ */ b.jsx(ZC, { participant: R }, R.ruid)) })
  ] });
};
function wC() {
  const s = ke((h) => h.conferenceJoined), [r, c] = ne.useState(!0);
  return ne.useEffect(() => {
    if (s) {
      const h = setTimeout(() => {
        c(!1);
      }, 300);
      return () => clearTimeout(h);
    }
  }, [s]), r ? /* @__PURE__ */ b.jsx(
    "div",
    {
      className: wt("cometchat-calls-connection-loader-overlay", {
        "cometchat-calls-connection-loader-overlay--fade-out": s
      }),
      "data-testid": "connecting-overlay",
      children: /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-connection-loader-animation" })
    }
  ) : null;
}
const BC = ({
  id: s,
  type: r = "default",
  message: c,
  buttonText: h,
  buttonAction: f,
  showCloseIcon: v = !0,
  autoClose: R = !0,
  autoCloseDelay: T = 2e3,
  onClose: E,
  className: C = ""
}) => {
  const [N, _] = ne.useState(!0), V = rc.useCallback(() => {
    _(!1), setTimeout(() => {
      E == null || E(s);
    }, 300);
  }, [s, E]);
  ne.useEffect(() => {
    if (R && T > 0) {
      const ce = setTimeout(() => {
        V();
      }, T);
      return () => clearTimeout(ce);
    }
  }, [R, T, V]);
  const B = () => {
    f == null || f(), V();
  };
  return N ? /* @__PURE__ */ b.jsxs(
    "div",
    {
      className: wt(
        "cometchat-calls-notification",
        `cometchat-calls-notification--${r}`,
        C
      ),
      role: "alert",
      "aria-live": "polite",
      children: [
        /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-notification__message", children: c }),
        h && f && /* @__PURE__ */ b.jsx(
          "button",
          {
            className: "cometchat-calls-notification__button",
            onClick: B,
            "aria-label": `${h} - ${c}`,
            type: "button",
            children: h
          }
        ),
        v && /* @__PURE__ */ b.jsx(
          "button",
          {
            className: "cometchat-calls-notification__close",
            onClick: V,
            "aria-label": "Close notification",
            type: "button",
            children: /* @__PURE__ */ b.jsx(ot, { name: "close", size: 24 })
          }
        )
      ]
    }
  ) : null;
}, AC = () => {
  const s = Su((f) => f.toasts), r = Su((f) => f.removeToast), c = He((f) => f.iAmRecorder), h = He(
    (f) => f.enableNotifications
  );
  return ne.useEffect(() => c || !h ? void 0 : Je.subscribe(
    Un.notification,
    (v) => {
      Su.getState().addToast({
        message: v.message,
        type: v.type,
        duration: v.duration ?? 3e3,
        position: v.position ?? "bottom",
        action: v.action
      });
    }
  ), [c, h]), /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-notification-container", children: s.map((f) => {
    var v, R;
    return /* @__PURE__ */ b.jsx(
      BC,
      {
        id: f.id,
        message: f.message,
        type: f.type,
        autoClose: f.duration > 0 && Number.isFinite(f.duration),
        autoCloseDelay: f.duration,
        buttonText: (v = f.action) == null ? void 0 : v.label,
        buttonAction: (R = f.action) == null ? void 0 : R.onPress,
        onClose: () => r(f.id)
      },
      f.id
    );
  }) });
};
function sU() {
  const s = Y(
    (T) => T.participantListVisible
  ), r = jv(), c = He((T) => T.unstable_headlessMode), h = He((T) => T.sessionType), f = c && h === im.VOICE, [v, R] = rc.useState(!1);
  return ne.useLayoutEffect(() => (Je.publish({
    type: Un.lifecycle.componentDidMount
  }), () => {
    Je.publish(
      {
        type: Un.lifecycle.componentWillUnmount
      },
      !0
    );
  }), []), ne.useEffect(() => {
    CT();
  }, []), ne.useEffect(() => {
    c && im.VOICE;
  }, [c, h]), ne.useEffect(() => Je.subscribe("onConnectionClosed", () => {
    setTimeout(() => {
      R(!0);
    }, 0);
  }), []), f ? v ? null : /* @__PURE__ */ b.jsx(XT, {}) : v ? /* @__PURE__ */ b.jsx(DC, { text: "The session has ended." }) : /* @__PURE__ */ b.jsxs("div", { className: "cometchat-calls-call-screen-container", children: [
    /* @__PURE__ */ b.jsxs(
      "div",
      {
        className: wt("cometchat-calls-call-screen-content-wrapper", {
          "cometchat-calls-call-screen--participant-list-open": s,
          "cometchat-calls-call-screen--sidebar-mode": r === "SIDEBAR",
          "cometchat-calls-call-screen--spotlight-mode": r === "SPOTLIGHT"
        }),
        children: [
          /* @__PURE__ */ b.jsxs(
            "div",
            {
              className: "cometchat-calls-call-screen-main-content",
              style: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                boxSizing: "border-box"
              },
              onClick: Y.getState().restartIdealTimeoutTimer,
              children: [
                /* @__PURE__ */ b.jsx(MC, {}),
                /* @__PURE__ */ b.jsx(
                  "div",
                  {
                    className: "cometchat-calls-call-stage-wrapper",
                    ref: (T) => {
                      if (T) {
                        const E = new ResizeObserver(
                          kU((C) => {
                            for (const N of C) {
                              const { width: _, height: V } = N.contentRect;
                              Y.setState({
                                mainAreaDimension: {
                                  width: _,
                                  height: V
                                }
                              });
                            }
                          }, 1e3)
                        );
                        return E.observe(T), () => E.disconnect();
                      }
                    },
                    children: /* @__PURE__ */ b.jsx(dC, {})
                  }
                ),
                /* @__PURE__ */ b.jsx(hC, {}),
                /* @__PURE__ */ b.jsx(NC, {}),
                /* @__PURE__ */ b.jsx(wC, {})
              ]
            }
          ),
          /* @__PURE__ */ b.jsx("div", { className: "cometchat-calls-participant-list-wrapper", children: /* @__PURE__ */ b.jsx(OC, {}) })
        ]
      }
    ),
    /* @__PURE__ */ b.jsx(kC, {}),
    /* @__PURE__ */ b.jsx(Qb, {}),
    /* @__PURE__ */ b.jsx(AC, {}),
    /* @__PURE__ */ b.jsx(mC, {})
  ] });
}
let vu = null;
function lU(s) {
  vu ? vu.render(/* @__PURE__ */ b.jsx(sU, {})) : (vu = Sb.createRoot(s), vu.render(/* @__PURE__ */ b.jsx(sU, {})));
}
Je.subscribe(
  st.SessionStatusListener.onConnectionClosed,
  () => {
    setTimeout(() => {
      vu && (vu.unmount(), vu = null);
    }, 0);
  }
);
const IC = "WEB", LC = 30, cU = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
let BR = null;
function JC(s) {
  let r = "";
  for (let c = 0; c < s; c++)
    r += cU.charAt(Math.floor(Math.random() * cU.length));
  return r;
}
function dU(s = !1) {
  if (BR === null || s) {
    const r = "5.1.0".replace(/\./g, "_");
    BR = `${IC}-${r}-${JC(LC)}-${Date.now()}`;
  }
  return BR;
}
const WC = /* @__PURE__ */ B6([
  /* @__PURE__ */ ns("eu"),
  /* @__PURE__ */ ns("us"),
  /* @__PURE__ */ ns("in"),
  /* @__PURE__ */ ns("EU"),
  /* @__PURE__ */ ns("US"),
  /* @__PURE__ */ ns("IN")
]), HC = /* @__PURE__ */ sb(
  /* @__PURE__ */ bi(),
  /* @__PURE__ */ IT((s) => s.toLowerCase()),
  WC
), uU = /* @__PURE__ */ R2({
  appId: /* @__PURE__ */ bi(),
  region: HC,
  authKey: /* @__PURE__ */ gu(/* @__PURE__ */ bi()),
  adminHost: /* @__PURE__ */ gu(/* @__PURE__ */ bi()),
  clientHost: /* @__PURE__ */ gu(/* @__PURE__ */ bi()),
  host: /* @__PURE__ */ gu(/* @__PURE__ */ bi())
});
function zC(s) {
  var h;
  const r = s.callsSDK ?? {}, c = {
    appId: s.appId,
    // Region validation/normalisation is handled by CallAppSettingsSchema, mirroring init().
    region: s.region
  };
  return (h = s.credentials) != null && h.authKey && (c.authKey = s.credentials.authKey), r.adminHost && (c.adminHost = r.adminHost), r.clientHost && (c.clientHost = r.clientHost), r.host && (c.host = r.host), c;
}
const jC = {
  LAYOUT: Ai,
  TYPE: im,
  CAMERA_FACING: Dv
}, qT = /* @__PURE__ */ R2({
  message: /* @__PURE__ */ bi(),
  devMessage: /* @__PURE__ */ bi(),
  source: /* @__PURE__ */ bi(),
  code: /* @__PURE__ */ bi()
}), $T = /* @__PURE__ */ R2({
  baseURL: /* @__PURE__ */ bi(),
  method: /* @__PURE__ */ gu(
    /* @__PURE__ */ B6([
      /* @__PURE__ */ ns("GET"),
      /* @__PURE__ */ ns("POST"),
      /* @__PURE__ */ ns("PUT"),
      /* @__PURE__ */ ns("DELETE")
    ]),
    "GET"
  ),
  endpoint: /* @__PURE__ */ bi(),
  headers: /* @__PURE__ */ JT(/* @__PURE__ */ bi(), /* @__PURE__ */ bi()),
  body: /* @__PURE__ */ gu(/* @__PURE__ */ WT())
});
async function Td({
  baseURL: s,
  method: r = "GET",
  endpoint: c,
  headers: h,
  body: f
}) {
  const v = /* @__PURE__ */ sc($T, {
    baseURL: s,
    method: r,
    endpoint: c,
    headers: h,
    body: f
  });
  if (!v.success)
    return {
      data: null,
      error: {
        name: "VALIDATION_ERROR",
        message: "Invalid request parameters: " + v.issues.map((V) => V.message).join(", "),
        timestamp: Date.now()
      }
    };
  const R = `${s}/${c}`, T = {
    method: r,
    headers: h
  };
  f && r !== "GET" && (T.body = typeof f == "string" ? f : JSON.stringify(f));
  const { data: E, error: C } = await rr(
    fetch(R, T)
  );
  if (C)
    return {
      data: null,
      error: {
        name: "NETWORK_ERROR",
        message: `Network request failed: ${C.message}`,
        details: C,
        timestamp: Date.now()
      }
    };
  const { data: N, error: _ } = await rr(
    E.json()
  );
  if (_)
    return {
      data: null,
      error: {
        name: "UNKNOWN_ERROR",
        message: `Failed to parse response JSON: ${_.message}`,
        timestamp: Date.now()
      }
    };
  if (N.error) {
    const V = /* @__PURE__ */ sc(
      qT,
      N.error
    );
    return V.success ? {
      data: null,
      error: {
        name: "COMET_CHAT_API_ERROR",
        message: V.output.message,
        details: V.output,
        timestamp: Date.now()
      }
    } : {
      data: null,
      error: {
        name: "UNKNOWN_ERROR",
        message: "Unknown API error format received from server",
        timestamp: Date.now()
      }
    };
  }
  return {
    data: N.data,
    error: null
  };
}
async function PC({
  baseURL: s,
  method: r = "GET",
  endpoint: c,
  headers: h,
  body: f
}) {
  const v = /* @__PURE__ */ sc($T, {
    baseURL: s,
    method: r,
    endpoint: c,
    headers: h,
    body: f
  });
  if (!v.success)
    return {
      data: null,
      meta: null,
      error: {
        name: "VALIDATION_ERROR",
        message: "Invalid request parameters: " + v.issues.map((V) => V.message).join(", "),
        timestamp: Date.now()
      }
    };
  const R = `${s}/${c}`, T = {
    method: r,
    headers: h
  };
  f && r !== "GET" && (T.body = typeof f == "string" ? f : JSON.stringify(f));
  const { data: E, error: C } = await rr(
    fetch(R, T)
  );
  if (C)
    return {
      data: null,
      meta: null,
      error: {
        name: "NETWORK_ERROR",
        message: `Network request failed: ${C.message}`,
        details: C,
        timestamp: Date.now()
      }
    };
  const { data: N, error: _ } = await rr(
    E.json()
  );
  if (_)
    return {
      data: null,
      meta: null,
      error: {
        name: "BAD_RESPONSE",
        message: `Failed to parse response JSON: ${_.message}`,
        timestamp: Date.now()
      }
    };
  if (N.error) {
    const V = /* @__PURE__ */ sc(
      qT,
      N.error
    );
    return V.success ? {
      data: null,
      meta: null,
      error: {
        name: "COMET_CHAT_API_ERROR",
        message: V.output.message,
        details: V.output,
        timestamp: Date.now()
      }
    } : {
      data: null,
      meta: null,
      error: {
        name: "BAD_RESPONSE",
        message: "Unknown API error format received from server",
        timestamp: Date.now()
      }
    };
  }
  return {
    data: N.data ?? null,
    meta: N.meta ?? null,
    error: null
  };
}
const ey = "javascript", GC = "web", s6 = "manual", YC = "ai-agent", ty = "cc_callssdk_session_hash", ny = "cc_callssdk_integration_source", hU = "cc_callssdk_device_id", XC = 2e3;
function KC() {
  try {
    const s = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : void 0;
    return s ? !!s.CometChat : !1;
  } catch {
    return !1;
  }
}
function qC() {
  return !KC();
}
function $C(s) {
  try {
    if (typeof window > "u") return;
    const r = {
      platform: ey,
      version: s
    };
    window.getCometChatCallSDKInfo = () => r;
  } catch {
  }
}
async function eV(s, r, c, h) {
  const f = `${s}|${r}|${c}|${h}`;
  try {
    if (typeof crypto < "u" && crypto.subtle && typeof TextEncoder < "u") {
      const R = new TextEncoder().encode(f), T = await crypto.subtle.digest("SHA-256", R);
      return Array.from(new Uint8Array(T)).map((E) => E.toString(16).padStart(2, "0")).join("");
    }
  } catch {
  }
  let v = 0;
  for (let R = 0; R < f.length; R++)
    v = Math.imul(31, v) + f.charCodeAt(R) | 0;
  return `fp_${(v >>> 0).toString(16)}`;
}
function iy(s, r) {
  return `${s}:${r}`;
}
const ay = /* @__PURE__ */ new Map(), ry = /* @__PURE__ */ new Map(), mU = /* @__PURE__ */ new Map(), AR = /* @__PURE__ */ new Set();
function U2() {
  try {
    if (typeof localStorage > "u" || localStorage === null)
      return !1;
    const s = "__cc_callssdk_probe__";
    return localStorage.setItem(s, "1"), localStorage.removeItem(s), !0;
  } catch {
    return !1;
  }
}
function J6(s, r) {
  try {
    return localStorage.getItem(iy(s, r));
  } catch {
    return null;
  }
}
function W6(s, r, c) {
  try {
    localStorage.setItem(iy(s, r), c);
  } catch {
  }
}
function tV(s) {
  return U2() ? J6(s, ty) : ay.get(s) ?? null;
}
function nV(s, r) {
  U2() ? W6(s, ty, r) : ay.set(s, r);
}
function iV(s, r) {
  try {
    if (!s) return;
    U2() ? W6(s, ny, r) : ry.set(s, r);
  } catch {
  }
}
function aV(s) {
  try {
    return (U2() ? J6(s, ny) : ry.get(s) ?? null) || s6;
  } catch {
    return s6;
  }
}
function rV(s) {
  if (U2()) {
    const h = J6(s, hU);
    if (h) return h;
    const f = pU();
    return W6(s, hU, f), f;
  }
  const r = mU.get(s);
  if (r) return r;
  const c = pU();
  return mU.set(s, c), c;
}
function pU() {
  return "web_" + Math.random().toString(36).slice(2, 11) + Date.now().toString(36);
}
function oV() {
  try {
    if (typeof window > "u" || !window.location) return !1;
    const s = window.location.hostname;
    return s === "localhost" || s === "127.0.0.1" || /^\d{1,3}(\.\d{1,3}){3}$/.test(s);
  } catch {
    return !1;
  }
}
function sV() {
  try {
    const s = -(/* @__PURE__ */ new Date()).getTimezoneOffset(), r = s >= 0 ? "+" : "-", c = Math.abs(s), h = String(Math.floor(c / 60)).padStart(2, "0"), f = String(c % 60).padStart(2, "0");
    return `${r}${h}:${f}`;
  } catch {
    return "";
  }
}
function lV() {
  try {
    return typeof window > "u" || !window.location ? "" : window.location.hostname ?? "";
  } catch {
    return "";
  }
}
function cV(s) {
  return /Chrome/.test(s) && !/Edge/.test(s) ? "Google Chrome" : /Firefox/.test(s) ? "Mozilla Firefox" : /Safari/.test(s) && !/Chrome/.test(s) ? "Safari" : /Edge/.test(s) ? "Microsoft Edge" : /Trident\/7\./.test(s) ? "Internet Explorer" : /Opera\//.test(s) || /OPR\//.test(s) ? "Opera" : "Unknown Browser";
}
function dV(s) {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    s
  );
}
function uV() {
  try {
    return typeof window > "u" || typeof window.matchMedia != "function" ? "Unknown" : window.matchMedia("(orientation: portrait)").matches ? "Portrait" : window.matchMedia("(orientation: landscape)").matches ? "Landscape" : "Unknown";
  } catch {
    return "Unknown";
  }
}
function hV(s, r, c, h) {
  const f = typeof navigator < "u" ? navigator : {}, v = typeof screen < "u" ? screen : {}, R = f.userAgent ?? "";
  return {
    sessionId: r,
    data: {
      // Mirrors the Chat JS sibling: `integrationSource` is the first `data` key.
      // Read from the source persisted at init time (init → "manual",
      // initFromSettings → "ai-agent"); defaults to "manual" when un-tracked.
      integrationSource: aV(s.appId),
      cometchat: {
        // Standalone case: callssdk is PRIMARY, no chatsdk key (net-new shape, PRE-1).
        callssdk: { platform: ey, version: s.callsSdkVersion }
      },
      app: {
        url: lV(),
        debug: h,
        browser: cV(R),
        isMobileBrowser: dV(R)
      },
      device: {
        id: c,
        platform: GC,
        language: f.language ?? "",
        resolution: v.width && v.height ? `${v.width} × ${v.height}` : "",
        userAgent: R,
        timezone: sV(),
        os: { name: pV(R) }
      },
      meta: {
        network: mV(f),
        deviceOrientation: uV()
      }
    },
    generatedAt: Math.ceil(Date.now() / 1e3)
    // NUMBER — Unix epoch seconds
  };
}
function mV(s) {
  var r;
  try {
    return (r = s == null ? void 0 : s.connection) == null ? void 0 : r.effectiveType;
  } catch {
    return;
  }
}
function pV(s) {
  return /Windows/.test(s) ? "Windows" : /Android/.test(s) ? "Android" : /iPhone|iPad|iPod/.test(s) ? "iOS" : /Mac/.test(s) ? "Mac OS" : /Linux/.test(s) ? "Linux" : "Unknown";
}
async function fV(s) {
  try {
    if (!qC() || !s.authToken || !s.appId) return;
    const r = gV(), c = oV(), h = await eV(
      s.appId,
      r,
      s.callsSdkVersion,
      c
    );
    if (tV(s.appId) === h) return;
    const f = `${s.appId}:${h}`;
    if (AR.has(f)) return;
    AR.add(f);
    try {
      const v = rV(s.appId), R = hV(s, h, v, c), { error: T } = await vV(
        Td({
          baseURL: s.apiclientBaseURL,
          method: "POST",
          endpoint: "user_sessions",
          headers: {
            "Content-Type": "application/json",
            authToken: s.authToken,
            appId: s.appId
          },
          body: R
        }),
        XC
      );
      T || nV(s.appId, h);
    } finally {
      AR.delete(f);
    }
  } catch {
  }
}
function gV() {
  var s, r, c;
  try {
    return (typeof globalThis < "u" ? globalThis : {}).__CC_APP_VERSION__ ?? (typeof document < "u" ? (c = (r = (s = document == null ? void 0 : document.querySelector) == null ? void 0 : s.call(document, 'meta[name="app-version"]')) == null ? void 0 : r.getAttribute) == null ? void 0 : c.call(r, "content") : null) ?? "";
  } catch {
    return "";
  }
}
async function vV(s, r) {
  let c;
  try {
    return await Promise.race([
      s.then((h) => ({ error: h.error })),
      new Promise((h) => {
        c = setTimeout(() => h({ error: new Error("timeout") }), r);
      })
    ]);
  } finally {
    c && clearTimeout(c);
  }
}
const fU = {
  CALL_LIST: "calls"
}, l6 = "__APP_ID__", c6 = "__REGION__", gU = `https://${l6}.call-${c6}.cometchat.io/v3.0/`, vU = (s) => new Promise((r) => {
  const c = new Headers();
  if (c.append("Accept", "application/json"), typeof s.headers == "object")
    for (const f in s.headers)
      c.append(f, s.headers[f]);
  const h = {
    method: "GET",
    headers: c
  };
  fetch(s.url, h).then((f) => f.json()).then((f) => {
    r({
      error: null,
      data: f
    });
  }).catch((f) => {
    r({
      error: f,
      data: void 0
    });
  });
});
function SV(s) {
  const r = [];
  for (let c in s)
    r.push(encodeURIComponent(c) + "=" + encodeURIComponent(s[c]));
  return r.join("&");
}
class H6 {
  /**
   * Sets the app settings for the APIHandler class.
   * @param appSettings - The CallAppSettings object containing the app settings.
   */
  static setAppSettings(r) {
    this.appSettings = r;
  }
  /**
   * Gets the call log list for the given filter parameters and authentication token.
   * @param params - The object containing the filter parameters.
   * @param authToken - The authentication token.
   * @returns A Promise that resolves to an array of call log objects.
   */
  static async getCallLogList(r, c) {
    let h = gU.replace(l6, this.appSettings.appId).replace(
      c6,
      this.appSettings.region
    );
    this.appSettings.host && (h = this.appSettings.host);
    const f = SV(r), v = `${h}${fU.CALL_LIST}?${f}`;
    return vU({
      url: v,
      headers: {
        authToken: c
      }
    });
  }
  /**
   * Gets the call details for the given session ID and authentication token.
   * @param sessionID - The session ID for which the call details are to be fetched.
   * @param authToken - The authentication token.
   * @returns A Promise that resolves to a call details object.
   */
  static async getCallDetails(r, c) {
    let h = gU.replace(l6, this.appSettings.appId).replace(
      c6,
      this.appSettings.region
    );
    return this.appSettings.host && (h = this.appSettings.host), vU({
      url: `${h}${fU.CALL_LIST}/${r}`,
      headers: {
        authToken: c
      }
    });
  }
}
x(H6, "appSettings");
class RV {
  constructor(r) {
    x(this, "appId");
    x(this, "region");
    // host is an optional parameter, it will be used for on-premises support.
    x(this, "host");
    this.appId = r.appId, this.region = r.region, this.host = r.host;
  }
  setAppId(r) {
    return this.appId = r, this;
  }
  setRegion(r) {
    return this.region = r, this;
  }
  setHost(r) {
    return this.host = r, this;
  }
  getAppId() {
    return this.appId;
  }
  getRegion() {
    return this.region;
  }
  getHost() {
    return this.host;
  }
}
class EV {
  constructor() {
    x(this, "appId");
    x(this, "region");
    // host is an optional parameter, it will be used for on-premises support.
    x(this, "host");
  }
  /**
   * Method to set appId of the app.
   * @param {string} appId appId of the app
   * @returns
   */
  setAppId(r) {
    return this.appId = r, this;
  }
  /**
   * Method to set region of the app.
   * @param {Region} region region of the app.
   * @returns {void}
   */
  setRegion(r) {
    return this.region = r, this;
  }
  /**
   * Method to set host/domain of the app.
   * @param {string} host host/domain of the app.
   * @returns {void}
   */
  setHost(r) {
    return this.host = r, this;
  }
  /**
   * This method will return an object of the CallsAppSettings class.
   * @returns {CallAppSettings} Returns the CallsAppSettings instance
   */
  build() {
    return new RV(this);
  }
}
const cn = {
  MODE: {
    DEFAULT: "DEFAULT"
  },
  RECEIVER_TYPE_USER: "user",
  CALL_KEYS: {
    CALL_DATA: "data",
    CALL_RECEIVER: "receiver",
    CALL_INITIATOR: "initiator",
    CALL_ENTITIES: "entities",
    CALL_ENTITY: "entity"
  }
}, d6 = {
  CALL_ALREADY_INITIATED: {
    code: "CALL_ALREADY_INITIATED",
    name: "CALL_ALREADY_INITIATED",
    message: "There is already call in progress",
    details: {}
  },
  ERROR_IN_CALLING: {
    code: "CALL_IN_PROGRESS",
    name: "CALL_ALREADY_INITIATED",
    message: "There is already call in progress",
    details: {}
  },
  CANNOT_ACCEPT_CALL: {
    code: "CALL_IN_PROGRESS",
    name: "CALL_IN_PROGRESS",
    message: "There is already a call in progress",
    details: {}
  },
  NOT_INITIALIZED: {
    code: "NOT_INITIALIZED",
    name: "NOT_INITIALIZED",
    message: "Please call the CometChat.init() method before calling any other methods related to CometChat.",
    details: {}
  },
  NOT_LOGGED_IN: {
    code: "NOT_LOGGED_IN",
    name: "NOT_LOGGED_IN",
    message: "Please login before starting a call.",
    details: {}
  },
  SESSION_ID_REQUIRED: {
    code: "SESSION_ID_REQUIRED",
    name: "SESSION_ID_REQUIRED",
    message: "Please make sure you are passing correct session id.",
    details: {}
  },
  CALL_SETTINGS_REQUIRED: {
    code: "CALL_SETTINGS_REQUIRED",
    name: "CALL_SETTINGS_REQUIRED",
    message: "Please make sure you are passing the call settings object.",
    details: {}
  },
  JWT_NOT_FOUND: {
    code: "JWT_NOT_FOUND",
    name: "JWT_NOT_FOUND",
    message: "There was some issue while fetching JWT from API.",
    details: {}
  }
};
class ts {
  constructor(r) {
    x(this, "defaultLayout");
    x(this, "isAudioOnly");
    x(this, "mode");
    x(this, "ShowEndCallButton");
    x(this, "ShowMuteAudioButton");
    x(this, "ShowPauseVideoButton");
    x(this, "ShowScreenShareButton");
    x(this, "ShowSwitchModeButton");
    x(this, "StartAudioMuted");
    x(this, "StartVideoMuted");
    // TODO below
    x(this, "localizedObject");
    x(this, "ShowRecordingButton");
    x(this, "idleTimeoutPeriod");
    x(this, "StartRecordingOnCallStart");
    x(this, "callListener");
    x(this, "ShowSwitchToVideoCallButton");
    x(this, "VirtualBackground");
    x(this, "ShowVirtualBackgroundSetting");
    this.defaultLayout = r.defaultLayout, this.isAudioOnly = r.isAudioOnly, this.mode = r.mode, this.ShowEndCallButton = r.ShowEndCallButton, this.ShowMuteAudioButton = r.ShowMuteAudioButton, this.ShowPauseVideoButton = r.ShowPauseVideoButton, this.ShowScreenShareButton = r.ShowScreenShareButton, this.ShowSwitchModeButton = r.ShowSwitchModeButton, this.StartAudioMuted = r.StartAudioMuted, this.StartVideoMuted = r.StartVideoMuted, this.localizedObject = r.localizedObject, this.ShowRecordingButton = r.ShowRecordingButton, this.idleTimeoutPeriod = r.idleTimeoutPeriod, this.StartRecordingOnCallStart = r.StartRecordingOnCallStart, this.callListener = r.callListener, this.ShowSwitchToVideoCallButton = r.ShowSwitchToVideoCallButton, this.VirtualBackground = r.virtualBackground, this.ShowVirtualBackgroundSetting = r.ShowVirtualBackgroundSetting;
  }
  getCallListener() {
    return this.callListener;
  }
  isRecordingButtonEnabled() {
    return this.ShowRecordingButton;
  }
  getIdleTimeoutPeriod() {
    return this.idleTimeoutPeriod;
  }
  shouldStartRecordingOnCallStart() {
    return this.StartRecordingOnCallStart;
  }
  isAudioOnlyCall() {
    return this.isAudioOnly;
  }
  isDefaultLayoutEnabled() {
    return this.defaultLayout;
  }
  getMode() {
    return this.mode;
  }
  getStartWithAudioMuted() {
    return this.StartAudioMuted;
  }
  getStartWithVideoMuted() {
    return this.StartVideoMuted;
  }
  isEndCallButtonEnabled() {
    return this.ShowEndCallButton;
  }
  isMuteAudioButtonEnabled() {
    return this.ShowMuteAudioButton;
  }
  isPauseVideoButtonEnabled() {
    return this.ShowPauseVideoButton;
  }
  isScreenShareButtonEnabled() {
    return this.ShowScreenShareButton;
  }
  isModeButtonEnabled() {
    return this.ShowSwitchModeButton;
  }
  getLocalizedStringObject() {
    return this.localizedObject;
  }
  isAudioToVideoButtonEnabled() {
    return this.ShowSwitchToVideoCallButton;
  }
  getVirtualBackground() {
    return this.VirtualBackground;
  }
  isVirtualBackgroundSettingEnabled() {
    return this.ShowVirtualBackgroundSetting;
  }
}
x(ts, "POSITION_TOP_LEFT", "top-left"), x(ts, "POSITION_TOP_RIGHT", "top-right"), x(ts, "POSITION_BOTTOM_LEFT", "bottom-left"), x(ts, "POSITION_BOTTOM_RIGHT", "bottom-right"), x(ts, "POSITION", {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right"
}), x(ts, "ASPECT_RATIO_DEFAULT", "default"), x(ts, "ASPECT_RATIO_CONTAIN", "contain"), x(ts, "ASPECT_RATIO_COVER", "cover"), x(ts, "ASPECT_RATIO", {
  DEFAULT: "default",
  CONTAIN: "contain",
  COVER: "cover"
});
class UV {
  constructor() {
    /** @private */
    x(this, "defaultLayout", !0);
    /** @private */
    x(this, "isAudioOnly", !1);
    /** @private */
    x(this, "mode", cn.MODE.DEFAULT);
    /** @private */
    x(this, "ShowEndCallButton", !0);
    /** @private */
    x(this, "ShowMuteAudioButton", !0);
    /** @private */
    x(this, "ShowPauseVideoButton", !0);
    /** @private */
    x(this, "ShowScreenShareButton", !0);
    /** @private */
    x(this, "ShowSwitchModeButton", !0);
    /** @private */
    x(this, "StartAudioMuted", !1);
    /** @private */
    x(this, "StartVideoMuted", !1);
    /** @private */
    x(this, "localizedObject", {});
    /** @private */
    x(this, "ShowRecordingButton", !1);
    /** @private */
    x(this, "idleTimeoutPeriod", 180);
    /** @private */
    x(this, "StartRecordingOnCallStart", !1);
    /** @private */
    x(this, "ShowSwitchToVideoCallButton", !0);
    /** @private */
    x(this, "virtualBackground", new yV().build());
    /** @private */
    x(this, "ShowVirtualBackgroundSetting", !0);
    /** @private */
    x(this, "callListener");
  }
  /**
   *
   * @param {boolean} defaultLayout
   * This methods shows/hides the default button layout.
   * If set to true the default button layout will be shown.
   * If set to false the default button layout will be hidden.
   * Default value is true
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  enableDefaultLayout(r) {
    return this.defaultLayout = r, this;
  }
  /**
   *
   * @param {boolean} isAudioOnly
   * This methods sets the type(audio/video) of the call.
   * If set to true, the call will be strictly an audio call.
   * If set to false, the call will be an audio-video call.
   * Default value is false
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  setIsAudioOnlyCall(r) {
    return this.isAudioOnly = r, this;
  }
  /**
   *
   * @param {string} mode
   * This method sets the mode of the call.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  setMode(r) {
    return this.mode = r, this;
  }
  /**
   *
   * @param {boolean} showEndCallButton
   * This method shows/hides the end call button.
   * If set to true it will display the end call button.
   * If set to false it will hide the end call button.
   * Default value is true.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  showEndCallButton(r) {
    return this.ShowEndCallButton = r, this;
  }
  /**
   *
   * @param {boolean} showMuteAudioButton
   * This method shows/hides the mute audio button.
   * If set to true it will display the mute audio button.
   * If set to false it will hide the mute audio button.
   * Default value is true.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  showMuteAudioButton(r) {
    return this.ShowMuteAudioButton = r, this;
  }
  /**
   *
   * @param {boolean} showPauseVideoButton
   * This method shows/hides the pause video button.
   * If set to true it will display the pause video button.
   * If set to false it will hide the pause video button.
   * Default value is true.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  showPauseVideoButton(r) {
    return this.ShowPauseVideoButton = r, this;
  }
  /**
   *
   * @param {boolean} showScreenShareButton
   * This method shows/hides the screen share button.
   * If set to true it will display the screen share button.
   * If set to false it will hide the screen share button.
   * Default value is true.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  showScreenShareButton(r) {
    return this.ShowScreenShareButton = r, this;
  }
  /**
   *
   * @param {boolean} showModeButton
   * This method shows/hides the switch mode button.
   * If set to true it will display the switch mode button.
   * If set to false it will hide the switch mode button.
   * Default value is true.
   * @returns
   */
  showModeButton(r) {
    return this.ShowSwitchModeButton = r, this;
  }
  /**
   *
   * @param {Object} localizedStringObject
   * This method will set the localized text in the call screen.
   * @returns
   */
  setLocalizedStringObject(r) {
    return console.error("setLocalizedStringObject is deprecated and have no effect."), this.localizedObject = r, this;
  }
  /**
   *
   * @param {boolean} audioMuted
   * This method allows the call to be started with audio muted.
   * If set to true, the call will start with audio muted.
   * Default value is false.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  startWithAudioMuted(r) {
    return this.StartAudioMuted = r, this;
  }
  /**
   *
   * @param {boolean} videoMuted
   * This method allows the call to be started with video muted.
   * If set to true, the call will start with video muted.
   * Default value is false.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  startWithVideoMuted(r) {
    return this.StartVideoMuted = r, this;
  }
  /**
   *
   * @param {boolean} customCSS
   * This method will set the custom CSS of the call screen.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setCustomCSS(r) {
    return console.error("setCustomCSS is deprecated and have no effect."), this;
  }
  /**
   *
   * @param {boolean} showRecordingButton
   * This method shows/hides the recording button.
   * If set to true it will display the recording button.
   * If set to false it will hide the recording button.
   * Default value is false.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  showRecordingButton(r) {
    return this.ShowRecordingButton = r, this;
  }
  /**
   *
   * @param {number} idleTimeoutPeriod
   * This method sets the idle timeout period for the call.
   * If set and you are the only one in call, the call will end
   * after the idle timeout period, giving you the option to
   * extend the call 60 seconds before the call ends.
   * Default value is 180 seconds.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  setIdleTimeoutPeriod(r) {
    return this.idleTimeoutPeriod = r, this;
  }
  /**
   *
   * @param {boolean} startRecordingOnCallStart
   * This method starts the recording as soon as the call start.
   * If set to true it will start the recording as soon as the call start.
   * Default value is false.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  startRecordingOnCallStart(r) {
    return this.StartRecordingOnCallStart = r, this;
  }
  /**
   *
   * @param {boolean} _showAudioToVideoSwitchButton
   * This method shows/hides the switch to video call button.
   * If set to true it will display the switch to video call button.
   * If set to false it will hide the switch to video call button.
   * Default value is true.
   * @returns
   */
  showSwitchToVideoCallButton(r) {
    return console.error(
      "showSwitchToVideoCallButton is deprecated and has no effect."
    ), this;
  }
  /**
   *
   * @param {VirtualBackground} virtualBackground
   * This method will set the virtual background setting.
   * This methods takes an Object of VirtualBackground Class.
   * @returns
   */
  setVirtualBackground(r) {
    return this.virtualBackground = r, this;
  }
  /**
   *
   * @param {MainVideoContainerSetting} mainVideoContainerSetting
   * This method can be used to customize the main video container.
   * @deprecated This method is deprecated and not supported.
   * @returns
   */
  setMainVideoContainerSetting(r) {
    return this;
  }
  /**
   *
   * @param {boolean} showVirtualBackgroundSetting
   * This method shows/hides the virtual background setting button.
   * If set to true it will display the virtual background setting button.
   * If set to false it will hide the virtual background setting button.
   * Default value is true.
   * @returns
   */
  showVirtualBackgroundSetting(r) {
    return this.ShowVirtualBackgroundSetting = r, this;
  }
  /**
   *
   * @param {OngoingCallListener} callListener
   * This method can be used to subscribe to available callings events
   * @returns
   */
  setCallListener(r) {
    return this.callListener = r, this;
  }
  /**
   * This method will return an object of the CallSettings class.
   * @returns {CallSettings} Returns the CallSettings instance
   */
  build() {
    return new ts(this);
  }
}
class TV {
  constructor(r) {
    x(this, "AllowBackgroundBlur");
    x(this, "AllowUserImages");
    x(this, "ShowDefaultImages");
    x(this, "SetImages");
    x(this, "EnforceBackgroundBlur");
    x(this, "EnforceBackgroundImage");
    this.AllowBackgroundBlur = r.AllowBackgroundBlur, this.AllowUserImages = r.AllowUserImages, this.ShowDefaultImages = r.ShowDefaultImages, this.SetImages = r.SetImages, this.EnforceBackgroundBlur = r.EnforceBackgroundBlur, this.EnforceBackgroundImage = r.EnforceBackgroundImage;
  }
  shouldAllowBackgroundBlur() {
    return this.AllowBackgroundBlur;
  }
  shouldAllowUserImages() {
    return this.AllowUserImages;
  }
  shouldShowDefaultImages() {
    return this.ShowDefaultImages;
  }
  getImages() {
    return this.SetImages;
  }
  isBackgroundBlurEnforced() {
    return this.EnforceBackgroundBlur;
  }
  getEnforcedBackgroundImage() {
    return this.EnforceBackgroundImage;
  }
}
class yV {
  constructor() {
    /** @private */
    x(this, "AllowBackgroundBlur", !0);
    /** @private */
    x(this, "AllowUserImages", !0);
    /** @private */
    x(this, "ShowDefaultImages", !0);
    /** @private */
    x(this, "SetImages", []);
    /** @private */
    x(this, "EnforceBackgroundBlur", 0);
    /** @private */
    x(this, "EnforceBackgroundImage", "");
  }
  /**
   *
   * @param {boolean} AllowBackgroundBlur
   * This method will show the background blur option in Virtual Background.
   * If set to true it will show the background blur option.
   * Default value is true.
   * @returns
   */
  allowBackgroundBlur(r) {
    return this.AllowBackgroundBlur = r, this;
  }
  /**
   *
   * @param {boolean} AllowUserImage
   * This method will allow the user to add custom images as background.
   * If set to true it will allow the user to add custom images as background.
   * Default value is true.
   * @returns
   */
  allowUserImages(r) {
    return this.AllowUserImages = r, this;
  }
  /**
   *
   * @param {boolean} ShowDefaultImages
   * This method will show the default images to be used as background.
   * If set to true it will show the default images to be used as background.
   * Default value is true.
   * @returns
   */
  showDefaultImages(r) {
    return this.ShowDefaultImages = r, this;
  }
  /**
   *
   * @param {boolean} SetImages
   * This method will allow user to add custom Images to be used as background. It takes in an array of URLs.
   * @returns
   */
  setImages(r) {
    return this.SetImages = r, this;
  }
  /**
   *
   * @param {number} EnforceBackgroundBlur
   * This method will enforce background blur.
   * This method takes number as input which decides the blur level of the background.
   * Default value is 0.
   * @returns
   */
  enforceBackgroundBlur(r) {
    return this.EnforceBackgroundBlur = r, this;
  }
  /**
   *
   * @param {string} EnforceBackgroundImage
   * This method will enforce background image.
   * If an URL of the image is sent then that image will be set as background.
   * By default no image is set.
   * @returns
   */
  enforceBackgroundImage(r) {
    return this.EnforceBackgroundImage = r, this;
  }
  /**
   * This method will return an object of the VirtualBackground class.
   * @returns {VirtualBackground}
   */
  build() {
    return new TV(this);
  }
}
class NV {
  /**
   *
   * @param {string} mainVideoAspectRatio
   * This method is used to set the aspect ratio of main video.
   * The default value is `contain`
   * @returns
   */
  setMainVideoAspectRatio(r) {
  }
  /**
   *
   * @param {string} position
   * @param {boolean} visibility
   * This method is used to set the position & visibility parameter of the full screen button.
   * By default the full screen button is visible in the `bottom-right` position.
   * @returns
   */
  setFullScreenButtonParams(r, c) {
  }
  /**
   *
   * @param {string} position
   * @param {boolean} visibility
   * @param {string} backgroundColor
   * This method is used to set the position, visibility & background color of the name label.
   * By default the name label is visible in the `bottom-left` position with a background-color `rgba(27, 27, 27, 0.4)`
   * @returns
   */
  setNameLabelParams(r, c, h) {
  }
  /**
   *
   * @param {string} position
   * @param {boolean} visibility
   * This method is used to set the position, visibility of the network label.
   * By default the network label is visible in the `bottom-right` position.
   * @returns
   */
  setNetworkLabelParams(r, c) {
  }
}
class Xh {
  constructor(r) {
    x(this, "code");
    x(this, "name");
    x(this, "message");
    x(this, "details");
    "code" in r && (this.code = r.code), "name" in r && (this.name = r.name), "message" in r && (this.message = r.message), "details" in r && (this.details = r.details);
  }
}
function Ba(s) {
  return s != null && (typeof s == "string" && (s = s.trim()), typeof s == "object" && Object.keys(s).length === 0 && (s = void 0)), [
    "",
    0,
    "0",
    !1,
    null,
    "null",
    void 0,
    "undefined"
  ].includes(s);
}
class bV {
  constructor(r) {
    /**
     * @internal
     */
    x(this, "onYouLeft");
    /**
     * @internal
     */
    x(this, "onYouJoined");
    /**
     * This event is triggered when a user joins the call.
     */
    x(this, "onUserJoined");
    /**
     * This event is triggered when a user leaves the call.
     */
    x(this, "onUserLeft");
    /**
     * This event is triggered when the participant list of the call changes.
     */
    x(this, "onUserListUpdated");
    /**
     * This event is triggered when the media device list changes.
     */
    x(this, "onMediaDeviceListUpdated");
    /**
     * This event is triggered when someone starts recording the call.
     */
    x(this, "onRecordingStarted");
    /**
     * This event is triggered when someone stops recording the call.
     */
    x(this, "onRecordingStopped");
    /**
     * This event is triggered when someone starts sharing their screen in the call.
     */
    x(this, "onScreenShareStarted");
    /**
     * This event is triggered when someone stops sharing their screen in the call.
     */
    x(this, "onScreenShareStopped");
    /**
     * This event is triggered when a user is muted.
     */
    x(this, "onUserMuted");
    /**
     * This event is triggered when a user is unmuted.
     */
    x(this, "onUserUnMuted");
    /**
     * This event is triggered when an audio call is switched to a video call.
     */
    x(this, "onCallSwitchedToVideo");
    /**
     * This event is triggered when the call is ended.
     */
    x(this, "onCallEnded");
    /**
     * This event is triggered when the call is ended due to session timeout.
     */
    x(this, "onSessionTimeout");
    /**
     * This event is triggered when an error occurs.
     */
    x(this, "onError");
    /**
     * This event is triggered when user presses end call button.
     */
    x(this, "onCallEndButtonPressed");
    Ba(r.onUserJoined) || (this.onUserJoined = r.onUserJoined), Ba(r.onUserLeft) || (this.onUserLeft = r.onUserLeft), Ba(r.onUserListUpdated) || (this.onUserListUpdated = r.onUserListUpdated), Ba(r.onMediaDeviceListUpdated) || (this.onMediaDeviceListUpdated = r.onMediaDeviceListUpdated), Ba(r.onRecordingStarted) || (this.onRecordingStarted = r.onRecordingStarted), Ba(r.onRecordingStopped) || (this.onRecordingStopped = r.onRecordingStopped), Ba(r.onScreenShareStarted) || (this.onScreenShareStarted = r.onScreenShareStarted), Ba(r.onScreenShareStopped) || (this.onScreenShareStopped = r.onScreenShareStopped), Ba(r.onUserMuted) || (this.onUserMuted = r.onUserMuted), Ba(r.onUserUnMuted) || (this.onUserUnMuted = r.onUserUnMuted), Ba(r.onCallSwitchedToVideo) || (this.onCallSwitchedToVideo = r.onCallSwitchedToVideo), Ba(r.onCallEnded) || (this.onCallEnded = r.onCallEnded), Ba(r.onSessionTimeout) || (this.onSessionTimeout = r.onSessionTimeout), Ba(r.onError) || (this.onError = r.onError), Ba(r.onCallEndButtonPressed) || (this.onCallEndButtonPressed = r.onCallEndButtonPressed);
  }
}
let oy = null;
function CV(s) {
  oy = s;
}
function VV() {
  return oy;
}
function _V(s, r, c) {
  const h = `perPage=${encodeURIComponent(
    String(c)
  )}&page=${encodeURIComponent(String(r))}`;
  return `calls/${encodeURIComponent(s)}/transcriptions?${h}`;
}
function FV(s, r) {
  return {
    appId: s,
    authToken: r,
    "Content-Type": "application/json",
    Accept: "application/json"
  };
}
function MV({
  callsBaseURL: s,
  appId: r,
  authToken: c,
  sessionId: h,
  page: f,
  perPage: v
}) {
  return PC({
    baseURL: s,
    method: "GET",
    endpoint: _V(h, f, v),
    headers: FV(r, c)
  });
}
function kV(s) {
  return { ...s };
}
const sy = 30, DV = 1, QV = 1e3, l2 = {
  REQUEST_IN_PROGRESS: {
    code: "REQUEST_IN_PROGRESS",
    name: "REQUEST_IN_PROGRESS",
    message: "A transcript request is already in progress.",
    details: {}
  },
  NETWORK_ERROR: {
    code: "NETWORK_ERROR",
    name: "NETWORK_ERROR",
    message: "Network request failed while fetching transcripts.",
    details: {}
  },
  BAD_RESPONSE: {
    code: "BAD_RESPONSE",
    name: "BAD_RESPONSE",
    message: "The transcript server returned a malformed response.",
    details: {}
  }
};
function _d(s) {
  return new Xh(s);
}
function xV(s) {
  return Number.isFinite(s) ? Math.min(QV, Math.max(DV, Math.floor(s))) : sy;
}
function ZV(s) {
  switch (s.name) {
    case "NETWORK_ERROR":
      return _d({
        ...l2.NETWORK_ERROR,
        message: s.message
      });
    case "COMET_CHAT_API_ERROR": {
      const r = s.details;
      return _d({
        code: (r == null ? void 0 : r.code) ?? l2.BAD_RESPONSE.code,
        name: (r == null ? void 0 : r.code) ?? "COMET_CHAT_API_ERROR",
        message: (r == null ? void 0 : r.message) ?? s.message,
        details: s.details
      });
    }
    default:
      return _d({
        ...l2.BAD_RESPONSE,
        message: s.message
      });
  }
}
class OV {
  constructor(r, c) {
    x(this, "limit");
    x(this, "sessionId");
    x(this, "config");
    /** Total pages reported by the server; `null` until a response reports one. */
    x(this, "totalPages", null);
    /** Page cursor; `0` before the first fetch. */
    x(this, "currentPage", 0);
    /** Guards against overlapping in-flight fetches. */
    x(this, "inProgress", !1);
    this.limit = xV(r.limit), this.sessionId = r.sessionId, this.config = c;
  }
  /**
   * Fetches the next page of transcripts.
   * @returns The page's transcripts, or `[]` when there are no more pages.
   * @throws {CometChatCallsException} on auth, concurrency, network or response errors.
   */
  fetchNext() {
    return this.makeAPICall(!0);
  }
  /**
   * Fetches the previous page of transcripts.
   * @returns The page's transcripts, or `[]` when already at the first page.
   * @throws {CometChatCallsException} on auth, concurrency, network or response errors.
   */
  fetchPrevious() {
    return this.makeAPICall(!1);
  }
  async makeAPICall(r) {
    if (r) {
      if (this.totalPages !== null && this.currentPage >= this.totalPages)
        return [];
    } else if (this.currentPage <= 1)
      return [];
    if (this.inProgress)
      throw _d(l2.REQUEST_IN_PROGRESS);
    this.inProgress = !0;
    try {
      const c = this.config.getAuthToken();
      if (!c)
        throw _d(d6.NOT_LOGGED_IN);
      const h = r ? this.currentPage + 1 : this.currentPage - 1, { data: f, meta: v, error: R } = await MV({
        callsBaseURL: this.config.callsBaseURL,
        appId: this.config.appId,
        authToken: c,
        sessionId: this.sessionId,
        page: h,
        perPage: this.limit
      });
      if (R)
        throw ZV(R);
      if (!Array.isArray(f))
        throw _d(l2.BAD_RESPONSE);
      if (v && v.pagination) {
        const { total_pages: T, current_page: E } = v.pagination;
        this.totalPages = typeof T == "number" ? T : this.totalPages, this.currentPage = typeof E == "number" ? E : h;
      } else
        this.currentPage = h, this.totalPages = h;
      return f.map(
        (T) => kV(T)
      );
    } finally {
      this.inProgress = !1;
    }
  }
}
class wV {
  constructor() {
    /** @internal */
    x(this, "limit", sy);
    /** @internal */
    x(this, "sessionId", "");
  }
  /**
   * Sets the meeting/session id whose transcripts to fetch. Required.
   * @param sessionId - The session id (e.g. `v1.us.<appId>.<user>`).
   */
  setSessionId(r) {
    return this.sessionId = r, this;
  }
  /**
   * Sets the page size. Optional; defaults to 30 and is clamped to `[1, 1000]`.
   * @param limit - Transcripts to fetch per page.
   */
  setLimit(r) {
    return this.limit = r, this;
  }
  /**
   * Validates pre-flight state and builds the request.
   * @throws {CometChatCallsException} `NOT_INITIALIZED` if `init()` was not called,
   *   or `SESSION_ID_REQUIRED` if no session id was set.
   */
  build() {
    const r = VV();
    if (!r)
      throw _d(d6.NOT_INITIALIZED);
    if (!this.sessionId || this.sessionId.trim() === "")
      throw _d(d6.SESSION_ID_REQUIRED);
    return new OV(this, r);
  }
}
class z6 {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(r) {
    x(this, "guid");
    x(this, "name");
    x(this, "icon");
    Object.assign(this, r);
  }
  getGuid() {
    return this.guid;
  }
  setGuid(r) {
    this.guid = r;
  }
  getName() {
    return this.name;
  }
  setName(r) {
    this.name = r;
  }
  getIcon() {
    return this.icon;
  }
  setIcon(r) {
    this.icon = r;
  }
  toString() {
    return `CallGroup{ guid='${this.guid}', name='${this.name}', icon='${this.icon}' }`;
  }
  static getGroupFromJson(r) {
    return new z6(r);
  }
}
class Lv {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(r) {
    x(this, "uid");
    x(this, "name");
    x(this, "avatar");
    Object.assign(this, r);
  }
  getUid() {
    return this.uid;
  }
  setUid(r) {
    this.uid = r;
  }
  getName() {
    return this.name;
  }
  setName(r) {
    this.name = r;
  }
  getAvatar() {
    return this.avatar;
  }
  setAvatar(r) {
    this.avatar = r;
  }
  toString() {
    return `CallUser{ uid='${this.uid}', name='${this.name}', avatar='${this.avatar}' }`;
  }
  static getUserFromJson(r) {
    return new Lv(r);
  }
}
class j6 {
  /**
   * Creates a new instance of Participant.
   * @param object - The object containing the participant data.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(r) {
    /**
     * The unique identifier of the participant.
     */
    x(this, "uid");
    /**
     * The name of the participant.
     */
    x(this, "name");
    /**
     * The avatar of the participant.
     */
    x(this, "avatar");
    /**
     * The total audio minutes of the participant.
     */
    x(this, "totalAudioMinutes");
    /**
     * The total video minutes of the participant.
     */
    x(this, "totalVideoMinutes");
    /**
     * The total duration in minutes of the participant.
     */
    x(this, "totalDurationInMinutes");
    /**
     * The device ID of the participant.
     */
    x(this, "deviceID");
    /**
     * Whether the participant has joined the call or not.
     */
    x(this, "hasJoined");
    /**
     * The timestamp when the participant joined the call.
     */
    x(this, "joinedAt");
    /**
     * The timestamp when the participant left the call.
     */
    x(this, "leftAt");
    /**
     * The media ID of the participant.
     */
    x(this, "mid");
    /**
     * The state of the participant.
     */
    x(this, "state");
    Object.assign(this, r);
  }
  /**
   * Gets the unique identifier of the participant.
   * @returns The unique identifier of the participant.
   */
  getUid() {
    return this.uid;
  }
  /**
   * Sets the unique identifier of the participant.
   * @param value - The unique identifier of the participant.
   */
  setUid(r) {
    this.uid = r;
  }
  /**
   * Gets the name of the participant.
   * @returns The name of the participant.
   */
  getName() {
    return this.name;
  }
  /**
   * Sets the name of the participant.
   * @param value - The name of the participant.
   */
  setName(r) {
    this.name = r;
  }
  /**
   * Gets the avatar of the participant.
   * @returns The avatar of the participant.
   */
  getAvatar() {
    return this.avatar;
  }
  /**
   * Sets the avatar of the participant.
   * @param value - The avatar of the participant.
   */
  setAvatar(r) {
    this.avatar = r;
  }
  /**
   * Gets the total audio minutes of the participant.
   * @returns The total audio minutes of the participant.
   */
  getTotalAudioMinutes() {
    return this.totalAudioMinutes;
  }
  /**
   * Sets the total audio minutes of the participant.
   * @param value - The total audio minutes of the participant.
   */
  setTotalAudioMinutes(r) {
    this.totalAudioMinutes = r;
  }
  /**
   * Gets the total video minutes of the participant.
   * @returns The total video minutes of the participant.
   */
  getTotalVideoMinutes() {
    return this.totalVideoMinutes;
  }
  /**
   * Sets the total video minutes of the participant.
   * @param value - The total video minutes of the participant.
   */
  setTotalVideoMinutes(r) {
    this.totalVideoMinutes = r;
  }
  /**
   * Gets the total duration in minutes of the participant.
   * @returns The total duration in minutes of the participant.
   */
  getTotalDurationInMinutes() {
    return this.totalDurationInMinutes;
  }
  /**
   * Sets the total duration in minutes of the participant.
   * @param value - The total duration in minutes of the participant.
   */
  setTotalDurationInMinutes(r) {
    this.totalDurationInMinutes = r;
  }
  /**
   * Gets the device ID of the participant.
   * @returns The device ID of the participant.
   */
  getDeviceID() {
    return this.deviceID;
  }
  /**
   * Sets the device ID of the participant.
   * @param value - The device ID of the participant.
   */
  setDeviceID(r) {
    this.deviceID = r;
  }
  /**
   * Gets whether the participant has joined the call or not.
   * @returns Whether the participant has joined the call or not.
   */
  getHasJoined() {
    return this.hasJoined;
  }
  /**
   * Sets whether the participant has joined the call or not.
   * @param value - Whether the participant has joined the call or not.
   */
  setHasJoined(r) {
    this.hasJoined = r;
  }
  /**
   * Gets the timestamp when the participant joined the call.
   * @returns The timestamp when the participant joined the call.
   */
  getJoinedAt() {
    return this.joinedAt;
  }
  /**
   * Sets the timestamp when the participant joined the call.
   * @param value - The timestamp when the participant joined the call.
   */
  setJoinedAt(r) {
    this.joinedAt = r;
  }
  /**
   * Gets the timestamp when the participant left the call.
   * @returns The timestamp when the participant left the call.
   */
  getLeftAt() {
    return this.leftAt;
  }
  /**
   * Sets the timestamp when the participant left the call.
   * @param value - The timestamp when the participant left the call.
   */
  setLeftAt(r) {
    this.leftAt = r;
  }
  /**
   * Gets the media ID of the participant.
   * @returns The media ID of the participant.
   */
  getMid() {
    return this.mid;
  }
  /**
   * Sets the media ID of the participant.
   * @param value - The media ID of the participant.
   */
  setMid(r) {
    this.mid = r;
  }
  /**
   * Gets the state of the participant.
   * @returns The state of the participant.
   */
  getState() {
    return this.state;
  }
  /**
   * Sets the state of the participant.
   * @param value - The state of the participant.
   */
  setState(r) {
    this.state = r;
  }
  /**
   * Creates a new instance of Participant from a JSON object.
   * @param object - The JSON object containing the participant data.
   * @returns A new instance of Participant.
   */
  static getParticipantFromJson(r) {
    return new j6(r);
  }
}
class P6 {
  /**
   * Creates a new instance of the Recording class.
   * @param data - The data to initialize the recording object.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(r) {
    /**
     * The recording ID.
     */
    x(this, "rid");
    /**
     * The URL of the recording.
     */
    x(this, "recording_url");
    /**
     * The start time of the recording.
     */
    x(this, "startTime");
    /**
     * The end time of the recording.
     */
    x(this, "endTime");
    /**
     * The duration of the recording.
     */
    x(this, "duration");
    Object.assign(this, r);
  }
  /**
   * Gets the recording ID.
   * @returns The recording ID.
   */
  getRid() {
    return this.rid;
  }
  /**
   * Sets the recording ID.
   * @param value - The recording ID to set.
   */
  setRid(r) {
    this.rid = r;
  }
  /**
   * Gets the recording URL.
   * @returns The recording URL.
   */
  getRecordingURL() {
    return this.recording_url;
  }
  /**
   * Sets the recording URL.
   * @param value - The recording URL to set.
   */
  setRecordingURL(r) {
    this.recording_url = r;
  }
  /**
   * Gets the start time of the recording.
   * @returns The start time of the recording.
   */
  getStartTime() {
    return this.startTime;
  }
  /**
   * Sets the start time of the recording.
   * @param value - The start time of the recording to set.
   */
  setStartTime(r) {
    this.startTime = r;
  }
  /**
   * Gets the end time of the recording.
   * @returns The end time of the recording.
   */
  getEndTime() {
    return this.endTime;
  }
  /**
   * Sets the end time of the recording.
   * @param value - The end time of the recording to set.
   */
  setEndTime(r) {
    this.endTime = r;
  }
  /**
   * Gets the duration of the recording.
   * @returns The duration of the recording.
   */
  getDuration() {
    return this.duration;
  }
  /**
   * Sets the duration of the recording.
   * @param value - The duration of the recording to set.
   */
  setDuration(r) {
    this.duration = r;
  }
  /**
   * Creates a new Recording object from the given JSON data.
   * @param data - The JSON data to create the Recording object from.
   * @returns A new Recording object.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static getRecordingFromJson(r) {
    return new P6(r);
  }
}
class G6 {
  /**
   * Creates a new instance of the Transcription class.
   * @param data - The data to initialize the transcription object.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(r) {
    /**
     * The transcript ID.
     */
    x(this, "tid");
    /**
     * The meeting ID; absent until the pipeline sends `uniqueMeetingId`.
     */
    x(this, "mid");
    /**
     * The room name of the meeting the transcript belongs to.
     */
    x(this, "roomName");
    /**
     * The start time of the transcribed meeting, in epoch seconds.
     */
    x(this, "startTime");
    /**
     * The end time of the transcribed meeting, in epoch seconds.
     */
    x(this, "endTime");
    /**
     * The transcript date.
     */
    x(this, "transcriptDate");
    /**
     * The URL of the downloadable transcript JSON.
     */
    x(this, "transcriptUrl");
    Object.assign(this, r);
  }
  /**
   * Gets the transcript ID.
   * @returns The transcript ID.
   */
  getTid() {
    return this.tid;
  }
  /**
   * Sets the transcript ID.
   * @param value - The transcript ID to set.
   */
  setTid(r) {
    this.tid = r;
  }
  /**
   * Gets the meeting ID.
   * @returns The meeting ID.
   */
  getMid() {
    return this.mid;
  }
  /**
   * Sets the meeting ID.
   * @param value - The meeting ID to set.
   */
  setMid(r) {
    this.mid = r;
  }
  /**
   * Gets the room name.
   * @returns The room name.
   */
  getRoomName() {
    return this.roomName;
  }
  /**
   * Sets the room name.
   * @param value - The room name to set.
   */
  setRoomName(r) {
    this.roomName = r;
  }
  /**
   * Gets the start time of the transcribed meeting.
   * @returns The start time, in epoch seconds.
   */
  getStartTime() {
    return this.startTime;
  }
  /**
   * Sets the start time of the transcribed meeting.
   * @param value - The start time, in epoch seconds.
   */
  setStartTime(r) {
    this.startTime = r;
  }
  /**
   * Gets the end time of the transcribed meeting.
   * @returns The end time, in epoch seconds.
   */
  getEndTime() {
    return this.endTime;
  }
  /**
   * Sets the end time of the transcribed meeting.
   * @param value - The end time, in epoch seconds.
   */
  setEndTime(r) {
    this.endTime = r;
  }
  /**
   * Gets the transcript date.
   * @returns The transcript date.
   */
  getTranscriptDate() {
    return this.transcriptDate;
  }
  /**
   * Sets the transcript date.
   * @param value - The transcript date to set.
   */
  setTranscriptDate(r) {
    this.transcriptDate = r;
  }
  /**
   * Gets the URL of the downloadable transcript JSON.
   * @returns The transcript URL.
   */
  getTranscriptURL() {
    return this.transcriptUrl;
  }
  /**
   * Sets the URL of the downloadable transcript JSON.
   * @param value - The transcript URL to set.
   */
  setTranscriptURL(r) {
    this.transcriptUrl = r;
  }
  /**
   * Creates a new Transcription object from the given JSON data.
   *
   * Every key is passed through untouched, so newly-added server fields survive
   * without an SDK release.
   * @param data - The JSON data to create the Transcription object from.
   * @returns A new Transcription object.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static getTranscriptionFromJson(r) {
    return new G6(r);
  }
}
class tS {
  /**
   * Creates a new instance of CallLog.
   * @param data - The data to initialize the call log with.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(r) {
    /**
     * The session ID of the call log.
     */
    x(this, "sessionId");
    /**
     * The total audio minutes of the call log.
     */
    x(this, "totalAudioMinutes");
    /**
     * The total video minutes of the call log.
     */
    x(this, "totalVideoMinutes");
    /**
     * The total duration of the call log.
     */
    x(this, "totalDuration");
    /**
     * Whether the call log has a recording.
     */
    x(this, "hasRecording");
    /**
     * The time the call was initiated at.
     */
    x(this, "initiatedAt");
    /**
     * The time the call started at. Sent by the calls host in place of
     * `initiatedAt`; read {@link getStartedAt} and fall back to
     * {@link getInitiatedAt} when only one of the two is present.
     */
    x(this, "startedAt");
    /**
     * The call category of the call log.
     */
    x(this, "callCategory");
    /**
     * The mode of the call log. Sent by the calls host in place of
     * `callCategory`; read {@link getMode} and fall back to
     * {@link getCallCategory} when only one of the two is present.
     */
    x(this, "mode");
    /**
     * @type {CallUser}
     * The initiator of the call log.
     */
    x(this, "initiator");
    /**
     * @type {CallUser | CallGroup}
     * The receiver of the call log.
     */
    x(this, "receiver");
    /**
     * The receiver type of the call log.
     */
    x(this, "receiverType");
    /**
     * The status of the call log.
     */
    x(this, "status");
    /**
     * The total duration in minutes of the call log.
     */
    x(this, "totalDurationInMinutes");
    /**
     * The total number of participants in the call log.
     */
    x(this, "totalParticipants");
    /**
     * The type of the call log.
     */
    x(this, "type");
    /**
     * The message ID of the call log.
     */
    x(this, "mid");
    /**
     * The time the call ended at.
     */
    x(this, "endedAt");
    /**
     * @type {Participant[]}
     * The participants of the call log.
     */
    x(this, "participants");
    /**
     * @type {Recording[]}
     * The recordings of the call log.
     */
    x(this, "recordings");
    /**
     * @type {Transcription[]}
     * The transcripts of the call log. Only populated when the request opted in
     * via `CallLogRequestBuilder.setHasTranscriptions(true)`.
     */
    x(this, "transcriptions");
    Object.assign(this, r);
  }
  /**
   * Gets the session ID of the call log.
   * @returns The session ID of the call log.
   */
  getSessionID() {
    return this.sessionId;
  }
  /**
   * Sets the session ID of the call log.
   * @param value - The session ID to set.
   */
  setSessionID(r) {
    this.sessionId = r;
  }
  /**
   * Gets the total audio minutes of the call log.
   * @returns The total audio minutes of the call log.
   */
  getTotalAudioMinutes() {
    return this.totalAudioMinutes;
  }
  /**
   * Sets the total audio minutes of the call log.
   * @param value - The total audio minutes to set.
   */
  setTotalAudioMinutes(r) {
    this.totalAudioMinutes = r;
  }
  /**
   * Gets the total video minutes of the call log.
   * @returns The total video minutes of the call log.
   */
  getTotalVideoMinutes() {
    return this.totalVideoMinutes;
  }
  /**
   * Sets the total video minutes of the call log.
   * @param value - The total video minutes to set.
   */
  setTotalVideoMinutes(r) {
    this.totalVideoMinutes = r;
  }
  /**
   * Gets the total duration of the call log.
   * @returns The total duration of the call log.
   */
  getTotalDuration() {
    return this.totalDuration;
  }
  /**
   * Sets the total duration of the call log.
   * @param value - The total duration to set.
   */
  setTotalDuration(r) {
    this.totalDuration = r;
  }
  /**
   * Gets whether the call log has a recording.
   * @returns Whether the call log has a recording.
   */
  getHasRecording() {
    return this.hasRecording;
  }
  /**
   * Sets whether the call log has a recording.
   * @param value - Whether the call log has a recording.
   */
  setHasRecording(r) {
    this.hasRecording = r;
  }
  /**
   * Gets the time the call was initiated at.
   * @returns The time the call was initiated at.
   */
  getInitiatedAt() {
    return this.initiatedAt;
  }
  /**
   * Sets the time the call was initiated at.
   * @param value - The time the call was initiated at.
   */
  setInitiatedAt(r) {
    this.initiatedAt = r;
  }
  /**
   * Gets the time the call started at.
   * @returns The time the call started at.
   */
  getStartedAt() {
    return this.startedAt;
  }
  /**
   * Sets the time the call started at.
   * @param value - The time the call started at.
   */
  setStartedAt(r) {
    this.startedAt = r;
  }
  /**
   * Gets the mode of the call log.
   * @returns The mode of the call log.
   */
  getMode() {
    return this.mode;
  }
  /**
   * Sets the mode of the call log.
   * @param value - The mode to set.
   */
  setMode(r) {
    this.mode = r;
  }
  /**
   * Gets the call category of the call log.
   * @returns The call category of the call log.
   */
  getCallCategory() {
    return this.callCategory;
  }
  /**
   * Sets the call category of the call log.
   * @param value - The call category to set.
   */
  setCallCategory(r) {
    this.callCategory = r;
  }
  /**
   * Gets the initiator of the call log.
   * @returns The initiator of the call log.
   */
  getInitiator() {
    return this.initiator;
  }
  /**
   * Sets the initiator of the call log.
   * @param value - The initiator to set.
   */
  setInitiator(r) {
    this.initiator = r;
  }
  /**
   * Gets the receiver of the call log.
   * @returns The receiver of the call log.
   */
  getReceiver() {
    return this.receiver;
  }
  /**
   * Sets the receiver of the call log.
   * @param value - The receiver to set.
   */
  setReceiver(r) {
    this.receiver = r;
  }
  /**
   * Gets the receiver type of the call log.
   * @returns The receiver type of the call log.
   */
  getReceiverType() {
    return this.receiverType;
  }
  /**
   * Sets the receiver type of the call log.
   * @param value - The receiver type to set.
   */
  setReceiverType(r) {
    this.receiverType = r;
  }
  /**
   * Gets the status of the call log.
   * @returns The status of the call log.
   */
  getStatus() {
    return this.status;
  }
  /**
   * Sets the status of the call log.
   * @param value - The status to set.
   */
  setStatus(r) {
    this.status = r;
  }
  /**
   * Gets the total duration in minutes of the call log.
   * @returns The total duration in minutes of the call log.
   */
  getTotalDurationInMinutes() {
    return this.totalDurationInMinutes;
  }
  /**
   * Sets the total duration in minutes of the call log.
   * @param value - The total duration in minutes to set.
   */
  setTotalDurationInMinutes(r) {
    this.totalDurationInMinutes = r;
  }
  /**
   * Gets the total number of participants in the call log.
   * @returns The total number of participants in the call log.
   */
  getTotalParticipants() {
    return this.totalParticipants;
  }
  /**
   * Sets the total number of participants in the call log.
   * @param value - The total number of participants to set.
   */
  setTotalParticipants(r) {
    this.totalParticipants = r;
  }
  /**
   * Gets the type of the call log.
   * @returns The type of the call log.
   */
  getType() {
    return this.type;
  }
  /**
   * Sets the type of the call log.
   * @param value - The type to set.
   */
  setType(r) {
    this.type = r;
  }
  /**
   * Gets the message ID of the call log.
   * @returns The message ID of the call log.
   */
  getMid() {
    return this.mid;
  }
  /**
   * Sets the message ID of the call log.
   * @param value - The message ID to set.
   */
  setMid(r) {
    this.mid = r;
  }
  /**
   * Gets the time the call ended at.
   * @returns The time the call ended at.
   */
  getEndedAt() {
    return this.endedAt;
  }
  /**
   * Sets the time the call ended at.
   * @param value - The time the call ended at.
   */
  setEndedAt(r) {
    this.endedAt = r;
  }
  /**
   * Gets the participants of the call log.
   * @returns The participants of the call log.
   */
  getParticipants() {
    return this.participants;
  }
  /**
   * Sets the participants of the call log.
   * @param value - The participants to set.
   */
  setParticipants(r) {
    this.participants = r;
  }
  /**
   * Gets the recordings of the call log.
   * @returns The recordings of the call log.
   */
  getRecordings() {
    return this.recordings;
  }
  /**
   * Sets the recordings of the call log.
   * @param value - The recordings to set.
   */
  setRecordings(r) {
    this.recordings = r;
  }
  /**
   * Gets the transcripts of the call log.
   * @returns The transcripts of the call log, or an empty array when the server
   * omitted them — never `undefined`. The array is absent unless the request
   * opted in via `CallLogRequestBuilder.setHasTranscriptions(true)`, and the
   * server currently omits it even then, so callers must not have to null-check.
   */
  getTranscriptions() {
    return this.transcriptions ?? [];
  }
  /**
   * Sets the transcripts of the call log.
   * @param value - The transcripts to set.
   */
  setTranscriptions(r) {
    this.transcriptions = r;
  }
  /**
   * Creates a new instance of CallLog from JSON data.
   * @param data - The JSON data to create the call log from.
   * @returns A new instance of CallLog created from the JSON data.
   */
  static callLogFromJson(r) {
    let c = new tS(r);
    if (r.participants && (c.participants = r.participants.map(
      (h) => j6.getParticipantFromJson(h)
    )), r.recordings && (c.recordings = r.recordings.map(
      (h) => P6.getRecordingFromJson(h)
    )), r.transcriptions && (c.transcriptions = r.transcriptions.map(
      (h) => G6.getTranscriptionFromJson(h)
    )), r.initiator && r[cn.CALL_KEYS.CALL_DATA] && r[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES] && r[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_INITIATOR] && r[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_INITIATOR][cn.CALL_KEYS.CALL_ENTITY]) {
      let h = r[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_INITIATOR][cn.CALL_KEYS.CALL_ENTITY];
      c.initiator = Lv.getUserFromJson(h);
    }
    if (r.receiver && r[cn.CALL_KEYS.CALL_DATA] && r[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES] && r[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_RECEIVER] && r[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_RECEIVER][cn.CALL_KEYS.CALL_ENTITY]) {
      let h = r[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_RECEIVER][cn.CALL_KEYS.CALL_ENTITY];
      r.receiverType == cn.RECEIVER_TYPE_USER ? c.receiver = Lv.getUserFromJson(h) : c.receiver = z6.getGroupFromJson(h);
    }
    return c;
  }
}
class BV {
  /**
   * Creates a new CallLogRequest instance.
   * @param builder The builder object to use for constructing the request.
   */
  constructor(r) {
    /**
     * The maximum number of call logs to fetch.
     */
    x(this, "limit", 30);
    /**
     * The total number of pages of call logs.
     */
    x(this, "totalPages", 0);
    /**
     * The current page of call logs.
     */
    x(this, "currentPage", 0);
    /**
     * The type of call to filter by.
     */
    x(this, "callType");
    /**
     * The status of call to filter by.
     */
    x(this, "callStatus");
    /**
     * Whether the call has a recording or not.
     */
    x(this, "hasRecording");
    /**
     * Whether to restrict the list to calls that have transcripts (and have the
     * server attach each call's `transcriptions` array).
     */
    x(this, "hasTranscriptions");
    /**
     * The category of call to filter by.
     */
    x(this, "callCategory");
    /**
     * The direction of call to filter by.
     */
    x(this, "callDirection");
    /**
     * The user ID to filter by.
     */
    x(this, "uid");
    /**
     * The group ID to filter by.
     */
    x(this, "guid");
    /**
     * The authentication token to use for the API call.
     */
    x(this, "authToken");
    /**
     * Whether an API call is currently in progress.
     */
    x(this, "inProgress", !1);
    this.limit = r.limit, this.callType = r.callType, this.callStatus = r.callStatus, this.hasRecording = r.hasRecording, this.hasTranscriptions = r.hasTranscriptions, this.callCategory = r.callCategory, this.callDirection = r.callDirection, this.uid = r.uid, this.guid = r.guid, this.authToken = r.authToken;
  }
  /**
   * Fetches the next page of call logs.
   * @returns A promise that resolves to an array of CallLog objects, or rejects with a CometChatCallsException if there was an error.
   */
  fetchNext() {
    return this.makeAPICall(!0);
  }
  /**
   * Fetches the previous page of call logs.
   * @returns A promise that resolves to an array of CallLog objects, or an empty array if there are no previous pages, or rejects with a CometChatCallsException if there was an error..
   */
  fetchPrevious() {
    return this.makeAPICall();
  }
  /**
   * Gets the page the cursor currently sits on.
   * @returns The current page, or `0` before the first successful fetch.
   */
  getCurrentPage() {
    return this.currentPage;
  }
  /**
   * Gets the number of pages the server reported.
   * @returns The total page count, or `0` before the first successful fetch.
   */
  getTotalPages() {
    return this.totalPages;
  }
  /**
   * Makes an API call to fetch call logs.
   * @param isFetchNext Whether to fetch the next page of call logs.
   * @returns A promise that resolves to an array of CallLog objects, or rejects with a CometChatCallsException if there was an error.
   */
  makeAPICall(r) {
    return new Promise(async (c, h) => {
      var f;
      try {
        if (r ? this.totalPages != 0 && this.totalPages == this.currentPage : this.currentPage == 1) {
          this.inProgress = !1, c([]);
          return;
        }
        if (this.inProgress) {
          this.inProgress = !1, h(
            new Xh({
              code: "REQUEST_IN_PROGRESS",
              name: "REQUEST_IN_PROGRESS",
              message: "Request in progress.",
              details: {}
            })
          );
          return;
        }
        if (this.inProgress = !0, !this.authToken) {
          this.inProgress = !1, h(
            new Xh({
              code: "NOT_ENOUGH_PARAMETERS",
              message: "`Auth Token` is required to use the 'fetchNext()' method."
            })
          );
          return;
        }
        try {
          let R = await H6.getCallLogList(
            this.getParams(r),
            this.authToken
          );
          if ((f = R == null ? void 0 : R.data) != null && f.error) {
            this.inProgress = !1, h(new Xh(R.data.error));
            return;
          }
          let T = this.getCallLogList(JSON.stringify(R.data));
          c(T), this.inProgress = !1;
        } catch (R) {
          this.inProgress = !1, h(new Xh(R));
        }
      } catch {
        this.inProgress = !1, h(
          new Xh({
            code: "UNKNOWN ERROR",
            message: "Unknown error"
          })
        );
      }
    });
  }
  /**
   * Gets the filter parameters for the API call.
   * @param isNext Whether to fetch the next page of call logs.
   * @returns The filter parameters object.
   */
  getParams(r) {
    let c = {};
    return r ? c.page = this.currentPage + 1 : c.page = this.currentPage - 1, c.perPage = this.limit, this.hasRecording && (c.hasRecording = this.hasRecording), this.hasTranscriptions && (c.hasTranscriptions = 1), this.callStatus && (c.status = this.callStatus), this.callType && (c.type = this.callType), this.callCategory && (c.mode = this.callCategory), this.callDirection && (c.direction = this.callDirection), this.uid && (c.uid = this.uid), this.guid && (c.guid = this.guid), c;
  }
  /**
   * Parses the API response and returns an array of CallLog objects.
   * @param response The API response string.
   * @returns An array of CallLog objects.
   */
  getCallLogList(r) {
    let c = [], h = JSON.parse(r), f = h.meta;
    if (f.pagination) {
      let R = f.pagination;
      R.total_pages && (this.totalPages = R.total_pages, this.currentPage = R.current_page);
    }
    let v = h.data;
    for (let R = 0; R < v.length; R++) {
      let T = v[R], E = tS.callLogFromJson(T);
      c.push(E);
    }
    return c;
  }
}
class AV {
  constructor() {
    /** @private */
    x(this, "limit", 30);
    /** @private */
    x(this, "callType");
    /** @private */
    x(this, "callStatus");
    /** @private */
    x(this, "hasRecording");
    /** @private */
    x(this, "hasTranscriptions");
    /** @private */
    x(this, "callCategory");
    /** @private */
    x(this, "callDirection");
    /** @private */
    x(this, "uid");
    /** @private */
    x(this, "guid");
    /** @private */
    x(this, "authToken");
  }
  /**
   * Sets the limit of call logs to be fetched.
   * @param limit - The number of call logs to be fetched.
   * @returns The CallLogRequestBuilder object.
   */
  setLimit(r) {
    return this.limit = r, this;
  }
  /**
   * Sets the type of call to be fetched.
   * @param callType - The type of call to be fetched. Can be either 'video' or 'audio'.
   * @returns The CallLogRequestBuilder object.
   */
  setCallType(r) {
    return this.callType = r, this;
  }
  /**
   * Sets the status of call to be fetched.
   * @param callStatus - The status of call to be fetched. Can be either 'ongoing', 'busy', 'rejected', 'cancelled', 'ended' or 'missed'.
   * @returns The CallLogRequestBuilder object.
   */
  setCallStatus(r) {
    return this.callStatus = r, this;
  }
  /**
   * Sets whether the call has recording or not.
   * @param hasRecording - Whether the call has recording or not.
   * @returns The CallLogRequestBuilder object.
   */
  setHasRecording(r) {
    return this.hasRecording = r, this;
  }
  /**
   * Sets whether only calls that have transcripts should be fetched. Opting in
   * also makes the server attach each call's `transcriptions` array, readable
   * via `CallLog.getTranscriptions()`.
   * @param hasTranscriptions - Whether to restrict the list to transcribed calls.
   * @returns The CallLogRequestBuilder object.
   */
  setHasTranscriptions(r) {
    return this.hasTranscriptions = r, this;
  }
  /**
   * Sets the category of call to be fetched.
   * @param callCategory - The category of call to be fetched. Can be either 'call' or 'meet'.
   * @returns The CallLogRequestBuilder object.
   */
  setCallCategory(r) {
    return this.callCategory = r, this;
  }
  /**
   * Sets the direction of call to be fetched.
   * @param callDirection - The direction of call to be fetched. Can be either 'incoming' or 'outgoing'.
   * @returns The CallLogRequestBuilder object.
   */
  setCallDirection(r) {
    return this.callDirection = r, this;
  }
  /**
   * Sets the user ID of the call logs to be fetched.
   * @param uid - The user ID of the call logs to be fetched.
   * @returns The CallLogRequestBuilder object.
   */
  setUid(r) {
    return this.uid = r, this;
  }
  /**
   * Sets the group ID of the call logs to be fetched.
   * @param guid - The group ID of the call logs to be fetched.
   * @returns The CallLogRequestBuilder object.
   */
  setGuid(r) {
    return this.guid = r, this;
  }
  /**
   * Sets the authorization token for the request.
   * @param authToken - The authorization token for the request.
   * @returns The CallLogRequestBuilder object.
   */
  setAuthToken(r) {
    return this.authToken = r, this;
  }
  /**
   * Builds and returns the CallLogRequest object.
   * @returns The CallLogRequest object.
   */
  build() {
    return new BV(this);
  }
}
const IV = /* @__PURE__ */ R2({
  appId: /* @__PURE__ */ bi(),
  region: /* @__PURE__ */ bi(),
  calltoken: /* @__PURE__ */ bi(),
  baseURL: /* @__PURE__ */ bi()
}), ly = DU;
async function LV({
  appId: s,
  region: r,
  calltoken: c,
  baseURL: h
}) {
  const f = /* @__PURE__ */ sc(IV, {
    appId: s,
    region: r,
    calltoken: c,
    baseURL: h
  });
  if (!f.success)
    return {
      data: null,
      error: {
        name: "VALIDATION_ERROR",
        message: f.issues.map((T) => T.message).join(", ")
      }
    };
  const v = await Td({
    baseURL: h,
    method: "GET",
    endpoint: "call_tokens?configVersion=1",
    headers: {
      calltoken: c,
      appId: s
    }
  });
  if (v.error)
    return v;
  const R = /* @__PURE__ */ sc(ly, v.data);
  return R.success ? {
    data: R.output,
    error: null
  } : {
    data: null,
    error: {
      name: "BAD_RESPONSE",
      message: R.issues.map((T) => T.message).join(", ")
    }
  };
}
function JV(s) {
  const { token: r, ...c } = s ?? {}, h = /* @__PURE__ */ sc(ly, {
    ...c,
    callToken: r
  });
  return h.success ? {
    data: h.output,
    error: null
  } : {
    data: null,
    error: {
      name: "BAD_RESPONSE",
      message: h.issues.map((f) => f.message).join(", ")
    }
  };
}
function WV(s) {
  const r = s.getImages().map(String);
  return {
    images: s.shouldShowDefaultImages() ? [..._T, ...r] : r,
    allowUserImages: s.shouldAllowUserImages(),
    allowBlur: s.shouldAllowBackgroundBlur()
  };
}
const an = class an extends OT {
  // v4 related changes end here
  // Initialize the SDK
  static async init(r) {
    const c = /* @__PURE__ */ sc(uU, r);
    return c.success ? (this.finalizeInit(c.output, s6), {
      success: !0,
      error: null
    }) : (console.error(
      "App settings validation failed:",
      c.issues
    ), {
      success: !1,
      error: {
        name: "VALIDATION_ERROR",
        message: `Invalid app settings: ${c.issues.map((h) => h.message).join(", ")}`,
        timestamp: Date.now()
      }
    });
  }
  /**
   * Shared tail of {@link init} / {@link initFromSettings}. Both entry points validate
   */
  static finalizeInit(r, c) {
    this.appSettings = r, this.isInitialized = !0, iV(this.appSettings.appId, c), H6.setAppSettings({
      ...this.appSettings,
      host: `${this.getBaseURL("call")}/`
    }), CV({
      callsBaseURL: this.getBaseURL("call"),
      appId: this.appSettings.appId,
      getAuthToken: () => an.getUserAuthToken()
    }), Je.publish({
      type: Un.lifecycle.SDKInitialized
    });
    const h = this.getSavedUser();
    if (h) {
      let f;
      if (typeof h == "string")
        try {
          f = JSON.parse(h);
        } catch {
          f = h;
        }
      else
        f = h;
      this.loggedInUser = f, this.reportSdkIdentification();
    }
  }
  /**
   * Initializes the CometChat Calls SDK from a `cometchat-settings.json` object.
   * Parallels the Chat SDK's `initFromSettings` (file-based init for skills-driven
   * integrations): it maps the shared settings shape onto the Calls SDK's own
   * `CallAppSettings` and then performs exactly the same work as {@link init}.
   * @param settings - Parsed `cometchat-settings.json` object.
   * @returns An object indicating success or failure with error details.
   */
  static async initFromSettings(r) {
    if (!r || !r.appId)
      return {
        success: !1,
        error: {
          name: "VALIDATION_ERROR",
          message: "Invalid app settings: appId is required",
          timestamp: Date.now()
        }
      };
    const c = zC(r), h = /* @__PURE__ */ sc(uU, c);
    return h.success ? (this.finalizeInit(h.output, YC), {
      success: !0,
      error: null
    }) : (console.error(
      "App settings validation failed:",
      h.issues
    ), {
      success: !1,
      error: {
        name: "VALIDATION_ERROR",
        message: `Invalid app settings: ${h.issues.map((f) => f.message).join(", ")}`,
        timestamp: Date.now()
      }
    });
  }
  // Login with UID and Auth Key
  static async login(r, c) {
    var h;
    try {
      if (this.loginInProgress)
        throw {
          errorCode: "ERROR_LOGIN_IN_PROGRESS",
          errorDescription: "Login is already in progress"
        };
      if (!r || r.trim() === "")
        throw {
          errorCode: "ERROR_INVALID_UID",
          errorDescription: "UID cannot be empty"
        };
      if (r.includes(" "))
        throw {
          errorCode: "ERROR_UID_WITH_SPACE",
          errorDescription: "UID cannot contain spaces"
        };
      const f = c || ((h = this.appSettings) == null ? void 0 : h.authKey);
      if (!f || f.trim() === "")
        throw {
          errorCode: "ERROR_API_KEY_NOT_FOUND",
          errorDescription: "Auth Key cannot be empty"
        };
      if (!this.isInitialized)
        throw {
          errorCode: "ERROR_SDK_NOT_INITIALIZED",
          errorDescription: "SDK not initialized. Call init() first"
        };
      if (this.loginInProgress = !0, this.loggedInUser && this.loggedInUser.uid === r && this.loggedInUser.authToken)
        return this.loginInProgress = !1, this.notifyLoginSuccess(this.loggedInUser), this.reportSdkIdentification(), this.loggedInUser;
      this.loggedInUser && this.loggedInUser.uid !== r && await this.logoutInternal();
      const v = await this.loginWithUID(r, f), R = await this.authenticateWithToken(v);
      return this.loginInProgress = !1, this.loggedInUser = R, this.saveUser(R), this.notifyLoginSuccess(R), this.reportSdkIdentification(), R;
    } catch (f) {
      this.loginInProgress = !1;
      const v = this.createError(f);
      throw this.notifyLoginFailure(v), v;
    }
  }
  // Login with auth token directly
  static async loginWithAuthToken(r) {
    try {
      if (this.loginInProgress)
        throw {
          errorCode: "ERROR_LOGIN_IN_PROGRESS",
          errorDescription: "Login is already in progress"
        };
      if (!r || r.trim() === "")
        throw {
          errorCode: "ERROR_BLANK_AUTHTOKEN",
          errorDescription: "Auth token cannot be empty"
        };
      if (r.includes(" "))
        throw {
          errorCode: "ERROR_AUTHTOKEN_WITH_SPACE",
          errorDescription: "Auth token cannot contain spaces"
        };
      if (this.loginInProgress = !0, this.loggedInUser && this.loggedInUser.authToken === r)
        return this.loginInProgress = !1, this.notifyLoginSuccess(this.loggedInUser), this.reportSdkIdentification(), this.loggedInUser;
      this.loggedInUser && this.loggedInUser.authToken !== r && await this.logoutInternal();
      const c = await this.authenticateWithToken(r);
      return this.loginInProgress = !1, this.loggedInUser = c, this.saveUser(c), this.notifyLoginSuccess(c), this.reportSdkIdentification(), c;
    } catch (c) {
      this.loginInProgress = !1;
      const h = this.createError(c);
      throw this.notifyLoginFailure(h), h;
    }
  }
  // Logout functionality
  static async logout() {
    try {
      if (!this.loggedInUser)
        throw {
          errorCode: "ERROR_NO_USER_LOGGED_IN",
          errorDescription: "No user is currently logged in"
        };
      return await this.logoutInternal(), this.notifyLogoutSuccess(), "Logout successful";
    } catch (r) {
      const c = this.createError(r);
      throw this.notifyLogoutFailure(c), c;
    }
  }
  // Get logged in user
  static getLoggedInUser() {
    return this.loggedInUser && typeof this.loggedInUser == "string" && (this.loggedInUser = JSON.parse(this.loggedInUser)), this.loggedInUser;
  }
  // Get user auth token
  static getUserAuthToken() {
    var r;
    return ((r = this.loggedInUser) == null ? void 0 : r.authToken) || null;
  }
  // Check if user is logged in
  static isUserLoggedIn() {
    return this.loggedInUser !== null && this.loggedInUser.authToken !== void 0;
  }
  // Add login listener
  static addLoginListener(r, c) {
    this.loginListeners.set(r, c);
  }
  // Remove login listener
  static removeLoginListener(r) {
    this.loginListeners.delete(r);
  }
  // Generate token (enhanced to use logged-in user's authToken)
  static async generateToken(r, c) {
    const { token: h } = await this.requestCallToken(r, c);
    return { token: h };
  }
  /**
   * The request behind {@link generateToken}. With `includeSettings` the
   * backend also verifies the token inline and returns the verification
   * response next to it (read it with `parseInlineVerifiedToken`), which
   * saves {@link connect} / {@link initiateCall} the verification round trip.
   */
  static async requestCallToken(r, c, h = !1) {
    try {
      if (!r || r.trim() === "")
        throw {
          errorCode: "ERROR_SESSION_ID_MISSING",
          errorDescription: "Session ID cannot be empty"
        };
      const f = c || this.getUserAuthToken();
      if (!f)
        throw {
          errorCode: "ERROR_AUTH_TOKEN_MISSING",
          errorDescription: "Auth token is required. Please login first or provide authToken."
        };
      if (!this.isInitialized)
        throw {
          errorCode: "ERROR_SDK_NOT_INITIALIZED",
          errorDescription: "SDK not initialized"
        };
      return await this.callGenerateTokenAPI(
        r,
        f,
        h
      );
    } catch (f) {
      throw this.createError(f);
    }
  }
  /**
   * Initiates a call: creates it on the server, delivers the "call
   * initiated" message to the receiver and starts
   * {@link connect | preparing} the new session so the join is near-instant
   * when the receiver accepts. The initiate call response already carries
   * the caller's call token, verified inline, so unlike {@link connect} no
   * token request is made. Requires a logged-in user
   * ({@link login} / {@link loginWithAuthToken}) — the requests are
   * authenticated with their auth token.
   *
   * Resolves as soon as the call exists and its prepare is in flight; it
   * does **not** wait for the prepare to settle, so the outgoing-call UI
   * gets `data.sessionId` without paying for the connection and the
   * conference join. `data.session` comes back with
   * `prepareStatus: 'pending'`: await `data.session.settled` (or read
   * `prepareStatus` / `error` later) for the outcome. Calling
   * `data.session.join(container)` while the prepare is still in flight is
   * fine — it waits for it.
   *
   * The returned promise never rejects: failures come back as `error` — `USER_NOT_LOGGED_IN`
   * when nobody is logged in, `SESSION_ALREADY_ACTIVE` while a session is
   * joined (no call is created), otherwise the validation / network / API
   * failure of the request. A prepare failure after the call was created
   * is **not** an `error` (the receiver is already
   * ringing): it surfaces on `data.session.prepareStatus` / `.error`
   * instead, and `data.sessionId` stays available e.g. to
   * {@link endCall | cancel} the call.
   *
   * @param receiver - UID of the user to call — or, with
   * `receiverType: 'group'`, GUID of the group.
   * @param options - `type` defaults to `'video'`, `receiverType` to
   * `'user'`; `sessionSettings` configure the prepared session.
   * @returns The created call; join it with `data.session.join(container)`
   * once the receiver accepts.
   */
  static async initiateCall(r, c = {}) {
    var _, V, B, ce;
    if (!this.isUserLoggedIn())
      return {
        data: null,
        error: {
          name: "USER_NOT_LOGGED_IN",
          message: "No user is logged in. Call login() before initiateCall().",
          timestamp: Date.now()
        }
      };
    if (typeof r != "string" || r.trim() === "")
      return {
        data: null,
        error: {
          name: "VALIDATION_ERROR",
          message: "receiver is required to initiate a call",
          timestamp: Date.now()
        }
      };
    const h = Hn();
    if (h === "joining" || h === "joined")
      return {
        data: null,
        error: {
          name: "SESSION_ALREADY_ACTIVE",
          message: "Cannot initiate a call while a session is already active. Leave it first.",
          timestamp: Date.now()
        }
      };
    const { type: f = "video", receiverType: v = "user", sessionSettings: R = {} } = c, T = await Td({
      baseURL: this.getBaseURL("call"),
      method: "POST",
      // configVersion=1 makes the inline settings next to the call token the
      // v5 shape the verification returns, as for call_tokens.
      endpoint: "calls?configVersion=1",
      headers: {
        "Content-Type": "application/json",
        authToken: this.getUserAuthToken() ?? "",
        appId: ((_ = this.appSettings) == null ? void 0 : _.appId) || "",
        // Without it the backend never pushes v2 call messages (see resource.ts).
        resource: dU()
      },
      body: {
        type: f,
        receiverType: v,
        status: "initiated",
        receiver: r
      }
    });
    if (T.error)
      return { data: null, error: T.error };
    const E = T.data, C = (ce = (B = (V = E == null ? void 0 : E.data) == null ? void 0 : V.entities) == null ? void 0 : B.on) == null ? void 0 : ce.entity;
    if (!(C != null && C.sessionid))
      return {
        data: null,
        error: {
          name: "BAD_RESPONSE",
          message: "Initiate call response did not contain a session ID",
          details: E,
          timestamp: Date.now()
        }
      };
    await this.beginPrepare(C.sessionid, R, async () => ({
      ...E,
      token: E.token ?? ""
    }));
    const N = this.session;
    return {
      data: {
        sessionId: C.sessionid,
        messageId: E.id,
        conversationId: E.conversationId,
        sender: E.sender,
        receiver: E.receiver,
        receiverType: E.receiverType,
        type: E.type,
        status: C.status ?? "initiated",
        initiatedAt: C.initiatedAt ?? E.sentAt ?? Math.floor(Date.now() / 1e3),
        session: N
      },
      error: null
    };
  }
  /**
   * Ends a call: updates it on the server and delivers the corresponding
   * "call rejected" / "call cancelled" / "call busy" / "call unanswered"
   * message to the other party. Requires a logged-in user ({@link login} /
   * {@link loginWithAuthToken}) — the request is authenticated with their
   * auth token.
   *
   * When the live session ({@link getActiveSession}) is the call being
   * ended — the caller cancelling the call {@link initiateCall} is still
   * preparing, or the receiver declining a ringing call they pre-prepared
   * with {@link connect} — it is torn down first, exactly as
   * {@link leaveSession} would: a prepare still in flight settles
   * `cancelled` on the session object, and `onConnectionClosed` fires. The
   * teardown happens before the request and regardless of its
   * outcome: the local session goes whether or not the server accepts the
   * update. A live session for any *other* call — declining an incoming
   * call `'busy'` mid-call, say — is left untouched, and with no live
   * session (the usual receiver decline) nothing is torn down.
   *
   * A session already in the room tells the other participants how the call
   * ended instead (a `cc-calls-internal-event` carrying `status`, sent right
   * before the teardown), and no request is made. Should that send fail,
   * the request is made as usual.
   *
   * Never rejects: failures come back as `error` — `USER_NOT_LOGGED_IN`
   * when nobody is logged in, otherwise the validation / network / API
   * failure of the request.
   *
   * @param sessionId - Session ID of the call to end (from
   * {@link initiateCall} or the incoming call message).
   * @param status - `'rejected'` (default) or `'busy'` when the receiver
   * declines an incoming call; `'cancelled'` when the caller withdraws
   * their own outgoing call, or `'unanswered'` when the caller gives up on
   * it after ringing with no answer.
   * @returns No data: `{ data: undefined, error: null }` once the call is
   * ended.
   */
  static async endCall(r, c = "rejected") {
    var v;
    if (!this.isUserLoggedIn())
      return {
        data: null,
        error: {
          name: "USER_NOT_LOGGED_IN",
          message: "No user is logged in. Call login() before endCall().",
          timestamp: Date.now()
        }
      };
    if (typeof r != "string" || r.trim() === "")
      return {
        data: null,
        error: {
          name: "VALIDATION_ERROR",
          message: "sessionId is required to end a call",
          timestamp: Date.now()
        }
      };
    const h = this.getActiveSession();
    (h == null ? void 0 : h.sessionId) === r && (KN(c), await this.leaveSession().catch((R) => {
    }));
    const f = await Td({
      baseURL: this.getBaseURL("apiclient"),
      method: "PUT",
      endpoint: `calls/${r}`,
      headers: {
        "Content-Type": "application/json",
        authToken: this.getUserAuthToken() ?? "",
        appId: ((v = this.appSettings) == null ? void 0 : v.appId) || "",
        // Without it the backend never pushes v2 call messages (see resource.ts).
        resource: dU()
      },
      body: {
        status: c
      }
    });
    return f.error ? { data: null, error: f.error } : { data: void 0, error: null };
  }
  static getBaseURL(r = "call") {
    var v, R, T, E, C;
    if (r === "call" && ((v = this.appSettings) != null && v.host))
      return this.appSettings.host;
    if (r === "api" && ((R = this.appSettings) != null && R.adminHost))
      return this.appSettings.adminHost;
    if (r === "apiclient" && ((T = this.appSettings) != null && T.clientHost))
      return this.appSettings.clientHost;
    const c = ((E = this.appSettings) == null ? void 0 : E.appId) || "", h = ((C = this.appSettings) == null ? void 0 : C.region) || "";
    return `https://${c}.${r}-${h}.cometchat.io/v3.0`;
  }
  /**
   * SDK-identification telemetry chokepoint. Fire-and-forget, deduped, non-fatal.
   * Called from login success AND init()-session-restore. Sends `/user_sessions`
   * ONLY when the Chat SDK is absent (it otherwise handles this telemetry itself).
   * Never awaited on the happy path; never throws.
   */
  static reportSdkIdentification() {
    var r, c;
    try {
      const h = (r = this.appSettings) == null ? void 0 : r.appId, f = (c = this.loggedInUser) == null ? void 0 : c.authToken;
      if (!h || !f) return;
      fV({
        appId: h,
        apiclientBaseURL: this.getBaseURL("apiclient"),
        authToken: f,
        callsSdkVersion: "5.1.0"
      });
    } catch {
    }
  }
  // Private helper methods
  static async loginWithUID(r, c) {
    var v;
    const h = ((v = this.appSettings) == null ? void 0 : v.appId) || "", f = await Td({
      baseURL: this.getBaseURL("api"),
      method: "POST",
      endpoint: `users/${r}/auth_tokens`,
      headers: {
        "Content-Type": "application/json",
        apiKey: c,
        appId: h
      },
      body: {
        platform: "web",
        deviceId: this.generateDeviceId()
      }
    });
    if (f.error)
      throw new Error(`Login failed: ${f.error.message}`);
    return f.data.authToken;
  }
  static async authenticateWithToken(r) {
    var v;
    const c = ((v = this.appSettings) == null ? void 0 : v.appId) || "", h = await Td({
      baseURL: this.getBaseURL("apiclient"),
      method: "PUT",
      endpoint: "me",
      headers: {
        "Content-Type": "application/json",
        authToken: r,
        appId: c
      },
      body: {
        platform: "web",
        deviceId: this.generateDeviceId()
      }
    });
    if (h.error)
      throw new Error(`Authentication failed: ${h.error.message}`);
    const f = h.data;
    return {
      uid: f.uid,
      name: f.name,
      authToken: r,
      status: f.status || "online",
      avatar: f.avatar || "",
      lastActiveAt: f.lastActiveAt || Date.now(),
      role: f.role || "default",
      hasBlockedMe: !1,
      blockedByMe: !1,
      deactivatedAt: 0,
      wsChannel: {
        identity: `[${c}]${f.uid}`
      },
      jwt: f.jwt
    };
  }
  static async logoutInternal() {
    var r, c;
    if ((r = this.loggedInUser) != null && r.authToken)
      try {
        await Td({
          baseURL: this.getBaseURL("apiclient"),
          method: "DELETE",
          endpoint: "me",
          headers: {
            authToken: this.loggedInUser.authToken,
            appId: ((c = this.appSettings) == null ? void 0 : c.appId) || ""
          }
        });
      } catch {
      }
    this.loggedInUser = null, this.clearSavedUser();
  }
  static async callGenerateTokenAPI(r, c, h) {
    var R;
    const f = ((R = this.appSettings) == null ? void 0 : R.appId) || "", v = await Td({
      baseURL: this.getBaseURL(),
      method: "POST",
      // configVersion=1 makes the inline settings the v5 shape the
      // verification returns; without it they come back in the v4 shape.
      endpoint: h ? "call_tokens?configVersion=1" : "call_tokens",
      headers: {
        "Content-Type": "application/json",
        authToken: c,
        appId: f
      },
      body: h ? { sessionId: r, includeSettings: h } : { sessionId: r }
    });
    if (v.error)
      throw new Error(`Token generation failed: ${v.error.message}`);
    return v.data;
  }
  static async callVerifyTokenAPI(r) {
    var c, h;
    return LV({
      appId: ((c = this.appSettings) == null ? void 0 : c.appId) || "",
      region: ((h = this.appSettings) == null ? void 0 : h.region) || "",
      calltoken: r,
      baseURL: this.getBaseURL()
    });
  }
  static saveUser(r) {
    var c, h;
    try {
      const f = `${(c = this.appSettings) == null ? void 0 : c.appId}:common_store/user`, v = {
        hasBlockedMe: !1,
        blockedByMe: !1,
        deactivatedAt: 0,
        ...r,
        role: r.role || "default",
        wsChannel: r.wsChannel || {
          identity: `[${(h = this.appSettings) == null ? void 0 : h.appId}]${r.uid}`
        }
      };
      localStorage.setItem(f, JSON.stringify(v));
    } catch {
    }
  }
  static getSavedUser() {
    var r;
    try {
      const c = `${(r = this.appSettings) == null ? void 0 : r.appId}:common_store/user`, h = localStorage.getItem(c);
      return h || null;
    } catch {
      return null;
    }
  }
  static clearSavedUser() {
    var r;
    try {
      const c = `${(r = this.appSettings) == null ? void 0 : r.appId}:common_store/user`;
      localStorage.removeItem(c);
    } catch {
    }
  }
  static generateDeviceId() {
    return "web_" + Math.random().toString(36).substr(2, 9);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static createError(r) {
    return r.errorCode && r.errorDescription ? r : {
      errorCode: "ERROR_UNKNOWN",
      errorDescription: r.message || "An unknown error occurred"
    };
  }
  // Notification methods for listeners
  static notifyLoginSuccess(r) {
    this.loginListeners.forEach((c) => {
      if (c.onLoginSuccess)
        try {
          c.onLoginSuccess(r);
        } catch (h) {
          console.error("Error in login success listener:", h);
        }
    });
  }
  static notifyLoginFailure(r) {
    this.loginListeners.forEach((c) => {
      if (c.onLoginFailure)
        try {
          c.onLoginFailure(r);
        } catch (h) {
          console.error("Error in login failure listener:", h);
        }
    });
  }
  static notifyLogoutSuccess() {
    this.loginListeners.forEach((r) => {
      if (r.onLogoutSuccess)
        try {
          r.onLogoutSuccess();
        } catch (c) {
          console.error("Error in logout success listener:", c);
        }
    });
  }
  static notifyLogoutFailure(r) {
    this.loginListeners.forEach((c) => {
      if (c.onLogoutFailure)
        try {
          c.onLogoutFailure(r);
        } catch (h) {
          console.error("Error in logout failure listener:", h);
        }
    });
  }
  static addEventListener(r, c, h) {
    return Je.subscribe(r, c, h);
  }
  /**
   * @deprecated Use CometChatCalls.joinSession instead.
   */
  static startSession(r, c, h) {
    var T, E;
    const f = c, v = {
      hideControlPanel: !(f.defaultLayout ?? !1),
      hideLeaveSessionButton: !(f.ShowEndCallButton ?? !0),
      hideRecordingButton: !(f.ShowRecordingButton ?? !0),
      hideChangeLayoutButton: !(f.ShowSwitchModeButton ?? !0),
      hideScreenSharingButton: !(f.ShowScreenShareButton ?? !0),
      hideToggleAudioButton: !(f.ShowMuteAudioButton ?? !0),
      hideToggleVideoButton: !(f.ShowPauseVideoButton ?? !0),
      autoStartRecording: f.StartRecordingOnCallStart ?? !1,
      hideNetworkIndicator: !(((E = (T = f.MainVideoContainerSetting) == null ? void 0 : T.network) == null ? void 0 : E.visibility) ?? !0),
      hideVirtualBackgroundButton: !(f.ShowVirtualBackgroundSetting ?? !0),
      virtualBackground: WV(
        c.getVirtualBackground()
      ),
      layout: f.mode === "DEFAULT" ? "SIDEBAR" : f.mode,
      startAudioMuted: f.StartAudioMuted ?? !1,
      startVideoPaused: f.StartVideoMuted ?? !1,
      idleTimeoutPeriodBeforePrompt: 60 * 1e3,
      idleTimeoutPeriodAfterPrompt: Math.max(
        f.idleTimeoutPeriod ?? 120 * 1e3,
        60 * 1e3
      ),
      sessionType: f.isAudioCall || f.isAudioOnly ? "VOICE" : "VIDEO"
    }, R = [];
    return R.push(
      an.addEventListener("onLeaveSessionButtonClicked", () => {
        var C, N;
        (N = (C = c.getCallListener()) == null ? void 0 : C.onCallEndButtonPressed) == null || N.call(C), R.forEach((_) => _());
      })
    ), R.push(
      an.addEventListener("onSessionLeft", () => {
        var C, N;
        (N = (C = c.getCallListener()) == null ? void 0 : C.onCallEnded) == null || N.call(C);
      })
    ), R.push(
      an.addEventListener("onParticipantLeft", (C) => {
        var N, _;
        (_ = (N = c.getCallListener()) == null ? void 0 : N.onUserLeft) == null || _.call(N, C);
      })
    ), R.push(
      an.addEventListener("onParticipantListChanged", (C) => {
        var _, V, B, ce;
        const N = je.getState().localParticipant;
        (V = (_ = c.getCallListener()) == null ? void 0 : _.onUserListUpdated) == null || V.call(_, [
          {
            name: N.name,
            uid: N.uid,
            avatar: N.avatar
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
          },
          ...C
        ]), C.length === 0 && ((ce = (B = c.getCallListener()) == null ? void 0 : B.onCallEnded) == null || ce.call(B));
      })
    ), R.push(
      an.addEventListener("onParticipantJoined", (C) => {
        var N, _;
        (_ = (N = c.getCallListener()) == null ? void 0 : N.onUserJoined) == null || _.call(N, C);
      })
    ), R.push(
      an.addEventListener("onAudioMuted", () => {
        var C, N;
        (N = (C = c.getCallListener()) == null ? void 0 : C.onUserMuted) == null || N.call(C, {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          muted: { isAudioMuted: !0 },
          mutedBy: void 0
        });
      })
    ), R.push(
      an.addEventListener("onParticipantAudioMuted", (C) => {
        var N, _;
        (_ = (N = c.getCallListener()) == null ? void 0 : N.onUserMuted) == null || _.call(N, {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          muted: { ...C, isAudioMuted: !0 },
          mutedBy: void 0
        });
      })
    ), R.push(
      an.addEventListener("onParticipantVideoPaused", (C) => {
        var N, _;
        (_ = (N = c.getCallListener()) == null ? void 0 : N.onUserMuted) == null || _.call(N, {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          muted: { ...C, isVideoMuted: !0 },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          mutedBy: void 0
        });
      })
    ), R.push(
      an.addEventListener("onRecordingStarted", () => {
        var C, N;
        (N = (C = c.getCallListener()) == null ? void 0 : C.onRecordingStarted) == null || N.call(C, void 0);
      })
    ), R.push(
      an.addEventListener("onRecordingStopped", () => {
        var C, N;
        (N = (C = c.getCallListener()) == null ? void 0 : C.onRecordingStopped) == null || N.call(C);
      })
    ), this.joinSession(r, v, h);
  }
  static async _connectToRoom(r, c) {
    wv();
    const { data: h, error: f } = await this.callVerifyTokenAPI(r);
    if (f)
      return {
        data: h,
        error: f
      };
    c != null && c.aborted || mv({
      internalSettings: JSON.stringify({ data: h })
    });
  }
  /**
   * Prepares the session `sessionId` ahead of time (e.g. while the user is on
   * a lobby / device-check screen) so that the actual join is near-instant,
   * and returns the {@link CallSession} object that owns it. Requires a
   * logged-in user ({@link login} / {@link loginWithAuthToken}): the call
   * token of the session is generated internally with their auth token (as
   * {@link generateToken} does) and kept on the object as
   * `session.callToken`, next to `session.sessionId`.
   *
   * Prepare is **signalling only**: it verifies the token, opens the
   * connection and joins the conference in a *prepared* state. It does **not**
   * create audio/video tracks (no permission prompt), does not mount the UI,
   * and does not count as "joined": `onSessionJoined` does not fire, other
   * participants do not see the user, the session timer does not run. While
   * prepared, only terminal events can fire (`onConnectionFailed` for a fatal
   * error, `onConnectionClosed` when the prepared session is torn down).
   *
   * `sessionSettings` are **frozen** at prepare: this is the only
   * configuration point of a prepared session. To change mic/camera state
   * from the lobby use `session.muteAudio()` / `unmuteAudio()` /
   * `pauseVideo()` / `resumeVideo()` — they only flip the intent and take
   * effect when the tracks are created at the actual join.
   *
   * A prepared session that is not joined within 5 minutes is torn down and
   * `onConnectionClosed` fires.
   *
   * Rejects when the session could not be prepared: with a
   * `{ errorCode, errorDescription }` exception for a missing / blank
   * `sessionId` (`ERROR_SESSION_ID_MISSING`), no logged-in user
   * (`ERROR_USER_NOT_LOGGED_IN`) and a failed token generation, and with the
   * `{ name, message }` `PrepareSessionException` for everything from the
   * token onwards — a token verification, connection or conference failure,
   * or `SESSION_ALREADY_ACTIVE` while a session is joined. The same exception
   * is left on `session.error` (`prepareStatus: 'failed'`), and
   * `session.join(container)` still works: it performs a normal direct join
   * with these settings.
   *
   * @param sessionId - Session ID of the call to prepare — the ID
   * {@link initiateCall} returned, or the one carried by the incoming call
   * message.
   * @param sessionSettings - Configuration of the prepared session, frozen
   * at prepare (see above).
   * @returns Once the prepare has settled, the session object — the SDK's
   * one `CallSession`, which always describes the live session:
   * `session.prepareStatus` is `'prepared'` (join with
   * `session.join(container)`) or `'cancelled'` (`leaveSession()` /
   * `session.leave()` was called meanwhile, or a later `connect()` for
   * another session superseded this one — the object then describes that
   * session).
   *
   * Calling this again with the same session ID while it is preparing /
   * prepared waits for that prepare and generates no second token — the
   * prepared session is left exactly as it is. A different session ID
   * silently tears it down and prepares the new one.
   */
  static async connect(r, c = {}) {
    if (typeof r != "string" || r.trim() === "")
      throw {
        errorCode: "ERROR_SESSION_ID_MISSING",
        errorDescription: "Session ID cannot be empty"
      };
    if (!this.isUserLoggedIn())
      throw {
        errorCode: "ERROR_USER_NOT_LOGGED_IN",
        errorDescription: "User login is required for connect(). Call login() or loginWithAuthToken() first."
      };
    const h = Hn(), f = this.session;
    if (h !== "joining" && h !== "joined" && f.sessionId === r && f.isSessionActive())
      return this.settledSession(await f.settled);
    const { settled: v, error: R } = await this.beginPrepare(
      r,
      c,
      () => this.requestCallToken(r, void 0, !0)
    );
    if (R)
      throw R;
    return this.settledSession(await v);
  }
  /**
   * What `connect()` resolves with once the prepare has settled: the session
   * object, or the prepare failure as a rejection.
   */
  static settledSession(r) {
    if ((r == null ? void 0 : r.status) === "failed")
      throw r.error;
    return this.session;
  }
  /**
   * The {@link CallSession} of the live session — the very object
   * {@link connect} / {@link initiateCall} handed out, for apps that would
   * rather ask the SDK than carry the reference around. Its `sessionId` says
   * which session it is. It is the SDK's one session object, so it also
   * describes a session joined directly with {@link joinSession}, exactly as
   * on Android and iOS.
   *
   * `null` when no session is live — none was ever prepared or joined, the
   * session ended, or its prepare failed / was cancelled — the same condition
   * as `session.isSessionActive() === false`. A returned object is always
   * safe to act on.
   */
  static getActiveSession() {
    return this.session.isSessionActive() ? this.session : null;
  }
  /**
   * The prepare behind {@link connect} and {@link initiateCall}: the phase
   * guards and the idempotency / supersede bookkeeping of D11, then the
   * session object pointed at the new prepare *from before the token exists*
   * (CANCEL_CONNECT_DESIGN D2) — the token generation and verification are
   * registered with the core as the pending join, so `leaveSession()` /
   * `endSessionForAll()` cancel them and the remaining steps are skipped.
   * Every step after an await checks it is still the current prepare, so a
   * `connect()` superseded meanwhile stops where it is.
   *
   * Resolves once the token is minted (or its generation failed / was
   * cancelled) with the prepare in flight — *before* it has settled —
   * with the promise of *this* prepare's outcome. `error` is what stops
   * `connect()`: `SESSION_ALREADY_ACTIVE` (the object is untouched), the
   * token generation failure as thrown (the prepare is settled
   * `TOKEN_GENERATION_FAILED`) or a blank minted token (`VALIDATION_ERROR`).
   * {@link initiateCall} ignores it and hands the object back as is.
   *
   * `mintToken` resolves with a token that is already verified:
   * {@link connect} requests it with `includeSettings: true`,
   * {@link initiateCall} hands back the initiate call response, which
   * carries it. Either way the prepare runs on the verification response
   * that comes with the token; a response without it fails the prepare
   * (`BAD_RESPONSE`).
   */
  static async beginPrepare(r, c, h) {
    const f = this.session, v = Hn();
    if (v === "joining" || v === "joined") {
      const _ = {
        name: "SESSION_ALREADY_ACTIVE",
        message: "Cannot prepare a session while one is already active."
      };
      return { settled: Promise.resolve({ status: "failed", error: _ }), error: _ };
    }
    if (f.isSessionActive() && f.sessionId === r)
      return {
        settled: f.settled.then(
          (_) => _ ?? { status: "cancelled", error: null }
        ),
        error: null
      };
    (v === "preparing" || v === "prepared") && await $i({ silent: !0 });
    const { prepareId: R, settled: T } = f.beginPrepare(
      "",
      c,
      r
    ), E = EE(
      () => f.cancelPendingPrepare(R)
    );
    let C, N;
    try {
      const _ = await h();
      C = _.token, N = JV(_);
    } catch (_) {
      E.dispose();
      const V = _;
      return f.settle(
        {
          status: "failed",
          error: {
            name: "TOKEN_GENERATION_FAILED",
            message: V.errorDescription || "Failed to generate a call token for the session",
            details: _
          }
        },
        R
      ), { settled: T, error: V };
    }
    if (E.aborted || !f.isPreparing(R))
      return f.cancelPendingPrepare(R), { settled: T, error: null };
    if (typeof C != "string" || C.trim() === "") {
      E.dispose();
      const _ = {
        name: "VALIDATION_ERROR",
        message: "callToken is required to prepare a session"
      };
      return f.settle({ status: "failed", error: _ }, R), { settled: T, error: _ };
    }
    return f.setCallToken(C), this.runPrepare(R, N, E), { settled: T, error: null };
  }
  /**
   * Runs the core prepare on the token verified inline by the token request
   * (a verification failure fails the prepare); always settles the prepare —
   * `connect()` and `session.join()` await it, so an unexpected throw has to
   * become a failed outcome rather than a promise that never resolves.
   */
  static async runPrepare(r, c, h) {
    const f = this.session;
    try {
      const { data: v, error: R } = c;
      if (R) {
        h.dispose(), f.settle({ status: "failed", error: R }, r);
        return;
      }
      const T = f.settings, E = await zN({
        // Applied under the core's session lock so it cannot race a leave.
        configure: () => {
          wv(), mv({
            internalSettings: JSON.stringify({ data: v })
          }), mv(T);
        }
      });
      f.settle(E, r);
    } catch (v) {
      h.dispose(), console.error("connect failed unexpectedly:", v), f.settle(
        {
          status: "failed",
          error: {
            name: "PREPARE_FAILED",
            message: v instanceof Error ? v.message : String(v),
            details: v
          }
        },
        r
      );
    }
  }
  /**
   * Joins a session directly — verify the token, connect, apply
   * `sessionSettings` — and mounts the call UI into `container`.
   *
   * This is the join *without* a prior `connect()`. While a session is
   * prepared (or preparing) this returns `SESSION_ALREADY_PREPARED`: join it
   * with `session.join(container)`, or cancel it with `session.leave()`
   * first. `sessionSettings` are required (`SESSION_SETTINGS_REQUIRED`).
   * The session object ({@link getActiveSession}) describes the joined
   * session from here on, as on Android and iOS.
   */
  static async joinSession(r, c, h) {
    if (c == null)
      return {
        data: null,
        error: {
          name: "SESSION_SETTINGS_REQUIRED",
          message: "sessionSettings are required: pass them to joinSession(callToken, sessionSettings, container). To join a prepared session use session.join(container) on the object returned by connect()."
        }
      };
    const f = Hn();
    return f === "preparing" || f === "prepared" || // The token of a prepare is still being minted or verified.
    this.session.prepareStatus === "pending" ? {
      data: null,
      error: {
        name: "SESSION_ALREADY_PREPARED",
        message: "A session is prepared; join it with session.join(container) or cancel it with session.leave() first."
      }
    } : (this.session.beginDirectJoin(r, c), this.directJoin(r, c, h));
  }
  /**
   * The direct join shared by {@link joinSession} and the dead-prepare
   * fallback of `CallSession.join()`.
   */
  static async directJoin(r, c, h) {
    const f = EE();
    if (!Wn.getState().connection) {
      const R = await this._connectToRoom(r, f);
      if (R != null && R.error)
        return f.dispose(), { data: null, error: R.error };
    }
    return f.aborted ? {
      data: null,
      error: {
        name: "SESSION_CANCELLED",
        message: "The join was cancelled by leaveSession() / endSessionForAll() before it completed."
      }
    } : (mv(c), lU(h), {
      data: void 0,
      error: null
    });
  }
  /**
   * Leaves the current session, whoever owns it. While a session is merely
   * prepared this cancels the prepare: `onSessionLeft` does not fire,
   * `onConnectionClosed` does and the session object's `prepareStatus`
   * becomes `cancelled`. Same as `session.leave()` on the object returned by
   * `connect()`.
   */
  static leaveSession() {
    return this.session.isSessionActive() ? this.session.leave() : $i();
  }
  static getAudioInputDevices() {
    return Y.getState().audioInputDevices;
  }
  static getVideoInputDevices() {
    return Y.getState().videoInputDevices;
  }
  static getAudioOutputDevices() {
    return Y.getState().audioOutputDevices;
  }
  static getCurrentAudioInputDevice() {
    return Y.getState().audioInputDevice;
  }
  static getCurrentVideoInputDevice() {
    return Y.getState().videoInputDevice;
  }
  static getCurrentAudioOutputDevice() {
    return Y.getState().audioOutputDevice;
  }
};
x(an, "loggedInUser", null), x(an, "isInitialized", !1), x(an, "loginInProgress", !1), x(an, "appSettings", null), x(an, "loginListeners", /* @__PURE__ */ new Map()), /** How a `CallSession` performs its joins (see `CallSession.join`). */
x(an, "sessionDriver", {
  joinPrepared: (r) => lU(r),
  directJoin: (r, c, h) => an.directJoin(r, c, h)
}), /**
 * The one session object of the SDK (see `CallSession`): it always
 * describes the live session, and is what `connect()` / `initiateCall()`
 * hand back and `getActiveSession()` reports.
 */
x(an, "session", new wT(
  an.sessionDriver
)), x(an, "constants", jC), x(an, "CallLogRequestBuilder", AV), x(an, "TranscriptRequestBuilder", wV), x(an, "CallLog", tS), /** @deprecated */
x(an, "MainVideoContainerSetting", NV), /** @deprecated */
x(an, "CallSettings", ts), // v4 related changes start here
/**
 * @deprecated Use CometChatCalls.init passing object directly.
 */
x(an, "CallAppSettingsBuilder", EV), /**
 * @deprecated Use CometChatCalls.joinSession passing object directly.
 */
x(an, "CallSettingsBuilder", UV), /**
 * @deprecated Use CometChatCalls.addEventListener
 */
x(an, "OngoingCallListener", bV);
let p2 = an;
process.env.NODE_ENV === "playwright-test" && (window.CometChatCalls = p2);
window.CometChatCalls = p2;
$C("5.1.0");
const zV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CometChatCalls: p2
}, Symbol.toStringTag, { value: "Module" }));
export {
  tS as CallLog,
  wT as CallSession,
  p2 as CometChatCalls,
  _T as DEFAULT_VIRTUAL_BACKGROUND_IMAGES,
  G6 as Transcription,
  zV as default
};
